import Vue from 'vue';

const PropValidator = {
  color: String,
  size: [String, Number],
  weight: {
    type: String
  },
  mirrored: Boolean
};
const ContextGetter = {
  contextWeight: {
    from: "weight",
    default: "regular"
  },
  contextSize: {
    from: "size",
    default: "1em"
  },
  contextColor: {
    from: "color",
    default: "currentColor"
  },
  contextMirrored: {
    from: "mirrored",
    default: false
  }
};

var script = Vue.extend({
  name: "PhActivity",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

/* script */
const __vue_script__ = script;
/* template */

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "24.002 128 56.002 128 96.002 40 160.002 208 200.002 128 232.002 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "24.002 128 56.002 128 96.002 40 160.002 208 200.002 128 232.002 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M160.00439,216c-.13378,0-.2666-.00342-.40039-.00977a7.99906,7.99906,0,0,1-7.07714-5.14209L95.35205,60.7644,63.28564,131.3103A8.00165,8.00165,0,0,1,56.00244,136h-32a8,8,0,0,1,0-16H50.85107L88.71924,36.6897a7.99988,7.99988,0,0,1,14.75879.4624l57.51562,150.97729,31.85352-63.707A7.99979,7.99979,0,0,1,200.00244,120h32a8,8,0,0,1,0,16H204.94678l-37.78907,75.57764A7.99952,7.99952,0,0,1,160.00439,216Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "24.002 128 56.002 128 96.002 40 160.002 208 200.002 128 232.002 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "24.002 128 56.002 128 96.002 40 160.002 208 200.002 128 232.002 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "24.002 128 56.002 128 96.002 40 160.002 208 200.002 128 232.002 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__ = [];
/* style */

const __vue_inject_styles__ = undefined;
/* scoped */

const __vue_scope_id__ = undefined;
/* module identifier */

const __vue_module_identifier__ = undefined;
/* functional template */

const __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);

var script$1 = Vue.extend({
  name: "PhAddressBook",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1 = script$1;
/* template */

var __vue_render__$1 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "136",
      "cy": "116",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "108.00005",
      "x2": "56",
      "y2": "108.00005",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "68.00005",
      "x2": "56",
      "y2": "68.00005",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "148.00005",
      "x2": "56",
      "y2": "148.00005",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "188.00005",
      "x2": "56",
      "y2": "188.00005",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "transform": "translate(264 -8) rotate(90)",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M91.99963,167.20785a60.00083,60.00083,0,0,1,88.00067-.00007",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "136",
      "cy": "112",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,32H64a8,8,0,0,0-8,8V216a8,8,0,0,0,8,8H208a8,8,0,0,0,8-8V40A8,8,0,0,0,208,32ZM136,144a32,32,0,1,1,32-32A32,32,0,0,1,136,144Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "108.00005",
      "x2": "56",
      "y2": "108.00005",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "68.00005",
      "x2": "56",
      "y2": "68.00005",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "148.00005",
      "x2": "56",
      "y2": "148.00005",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "188.00005",
      "x2": "56",
      "y2": "188.00005",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M87.99717,167.99792a60.00878,60.00878,0,0,1,96.004-.00225",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "transform": "translate(264 -8) rotate(90)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M160,112a24,24,0,1,1-24-24A24.0275,24.0275,0,0,1,160,112Zm64-72V216a16.01833,16.01833,0,0,1-16,16H64a16.01833,16.01833,0,0,1-16-16V196H32a8,8,0,0,1,0-16H48V156H32a8,8,0,0,1,0-16H48V116H32a8,8,0,0,1,0-16H48V76H32a8,8,0,0,1,0-16H48V40A16.01833,16.01833,0,0,1,64,24H208A16.01833,16.01833,0,0,1,224,40ZM190.397,163.19141a67.80622,67.80622,0,0,0-27.42627-21.68067,40,40,0,1,0-53.94153-.00012,67.80949,67.80949,0,0,0-27.42858,21.68274,8,8,0,1,0,12.793,9.60937,52.0088,52.0088,0,0,1,83.21143-.00195,7.99961,7.99961,0,1,0,12.792-9.60937Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "136",
      "cy": "112",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "108.00005",
      "x2": "56",
      "y2": "108.00005",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "68.00005",
      "x2": "56",
      "y2": "68.00005",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "148.00005",
      "x2": "56",
      "y2": "148.00005",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "188.00005",
      "x2": "56",
      "y2": "188.00005",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M87.99717,167.99792a60.00878,60.00878,0,0,1,96.004-.00225",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "transform": "translate(264 -8) rotate(90)",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "136",
      "cy": "112",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "108.00005",
      "x2": "56",
      "y2": "108.00005",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "68.00005",
      "x2": "56",
      "y2": "68.00005",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "148.00005",
      "x2": "56",
      "y2": "148.00005",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "188.00005",
      "x2": "56",
      "y2": "188.00005",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M87.99717,167.99792a60.00878,60.00878,0,0,1,96.004-.00225",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "transform": "translate(264 -8) rotate(90)",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "136",
      "cy": "112",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "108.00005",
      "x2": "56",
      "y2": "108.00005",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "68.00005",
      "x2": "56",
      "y2": "68.00005",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "148.00005",
      "x2": "56",
      "y2": "148.00005",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "188.00005",
      "x2": "56",
      "y2": "188.00005",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M87.99717,167.99792a60.00878,60.00878,0,0,1,96.004-.00225",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "transform": "translate(264 -8) rotate(90)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1 = [];
/* style */

const __vue_inject_styles__$1 = undefined;
/* scoped */

const __vue_scope_id__$1 = undefined;
/* module identifier */

const __vue_module_identifier__$1 = undefined;
/* functional template */

const __vue_is_functional_template__$1 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1,
  staticRenderFns: __vue_staticRenderFns__$1
}, __vue_inject_styles__$1, __vue_script__$1, __vue_scope_id__$1, __vue_is_functional_template__$1, __vue_module_identifier__$1, false, undefined, undefined, undefined);

var script$2 = Vue.extend({
  name: "PhAirplane",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2 = script$2;
/* template */

var __vue_render__$2 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,216,88,232V200l16-16V152L24,168V136l80-40,.11255-48a24,24,0,0,1,48,0l.11255,48,80,40v32l-80-16v32L168,200v32Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,216,88,232V200l16-16V152L24,168V136l80-40,.11255-48a24,24,0,0,1,48,0l.11255,48,80,40v32l-80-16v32L168,200v32Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,216,88,232V200l16-16V152L24,168V136l80-40,.11255-48a24,24,0,0,1,48,0l.11255,48,80,40v32l-80-16v32L168,200v32Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M240.22559,136v32a8.00013,8.00013,0,0,1-9.56934,7.84473L160.22559,161.7583v26.96143l13.47168,13.66357A8.00119,8.00119,0,0,1,176,208v24a7.99947,7.99947,0,0,1-10.9707,7.42773L128,224.61621,90.9707,239.42773A7.99953,7.99953,0,0,1,80,232V208a8.00035,8.00035,0,0,1,2.34277-5.65674L96,188.686V161.7583L25.56934,175.84473A8.00012,8.00012,0,0,1,16,168V136a7.99967,7.99967,0,0,1,4.42188-7.15527L96.01172,91.0498l.10058-43.06835a32,32,0,0,1,64,.01855l.10157,43.0498,75.58984,37.79493A7.99969,7.99969,0,0,1,240.22559,136Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,216,88,232V200l16-16V152L24,168V136l80-40,.11255-48a24,24,0,0,1,48,0l.11255,48,80,40v32l-80-16v32L168,200v32Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,216,88,232V200l16-16V152L24,168V136l80-40,.11255-48a24,24,0,0,1,48,0l.11255,48,80,40v32l-80-16v32L168,200v32Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,216,88,232V200l16-16V152L24,168V136l80-40,.11255-48a24,24,0,0,1,48,0l.11255,48,80,40v32l-80-16v32L168,200v32Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2 = [];
/* style */

const __vue_inject_styles__$2 = undefined;
/* scoped */

const __vue_scope_id__$2 = undefined;
/* module identifier */

const __vue_module_identifier__$2 = undefined;
/* functional template */

const __vue_is_functional_template__$2 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2,
  staticRenderFns: __vue_staticRenderFns__$2
}, __vue_inject_styles__$2, __vue_script__$2, __vue_scope_id__$2, __vue_is_functional_template__$2, __vue_module_identifier__$2, false, undefined, undefined, undefined);

var script$3 = Vue.extend({
  name: "PhAirplaneInFlight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3 = script$3;
/* template */

var __vue_render__$3 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "72",
      "y1": "216",
      "x2": "216",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M26.75225,80H44l20,24H96L83.50994,66.52982A8,8,0,0,1,91.09941,56H108l44,48h56a32,32,0,0,1,32,32v24H63.809a32,32,0,0,1-30.65044-22.80487L19.08963,90.29878A8,8,0,0,1,26.75225,80Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M26.75225,80H44l20,24H96L83.50994,66.52982A8,8,0,0,1,91.09941,56H108l44,48h56a32,32,0,0,1,32,32v24H63.809a32,32,0,0,1-30.65044-22.80487L19.08963,90.29878A8,8,0,0,1,26.75225,80Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "216",
      "x2": "216",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M26.75225,80H44l20,24H96L83.50994,66.52982A8,8,0,0,1,91.09941,56H108l44,48h56a32,32,0,0,1,32,32v24H63.809a32,32,0,0,1-30.65044-22.80487L19.08963,90.29878A8,8,0,0,1,26.75225,80Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,216a8.00008,8.00008,0,0,1-8,8H72a8,8,0,0,1,0-16H216A8.00008,8.00008,0,0,1,224,216ZM208,100H153.75977L110.94824,53.29688A3.99911,3.99911,0,0,0,108,52H91.09961A12.00015,12.00015,0,0,0,79.71484,67.79492L90.4502,100H65.87305L47.07324,77.43945A4.001,4.001,0,0,0,44,76H26.752A11.99986,11.99986,0,0,0,15.25879,91.44824l14.06836,46.89649A35.77737,35.77737,0,0,0,63.80859,164H240a4.0002,4.0002,0,0,0,4-4V136A36.04061,36.04061,0,0,0,208,100Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "72",
      "y1": "216",
      "x2": "216",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M26.75225,80H44l20,24H96L83.50994,66.52982A8,8,0,0,1,91.09941,56H108l44,48h56a32,32,0,0,1,32,32v24H63.809a32,32,0,0,1-30.65044-22.80487L19.08963,90.29878A8,8,0,0,1,26.75225,80Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "72",
      "y1": "216",
      "x2": "216",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M26.75225,80H44l20,24H96L83.50994,66.52982A8,8,0,0,1,91.09941,56H108l44,48h56a32,32,0,0,1,32,32v24H63.809a32,32,0,0,1-30.65044-22.80487L19.08963,90.29878A8,8,0,0,1,26.75225,80Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "72",
      "y1": "216",
      "x2": "216",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M26.75225,80H44l20,24H96L83.50994,66.52982A8,8,0,0,1,91.09941,56H108l44,48h56a32,32,0,0,1,32,32v24H63.809a32,32,0,0,1-30.65044-22.80487L19.08963,90.29878A8,8,0,0,1,26.75225,80Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3 = [];
/* style */

const __vue_inject_styles__$3 = undefined;
/* scoped */

const __vue_scope_id__$3 = undefined;
/* module identifier */

const __vue_module_identifier__$3 = undefined;
/* functional template */

const __vue_is_functional_template__$3 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3,
  staticRenderFns: __vue_staticRenderFns__$3
}, __vue_inject_styles__$3, __vue_script__$3, __vue_scope_id__$3, __vue_is_functional_template__$3, __vue_module_identifier__$3, false, undefined, undefined, undefined);

var script$4 = Vue.extend({
  name: "PhAirplaneLanding",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4 = script$4;
/* template */

var __vue_render__$4 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "216",
      "x2": "240",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,103.72927V51.09941a8,8,0,0,1,10.52982-7.58947L48,48,64,78,96,88V51.09941a8,8,0,0,1,10.52982-7.58947L120,48l32,56,48.5646,13.49017A32,32,0,0,1,224,148.32274V184L47.37184,134.54412A32,32,0,0,1,24,103.72927Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M24,103.72927V51.09941a8,8,0,0,1,10.52982-7.58947L48,48,64,78,96,88V51.09941a8,8,0,0,1,10.52982-7.58947L120,48l32,56,48.5646,13.49017A32,32,0,0,1,224,148.32274V184L47.37184,134.54412A32,32,0,0,1,24,103.72927Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "216",
      "x2": "240",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,103.72927V51.09941a8,8,0,0,1,10.52982-7.58947L48,48,64,78,96,88V51.09941a8,8,0,0,1,10.52982-7.58947L120,48l32,56,48.5646,13.49017A32,32,0,0,1,224,148.32274V184L47.37184,134.54412A32,32,0,0,1,24,103.72927Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M248,216a8.00008,8.00008,0,0,1-8,8H96a8,8,0,0,1,0-16H240A8.00008,8.00008,0,0,1,248,216Zm-24-28a4.00035,4.00035,0,0,0,4-4V148.32275a36.10691,36.10691,0,0,0-26.36523-34.68652l-46.97852-13.0498L123.47266,46.01562a4.00193,4.00193,0,0,0-2.208-1.81054l-13.46973-4.49024A12.00071,12.00071,0,0,0,92,51.09961V82.55908L66.75781,74.6709,51.5293,46.11768a4.00065,4.00065,0,0,0-2.26465-1.9126L35.79492,39.71484A12.00071,12.00071,0,0,0,20,51.09961v52.62988A36.11994,36.11994,0,0,0,46.294,138.396l176.62793,49.45605A4.00591,4.00591,0,0,0,224,188Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "216",
      "x2": "240",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,103.72927V51.09941a8,8,0,0,1,10.52982-7.58947L48,48,64,78,96,88V51.09941a8,8,0,0,1,10.52982-7.58947L120,48l32,56,48.5646,13.49017A32,32,0,0,1,224,148.32274V184L47.37184,134.54412A32,32,0,0,1,24,103.72927Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "216",
      "x2": "240",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,103.72927V51.09941a8,8,0,0,1,10.52982-7.58947L48,48,64,78,96,88V51.09941a8,8,0,0,1,10.52982-7.58947L120,48l32,56,48.5646,13.49017A32,32,0,0,1,224,148.32274V184L47.37184,134.54412A32,32,0,0,1,24,103.72927Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "216",
      "x2": "240",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,103.72927V51.09941a8,8,0,0,1,10.52982-7.58947L48,48,64,78,96,88V51.09941a8,8,0,0,1,10.52982-7.58947L120,48l32,56,48.5646,13.49017A32,32,0,0,1,224,148.32274V184L47.37184,134.54412A32,32,0,0,1,24,103.72927Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4 = [];
/* style */

const __vue_inject_styles__$4 = undefined;
/* scoped */

const __vue_scope_id__$4 = undefined;
/* module identifier */

const __vue_module_identifier__$4 = undefined;
/* functional template */

const __vue_is_functional_template__$4 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4,
  staticRenderFns: __vue_staticRenderFns__$4
}, __vue_inject_styles__$4, __vue_script__$4, __vue_scope_id__$4, __vue_is_functional_template__$4, __vue_module_identifier__$4, false, undefined, undefined, undefined);

var script$5 = Vue.extend({
  name: "PhAirplaneTakeoff",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5 = script$5;
/* template */

var __vue_render__$5 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "24",
      "y1": "216",
      "x2": "168",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16.92713,140.36918,54.6225,175.70859a32,32,0,0,0,37.97,4.319L244,92,225.3607,69.21863a32,32,0,0,0-40.99128-7.31829L140,88,80,68,63.501,75.071a8,8,0,0,0-2.20037,13.29951L92,116,64,132,36,120l-16.7527,7.17973A8,8,0,0,0,16.92713,140.36918Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M16.92713,140.36918,54.6225,175.70859a32,32,0,0,0,37.97,4.319L244,92,225.3607,69.21863a32,32,0,0,0-40.99128-7.31829L140,88,80,68,63.501,75.071a8,8,0,0,0-2.20037,13.29951L92,116,64,132,36,120l-16.7527,7.17973A8,8,0,0,0,16.92713,140.36918Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "216",
      "x2": "168",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16.92713,140.36918,54.6225,175.70859a32,32,0,0,0,37.97,4.319L244,92,225.3607,69.21863a32,32,0,0,0-40.99128-7.31829L140,88,80,68,63.501,75.071a8,8,0,0,0-2.20037,13.29951L92,116,64,132,36,120l-16.7527,7.17973A8,8,0,0,0,16.92713,140.36918Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,216a8.00008,8.00008,0,0,1-8,8H24a8,8,0,0,1,0-16H168A8.00008,8.00008,0,0,1,176,216ZM247.0957,89.4668,228.45605,66.686a35.81374,35.81374,0,0,0-46.11523-8.2334L139.53906,83.62988,81.26465,64.20508a4.0083,4.0083,0,0,0-2.83985.11816l-16.5,7.0708A12.00078,12.00078,0,0,0,58.625,91.34375L85.21191,115.272l-21.46679,12.2666L37.5752,116.32324a4.00251,4.00251,0,0,0-3.1504,0l-16.75292,7.17969a12.00032,12.00032,0,0,0-3.48145,19.78418h.001l37.69531,35.33935a35.78229,35.78229,0,0,0,42.7168,4.85938L246.01074,95.458a4.001,4.001,0,0,0,1.085-5.99121Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "24",
      "y1": "216",
      "x2": "168",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16.92713,140.36918,54.6225,175.70859a32,32,0,0,0,37.97,4.319L244,92,225.3607,69.21863a32,32,0,0,0-40.99128-7.31829L140,88,80,68,63.501,75.071a8,8,0,0,0-2.20037,13.29951L92,116,64,132,36,120l-16.7527,7.17973A8,8,0,0,0,16.92713,140.36918Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "24",
      "y1": "216",
      "x2": "168",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16.92713,140.36918,54.6225,175.70859a32,32,0,0,0,37.97,4.319L244,92,225.3607,69.21863a32,32,0,0,0-40.99128-7.31829L140,88,80,68,63.501,75.071a8,8,0,0,0-2.20037,13.29951L92,116,64,132,36,120l-16.7527,7.17973A8,8,0,0,0,16.92713,140.36918Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "24",
      "y1": "216",
      "x2": "168",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16.92713,140.36918,54.6225,175.70859a32,32,0,0,0,37.97,4.319L244,92,225.3607,69.21863a32,32,0,0,0-40.99128-7.31829L140,88,80,68,63.501,75.071a8,8,0,0,0-2.20037,13.29951L92,116,64,132,36,120l-16.7527,7.17973A8,8,0,0,0,16.92713,140.36918Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5 = [];
/* style */

const __vue_inject_styles__$5 = undefined;
/* scoped */

const __vue_scope_id__$5 = undefined;
/* module identifier */

const __vue_module_identifier__$5 = undefined;
/* functional template */

const __vue_is_functional_template__$5 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5,
  staticRenderFns: __vue_staticRenderFns__$5
}, __vue_inject_styles__$5, __vue_script__$5, __vue_scope_id__$5, __vue_is_functional_template__$5, __vue_module_identifier__$5, false, undefined, undefined, undefined);

var script$6 = Vue.extend({
  name: "PhAirplaneTilt",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6 = script$6;
/* template */

var __vue_render__$6 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M209.53911,80.402,175.88745,112l32,88-24,24-47.80786-69.97929L111.88745,176v24l-24,24L73.695,182.14581,31.88745,168l24-24h24l24-24-72-48,24-24,88,32L175.598,46.46089l-.68109.56855A24,24,0,1,1,208.858,80.97056Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M209.53911,80.402,175.88745,112l32,88-24,24-47.80786-69.97929L111.88745,176v24l-24,24L73.695,182.14581,31.88745,168l24-24h24l24-24-72-48,24-24,88,32L175.598,46.46089l-.68109.56855A24,24,0,1,1,208.858,80.97056Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M209.53911,80.402,175.88745,112l32,88-24,24-47.80786-69.97929L111.88745,176v24l-24,24L73.695,182.14581,31.88745,168l24-24h24l24-24-72-48,24-24,88,32L175.598,46.46089l-.68109.56855A24,24,0,1,1,208.858,80.97056Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M215.01538,86.23437l-29.80762,27.98829,30.19824,83.043a8.00184,8.00184,0,0,1-1.86181,8.39161l-24,24A7.99924,7.99924,0,0,1,177.282,228.5127l-42.58691-62.33692-18.80762,17.33106V204a8.0008,8.0008,0,0,1-2.34326,5.65723l-20,20a7.99986,7.99986,0,0,1-13.23291-3.08789L67.38745,188.457l-38.064-12.87891a8.00081,8.00081,0,0,1-3.09326-13.23535l20-20A8.00235,8.00235,0,0,1,51.88745,140H72.574l18.75635-18.75684L27.45,78.65625a8.00073,8.00073,0,0,1-1.21973-12.31348l24-24a8.003,8.003,0,0,1,8.39111-1.86132l83.0625,30.20507,26.606-28.14062a7.98306,7.98306,0,0,1,.97071-1.17383,32.0006,32.0006,0,0,1,47.01806,43.34375A8.03536,8.03536,0,0,1,215.01538,86.23437Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M209.53911,80.402,175.88745,112l32,88-24,24-47.80786-69.97929L111.88745,176v24l-24,24L73.695,182.14581,31.88745,168l24-24h24l24-24-72-48,24-24,88,32L175.598,46.46089l-.68109.56855A24,24,0,1,1,208.858,80.97056Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M209.53911,80.402,175.88745,112l32,88-24,24-47.80786-69.97929L111.88745,176v24l-24,24L73.695,182.14581,31.88745,168l24-24h24l24-24-72-48,24-24,88,32L175.598,46.46089l-.68109.56855A24,24,0,1,1,208.858,80.97056Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M209.53911,80.402,175.88745,112l32,88-24,24-47.80786-69.97929L111.88745,176v24l-24,24L73.695,182.14581,31.88745,168l24-24h24l24-24-72-48,24-24,88,32L175.598,46.46089l-.68109.56855A24,24,0,1,1,208.858,80.97056Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6 = [];
/* style */

const __vue_inject_styles__$6 = undefined;
/* scoped */

const __vue_scope_id__$6 = undefined;
/* module identifier */

const __vue_module_identifier__$6 = undefined;
/* functional template */

const __vue_is_functional_template__$6 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6,
  staticRenderFns: __vue_staticRenderFns__$6
}, __vue_inject_styles__$6, __vue_script__$6, __vue_scope_id__$6, __vue_is_functional_template__$6, __vue_module_identifier__$6, false, undefined, undefined, undefined);

var script$7 = Vue.extend({
  name: "PhAirplay",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7 = script$7;
/* template */

var __vue_render__$7 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "128.002 160 176 216 80 216 128.002 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,192a16,16,0,0,1-16-16V64A16,16,0,0,1,48,48H208a16,16,0,0,1,16,16V176a16,16,0,0,1-16,16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,48H48A16.00016,16.00016,0,0,0,32,64V176a16.00016,16.00016,0,0,0,16,16h52.57227l27.43017-32,27.42725,32H208a16.00016,16.00016,0,0,0,16-16V64A16.00016,16.00016,0,0,0,208,48Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "128.002 160 176 216 80 216 128.002 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,192H48a16,16,0,0,1-16-16V64A16,16,0,0,1,48,48H208a16,16,0,0,1,16,16V176a16,16,0,0,1-16,16H192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M134.07666,154.794a8.0003,8.0003,0,0,0-12.14844-.00049l-48.00293,56A8,8,0,0,0,79.99951,224h96a8.00032,8.00032,0,0,0,6.07422-13.20605Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208.00244,40H47.99951a24.0275,24.0275,0,0,0-24,24V176a24.0275,24.0275,0,0,0,24,24h14.104l47.67919-55.62231a24.00045,24.00045,0,0,1,36.44239.0039L193.895,200h14.10742a24.0275,24.0275,0,0,0,24-24V64A24.0275,24.0275,0,0,0,208.00244,40Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "128.002 160 176 216 80 216 128.002 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,192H48a16,16,0,0,1-16-16V64A16,16,0,0,1,48,48H208a16,16,0,0,1,16,16V176a16,16,0,0,1-16,16H192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "128.002 160 176 216 80 216 128.002 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,192H48a16,16,0,0,1-16-16V64A16,16,0,0,1,48,48H208a16,16,0,0,1,16,16V176a16,16,0,0,1-16,16H192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "128.002 160 176 216 80 216 128.002 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,192H48a16,16,0,0,1-16-16V64A16,16,0,0,1,48,48H208a16,16,0,0,1,16,16V176a16,16,0,0,1-16,16H192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7 = [];
/* style */

const __vue_inject_styles__$7 = undefined;
/* scoped */

const __vue_scope_id__$7 = undefined;
/* module identifier */

const __vue_module_identifier__$7 = undefined;
/* functional template */

const __vue_is_functional_template__$7 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7,
  staticRenderFns: __vue_staticRenderFns__$7
}, __vue_inject_styles__$7, __vue_script__$7, __vue_scope_id__$7, __vue_is_functional_template__$7, __vue_module_identifier__$7, false, undefined, undefined, undefined);

var script$8 = Vue.extend({
  name: "PhAlarm",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8 = script$8;
/* template */

var __vue_render__$8 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "128 80 128 128 176 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "201.53911",
      "y1": "20.51977",
      "x2": "235.48023",
      "y2": "54.46089",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "20.51977",
      "y1": "54.46089",
      "x2": "54.46089",
      "y2": "20.51977",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "88",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 72 128 128 184 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "195.88225",
      "y1": "26.17662",
      "x2": "229.82338",
      "y2": "60.11775",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "26.17662",
      "y1": "60.11775",
      "x2": "60.11775",
      "y2": "26.17662",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M235.48047,54.46094,201.53906,20.51953a8,8,0,0,0-11.31347,11.314L224.1665,65.77441a8,8,0,1,0,11.314-11.31347Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M65.77441,20.51953a8,8,0,0,0-11.31347,0L20.51953,54.46094a8,8,0,0,0,11.314,11.31347L65.77441,31.8335A8.00061,8.00061,0,0,0,65.77441,20.51953Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M223.957,125.22363c-.02051-.71777-.0459-1.43408-.082-2.14892-.001-.02491-.00293-.04932-.00439-.07373A96.003,96.003,0,0,0,132.999,32.12939c-.02441-.00146-.04882-.00341-.07373-.00439-.71484-.03613-1.43115-.06152-2.14892-.082-.10742-.00293-.21436-.00879-.32227-.01172Q129.2295,32.00048,128,32q-1.22973,0-2.4541.03125c-.10791.00293-.21485.00879-.32227.01172-.71777.02051-1.43408.0459-2.14892.082-.02491.001-.04932.00293-.07373.00439A96.004,96.004,0,0,0,32.12939,123.001c-.00146.02441-.00341.04882-.00439.07373-.03613.71484-.06152,1.43115-.082,2.14892-.00293.10742-.00879.21436-.01172.32227Q32.00048,126.7705,32,128q0,1.22973.03125,2.4541c.00293.10791.00879.21485.01172.32227.02051.71777.0459,1.43408.082,2.14892.001.02491.00293.04932.00439.07373A96.003,96.003,0,0,0,123.001,223.87061c.02441.00146.04882.00341.07373.00439.71484.03613,1.43115.06152,2.14892.082.10742.00293.21436.00879.32227.01172q1.2246.03077,2.4541.03125,1.22973,0,2.4541-.03125c.10791-.00293.21485-.00879.32227-.01172.71777-.02051,1.43408-.0459,2.14892-.082.02491-.001.04932-.00293.07373-.00439A96.004,96.004,0,0,0,223.87061,132.999c.00146-.02441.00341-.04882.00439-.07373.03613-.71484.06152-1.43115.082-2.14892.00293-.10742.00879-.21436.01172-.32227Q223.99952,129.2295,224,128q0-1.22973-.03125-2.4541C223.96582,125.438,223.96,125.33105,223.957,125.22363ZM184,136H128a8.00008,8.00008,0,0,1-8-8V72a8,8,0,0,1,16,0v48h48a8,8,0,0,1,0,16Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "128 72 128 128 184 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "195.88225",
      "y1": "26.17662",
      "x2": "229.82338",
      "y2": "60.11775",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "26.17662",
      "y1": "60.11775",
      "x2": "60.11775",
      "y2": "26.17662",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "128 72 128 128 184 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "195.88225",
      "y1": "26.17662",
      "x2": "229.82338",
      "y2": "60.11775",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "26.17662",
      "y1": "60.11775",
      "x2": "60.11775",
      "y2": "26.17662",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "128 72 128 128 184 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "195.88225",
      "y1": "26.17662",
      "x2": "229.82338",
      "y2": "60.11775",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "26.17662",
      "y1": "60.11775",
      "x2": "60.11775",
      "y2": "26.17662",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8 = [];
/* style */

const __vue_inject_styles__$8 = undefined;
/* scoped */

const __vue_scope_id__$8 = undefined;
/* module identifier */

const __vue_module_identifier__$8 = undefined;
/* functional template */

const __vue_is_functional_template__$8 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8,
  staticRenderFns: __vue_staticRenderFns__$8
}, __vue_inject_styles__$8, __vue_script__$8, __vue_scope_id__$8, __vue_is_functional_template__$8, __vue_module_identifier__$8, false, undefined, undefined, undefined);

var script$9 = Vue.extend({
  name: "PhAlignBottom",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9 = script$9;
/* template */

var __vue_render__$9 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "216.00488",
      "y1": "216.00586",
      "x2": "40.00488",
      "y2": "216.00586",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "122",
      "y": "98",
      "width": "104",
      "height": "52",
      "rx": "8",
      "transform": "translate(50 298) rotate(-90)",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "56",
      "y": "32",
      "width": "52",
      "height": "144",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "116",
      "y": "100",
      "width": "112",
      "height": "56",
      "rx": "8",
      "transform": "translate(44 300) rotate(-90)",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "56",
      "y": "32",
      "width": "56",
      "height": "152",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216.00488",
      "y1": "216.00586",
      "x2": "40.00488",
      "y2": "216.00586",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "116",
      "y": "100",
      "width": "112",
      "height": "56",
      "rx": "8",
      "transform": "translate(44 300) rotate(-90)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "56",
      "y": "32",
      "width": "56",
      "height": "152",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224.00488,216.00586a8.00008,8.00008,0,0,1-8,8h-176a8,8,0,1,1,0-16h176A8.00008,8.00008,0,0,1,224.00488,216.00586ZM152,192h40a16.01833,16.01833,0,0,0,16-16V80a16.01833,16.01833,0,0,0-16-16H152a16.01833,16.01833,0,0,0-16,16v96A16.01833,16.01833,0,0,0,152,192Zm-88,0h40a16.01833,16.01833,0,0,0,16-16V40a16.01833,16.01833,0,0,0-16-16H64A16.01833,16.01833,0,0,0,48,40V176A16.01833,16.01833,0,0,0,64,192Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "216.00488",
      "y1": "216.00586",
      "x2": "40.00488",
      "y2": "216.00586",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "116",
      "y": "100",
      "width": "112",
      "height": "56",
      "rx": "8",
      "transform": "translate(44 300) rotate(-90)",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "56",
      "y": "32",
      "width": "56",
      "height": "152",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "216.00488",
      "y1": "216.00586",
      "x2": "40.00488",
      "y2": "216.00586",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "116",
      "y": "100",
      "width": "112",
      "height": "56",
      "rx": "8",
      "transform": "translate(44 300) rotate(-90)",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "56",
      "y": "32",
      "width": "56",
      "height": "152",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "216.00488",
      "y1": "216.00586",
      "x2": "40.00488",
      "y2": "216.00586",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "116",
      "y": "100",
      "width": "112",
      "height": "56",
      "rx": "8",
      "transform": "translate(44 300) rotate(-90)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "56",
      "y": "32",
      "width": "56",
      "height": "152",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9 = [];
/* style */

const __vue_inject_styles__$9 = undefined;
/* scoped */

const __vue_scope_id__$9 = undefined;
/* module identifier */

const __vue_module_identifier__$9 = undefined;
/* functional template */

const __vue_is_functional_template__$9 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9,
  staticRenderFns: __vue_staticRenderFns__$9
}, __vue_inject_styles__$9, __vue_script__$9, __vue_scope_id__$9, __vue_is_functional_template__$9, __vue_module_identifier__$9, false, undefined, undefined, undefined);

var script$a = Vue.extend({
  name: "PhAlignCenterHorizontal",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$a = script$a;
/* template */

var __vue_render__$a = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "31.99512",
      "x2": "128",
      "y2": "51.99512",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "203.99512",
      "x2": "128",
      "y2": "223.99512",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "107.99512",
      "x2": "128",
      "y2": "147.99512",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "64",
      "y": "52",
      "width": "128",
      "height": "56",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "148",
      "width": "176",
      "height": "56",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "64",
      "y": "56",
      "width": "128",
      "height": "56",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "144",
      "width": "176",
      "height": "56",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "31.99512",
      "x2": "128",
      "y2": "55.99512",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "199.99512",
      "x2": "128",
      "y2": "223.99512",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "111.99512",
      "x2": "128",
      "y2": "143.99512",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "64",
      "y": "56",
      "width": "128",
      "height": "56",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "144",
      "width": "176",
      "height": "56",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,152v40a16.01833,16.01833,0,0,1-16,16H136v15.99512a8,8,0,0,1-16,0V208H48a16.01833,16.01833,0,0,1-16-16V152a16.01833,16.01833,0,0,1,16-16h72V120H72a16.01833,16.01833,0,0,1-16-16V64A16.01833,16.01833,0,0,1,72,48h48V31.99512a8,8,0,1,1,16,0V48h48a16.01833,16.01833,0,0,1,16,16v40a16.01833,16.01833,0,0,1-16,16H136v16h72A16.01833,16.01833,0,0,1,224,152Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "31.99512",
      "x2": "128",
      "y2": "55.99512",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "199.99512",
      "x2": "128",
      "y2": "223.99512",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "111.99512",
      "x2": "128",
      "y2": "143.99512",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "64",
      "y": "56",
      "width": "128",
      "height": "56",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "144",
      "width": "176",
      "height": "56",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "31.99512",
      "x2": "128",
      "y2": "55.99512",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "199.99512",
      "x2": "128",
      "y2": "223.99512",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "111.99512",
      "x2": "128",
      "y2": "143.99512",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "64",
      "y": "56",
      "width": "128",
      "height": "56",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "144",
      "width": "176",
      "height": "56",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "31.99512",
      "x2": "128",
      "y2": "55.99512",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "199.99512",
      "x2": "128",
      "y2": "223.99512",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "111.99512",
      "x2": "128",
      "y2": "143.99512",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "64",
      "y": "56",
      "width": "128",
      "height": "56",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "144",
      "width": "176",
      "height": "56",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$a = [];
/* style */

const __vue_inject_styles__$a = undefined;
/* scoped */

const __vue_scope_id__$a = undefined;
/* module identifier */

const __vue_module_identifier__$a = undefined;
/* functional template */

const __vue_is_functional_template__$a = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$a = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$a,
  staticRenderFns: __vue_staticRenderFns__$a
}, __vue_inject_styles__$a, __vue_script__$a, __vue_scope_id__$a, __vue_is_functional_template__$a, __vue_module_identifier__$a, false, undefined, undefined, undefined);

var script$b = Vue.extend({
  name: "PhAlignCenterVertical",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$b = script$b;
/* template */

var __vue_render__$b = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "224.00488",
      "y1": "128",
      "x2": "204.00488",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "52.00488",
      "y1": "128",
      "x2": "32.00488",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "148.00488",
      "y1": "128",
      "x2": "108.00488",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "112",
      "y": "100",
      "width": "128",
      "height": "56",
      "rx": "8",
      "transform": "translate(304 -48) rotate(90)",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "52",
      "y": "40",
      "width": "56",
      "height": "176",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "224.00488",
      "y1": "128",
      "x2": "200.00488",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "108",
      "y": "100",
      "width": "128",
      "height": "56",
      "rx": "8",
      "transform": "translate(300 -44) rotate(90)",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "56",
      "y": "40",
      "width": "56",
      "height": "176",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56.00488",
      "y1": "128",
      "x2": "32.00488",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144.00488",
      "y1": "128",
      "x2": "112.00488",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "108",
      "y": "100",
      "width": "128",
      "height": "56",
      "rx": "8",
      "transform": "translate(300 -44) rotate(90)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "56",
      "y": "40",
      "width": "56",
      "height": "176",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232.00488,128a7.99977,7.99977,0,0,1-8,8H208v48a16.01833,16.01833,0,0,1-16,16H152a16.01833,16.01833,0,0,1-16-16V136H120v72a16.01833,16.01833,0,0,1-16,16H64a16.01833,16.01833,0,0,1-16-16V136H32.00488a8,8,0,0,1,0-16H48V48A16.01833,16.01833,0,0,1,64,32h40a16.01833,16.01833,0,0,1,16,16v72h16V72a16.01833,16.01833,0,0,1,16-16h40a16.01833,16.01833,0,0,1,16,16v48h16.00488A7.99977,7.99977,0,0,1,232.00488,128Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "224.00488",
      "y1": "128",
      "x2": "200.00488",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56.00488",
      "y1": "128",
      "x2": "32.00488",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144.00488",
      "y1": "128",
      "x2": "112.00488",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "108",
      "y": "100",
      "width": "128",
      "height": "56",
      "rx": "8",
      "transform": "translate(300 -44) rotate(90)",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "56",
      "y": "40",
      "width": "56",
      "height": "176",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "224.00488",
      "y1": "128",
      "x2": "200.00488",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56.00488",
      "y1": "128",
      "x2": "32.00488",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144.00488",
      "y1": "128",
      "x2": "112.00488",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "108",
      "y": "100",
      "width": "128",
      "height": "56",
      "rx": "8",
      "transform": "translate(300 -44) rotate(90)",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "56",
      "y": "40",
      "width": "56",
      "height": "176",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "224.00488",
      "y1": "128",
      "x2": "200.00488",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56.00488",
      "y1": "128",
      "x2": "32.00488",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144.00488",
      "y1": "128",
      "x2": "112.00488",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "108",
      "y": "100",
      "width": "128",
      "height": "56",
      "rx": "8",
      "transform": "translate(300 -44) rotate(90)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "56",
      "y": "40",
      "width": "56",
      "height": "176",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$b = [];
/* style */

const __vue_inject_styles__$b = undefined;
/* scoped */

const __vue_scope_id__$b = undefined;
/* module identifier */

const __vue_module_identifier__$b = undefined;
/* functional template */

const __vue_is_functional_template__$b = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$b = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$b,
  staticRenderFns: __vue_staticRenderFns__$b
}, __vue_inject_styles__$b, __vue_script__$b, __vue_scope_id__$b, __vue_is_functional_template__$b, __vue_module_identifier__$b, false, undefined, undefined, undefined);

var script$c = Vue.extend({
  name: "PhAlignLeft",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$c = script$c;
/* template */

var __vue_render__$c = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "39.99414",
      "y1": "39.99512",
      "x2": "39.99414",
      "y2": "215.99512",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "80",
      "y": "56",
      "width": "104",
      "height": "52",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "80",
      "y": "148",
      "width": "144",
      "height": "52",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "72",
      "y": "56",
      "width": "112",
      "height": "56",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "72",
      "y": "144",
      "width": "152",
      "height": "56",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "72",
      "y": "144",
      "width": "152",
      "height": "56",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "39.99414",
      "y1": "39.99512",
      "x2": "39.99414",
      "y2": "215.99512",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "72",
      "y": "56",
      "width": "112",
      "height": "56",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M47.99414,39.99512v176a8,8,0,0,1-16,0v-176a8,8,0,0,1,16,0ZM80,120h96a16.01833,16.01833,0,0,0,16-16V64a16.01833,16.01833,0,0,0-16-16H80A16.01833,16.01833,0,0,0,64,64v40A16.01833,16.01833,0,0,0,80,120Zm136,16H80a16.01833,16.01833,0,0,0-16,16v40a16.01833,16.01833,0,0,0,16,16H216a16.01833,16.01833,0,0,0,16-16V152A16.01833,16.01833,0,0,0,216,136Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "39.99414",
      "y1": "39.99512",
      "x2": "39.99414",
      "y2": "215.99512",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "72",
      "y": "56",
      "width": "112",
      "height": "56",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "72",
      "y": "144",
      "width": "152",
      "height": "56",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "39.99414",
      "y1": "39.99512",
      "x2": "39.99414",
      "y2": "215.99512",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "72",
      "y": "56",
      "width": "112",
      "height": "56",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "72",
      "y": "144",
      "width": "152",
      "height": "56",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "39.99414",
      "y1": "39.99512",
      "x2": "39.99414",
      "y2": "215.99512",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "72",
      "y": "56",
      "width": "112",
      "height": "56",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "72",
      "y": "144",
      "width": "152",
      "height": "56",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$c = [];
/* style */

const __vue_inject_styles__$c = undefined;
/* scoped */

const __vue_scope_id__$c = undefined;
/* module identifier */

const __vue_module_identifier__$c = undefined;
/* functional template */

const __vue_is_functional_template__$c = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$c = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$c,
  staticRenderFns: __vue_staticRenderFns__$c
}, __vue_inject_styles__$c, __vue_script__$c, __vue_scope_id__$c, __vue_is_functional_template__$c, __vue_module_identifier__$c, false, undefined, undefined, undefined);

var script$d = Vue.extend({
  name: "PhAlignRight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$d = script$d;
/* template */

var __vue_render__$d = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "216.00586",
      "y1": "39.99512",
      "x2": "216.00586",
      "y2": "215.99512",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "72",
      "y": "56",
      "width": "104",
      "height": "52",
      "rx": "8",
      "transform": "translate(248 164) rotate(180)",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "148",
      "width": "144",
      "height": "52",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "72",
      "y": "56",
      "width": "112",
      "height": "56",
      "rx": "8",
      "transform": "translate(256 168) rotate(180)",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "144",
      "width": "152",
      "height": "56",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216.00586",
      "y1": "39.99512",
      "x2": "216.00586",
      "y2": "215.99512",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "72",
      "y": "56",
      "width": "112",
      "height": "56",
      "rx": "8",
      "transform": "translate(256 168) rotate(180)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "144",
      "width": "152",
      "height": "56",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224.00586,39.99512v176a8,8,0,0,1-16,0v-176a8,8,0,0,1,16,0ZM176,48H80A16.01833,16.01833,0,0,0,64,64v40a16.01833,16.01833,0,0,0,16,16h96a16.01833,16.01833,0,0,0,16-16V64A16.01833,16.01833,0,0,0,176,48Zm0,88H40a16.01833,16.01833,0,0,0-16,16v40a16.01833,16.01833,0,0,0,16,16H176a16.01833,16.01833,0,0,0,16-16V152A16.01833,16.01833,0,0,0,176,136Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "216.00586",
      "y1": "39.99512",
      "x2": "216.00586",
      "y2": "215.99512",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "72",
      "y": "56",
      "width": "112",
      "height": "56",
      "rx": "8",
      "transform": "translate(256 168) rotate(180)",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "144",
      "width": "152",
      "height": "56",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "216.00586",
      "y1": "39.99512",
      "x2": "216.00586",
      "y2": "215.99512",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "72",
      "y": "56",
      "width": "112",
      "height": "56",
      "rx": "8",
      "transform": "translate(256 168) rotate(180)",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "144",
      "width": "152",
      "height": "56",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "216.00586",
      "y1": "39.99512",
      "x2": "216.00586",
      "y2": "215.99512",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "72",
      "y": "56",
      "width": "112",
      "height": "56",
      "rx": "8",
      "transform": "translate(256 168) rotate(180)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "144",
      "width": "152",
      "height": "56",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$d = [];
/* style */

const __vue_inject_styles__$d = undefined;
/* scoped */

const __vue_scope_id__$d = undefined;
/* module identifier */

const __vue_module_identifier__$d = undefined;
/* functional template */

const __vue_is_functional_template__$d = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$d = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$d,
  staticRenderFns: __vue_staticRenderFns__$d
}, __vue_inject_styles__$d, __vue_script__$d, __vue_scope_id__$d, __vue_is_functional_template__$d, __vue_module_identifier__$d, false, undefined, undefined, undefined);

var script$e = Vue.extend({
  name: "PhAlignTop",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$e = script$e;
/* template */

var __vue_render__$e = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "216.00488",
      "y1": "39.99414",
      "x2": "40.00488",
      "y2": "39.99414",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "122",
      "y": "106",
      "width": "104",
      "height": "52",
      "rx": "8",
      "transform": "translate(306 -42) rotate(90)",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "56",
      "y": "80",
      "width": "52",
      "height": "144",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "116",
      "y": "100",
      "width": "112",
      "height": "56",
      "rx": "8",
      "transform": "translate(300 -44) rotate(90)",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "56",
      "y": "72",
      "width": "56",
      "height": "152",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216.00488",
      "y1": "39.99414",
      "x2": "40.00488",
      "y2": "39.99414",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "116",
      "y": "100",
      "width": "112",
      "height": "56",
      "rx": "8",
      "transform": "translate(300 -44) rotate(90)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "56",
      "y": "72",
      "width": "56",
      "height": "152",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224.00488,39.99414a7.99977,7.99977,0,0,1-8,8h-176a8,8,0,0,1,0-16h176A7.99977,7.99977,0,0,1,224.00488,39.99414ZM192,64H152a16.01833,16.01833,0,0,0-16,16v96a16.01833,16.01833,0,0,0,16,16h40a16.01833,16.01833,0,0,0,16-16V80A16.01833,16.01833,0,0,0,192,64Zm-88,0H64A16.01833,16.01833,0,0,0,48,80V216a16.01833,16.01833,0,0,0,16,16h40a16.01833,16.01833,0,0,0,16-16V80A16.01833,16.01833,0,0,0,104,64Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "216.00488",
      "y1": "39.99414",
      "x2": "40.00488",
      "y2": "39.99414",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "116",
      "y": "100",
      "width": "112",
      "height": "56",
      "rx": "8",
      "transform": "translate(300 -44) rotate(90)",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "56",
      "y": "72",
      "width": "56",
      "height": "152",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "216.00488",
      "y1": "39.99414",
      "x2": "40.00488",
      "y2": "39.99414",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "116",
      "y": "100",
      "width": "112",
      "height": "56",
      "rx": "8",
      "transform": "translate(300 -44) rotate(90)",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "56",
      "y": "72",
      "width": "56",
      "height": "152",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "216.00488",
      "y1": "39.99414",
      "x2": "40.00488",
      "y2": "39.99414",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "116",
      "y": "100",
      "width": "112",
      "height": "56",
      "rx": "8",
      "transform": "translate(300 -44) rotate(90)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "56",
      "y": "72",
      "width": "56",
      "height": "152",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$e = [];
/* style */

const __vue_inject_styles__$e = undefined;
/* scoped */

const __vue_scope_id__$e = undefined;
/* module identifier */

const __vue_module_identifier__$e = undefined;
/* functional template */

const __vue_is_functional_template__$e = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$e = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$e,
  staticRenderFns: __vue_staticRenderFns__$e
}, __vue_inject_styles__$e, __vue_script__$e, __vue_scope_id__$e, __vue_is_functional_template__$e, __vue_module_identifier__$e, false, undefined, undefined, undefined);

var script$f = Vue.extend({
  name: "PhAnchor",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$f = script$f;
/* template */

var __vue_render__$f = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "232",
      "x2": "128",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "52",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "112",
      "x2": "168",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,144a48,48,0,0,0,48,48,40,40,0,0,1,40,40,40,40,0,0,1,40-40,48,48,0,0,0,48-48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "232",
      "x2": "128",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "52",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "112",
      "x2": "168",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,144a48,48,0,0,0,48,48,40,40,0,0,1,40,40,40,40,0,0,1,40-40,48,48,0,0,0,48-48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,136a8.00039,8.00039,0,0,0-8,8,40.04584,40.04584,0,0,1-40,40,47.79539,47.79539,0,0,0-32,12.27148V120h32a8,8,0,0,0,0-16H136V78.8291a28,28,0,1,0-16,0V104H88a8,8,0,0,0,0,16h32v76.27148A47.79539,47.79539,0,0,0,88,184a40.04584,40.04584,0,0,1-40-40,8,8,0,0,0-16,0,56.0629,56.0629,0,0,0,56,56,32.03667,32.03667,0,0,1,32,32,8,8,0,0,0,16,0,32.03667,32.03667,0,0,1,32-32,56.0629,56.0629,0,0,0,56-56A8.00039,8.00039,0,0,0,216,136ZM116,52a12,12,0,1,1,12,12A12.01312,12.01312,0,0,1,116,52Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "232",
      "x2": "128",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "52",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "112",
      "x2": "168",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,144a48,48,0,0,0,48,48,40,40,0,0,1,40,40,40,40,0,0,1,40-40,48,48,0,0,0,48-48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "232",
      "x2": "128",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "52",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "112",
      "x2": "168",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,144a48,48,0,0,0,48,48,40,40,0,0,1,40,40,40,40,0,0,1,40-40,48,48,0,0,0,48-48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "232",
      "x2": "128",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "52",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "112",
      "x2": "168",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,144a48,48,0,0,0,48,48,40,40,0,0,1,40,40,40,40,0,0,1,40-40,48,48,0,0,0,48-48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$f = [];
/* style */

const __vue_inject_styles__$f = undefined;
/* scoped */

const __vue_scope_id__$f = undefined;
/* module identifier */

const __vue_module_identifier__$f = undefined;
/* functional template */

const __vue_is_functional_template__$f = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$f = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$f,
  staticRenderFns: __vue_staticRenderFns__$f
}, __vue_inject_styles__$f, __vue_script__$f, __vue_scope_id__$f, __vue_is_functional_template__$f, __vue_module_identifier__$f, false, undefined, undefined, undefined);

var script$g = Vue.extend({
  name: "PhAnchorSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$g = script$g;
/* template */

var __vue_render__$g = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128.00098",
      "cy": "63.99707",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128.00098",
      "y1": "215.99707",
      "x2": "128.00098",
      "y2": "87.99707",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56.001,119.99707h-24a96,96,0,0,0,192,0h-24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128.00098",
      "cy": "63.99707",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128.00098",
      "y1": "215.99707",
      "x2": "128.00098",
      "y2": "87.99707",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56.001,119.99707h-24a96,96,0,0,0,192,0h-24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224.001,111.99707h-24a8,8,0,0,0,0,16h15.63964A88.14248,88.14248,0,0,1,136.001,207.626V94.98437a32,32,0,1,0-16,0V207.626a88.1425,88.1425,0,0,1-79.63965-79.62891H56.001a8,8,0,0,0,0-16h-24a8.00039,8.00039,0,0,0-8,8,104,104,0,0,0,208,0A8.00039,8.00039,0,0,0,224.001,111.99707Zm-112-48a16,16,0,1,1,16,16A16.01833,16.01833,0,0,1,112.001,63.99707Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128.00098",
      "cy": "63.99707",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128.00098",
      "y1": "215.99707",
      "x2": "128.00098",
      "y2": "87.99707",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56.001,119.99707h-24a96,96,0,0,0,192,0h-24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128.00098",
      "cy": "63.99707",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128.00098",
      "y1": "215.99707",
      "x2": "128.00098",
      "y2": "87.99707",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56.001,119.99707h-24a96,96,0,0,0,192,0h-24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128.00098",
      "cy": "63.99707",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128.00098",
      "y1": "215.99707",
      "x2": "128.00098",
      "y2": "87.99707",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56.001,119.99707h-24a96,96,0,0,0,192,0h-24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$g = [];
/* style */

const __vue_inject_styles__$g = undefined;
/* scoped */

const __vue_scope_id__$g = undefined;
/* module identifier */

const __vue_module_identifier__$g = undefined;
/* functional template */

const __vue_is_functional_template__$g = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$g = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$g,
  staticRenderFns: __vue_staticRenderFns__$g
}, __vue_inject_styles__$g, __vue_script__$g, __vue_scope_id__$g, __vue_is_functional_template__$g, __vue_module_identifier__$g, false, undefined, undefined, undefined);

var script$h = Vue.extend({
  name: "PhAndroidLogo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$h = script$h;
/* template */

var __vue_render__$h = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "164",
      "cy": "156",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92.00001",
      "cy": "156.00002",
      "r": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,192V169.12886C24,111.65,70.15361,64.19953,127.63214,64.00066A104,104,0,0,1,232,168v24a8,8,0,0,1-8,8H32A8,8,0,0,1,24,192Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "56.00002",
      "x2": "63.07266",
      "y2": "87.07268",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "56.00002",
      "x2": "193.10334",
      "y2": "86.89668",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M24,192V169.12886C24,111.65,70.15361,64.19953,127.63214,64.00066A104,104,0,0,1,232,168v24a8,8,0,0,1-8,8H32A8,8,0,0,1,24,192Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "156",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "156",
      "r": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,192V169.12886C24,111.65,70.15361,64.19953,127.63214,64.00066A104,104,0,0,1,232,168v24a8,8,0,0,1-8,8H32A8,8,0,0,1,24,192Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "56.00002",
      "x2": "63.07266",
      "y2": "87.07268",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "56.00002",
      "x2": "193.10334",
      "y2": "86.89668",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M207.05811,88.666q-1.10724-1.103-2.24146-2.16895l24.84009-24.84033a7.99984,7.99984,0,0,0-11.31348-11.31348L192.3728,76.3135a111.42105,111.42105,0,0,0-128.55444.19092L37.65674,50.34328A7.99984,7.99984,0,0,0,26.34326,61.65676L51.40283,86.71633A113.38256,113.38256,0,0,0,16,169.12893V192a16.01833,16.01833,0,0,0,16,16H224a16.01833,16.01833,0,0,0,16-16V168A111.25215,111.25215,0,0,0,207.05811,88.666ZM92,168a12,12,0,1,1,12-12A12,12,0,0,1,92,168Zm72,0a12,12,0,1,1,12-12A12,12,0,0,1,164,168Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "164",
      "cy": "156",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "156",
      "r": "10"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,192V169.12886C24,111.65,70.15361,64.19953,127.63214,64.00066A104,104,0,0,1,232,168v24a8,8,0,0,1-8,8H32A8,8,0,0,1,24,192Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "56.00002",
      "x2": "63.07266",
      "y2": "87.07268",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "56.00002",
      "x2": "193.10334",
      "y2": "86.89668",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "164",
      "cy": "156",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "156",
      "r": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,192V169.12886C24,111.65,70.15361,64.19953,127.63214,64.00066A104,104,0,0,1,232,168v24a8,8,0,0,1-8,8H32A8,8,0,0,1,24,192Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "56.00002",
      "x2": "63.07266",
      "y2": "87.07268",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "56.00002",
      "x2": "193.10334",
      "y2": "86.89668",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "164",
      "cy": "156",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "156",
      "r": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,192V169.12886C24,111.65,70.15361,64.19953,127.63214,64.00066A104,104,0,0,1,232,168v24a8,8,0,0,1-8,8H32A8,8,0,0,1,24,192Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "56.00002",
      "x2": "63.07266",
      "y2": "87.07268",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "56.00002",
      "x2": "193.10334",
      "y2": "86.89668",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$h = [];
/* style */

const __vue_inject_styles__$h = undefined;
/* scoped */

const __vue_scope_id__$h = undefined;
/* module identifier */

const __vue_module_identifier__$h = undefined;
/* functional template */

const __vue_is_functional_template__$h = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$h = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$h,
  staticRenderFns: __vue_staticRenderFns__$h
}, __vue_inject_styles__$h, __vue_script__$h, __vue_scope_id__$h, __vue_is_functional_template__$h, __vue_module_identifier__$h, false, undefined, undefined, undefined);

var script$i = Vue.extend({
  name: "PhAperture",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$i = script$i;
/* template */

var __vue_render__$i = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "32",
      "x2": "164.6771",
      "y2": "134.69588",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "44.86156",
      "y1": "80",
      "x2": "152.13735",
      "y2": "99.58464",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "44.86156",
      "y1": "176",
      "x2": "115.46025",
      "y2": "92.88876",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "224",
      "x2": "91.3229",
      "y2": "121.30412",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "211.13844",
      "y1": "176",
      "x2": "103.86265",
      "y2": "156.41536",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "211.13844",
      "y1": "80",
      "x2": "140.53975",
      "y2": "163.11124",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M195.88226,60.11768a96.00006,96.00006,0,1,0,0,135.76464A96.00019,96.00019,0,0,0,195.88226,60.11768ZM164.67712,134.6958l-24.13733,28.41553h-.00006l-36.67706-6.6958-.00006-.00049L91.32294,121.3042h0l24.13733-28.41553h.00006l36.67706,6.6958h0l12.53973,35.11133Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "32",
      "x2": "164.6771",
      "y2": "134.69588",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "44.86156",
      "y1": "80",
      "x2": "152.13735",
      "y2": "99.58464",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "44.86156",
      "y1": "176",
      "x2": "115.46025",
      "y2": "92.88876",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "224",
      "x2": "91.3229",
      "y2": "121.30412",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "211.13844",
      "y1": "176",
      "x2": "103.86265",
      "y2": "156.41536",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "211.13844",
      "y1": "80",
      "x2": "140.53975",
      "y2": "163.11124",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232,128A103.99994,103.99994,0,0,0,54.46094,54.46094,103.99951,103.99951,0,0,0,127.97,231.99951c.01,0,.0199.00244.03.00244.02148,0,.04321-.00244.0647-.00293A103.99851,103.99851,0,0,0,232,128ZM49.17554,88.91992l51.21631,9.35059L46.65076,161.53613A88.43277,88.43277,0,0,1,49.17554,88.91992Zm160.17383,5.54395a88.43282,88.43282,0,0,1-2.52491,72.61621l-51.21631-9.35059Zm-8.079-15.2041-33.7201,39.69628L139.63037,40.78027a87.98552,87.98552,0,0,1,61.64,38.4795ZM122.43164,40.19336l17.51148,49.03271L58.2959,74.32031a88.35033,88.35033,0,0,1,7.47851-8.54492A87.33436,87.33436,0,0,1,122.43164,40.19336Zm-67.702,136.54687L88.44971,137.044l27.91992,78.17578a87.98552,87.98552,0,0,1-61.64-38.4795Zm78.83875,39.06641-17.51148-49.03271,23.08216,4.21386.04553.0083,58.51953,10.6836a88.35033,88.35033,0,0,1-7.47851,8.54492A87.33436,87.33436,0,0,1,133.56836,215.80664Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "32",
      "x2": "164.6771",
      "y2": "134.69588",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "44.86156",
      "y1": "80",
      "x2": "152.13735",
      "y2": "99.58464",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "44.86156",
      "y1": "176",
      "x2": "115.46025",
      "y2": "92.88876",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "224",
      "x2": "91.3229",
      "y2": "121.30412",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "211.13844",
      "y1": "176",
      "x2": "103.86265",
      "y2": "156.41536",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "211.13844",
      "y1": "80",
      "x2": "140.53975",
      "y2": "163.11124",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "32",
      "x2": "164.6771",
      "y2": "134.69588",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "44.86156",
      "y1": "80",
      "x2": "152.13735",
      "y2": "99.58464",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "44.86156",
      "y1": "176",
      "x2": "115.46025",
      "y2": "92.88876",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "224",
      "x2": "91.3229",
      "y2": "121.30412",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "211.13844",
      "y1": "176",
      "x2": "103.86265",
      "y2": "156.41536",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "211.13844",
      "y1": "80",
      "x2": "140.53975",
      "y2": "163.11124",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "32",
      "x2": "164.6771",
      "y2": "134.69588",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "44.86156",
      "y1": "80",
      "x2": "152.13735",
      "y2": "99.58464",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "44.86156",
      "y1": "176",
      "x2": "115.46025",
      "y2": "92.88876",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "224",
      "x2": "91.3229",
      "y2": "121.30412",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "211.13844",
      "y1": "176",
      "x2": "103.86265",
      "y2": "156.41536",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "211.13844",
      "y1": "80",
      "x2": "140.53975",
      "y2": "163.11124",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$i = [];
/* style */

const __vue_inject_styles__$i = undefined;
/* scoped */

const __vue_scope_id__$i = undefined;
/* module identifier */

const __vue_module_identifier__$i = undefined;
/* functional template */

const __vue_is_functional_template__$i = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$i = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$i,
  staticRenderFns: __vue_staticRenderFns__$i
}, __vue_inject_styles__$i, __vue_script__$i, __vue_scope_id__$i, __vue_is_functional_template__$i, __vue_module_identifier__$i, false, undefined, undefined, undefined);

var script$j = Vue.extend({
  name: "PhAppWindow",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$j = script$j;
/* template */

var __vue_render__$j = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48.00586",
      "width": "192",
      "height": "160",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "76",
      "cy": "92.00586",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "124",
      "cy": "92.00586",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48.00586",
      "width": "192",
      "height": "160",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48.00586",
      "width": "192",
      "height": "160",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "84.00586",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "108",
      "cy": "84.00586",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,40.00586H40a16.01833,16.01833,0,0,0-16,16v144a16.01833,16.01833,0,0,0,16,16H216a16.01833,16.01833,0,0,0,16-16v-144A16.01833,16.01833,0,0,0,216,40.00586Zm-148,56a12,12,0,1,1,12-12A12,12,0,0,1,68,96.00586Zm40,0a12,12,0,1,1,12-12A12,12,0,0,1,108,96.00586Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48.00586",
      "width": "192",
      "height": "160",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "84.00586",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "108",
      "cy": "84.00586",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48.00586",
      "width": "192",
      "height": "160",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "84.00586",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "108",
      "cy": "84.00586",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48.00586",
      "width": "192",
      "height": "160",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "84.00586",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "108",
      "cy": "84.00586",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$j = [];
/* style */

const __vue_inject_styles__$j = undefined;
/* scoped */

const __vue_scope_id__$j = undefined;
/* module identifier */

const __vue_module_identifier__$j = undefined;
/* functional template */

const __vue_is_functional_template__$j = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$j = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$j,
  staticRenderFns: __vue_staticRenderFns__$j
}, __vue_inject_styles__$j, __vue_script__$j, __vue_scope_id__$j, __vue_is_functional_template__$j, __vue_module_identifier__$j, false, undefined, undefined, undefined);

var script$k = Vue.extend({
  name: "PhAppleLogo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$k = script$k;
/* template */

var __vue_render__$k = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M218.51254,162.9332C205.936,193.65156,183.10562,216,164,216H92c-28,0-64-48-64-100A60.00062,60.00062,0,0,1,128.00185,71.27954l-.00164-.00185a60.0047,60.0047,0,0,1,87.16862,7.63587l-.00019.00015a48.01693,48.01693,0,0,0,3.33915,84.01754Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M218.51254,162.9332C205.936,193.65156,183.10562,216,164,216H92c-28,0-64-48-64-100A60.00062,60.00062,0,0,1,128.00185,71.27954l-.00164-.00185a60.0047,60.0047,0,0,1,87.16862,7.63587l-.00019.00015a48.01693,48.01693,0,0,0,3.33915,84.01754Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M143.53892,23.36749A31.931,31.931,0,0,1,168,12",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M218.51254,162.9332C205.936,193.65156,183.10562,216,164,216H92c-28,0-64-48-64-100A60.00062,60.00062,0,0,1,128.00185,71.27954l-.00164-.00185a60.0047,60.0047,0,0,1,87.16862,7.63587l-.00019.00015a48.01693,48.01693,0,0,0,3.33915,84.01754Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M138.12628,32.506A32.01179,32.01179,0,0,1,168,12",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M218.51254,162.9332C205.936,193.65156,183.10562,216,164,216H92c-28,0-64-48-64-100A60.00062,60.00062,0,0,1,128.00185,71.27954l-.00164-.00185a60.0047,60.0047,0,0,1,87.16862,7.63587l-.00019.00015a48.01693,48.01693,0,0,0,3.33915,84.01754Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M130.66016,29.63136A40.25041,40.25041,0,0,1,168,4a8,8,0,0,1,0,16,24.15408,24.15408,0,0,0-22.4082,15.38037,8.00008,8.00008,0,0,1-14.93164-5.749Zm91.38476,126.12451a40.01719,40.01719,0,0,1-2.73144-69.99951,8.00039,8.00039,0,0,0,2.14111-11.7915A68.012,68.012,0,0,0,128,61.00441,68.00487,68.00487,0,0,0,20,116c0,25.50293,8.33594,52.4668,22.87109,73.97852C57.26514,211.28224,75.63086,224,92,224h72c22.46533,0,47.92578-23.86523,61.916-58.03515A8.00438,8.00438,0,0,0,222.04492,155.75587Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M138.12628,32.506A32.01179,32.01179,0,0,1,168,12",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M218.51254,162.9332C205.936,193.65156,183.10562,216,164,216H92c-28,0-64-48-64-100A60.00062,60.00062,0,0,1,128.00185,71.27954l-.00164-.00185a60.0047,60.0047,0,0,1,87.16862,7.63587l-.00019.00015a48.01693,48.01693,0,0,0,3.33915,84.01754Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M138.12628,32.506A32.01179,32.01179,0,0,1,168,12",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M218.51254,162.9332C205.936,193.65156,183.10562,216,164,216H92c-28,0-64-48-64-100A60.00062,60.00062,0,0,1,128.00185,71.27954l-.00164-.00185a60.0047,60.0047,0,0,1,87.16862,7.63587l-.00019.00015a48.01693,48.01693,0,0,0,3.33915,84.01754Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M138.12628,32.506A32.01179,32.01179,0,0,1,168,12",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M218.51254,162.9332C205.936,193.65156,183.10562,216,164,216H92c-28,0-64-48-64-100A60.00062,60.00062,0,0,1,128.00185,71.27954l-.00164-.00185a60.0047,60.0047,0,0,1,87.16862,7.63587l-.00019.00015a48.01693,48.01693,0,0,0,3.33915,84.01754Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$k = [];
/* style */

const __vue_inject_styles__$k = undefined;
/* scoped */

const __vue_scope_id__$k = undefined;
/* module identifier */

const __vue_module_identifier__$k = undefined;
/* functional template */

const __vue_is_functional_template__$k = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$k = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$k,
  staticRenderFns: __vue_staticRenderFns__$k
}, __vue_inject_styles__$k, __vue_script__$k, __vue_scope_id__$k, __vue_is_functional_template__$k, __vue_module_identifier__$k, false, undefined, undefined, undefined);

var script$l = Vue.extend({
  name: "PhArchive",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$l = script$l;
/* template */

var __vue_render__$l = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "56",
      "width": "208",
      "height": "40",
      "rx": "7.99999",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,96v96a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "136",
      "x2": "152",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,96v96a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V96Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "24",
      "y": "56",
      "width": "208",
      "height": "40",
      "rx": "7.99999",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,96v96a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "136",
      "x2": "152",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,48H32A16.01833,16.01833,0,0,0,16,64V88a16.01833,16.01833,0,0,0,16,16v88a16.01833,16.01833,0,0,0,16,16H208a16.01833,16.01833,0,0,0,16-16V104a16.01833,16.01833,0,0,0,16-16V64A16.01833,16.01833,0,0,0,224,48Zm-72,96H104a8,8,0,0,1,0-16h48a8,8,0,0,1,0,16Zm72-56H32V64H224l.00977,24Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "56",
      "width": "208",
      "height": "40",
      "rx": "7.99999",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,96v96a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "136",
      "x2": "152",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "56",
      "width": "208",
      "height": "40",
      "rx": "7.99999",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,96v96a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "136",
      "x2": "152",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "56",
      "width": "208",
      "height": "40",
      "rx": "7.99999",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,96v96a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "136",
      "x2": "152",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$l = [];
/* style */

const __vue_inject_styles__$l = undefined;
/* scoped */

const __vue_scope_id__$l = undefined;
/* module identifier */

const __vue_module_identifier__$l = undefined;
/* functional template */

const __vue_is_functional_template__$l = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$l = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$l,
  staticRenderFns: __vue_staticRenderFns__$l
}, __vue_inject_styles__$l, __vue_script__$l, __vue_scope_id__$l, __vue_is_functional_template__$l, __vue_module_identifier__$l, false, undefined, undefined, undefined);

var script$m = Vue.extend({
  name: "PhArchiveBox",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$m = script$m;
/* template */

var __vue_render__$m = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,216H48a8,8,0,0,1-8-8V76L56,40H200l16,36V208A8,8,0,0,1,208,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "76",
      "x2": "216",
      "y2": "76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "99.716 151.716 128 180 156.284 151.716",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "112",
      "x2": "128",
      "y2": "180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,72V208a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V72Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,216H48a8,8,0,0,1-8-8V72L56,40H200l16,32V208A8,8,0,0,1,208,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "94.059 150.059 128 184 161.941 150.059",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "104",
      "x2": "128",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "72",
      "x2": "216",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M223.15527,68.42188l-16-32A7.99967,7.99967,0,0,0,200,32H56a7.99967,7.99967,0,0,0-7.15527,4.42188l-16,32A7.99934,7.99934,0,0,0,32,72V208a16.01833,16.01833,0,0,0,16,16H208a16.01833,16.01833,0,0,0,16-16V72A7.99934,7.99934,0,0,0,223.15527,68.42188Zm-55.55713,87.29394-33.94091,33.94141c-.0542.0542-.11426.10107-.16944.15332-.1333.126-.26611.25244-.4082.36914-.06689.05517-.13867.10254-.207.15527-.13916.10693-.27686.21484-.42285.313-.05616.0376-.11621.06885-.17334.105-.16358.104-.32813.207-.49951.29883-.04248.023-.08692.041-.12989.0625-.18945.09765-.38135.1914-.57959.27392-.02832.01221-.05859.02051-.0874.03223-.2124.08545-.42725.16455-.64844.23193-.02929.00928-.05957.01465-.08886.02295-.21973.064-.44141.12256-.668.168-.06543.01319-.13282.01856-.19873.03028-.19092.0332-.38184.06689-.57715.08593a7.89257,7.89257,0,0,1-1.59766,0c-.19531-.019-.38623-.05273-.57715-.08593-.06591-.01172-.1333-.01709-.19873-.03028-.22656-.04541-.44824-.104-.668-.168-.02929-.0083-.05957-.01367-.08886-.02295-.22168-.06738-.438-.14746-.65088-.23291-.02783-.01123-.05713-.01953-.085-.03125-.19824-.08252-.39014-.17627-.58008-.27392-.04248-.022-.08692-.03955-.1294-.0625-.17138-.0918-.33593-.19483-.49951-.29883-.05713-.03613-.11718-.06738-.17334-.105-.146-.09815-.28369-.20606-.42285-.313-.06836-.05273-.14014-.1001-.207-.15527-.13818-.11328-.26709-.23731-.39746-.35938-.05908-.05566-.12256-.10547-.18018-.16308L88.40186,155.71582a8.00035,8.00035,0,0,1,11.314-11.31445L120,164.686V104a8,8,0,0,1,16,0v60.686l20.28418-20.28467a8.00035,8.00035,0,0,1,11.314,11.31445ZM52.94434,64l8-16H195.05566l8,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,216H48a8,8,0,0,1-8-8V72L56,40H200l16,32V208A8,8,0,0,1,208,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "94.059 150.059 128 184 161.941 150.059",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "104",
      "x2": "128",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "72",
      "x2": "216",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,216H48a8,8,0,0,1-8-8V72L56,40H200l16,32V208A8,8,0,0,1,208,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "94.059 150.059 128 184 161.941 150.059",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "104",
      "x2": "128",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "72",
      "x2": "216",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,216H48a8,8,0,0,1-8-8V72L56,40H200l16,32V208A8,8,0,0,1,208,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "94.059 150.059 128 184 161.941 150.059",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "104",
      "x2": "128",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "72",
      "x2": "216",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$m = [];
/* style */

const __vue_inject_styles__$m = undefined;
/* scoped */

const __vue_scope_id__$m = undefined;
/* module identifier */

const __vue_module_identifier__$m = undefined;
/* functional template */

const __vue_is_functional_template__$m = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$m = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$m,
  staticRenderFns: __vue_staticRenderFns__$m
}, __vue_inject_styles__$m, __vue_script__$m, __vue_scope_id__$m, __vue_is_functional_template__$m, __vue_module_identifier__$m, false, undefined, undefined, undefined);

var script$n = Vue.extend({
  name: "PhArchiveTray",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$n = script$n;
/* template */

var __vue_render__$n = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "99.716 115.716 128 144 156.284 115.716",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "76",
      "x2": "128",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M39.99414,156H76.68043a8,8,0,0,1,5.65686,2.34315l19.3137,19.3137A8,8,0,0,0,107.30785,180h41.37258a8,8,0,0,0,5.65686-2.34315l19.3137-19.3137A8,8,0,0,1,179.30785,156h36.68629",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M76.68066,160a7.9996,7.9996,0,0,1,5.65674,2.34326l19.31348,19.31348A7.99962,7.99962,0,0,0,107.30762,184h41.373a7.9996,7.9996,0,0,0,5.65674-2.34326l19.31348-19.31348A7.99962,7.99962,0,0,1,179.30762,160h36.68652l.00586.00439V48a7.99977,7.99977,0,0,0-8-8H48a7.99977,7.99977,0,0,0-8,8V160Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "94.059 118.059 128 152 161.941 118.059",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "72",
      "x2": "128",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M39.99414,160H76.68043a8,8,0,0,1,5.65686,2.34315l19.3137,19.3137A8,8,0,0,0,107.30785,184h41.37258a8,8,0,0,0,5.65686-2.34315l19.3137-19.3137A8,8,0,0,1,179.30785,160h36.68629",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,32H48A16.01833,16.01833,0,0,0,32,48V159.88379c-.00049.03906-.00586.07715-.00586.11621s.00537.07715.00586.11621V208a16.01833,16.01833,0,0,0,16,16H208a16.01833,16.01833,0,0,0,16-16V48A16.01833,16.01833,0,0,0,208,32ZM88.40234,112.40137a8.0018,8.0018,0,0,1,11.31348,0L120,132.686V72a8,8,0,0,1,16,0v60.686l20.28418-20.28467a8.00035,8.00035,0,0,1,11.314,11.31445l-33.94091,33.94141c-.0542.0542-.11426.10107-.16944.15332-.1333.126-.26611.25244-.4082.36914-.06689.05517-.13867.10254-.207.15527-.13916.10693-.27686.21484-.42285.313-.05616.0376-.11621.06885-.17334.105-.16358.104-.32813.207-.49951.29883-.04248.023-.08692.041-.12989.0625-.18945.09765-.38135.1914-.57959.27392-.02832.01221-.05859.02051-.0874.03223-.2124.08545-.42725.16455-.64844.23193-.02929.00928-.05957.01465-.08886.02295-.21973.064-.44141.12256-.668.168-.06543.01319-.13282.01856-.19873.03028-.19092.0332-.38184.06689-.57715.08593a7.89257,7.89257,0,0,1-1.59766,0c-.19531-.019-.38623-.05273-.57715-.08593-.06591-.01172-.1333-.01709-.19873-.03028-.22656-.04541-.44824-.104-.668-.168-.02929-.0083-.05957-.01367-.08886-.02295-.22168-.06738-.438-.14746-.65088-.23291-.02783-.01123-.05713-.01953-.085-.03125-.19824-.08252-.39014-.17627-.58008-.27392-.04248-.022-.08692-.03955-.1294-.0625-.17138-.0918-.33593-.19483-.49951-.29883-.05713-.03613-.11718-.06738-.17334-.105-.146-.09815-.28369-.20606-.42285-.313-.06836-.05273-.14014-.1001-.207-.15527-.13818-.11328-.26709-.23731-.39746-.35938-.05908-.05566-.12256-.10547-.18018-.16308L88.40186,123.71582A8.00076,8.00076,0,0,1,88.40234,112.40137ZM208,208H48V168l28.68066-.001,19.31446,19.31641A15.89834,15.89834,0,0,0,107.30762,192h41.373a15.89606,15.89606,0,0,0,11.31348-4.68652L179.30762,168h28.6997l.00245,40Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "94.059 118.059 128 152 161.941 118.059",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "72",
      "x2": "128",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M39.99414,160H76.68043a8,8,0,0,1,5.65686,2.34315l19.3137,19.3137A8,8,0,0,0,107.30785,184h41.37258a8,8,0,0,0,5.65686-2.34315l19.3137-19.3137A8,8,0,0,1,179.30785,160h36.68629",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "94.059 118.059 128 152 161.941 118.059",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "72",
      "x2": "128",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M39.99414,160H76.68043a8,8,0,0,1,5.65686,2.34315l19.3137,19.3137A8,8,0,0,0,107.30785,184h41.37258a8,8,0,0,0,5.65686-2.34315l19.3137-19.3137A8,8,0,0,1,179.30785,160h36.68629",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "94.059 118.059 128 152 161.941 118.059",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "72",
      "x2": "128",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M39.99414,160H76.68043a8,8,0,0,1,5.65686,2.34315l19.3137,19.3137A8,8,0,0,0,107.30785,184h41.37258a8,8,0,0,0,5.65686-2.34315l19.3137-19.3137A8,8,0,0,1,179.30785,160h36.68629",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$n = [];
/* style */

const __vue_inject_styles__$n = undefined;
/* scoped */

const __vue_scope_id__$n = undefined;
/* module identifier */

const __vue_module_identifier__$n = undefined;
/* functional template */

const __vue_is_functional_template__$n = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$n = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$n,
  staticRenderFns: __vue_staticRenderFns__$n
}, __vue_inject_styles__$n, __vue_script__$n, __vue_scope_id__$n, __vue_is_functional_template__$n, __vue_module_identifier__$n, false, undefined, undefined, undefined);

var script$o = Vue.extend({
  name: "PhArmchair",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$o = script$o;
/* template */

var __vue_render__$o = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "92",
      "y1": "136",
      "x2": "164",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M164,164V128a40,40,0,1,1,44,39.8025V200a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V167.8025A40.00143,40.00143,0,1,1,92,128v36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,88.19819V72A32,32,0,0,1,80,40h96a32,32,0,0,1,32,32V88.19792",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,159.98766V200a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V160a32,32,0,0,1,0-64V72A32,32,0,0,1,80,40h96a32,32,0,0,1,32,32V96a32,32,0,0,1,0,64Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "136",
      "x2": "176",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,96V72A32,32,0,0,1,80,40h96a32,32,0,0,1,32,32V96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,168V128a32,32,0,1,0-32,32v40a8,8,0,0,0,8,8H200a8,8,0,0,0,8-8V160a32,32,0,1,0-32-32v40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M48,80a48.07871,48.07871,0,0,1,47.3335,40h65.333A47.95539,47.95539,0,0,1,216,80.6792V72a40.04521,40.04521,0,0,0-40-40H80A40.04521,40.04521,0,0,0,40,72v8.6792A48.11745,48.11745,0,0,1,48,80Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M239.93188,126.01025c-.02233-.36181-.04809-.72265-.08251-1.08154-.01563-.165-.03455-.3291-.05274-.49316q-.05933-.53247-.135-1.05957c-.02124-.14551-.04248-.291-.06555-.43555q-.09558-.59985-.21338-1.19141c-.01758-.08886-.03332-.17773-.05164-.26611A32.00094,32.00094,0,0,0,176,128v40a8,8,0,0,1-16,0V136H96v32a8,8,0,0,1-16,0V128a32.00094,32.00094,0,0,0-63.331-6.51709c-.01832.08838-.03406.17725-.05164.26611q-.11773.5918-.21338,1.19141c-.02307.14453-.04443.29-.06555.43555q-.07655.52661-.135,1.05957c-.01819.16406-.03711.32812-.05274.49316-.03442.35889-.06018.71973-.08251,1.08154-.00928.15137-.022.30176-.02906.45362C16.01477,126.97314,16,127.48486,16,128a32.01333,32.01333,0,0,0,24,30.9917V200a16.01833,16.01833,0,0,0,16,16H200a16.01833,16.01833,0,0,0,16-16V158.9917A32.01319,32.01319,0,0,0,240,128c0-.51514-.01477-1.02686-.03906-1.53613C239.95386,126.312,239.94116,126.16162,239.93188,126.01025Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "80",
      "y1": "136",
      "x2": "176",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,96V72A32,32,0,0,1,80,40h96a32,32,0,0,1,32,32V96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,168V128a32,32,0,1,0-32,32v40a8,8,0,0,0,8,8H200a8,8,0,0,0,8-8V160a32,32,0,1,0-32-32v40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "80",
      "y1": "136",
      "x2": "176",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,96V72A32,32,0,0,1,80,40h96a32,32,0,0,1,32,32V96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,168V128a32,32,0,1,0-32,32v40a8,8,0,0,0,8,8H200a8,8,0,0,0,8-8V160a32,32,0,1,0-32-32v40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "80",
      "y1": "136",
      "x2": "176",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,96V72A32,32,0,0,1,80,40h96a32,32,0,0,1,32,32V96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,168V128a32,32,0,1,0-32,32v40a8,8,0,0,0,8,8H200a8,8,0,0,0,8-8V160a32,32,0,1,0-32-32v40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$o = [];
/* style */

const __vue_inject_styles__$o = undefined;
/* scoped */

const __vue_scope_id__$o = undefined;
/* module identifier */

const __vue_module_identifier__$o = undefined;
/* functional template */

const __vue_is_functional_template__$o = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$o = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$o,
  staticRenderFns: __vue_staticRenderFns__$o
}, __vue_inject_styles__$o, __vue_script__$o, __vue_scope_id__$o, __vue_is_functional_template__$o, __vue_module_identifier__$o, false, undefined, undefined, undefined);

var script$p = Vue.extend({
  name: "PhArrowArcLeft",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$p = script$p;
/* template */

var __vue_render__$p = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "92.118 148.118 28.118 148.118 28.118 84.118",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,184A96,96,0,0,0,60.11775,116.11775l-32,32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "92.118 148.118 28.118 148.118 28.118 84.118",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,184A96,96,0,0,0,60.11775,116.11775l-32,32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232,184a8,8,0,0,1-16,0A87.99083,87.99083,0,0,0,71.69507,116.38086l26.08032,26.08008a8.00064,8.00064,0,0,1-5.65723,13.65722h-64a8.0004,8.0004,0,0,1-8-8v-64a8.00065,8.00065,0,0,1,13.65723-5.65722L60.333,105.01855A104.00326,104.00326,0,0,1,232,184Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "92.118 148.118 28.118 148.118 28.118 84.118",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,184A96,96,0,0,0,60.11775,116.11775l-32,32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "92.118 148.118 28.118 148.118 28.118 84.118",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,184A96,96,0,0,0,60.11775,116.11775l-32,32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "92.118 148.118 28.118 148.118 28.118 84.118",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,184A96,96,0,0,0,60.11775,116.11775l-32,32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$p = [];
/* style */

const __vue_inject_styles__$p = undefined;
/* scoped */

const __vue_scope_id__$p = undefined;
/* module identifier */

const __vue_module_identifier__$p = undefined;
/* functional template */

const __vue_is_functional_template__$p = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$p = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$p,
  staticRenderFns: __vue_staticRenderFns__$p
}, __vue_inject_styles__$p, __vue_script__$p, __vue_scope_id__$p, __vue_is_functional_template__$p, __vue_module_identifier__$p, false, undefined, undefined, undefined);

var script$q = Vue.extend({
  name: "PhArrowArcRight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$q = script$q;
/* template */

var __vue_render__$q = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "163.882 148.118 227.882 148.118 227.882 84.118",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,184a96,96,0,0,1,163.88225-67.88229l32,32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "163.882 148.118 227.882 148.118 227.882 84.118",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,184a96,96,0,0,1,163.88225-67.88229l32,32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M235.88184,84.11816v64a8.0004,8.0004,0,0,1-8,8h-64a8.00064,8.00064,0,0,1-5.65723-13.65722l26.08032-26.08008A87.99487,87.99487,0,0,0,40,184a8,8,0,0,1-16,0,104.00481,104.00481,0,0,1,171.667-78.98145l26.55762-26.55761a8.00065,8.00065,0,0,1,13.65723,5.65722Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "163.882 148.118 227.882 148.118 227.882 84.118",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,184a96,96,0,0,1,163.88225-67.88229l32,32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "163.882 148.118 227.882 148.118 227.882 84.118",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,184a96,96,0,0,1,163.88225-67.88229l32,32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "163.882 148.118 227.882 148.118 227.882 84.118",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,184a96,96,0,0,1,163.88225-67.88229l32,32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$q = [];
/* style */

const __vue_inject_styles__$q = undefined;
/* scoped */

const __vue_scope_id__$q = undefined;
/* module identifier */

const __vue_module_identifier__$q = undefined;
/* functional template */

const __vue_is_functional_template__$q = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$q = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$q,
  staticRenderFns: __vue_staticRenderFns__$q
}, __vue_inject_styles__$q, __vue_script__$q, __vue_scope_id__$q, __vue_is_functional_template__$q, __vue_module_identifier__$q, false, undefined, undefined, undefined);

var script$r = Vue.extend({
  name: "PhArrowBendDoubleUpLeft",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$r = script$r;
/* template */

var __vue_render__$r = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 152 32 104 80 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "136 152 88 104 136 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,200a96,96,0,0,0-96-96H88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 152 32 104 80 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 152 80 104 128 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,200a96,96,0,0,0-96-96H80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M85.65723,146.34277a8.00053,8.00053,0,0,1-11.31446,11.31446l-48-48a8.00122,8.00122,0,0,1,0-11.31446l48-48A8.00053,8.00053,0,0,1,85.65723,61.65723L43.31348,104ZM136,96.30469V56a8.00066,8.00066,0,0,0-13.65723-5.65723l-48,48a8.00122,8.00122,0,0,0,0,11.31446l48,48A8.00065,8.00065,0,0,0,136,152V112.36768A88.11673,88.11673,0,0,1,216,200a8,8,0,0,0,16,0A104.13965,104.13965,0,0,0,136,96.30469Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 152 32 104 80 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 152 80 104 128 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,200a96,96,0,0,0-96-96H80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 152 32 104 80 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 152 80 104 128 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,200a96,96,0,0,0-96-96H80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 152 32 104 80 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 152 80 104 128 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,200a96,96,0,0,0-96-96H80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$r = [];
/* style */

const __vue_inject_styles__$r = undefined;
/* scoped */

const __vue_scope_id__$r = undefined;
/* module identifier */

const __vue_module_identifier__$r = undefined;
/* functional template */

const __vue_is_functional_template__$r = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$r = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$r,
  staticRenderFns: __vue_staticRenderFns__$r
}, __vue_inject_styles__$r, __vue_script__$r, __vue_scope_id__$r, __vue_is_functional_template__$r, __vue_module_identifier__$r, false, undefined, undefined, undefined);

var script$s = Vue.extend({
  name: "PhArrowBendDoubleUpRight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$s = script$s;
/* template */

var __vue_render__$s = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 152 224 104 176 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "120 152 168 104 120 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,200a96,96,0,0,1,96-96h40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 152 224 104 176 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 152 176 104 128 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,200a96,96,0,0,1,96-96h48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M229.65723,109.65723l-48,48a8.00053,8.00053,0,0,1-11.31446-11.31446L212.68652,104,170.34277,61.65723a8.00053,8.00053,0,0,1,11.31446-11.31446l48,48A8.00122,8.00122,0,0,1,229.65723,109.65723Zm-48-11.31446-48-48A8.00066,8.00066,0,0,0,120,56V96.30469A104.13965,104.13965,0,0,0,24,200a8,8,0,0,0,16,0,88.11673,88.11673,0,0,1,80-87.63232V152a8.00053,8.00053,0,0,0,13.65723,5.65723l48-48A8.00122,8.00122,0,0,0,181.65723,98.34277Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 152 224 104 176 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 152 176 104 128 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,200a96,96,0,0,1,96-96h48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 152 224 104 176 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 152 176 104 128 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,200a96,96,0,0,1,96-96h48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 152 224 104 176 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 152 176 104 128 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,200a96,96,0,0,1,96-96h48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$s = [];
/* style */

const __vue_inject_styles__$s = undefined;
/* scoped */

const __vue_scope_id__$s = undefined;
/* module identifier */

const __vue_module_identifier__$s = undefined;
/* functional template */

const __vue_is_functional_template__$s = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$s = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$s,
  staticRenderFns: __vue_staticRenderFns__$s
}, __vue_inject_styles__$s, __vue_script__$s, __vue_scope_id__$s, __vue_is_functional_template__$s, __vue_module_identifier__$s, false, undefined, undefined, undefined);

var script$t = Vue.extend({
  name: "PhArrowBendDownLeft",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$t = script$t;
/* template */

var __vue_render__$t = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 104 32 152 80 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,56a96,96,0,0,1-96,96H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 104 32 152 80 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,56a96,96,0,0,1-96,96H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232,56A104.11791,104.11791,0,0,1,128,160H88v40a8.00053,8.00053,0,0,1-13.65723,5.65723l-48-48a8.00122,8.00122,0,0,1,0-11.31446l48-48A8.00065,8.00065,0,0,1,88,104v40h40a88.09957,88.09957,0,0,0,88-88,8,8,0,0,1,16,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 104 32 152 80 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,56a96,96,0,0,1-96,96H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 104 32 152 80 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,56a96,96,0,0,1-96,96H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 104 32 152 80 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,56a96,96,0,0,1-96,96H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$t = [];
/* style */

const __vue_inject_styles__$t = undefined;
/* scoped */

const __vue_scope_id__$t = undefined;
/* module identifier */

const __vue_module_identifier__$t = undefined;
/* functional template */

const __vue_is_functional_template__$t = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$t = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$t,
  staticRenderFns: __vue_staticRenderFns__$t
}, __vue_inject_styles__$t, __vue_script__$t, __vue_scope_id__$t, __vue_is_functional_template__$t, __vue_module_identifier__$t, false, undefined, undefined, undefined);

var script$u = Vue.extend({
  name: "PhArrowBendDownRight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$u = script$u;
/* template */

var __vue_render__$u = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 104 224 152 176 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,56a96,96,0,0,0,96,96h96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 104 224 152 176 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,56a96,96,0,0,0,96,96h96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M229.65723,157.65723l-48,48A8.00066,8.00066,0,0,1,168,200V160H128A104.11791,104.11791,0,0,1,24,56a8,8,0,0,1,16,0,88.09957,88.09957,0,0,0,88,88h40V104a8.00065,8.00065,0,0,1,13.65723-5.65723l48,48A8.00122,8.00122,0,0,1,229.65723,157.65723Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 104 224 152 176 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,56a96,96,0,0,0,96,96h96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 104 224 152 176 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,56a96,96,0,0,0,96,96h96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 104 224 152 176 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,56a96,96,0,0,0,96,96h96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$u = [];
/* style */

const __vue_inject_styles__$u = undefined;
/* scoped */

const __vue_scope_id__$u = undefined;
/* module identifier */

const __vue_module_identifier__$u = undefined;
/* functional template */

const __vue_is_functional_template__$u = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$u = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$u,
  staticRenderFns: __vue_staticRenderFns__$u
}, __vue_inject_styles__$u, __vue_script__$u, __vue_scope_id__$u, __vue_is_functional_template__$u, __vue_module_identifier__$u, false, undefined, undefined, undefined);

var script$v = Vue.extend({
  name: "PhArrowBendLeftDown",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$v = script$v;
/* template */

var __vue_render__$v = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "152 176 104 224 56 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,32a96,96,0,0,0-96,96v96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "152 176 104 224 56 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,32a96,96,0,0,0-96,96v96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,32a8.00039,8.00039,0,0,1-8,8,88.09957,88.09957,0,0,0-88,88v40h40a8.00066,8.00066,0,0,1,5.65723,13.65723l-48,48a8.00181,8.00181,0,0,1-11.31446,0l-48-48A8.00065,8.00065,0,0,1,56,168H96V128A104.11791,104.11791,0,0,1,200,24,8.00039,8.00039,0,0,1,208,32Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "152 176 104 224 56 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,32a96,96,0,0,0-96,96v96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "152 176 104 224 56 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,32a96,96,0,0,0-96,96v96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "152 176 104 224 56 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,32a96,96,0,0,0-96,96v96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$v = [];
/* style */

const __vue_inject_styles__$v = undefined;
/* scoped */

const __vue_scope_id__$v = undefined;
/* module identifier */

const __vue_module_identifier__$v = undefined;
/* functional template */

const __vue_is_functional_template__$v = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$v = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$v,
  staticRenderFns: __vue_staticRenderFns__$v
}, __vue_inject_styles__$v, __vue_script__$v, __vue_scope_id__$v, __vue_is_functional_template__$v, __vue_module_identifier__$v, false, undefined, undefined, undefined);

var script$w = Vue.extend({
  name: "PhArrowBendLeftUp",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$w = script$w;
/* template */

var __vue_render__$w = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "152 80 104 32 56 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,224a96,96,0,0,1-96-96V32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "152 80 104 32 56 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,224a96,96,0,0,1-96-96V32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,224a8.00039,8.00039,0,0,1-8,8A104.11791,104.11791,0,0,1,96,128V88H56a8.00065,8.00065,0,0,1-5.65723-13.65723l48-48a8.003,8.003,0,0,1,11.31446,0l48,48A8.00066,8.00066,0,0,1,152,88H112v40a88.09957,88.09957,0,0,0,88,88A8.00039,8.00039,0,0,1,208,224Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "152 80 104 32 56 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,224a96,96,0,0,1-96-96V32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "152 80 104 32 56 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,224a96,96,0,0,1-96-96V32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "152 80 104 32 56 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,224a96,96,0,0,1-96-96V32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$w = [];
/* style */

const __vue_inject_styles__$w = undefined;
/* scoped */

const __vue_scope_id__$w = undefined;
/* module identifier */

const __vue_module_identifier__$w = undefined;
/* functional template */

const __vue_is_functional_template__$w = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$w = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$w,
  staticRenderFns: __vue_staticRenderFns__$w
}, __vue_inject_styles__$w, __vue_script__$w, __vue_scope_id__$w, __vue_is_functional_template__$w, __vue_module_identifier__$w, false, undefined, undefined, undefined);

var script$x = Vue.extend({
  name: "PhArrowBendRightDown",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$x = script$x;
/* template */

var __vue_render__$x = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "104 176 152 224 200 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,32a96,96,0,0,1,96,96v96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "104 176 152 224 200 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,32a96,96,0,0,1,96,96v96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M205.65723,181.65723l-48,48a8.00181,8.00181,0,0,1-11.31446,0l-48-48A8.00065,8.00065,0,0,1,104,168h40V128A88.09957,88.09957,0,0,0,56,40a8,8,0,0,1,0-16A104.11791,104.11791,0,0,1,160,128v40h40a8.00066,8.00066,0,0,1,5.65723,13.65723Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "104 176 152 224 200 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,32a96,96,0,0,1,96,96v96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "104 176 152 224 200 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,32a96,96,0,0,1,96,96v96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "104 176 152 224 200 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,32a96,96,0,0,1,96,96v96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$x = [];
/* style */

const __vue_inject_styles__$x = undefined;
/* scoped */

const __vue_scope_id__$x = undefined;
/* module identifier */

const __vue_module_identifier__$x = undefined;
/* functional template */

const __vue_is_functional_template__$x = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$x = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$x,
  staticRenderFns: __vue_staticRenderFns__$x
}, __vue_inject_styles__$x, __vue_script__$x, __vue_scope_id__$x, __vue_is_functional_template__$x, __vue_module_identifier__$x, false, undefined, undefined, undefined);

var script$y = Vue.extend({
  name: "PhArrowBendRightUp",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$y = script$y;
/* template */

var __vue_render__$y = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "104 80 152 32 200 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,224a96,96,0,0,0,96-96V32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "104 80 152 32 200 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,224a96,96,0,0,0,96-96V32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M207.39062,83.06152A8,8,0,0,1,200,88H160v40A104.11791,104.11791,0,0,1,56,232a8,8,0,0,1,0-16,88.09957,88.09957,0,0,0,88-88V88H104a8.00065,8.00065,0,0,1-5.65723-13.65723l48-48a8.003,8.003,0,0,1,11.31446,0l48,48A8.00028,8.00028,0,0,1,207.39062,83.06152Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "104 80 152 32 200 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,224a96,96,0,0,0,96-96V32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "104 80 152 32 200 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,224a96,96,0,0,0,96-96V32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "104 80 152 32 200 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,224a96,96,0,0,0,96-96V32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$y = [];
/* style */

const __vue_inject_styles__$y = undefined;
/* scoped */

const __vue_scope_id__$y = undefined;
/* module identifier */

const __vue_module_identifier__$y = undefined;
/* functional template */

const __vue_is_functional_template__$y = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$y = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$y,
  staticRenderFns: __vue_staticRenderFns__$y
}, __vue_inject_styles__$y, __vue_script__$y, __vue_scope_id__$y, __vue_is_functional_template__$y, __vue_module_identifier__$y, false, undefined, undefined, undefined);

var script$z = Vue.extend({
  name: "PhArrowBendUpLeft",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$z = script$z;
/* template */

var __vue_render__$z = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 152 32 104 80 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,200a96,96,0,0,0-96-96H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 152 32 104 80 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,200a96,96,0,0,0-96-96H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232,200a8,8,0,0,1-16,0,88.09957,88.09957,0,0,0-88-88H88v40a8.00053,8.00053,0,0,1-13.65723,5.65723l-48-48a8.00122,8.00122,0,0,1,0-11.31446l48-48A8.00065,8.00065,0,0,1,88,56V96h40A104.11791,104.11791,0,0,1,232,200Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 152 32 104 80 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,200a96,96,0,0,0-96-96H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 152 32 104 80 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,200a96,96,0,0,0-96-96H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 152 32 104 80 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,200a96,96,0,0,0-96-96H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$z = [];
/* style */

const __vue_inject_styles__$z = undefined;
/* scoped */

const __vue_scope_id__$z = undefined;
/* module identifier */

const __vue_module_identifier__$z = undefined;
/* functional template */

const __vue_is_functional_template__$z = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$z = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$z,
  staticRenderFns: __vue_staticRenderFns__$z
}, __vue_inject_styles__$z, __vue_script__$z, __vue_scope_id__$z, __vue_is_functional_template__$z, __vue_module_identifier__$z, false, undefined, undefined, undefined);

var script$A = Vue.extend({
  name: "PhArrowBendUpRight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$A = script$A;
/* template */

var __vue_render__$A = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 152 224 104 176 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,200a96,96,0,0,1,96-96h96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 152 224 104 176 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,200a96,96,0,0,1,96-96h96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M229.65723,109.65723l-48,48A8.00066,8.00066,0,0,1,168,152V112H128a88.09957,88.09957,0,0,0-88,88,8,8,0,0,1-16,0A104.11791,104.11791,0,0,1,128,96h40V56a8.00065,8.00065,0,0,1,13.65723-5.65723l48,48A8.00122,8.00122,0,0,1,229.65723,109.65723Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 152 224 104 176 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,200a96,96,0,0,1,96-96h96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 152 224 104 176 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,200a96,96,0,0,1,96-96h96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 152 224 104 176 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,200a96,96,0,0,1,96-96h96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$A = [];
/* style */

const __vue_inject_styles__$A = undefined;
/* scoped */

const __vue_scope_id__$A = undefined;
/* module identifier */

const __vue_module_identifier__$A = undefined;
/* functional template */

const __vue_is_functional_template__$A = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$A = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$A,
  staticRenderFns: __vue_staticRenderFns__$A
}, __vue_inject_styles__$A, __vue_script__$A, __vue_scope_id__$A, __vue_is_functional_template__$A, __vue_module_identifier__$A, false, undefined, undefined, undefined);

var script$B = Vue.extend({
  name: "PhArrowCircleDown",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$B = script$B;
/* template */

var __vue_render__$B = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "94.059 134.059 128 168 161.941 134.059",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "88",
      "x2": "128",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "94.059 134.059 128 168 161.941 134.059",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "88",
      "x2": "128",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.12041,104.12041,0,0,0,128,24Zm39.59375,115.71875L133.666,173.64648a8.02367,8.02367,0,0,1-11.332,0L88.40625,139.71875a7.99915,7.99915,0,0,1,11.3125-11.3125L120,148.6875V88a8,8,0,0,1,16,0v60.6875l20.28125-20.28125a7.99915,7.99915,0,0,1,11.3125,11.3125Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "94.059 134.059 128 168 161.941 134.059",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "88",
      "x2": "128",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "94.059 134.059 128 168 161.941 134.059",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "88",
      "x2": "128",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "94.059 134.059 128 168 161.941 134.059",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "88",
      "x2": "128",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$B = [];
/* style */

const __vue_inject_styles__$B = undefined;
/* scoped */

const __vue_scope_id__$B = undefined;
/* module identifier */

const __vue_module_identifier__$B = undefined;
/* functional template */

const __vue_is_functional_template__$B = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$B = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$B,
  staticRenderFns: __vue_staticRenderFns__$B
}, __vue_inject_styles__$B, __vue_script__$B, __vue_scope_id__$B, __vue_is_functional_template__$B, __vue_module_identifier__$B, false, undefined, undefined, undefined);

var script$C = Vue.extend({
  name: "PhArrowCircleDownLeft",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$C = script$C;
/* template */

var __vue_render__$C = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "100 108 100 156 148 156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "100",
      "x2": "100",
      "y2": "156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "100 108 100 156 148 156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "100",
      "x2": "100",
      "y2": "156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.12041,104.12041,0,0,0,128,24Zm33.65625,81.65625L119.3125,148H148a8,8,0,0,1,0,16H100a8.02752,8.02752,0,0,1-8-8V108a8,8,0,0,1,16,0v28.6875l42.34375-42.34375a7.99915,7.99915,0,0,1,11.3125,11.3125Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "100 108 100 156 148 156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "100",
      "x2": "100",
      "y2": "156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "100 108 100 156 148 156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "100",
      "x2": "100",
      "y2": "156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "100 108 100 156 148 156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "100",
      "x2": "100",
      "y2": "156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$C = [];
/* style */

const __vue_inject_styles__$C = undefined;
/* scoped */

const __vue_scope_id__$C = undefined;
/* module identifier */

const __vue_module_identifier__$C = undefined;
/* functional template */

const __vue_is_functional_template__$C = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$C = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$C,
  staticRenderFns: __vue_staticRenderFns__$C
}, __vue_inject_styles__$C, __vue_script__$C, __vue_scope_id__$C, __vue_is_functional_template__$C, __vue_module_identifier__$C, false, undefined, undefined, undefined);

var script$D = Vue.extend({
  name: "PhArrowCircleDownRight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$D = script$D;
/* template */

var __vue_render__$D = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 156 156 156 156 108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "100",
      "x2": "156",
      "y2": "156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 156 156 156 156 108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "100",
      "x2": "156",
      "y2": "156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.12041,104.12041,0,0,0,128,24Zm36,132a8.02752,8.02752,0,0,1-8,8H108a8,8,0,0,1,0-16h28.6875L94.34375,105.65625a7.99915,7.99915,0,0,1,11.3125-11.3125L148,136.6875V108a8,8,0,0,1,16,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 156 156 156 156 108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "100",
      "x2": "156",
      "y2": "156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 156 156 156 156 108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "100",
      "x2": "156",
      "y2": "156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 156 156 156 156 108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "100",
      "x2": "156",
      "y2": "156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$D = [];
/* style */

const __vue_inject_styles__$D = undefined;
/* scoped */

const __vue_scope_id__$D = undefined;
/* module identifier */

const __vue_module_identifier__$D = undefined;
/* functional template */

const __vue_is_functional_template__$D = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$D = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$D,
  staticRenderFns: __vue_staticRenderFns__$D
}, __vue_inject_styles__$D, __vue_script__$D, __vue_scope_id__$D, __vue_is_functional_template__$D, __vue_module_identifier__$D, false, undefined, undefined, undefined);

var script$E = Vue.extend({
  name: "PhArrowCircleLeft",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$E = script$E;
/* template */

var __vue_render__$E = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "121.941 161.941 88 128 121.941 94.059",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "128",
      "x2": "88",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "121.941 161.941 88 128 121.941 94.059",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "128",
      "x2": "88",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.12041,104.12041,0,0,0,128,24Zm40,112H107.3125l20.28125,20.28125a7.99915,7.99915,0,1,1-11.3125,11.3125L82.35352,133.666a8.02367,8.02367,0,0,1,0-11.332l33.92773-33.92773a7.99915,7.99915,0,0,1,11.3125,11.3125L107.3125,120H168a8,8,0,0,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "121.941 161.941 88 128 121.941 94.059",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "128",
      "x2": "168",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "121.941 161.941 88 128 121.941 94.059",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "128",
      "x2": "168",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "121.941 161.941 88 128 121.941 94.059",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "128",
      "x2": "168",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$E = [];
/* style */

const __vue_inject_styles__$E = undefined;
/* scoped */

const __vue_scope_id__$E = undefined;
/* module identifier */

const __vue_module_identifier__$E = undefined;
/* functional template */

const __vue_is_functional_template__$E = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$E = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$E,
  staticRenderFns: __vue_staticRenderFns__$E
}, __vue_inject_styles__$E, __vue_script__$E, __vue_scope_id__$E, __vue_is_functional_template__$E, __vue_module_identifier__$E, false, undefined, undefined, undefined);

var script$F = Vue.extend({
  name: "PhArrowCircleRight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$F = script$F;
/* template */

var __vue_render__$F = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "134.059 161.941 168 128 134.059 94.059",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "128",
      "x2": "168",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "134.059 161.941 168 128 134.059 94.059",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "128",
      "x2": "168",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.12041,104.12041,0,0,0,128,24Zm47.38477,107.05469a7.99866,7.99866,0,0,1-1.73829,2.61133l-33.92773,33.92773a7.99915,7.99915,0,0,1-11.3125-11.3125L148.6875,136H88a8,8,0,0,1,0-16h60.6875L128.40625,99.71875a7.99915,7.99915,0,0,1,11.3125-11.3125L173.64648,122.334a8.02367,8.02367,0,0,1,1.73829,8.72071Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "134.059 161.941 168 128 134.059 94.059",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "128",
      "x2": "168",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "134.059 161.941 168 128 134.059 94.059",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "128",
      "x2": "168",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "134.059 161.941 168 128 134.059 94.059",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "128",
      "x2": "168",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$F = [];
/* style */

const __vue_inject_styles__$F = undefined;
/* scoped */

const __vue_scope_id__$F = undefined;
/* module identifier */

const __vue_module_identifier__$F = undefined;
/* functional template */

const __vue_is_functional_template__$F = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$F = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$F,
  staticRenderFns: __vue_staticRenderFns__$F
}, __vue_inject_styles__$F, __vue_script__$F, __vue_scope_id__$F, __vue_is_functional_template__$F, __vue_module_identifier__$F, false, undefined, undefined, undefined);

var script$G = Vue.extend({
  name: "PhArrowCircleUp",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$G = script$G;
/* template */

var __vue_render__$G = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "94.059 121.941 128 88 161.941 121.941",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "168",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "94.059 121.941 128 88 161.941 121.941",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "168",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.12041,104.12041,0,0,0,128,24Zm39.59375,103.59375a7.99708,7.99708,0,0,1-11.3125,0L136,107.3125V168a8,8,0,0,1-16,0V107.3125L99.71875,127.59375a7.99915,7.99915,0,0,1-11.3125-11.3125L122.334,82.35352a8.02367,8.02367,0,0,1,11.332,0l33.92773,33.92773A7.99708,7.99708,0,0,1,167.59375,127.59375Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "94.059 121.941 128 88 161.941 121.941",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "168",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "94.059 121.941 128 88 161.941 121.941",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "168",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "94.059 121.941 128 88 161.941 121.941",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "168",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$G = [];
/* style */

const __vue_inject_styles__$G = undefined;
/* scoped */

const __vue_scope_id__$G = undefined;
/* module identifier */

const __vue_module_identifier__$G = undefined;
/* functional template */

const __vue_is_functional_template__$G = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$G = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$G,
  staticRenderFns: __vue_staticRenderFns__$G
}, __vue_inject_styles__$G, __vue_script__$G, __vue_scope_id__$G, __vue_is_functional_template__$G, __vue_module_identifier__$G, false, undefined, undefined, undefined);

var script$H = Vue.extend({
  name: "PhArrowCircleUpLeft",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$H = script$H;
/* template */

var __vue_render__$H = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "148 100 100 100 100 148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "156",
      "x2": "100",
      "y2": "100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "148 100 100 100 100 148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "156",
      "x2": "100",
      "y2": "100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.12041,104.12041,0,0,0,128,24Zm33.65625,137.65625a7.99708,7.99708,0,0,1-11.3125,0L108,119.3125V148a8,8,0,0,1-16,0V100a8.02752,8.02752,0,0,1,8-8h48a8,8,0,0,1,0,16H119.3125l42.34375,42.34375A7.99708,7.99708,0,0,1,161.65625,161.65625Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "148 100 100 100 100 148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "156",
      "x2": "100",
      "y2": "100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "148 100 100 100 100 148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "156",
      "x2": "100",
      "y2": "100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "148 100 100 100 100 148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "156",
      "x2": "100",
      "y2": "100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$H = [];
/* style */

const __vue_inject_styles__$H = undefined;
/* scoped */

const __vue_scope_id__$H = undefined;
/* module identifier */

const __vue_module_identifier__$H = undefined;
/* functional template */

const __vue_is_functional_template__$H = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$H = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$H,
  staticRenderFns: __vue_staticRenderFns__$H
}, __vue_inject_styles__$H, __vue_script__$H, __vue_scope_id__$H, __vue_is_functional_template__$H, __vue_module_identifier__$H, false, undefined, undefined, undefined);

var script$I = Vue.extend({
  name: "PhArrowCircleUpRight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$I = script$I;
/* template */

var __vue_render__$I = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 100 156 100 156 148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "156",
      "x2": "156",
      "y2": "100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 100 156 100 156 148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "156",
      "x2": "156",
      "y2": "100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M201.541,54.458a104,104,0,1,0,0,147.07813A104.10845,104.10845,0,0,0,201.541,54.458ZM163.99414,147.9971a8,8,0,0,1-16,0V119.3096l-42.34375,42.34375a7.99915,7.99915,0,0,1-11.3125-11.3125l42.34375-42.34375h-28.6875a8,8,0,0,1,0-16h48a8.02753,8.02753,0,0,1,8,8Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 100 156 100 156 148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "156",
      "x2": "156",
      "y2": "100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 100 156 100 156 148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "156",
      "x2": "156",
      "y2": "100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 100 156 100 156 148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "156",
      "x2": "156",
      "y2": "100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$I = [];
/* style */

const __vue_inject_styles__$I = undefined;
/* scoped */

const __vue_scope_id__$I = undefined;
/* module identifier */

const __vue_module_identifier__$I = undefined;
/* functional template */

const __vue_is_functional_template__$I = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$I = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$I,
  staticRenderFns: __vue_staticRenderFns__$I
}, __vue_inject_styles__$I, __vue_script__$I, __vue_scope_id__$I, __vue_is_functional_template__$I, __vue_module_identifier__$I, false, undefined, undefined, undefined);

var script$J = Vue.extend({
  name: "PhArrowClockwise",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$J = script$J;
/* template */

var __vue_render__$J = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176.167 99.716 224.167 99.716 224.167 51.716",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M190.2254,190.2254a88,88,0,1,1,0-124.4508l33.94112,33.94113",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176.167 99.716 224.167 99.716 224.167 51.716",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M190.2254,190.2254a88,88,0,1,1,0-124.4508l33.94112,33.94113",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232.167,51.71582v48a8.00008,8.00008,0,0,1-8,8h-48a8.00037,8.00037,0,0,1-5.65722-13.65674L188.853,75.71582l-4.28467-4.28467a80.00009,80.00009,0,1,0,0,113.1377,8.00018,8.00018,0,1,1,11.31445,11.31347,96.00044,96.00044,0,1,1,0-135.76464l4.28418,4.28418,18.34278-18.34278A8.00009,8.00009,0,0,1,232.167,51.71582Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176.167 99.716 224.167 99.716 224.167 51.716",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M190.2254,190.2254a88,88,0,1,1,0-124.4508l33.94112,33.94113",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176.167 99.716 224.167 99.716 224.167 51.716",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M190.2254,190.2254a88,88,0,1,1,0-124.4508l33.94112,33.94113",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176.167 99.716 224.167 99.716 224.167 51.716",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M190.2254,190.2254a88,88,0,1,1,0-124.4508l33.94112,33.94113",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$J = [];
/* style */

const __vue_inject_styles__$J = undefined;
/* scoped */

const __vue_scope_id__$J = undefined;
/* module identifier */

const __vue_module_identifier__$J = undefined;
/* functional template */

const __vue_is_functional_template__$J = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$J = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$J,
  staticRenderFns: __vue_staticRenderFns__$J
}, __vue_inject_styles__$J, __vue_script__$J, __vue_scope_id__$J, __vue_is_functional_template__$J, __vue_module_identifier__$J, false, undefined, undefined, undefined);

var script$K = Vue.extend({
  name: "PhArrowCounterClockwise",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$K = script$K;
/* template */

var __vue_render__$K = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "79.833 99.716 31.833 99.716 31.833 51.716",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M65.7746,190.2254a88,88,0,1,0,0-124.4508L31.83348,99.71573",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "79.833 99.716 31.833 99.716 31.833 51.716",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M65.7746,190.2254a88,88,0,1,0,0-124.4508L31.83348,99.71573",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M195.88281,195.88281a96.11136,96.11136,0,0,1-135.76562,0,8.00052,8.00052,0,0,1,11.31445-11.31445,79.99992,79.99992,0,1,0,0-113.13721L67.147,75.71582,85.49023,94.05908A8.00037,8.00037,0,0,1,79.833,107.71582h-48a8.00008,8.00008,0,0,1-8-8v-48a8.00009,8.00009,0,0,1,13.65722-5.65674L55.833,64.40186l4.28418-4.28418A96.00062,96.00062,0,0,1,195.88281,195.88281Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "79.833 99.716 31.833 99.716 31.833 51.716",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M65.7746,190.2254a88,88,0,1,0,0-124.4508L31.83348,99.71573",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "79.833 99.716 31.833 99.716 31.833 51.716",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M65.7746,190.2254a88,88,0,1,0,0-124.4508L31.83348,99.71573",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "79.833 99.716 31.833 99.716 31.833 51.716",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M65.7746,190.2254a88,88,0,1,0,0-124.4508L31.83348,99.71573",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$K = [];
/* style */

const __vue_inject_styles__$K = undefined;
/* scoped */

const __vue_scope_id__$K = undefined;
/* module identifier */

const __vue_module_identifier__$K = undefined;
/* functional template */

const __vue_is_functional_template__$K = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$K = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$K,
  staticRenderFns: __vue_staticRenderFns__$K
}, __vue_inject_styles__$K, __vue_script__$K, __vue_scope_id__$K, __vue_is_functional_template__$K, __vue_module_identifier__$K, false, undefined, undefined, undefined);

var script$L = Vue.extend({
  name: "PhArrowDown",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$L = script$L;
/* template */

var __vue_render__$L = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "56 144 128 216 200 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "56 144 128 216 200 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M205.65674,149.65723l-72,72a8.00063,8.00063,0,0,1-11.31348,0l-72-72A8.0001,8.0001,0,0,1,56,136h64V40a8,8,0,0,1,16,0v96h64a8.0001,8.0001,0,0,1,5.65674,13.65723Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "56 144 128 216 200 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "56 144 128 216 200 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "56 144 128 216 200 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$L = [];
/* style */

const __vue_inject_styles__$L = undefined;
/* scoped */

const __vue_scope_id__$L = undefined;
/* module identifier */

const __vue_module_identifier__$L = undefined;
/* functional template */

const __vue_is_functional_template__$L = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$L = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$L,
  staticRenderFns: __vue_staticRenderFns__$L
}, __vue_inject_styles__$L, __vue_script__$L, __vue_scope_id__$L, __vue_is_functional_template__$L, __vue_module_identifier__$L, false, undefined, undefined, undefined);

var script$M = Vue.extend({
  name: "PhArrowDownLeft",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$M = script$M;
/* template */

var __vue_render__$M = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "192",
      "y1": "64",
      "x2": "64",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "168 192 64 192 64 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "192",
      "y1": "64",
      "x2": "64",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "168 192 64 192 64 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M197.65674,69.65723,127.314,140l46.34327,46.34277A8.00038,8.00038,0,0,1,168,200H64a8.00039,8.00039,0,0,1-8-8V88a8.00065,8.00065,0,0,1,13.65723-5.65723L116,128.686l70.34326-70.34327a8.00018,8.00018,0,1,1,11.31348,11.31446Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "192",
      "y1": "64",
      "x2": "64",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "168 192 64 192 64 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "192",
      "y1": "64",
      "x2": "64",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "168 192 64 192 64 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "192",
      "y1": "64",
      "x2": "64",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "168 192 64 192 64 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$M = [];
/* style */

const __vue_inject_styles__$M = undefined;
/* scoped */

const __vue_scope_id__$M = undefined;
/* module identifier */

const __vue_module_identifier__$M = undefined;
/* functional template */

const __vue_is_functional_template__$M = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$M = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$M,
  staticRenderFns: __vue_staticRenderFns__$M
}, __vue_inject_styles__$M, __vue_script__$M, __vue_scope_id__$M, __vue_is_functional_template__$M, __vue_module_identifier__$M, false, undefined, undefined, undefined);

var script$N = Vue.extend({
  name: "PhArrowDownRight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$N = script$N;
/* template */

var __vue_render__$N = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "64",
      "y1": "64",
      "x2": "192",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "88 192 192 192 192 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "64",
      "y1": "64",
      "x2": "192",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "88 192 192 192 192 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,88V192a8.00039,8.00039,0,0,1-8,8H88a8.00038,8.00038,0,0,1-5.65723-13.65723L128.686,140,58.34326,69.65723A8.00018,8.00018,0,0,1,69.65674,58.34277L140,128.686l46.34277-46.34327A8.00065,8.00065,0,0,1,200,88Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "64",
      "y1": "64",
      "x2": "192",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "88 192 192 192 192 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "64",
      "y1": "64",
      "x2": "192",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "88 192 192 192 192 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "64",
      "y1": "64",
      "x2": "192",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "88 192 192 192 192 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$N = [];
/* style */

const __vue_inject_styles__$N = undefined;
/* scoped */

const __vue_scope_id__$N = undefined;
/* module identifier */

const __vue_module_identifier__$N = undefined;
/* functional template */

const __vue_is_functional_template__$N = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$N = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$N,
  staticRenderFns: __vue_staticRenderFns__$N
}, __vue_inject_styles__$N, __vue_script__$N, __vue_scope_id__$N, __vue_is_functional_template__$N, __vue_module_identifier__$N, false, undefined, undefined, undefined);

var script$O = Vue.extend({
  name: "PhArrowElbowDownLeft",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$O = script$O;
/* template */

var __vue_render__$O = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "96 128 48 176 96 224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192 32 192 176 48 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "96 128 48 176 96 224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192 32 192 176 48 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,32V176a8.00008,8.00008,0,0,1-8,8H104v40a8.00018,8.00018,0,0,1-13.65723,5.65674l-48-48a8,8,0,0,1,0-11.31348l48-48A8.0001,8.0001,0,0,1,104,128v40h80V32a8,8,0,0,1,16,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "96 128 48 176 96 224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192 32 192 176 48 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "96 128 48 176 96 224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192 32 192 176 48 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "96 128 48 176 96 224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192 32 192 176 48 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$O = [];
/* style */

const __vue_inject_styles__$O = undefined;
/* scoped */

const __vue_scope_id__$O = undefined;
/* module identifier */

const __vue_module_identifier__$O = undefined;
/* functional template */

const __vue_is_functional_template__$O = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$O = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$O,
  staticRenderFns: __vue_staticRenderFns__$O
}, __vue_inject_styles__$O, __vue_script__$O, __vue_scope_id__$O, __vue_is_functional_template__$O, __vue_module_identifier__$O, false, undefined, undefined, undefined);

var script$P = Vue.extend({
  name: "PhArrowElbowDownRight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$P = script$P;
/* template */

var __vue_render__$P = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "160 128 208 176 160 224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 32 64 176 208 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "160 128 208 176 160 224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 32 64 176 208 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M213.65723,181.65674l-48,48A8.0001,8.0001,0,0,1,152,224V184H64a8.00008,8.00008,0,0,1-8-8V32a8,8,0,0,1,16,0V168h80V128a8.0001,8.0001,0,0,1,13.65723-5.65674l48,48A8,8,0,0,1,213.65723,181.65674Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "160 128 208 176 160 224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 32 64 176 208 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "160 128 208 176 160 224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 32 64 176 208 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "160 128 208 176 160 224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 32 64 176 208 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$P = [];
/* style */

const __vue_inject_styles__$P = undefined;
/* scoped */

const __vue_scope_id__$P = undefined;
/* module identifier */

const __vue_module_identifier__$P = undefined;
/* functional template */

const __vue_is_functional_template__$P = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$P = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$P,
  staticRenderFns: __vue_staticRenderFns__$P
}, __vue_inject_styles__$P, __vue_script__$P, __vue_scope_id__$P, __vue_is_functional_template__$P, __vue_module_identifier__$P, false, undefined, undefined, undefined);

var script$Q = Vue.extend({
  name: "PhArrowElbowLeft",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$Q = script$Q;
/* template */

var __vue_render__$Q = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "96 80 24 80 24 152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "232 96 136 192 24 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "96 80 24 80 24 152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "232 96 136 192 24 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M237.65723,101.65723l-96,96a8.00181,8.00181,0,0,1-11.31446,0L60,127.31445,29.65723,157.65723A8.00066,8.00066,0,0,1,16,152V80a8.00039,8.00039,0,0,1,8-8H96a8.00066,8.00066,0,0,1,5.65723,13.65723l-30.343,30.343L136,180.68652l90.34277-90.34375a8.00053,8.00053,0,0,1,11.31446,11.31446Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "96 80 24 80 24 152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "232 96 136 192 24 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "96 80 24 80 24 152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "232 96 136 192 24 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "96 80 24 80 24 152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "232 96 136 192 24 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$Q = [];
/* style */

const __vue_inject_styles__$Q = undefined;
/* scoped */

const __vue_scope_id__$Q = undefined;
/* module identifier */

const __vue_module_identifier__$Q = undefined;
/* functional template */

const __vue_is_functional_template__$Q = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$Q = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$Q,
  staticRenderFns: __vue_staticRenderFns__$Q
}, __vue_inject_styles__$Q, __vue_script__$Q, __vue_scope_id__$Q, __vue_is_functional_template__$Q, __vue_module_identifier__$Q, false, undefined, undefined, undefined);

var script$R = Vue.extend({
  name: "PhArrowElbowLeftDown",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$R = script$R;
/* template */

var __vue_render__$R = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "128 160 80 208 32 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "224 64 80 64 80 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "128 160 80 208 32 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "224 64 80 64 80 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232,64a8.00008,8.00008,0,0,1-8,8H88v80h40a8.00038,8.00038,0,0,1,5.65723,13.65674l-48,48a8.00063,8.00063,0,0,1-11.31446,0l-48-48A8.00037,8.00037,0,0,1,32,152H72V64a8.00008,8.00008,0,0,1,8-8H224A8.00008,8.00008,0,0,1,232,64Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "128 160 80 208 32 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "224 64 80 64 80 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "128 160 80 208 32 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "224 64 80 64 80 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "128 160 80 208 32 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "224 64 80 64 80 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$R = [];
/* style */

const __vue_inject_styles__$R = undefined;
/* scoped */

const __vue_scope_id__$R = undefined;
/* module identifier */

const __vue_module_identifier__$R = undefined;
/* functional template */

const __vue_is_functional_template__$R = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$R = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$R,
  staticRenderFns: __vue_staticRenderFns__$R
}, __vue_inject_styles__$R, __vue_script__$R, __vue_scope_id__$R, __vue_is_functional_template__$R, __vue_module_identifier__$R, false, undefined, undefined, undefined);

var script$S = Vue.extend({
  name: "PhArrowElbowLeftUp",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$S = script$S;
/* template */

var __vue_render__$S = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "128 96 80 48 32 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "224 192 80 192 80 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "128 96 80 48 32 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "224 192 80 192 80 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232,192a8.00008,8.00008,0,0,1-8,8H80a8.00008,8.00008,0,0,1-8-8V104H32a8.00037,8.00037,0,0,1-5.65723-13.65674l48-48a8.00122,8.00122,0,0,1,11.31446,0l48,48A8.00038,8.00038,0,0,1,128,104H88v80H224A8.00008,8.00008,0,0,1,232,192Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "128 96 80 48 32 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "224 192 80 192 80 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "128 96 80 48 32 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "224 192 80 192 80 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "128 96 80 48 32 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "224 192 80 192 80 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$S = [];
/* style */

const __vue_inject_styles__$S = undefined;
/* scoped */

const __vue_scope_id__$S = undefined;
/* module identifier */

const __vue_module_identifier__$S = undefined;
/* functional template */

const __vue_is_functional_template__$S = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$S = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$S,
  staticRenderFns: __vue_staticRenderFns__$S
}, __vue_inject_styles__$S, __vue_script__$S, __vue_scope_id__$S, __vue_is_functional_template__$S, __vue_module_identifier__$S, false, undefined, undefined, undefined);

var script$T = Vue.extend({
  name: "PhArrowElbowRight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$T = script$T;
/* template */

var __vue_render__$T = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "160 80 232 80 232 152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "24 96 120 192 232 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "160 80 232 80 232 152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "24 96 120 192 232 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M240,80v72a8.00053,8.00053,0,0,1-13.65723,5.65723L196,127.31445l-70.34277,70.34278a8.00181,8.00181,0,0,1-11.31446,0l-96-96A8.00053,8.00053,0,0,1,29.65723,90.34277L120,180.68652l64.68579-64.68628-30.343-30.343A8.00065,8.00065,0,0,1,160,72h72A8.00039,8.00039,0,0,1,240,80Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "160 80 232 80 232 152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "24 96 120 192 232 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "160 80 232 80 232 152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "24 96 120 192 232 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "160 80 232 80 232 152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "24 96 120 192 232 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$T = [];
/* style */

const __vue_inject_styles__$T = undefined;
/* scoped */

const __vue_scope_id__$T = undefined;
/* module identifier */

const __vue_module_identifier__$T = undefined;
/* functional template */

const __vue_is_functional_template__$T = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$T = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$T,
  staticRenderFns: __vue_staticRenderFns__$T
}, __vue_inject_styles__$T, __vue_script__$T, __vue_scope_id__$T, __vue_is_functional_template__$T, __vue_module_identifier__$T, false, undefined, undefined, undefined);

var script$U = Vue.extend({
  name: "PhArrowElbowRightDown",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$U = script$U;
/* template */

var __vue_render__$U = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "128 160 176 208 224 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "32 64 176 64 176 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "128 160 176 208 224 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "32 64 176 64 176 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M229.65723,165.65674l-48,48a8.00063,8.00063,0,0,1-11.31446,0l-48-48A8.00037,8.00037,0,0,1,128,152h40V72H32a8,8,0,0,1,0-16H176a8.00008,8.00008,0,0,1,8,8v88h40a8.00038,8.00038,0,0,1,5.65723,13.65674Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "128 160 176 208 224 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "32 64 176 64 176 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "128 160 176 208 224 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "32 64 176 64 176 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "128 160 176 208 224 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "32 64 176 64 176 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$U = [];
/* style */

const __vue_inject_styles__$U = undefined;
/* scoped */

const __vue_scope_id__$U = undefined;
/* module identifier */

const __vue_module_identifier__$U = undefined;
/* functional template */

const __vue_is_functional_template__$U = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$U = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$U,
  staticRenderFns: __vue_staticRenderFns__$U
}, __vue_inject_styles__$U, __vue_script__$U, __vue_scope_id__$U, __vue_is_functional_template__$U, __vue_module_identifier__$U, false, undefined, undefined, undefined);

var script$V = Vue.extend({
  name: "PhArrowElbowRightUp",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$V = script$V;
/* template */

var __vue_render__$V = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "128 96 176 48 224 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "32 192 176 192 176 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "128 96 176 48 224 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "32 192 176 192 176 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M231.39062,99.06152A8,8,0,0,1,224,104H184v88a8.00008,8.00008,0,0,1-8,8H32a8,8,0,0,1,0-16H168V104H128a8.00037,8.00037,0,0,1-5.65723-13.65674l48-48a8.00122,8.00122,0,0,1,11.31446,0l48,48A7.99949,7.99949,0,0,1,231.39062,99.06152Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "128 96 176 48 224 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "32 192 176 192 176 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "128 96 176 48 224 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "32 192 176 192 176 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "128 96 176 48 224 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "32 192 176 192 176 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$V = [];
/* style */

const __vue_inject_styles__$V = undefined;
/* scoped */

const __vue_scope_id__$V = undefined;
/* module identifier */

const __vue_module_identifier__$V = undefined;
/* functional template */

const __vue_is_functional_template__$V = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$V = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$V,
  staticRenderFns: __vue_staticRenderFns__$V
}, __vue_inject_styles__$V, __vue_script__$V, __vue_scope_id__$V, __vue_is_functional_template__$V, __vue_module_identifier__$V, false, undefined, undefined, undefined);

var script$W = Vue.extend({
  name: "PhArrowElbowUpLeft",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$W = script$W;
/* template */

var __vue_render__$W = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "96 128 48 80 96 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192 224 192 80 48 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "96 128 48 80 96 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192 224 192 80 48 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,80V224a8,8,0,0,1-16,0V88H104v40a8.00018,8.00018,0,0,1-13.65723,5.65674l-48-48a8,8,0,0,1,0-11.31348l48-48A8.0001,8.0001,0,0,1,104,32V72h88A8.00008,8.00008,0,0,1,200,80Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "96 128 48 80 96 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192 224 192 80 48 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "96 128 48 80 96 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192 224 192 80 48 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "192 224 192 80 48 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 128 48 80 96 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192 224 192 80 48 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$W = [];
/* style */

const __vue_inject_styles__$W = undefined;
/* scoped */

const __vue_scope_id__$W = undefined;
/* module identifier */

const __vue_module_identifier__$W = undefined;
/* functional template */

const __vue_is_functional_template__$W = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$W = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$W,
  staticRenderFns: __vue_staticRenderFns__$W
}, __vue_inject_styles__$W, __vue_script__$W, __vue_scope_id__$W, __vue_is_functional_template__$W, __vue_module_identifier__$W, false, undefined, undefined, undefined);

var script$X = Vue.extend({
  name: "PhArrowElbowUpRight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$X = script$X;
/* template */

var __vue_render__$X = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "160 128 208 80 160 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 224 64 80 208 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "160 128 208 80 160 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 224 64 80 208 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M213.65723,85.65674l-48,48A8.0001,8.0001,0,0,1,152,128V88H72V224a8,8,0,0,1-16,0V80a8.00008,8.00008,0,0,1,8-8h88V32a8.0001,8.0001,0,0,1,13.65723-5.65674l48,48A8,8,0,0,1,213.65723,85.65674Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "160 128 208 80 160 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 224 64 80 208 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "160 128 208 80 160 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 224 64 80 208 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "160 128 208 80 160 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 224 64 80 208 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$X = [];
/* style */

const __vue_inject_styles__$X = undefined;
/* scoped */

const __vue_scope_id__$X = undefined;
/* module identifier */

const __vue_module_identifier__$X = undefined;
/* functional template */

const __vue_is_functional_template__$X = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$X = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$X,
  staticRenderFns: __vue_staticRenderFns__$X
}, __vue_inject_styles__$X, __vue_script__$X, __vue_scope_id__$X, __vue_is_functional_template__$X, __vue_module_identifier__$X, false, undefined, undefined, undefined);

var script$Y = Vue.extend({
  name: "PhArrowFatDown",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$Y = script$Y;
/* template */

var __vue_render__$Y = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,136l96,96,96-96H176V48a8,8,0,0,0-8-8H88a8,8,0,0,0-8,8v88Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,136l96,96,96-96H176V48a8,8,0,0,0-8-8H88a8,8,0,0,0-8,8v88Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,136l96,96,96-96H176V48a8,8,0,0,0-8-8H88a8,8,0,0,0-8,8v88Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M229.65723,141.65723l-96,96a8.003,8.003,0,0,1-11.31446,0l-96-96A8.00065,8.00065,0,0,1,32,128H72V48A16.01833,16.01833,0,0,1,88,32h80a16.01833,16.01833,0,0,1,16,16v80h40a8.00066,8.00066,0,0,1,5.65723,13.65723Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,136l96,96,96-96H176V48a8,8,0,0,0-8-8H88a8,8,0,0,0-8,8v88Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,136l96,96,96-96H176V48a8,8,0,0,0-8-8H88a8,8,0,0,0-8,8v88Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,136l96,96,96-96H176V48a8,8,0,0,0-8-8H88a8,8,0,0,0-8,8v88Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$Y = [];
/* style */

const __vue_inject_styles__$Y = undefined;
/* scoped */

const __vue_scope_id__$Y = undefined;
/* module identifier */

const __vue_module_identifier__$Y = undefined;
/* functional template */

const __vue_is_functional_template__$Y = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$Y = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$Y,
  staticRenderFns: __vue_staticRenderFns__$Y
}, __vue_inject_styles__$Y, __vue_script__$Y, __vue_scope_id__$Y, __vue_is_functional_template__$Y, __vue_module_identifier__$Y, false, undefined, undefined, undefined);

var script$Z = Vue.extend({
  name: "PhArrowFatLeft",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$Z = script$Z;
/* template */

var __vue_render__$Z = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M120,32,24,128l96,96V176h88a8,8,0,0,0,8-8V88a8,8,0,0,0-8-8H120Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M120,32,24,128l96,96V176h88a8,8,0,0,0,8-8V88a8,8,0,0,0-8-8H120Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M120,32,24,128l96,96V176h88a8,8,0,0,0,8-8V88a8,8,0,0,0-8-8H120Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M114.34277,229.65723l-96-96a8.003,8.003,0,0,1,0-11.31446l96-96A8.00065,8.00065,0,0,1,128,32V72h80a16.01833,16.01833,0,0,1,16,16v80a16.01833,16.01833,0,0,1-16,16H128v40a8.00066,8.00066,0,0,1-13.65723,5.65723Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M120,32,24,128l96,96V176h88a8,8,0,0,0,8-8V88a8,8,0,0,0-8-8H120Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M120,32,24,128l96,96V176h88a8,8,0,0,0,8-8V88a8,8,0,0,0-8-8H120Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M120,32,24,128l96,96V176h88a8,8,0,0,0,8-8V88a8,8,0,0,0-8-8H120Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$Z = [];
/* style */

const __vue_inject_styles__$Z = undefined;
/* scoped */

const __vue_scope_id__$Z = undefined;
/* module identifier */

const __vue_module_identifier__$Z = undefined;
/* functional template */

const __vue_is_functional_template__$Z = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$Z = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$Z,
  staticRenderFns: __vue_staticRenderFns__$Z
}, __vue_inject_styles__$Z, __vue_script__$Z, __vue_scope_id__$Z, __vue_is_functional_template__$Z, __vue_module_identifier__$Z, false, undefined, undefined, undefined);

var script$_ = Vue.extend({
  name: "PhArrowFatLineDown",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$_ = script$_;
/* template */

var __vue_render__$_ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "32 136 128 232 224 136 176 136 176 80 80 80 80 136 32 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "40",
      "x2": "80",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "32 136 128 232 224 136 176 136 176 72 80 72 80 136 32 136",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "32 136 128 232 224 136 176 136 176 72 80 72 80 136 32 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "40",
      "x2": "80",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M229.65723,141.65723l-96,96a8.003,8.003,0,0,1-11.31446,0l-96-96A8.00065,8.00065,0,0,1,32,128H72V72a8.00039,8.00039,0,0,1,8-8h96a8.00039,8.00039,0,0,1,8,8v56h40a8.00066,8.00066,0,0,1,5.65723,13.65723ZM184,40a8.00039,8.00039,0,0,0-8-8H80a8,8,0,0,0,0,16h96A8.00039,8.00039,0,0,0,184,40Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "32 136 128 232 224 136 176 136 176 72 80 72 80 136 32 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "40",
      "x2": "80",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "32 136 128 232 224 136 176 136 176 72 80 72 80 136 32 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "40",
      "x2": "80",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "32 136 128 232 224 136 176 136 176 72 80 72 80 136 32 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "40",
      "x2": "80",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$_ = [];
/* style */

const __vue_inject_styles__$_ = undefined;
/* scoped */

const __vue_scope_id__$_ = undefined;
/* module identifier */

const __vue_module_identifier__$_ = undefined;
/* functional template */

const __vue_is_functional_template__$_ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$_ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$_,
  staticRenderFns: __vue_staticRenderFns__$_
}, __vue_inject_styles__$_, __vue_script__$_, __vue_scope_id__$_, __vue_is_functional_template__$_, __vue_module_identifier__$_, false, undefined, undefined, undefined);

var script$$ = Vue.extend({
  name: "PhArrowFatLineLeft",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$$ = script$$;
/* template */

var __vue_render__$$ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "120 32 24 128 120 224 120 176 176 176 176 80 120 80 120 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "176",
      "x2": "216",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "120 32 24 128 120 224 120 176 184 176 184 80 120 80 120 32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "120 32 24 128 120 224 120 176 184 176 184 80 120 80 120 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "176",
      "x2": "216",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M114.34277,229.65723l-96-96a8.003,8.003,0,0,1,0-11.31446l96-96A8.00065,8.00065,0,0,1,128,32V72h56a8.00039,8.00039,0,0,1,8,8v96a8.00039,8.00039,0,0,1-8,8H128v40a8.00066,8.00066,0,0,1-13.65723,5.65723ZM216,184a8.00039,8.00039,0,0,0,8-8V80a8,8,0,0,0-16,0v96A8.00039,8.00039,0,0,0,216,184Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "120 32 24 128 120 224 120 176 184 176 184 80 120 80 120 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "176",
      "x2": "216",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "120 32 24 128 120 224 120 176 184 176 184 80 120 80 120 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "176",
      "x2": "216",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "120 32 24 128 120 224 120 176 184 176 184 80 120 80 120 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "176",
      "x2": "216",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$$ = [];
/* style */

const __vue_inject_styles__$$ = undefined;
/* scoped */

const __vue_scope_id__$$ = undefined;
/* module identifier */

const __vue_module_identifier__$$ = undefined;
/* functional template */

const __vue_is_functional_template__$$ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$$ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$$,
  staticRenderFns: __vue_staticRenderFns__$$
}, __vue_inject_styles__$$, __vue_script__$$, __vue_scope_id__$$, __vue_is_functional_template__$$, __vue_module_identifier__$$, false, undefined, undefined, undefined);

var script$10 = Vue.extend({
  name: "PhArrowFatLineRight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$10 = script$10;
/* template */

var __vue_render__$10 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "136 32 232 128 136 224 136 176 80 176 80 80 136 80 136 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "176",
      "x2": "40",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "136 32 232 128 136 224 136 176 72 176 72 80 136 80 136 32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "136 32 232 128 136 224 136 176 72 176 72 80 136 80 136 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "176",
      "x2": "40",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M132.93848,231.39062A8,8,0,0,1,128,224V184H72a8.00039,8.00039,0,0,1-8-8V80a8.00039,8.00039,0,0,1,8-8h56V32a8.00065,8.00065,0,0,1,13.65723-5.65723l96,96a8.003,8.003,0,0,1,0,11.31446l-96,96A8.002,8.002,0,0,1,132.93848,231.39062ZM48,176V80a8,8,0,0,0-16,0v96a8,8,0,0,0,16,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "136 32 232 128 136 224 136 176 72 176 72 80 136 80 136 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "176",
      "x2": "40",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "136 32 232 128 136 224 136 176 72 176 72 80 136 80 136 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "176",
      "x2": "40",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "136 32 232 128 136 224 136 176 72 176 72 80 136 80 136 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "176",
      "x2": "40",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$10 = [];
/* style */

const __vue_inject_styles__$10 = undefined;
/* scoped */

const __vue_scope_id__$10 = undefined;
/* module identifier */

const __vue_module_identifier__$10 = undefined;
/* functional template */

const __vue_is_functional_template__$10 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$10 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$10,
  staticRenderFns: __vue_staticRenderFns__$10
}, __vue_inject_styles__$10, __vue_script__$10, __vue_scope_id__$10, __vue_is_functional_template__$10, __vue_module_identifier__$10, false, undefined, undefined, undefined);

var script$11 = Vue.extend({
  name: "PhArrowFatLineUp",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$11 = script$11;
/* template */

var __vue_render__$11 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "32 120 128 24 224 120 176 120 176 176 80 176 80 120 32 120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "216",
      "x2": "80",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "32 120 128 24 224 120 176 120 176 184 80 184 80 120 32 120",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "32 120 128 24 224 120 176 120 176 184 80 184 80 120 32 120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "216",
      "x2": "80",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M231.39062,123.06152A8,8,0,0,1,224,128H184v56a8.00039,8.00039,0,0,1-8,8H80a8.00039,8.00039,0,0,1-8-8V128H32a8.00065,8.00065,0,0,1-5.65723-13.65723l96-96a8.003,8.003,0,0,1,11.31446,0l96,96A8.002,8.002,0,0,1,231.39062,123.06152ZM176,208H80a8,8,0,0,0,0,16h96a8,8,0,0,0,0-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "32 120 128 24 224 120 176 120 176 184 80 184 80 120 32 120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "216",
      "x2": "80",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "32 120 128 24 224 120 176 120 176 184 80 184 80 120 32 120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "216",
      "x2": "80",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "32 120 128 24 224 120 176 120 176 184 80 184 80 120 32 120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "216",
      "x2": "80",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$11 = [];
/* style */

const __vue_inject_styles__$11 = undefined;
/* scoped */

const __vue_scope_id__$11 = undefined;
/* module identifier */

const __vue_module_identifier__$11 = undefined;
/* functional template */

const __vue_is_functional_template__$11 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$11 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$11,
  staticRenderFns: __vue_staticRenderFns__$11
}, __vue_inject_styles__$11, __vue_script__$11, __vue_scope_id__$11, __vue_is_functional_template__$11, __vue_module_identifier__$11, false, undefined, undefined, undefined);

var script$12 = Vue.extend({
  name: "PhArrowFatLinesDown",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$12 = script$12;
/* template */

var __vue_render__$12 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "32 136 128 232 224 136 176 136 176 116 80 116 80 136 32 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "44",
      "x2": "80",
      "y2": "44",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "80",
      "x2": "80",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "32 136 128 232 224 136 176 136 176 104 80 104 80 136 32 136",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "32 136 128 232 224 136 176 136 176 104 80 104 80 136 32 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "40",
      "x2": "80",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "72",
      "x2": "80",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M229.65674,141.65723l-96,96a8.00182,8.00182,0,0,1-11.31348,0l-96-96A8.0001,8.0001,0,0,1,32,128H72V104a8.00008,8.00008,0,0,1,8-8h96a8.00008,8.00008,0,0,1,8,8v24h40a8.0001,8.0001,0,0,1,5.65674,13.65723ZM184,40a8.00008,8.00008,0,0,0-8-8H80a8,8,0,0,0,0,16h96A8.00008,8.00008,0,0,0,184,40Zm0,32a8.00008,8.00008,0,0,0-8-8H80a8,8,0,0,0,0,16h96A8.00008,8.00008,0,0,0,184,72Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "32 136 128 232 224 136 176 136 176 104 80 104 80 136 32 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "40",
      "x2": "80",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "72",
      "x2": "80",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "32 136 128 232 224 136 176 136 176 104 80 104 80 136 32 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "40",
      "x2": "80",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "72",
      "x2": "80",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "32 136 128 232 224 136 176 136 176 104 80 104 80 136 32 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "40",
      "x2": "80",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "72",
      "x2": "80",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$12 = [];
/* style */

const __vue_inject_styles__$12 = undefined;
/* scoped */

const __vue_scope_id__$12 = undefined;
/* module identifier */

const __vue_module_identifier__$12 = undefined;
/* functional template */

const __vue_is_functional_template__$12 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$12 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$12,
  staticRenderFns: __vue_staticRenderFns__$12
}, __vue_inject_styles__$12, __vue_script__$12, __vue_scope_id__$12, __vue_is_functional_template__$12, __vue_module_identifier__$12, false, undefined, undefined, undefined);

var script$13 = Vue.extend({
  name: "PhArrowFatLinesLeft",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$13 = script$13;
/* template */

var __vue_render__$13 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "120 32 24 128 120 224 120 176 140 176 140 80 120 80 120 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "212",
      "y1": "176",
      "x2": "212",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "176",
      "x2": "176",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "120 32 24 128 120 224 120 176 152 176 152 80 120 80 120 32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "120 32 24 128 120 224 120 176 152 176 152 80 120 80 120 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "176",
      "x2": "216",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "176",
      "x2": "184",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M114.34277,229.65674l-96-96a8.00182,8.00182,0,0,1,0-11.31348l96-96A8.0001,8.0001,0,0,1,128,32V72h24a8.00008,8.00008,0,0,1,8,8v96a8.00008,8.00008,0,0,1-8,8H128v40a8.0001,8.0001,0,0,1-13.65723,5.65674ZM216,184a8.00008,8.00008,0,0,0,8-8V80a8,8,0,0,0-16,0v96A8.00008,8.00008,0,0,0,216,184Zm-32,0a8.00008,8.00008,0,0,0,8-8V80a8,8,0,0,0-16,0v96A8.00008,8.00008,0,0,0,184,184Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "120 32 24 128 120 224 120 176 152 176 152 80 120 80 120 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "176",
      "x2": "216",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "176",
      "x2": "184",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "120 32 24 128 120 224 120 176 152 176 152 80 120 80 120 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "176",
      "x2": "216",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "176",
      "x2": "184",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "120 32 24 128 120 224 120 176 152 176 152 80 120 80 120 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "176",
      "x2": "216",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "176",
      "x2": "184",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$13 = [];
/* style */

const __vue_inject_styles__$13 = undefined;
/* scoped */

const __vue_scope_id__$13 = undefined;
/* module identifier */

const __vue_module_identifier__$13 = undefined;
/* functional template */

const __vue_is_functional_template__$13 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$13 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$13,
  staticRenderFns: __vue_staticRenderFns__$13
}, __vue_inject_styles__$13, __vue_script__$13, __vue_scope_id__$13, __vue_is_functional_template__$13, __vue_module_identifier__$13, false, undefined, undefined, undefined);

var script$14 = Vue.extend({
  name: "PhArrowFatLinesRight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$14 = script$14;
/* template */

var __vue_render__$14 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "136 32 232 128 136 224 136 176 116 176 116 80 136 80 136 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "44",
      "y1": "176",
      "x2": "44",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "176",
      "x2": "80",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "136 32 232 128 136 224 136 176 104 176 104 80 136 80 136 32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "136 32 232 128 136 224 136 176 104 176 104 80 136 80 136 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "176",
      "x2": "40",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "176",
      "x2": "72",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M132.93848,231.39111A8.00015,8.00015,0,0,1,128,224V184H104a8.00008,8.00008,0,0,1-8-8V80a8.00008,8.00008,0,0,1,8-8h24V32a8.0001,8.0001,0,0,1,13.65723-5.65674l96,96a8.00182,8.00182,0,0,1,0,11.31348l-96,96A8.00061,8.00061,0,0,1,132.93848,231.39111ZM48,176V80a8,8,0,0,0-16,0v96a8,8,0,0,0,16,0Zm32,0V80a8,8,0,0,0-16,0v96a8,8,0,0,0,16,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "136 32 232 128 136 224 136 176 104 176 104 80 136 80 136 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "176",
      "x2": "40",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "176",
      "x2": "72",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "136 32 232 128 136 224 136 176 104 176 104 80 136 80 136 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "176",
      "x2": "40",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "176",
      "x2": "72",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "136 32 232 128 136 224 136 176 104 176 104 80 136 80 136 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "176",
      "x2": "40",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "176",
      "x2": "72",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$14 = [];
/* style */

const __vue_inject_styles__$14 = undefined;
/* scoped */

const __vue_scope_id__$14 = undefined;
/* module identifier */

const __vue_module_identifier__$14 = undefined;
/* functional template */

const __vue_is_functional_template__$14 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$14 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$14,
  staticRenderFns: __vue_staticRenderFns__$14
}, __vue_inject_styles__$14, __vue_script__$14, __vue_scope_id__$14, __vue_is_functional_template__$14, __vue_module_identifier__$14, false, undefined, undefined, undefined);

var script$15 = Vue.extend({
  name: "PhArrowFatLinesUp",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$15 = script$15;
/* template */

var __vue_render__$15 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "32 120 128 24 224 120 176 120 176 140 80 140 80 120 32 120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "212",
      "x2": "80",
      "y2": "212",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "176",
      "x2": "80",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "32 120 128 24 224 120 176 120 176 152 80 152 80 120 32 120",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "32 120 128 24 224 120 176 120 176 152 80 152 80 120 32 120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "216",
      "x2": "80",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "184",
      "x2": "80",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M231.39111,123.06152A8.00015,8.00015,0,0,1,224,128H184v24a8.00008,8.00008,0,0,1-8,8H80a8.00008,8.00008,0,0,1-8-8V128H32a8.0001,8.0001,0,0,1-5.65674-13.65723l96-96a8.00182,8.00182,0,0,1,11.31348,0l96,96A8.00061,8.00061,0,0,1,231.39111,123.06152ZM176,208H80a8,8,0,0,0,0,16h96a8,8,0,0,0,0-16Zm0-32H80a8,8,0,0,0,0,16h96a8,8,0,0,0,0-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "32 120 128 24 224 120 176 120 176 152 80 152 80 120 32 120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "216",
      "x2": "80",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "184",
      "x2": "80",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "32 120 128 24 224 120 176 120 176 152 80 152 80 120 32 120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "216",
      "x2": "80",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "184",
      "x2": "80",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "32 120 128 24 224 120 176 120 176 152 80 152 80 120 32 120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "216",
      "x2": "80",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "184",
      "x2": "80",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$15 = [];
/* style */

const __vue_inject_styles__$15 = undefined;
/* scoped */

const __vue_scope_id__$15 = undefined;
/* module identifier */

const __vue_module_identifier__$15 = undefined;
/* functional template */

const __vue_is_functional_template__$15 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$15 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$15,
  staticRenderFns: __vue_staticRenderFns__$15
}, __vue_inject_styles__$15, __vue_script__$15, __vue_scope_id__$15, __vue_is_functional_template__$15, __vue_module_identifier__$15, false, undefined, undefined, undefined);

var script$16 = Vue.extend({
  name: "PhArrowFatRight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$16 = script$16;
/* template */

var __vue_render__$16 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M136,32l96,96-96,96V176H48a8,8,0,0,1-8-8V88a8,8,0,0,1,8-8h88Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M136,32l96,96-96,96V176H48a8,8,0,0,1-8-8V88a8,8,0,0,1,8-8h88Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M136,32l96,96-96,96V176H48a8,8,0,0,1-8-8V88a8,8,0,0,1,8-8h88Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M132.93848,231.39062A8,8,0,0,1,128,224V184H48a16.01833,16.01833,0,0,1-16-16V88A16.01833,16.01833,0,0,1,48,72h80V32a8.00065,8.00065,0,0,1,13.65723-5.65723l96,96a8.003,8.003,0,0,1,0,11.31446l-96,96A8.002,8.002,0,0,1,132.93848,231.39062Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M136,32l96,96-96,96V176H48a8,8,0,0,1-8-8V88a8,8,0,0,1,8-8h88Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M136,32l96,96-96,96V176H48a8,8,0,0,1-8-8V88a8,8,0,0,1,8-8h88Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M136,32l96,96-96,96V176H48a8,8,0,0,1-8-8V88a8,8,0,0,1,8-8h88Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$16 = [];
/* style */

const __vue_inject_styles__$16 = undefined;
/* scoped */

const __vue_scope_id__$16 = undefined;
/* module identifier */

const __vue_module_identifier__$16 = undefined;
/* functional template */

const __vue_is_functional_template__$16 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$16 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$16,
  staticRenderFns: __vue_staticRenderFns__$16
}, __vue_inject_styles__$16, __vue_script__$16, __vue_scope_id__$16, __vue_is_functional_template__$16, __vue_module_identifier__$16, false, undefined, undefined, undefined);

var script$17 = Vue.extend({
  name: "PhArrowFatUp",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$17 = script$17;
/* template */

var __vue_render__$17 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,120l96-96,96,96H176v88a8,8,0,0,1-8,8H88a8,8,0,0,1-8-8V120Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,120l96-96,96,96H176v88a8,8,0,0,1-8,8H88a8,8,0,0,1-8-8V120Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,120l96-96,96,96H176v88a8,8,0,0,1-8,8H88a8,8,0,0,1-8-8V120Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M231.39062,123.06152A8,8,0,0,1,224,128H184v80a16.01833,16.01833,0,0,1-16,16H88a16.01833,16.01833,0,0,1-16-16V128H32a8.00065,8.00065,0,0,1-5.65723-13.65723l96-96a8.003,8.003,0,0,1,11.31446,0l96,96A8.002,8.002,0,0,1,231.39062,123.06152Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,120l96-96,96,96H176v88a8,8,0,0,1-8,8H88a8,8,0,0,1-8-8V120Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,120l96-96,96,96H176v88a8,8,0,0,1-8,8H88a8,8,0,0,1-8-8V120Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,120l96-96,96,96H176v88a8,8,0,0,1-8,8H88a8,8,0,0,1-8-8V120Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$17 = [];
/* style */

const __vue_inject_styles__$17 = undefined;
/* scoped */

const __vue_scope_id__$17 = undefined;
/* module identifier */

const __vue_module_identifier__$17 = undefined;
/* functional template */

const __vue_is_functional_template__$17 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$17 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$17,
  staticRenderFns: __vue_staticRenderFns__$17
}, __vue_inject_styles__$17, __vue_script__$17, __vue_scope_id__$17, __vue_is_functional_template__$17, __vue_module_identifier__$17, false, undefined, undefined, undefined);

var script$18 = Vue.extend({
  name: "PhArrowLeft",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$18 = script$18;
/* template */

var __vue_render__$18 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "216",
      "y1": "128",
      "x2": "40",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "112 56 40 128 112 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "216",
      "y1": "128",
      "x2": "40",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "112 56 40 128 112 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,128a8.00039,8.00039,0,0,1-8,8H120v64a8.00018,8.00018,0,0,1-13.65674,5.65723l-72-72a8.00034,8.00034,0,0,1,0-11.31446l72-72A8.00037,8.00037,0,0,1,120,56v64h96A8.00039,8.00039,0,0,1,224,128Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "216",
      "y1": "128",
      "x2": "40",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "112 56 40 128 112 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "216",
      "y1": "128",
      "x2": "40",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "112 56 40 128 112 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "216",
      "y1": "128",
      "x2": "40",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "112 56 40 128 112 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$18 = [];
/* style */

const __vue_inject_styles__$18 = undefined;
/* scoped */

const __vue_scope_id__$18 = undefined;
/* module identifier */

const __vue_module_identifier__$18 = undefined;
/* functional template */

const __vue_is_functional_template__$18 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$18 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$18,
  staticRenderFns: __vue_staticRenderFns__$18
}, __vue_inject_styles__$18, __vue_script__$18, __vue_scope_id__$18, __vue_is_functional_template__$18, __vue_module_identifier__$18, false, undefined, undefined, undefined);

var script$19 = Vue.extend({
  name: "PhArrowLineDown",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$19 = script$19;
/* template */

var __vue_render__$19 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "31.99627",
      "x2": "128",
      "y2": "175.99627",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "56 103.996 128 175.996 200 103.996",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "215.99627",
      "x2": "216",
      "y2": "215.99627",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "31.99627",
      "x2": "128",
      "y2": "183.99627",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "56 111.996 128 183.996 200 111.996",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "215.99627",
      "x2": "216",
      "y2": "215.99627",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M50.34326,117.65283A7.99981,7.99981,0,0,1,56,103.99609h64v-72a8,8,0,0,1,16,0v72h64a7.99981,7.99981,0,0,1,5.65674,13.65674l-72,72a7.99945,7.99945,0,0,1-11.31348,0ZM216,207.99609H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "31.99627",
      "x2": "128",
      "y2": "183.99627",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "56 111.996 128 183.996 200 111.996",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "215.99627",
      "x2": "216",
      "y2": "215.99627",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "31.99627",
      "x2": "128",
      "y2": "183.99627",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "56 111.996 128 183.996 200 111.996",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "215.99627",
      "x2": "216",
      "y2": "215.99627",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "31.99627",
      "x2": "128",
      "y2": "183.99627",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "56 111.996 128 183.996 200 111.996",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "215.99627",
      "x2": "216",
      "y2": "215.99627",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$19 = [];
/* style */

const __vue_inject_styles__$19 = undefined;
/* scoped */

const __vue_scope_id__$19 = undefined;
/* module identifier */

const __vue_module_identifier__$19 = undefined;
/* functional template */

const __vue_is_functional_template__$19 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$19 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$19,
  staticRenderFns: __vue_staticRenderFns__$19
}, __vue_inject_styles__$19, __vue_script__$19, __vue_scope_id__$19, __vue_is_functional_template__$19, __vue_module_identifier__$19, false, undefined, undefined, undefined);

var script$1a = Vue.extend({
  name: "PhArrowLineDownLeft",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1a = script$1a;
/* template */

var __vue_render__$1a = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "176",
      "y1": "88",
      "x2": "64",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 100 64 200 164 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "40.00373",
      "x2": "40",
      "y2": "40.00373",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "176",
      "y1": "88",
      "x2": "64",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 100 64 200 164 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "40.00373",
      "x2": "40",
      "y2": "40.00373",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M181.65723,82.34277a8.00122,8.00122,0,0,1,0,11.31446L125.31445,150l44.34278,44.34277A8.00038,8.00038,0,0,1,164,208H64a8.00039,8.00039,0,0,1-8-8V100a8.00065,8.00065,0,0,1,13.65723-5.65723L114,138.68579l56.34277-56.343A8.003,8.003,0,0,1,181.65723,82.34277ZM216,32.00391H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "176",
      "y1": "88",
      "x2": "64",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 100 64 200 164 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "40.00373",
      "x2": "40",
      "y2": "40.00373",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "176",
      "y1": "88",
      "x2": "64",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 100 64 200 164 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "40.00373",
      "x2": "40",
      "y2": "40.00373",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "176",
      "y1": "88",
      "x2": "64",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 100 64 200 164 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "40.00373",
      "x2": "40",
      "y2": "40.00373",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1a = [];
/* style */

const __vue_inject_styles__$1a = undefined;
/* scoped */

const __vue_scope_id__$1a = undefined;
/* module identifier */

const __vue_module_identifier__$1a = undefined;
/* functional template */

const __vue_is_functional_template__$1a = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1a = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1a,
  staticRenderFns: __vue_staticRenderFns__$1a
}, __vue_inject_styles__$1a, __vue_script__$1a, __vue_scope_id__$1a, __vue_is_functional_template__$1a, __vue_module_identifier__$1a, false, undefined, undefined, undefined);

var script$1b = Vue.extend({
  name: "PhArrowLineDownRight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1b = script$1b;
/* template */

var __vue_render__$1b = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "80",
      "y1": "88",
      "x2": "192",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192 100 192 200 92 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "40.00373",
      "x2": "216",
      "y2": "40.00373",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "80",
      "y1": "88",
      "x2": "192",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192 100 192 200 92 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "40.00373",
      "x2": "216",
      "y2": "40.00373",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,100V200a8.00039,8.00039,0,0,1-8,8H92a8.00038,8.00038,0,0,1-5.65723-13.65723L130.686,150,74.34277,93.65674A8.00018,8.00018,0,1,1,85.65723,82.34326L142,138.686l44.34277-44.34278A8.0001,8.0001,0,0,1,200,100Zm16-67.99609H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "80",
      "y1": "88",
      "x2": "192",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192 100 192 200 92 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "40.00373",
      "x2": "216",
      "y2": "40.00373",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "80",
      "y1": "88",
      "x2": "192",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192 100 192 200 92 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "40.00373",
      "x2": "216",
      "y2": "40.00373",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "80",
      "y1": "88",
      "x2": "192",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192 100 192 200 92 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "40.00373",
      "x2": "216",
      "y2": "40.00373",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1b = [];
/* style */

const __vue_inject_styles__$1b = undefined;
/* scoped */

const __vue_scope_id__$1b = undefined;
/* module identifier */

const __vue_module_identifier__$1b = undefined;
/* functional template */

const __vue_is_functional_template__$1b = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1b = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1b,
  staticRenderFns: __vue_staticRenderFns__$1b
}, __vue_inject_styles__$1b, __vue_script__$1b, __vue_scope_id__$1b, __vue_is_functional_template__$1b, __vue_module_identifier__$1b, false, undefined, undefined, undefined);

var script$1c = Vue.extend({
  name: "PhArrowLineLeft",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1c = script$1c;
/* template */

var __vue_render__$1c = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "224.00373",
      "y1": "128",
      "x2": "80.00373",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152.004 56 80.004 128 152.004 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "40",
      "x2": "40",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "224.00373",
      "y1": "128",
      "x2": "72.00373",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144.004 56 72.004 128 144.004 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "40",
      "x2": "40",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232.00391,128a8.00009,8.00009,0,0,1-8,8h-72v64a8.00018,8.00018,0,0,1-13.65723,5.65674l-72-72a8,8,0,0,1,0-11.31348l72-72A8.0001,8.0001,0,0,1,152.00391,56v64h72A8.00009,8.00009,0,0,1,232.00391,128ZM40,32a8.00008,8.00008,0,0,0-8,8V216a8,8,0,0,0,16,0V40A8.00008,8.00008,0,0,0,40,32Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "224.00373",
      "y1": "128",
      "x2": "72.00373",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144.004 56 72.004 128 144.004 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "40",
      "x2": "40",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "224.00373",
      "y1": "128",
      "x2": "72.00373",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144.004 56 72.004 128 144.004 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "40",
      "x2": "40",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "224.00373",
      "y1": "128",
      "x2": "72.00373",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144.004 56 72.004 128 144.004 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "40",
      "x2": "40",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1c = [];
/* style */

const __vue_inject_styles__$1c = undefined;
/* scoped */

const __vue_scope_id__$1c = undefined;
/* module identifier */

const __vue_module_identifier__$1c = undefined;
/* functional template */

const __vue_is_functional_template__$1c = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1c = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1c,
  staticRenderFns: __vue_staticRenderFns__$1c
}, __vue_inject_styles__$1c, __vue_script__$1c, __vue_scope_id__$1c, __vue_is_functional_template__$1c, __vue_module_identifier__$1c, false, undefined, undefined, undefined);

var script$1d = Vue.extend({
  name: "PhArrowLineRight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1d = script$1d;
/* template */

var __vue_render__$1d = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "31.99627",
      "y1": "128",
      "x2": "175.99627",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "103.996 56 175.996 128 103.996 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "40",
      "x2": "216",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "31.99627",
      "y1": "128",
      "x2": "183.99627",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "111.996 56 183.996 128 111.996 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "40",
      "x2": "216",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M189.65332,122.34326a8,8,0,0,1,0,11.31348l-72,72A8.0001,8.0001,0,0,1,103.99609,200V136h-72a8,8,0,0,1,0-16h72V56a8.0001,8.0001,0,0,1,13.65723-5.65674ZM216,32a8.00008,8.00008,0,0,0-8,8V216a8,8,0,0,0,16,0V40A8.00008,8.00008,0,0,0,216,32Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "31.99627",
      "y1": "128",
      "x2": "183.99627",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "111.996 56 183.996 128 111.996 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "40",
      "x2": "216",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "31.99627",
      "y1": "128",
      "x2": "183.99627",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "111.996 56 183.996 128 111.996 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "40",
      "x2": "216",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "31.99627",
      "y1": "128",
      "x2": "183.99627",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "111.996 56 183.996 128 111.996 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "40",
      "x2": "216",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1d = [];
/* style */

const __vue_inject_styles__$1d = undefined;
/* scoped */

const __vue_scope_id__$1d = undefined;
/* module identifier */

const __vue_module_identifier__$1d = undefined;
/* functional template */

const __vue_is_functional_template__$1d = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1d = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1d,
  staticRenderFns: __vue_staticRenderFns__$1d
}, __vue_inject_styles__$1d, __vue_script__$1d, __vue_scope_id__$1d, __vue_is_functional_template__$1d, __vue_module_identifier__$1d, false, undefined, undefined, undefined);

var script$1e = Vue.extend({
  name: "PhArrowLineUp",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1e = script$1e;
/* template */

var __vue_render__$1e = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "224.00373",
      "x2": "128",
      "y2": "80.00373",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "56 152.004 128 80.004 200 152.004",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "40",
      "x2": "216",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "224.00373",
      "x2": "128",
      "y2": "72.00373",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "56 144.004 128 72.004 200 144.004",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "40",
      "x2": "216",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M205.65674,138.34717A7.99981,7.99981,0,0,1,200,152.00391H136v72a8,8,0,1,1-16,0v-72H56a7.99981,7.99981,0,0,1-5.65674-13.65674l72-72a8,8,0,0,1,11.31348,0ZM216,32H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "224.00373",
      "x2": "128",
      "y2": "72.00373",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "56 144.004 128 72.004 200 144.004",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "40",
      "x2": "216",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "224.00373",
      "x2": "128",
      "y2": "72.00373",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "56 144.004 128 72.004 200 144.004",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "40",
      "x2": "216",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "224.00373",
      "x2": "128",
      "y2": "72.00373",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "56 144.004 128 72.004 200 144.004",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "40",
      "x2": "216",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1e = [];
/* style */

const __vue_inject_styles__$1e = undefined;
/* scoped */

const __vue_scope_id__$1e = undefined;
/* module identifier */

const __vue_module_identifier__$1e = undefined;
/* functional template */

const __vue_is_functional_template__$1e = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1e = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1e,
  staticRenderFns: __vue_staticRenderFns__$1e
}, __vue_inject_styles__$1e, __vue_script__$1e, __vue_scope_id__$1e, __vue_is_functional_template__$1e, __vue_module_identifier__$1e, false, undefined, undefined, undefined);

var script$1f = Vue.extend({
  name: "PhArrowLineUpLeft",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1f = script$1f;
/* template */

var __vue_render__$1f = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "176",
      "y1": "168",
      "x2": "64",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 156 64 56 164 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "215.99627",
      "x2": "40",
      "y2": "215.99627",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "176",
      "y1": "168",
      "x2": "64",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 156 64 56 164 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "215.99627",
      "x2": "40",
      "y2": "215.99627",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56,156V56a8.00008,8.00008,0,0,1,8-8H164a8.0001,8.0001,0,0,1,5.65723,13.65674L125.31348,106l56.34375,56.34326a8.00018,8.00018,0,0,1-11.31446,11.31348L114,117.31372l-44.34277,44.343A8.0001,8.0001,0,0,1,56,156Zm160,51.99609H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "176",
      "y1": "168",
      "x2": "64",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 156 64 56 164 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "215.99627",
      "x2": "40",
      "y2": "215.99627",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "176",
      "y1": "168",
      "x2": "64",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 156 64 56 164 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "215.99627",
      "x2": "40",
      "y2": "215.99627",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "176",
      "y1": "168",
      "x2": "64",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 156 64 56 164 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "215.99627",
      "x2": "40",
      "y2": "215.99627",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1f = [];
/* style */

const __vue_inject_styles__$1f = undefined;
/* scoped */

const __vue_scope_id__$1f = undefined;
/* module identifier */

const __vue_module_identifier__$1f = undefined;
/* functional template */

const __vue_is_functional_template__$1f = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1f = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1f,
  staticRenderFns: __vue_staticRenderFns__$1f
}, __vue_inject_styles__$1f, __vue_script__$1f, __vue_scope_id__$1f, __vue_is_functional_template__$1f, __vue_module_identifier__$1f, false, undefined, undefined, undefined);

var script$1g = Vue.extend({
  name: "PhArrowLineUpRight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1g = script$1g;
/* template */

var __vue_render__$1g = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "80",
      "y1": "168",
      "x2": "192",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192 156 192 56 92 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "215.99627",
      "x2": "216",
      "y2": "215.99627",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "80",
      "y1": "168",
      "x2": "192",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192 156 192 56 92 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "215.99627",
      "x2": "216",
      "y2": "215.99627",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M74.34277,173.65674a8,8,0,0,1,0-11.31348L130.68652,106,86.34277,61.65674A8.0001,8.0001,0,0,1,92,48H192a8.00008,8.00008,0,0,1,8,8V156a8.00018,8.00018,0,0,1-13.65723,5.65674L142,117.31372l-56.34277,56.343a8.00063,8.00063,0,0,1-11.31446,0ZM216,207.99609H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "80",
      "y1": "168",
      "x2": "192",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192 156 192 56 92 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "215.99627",
      "x2": "216",
      "y2": "215.99627",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "80",
      "y1": "168",
      "x2": "192",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192 156 192 56 92 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "215.99627",
      "x2": "216",
      "y2": "215.99627",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "80",
      "y1": "168",
      "x2": "192",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192 156 192 56 92 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "215.99627",
      "x2": "216",
      "y2": "215.99627",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1g = [];
/* style */

const __vue_inject_styles__$1g = undefined;
/* scoped */

const __vue_scope_id__$1g = undefined;
/* module identifier */

const __vue_module_identifier__$1g = undefined;
/* functional template */

const __vue_is_functional_template__$1g = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1g = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1g,
  staticRenderFns: __vue_staticRenderFns__$1g
}, __vue_inject_styles__$1g, __vue_script__$1g, __vue_scope_id__$1g, __vue_is_functional_template__$1g, __vue_module_identifier__$1g, false, undefined, undefined, undefined);

var script$1h = Vue.extend({
  name: "PhArrowRight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1h = script$1h;
/* template */

var __vue_render__$1h = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 56 216 128 144 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 56 216 128 144 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M221.65674,133.65723l-72,72A8.00038,8.00038,0,0,1,136,200V136H40a8,8,0,0,1,0-16h96V56a8.00037,8.00037,0,0,1,13.65674-5.65723l72,72A8.00034,8.00034,0,0,1,221.65674,133.65723Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 56 216 128 144 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 56 216 128 144 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 56 216 128 144 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1h = [];
/* style */

const __vue_inject_styles__$1h = undefined;
/* scoped */

const __vue_scope_id__$1h = undefined;
/* module identifier */

const __vue_module_identifier__$1h = undefined;
/* functional template */

const __vue_is_functional_template__$1h = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1h = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1h,
  staticRenderFns: __vue_staticRenderFns__$1h
}, __vue_inject_styles__$1h, __vue_script__$1h, __vue_scope_id__$1h, __vue_is_functional_template__$1h, __vue_module_identifier__$1h, false, undefined, undefined, undefined);

var script$1i = Vue.extend({
  name: "PhArrowSquareDown",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1i = script$1i;
/* template */

var __vue_render__$1i = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "94.059 134.059 128 168 161.941 134.059",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "88",
      "x2": "128",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "94.059 134.059 128 168 161.941 134.059",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "88",
      "x2": "128",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M207.99414,32h-160a16.01583,16.01583,0,0,0-16,16V208a16.01583,16.01583,0,0,0,16,16h160a16.01582,16.01582,0,0,0,16-16V48A16.01582,16.01582,0,0,0,207.99414,32ZM167.60352,139.71875l-33.94336,33.92773a8.02367,8.02367,0,0,1-11.332,0L88.40039,139.71875a7.99915,7.99915,0,0,1,11.3125-11.3125l20.28125,20.28125V88a8,8,0,1,1,16,0v60.69238L156.291,128.40625a7.99915,7.99915,0,0,1,11.3125,11.3125Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "94.059 134.059 128 168 161.941 134.059",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "88",
      "x2": "128",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "94.059 134.059 128 168 161.941 134.059",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "88",
      "x2": "128",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "94.059 134.059 128 168 161.941 134.059",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "88",
      "x2": "128",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1i = [];
/* style */

const __vue_inject_styles__$1i = undefined;
/* scoped */

const __vue_scope_id__$1i = undefined;
/* module identifier */

const __vue_module_identifier__$1i = undefined;
/* functional template */

const __vue_is_functional_template__$1i = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1i = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1i,
  staticRenderFns: __vue_staticRenderFns__$1i
}, __vue_inject_styles__$1i, __vue_script__$1i, __vue_scope_id__$1i, __vue_is_functional_template__$1i, __vue_module_identifier__$1i, false, undefined, undefined, undefined);

var script$1j = Vue.extend({
  name: "PhArrowSquareDownLeft",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1j = script$1j;
/* template */

var __vue_render__$1j = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "transform": "translate(0 256) rotate(-90)",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "148 156 100 156 100 108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "100",
      "x2": "100",
      "y2": "156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "transform": "translate(0 256) rotate(-90)",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "transform": "translate(0 256) rotate(-90)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "148 156 100 156 100 108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "100",
      "x2": "100",
      "y2": "156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,208V48a16.01833,16.01833,0,0,0-16-16H48A16.01833,16.01833,0,0,0,32,48V208a16.01833,16.01833,0,0,0,16,16H208A16.01833,16.01833,0,0,0,224,208ZM161.65674,105.65723,119.314,148H148a8,8,0,0,1,0,16H100c-.05981,0-.11768-.00781-.17725-.00879-.20251-.00488-.405-.01123-.60693-.03076-.13867-.01367-.27344-.03857-.41-.05908-.12171-.01856-.24366-.03174-.36451-.05567-.14636-.02881-.2882-.06884-.43151-.10547-.10938-.02783-.21949-.05175-.32789-.084-.13732-.042-.27014-.09277-.40429-.1416-.11231-.04053-.22547-.07715-.33618-.123-.12281-.05078-.24073-.11035-.36036-.167-.1173-.05566-.23559-.10742-.35058-.169-.11231-.06054-.219-.1289-.32813-.19384-.11523-.06885-.23181-.13428-.34423-.20948-.1167-.07812-.22669-.165-.339-.249-.09681-.07227-.19629-.13965-.29053-.21728-.1825-.14991-.35657-.30909-.525-.47413-.01953-.01953-.041-.03515-.0603-.05468-.01672-.01661-.03052-.03516-.04712-.05225-.168-.1709-.32959-.34766-.48169-.53271-.08007-.09766-.14966-.2002-.22436-.3003-.0813-.10888-.166-.21582-.242-.3291-.07788-.11621-.1455-.2373-.21655-.35644-.0625-.105-.12829-.207-.186-.315-.06482-.12109-.11988-.2456-.178-.36914-.05322-.11328-.10987-.22461-.158-.34033-.04956-.11963-.0896-.24219-.13318-.36377-.04468-.125-.09253-.24756-.13123-.375-.0371-.123-.06433-.24756-.09545-.37158-.03235-.12891-.06861-.25635-.09449-.38721-.02881-.145-.04614-.2915-.06677-.4375-.01587-.1123-.03747-.22265-.04858-.33642-.026-.26367-.03992-.52832-.03992-.793V108a8,8,0,0,1,16,0v28.686l42.34326-42.34327a8.00018,8.00018,0,1,1,11.31348,11.31446Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "transform": "translate(0 256) rotate(-90)",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "148 156 100 156 100 108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "100",
      "x2": "100",
      "y2": "156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "transform": "translate(0 256) rotate(-90)",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "148 156 100 156 100 108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "100",
      "x2": "100",
      "y2": "156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "transform": "translate(0 256) rotate(-90)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "148 156 100 156 100 108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "100",
      "x2": "100",
      "y2": "156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1j = [];
/* style */

const __vue_inject_styles__$1j = undefined;
/* scoped */

const __vue_scope_id__$1j = undefined;
/* module identifier */

const __vue_module_identifier__$1j = undefined;
/* functional template */

const __vue_is_functional_template__$1j = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1j = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1j,
  staticRenderFns: __vue_staticRenderFns__$1j
}, __vue_inject_styles__$1j, __vue_script__$1j, __vue_scope_id__$1j, __vue_is_functional_template__$1j, __vue_module_identifier__$1j, false, undefined, undefined, undefined);

var script$1k = Vue.extend({
  name: "PhArrowSquareDownRight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1k = script$1k;
/* template */

var __vue_render__$1k = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "transform": "translate(256 0) rotate(90)",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 156 156 156 156 108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "100",
      "x2": "156",
      "y2": "156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "transform": "translate(256 0) rotate(90)",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "transform": "translate(256 0) rotate(90)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 156 156 156 156 108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "100",
      "x2": "156",
      "y2": "156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M48,224H208a16.01833,16.01833,0,0,0,16-16V48a16.01833,16.01833,0,0,0-16-16H48A16.01833,16.01833,0,0,0,32,48V208A16.01833,16.01833,0,0,0,48,224ZM94.34326,94.34277a8.00063,8.00063,0,0,1,11.31348,0L148,136.686V108a8,8,0,0,1,16,0v47.99756c0,.26465-.01392.5293-.03992.793-.01111.11377-.03271.22412-.04858.33642-.02063.146-.038.29248-.06677.4375-.02588.13086-.06214.2583-.09449.38721-.03112.124-.05835.24854-.09545.37158-.0387.12744-.08655.25-.13123.375-.04358.12158-.08362.24414-.13318.36377-.04809.11572-.10474.22705-.158.34033-.0581.12354-.11316.248-.178.36914-.05774.10791-.12353.21-.186.315-.07105.11914-.13867.24023-.21655.35644-.07593.11328-.16065.22022-.242.3291-.0747.1001-.14429.20264-.22436.3003-.1521.185-.31372.36181-.48169.53271-.0166.01709-.0304.03564-.04712.05225-.01929.01953-.04077.03515-.0603.05468-.16846.165-.34253.32422-.525.47413-.09424.07763-.19372.145-.29053.21728-.1123.084-.22229.1709-.339.249-.11242.0752-.229.14063-.34423.20948-.10913.06494-.21582.1333-.32813.19384-.115.06153-.23328.11329-.35058.169-.11963.05664-.23755.11621-.36036.167-.11071.0459-.22387.08252-.33618.123-.13415.04883-.267.09961-.40429.1416-.1084.03223-.21851.05615-.32789.084-.14331.03663-.28515.07666-.43151.10547-.12085.02393-.2428.03711-.36451.05567-.13659.02051-.27136.04541-.41.05908-.2019.01953-.40442.02588-.60693.03076-.05957.001-.11744.00879-.17725.00879H108a8,8,0,0,1,0-16h28.686L94.34326,105.65723A8.00034,8.00034,0,0,1,94.34326,94.34277Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "transform": "translate(256 0) rotate(90)",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 156 156 156 156 108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "100",
      "x2": "156",
      "y2": "156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "transform": "translate(256 0) rotate(90)",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 156 156 156 156 108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "100",
      "x2": "156",
      "y2": "156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "transform": "translate(256 0) rotate(90)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 156 156 156 156 108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "100",
      "x2": "156",
      "y2": "156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1k = [];
/* style */

const __vue_inject_styles__$1k = undefined;
/* scoped */

const __vue_scope_id__$1k = undefined;
/* module identifier */

const __vue_module_identifier__$1k = undefined;
/* functional template */

const __vue_is_functional_template__$1k = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1k = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1k,
  staticRenderFns: __vue_staticRenderFns__$1k
}, __vue_inject_styles__$1k, __vue_script__$1k, __vue_scope_id__$1k, __vue_is_functional_template__$1k, __vue_module_identifier__$1k, false, undefined, undefined, undefined);

var script$1l = Vue.extend({
  name: "PhArrowSquareIn",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1l = script$1l;
/* template */

var __vue_render__$1l = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "112 204 111.992 144.008 52 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "39.9714",
      "y1": "216.0286",
      "x2": "111.9714",
      "y2": "144.0286",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160,192h48a8,8,0,0,0,8-8V48a8,8,0,0,0-8-8H72a8,8,0,0,0-8,8V96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "64",
      "y": "40",
      "width": "152",
      "height": "152",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "112 204 111.992 144.008 52 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "39.9714",
      "y1": "216.0286",
      "x2": "111.9714",
      "y2": "144.0286",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160,192h48a8,8,0,0,0,8-8V48a8,8,0,0,0-8-8H72a8,8,0,0,0-8,8V96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M119.99219,144.00684,120,203.999a8.00018,8.00018,0,0,1-13.65674,5.65821l-24.3435-24.34375L45.62793,221.68555a8.00018,8.00018,0,0,1-11.31348-11.31446L70.68579,174,46.34326,149.65723A8.00038,8.00038,0,0,1,52,136h.001l59.99218.00781A8,8,0,0,1,119.99219,144.00684ZM208,32H72A16.01833,16.01833,0,0,0,56,48V96a8,8,0,0,0,16,0V48H208V184H160a8,8,0,0,0,0,16h48a16.01833,16.01833,0,0,0,16-16V48A16.01833,16.01833,0,0,0,208,32Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "112 204 111.992 144.008 52 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "39.9714",
      "y1": "216.0286",
      "x2": "111.9714",
      "y2": "144.0286",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160,192h48a8,8,0,0,0,8-8V48a8,8,0,0,0-8-8H72a8,8,0,0,0-8,8V96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "112 204 111.992 144.008 52 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "39.9714",
      "y1": "216.0286",
      "x2": "111.9714",
      "y2": "144.0286",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160,192h48a8,8,0,0,0,8-8V48a8,8,0,0,0-8-8H72a8,8,0,0,0-8,8V96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "112 204 111.992 144.008 52 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "39.9714",
      "y1": "216.0286",
      "x2": "111.9714",
      "y2": "144.0286",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160,192h48a8,8,0,0,0,8-8V48a8,8,0,0,0-8-8H72a8,8,0,0,0-8,8V96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1l = [];
/* style */

const __vue_inject_styles__$1l = undefined;
/* scoped */

const __vue_scope_id__$1l = undefined;
/* module identifier */

const __vue_module_identifier__$1l = undefined;
/* functional template */

const __vue_is_functional_template__$1l = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1l = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1l,
  staticRenderFns: __vue_staticRenderFns__$1l
}, __vue_inject_styles__$1l, __vue_script__$1l, __vue_scope_id__$1l, __vue_is_functional_template__$1l, __vue_module_identifier__$1l, false, undefined, undefined, undefined);

var script$1m = Vue.extend({
  name: "PhArrowSquareLeft",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1m = script$1m;
/* template */

var __vue_render__$1m = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "transform": "translate(256 0) rotate(90)",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "121.941 94.059 88 128 121.941 161.941",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "128",
      "x2": "88",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "transform": "translate(256 0) rotate(90)",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "transform": "translate(256 0) rotate(90)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "121.941 94.059 88 128 121.941 161.941",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "128",
      "x2": "88",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,207.99414v-160a16.01583,16.01583,0,0,0-16-16H48a16.01583,16.01583,0,0,0-16,16v160a16.01582,16.01582,0,0,0,16,16H208A16.01582,16.01582,0,0,0,224,207.99414ZM116.28125,167.60352,82.35352,133.66016a8.02367,8.02367,0,0,1,0-11.332l33.92773-33.92773a7.99915,7.99915,0,0,1,11.3125,11.3125L107.3125,119.99414H168a8,8,0,1,1,0,16H107.30762L127.59375,156.291a7.99915,7.99915,0,0,1-11.3125,11.3125Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "transform": "translate(256 0) rotate(90)",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "121.941 94.059 88 128 121.941 161.941",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "128",
      "x2": "88",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "transform": "translate(256 0) rotate(90)",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "121.941 94.059 88 128 121.941 161.941",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "128",
      "x2": "88",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "transform": "translate(256 0) rotate(90)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "121.941 94.059 88 128 121.941 161.941",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "128",
      "x2": "88",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1m = [];
/* style */

const __vue_inject_styles__$1m = undefined;
/* scoped */

const __vue_scope_id__$1m = undefined;
/* module identifier */

const __vue_module_identifier__$1m = undefined;
/* functional template */

const __vue_is_functional_template__$1m = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1m = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1m,
  staticRenderFns: __vue_staticRenderFns__$1m
}, __vue_inject_styles__$1m, __vue_script__$1m, __vue_scope_id__$1m, __vue_is_functional_template__$1m, __vue_module_identifier__$1m, false, undefined, undefined, undefined);

var script$1n = Vue.extend({
  name: "PhArrowSquareOut",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1n = script$1n;
/* template */

var __vue_render__$1n = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "216 100 215.992 40.008 156 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "143.9714",
      "y1": "112.0286",
      "x2": "215.9714",
      "y2": "40.0286",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,144v64a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V80a8,8,0,0,1,8-8h64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "72",
      "width": "144",
      "height": "144",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "216 100 215.992 40.008 156 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "143.9714",
      "y1": "112.0286",
      "x2": "215.9714",
      "y2": "40.0286",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,144v64a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V80a8,8,0,0,1,8-8h64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,99.999a8.00053,8.00053,0,0,1-13.65723,5.65821L186,81.314l-36.37207,36.37159a8.00018,8.00018,0,1,1-11.31348-11.31446L174.68555,70,150.34277,45.65723A8.00066,8.00066,0,0,1,156,32h.001l59.99218.00781a8,8,0,0,1,7.999,7.999ZM184,136a8.00039,8.00039,0,0,0-8,8v64H48V80h64a8,8,0,0,0,0-16H48A16.01833,16.01833,0,0,0,32,80V208a16.01833,16.01833,0,0,0,16,16H176a16.01833,16.01833,0,0,0,16-16V144A8.00039,8.00039,0,0,0,184,136Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "216 100 215.992 40.008 156 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "143.9714",
      "y1": "112.0286",
      "x2": "215.9714",
      "y2": "40.0286",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,144v64a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V80a8,8,0,0,1,8-8h64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "216 100 215.992 40.008 156 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "143.9714",
      "y1": "112.0286",
      "x2": "215.9714",
      "y2": "40.0286",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,144v64a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V80a8,8,0,0,1,8-8h64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "216 100 215.992 40.008 156 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "143.9714",
      "y1": "112.0286",
      "x2": "215.9714",
      "y2": "40.0286",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,144v64a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V80a8,8,0,0,1,8-8h64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1n = [];
/* style */

const __vue_inject_styles__$1n = undefined;
/* scoped */

const __vue_scope_id__$1n = undefined;
/* module identifier */

const __vue_module_identifier__$1n = undefined;
/* functional template */

const __vue_is_functional_template__$1n = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1n = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1n,
  staticRenderFns: __vue_staticRenderFns__$1n
}, __vue_inject_styles__$1n, __vue_script__$1n, __vue_scope_id__$1n, __vue_is_functional_template__$1n, __vue_module_identifier__$1n, false, undefined, undefined, undefined);

var script$1o = Vue.extend({
  name: "PhArrowSquareRight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1o = script$1o;
/* template */

var __vue_render__$1o = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "transform": "translate(256) rotate(90)",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "134.059 94.059 168 128 134.059 161.941",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "128",
      "x2": "168",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "transform": "translate(256) rotate(90)",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "transform": "translate(256) rotate(90)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "134.059 94.059 168 128 134.059 161.941",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "128",
      "x2": "168",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M48,223.99414H208a16.01582,16.01582,0,0,0,16-16v-160a16.01583,16.01583,0,0,0-16-16H48a16.01583,16.01583,0,0,0-16,16v160A16.01582,16.01582,0,0,0,48,223.99414Zm80.40625-56.39062a7.99708,7.99708,0,0,1,0-11.3125l20.28613-20.29688H88a8,8,0,0,1,0-16h60.6875L128.40625,99.71289a7.99915,7.99915,0,0,1,11.3125-11.3125l33.92773,33.92773a8.02367,8.02367,0,0,1,0,11.332l-33.92773,33.94336A7.99708,7.99708,0,0,1,128.40625,167.60352Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "transform": "translate(256) rotate(90)",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "134.059 94.059 168 128 134.059 161.941",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "128",
      "x2": "168",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "transform": "translate(256) rotate(90)",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "134.059 94.059 168 128 134.059 161.941",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "128",
      "x2": "168",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "transform": "translate(256) rotate(90)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "134.059 94.059 168 128 134.059 161.941",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "128",
      "x2": "168",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1o = [];
/* style */

const __vue_inject_styles__$1o = undefined;
/* scoped */

const __vue_scope_id__$1o = undefined;
/* module identifier */

const __vue_module_identifier__$1o = undefined;
/* functional template */

const __vue_is_functional_template__$1o = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1o = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1o,
  staticRenderFns: __vue_staticRenderFns__$1o
}, __vue_inject_styles__$1o, __vue_script__$1o, __vue_scope_id__$1o, __vue_is_functional_template__$1o, __vue_module_identifier__$1o, false, undefined, undefined, undefined);

var script$1p = Vue.extend({
  name: "PhArrowSquareUp",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1p = script$1p;
/* template */

var __vue_render__$1p = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "94.059 121.941 128 88 161.941 121.941",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "168",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "94.059 121.941 128 88 161.941 121.941",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "168",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M223.99414,208V48a16.01582,16.01582,0,0,0-16-16h-160a16.01583,16.01583,0,0,0-16,16V208a16.01583,16.01583,0,0,0,16,16h160A16.01582,16.01582,0,0,0,223.99414,208Zm-56.39062-80.40625a7.99708,7.99708,0,0,1-11.3125,0l-20.29688-20.28613V168a8,8,0,1,1-16,0V107.3125L99.71289,127.59375a7.99915,7.99915,0,0,1-11.3125-11.3125l33.92773-33.92773a8.02367,8.02367,0,0,1,11.332,0l33.94336,33.92773A7.99708,7.99708,0,0,1,167.60352,127.59375Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "94.059 121.941 128 88 161.941 121.941",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "168",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "94.059 121.941 128 88 161.941 121.941",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "168",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "94.059 121.941 128 88 161.941 121.941",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "168",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1p = [];
/* style */

const __vue_inject_styles__$1p = undefined;
/* scoped */

const __vue_scope_id__$1p = undefined;
/* module identifier */

const __vue_module_identifier__$1p = undefined;
/* functional template */

const __vue_is_functional_template__$1p = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1p = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1p,
  staticRenderFns: __vue_staticRenderFns__$1p
}, __vue_inject_styles__$1p, __vue_script__$1p, __vue_scope_id__$1p, __vue_is_functional_template__$1p, __vue_module_identifier__$1p, false, undefined, undefined, undefined);

var script$1q = Vue.extend({
  name: "PhArrowSquareUpLeft",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1q = script$1q;
/* template */

var __vue_render__$1q = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "transform": "translate(256 0) rotate(90)",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "148 100 100 100 100 148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "156",
      "x2": "100",
      "y2": "100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "transform": "translate(256 0) rotate(90)",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "transform": "translate(256 0) rotate(90)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "148 100 100 100 100 148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "156",
      "x2": "100",
      "y2": "100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,32H48A16.01833,16.01833,0,0,0,32,48V208a16.01833,16.01833,0,0,0,16,16H208a16.01833,16.01833,0,0,0,16-16V48A16.01833,16.01833,0,0,0,208,32ZM161.65674,161.65723a8.00063,8.00063,0,0,1-11.31348,0L108,119.314V148a8,8,0,0,1-16,0V100.00244c0-.26465.01392-.5293.03992-.793.01111-.11377.03271-.22412.04858-.33642.02063-.146.038-.29248.06677-.4375.02588-.13086.06214-.2583.09449-.38721.03112-.124.05835-.24854.09545-.37158.0387-.12744.08655-.25.13123-.375.04358-.12158.08362-.24414.13318-.36377.04809-.11572.10474-.22705.158-.34033.0581-.12354.11316-.24805.178-.36914.05774-.10791.12353-.21.186-.31495.071-.11914.13867-.24023.21655-.35644.07593-.11328.16065-.22022.242-.3291.0747-.1001.14429-.20264.22436-.3003.1521-.18505.31372-.36181.48169-.53271.0166-.01709.0304-.03564.04712-.05225.01929-.01953.04077-.03515.0603-.05468.16846-.165.34253-.32422.525-.47413.09424-.07763.19372-.145.29053-.21728.1123-.084.22229-.1709.339-.249.11242-.0752.229-.14063.34423-.20948.10913-.06494.21582-.1333.32813-.19384.115-.06153.23328-.11329.35058-.16895.11963-.05664.23755-.11621.36036-.167.11071-.0459.22387-.08252.33618-.12305.13415-.04883.267-.09961.40429-.1416.1084-.03223.21851-.05615.32789-.084.14331-.03663.28515-.07666.43151-.10547.12085-.02393.2428-.03711.36451-.05567.13659-.02051.27136-.04541.41-.05908.2019-.01953.40442-.02588.60693-.03076C99.88232,92.00781,99.94019,92,100,92h48a8,8,0,0,1,0,16H119.314l42.34278,42.34277A8.00034,8.00034,0,0,1,161.65674,161.65723Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "transform": "translate(256 0) rotate(90)",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "148 100 100 100 100 148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "156",
      "x2": "100",
      "y2": "100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "transform": "translate(256 0) rotate(90)",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "148 100 100 100 100 148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "156",
      "x2": "100",
      "y2": "100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "transform": "translate(256 0) rotate(90)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "148 100 100 100 100 148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "156",
      "x2": "100",
      "y2": "100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1q = [];
/* style */

const __vue_inject_styles__$1q = undefined;
/* scoped */

const __vue_scope_id__$1q = undefined;
/* module identifier */

const __vue_module_identifier__$1q = undefined;
/* functional template */

const __vue_is_functional_template__$1q = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1q = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1q,
  staticRenderFns: __vue_staticRenderFns__$1q
}, __vue_inject_styles__$1q, __vue_script__$1q, __vue_scope_id__$1q, __vue_is_functional_template__$1q, __vue_module_identifier__$1q, false, undefined, undefined, undefined);

var script$1r = Vue.extend({
  name: "PhArrowSquareUpRight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1r = script$1r;
/* template */

var __vue_render__$1r = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "transform": "translate(0 256) rotate(-90)",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 100 156 100 156 148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "156",
      "x2": "156",
      "y2": "100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "transform": "translate(0 256) rotate(-90)",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "transform": "translate(0 256) rotate(-90)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 100 156 100 156 148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "156",
      "x2": "156",
      "y2": "100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,48V208a16.01833,16.01833,0,0,0,16,16H208a16.01833,16.01833,0,0,0,16-16V48a16.01833,16.01833,0,0,0-16-16H48A16.01833,16.01833,0,0,0,32,48ZM94.34326,150.34277,136.686,108H108a8,8,0,0,1,0-16h48c.05981,0,.11768.00781.17725.00879.20251.00488.405.01123.60693.03076.13867.01367.27344.03857.41.05908.12171.01856.24366.03174.36451.05567.14636.02881.2882.06884.43151.10547.10938.02783.21949.05175.32789.084.13732.042.27014.09277.40429.1416.11231.04053.22547.07715.33618.12305.12281.05078.24073.11035.36036.167.1173.05566.23559.10742.35058.16895.11231.06054.219.1289.32813.19384.11523.06885.23181.13428.34423.20948.1167.07812.22669.165.339.249.09681.07227.19629.13965.29053.21728.1825.14991.35657.30909.525.47413.01953.01953.041.03515.0603.05468.01672.01661.03052.03516.04712.05225.168.1709.32959.34766.48169.53271.08007.09766.14966.2002.22436.3003.0813.10888.166.21582.242.3291.07788.11621.1455.2373.21655.35644.0625.105.12829.207.186.31495.06482.12109.11988.2456.178.36914.05322.11328.10987.22461.158.34033.04956.11963.0896.24219.13318.36377.04468.125.09253.24756.13123.375.0371.123.06433.24756.09545.37158.03235.12891.06861.25635.09449.38721.02881.145.04614.2915.06677.4375.01587.1123.03747.22265.04858.33642.026.26367.03992.52832.03992.793V148a8,8,0,0,1-16,0V119.314l-42.34326,42.34327a8.00018,8.00018,0,0,1-11.31348-11.31446Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "transform": "translate(0 256) rotate(-90)",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 100 156 100 156 148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "156",
      "x2": "156",
      "y2": "100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "transform": "translate(0 256) rotate(-90)",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 100 156 100 156 148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "156",
      "x2": "156",
      "y2": "100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "transform": "translate(0 256) rotate(-90)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 100 156 100 156 148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "156",
      "x2": "156",
      "y2": "100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1r = [];
/* style */

const __vue_inject_styles__$1r = undefined;
/* scoped */

const __vue_scope_id__$1r = undefined;
/* module identifier */

const __vue_module_identifier__$1r = undefined;
/* functional template */

const __vue_is_functional_template__$1r = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1r = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1r,
  staticRenderFns: __vue_staticRenderFns__$1r
}, __vue_inject_styles__$1r, __vue_script__$1r, __vue_scope_id__$1r, __vue_is_functional_template__$1r, __vue_module_identifier__$1r, false, undefined, undefined, undefined);

var script$1s = Vue.extend({
  name: "PhArrowUDownLeft",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1s = script$1s;
/* template */

var __vue_render__$1s = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 120 32 168 80 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,56h88a56,56,0,0,1,56,56v.00011A55.99988,55.99988,0,0,1,168.00011,168H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 120 32 168 80 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,56h88a56,56,0,0,1,56,56v.00011A55.99988,55.99988,0,0,1,168.00011,168H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232,112a64.07207,64.07207,0,0,1-64,64H88v40a8.00018,8.00018,0,0,1-13.65723,5.65674l-48-48a8,8,0,0,1,0-11.31348l48-48A8.0001,8.0001,0,0,1,88,120v40h80a48,48,0,0,0,0-96H80a8,8,0,0,1,0-16h88A64.07207,64.07207,0,0,1,232,112Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 120 32 168 80 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,56h88a56,56,0,0,1,56,56v.00011A55.99988,55.99988,0,0,1,168.00011,168H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 120 32 168 80 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,56h88a56,56,0,0,1,56,56v.00011A55.99988,55.99988,0,0,1,168.00011,168H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 120 32 168 80 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,56h88a56,56,0,0,1,56,56v.00011A55.99988,55.99988,0,0,1,168.00011,168H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1s = [];
/* style */

const __vue_inject_styles__$1s = undefined;
/* scoped */

const __vue_scope_id__$1s = undefined;
/* module identifier */

const __vue_module_identifier__$1s = undefined;
/* functional template */

const __vue_is_functional_template__$1s = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1s = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1s,
  staticRenderFns: __vue_staticRenderFns__$1s
}, __vue_inject_styles__$1s, __vue_script__$1s, __vue_scope_id__$1s, __vue_is_functional_template__$1s, __vue_module_identifier__$1s, false, undefined, undefined, undefined);

var script$1t = Vue.extend({
  name: "PhArrowUDownRight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1t = script$1t;
/* template */

var __vue_render__$1t = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 120 224 168 176 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,56H88a56,56,0,0,0-56,56v.00011A55.99988,55.99988,0,0,0,87.99989,168H224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 120 224 168 176 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,56H88a56,56,0,0,0-56,56v.00011A55.99988,55.99988,0,0,0,87.99989,168H224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M229.65723,173.65674l-48,48A8.0001,8.0001,0,0,1,168,216V176H88A64,64,0,0,1,88,48h88a8,8,0,0,1,0,16H88a48,48,0,0,0,0,96h80V120a8.0001,8.0001,0,0,1,13.65723-5.65674l48,48A8,8,0,0,1,229.65723,173.65674Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 120 224 168 176 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,56H88a56,56,0,0,0-56,56v.00011A55.99988,55.99988,0,0,0,87.99989,168H224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 120 224 168 176 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,56H88a56,56,0,0,0-56,56v.00011A55.99988,55.99988,0,0,0,87.99989,168H224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 120 224 168 176 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,56H88a56,56,0,0,0-56,56v.00011A55.99988,55.99988,0,0,0,87.99989,168H224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1t = [];
/* style */

const __vue_inject_styles__$1t = undefined;
/* scoped */

const __vue_scope_id__$1t = undefined;
/* module identifier */

const __vue_module_identifier__$1t = undefined;
/* functional template */

const __vue_is_functional_template__$1t = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1t = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1t,
  staticRenderFns: __vue_staticRenderFns__$1t
}, __vue_inject_styles__$1t, __vue_script__$1t, __vue_scope_id__$1t, __vue_is_functional_template__$1t, __vue_module_identifier__$1t, false, undefined, undefined, undefined);

var script$1u = Vue.extend({
  name: "PhArrowULeftDown",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1u = script$1u;
/* template */

var __vue_render__$1u = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "136 176 88 224 40 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,176V88a56,56,0,0,0-56-56h-.00011A55.99988,55.99988,0,0,0,88,87.99989V224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "136 176 88 224 40 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,176V88a56,56,0,0,0-56-56h-.00011A55.99988,55.99988,0,0,0,88,87.99989V224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,88v88a8,8,0,0,1-16,0V88a48,48,0,0,0-96,0v80h40a8.00038,8.00038,0,0,1,5.65723,13.65674l-48,48a8.00063,8.00063,0,0,1-11.31446,0l-48-48A8.00037,8.00037,0,0,1,40,168H80V88a64,64,0,0,1,128,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "136 176 88 224 40 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,176V88a56,56,0,0,0-56-56h-.00011A55.99988,55.99988,0,0,0,88,87.99989V224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "136 176 88 224 40 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,176V88a56,56,0,0,0-56-56h-.00011A55.99988,55.99988,0,0,0,88,87.99989V224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "136 176 88 224 40 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,176V88a56,56,0,0,0-56-56h-.00011A55.99988,55.99988,0,0,0,88,87.99989V224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1u = [];
/* style */

const __vue_inject_styles__$1u = undefined;
/* scoped */

const __vue_scope_id__$1u = undefined;
/* module identifier */

const __vue_module_identifier__$1u = undefined;
/* functional template */

const __vue_is_functional_template__$1u = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1u = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1u,
  staticRenderFns: __vue_staticRenderFns__$1u
}, __vue_inject_styles__$1u, __vue_script__$1u, __vue_scope_id__$1u, __vue_is_functional_template__$1u, __vue_module_identifier__$1u, false, undefined, undefined, undefined);

var script$1v = Vue.extend({
  name: "PhArrowULeftUp",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1v = script$1v;
/* template */

var __vue_render__$1v = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "136 80 88 32 40 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,80v88a56,56,0,0,1-56,56h-.00011A55.99988,55.99988,0,0,1,88,168.00011V32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "136 80 88 32 40 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,80v88a56,56,0,0,1-56,56h-.00011A55.99988,55.99988,0,0,1,88,168.00011V32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,80v88a64,64,0,0,1-128,0V88H40a8.00037,8.00037,0,0,1-5.65723-13.65674l48-48a8.00122,8.00122,0,0,1,11.31446,0l48,48A8.00038,8.00038,0,0,1,136,88H96v80a48,48,0,0,0,96,0V80a8,8,0,0,1,16,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "136 80 88 32 40 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,80v88a56,56,0,0,1-56,56h-.00011A55.99988,55.99988,0,0,1,88,168.00011V32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "136 80 88 32 40 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,80v88a56,56,0,0,1-56,56h-.00011A55.99988,55.99988,0,0,1,88,168.00011V32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "136 80 88 32 40 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,80v88a56,56,0,0,1-56,56h-.00011A55.99988,55.99988,0,0,1,88,168.00011V32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1v = [];
/* style */

const __vue_inject_styles__$1v = undefined;
/* scoped */

const __vue_scope_id__$1v = undefined;
/* module identifier */

const __vue_module_identifier__$1v = undefined;
/* functional template */

const __vue_is_functional_template__$1v = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1v = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1v,
  staticRenderFns: __vue_staticRenderFns__$1v
}, __vue_inject_styles__$1v, __vue_script__$1v, __vue_scope_id__$1v, __vue_is_functional_template__$1v, __vue_module_identifier__$1v, false, undefined, undefined, undefined);

var script$1w = Vue.extend({
  name: "PhArrowURightDown",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1w = script$1w;
/* template */

var __vue_render__$1w = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "120 176 168 224 216 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,176V88a56,56,0,0,1,56-56h.00011A55.99988,55.99988,0,0,1,168,87.99989V224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "120 176 168 224 216 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,176V88a56,56,0,0,1,56-56h.00011A55.99988,55.99988,0,0,1,168,87.99989V224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M221.65723,181.65674l-48,48a8.00063,8.00063,0,0,1-11.31446,0l-48-48A8.00037,8.00037,0,0,1,120,168h40V88a48,48,0,0,0-96,0v88a8,8,0,0,1-16,0V88a64,64,0,0,1,128,0v80h40a8.00038,8.00038,0,0,1,5.65723,13.65674Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "120 176 168 224 216 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,176V88a56,56,0,0,1,56-56h.00011A55.99988,55.99988,0,0,1,168,87.99989V224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "120 176 168 224 216 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,176V88a56,56,0,0,1,56-56h.00011A55.99988,55.99988,0,0,1,168,87.99989V224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "120 176 168 224 216 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,176V88a56,56,0,0,1,56-56h.00011A55.99988,55.99988,0,0,1,168,87.99989V224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1w = [];
/* style */

const __vue_inject_styles__$1w = undefined;
/* scoped */

const __vue_scope_id__$1w = undefined;
/* module identifier */

const __vue_module_identifier__$1w = undefined;
/* functional template */

const __vue_is_functional_template__$1w = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1w = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1w,
  staticRenderFns: __vue_staticRenderFns__$1w
}, __vue_inject_styles__$1w, __vue_script__$1w, __vue_scope_id__$1w, __vue_is_functional_template__$1w, __vue_module_identifier__$1w, false, undefined, undefined, undefined);

var script$1x = Vue.extend({
  name: "PhArrowURightUp",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1x = script$1x;
/* template */

var __vue_render__$1x = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "120 80 168 32 216 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,80v88a56,56,0,0,0,56,56h.00011A55.99988,55.99988,0,0,0,168,168.00011V32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "120 80 168 32 216 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,80v88a56,56,0,0,0,56,56h.00011A55.99988,55.99988,0,0,0,168,168.00011V32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M223.39062,83.06152A8,8,0,0,1,216,88H176v80a64,64,0,0,1-128,0V80a8,8,0,0,1,16,0v88a48,48,0,0,0,96,0V88H120a8.00037,8.00037,0,0,1-5.65723-13.65674l48-48a8.00034,8.00034,0,0,1,11.31446,0l48,48A7.99931,7.99931,0,0,1,223.39062,83.06152Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "120 80 168 32 216 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,80v88a56,56,0,0,0,56,56h.00011A55.99988,55.99988,0,0,0,168,168.00011V32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "120 80 168 32 216 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,80v88a56,56,0,0,0,56,56h.00011A55.99988,55.99988,0,0,0,168,168.00011V32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "120 80 168 32 216 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,80v88a56,56,0,0,0,56,56h.00011A55.99988,55.99988,0,0,0,168,168.00011V32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1x = [];
/* style */

const __vue_inject_styles__$1x = undefined;
/* scoped */

const __vue_scope_id__$1x = undefined;
/* module identifier */

const __vue_module_identifier__$1x = undefined;
/* functional template */

const __vue_is_functional_template__$1x = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1x = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1x,
  staticRenderFns: __vue_staticRenderFns__$1x
}, __vue_inject_styles__$1x, __vue_script__$1x, __vue_scope_id__$1x, __vue_is_functional_template__$1x, __vue_module_identifier__$1x, false, undefined, undefined, undefined);

var script$1y = Vue.extend({
  name: "PhArrowUUpLeft",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1y = script$1y;
/* template */

var __vue_render__$1y = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 136 32 88 80 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,200h88a56,56,0,0,0,56-56v-.00011A55.99988,55.99988,0,0,0,168.00011,88H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 136 32 88 80 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,200h88a56,56,0,0,0,56-56v-.00011A55.99988,55.99988,0,0,0,168.00011,88H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232,144a64.07239,64.07239,0,0,1-64,64H80a8,8,0,0,1,0-16h88a48,48,0,0,0,0-96H88v40a8.00018,8.00018,0,0,1-13.65723,5.65674l-48-48a8,8,0,0,1,0-11.31348l48-48A8.0001,8.0001,0,0,1,88,40V80h80A64.07207,64.07207,0,0,1,232,144Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 136 32 88 80 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,200h88a56,56,0,0,0,56-56v-.00011A55.99988,55.99988,0,0,0,168.00011,88H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 136 32 88 80 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,200h88a56,56,0,0,0,56-56v-.00011A55.99988,55.99988,0,0,0,168.00011,88H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 136 32 88 80 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,200h88a56,56,0,0,0,56-56v-.00011A55.99988,55.99988,0,0,0,168.00011,88H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1y = [];
/* style */

const __vue_inject_styles__$1y = undefined;
/* scoped */

const __vue_scope_id__$1y = undefined;
/* module identifier */

const __vue_module_identifier__$1y = undefined;
/* functional template */

const __vue_is_functional_template__$1y = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1y = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1y,
  staticRenderFns: __vue_staticRenderFns__$1y
}, __vue_inject_styles__$1y, __vue_script__$1y, __vue_scope_id__$1y, __vue_is_functional_template__$1y, __vue_module_identifier__$1y, false, undefined, undefined, undefined);

var script$1z = Vue.extend({
  name: "PhArrowUUpRight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1z = script$1z;
/* template */

var __vue_render__$1z = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 136 224 88 176 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,200H88a56,56,0,0,1-56-56v-.00011A55.99988,55.99988,0,0,1,87.99989,88H224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 136 224 88 176 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,200H88a56,56,0,0,1-56-56v-.00011A55.99988,55.99988,0,0,1,87.99989,88H224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M168,136V96H88a48,48,0,0,0,0,96h88a8,8,0,0,1,0,16H88A64,64,0,0,1,88,80h80V40a8.0001,8.0001,0,0,1,13.65723-5.65674l48,48a8,8,0,0,1,0,11.31348l-48,48A8.0001,8.0001,0,0,1,168,136Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 136 224 88 176 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,200H88a56,56,0,0,1-56-56v-.00011A55.99988,55.99988,0,0,1,87.99989,88H224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 136 224 88 176 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,200H88a56,56,0,0,1-56-56v-.00011A55.99988,55.99988,0,0,1,87.99989,88H224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 136 224 88 176 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,200H88a56,56,0,0,1-56-56v-.00011A55.99988,55.99988,0,0,1,87.99989,88H224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1z = [];
/* style */

const __vue_inject_styles__$1z = undefined;
/* scoped */

const __vue_scope_id__$1z = undefined;
/* module identifier */

const __vue_module_identifier__$1z = undefined;
/* functional template */

const __vue_is_functional_template__$1z = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1z = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1z,
  staticRenderFns: __vue_staticRenderFns__$1z
}, __vue_inject_styles__$1z, __vue_script__$1z, __vue_scope_id__$1z, __vue_is_functional_template__$1z, __vue_module_identifier__$1z, false, undefined, undefined, undefined);

var script$1A = Vue.extend({
  name: "PhArrowUp",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1A = script$1A;
/* template */

var __vue_render__$1A = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "216",
      "x2": "128",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "56 112 128 40 200 112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "216",
      "x2": "128",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "56 112 128 40 200 112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M207.39111,115.06152A8.00065,8.00065,0,0,1,200,120H136v96a8,8,0,0,1-16,0V120H56a8.0001,8.0001,0,0,1-5.65674-13.65723l72-72a8.00182,8.00182,0,0,1,11.31348,0l72,72A8.00148,8.00148,0,0,1,207.39111,115.06152Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "216",
      "x2": "128",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "56 112 128 40 200 112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "216",
      "x2": "128",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "56 112 128 40 200 112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "216",
      "x2": "128",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "56 112 128 40 200 112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1A = [];
/* style */

const __vue_inject_styles__$1A = undefined;
/* scoped */

const __vue_scope_id__$1A = undefined;
/* module identifier */

const __vue_module_identifier__$1A = undefined;
/* functional template */

const __vue_is_functional_template__$1A = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1A = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1A,
  staticRenderFns: __vue_staticRenderFns__$1A
}, __vue_inject_styles__$1A, __vue_script__$1A, __vue_scope_id__$1A, __vue_is_functional_template__$1A, __vue_module_identifier__$1A, false, undefined, undefined, undefined);

var script$1B = Vue.extend({
  name: "PhArrowUpLeft",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1B = script$1B;
/* template */

var __vue_render__$1B = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "192",
      "y1": "192",
      "x2": "64",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "168 64 64 64 64 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "192",
      "y1": "192",
      "x2": "64",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "168 64 64 64 64 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M197.65674,197.65723a8.00063,8.00063,0,0,1-11.31348,0L116,127.314,69.65723,173.65723A8.00066,8.00066,0,0,1,56,168V64a8.00039,8.00039,0,0,1,8-8H168a8.00038,8.00038,0,0,1,5.65723,13.65723L127.314,116l70.34278,70.34277A8.00034,8.00034,0,0,1,197.65674,197.65723Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "192",
      "y1": "192",
      "x2": "64",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "168 64 64 64 64 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "192",
      "y1": "192",
      "x2": "64",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "168 64 64 64 64 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "192",
      "y1": "192",
      "x2": "64",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "168 64 64 64 64 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1B = [];
/* style */

const __vue_inject_styles__$1B = undefined;
/* scoped */

const __vue_scope_id__$1B = undefined;
/* module identifier */

const __vue_module_identifier__$1B = undefined;
/* functional template */

const __vue_is_functional_template__$1B = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1B = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1B,
  staticRenderFns: __vue_staticRenderFns__$1B
}, __vue_inject_styles__$1B, __vue_script__$1B, __vue_scope_id__$1B, __vue_is_functional_template__$1B, __vue_module_identifier__$1B, false, undefined, undefined, undefined);

var script$1C = Vue.extend({
  name: "PhArrowUpRight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1C = script$1C;
/* template */

var __vue_render__$1C = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "64",
      "y1": "192",
      "x2": "192",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "88 64 192 64 192 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "64",
      "y1": "192",
      "x2": "192",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "88 64 192 64 192 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,64V168a8.00053,8.00053,0,0,1-13.65723,5.65723L140,127.314,69.65674,197.65723a8.00018,8.00018,0,0,1-11.31348-11.31446L128.686,116,82.34277,69.65723A8.00038,8.00038,0,0,1,88,56H192A8.00039,8.00039,0,0,1,200,64Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "64",
      "y1": "192",
      "x2": "192",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "88 64 192 64 192 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "64",
      "y1": "192",
      "x2": "192",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "88 64 192 64 192 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "64",
      "y1": "192",
      "x2": "192",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "88 64 192 64 192 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1C = [];
/* style */

const __vue_inject_styles__$1C = undefined;
/* scoped */

const __vue_scope_id__$1C = undefined;
/* module identifier */

const __vue_module_identifier__$1C = undefined;
/* functional template */

const __vue_is_functional_template__$1C = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1C = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1C,
  staticRenderFns: __vue_staticRenderFns__$1C
}, __vue_inject_styles__$1C, __vue_script__$1C, __vue_scope_id__$1C, __vue_is_functional_template__$1C, __vue_module_identifier__$1C, false, undefined, undefined, undefined);

var script$1D = Vue.extend({
  name: "PhArrowsClockwise",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1D = script$1D;
/* template */

var __vue_render__$1D = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176.167 99.716 224.167 99.716 224.167 51.716",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M65.7746,65.7746a88,88,0,0,1,124.4508,0l33.94112,33.94113",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "79.833 156.284 31.833 156.284 31.833 204.284",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M190.2254,190.2254a88,88,0,0,1-124.4508,0L31.83348,156.28427",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176.167 99.716 224.167 99.716 224.167 51.716",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M65.7746,65.7746a88,88,0,0,1,124.4508,0l33.94112,33.94113",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "79.833 156.284 31.833 156.284 31.833 204.284",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M190.2254,190.2254a88,88,0,0,1-124.4508,0L31.83348,156.28427",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232.167,51.71582v48a8.00039,8.00039,0,0,1-8,8h-48a8.00065,8.00065,0,0,1-5.65722-13.65723l18.34277-18.34277-4.28418-4.28418a80.08769,80.08769,0,0,0-113.13672,0A8.00052,8.00052,0,0,1,60.11719,60.11719a96.11137,96.11137,0,0,1,135.76562,0l4.28418,4.28418,18.34278-18.34278A8.00065,8.00065,0,0,1,232.167,51.71582ZM184.56836,184.56836a80.08769,80.08769,0,0,1-113.13672,0l-4.28418-4.28418,18.34277-18.34277A8.00065,8.00065,0,0,0,79.833,148.28418h-48a8.00039,8.00039,0,0,0-8,8v48a8.00052,8.00052,0,0,0,13.65722,5.65723L55.833,191.59863l4.28418,4.28418a96.11136,96.11136,0,0,0,135.76562,0,8.00052,8.00052,0,0,0-11.31445-11.31445Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176.167 99.716 224.167 99.716 224.167 51.716",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M65.7746,65.7746a88,88,0,0,1,124.4508,0l33.94112,33.94113",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "79.833 156.284 31.833 156.284 31.833 204.284",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M190.2254,190.2254a88,88,0,0,1-124.4508,0L31.83348,156.28427",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176.167 99.716 224.167 99.716 224.167 51.716",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M65.7746,65.7746a88,88,0,0,1,124.4508,0l33.94112,33.94113",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "79.833 156.284 31.833 156.284 31.833 204.284",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M190.2254,190.2254a88,88,0,0,1-124.4508,0L31.83348,156.28427",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176.167 99.716 224.167 99.716 224.167 51.716",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M65.7746,65.7746a88,88,0,0,1,124.4508,0l33.94112,33.94113",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "79.833 156.284 31.833 156.284 31.833 204.284",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M190.2254,190.2254a88,88,0,0,1-124.4508,0L31.83348,156.28427",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1D = [];
/* style */

const __vue_inject_styles__$1D = undefined;
/* scoped */

const __vue_scope_id__$1D = undefined;
/* module identifier */

const __vue_module_identifier__$1D = undefined;
/* functional template */

const __vue_is_functional_template__$1D = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1D = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1D,
  staticRenderFns: __vue_staticRenderFns__$1D
}, __vue_inject_styles__$1D, __vue_script__$1D, __vue_scope_id__$1D, __vue_is_functional_template__$1D, __vue_module_identifier__$1D, false, undefined, undefined, undefined);

var script$1E = Vue.extend({
  name: "PhArrowsCounterClockwise",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1E = script$1E;
/* template */

var __vue_render__$1E = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "79.833 99.716 31.833 99.716 31.833 51.716",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M190.2254,65.7746a88,88,0,0,0-124.4508,0L31.83348,99.71573",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176.167 156.284 224.167 156.284 224.167 204.284",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M65.7746,190.2254a88,88,0,0,0,124.4508,0l33.94112-33.94113",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "79.833 99.716 31.833 99.716 31.833 51.716",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M190.2254,65.7746a88,88,0,0,0-124.4508,0L31.83348,99.71573",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176.167 156.284 224.167 156.284 224.167 204.284",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M65.7746,190.2254a88,88,0,0,0,124.4508,0l33.94112-33.94113",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M79.833,107.71582h-48a8.00008,8.00008,0,0,1-8-8v-48a8.00009,8.00009,0,0,1,13.65722-5.65674L55.833,64.40186l4.28418-4.28418a96.10959,96.10959,0,0,1,135.76562,0,8.00018,8.00018,0,1,1-11.31445,11.31347,80.09125,80.09125,0,0,0-113.13672,0L67.147,75.71582,85.49023,94.05908A8.00037,8.00037,0,0,1,79.833,107.71582Zm144.334,40.56836h-48a8.00037,8.00037,0,0,0-5.65722,13.65674L188.853,180.28418l-4.28467,4.28467a80.09125,80.09125,0,0,1-113.13672,0,8.00018,8.00018,0,0,0-11.31445,11.31347,96.11017,96.11017,0,0,0,135.76562,0l4.28418-4.28418,18.34278,18.34278a8.00009,8.00009,0,0,0,13.65722-5.65674v-48A8.00008,8.00008,0,0,0,224.167,148.28418Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "79.833 99.716 31.833 99.716 31.833 51.716",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M190.2254,65.7746a88,88,0,0,0-124.4508,0L31.83348,99.71573",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176.167 156.284 224.167 156.284 224.167 204.284",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M65.7746,190.2254a88,88,0,0,0,124.4508,0l33.94112-33.94113",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "79.833 99.716 31.833 99.716 31.833 51.716",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M190.2254,65.7746a88,88,0,0,0-124.4508,0L31.83348,99.71573",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176.167 156.284 224.167 156.284 224.167 204.284",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M65.7746,190.2254a88,88,0,0,0,124.4508,0l33.94112-33.94113",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "79.833 99.716 31.833 99.716 31.833 51.716",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M190.2254,65.7746a88,88,0,0,0-124.4508,0L31.83348,99.71573",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176.167 156.284 224.167 156.284 224.167 204.284",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M65.7746,190.2254a88,88,0,0,0,124.4508,0l33.94112-33.94113",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1E = [];
/* style */

const __vue_inject_styles__$1E = undefined;
/* scoped */

const __vue_scope_id__$1E = undefined;
/* module identifier */

const __vue_module_identifier__$1E = undefined;
/* functional template */

const __vue_is_functional_template__$1E = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1E = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1E,
  staticRenderFns: __vue_staticRenderFns__$1E
}, __vue_inject_styles__$1E, __vue_script__$1E, __vue_scope_id__$1E, __vue_is_functional_template__$1E, __vue_module_identifier__$1E, false, undefined, undefined, undefined);

var script$1F = Vue.extend({
  name: "PhArrowsDownUp",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1F = script$1F;
/* template */

var __vue_render__$1F = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "112 176 80 208 48 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "48",
      "x2": "80",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 80 176 48 208 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "208.00006",
      "x2": "176",
      "y2": "48.00006",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "112 176 80 208 48 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "48",
      "x2": "80",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 80 176 48 208 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "208.00006",
      "x2": "176",
      "y2": "48.00006",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M119.39062,172.93848a8.00028,8.00028,0,0,1-1.73339,8.71875l-32,32a8.00181,8.00181,0,0,1-11.31446,0l-32-32A8.00065,8.00065,0,0,1,48,168H72V48a8,8,0,0,1,16,0V168h24A8,8,0,0,1,119.39062,172.93848Zm94.26661-98.59571-32-32a8.00122,8.00122,0,0,0-11.31446,0l-32,32A8.00065,8.00065,0,0,0,144,88h24V208a8,8,0,0,0,16,0V88h24a8.00066,8.00066,0,0,0,5.65723-13.65723Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "112 176 80 208 48 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "48",
      "x2": "80",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 80 176 48 208 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "208.00006",
      "x2": "176",
      "y2": "48.00006",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "112 176 80 208 48 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "48",
      "x2": "80",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 80 176 48 208 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "208.00006",
      "x2": "176",
      "y2": "48.00006",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "112 176 80 208 48 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "48",
      "x2": "80",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 80 176 48 208 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "208.00006",
      "x2": "176",
      "y2": "48.00006",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1F = [];
/* style */

const __vue_inject_styles__$1F = undefined;
/* scoped */

const __vue_scope_id__$1F = undefined;
/* module identifier */

const __vue_module_identifier__$1F = undefined;
/* functional template */

const __vue_is_functional_template__$1F = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1F = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1F,
  staticRenderFns: __vue_staticRenderFns__$1F
}, __vue_inject_styles__$1F, __vue_script__$1F, __vue_scope_id__$1F, __vue_is_functional_template__$1F, __vue_module_identifier__$1F, false, undefined, undefined, undefined);

var script$1G = Vue.extend({
  name: "PhArrowsIn",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1G = script$1G;
/* template */

var __vue_render__$1G = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "192 104 152 104 152 64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "48",
      "x2": "152",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 152 104 152 104 192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "208",
      "x2": "104",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 192 152 152 192 152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "208",
      "x2": "152",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "104 64 104 104 64 104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "48",
      "x2": "104",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "192 104 152 104 152 64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "48",
      "x2": "152",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 152 104 152 104 192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "208",
      "x2": "104",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 192 152 152 192 152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "208",
      "x2": "152",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "104 64 104 104 64 104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "48",
      "x2": "104",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M144,104V64a8.0001,8.0001,0,0,1,13.65723-5.65674L172,72.686l30.34277-30.34278a8.00018,8.00018,0,0,1,11.31446,11.31348L183.314,84l14.34327,14.34326A8.00038,8.00038,0,0,1,192,112H152A8.00008,8.00008,0,0,1,144,104Zm-40,40H64a8.00038,8.00038,0,0,0-5.65723,13.65674L72.686,172,42.34277,202.34277a8.00053,8.00053,0,0,0,11.31446,11.31446L84,183.31421l14.34277,14.343A8.00066,8.00066,0,0,0,112,192V152A8.00008,8.00008,0,0,0,104,144Zm79.314,28,14.34327-14.34326A8.00038,8.00038,0,0,0,192,144H152a8.00008,8.00008,0,0,0-8,8v40a8.00053,8.00053,0,0,0,13.65723,5.65723L172,183.31421l30.34277,30.343a8.00053,8.00053,0,0,0,11.31446-11.31446ZM107.06152,56.60889a7.9999,7.9999,0,0,0-8.71875,1.73437L84,72.686,53.65723,42.34326A8.00018,8.00018,0,1,0,42.34277,53.65674L72.686,84,58.34277,98.34326A8.00038,8.00038,0,0,0,64,112h40a8.00008,8.00008,0,0,0,8-8V64A8.00015,8.00015,0,0,0,107.06152,56.60889Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "192 104 152 104 152 64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "48",
      "x2": "152",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 152 104 152 104 192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "208",
      "x2": "104",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 192 152 152 192 152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "208",
      "x2": "152",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "104 64 104 104 64 104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "48",
      "x2": "104",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "192 104 152 104 152 64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "48",
      "x2": "152",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 152 104 152 104 192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "208",
      "x2": "104",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 192 152 152 192 152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "208",
      "x2": "152",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "104 64 104 104 64 104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "48",
      "x2": "104",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "192 104 152 104 152 64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "48",
      "x2": "152",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 152 104 152 104 192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "208",
      "x2": "104",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 192 152 152 192 152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "208",
      "x2": "152",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "104 64 104 104 64 104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "48",
      "x2": "104",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1G = [];
/* style */

const __vue_inject_styles__$1G = undefined;
/* scoped */

const __vue_scope_id__$1G = undefined;
/* module identifier */

const __vue_module_identifier__$1G = undefined;
/* functional template */

const __vue_is_functional_template__$1G = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1G = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1G,
  staticRenderFns: __vue_staticRenderFns__$1G
}, __vue_inject_styles__$1G, __vue_script__$1G, __vue_scope_id__$1G, __vue_is_functional_template__$1G, __vue_module_identifier__$1G, false, undefined, undefined, undefined);

var script$1H = Vue.extend({
  name: "PhArrowsInCardinal",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1H = script$1H;
/* template */

var __vue_render__$1H = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "156.284 188.284 128 160 99.716 188.284",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "232",
      "x2": "128",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "99.716 67.716 128 96 156.284 67.716",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "24",
      "x2": "128",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "67.716 156.284 96 128 67.716 99.716",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "128",
      "x2": "96",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "188.284 99.716 160 128 188.284 156.284",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "128",
      "x2": "160",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "156.284 188.284 128 160 99.716 188.284",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "232",
      "x2": "128",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "99.716 67.716 128 96 156.284 67.716",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "24",
      "x2": "128",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "67.716 156.284 96 128 67.716 99.716",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "128",
      "x2": "96",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "188.284 99.716 160 128 188.284 156.284",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "128",
      "x2": "160",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M161.94141,182.627a8.00066,8.00066,0,0,1-5.65723,13.65723H136V232a8,8,0,0,1-16,0V196.28418H99.71582A8.00066,8.00066,0,0,1,94.05859,182.627l28.28418-28.28418a8.003,8.003,0,0,1,11.31446,0Zm-39.59864-80.96972a8.00181,8.00181,0,0,0,11.31446,0l28.28418-28.28418a8.00066,8.00066,0,0,0-5.65723-13.65723H136V24a8,8,0,0,0-16,0V59.71582H99.71582a8.00066,8.00066,0,0,0-5.65723,13.65723Zm-20.68554,20.68554L73.37305,94.05859a8.00066,8.00066,0,0,0-13.65723,5.65723V120H24a8,8,0,0,0,0,16H59.71582v20.28418a8.00053,8.00053,0,0,0,13.65723,5.65723l28.28418-28.28418A8.00122,8.00122,0,0,0,101.65723,122.34277ZM232,120H196.28418V99.71582A8.00066,8.00066,0,0,0,182.627,94.05859l-28.28418,28.28418a8.00122,8.00122,0,0,0,0,11.31446L182.627,161.94141a8.00066,8.00066,0,0,0,13.65723-5.65723V136H232a8,8,0,0,0,0-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "156.284 188.284 128 160 99.716 188.284",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "232",
      "x2": "128",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "99.716 67.716 128 96 156.284 67.716",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "24",
      "x2": "128",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "67.716 156.284 96 128 67.716 99.716",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "128",
      "x2": "96",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "188.284 99.716 160 128 188.284 156.284",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "128",
      "x2": "160",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "156.284 188.284 128 160 99.716 188.284",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "232",
      "x2": "128",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "99.716 67.716 128 96 156.284 67.716",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "24",
      "x2": "128",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "67.716 156.284 96 128 67.716 99.716",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "128",
      "x2": "96",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "188.284 99.716 160 128 188.284 156.284",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "128",
      "x2": "160",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "156.284 188.284 128 160 99.716 188.284",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "232",
      "x2": "128",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "99.716 67.716 128 96 156.284 67.716",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "24",
      "x2": "128",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "67.716 156.284 96 128 67.716 99.716",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "128",
      "x2": "96",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "188.284 99.716 160 128 188.284 156.284",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "128",
      "x2": "160",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1H = [];
/* style */

const __vue_inject_styles__$1H = undefined;
/* scoped */

const __vue_scope_id__$1H = undefined;
/* module identifier */

const __vue_module_identifier__$1H = undefined;
/* functional template */

const __vue_is_functional_template__$1H = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1H = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1H,
  staticRenderFns: __vue_staticRenderFns__$1H
}, __vue_inject_styles__$1H, __vue_script__$1H, __vue_scope_id__$1H, __vue_is_functional_template__$1H, __vue_module_identifier__$1H, false, undefined, undefined, undefined);

var script$1I = Vue.extend({
  name: "PhArrowsInLineHorizontal",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1I = script$1I;
/* template */

var __vue_render__$1I = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "128",
      "x2": "88",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "56 96 88 128 56 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "244",
      "y1": "128",
      "x2": "168",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "200 160 168 128 200 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "128",
      "x2": "96",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 96 96 128 64 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "240",
      "y1": "128",
      "x2": "160",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192 160 160 128 192 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M136,40V216a8,8,0,0,1-16,0V40a8,8,0,0,1,16,0ZM69.65723,90.34277A8.00066,8.00066,0,0,0,56,96v24H16a8,8,0,0,0,0,16H56v24a8.00053,8.00053,0,0,0,13.65723,5.65723l32-32a8.00122,8.00122,0,0,0,0-11.31446ZM240,120H200V96a8.00066,8.00066,0,0,0-13.65723-5.65723l-32,32a8.00122,8.00122,0,0,0,0,11.31446l32,32A8.00066,8.00066,0,0,0,200,160V136h40a8,8,0,0,0,0-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "128",
      "x2": "96",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 96 96 128 64 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "240",
      "y1": "128",
      "x2": "160",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192 160 160 128 192 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "128",
      "x2": "96",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 96 96 128 64 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "240",
      "y1": "128",
      "x2": "160",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192 160 160 128 192 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "128",
      "x2": "96",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 96 96 128 64 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "240",
      "y1": "128",
      "x2": "160",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192 160 160 128 192 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1I = [];
/* style */

const __vue_inject_styles__$1I = undefined;
/* scoped */

const __vue_scope_id__$1I = undefined;
/* module identifier */

const __vue_module_identifier__$1I = undefined;
/* functional template */

const __vue_is_functional_template__$1I = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1I = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1I,
  staticRenderFns: __vue_staticRenderFns__$1I
}, __vue_inject_styles__$1I, __vue_script__$1I, __vue_scope_id__$1I, __vue_is_functional_template__$1I, __vue_module_identifier__$1I, false, undefined, undefined, undefined);

var script$1J = Vue.extend({
  name: "PhArrowsInLineVertical",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1J = script$1J;
/* template */

var __vue_render__$1J = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "216",
      "y1": "128",
      "x2": "40",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "12",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 56 128 88 96 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "244",
      "x2": "128",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 200 128 168 160 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "216",
      "y1": "128",
      "x2": "40",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "16",
      "x2": "128",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 64 128 96 96 64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "240",
      "x2": "128",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 192 128 160 160 192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,128a8.00039,8.00039,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8.00039,8.00039,0,0,1,224,128ZM122.34277,101.65723a8.00181,8.00181,0,0,0,11.31446,0l32-32A8.00066,8.00066,0,0,0,160,56H136V16a8,8,0,0,0-16,0V56H96a8.00066,8.00066,0,0,0-5.65723,13.65723Zm11.31446,52.68554a8.003,8.003,0,0,0-11.31446,0l-32,32A8.00066,8.00066,0,0,0,96,200h24v40a8,8,0,0,0,16,0V200h24a8.00066,8.00066,0,0,0,5.65723-13.65723Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "216",
      "y1": "128",
      "x2": "40",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "16",
      "x2": "128",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 64 128 96 96 64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "240",
      "x2": "128",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 192 128 160 160 192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "216",
      "y1": "128",
      "x2": "40",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "16",
      "x2": "128",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 64 128 96 96 64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "240",
      "x2": "128",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 192 128 160 160 192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "216",
      "y1": "128",
      "x2": "40",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "16",
      "x2": "128",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 64 128 96 96 64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "240",
      "x2": "128",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 192 128 160 160 192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1J = [];
/* style */

const __vue_inject_styles__$1J = undefined;
/* scoped */

const __vue_scope_id__$1J = undefined;
/* module identifier */

const __vue_module_identifier__$1J = undefined;
/* functional template */

const __vue_is_functional_template__$1J = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1J = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1J,
  staticRenderFns: __vue_staticRenderFns__$1J
}, __vue_inject_styles__$1J, __vue_script__$1J, __vue_scope_id__$1J, __vue_is_functional_template__$1J, __vue_module_identifier__$1J, false, undefined, undefined, undefined);

var script$1K = Vue.extend({
  name: "PhArrowsInSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1K = script$1K;
/* template */

var __vue_render__$1K = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "152 56 152 104 200 104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "48",
      "x2": "152",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "56 152 104 152 104 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "208",
      "x2": "104",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "152 56 152 104 200 104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "48",
      "x2": "152",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "56 152 104 152 104 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "208",
      "x2": "104",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M213.65723,53.65723,187.31445,80l18.34278,18.34277A8.00066,8.00066,0,0,1,200,112H152a8.00039,8.00039,0,0,1-8-8V56a8.00066,8.00066,0,0,1,13.65723-5.65723L176,68.68555l26.34277-26.34278a8.00053,8.00053,0,0,1,11.31446,11.31446ZM104,144H56a8.00066,8.00066,0,0,0-5.65723,13.65723L68.68555,176,42.34277,202.34277a8.00053,8.00053,0,0,0,11.31446,11.31446L80,187.31445l18.34277,18.34278A8.00066,8.00066,0,0,0,112,200V152A8.00039,8.00039,0,0,0,104,144Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "152 56 152 104 200 104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "48",
      "x2": "152",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "56 152 104 152 104 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "208",
      "x2": "104",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "152 56 152 104 200 104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "48",
      "x2": "152",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "56 152 104 152 104 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "208",
      "x2": "104",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "152 56 152 104 200 104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "48",
      "x2": "152",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "56 152 104 152 104 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "208",
      "x2": "104",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1K = [];
/* style */

const __vue_inject_styles__$1K = undefined;
/* scoped */

const __vue_scope_id__$1K = undefined;
/* module identifier */

const __vue_module_identifier__$1K = undefined;
/* functional template */

const __vue_is_functional_template__$1K = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1K = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1K,
  staticRenderFns: __vue_staticRenderFns__$1K
}, __vue_inject_styles__$1K, __vue_script__$1K, __vue_scope_id__$1K, __vue_is_functional_template__$1K, __vue_module_identifier__$1K, false, undefined, undefined, undefined);

var script$1L = Vue.extend({
  name: "PhArrowsLeftRight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1L = script$1L;
/* template */

var __vue_render__$1L = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 144 208 176 176 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "176",
      "x2": "208",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 112 48 80 80 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208.00006",
      "y1": "80",
      "x2": "48.00006",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 144 208 176 176 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "176",
      "x2": "208",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 112 48 80 80 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208.00006",
      "y1": "80",
      "x2": "48.00006",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M213.65723,181.65723l-32,32A8.00038,8.00038,0,0,1,168,208V184H48a8,8,0,0,1,0-16H168V144a8.00038,8.00038,0,0,1,13.65723-5.65723l32,32A8.00122,8.00122,0,0,1,213.65723,181.65723Zm-139.31446-64A8.00038,8.00038,0,0,0,88,112V88H208a8,8,0,0,0,0-16H88V48a8.00038,8.00038,0,0,0-13.65723-5.65723l-32,32a8.00122,8.00122,0,0,0,0,11.31446Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 144 208 176 176 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "176",
      "x2": "208",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 112 48 80 80 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208.00006",
      "y1": "80",
      "x2": "48.00006",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 144 208 176 176 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "176",
      "x2": "208",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 112 48 80 80 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208.00006",
      "y1": "80",
      "x2": "48.00006",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 144 208 176 176 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "176",
      "x2": "208",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 112 48 80 80 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208.00006",
      "y1": "80",
      "x2": "48.00006",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1L = [];
/* style */

const __vue_inject_styles__$1L = undefined;
/* scoped */

const __vue_scope_id__$1L = undefined;
/* module identifier */

const __vue_module_identifier__$1L = undefined;
/* functional template */

const __vue_is_functional_template__$1L = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1L = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1L,
  staticRenderFns: __vue_staticRenderFns__$1L
}, __vue_inject_styles__$1L, __vue_script__$1L, __vue_scope_id__$1L, __vue_is_functional_template__$1L, __vue_module_identifier__$1L, false, undefined, undefined, undefined);

var script$1M = Vue.extend({
  name: "PhArrowsOut",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1M = script$1M;
/* template */

var __vue_render__$1M = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "168 48 208 48 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "104",
      "x2": "208",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "88 208 48 208 48 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "152",
      "x2": "48",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 168 208 208 168 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "152",
      "x2": "208",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48 88 48 48 88 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "104",
      "x2": "48",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "168 48 208 48 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "104",
      "x2": "208",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "88 208 48 208 48 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "152",
      "x2": "48",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 168 208 208 168 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "152",
      "x2": "208",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48 88 48 48 88 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "104",
      "x2": "48",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,48V88a8.00018,8.00018,0,0,1-13.65723,5.65674L188,79.314l-30.34277,30.34278a8.00018,8.00018,0,0,1-11.31446-11.31348L176.686,68,162.34277,53.65674A8.00037,8.00037,0,0,1,168,40h40A8.00008,8.00008,0,0,1,216,48ZM98.34277,146.34326,68,176.686,53.65723,162.34326A8.0001,8.0001,0,0,0,40,168v40a8.00008,8.00008,0,0,0,8,8H88a8.00038,8.00038,0,0,0,5.65723-13.65674L79.314,188l30.34327-30.34326a8.00018,8.00018,0,0,0-11.31446-11.31348Zm112.71875,14.26563a8.00113,8.00113,0,0,0-8.71875,1.73437L188,176.686l-30.34277-30.34278a8.00018,8.00018,0,0,0-11.31446,11.31348L176.686,188l-14.34327,14.34326A8.00037,8.00037,0,0,0,168,216h40a8.00008,8.00008,0,0,0,8-8V168A8.00015,8.00015,0,0,0,211.06152,160.60889ZM79.314,68,93.65723,53.65674A8.00038,8.00038,0,0,0,88,40H48a8.00008,8.00008,0,0,0-8,8V88a8.00018,8.00018,0,0,0,13.65723,5.65674L68,79.314l30.34277,30.34278a8.00018,8.00018,0,0,0,11.31446-11.31348Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "168 48 208 48 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "104",
      "x2": "208",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "88 208 48 208 48 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "152",
      "x2": "48",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 168 208 208 168 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "152",
      "x2": "208",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48 88 48 48 88 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "104",
      "x2": "48",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "168 48 208 48 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "104",
      "x2": "208",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "88 208 48 208 48 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "152",
      "x2": "48",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 168 208 208 168 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "152",
      "x2": "208",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48 88 48 48 88 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "104",
      "x2": "48",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "168 48 208 48 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "104",
      "x2": "208",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "88 208 48 208 48 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "152",
      "x2": "48",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 168 208 208 168 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "152",
      "x2": "208",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48 88 48 48 88 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "104",
      "x2": "48",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1M = [];
/* style */

const __vue_inject_styles__$1M = undefined;
/* scoped */

const __vue_scope_id__$1M = undefined;
/* module identifier */

const __vue_module_identifier__$1M = undefined;
/* functional template */

const __vue_is_functional_template__$1M = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1M = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1M,
  staticRenderFns: __vue_staticRenderFns__$1M
}, __vue_inject_styles__$1M, __vue_script__$1M, __vue_scope_id__$1M, __vue_is_functional_template__$1M, __vue_module_identifier__$1M, false, undefined, undefined, undefined);

var script$1N = Vue.extend({
  name: "PhArrowsOutCardinal",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1N = script$1N;
/* template */

var __vue_render__$1N = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "156.284 203.716 128 232 99.716 203.716",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "160",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "99.716 52.284 128 24 156.284 52.284",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "96",
      "x2": "128",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "52.284 156.284 24 128 52.284 99.716",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "128",
      "x2": "24",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "203.716 99.716 232 128 203.716 156.284",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "128",
      "x2": "232",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "156.284 203.716 128 232 99.716 203.716",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "160",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "99.716 52.284 128 24 156.284 52.284",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "96",
      "x2": "128",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "52.284 156.284 24 128 52.284 99.716",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "128",
      "x2": "24",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "203.716 99.716 232 128 203.716 156.284",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "128",
      "x2": "232",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M163.6748,200.6543a7.99949,7.99949,0,0,1-1.73339,8.71826l-28.28418,28.28418a8.00063,8.00063,0,0,1-11.31446,0L94.05859,209.37256a8.00038,8.00038,0,0,1,5.65723-13.65674H120V160a8,8,0,0,1,16,0v35.71582h20.28418A8,8,0,0,1,163.6748,200.6543ZM99.71582,60.28418H120V96a8,8,0,0,0,16,0V60.28418h20.28418a8.00038,8.00038,0,0,0,5.65723-13.65674L133.65723,18.34326a8.00063,8.00063,0,0,0-11.31446,0L94.05859,46.62744a8.00038,8.00038,0,0,0,5.65723,13.65674ZM96,136a8,8,0,0,0,0-16H60.28418V99.71582A8.00038,8.00038,0,0,0,46.627,94.05859L18.34277,122.34326a8,8,0,0,0,0,11.31348L46.627,161.94141a8.00038,8.00038,0,0,0,13.65723-5.65723V136Zm141.65723-13.65674L209.37305,94.05859a8.00038,8.00038,0,0,0-13.65723,5.65723V120H160a8,8,0,0,0,0,16h35.71582v20.28418a8.00018,8.00018,0,0,0,13.65723,5.65723l28.28418-28.28467A8,8,0,0,0,237.65723,122.34326Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "156.284 203.716 128 232 99.716 203.716",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "160",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "99.716 52.284 128 24 156.284 52.284",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "96",
      "x2": "128",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "52.284 156.284 24 128 52.284 99.716",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "128",
      "x2": "24",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "203.716 99.716 232 128 203.716 156.284",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "128",
      "x2": "232",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "156.284 203.716 128 232 99.716 203.716",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "160",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "99.716 52.284 128 24 156.284 52.284",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "96",
      "x2": "128",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "52.284 156.284 24 128 52.284 99.716",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "128",
      "x2": "24",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "203.716 99.716 232 128 203.716 156.284",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "128",
      "x2": "232",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "156.284 203.716 128 232 99.716 203.716",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "160",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "99.716 52.284 128 24 156.284 52.284",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "96",
      "x2": "128",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "52.284 156.284 24 128 52.284 99.716",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "128",
      "x2": "24",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "203.716 99.716 232 128 203.716 156.284",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "128",
      "x2": "232",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1N = [];
/* style */

const __vue_inject_styles__$1N = undefined;
/* scoped */

const __vue_scope_id__$1N = undefined;
/* module identifier */

const __vue_module_identifier__$1N = undefined;
/* functional template */

const __vue_is_functional_template__$1N = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1N = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1N,
  staticRenderFns: __vue_staticRenderFns__$1N
}, __vue_inject_styles__$1N, __vue_script__$1N, __vue_scope_id__$1N, __vue_is_functional_template__$1N, __vue_module_identifier__$1N, false, undefined, undefined, undefined);

var script$1O = Vue.extend({
  name: "PhArrowsOutLineHorizontal",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1O = script$1O;
/* template */

var __vue_render__$1O = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "128",
      "x2": "12",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "44 96 12 128 44 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "128",
      "x2": "244",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "212 160 244 128 212 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "128",
      "x2": "16",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48 160 16 128 48 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "128",
      "x2": "240",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 96 240 128 208 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M136,40V216a8,8,0,0,1-16,0V40a8,8,0,0,1,16,0ZM96,120H56V96a8.00066,8.00066,0,0,0-13.65723-5.65723l-32,32a8.00122,8.00122,0,0,0,0,11.31446l32,32A8.00066,8.00066,0,0,0,56,160V136H96a8,8,0,0,0,0-16Zm149.65723,2.34277-32-32A8.00066,8.00066,0,0,0,200,96v24H160a8,8,0,0,0,0,16h40v24a8.00053,8.00053,0,0,0,13.65723,5.65723l32-32A8.00122,8.00122,0,0,0,245.65723,122.34277Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "128",
      "x2": "16",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48 160 16 128 48 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "128",
      "x2": "240",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 96 240 128 208 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "128",
      "x2": "16",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48 160 16 128 48 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "128",
      "x2": "240",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 96 240 128 208 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "128",
      "x2": "16",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48 160 16 128 48 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "128",
      "x2": "240",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 96 240 128 208 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1O = [];
/* style */

const __vue_inject_styles__$1O = undefined;
/* scoped */

const __vue_scope_id__$1O = undefined;
/* module identifier */

const __vue_module_identifier__$1O = undefined;
/* functional template */

const __vue_is_functional_template__$1O = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1O = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1O,
  staticRenderFns: __vue_staticRenderFns__$1O
}, __vue_inject_styles__$1O, __vue_script__$1O, __vue_scope_id__$1O, __vue_is_functional_template__$1O, __vue_module_identifier__$1O, false, undefined, undefined, undefined);

var script$1P = Vue.extend({
  name: "PhArrowsOutLineVertical",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1P = script$1P;
/* template */

var __vue_render__$1P = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "216",
      "y1": "128",
      "x2": "40",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "88",
      "x2": "128",
      "y2": "12",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 44 128 12 96 44",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "168",
      "x2": "128",
      "y2": "244",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 212 128 244 160 212",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "216",
      "y1": "128",
      "x2": "40",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "96",
      "x2": "128",
      "y2": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 48 128 16 160 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "160",
      "x2": "128",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 208 128 240 96 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,128a8.00039,8.00039,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8.00039,8.00039,0,0,1,224,128ZM96,56h24V96a8,8,0,0,0,16,0V56h24a8.00066,8.00066,0,0,0,5.65723-13.65723l-32-32a8.003,8.003,0,0,0-11.31446,0l-32,32A8.00066,8.00066,0,0,0,96,56Zm64,144H136V160a8,8,0,0,0-16,0v40H96a8.00066,8.00066,0,0,0-5.65723,13.65723l32,32a8.00181,8.00181,0,0,0,11.31446,0l32-32A8.00066,8.00066,0,0,0,160,200Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "216",
      "y1": "128",
      "x2": "40",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "96",
      "x2": "128",
      "y2": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 48 128 16 160 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "160",
      "x2": "128",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 208 128 240 96 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "216",
      "y1": "128",
      "x2": "40",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "96",
      "x2": "128",
      "y2": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 48 128 16 160 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "160",
      "x2": "128",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 208 128 240 96 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "216",
      "y1": "128",
      "x2": "40",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "96",
      "x2": "128",
      "y2": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 48 128 16 160 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "160",
      "x2": "128",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 208 128 240 96 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1P = [];
/* style */

const __vue_inject_styles__$1P = undefined;
/* scoped */

const __vue_scope_id__$1P = undefined;
/* module identifier */

const __vue_module_identifier__$1P = undefined;
/* functional template */

const __vue_is_functional_template__$1P = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1P = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1P,
  staticRenderFns: __vue_staticRenderFns__$1P
}, __vue_inject_styles__$1P, __vue_script__$1P, __vue_scope_id__$1P, __vue_is_functional_template__$1P, __vue_module_identifier__$1P, false, undefined, undefined, undefined);

var script$1Q = Vue.extend({
  name: "PhArrowsOutSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1Q = script$1Q;
/* template */

var __vue_render__$1Q = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "160 48 208 48 208 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "104",
      "x2": "208",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 208 48 208 48 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "152",
      "x2": "48",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "160 48 208 48 208 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "104",
      "x2": "208",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 208 48 208 48 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "152",
      "x2": "48",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,48V96a8.00018,8.00018,0,0,1-13.65723,5.65674L184,83.314l-26.34277,26.34278a8.00018,8.00018,0,0,1-11.31446-11.31348L172.686,72,154.34277,53.65674A8.00038,8.00038,0,0,1,160,40h48A8.00008,8.00008,0,0,1,216,48ZM98.34277,146.34326,72,172.686,53.65723,154.34326A8.0001,8.0001,0,0,0,40,160v48a8.00008,8.00008,0,0,0,8,8H96a8.00038,8.00038,0,0,0,5.65723-13.65674L83.314,184l26.34327-26.34326a8.00018,8.00018,0,0,0-11.31446-11.31348Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "160 48 208 48 208 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "104",
      "x2": "208",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 208 48 208 48 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "152",
      "x2": "48",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "160 48 208 48 208 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "104",
      "x2": "208",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 208 48 208 48 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "152",
      "x2": "48",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "160 48 208 48 208 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "104",
      "x2": "208",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 208 48 208 48 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "152",
      "x2": "48",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1Q = [];
/* style */

const __vue_inject_styles__$1Q = undefined;
/* scoped */

const __vue_scope_id__$1Q = undefined;
/* module identifier */

const __vue_module_identifier__$1Q = undefined;
/* functional template */

const __vue_is_functional_template__$1Q = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1Q = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1Q,
  staticRenderFns: __vue_staticRenderFns__$1Q
}, __vue_inject_styles__$1Q, __vue_script__$1Q, __vue_scope_id__$1Q, __vue_is_functional_template__$1Q, __vue_module_identifier__$1Q, false, undefined, undefined, undefined);

var script$1R = Vue.extend({
  name: "PhArticle",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1R = script$1R;
/* template */

var __vue_render__$1R = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "76",
      "y1": "92",
      "x2": "180",
      "y2": "92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "76",
      "y1": "128",
      "x2": "180",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "76",
      "y1": "164",
      "x2": "180",
      "y2": "164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "76",
      "y1": "96",
      "x2": "180",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "76",
      "y1": "128",
      "x2": "180",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "76",
      "y1": "160",
      "x2": "180",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,40H40A16.01833,16.01833,0,0,0,24,56V200a16.01833,16.01833,0,0,0,16,16H216a16.01833,16.01833,0,0,0,16-16V56A16.01833,16.01833,0,0,0,216,40ZM180,168H76a8,8,0,0,1,0-16H180a8,8,0,0,1,0,16Zm0-32H76a8,8,0,0,1,0-16H180a8,8,0,0,1,0,16Zm0-32H76a8,8,0,0,1,0-16H180a8,8,0,0,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "76",
      "y1": "96",
      "x2": "180",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "76",
      "y1": "128",
      "x2": "180",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "76",
      "y1": "160",
      "x2": "180",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "76",
      "y1": "96",
      "x2": "180",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "76",
      "y1": "128",
      "x2": "180",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "76",
      "y1": "160",
      "x2": "180",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "76",
      "y1": "96",
      "x2": "180",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "76",
      "y1": "128",
      "x2": "180",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "76",
      "y1": "160",
      "x2": "180",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1R = [];
/* style */

const __vue_inject_styles__$1R = undefined;
/* scoped */

const __vue_scope_id__$1R = undefined;
/* module identifier */

const __vue_module_identifier__$1R = undefined;
/* functional template */

const __vue_is_functional_template__$1R = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1R = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1R,
  staticRenderFns: __vue_staticRenderFns__$1R
}, __vue_inject_styles__$1R, __vue_script__$1R, __vue_scope_id__$1R, __vue_is_functional_template__$1R, __vue_module_identifier__$1R, false, undefined, undefined, undefined);

var script$1S = Vue.extend({
  name: "PhArticleMedium",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1S = script$1S;
/* template */

var __vue_render__$1S = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "24.03516",
      "y1": "48.00094",
      "x2": "40.03516",
      "y2": "48.00094",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120.03516",
      "y1": "48.00094",
      "x2": "136.03516",
      "y2": "48.00094",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24.03516",
      "y1": "128.00094",
      "x2": "48.03516",
      "y2": "128.00094",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112.03516",
      "y1": "128.00094",
      "x2": "136.03516",
      "y2": "128.00094",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176.03516",
      "y1": "88.00094",
      "x2": "240.03516",
      "y2": "88.00094",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176.03516",
      "y1": "128.00094",
      "x2": "240.03516",
      "y2": "128.00094",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72.03516",
      "y1": "168.00094",
      "x2": "240.03516",
      "y2": "168.00094",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72.03516",
      "y1": "208.00094",
      "x2": "240.03516",
      "y2": "208.00094",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "40.035 128.001 40.035 48.001 80.035 112.001 120.035 48.001 120.035 128.001",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "24.01172",
      "y1": "56.00094",
      "x2": "40.01172",
      "y2": "56.00094",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120.01172",
      "y1": "56.00094",
      "x2": "136.01172",
      "y2": "56.00094",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24.01172",
      "y1": "136.00094",
      "x2": "48.01172",
      "y2": "136.00094",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112.01172",
      "y1": "136.00094",
      "x2": "136.01172",
      "y2": "136.00094",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168.01172",
      "y1": "104.00094",
      "x2": "240.01172",
      "y2": "104.00094",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168.01172",
      "y1": "136.00094",
      "x2": "240.01172",
      "y2": "136.00094",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72.01172",
      "y1": "168.00094",
      "x2": "240.01172",
      "y2": "168.00094",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72.01172",
      "y1": "200.00094",
      "x2": "240.01172",
      "y2": "200.00094",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "40.012 136.001 40.012 56.001 80.012 120.001 120.012 56.001 120.012 136.001",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M48.02344,128.00094V83.89547l25.21582,40.34571a8.00063,8.00063,0,0,0,13.56836,0l25.21582-40.34571v44.10547a8,8,0,0,0,0,16h24a8,8,0,0,0,0-16h-8v-64h8a8,8,0,0,0,0-16h-16c-.04,0-.07862.00537-.11817.00586-.15478.00244-.3081.01221-.46191.02344-.11768.0083-.23584.01611-.35205.0293-.12793.01513-.2544.03711-.38135.05859-.13769.02246-.27539.04443-.41064.07422-.103.02246-.20459.05176-.30664.07861-.15088.03955-.30176.07862-.44922.12647-.09424.03076-.186.06836-.2793.10254-.11816.04345-.23926.08105-.35449.12988-.02881.01172-.05518.02734-.0835.04-.104.04492-.20459.09814-.30713.14746-.125.06152-.25146.12061-.373.188s-.23877.14355-.35743.21728c-.09619.06006-.19384.11719-.28711.18116-.1289.08837-.25244.18554-.37695.28173-.07812.061-.1582.11914-.23437.18262-.11914.09961-.23243.20752-.3462.31494-.0581.05469-.12109.10449-.17724.16114-.01807.01757-.0332.03759-.05078.05566-.09766.09961-.18994.20557-.28321.31152-.05957.06787-.125.13086-.18261.20069-.02344.02832-.043.05957-.06592.08838-.07373.09228-.14307.189-.21289.28515-.09082.124-.18067.249-.26416.37842-.02149.0332-.04639.063-.06787.09668l-33.21582,53.146-33.21582-53.146c-.02149-.03369-.04639-.06348-.06787-.09668-.0835-.1294-.17334-.2544-.26416-.37842-.06983-.09619-.13916-.19287-.2129-.28515-.02294-.02881-.043-.06006-.06591-.08838-.05762-.06983-.12256-.13282-.18262-.20069-.09326-.10547-.18555-.21191-.2832-.312-.01758-.01758-.03321-.0376-.05078-.05517-.05616-.05616-.11866-.106-.17627-.16065-.11426-.10791-.228-.21582-.34766-.31592-.0752-.063-.1543-.12011-.23193-.18017-.125-.09717-.24952-.19483-.3794-.28369-.09277-.064-.19043-.1211-.28613-.18116-.11865-.07373-.23584-.14941-.35791-.21679-.12256-.06836-.25-.12793-.37647-.19-.10058-.04882-.20019-.10107-.30273-.1455-.02881-.0127-.05566-.02881-.08447-.04053-.1167-.04981-.23926-.08789-.35889-.13184-.09131-.0332-.18164-.06982-.27393-.10009-.14843-.04834-.30127-.08789-.45361-.12745-.10059-.02636-.20068-.05566-.30225-.07812-.1372-.02979-.27636-.05225-.416-.0752-.125-.0205-.249-.04248-.375-.05712-.11817-.01368-.23828-.02149-.35791-.02979-.15186-.01123-.30322-.02051-.45557-.02344-.04052-.00049-.08008-.00586-.1206-.00586h-16a8,8,0,0,0,0,16h8v64h-8a8,8,0,1,0,0,16h24a8,8,0,0,0,0-16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168.02344,112.00094h72a8,8,0,0,0,0-16h-72a8,8,0,0,0,0,16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M240.02344,128.00094h-72a8,8,0,0,0,0,16h72a8,8,0,0,0,0-16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M240.02344,160.00094h-168a8,8,0,0,0,0,16h168a8,8,0,0,0,0-16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M240.02344,192.00094h-168a8,8,0,0,0,0,16h168a8,8,0,0,0,0-16Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "24.04688",
      "y1": "56.00094",
      "x2": "40.04688",
      "y2": "56.00094",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120.04688",
      "y1": "56.00094",
      "x2": "136.04688",
      "y2": "56.00094",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24.04688",
      "y1": "136.00094",
      "x2": "48.04688",
      "y2": "136.00094",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112.04688",
      "y1": "136.00094",
      "x2": "136.04688",
      "y2": "136.00094",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168.04688",
      "y1": "104.00094",
      "x2": "240.04688",
      "y2": "104.00094",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168.04688",
      "y1": "136.00094",
      "x2": "240.04688",
      "y2": "136.00094",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72.04688",
      "y1": "168.00094",
      "x2": "240.04688",
      "y2": "168.00094",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72.04688",
      "y1": "200.00094",
      "x2": "240.04688",
      "y2": "200.00094",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "40.047 136.001 40.047 56.001 80.047 120.001 120.047 56.001 120.047 136.001",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "24.05859",
      "y1": "56.00094",
      "x2": "40.05859",
      "y2": "56.00094",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120.05859",
      "y1": "56.00094",
      "x2": "136.05859",
      "y2": "56.00094",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24.05859",
      "y1": "136.00094",
      "x2": "48.05859",
      "y2": "136.00094",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112.05859",
      "y1": "136.00094",
      "x2": "136.05859",
      "y2": "136.00094",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168.05859",
      "y1": "104.00094",
      "x2": "240.05859",
      "y2": "104.00094",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168.05859",
      "y1": "136.00094",
      "x2": "240.05859",
      "y2": "136.00094",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72.05859",
      "y1": "168.00094",
      "x2": "240.05859",
      "y2": "168.00094",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72.05859",
      "y1": "200.00094",
      "x2": "240.05859",
      "y2": "200.00094",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "40.059 136.001 40.059 56.001 80.059 120.001 120.059 56.001 120.059 136.001",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "24.07031",
      "y1": "56.00094",
      "x2": "40.07031",
      "y2": "56.00094",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120.07031",
      "y1": "56.00094",
      "x2": "136.07031",
      "y2": "56.00094",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24.07031",
      "y1": "136.00094",
      "x2": "48.07031",
      "y2": "136.00094",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112.07031",
      "y1": "136.00094",
      "x2": "136.07031",
      "y2": "136.00094",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168.07031",
      "y1": "104.00094",
      "x2": "240.07031",
      "y2": "104.00094",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168.07031",
      "y1": "136.00094",
      "x2": "240.07031",
      "y2": "136.00094",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72.07031",
      "y1": "168.00094",
      "x2": "240.07031",
      "y2": "168.00094",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72.07031",
      "y1": "200.00094",
      "x2": "240.07031",
      "y2": "200.00094",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "40.07 136.001 40.07 56.001 80.07 120.001 120.07 56.001 120.07 136.001",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24.07031",
      "y1": "56.00094",
      "x2": "40.07031",
      "y2": "56.00094",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120.07031",
      "y1": "56.00094",
      "x2": "136.07031",
      "y2": "56.00094",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24.07031",
      "y1": "136.00094",
      "x2": "48.07031",
      "y2": "136.00094",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112.07031",
      "y1": "136.00094",
      "x2": "136.07031",
      "y2": "136.00094",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168.07031",
      "y1": "104.00094",
      "x2": "240.07031",
      "y2": "104.00094",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168.07031",
      "y1": "136.00094",
      "x2": "240.07031",
      "y2": "136.00094",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72.07031",
      "y1": "168.00094",
      "x2": "240.07031",
      "y2": "168.00094",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72.07031",
      "y1": "200.00094",
      "x2": "240.07031",
      "y2": "200.00094",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "40.07 136.001 40.07 56.001 80.07 120.001 120.07 56.001 120.07 136.001",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1S = [];
/* style */

const __vue_inject_styles__$1S = undefined;
/* scoped */

const __vue_scope_id__$1S = undefined;
/* module identifier */

const __vue_module_identifier__$1S = undefined;
/* functional template */

const __vue_is_functional_template__$1S = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1S = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1S,
  staticRenderFns: __vue_staticRenderFns__$1S
}, __vue_inject_styles__$1S, __vue_script__$1S, __vue_scope_id__$1S, __vue_is_functional_template__$1S, __vue_module_identifier__$1S, false, undefined, undefined, undefined);

var script$1T = Vue.extend({
  name: "PhArticleNyTimes",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1T = script$1T;
/* template */

var __vue_render__$1T = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "176",
      "y1": "88",
      "x2": "240",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "128",
      "x2": "240",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "168",
      "x2": "240",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "208",
      "x2": "240",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M126.51493,131.6147A48.00511,48.00511,0,1,1,79.92969,72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "79.92969",
      "y1": "114.47668",
      "x2": "79.87491",
      "y2": "167.89045",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M111.92969,52a20,20,0,0,1,0,40l-64-40a20.00331,20.00331,0,0,0-6.25081,39.00379",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "160",
      "y1": "104",
      "x2": "240",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "136",
      "x2": "240",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "168",
      "x2": "240",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "200",
      "x2": "240",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M126.51493,131.6147A48.00511,48.00511,0,1,1,79.92969,72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "79.92969",
      "y1": "114.47668",
      "x2": "79.87491",
      "y2": "167.89045",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M111.92969,52a20,20,0,0,1,0,40l-64-40a20.00331,20.00331,0,0,0-6.25081,39.00379",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M152,104a8.00008,8.00008,0,0,1,8-8h80a8,8,0,0,1,0,16H160A8.00008,8.00008,0,0,1,152,104Zm88,24H160a8,8,0,0,0,0,16h80a8,8,0,0,0,0-16Zm0,32H160a8,8,0,0,0,0,16h80a8,8,0,0,0,0-16Zm0,32H72a8,8,0,0,0,0,16H240a8,8,0,0,0,0-16ZM79.92969,176A55.96817,55.96817,0,0,1,30.43091,93.85059,27.99468,27.99468,0,0,1,47.92969,44a8.00234,8.00234,0,0,1,4.24023,1.21582l61.78174,38.61377A12.00063,12.00063,0,0,0,111.92969,60a8,8,0,0,1,0-16,28,28,0,0,1,0,56,8.00238,8.00238,0,0,1-4.24024-1.21582L77.73535,80.0625A40.00129,40.00129,0,0,0,71.88391,159.187l.04578-44.71826a8.00029,8.00029,0,0,1,8-7.99219h.0083a8.00041,8.00041,0,0,1,7.9917,8.0083l-.04578,44.71875a39.8882,39.8882,0,0,0,30.86755-29.51806,7.99978,7.99978,0,1,1,15.52735,3.8584A55.88761,55.88761,0,0,1,79.92969,176ZM39.88574,80.90771A56.18282,56.18282,0,0,1,58.72546,68.18164L45.90771,60.17041a12.00319,12.00319,0,0,0-6.022,20.7373Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "160",
      "y1": "104",
      "x2": "240",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "136",
      "x2": "240",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "168",
      "x2": "240",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "200",
      "x2": "240",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M126.51493,131.6147A48.00511,48.00511,0,1,1,79.92969,72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "79.92969",
      "y1": "114.47668",
      "x2": "79.87491",
      "y2": "167.89045",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M111.92969,52a20,20,0,0,1,0,40l-64-40a20.00331,20.00331,0,0,0-6.25081,39.00379",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "160",
      "y1": "104",
      "x2": "240",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "136",
      "x2": "240",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "168",
      "x2": "240",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "200",
      "x2": "240",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M126.51493,131.6147A48.00511,48.00511,0,1,1,79.92969,72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "79.92969",
      "y1": "114.47668",
      "x2": "79.87491",
      "y2": "167.89045",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M111.92969,52a20,20,0,0,1,0,40l-64-40a20.00331,20.00331,0,0,0-6.25081,39.00379",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "160",
      "y1": "104",
      "x2": "240",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "136",
      "x2": "240",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "168",
      "x2": "240",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "200",
      "x2": "240",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M126.51493,131.6147A48.00511,48.00511,0,1,1,79.92969,72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "79.92969",
      "y1": "114.47668",
      "x2": "79.87491",
      "y2": "167.89045",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M111.92969,52a20,20,0,0,1,0,40l-64-40a20.00331,20.00331,0,0,0-6.25081,39.00379",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1T = [];
/* style */

const __vue_inject_styles__$1T = undefined;
/* scoped */

const __vue_scope_id__$1T = undefined;
/* module identifier */

const __vue_module_identifier__$1T = undefined;
/* functional template */

const __vue_is_functional_template__$1T = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1T = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1T,
  staticRenderFns: __vue_staticRenderFns__$1T
}, __vue_inject_styles__$1T, __vue_script__$1T, __vue_scope_id__$1T, __vue_is_functional_template__$1T, __vue_module_identifier__$1T, false, undefined, undefined, undefined);

var script$1U = Vue.extend({
  name: "PhAsterisk",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1U = script$1U;
/* template */

var __vue_render__$1U = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "51.78976",
      "y1": "84",
      "x2": "204.21024",
      "y2": "172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "51.78976",
      "y1": "172",
      "x2": "204.21024",
      "y2": "84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "51.78976",
      "y1": "84",
      "x2": "204.21024",
      "y2": "172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "51.78976",
      "y1": "172",
      "x2": "204.21024",
      "y2": "84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208.21045,165.07178,144,128l64.21045-37.07178a8,8,0,1,0-8-13.85644L136,114.14355V40a8,8,0,0,0-16,0v74.14355L55.78955,77.07178a8,8,0,0,0-8,13.85644L112,128,47.78955,165.07178a8,8,0,1,0,8,13.85644L120,141.85645V216a8,8,0,0,0,16,0V141.85645l64.21045,37.07177a8,8,0,0,0,8-13.85644Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "51.78976",
      "y1": "84",
      "x2": "204.21024",
      "y2": "172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "51.78976",
      "y1": "172",
      "x2": "204.21024",
      "y2": "84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "51.78976",
      "y1": "84",
      "x2": "204.21024",
      "y2": "172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "51.78976",
      "y1": "172",
      "x2": "204.21024",
      "y2": "84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "51.78976",
      "y1": "84",
      "x2": "204.21024",
      "y2": "172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "51.78976",
      "y1": "172",
      "x2": "204.21024",
      "y2": "84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1U = [];
/* style */

const __vue_inject_styles__$1U = undefined;
/* scoped */

const __vue_scope_id__$1U = undefined;
/* module identifier */

const __vue_module_identifier__$1U = undefined;
/* functional template */

const __vue_is_functional_template__$1U = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1U = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1U,
  staticRenderFns: __vue_staticRenderFns__$1U
}, __vue_inject_styles__$1U, __vue_script__$1U, __vue_scope_id__$1U, __vue_is_functional_template__$1U, __vue_module_identifier__$1U, false, undefined, undefined, undefined);

var script$1V = Vue.extend({
  name: "PhAt",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1V = script$1V;
/* template */

var __vue_render__$1V = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "127.99121",
      "cy": "127.99512",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M181.07274,207.99724a96.00809,96.00809,0,1,1,42.91847-80.00212c0,22.09139-8,40-28,40s-28-17.90861-28-40v-40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "127.99512",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "127.99512",
      "cy": "127.99512",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M181.07664,207.99724a96.00808,96.00808,0,1,1,42.91848-80.00212c0,22.09139-8,40-28,40s-28-17.90861-28-40v-40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M128,23.99121a104,104,0,1,0,93.78125,148.9364A49.2519,49.2519,0,0,1,204,175.99121c-18.28711,0-28.52441-8.00488-33.8916-14.7207a39.57375,39.57375,0,0,1-3.37793-4.96948A48.00646,48.00646,0,1,1,160,92.2522v-4.261a8,8,0,0,1,16,0v40c0,14.59863,4.85742,32,28,32,22.3457,0,27.64258-16.22314,27.98047-30.4823.00732-.50574.01953-1.01037.01953-1.5177A104.11791,104.11791,0,0,0,128,23.99121Z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "127.99121",
      "r": "32"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "127.99512",
      "cy": "127.99512",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M181.07664,207.99724a96.00808,96.00808,0,1,1,42.91848-80.00212c0,22.09139-8,40-28,40s-28-17.90861-28-40v-40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "127.99902",
      "cy": "127.99512",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M181.08055,207.99724A96.00809,96.00809,0,1,1,223.999,127.99512c0,22.09139-8,40-28,40s-28-17.90861-28-40v-40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128.00293",
      "cy": "127.99512",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M181.08446,207.99724a96.00809,96.00809,0,1,1,42.91847-80.00212c0,22.09139-8,40-28,40s-28-17.90861-28-40v-40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1V = [];
/* style */

const __vue_inject_styles__$1V = undefined;
/* scoped */

const __vue_scope_id__$1V = undefined;
/* module identifier */

const __vue_module_identifier__$1V = undefined;
/* functional template */

const __vue_is_functional_template__$1V = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1V = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1V,
  staticRenderFns: __vue_staticRenderFns__$1V
}, __vue_inject_styles__$1V, __vue_script__$1V, __vue_scope_id__$1V, __vue_is_functional_template__$1V, __vue_module_identifier__$1V, false, undefined, undefined, undefined);

var script$1W = Vue.extend({
  name: "PhAtom",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1W = script$1W;
/* template */

var __vue_render__$1W = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "44",
      "ry": "116",
      "transform": "translate(-53.01934 128) rotate(-45)",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "116",
      "ry": "44",
      "transform": "translate(-53.01934 128) rotate(-45)",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "44",
      "ry": "116",
      "transform": "translate(-53.01934 128) rotate(-45)",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "44",
      "ry": "116",
      "transform": "translate(-53.01934 128) rotate(-45)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "116",
      "ry": "44",
      "transform": "translate(-53.01934 128) rotate(-45)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M196.09521,128a195.65007,195.65007,0,0,0,19.2002-32.71777c11.07715-24.61524,11.21436-44.13575.38574-54.96387C198.23242,22.87354,162.541,35.40918,128,60.00342,93.45947,35.40869,57.76758,22.87256,40.31885,40.31836,29.49023,51.14648,29.62744,70.667,40.70459,95.28223A195.65007,195.65007,0,0,0,59.90479,128a195.65007,195.65007,0,0,0-19.2002,32.71777c-11.07715,24.61524-11.21436,44.13575-.38574,54.96387,5.61767,5.61719,13.12549,8.127,21.87842,8.127,18.4331,0,42.38232-11.1394,65.80273-27.81616,23.42041,16.677,47.36914,27.81616,65.80273,27.81616,8.75,0,16.26172-2.51074,21.87842-8.127,10.82862-10.82812,10.69141-30.34863-.38574-54.96387A195.65007,195.65007,0,0,0,196.09521,128Zm-2.31982-79.7002c4.77539,0,8.39453,1.13575,10.59229,3.333,5.62451,5.624,4.25537,19.48731-3.66309,37.084a172.9306,172.9306,0,0,1-14.79053,25.93188,306.72561,306.72561,0,0,0-21.14453-23.41821,300.50739,300.50739,0,0,0-23.48389-21.13184C163.18457,55.21191,182.00049,48.2998,193.77539,48.2998ZM176.12061,128a288.40831,288.40831,0,0,1-22.66456,25.45508,288.63877,288.63877,0,0,1-25.45459,22.69873A288.50733,288.50733,0,0,1,102.544,153.45508,288.40831,288.40831,0,0,1,79.87939,128,296.26257,296.26257,0,0,1,128,79.84717a288.52058,288.52058,0,0,1,25.45605,22.69775A288.40831,288.40831,0,0,1,176.12061,128ZM55.29541,88.7168c-7.91846-17.59668-9.2876-31.46-3.66309-37.084,2.19776-2.19824,5.815-3.333,10.59229-3.333,11.77539,0,30.59131,6.91285,52.48975,21.79908A300.45376,300.45376,0,0,0,91.23047,91.23047a306.72561,306.72561,0,0,0-21.14453,23.41821A172.9306,172.9306,0,0,1,55.29541,88.7168ZM51.63232,204.36719c-5.62451-5.624-4.25537-19.48731,3.66309-37.084a172.9306,172.9306,0,0,1,14.79053-25.93188,306.72561,306.72561,0,0,0,21.14453,23.41821,300.52025,300.52025,0,0,0,23.4917,21.13233C83.93555,206.83276,59.249,211.98193,51.63232,204.36719Zm152.73536,0c-2.19776,2.19824-5.815,3.333-10.59229,3.333-11.77588-.00123-30.59326-6.91456-52.49316-21.80176a300.51532,300.51532,0,0,0,23.4873-21.12891,306.72561,306.72561,0,0,0,21.14453-23.41821,172.9306,172.9306,0,0,1,14.79053,25.93188C208.62305,184.87988,209.99219,198.74316,204.36768,204.36719ZM140,128a12,12,0,1,1-12-12A12,12,0,0,1,140,128Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "44",
      "ry": "116",
      "transform": "translate(-53.01934 128) rotate(-45)",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "116",
      "ry": "44",
      "transform": "translate(-53.01934 128) rotate(-45)",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "44",
      "ry": "116",
      "transform": "translate(-53.01934 128) rotate(-45)",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "116",
      "ry": "44",
      "transform": "translate(-53.01934 128) rotate(-45)",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "44",
      "ry": "116",
      "transform": "translate(-53.01934 128) rotate(-45)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "116",
      "ry": "44",
      "transform": "translate(-53.01934 128) rotate(-45)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1W = [];
/* style */

const __vue_inject_styles__$1W = undefined;
/* scoped */

const __vue_scope_id__$1W = undefined;
/* module identifier */

const __vue_module_identifier__$1W = undefined;
/* functional template */

const __vue_is_functional_template__$1W = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1W = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1W,
  staticRenderFns: __vue_staticRenderFns__$1W
}, __vue_inject_styles__$1W, __vue_script__$1W, __vue_scope_id__$1W, __vue_is_functional_template__$1W, __vue_module_identifier__$1W, false, undefined, undefined, undefined);

var script$1X = Vue.extend({
  name: "PhBaby",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1X = script$1X;
/* template */

var __vue_render__$1X = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "128",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "128",
      "r": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154.53832,168.00269a48.03112,48.03112,0,0,1-53.07491.00115",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,32c-16,20-16,40-16,40a16.00421,16.00421,0,0,0,24.00155,13.85859",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154.53832,168.00269a48.03112,48.03112,0,0,1-53.07491.00115",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,32c-16,20-16,40-16,40a16,16,0,0,0,32,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M131.92139,24.0813C120.32031,40.37354,120.002,55.87939,120,56.044A8.00006,8.00006,0,0,0,136,56a8,8,0,0,1,16,0,24,24,0,0,1-48,0c0-.72876.125-14.4248,8.57715-30.85474a104.06072,104.06072,0,1,0,19.34424-1.064ZM80,128a12,12,0,1,1,12,12A12,12,0,0,1,80,128Zm78.9668,46.665a56.03047,56.03047,0,0,1-61.93213.001,7.99982,7.99982,0,1,1,8.85742-13.32422,40.03347,40.03347,0,0,0,44.21777-.001A7.99969,7.99969,0,1,1,158.9668,174.665ZM164,140a12,12,0,1,1,12-12A12,12,0,0,1,164,140Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "128",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "128",
      "r": "10"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154.53832,168.00269a48.03112,48.03112,0,0,1-53.07491.00115",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,32c-16,20-16,40-16,40a16,16,0,0,0,32,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "128",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "128",
      "r": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154.53832,168.00269a48.03112,48.03112,0,0,1-53.07491.00115",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,32c-16,20-16,40-16,40a16,16,0,0,0,32,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154.53832,168.00269a48.03112,48.03112,0,0,1-53.07491.00115",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,32c-16,20-16,40-16,40a16,16,0,0,0,32,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1X = [];
/* style */

const __vue_inject_styles__$1X = undefined;
/* scoped */

const __vue_scope_id__$1X = undefined;
/* module identifier */

const __vue_module_identifier__$1X = undefined;
/* functional template */

const __vue_is_functional_template__$1X = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1X = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1X,
  staticRenderFns: __vue_staticRenderFns__$1X
}, __vue_inject_styles__$1X, __vue_script__$1X, __vue_scope_id__$1X, __vue_is_functional_template__$1X, __vue_module_identifier__$1X, false, undefined, undefined, undefined);

var script$1Y = Vue.extend({
  name: "PhBackspace",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1Y = script$1Y;
/* template */

var __vue_render__$1Y = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M61.66958,204.116,16,128l45.66958-76.116a8,8,0,0,1,6.85994-3.884H216a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H68.52952A8,8,0,0,1,61.66958,204.116Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "104.00005",
      "x2": "112",
      "y2": "152.00005",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "152.00005",
      "x2": "112",
      "y2": "104.00005",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M61.66958,204.116,16,128l45.66958-76.116a8,8,0,0,1,6.85994-3.884H216a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H68.52952A8,8,0,0,1,61.66958,204.116Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M61.66958,204.116,16,128l45.66958-76.116a8,8,0,0,1,6.85994-3.884H216a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H68.52952A8,8,0,0,1,61.66958,204.116Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "104.00005",
      "x2": "112",
      "y2": "152.00005",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "152.00005",
      "x2": "112",
      "y2": "104.00005",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M215.99512,39.99805H68.52637a16.1162,16.1162,0,0,0-13.71875,7.76562L9.13574,123.88086a8.02459,8.02459,0,0,0,0,8.23437l45.67188,76.11719v.00781a16.10652,16.10652,0,0,0,13.71875,7.75782H215.99512a16.01583,16.01583,0,0,0,16-16v-144A16.01582,16.01582,0,0,0,215.99512,39.99805ZM165.65137,146.3418a7.99915,7.99915,0,1,1-11.3125,11.3125l-18.34375-18.34375L117.65137,157.6543a7.99915,7.99915,0,0,1-11.3125-11.3125l18.34375-18.34375L106.33887,109.6543a7.99915,7.99915,0,0,1,11.3125-11.3125l18.34375,18.34375L154.33887,98.3418a7.99915,7.99915,0,0,1,11.3125,11.3125l-18.34375,18.34375Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M61.66958,204.116,16,128l45.66958-76.116a8,8,0,0,1,6.85994-3.884H216a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H68.52952A8,8,0,0,1,61.66958,204.116Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "104.00005",
      "x2": "112",
      "y2": "152.00005",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "152.00005",
      "x2": "112",
      "y2": "104.00005",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M61.66958,204.116,16,128l45.66958-76.116a8,8,0,0,1,6.85994-3.884H216a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H68.52952A8,8,0,0,1,61.66958,204.116Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "104.00005",
      "x2": "112",
      "y2": "152.00005",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "152.00005",
      "x2": "112",
      "y2": "104.00005",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M61.66958,204.116,16,128l45.66958-76.116a8,8,0,0,1,6.85994-3.884H216a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H68.52952A8,8,0,0,1,61.66958,204.116Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "104.00005",
      "x2": "112",
      "y2": "152.00005",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "152.00005",
      "x2": "112",
      "y2": "104.00005",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1Y = [];
/* style */

const __vue_inject_styles__$1Y = undefined;
/* scoped */

const __vue_scope_id__$1Y = undefined;
/* module identifier */

const __vue_module_identifier__$1Y = undefined;
/* functional template */

const __vue_is_functional_template__$1Y = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1Y = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1Y,
  staticRenderFns: __vue_staticRenderFns__$1Y
}, __vue_inject_styles__$1Y, __vue_script__$1Y, __vue_scope_id__$1Y, __vue_is_functional_template__$1Y, __vue_module_identifier__$1Y, false, undefined, undefined, undefined);

var script$1Z = Vue.extend({
  name: "PhBag",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1Z = script$1Z;
/* template */

var __vue_render__$1Z = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "144",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,104V72a40,40,0,0,1,80,0v32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "144",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "144",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,104V72a40,40,0,0,1,80,0v32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,64H175.3208a47.99073,47.99073,0,0,0-94.6416,0H40A16.01833,16.01833,0,0,0,24,80V208a16.01833,16.01833,0,0,0,16,16H216a16.01833,16.01833,0,0,0,16-16V80A16.01833,16.01833,0,0,0,216,64ZM95.99219,104a8,8,0,0,1-16,0V88a8,8,0,0,1,16,0ZM97.0127,64a32.00443,32.00443,0,0,1,61.9746,0Zm78.97949,40a8,8,0,0,1-16,0V88a8,8,0,0,1,16,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "144",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,104V72a40,40,0,0,1,80,0v32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "144",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,104V72a40,40,0,0,1,80,0v32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "144",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,104V72a40,40,0,0,1,80,0v32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1Z = [];
/* style */

const __vue_inject_styles__$1Z = undefined;
/* scoped */

const __vue_scope_id__$1Z = undefined;
/* module identifier */

const __vue_module_identifier__$1Z = undefined;
/* functional template */

const __vue_is_functional_template__$1Z = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1Z = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1Z,
  staticRenderFns: __vue_staticRenderFns__$1Z
}, __vue_inject_styles__$1Z, __vue_script__$1Z, __vue_scope_id__$1Z, __vue_is_functional_template__$1Z, __vue_module_identifier__$1Z, false, undefined, undefined, undefined);

var script$1_ = Vue.extend({
  name: "PhBagSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1_ = script$1_;
/* template */

var __vue_render__$1_ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "144",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,72a40,40,0,0,1,80,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "144",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "144",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,72a40,40,0,0,1,80,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,64H175.3208a47.99073,47.99073,0,0,0-94.6416,0H40A16.01833,16.01833,0,0,0,24,80V208a16.01833,16.01833,0,0,0,16,16H216a16.01833,16.01833,0,0,0,16-16V80A16.01833,16.01833,0,0,0,216,64ZM128,40a32.05773,32.05773,0,0,1,30.9873,24H97.0127A32.05773,32.05773,0,0,1,128,40Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "144",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,72a40,40,0,0,1,80,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "144",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,72a40,40,0,0,1,80,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "144",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,72a40,40,0,0,1,80,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1_ = [];
/* style */

const __vue_inject_styles__$1_ = undefined;
/* scoped */

const __vue_scope_id__$1_ = undefined;
/* module identifier */

const __vue_module_identifier__$1_ = undefined;
/* functional template */

const __vue_is_functional_template__$1_ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1_ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1_,
  staticRenderFns: __vue_staticRenderFns__$1_
}, __vue_inject_styles__$1_, __vue_script__$1_, __vue_scope_id__$1_, __vue_is_functional_template__$1_, __vue_module_identifier__$1_, false, undefined, undefined, undefined);

var script$1$ = Vue.extend({
  name: "PhBandaids",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1$ = script$1$;
/* template */

var __vue_render__$1$ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M49.37258,94.62742A32,32,0,0,1,94.62742,49.37258l112,112a32,32,0,0,1-45.25484,45.25484Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M161.37258,49.37258a32,32,0,0,1,45.25484,45.25484l-112,112a32,32,0,0,1-45.25484-45.25484Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M206.62744,94.62744a32,32,0,0,0-45.25488-45.25488L128,82.74512,173.25488,128Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M49.37256,161.37256a32,32,0,0,0,45.25488,45.25488L128,173.25488,82.74512,128Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M94.62744,49.37256A32,32,0,0,0,49.37256,94.62744L82.74512,128,128,82.74512Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M173.25488,128,128,173.25488l33.37256,33.37256a32,32,0,0,0,45.25488-45.25488Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M49.37258,94.62742A32,32,0,0,1,94.62742,49.37258l112,112a32,32,0,0,1-45.25484,45.25484Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M161.37258,49.37258a32,32,0,0,1,45.25484,45.25484l-112,112a32,32,0,0,1-45.25484-45.25484Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16",
      "opacity": "0.5"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184.56836,128l27.71582-27.71558a40,40,0,1,0-56.56836-56.5686L128,71.43164,100.28418,43.71582a39.99987,39.99987,0,1,0-56.56836,56.56836L71.43164,128,43.71582,155.71558a40,40,0,1,0,56.56836,56.5686L128,184.56836l27.71582,27.71582a39.99987,39.99987,0,1,0,56.56836-56.56836ZM128,94.05957,161.94043,128,128,161.94043,94.05957,128ZM167.03027,55.0293a23.99951,23.99951,0,1,1,33.93946,33.9414L173.25439,116.686,139.314,82.74561ZM88.96973,200.9707a23.99951,23.99951,0,1,1-33.93946-33.9414L82.74561,139.314,116.686,173.25439Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M49.37258,94.62742A32,32,0,0,1,94.62742,49.37258l112,112a32,32,0,0,1-45.25484,45.25484Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M161.37258,49.37258a32,32,0,0,1,45.25484,45.25484l-112,112a32,32,0,0,1-45.25484-45.25484Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12",
      "opacity": "0.5"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M161.37258,49.37258a32,32,0,0,1,45.25484,45.25484l-112,112a32,32,0,0,1-45.25484-45.25484Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M49.37258,94.62742A32,32,0,0,1,94.62742,49.37258l112,112a32,32,0,0,1-45.25484,45.25484Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8",
      "opacity": "0.5"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M49.37258,94.62742A32,32,0,0,1,94.62742,49.37258l112,112a32,32,0,0,1-45.25484,45.25484Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M161.37258,49.37258a32,32,0,0,1,45.25484,45.25484l-112,112a32,32,0,0,1-45.25484-45.25484Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16",
      "opacity": "0.5"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1$ = [];
/* style */

const __vue_inject_styles__$1$ = undefined;
/* scoped */

const __vue_scope_id__$1$ = undefined;
/* module identifier */

const __vue_module_identifier__$1$ = undefined;
/* functional template */

const __vue_is_functional_template__$1$ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1$ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1$,
  staticRenderFns: __vue_staticRenderFns__$1$
}, __vue_inject_styles__$1$, __vue_script__$1$, __vue_scope_id__$1$, __vue_is_functional_template__$1$, __vue_module_identifier__$1$, false, undefined, undefined, undefined);

var script$20 = Vue.extend({
  name: "PhBank",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$20 = script$20;
/* template */

var __vue_render__$20 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "24.002 96 232.002 96 128.002 32 24.002 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56.00244",
      "y1": "96",
      "x2": "56.00244",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104.00244",
      "y1": "96",
      "x2": "104.00244",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152.00244",
      "y1": "96",
      "x2": "152.00244",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200.00244",
      "y1": "96",
      "x2": "200.00244",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32.00244",
      "y1": "168",
      "x2": "224.00244",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16.00244",
      "y1": "208",
      "x2": "240.00244",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "24.002 96 232.002 96 128.002 32 24.002 96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "24.002 96 232.002 96 128.002 32 24.002 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56.00244",
      "y1": "96",
      "x2": "56.00244",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104.00244",
      "y1": "96",
      "x2": "104.00244",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152.00244",
      "y1": "96",
      "x2": "152.00244",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200.00244",
      "y1": "96",
      "x2": "200.00244",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32.00244",
      "y1": "176",
      "x2": "224.00244",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16.00244",
      "y1": "208",
      "x2": "240.00244",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M248.00244,208a8.00039,8.00039,0,0,1-8,8h-224a8,8,0,0,1,0-16h224A8.00039,8.00039,0,0,1,248.00244,208ZM16.30518,98.17871a7.99868,7.99868,0,0,1,3.50488-8.99219l104-64a7.9998,7.9998,0,0,1,8.38476,0l104,64A8.0001,8.0001,0,0,1,232.00244,104h-24v64h16a8,8,0,0,1,0,16h-192a8,8,0,0,1,0-16h16V104h-24A7.999,7.999,0,0,1,16.30518,98.17871ZM144.00244,160a8,8,0,0,0,16,0V112a8,8,0,1,0-16,0Zm-48,0a8,8,0,0,0,16,0V112a8,8,0,0,0-16,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "24.002 96 232.002 96 128.002 32 24.002 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56.00244",
      "y1": "96",
      "x2": "56.00244",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104.00244",
      "y1": "96",
      "x2": "104.00244",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152.00244",
      "y1": "96",
      "x2": "152.00244",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200.00244",
      "y1": "96",
      "x2": "200.00244",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32.00244",
      "y1": "176",
      "x2": "224.00244",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16.00244",
      "y1": "208",
      "x2": "240.00244",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "24.002 96 232.002 96 128.002 32 24.002 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56.00244",
      "y1": "96",
      "x2": "56.00244",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104.00244",
      "y1": "96",
      "x2": "104.00244",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152.00244",
      "y1": "96",
      "x2": "152.00244",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200.00244",
      "y1": "96",
      "x2": "200.00244",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32.00244",
      "y1": "176",
      "x2": "224.00244",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16.00244",
      "y1": "208",
      "x2": "240.00244",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "24.002 96 232.002 96 128.002 32 24.002 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56.00244",
      "y1": "96",
      "x2": "56.00244",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104.00244",
      "y1": "96",
      "x2": "104.00244",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152.00244",
      "y1": "96",
      "x2": "152.00244",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200.00244",
      "y1": "96",
      "x2": "200.00244",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32.00244",
      "y1": "176",
      "x2": "224.00244",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16.00244",
      "y1": "208",
      "x2": "240.00244",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$20 = [];
/* style */

const __vue_inject_styles__$20 = undefined;
/* scoped */

const __vue_scope_id__$20 = undefined;
/* module identifier */

const __vue_module_identifier__$20 = undefined;
/* functional template */

const __vue_is_functional_template__$20 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$20 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$20,
  staticRenderFns: __vue_staticRenderFns__$20
}, __vue_inject_styles__$20, __vue_script__$20, __vue_scope_id__$20, __vue_is_functional_template__$20, __vue_module_identifier__$20, false, undefined, undefined, undefined);

var script$21 = Vue.extend({
  name: "PhBarbell",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$21 = script$21;
/* template */

var __vue_render__$21 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "60",
      "y": "56",
      "width": "40",
      "height": "144",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "156",
      "y": "56",
      "width": "40",
      "height": "144",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M196,80h28a8,8,0,0,1,8,8v80a8,8,0,0,1-8,8H196",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M60,176H32a8,8,0,0,1-8-8V88a8,8,0,0,1,8-8H60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "128",
      "x2": "156",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "128",
      "x2": "244",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "128",
      "x2": "24",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "56",
      "y": "56",
      "width": "40",
      "height": "144",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "160",
      "y": "56",
      "width": "40",
      "height": "144",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "56",
      "y": "56",
      "width": "40",
      "height": "144",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "160",
      "y": "56",
      "width": "40",
      "height": "144",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,80h24a8,8,0,0,1,8,8v80a8,8,0,0,1-8,8H200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,176H32a8,8,0,0,1-8-8V88a8,8,0,0,1,8-8H56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "128",
      "x2": "160",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "128",
      "x2": "248",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "8",
      "y1": "128",
      "x2": "24",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M248,120h-8V88a16.01833,16.01833,0,0,0-16-16H208V64a16.01833,16.01833,0,0,0-16-16H168a16.01833,16.01833,0,0,0-16,16v56H104V64A16.01833,16.01833,0,0,0,88,48H64A16.01833,16.01833,0,0,0,48,64v8H32A16.01833,16.01833,0,0,0,16,88v32H8a8,8,0,0,0,0,16h8v32a16.01833,16.01833,0,0,0,16,16H48v8a16.01833,16.01833,0,0,0,16,16H88a16.01833,16.01833,0,0,0,16-16V136h48v56a16.01833,16.01833,0,0,0,16,16h24a16.01833,16.01833,0,0,0,16-16v-8h16a16.01833,16.01833,0,0,0,16-16V136h8a8,8,0,0,0,0-16ZM32,168V88H48v80Zm192,0H208V88h16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "56",
      "y": "56",
      "width": "40",
      "height": "144",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "160",
      "y": "56",
      "width": "40",
      "height": "144",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,80h24a8,8,0,0,1,8,8v80a8,8,0,0,1-8,8H200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,176H32a8,8,0,0,1-8-8V88a8,8,0,0,1,8-8H56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "128",
      "x2": "160",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "128",
      "x2": "248",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "8",
      "y1": "128",
      "x2": "24",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "56",
      "y": "56",
      "width": "40",
      "height": "144",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "160",
      "y": "56",
      "width": "40",
      "height": "144",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,80h24a8,8,0,0,1,8,8v80a8,8,0,0,1-8,8H200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,176H32a8,8,0,0,1-8-8V88a8,8,0,0,1,8-8H56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "128",
      "x2": "160",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "128",
      "x2": "248",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "8",
      "y1": "128",
      "x2": "24",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "56",
      "y": "56",
      "width": "40",
      "height": "144",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "160",
      "y": "56",
      "width": "40",
      "height": "144",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,80h24a8,8,0,0,1,8,8v80a8,8,0,0,1-8,8H200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,176H32a8,8,0,0,1-8-8V88a8,8,0,0,1,8-8H56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "128",
      "x2": "160",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "128",
      "x2": "248",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "8",
      "y1": "128",
      "x2": "24",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$21 = [];
/* style */

const __vue_inject_styles__$21 = undefined;
/* scoped */

const __vue_scope_id__$21 = undefined;
/* module identifier */

const __vue_module_identifier__$21 = undefined;
/* functional template */

const __vue_is_functional_template__$21 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$21 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$21,
  staticRenderFns: __vue_staticRenderFns__$21
}, __vue_inject_styles__$21, __vue_script__$21, __vue_scope_id__$21, __vue_is_functional_template__$21, __vue_module_identifier__$21, false, undefined, undefined, undefined);

var script$22 = Vue.extend({
  name: "PhBarcode",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$22 = script$22;
/* template */

var __vue_render__$22 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "180 52 220 52 220 92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "76 204 36 204 36 164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "220 164 220 204 180 204",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "36 92 36 52 76 52",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "92",
      "x2": "88",
      "y2": "164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "92",
      "x2": "168",
      "y2": "164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "92",
      "x2": "128",
      "y2": "164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "184 48 224 48 224 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "72 208 32 208 32 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "224 168 224 208 184 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "32 88 32 48 72 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "88",
      "x2": "80",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "88",
      "x2": "176",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "88",
      "x2": "144",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "88",
      "x2": "112",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M224,40H184a8,8,0,0,0,0,16h32V88a8,8,0,0,0,16,0V48A8.00039,8.00039,0,0,0,224,40Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,200H40V168a8,8,0,0,0-16,0v40a8.00039,8.00039,0,0,0,8,8H72a8,8,0,0,0,0-16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,160a8.00039,8.00039,0,0,0-8,8v32H184a8,8,0,0,0,0,16h40a8.00039,8.00039,0,0,0,8-8V168A8.00039,8.00039,0,0,0,224,160Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,96a8.00039,8.00039,0,0,0,8-8V56H72a8,8,0,0,0,0-16H32a8.00039,8.00039,0,0,0-8,8V88A8.00039,8.00039,0,0,0,32,96Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,80a8.00039,8.00039,0,0,0-8,8v80a8,8,0,0,0,16,0V88A8.00039,8.00039,0,0,0,80,80Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,168V88a8,8,0,0,0-16,0v80a8,8,0,0,0,16,0Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M144,80a8.00039,8.00039,0,0,0-8,8v80a8,8,0,0,0,16,0V88A8.00039,8.00039,0,0,0,144,80Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112,80a8.00039,8.00039,0,0,0-8,8v80a8,8,0,0,0,16,0V88A8.00039,8.00039,0,0,0,112,80Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "184 48 224 48 224 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "72 208 32 208 32 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "224 168 224 208 184 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "32 88 32 48 72 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "88",
      "x2": "80",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "88",
      "x2": "176",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "88",
      "x2": "144",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "88",
      "x2": "112",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "184 48 224 48 224 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "72 208 32 208 32 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "224 168 224 208 184 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "32 88 32 48 72 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "88",
      "x2": "80",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "88",
      "x2": "176",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "88",
      "x2": "144",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "88",
      "x2": "112",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "184 48 224 48 224 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "72 208 32 208 32 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "224 168 224 208 184 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "32 88 32 48 72 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "88",
      "x2": "80",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "88",
      "x2": "176",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "88",
      "x2": "144",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "88",
      "x2": "112",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$22 = [];
/* style */

const __vue_inject_styles__$22 = undefined;
/* scoped */

const __vue_scope_id__$22 = undefined;
/* module identifier */

const __vue_module_identifier__$22 = undefined;
/* functional template */

const __vue_is_functional_template__$22 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$22 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$22,
  staticRenderFns: __vue_staticRenderFns__$22
}, __vue_inject_styles__$22, __vue_script__$22, __vue_scope_id__$22, __vue_is_functional_template__$22, __vue_module_identifier__$22, false, undefined, undefined, undefined);

var script$23 = Vue.extend({
  name: "PhBaseball",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$23 = script$23;
/* template */

var __vue_render__$23 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M181.19142,79.40281a96.385,96.385,0,0,1,14.80852-19.167",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M196,195.76425a96.38487,96.38487,0,0,1-14.80811-19.16636",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168.74273,140a97.31136,97.31136,0,0,1,0-24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('g', [_c('path', {
    attrs: {
      "d": "M74.80858,79.40281a96.385,96.385,0,0,0-14.80852-19.167",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M60.00005,195.76425a96.38487,96.38487,0,0,0,14.80811-19.16636",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M87.25728,140A96.9478,96.9478,0,0,0,88,128a96.94587,96.94587,0,0,0-.74152-11.9903",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })])]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M60.05889,195.90664a96,96,0,0,1-.11775-135.64655l0,0a95.69768,95.69768,0,0,1,28,67.76427,95.69771,95.69771,0,0,1-27.99925,67.76355Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M196.05884,195.90664a96,96,0,0,1-.11776-135.64655l0,0a96,96,0,0,1,.00073,135.52782Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M169.172,113.03177a96.58913,96.58913,0,0,1,3.80409-15.5448",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M172.975,158.5097a96.58848,96.58848,0,0,1-3.80352-15.54493",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M86.828,113.03177A96.58913,96.58913,0,0,0,83.02388,97.487",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M83.025,158.5097a96.58848,96.58848,0,0,0,3.80352-15.54493",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M186.79812,70.93634a96.59069,96.59069,0,0,1,9.20058-10.701",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M195.999,195.765a96.59178,96.59178,0,0,1-9.20291-10.70411",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M60.0012,195.76479A96.5897,96.5897,0,0,0,69.204,185.06084",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M69.20188,70.93634A96.59162,96.59162,0,0,0,60.001,60.235",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M207.24951,60.73486c-.02392.021-.04468.044-.06885.06446a88.76639,88.76639,0,0,0-10.37841,10.37841,8.0001,8.0001,0,1,1-12.21289-10.33691,104.79143,104.79143,0,0,1,11.3872-11.48828,103.80743,103.80743,0,0,0-135.95312,0,104.83246,104.83246,0,0,1,11.387,11.48779,8.00014,8.00014,0,0,1-6.102,13.169h-.00366a7.98253,7.98253,0,0,1-6.10987-2.83106A88.78841,88.78841,0,0,0,48.81592,60.7998c-.02368-.02-.0437-.04248-.0669-.0625a103.77819,103.77819,0,0,0,0,134.52588c.02417-.021.04493-.04443.06958-.06543A88.82286,88.82286,0,0,0,59.197,184.81934,8.00144,8.00144,0,0,1,71.4126,195.15723a104.89749,104.89749,0,0,1-11.38916,11.49023,103.80743,103.80743,0,0,0,135.95312,0,104.83154,104.83154,0,0,1-11.38916-11.49023,8,8,0,1,1,12.21192-10.33789,88.76639,88.76639,0,0,0,10.37841,10.37841c.02539.02149.04688.04541.07178.0669a103.77881,103.77881,0,0,0,0-134.52979ZM79.62866,87.97949A7.99764,7.99764,0,0,1,89.866,92.80518a104.86829,104.86829,0,0,1,4.4851,16.73877,8.00663,8.00663,0,0,1-7.88159,9.42431h-.00366a8.00242,8.00242,0,0,1-7.863-6.57861,88.81047,88.81047,0,0,0-3.79907-14.17676A8.00027,8.00027,0,0,1,79.62866,87.97949Zm14.72315,58.47315a104.886,104.886,0,0,1-4.48487,16.73925,8.003,8.003,0,0,1-7.52954,5.29834h-.00366a8.00492,8.00492,0,0,1-7.52905-10.70556,88.874,88.874,0,0,0,3.79883-14.17774,8.00167,8.00167,0,0,1,15.74829,2.84571Zm82.01391,21.56494a7.993,7.993,0,0,1-10.23291-4.82569,104.83662,104.83662,0,0,1-4.48486-16.73925,8.00011,8.00011,0,0,1,15.74512-2.84571,88.80709,88.80709,0,0,0,3.79834,14.17774A8.00013,8.00013,0,0,1,176.36572,168.01758Zm4.82666-69.8042a88.82819,88.82819,0,0,0-3.79883,14.17676,8.00019,8.00019,0,1,1-15.74511-2.84668,104.80436,104.80436,0,0,1,4.48633-16.73926,7.99986,7.99986,0,1,1,15.05761,5.40918Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M169.172,113.03177a96.58913,96.58913,0,0,1,3.80409-15.5448",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M172.975,158.5097a96.58848,96.58848,0,0,1-3.80352-15.54493",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M86.828,113.03177A96.58913,96.58913,0,0,0,83.02388,97.487",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M83.025,158.5097a96.58848,96.58848,0,0,0,3.80352-15.54493",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M186.79812,70.93634a96.59069,96.59069,0,0,1,9.20058-10.701",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M195.999,195.765a96.59178,96.59178,0,0,1-9.20291-10.70411",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M60.0012,195.76479A96.5897,96.5897,0,0,0,69.204,185.06084",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M69.20188,70.93634A96.59162,96.59162,0,0,0,60.001,60.235",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M169.172,113.03177a96.58913,96.58913,0,0,1,3.80409-15.5448",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M172.975,158.5097a96.58848,96.58848,0,0,1-3.80352-15.54493",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M86.828,113.03177A96.58913,96.58913,0,0,0,83.02388,97.487",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M83.025,158.5097a96.58848,96.58848,0,0,0,3.80352-15.54493",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M186.79812,70.93634a96.59069,96.59069,0,0,1,9.20058-10.701",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M195.999,195.765a96.59178,96.59178,0,0,1-9.20291-10.70411",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M60.0012,195.76479A96.5897,96.5897,0,0,0,69.204,185.06084",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M69.20188,70.93634A96.59162,96.59162,0,0,0,60.001,60.235",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M169.172,113.03177a96.58913,96.58913,0,0,1,3.80409-15.5448",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M172.975,158.5097a96.58848,96.58848,0,0,1-3.80352-15.54493",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M86.828,113.03177A96.58913,96.58913,0,0,0,83.02388,97.487",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M83.025,158.5097a96.58848,96.58848,0,0,0,3.80352-15.54493",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M186.79812,70.93634a96.59069,96.59069,0,0,1,9.20058-10.701",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M195.999,195.765a96.59178,96.59178,0,0,1-9.20291-10.70411",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M60.0012,195.76479A96.5897,96.5897,0,0,0,69.204,185.06084",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M69.20188,70.93634A96.59162,96.59162,0,0,0,60.001,60.235",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$23 = [];
/* style */

const __vue_inject_styles__$23 = undefined;
/* scoped */

const __vue_scope_id__$23 = undefined;
/* module identifier */

const __vue_module_identifier__$23 = undefined;
/* functional template */

const __vue_is_functional_template__$23 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$23 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$23,
  staticRenderFns: __vue_staticRenderFns__$23
}, __vue_inject_styles__$23, __vue_script__$23, __vue_scope_id__$23, __vue_is_functional_template__$23, __vue_module_identifier__$23, false, undefined, undefined, undefined);

var script$24 = Vue.extend({
  name: "PhBasketball",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$24 = script$24;
/* template */

var __vue_render__$24 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M60,60.23573A95.69771,95.69771,0,0,1,88,128a95.69767,95.69767,0,0,1-27.99925,67.76354",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M196,60.23573a96,96,0,0,0-.00072,135.52781",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "128",
      "x2": "224",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "32",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M60.05889,195.90664a96,96,0,0,1-.11775-135.64655l0,0a95.69768,95.69768,0,0,1,28,67.76427,95.69771,95.69771,0,0,1-27.99925,67.76355Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M196.05884,195.90664a96,96,0,0,1-.11776-135.64655l0,0a96,96,0,0,1,.00073,135.52782Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M60,60.23573A95.69771,95.69771,0,0,1,88,128a95.69767,95.69767,0,0,1-27.99925,67.76354",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M196,60.23573a96,96,0,0,0-.00072,135.52781",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "128",
      "x2": "224",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "32",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M59.99512,49.37646A103.57046,103.57046,0,0,1,120,24.30469V120H95.69531A103.84891,103.84891,0,0,0,59.99512,49.37646ZM48.71558,60.77637A103.54348,103.54348,0,0,0,24.30469,120H79.63257A87.91116,87.91116,0,0,0,48.71558,60.77637Zm147.2893-11.39991A103.57046,103.57046,0,0,0,136,24.30469V120h24.30469A103.84891,103.84891,0,0,1,196.00488,49.37646ZM231.69531,120a103.54348,103.54348,0,0,0-24.41089-59.22363A87.91116,87.91116,0,0,0,176.36743,120ZM24.30469,136a103.54348,103.54348,0,0,0,24.41089,59.22363A87.91116,87.91116,0,0,0,79.63257,136Zm182.97973,59.22363A103.54348,103.54348,0,0,0,231.69531,136H176.36743A87.91116,87.91116,0,0,0,207.28442,195.22363ZM59.99512,206.62354A103.57046,103.57046,0,0,0,120,231.69531V136H95.69531A103.84891,103.84891,0,0,1,59.99512,206.62354ZM160.30469,136H136v95.69531a103.57046,103.57046,0,0,0,60.00488-25.07177A103.84891,103.84891,0,0,1,160.30469,136Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M60,60.23573A95.69771,95.69771,0,0,1,88,128a95.69767,95.69767,0,0,1-27.99925,67.76354",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M196,60.23573a96,96,0,0,0-.00072,135.52781",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "128",
      "x2": "224",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "32",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M60,60.23573A95.69771,95.69771,0,0,1,88,128a95.69767,95.69767,0,0,1-27.99925,67.76354",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M196,60.23573a96,96,0,0,0-.00072,135.52781",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "128",
      "x2": "224",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "32",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M60,60.23573A95.69771,95.69771,0,0,1,88,128a95.69767,95.69767,0,0,1-27.99925,67.76354",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M196,60.23573a96,96,0,0,0-.00072,135.52781",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "128",
      "x2": "224",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "32",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$24 = [];
/* style */

const __vue_inject_styles__$24 = undefined;
/* scoped */

const __vue_scope_id__$24 = undefined;
/* module identifier */

const __vue_module_identifier__$24 = undefined;
/* functional template */

const __vue_is_functional_template__$24 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$24 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$24,
  staticRenderFns: __vue_staticRenderFns__$24
}, __vue_inject_styles__$24, __vue_script__$24, __vue_scope_id__$24, __vue_is_functional_template__$24, __vue_module_identifier__$24, false, undefined, undefined, undefined);

var script$25 = Vue.extend({
  name: "PhBatteryCharging",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$25 = script$25;
/* template */

var __vue_render__$25 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "46",
      "y": "38",
      "width": "144",
      "height": "180",
      "rx": "16",
      "transform": "translate(246 10) rotate(90)",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "244",
      "y1": "96",
      "x2": "244",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "118 168 134 128 102 128 118 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "268",
      "x2": "160",
      "y2": "268",
      "fill": "none",
      "opacity": "0.1",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24",
      "stroke": _vm.displayColor
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "52",
      "y": "36",
      "width": "144",
      "height": "184",
      "rx": "16",
      "transform": "translate(252 4) rotate(90)",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "248",
      "y1": "96",
      "x2": "248",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "52",
      "y": "36",
      "width": "144",
      "height": "184",
      "rx": "16",
      "transform": "translate(252 4) rotate(90)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "124 168 140 128 108 128 124 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M248,88a8.00008,8.00008,0,0,0-8,8v64a8,8,0,0,0,16,0V96A8.00008,8.00008,0,0,0,248,88Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,47.99805H48a24.02624,24.02624,0,0,0-24,24v112a24.02624,24.02624,0,0,0,24,24H200a24.02625,24.02625,0,0,0,24-24v-112A24.02624,24.02624,0,0,0,200,47.99805ZM147.42187,130.9668l-16,40a7.99361,7.99361,0,1,1-14.84375-5.9375l11.60938-29.03125H108a7.99271,7.99271,0,0,1-7.42188-10.96875l16-40a7.99361,7.99361,0,1,1,14.84375,5.9375L119.8125,119.99805H140a7.9927,7.9927,0,0,1,7.42187,10.96875Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "248",
      "y1": "96",
      "x2": "248",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "52",
      "y": "36",
      "width": "144",
      "height": "184",
      "rx": "16",
      "transform": "translate(252 4) rotate(90)",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "124 168 140 128 108 128 124 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "248",
      "y1": "96",
      "x2": "248",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "52",
      "y": "36",
      "width": "144",
      "height": "184",
      "rx": "16",
      "transform": "translate(252 4) rotate(90)",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "124 168 140 128 108 128 124 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "248",
      "y1": "96",
      "x2": "248",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "52",
      "y": "36",
      "width": "144",
      "height": "184",
      "rx": "16",
      "transform": "translate(252 4) rotate(90)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "124 168 140 128 108 128 124 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$25 = [];
/* style */

const __vue_inject_styles__$25 = undefined;
/* scoped */

const __vue_scope_id__$25 = undefined;
/* module identifier */

const __vue_module_identifier__$25 = undefined;
/* functional template */

const __vue_is_functional_template__$25 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$25 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$25,
  staticRenderFns: __vue_staticRenderFns__$25
}, __vue_inject_styles__$25, __vue_script__$25, __vue_scope_id__$25, __vue_is_functional_template__$25, __vue_module_identifier__$25, false, undefined, undefined, undefined);

var script$26 = Vue.extend({
  name: "PhBatteryChargingVertical",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$26 = script$26;
/* template */

var __vue_render__$26 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "100",
      "y1": "12",
      "x2": "156",
      "y2": "12",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "56.00586",
      "y": "48",
      "width": "144",
      "height": "180",
      "rx": "16",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 178 144 138 112 138 128 98",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "56",
      "y": "40",
      "width": "144",
      "height": "184",
      "rx": "16",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "8",
      "x2": "160",
      "y2": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "56",
      "y": "40",
      "width": "144",
      "height": "184",
      "rx": "16",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 172 144 132 112 132 128 92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M96,16h64a8,8,0,0,0,0-16H96a8,8,0,0,0,0,16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,32.00781H72a24.02625,24.02625,0,0,0-24,24v152a24.02624,24.02624,0,0,0,24,24H184a24.02624,24.02624,0,0,0,24-24v-152A24.02624,24.02624,0,0,0,184,32.00781ZM151.42969,134.97656l-16,40a8.00086,8.00086,0,0,1-14.85938-5.9375l11.61719-29.03125L112,139.99219a8.001,8.001,0,0,1-7.42969-10.96875l16-39.98438a8.00086,8.00086,0,0,1,14.85938,5.9375L123.8125,123.99219,144,124.00781a8.001,8.001,0,0,1,7.42969,10.96875Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "8",
      "x2": "160",
      "y2": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "56",
      "y": "40",
      "width": "144",
      "height": "184",
      "rx": "16",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 172 144 132 112 132 128 92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "8",
      "x2": "160",
      "y2": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "56",
      "y": "40",
      "width": "144",
      "height": "184",
      "rx": "16",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 172 144 132 112 132 128 92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "8",
      "x2": "160",
      "y2": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "56",
      "y": "40",
      "width": "144",
      "height": "184",
      "rx": "16",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 172 144 132 112 132 128 92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$26 = [];
/* style */

const __vue_inject_styles__$26 = undefined;
/* scoped */

const __vue_scope_id__$26 = undefined;
/* module identifier */

const __vue_module_identifier__$26 = undefined;
/* functional template */

const __vue_is_functional_template__$26 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$26 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$26,
  staticRenderFns: __vue_staticRenderFns__$26
}, __vue_inject_styles__$26, __vue_script__$26, __vue_scope_id__$26, __vue_is_functional_template__$26, __vue_module_identifier__$26, false, undefined, undefined, undefined);

var script$27 = Vue.extend({
  name: "PhBatteryEmpty",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$27 = script$27;
/* template */

var __vue_render__$27 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "46",
      "y": "38",
      "width": "144",
      "height": "180",
      "rx": "16",
      "transform": "translate(246 10) rotate(90)",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "244",
      "y1": "96",
      "x2": "244",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "52",
      "y": "36",
      "width": "144",
      "height": "184",
      "rx": "16",
      "transform": "translate(252 4) rotate(90)",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "248",
      "y1": "96",
      "x2": "248",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "52",
      "y": "36",
      "width": "144",
      "height": "184",
      "rx": "16",
      "transform": "translate(252 4) rotate(90)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M248,88a8.00008,8.00008,0,0,0-8,8v64a8,8,0,0,0,16,0V96A8.00008,8.00008,0,0,0,248,88Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,48H48A24.0275,24.0275,0,0,0,24,72V184a24.0275,24.0275,0,0,0,24,24H200a24.0275,24.0275,0,0,0,24-24V72A24.0275,24.0275,0,0,0,200,48Zm8,136a8.00917,8.00917,0,0,1-8,8H48a8.00917,8.00917,0,0,1-8-8V72a8.00917,8.00917,0,0,1,8-8H200a8.00917,8.00917,0,0,1,8,8Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "248",
      "y1": "96",
      "x2": "248",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "52",
      "y": "36",
      "width": "144",
      "height": "184",
      "rx": "16",
      "transform": "translate(252 4) rotate(90)",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "248",
      "y1": "96",
      "x2": "248",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "52",
      "y": "36",
      "width": "144",
      "height": "184",
      "rx": "16",
      "transform": "translate(252 4) rotate(90)",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "248",
      "y1": "96",
      "x2": "248",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "52",
      "y": "36",
      "width": "144",
      "height": "184",
      "rx": "16",
      "transform": "translate(252 4) rotate(90)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$27 = [];
/* style */

const __vue_inject_styles__$27 = undefined;
/* scoped */

const __vue_scope_id__$27 = undefined;
/* module identifier */

const __vue_module_identifier__$27 = undefined;
/* functional template */

const __vue_is_functional_template__$27 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$27 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$27,
  staticRenderFns: __vue_staticRenderFns__$27
}, __vue_inject_styles__$27, __vue_script__$27, __vue_scope_id__$27, __vue_is_functional_template__$27, __vue_module_identifier__$27, false, undefined, undefined, undefined);

var script$28 = Vue.extend({
  name: "PhBatteryFull",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$28 = script$28;
/* template */

var __vue_render__$28 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "46",
      "y": "38",
      "width": "144",
      "height": "180",
      "rx": "16",
      "transform": "translate(246 10) rotate(90)",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "164",
      "x2": "64",
      "y2": "92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "164",
      "x2": "100",
      "y2": "92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "164",
      "x2": "136",
      "y2": "92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "172",
      "y1": "164",
      "x2": "172",
      "y2": "92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "244",
      "y1": "96",
      "x2": "244",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "52",
      "y": "36",
      "width": "144",
      "height": "184",
      "rx": "16",
      "transform": "translate(252 4) rotate(90)",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "248",
      "y1": "96",
      "x2": "248",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "52",
      "y": "36",
      "width": "144",
      "height": "184",
      "rx": "16",
      "transform": "translate(252 4) rotate(90)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "142.4",
      "y1": "168.00043",
      "x2": "142.4",
      "y2": "88.00043",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "105.6",
      "y1": "168.00043",
      "x2": "105.6",
      "y2": "88.00043",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "68.8",
      "y1": "168.00043",
      "x2": "68.8",
      "y2": "88.00043",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "179.2",
      "y1": "168.00043",
      "x2": "179.2",
      "y2": "88.00043",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M248,88a7.99977,7.99977,0,0,0-8,8v64a8,8,0,0,0,16,0V96A7.99977,7.99977,0,0,0,248,88Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,48H48A24.0275,24.0275,0,0,0,24,72V184a24.0275,24.0275,0,0,0,24,24H200a24.0275,24.0275,0,0,0,24-24V72A24.0275,24.0275,0,0,0,200,48Zm8,136a8.00917,8.00917,0,0,1-8,8H48a8.00917,8.00917,0,0,1-8-8V72a8.00917,8.00917,0,0,1,8-8H200a8.00917,8.00917,0,0,1,8,8Z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "56",
      "y": "80.00049",
      "width": "136",
      "height": "96",
      "rx": "8"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "248",
      "y1": "96",
      "x2": "248",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "52",
      "y": "36",
      "width": "144",
      "height": "184",
      "rx": "16",
      "transform": "translate(252 4) rotate(90)",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "142.4",
      "y1": "168.00043",
      "x2": "142.4",
      "y2": "88.00043",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "105.6",
      "y1": "168.00043",
      "x2": "105.6",
      "y2": "88.00043",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "68.8",
      "y1": "168.00043",
      "x2": "68.8",
      "y2": "88.00043",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "179.2",
      "y1": "168.00043",
      "x2": "179.2",
      "y2": "88.00043",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "248",
      "y1": "96",
      "x2": "248",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "52",
      "y": "36",
      "width": "144",
      "height": "184",
      "rx": "16",
      "transform": "translate(252 4) rotate(90)",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "142.4",
      "y1": "168.00043",
      "x2": "142.4",
      "y2": "88.00043",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "105.6",
      "y1": "168.00043",
      "x2": "105.6",
      "y2": "88.00043",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "68.8",
      "y1": "168.00043",
      "x2": "68.8",
      "y2": "88.00043",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "179.2",
      "y1": "168.00043",
      "x2": "179.2",
      "y2": "88.00043",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "248",
      "y1": "96",
      "x2": "248",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "52",
      "y": "36",
      "width": "144",
      "height": "184",
      "rx": "16",
      "transform": "translate(252 4) rotate(90)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "142.4",
      "y1": "168.00043",
      "x2": "142.4",
      "y2": "88.00043",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "105.6",
      "y1": "168.00043",
      "x2": "105.6",
      "y2": "88.00043",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "68.8",
      "y1": "168.00043",
      "x2": "68.8",
      "y2": "88.00043",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "179.2",
      "y1": "168.00043",
      "x2": "179.2",
      "y2": "88.00043",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$28 = [];
/* style */

const __vue_inject_styles__$28 = undefined;
/* scoped */

const __vue_scope_id__$28 = undefined;
/* module identifier */

const __vue_module_identifier__$28 = undefined;
/* functional template */

const __vue_is_functional_template__$28 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$28 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$28,
  staticRenderFns: __vue_staticRenderFns__$28
}, __vue_inject_styles__$28, __vue_script__$28, __vue_scope_id__$28, __vue_is_functional_template__$28, __vue_module_identifier__$28, false, undefined, undefined, undefined);

var script$29 = Vue.extend({
  name: "PhBatteryHigh",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$29 = script$29;
/* template */

var __vue_render__$29 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "46",
      "y": "38",
      "width": "144",
      "height": "180",
      "rx": "16",
      "transform": "translate(246 10) rotate(90)",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "164",
      "x2": "64",
      "y2": "92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "164",
      "x2": "100",
      "y2": "92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "164",
      "x2": "136",
      "y2": "92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "244",
      "y1": "96",
      "x2": "244",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "52",
      "y": "36",
      "width": "144",
      "height": "184",
      "rx": "16",
      "transform": "translate(252 4) rotate(90)",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "248",
      "y1": "96",
      "x2": "248",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "52",
      "y": "36",
      "width": "144",
      "height": "184",
      "rx": "16",
      "transform": "translate(252 4) rotate(90)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "142.4",
      "y1": "168.00043",
      "x2": "142.4",
      "y2": "88.00043",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "105.6",
      "y1": "168.00043",
      "x2": "105.6",
      "y2": "88.00043",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "68.8",
      "y1": "168.00043",
      "x2": "68.8",
      "y2": "88.00043",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M248,88.00781a7.9954,7.9954,0,0,0-8,8v64a8,8,0,0,0,16,0v-64A7.99541,7.99541,0,0,0,248,88.00781Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,48.00781H48a24.02624,24.02624,0,0,0-24,24v112a24.02624,24.02624,0,0,0,24,24H200a24.02624,24.02624,0,0,0,24-24v-112A24.02625,24.02625,0,0,0,200,48.00781Zm8,136a8.01042,8.01042,0,0,1-8,8H48a8.01042,8.01042,0,0,1-8-8v-112a8.01042,8.01042,0,0,1,8-8H200a8.01042,8.01042,0,0,1,8,8Z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "56",
      "y": "80.00781",
      "width": "96",
      "height": "96",
      "rx": "8"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "248",
      "y1": "96",
      "x2": "248",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "52",
      "y": "36",
      "width": "144",
      "height": "184",
      "rx": "16",
      "transform": "translate(252 4) rotate(90)",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "142.4",
      "y1": "168.00043",
      "x2": "142.4",
      "y2": "88.00043",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "105.6",
      "y1": "168.00043",
      "x2": "105.6",
      "y2": "88.00043",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "68.8",
      "y1": "168.00043",
      "x2": "68.8",
      "y2": "88.00043",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "248",
      "y1": "96",
      "x2": "248",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "52",
      "y": "36",
      "width": "144",
      "height": "184",
      "rx": "16",
      "transform": "translate(252 4) rotate(90)",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "142.4",
      "y1": "168.00043",
      "x2": "142.4",
      "y2": "88.00043",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "105.6",
      "y1": "168.00043",
      "x2": "105.6",
      "y2": "88.00043",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "68.8",
      "y1": "168.00043",
      "x2": "68.8",
      "y2": "88.00043",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "248",
      "y1": "96",
      "x2": "248",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "52",
      "y": "36",
      "width": "144",
      "height": "184",
      "rx": "16",
      "transform": "translate(252 4) rotate(90)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "142.4",
      "y1": "168.00043",
      "x2": "142.4",
      "y2": "88.00043",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "105.6",
      "y1": "168.00043",
      "x2": "105.6",
      "y2": "88.00043",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "68.8",
      "y1": "168.00043",
      "x2": "68.8",
      "y2": "88.00043",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$29 = [];
/* style */

const __vue_inject_styles__$29 = undefined;
/* scoped */

const __vue_scope_id__$29 = undefined;
/* module identifier */

const __vue_module_identifier__$29 = undefined;
/* functional template */

const __vue_is_functional_template__$29 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$29 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$29,
  staticRenderFns: __vue_staticRenderFns__$29
}, __vue_inject_styles__$29, __vue_script__$29, __vue_scope_id__$29, __vue_is_functional_template__$29, __vue_module_identifier__$29, false, undefined, undefined, undefined);

var script$2a = Vue.extend({
  name: "PhBatteryLow",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2a = script$2a;
/* template */

var __vue_render__$2a = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "46",
      "y": "38",
      "width": "144",
      "height": "180",
      "rx": "16",
      "transform": "translate(246 10) rotate(90)",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "164",
      "x2": "64",
      "y2": "92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "244",
      "y1": "96",
      "x2": "244",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "52",
      "y": "36",
      "width": "144",
      "height": "184",
      "rx": "16",
      "transform": "translate(252 4) rotate(90)",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "248",
      "y1": "96",
      "x2": "248",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "52",
      "y": "36",
      "width": "144",
      "height": "184",
      "rx": "16",
      "transform": "translate(252 4) rotate(90)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "68.8",
      "y1": "168.00043",
      "x2": "68.8",
      "y2": "88.00043",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M248,88a8.00008,8.00008,0,0,0-8,8v64a8,8,0,0,0,16,0V96A8.00008,8.00008,0,0,0,248,88Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,48H48A24.0275,24.0275,0,0,0,24,72V184a24.0275,24.0275,0,0,0,24,24H200a24.0275,24.0275,0,0,0,24-24V72A24.0275,24.0275,0,0,0,200,48Zm8,136a8.00917,8.00917,0,0,1-8,8H48a8.00917,8.00917,0,0,1-8-8V72a8.00917,8.00917,0,0,1,8-8H200a8.00917,8.00917,0,0,1,8,8Z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "56",
      "y": "80.00049",
      "width": "32",
      "height": "96",
      "rx": "8"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "248",
      "y1": "96",
      "x2": "248",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "52",
      "y": "36",
      "width": "144",
      "height": "184",
      "rx": "16",
      "transform": "translate(252 4) rotate(90)",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "68.8",
      "y1": "168.00043",
      "x2": "68.8",
      "y2": "88.00043",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "248",
      "y1": "96",
      "x2": "248",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "52",
      "y": "36",
      "width": "144",
      "height": "184",
      "rx": "16",
      "transform": "translate(252 4) rotate(90)",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "68.8",
      "y1": "168.00043",
      "x2": "68.8",
      "y2": "88.00043",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "248",
      "y1": "96",
      "x2": "248",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "52",
      "y": "36",
      "width": "144",
      "height": "184",
      "rx": "16",
      "transform": "translate(252 4) rotate(90)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "68.8",
      "y1": "168.00043",
      "x2": "68.8",
      "y2": "88.00043",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2a = [];
/* style */

const __vue_inject_styles__$2a = undefined;
/* scoped */

const __vue_scope_id__$2a = undefined;
/* module identifier */

const __vue_module_identifier__$2a = undefined;
/* functional template */

const __vue_is_functional_template__$2a = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2a = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2a,
  staticRenderFns: __vue_staticRenderFns__$2a
}, __vue_inject_styles__$2a, __vue_script__$2a, __vue_scope_id__$2a, __vue_is_functional_template__$2a, __vue_module_identifier__$2a, false, undefined, undefined, undefined);

var script$2b = Vue.extend({
  name: "PhBatteryMedium",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2b = script$2b;
/* template */

var __vue_render__$2b = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "46",
      "y": "38",
      "width": "144",
      "height": "180",
      "rx": "16",
      "transform": "translate(246 10) rotate(90)",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "164",
      "x2": "64",
      "y2": "92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "164",
      "x2": "100",
      "y2": "92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "244",
      "y1": "96",
      "x2": "244",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "52",
      "y": "36",
      "width": "144",
      "height": "184",
      "rx": "16",
      "transform": "translate(252 4) rotate(90)",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "248",
      "y1": "96",
      "x2": "248",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "52",
      "y": "36",
      "width": "144",
      "height": "184",
      "rx": "16",
      "transform": "translate(252 4) rotate(90)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "105.6",
      "y1": "168.00043",
      "x2": "105.6",
      "y2": "88.00043",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "68.8",
      "y1": "168.00043",
      "x2": "68.8",
      "y2": "88.00043",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M248,88a7.99977,7.99977,0,0,0-8,8v64a8,8,0,0,0,16,0V96A7.99977,7.99977,0,0,0,248,88Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,48H48A24.0275,24.0275,0,0,0,24,72V184a24.0275,24.0275,0,0,0,24,24H200a24.0275,24.0275,0,0,0,24-24V72A24.0275,24.0275,0,0,0,200,48Zm8,136a8.00917,8.00917,0,0,1-8,8H48a8.00917,8.00917,0,0,1-8-8V72a8.00917,8.00917,0,0,1,8-8H200a8.00917,8.00917,0,0,1,8,8Z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "56",
      "y": "80.00049",
      "width": "72",
      "height": "96",
      "rx": "8"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "248",
      "y1": "96",
      "x2": "248",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "52",
      "y": "36",
      "width": "144",
      "height": "184",
      "rx": "16",
      "transform": "translate(252 4) rotate(90)",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "105.6",
      "y1": "168.00043",
      "x2": "105.6",
      "y2": "88.00043",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "68.8",
      "y1": "168.00043",
      "x2": "68.8",
      "y2": "88.00043",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "248",
      "y1": "96",
      "x2": "248",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "52",
      "y": "36",
      "width": "144",
      "height": "184",
      "rx": "16",
      "transform": "translate(252 4) rotate(90)",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "105.6",
      "y1": "168.00043",
      "x2": "105.6",
      "y2": "88.00043",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "68.8",
      "y1": "168.00043",
      "x2": "68.8",
      "y2": "88.00043",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "248",
      "y1": "96",
      "x2": "248",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "52",
      "y": "36",
      "width": "144",
      "height": "184",
      "rx": "16",
      "transform": "translate(252 4) rotate(90)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "105.6",
      "y1": "168.00043",
      "x2": "105.6",
      "y2": "88.00043",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "68.8",
      "y1": "168.00043",
      "x2": "68.8",
      "y2": "88.00043",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2b = [];
/* style */

const __vue_inject_styles__$2b = undefined;
/* scoped */

const __vue_scope_id__$2b = undefined;
/* module identifier */

const __vue_module_identifier__$2b = undefined;
/* functional template */

const __vue_is_functional_template__$2b = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2b = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2b,
  staticRenderFns: __vue_staticRenderFns__$2b
}, __vue_inject_styles__$2b, __vue_script__$2b, __vue_scope_id__$2b, __vue_is_functional_template__$2b, __vue_module_identifier__$2b, false, undefined, undefined, undefined);

var script$2c = Vue.extend({
  name: "PhBatteryWarning",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2c = script$2c;
/* template */

var __vue_render__$2c = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "46",
      "y": "38.00452",
      "width": "144",
      "height": "180",
      "rx": "16",
      "transform": "translate(246.00452 10.00452) rotate(90)",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "244",
      "y1": "96.00452",
      "x2": "244",
      "y2": "160.00452",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "116",
      "y1": "92",
      "x2": "116",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "116",
      "cy": "160",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "52",
      "y": "36",
      "width": "144",
      "height": "184",
      "rx": "16",
      "transform": "translate(252 4) rotate(90)",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "124",
      "y1": "88",
      "x2": "124",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "248",
      "y1": "96",
      "x2": "248",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "52",
      "y": "36",
      "width": "144",
      "height": "184",
      "rx": "16",
      "transform": "translate(252 4) rotate(90)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "124",
      "cy": "164",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M256,96.00012v64a8,8,0,1,1-16,0v-64a8,8,0,1,1,16,0Zm-32-24v112a24.0275,24.0275,0,0,1-24,24H48a24.0275,24.0275,0,0,1-24-24v-112a24.0275,24.0275,0,0,1,24-24H200A24.0275,24.0275,0,0,1,224,72.00012Zm-108,56a8,8,0,0,0,16,0v-40a8,8,0,1,0-16,0Zm20,36a12,12,0,1,0-12,12A12.01375,12.01375,0,0,0,136,164.00012Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "124",
      "y1": "88",
      "x2": "124",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "248",
      "y1": "96",
      "x2": "248",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "52",
      "y": "36",
      "width": "144",
      "height": "184",
      "rx": "16",
      "transform": "translate(252 4) rotate(90)",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "124",
      "cy": "164",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "124",
      "y1": "88",
      "x2": "124",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "248",
      "y1": "96",
      "x2": "248",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "52",
      "y": "36",
      "width": "144",
      "height": "184",
      "rx": "16",
      "transform": "translate(252 4) rotate(90)",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "124",
      "cy": "164",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "124",
      "y1": "88",
      "x2": "124",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "248",
      "y1": "96",
      "x2": "248",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "52",
      "y": "36",
      "width": "144",
      "height": "184",
      "rx": "16",
      "transform": "translate(252 4) rotate(90)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "124",
      "cy": "164",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2c = [];
/* style */

const __vue_inject_styles__$2c = undefined;
/* scoped */

const __vue_scope_id__$2c = undefined;
/* module identifier */

const __vue_module_identifier__$2c = undefined;
/* functional template */

const __vue_is_functional_template__$2c = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2c = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2c,
  staticRenderFns: __vue_staticRenderFns__$2c
}, __vue_inject_styles__$2c, __vue_script__$2c, __vue_scope_id__$2c, __vue_is_functional_template__$2c, __vue_module_identifier__$2c, false, undefined, undefined, undefined);

var script$2d = Vue.extend({
  name: "PhBatteryWarningVertical",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2d = script$2d;
/* template */

var __vue_render__$2d = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "100",
      "y1": "12",
      "x2": "156",
      "y2": "12",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "56.00586",
      "y": "48",
      "width": "144",
      "height": "180",
      "rx": "16",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "96",
      "x2": "128",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "176",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "56",
      "y": "40",
      "width": "144",
      "height": "184",
      "rx": "16",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "92",
      "x2": "128",
      "y2": "132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "8",
      "x2": "160",
      "y2": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "56",
      "y": "40",
      "width": "144",
      "height": "184",
      "rx": "16",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "168",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M88,8a7.99977,7.99977,0,0,1,8-8h64a8,8,0,0,1,0,16H96A7.99977,7.99977,0,0,1,88,8ZM208,56V208a24.0275,24.0275,0,0,1-24,24H72a24.0275,24.0275,0,0,1-24-24V56A24.0275,24.0275,0,0,1,72,32H184A24.0275,24.0275,0,0,1,208,56Zm-88,76a8,8,0,0,0,16,0V92a8,8,0,0,0-16,0Zm20,36a12,12,0,1,0-12,12A12.01375,12.01375,0,0,0,140,168Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "92",
      "x2": "128",
      "y2": "132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "8",
      "x2": "160",
      "y2": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "56",
      "y": "40",
      "width": "144",
      "height": "184",
      "rx": "16",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "168",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "92",
      "x2": "128",
      "y2": "132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "8",
      "x2": "160",
      "y2": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "56",
      "y": "40",
      "width": "144",
      "height": "184",
      "rx": "16",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "168",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "92",
      "x2": "128",
      "y2": "132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "8",
      "x2": "160",
      "y2": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "56",
      "y": "40",
      "width": "144",
      "height": "184",
      "rx": "16",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "168",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2d = [];
/* style */

const __vue_inject_styles__$2d = undefined;
/* scoped */

const __vue_scope_id__$2d = undefined;
/* module identifier */

const __vue_module_identifier__$2d = undefined;
/* functional template */

const __vue_is_functional_template__$2d = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2d = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2d,
  staticRenderFns: __vue_staticRenderFns__$2d
}, __vue_inject_styles__$2d, __vue_script__$2d, __vue_scope_id__$2d, __vue_is_functional_template__$2d, __vue_module_identifier__$2d, false, undefined, undefined, undefined);

var script$2e = Vue.extend({
  name: "PhBed",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2e = script$2e;
/* template */

var __vue_render__$2e = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M104,168V80H208a32,32,0,0,1,32,32v56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "208",
      "x2": "16",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "16 168 240 168 240 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "80",
      "x2": "16",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M104,80H208a32,32,0,0,1,32,32v56a0,0,0,0,1,0,0H104a0,0,0,0,1,0,0V80A0,0,0,0,1,104,80Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,168V80H208a32,32,0,0,1,32,32v56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "208",
      "x2": "16",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "16 168 240 168 240 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "80",
      "x2": "16",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,72H24V48A8,8,0,0,0,8,48V208a8,8,0,0,0,16,0V176H232v32a8,8,0,0,0,16,0V112A40.04521,40.04521,0,0,0,208,72ZM24,88H96v72H24Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M104,168V80H208a32,32,0,0,1,32,32v56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "208",
      "x2": "16",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "16 168 240 168 240 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "80",
      "x2": "16",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M104,168V80H208a32,32,0,0,1,32,32v56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "208",
      "x2": "16",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "16 168 240 168 240 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "80",
      "x2": "16",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M104,168V80H208a32,32,0,0,1,32,32v56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "208",
      "x2": "16",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "16 168 240 168 240 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "80",
      "x2": "16",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2e = [];
/* style */

const __vue_inject_styles__$2e = undefined;
/* scoped */

const __vue_scope_id__$2e = undefined;
/* module identifier */

const __vue_module_identifier__$2e = undefined;
/* functional template */

const __vue_is_functional_template__$2e = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2e = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2e,
  staticRenderFns: __vue_staticRenderFns__$2e
}, __vue_inject_styles__$2e, __vue_script__$2e, __vue_scope_id__$2e, __vue_is_functional_template__$2e, __vue_module_identifier__$2e, false, undefined, undefined, undefined);

var script$2f = Vue.extend({
  name: "PhBell",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2f = script$2f;
/* template */

var __vue_render__$2f = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56.20305,104A71.899,71.899,0,0,1,128.5484,32.002c39.58967.29432,71.25651,33.20133,71.25651,72.90185V112c0,35.81563,7.49325,56.59893,14.093,67.95814A7.999,7.999,0,0,1,207.01628,192H48.98365A7.99908,7.99908,0,0,1,42.103,179.95641c6.60328-11.35959,14.1-32.1426,14.1-67.95641Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,192v8a32,32,0,0,0,64,0v-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56.20305,104A71.899,71.899,0,0,1,128.5484,32.002c39.58967.29432,71.25651,33.20133,71.25651,72.90185V112c0,35.81563,7.49325,56.59893,14.093,67.95814A7.999,7.999,0,0,1,207.01628,192H48.98365A7.99908,7.99908,0,0,1,42.103,179.95641c6.60328-11.35959,14.1-32.1426,14.1-67.95641Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56.20305,104A71.899,71.899,0,0,1,128.5484,32.002c39.58967.29432,71.25651,33.20133,71.25651,72.90185V112c0,35.81563,7.49325,56.59893,14.093,67.95814A7.999,7.999,0,0,1,207.01628,192H48.98365A7.99908,7.99908,0,0,1,42.103,179.95641c6.60328-11.35959,14.1-32.1426,14.1-67.95641Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,192v8a32,32,0,0,0,64,0v-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M220.81445,175.9397c-5.93457-10.21582-13.00976-29.60157-13.00976-63.93946v-7.09668c0-44.28515-35.52735-80.57715-79.19629-80.90136-.2041-.001-.40625-.002-.61035-.002a79.89891,79.89891,0,0,0-79.79493,80v8c0,34.33594-7.0791,53.72071-13.0166,63.93555A15.99885,15.99885,0,0,0,48.9834,200.00024H88a40,40,0,0,0,80,0h39.0166a15.99808,15.99808,0,0,0,13.79785-24.06054ZM128,224.00024a24.0275,24.0275,0,0,1-24-24h48A24.0275,24.0275,0,0,1,128,224.00024Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56.20305,104A71.899,71.899,0,0,1,128.5484,32.002c39.58967.29432,71.25651,33.20133,71.25651,72.90185V112c0,35.81563,7.49325,56.59893,14.093,67.95814A7.999,7.999,0,0,1,207.01628,192H48.98365A7.99908,7.99908,0,0,1,42.103,179.95641c6.60328-11.35959,14.1-32.1426,14.1-67.95641Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,192v8a32,32,0,0,0,64,0v-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56.20305,104A71.899,71.899,0,0,1,128.5484,32.002c39.58967.29432,71.25651,33.20133,71.25651,72.90185V112c0,35.81563,7.49325,56.59893,14.093,67.95814A7.999,7.999,0,0,1,207.01628,192H48.98365A7.99908,7.99908,0,0,1,42.103,179.95641c6.60328-11.35959,14.1-32.1426,14.1-67.95641Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,192v8a32,32,0,0,0,64,0v-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56.20305,104A71.899,71.899,0,0,1,128.5484,32.002c39.58967.29432,71.25651,33.20133,71.25651,72.90185V112c0,35.81563,7.49325,56.59893,14.093,67.95814A7.999,7.999,0,0,1,207.01628,192H48.98365A7.99908,7.99908,0,0,1,42.103,179.95641c6.60328-11.35959,14.1-32.1426,14.1-67.95641Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,192v8a32,32,0,0,0,64,0v-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2f = [];
/* style */

const __vue_inject_styles__$2f = undefined;
/* scoped */

const __vue_scope_id__$2f = undefined;
/* module identifier */

const __vue_module_identifier__$2f = undefined;
/* functional template */

const __vue_is_functional_template__$2f = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2f = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2f,
  staticRenderFns: __vue_staticRenderFns__$2f
}, __vue_inject_styles__$2f, __vue_script__$2f, __vue_scope_id__$2f, __vue_is_functional_template__$2f, __vue_module_identifier__$2f, false, undefined, undefined, undefined);

var script$2g = Vue.extend({
  name: "PhBellRinging",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2g = script$2g;
/* template */

var __vue_render__$2g = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56.20305,112a71.80121,71.80121,0,1,1,143.60186,0h0c0,35.81563,7.49325,56.59893,14.093,67.95814A7.999,7.999,0,0,1,207.01628,192H48.98365A7.99908,7.99908,0,0,1,42.103,179.95641c6.60328-11.35959,14.1-32.1426,14.1-67.95641Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,192v8a32,32,0,0,0,64,0v-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M187.6965,17.21819a112.5022,112.5022,0,0,1,40.83526,45.35527",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M27.46825,62.57344A112.50227,112.50227,0,0,1,68.30353,17.21816",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56.20305,112a71.80121,71.80121,0,1,1,143.60186,0h0c0,35.81563,7.49325,56.59893,14.093,67.95814A7.999,7.999,0,0,1,207.01628,192H48.98365A7.99908,7.99908,0,0,1,42.103,179.95641c6.60328-11.35959,14.1-32.1426,14.1-67.95641Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56.20305,112a71.80121,71.80121,0,1,1,143.60186,0h0c0,35.81563,7.49325,56.59893,14.093,67.95814A7.999,7.999,0,0,1,207.01628,192H48.98365A7.99908,7.99908,0,0,1,42.103,179.95641c6.60328-11.35959,14.1-32.1426,14.1-67.95641Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,192v8a32,32,0,0,0,64,0v-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M183.43247,23.98832a104.46641,104.46641,0,0,1,37.91845,42.1156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M34.64909,66.10391A104.46639,104.46639,0,0,1,72.56757,23.98829",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M207.80469,112A79.70738,79.70738,0,0,0,128.6084,32.002c-.2041-.001-.40625-.002-.61035-.002a79.89888,79.89888,0,0,0-79.79492,80c0,34.33594-7.07911,53.7207-13.01661,63.93555A15.99886,15.99886,0,0,0,48.9834,200H88a40,40,0,0,0,80,0h39.0166a15.99808,15.99808,0,0,0,13.79785-24.06055C214.87988,165.72363,207.80469,146.33789,207.80469,112ZM128,224a24.0275,24.0275,0,0,1-24-24h48A24.0275,24.0275,0,0,1,128,224ZM224.88574,73.28027a7.995,7.995,0,0,1-10.71191-3.6416,96.29849,96.29849,0,0,0-35.01074-38.88574,7.9996,7.9996,0,1,1,8.54-13.5293,112.28362,112.28362,0,0,1,40.82421,45.34473A8,8,0,0,1,224.88574,73.28027Zm-190.24219.8252a8.00344,8.00344,0,0,1-7.17089-11.53711A112.28357,112.28357,0,0,1,68.29688,17.22363a7.99959,7.99959,0,1,1,8.54,13.5293A96.29849,96.29849,0,0,0,41.82617,69.63867,8.002,8.002,0,0,1,34.64355,74.10547Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56.20305,112a71.80121,71.80121,0,1,1,143.60186,0h0c0,35.81563,7.49325,56.59893,14.093,67.95814A7.999,7.999,0,0,1,207.01628,192H48.98365A7.99908,7.99908,0,0,1,42.103,179.95641c6.60328-11.35959,14.1-32.1426,14.1-67.95641Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,192v8a32,32,0,0,0,64,0v-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M183.43247,23.98832a104.46641,104.46641,0,0,1,37.91845,42.1156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M34.64909,66.10391A104.46639,104.46639,0,0,1,72.56757,23.98829",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56.20305,112a71.80121,71.80121,0,1,1,143.60186,0h0c0,35.81563,7.49325,56.59893,14.093,67.95814A7.999,7.999,0,0,1,207.01628,192H48.98365A7.99908,7.99908,0,0,1,42.103,179.95641c6.60328-11.35959,14.1-32.1426,14.1-67.95641Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,192v8a32,32,0,0,0,64,0v-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M183.43247,23.98832a104.46641,104.46641,0,0,1,37.91845,42.1156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M34.64909,66.10391A104.46639,104.46639,0,0,1,72.56757,23.98829",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56.20305,112a71.80121,71.80121,0,1,1,143.60186,0h0c0,35.81563,7.49325,56.59893,14.093,67.95814A7.999,7.999,0,0,1,207.01628,192H48.98365A7.99908,7.99908,0,0,1,42.103,179.95641c6.60328-11.35959,14.1-32.1426,14.1-67.95641Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,192v8a32,32,0,0,0,64,0v-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M183.43247,23.98832a104.46641,104.46641,0,0,1,37.91845,42.1156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M34.64909,66.10391A104.46639,104.46639,0,0,1,72.56757,23.98829",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2g = [];
/* style */

const __vue_inject_styles__$2g = undefined;
/* scoped */

const __vue_scope_id__$2g = undefined;
/* module identifier */

const __vue_module_identifier__$2g = undefined;
/* functional template */

const __vue_is_functional_template__$2g = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2g = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2g,
  staticRenderFns: __vue_staticRenderFns__$2g
}, __vue_inject_styles__$2g, __vue_script__$2g, __vue_scope_id__$2g, __vue_is_functional_template__$2g, __vue_module_identifier__$2g, false, undefined, undefined, undefined);

var script$2h = Vue.extend({
  name: "PhBellSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2h = script$2h;
/* template */

var __vue_render__$2h = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "228",
      "x2": "160",
      "y2": "228",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56.20305,104A71.899,71.899,0,0,1,128.5484,32.002c39.58967.29432,71.25651,33.20133,71.25651,72.90185V108c0,35.81563,7.49325,56.59893,14.093,67.95814A7.999,7.999,0,0,1,207.01628,188H48.98365A7.99908,7.99908,0,0,1,42.103,175.95641c6.60328-11.35959,14.1-32.1426,14.1-67.95641Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M55.99674,104A72.00377,72.00377,0,0,1,128.55,32.002c39.70343.29432,71.46127,33.20133,71.46127,72.90185V112c0,35.81563,7.51478,56.59893,14.13351,67.95814A7.99892,7.99892,0,0,1,207.24334,192H48.75659a7.999,7.999,0,0,1-6.90041-12.04359C48.47844,168.59682,55.99674,147.81381,55.99674,112Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "224",
      "x2": "160",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56.20305,104A71.899,71.899,0,0,1,128.5484,32.002c39.58967.29432,71.25651,33.20133,71.25651,72.90185V112c0,35.81563,7.49325,56.59893,14.093,67.95814A7.999,7.999,0,0,1,207.01628,192H48.98365A7.99908,7.99908,0,0,1,42.103,179.95641c6.60328-11.35959,14.1-32.1426,14.1-67.95641Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M221.048,175.93066C215.09778,165.7168,208.004,146.335,208.004,112v-7.0957c0-44.28516-35.61621-80.57813-79.39453-80.90235-.20508-.001-.40722-.002-.61133-.002A79.99928,79.99928,0,0,0,48.004,104v8c0,34.33105-7.09668,53.71387-13.0498,63.92676A15.999,15.999,0,0,0,48.76478,200h158.4707a15.99861,15.99861,0,0,0,13.8125-24.06934Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M159.92884,216h-64a8,8,0,1,0,0,16h64a8,8,0,1,0,0-16Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "95.92521",
      "y1": "224.02075",
      "x2": "159.92521",
      "y2": "224.02075",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56.20305,104A71.899,71.899,0,0,1,128.5484,32.002c39.58967.29432,71.25651,33.20133,71.25651,72.90185V112c0,35.81563,7.49325,56.59893,14.093,67.95814A7.999,7.999,0,0,1,207.01628,192H48.98365A7.99908,7.99908,0,0,1,42.103,179.95641c6.60328-11.35959,14.1-32.1426,14.1-67.95641Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "224",
      "x2": "160",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56.20305,104A71.899,71.899,0,0,1,128.5484,32.002c39.58967.29432,71.25651,33.20133,71.25651,72.90185V112c0,35.81563,7.49325,56.59893,14.093,67.95814A7.999,7.999,0,0,1,207.01628,192H48.98365A7.99908,7.99908,0,0,1,42.103,179.95641c6.60328-11.35959,14.1-32.1426,14.1-67.95641Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "224",
      "x2": "160",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56.20305,104A71.899,71.899,0,0,1,128.5484,32.002c39.58967.29432,71.25651,33.20133,71.25651,72.90185V112c0,35.81563,7.49325,56.59893,14.093,67.95814A7.999,7.999,0,0,1,207.01628,192H48.98365A7.99908,7.99908,0,0,1,42.103,179.95641c6.60328-11.35959,14.1-32.1426,14.1-67.95641Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2h = [];
/* style */

const __vue_inject_styles__$2h = undefined;
/* scoped */

const __vue_scope_id__$2h = undefined;
/* module identifier */

const __vue_module_identifier__$2h = undefined;
/* functional template */

const __vue_is_functional_template__$2h = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2h = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2h,
  staticRenderFns: __vue_staticRenderFns__$2h
}, __vue_inject_styles__$2h, __vue_script__$2h, __vue_scope_id__$2h, __vue_is_functional_template__$2h, __vue_module_identifier__$2h, false, undefined, undefined, undefined);

var script$2i = Vue.extend({
  name: "PhBellSimpleRinging",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2i = script$2i;
/* template */

var __vue_render__$2i = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "228",
      "x2": "160",
      "y2": "228",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56.20305,112a71.80121,71.80121,0,1,1,143.60186,0h0c0,35.81563,7.49325,52.59893,14.093,63.95814A7.999,7.999,0,0,1,207.01628,188H48.98365A7.99908,7.99908,0,0,1,42.103,175.95641c6.60328-11.35959,14.1-28.1426,14.1-63.95641Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M187.6965,17.21819a112.5022,112.5022,0,0,1,40.83526,45.35527",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M27.46825,62.57344A112.50227,112.50227,0,0,1,68.30353,17.21816",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56.20305,112a71.80121,71.80121,0,1,1,143.60186,0h0c0,35.81563,7.49325,56.59893,14.093,67.95814A7.999,7.999,0,0,1,207.01628,192H48.98365A7.99908,7.99908,0,0,1,42.103,179.95641c6.60328-11.35959,14.1-32.1426,14.1-67.95641Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "224",
      "x2": "160",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56.20305,112a71.80121,71.80121,0,1,1,143.60186,0h0c0,35.81563,7.49325,56.59893,14.093,67.95814A7.999,7.999,0,0,1,207.01628,192H48.98365A7.99908,7.99908,0,0,1,42.103,179.95641c6.60328-11.35959,14.1-32.1426,14.1-67.95641Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M183.43247,23.98832a104.46641,104.46641,0,0,1,37.91845,42.1156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M34.64909,66.10391A104.46639,104.46639,0,0,1,72.56757,23.98829",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M168,224a8.00039,8.00039,0,0,1-8,8H96a8,8,0,0,1,0-16h64A8.00039,8.00039,0,0,1,168,224Zm39.80469-112A79.70738,79.70738,0,0,0,128.6084,32.002c-.2041-.001-.40625-.002-.61035-.002a79.89888,79.89888,0,0,0-79.79492,80c0,34.33594-7.07911,53.7207-13.01661,63.93555A15.99886,15.99886,0,0,0,48.9834,200H207.0166a15.99808,15.99808,0,0,0,13.79785-24.06055C214.87988,165.72363,207.80469,146.33789,207.80469,112Zm20.72265-49.43164a112.28362,112.28362,0,0,0-40.82421-45.34473,7.9996,7.9996,0,1,0-8.54,13.5293,96.29849,96.29849,0,0,1,35.01074,38.88574,8.0002,8.0002,0,1,0,14.35351-7.07031ZM41.82617,69.63867A96.29849,96.29849,0,0,1,76.83691,30.75293a7.99959,7.99959,0,1,0-8.54-13.5293A112.28357,112.28357,0,0,0,27.47266,62.56836a8.0002,8.0002,0,1,0,14.35351,7.07031Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "95.92521",
      "y1": "224.02075",
      "x2": "159.92521",
      "y2": "224.02075",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56.20305,112a71.80121,71.80121,0,1,1,143.60186,0h0c0,35.81563,7.49325,56.59893,14.093,67.95814A7.999,7.999,0,0,1,207.01628,192H48.98365A7.99908,7.99908,0,0,1,42.103,179.95641c6.60328-11.35959,14.1-32.1426,14.1-67.95641Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M183.43247,23.98832a104.46641,104.46641,0,0,1,37.91845,42.1156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M34.64909,66.10391A104.46639,104.46639,0,0,1,72.56757,23.98829",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "224",
      "x2": "160",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56.20305,112a71.80121,71.80121,0,1,1,143.60186,0h0c0,35.81563,7.49325,56.59893,14.093,67.95814A7.999,7.999,0,0,1,207.01628,192H48.98365A7.99908,7.99908,0,0,1,42.103,179.95641c6.60328-11.35959,14.1-32.1426,14.1-67.95641Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M183.43247,23.98832a104.46641,104.46641,0,0,1,37.91845,42.1156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M34.64909,66.10391A104.46639,104.46639,0,0,1,72.56757,23.98829",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "224",
      "x2": "160",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56.20305,112a71.80121,71.80121,0,1,1,143.60186,0h0c0,35.81563,7.49325,56.59893,14.093,67.95814A7.999,7.999,0,0,1,207.01628,192H48.98365A7.99908,7.99908,0,0,1,42.103,179.95641c6.60328-11.35959,14.1-32.1426,14.1-67.95641Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M183.43247,23.98832a104.46641,104.46641,0,0,1,37.91845,42.1156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M34.64909,66.10391A104.46639,104.46639,0,0,1,72.56757,23.98829",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2i = [];
/* style */

const __vue_inject_styles__$2i = undefined;
/* scoped */

const __vue_scope_id__$2i = undefined;
/* module identifier */

const __vue_module_identifier__$2i = undefined;
/* functional template */

const __vue_is_functional_template__$2i = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2i = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2i,
  staticRenderFns: __vue_staticRenderFns__$2i
}, __vue_inject_styles__$2i, __vue_script__$2i, __vue_scope_id__$2i, __vue_is_functional_template__$2i, __vue_module_identifier__$2i, false, undefined, undefined, undefined);

var script$2j = Vue.extend({
  name: "PhBellSimpleSlash",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2j = script$2j;
/* template */

var __vue_render__$2j = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "227.97925",
      "x2": "160",
      "y2": "227.97925",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M182.52658,187.97925H48.98365A7.99908,7.99908,0,0,1,42.103,175.93566c6.60328-11.35959,14.1-32.1426,14.1-67.95641v-4A71.80588,71.80588,0,0,1,68.93752,63.03149",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M99.95187,37.68155a71.42431,71.42431,0,0,1,28.59653-5.70028c39.58967.29432,71.25651,33.20133,71.25651,72.90185v3.09613c0,18.98255,2.10491,33.7424,5.0661,45.11452",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M55.99674,104A72.00377,72.00377,0,0,1,128.55,32.002c39.70343.29432,71.46127,33.20133,71.46127,72.90185V112c0,35.81563,7.51478,56.59893,14.13351,67.95814A7.99892,7.99892,0,0,1,207.24334,192H48.75659a7.999,7.999,0,0,1-6.90041-12.04359C48.47844,168.59682,55.99674,147.81381,55.99674,112Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40.02075",
      "x2": "208",
      "y2": "216.02075",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "224",
      "x2": "160",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.50261,41.40252A71.33429,71.33429,0,0,1,128.5484,32.002c39.58967.29432,71.25651,33.20133,71.25651,72.90185V112c0,26.69367,4.16238,45.03713,9.015,57.35221",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M186.163,192H48.98365A7.99908,7.99908,0,0,1,42.103,179.95641c6.60328-11.35959,14.1-32.1426,14.1-67.95641v-8A71.80594,71.80594,0,0,1,68.93758,63.05215",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M213.91992,210.61816a8.0006,8.0006,0,0,1-11.83984,10.76368l-19.45654-21.40235H48.9834A15.99885,15.99885,0,0,1,35.18652,175.915c5.9375-10.21484,13.0166-29.59961,13.0166-63.93555v-8a79.6939,79.6939,0,0,1,10.7212-40.06885L42.08008,45.38184A8.0006,8.0006,0,1,1,53.91992,34.61816ZM160,215.97949H96a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16Zm42.90039-41.2666a8.0004,8.0004,0,0,0,13.36328-8.31445c-5.61328-14.24414-8.459-32.55274-8.459-54.41895v-7.09668c0-44.28515-35.52735-80.57715-79.19629-80.90136A79.49567,79.49567,0,0,0,88.5332,34.43652,8.00109,8.00109,0,0,0,86.583,46.76367Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "223.97925",
      "x2": "160",
      "y2": "223.97925",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.50261,41.38177a71.33429,71.33429,0,0,1,36.04579-9.4005c39.58967.29432,71.25651,33.20133,71.25651,72.90185v7.09613c0,26.69367,4.16238,45.03713,9.015,57.35221",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M186.163,191.97925H48.98365A7.99908,7.99908,0,0,1,42.103,179.93566c6.60328-11.35959,14.1-32.1426,14.1-67.95641v-8A71.806,71.806,0,0,1,68.93758,63.03139",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "223.97925",
      "x2": "160",
      "y2": "223.97925",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.50261,41.38177a71.33429,71.33429,0,0,1,36.04579-9.4005c39.58967.29432,71.25651,33.20133,71.25651,72.90185v7.09613c0,26.69367,4.16238,45.03713,9.015,57.35221",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M186.163,191.97925H48.98365A7.99908,7.99908,0,0,1,42.103,179.93566c6.60328-11.35959,14.1-32.1426,14.1-67.95641v-8A71.806,71.806,0,0,1,68.93758,63.03139",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "223.97925",
      "x2": "160",
      "y2": "223.97925",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.50261,41.38177a71.33429,71.33429,0,0,1,36.04579-9.4005c39.58967.29432,71.25651,33.20133,71.25651,72.90185v7.09613c0,26.69367,4.16238,45.03713,9.015,57.35221",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M186.163,191.97925H48.98365A7.99908,7.99908,0,0,1,42.103,179.93566c6.60328-11.35959,14.1-32.1426,14.1-67.95641v-8A71.806,71.806,0,0,1,68.93758,63.03139",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2j = [];
/* style */

const __vue_inject_styles__$2j = undefined;
/* scoped */

const __vue_scope_id__$2j = undefined;
/* module identifier */

const __vue_module_identifier__$2j = undefined;
/* functional template */

const __vue_is_functional_template__$2j = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2j = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2j,
  staticRenderFns: __vue_staticRenderFns__$2j
}, __vue_inject_styles__$2j, __vue_script__$2j, __vue_scope_id__$2j, __vue_is_functional_template__$2j, __vue_module_identifier__$2j, false, undefined, undefined, undefined);

var script$2k = Vue.extend({
  name: "PhBellSimpleZ",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2k = script$2k;
/* template */

var __vue_render__$2k = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "108 96 148 96 108 144 148 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "228",
      "x2": "160",
      "y2": "228",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56.20305,104A71.899,71.899,0,0,1,128.5484,32.002c39.58967.29432,71.25651,33.20133,71.25651,72.90185V108c0,35.81563,7.49325,56.59893,14.093,67.95814A7.999,7.999,0,0,1,207.01628,188H48.98365A7.99908,7.99908,0,0,1,42.103,175.95641c6.60328-11.35959,14.1-32.1426,14.1-67.95641Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56.20305,104A71.899,71.899,0,0,1,128.5484,32.002c39.58967.29432,71.25651,33.20133,71.25651,72.90185V112c0,35.81563,7.49325,56.59893,14.093,67.95814A7.999,7.999,0,0,1,207.01628,192H48.98365A7.99908,7.99908,0,0,1,42.103,179.95641c6.60328-11.35959,14.1-32.1426,14.1-67.95641Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "224",
      "x2": "160",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56.20305,104A71.899,71.899,0,0,1,128.5484,32.002c39.58967.29432,71.25651,33.20133,71.25651,72.90185V112c0,35.81563,7.49325,56.59893,14.093,67.95814A7.999,7.999,0,0,1,207.01628,192H48.98365A7.99908,7.99908,0,0,1,42.103,179.95641c6.60328-11.35959,14.1-32.1426,14.1-67.95641Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 96 148 96 108 144 148 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M168,224a8.00039,8.00039,0,0,1-8,8H96a8,8,0,0,1,0-16h64A8.00039,8.00039,0,0,1,168,224Zm52.85352-32.00293A15.80079,15.80079,0,0,1,207.0166,200H48.9834a15.99886,15.99886,0,0,1-13.79688-24.06445C41.124,165.7207,48.20313,146.33594,48.20313,112v-8a79.89888,79.89888,0,0,1,79.79492-80c.2041,0,.40625.001.61035.002,43.66894.32422,79.19629,36.61719,79.19629,80.90235V112c0,34.33789,7.07519,53.72363,13.00976,63.93945A15.87,15.87,0,0,1,220.85352,191.99707ZM156,144a8.00039,8.00039,0,0,0-8-8H125.08008l29.06543-34.87891A7.99925,7.99925,0,0,0,148,88H108a8,8,0,0,0,0,16h22.91992l-29.06543,34.87891A7.99925,7.99925,0,0,0,108,152h40A8.00039,8.00039,0,0,0,156,144Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "224",
      "x2": "160",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56.20305,104A71.899,71.899,0,0,1,128.5484,32.002c39.58967.29432,71.25651,33.20133,71.25651,72.90185V112c0,35.81563,7.49325,56.59893,14.093,67.95814A7.999,7.999,0,0,1,207.01628,192H48.98365A7.99908,7.99908,0,0,1,42.103,179.95641c6.60328-11.35959,14.1-32.1426,14.1-67.95641Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 96 148 96 108 144 148 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "224",
      "x2": "160",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56.20305,104A71.899,71.899,0,0,1,128.5484,32.002c39.58967.29432,71.25651,33.20133,71.25651,72.90185V112c0,35.81563,7.49325,56.59893,14.093,67.95814A7.999,7.999,0,0,1,207.01628,192H48.98365A7.99908,7.99908,0,0,1,42.103,179.95641c6.60328-11.35959,14.1-32.1426,14.1-67.95641Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 96 148 96 108 144 148 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "224",
      "x2": "160",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56.20305,104A71.899,71.899,0,0,1,128.5484,32.002c39.58967.29432,71.25651,33.20133,71.25651,72.90185V112c0,35.81563,7.49325,56.59893,14.093,67.95814A7.999,7.999,0,0,1,207.01628,192H48.98365A7.99908,7.99908,0,0,1,42.103,179.95641c6.60328-11.35959,14.1-32.1426,14.1-67.95641Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 96 148 96 108 144 148 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2k = [];
/* style */

const __vue_inject_styles__$2k = undefined;
/* scoped */

const __vue_scope_id__$2k = undefined;
/* module identifier */

const __vue_module_identifier__$2k = undefined;
/* functional template */

const __vue_is_functional_template__$2k = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2k = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2k,
  staticRenderFns: __vue_staticRenderFns__$2k
}, __vue_inject_styles__$2k, __vue_script__$2k, __vue_scope_id__$2k, __vue_is_functional_template__$2k, __vue_module_identifier__$2k, false, undefined, undefined, undefined);

var script$2l = Vue.extend({
  name: "PhBellSlash",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2l = script$2l;
/* template */

var __vue_render__$2l = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,192v8a32,32,0,0,0,64,0v-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M186.18182,192H48.98365A7.99908,7.99908,0,0,1,42.103,179.95641c6.60328-11.35959,14.1-32.1426,14.1-67.95641v-8A71.80594,71.80594,0,0,1,68.9457,63.0404",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M99.96516,37.69664A71.42478,71.42478,0,0,1,128.5484,32.002c39.58967.29432,71.25651,33.20133,71.25651,72.90185V112a189.04639,189.04639,0,0,0,3.776,39.67466",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56.20305,103.97925a71.899,71.899,0,0,1,72.34535-71.998c39.58967.29432,71.25651,33.20133,71.25651,72.90185v7.09613c0,35.81563,7.49325,56.59893,14.093,67.95814a7.999,7.999,0,0,1-6.88165,12.04186H48.98365A7.99908,7.99908,0,0,1,42.103,179.93566c6.60328-11.35959,14.1-32.1426,14.1-67.95641Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,192v8a32,32,0,0,0,64,0v-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M186.18182,192H48.98365A7.99908,7.99908,0,0,1,42.103,179.95641c6.60328-11.35959,14.1-32.1426,14.1-67.95641v-8A71.80594,71.80594,0,0,1,68.9457,63.0404",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.515,41.39547A71.33425,71.33425,0,0,1,128.5484,32.002c39.58967.29432,71.25651,33.20133,71.25651,72.90185V112c0,26.66813,4.15442,45.002,9.001,57.31684",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M53.91992,34.61816A8.0006,8.0006,0,1,0,42.08008,45.38184L58.93164,63.91846A79.70131,79.70131,0,0,0,48.20312,104v8c0,34.33594-7.0791,53.7207-13.0166,63.93555A15.99886,15.99886,0,0,0,48.9834,200H88a40,40,0,0,0,80,0h14.64209l19.438,21.38184a8.0006,8.0006,0,1,0,11.83984-10.76368ZM128,224a24.0275,24.0275,0,0,1-24-24h48A24.0275,24.0275,0,0,1,128,224ZM86.59473,46.77734a8.00066,8.00066,0,0,1,1.95215-12.32812A79.89269,79.89269,0,0,1,128.6084,24.002c43.66894.32422,79.19629,36.61719,79.19629,80.90235V112c0,21.85059,2.84179,40.14844,8.44531,54.38672a8.00047,8.00047,0,0,1-13.36426,8.31152Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,192v8a32,32,0,0,0,64,0v-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M186.18182,192H48.98365A7.99908,7.99908,0,0,1,42.103,179.95641c6.60328-11.35959,14.1-32.1426,14.1-67.95641v-8A71.80594,71.80594,0,0,1,68.9457,63.0404",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.515,41.39547A71.33425,71.33425,0,0,1,128.5484,32.002c39.58967.29432,71.25651,33.20133,71.25651,72.90185V112c0,26.66813,4.15442,45.002,9.001,57.31684",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,192v8a32,32,0,0,0,64,0v-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M186.18182,192H48.98365A7.99908,7.99908,0,0,1,42.103,179.95641c6.60328-11.35959,14.1-32.1426,14.1-67.95641v-8A71.80594,71.80594,0,0,1,68.9457,63.0404",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.515,41.39547A71.33425,71.33425,0,0,1,128.5484,32.002c39.58967.29432,71.25651,33.20133,71.25651,72.90185V112c0,26.66813,4.15442,45.002,9.001,57.31684",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,192v8a32,32,0,0,0,64,0v-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M186.18182,192H48.98365A7.99908,7.99908,0,0,1,42.103,179.95641c6.60328-11.35959,14.1-32.1426,14.1-67.95641v-8A71.80594,71.80594,0,0,1,68.9457,63.0404",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.515,41.39547A71.33425,71.33425,0,0,1,128.5484,32.002c39.58967.29432,71.25651,33.20133,71.25651,72.90185V112c0,26.66813,4.15442,45.002,9.001,57.31684",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2l = [];
/* style */

const __vue_inject_styles__$2l = undefined;
/* scoped */

const __vue_scope_id__$2l = undefined;
/* module identifier */

const __vue_module_identifier__$2l = undefined;
/* functional template */

const __vue_is_functional_template__$2l = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2l = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2l,
  staticRenderFns: __vue_staticRenderFns__$2l
}, __vue_inject_styles__$2l, __vue_script__$2l, __vue_scope_id__$2l, __vue_is_functional_template__$2l, __vue_module_identifier__$2l, false, undefined, undefined, undefined);

var script$2m = Vue.extend({
  name: "PhBellZ",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2m = script$2m;
/* template */

var __vue_render__$2m = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "108 96 148 96 108 144 148 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56.20305,104A71.899,71.899,0,0,1,128.5484,32.002c39.58967.29432,71.25651,33.20133,71.25651,72.90185V112c0,35.81563,7.49325,56.59893,14.093,67.95814A7.999,7.999,0,0,1,207.01628,192H48.98365A7.99908,7.99908,0,0,1,42.103,179.95641c6.60328-11.35959,14.1-32.1426,14.1-67.95641Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,192v8a32,32,0,0,0,64,0v-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56.20305,104A71.899,71.899,0,0,1,128.5484,32.002c39.58967.29432,71.25651,33.20133,71.25651,72.90185V112c0,35.81563,7.49325,56.59893,14.093,67.95814A7.999,7.999,0,0,1,207.01628,192H48.98365A7.99908,7.99908,0,0,1,42.103,179.95641c6.60328-11.35959,14.1-32.1426,14.1-67.95641Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56.20305,104A71.899,71.899,0,0,1,128.5484,32.002c39.58967.29432,71.25651,33.20133,71.25651,72.90185V112c0,35.81563,7.49325,56.59893,14.093,67.95814A7.999,7.999,0,0,1,207.01628,192H48.98365A7.99908,7.99908,0,0,1,42.103,179.95641c6.60328-11.35959,14.1-32.1426,14.1-67.95641Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,192v8a32,32,0,0,0,64,0v-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 96 148 96 108 144 148 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M220.81445,175.93945C214.87988,165.72363,207.80469,146.33789,207.80469,112v-7.0957c0-44.28516-35.52735-80.57813-79.19629-80.90235-.2041-.001-.40625-.002-.61035-.002a79.89888,79.89888,0,0,0-79.79492,80v8c0,34.33594-7.07911,53.7207-13.01661,63.93555A15.99886,15.99886,0,0,0,48.9834,200H88a40,40,0,0,0,80,0h39.0166a15.99808,15.99808,0,0,0,13.79785-24.06055ZM128,224a24.0275,24.0275,0,0,1-24-24h48A24.0275,24.0275,0,0,1,128,224Zm20-72H108a7.99925,7.99925,0,0,1-6.14551-13.12109L130.91992,104H108a8,8,0,0,1,0-16h40a7.99925,7.99925,0,0,1,6.14551,13.12109L125.08008,136H148a8,8,0,0,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56.20305,104A71.899,71.899,0,0,1,128.5484,32.002c39.58967.29432,71.25651,33.20133,71.25651,72.90185V112c0,35.81563,7.49325,56.59893,14.093,67.95814A7.999,7.999,0,0,1,207.01628,192H48.98365A7.99908,7.99908,0,0,1,42.103,179.95641c6.60328-11.35959,14.1-32.1426,14.1-67.95641Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,192v8a32,32,0,0,0,64,0v-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 96 148 96 108 144 148 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56.20305,104A71.899,71.899,0,0,1,128.5484,32.002c39.58967.29432,71.25651,33.20133,71.25651,72.90185V112c0,35.81563,7.49325,56.59893,14.093,67.95814A7.999,7.999,0,0,1,207.01628,192H48.98365A7.99908,7.99908,0,0,1,42.103,179.95641c6.60328-11.35959,14.1-32.1426,14.1-67.95641Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,192v8a32,32,0,0,0,64,0v-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 96 148 96 108 144 148 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56.20305,104A71.899,71.899,0,0,1,128.5484,32.002c39.58967.29432,71.25651,33.20133,71.25651,72.90185V112c0,35.81563,7.49325,56.59893,14.093,67.95814A7.999,7.999,0,0,1,207.01628,192H48.98365A7.99908,7.99908,0,0,1,42.103,179.95641c6.60328-11.35959,14.1-32.1426,14.1-67.95641Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,192v8a32,32,0,0,0,64,0v-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 96 148 96 108 144 148 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2m = [];
/* style */

const __vue_inject_styles__$2m = undefined;
/* scoped */

const __vue_scope_id__$2m = undefined;
/* module identifier */

const __vue_module_identifier__$2m = undefined;
/* functional template */

const __vue_is_functional_template__$2m = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2m = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2m,
  staticRenderFns: __vue_staticRenderFns__$2m
}, __vue_inject_styles__$2m, __vue_script__$2m, __vue_scope_id__$2m, __vue_is_functional_template__$2m, __vue_module_identifier__$2m, false, undefined, undefined, undefined);

var script$2n = Vue.extend({
  name: "PhBicycle",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2n = script$2n;
/* template */

var __vue_render__$2n = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,80a16,16,0,0,0-16-16H148l56,96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "204",
      "cy": "160",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "52",
      "cy": "160",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "166.667 96 102.667 96 52 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "52 64 84 64 128.333 140",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "208",
      "cy": "160",
      "r": "40",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "48",
      "cy": "160",
      "r": "40",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,80a16,16,0,0,0-16-16H152l56,96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "208",
      "cy": "160",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "48",
      "cy": "160",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48 64 76 64 132 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "170.087 96 94.667 96 48 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M256,160a48,48,0,1,1-78.74414-36.82715l23.834,40.85791a7.99983,7.99983,0,1,0,13.82032-8.06152l-23.84375-40.87549A47.983,47.983,0,0,1,256,160ZM47.99316,168.00049a8.00038,8.00038,0,0,1-6.457-12.71387l27.875-38.22827a48.13563,48.13563,0,1,0,12.918,9.43994L54.46387,164.71338A7.98855,7.98855,0,0,1,47.99316,168.00049ZM165.92871,72H192a8.00917,8.00917,0,0,1,8,8,8,8,0,0,0,16,0,24.02718,24.02718,0,0,0-24-24H152a7.99957,7.99957,0,0,0-6.91016,12.03076L156.73853,88H99.26147L82.91016,59.96924A7.999,7.999,0,0,0,76,56H48a8,8,0,0,0,0,16H71.40527L85.12134,95.51318,69.41113,117.05835a48.23239,48.23239,0,0,1,12.918,9.43994l11.59278-15.89844,31.168,53.43091a7.99983,7.99983,0,1,0,13.82032-8.06152L108.59473,104h57.477l11.18408,19.17285a48.02278,48.02278,0,0,1,13.81055-8.0791Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,80a16,16,0,0,0-16-16H152l56,96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "208",
      "cy": "160",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "48",
      "cy": "160",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48 64 76 64 132 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "170.087 96 94.667 96 48 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,80a16,16,0,0,0-16-16H152l56,96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "208",
      "cy": "160",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "48",
      "cy": "160",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48 64 76 64 132 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "170.087 96 94.667 96 48 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,80a16,16,0,0,0-16-16H152l56,96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "208",
      "cy": "160",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "48",
      "cy": "160",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48 64 76 64 132 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "170.087 96 94.667 96 48 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2n = [];
/* style */

const __vue_inject_styles__$2n = undefined;
/* scoped */

const __vue_scope_id__$2n = undefined;
/* module identifier */

const __vue_module_identifier__$2n = undefined;
/* functional template */

const __vue_is_functional_template__$2n = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2n = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2n,
  staticRenderFns: __vue_staticRenderFns__$2n
}, __vue_inject_styles__$2n, __vue_script__$2n, __vue_scope_id__$2n, __vue_is_functional_template__$2n, __vue_module_identifier__$2n, false, undefined, undefined, undefined);

var script$2o = Vue.extend({
  name: "PhBird",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2o = script$2o;
/* template */

var __vue_render__$2o = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "160",
      "cy": "72",
      "r": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,96v24a96,96,0,0,1-96,96H12L104,96V76A52.00738,52.00738,0,0,1,206.33275,62.88778L232,80Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "90.66667",
      "y1": "176",
      "x2": "121.33333",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,96v24a96,96,0,0,1-96,96H8L104,96V76A52.00738,52.00738,0,0,1,206.33275,62.88778L232,80Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "68",
      "r": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "136",
      "x2": "80",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,96v24a96,96,0,0,1-96,96H8L104,96V76A52.00738,52.00738,0,0,1,206.33275,62.88778L232,80Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M236.4375,73.34375,213.207,57.85547A60.00943,60.00943,0,0,0,96,76V93.19385L1.75293,211.00244A7.99963,7.99963,0,0,0,8,224H112A104.11791,104.11791,0,0,0,216,120V100.28125l20.4375-13.625a7.99959,7.99959,0,0,0,0-13.3125Zm-126.292,67.77783-40,48a7.99987,7.99987,0,0,1-12.291-10.24316l40-48a7.99987,7.99987,0,0,1,12.291,10.24316ZM164,80a12,12,0,1,1,12-12A12,12,0,0,1,164,80Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "164",
      "cy": "68",
      "r": "10"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "136",
      "x2": "80",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,96v24a96,96,0,0,1-96,96H8L104,96V76A52.00738,52.00738,0,0,1,206.33275,62.88778L232,80Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "164",
      "cy": "68",
      "r": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "136",
      "x2": "80",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,96v24a96,96,0,0,1-96,96H8L104,96V76A52.00738,52.00738,0,0,1,206.33275,62.88778L232,80Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "164",
      "cy": "68",
      "r": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "136",
      "x2": "80",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,96v24a96,96,0,0,1-96,96H8L104,96V76A52.00738,52.00738,0,0,1,206.33275,62.88778L232,80Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2o = [];
/* style */

const __vue_inject_styles__$2o = undefined;
/* scoped */

const __vue_scope_id__$2o = undefined;
/* module identifier */

const __vue_module_identifier__$2o = undefined;
/* functional template */

const __vue_is_functional_template__$2o = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2o = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2o,
  staticRenderFns: __vue_staticRenderFns__$2o
}, __vue_inject_styles__$2o, __vue_script__$2o, __vue_scope_id__$2o, __vue_is_functional_template__$2o, __vue_module_identifier__$2o, false, undefined, undefined, undefined);

var script$2p = Vue.extend({
  name: "PhBluetooth",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2p = script$2p;
/* template */

var __vue_render__$2p = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "120 32.003 184 80.003 120 128.003 120 32.003",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "120 128.003 184 176.003 120 224.003 120 128.003",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "80.00256",
      "x2": "120",
      "y2": "128.00256",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "176.00256",
      "x2": "120",
      "y2": "128.00256",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "120 32.003 184 80.003 120 128.003 120 32.003",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "120 128.003 184 176.003 120 224.003 120 128.003",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "120 128.003 184 176.003 120 224.003 120 128.003",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "120 32.003 184 80.003 120 128.003 120 32.003",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "80.00256",
      "x2": "120",
      "y2": "128.00256",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "176.00256",
      "x2": "120",
      "y2": "128.00256",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M188.79883,169.60193l-55.46631-41.59967,55.46631-41.6a7.99952,7.99952,0,0,0,0-12.7998l-64-48a8,8,0,0,0-12.79981,6.3999v80.00006l-51.20019-38.4a7.9998,7.9998,0,1,0-9.59961,12.7998l55.46631,41.6L51.19922,169.60193a8.0002,8.0002,0,0,0,9.59961,12.80078L111.999,144.00238v79.99994a8.00025,8.00025,0,0,0,12.79981,6.40039l64-48a8.0005,8.0005,0,0,0,0-12.80078ZM127.999,48.00232l42.667,32-42.667,32Zm0,160v-64l42.667,32Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "120 32.003 184 80.003 120 128.003 120 32.003",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "120 128.003 184 176.003 120 224.003 120 128.003",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "80.00256",
      "x2": "120",
      "y2": "128.00256",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "176.00256",
      "x2": "120",
      "y2": "128.00256",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "120 32.003 184 80.003 120 128.003 120 32.003",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "120 128.003 184 176.003 120 224.003 120 128.003",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "80.00256",
      "x2": "120",
      "y2": "128.00256",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "176.00256",
      "x2": "120",
      "y2": "128.00256",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "120 32.003 184 80.003 120 128.003 120 32.003",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "120 128.003 184 176.003 120 224.003 120 128.003",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "80.00256",
      "x2": "120",
      "y2": "128.00256",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "176.00256",
      "x2": "120",
      "y2": "128.00256",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2p = [];
/* style */

const __vue_inject_styles__$2p = undefined;
/* scoped */

const __vue_scope_id__$2p = undefined;
/* module identifier */

const __vue_module_identifier__$2p = undefined;
/* functional template */

const __vue_is_functional_template__$2p = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2p = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2p,
  staticRenderFns: __vue_staticRenderFns__$2p
}, __vue_inject_styles__$2p, __vue_script__$2p, __vue_scope_id__$2p, __vue_is_functional_template__$2p, __vue_module_identifier__$2p, false, undefined, undefined, undefined);

var script$2q = Vue.extend({
  name: "PhBluetoothConnected",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2q = script$2q;
/* template */

var __vue_render__$2q = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "120 32 184 80 120 128 120 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "120 128 184 176 120 224 120 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "80",
      "x2": "120",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "176",
      "x2": "120",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "52",
      "cy": "128",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "196",
      "cy": "128",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "120 32 184 80 120 128 120 32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "120 128 184 176 120 224 120 128",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "120 32 184 80 120 128 120 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "120 128 184 176 120 224 120 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "80",
      "x2": "120",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "176",
      "x2": "120",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "52",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "196",
      "cy": "128",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M188.7998,169.6,133.334,128.00037,188.7998,86.40076a8.00048,8.00048,0,0,0,0-12.80078l-64-48A8.0003,8.0003,0,0,0,112,32.00037v79.99957L60.7998,73.6a8.00019,8.00019,0,0,0-9.5996,12.80078L106.666,128.00037,51.2002,169.6a8.00019,8.00019,0,0,0,9.5996,12.80078l51.2002-38.4v79.99958a8.00024,8.00024,0,0,0,12.7998,6.40039l64-48a8.00048,8.00048,0,0,0,0-12.80078ZM128,48.00037l42.667,32-42.667,32Zm0,160v-64l42.667,32Zm80-80a12,12,0,1,1-12-12A12.01344,12.01344,0,0,1,208,128.00037Zm-156,12a12,12,0,1,1,12-12A12.01344,12.01344,0,0,1,52,140.00037Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "120 32 184 80 120 128 120 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "120 128 184 176 120 224 120 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "80",
      "x2": "120",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "176",
      "x2": "120",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "52",
      "cy": "128",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "196",
      "cy": "128",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "120 32 184 80 120 128 120 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "120 128 184 176 120 224 120 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "80",
      "x2": "120",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "176",
      "x2": "120",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "52",
      "cy": "128",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "196",
      "cy": "128",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "120 32 184 80 120 128 120 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "120 128 184 176 120 224 120 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "80",
      "x2": "120",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "176",
      "x2": "120",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "52",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "196",
      "cy": "128",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2q = [];
/* style */

const __vue_inject_styles__$2q = undefined;
/* scoped */

const __vue_scope_id__$2q = undefined;
/* module identifier */

const __vue_module_identifier__$2q = undefined;
/* functional template */

const __vue_is_functional_template__$2q = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2q = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2q,
  staticRenderFns: __vue_staticRenderFns__$2q
}, __vue_inject_styles__$2q, __vue_script__$2q, __vue_scope_id__$2q, __vue_is_functional_template__$2q, __vue_module_identifier__$2q, false, undefined, undefined, undefined);

var script$2r = Vue.extend({
  name: "PhBluetoothSlash",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2r = script$2r;
/* template */

var __vue_render__$2r = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "55.99414",
      "y1": "176.00256",
      "x2": "119.99414",
      "y2": "128.00256",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176.648 181.512 119.994 224.003 119.994 119.194",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "119.994 59.729 119.994 32.003 183.994 80.003 156.899 100.324",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "119.971 32.003 183.971 80.003 119.971 128.003 119.971 32.003",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "119.971 128 183.971 176 119.971 224 119.971 128",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "176.00256",
      "x2": "120",
      "y2": "128.00256",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48.00586",
      "y1": "40",
      "x2": "208.00586",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "120 71.622 120 32.003 184 80.003 150.476 105.146",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176.654 181.512 120 224.003 120 128.003 145.169 146.879",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M213.91943,210.61865l-31.39087-34.53-.009-.01-31.35718-34.49292-.02148-.02343L53.91943,34.61865a7.99991,7.99991,0,1,0-11.83886,10.7627l70.8413,77.92553L51.19434,169.60254a7.9998,7.9998,0,1,0,9.5996,12.7998l51.2002-38.40014v80.00024a7.99975,7.99975,0,0,0,12.7998,6.3999l50.83033-38.12292,26.4563,29.10193a7.99991,7.99991,0,0,0,11.83886-10.7627Zm-85.92529-2.61621v-64l11.76013,8.82007,25.05945,27.56519Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M119.99414,79.62207a7.99977,7.99977,0,0,0,8-8V48.00244l42.6665,32L145.67041,98.74561a7.9998,7.9998,0,1,0,9.59961,12.7998l33.52392-25.14307a7.9995,7.9995,0,0,0,0-12.7998l-64-48a8,8,0,0,0-12.7998,6.3999V71.62207A7.99977,7.99977,0,0,0,119.99414,79.62207Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "55.99414",
      "y1": "176.00256",
      "x2": "119.99414",
      "y2": "128.00256",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "119.994 71.622 119.994 32.003 183.994 80.003 150.47 105.146",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176.648 181.512 119.994 224.003 119.994 128.003 145.163 146.879",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "55.99414",
      "y1": "176.00256",
      "x2": "119.99414",
      "y2": "128.00256",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "119.994 71.622 119.994 32.003 183.994 80.003 150.47 105.146",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176.648 181.512 119.994 224.003 119.994 128.003 145.163 146.879",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "55.99414",
      "y1": "176.00256",
      "x2": "119.99414",
      "y2": "128.00256",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "119.994 71.622 119.994 32.003 183.994 80.003 150.47 105.146",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176.648 181.512 119.994 224.003 119.994 128.003 145.163 146.879",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2r = [];
/* style */

const __vue_inject_styles__$2r = undefined;
/* scoped */

const __vue_scope_id__$2r = undefined;
/* module identifier */

const __vue_module_identifier__$2r = undefined;
/* functional template */

const __vue_is_functional_template__$2r = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2r = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2r,
  staticRenderFns: __vue_staticRenderFns__$2r
}, __vue_inject_styles__$2r, __vue_script__$2r, __vue_scope_id__$2r, __vue_is_functional_template__$2r, __vue_module_identifier__$2r, false, undefined, undefined, undefined);

var script$2s = Vue.extend({
  name: "PhBluetoothX",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2s = script$2s;
/* template */

var __vue_render__$2s = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "120 128.003 184 176.003 120 224.003 120 128.003",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "80.00256",
      "x2": "120",
      "y2": "128.00256",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "176.00256",
      "x2": "120",
      "y2": "128.00256",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "56",
      "x2": "184",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "104",
      "x2": "184",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144.406 109.698 120 128.003 120 32.003 144.405 50.307",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "119.971 32.003 183.971 80.003 119.971 128.003 119.971 32.003",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "119.971 128 183.971 176 119.971 224 119.971 128",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "120 128.003 184 176.003 120 224.003 120 128.003",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "80.00256",
      "x2": "120",
      "y2": "128.00256",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "176.00256",
      "x2": "120",
      "y2": "128.00256",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "56",
      "x2": "184",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "104",
      "x2": "184",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 104.002 120 128.003 120 32.003 151.999 56.002",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M188.7998,169.60254,133.333,128.00244l23.46679-17.6001a7.9998,7.9998,0,1,0-9.59961-12.7998L128,112.00244v-64l19.19922,14.39893a7.99981,7.99981,0,0,0,9.59961-12.79981l-31.999-23.999A8,8,0,0,0,112,32.00244v80.00025L60.7998,73.60254a7.9998,7.9998,0,0,0-9.59961,12.7998l55.4668,41.6001-55.4668,41.6001a7.9998,7.9998,0,1,0,9.59961,12.7998L112,144.0022v80.00024a7.99975,7.99975,0,0,0,12.7998,6.3999l64-48a7.9995,7.9995,0,0,0,0-12.7998ZM128,208.00244v-64l42.6665,32Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M219.31348,80l18.34326-18.34326a7.99984,7.99984,0,0,0-11.31348-11.31348L208,68.68652,189.65674,50.34326a7.99984,7.99984,0,0,0-11.31348,11.31348L196.68652,80,178.34326,98.34326a7.99984,7.99984,0,1,0,11.31348,11.31348L208,91.31348l18.34326,18.34326a7.99984,7.99984,0,1,0,11.31348-11.31348Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "120 128.003 184 176.003 120 224.003 120 128.003",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "80.00256",
      "x2": "120",
      "y2": "128.00256",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "176.00256",
      "x2": "120",
      "y2": "128.00256",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "56",
      "x2": "184",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "104",
      "x2": "184",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 104.002 120 128.003 120 32.003 151.999 56.002",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "120 128.003 184 176.003 120 224.003 120 128.003",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "80.00256",
      "x2": "120",
      "y2": "128.00256",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "176.00256",
      "x2": "120",
      "y2": "128.00256",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "56",
      "x2": "184",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "104",
      "x2": "184",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 104.002 120 128.003 120 32.003 151.999 56.002",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "120 128.003 184 176.003 120 224.003 120 128.003",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "80.00256",
      "x2": "120",
      "y2": "128.00256",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "176.00256",
      "x2": "120",
      "y2": "128.00256",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "56",
      "x2": "184",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "104",
      "x2": "184",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 104.002 120 128.003 120 32.003 151.999 56.002",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2s = [];
/* style */

const __vue_inject_styles__$2s = undefined;
/* scoped */

const __vue_scope_id__$2s = undefined;
/* module identifier */

const __vue_module_identifier__$2s = undefined;
/* functional template */

const __vue_is_functional_template__$2s = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2s = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2s,
  staticRenderFns: __vue_staticRenderFns__$2s
}, __vue_inject_styles__$2s, __vue_script__$2s, __vue_scope_id__$2s, __vue_is_functional_template__$2s, __vue_module_identifier__$2s, false, undefined, undefined, undefined);

var script$2t = Vue.extend({
  name: "PhBoat",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2t = script$2t;
/* template */

var __vue_render__$2t = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "48",
      "x2": "128",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,160c-14.57032,50.99614-82.21424,68.82128-94.18651,71.59963a8.00355,8.00355,0,0,1-3.627,0C114.21424,228.82128,46.57032,210.99614,32,160V125.76607a8,8,0,0,1,5.47018-7.58946l88-29.33334a8.0001,8.0001,0,0,1,5.05964,0l88,29.33334A8,8,0,0,1,224,125.76607Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "168",
      "x2": "128",
      "y2": "88.43274",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,112V56a8,8,0,0,1,8-8H192a8,8,0,0,1,8,8v56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,160c-14.57032,50.99614-82.21424,68.82128-94.18651,71.59963a8.00355,8.00355,0,0,1-3.627,0C114.21424,228.82128,46.57032,210.99614,32,160V125.76607a8,8,0,0,1,5.47018-7.58946l88-29.33334a8.0001,8.0001,0,0,1,5.05964,0l88,29.33334A8,8,0,0,1,224,125.76607Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "48",
      "x2": "128",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,160c-14.57032,50.99614-82.21424,68.82128-94.18651,71.59963a8.00355,8.00355,0,0,1-3.627,0C114.21424,228.82128,46.57032,210.99614,32,160V125.76607a8,8,0,0,1,5.47018-7.58946l88-29.33334a8.0001,8.0001,0,0,1,5.05964,0l88,29.33334A8,8,0,0,1,224,125.76607Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "168",
      "x2": "128",
      "y2": "88.43274",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,112V56a8,8,0,0,1,8-8H192a8,8,0,0,1,8,8v56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M221.06055,110.58691,208,106.2334V56a16.01833,16.01833,0,0,0-16-16H136V24a8,8,0,0,0-16,0V40H64A16.01833,16.01833,0,0,0,48,56v50.2334l-13.06055,4.35351A15.98076,15.98076,0,0,0,24,125.76611V160a8.00533,8.00533,0,0,0,.30762,2.19775c15.71972,55.01856,86.11816,73.957,100.07031,77.19483a16.1234,16.1234,0,0,0,7.24414,0c13.95215-3.23779,84.35059-22.17627,100.07031-77.19483A8.00533,8.00533,0,0,0,232,160V125.76611A15.98076,15.98076,0,0,0,221.06055,110.58691ZM136,168a8,8,0,0,1-16,0V112.43262a8,8,0,1,1,16,0Zm56-67.09961L133.05957,81.25391a16.0984,16.0984,0,0,0-10.12012,0L64,100.90039V56H192Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "48",
      "x2": "128",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,160c-14.57032,50.99614-82.21424,68.82128-94.18651,71.59963a8.00355,8.00355,0,0,1-3.627,0C114.21424,228.82128,46.57032,210.99614,32,160V125.76607a8,8,0,0,1,5.47018-7.58946l88-29.33334a8.0001,8.0001,0,0,1,5.05964,0l88,29.33334A8,8,0,0,1,224,125.76607Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "168",
      "x2": "128",
      "y2": "88.43274",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,112V56a8,8,0,0,1,8-8H192a8,8,0,0,1,8,8v56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "48",
      "x2": "128",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,160c-14.57032,50.99614-82.21424,68.82128-94.18651,71.59963a8.00355,8.00355,0,0,1-3.627,0C114.21424,228.82128,46.57032,210.99614,32,160V125.76607a8,8,0,0,1,5.47018-7.58946l88-29.33334a8.0001,8.0001,0,0,1,5.05964,0l88,29.33334A8,8,0,0,1,224,125.76607Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "168",
      "x2": "128",
      "y2": "88.43274",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,112V56a8,8,0,0,1,8-8H192a8,8,0,0,1,8,8v56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "48",
      "x2": "128",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,160c-14.57032,50.99614-82.21424,68.82128-94.18651,71.59963a8.00355,8.00355,0,0,1-3.627,0C114.21424,228.82128,46.57032,210.99614,32,160V125.76607a8,8,0,0,1,5.47018-7.58946l88-29.33334a8.0001,8.0001,0,0,1,5.05964,0l88,29.33334A8,8,0,0,1,224,125.76607Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "168",
      "x2": "128",
      "y2": "88.43274",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,112V56a8,8,0,0,1,8-8H192a8,8,0,0,1,8,8v56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2t = [];
/* style */

const __vue_inject_styles__$2t = undefined;
/* scoped */

const __vue_scope_id__$2t = undefined;
/* module identifier */

const __vue_module_identifier__$2t = undefined;
/* functional template */

const __vue_is_functional_template__$2t = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2t = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2t,
  staticRenderFns: __vue_staticRenderFns__$2t
}, __vue_inject_styles__$2t, __vue_script__$2t, __vue_scope_id__$2t, __vue_is_functional_template__$2t, __vue_module_identifier__$2t, false, undefined, undefined, undefined);

var script$2u = Vue.extend({
  name: "PhBook",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2u = script$2u;
/* template */

var __vue_render__$2u = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M48,208a24,24,0,0,1,24-24H208V32H72A24,24,0,0,0,48,56Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48 208 48 224 192 224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M48,216a24,24,0,0,1,24-24H208V32H72A24,24,0,0,0,48,56Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,216a24,24,0,0,1,24-24H208V32H72A24,24,0,0,0,48,56Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48 216 48 224 192 224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,32V192a8.00039,8.00039,0,0,1-8,8H72a16.01833,16.01833,0,0,0-16,16H192a8,8,0,0,1,0,16H48a8.00039,8.00039,0,0,1-8-8V56A32.03667,32.03667,0,0,1,72,24H208A8.00039,8.00039,0,0,1,216,32Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M48,216a24,24,0,0,1,24-24H208V32H72A24,24,0,0,0,48,56Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48 216 48 224 192 224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M48,216a24,24,0,0,1,24-24H208V32H72A24,24,0,0,0,48,56Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48 216 48 224 192 224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M48,216a24,24,0,0,1,24-24H208V32H72A24,24,0,0,0,48,56Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48 216 48 224 192 224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2u = [];
/* style */

const __vue_inject_styles__$2u = undefined;
/* scoped */

const __vue_scope_id__$2u = undefined;
/* module identifier */

const __vue_module_identifier__$2u = undefined;
/* functional template */

const __vue_is_functional_template__$2u = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2u = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2u,
  staticRenderFns: __vue_staticRenderFns__$2u
}, __vue_inject_styles__$2u, __vue_script__$2u, __vue_scope_id__$2u, __vue_is_functional_template__$2u, __vue_module_identifier__$2u, false, undefined, undefined, undefined);

var script$2v = Vue.extend({
  name: "PhBookBookmark",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2v = script$2v;
/* template */

var __vue_render__$2v = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "172.002 32 172.002 128 139.995 104 108.002 128 108.002 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48.00244,208a24,24,0,0,1,24-24h136V32h-136a24,24,0,0,0-24,24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48.002 208 48.002 224 192.002 224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176.00244,32v96l-32.00732-24-31.99268,24V32h-40a23.99994,23.99994,0,0,0-24,24V216a23.99994,23.99994,0,0,1,24-24h136V32Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48.002 216 48.002 224 192.002 224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176.002 32 176.002 128 143.995 104 112.002 128 112.002 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48.00244,216a24,24,0,0,1,24-24h136V32h-136a24,24,0,0,0-24,24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208.00244,24h-136a32.03667,32.03667,0,0,0-32,32V224a8.00039,8.00039,0,0,0,8,8h144a8,8,0,0,0,0-16h-136a16.01833,16.01833,0,0,1,16-16h136a8.00039,8.00039,0,0,0,8-8V32A8.00039,8.00039,0,0,0,208.00244,24Zm-24,96.001L158.394,100.7998a4.0005,4.0005,0,0,0-4.7998,0L128.00244,119.999V40h56Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176.002 32 176.002 128 143.995 104 112.002 128 112.002 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48.00244,216a24,24,0,0,1,24-24h136V32h-136a24,24,0,0,0-24,24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48.002 216 48.002 224 192.002 224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176.002 32 176.002 128 143.995 104 112.002 128 112.002 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48.00244,216a24,24,0,0,1,24-24h136V32h-136a24,24,0,0,0-24,24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48.002 216 48.002 224 192.002 224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176.002 32 176.002 128 143.995 104 112.002 128 112.002 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48.00244,216a24,24,0,0,1,24-24h136V32h-136a24,24,0,0,0-24,24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48.002 216 48.002 224 192.002 224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2v = [];
/* style */

const __vue_inject_styles__$2v = undefined;
/* scoped */

const __vue_scope_id__$2v = undefined;
/* module identifier */

const __vue_module_identifier__$2v = undefined;
/* functional template */

const __vue_is_functional_template__$2v = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2v = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2v,
  staticRenderFns: __vue_staticRenderFns__$2v
}, __vue_inject_styles__$2v, __vue_script__$2v, __vue_scope_id__$2v, __vue_is_functional_template__$2v, __vue_module_identifier__$2v, false, undefined, undefined, undefined);

var script$2w = Vue.extend({
  name: "PhBookOpen",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2w = script$2w;
/* template */

var __vue_render__$2w = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,88a32,32,0,0,1,32-32h64a8,8,0,0,1,8,8V192a8,8,0,0,1-8,8H160a32,32,0,0,0-32,32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,192a8,8,0,0,0,8,8H96a32,32,0,0,1,32,32V88A32,32,0,0,0,96,56H32a8,8,0,0,0-8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,56H160a32.00018,32.00018,0,0,0-32,32A31.99986,31.99986,0,0,0,96,56H32a7.99993,7.99993,0,0,0-8,8V192a7.99993,7.99993,0,0,0,8,8H96a31.99986,31.99986,0,0,1,32,32,32.00018,32.00018,0,0,1,32-32h64a7.99993,7.99993,0,0,0,8-8V64A7.99993,7.99993,0,0,0,224,56Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,88a32,32,0,0,1,32-32h64a8,8,0,0,1,8,8V192a8,8,0,0,1-8,8H160a32,32,0,0,0-32,32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,192a8,8,0,0,0,8,8H96a32,32,0,0,1,32,32V88A32,32,0,0,0,96,56H32a8,8,0,0,0-8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M96,208a24.0275,24.0275,0,0,1,24,24,8,8,0,0,0,16,0,24.0275,24.0275,0,0,1,24-24h64a16.01833,16.01833,0,0,0,16-16V64a16.01833,16.01833,0,0,0-16-16H176a40.04552,40.04552,0,0,0-40,40v80a8,8,0,0,1-16,0V88A40.04552,40.04552,0,0,0,80,48H32A16.01833,16.01833,0,0,0,16,64V192a16.01833,16.01833,0,0,0,16,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,88a32,32,0,0,1,32-32h64a8,8,0,0,1,8,8V192a8,8,0,0,1-8,8H160a32,32,0,0,0-32,32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,192a8,8,0,0,0,8,8H96a32,32,0,0,1,32,32V88A32,32,0,0,0,96,56H32a8,8,0,0,0-8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,88a32,32,0,0,1,32-32h64a8,8,0,0,1,8,8V192a8,8,0,0,1-8,8H160a32,32,0,0,0-32,32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,192a8,8,0,0,0,8,8H96a32,32,0,0,1,32,32V88A32,32,0,0,0,96,56H32a8,8,0,0,0-8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,88a32,32,0,0,1,32-32h64a8,8,0,0,1,8,8V192a8,8,0,0,1-8,8H160a32,32,0,0,0-32,32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,192a8,8,0,0,0,8,8H96a32,32,0,0,1,32,32V88A32,32,0,0,0,96,56H32a8,8,0,0,0-8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2w = [];
/* style */

const __vue_inject_styles__$2w = undefined;
/* scoped */

const __vue_scope_id__$2w = undefined;
/* module identifier */

const __vue_module_identifier__$2w = undefined;
/* functional template */

const __vue_is_functional_template__$2w = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2w = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2w,
  staticRenderFns: __vue_staticRenderFns__$2w
}, __vue_inject_styles__$2w, __vue_script__$2w, __vue_scope_id__$2w, __vue_is_functional_template__$2w, __vue_module_identifier__$2w, false, undefined, undefined, undefined);

var script$2x = Vue.extend({
  name: "PhBookmark",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2x = script$2x;
/* template */

var __vue_render__$2x = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M191.98242,224,127.975,184l-63.9926,40V48a8,8,0,0,1,8-8h112a8,8,0,0,1,8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "191.982 176 127.975 136 63.982 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "191.971 176 127.963 136 63.971 176 63.971 224 127.963 184 191.971 224 191.971 176",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M191.9707,224l-64.0074-40L63.9707,224V48a8,8,0,0,1,8-8h112a8,8,0,0,1,8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "191.971 176 127.963 136 63.971 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M183.97656,32h-112a16.01833,16.01833,0,0,0-16,16V224a8.00043,8.00043,0,0,0,12.24024,6.78418l59.75293-37.35059,59.76709,37.35059A8,8,0,0,0,199.97656,224V48A16.01833,16.01833,0,0,0,183.97656,32ZM132.209,177.21582a8.00107,8.00107,0,0,0-8.48,0L71.97656,209.56543V180.434l55.99317-35.00043,56.00683,35.00068v29.13311Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M191.98828,224l-64.0074-40-63.9926,40V48a8,8,0,0,1,8-8h112a8,8,0,0,1,8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "191.988 176 127.981 136 63.988 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M191.99414,224l-64.0074-40-63.9926,40V48a8,8,0,0,1,8-8h112a8,8,0,0,1,8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "191.994 176 127.987 136 63.994 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M192,224l-64.0074-40L64,224V48a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192 176 127.993 136 64 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2x = [];
/* style */

const __vue_inject_styles__$2x = undefined;
/* scoped */

const __vue_scope_id__$2x = undefined;
/* module identifier */

const __vue_module_identifier__$2x = undefined;
/* functional template */

const __vue_is_functional_template__$2x = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2x = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2x,
  staticRenderFns: __vue_staticRenderFns__$2x
}, __vue_inject_styles__$2x, __vue_script__$2x, __vue_scope_id__$2x, __vue_is_functional_template__$2x, __vue_module_identifier__$2x, false, undefined, undefined, undefined);

var script$2y = Vue.extend({
  name: "PhBookmarkSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2y = script$2y;
/* template */

var __vue_render__$2y = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M191.98242,224,127.975,184l-63.9926,40V48a8,8,0,0,1,8-8h112a8,8,0,0,1,8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M191.9707,224l-64.0074-40L63.9707,224V48a8,8,0,0,1,8-8h112a8,8,0,0,1,8,8Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M191.9707,224l-64.0074-40L63.9707,224V48a8,8,0,0,1,8-8h112a8,8,0,0,1,8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M183.97656,32h-112a16.01833,16.01833,0,0,0-16,16V224a8.00043,8.00043,0,0,0,12.24024,6.78418l59.75293-37.35059,59.76709,37.35059A8,8,0,0,0,199.97656,224V48A16.01833,16.01833,0,0,0,183.97656,32Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M191.98828,224l-64.0074-40-63.9926,40V48a8,8,0,0,1,8-8h112a8,8,0,0,1,8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M191.99414,224l-64.0074-40-63.9926,40V48a8,8,0,0,1,8-8h112a8,8,0,0,1,8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M192,224l-64.0074-40L64,224V48a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2y = [];
/* style */

const __vue_inject_styles__$2y = undefined;
/* scoped */

const __vue_scope_id__$2y = undefined;
/* module identifier */

const __vue_module_identifier__$2y = undefined;
/* functional template */

const __vue_is_functional_template__$2y = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2y = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2y,
  staticRenderFns: __vue_staticRenderFns__$2y
}, __vue_inject_styles__$2y, __vue_script__$2y, __vue_scope_id__$2y, __vue_is_functional_template__$2y, __vue_module_identifier__$2y, false, undefined, undefined, undefined);

var script$2z = Vue.extend({
  name: "PhBookmarks",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2z = script$2z;
/* template */

var __vue_render__$2z = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M160,224l-52.0074-40L56,224V80a8,8,0,0,1,8-8h88a8,8,0,0,1,8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,72V40a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8V184l-40-30.76487",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M192,32H96a7.99993,7.99993,0,0,0-8,8V64h72a7.99993,7.99993,0,0,1,8,8v97.146L200,192V40A7.99993,7.99993,0,0,0,192,32Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,224l-56.0074-40L56,224V72a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,64V40a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8V192l-32-22.85412",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M192,24H96A16.01833,16.01833,0,0,0,80,40V56H64A16.01833,16.01833,0,0,0,48,72V224a8.00026,8.00026,0,0,0,12.65039,6.50977l51.34277-36.67872,51.35743,36.67872A7.99952,7.99952,0,0,0,176,224V184.6897l19.35059,13.82007A7.99952,7.99952,0,0,0,208,192V40A16.01833,16.01833,0,0,0,192,24Zm0,152.45508-16-11.42676V72a16.01833,16.01833,0,0,0-16-16H96V40h96Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M168,224l-56.0074-40L56,224V72a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,64V40a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8V192l-32-22.85412",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M168,224l-56.0074-40L56,224V72a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,64V40a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8V192l-32-22.85412",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M168,224l-56.0074-40L56,224V72a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,64V40a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8V192l-32-22.85412",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2z = [];
/* style */

const __vue_inject_styles__$2z = undefined;
/* scoped */

const __vue_scope_id__$2z = undefined;
/* module identifier */

const __vue_module_identifier__$2z = undefined;
/* functional template */

const __vue_is_functional_template__$2z = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2z = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2z,
  staticRenderFns: __vue_staticRenderFns__$2z
}, __vue_inject_styles__$2z, __vue_script__$2z, __vue_scope_id__$2z, __vue_is_functional_template__$2z, __vue_module_identifier__$2z, false, undefined, undefined, undefined);

var script$2A = Vue.extend({
  name: "PhBookmarksSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2A = script$2A;
/* template */

var __vue_render__$2A = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M164.00586,228l-56.0074-40-55.9926,40V76a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.00586,28h104a8,8,0,0,1,8,8V188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M168.00586,224l-56.0074-40-55.9926,40V72a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168.00586,224l-56.0074-40-55.9926,40V72a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88.00586,32h104a8,8,0,0,1,8,8V192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M160.00586,56h-96a16.01833,16.01833,0,0,0-16,16V224a8.00026,8.00026,0,0,0,12.65039,6.50977L111.999,193.83105l51.35743,36.67872A7.99952,7.99952,0,0,0,176.00586,224V72A16.01833,16.01833,0,0,0,160.00586,56Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M192.00586,24h-104a8,8,0,0,0,0,16h104V192a8,8,0,0,0,16,0V40A16.01833,16.01833,0,0,0,192.00586,24Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M168.00586,224l-56.0074-40-55.9926,40V72a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88.00586,32h104a8,8,0,0,1,8,8V192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M168.00586,224l-56.0074-40-55.9926,40V72a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88.00586,32h104a8,8,0,0,1,8,8V192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M168.00586,224l-56.0074-40-55.9926,40V72a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88.00586,32h104a8,8,0,0,1,8,8V192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2A = [];
/* style */

const __vue_inject_styles__$2A = undefined;
/* scoped */

const __vue_scope_id__$2A = undefined;
/* module identifier */

const __vue_module_identifier__$2A = undefined;
/* functional template */

const __vue_is_functional_template__$2A = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2A = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2A,
  staticRenderFns: __vue_staticRenderFns__$2A
}, __vue_inject_styles__$2A, __vue_script__$2A, __vue_scope_id__$2A, __vue_is_functional_template__$2A, __vue_module_identifier__$2A, false, undefined, undefined, undefined);

var script$2B = Vue.extend({
  name: "PhBooks",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2B = script$2B;
/* template */

var __vue_render__$2B = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "48",
      "height": "176",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "80",
      "x2": "88",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "88",
      "y": "40",
      "width": "48",
      "height": "176",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "176",
      "x2": "136",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "158",
      "y": "38.58284",
      "width": "48",
      "height": "176",
      "rx": "8",
      "transform": "translate(-26.56055 51.41827) rotate(-15)",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "171.24109",
      "y1": "179.15894",
      "x2": "217.60553",
      "y2": "166.73563",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "146.39447",
      "y1": "86.43006",
      "x2": "192.75891",
      "y2": "74.00675",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,80H88V48a8,8,0,0,0-8-8H48a8,8,0,0,0-8,8Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,176h48V48a8,8,0,0,0-8-8H96a8,8,0,0,0-8,8Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M171.24109,179.15894l46.36444-12.42331,8.28221,30.90962a8,8,0,0,1-5.65685,9.798l-30.90963,8.28221a8,8,0,0,1-9.798-5.65685Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M146.39447,86.43006l46.36444-12.42331L184.4767,43.09712a8,8,0,0,0-9.798-5.65685l-30.90963,8.28221a8,8,0,0,0-5.65685,9.798Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "48",
      "height": "176",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "80",
      "x2": "88",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "88",
      "y": "40",
      "width": "48",
      "height": "176",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "176",
      "x2": "136",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "158",
      "y": "38.58284",
      "width": "48",
      "height": "176",
      "rx": "8",
      "transform": "translate(-26.56055 51.41827) rotate(-15)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "171.24109",
      "y1": "179.15894",
      "x2": "217.60553",
      "y2": "166.73563",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "146.39447",
      "y1": "86.43006",
      "x2": "192.75891",
      "y2": "74.00675",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M233.61523,195.5752,192.2041,41.02637a16.01548,16.01548,0,0,0-19.5957-11.31348l-30.91016,8.28223c-.33935.09094-.66357.20923-.99219.32043A15.96591,15.96591,0,0,0,128,32H96a15.8799,15.8799,0,0,0-8,2.16492A15.8799,15.8799,0,0,0,80,32H48A16.01833,16.01833,0,0,0,32,48V208a16.01833,16.01833,0,0,0,16,16H80a15.8799,15.8799,0,0,0,8-2.16492A15.8799,15.8799,0,0,0,96,224h32a16.01833,16.01833,0,0,0,16-16V108.40283l27.7959,103.73584a15.992,15.992,0,0,0,19.5957,11.31445l30.91016-8.28222A16.01822,16.01822,0,0,0,233.61523,195.5752ZM176.749,45.167l6.21338,23.18238-30.91113,8.28247L145.83984,53.4502ZM128,48l.00732,120H96V48ZM80,48V72H48V48Zm48,160H96V184h32.0083l.00147,24Zm90.16016-8.28418-30.90967,8.28223-6.21143-23.18189,30.918-8.28491,6.21289,23.18164Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "48",
      "height": "176",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "80",
      "x2": "88",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "88",
      "y": "40",
      "width": "48",
      "height": "176",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "176",
      "x2": "136",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "158",
      "y": "38.58284",
      "width": "48",
      "height": "176",
      "rx": "8",
      "transform": "matrix(0.96593, -0.25882, 0.25882, 0.96593, -26.56055, 51.41827)",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "171.24109",
      "y1": "179.15894",
      "x2": "217.60553",
      "y2": "166.73563",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "146.39447",
      "y1": "86.43006",
      "x2": "192.75891",
      "y2": "74.00675",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "48",
      "height": "176",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "80",
      "x2": "88",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "88",
      "y": "40",
      "width": "48",
      "height": "176",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "176",
      "x2": "136",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "158",
      "y": "38.58284",
      "width": "48",
      "height": "176",
      "rx": "8",
      "transform": "translate(-26.56055 51.41827) rotate(-15)",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "171.24109",
      "y1": "179.15894",
      "x2": "217.60553",
      "y2": "166.73563",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "146.39447",
      "y1": "86.43006",
      "x2": "192.75891",
      "y2": "74.00675",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "48",
      "height": "176",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "80",
      "x2": "88",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "88",
      "y": "40",
      "width": "48",
      "height": "176",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "176",
      "x2": "136",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "158",
      "y": "38.58284",
      "width": "48",
      "height": "176",
      "rx": "8",
      "transform": "matrix(0.96593, -0.25882, 0.25882, 0.96593, -26.56055, 51.41827)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "171.24109",
      "y1": "179.15894",
      "x2": "217.60553",
      "y2": "166.73563",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "146.39447",
      "y1": "86.43006",
      "x2": "192.75891",
      "y2": "74.00675",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2B = [];
/* style */

const __vue_inject_styles__$2B = undefined;
/* scoped */

const __vue_scope_id__$2B = undefined;
/* module identifier */

const __vue_module_identifier__$2B = undefined;
/* functional template */

const __vue_is_functional_template__$2B = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2B = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2B,
  staticRenderFns: __vue_staticRenderFns__$2B
}, __vue_inject_styles__$2B, __vue_script__$2B, __vue_scope_id__$2B, __vue_is_functional_template__$2B, __vue_module_identifier__$2B, false, undefined, undefined, undefined);

var script$2C = Vue.extend({
  name: "PhBoundingBox",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2C = script$2C;
/* template */

var __vue_render__$2C = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "168",
      "y": "40",
      "width": "48",
      "height": "48",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "48",
      "height": "48",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "168",
      "y": "168",
      "width": "48",
      "height": "48",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "168",
      "width": "48",
      "height": "48",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "168",
      "x2": "64",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "192",
      "x2": "88",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "88",
      "x2": "192",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "64",
      "x2": "168",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "168",
      "y": "40",
      "width": "48",
      "height": "48",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "48",
      "height": "48",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "168",
      "y": "168",
      "width": "48",
      "height": "48",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "168",
      "width": "48",
      "height": "48",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "168",
      "y": "40",
      "width": "48",
      "height": "48",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "48",
      "height": "48",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "168",
      "y": "168",
      "width": "48",
      "height": "48",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "168",
      "width": "48",
      "height": "48",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "168",
      "x2": "64",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "192",
      "x2": "88",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "88",
      "x2": "192",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "64",
      "x2": "168",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,96a16.01833,16.01833,0,0,0,16-16V48a16.01833,16.01833,0,0,0-16-16H176a16.01833,16.01833,0,0,0-16,16v8H96V48A16.01833,16.01833,0,0,0,80,32H48A16.01833,16.01833,0,0,0,32,48V80A16.01833,16.01833,0,0,0,48,96h8v64H48a16.01833,16.01833,0,0,0-16,16v32a16.01833,16.01833,0,0,0,16,16H80a16.01833,16.01833,0,0,0,16-16v-8h64v8a16.01833,16.01833,0,0,0,16,16h32a16.01833,16.01833,0,0,0,16-16V176a16.01833,16.01833,0,0,0-16-16h-8V96Zm-24,64h-8a16.01833,16.01833,0,0,0-16,16v8H96v-8a16.01833,16.01833,0,0,0-16-16H72V96h8A16.01833,16.01833,0,0,0,96,80V72h64v8a16.01833,16.01833,0,0,0,16,16h8Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "168",
      "y": "40",
      "width": "48",
      "height": "48",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "48",
      "height": "48",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "168",
      "y": "168",
      "width": "48",
      "height": "48",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "168",
      "width": "48",
      "height": "48",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "168",
      "x2": "64",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "192",
      "x2": "88",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "88",
      "x2": "192",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "64",
      "x2": "168",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "168",
      "y": "40",
      "width": "48",
      "height": "48",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "48",
      "height": "48",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "168",
      "y": "168",
      "width": "48",
      "height": "48",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "168",
      "width": "48",
      "height": "48",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "168",
      "x2": "64",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "192",
      "x2": "88",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "88",
      "x2": "192",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "64",
      "x2": "168",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "168",
      "y": "40",
      "width": "48",
      "height": "48",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "48",
      "height": "48",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "168",
      "y": "168",
      "width": "48",
      "height": "48",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "168",
      "width": "48",
      "height": "48",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "168",
      "x2": "64",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "192",
      "x2": "88",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "88",
      "x2": "192",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "64",
      "x2": "168",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2C = [];
/* style */

const __vue_inject_styles__$2C = undefined;
/* scoped */

const __vue_scope_id__$2C = undefined;
/* module identifier */

const __vue_module_identifier__$2C = undefined;
/* functional template */

const __vue_is_functional_template__$2C = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2C = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2C,
  staticRenderFns: __vue_staticRenderFns__$2C
}, __vue_inject_styles__$2C, __vue_script__$2C, __vue_scope_id__$2C, __vue_is_functional_template__$2C, __vue_module_identifier__$2C, false, undefined, undefined, undefined);

var script$2D = Vue.extend({
  name: "PhBracketsAngle",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2D = script$2D;
/* template */

var __vue_render__$2D = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 40 24 128 80 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176 40 232 128 176 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 40 24 128 80 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176 40 232 128 176 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M86.749,44.29492,33.48242,128,86.749,211.70508a7.99973,7.99973,0,1,1-13.498,8.58984l-56-88a7.99826,7.99826,0,0,1,0-8.58984l56-88a7.99973,7.99973,0,0,1,13.498,8.58984Zm152,79.41016-56-88a7.99973,7.99973,0,0,0-13.498,8.58984L222.51758,128,169.251,211.70508a7.99973,7.99973,0,1,0,13.498,8.58984l56-88A7.99826,7.99826,0,0,0,238.749,123.70508Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 40 24 128 80 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176 40 232 128 176 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 40 24 128 80 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176 40 232 128 176 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 40 24 128 80 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176 40 232 128 176 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2D = [];
/* style */

const __vue_inject_styles__$2D = undefined;
/* scoped */

const __vue_scope_id__$2D = undefined;
/* module identifier */

const __vue_module_identifier__$2D = undefined;
/* functional template */

const __vue_is_functional_template__$2D = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2D = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2D,
  staticRenderFns: __vue_staticRenderFns__$2D
}, __vue_inject_styles__$2D, __vue_script__$2D, __vue_scope_id__$2D, __vue_is_functional_template__$2D, __vue_module_identifier__$2D, false, undefined, undefined, undefined);

var script$2E = Vue.extend({
  name: "PhBracketsCurly",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2E = script$2E;
/* template */

var __vue_render__$2E = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,40c-64,0,0,88-64,88,64,0,0,88,64,88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,40c64,0,0,88,64,88-64,0,0,88-64,88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,40c-64,0,0,88-64,88,64,0,0,88,64,88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,40c64,0,0,88,64,88-64,0,0,88-64,88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M43.17529,128a29.7852,29.7852,0,0,1,8.023,10.25977C56,148.16309,56,160.28125,56,172c0,24.31348,1.01953,36,24,36a8,8,0,0,1,0,16c-17.48145,0-29.32422-6.14355-35.19824-18.25977C40,195.83691,40,183.71875,40,172c0-24.31348-1.01953-36-24-36a8,8,0,0,1,0-16c22.98047,0,24-11.68652,24-36,0-11.71875,0-23.83691,4.80176-33.74023C50.67578,38.14355,62.51855,32,80,32a8,8,0,0,1,0,16C57.01953,48,56,59.68652,56,84c0,11.71875,0,23.83691-4.80176,33.74023A29.7852,29.7852,0,0,1,43.17529,128ZM240,120c-22.98047,0-24-11.68652-24-36,0-11.71875,0-23.83691-4.80176-33.74023C205.32422,38.14355,193.48145,32,176,32a8,8,0,0,0,0,16c22.98047,0,24,11.68652,24,36,0,11.71875,0,23.83691,4.80176,33.74023A29.7852,29.7852,0,0,0,212.82471,128a29.7852,29.7852,0,0,0-8.023,10.25977C200,148.16309,200,160.28125,200,172c0,24.31348-1.01953,36-24,36a8,8,0,0,0,0,16c17.48145,0,29.32422-6.14355,35.19824-18.25977C216,195.83691,216,183.71875,216,172c0-24.31348,1.01953-36,24-36a8,8,0,0,0,0-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,40c-64,0,0,88-64,88,64,0,0,88,64,88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,40c64,0,0,88,64,88-64,0,0,88-64,88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,40c-64,0,0,88-64,88,64,0,0,88,64,88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,40c64,0,0,88,64,88-64,0,0,88-64,88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,40c-64,0,0,88-64,88,64,0,0,88,64,88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,40c64,0,0,88,64,88-64,0,0,88-64,88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2E = [];
/* style */

const __vue_inject_styles__$2E = undefined;
/* scoped */

const __vue_scope_id__$2E = undefined;
/* module identifier */

const __vue_module_identifier__$2E = undefined;
/* functional template */

const __vue_is_functional_template__$2E = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2E = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2E,
  staticRenderFns: __vue_staticRenderFns__$2E
}, __vue_inject_styles__$2E, __vue_script__$2E, __vue_scope_id__$2E, __vue_is_functional_template__$2E, __vue_module_identifier__$2E, false, undefined, undefined, undefined);

var script$2F = Vue.extend({
  name: "PhBracketsRound",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2F = script$2F;
/* template */

var __vue_render__$2F = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M72,40S32,64,32,128s40,88,40,88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,40s40,24,40,88-40,88-40,88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M72,40S32,64,32,128s40,88,40,88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,40s40,24,40,88-40,88-40,88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,128c0,58.28906,34.6748,80.25488,36.15088,81.16113a8.00025,8.00025,0,0,1-8.26709,13.69922C66.09229,221.78516,24,195.751,24,128S66.09229,34.21484,67.88379,33.13965a8,8,0,0,1,8.2583,13.7041C74.544,47.8291,40,69.82129,40,128ZM188.11621,33.13965a8.00032,8.00032,0,0,0-8.26709,13.69922C181.3252,47.74512,216,69.71094,216,128s-34.6748,80.25488-36.11621,81.13965a8.00047,8.00047,0,1,0,8.23242,13.7207C189.90771,221.78516,232,195.751,232,128S189.90771,34.21484,188.11621,33.13965Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M72,40S32,64,32,128s40,88,40,88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,40s40,24,40,88-40,88-40,88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M72,40S32,64,32,128s40,88,40,88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,40s40,24,40,88-40,88-40,88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M72,40S32,64,32,128s40,88,40,88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,40s40,24,40,88-40,88-40,88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2F = [];
/* style */

const __vue_inject_styles__$2F = undefined;
/* scoped */

const __vue_scope_id__$2F = undefined;
/* module identifier */

const __vue_module_identifier__$2F = undefined;
/* functional template */

const __vue_is_functional_template__$2F = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2F = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2F,
  staticRenderFns: __vue_staticRenderFns__$2F
}, __vue_inject_styles__$2F, __vue_script__$2F, __vue_scope_id__$2F, __vue_is_functional_template__$2F, __vue_module_identifier__$2F, false, undefined, undefined, undefined);

var script$2G = Vue.extend({
  name: "PhBracketsSquare",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2G = script$2G;
/* template */

var __vue_render__$2G = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 40 40 40 40 216 80 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176 40 216 40 216 216 176 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 40 40 40 40 216 80 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176 40 216 40 216 216 176 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M48,48V208H80a8,8,0,0,1,0,16H40a8.00039,8.00039,0,0,1-8-8V40a8.00039,8.00039,0,0,1,8-8H80a8,8,0,0,1,0,16ZM216,32H176a8,8,0,0,0,0,16h32V208H176a8,8,0,0,0,0,16h40a8.00039,8.00039,0,0,0,8-8V40A8.00039,8.00039,0,0,0,216,32Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 40 40 40 40 216 80 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176 40 216 40 216 216 176 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 40 40 40 40 216 80 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176 40 216 40 216 216 176 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 40 40 40 40 216 80 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176 40 216 40 216 216 176 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2G = [];
/* style */

const __vue_inject_styles__$2G = undefined;
/* scoped */

const __vue_scope_id__$2G = undefined;
/* module identifier */

const __vue_module_identifier__$2G = undefined;
/* functional template */

const __vue_is_functional_template__$2G = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2G = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2G,
  staticRenderFns: __vue_staticRenderFns__$2G
}, __vue_inject_styles__$2G, __vue_script__$2G, __vue_scope_id__$2G, __vue_is_functional_template__$2G, __vue_module_identifier__$2G, false, undefined, undefined, undefined);

var script$2H = Vue.extend({
  name: "PhBrain",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2H = script$2H;
/* template */

var __vue_render__$2H = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "176",
      "x2": "128",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,180H64A48.00813,48.00813,0,0,1,47.99924,86.73156L48,72a40,40,0,0,1,80,0V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,180h8a48.00813,48.00813,0,0,0,16.00076-93.26844L208,72a40,40,0,0,0-80,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,88v8a28,28,0,0,1-28,28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,88v8a28,28,0,0,0,28,28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104.00052,147.32858A40.00437,40.00437,0,1,1,48,184v-6.73323",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M151.99955,147.32854A40.00437,40.00437,0,1,0,208,184v-6.7317",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208.001,86.73157,208,72a40,40,0,0,0-80,0,40,40,0,0,0-80,0l-.001,14.73157a48.01968,48.01968,0,0,0,.00049,90.537L48,177.26685V184a40,40,0,0,0,80,0,40,40,0,0,0,80,0v-6.73315l.00049.0017a48.01968,48.01968,0,0,0,.00049-90.537Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "176",
      "x2": "128",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,144a40,40,0,1,1-40,40v-6.73323",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,144a40,40,0,1,0,40,40v-6.7317",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,180H64A48.00813,48.00813,0,0,1,47.99924,86.73156L48,72a40,40,0,0,1,80,0V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,180h8a48.00813,48.00813,0,0,0,16.00076-93.26844L208,72a40,40,0,0,0-80,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,84v8a28,28,0,0,1-28,28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,84v8a28,28,0,0,0,28,28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M248,132a56.1211,56.1211,0,0,0-31.99951-50.61035L216,72a47.98283,47.98283,0,0,0-88-26.49316A47.98283,47.98283,0,0,0,40,71.99951l-.00049,9.39014A56.00268,56.00268,0,0,0,40,182.58569V184a47.98283,47.98283,0,0,0,88,26.49316A47.98283,47.98283,0,0,0,216,184v-1.41431A56.06726,56.06726,0,0,0,248,132ZM88,216a32.0433,32.0433,0,0,1-31.812-28.55664A56.1738,56.1738,0,0,0,64,188h8a8,8,0,0,0,0-16H64A40.00827,40.00827,0,0,1,50.66553,94.27393a7.99958,7.99958,0,0,0,5.33349-7.542L56,72a32,32,0,0,1,64,0v76.26147A47.80252,47.80252,0,0,0,88,136a8,8,0,0,0,0,16,32,32,0,0,1,0,64Zm104-44h-8a8,8,0,0,0,0,16h8a56.1738,56.1738,0,0,0,7.812-.55664A31.999,31.999,0,1,1,168,152a8,8,0,0,0,0-16,47.80252,47.80252,0,0,0-32,12.26147V72a32,32,0,1,1,64,.00049l.001,14.73144a7.99958,7.99958,0,0,0,5.33349,7.542A40.00827,40.00827,0,0,1,192,172ZM60,128a8,8,0,0,1,0-16A20.0226,20.0226,0,0,0,80,92V84a8,8,0,0,1,16,0v8A36.04061,36.04061,0,0,1,60,128Zm144-8a8.00008,8.00008,0,0,1-8,8,36.04061,36.04061,0,0,1-36-36V84a8,8,0,0,1,16,0v8a20.0226,20.0226,0,0,0,20,20A8.00008,8.00008,0,0,1,204,120Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "176",
      "x2": "128",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,144a40,40,0,1,1-40,40v-6.73323",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,144a40,40,0,1,0,40,40v-6.7317",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,180H64A48.00813,48.00813,0,0,1,47.99924,86.73156L48,72a40,40,0,0,1,80,0V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,180h8a48.00813,48.00813,0,0,0,16.00076-93.26844L208,72a40,40,0,0,0-80,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,84v8a28,28,0,0,1-28,28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,84v8a28,28,0,0,0,28,28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "176",
      "x2": "128",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,144a40,40,0,1,1-40,40v-6.73323",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,144a40,40,0,1,0,40,40v-6.7317",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,180H64A48.00813,48.00813,0,0,1,47.99924,86.73156L48,72a40,40,0,0,1,80,0V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,180h8a48.00813,48.00813,0,0,0,16.00076-93.26844L208,72a40,40,0,0,0-80,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,84v8a28,28,0,0,1-28,28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,84v8a28,28,0,0,0,28,28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "176",
      "x2": "128",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,144a40,40,0,1,1-40,40v-6.73323",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,144a40,40,0,1,0,40,40v-6.7317",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,180H64A48.00813,48.00813,0,0,1,47.99924,86.73156L48,72a40,40,0,0,1,80,0V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,180h8a48.00813,48.00813,0,0,0,16.00076-93.26844L208,72a40,40,0,0,0-80,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,84v8a28,28,0,0,1-28,28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,84v8a28,28,0,0,0,28,28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2H = [];
/* style */

const __vue_inject_styles__$2H = undefined;
/* scoped */

const __vue_scope_id__$2H = undefined;
/* module identifier */

const __vue_module_identifier__$2H = undefined;
/* functional template */

const __vue_is_functional_template__$2H = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2H = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2H,
  staticRenderFns: __vue_staticRenderFns__$2H
}, __vue_inject_styles__$2H, __vue_script__$2H, __vue_scope_id__$2H, __vue_is_functional_template__$2H, __vue_module_identifier__$2H, false, undefined, undefined, undefined);

var script$2I = Vue.extend({
  name: "PhBrandy",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2I = script$2I;
/* template */

var __vue_render__$2I = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "176",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "224",
      "x2": "168",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M201.76684,39.99737a88,88,0,1,1-147.53337-.00048Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "88",
      "x2": "216",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,88A88,88,0,0,1,40,88Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "176",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "224",
      "x2": "168",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M201.76684,39.99737a88,88,0,1,1-147.53337-.00048Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "88",
      "x2": "216",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,88a95.63426,95.63426,0,0,0-15.53223-52.37207,7.99982,7.99982,0,0,0-6.70117-3.63086H54.2334A7.99954,7.99954,0,0,0,47.53223,35.627,96.014,96.014,0,0,0,120,183.66406V216H88a8,8,0,0,0,0,16h80a8,8,0,0,0,0-16H136V183.66406A96.127,96.127,0,0,0,224,88ZM58.70312,47.99707H197.29736A79.54855,79.54855,0,0,1,207.60205,80H48.398A79.53944,79.53944,0,0,1,58.70312,47.99707Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "176",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "224",
      "x2": "168",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M201.76684,39.99737a88,88,0,1,1-147.53337-.00048Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "88",
      "x2": "216",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "176",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "224",
      "x2": "168",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M201.76684,39.99737a88,88,0,1,1-147.53337-.00048Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "88",
      "x2": "216",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "176",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "224",
      "x2": "168",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M201.76684,39.99737a88,88,0,1,1-147.53337-.00048Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "88",
      "x2": "216",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2I = [];
/* style */

const __vue_inject_styles__$2I = undefined;
/* scoped */

const __vue_scope_id__$2I = undefined;
/* module identifier */

const __vue_module_identifier__$2I = undefined;
/* functional template */

const __vue_is_functional_template__$2I = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2I = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2I,
  staticRenderFns: __vue_staticRenderFns__$2I
}, __vue_inject_styles__$2I, __vue_script__$2I, __vue_scope_id__$2I, __vue_is_functional_template__$2I, __vue_module_identifier__$2I, false, undefined, undefined, undefined);

var script$2J = Vue.extend({
  name: "PhBriefcase",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2J = script$2J;
/* template */

var __vue_render__$2J = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32.00781",
      "y": "68.00005",
      "width": "192",
      "height": "144",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,68V48a16,16,0,0,0-16-16H104A16,16,0,0,0,88,48V68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224.00806,122.30915A191.11647,191.11647,0,0,1,128,148a191.11667,191.11667,0,0,1-95.99345-25.68239",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "116",
      "y1": "112",
      "x2": "140",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,152a191.11689,191.11689,0,0,1-95.99219-25.68164V208a7.99993,7.99993,0,0,0,8,8h176a7.99992,7.99992,0,0,0,8-8V126.30908A191.1142,191.1142,0,0,1,128,152Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32.00781",
      "y": "72.00005",
      "width": "192",
      "height": "144",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,72V56a16,16,0,0,0-16-16H104A16,16,0,0,0,88,56V72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224.00806,126.30915A191.11647,191.11647,0,0,1,128,152a191.11667,191.11667,0,0,1-95.99345-25.68239",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "116",
      "y1": "120",
      "x2": "140",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216.00781,64H176V56a24.0275,24.0275,0,0,0-24-24H104A24.0275,24.0275,0,0,0,80,56v8H40.00781a16.01833,16.01833,0,0,0-16,16V208a16.01833,16.01833,0,0,0,16,16h176a16.01833,16.01833,0,0,0,16-16V80A16.01833,16.01833,0,0,0,216.00781,64ZM96,56a8.00917,8.00917,0,0,1,8-8h48a8.00917,8.00917,0,0,1,8,8v8H96ZM216.00781,80l.00318,41.606A184.00072,184.00072,0,0,1,128,144a184.00068,184.00068,0,0,1-87.99219-22.38428V80ZM108,120a8.00039,8.00039,0,0,1,8-8h24a8,8,0,0,1,0,16H116A8.00039,8.00039,0,0,1,108,120Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32.00781",
      "y": "72.00005",
      "width": "192",
      "height": "144",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,72V56a16,16,0,0,0-16-16H104A16,16,0,0,0,88,56V72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224.00806,126.30915A191.11647,191.11647,0,0,1,128,152a191.11667,191.11667,0,0,1-95.99345-25.68239",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "116",
      "y1": "120",
      "x2": "140",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32.00781",
      "y": "72.00005",
      "width": "192",
      "height": "144",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,72V56a16,16,0,0,0-16-16H104A16,16,0,0,0,88,56V72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224.00806,126.30915A191.11647,191.11647,0,0,1,128,152a191.11667,191.11667,0,0,1-95.99345-25.68239",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "116",
      "y1": "120",
      "x2": "140",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32.00781",
      "y": "72.00005",
      "width": "192",
      "height": "144",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,72V56a16,16,0,0,0-16-16H104A16,16,0,0,0,88,56V72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224.00806,126.30915A191.11647,191.11647,0,0,1,128,152a191.11667,191.11667,0,0,1-95.99345-25.68239",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "116",
      "y1": "120",
      "x2": "140",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2J = [];
/* style */

const __vue_inject_styles__$2J = undefined;
/* scoped */

const __vue_scope_id__$2J = undefined;
/* module identifier */

const __vue_module_identifier__$2J = undefined;
/* functional template */

const __vue_is_functional_template__$2J = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2J = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2J,
  staticRenderFns: __vue_staticRenderFns__$2J
}, __vue_inject_styles__$2J, __vue_script__$2J, __vue_scope_id__$2J, __vue_is_functional_template__$2J, __vue_module_identifier__$2J, false, undefined, undefined, undefined);

var script$2K = Vue.extend({
  name: "PhBriefcaseMetal",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2K = script$2K;
/* template */

var __vue_render__$2K = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "144",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "176",
      "x2": "224",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "112",
      "x2": "224",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,68V48a16,16,0,0,0-16-16H104A16,16,0,0,0,88,48V68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,112H224V80a8,8,0,0,0-8-8H40a8,8,0,0,0-8,8Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,176H224v32a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "144",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,72V56a16,16,0,0,0-16-16H104A16,16,0,0,0,88,56V72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "176",
      "x2": "224",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "112",
      "x2": "224",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "120",
      "width": "208",
      "height": "48"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,184v24a16.01833,16.01833,0,0,0,16,16H216a16.01833,16.01833,0,0,0,16-16V184Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M232,104V80a16.01833,16.01833,0,0,0-16-16H176V56a24.0275,24.0275,0,0,0-24-24H104A24.0275,24.0275,0,0,0,80,56v8H40A16.01833,16.01833,0,0,0,24,80v24ZM96,56a8.00917,8.00917,0,0,1,8-8h48a8.00917,8.00917,0,0,1,8,8v8H96Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "144",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,72V56a16,16,0,0,0-16-16H104A16,16,0,0,0,88,56V72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "176",
      "x2": "224",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "112",
      "x2": "224",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "144",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,72V56a16,16,0,0,0-16-16H104A16,16,0,0,0,88,56V72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "176",
      "x2": "224",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "112",
      "x2": "224",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "144",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,72V56a16,16,0,0,0-16-16H104A16,16,0,0,0,88,56V72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "176",
      "x2": "224",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "112",
      "x2": "224",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2K = [];
/* style */

const __vue_inject_styles__$2K = undefined;
/* scoped */

const __vue_scope_id__$2K = undefined;
/* module identifier */

const __vue_module_identifier__$2K = undefined;
/* functional template */

const __vue_is_functional_template__$2K = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2K = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2K,
  staticRenderFns: __vue_staticRenderFns__$2K
}, __vue_inject_styles__$2K, __vue_script__$2K, __vue_scope_id__$2K, __vue_is_functional_template__$2K, __vue_module_identifier__$2K, false, undefined, undefined, undefined);

var script$2L = Vue.extend({
  name: "PhBroadcast",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2L = script$2L;
/* template */

var __vue_render__$2L = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M77.08831,178.91169a71.93858,71.93858,0,0,1,0-101.82338",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M178.91169,77.08831a71.93858,71.93858,0,0,1,0,101.82338",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48.804,207.196a111.90445,111.90445,0,0,1,0-158.39192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M207.196,48.804a111.90445,111.90445,0,0,1,0,158.39192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M77.08831,178.91169a71.93858,71.93858,0,0,1,0-101.82338",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M178.91169,77.08831a71.93858,71.93858,0,0,1,0,101.82338",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48.804,207.196a111.90445,111.90445,0,0,1,0-158.39192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M207.196,48.804a111.90445,111.90445,0,0,1,0,158.39192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "40"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M82.74512,82.74512A8.00018,8.00018,0,1,0,71.43066,71.43164a79.94026,79.94026,0,0,0,0,113.13672,8.00018,8.00018,0,1,0,11.31446-11.31348,63.93958,63.93958,0,0,1,0-90.50976Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,128a79.7769,79.7769,0,0,0-23.43066-56.56836,8.00018,8.00018,0,1,0-11.31446,11.31348,63.93958,63.93958,0,0,1,0,90.50976,8.00018,8.00018,0,0,0,11.31446,11.31348A79.7769,79.7769,0,0,0,208,128Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32.16992,168.479a103.90428,103.90428,0,0,1,22.291-114.01806A8.00018,8.00018,0,0,0,43.14648,43.14746a119.906,119.906,0,0,0,0,169.70508,8.00018,8.00018,0,1,0,11.31446-11.31348A103.65105,103.65105,0,0,1,32.16992,168.479Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M238.56641,81.28809a119.58135,119.58135,0,0,0-25.71289-38.14063,8.00018,8.00018,0,1,0-11.31446,11.31348,103.90471,103.90471,0,0,1,0,147.07812,8.00018,8.00018,0,0,0,11.31446,11.31348A120.12116,120.12116,0,0,0,238.56641,81.28809Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M77.08831,178.91169a71.93858,71.93858,0,0,1,0-101.82338",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M178.91169,77.08831a71.93858,71.93858,0,0,1,0,101.82338",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48.804,207.196a111.90445,111.90445,0,0,1,0-158.39192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M207.196,48.804a111.90445,111.90445,0,0,1,0,158.39192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M77.08831,178.91169a71.93858,71.93858,0,0,1,0-101.82338",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M178.91169,77.08831a71.93858,71.93858,0,0,1,0,101.82338",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48.804,207.196a111.90445,111.90445,0,0,1,0-158.39192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M207.196,48.804a111.90445,111.90445,0,0,1,0,158.39192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M77.08831,178.91169a71.93858,71.93858,0,0,1,0-101.82338",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M178.91169,77.08831a71.93858,71.93858,0,0,1,0,101.82338",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48.804,207.196a111.90445,111.90445,0,0,1,0-158.39192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M207.196,48.804a111.90445,111.90445,0,0,1,0,158.39192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2L = [];
/* style */

const __vue_inject_styles__$2L = undefined;
/* scoped */

const __vue_scope_id__$2L = undefined;
/* module identifier */

const __vue_module_identifier__$2L = undefined;
/* functional template */

const __vue_is_functional_template__$2L = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2L = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2L,
  staticRenderFns: __vue_staticRenderFns__$2L
}, __vue_inject_styles__$2L, __vue_script__$2L, __vue_scope_id__$2L, __vue_is_functional_template__$2L, __vue_module_identifier__$2L, false, undefined, undefined, undefined);

var script$2M = Vue.extend({
  name: "PhBrowser",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2M = script$2M;
/* template */

var __vue_render__$2M = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "96",
      "x2": "224",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,96H223.99219L224,56a7.99985,7.99985,0,0,0-7.99967-8H40.00749a7.99985,7.99985,0,0,0-7.99968,8Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "96",
      "x2": "224",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216.0006,40H40.00721a16.018,16.018,0,0,0-15.9994,16V95.84521C24.00684,95.89746,24,95.94775,24,96s.00684.10254.00781.15479V200a16.018,16.018,0,0,0,15.9994,16H216.0006A16.018,16.018,0,0,0,232,200V56A16.018,16.018,0,0,0,216.0006,40Zm0,16,.002,32H40.00721V56Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "96",
      "x2": "224",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "96",
      "x2": "224",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "96",
      "x2": "224",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2M = [];
/* style */

const __vue_inject_styles__$2M = undefined;
/* scoped */

const __vue_scope_id__$2M = undefined;
/* module identifier */

const __vue_module_identifier__$2M = undefined;
/* functional template */

const __vue_is_functional_template__$2M = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2M = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2M,
  staticRenderFns: __vue_staticRenderFns__$2M
}, __vue_inject_styles__$2M, __vue_script__$2M, __vue_scope_id__$2M, __vue_is_functional_template__$2M, __vue_module_identifier__$2M, false, undefined, undefined, undefined);

var script$2N = Vue.extend({
  name: "PhBrowsers",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2N = script$2N;
/* template */

var __vue_render__$2N = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "28.00781",
      "y": "84.00005",
      "width": "160",
      "height": "128",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M68.00781,84.00005v-32a8,8,0,0,1,8-8h144a8,8,0,0,1,8,8V164a8,8,0,0,1-8,8h-32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "28",
      "y1": "124",
      "x2": "188",
      "y2": "124",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216.00781,48h-144a7.99993,7.99993,0,0,0-8,8V80h120a7.99993,7.99993,0,0,1,8,8v88h24a7.99977,7.99977,0,0,0,8-8V56A7.99993,7.99993,0,0,0,216.00781,48Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32.00781",
      "y": "80.00005",
      "width": "160",
      "height": "128",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64.00781,80.00005v-24a8,8,0,0,1,8-8h144a8,8,0,0,1,8,8V168a8,8,0,0,1-8,8h-24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "112",
      "x2": "192",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216.00781,40h-144a16.01818,16.01818,0,0,0-16,16V72h-16a16.01818,16.01818,0,0,0-16,16v23.84521c-.001.052-.00781.10254-.00781.15479s.00684.10278.00781.15479V200a16.01833,16.01833,0,0,0,16,16h144a16.01833,16.01833,0,0,0,16-16V184h16a16.01833,16.01833,0,0,0,16-16V56A16.01817,16.01817,0,0,0,216.00781,40Zm-32,48,.00147,16H40.00781V88Zm32,80h-16V88a16.01817,16.01817,0,0,0-16-16h-112V56h144Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32.00781",
      "y": "80.00005",
      "width": "160",
      "height": "128",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64.00781,80.00005v-24a8,8,0,0,1,8-8h144a8,8,0,0,1,8,8V168a8,8,0,0,1-8,8h-24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "112",
      "x2": "192",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32.00781",
      "y": "80.00005",
      "width": "160",
      "height": "128",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64.00781,80.00005v-24a8,8,0,0,1,8-8h144a8,8,0,0,1,8,8V168a8,8,0,0,1-8,8h-24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "112",
      "x2": "192",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32.00781",
      "y": "80.00005",
      "width": "160",
      "height": "128",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64.00781,80.00005v-24a8,8,0,0,1,8-8h144a8,8,0,0,1,8,8V168a8,8,0,0,1-8,8h-24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "112",
      "x2": "192",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2N = [];
/* style */

const __vue_inject_styles__$2N = undefined;
/* scoped */

const __vue_scope_id__$2N = undefined;
/* module identifier */

const __vue_module_identifier__$2N = undefined;
/* functional template */

const __vue_is_functional_template__$2N = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2N = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2N,
  staticRenderFns: __vue_staticRenderFns__$2N
}, __vue_inject_styles__$2N, __vue_script__$2N, __vue_scope_id__$2N, __vue_is_functional_template__$2N, __vue_module_identifier__$2N, false, undefined, undefined, undefined);

var script$2O = Vue.extend({
  name: "PhBug",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2O = script$2O;
/* template */

var __vue_render__$2O = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "156",
      "cy": "88",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "100",
      "cy": "88",
      "r": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "244",
      "y1": "128.00007",
      "x2": "12",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,144a80,80,0,0,1-160,0V112a80,80,0,0,1,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "231.92301",
      "y1": "188.00006",
      "x2": "203.18198",
      "y2": "171.40642",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "231.92308",
      "y1": "68.00006",
      "x2": "203.18193",
      "y2": "84.59378",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24.07695",
      "y1": "68",
      "x2": "52.81817",
      "y2": "84.59375",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24.07695",
      "y1": "188",
      "x2": "52.81789",
      "y2": "171.40641",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,128v16a80,80,0,0,1-160,0V128Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "155.92969",
      "cy": "91.99998",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "99.92969",
      "cy": "91.99998",
      "r": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "244",
      "y1": "128.00007",
      "x2": "12",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,144a80,80,0,0,1-160,0V112a80,80,0,0,1,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "231.92301",
      "y1": "188.00006",
      "x2": "203.18198",
      "y2": "171.40642",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "231.92308",
      "y1": "68.00006",
      "x2": "203.18193",
      "y2": "84.59378",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24.07695",
      "y1": "68",
      "x2": "52.81817",
      "y2": "84.59375",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24.07695",
      "y1": "188",
      "x2": "52.81789",
      "y2": "171.40641",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M167.92969,92a12,12,0,1,1-12-12A12,12,0,0,1,167.92969,92Zm-68-12a12,12,0,1,0,12,12A12,12,0,0,0,99.92969,80ZM252,128a8.00039,8.00039,0,0,1-8,8H216v8a87.78437,87.78437,0,0,1-3.24438,23.69629l23.16723,13.37549a8,8,0,1,1-8,13.85644l-20.96533-12.104a87.9757,87.9757,0,0,1-157.915,0l-20.96533,12.104a8,8,0,1,1-8-13.85644l23.16723-13.37549A87.78437,87.78437,0,0,1,40,144v-8H12a8,8,0,0,1,0-16H40v-8a87.787,87.787,0,0,1,3.24438-23.69629L20.07715,74.92822a8,8,0,0,1,8-13.85644L49.04248,73.17627a87.97531,87.97531,0,0,1,157.915,0l20.96533-12.10449a8,8,0,0,1,8,13.85644L212.75562,88.30371A87.787,87.787,0,0,1,216,112v8h28A8.00039,8.00039,0,0,1,252,128ZM136,144a8,8,0,0,0-16,0v64a8,8,0,0,0,16,0Zm64-32a72,72,0,0,0-144,0v8H200Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "156",
      "cy": "92",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "100",
      "cy": "92",
      "r": "10"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "244",
      "y1": "128.00007",
      "x2": "12",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,144a80,80,0,0,1-160,0V112a80,80,0,0,1,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "231.92301",
      "y1": "188.00006",
      "x2": "203.18198",
      "y2": "171.40642",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "231.92308",
      "y1": "68.00006",
      "x2": "203.18193",
      "y2": "84.59378",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24.07695",
      "y1": "68",
      "x2": "52.81817",
      "y2": "84.59375",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24.07695",
      "y1": "188",
      "x2": "52.81789",
      "y2": "171.40641",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "156",
      "cy": "92",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "100",
      "cy": "92",
      "r": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "244",
      "y1": "128.00007",
      "x2": "12",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,144a80,80,0,0,1-160,0V112a80,80,0,0,1,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "231.92301",
      "y1": "188.00006",
      "x2": "203.18198",
      "y2": "171.40642",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "231.92308",
      "y1": "68.00006",
      "x2": "203.18193",
      "y2": "84.59378",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24.07695",
      "y1": "68",
      "x2": "52.81817",
      "y2": "84.59375",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24.07695",
      "y1": "188",
      "x2": "52.81789",
      "y2": "171.40641",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "156",
      "cy": "92",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "100",
      "cy": "92",
      "r": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "244",
      "y1": "128.00007",
      "x2": "12",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,144a80,80,0,0,1-160,0V112a80,80,0,0,1,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "231.92301",
      "y1": "188.00006",
      "x2": "203.18198",
      "y2": "171.40642",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "231.92308",
      "y1": "68.00006",
      "x2": "203.18193",
      "y2": "84.59378",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24.07695",
      "y1": "68",
      "x2": "52.81817",
      "y2": "84.59375",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24.07695",
      "y1": "188",
      "x2": "52.81789",
      "y2": "171.40641",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2O = [];
/* style */

const __vue_inject_styles__$2O = undefined;
/* scoped */

const __vue_scope_id__$2O = undefined;
/* module identifier */

const __vue_module_identifier__$2O = undefined;
/* functional template */

const __vue_is_functional_template__$2O = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2O = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2O,
  staticRenderFns: __vue_staticRenderFns__$2O
}, __vue_inject_styles__$2O, __vue_script__$2O, __vue_scope_id__$2O, __vue_is_functional_template__$2O, __vue_module_identifier__$2O, false, undefined, undefined, undefined);

var script$2P = Vue.extend({
  name: "PhBugBeetle",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2P = script$2P;
/* template */

var __vue_render__$2P = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "56",
      "y": "32",
      "width": "144",
      "height": "192",
      "rx": "71.99993",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "144",
      "x2": "224",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "144",
      "x2": "56",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "104",
      "x2": "224",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "144",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "55.92969",
      "y1": "28",
      "x2": "79.69497",
      "y2": "50.6085",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "199.92969",
      "y1": "28",
      "x2": "176.23303",
      "y2": "50.54341",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "184",
      "x2": "63.48654",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192.51244",
      "y1": "184",
      "x2": "224",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,103.99993v48.00014A71.99993,71.99993,0,0,1,128.00007,224h-.00014A71.99993,71.99993,0,0,1,56,152.00007V103.99993Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "56",
      "y": "32",
      "width": "144",
      "height": "192",
      "rx": "71.99993",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "136",
      "x2": "224",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "136",
      "x2": "56",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "168",
      "x2": "57.78445",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "104",
      "x2": "224",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "136",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "198.21531",
      "y1": "168",
      "x2": "224",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "55.92969",
      "y1": "28",
      "x2": "79.69497",
      "y2": "50.6085",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "199.92969",
      "y1": "28",
      "x2": "176.23303",
      "y2": "50.54341",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M50.416,33.7959A7.99956,7.99956,0,0,1,61.44336,22.2041L80.10742,39.959a79.84411,79.84411,0,0,1,95.70777-.05908L194.416,22.2041a7.99956,7.99956,0,1,1,11.02734,11.5918L187.63013,50.74268A79.69432,79.69432,0,0,1,207.59912,96H48.40088A79.69482,79.69482,0,0,1,68.30664,50.81543ZM32,96a8,8,0,0,0,0,16H48V96Zm176,56c0,2.7002-.13843,5.36816-.40088,8H224a8,8,0,0,1,0,16H204.31714a80.00273,80.00273,0,0,1-152.63428,0H32a8,8,0,0,1,0-16H48.40088C48.13843,157.36816,48,154.7002,48,152v-8H32a8,8,0,0,1,0-16H48V112H208v16h16a8,8,0,0,1,0,16H208Zm-72-16a8,8,0,0,0-16,0v64a8,8,0,0,0,16,0Zm96-32a8.00039,8.00039,0,0,0-8-8H208v16h16A8.00039,8.00039,0,0,0,232,104Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "56",
      "y": "32",
      "width": "144",
      "height": "192",
      "rx": "71.99993",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "136",
      "x2": "224",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "136",
      "x2": "56",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "168",
      "x2": "57.78445",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "104",
      "x2": "224",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "136",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "198.21531",
      "y1": "168",
      "x2": "224",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "55.92969",
      "y1": "28",
      "x2": "79.69497",
      "y2": "50.6085",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "199.92969",
      "y1": "28",
      "x2": "176.23303",
      "y2": "50.54341",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "56",
      "y": "32",
      "width": "144",
      "height": "192",
      "rx": "71.99993",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "136",
      "x2": "224",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "136",
      "x2": "56",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "168",
      "x2": "57.78445",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "104",
      "x2": "224",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "136",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "198.21531",
      "y1": "168",
      "x2": "224",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "55.92969",
      "y1": "28",
      "x2": "79.69497",
      "y2": "50.6085",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "199.92969",
      "y1": "28",
      "x2": "176.23303",
      "y2": "50.54341",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "56",
      "y": "32",
      "width": "144",
      "height": "192",
      "rx": "71.99993",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "136",
      "x2": "224",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "136",
      "x2": "56",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "168",
      "x2": "57.78445",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "104",
      "x2": "224",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "136",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "198.21531",
      "y1": "168",
      "x2": "224",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "55.92969",
      "y1": "28",
      "x2": "79.69497",
      "y2": "50.6085",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "199.92969",
      "y1": "28",
      "x2": "176.23303",
      "y2": "50.54341",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2P = [];
/* style */

const __vue_inject_styles__$2P = undefined;
/* scoped */

const __vue_scope_id__$2P = undefined;
/* module identifier */

const __vue_module_identifier__$2P = undefined;
/* functional template */

const __vue_is_functional_template__$2P = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2P = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2P,
  staticRenderFns: __vue_staticRenderFns__$2P
}, __vue_inject_styles__$2P, __vue_script__$2P, __vue_scope_id__$2P, __vue_is_functional_template__$2P, __vue_module_identifier__$2P, false, undefined, undefined, undefined);

var script$2Q = Vue.extend({
  name: "PhBugDroid",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2Q = script$2Q;
/* template */

var __vue_render__$2Q = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "156",
      "cy": "84",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "100",
      "cy": "84",
      "r": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M207.92969,148a80,80,0,0,1-160,0V108a80,80,0,0,1,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "207.92969",
      "y1": "128",
      "x2": "47.92969",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "55.92969",
      "y1": "28",
      "x2": "76.24389",
      "y2": "46.93601",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "199.92969",
      "y1": "28",
      "x2": "179.61507",
      "y2": "46.93662",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M47.92969,128h160v20a80,80,0,0,1-160,0Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M207.92969,148a80,80,0,0,1-160,0V108a80,80,0,0,1,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "207.92969",
      "y1": "128",
      "x2": "47.92969",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "155.92969",
      "cy": "91.99998",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "99.92969",
      "cy": "91.99998",
      "r": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "55.92969",
      "y1": "28",
      "x2": "76.24389",
      "y2": "46.93601",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "199.92969",
      "y1": "28",
      "x2": "179.61507",
      "y2": "46.93662",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M191.28711,46.99316l14.09765-13.14111A8.00027,8.00027,0,0,0,194.47461,22.148L179.11914,36.4624a87.81742,87.81742,0,0,0-102.37891,0L61.38476,22.148a8.00027,8.00027,0,0,0-10.91015,11.7041L64.57226,46.99268A87.69686,87.69686,0,0,0,39.92969,108v40a88,88,0,0,0,176,0V108A87.69484,87.69484,0,0,0,191.28711,46.99316ZM127.92969,36a72.08124,72.08124,0,0,1,72,72v12h-144V108A72.08124,72.08124,0,0,1,127.92969,36Zm16,56a12,12,0,1,1,12,12A12,12,0,0,1,143.92969,92Zm-56,0a12,12,0,1,1,12,12A12,12,0,0,1,87.92969,92Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "156",
      "cy": "84",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "100",
      "cy": "84",
      "r": "10"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M207.92969,148a80,80,0,0,1-160,0V108a80,80,0,0,1,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "207.92969",
      "y1": "128",
      "x2": "47.92969",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "55.92969",
      "y1": "28",
      "x2": "76.24389",
      "y2": "46.93601",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "199.92969",
      "y1": "28",
      "x2": "179.61507",
      "y2": "46.93662",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "156",
      "cy": "84",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "100",
      "cy": "84",
      "r": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M207.92969,148a80,80,0,0,1-160,0V108a80,80,0,0,1,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "207.92969",
      "y1": "128",
      "x2": "47.92969",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "55.92969",
      "y1": "28",
      "x2": "76.24389",
      "y2": "46.93601",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "199.92969",
      "y1": "28",
      "x2": "179.61507",
      "y2": "46.93662",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,148a80,80,0,0,1-160,0V108a80,80,0,0,1,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "128",
      "x2": "48",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "91.99998",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "100",
      "cy": "91.99998",
      "r": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "28",
      "x2": "76.3142",
      "y2": "46.93601",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "28",
      "x2": "179.68538",
      "y2": "46.93662",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2Q = [];
/* style */

const __vue_inject_styles__$2Q = undefined;
/* scoped */

const __vue_scope_id__$2Q = undefined;
/* module identifier */

const __vue_module_identifier__$2Q = undefined;
/* functional template */

const __vue_is_functional_template__$2Q = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2Q = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2Q,
  staticRenderFns: __vue_staticRenderFns__$2Q
}, __vue_inject_styles__$2Q, __vue_script__$2Q, __vue_scope_id__$2Q, __vue_is_functional_template__$2Q, __vue_module_identifier__$2Q, false, undefined, undefined, undefined);

var script$2R = Vue.extend({
  name: "PhBuildings",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2R = script$2R;
/* template */

var __vue_render__$2R = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "16",
      "y1": "215.98316",
      "x2": "240",
      "y2": "215.98316",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M143.99414,215.98316v-176a8,8,0,0,0-8-8h-96a8,8,0,0,0-8,8v176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M223.99414,215.98316v-112a8,8,0,0,0-8-8h-72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "67.99414",
      "y1": "71.98316",
      "x2": "95.99414",
      "y2": "71.98316",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "79.99414",
      "y1": "135.98316",
      "x2": "107.99414",
      "y2": "135.98316",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "67.99414",
      "y1": "175.98316",
      "x2": "95.99414",
      "y2": "175.98316",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "179.99414",
      "y1": "175.98316",
      "x2": "187.99414",
      "y2": "175.98316",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "179.99414",
      "y1": "135.98316",
      "x2": "187.99414",
      "y2": "135.98316",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M143.99414,215.98316v-176a8,8,0,0,0-8-8h-96a8,8,0,0,0-8,8v176",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "215.98316",
      "x2": "240",
      "y2": "215.98316",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M143.99414,215.98316v-176a8,8,0,0,0-8-8h-96a8,8,0,0,0-8,8v176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M223.99414,215.98316v-112a8,8,0,0,0-8-8h-72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "63.99414",
      "y1": "71.98316",
      "x2": "95.99414",
      "y2": "71.98316",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "79.99414",
      "y1": "135.98316",
      "x2": "111.99414",
      "y2": "135.98316",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "63.99414",
      "y1": "175.98316",
      "x2": "95.99414",
      "y2": "175.98316",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "175.99414",
      "y1": "175.98316",
      "x2": "191.99414",
      "y2": "175.98316",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "175.99414",
      "y1": "135.98316",
      "x2": "191.99414",
      "y2": "135.98316",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M240,207.98316h-8.00586v-104a16.01833,16.01833,0,0,0-16-16h-64v-48a16.01833,16.01833,0,0,0-16-16h-96a16.01833,16.01833,0,0,0-16,16v168H16a8,8,0,0,0,0,16H240a8,8,0,0,0,0-16Zm-120.00586-72a8.00009,8.00009,0,0,1-8,8h-32a8,8,0,0,1,0-16h32A8.00008,8.00008,0,0,1,119.99414,135.98316Zm-56-72h32a8,8,0,1,1,0,16h-32a8,8,0,0,1,0-16Zm0,104h32a8,8,0,1,1,0,16h-32a8,8,0,0,1,0-16Zm88-64h64v104h-64Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M191.99414,167.98316h-16a8,8,0,0,0,0,16h16a8,8,0,1,0,0-16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M175.99414,143.98316h16a8,8,0,1,0,0-16h-16a8,8,0,0,0,0,16Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "16",
      "y1": "215.98316",
      "x2": "240",
      "y2": "215.98316",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M143.99414,215.98316v-176a8,8,0,0,0-8-8h-96a8,8,0,0,0-8,8v176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M223.99414,215.98316v-112a8,8,0,0,0-8-8h-72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "63.99414",
      "y1": "71.98316",
      "x2": "95.99414",
      "y2": "71.98316",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "79.99414",
      "y1": "135.98316",
      "x2": "111.99414",
      "y2": "135.98316",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "63.99414",
      "y1": "175.98316",
      "x2": "95.99414",
      "y2": "175.98316",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "175.99414",
      "y1": "175.98316",
      "x2": "191.99414",
      "y2": "175.98316",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "175.99414",
      "y1": "135.98316",
      "x2": "191.99414",
      "y2": "135.98316",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "16",
      "y1": "215.98316",
      "x2": "240",
      "y2": "215.98316",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M143.99414,215.98316v-176a8,8,0,0,0-8-8h-96a8,8,0,0,0-8,8v176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M223.99414,215.98316v-112a8,8,0,0,0-8-8h-72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "63.99414",
      "y1": "71.98316",
      "x2": "95.99414",
      "y2": "71.98316",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "79.99414",
      "y1": "135.98316",
      "x2": "111.99414",
      "y2": "135.98316",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "63.99414",
      "y1": "175.98316",
      "x2": "95.99414",
      "y2": "175.98316",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "175.99414",
      "y1": "175.98316",
      "x2": "191.99414",
      "y2": "175.98316",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "175.99414",
      "y1": "135.98316",
      "x2": "191.99414",
      "y2": "135.98316",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "16",
      "y1": "215.98316",
      "x2": "240",
      "y2": "215.98316",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M143.99414,215.98316v-176a8,8,0,0,0-8-8h-96a8,8,0,0,0-8,8v176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M223.99414,215.98316v-112a8,8,0,0,0-8-8h-72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "63.99414",
      "y1": "71.98316",
      "x2": "95.99414",
      "y2": "71.98316",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "79.99414",
      "y1": "135.98316",
      "x2": "111.99414",
      "y2": "135.98316",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "63.99414",
      "y1": "175.98316",
      "x2": "95.99414",
      "y2": "175.98316",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "175.99414",
      "y1": "175.98316",
      "x2": "191.99414",
      "y2": "175.98316",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "175.99414",
      "y1": "135.98316",
      "x2": "191.99414",
      "y2": "135.98316",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2R = [];
/* style */

const __vue_inject_styles__$2R = undefined;
/* scoped */

const __vue_scope_id__$2R = undefined;
/* module identifier */

const __vue_module_identifier__$2R = undefined;
/* functional template */

const __vue_is_functional_template__$2R = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2R = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2R,
  staticRenderFns: __vue_staticRenderFns__$2R
}, __vue_inject_styles__$2R, __vue_script__$2R, __vue_scope_id__$2R, __vue_is_functional_template__$2R, __vue_module_identifier__$2R, false, undefined, undefined, undefined);

var script$2S = Vue.extend({
  name: "PhBus",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2S = script$2S;
/* template */

var __vue_render__$2S = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "42",
      "y1": "80",
      "x2": "214",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "42",
      "y1": "132",
      "x2": "214",
      "y2": "132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M214,184H42V64A24,24,0,0,1,66,40H190a24,24,0,0,1,24,24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M214,184v32a8,8,0,0,1-8,8H182a8,8,0,0,1-8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M82,184v32a8,8,0,0,1-8,8H50a8,8,0,0,1-8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M214,192v24a8,8,0,0,1-8,8H182a8,8,0,0,1-8-8V192Z",
      "opacity": "0.3"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M82,192v24a8,8,0,0,1-8,8H50a8,8,0,0,1-8-8V192Z",
      "opacity": "0.3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "42",
      "y": "72",
      "width": "172",
      "height": "48",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "42",
      "y1": "72",
      "x2": "214",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "42",
      "y1": "120",
      "x2": "214",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M214,192H42V64A24,24,0,0,1,66,40H190a24,24,0,0,1,24,24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M214,192v24a8,8,0,0,1-8,8H182a8,8,0,0,1-8-8V192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M82,192v24a8,8,0,0,1-8,8H50a8,8,0,0,1-8-8V192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "156",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "172",
      "cy": "156",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M190,32H66A32.03667,32.03667,0,0,0,34,64V216a16.01833,16.01833,0,0,0,16,16H74a16.01833,16.01833,0,0,0,16-16V200h76v16a16.01833,16.01833,0,0,0,16,16h24a16.01833,16.01833,0,0,0,16-16V64A32.03667,32.03667,0,0,0,190,32ZM82,168a12,12,0,1,1,12-12A12,12,0,0,1,82,168Zm92,0a12,12,0,1,1,12-12A12,12,0,0,1,174,168Zm32-48H50V72H206Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "42",
      "y1": "72",
      "x2": "214",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "42",
      "y1": "120",
      "x2": "214",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M214,192H42V64A24,24,0,0,1,66,40H190a24,24,0,0,1,24,24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M214,192v24a8,8,0,0,1-8,8H182a8,8,0,0,1-8-8V192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M82,192v24a8,8,0,0,1-8,8H50a8,8,0,0,1-8-8V192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "172",
      "cy": "156",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "156",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "42",
      "y1": "72",
      "x2": "214",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "42",
      "y1": "120",
      "x2": "214",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M214,192H42V64A24,24,0,0,1,66,40H190a24,24,0,0,1,24,24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M214,192v24a8,8,0,0,1-8,8H182a8,8,0,0,1-8-8V192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M82,192v24a8,8,0,0,1-8,8H50a8,8,0,0,1-8-8V192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "156",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "172",
      "cy": "156",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "42",
      "y1": "72",
      "x2": "214",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "42",
      "y1": "120",
      "x2": "214",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M214,192H42V64A24,24,0,0,1,66,40H190a24,24,0,0,1,24,24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M214,192v24a8,8,0,0,1-8,8H182a8,8,0,0,1-8-8V192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M82,192v24a8,8,0,0,1-8,8H50a8,8,0,0,1-8-8V192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "156",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "172",
      "cy": "156",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2S = [];
/* style */

const __vue_inject_styles__$2S = undefined;
/* scoped */

const __vue_scope_id__$2S = undefined;
/* module identifier */

const __vue_module_identifier__$2S = undefined;
/* functional template */

const __vue_is_functional_template__$2S = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2S = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2S,
  staticRenderFns: __vue_staticRenderFns__$2S
}, __vue_inject_styles__$2S, __vue_script__$2S, __vue_scope_id__$2S, __vue_is_functional_template__$2S, __vue_module_identifier__$2S, false, undefined, undefined, undefined);

var script$2T = Vue.extend({
  name: "PhCake",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2T = script$2T;
/* template */

var __vue_render__$2T = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,88c56-24,0-76,0-76S72,64,128,88Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M162,126a34,34,0,0,1-68,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M94,126a34.0002,34.0002,0,0,1-33.337,33.99366C41.60193,160.35824,26,144.393,26,125.32842V112A24,24,0,0,1,50,88H206a24,24,0,0,1,24,24v13.32842c0,19.06459-15.60193,35.02982-34.663,34.66524A34.0002,34.0002,0,0,1,162,126",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,153.26948V208a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V153.26978",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M162,126a34,34,0,0,1-68,0,34.0002,34.0002,0,0,1-33.337,33.99366C41.60193,160.35824,26,144.393,26,125.32842V112A24,24,0,0,1,50,88H206a24,24,0,0,1,24,24v13.32842c0,19.06459-15.60193,35.02982-34.663,34.66524A34.0002,34.0002,0,0,1,162,126Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,64c46.22222-16,0-56,0-56S80,48,128,64Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "88",
      "x2": "128",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,64c46.22222-16,0-56,0-56S80,48,128,64Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M162,126a34,34,0,0,1-68,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M94,126a34.0002,34.0002,0,0,1-33.337,33.99366C41.60193,160.35824,26,144.393,26,125.32842V112A24,24,0,0,1,50,88H206a24,24,0,0,1,24,24v13.32842c0,19.06459-15.60193,35.02982-34.663,34.66524A34.0002,34.0002,0,0,1,162,126",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,153.26948V208a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V153.26978",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M206,80H136V69.439c11.49683-5.13232,18.2417-12.52441,20.07031-22.03027,4.11914-21.41113-20.06445-43.06006-22.835-45.458a7.99935,7.99935,0,0,0-10.35644-.09619c-2.85938,2.38184-27.81446,23.895-23.76661,45.34717,1.82349,9.6665,8.84131,17.15674,20.8877,22.31885V80H50a32.03635,32.03635,0,0,0-32,32v13.32812A43.21843,43.21843,0,0,0,30.90918,155.9834c.35693.35058.72461.68408,1.09082,1.02V208a16.01833,16.01833,0,0,0,16,16H208a16.01833,16.01833,0,0,0,16-16V157.00439c.36646-.33593.73389-.67041,1.09082-1.021A43.21843,43.21843,0,0,0,238,125.32812V112A32.03635,32.03635,0,0,0,206,80Zm2,128H48V166.20312a41.105,41.105,0,0,0,12.81641,1.78907,42.04634,42.04634,0,0,0,33.15014-17.42432,41.9385,41.9385,0,0,0,68.0669,0,42.04634,42.04634,0,0,0,33.15014,17.42432q.40137.00732.80079.00781A41.06205,41.06205,0,0,0,208,166.209Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "88",
      "x2": "128",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,64c46.22222-16,0-56,0-56S80,48,128,64Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M162,126a34,34,0,0,1-68,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M94,126a34.0002,34.0002,0,0,1-33.337,33.99366C41.60193,160.35824,26,144.393,26,125.32842V112A24,24,0,0,1,50,88H206a24,24,0,0,1,24,24v13.32842c0,19.06459-15.60193,35.02982-34.663,34.66524A34.0002,34.0002,0,0,1,162,126",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,153.26948V208a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V153.26978",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "88",
      "x2": "128",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,64c46.22222-16,0-56,0-56S80,48,128,64Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M162,126a34,34,0,0,1-68,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M94,126a34.0002,34.0002,0,0,1-33.337,33.99366C41.60193,160.35824,26,144.393,26,125.32842V112A24,24,0,0,1,50,88H206a24,24,0,0,1,24,24v13.32842c0,19.06459-15.60193,35.02982-34.663,34.66524A34.0002,34.0002,0,0,1,162,126",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,153.26948V208a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V153.26978",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "88",
      "x2": "128",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,64c46.22222-16,0-56,0-56S80,48,128,64Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M162,126a34,34,0,0,1-68,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M94,126a34.0002,34.0002,0,0,1-33.337,33.99366C41.60193,160.35824,26,144.393,26,125.32842V112A24,24,0,0,1,50,88H206a24,24,0,0,1,24,24v13.32842c0,19.06459-15.60193,35.02982-34.663,34.66524A34.0002,34.0002,0,0,1,162,126",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,153.26948V208a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V153.26978",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2T = [];
/* style */

const __vue_inject_styles__$2T = undefined;
/* scoped */

const __vue_scope_id__$2T = undefined;
/* module identifier */

const __vue_module_identifier__$2T = undefined;
/* functional template */

const __vue_is_functional_template__$2T = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2T = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2T,
  staticRenderFns: __vue_staticRenderFns__$2T
}, __vue_inject_styles__$2T, __vue_script__$2T, __vue_scope_id__$2T, __vue_is_functional_template__$2T, __vue_module_identifier__$2T, false, undefined, undefined, undefined);

var script$2U = Vue.extend({
  name: "PhCalculator",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2U = script$2U;
/* template */

var __vue_render__$2U = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "transform": "translate(256) rotate(90)",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "92",
      "y1": "76",
      "x2": "164",
      "y2": "76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "104",
      "cy": "128",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "152",
      "cy": "128",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "104",
      "cy": "176",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "152",
      "cy": "176",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "80",
      "y": "64",
      "width": "96",
      "height": "48",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "80",
      "y": "64",
      "width": "96",
      "height": "48",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "31.99995",
      "y": "48.00781",
      "width": "192",
      "height": "160",
      "rx": "8",
      "transform": "translate(256.00777 0.00786) rotate(90)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "88",
      "cy": "148",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "148",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "168",
      "cy": "148",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "88",
      "cy": "188",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "188",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "168",
      "cy": "188",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,24H56A16.01833,16.01833,0,0,0,40,40V216a16.01833,16.01833,0,0,0,16,16H200a16.01833,16.01833,0,0,0,16-16V40A16.01833,16.01833,0,0,0,200,24ZM88,199.99219a12,12,0,1,1,12-12A12.01375,12.01375,0,0,1,88,199.99219Zm0-40a12,12,0,1,1,12-12A12.01375,12.01375,0,0,1,88,159.99219Zm40,40a12,12,0,1,1,12-12A12.01375,12.01375,0,0,1,128,199.99219Zm0-40a12,12,0,1,1,12-12A12.01375,12.01375,0,0,1,128,159.99219Zm40,40a12,12,0,1,1,12-12A12.01375,12.01375,0,0,1,168,199.99219Zm0-40a12,12,0,1,1,12-12A12.01375,12.01375,0,0,1,168,159.99219Zm16-56a7.99977,7.99977,0,0,1-8,8H80a7.99977,7.99977,0,0,1-8-8v-40a7.99977,7.99977,0,0,1,8-8h96a7.99977,7.99977,0,0,1,8,8Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "80",
      "y": "64",
      "width": "96",
      "height": "48",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "transform": "translate(256) rotate(90)",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "88",
      "cy": "148",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "148",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "168",
      "cy": "148",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "88",
      "cy": "188",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "188",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "168",
      "cy": "188",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "80",
      "y": "64",
      "width": "96",
      "height": "48",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "transform": "translate(256) rotate(90)",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "88",
      "cy": "148",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "148",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "168",
      "cy": "148",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "88",
      "cy": "188",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "188",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "168",
      "cy": "188",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "80",
      "y": "64",
      "width": "96",
      "height": "48",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "transform": "translate(256) rotate(90)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "88",
      "cy": "148",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "148",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "168",
      "cy": "148",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "88",
      "cy": "188",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "188",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "168",
      "cy": "188",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2U = [];
/* style */

const __vue_inject_styles__$2U = undefined;
/* scoped */

const __vue_scope_id__$2U = undefined;
/* module identifier */

const __vue_module_identifier__$2U = undefined;
/* functional template */

const __vue_is_functional_template__$2U = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2U = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2U,
  staticRenderFns: __vue_staticRenderFns__$2U
}, __vue_inject_styles__$2U, __vue_script__$2U, __vue_scope_id__$2U, __vue_is_functional_template__$2U, __vue_module_identifier__$2U, false, undefined, undefined, undefined);

var script$2V = Vue.extend({
  name: "PhCalendar",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2V = script$2V;
/* template */

var __vue_render__$2V = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "20",
      "x2": "176",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "20",
      "x2": "80",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "88",
      "x2": "216",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,127.99666h28l-16,20a16,16,0,1,1-11.30681,27.3206",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "148 139.997 164 127.997 164 179.997",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,88H216V48a8,8,0,0,0-8-8H48a8,8,0,0,0-8,8Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "24",
      "x2": "176",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "24",
      "x2": "80",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "88",
      "x2": "216",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92,127.99666h28l-16,20a16,16,0,1,1-11.30681,27.3206",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 139.997 160 127.997 160 179.997",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M207.99414,31.99707h-24v-8a8,8,0,0,0-16,0v8h-80v-8a8,8,0,1,0-16,0v8h-24a16.01583,16.01583,0,0,0-16,16v160a16.01583,16.01583,0,0,0,16,16h160a16.01582,16.01582,0,0,0,16-16v-160A16.01582,16.01582,0,0,0,207.99414,31.99707ZM104,187.99707a23.84464,23.84464,0,0,1-16.96045-7.01953,8,8,0,0,1,11.30713-11.32031A7.99993,7.99993,0,1,0,104,155.99707h-.00488c-.249,0-.49805-.01465-.74658-.03809-.07959-.00732-.15723-.01953-.23584-.029-.16651-.02075-.33252-.04492-.498-.07593-.09229-.01757-.1836-.03711-.2749-.05761-.15039-.03369-.3003-.07276-.44922-.11548-.09082-.02612-.18164-.05152-.271-.08081-.15039-.04907-.29932-.10523-.44726-.16358-.08057-.03173-.16211-.06054-.24122-.09472-.17236-.07447-.34179-.15845-.51074-.24585-.04883-.02564-.1001-.04712-.14843-.07349q-.31641-.17322-.6211-.37744c-.06836-.0459-.13183-.09741-.19873-.14526-.11719-.08374-.23584-.16455-.34961-.25562-.01465-.01172-.02734-.02515-.042-.03711-.12061-.09814-.23389-.2041-.34863-.30908-.0835-.07617-.17139-.14917-.251-.22827-.07715-.07666-.147-.15991-.22119-.23975a8.03993,8.03993,0,0,1-1.95069-3.71777c-.00537-.02539-.01416-.05-.01953-.07544-.02783-.13477-.04443-.27344-.06543-.41065-.019-.12426-.04345-.24755-.05664-.37255-.01123-.10279-.01269-.208-.02-.312-.01123-.16381-.02343-.32739-.02441-.4917C96.00244,148.032,96,148.01489,96,147.99707c0-.083.00977-.16357.0127-.24609.00488-.16577.00976-.3313.0249-.49683.01025-.11182.02783-.221.043-.3313.02-.14892.03955-.29761.06787-.44556.023-.11889.05273-.23461.08056-.3518.03272-.13623.06495-.27246.105-.40772.03614-.12109.07862-.239.12012-.35766.04444-.12671.08789-.25366.13867-.37891.04981-.12231.10645-.24048.16211-.35986.05469-.1167.10742-.23364.168-.34863.06543-.12452.13867-.24439.21045-.365.062-.10375.12158-.20849.18848-.3103.085-.12817.17724-.25024.269-.37329.05566-.07446.10352-.1521.16211-.2251l5.602-7.00195H92a8,8,0,1,1,0-16h28a8.00023,8.00023,0,0,1,6.24707,12.998l-8.86914,11.08642A23.99341,23.99341,0,0,1,104,187.99707Zm64-8a8,8,0,0,1-16,0v-36l-3.2002,2.40039a8.00019,8.00019,0,0,1-9.5996-12.80078l16-12A8.00031,8.00031,0,0,1,168,127.99707Zm39.99414-100h-160v-32h24v8a8,8,0,0,0,16,0v-8h80v8a8,8,0,1,0,16,0v-8h24Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "24",
      "x2": "176",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "24",
      "x2": "80",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "88",
      "x2": "216",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92,127.99666h28l-16,20a16,16,0,1,1-11.30681,27.3206",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 139.997 160 127.997 160 179.997",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "24",
      "x2": "176",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "24",
      "x2": "80",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "88",
      "x2": "216",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92,127.99666h28l-16,20a16,16,0,1,1-11.30681,27.3206",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 139.997 160 127.997 160 179.997",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "24",
      "x2": "176",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "24",
      "x2": "80",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "88",
      "x2": "216",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92,127.99666h28l-16,20a16,16,0,1,1-11.30681,27.3206",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 139.997 160 127.997 160 179.997",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2V = [];
/* style */

const __vue_inject_styles__$2V = undefined;
/* scoped */

const __vue_scope_id__$2V = undefined;
/* module identifier */

const __vue_module_identifier__$2V = undefined;
/* functional template */

const __vue_is_functional_template__$2V = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2V = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2V,
  staticRenderFns: __vue_staticRenderFns__$2V
}, __vue_inject_styles__$2V, __vue_script__$2V, __vue_scope_id__$2V, __vue_is_functional_template__$2V, __vue_module_identifier__$2V, false, undefined, undefined, undefined);

var script$2W = Vue.extend({
  name: "PhCalendarBlank",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2W = script$2W;
/* template */

var __vue_render__$2W = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "20",
      "x2": "176",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "20",
      "x2": "80",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "88",
      "x2": "216",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,88H216V48a8,8,0,0,0-8-8H48a8,8,0,0,0-8,8Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "24",
      "x2": "176",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "24",
      "x2": "80",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "88",
      "x2": "216",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M207.99414,31.9971h-24v-8a8,8,0,1,0-16,0v8h-80v-8a8,8,0,0,0-16,0v8h-24a16.01583,16.01583,0,0,0-16,16v160a16.01582,16.01582,0,0,0,16,16h160a16.01581,16.01581,0,0,0,16-16v-160A16.01582,16.01582,0,0,0,207.99414,31.9971Zm0,48h-160v-32h24v8a8,8,0,0,0,16,0v-8h80v8a8,8,0,1,0,16,0v-8h24Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "24",
      "x2": "176",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "24",
      "x2": "80",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "88",
      "x2": "216",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "24",
      "x2": "176",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "24",
      "x2": "80",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "88",
      "x2": "216",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "24",
      "x2": "176",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "24",
      "x2": "80",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "88",
      "x2": "216",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2W = [];
/* style */

const __vue_inject_styles__$2W = undefined;
/* scoped */

const __vue_scope_id__$2W = undefined;
/* module identifier */

const __vue_module_identifier__$2W = undefined;
/* functional template */

const __vue_is_functional_template__$2W = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2W = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2W,
  staticRenderFns: __vue_staticRenderFns__$2W
}, __vue_inject_styles__$2W, __vue_script__$2W, __vue_scope_id__$2W, __vue_is_functional_template__$2W, __vue_module_identifier__$2W, false, undefined, undefined, undefined);

var script$2X = Vue.extend({
  name: "PhCalendarCheck",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2X = script$2X;
/* template */

var __vue_render__$2X = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "20",
      "x2": "176",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "20",
      "x2": "80",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "88",
      "x2": "216",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "163.995 127.995 117.328 171.995 91.995 147.995",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,88H216V48a8,8,0,0,0-8-8H48a8,8,0,0,0-8,8Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "24",
      "x2": "176",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "24",
      "x2": "80",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "88",
      "x2": "216",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "163.995 127.995 117.328 171.995 91.995 147.995",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M207.99414,31.99707h-24v-8a8,8,0,0,0-16,0v8h-80v-8a8,8,0,1,0-16,0v8h-24a16.01583,16.01583,0,0,0-16,16v160a16.01583,16.01583,0,0,0,16,16h160a16.01582,16.01582,0,0,0,16-16v-160A16.01582,16.01582,0,0,0,207.99414,31.99707ZM169.48242,133.81543l-46.6665,44a7.99905,7.99905,0,0,1-10.98975-.0127l-25.33349-24a8,8,0,1,1,11.0039-11.61523l19.84424,18.7998,41.166-38.8125a7.99949,7.99949,0,1,1,10.97558,11.64063Zm38.51172-53.81836h-160v-32h24v8a8,8,0,0,0,16,0v-8h80v8a8,8,0,1,0,16,0v-8h24Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "24",
      "x2": "176",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "24",
      "x2": "80",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "88",
      "x2": "216",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "163.995 127.995 117.328 171.995 91.995 147.995",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "24",
      "x2": "176",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "24",
      "x2": "80",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "88",
      "x2": "216",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "163.995 127.995 117.328 171.995 91.995 147.995",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "24",
      "x2": "176",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "24",
      "x2": "80",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "88",
      "x2": "216",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "163.995 127.995 117.328 171.995 91.995 147.995",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2X = [];
/* style */

const __vue_inject_styles__$2X = undefined;
/* scoped */

const __vue_scope_id__$2X = undefined;
/* module identifier */

const __vue_module_identifier__$2X = undefined;
/* functional template */

const __vue_is_functional_template__$2X = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2X = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2X,
  staticRenderFns: __vue_staticRenderFns__$2X
}, __vue_inject_styles__$2X, __vue_script__$2X, __vue_scope_id__$2X, __vue_is_functional_template__$2X, __vue_module_identifier__$2X, false, undefined, undefined, undefined);

var script$2Y = Vue.extend({
  name: "PhCalendarPlus",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2Y = script$2Y;
/* template */

var __vue_render__$2Y = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "156",
      "y1": "152",
      "x2": "100",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "124",
      "x2": "128",
      "y2": "180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "20",
      "x2": "176",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "20",
      "x2": "80",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "88",
      "x2": "216",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,88H216V48a8,8,0,0,0-8-8H48a8,8,0,0,0-8,8Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "24",
      "x2": "176",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "24",
      "x2": "80",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "88",
      "x2": "216",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "152",
      "x2": "100",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "124",
      "x2": "128",
      "y2": "180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M207.99414,31.99707h-24v-8a8,8,0,0,0-16,0v8h-80v-8a8,8,0,1,0-16,0v8h-24a16.01583,16.01583,0,0,0-16,16v160a16.01583,16.01583,0,0,0,16,16h160a16.01582,16.01582,0,0,0,16-16v-160A16.01582,16.01582,0,0,0,207.99414,31.99707ZM156,160H136v20a8,8,0,0,1-16,0V160H100a8,8,0,0,1,0-16h20V124a8,8,0,0,1,16,0v20h20a8,8,0,0,1,0,16Zm51.99414-80.00293h-160v-32h24v8a8,8,0,0,0,16,0v-8h80v8a8,8,0,1,0,16,0v-8h24Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "24",
      "x2": "176",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "24",
      "x2": "80",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "88",
      "x2": "216",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "152",
      "x2": "100",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "124",
      "x2": "128",
      "y2": "180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "24",
      "x2": "176",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "24",
      "x2": "80",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "88",
      "x2": "216",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "152",
      "x2": "100",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "124",
      "x2": "128",
      "y2": "180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "24",
      "x2": "176",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "24",
      "x2": "80",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "88",
      "x2": "216",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "152",
      "x2": "100",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "124",
      "x2": "128",
      "y2": "180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2Y = [];
/* style */

const __vue_inject_styles__$2Y = undefined;
/* scoped */

const __vue_scope_id__$2Y = undefined;
/* module identifier */

const __vue_module_identifier__$2Y = undefined;
/* functional template */

const __vue_is_functional_template__$2Y = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2Y = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2Y,
  staticRenderFns: __vue_staticRenderFns__$2Y
}, __vue_inject_styles__$2Y, __vue_script__$2Y, __vue_scope_id__$2Y, __vue_is_functional_template__$2Y, __vue_module_identifier__$2Y, false, undefined, undefined, undefined);

var script$2Z = Vue.extend({
  name: "PhCalendarX",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2Z = script$2Z;
/* template */

var __vue_render__$2Z = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "152",
      "y1": "128",
      "x2": "104",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "176",
      "x2": "104",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "20",
      "x2": "176",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "20",
      "x2": "80",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "88",
      "x2": "216",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,88H216V48a8,8,0,0,0-8-8H48a8,8,0,0,0-8,8Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "24",
      "x2": "176",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "24",
      "x2": "80",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "88",
      "x2": "216",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "128",
      "x2": "104",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "176",
      "x2": "104",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M207.99414,31.9971h-24v-8a8,8,0,1,0-16,0v8h-80v-8a8,8,0,0,0-16,0v8h-24a16.01583,16.01583,0,0,0-16,16v160a16.01582,16.01582,0,0,0,16,16h160a16.01581,16.01581,0,0,0,16-16v-160A16.01582,16.01582,0,0,0,207.99414,31.9971ZM157.65039,170.34085a7.99915,7.99915,0,1,1-11.3125,11.3125L127.99414,163.3096l-18.34375,18.34375a7.99915,7.99915,0,0,1-11.3125-11.3125l18.34375-18.34375L98.33789,133.65335a7.99915,7.99915,0,1,1,11.3125-11.3125l18.34375,18.34375,18.34375-18.34375a7.99915,7.99915,0,1,1,11.3125,11.3125L139.30664,151.9971ZM207.99414,79.9971h-160v-32h24v8a8,8,0,0,0,16,0v-8h80v8a8,8,0,1,0,16,0v-8h24Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "24",
      "x2": "176",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "24",
      "x2": "80",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "88",
      "x2": "216",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "128",
      "x2": "104",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "176",
      "x2": "104",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "24",
      "x2": "176",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "24",
      "x2": "80",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "88",
      "x2": "216",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "128",
      "x2": "104",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "176",
      "x2": "104",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "24",
      "x2": "176",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "24",
      "x2": "80",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "88",
      "x2": "216",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "128",
      "x2": "104",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "176",
      "x2": "104",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2Z = [];
/* style */

const __vue_inject_styles__$2Z = undefined;
/* scoped */

const __vue_scope_id__$2Z = undefined;
/* module identifier */

const __vue_module_identifier__$2Z = undefined;
/* functional template */

const __vue_is_functional_template__$2Z = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2Z = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2Z,
  staticRenderFns: __vue_staticRenderFns__$2Z
}, __vue_inject_styles__$2Z, __vue_script__$2Z, __vue_scope_id__$2Z, __vue_is_functional_template__$2Z, __vue_module_identifier__$2Z, false, undefined, undefined, undefined);

var script$2_ = Vue.extend({
  name: "PhCamera",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2_ = script$2_;
/* template */

var __vue_render__$2_ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,208H48a16,16,0,0,1-16-16V80A16,16,0,0,1,48,64H79.99414l16-24h64l16,24H208a16,16,0,0,1,16,16V192A16,16,0,0,1,208,208Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "132",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,64H175.99414l-16-24h-64l-16,24H48A16,16,0,0,0,32,80V192a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V80A16,16,0,0,0,208,64ZM128,168a36,36,0,1,1,36-36A36,36,0,0,1,128,168Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,208H48a16,16,0,0,1-16-16V80A16,16,0,0,1,48,64H79.99414l16-24h64l16,24H208a16,16,0,0,1,16,16V192A16,16,0,0,1,208,208Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "132",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,56H180.27539l-13.625-20.4375A7.99942,7.99942,0,0,0,159.99414,32h-64a7.99943,7.99943,0,0,0-6.65625,3.5625L75.71289,56H48A24.0275,24.0275,0,0,0,24,80V192a24.0275,24.0275,0,0,0,24,24H208a24.0275,24.0275,0,0,0,24-24V80A24.0275,24.0275,0,0,0,208,56Zm-44,76a36,36,0,1,1-36-36A36.04043,36.04043,0,0,1,164,132Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,208H48a16,16,0,0,1-16-16V80A16,16,0,0,1,48,64H79.99414l16-24h64l16,24H208a16,16,0,0,1,16,16V192A16,16,0,0,1,208,208Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "132",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,208H48a16,16,0,0,1-16-16V80A16,16,0,0,1,48,64H79.99414l16-24h64l16,24H208a16,16,0,0,1,16,16V192A16,16,0,0,1,208,208Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "132",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,208H48a16,16,0,0,1-16-16V80A16,16,0,0,1,48,64H79.99414l16-24h64l16,24H208a16,16,0,0,1,16,16V192A16,16,0,0,1,208,208Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "132",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2_ = [];
/* style */

const __vue_inject_styles__$2_ = undefined;
/* scoped */

const __vue_scope_id__$2_ = undefined;
/* module identifier */

const __vue_module_identifier__$2_ = undefined;
/* functional template */

const __vue_is_functional_template__$2_ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2_ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2_,
  staticRenderFns: __vue_staticRenderFns__$2_
}, __vue_inject_styles__$2_, __vue_script__$2_, __vue_scope_id__$2_, __vue_is_functional_template__$2_, __vue_module_identifier__$2_, false, undefined, undefined, undefined);

var script$2$ = Vue.extend({
  name: "PhCameraSlash",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2$ = script$2$;
/* template */

var __vue_render__$2$ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "33.45455",
      "y1": "24",
      "x2": "222.54545",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200.72725,208H48a16,16,0,0,1-16-16V80A16,16,0,0,1,48,64H69.8181",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154.13957,156.75336a36.00072,36.00072,0,1,1-48.298-53.128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M102.05858,40h57.93556l16,24H208a16,16,0,0,1,16,16v94.13562",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208.00244,64.00684H175.99658l-16-24h-64l-16,24H48.00244a16,16,0,0,0-16,16v112a16,16,0,0,0,16,16h160a16,16,0,0,0,16-16v-112A16,16,0,0,0,208.00244,64.00684Zm-80,104a36,36,0,1,1,36-36A36,36,0,0,1,128.00244,168.00684Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "33.45455",
      "y1": "24",
      "x2": "222.54545",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M93.98553,43.01291,95.99414,40h64l16,24H208a16,16,0,0,1,16,16V186.02889",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200.72725,208H48a16,16,0,0,1-16-16V80A16,16,0,0,1,48,64H69.8181",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154.13957,156.75336a36.00072,36.00072,0,1,1-48.298-53.128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M39.37451,18.61865a8.00027,8.00027,0,0,0-11.83984,10.7627L51.7334,56H47.99951a24.0275,24.0275,0,0,0-24,24V192a24.0275,24.0275,0,0,0,24,24H197.188l19.4375,21.38135a8.00027,8.00027,0,0,0,11.83984-10.7627ZM128,168a35.97306,35.97306,0,0,1-27.86426-58.75781L148.02246,161.918A35.81152,35.81152,0,0,1,128,168Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M207.99951,56H180.2749l-13.625-20.4375A7.99942,7.99942,0,0,0,159.99365,32h-64a7.99954,7.99954,0,0,0-6.65722,3.56348l-2.00782,3.01318a8.00079,8.00079,0,0,0,.73731,9.81787L218.07959,191.41016a8.0004,8.0004,0,0,0,13.91992-5.38135V80A24.0275,24.0275,0,0,0,207.99951,56Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "33.45455",
      "y1": "24",
      "x2": "222.54545",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M93.98553,43.01291,95.99414,40h64l16,24H208a16,16,0,0,1,16,16V186.02889",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200.72725,208H48a16,16,0,0,1-16-16V80A16,16,0,0,1,48,64H69.8181",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154.13957,156.75336a36.00072,36.00072,0,1,1-48.298-53.128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "33.45455",
      "y1": "24",
      "x2": "222.54545",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M93.98553,43.01291,95.99414,40h64l16,24H208a16,16,0,0,1,16,16V186.02889",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200.72725,208H48a16,16,0,0,1-16-16V80A16,16,0,0,1,48,64H69.8181",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154.13957,156.75336a36.00072,36.00072,0,1,1-48.298-53.128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "33.45455",
      "y1": "24",
      "x2": "222.54545",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M93.98553,43.01291,95.99414,40h64l16,24H208a16,16,0,0,1,16,16V186.02889",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200.72725,208H48a16,16,0,0,1-16-16V80A16,16,0,0,1,48,64H69.8181",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154.13957,156.75336a36.00072,36.00072,0,1,1-48.298-53.128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2$ = [];
/* style */

const __vue_inject_styles__$2$ = undefined;
/* scoped */

const __vue_scope_id__$2$ = undefined;
/* module identifier */

const __vue_module_identifier__$2$ = undefined;
/* functional template */

const __vue_is_functional_template__$2$ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2$ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2$,
  staticRenderFns: __vue_staticRenderFns__$2$
}, __vue_inject_styles__$2$, __vue_script__$2$, __vue_scope_id__$2$, __vue_is_functional_template__$2$, __vue_module_identifier__$2$, false, undefined, undefined, undefined);

var script$30 = Vue.extend({
  name: "PhCar",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$30 = script$30;
/* template */

var __vue_render__$30 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "16",
      "y1": "120",
      "x2": "240",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,176v32a8,8,0,0,1-8,8H192a8,8,0,0,1-8-8V176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,176v32a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,120,194.11151,52.75089A8,8,0,0,0,186.801,48H69.199a8,8,0,0,0-7.31049,4.75089L32,120v56H224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,184v24a8,8,0,0,1-8,8H192a8,8,0,0,1-8-8V184Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,184v24a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V184Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,120,194.11151,52.75089A8,8,0,0,0,186.801,48H69.199a8,8,0,0,0-7.31049,4.75089L32,120Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "120",
      "x2": "240",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,184v24a8,8,0,0,1-8,8H192a8,8,0,0,1-8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,184v24a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "152",
      "x2": "80",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "152",
      "x2": "192",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,120,194.11151,52.75089A8,8,0,0,0,186.801,48H69.199a8,8,0,0,0-7.31049,4.75089L32,120v64H224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M240,112H229.199L201.42188,49.501A16.01649,16.01649,0,0,0,186.80078,40H69.19922a16.0158,16.0158,0,0,0-14.6211,9.502L26.801,112H16a8,8,0,0,0,0,16h8v80a16.01833,16.01833,0,0,0,16,16H64a16.01833,16.01833,0,0,0,16-16V192h96v16a16.01833,16.01833,0,0,0,16,16h24a16.01833,16.01833,0,0,0,16-16V128h8a8,8,0,0,0,0-16ZM80,160H64a8,8,0,0,1,0-16H80a8,8,0,0,1,0,16Zm96,0a8,8,0,0,1,0-16h16a8,8,0,0,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "16",
      "y1": "120",
      "x2": "240",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,184v24a8,8,0,0,1-8,8H192a8,8,0,0,1-8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,184v24a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "152",
      "x2": "80",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "152",
      "x2": "192",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,120,194.11151,52.75089A8,8,0,0,0,186.801,48H69.199a8,8,0,0,0-7.31049,4.75089L32,120v64H224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "16",
      "y1": "120",
      "x2": "240",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,184v24a8,8,0,0,1-8,8H192a8,8,0,0,1-8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,184v24a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "152",
      "x2": "80",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "152",
      "x2": "192",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,120,194.11151,52.75089A8,8,0,0,0,186.801,48H69.199a8,8,0,0,0-7.31049,4.75089L32,120v64H224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "16",
      "y1": "120",
      "x2": "240",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,184v24a8,8,0,0,1-8,8H192a8,8,0,0,1-8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,184v24a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "152",
      "x2": "80",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "152",
      "x2": "192",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,120,194.11151,52.75089A8,8,0,0,0,186.801,48H69.199a8,8,0,0,0-7.31049,4.75089L32,120v64H224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$30 = [];
/* style */

const __vue_inject_styles__$30 = undefined;
/* scoped */

const __vue_scope_id__$30 = undefined;
/* module identifier */

const __vue_module_identifier__$30 = undefined;
/* functional template */

const __vue_is_functional_template__$30 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$30 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$30,
  staticRenderFns: __vue_staticRenderFns__$30
}, __vue_inject_styles__$30, __vue_script__$30, __vue_scope_id__$30, __vue_is_functional_template__$30, __vue_module_identifier__$30, false, undefined, undefined, undefined);

var script$31 = Vue.extend({
  name: "PhCarSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$31 = script$31;
/* template */

var __vue_render__$31 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "16",
      "y1": "120",
      "x2": "240",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,216H192a8,8,0,0,1-8-8V184H72v24a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V120L61.88849,52.75089A8,8,0,0,1,69.199,48H186.801a8,8,0,0,1,7.31049,4.75089L224,120v88A8,8,0,0,1,216,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,120,61.88849,52.75089A8,8,0,0,1,69.199,48H186.801a8,8,0,0,1,7.31049,4.75089L224,120Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "120",
      "x2": "240",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,216H192a8,8,0,0,1-8-8V184H72v24a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V120L61.88849,52.75089A8,8,0,0,1,69.199,48H186.801a8,8,0,0,1,7.31049,4.75089L224,120v88A8,8,0,0,1,216,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M240,112H229.199L201.42188,49.501A16.01649,16.01649,0,0,0,186.80078,40H69.19922a16.0158,16.0158,0,0,0-14.6211,9.502L26.801,112H16a8,8,0,0,0,0,16h8v80a16.01833,16.01833,0,0,0,16,16H64a16.01833,16.01833,0,0,0,16-16V192h96v16a16.01833,16.01833,0,0,0,16,16h24a16.01833,16.01833,0,0,0,16-16V128h8a8,8,0,0,0,0-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "16",
      "y1": "120",
      "x2": "240",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,216H192a8,8,0,0,1-8-8V184H72v24a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V120L61.88849,52.75089A8,8,0,0,1,69.199,48H186.801a8,8,0,0,1,7.31049,4.75089L224,120v88A8,8,0,0,1,216,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "16",
      "y1": "120",
      "x2": "240",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,216H192a8,8,0,0,1-8-8V184H72v24a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V120L61.88849,52.75089A8,8,0,0,1,69.199,48H186.801a8,8,0,0,1,7.31049,4.75089L224,120v88A8,8,0,0,1,216,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "16",
      "y1": "120",
      "x2": "240",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,216H192a8,8,0,0,1-8-8V184H72v24a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V120L61.88849,52.75089A8,8,0,0,1,69.199,48H186.801a8,8,0,0,1,7.31049,4.75089L224,120v88A8,8,0,0,1,216,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$31 = [];
/* style */

const __vue_inject_styles__$31 = undefined;
/* scoped */

const __vue_scope_id__$31 = undefined;
/* module identifier */

const __vue_module_identifier__$31 = undefined;
/* functional template */

const __vue_is_functional_template__$31 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$31 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$31,
  staticRenderFns: __vue_staticRenderFns__$31
}, __vue_inject_styles__$31, __vue_script__$31, __vue_scope_id__$31, __vue_is_functional_template__$31, __vue_module_identifier__$31, false, undefined, undefined, undefined);

var script$32 = Vue.extend({
  name: "PhCardholder",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$32 = script$32;
/* template */

var __vue_render__$32 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "56",
      "width": "192",
      "height": "144",
      "rx": "16",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,100H88.80976A7.98836,7.98836,0,0,1,96.64,106.39917a32.00785,32.00785,0,0,0,62.7201,0A7.98836,7.98836,0,0,1,167.19024,100H224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,120H88.80976A7.98836,7.98836,0,0,1,96.64,126.39917a32.00785,32.00785,0,0,0,62.7201,0A7.98836,7.98836,0,0,1,167.19024,120H224V72a16,16,0,0,0-16-16H48A16,16,0,0,0,32,72Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "56",
      "width": "192",
      "height": "144",
      "rx": "16",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,120H88.80976A7.98836,7.98836,0,0,1,96.64,126.39917a32.00785,32.00785,0,0,0,62.7201,0A7.98836,7.98836,0,0,1,167.19024,120H224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "88",
      "x2": "224",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,48H48A24.0275,24.0275,0,0,0,24,72V184a24.0275,24.0275,0,0,0,24,24H208a24.0275,24.0275,0,0,0,24-24V72A24.0275,24.0275,0,0,0,208,48Zm-56.47949,76.80762a24.00866,24.00866,0,0,1-47.041.001A16.03939,16.03939,0,0,0,88.80957,112H40V96H216v16H167.19043A16.0395,16.0395,0,0,0,151.52051,124.80762ZM48,64H208a8.00917,8.00917,0,0,1,8,8v8H40V72A8.00917,8.00917,0,0,1,48,64Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "56",
      "width": "192",
      "height": "144",
      "rx": "16",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,120H88.80976A7.98836,7.98836,0,0,1,96.64,126.39917a32.00785,32.00785,0,0,0,62.7201,0A7.98836,7.98836,0,0,1,167.19024,120H224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "88",
      "x2": "224",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "56",
      "width": "192",
      "height": "144",
      "rx": "16",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,120H88.80976A7.98836,7.98836,0,0,1,96.64,126.39917a32.00785,32.00785,0,0,0,62.7201,0A7.98836,7.98836,0,0,1,167.19024,120H224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "88",
      "x2": "224",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "56",
      "width": "192",
      "height": "144",
      "rx": "16",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,120H88.80976A7.98836,7.98836,0,0,1,96.64,126.39917a32.00785,32.00785,0,0,0,62.7201,0A7.98836,7.98836,0,0,1,167.19024,120H224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "88",
      "x2": "224",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$32 = [];
/* style */

const __vue_inject_styles__$32 = undefined;
/* scoped */

const __vue_scope_id__$32 = undefined;
/* module identifier */

const __vue_module_identifier__$32 = undefined;
/* functional template */

const __vue_is_functional_template__$32 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$32 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$32,
  staticRenderFns: __vue_staticRenderFns__$32
}, __vue_inject_styles__$32, __vue_script__$32, __vue_scope_id__$32, __vue_is_functional_template__$32, __vue_module_identifier__$32, false, undefined, undefined, undefined);

var script$33 = Vue.extend({
  name: "PhCards",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$33 = script$33;
/* template */

var __vue_render__$33 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "28.00781",
      "y": "84.00005",
      "width": "160",
      "height": "128",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64.00781,44.00005h156a8,8,0,0,1,8,8V176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32.00781",
      "y": "80.00005",
      "width": "160",
      "height": "128",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32.00781",
      "y": "80.00005",
      "width": "160",
      "height": "128",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64.00781,48.00005h152a8,8,0,0,1,8,8V176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('rect', {
    attrs: {
      "x": "24.00781",
      "y": "72",
      "width": "176",
      "height": "144",
      "rx": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216.00781,40h-152a8,8,0,0,0,0,16h152V176a8,8,0,0,0,16,0V56A16.01833,16.01833,0,0,0,216.00781,40Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32.00781",
      "y": "80.00005",
      "width": "160",
      "height": "128",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64.00781,48.00005h152a8,8,0,0,1,8,8V176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32.00781",
      "y": "80.00005",
      "width": "160",
      "height": "128",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64.00781,48.00005h152a8,8,0,0,1,8,8V176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32.00781",
      "y": "80.00005",
      "width": "160",
      "height": "128",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64.00781,48.00005h152a8,8,0,0,1,8,8V176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$33 = [];
/* style */

const __vue_inject_styles__$33 = undefined;
/* scoped */

const __vue_scope_id__$33 = undefined;
/* module identifier */

const __vue_module_identifier__$33 = undefined;
/* functional template */

const __vue_is_functional_template__$33 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$33 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$33,
  staticRenderFns: __vue_staticRenderFns__$33
}, __vue_inject_styles__$33, __vue_script__$33, __vue_scope_id__$33, __vue_is_functional_template__$33, __vue_module_identifier__$33, false, undefined, undefined, undefined);

var script$34 = Vue.extend({
  name: "PhCaretCircleDoubleDown",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$34 = script$34;
/* template */

var __vue_render__$34 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 88 128 120 96 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 144 128 176 96 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 88 128 120 96 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 144 128 176 96 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M54.46094,54.46094a103.95314,103.95314,0,1,0,147.07812,0A104.12262,104.12262,0,0,0,54.46094,54.46094Zm99.88281,83.88281a7.99915,7.99915,0,1,1,11.3125,11.3125l-32,32a7.99708,7.99708,0,0,1-11.3125,0l-32-32a7.99915,7.99915,0,0,1,11.3125-11.3125L128,164.6875Zm0-56a7.99915,7.99915,0,1,1,11.3125,11.3125l-32,32a7.99708,7.99708,0,0,1-11.3125,0l-32-32a7.99915,7.99915,0,0,1,11.3125-11.3125L128,108.6875Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 88 128 120 96 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 144 128 176 96 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 88 128 120 96 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 144 128 176 96 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 88 128 120 96 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 144 128 176 96 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$34 = [];
/* style */

const __vue_inject_styles__$34 = undefined;
/* scoped */

const __vue_scope_id__$34 = undefined;
/* module identifier */

const __vue_module_identifier__$34 = undefined;
/* functional template */

const __vue_is_functional_template__$34 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$34 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$34,
  staticRenderFns: __vue_staticRenderFns__$34
}, __vue_inject_styles__$34, __vue_script__$34, __vue_scope_id__$34, __vue_is_functional_template__$34, __vue_module_identifier__$34, false, undefined, undefined, undefined);

var script$35 = Vue.extend({
  name: "PhCaretCircleDoubleLeft",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$35 = script$35;
/* template */

var __vue_render__$35 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "168 160 136 128 168 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "112 160 80 128 112 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "168 160 136 128 168 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "112 160 80 128 112 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M201.53906,54.46094a103.95314,103.95314,0,1,0,0,147.07812A104.12262,104.12262,0,0,0,201.53906,54.46094Zm-83.88281,99.88281a7.99915,7.99915,0,1,1-11.3125,11.3125l-32-32a7.99708,7.99708,0,0,1,0-11.3125l32-32a7.99915,7.99915,0,0,1,11.3125,11.3125L91.3125,128Zm56,0a7.99915,7.99915,0,1,1-11.3125,11.3125l-32-32a7.99708,7.99708,0,0,1,0-11.3125l32-32a7.99915,7.99915,0,0,1,11.3125,11.3125L147.3125,128Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "168 160 136 128 168 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "112 160 80 128 112 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "168 160 136 128 168 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "112 160 80 128 112 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "168 160 136 128 168 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "112 160 80 128 112 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$35 = [];
/* style */

const __vue_inject_styles__$35 = undefined;
/* scoped */

const __vue_scope_id__$35 = undefined;
/* module identifier */

const __vue_module_identifier__$35 = undefined;
/* functional template */

const __vue_is_functional_template__$35 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$35 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$35,
  staticRenderFns: __vue_staticRenderFns__$35
}, __vue_inject_styles__$35, __vue_script__$35, __vue_scope_id__$35, __vue_is_functional_template__$35, __vue_module_identifier__$35, false, undefined, undefined, undefined);

var script$36 = Vue.extend({
  name: "PhCaretCircleDoubleRight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$36 = script$36;
/* template */

var __vue_render__$36 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "88 160 120 128 88 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 160 176 128 144 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "88 160 120 128 88 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 160 176 128 144 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M201.53906,54.46094a103.95314,103.95314,0,1,0,0,147.07812A104.12262,104.12262,0,0,0,201.53906,54.46094Zm-75.88281,79.19531-32,32a7.99915,7.99915,0,0,1-11.3125-11.3125L108.6875,128,82.34375,101.65625a7.99915,7.99915,0,0,1,11.3125-11.3125l32,32A7.99708,7.99708,0,0,1,125.65625,133.65625Zm56,0-32,32a7.99915,7.99915,0,0,1-11.3125-11.3125L164.6875,128l-26.34375-26.34375a7.99915,7.99915,0,0,1,11.3125-11.3125l32,32A7.99708,7.99708,0,0,1,181.65625,133.65625Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "88 160 120 128 88 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 160 176 128 144 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "88 160 120 128 88 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 160 176 128 144 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "88 160 120 128 88 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 160 176 128 144 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$36 = [];
/* style */

const __vue_inject_styles__$36 = undefined;
/* scoped */

const __vue_scope_id__$36 = undefined;
/* module identifier */

const __vue_module_identifier__$36 = undefined;
/* functional template */

const __vue_is_functional_template__$36 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$36 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$36,
  staticRenderFns: __vue_staticRenderFns__$36
}, __vue_inject_styles__$36, __vue_script__$36, __vue_scope_id__$36, __vue_is_functional_template__$36, __vue_module_identifier__$36, false, undefined, undefined, undefined);

var script$37 = Vue.extend({
  name: "PhCaretCircleDoubleUp",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$37 = script$37;
/* template */

var __vue_render__$37 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 168 128 136 160 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 112 128 80 160 112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 168 128 136 160 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 112 128 80 160 112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M201.53906,201.53906a103.95314,103.95314,0,1,0-147.07812,0A104.12262,104.12262,0,0,0,201.53906,201.53906Zm-99.88281-83.88281a7.99915,7.99915,0,1,1-11.3125-11.3125l32-32a7.99708,7.99708,0,0,1,11.3125,0l32,32a7.99915,7.99915,0,0,1-11.3125,11.3125L128,91.3125Zm0,56a7.99915,7.99915,0,1,1-11.3125-11.3125l32-32a7.99708,7.99708,0,0,1,11.3125,0l32,32a7.99915,7.99915,0,0,1-11.3125,11.3125L128,147.3125Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 168 128 136 160 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 112 128 80 160 112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 168 128 136 160 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 112 128 80 160 112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 168 128 136 160 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 112 128 80 160 112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$37 = [];
/* style */

const __vue_inject_styles__$37 = undefined;
/* scoped */

const __vue_scope_id__$37 = undefined;
/* module identifier */

const __vue_module_identifier__$37 = undefined;
/* functional template */

const __vue_is_functional_template__$37 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$37 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$37,
  staticRenderFns: __vue_staticRenderFns__$37
}, __vue_inject_styles__$37, __vue_script__$37, __vue_scope_id__$37, __vue_is_functional_template__$37, __vue_module_identifier__$37, false, undefined, undefined, undefined);

var script$38 = Vue.extend({
  name: "PhCaretCircleDown",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$38 = script$38;
/* template */

var __vue_render__$38 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "164 116 128 156 92 116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "164 116 128 156 92 116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.12041,104.12041,0,0,0,128,24Zm41.94531,97.35156-36,40a7.99734,7.99734,0,0,1-11.89062,0l-36-40a7.99912,7.99912,0,1,1,11.89062-10.70312L128,144.03906l30.05469-33.39062a7.99912,7.99912,0,1,1,11.89062,10.70312Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "164 116 128 156 92 116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "164 116 128 156 92 116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "164 116 128 156 92 116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$38 = [];
/* style */

const __vue_inject_styles__$38 = undefined;
/* scoped */

const __vue_scope_id__$38 = undefined;
/* module identifier */

const __vue_module_identifier__$38 = undefined;
/* functional template */

const __vue_is_functional_template__$38 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$38 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$38,
  staticRenderFns: __vue_staticRenderFns__$38
}, __vue_inject_styles__$38, __vue_script__$38, __vue_scope_id__$38, __vue_is_functional_template__$38, __vue_module_identifier__$38, false, undefined, undefined, undefined);

var script$39 = Vue.extend({
  name: "PhCaretCircleLeft",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$39 = script$39;
/* template */

var __vue_render__$39 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 92 104 128 144 164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 92 104 128 144 164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.12041,104.12041,0,0,0,128,24Zm21.35156,134.05469a7.99912,7.99912,0,1,1-10.70312,11.89062l-40-36a7.99734,7.99734,0,0,1,0-11.89062l40-36a7.99912,7.99912,0,1,1,10.70312,11.89062L115.96094,128Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 92 104 128 144 164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 92 104 128 144 164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 92 104 128 144 164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$39 = [];
/* style */

const __vue_inject_styles__$39 = undefined;
/* scoped */

const __vue_scope_id__$39 = undefined;
/* module identifier */

const __vue_module_identifier__$39 = undefined;
/* functional template */

const __vue_is_functional_template__$39 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$39 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$39,
  staticRenderFns: __vue_staticRenderFns__$39
}, __vue_inject_styles__$39, __vue_script__$39, __vue_scope_id__$39, __vue_is_functional_template__$39, __vue_module_identifier__$39, false, undefined, undefined, undefined);

var script$3a = Vue.extend({
  name: "PhCaretCircleRight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3a = script$3a;
/* template */

var __vue_render__$3a = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "116 92 156 128 116 164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "116 92 156 128 116 164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.12041,104.12041,0,0,0,128,24Zm33.35156,109.94531-40,36a7.99912,7.99912,0,1,1-10.70312-11.89062L144.03906,128,110.64844,97.94531a7.99912,7.99912,0,0,1,10.70312-11.89062l40,36a7.99734,7.99734,0,0,1,0,11.89062Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "116 92 156 128 116 164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "116 92 156 128 116 164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "116 92 156 128 116 164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3a = [];
/* style */

const __vue_inject_styles__$3a = undefined;
/* scoped */

const __vue_scope_id__$3a = undefined;
/* module identifier */

const __vue_module_identifier__$3a = undefined;
/* functional template */

const __vue_is_functional_template__$3a = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3a = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3a,
  staticRenderFns: __vue_staticRenderFns__$3a
}, __vue_inject_styles__$3a, __vue_script__$3a, __vue_scope_id__$3a, __vue_is_functional_template__$3a, __vue_module_identifier__$3a, false, undefined, undefined, undefined);

var script$3b = Vue.extend({
  name: "PhCaretCircleUp",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3b = script$3b;
/* template */

var __vue_render__$3b = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "164 144 128 104 92 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "164 144 128 104 92 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.12041,104.12041,0,0,0,128,24Zm41.35156,125.94531a7.997,7.997,0,0,1-11.29687-.59375L128,115.96094,97.94531,149.35156a7.99912,7.99912,0,0,1-11.89062-10.70312l36-40a8.24769,8.24769,0,0,1,11.89062,0l36,40A8.00337,8.00337,0,0,1,169.35156,149.94531Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "164 144 128 104 92 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "164 144 128 104 92 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "164 144 128 104 92 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3b = [];
/* style */

const __vue_inject_styles__$3b = undefined;
/* scoped */

const __vue_scope_id__$3b = undefined;
/* module identifier */

const __vue_module_identifier__$3b = undefined;
/* functional template */

const __vue_is_functional_template__$3b = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3b = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3b,
  staticRenderFns: __vue_staticRenderFns__$3b
}, __vue_inject_styles__$3b, __vue_script__$3b, __vue_scope_id__$3b, __vue_is_functional_template__$3b, __vue_module_identifier__$3b, false, undefined, undefined, undefined);

var script$3c = Vue.extend({
  name: "PhCaretDoubleDown",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3c = script$3c;
/* template */

var __vue_render__$3c = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "208 128 128 208 48 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 48 128 128 48 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "208 48 128 128 48 48 208 48",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 128 128 208 48 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "208 48 128 128 48 48 208 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,120H147.31348l66.34326-66.34326A7.99981,7.99981,0,0,0,208,40H48a7.99981,7.99981,0,0,0-5.65674,13.65674L108.68652,120H48a7.99981,7.99981,0,0,0-5.65674,13.65674l80,80.00049a8.00063,8.00063,0,0,0,11.31348,0l80-80.00049A7.99981,7.99981,0,0,0,208,120Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "208 128 128 208 48 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 48 128 128 48 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "208 128 128 208 48 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 48 128 128 48 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "208 128 128 208 48 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 48 128 128 48 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3c = [];
/* style */

const __vue_inject_styles__$3c = undefined;
/* scoped */

const __vue_scope_id__$3c = undefined;
/* module identifier */

const __vue_module_identifier__$3c = undefined;
/* functional template */

const __vue_is_functional_template__$3c = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3c = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3c,
  staticRenderFns: __vue_staticRenderFns__$3c
}, __vue_inject_styles__$3c, __vue_script__$3c, __vue_scope_id__$3c, __vue_is_functional_template__$3c, __vue_module_identifier__$3c, false, undefined, undefined, undefined);

var script$3d = Vue.extend({
  name: "PhCaretDoubleLeft",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3d = script$3d;
/* template */

var __vue_render__$3d = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "200 208 120 128 200 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "120 208 40 128 120 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "200 208 120 128 200 48 200 208",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "200 208 120 128 200 48 200 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "120 208 40 128 120 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M203.06152,40.60889a7.99927,7.99927,0,0,0-8.71826,1.73437L128,108.68652V48a7.99981,7.99981,0,0,0-13.65674-5.65674l-80,80a7.99915,7.99915,0,0,0,0,11.31348l80,80A7.99981,7.99981,0,0,0,128,208V147.31348l66.34326,66.34326A7.99981,7.99981,0,0,0,208,208V48A8.00015,8.00015,0,0,0,203.06152,40.60889Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "200 208 120 128 200 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "120 208 40 128 120 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "200 208 120 128 200 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "120 208 40 128 120 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "200 208 120 128 200 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "120 208 40 128 120 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3d = [];
/* style */

const __vue_inject_styles__$3d = undefined;
/* scoped */

const __vue_scope_id__$3d = undefined;
/* module identifier */

const __vue_module_identifier__$3d = undefined;
/* functional template */

const __vue_is_functional_template__$3d = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3d = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3d,
  staticRenderFns: __vue_staticRenderFns__$3d
}, __vue_inject_styles__$3d, __vue_script__$3d, __vue_scope_id__$3d, __vue_is_functional_template__$3d, __vue_module_identifier__$3d, false, undefined, undefined, undefined);

var script$3e = Vue.extend({
  name: "PhCaretDoubleRight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3e = script$3e;
/* template */

var __vue_render__$3e = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "56 48 136 128 56 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "136 48 216 128 136 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "56 48 136 128 56 208 56 48",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "56 48 136 128 56 208 56 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "136 48 216 128 136 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M221.65674,122.34326l-80-80A7.99981,7.99981,0,0,0,128,48v60.68652L61.65674,42.34326A7.99981,7.99981,0,0,0,48,48V208a7.99984,7.99984,0,0,0,13.65674,5.65674L128,147.31348V208a7.99984,7.99984,0,0,0,13.65674,5.65674l80-80A7.99915,7.99915,0,0,0,221.65674,122.34326Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "56 48 136 128 56 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "136 48 216 128 136 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "56 48 136 128 56 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "136 48 216 128 136 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "56 48 136 128 56 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "136 48 216 128 136 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3e = [];
/* style */

const __vue_inject_styles__$3e = undefined;
/* scoped */

const __vue_scope_id__$3e = undefined;
/* module identifier */

const __vue_module_identifier__$3e = undefined;
/* functional template */

const __vue_is_functional_template__$3e = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3e = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3e,
  staticRenderFns: __vue_staticRenderFns__$3e
}, __vue_inject_styles__$3e, __vue_script__$3e, __vue_scope_id__$3e, __vue_is_functional_template__$3e, __vue_module_identifier__$3e, false, undefined, undefined, undefined);

var script$3f = Vue.extend({
  name: "PhCaretDoubleUp",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3f = script$3f;
/* template */

var __vue_render__$3f = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "48 208 128 128 208 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48 128 128 48 208 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "48 208 128 128 208 208 48 208",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "48 208 128 128 208 208 48 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48 128 128 48 208 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M147.314,136H208a8.0001,8.0001,0,0,0,5.65674-13.65723l-80-80a8.00182,8.00182,0,0,0-11.31348,0l-80,80A8.0001,8.0001,0,0,0,48,136h60.686L42.34326,202.34277A8.0001,8.0001,0,0,0,48,216H208a8.0001,8.0001,0,0,0,5.65674-13.65723Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "48 208 128 128 208 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48 128 128 48 208 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "48 208 128 128 208 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48 128 128 48 208 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "48 208 128 128 208 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48 128 128 48 208 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3f = [];
/* style */

const __vue_inject_styles__$3f = undefined;
/* scoped */

const __vue_scope_id__$3f = undefined;
/* module identifier */

const __vue_module_identifier__$3f = undefined;
/* functional template */

const __vue_is_functional_template__$3f = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3f = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3f,
  staticRenderFns: __vue_staticRenderFns__$3f
}, __vue_inject_styles__$3f, __vue_script__$3f, __vue_scope_id__$3f, __vue_is_functional_template__$3f, __vue_module_identifier__$3f, false, undefined, undefined, undefined);

var script$3g = Vue.extend({
  name: "PhCaretDown",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3g = script$3g;
/* template */

var __vue_render__$3g = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "208 96 128 176 48 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "208 96 128 176 48 96 208 96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "208 96 128 176 48 96 208 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M215.39111,92.93848A8.00015,8.00015,0,0,0,208,88H48a8,8,0,0,0-5.65674,13.657l80,79.99976a7.99945,7.99945,0,0,0,11.31348,0l80-79.99976A8.00011,8.00011,0,0,0,215.39111,92.93848Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "208 96 128 176 48 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "208 96 128 176 48 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "208 96 128 176 48 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3g = [];
/* style */

const __vue_inject_styles__$3g = undefined;
/* scoped */

const __vue_scope_id__$3g = undefined;
/* module identifier */

const __vue_module_identifier__$3g = undefined;
/* functional template */

const __vue_is_functional_template__$3g = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3g = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3g,
  staticRenderFns: __vue_staticRenderFns__$3g
}, __vue_inject_styles__$3g, __vue_script__$3g, __vue_scope_id__$3g, __vue_is_functional_template__$3g, __vue_module_identifier__$3g, false, undefined, undefined, undefined);

var script$3h = Vue.extend({
  name: "PhCaretLeft",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3h = script$3h;
/* template */

var __vue_render__$3h = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "160 208 80 128 160 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "160 208 80 128 160 48 160 208",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "160 208 80 128 160 48 160 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M163.06152,40.60889a8.00159,8.00159,0,0,0-8.71826,1.73388l-80,80a8.00034,8.00034,0,0,0,0,11.31446l80,80A8.0001,8.0001,0,0,0,168,208V48A8.00065,8.00065,0,0,0,163.06152,40.60889Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "160 208 80 128 160 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "160 208 80 128 160 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "160 208 80 128 160 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3h = [];
/* style */

const __vue_inject_styles__$3h = undefined;
/* scoped */

const __vue_scope_id__$3h = undefined;
/* module identifier */

const __vue_module_identifier__$3h = undefined;
/* functional template */

const __vue_is_functional_template__$3h = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3h = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3h,
  staticRenderFns: __vue_staticRenderFns__$3h
}, __vue_inject_styles__$3h, __vue_script__$3h, __vue_scope_id__$3h, __vue_is_functional_template__$3h, __vue_module_identifier__$3h, false, undefined, undefined, undefined);

var script$3i = Vue.extend({
  name: "PhCaretRight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3i = script$3i;
/* template */

var __vue_render__$3i = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "96 48 176 128 96 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "96 48 176 128 96 208 96 48",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "96 48 176 128 96 208 96 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M181.65674,122.34277l-80-80A8.0001,8.0001,0,0,0,88,48V208a8.00018,8.00018,0,0,0,13.65674,5.65723l80-80A8.00034,8.00034,0,0,0,181.65674,122.34277Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "96 48 176 128 96 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "96 48 176 128 96 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "96 48 176 128 96 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3i = [];
/* style */

const __vue_inject_styles__$3i = undefined;
/* scoped */

const __vue_scope_id__$3i = undefined;
/* module identifier */

const __vue_module_identifier__$3i = undefined;
/* functional template */

const __vue_is_functional_template__$3i = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3i = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3i,
  staticRenderFns: __vue_staticRenderFns__$3i
}, __vue_inject_styles__$3i, __vue_script__$3i, __vue_scope_id__$3i, __vue_is_functional_template__$3i, __vue_module_identifier__$3i, false, undefined, undefined, undefined);

var script$3j = Vue.extend({
  name: "PhCaretUp",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3j = script$3j;
/* template */

var __vue_render__$3j = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "48 160 128 80 208 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "48 160 128 80 208 160 48 160",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "48 160 128 80 208 160 48 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M213.65674,154.34326l-80-80a8,8,0,0,0-11.31348,0l-80,80A7.99981,7.99981,0,0,0,48,168H208a7.99981,7.99981,0,0,0,5.65674-13.65674Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "48 160 128 80 208 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "48 160 128 80 208 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "48 160 128 80 208 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3j = [];
/* style */

const __vue_inject_styles__$3j = undefined;
/* scoped */

const __vue_scope_id__$3j = undefined;
/* module identifier */

const __vue_module_identifier__$3j = undefined;
/* functional template */

const __vue_is_functional_template__$3j = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3j = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3j,
  staticRenderFns: __vue_staticRenderFns__$3j
}, __vue_inject_styles__$3j, __vue_script__$3j, __vue_scope_id__$3j, __vue_is_functional_template__$3j, __vue_module_identifier__$3j, false, undefined, undefined, undefined);

var script$3k = Vue.extend({
  name: "PhCat",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3k = script$3k;
/* template */

var __vue_render__$3k = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "192",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "140",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "172",
      "cy": "140",
      "r": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 176 128 192 112 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,136V51.31371a8,8,0,0,1,13.65685-5.65686L67.59832,67.59832l-.0003-.00039a102.88019,102.88019,0,0,1,120.804,0l-.00032.00037,21.94147-21.94147A8,8,0,0,1,224,51.31371V136c0,48.60106-42.98066,88-96,88S32,184.60106,32,136Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "108",
      "y1": "49.91564",
      "x2": "108",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "148",
      "y1": "49.91489",
      "x2": "148",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,136V51.31371a8,8,0,0,1,13.65685-5.65686L67.59832,67.59832l-.0003-.00039a102.88019,102.88019,0,0,1,120.804,0l-.00032.00037,21.94147-21.94147A8,8,0,0,1,224,51.31371V136c0,48.60106-42.98066,88-96,88S32,184.60106,32,136Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "192",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "140",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "172",
      "cy": "140",
      "r": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "48",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 176 128 192 112 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "53.00879",
      "x2": "96",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "53.00879",
      "x2": "160",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,136V51.31371a8,8,0,0,1,13.65685-5.65686L67.59832,67.59832l-.0003-.00039a102.88019,102.88019,0,0,1,120.804,0l-.00032.00037,21.94147-21.94147A8,8,0,0,1,224,51.31371V136c0,48.60106-42.98066,88-96,88S32,184.60106,32,136Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M221.4126,36.25659a16.40365,16.40365,0,0,0-17.04737,4.06372L187.46,57.22656a111.22891,111.22891,0,0,0-118.91894,0L51.63379,40.31982a16.40325,16.40325,0,0,0-17.04688-4.063A15.9582,15.9582,0,0,0,24,51.31348V136c0,47.50391,37.57251,87.05957,86.72656,94.67578A8.01964,8.01964,0,0,0,120,222.77075V195.314l-13.42163-13.42163a8.21993,8.21993,0,0,1-.40625-11.37329,8.00123,8.00123,0,0,1,11.48511-.17578L128,180.68652l10.34277-10.34326a8.00123,8.00123,0,0,1,11.48511.17578,8.21993,8.21993,0,0,1-.40625,11.37329L136,195.314v27.45679a8.01964,8.01964,0,0,0,9.27344,7.905C194.42749,223.05957,232,183.50391,232,136V51.31348A15.95841,15.95841,0,0,0,221.4126,36.25659ZM84,152a12,12,0,1,1,12-12A12,12,0,0,1,84,152Zm20-64a8,8,0,0,1-16,0V69.00879a8,8,0,0,1,16,0Zm32,0a8,8,0,0,1-16,0V64a8,8,0,0,1,16,0Zm16,0V69.00879a8,8,0,0,1,16,0V88a8,8,0,0,1-16,0Zm20,64a12,12,0,1,1,12-12A12,12,0,0,1,172,152Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "192",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "140",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "172",
      "cy": "140",
      "r": "10"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "48",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 176 128 192 112 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "53.00879",
      "x2": "96",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "53.00879",
      "x2": "160",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,136V51.31371a8,8,0,0,1,13.65685-5.65686L67.59832,67.59832l-.0003-.00039a102.88019,102.88019,0,0,1,120.804,0l-.00032.00037,21.94147-21.94147A8,8,0,0,1,224,51.31371V136c0,48.60106-42.98066,88-96,88S32,184.60106,32,136Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "192",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "140",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "172",
      "cy": "140",
      "r": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "48",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 176 128 192 112 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "53.00879",
      "x2": "96",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "53.00879",
      "x2": "160",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,136V51.31371a8,8,0,0,1,13.65685-5.65686L67.59832,67.59832l-.0003-.00039a102.88019,102.88019,0,0,1,120.804,0l-.00032.00037,21.94147-21.94147A8,8,0,0,1,224,51.31371V136c0,48.60106-42.98066,88-96,88S32,184.60106,32,136Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "192",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "140",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "172",
      "cy": "140",
      "r": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "48",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 176 128 192 112 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "53.00879",
      "x2": "96",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "53.00879",
      "x2": "160",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,136V51.31371a8,8,0,0,1,13.65685-5.65686L67.59832,67.59832l-.0003-.00039a102.88019,102.88019,0,0,1,120.804,0l-.00032.00037,21.94147-21.94147A8,8,0,0,1,224,51.31371V136c0,48.60106-42.98066,88-96,88S32,184.60106,32,136Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3k = [];
/* style */

const __vue_inject_styles__$3k = undefined;
/* scoped */

const __vue_scope_id__$3k = undefined;
/* module identifier */

const __vue_module_identifier__$3k = undefined;
/* functional template */

const __vue_is_functional_template__$3k = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3k = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3k,
  staticRenderFns: __vue_staticRenderFns__$3k
}, __vue_inject_styles__$3k, __vue_script__$3k, __vue_scope_id__$3k, __vue_is_functional_template__$3k, __vue_module_identifier__$3k, false, undefined, undefined, undefined);

var script$3l = Vue.extend({
  name: "PhCellSignalFull",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3l = script$3l;
/* template */

var __vue_render__$3l = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,43.31371V208a8,8,0,0,1-8,8H27.31371a8,8,0,0,1-5.65686-13.65685l164.6863-164.6863A8,8,0,0,1,200,43.31371Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "64",
      "x2": "160",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "104",
      "x2": "120",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "144",
      "x2": "80",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,43.31371V208a8,8,0,0,1-8,8H27.31371a8,8,0,0,1-5.65686-13.65685l164.6863-164.6863A8,8,0,0,1,200,43.31371Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,43.31371V208a8,8,0,0,1-8,8H27.31371a8,8,0,0,1-5.65686-13.65685l164.6863-164.6863A8,8,0,0,1,200,43.31371Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M198.12305,28.53186a15.95339,15.95339,0,0,0-17.4375,3.46826L16.001,196.68616a15.99933,15.99933,0,0,0,11.3125,27.314H192a16.018,16.018,0,0,0,16-16V43.3136A15.95222,15.95222,0,0,0,198.12305,28.53186Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,43.31371V208a8,8,0,0,1-8,8H27.31371a8,8,0,0,1-5.65686-13.65685l164.6863-164.6863A8,8,0,0,1,200,43.31371Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "64",
      "x2": "160",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "104",
      "x2": "120",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "144",
      "x2": "80",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,43.31371V208a8,8,0,0,1-8,8H27.31371a8,8,0,0,1-5.65686-13.65685l164.6863-164.6863A8,8,0,0,1,200,43.31371Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "64",
      "x2": "160",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "104",
      "x2": "120",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "144",
      "x2": "80",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "160",
      "y1": "64",
      "x2": "160",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,43.31371V208a8,8,0,0,1-8,8H27.31371a8,8,0,0,1-5.65686-13.65685l164.6863-164.6863A8,8,0,0,1,200,43.31371Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "104",
      "x2": "120",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "144",
      "x2": "80",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3l = [];
/* style */

const __vue_inject_styles__$3l = undefined;
/* scoped */

const __vue_scope_id__$3l = undefined;
/* module identifier */

const __vue_module_identifier__$3l = undefined;
/* functional template */

const __vue_is_functional_template__$3l = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3l = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3l,
  staticRenderFns: __vue_staticRenderFns__$3l
}, __vue_inject_styles__$3l, __vue_script__$3l, __vue_scope_id__$3l, __vue_is_functional_template__$3l, __vue_module_identifier__$3l, false, undefined, undefined, undefined);

var script$3m = Vue.extend({
  name: "PhCellSignalHigh",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3m = script$3m;
/* template */

var __vue_render__$3m = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,43.31371V208a8,8,0,0,1-8,8H27.31371a8,8,0,0,1-5.65686-13.65685l164.6863-164.6863A8,8,0,0,1,200,43.31371Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "64",
      "x2": "160",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M160,216H27.31371a8,8,0,0,1-5.65686-13.65685L160,64Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,43.31371V208a8,8,0,0,1-8,8H27.31371a8,8,0,0,1-5.65686-13.65685l164.6863-164.6863A8,8,0,0,1,200,43.31371Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "64",
      "x2": "160",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M198.12305,28.53186a15.95339,15.95339,0,0,0-17.4375,3.46826L16.001,196.68616a15.95542,15.95542,0,0,0-4.69092,11.65869q.01319.58374.06933,1.168a16.06842,16.06842,0,0,0,8.02735,12.40771q.50536.28712,1.031.53662a16.00569,16.00569,0,0,0,6.87574,1.543H192a16.018,16.018,0,0,0,16-16V43.3136A15.95222,15.95222,0,0,0,198.12305,28.53186ZM192,208.00012l-24-.00049V67.31946L192,43.32Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,43.31371V208a8,8,0,0,1-8,8H27.31371a8,8,0,0,1-5.65686-13.65685l164.6863-164.6863A8,8,0,0,1,200,43.31371Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "64",
      "x2": "160",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,43.31371V208a8,8,0,0,1-8,8H27.31371a8,8,0,0,1-5.65686-13.65685l164.6863-164.6863A8,8,0,0,1,200,43.31371Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "64",
      "x2": "160",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,43.31371V208a8,8,0,0,1-8,8H27.31371a8,8,0,0,1-5.65686-13.65685l164.6863-164.6863A8,8,0,0,1,200,43.31371Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "64",
      "x2": "160",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3m = [];
/* style */

const __vue_inject_styles__$3m = undefined;
/* scoped */

const __vue_scope_id__$3m = undefined;
/* module identifier */

const __vue_module_identifier__$3m = undefined;
/* functional template */

const __vue_is_functional_template__$3m = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3m = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3m,
  staticRenderFns: __vue_staticRenderFns__$3m
}, __vue_inject_styles__$3m, __vue_script__$3m, __vue_scope_id__$3m, __vue_is_functional_template__$3m, __vue_module_identifier__$3m, false, undefined, undefined, undefined);

var script$3n = Vue.extend({
  name: "PhCellSignalLow",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3n = script$3n;
/* template */

var __vue_render__$3n = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,43.31371V208a8,8,0,0,1-8,8H27.31371a8,8,0,0,1-5.65686-13.65685l164.6863-164.6863A8,8,0,0,1,200,43.31371Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "144",
      "x2": "80",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,216H27.31371a8,8,0,0,1-5.65686-13.65685L80,144Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,43.31371V208a8,8,0,0,1-8,8H27.31371a8,8,0,0,1-5.65686-13.65685l164.6863-164.6863A8,8,0,0,1,200,43.31371Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "144",
      "x2": "80",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M198.12305,28.53186a15.95427,15.95427,0,0,0-17.4375,3.46826L74.34692,138.33948l-.00415.0039L16.001,196.68616a15.99945,15.99945,0,0,0,11.3125,27.314H192a16.01833,16.01833,0,0,0,16-16V43.3136A15.95272,15.95272,0,0,0,198.12305,28.53186ZM192,208.00012,88,207.9967V147.31653L192,43.32043Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,43.31371V208a8,8,0,0,1-8,8H27.31371a8,8,0,0,1-5.65686-13.65685l164.6863-164.6863A8,8,0,0,1,200,43.31371Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "144",
      "x2": "80",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,43.31371V208a8,8,0,0,1-8,8H27.31371a8,8,0,0,1-5.65686-13.65685l164.6863-164.6863A8,8,0,0,1,200,43.31371Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "144",
      "x2": "80",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,43.31371V208a8,8,0,0,1-8,8H27.31371a8,8,0,0,1-5.65686-13.65685l164.6863-164.6863A8,8,0,0,1,200,43.31371Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "144",
      "x2": "80",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3n = [];
/* style */

const __vue_inject_styles__$3n = undefined;
/* scoped */

const __vue_scope_id__$3n = undefined;
/* module identifier */

const __vue_module_identifier__$3n = undefined;
/* functional template */

const __vue_is_functional_template__$3n = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3n = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3n,
  staticRenderFns: __vue_staticRenderFns__$3n
}, __vue_inject_styles__$3n, __vue_script__$3n, __vue_scope_id__$3n, __vue_is_functional_template__$3n, __vue_module_identifier__$3n, false, undefined, undefined, undefined);

var script$3o = Vue.extend({
  name: "PhCellSignalMedium",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3o = script$3o;
/* template */

var __vue_render__$3o = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,43.31371V208a8,8,0,0,1-8,8H27.31371a8,8,0,0,1-5.65686-13.65685l164.6863-164.6863A8,8,0,0,1,200,43.31371Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "104",
      "x2": "120",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M120,216H27.31371a8,8,0,0,1-5.65686-13.65685L120,104Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,43.31371V208a8,8,0,0,1-8,8H27.31371a8,8,0,0,1-5.65686-13.65685l164.6863-164.6863A8,8,0,0,1,200,43.31371Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "104",
      "x2": "120",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M198.12305,28.53186a15.95339,15.95339,0,0,0-17.4375,3.46826L114.34473,98.34143l-.002.00195L16.001,196.68616a15.95542,15.95542,0,0,0-4.69092,11.65869q.01319.58374.06933,1.168a16.06842,16.06842,0,0,0,8.02735,12.40771q.50536.28712,1.031.53662a16.00569,16.00569,0,0,0,6.87574,1.543H192a16.018,16.018,0,0,0,16-16V43.3136A15.95272,15.95272,0,0,0,198.12305,28.53186ZM192,208.00012l-64-.002V107.318l64-63.99756Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,43.31371V208a8,8,0,0,1-8,8H27.31371a8,8,0,0,1-5.65686-13.65685l164.6863-164.6863A8,8,0,0,1,200,43.31371Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "104",
      "x2": "120",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,43.31371V208a8,8,0,0,1-8,8H27.31371a8,8,0,0,1-5.65686-13.65685l164.6863-164.6863A8,8,0,0,1,200,43.31371Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "104",
      "x2": "120",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,43.31371V208a8,8,0,0,1-8,8H27.31371a8,8,0,0,1-5.65686-13.65685l164.6863-164.6863A8,8,0,0,1,200,43.31371Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "104",
      "x2": "120",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3o = [];
/* style */

const __vue_inject_styles__$3o = undefined;
/* scoped */

const __vue_scope_id__$3o = undefined;
/* module identifier */

const __vue_module_identifier__$3o = undefined;
/* functional template */

const __vue_is_functional_template__$3o = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3o = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3o,
  staticRenderFns: __vue_staticRenderFns__$3o
}, __vue_inject_styles__$3o, __vue_script__$3o, __vue_scope_id__$3o, __vue_is_functional_template__$3o, __vue_module_identifier__$3o, false, undefined, undefined, undefined);

var script$3p = Vue.extend({
  name: "PhCellSignalNone",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3p = script$3p;
/* template */

var __vue_render__$3p = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,43.31371V208a8,8,0,0,1-8,8H27.31371a8,8,0,0,1-5.65686-13.65685l164.6863-164.6863A8,8,0,0,1,200,43.31371Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,43.31371V208a8,8,0,0,1-8,8H27.31371a8,8,0,0,1-5.65686-13.65685l164.6863-164.6863A8,8,0,0,1,200,43.31371Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M192,224H27.31348A15.9994,15.9994,0,0,1,16.001,196.686L180.68555,32A16.00046,16.00046,0,0,1,208,43.31372V208A16.01825,16.01825,0,0,1,192,224ZM27.31934,207.99512,192,208V43.32031L27.31445,208Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,43.31371V208a8,8,0,0,1-8,8H27.31371a8,8,0,0,1-5.65686-13.65685l164.6863-164.6863A8,8,0,0,1,200,43.31371Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,43.31371V208a8,8,0,0,1-8,8H27.31371a8,8,0,0,1-5.65686-13.65685l164.6863-164.6863A8,8,0,0,1,200,43.31371Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,43.31371V208a8,8,0,0,1-8,8H27.31371a8,8,0,0,1-5.65686-13.65685l164.6863-164.6863A8,8,0,0,1,200,43.31371Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3p = [];
/* style */

const __vue_inject_styles__$3p = undefined;
/* scoped */

const __vue_scope_id__$3p = undefined;
/* module identifier */

const __vue_module_identifier__$3p = undefined;
/* functional template */

const __vue_is_functional_template__$3p = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3p = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3p,
  staticRenderFns: __vue_staticRenderFns__$3p
}, __vue_inject_styles__$3p, __vue_script__$3p, __vue_scope_id__$3p, __vue_is_functional_template__$3p, __vue_module_identifier__$3p, false, undefined, undefined, undefined);

var script$3q = Vue.extend({
  name: "PhCellSignalSlash",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3q = script$3q;
/* template */

var __vue_render__$3q = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "47.99463",
      "y1": "40.00842",
      "x2": "207.99463",
      "y2": "216.00842",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M207.99463,216.00842,27.31371,216a8,8,0,0,1-5.65686-13.65685l91.09823-91.09823",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M141.07158,82.92842l45.27157-45.27157A8,8,0,0,1,200,43.31371v104.436",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M199.99414,43.32213V208.00842a8,8,0,0,1-8,8H27.30785A8,8,0,0,1,21.651,202.35157L186.33729,37.66528A8,8,0,0,1,199.99414,43.32213Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M135.40815,88.59185l50.935-50.935A8,8,0,0,1,200,43.31371V159.64292",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "47.99463",
      "y1": "40.00842",
      "x2": "207.99463",
      "y2": "216.00842",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M207.99463,216H27.31371a8,8,0,0,1-5.65686-13.65685l91.09823-91.09823",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M194.08057,165.025A8.00011,8.00011,0,0,0,208,159.64319V43.31409a15.99974,15.99974,0,0,0-27.31348-11.31446L129.75146,82.9342a7.99987,7.99987,0,0,0-.26269,11.03809Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M214.2179,221.02112c.13305-.16455.25988-.33252.37805-.50537.02783-.04053.054-.082.08105-.12354.113-.17187.22034-.34619.31885-.52441.03027-.05469.05786-.11084.08691-.16651.08765-.16845.17139-.33838.24634-.51123.03333-.07666.063-.15478.094-.23242.06225-.15723.12182-.31494.17382-.4751.032-.09814.05957-.19775.08777-.29736.04138-.147.08093-.29395.11377-.44238.02478-.11133.0448-.22364.06494-.33643.02552-.144.04871-.28857.06629-.43408.01416-.11621.02441-.23291.03344-.35059.01136-.14648.01917-.29345.02234-.44043.00135-.061.00916-.12011.00916-.18164s-.00781-.12109-.00928-.18213c-.00317-.13818-.0105-.27587-.02075-.41406-.01-.13428-.022-.26806-.03857-.40039-.01465-.1167-.03321-.23193-.053-.34766-.02539-.1499-.053-.29834-.08655-.44531-.02222-.09668-.04822-.19189-.0741-.28808-.04321-.16065-.08886-.31983-.1416-.47657-.02759-.082-.05884-.16308-.08935-.24414-.06226-.1665-.12745-.33056-.2002-.49121-.032-.0708-.06689-.14013-.10107-.21-.08277-.16943-.16968-.33642-.26392-.49951-.03345-.05762-.06909-.11426-.10425-.17139-.10644-.17383-.21826-.34326-.33716-.50781-.03247-.04443-.06579-.08838-.09912-.13232q-.19886-.26369-.41784-.50928c-.01551-.01709-.0282-.03613-.04383-.05322l-160-176A8.00024,8.00024,0,1,0,42.0752,45.39026l59.62866,65.59179L16,196.68616a15.99962,15.99962,0,0,0,11.31348,27.31347H207.82361c.058.00147.1156.00879.17346.00879a7.98959,7.98959,0,0,0,3.10938-.63672l.00537-.00244q.34863-.14721.68505-.33008l.02356-.01269q.31842-.17358.62342-.37891l.04736-.03174q.28491-.19482.55615-.416l.06983-.05762c.08593-.07226.175-.13769.25879-.21387.07837-.07129.14648-.14892.22143-.22265.03711-.03662.07349-.07324.10987-.11084.14733-.15039.28808-.3042.42114-.46338C214.15894,221.09534,214.18811,221.05823,214.2179,221.02112Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "47.99463",
      "y1": "40.00842",
      "x2": "207.99463",
      "y2": "216.00842",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M135.40815,88.59185l50.935-50.935A8,8,0,0,1,200,43.31371V159.64292",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M207.99463,216.00842,27.31371,216a8,8,0,0,1-5.65686-13.65685l91.09823-91.09823",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "47.99463",
      "y1": "40.00842",
      "x2": "207.99463",
      "y2": "216.00842",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M135.40815,88.59185l50.935-50.935A8,8,0,0,1,200,43.31371V159.64292",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M207.99463,216.00842,27.31371,216a8,8,0,0,1-5.65686-13.65685l91.09823-91.09823",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "47.99463",
      "y1": "40.00842",
      "x2": "207.99463",
      "y2": "216.00842",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M135.40815,88.59185l50.935-50.935A8,8,0,0,1,200,43.31371V159.64292",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M207.99463,216.00842,27.31371,216a8,8,0,0,1-5.65686-13.65685l91.09823-91.09823",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3q = [];
/* style */

const __vue_inject_styles__$3q = undefined;
/* scoped */

const __vue_scope_id__$3q = undefined;
/* module identifier */

const __vue_module_identifier__$3q = undefined;
/* functional template */

const __vue_is_functional_template__$3q = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3q = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3q,
  staticRenderFns: __vue_staticRenderFns__$3q
}, __vue_inject_styles__$3q, __vue_script__$3q, __vue_scope_id__$3q, __vue_is_functional_template__$3q, __vue_module_identifier__$3q, false, undefined, undefined, undefined);

var script$3r = Vue.extend({
  name: "PhCellSignalX",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3r = script$3r;
/* template */

var __vue_render__$3r = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "224",
      "y1": "104",
      "x2": "176",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "152",
      "x2": "176",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,183.99507V208a8,8,0,0,1-8,8H27.31371a8,8,0,0,1-5.65686-13.65685l164.6863-164.6863A8,8,0,0,1,200,43.31371V72.00485",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,43.31371V208a8,8,0,0,1-8,8H27.31371a8,8,0,0,1-5.65686-13.65685l164.6863-164.6863A8,8,0,0,1,200,43.31371Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "104",
      "x2": "176",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "152",
      "x2": "176",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,173.2544V208a8,8,0,0,1-8,8H27.31371a8,8,0,0,1-5.65686-13.65685l164.6863-164.6863A8,8,0,0,1,200,43.31371V82.74556",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M211.314,128l18.34278-18.34277a8.00018,8.00018,0,1,0-11.31348-11.31446L200,116.686,181.65674,98.34277a8.00018,8.00018,0,0,0-11.31348,11.31446L188.686,128l-18.34278,18.34277a8.00018,8.00018,0,0,0,11.31348,11.31446L200,139.314l18.34326,18.34327a8.00018,8.00018,0,0,0,11.31348-11.31446Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,161.94141l-7.0293,7.02929a24.00019,24.00019,0,0,1-33.9414-33.9414L166.05859,128l-7.02929-7.0293a24.00019,24.00019,0,0,1,33.9414-33.9414L200,94.05859l7.0293-7.02929c.312-.312.64624-.58594.9707-.87744V43.31348A15.99974,15.99974,0,0,0,180.68652,32L15.99951,196.68652A16.00018,16.00018,0,0,0,27.31348,224H192a16.01833,16.01833,0,0,0,16-16V169.84814c-.32446-.2915-.65869-.56543-.9707-.87744Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "224",
      "y1": "104",
      "x2": "176",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "152",
      "x2": "176",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,173.2544V208a8,8,0,0,1-8,8H27.31371a8,8,0,0,1-5.65686-13.65685l164.6863-164.6863A8,8,0,0,1,200,43.31371V82.74556",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "224",
      "y1": "104",
      "x2": "176",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "152",
      "x2": "176",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,173.2544V208a8,8,0,0,1-8,8H27.31371a8,8,0,0,1-5.65686-13.65685l164.6863-164.6863A8,8,0,0,1,200,43.31371V82.74556",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "224",
      "y1": "104",
      "x2": "176",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "152",
      "x2": "176",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,173.2544V208a8,8,0,0,1-8,8H27.31371a8,8,0,0,1-5.65686-13.65685l164.6863-164.6863A8,8,0,0,1,200,43.31371V82.74556",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3r = [];
/* style */

const __vue_inject_styles__$3r = undefined;
/* scoped */

const __vue_scope_id__$3r = undefined;
/* module identifier */

const __vue_module_identifier__$3r = undefined;
/* functional template */

const __vue_is_functional_template__$3r = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3r = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3r,
  staticRenderFns: __vue_staticRenderFns__$3r
}, __vue_inject_styles__$3r, __vue_script__$3r, __vue_scope_id__$3r, __vue_is_functional_template__$3r, __vue_module_identifier__$3r, false, undefined, undefined, undefined);

var script$3s = Vue.extend({
  name: "PhChalkboard",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3s = script$3s;
/* template */

var __vue_render__$3s = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,200V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "200",
      "x2": "240",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "120 200 120 160 184 160 184 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "72 200 72 88 184 88 184 120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "120 168 192 168 192 80 64 80 64 200 120 200 120 168",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,200V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "200",
      "x2": "240",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "120 200 120 168 192 168 192 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 200 64 80 192 80 192 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M240,192h-8V56a16.01833,16.01833,0,0,0-16-16H40A16.01833,16.01833,0,0,0,24,56V192H16a8,8,0,0,0,0,16H240a8,8,0,0,0,0-16Zm-24,0H144V176a7.99993,7.99993,0,0,1,8-8h56a7.99993,7.99993,0,0,1,8,8Zm0-48a8,8,0,0,1-16,0V72H56V184a8,8,0,0,1-16,0V64a8.00008,8.00008,0,0,1,8-8H208a8.00008,8.00008,0,0,1,8,8Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,200V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "200",
      "x2": "240",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "120 200 120 168 192 168 192 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 200 64 80 192 80 192 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,200V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "200",
      "x2": "240",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "120 200 120 168 192 168 192 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 200 64 80 192 80 192 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,200V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "200",
      "x2": "240",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "120 200 120 168 192 168 192 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 200 64 80 192 80 192 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3s = [];
/* style */

const __vue_inject_styles__$3s = undefined;
/* scoped */

const __vue_scope_id__$3s = undefined;
/* module identifier */

const __vue_module_identifier__$3s = undefined;
/* functional template */

const __vue_is_functional_template__$3s = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3s = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3s,
  staticRenderFns: __vue_staticRenderFns__$3s
}, __vue_inject_styles__$3s, __vue_script__$3s, __vue_scope_id__$3s, __vue_is_functional_template__$3s, __vue_module_identifier__$3s, false, undefined, undefined, undefined);

var script$3t = Vue.extend({
  name: "PhChalkboardSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3t = script$3t;
/* template */

var __vue_render__$3t = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,160V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "200",
      "x2": "240",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "120 200 120 160 184 160 184 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "120",
      "y": "168",
      "width": "64",
      "height": "32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,168V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "200",
      "x2": "240",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "120 200 120 168 184 168 184 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M240,192h-8V56a16.01833,16.01833,0,0,0-16-16H40A16.01833,16.01833,0,0,0,24,56V192H16a8,8,0,0,0,0,16H240a8,8,0,0,0,0-16Zm-40,0H128V176a7.99993,7.99993,0,0,1,8-8h56a7.99993,7.99993,0,0,1,8,8Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,168V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "200",
      "x2": "240",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "120 200 120 168 184 168 184 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,168V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "200",
      "x2": "240",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "120 200 120 168 184 168 184 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,168V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "200",
      "x2": "240",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "120 200 120 168 184 168 184 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3t = [];
/* style */

const __vue_inject_styles__$3t = undefined;
/* scoped */

const __vue_scope_id__$3t = undefined;
/* module identifier */

const __vue_module_identifier__$3t = undefined;
/* functional template */

const __vue_is_functional_template__$3t = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3t = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3t,
  staticRenderFns: __vue_staticRenderFns__$3t
}, __vue_inject_styles__$3t, __vue_script__$3t, __vue_scope_id__$3t, __vue_is_functional_template__$3t, __vue_module_identifier__$3t, false, undefined, undefined, undefined);

var script$3u = Vue.extend({
  name: "PhChalkboardTeacher",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3u = script$3u;
/* template */

var __vue_render__$3u = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "104",
      "cy": "148",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "188 172 188 84 68 84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M149.26463,207.99877,215.99985,208A8,8,0,0,0,224,200V56a8,8,0,0,0-8-8H40a8,8,0,0,0-8,8V200.00015a8,8,0,0,0,8.00059,8l18.73446-.00139-.00295-.001a48.01963,48.01963,0,0,1,90.53578-.00006Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "104",
      "cy": "144",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,144a32,32,0,1,1,32,32h88V80H64v64Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M53.38964,207.99876a56.02294,56.02294,0,0,1,101.22072,0L215.99984,208A8,8,0,0,0,224,200V56a8,8,0,0,0-8-8H40a8,8,0,0,0-8,8V200.00074A7.99926,7.99926,0,0,0,40,208Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176 176 192 176 192 80 64 80 64 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,40H40A16.01833,16.01833,0,0,0,24,56V200.001A15.99912,15.99912,0,0,0,40.001,216l13.38965-.00146a7.99978,7.99978,0,0,0,7.2246-4.5669,48.02362,48.02362,0,0,1,86.76954,0,7.99952,7.99952,0,0,0,7.22558,4.5669L216,216a16.01833,16.01833,0,0,0,16-16V56A16.01833,16.01833,0,0,0,216,40ZM104,168a32,32,0,1,1,32-32A32.03667,32.03667,0,0,1,104,168Zm112,32-56.56641-.00146A63.89863,63.89863,0,0,0,146.26563,184H192a8.00008,8.00008,0,0,0,8-8V80a8.00008,8.00008,0,0,0-8-8H64a8.00008,8.00008,0,0,0-8,8v96a7.99618,7.99618,0,0,0,6.02881,7.74518,63.91387,63.91387,0,0,0-13.4624,16.25433L40,200.001V56H216Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "104",
      "cy": "144",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M53.38964,207.99876a56.02294,56.02294,0,0,1,101.22072,0L215.99984,208A8,8,0,0,0,224,200V56a8,8,0,0,0-8-8H40a8,8,0,0,0-8,8V200.00074A7.99926,7.99926,0,0,0,40,208Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176 176 192 176 192 80 64 80 64 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "104",
      "cy": "144",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M53.38964,207.99876a56.02294,56.02294,0,0,1,101.22072,0L215.99984,208A8,8,0,0,0,224,200V56a8,8,0,0,0-8-8H40a8,8,0,0,0-8,8V200.00074A7.99926,7.99926,0,0,0,40,208Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176 176 192 176 192 80 64 80 64 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "104",
      "cy": "144",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M53.38964,207.99876a56.02294,56.02294,0,0,1,101.22072,0L215.99984,208A8,8,0,0,0,224,200V56a8,8,0,0,0-8-8H40a8,8,0,0,0-8,8V200.00074A7.99926,7.99926,0,0,0,40,208Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176 176 192 176 192 80 64 80 64 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3u = [];
/* style */

const __vue_inject_styles__$3u = undefined;
/* scoped */

const __vue_scope_id__$3u = undefined;
/* module identifier */

const __vue_module_identifier__$3u = undefined;
/* functional template */

const __vue_is_functional_template__$3u = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3u = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3u,
  staticRenderFns: __vue_staticRenderFns__$3u
}, __vue_inject_styles__$3u, __vue_script__$3u, __vue_scope_id__$3u, __vue_is_functional_template__$3u, __vue_module_identifier__$3u, false, undefined, undefined, undefined);

var script$3v = Vue.extend({
  name: "PhChartBar",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3v = script$3v;
/* template */

var __vue_render__$3v = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "228",
      "y1": "208",
      "x2": "28",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "100 208 100 88 156 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "156",
      "y": "40",
      "width": "56",
      "height": "168",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "44 208 44 136 100 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "156",
      "y": "40",
      "width": "56",
      "height": "168",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "228",
      "y1": "208",
      "x2": "28",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "100 208 100 88 156 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "156",
      "y": "40",
      "width": "56",
      "height": "168",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "44 208 44 136 100 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M228,200h-8V40a8.00008,8.00008,0,0,0-8-8H156a8.00008,8.00008,0,0,0-8,8V80H100a8.00008,8.00008,0,0,0-8,8v40H44a8.00008,8.00008,0,0,0-8,8v64H28a8,8,0,0,0,0,16H228a8,8,0,0,0,0-16ZM108,96h40V200H108ZM52,144H92v56H52Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "228",
      "y1": "208",
      "x2": "28",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "100 208 100 88 156 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "156",
      "y": "40",
      "width": "56",
      "height": "168",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "44 208 44 136 100 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "228",
      "y1": "208",
      "x2": "28",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "100 208 100 88 156 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "156",
      "y": "40",
      "width": "56",
      "height": "168",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "44 208 44 136 100 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "44 208 44 136 100 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "228",
      "y1": "208",
      "x2": "28",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "100 208 100 88 156 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "156",
      "y": "40",
      "width": "56",
      "height": "168",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3v = [];
/* style */

const __vue_inject_styles__$3v = undefined;
/* scoped */

const __vue_scope_id__$3v = undefined;
/* module identifier */

const __vue_module_identifier__$3v = undefined;
/* functional template */

const __vue_is_functional_template__$3v = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3v = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3v,
  staticRenderFns: __vue_staticRenderFns__$3v
}, __vue_inject_styles__$3v, __vue_script__$3v, __vue_scope_id__$3v, __vue_is_functional_template__$3v, __vue_module_identifier__$3v, false, undefined, undefined, undefined);

var script$3w = Vue.extend({
  name: "PhChartBarHorizontal",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3w = script$3w;
/* template */

var __vue_render__$3w = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "216",
      "x2": "40",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "40 56 168 56 168 104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "104",
      "width": "176",
      "height": "48",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "136 152 136 200 40 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "104",
      "width": "176",
      "height": "48",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "216",
      "x2": "40",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "40 56 168 56 168 104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "104",
      "width": "176",
      "height": "48",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "136 152 136 200 40 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,96H176V56a7.99977,7.99977,0,0,0-8-8H48V40a8,8,0,0,0-16,0V216a8,8,0,0,0,16,0v-8h88a7.99977,7.99977,0,0,0,8-8V160h72a7.99977,7.99977,0,0,0,8-8V104A7.99977,7.99977,0,0,0,216,96ZM160,64V96H48V64ZM128,192H48V160h80Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "216",
      "x2": "40",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "40 56 168 56 168 104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "104",
      "width": "176",
      "height": "48",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "136 152 136 200 40 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "216",
      "x2": "40",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "40 56 168 56 168 104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "104",
      "width": "176",
      "height": "48",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "136 152 136 200 40 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "216",
      "x2": "40",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "40 56 168 56 168 104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "104",
      "width": "176",
      "height": "48",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "136 152 136 200 40 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3w = [];
/* style */

const __vue_inject_styles__$3w = undefined;
/* scoped */

const __vue_scope_id__$3w = undefined;
/* module identifier */

const __vue_module_identifier__$3w = undefined;
/* functional template */

const __vue_is_functional_template__$3w = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3w = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3w,
  staticRenderFns: __vue_staticRenderFns__$3w
}, __vue_inject_styles__$3w, __vue_script__$3w, __vue_scope_id__$3w, __vue_is_functional_template__$3w, __vue_module_identifier__$3w, false, undefined, undefined, undefined);

var script$3x = Vue.extend({
  name: "PhChartLine",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3x = script$3x;
/* template */

var __vue_render__$3x = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "224 208 32 208 32 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "224.002 96 160.002 152 96.002 104 32.002 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "224 208 32 208 32 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "224.002 96 160.002 152 96.002 104 32.002 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M223.99951,200h-184V163.63232L96.39014,114.291l58.8125,44.10888a7.99913,7.99913,0,0,0,10.06738-.37939l64-56a7.99962,7.99962,0,1,0-10.53516-12.041L159.61475,141.709,100.80225,97.6001a7.99909,7.99909,0,0,0-10.06739.37939L39.99951,142.37305V48a8,8,0,0,0-16,0V208a8.00039,8.00039,0,0,0,8,8h192a8,8,0,0,0,0-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "224 208 32 208 32 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "224.002 96 160.002 152 96.002 104 32.002 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "224 208 32 208 32 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "224.002 96 160.002 152 96.002 104 32.002 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "224 208 32 208 32 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "224.002 96 160.002 152 96.002 104 32.002 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3x = [];
/* style */

const __vue_inject_styles__$3x = undefined;
/* scoped */

const __vue_scope_id__$3x = undefined;
/* module identifier */

const __vue_module_identifier__$3x = undefined;
/* functional template */

const __vue_is_functional_template__$3x = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3x = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3x,
  staticRenderFns: __vue_staticRenderFns__$3x
}, __vue_inject_styles__$3x, __vue_script__$3x, __vue_scope_id__$3x, __vue_is_functional_template__$3x, __vue_module_identifier__$3x, false, undefined, undefined, undefined);

var script$3y = Vue.extend({
  name: "PhChartLineUp",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3y = script$3y;
/* template */

var __vue_render__$3y = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "224 208 32 208 32 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208.002 64 128.002 144 96.002 112 32.002 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208.002 104 208.002 64 168.002 64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "224 208 32 208 32 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208.002 64 128.002 144 96.002 112 32.002 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208.002 104 208.002 64 168.002 64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M231.99951,208a8.00039,8.00039,0,0,1-8,8h-192a8.00039,8.00039,0,0,1-8-8V48a8,8,0,0,1,16,0V156.68848l50.3457-50.34571a8.00122,8.00122,0,0,1,11.31446,0l26.34277,26.34375L176.68848,84,162.34521,69.65674A8.00038,8.00038,0,0,1,168.00244,56h40a8.00039,8.00039,0,0,1,8,8v40a8.00018,8.00018,0,0,1-13.65723,5.65674L188.00244,95.314l-54.34277,54.34327a8.00122,8.00122,0,0,1-11.31446,0L96.00244,123.31348l-56.00293,56.0039V200h184A8.00039,8.00039,0,0,1,231.99951,208Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "224 208 32 208 32 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208.002 64 128.002 144 96.002 112 32.002 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208.002 104 208.002 64 168.002 64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "224 208 32 208 32 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208.002 64 128.002 144 96.002 112 32.002 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208.002 104 208.002 64 168.002 64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "224 208 32 208 32 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208.002 64 128.002 144 96.002 112 32.002 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208.002 104 208.002 64 168.002 64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3y = [];
/* style */

const __vue_inject_styles__$3y = undefined;
/* scoped */

const __vue_scope_id__$3y = undefined;
/* module identifier */

const __vue_module_identifier__$3y = undefined;
/* functional template */

const __vue_is_functional_template__$3y = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3y = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3y,
  staticRenderFns: __vue_staticRenderFns__$3y
}, __vue_inject_styles__$3y, __vue_script__$3y, __vue_scope_id__$3y, __vue_is_functional_template__$3y, __vue_module_identifier__$3y, false, undefined, undefined, undefined);

var script$3z = Vue.extend({
  name: "PhChartPie",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3z = script$3z;
/* template */

var __vue_render__$3z = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "211.13844",
      "y1": "80",
      "x2": "44.86156",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,128,44.86156,176l-.01368.00827A96.02522,96.02522,0,0,1,128,32Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "211.13844",
      "y1": "80",
      "x2": "44.86156",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M218.27124,76.39893c-.06738-.13331-.12878-.26807-.20435-.39893-.102-.17676-.21545-.34229-.32849-.50781A103.97483,103.97483,0,0,0,37.72876,179.60107c.06738.1333.12878.26807.20435.39893.07153.124.15856.23242.23559.35107A103.97546,103.97546,0,0,0,218.27124,76.39893Zm-18.40454.87158L136,114.14355V40.36768A88.02766,88.02766,0,0,1,199.8667,77.27051ZM128,216a87.95493,87.95493,0,0,1-71.8667-37.27051L207.88574,91.11572A87.9798,87.9798,0,0,1,128,216Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "211.13844",
      "y1": "80",
      "x2": "44.86156",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "211.13844",
      "y1": "80",
      "x2": "44.86156",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "211.13844",
      "y1": "80",
      "x2": "44.86156",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3z = [];
/* style */

const __vue_inject_styles__$3z = undefined;
/* scoped */

const __vue_scope_id__$3z = undefined;
/* module identifier */

const __vue_module_identifier__$3z = undefined;
/* functional template */

const __vue_is_functional_template__$3z = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3z = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3z,
  staticRenderFns: __vue_staticRenderFns__$3z
}, __vue_inject_styles__$3z, __vue_script__$3z, __vue_scope_id__$3z, __vue_is_functional_template__$3z, __vue_module_identifier__$3z, false, undefined, undefined, undefined);

var script$3A = Vue.extend({
  name: "PhChartPieSlice",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3A = script$3A;
/* template */

var __vue_render__$3A = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "211.13844",
      "y1": "80",
      "x2": "44.86156",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,32A96,96,0,1,1,45.21664,176.64005",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M87.99413,106.14643,32.532,138.16712A97.09884,97.09884,0,0,1,32,128,96.0159,96.0159,0,0,1,87.99362,40.7076Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M33.60061,145.5506A96.15147,96.15147,0,0,1,95.99845,37.46313V109.5252Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "211.13844",
      "y1": "80",
      "x2": "44.86156",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M33.60061,145.5506A96.15147,96.15147,0,0,1,95.99845,37.46313V109.5252Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,32A96,96,0,1,1,45.21664,176.64005",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M99.99854,116.45312a7.99932,7.99932,0,0,0,4-6.92773V37.46289a8.00029,8.00029,0,0,0-10.666-7.54248,104.15035,104.15035,0,0,0-67.59863,117.0835,7.99907,7.99907,0,0,0,11.8667,5.47461Zm-12-66.86328v55.31641L40.11621,132.55078Q40.00048,130.27881,40,128A88.20107,88.20107,0,0,1,87.99854,49.58984Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M218.27124,76.39893c-.06738-.13331-.12878-.26807-.20435-.39893-.102-.17676-.21545-.34229-.32849-.50781A104.0515,104.0515,0,0,0,128,24a8.00008,8.00008,0,0,0-8,8v91.38135L40.86133,169.07178A8.00042,8.00042,0,0,0,37.93311,180c.03369.05811.07592.10791.11084.165.08837.17969.17614.35889.27929.53418A104.0111,104.0111,0,0,0,232,128,103.36465,103.36465,0,0,0,218.27124,76.39893Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "211.13844",
      "y1": "80",
      "x2": "44.86156",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M33.60061,145.5506A96.15147,96.15147,0,0,1,95.99845,37.46313V109.5252Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,32A96,96,0,1,1,45.21664,176.64005",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "211.13844",
      "y1": "80",
      "x2": "44.86156",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M33.60061,145.5506A96.15147,96.15147,0,0,1,95.99845,37.46313V109.5252Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,32A96,96,0,1,1,45.21664,176.64005",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "211.13844",
      "y1": "80",
      "x2": "44.86156",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M33.60061,145.5506A96.15147,96.15147,0,0,1,95.99845,37.46313V109.5252Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,32A96,96,0,1,1,45.21664,176.64005",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3A = [];
/* style */

const __vue_inject_styles__$3A = undefined;
/* scoped */

const __vue_scope_id__$3A = undefined;
/* module identifier */

const __vue_module_identifier__$3A = undefined;
/* functional template */

const __vue_is_functional_template__$3A = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3A = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3A,
  staticRenderFns: __vue_staticRenderFns__$3A
}, __vue_inject_styles__$3A, __vue_script__$3A, __vue_scope_id__$3A, __vue_is_functional_template__$3A, __vue_module_identifier__$3A, false, undefined, undefined, undefined);

var script$3B = Vue.extend({
  name: "PhChat",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3B = script$3B;
/* template */

var __vue_render__$3B = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M77.35142,201.87677l-32.2031,27.07116a8,8,0,0,1-13.14783-6.12372V64.00049a8,8,0,0,1,8-8h176a8,8,0,0,1,8,8v128a8,8,0,0,1-8,8H82.49925A8,8,0,0,0,77.35142,201.87677Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M77.98509,201.34409,45.14832,228.94793a8,8,0,0,1-13.14783-6.12372V64.00049a8,8,0,0,1,8-8h176a8,8,0,0,1,8,8v128a8,8,0,0,1-8,8H81.67142Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M77.35142,201.87677l-32.2031,27.07116a8,8,0,0,1-13.14783-6.12372V64.00049a8,8,0,0,1,8-8h176a8,8,0,0,1,8,8v128a8,8,0,0,1-8,8H82.49925A8,8,0,0,0,77.35142,201.87677Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216.002,48.00293h-176a16.02085,16.02085,0,0,0-16,16V222.82324a15.8614,15.8614,0,0,0,9.25,14.50781,16.11258,16.11258,0,0,0,6.79688,1.51563,15.86968,15.86968,0,0,0,10.25-3.77344l31.75-26.69531,133.95312-.375a16.02084,16.02084,0,0,0,16-16v-128A16.02084,16.02084,0,0,0,216.002,48.00293Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M77.35142,201.87677l-32.2031,27.07116a8,8,0,0,1-13.14783-6.12372V64.00049a8,8,0,0,1,8-8h176a8,8,0,0,1,8,8v128a8,8,0,0,1-8,8H82.49925A8,8,0,0,0,77.35142,201.87677Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M77.35142,201.87677l-32.2031,27.07116a8,8,0,0,1-13.14783-6.12372V64.00049a8,8,0,0,1,8-8h176a8,8,0,0,1,8,8v128a8,8,0,0,1-8,8H82.49925A8,8,0,0,0,77.35142,201.87677Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M77.35142,201.87677l-32.2031,27.07116a8,8,0,0,1-13.14783-6.12372V64.00049a8,8,0,0,1,8-8h176a8,8,0,0,1,8,8v128a8,8,0,0,1-8,8H82.49925A8,8,0,0,0,77.35142,201.87677Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3B = [];
/* style */

const __vue_inject_styles__$3B = undefined;
/* scoped */

const __vue_scope_id__$3B = undefined;
/* module identifier */

const __vue_module_identifier__$3B = undefined;
/* functional template */

const __vue_is_functional_template__$3B = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3B = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3B,
  staticRenderFns: __vue_staticRenderFns__$3B
}, __vue_inject_styles__$3B, __vue_script__$3B, __vue_scope_id__$3B, __vue_is_functional_template__$3B, __vue_module_identifier__$3B, false, undefined, undefined, undefined);

var script$3C = Vue.extend({
  name: "PhChatCentered",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3C = script$3C;
/* template */

var __vue_render__$3C = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M149.66907,195.88358l-14.80961,24.68269a8,8,0,0,1-13.71989,0l-14.80964-24.68272a8,8,0,0,0-6.85994-3.884H39.99951a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8h176a8,8,0,0,1,8,8V184a8,8,0,0,1-8,8l-59.47039-.00041A8,8,0,0,0,149.66907,195.88358Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M149.66907,195.88358l-14.80961,24.68269a8,8,0,0,1-13.71989,0l-14.80964-24.68272a8,8,0,0,0-6.85994-3.884H39.99951a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8h176a8,8,0,0,1,8,8V184a8,8,0,0,1-8,8l-59.47039-.00041A8,8,0,0,0,149.66907,195.88358Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M149.66907,195.88358l-14.80961,24.68269a8,8,0,0,1-13.71989,0l-14.80964-24.68272a8,8,0,0,0-6.85994-3.884H39.99951a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8h176a8,8,0,0,1,8,8V184a8,8,0,0,1-8,8l-59.47039-.00041A8,8,0,0,0,149.66907,195.88358Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,40H40A16.01833,16.01833,0,0,0,24,56V183.999a16.01833,16.01833,0,0,0,16,16L99.46973,200l14.81054,24.68262a16.00024,16.00024,0,0,0,27.43946,0L156.5293,200H215.999A16.01853,16.01853,0,0,0,232,184V56A16.01833,16.01833,0,0,0,216,40Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M149.66907,195.88358l-14.80961,24.68269a8,8,0,0,1-13.71989,0l-14.80964-24.68272a8,8,0,0,0-6.85994-3.884H39.99951a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8h176a8,8,0,0,1,8,8V184a8,8,0,0,1-8,8l-59.47039-.00041A8,8,0,0,0,149.66907,195.88358Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M149.66907,195.88358l-14.80961,24.68269a8,8,0,0,1-13.71989,0l-14.80964-24.68272a8,8,0,0,0-6.85994-3.884H39.99951a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8h176a8,8,0,0,1,8,8V184a8,8,0,0,1-8,8l-59.47039-.00041A8,8,0,0,0,149.66907,195.88358Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M149.66907,195.88358l-14.80961,24.68269a8,8,0,0,1-13.71989,0l-14.80964-24.68272a8,8,0,0,0-6.85994-3.884H39.99951a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8h176a8,8,0,0,1,8,8V184a8,8,0,0,1-8,8l-59.47039-.00041A8,8,0,0,0,149.66907,195.88358Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3C = [];
/* style */

const __vue_inject_styles__$3C = undefined;
/* scoped */

const __vue_scope_id__$3C = undefined;
/* module identifier */

const __vue_module_identifier__$3C = undefined;
/* functional template */

const __vue_is_functional_template__$3C = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3C = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3C,
  staticRenderFns: __vue_staticRenderFns__$3C
}, __vue_inject_styles__$3C, __vue_script__$3C, __vue_scope_id__$3C, __vue_is_functional_template__$3C, __vue_module_identifier__$3C, false, undefined, undefined, undefined);

var script$3D = Vue.extend({
  name: "PhChatCenteredDots",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3D = script$3D;
/* template */

var __vue_render__$3D = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M149.67005,195.88358l-14.80962,24.68269a8,8,0,0,1-13.71989,0l-14.80963-24.68272a8,8,0,0,0-6.85994-3.884H40.00049a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8h176a8,8,0,0,1,8,8V184a8,8,0,0,1-8.00006,8l-59.47038-.00041A8,8,0,0,0,149.67005,195.88358Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "99.99365",
      "cy": "120.00195",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "155.99365",
      "cy": "120.00195",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M149.67005,195.88358l-14.80962,24.68269a8,8,0,0,1-13.71989,0l-14.80963-24.68272a8,8,0,0,0-6.85994-3.884H40.00049a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8h176a8,8,0,0,1,8,8V184a8,8,0,0,1-8.00006,8l-59.47038-.00041A8,8,0,0,0,149.67005,195.88358Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M149.67005,195.88358l-14.80962,24.68269a8,8,0,0,1-13.71989,0l-14.80963-24.68272a8,8,0,0,0-6.85994-3.884H40.00049a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8h176a8,8,0,0,1,8,8V184a8,8,0,0,1-8.00006,8l-59.47038-.00041A8,8,0,0,0,149.67005,195.88358Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "80",
      "cy": "120",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "120",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216.001,40h-176a16.01833,16.01833,0,0,0-16,16V183.999a16.01833,16.01833,0,0,0,16,16L99.4707,200l14.81055,24.68262a16.00023,16.00023,0,0,0,27.43945,0L156.53027,200H216a16.01854,16.01854,0,0,0,16.001-16V56A16.01833,16.01833,0,0,0,216.001,40ZM80.00049,132.00049a12,12,0,1,1,12-12A12,12,0,0,1,80.00049,132.00049Zm48,0a12,12,0,1,1,12-12A12,12,0,0,1,128.00049,132.00049Zm48,0a12,12,0,1,1,12-12A12,12,0,0,1,176.00049,132.00049Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M149.67005,195.88358l-14.80962,24.68269a8,8,0,0,1-13.71989,0l-14.80963-24.68272a8,8,0,0,0-6.85994-3.884H40.00049a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8h176a8,8,0,0,1,8,8V184a8,8,0,0,1-8.00006,8l-59.47038-.00041A8,8,0,0,0,149.67005,195.88358Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "120",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "80",
      "cy": "120",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M149.67005,195.88358l-14.80962,24.68269a8,8,0,0,1-13.71989,0l-14.80963-24.68272a8,8,0,0,0-6.85994-3.884H40.00049a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8h176a8,8,0,0,1,8,8V184a8,8,0,0,1-8.00006,8l-59.47038-.00041A8,8,0,0,0,149.67005,195.88358Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "80",
      "cy": "120",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "120",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M149.67005,195.88358l-14.80962,24.68269a8,8,0,0,1-13.71989,0l-14.80963-24.68272a8,8,0,0,0-6.85994-3.884H40.00049a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8h176a8,8,0,0,1,8,8V184a8,8,0,0,1-8.00006,8l-59.47038-.00041A8,8,0,0,0,149.67005,195.88358Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "80",
      "cy": "120",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "120",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3D = [];
/* style */

const __vue_inject_styles__$3D = undefined;
/* scoped */

const __vue_scope_id__$3D = undefined;
/* module identifier */

const __vue_module_identifier__$3D = undefined;
/* functional template */

const __vue_is_functional_template__$3D = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3D = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3D,
  staticRenderFns: __vue_staticRenderFns__$3D
}, __vue_inject_styles__$3D, __vue_script__$3D, __vue_scope_id__$3D, __vue_is_functional_template__$3D, __vue_module_identifier__$3D, false, undefined, undefined, undefined);

var script$3E = Vue.extend({
  name: "PhChatCenteredText",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3E = script$3E;
/* template */

var __vue_render__$3E = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96.00049",
      "y1": "99.99951",
      "x2": "160.00049",
      "y2": "99.99951",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96.00049",
      "y1": "139.99951",
      "x2": "160.00049",
      "y2": "139.99951",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M149.66907,195.88358l-14.80961,24.68269a8,8,0,0,1-13.71989,0l-14.80964-24.68272a8,8,0,0,0-6.85994-3.884H39.99951a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8h176a8,8,0,0,1,8,8V184a8,8,0,0,1-8,8l-59.47039-.00041A8,8,0,0,0,149.66907,195.88358Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M149.66907,195.88358l-14.80961,24.68269a8,8,0,0,1-13.71989,0l-14.80964-24.68272a8,8,0,0,0-6.85994-3.884H39.99951a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8h176a8,8,0,0,1,8,8V184a8,8,0,0,1-8,8l-59.47039-.00041A8,8,0,0,0,149.66907,195.88358Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96.00049",
      "y1": "103.99951",
      "x2": "160.00049",
      "y2": "103.99951",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96.00049",
      "y1": "135.99951",
      "x2": "160.00049",
      "y2": "135.99951",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M149.66907,195.88358l-14.80961,24.68269a8,8,0,0,1-13.71989,0l-14.80964-24.68272a8,8,0,0,0-6.85994-3.884H39.99951a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8h176a8,8,0,0,1,8,8V184a8,8,0,0,1-8,8l-59.47039-.00041A8,8,0,0,0,149.66907,195.88358Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,40H40A16.01833,16.01833,0,0,0,24,56V183.999a16.01833,16.01833,0,0,0,16,16L99.46973,200l14.81054,24.68262a16.00024,16.00024,0,0,0,27.43946,0L156.5293,200H215.999A16.01853,16.01853,0,0,0,232,184V56A16.01833,16.01833,0,0,0,216,40ZM160,143.999H96a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm0-32H96a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96.00049",
      "y1": "103.99951",
      "x2": "160.00049",
      "y2": "103.99951",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96.00049",
      "y1": "135.99951",
      "x2": "160.00049",
      "y2": "135.99951",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M149.66907,195.88358l-14.80961,24.68269a8,8,0,0,1-13.71989,0l-14.80964-24.68272a8,8,0,0,0-6.85994-3.884H39.99951a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8h176a8,8,0,0,1,8,8V184a8,8,0,0,1-8,8l-59.47039-.00041A8,8,0,0,0,149.66907,195.88358Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96.00049",
      "y1": "103.99951",
      "x2": "160.00049",
      "y2": "103.99951",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96.00049",
      "y1": "135.99951",
      "x2": "160.00049",
      "y2": "135.99951",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M149.66907,195.88358l-14.80961,24.68269a8,8,0,0,1-13.71989,0l-14.80964-24.68272a8,8,0,0,0-6.85994-3.884H39.99951a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8h176a8,8,0,0,1,8,8V184a8,8,0,0,1-8,8l-59.47039-.00041A8,8,0,0,0,149.66907,195.88358Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96.00049",
      "y1": "103.99951",
      "x2": "160.00049",
      "y2": "103.99951",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96.00049",
      "y1": "135.99951",
      "x2": "160.00049",
      "y2": "135.99951",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M149.66907,195.88358l-14.80961,24.68269a8,8,0,0,1-13.71989,0l-14.80964-24.68272a8,8,0,0,0-6.85994-3.884H39.99951a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8h176a8,8,0,0,1,8,8V184a8,8,0,0,1-8,8l-59.47039-.00041A8,8,0,0,0,149.66907,195.88358Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3E = [];
/* style */

const __vue_inject_styles__$3E = undefined;
/* scoped */

const __vue_scope_id__$3E = undefined;
/* module identifier */

const __vue_module_identifier__$3E = undefined;
/* functional template */

const __vue_is_functional_template__$3E = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3E = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3E,
  staticRenderFns: __vue_staticRenderFns__$3E
}, __vue_inject_styles__$3E, __vue_script__$3E, __vue_scope_id__$3E, __vue_is_functional_template__$3E, __vue_module_identifier__$3E, false, undefined, undefined, undefined);

var script$3F = Vue.extend({
  name: "PhChatCircle",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3F = script$3F;
/* template */

var __vue_render__$3F = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M45.42853,176.99811A95.95978,95.95978,0,1,1,79.00228,210.5717l.00023-.001L45.84594,220.044a8,8,0,0,1-9.89-9.89l9.47331-33.15657Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M45.42853,176.99811A95.95978,95.95978,0,1,1,79.00228,210.5717l.00023-.001L45.84594,220.044a8,8,0,0,1-9.89-9.89l9.47331-33.15657Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M45.42853,176.99811A95.95978,95.95978,0,1,1,79.00228,210.5717l.00023-.001L45.84594,220.044a8,8,0,0,1-9.89-9.89l9.47331-33.15657Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128.00146,24.002A104.02442,104.02442,0,0,0,36.814,178.041l-8.55468,29.91406a16.00544,16.00544,0,0,0,19.78125,19.78125l29.91406-8.54688A104.00785,104.00785,0,1,0,128.00146,24.002Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M45.42853,176.99811A95.95978,95.95978,0,1,1,79.00228,210.5717l.00023-.001L45.84594,220.044a8,8,0,0,1-9.89-9.89l9.47331-33.15657Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M45.42853,176.99811A95.95978,95.95978,0,1,1,79.00228,210.5717l.00023-.001L45.84594,220.044a8,8,0,0,1-9.89-9.89l9.47331-33.15657Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M45.42853,176.99811A95.95978,95.95978,0,1,1,79.00228,210.5717l.00023-.001L45.84594,220.044a8,8,0,0,1-9.89-9.89l9.47331-33.15657Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3F = [];
/* style */

const __vue_inject_styles__$3F = undefined;
/* scoped */

const __vue_scope_id__$3F = undefined;
/* module identifier */

const __vue_module_identifier__$3F = undefined;
/* functional template */

const __vue_is_functional_template__$3F = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3F = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3F,
  staticRenderFns: __vue_staticRenderFns__$3F
}, __vue_inject_styles__$3F, __vue_script__$3F, __vue_scope_id__$3F, __vue_is_functional_template__$3F, __vue_module_identifier__$3F, false, undefined, undefined, undefined);

var script$3G = Vue.extend({
  name: "PhChatCircleDots",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3G = script$3G;
/* template */

var __vue_render__$3G = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M45.42853,176.99811A95.95978,95.95978,0,1,1,79.00228,210.5717l.00023-.001L45.84594,220.044a8,8,0,0,1-9.89-9.89l9.47331-33.15657Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "99.99951",
      "cy": "127.99902",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "155.99951",
      "cy": "127.99902",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M45.42853,176.99811A95.95978,95.95978,0,1,1,79.00228,210.5717l.00023-.001L45.84594,220.044a8,8,0,0,1-9.89-9.89l9.47331-33.15657Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M45.42853,176.99811A95.95978,95.95978,0,1,1,79.00228,210.5717l.00023-.001L45.84594,220.044a8,8,0,0,1-9.89-9.89l9.47331-33.15657Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "80",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "128",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128.00146,24.00781A104.01819,104.01819,0,0,0,36.814,178.03906l-8.55468,29.90625a15.995,15.995,0,0,0,19.78125,19.78125l29.91406-8.53125a104.00785,104.00785,0,1,0,50.04687-195.1875ZM80.00049,140a12,12,0,1,1,12-12A12,12,0,0,1,80.00049,140Zm48,0a12,12,0,1,1,12-12A12,12,0,0,1,128.00049,140Zm48,0a12,12,0,1,1,12-12A12,12,0,0,1,176.00049,140Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M45.42853,176.99811A95.95978,95.95978,0,1,1,79.00228,210.5717l.00023-.001L45.84594,220.044a8,8,0,0,1-9.89-9.89l9.47331-33.15657Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "128",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "80",
      "cy": "128",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M45.42853,176.99811A95.95978,95.95978,0,1,1,79.00228,210.5717l.00023-.001L45.84594,220.044a8,8,0,0,1-9.89-9.89l9.47331-33.15657Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "80",
      "cy": "128",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "128",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M45.42853,176.99811A95.95978,95.95978,0,1,1,79.00228,210.5717l.00023-.001L45.84594,220.044a8,8,0,0,1-9.89-9.89l9.47331-33.15657Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "80",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "128",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3G = [];
/* style */

const __vue_inject_styles__$3G = undefined;
/* scoped */

const __vue_scope_id__$3G = undefined;
/* module identifier */

const __vue_module_identifier__$3G = undefined;
/* functional template */

const __vue_is_functional_template__$3G = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3G = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3G,
  staticRenderFns: __vue_staticRenderFns__$3G
}, __vue_inject_styles__$3G, __vue_script__$3G, __vue_scope_id__$3G, __vue_is_functional_template__$3G, __vue_module_identifier__$3G, false, undefined, undefined, undefined);

var script$3H = Vue.extend({
  name: "PhChatCircleText",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3H = script$3H;
/* template */

var __vue_render__$3H = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M45.42853,176.99811A95.95978,95.95978,0,1,1,79.00228,210.5717l.00023-.001L45.84594,220.044a8,8,0,0,1-9.89-9.89l9.47331-33.15657Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "108",
      "x2": "160",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "148",
      "x2": "160",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M45.42853,176.99811A95.95978,95.95978,0,1,1,79.00228,210.5717l.00023-.001L45.84594,220.044a8,8,0,0,1-9.89-9.89l9.47331-33.15657Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M45.42853,176.99811A95.95978,95.95978,0,1,1,79.00228,210.5717l.00023-.001L45.84594,220.044a8,8,0,0,1-9.89-9.89l9.47331-33.15657Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "112",
      "x2": "160",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "144",
      "x2": "160",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128.00146,23.99316A104.03063,104.03063,0,0,0,36.814,178.04l-8.55468,29.90625a15.995,15.995,0,0,0,19.78125,19.78125l29.91406-8.53125A104.01366,104.01366,0,1,0,128.00146,23.99316Zm32,128h-64a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm0-32h-64a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M45.42853,176.99811A95.95978,95.95978,0,1,1,79.00228,210.5717l.00023-.001L45.84594,220.044a8,8,0,0,1-9.89-9.89l9.47331-33.15657Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "112",
      "x2": "160",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "144",
      "x2": "160",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M45.42853,176.99811A95.95978,95.95978,0,1,1,79.00228,210.5717l.00023-.001L45.84594,220.044a8,8,0,0,1-9.89-9.89l9.47331-33.15657Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "112",
      "x2": "160",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "144",
      "x2": "160",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M45.42853,176.99811A95.95978,95.95978,0,1,1,79.00228,210.5717l.00023-.001L45.84594,220.044a8,8,0,0,1-9.89-9.89l9.47331-33.15657Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "112",
      "x2": "160",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "144",
      "x2": "160",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3H = [];
/* style */

const __vue_inject_styles__$3H = undefined;
/* scoped */

const __vue_scope_id__$3H = undefined;
/* module identifier */

const __vue_module_identifier__$3H = undefined;
/* functional template */

const __vue_is_functional_template__$3H = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3H = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3H,
  staticRenderFns: __vue_staticRenderFns__$3H
}, __vue_inject_styles__$3H, __vue_script__$3H, __vue_scope_id__$3H, __vue_is_functional_template__$3H, __vue_module_identifier__$3H, false, undefined, undefined, undefined);

var script$3I = Vue.extend({
  name: "PhChatDots",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3I = script$3I;
/* template */

var __vue_render__$3I = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M77.35142,201.87677l-32.2031,27.07116a8,8,0,0,1-13.14783-6.12372V64.00049a8,8,0,0,1,8-8h176a8,8,0,0,1,8,8v128a8,8,0,0,1-8,8H82.49925A8,8,0,0,0,77.35142,201.87677Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "100",
      "cy": "128",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "128",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M77.98509,201.34409,45.14832,228.94793a8,8,0,0,1-13.14783-6.12372V64.00049a8,8,0,0,1,8-8h176a8,8,0,0,1,8,8v128a8,8,0,0,1-8,8H81.67142Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M77.35142,201.87677l-32.2031,27.07116a8,8,0,0,1-13.14783-6.12372V64.00049a8,8,0,0,1,8-8h176a8,8,0,0,1,8,8v128a8,8,0,0,1-8,8H82.49925A8,8,0,0,0,77.35142,201.87677Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "80",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "128",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216.002,47.99316h-176a16.01583,16.01583,0,0,0-16,16V222.82129a15.97593,15.97593,0,0,0,26.29688,12.25l31.75781-26.70313,133.94531-.375a16.01581,16.01581,0,0,0,16-16v-128A16.01582,16.01582,0,0,0,216.002,47.99316ZM80.001,140.001a12,12,0,1,1,12-12A12,12,0,0,1,80.001,140.001Zm48,0a12,12,0,1,1,12-12A12,12,0,0,1,128.001,140.001Zm48,0a12,12,0,1,1,12-12A12,12,0,0,1,176.001,140.001Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M77.35142,201.87677l-32.2031,27.07116a8,8,0,0,1-13.14783-6.12372V64.00049a8,8,0,0,1,8-8h176a8,8,0,0,1,8,8v128a8,8,0,0,1-8,8H82.49925A8,8,0,0,0,77.35142,201.87677Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "128",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "80",
      "cy": "128",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M77.35142,201.87677l-32.2031,27.07116a8,8,0,0,1-13.14783-6.12372V64.00049a8,8,0,0,1,8-8h176a8,8,0,0,1,8,8v128a8,8,0,0,1-8,8H82.49925A8,8,0,0,0,77.35142,201.87677Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "80",
      "cy": "128",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "128",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M77.35142,201.87677l-32.2031,27.07116a8,8,0,0,1-13.14783-6.12372V64.00049a8,8,0,0,1,8-8h176a8,8,0,0,1,8,8v128a8,8,0,0,1-8,8H82.49925A8,8,0,0,0,77.35142,201.87677Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "80",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "128",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3I = [];
/* style */

const __vue_inject_styles__$3I = undefined;
/* scoped */

const __vue_scope_id__$3I = undefined;
/* module identifier */

const __vue_module_identifier__$3I = undefined;
/* functional template */

const __vue_is_functional_template__$3I = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3I = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3I,
  staticRenderFns: __vue_staticRenderFns__$3I
}, __vue_inject_styles__$3I, __vue_script__$3I, __vue_scope_id__$3I, __vue_is_functional_template__$3I, __vue_module_identifier__$3I, false, undefined, undefined, undefined);

var script$3J = Vue.extend({
  name: "PhChatTeardrop",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3J = script$3J;
/* template */

var __vue_render__$3J = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M132.00018,215.99219H47.66667A7.66667,7.66667,0,0,1,40,208.32552V123.992a91.99981,91.99981,0,0,1,91.99982-91.99981H132a92,92,0,0,1,92,92v.00018A91.99982,91.99982,0,0,1,132.00018,215.99219Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M132.00018,215.99219H47.66667A7.66667,7.66667,0,0,1,40,208.32552V123.992a91.99981,91.99981,0,0,1,91.99982-91.99981H132a92,92,0,0,1,92,92v.00018A91.99982,91.99982,0,0,1,132.00018,215.99219Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M132.00018,215.99219H47.66667A7.66667,7.66667,0,0,1,40,208.32552V123.992a91.99981,91.99981,0,0,1,91.99982-91.99981H132a92,92,0,0,1,92,92v.00018A91.99982,91.99982,0,0,1,132.00018,215.99219Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M132,23.99219a100.113,100.113,0,0,0-100,100v84.33349a15.68449,15.68449,0,0,0,15.667,15.66651H132a100,100,0,0,0,0-200Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M132.00018,215.99219H47.66667A7.66667,7.66667,0,0,1,40,208.32552V123.992a91.99981,91.99981,0,0,1,91.99982-91.99981H132a92,92,0,0,1,92,92v.00018A91.99982,91.99982,0,0,1,132.00018,215.99219Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M132.00018,215.99219H47.66667A7.66667,7.66667,0,0,1,40,208.32552V123.992a91.99981,91.99981,0,0,1,91.99982-91.99981H132a92,92,0,0,1,92,92v.00018A91.99982,91.99982,0,0,1,132.00018,215.99219Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M132.00018,215.99219H47.66667A7.66667,7.66667,0,0,1,40,208.32552V123.992a91.99981,91.99981,0,0,1,91.99982-91.99981H132a92,92,0,0,1,92,92v.00018A91.99982,91.99982,0,0,1,132.00018,215.99219Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3J = [];
/* style */

const __vue_inject_styles__$3J = undefined;
/* scoped */

const __vue_scope_id__$3J = undefined;
/* module identifier */

const __vue_module_identifier__$3J = undefined;
/* functional template */

const __vue_is_functional_template__$3J = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3J = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3J,
  staticRenderFns: __vue_staticRenderFns__$3J
}, __vue_inject_styles__$3J, __vue_script__$3J, __vue_scope_id__$3J, __vue_is_functional_template__$3J, __vue_module_identifier__$3J, false, undefined, undefined, undefined);

var script$3K = Vue.extend({
  name: "PhChatTeardropDots",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3K = script$3K;
/* template */

var __vue_render__$3K = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M132.00018,215.99219H47.66667A7.66667,7.66667,0,0,1,40,208.32552V123.992a91.99981,91.99981,0,0,1,91.99982-91.99981H132a92,92,0,0,1,92,92v.00018A91.99982,91.99982,0,0,1,132.00018,215.99219Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "132",
      "cy": "128",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "128",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "128",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M132.00018,215.99219H47.66667A7.66667,7.66667,0,0,1,40,208.32552V123.992a91.99981,91.99981,0,0,1,91.99982-91.99981H132a92,92,0,0,1,92,92v.00018A91.99982,91.99982,0,0,1,132.00018,215.99219Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M132.00018,215.99219H47.66667A7.66667,7.66667,0,0,1,40,208.32552V123.992a91.99981,91.99981,0,0,1,91.99982-91.99981H132a92,92,0,0,1,92,92v.00018A91.99982,91.99982,0,0,1,132.00018,215.99219Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "132",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "128",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M132,23.99219a100.113,100.113,0,0,0-100,100v84.33349a15.68449,15.68449,0,0,0,15.667,15.66651H132a100,100,0,0,0,0-200Zm-48.00195,116.001a12,12,0,1,1,12-12A12,12,0,0,1,83.99805,139.99316Zm48,0a12,12,0,1,1,12-12A12,12,0,0,1,131.99805,139.99316Zm48,0a12,12,0,1,1,12-12A12,12,0,0,1,179.99805,139.99316Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M132.00018,215.99219H47.66667A7.66667,7.66667,0,0,1,40,208.32552V123.992a91.99981,91.99981,0,0,1,91.99982-91.99981H132a92,92,0,0,1,92,92v.00018A91.99982,91.99982,0,0,1,132.00018,215.99219Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "132",
      "cy": "128",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "128",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "128",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M132.00018,215.99219H47.66667A7.66667,7.66667,0,0,1,40,208.32552V123.992a91.99981,91.99981,0,0,1,91.99982-91.99981H132a92,92,0,0,1,92,92v.00018A91.99982,91.99982,0,0,1,132.00018,215.99219Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "132",
      "cy": "128",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "128",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "128",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M132.00018,215.99219H47.66667A7.66667,7.66667,0,0,1,40,208.32552V123.992a91.99981,91.99981,0,0,1,91.99982-91.99981H132a92,92,0,0,1,92,92v.00018A91.99982,91.99982,0,0,1,132.00018,215.99219Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "132",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "128",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3K = [];
/* style */

const __vue_inject_styles__$3K = undefined;
/* scoped */

const __vue_scope_id__$3K = undefined;
/* module identifier */

const __vue_module_identifier__$3K = undefined;
/* functional template */

const __vue_is_functional_template__$3K = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3K = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3K,
  staticRenderFns: __vue_staticRenderFns__$3K
}, __vue_inject_styles__$3K, __vue_script__$3K, __vue_scope_id__$3K, __vue_is_functional_template__$3K, __vue_module_identifier__$3K, false, undefined, undefined, undefined);

var script$3L = Vue.extend({
  name: "PhChatTeardropText",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3L = script$3L;
/* template */

var __vue_render__$3L = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M132.00018,215.99219H47.66667A7.66667,7.66667,0,0,1,40,208.32552V123.992a91.99981,91.99981,0,0,1,91.99982-91.99981H132a92,92,0,0,1,92,92v.00018A91.99982,91.99982,0,0,1,132.00018,215.99219Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "99.99902",
      "y1": "107.99219",
      "x2": "159.99902",
      "y2": "107.99219",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "99.99902",
      "y1": "147.99219",
      "x2": "159.99902",
      "y2": "147.99219",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M132.00018,215.99219H47.66667A7.66667,7.66667,0,0,1,40,208.32552V123.992a91.99981,91.99981,0,0,1,91.99982-91.99981H132a92,92,0,0,1,92,92v.00018A91.99982,91.99982,0,0,1,132.00018,215.99219Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M132.00018,215.99219H47.66667A7.66667,7.66667,0,0,1,40,208.32552V123.992a91.99981,91.99981,0,0,1,91.99982-91.99981H132a92,92,0,0,1,92,92v.00018A91.99982,91.99982,0,0,1,132.00018,215.99219Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "99.99805",
      "y1": "111.99219",
      "x2": "159.99805",
      "y2": "111.99219",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "99.99805",
      "y1": "143.99219",
      "x2": "159.99805",
      "y2": "143.99219",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M132,23.99219a100.113,100.113,0,0,0-100,100v84.33349a15.68449,15.68449,0,0,0,15.667,15.66651H132a100,100,0,0,0,0-200Zm27.99805,128h-60a8,8,0,0,1,0-16h60a8,8,0,0,1,0,16Zm0-32h-60a8,8,0,0,1,0-16h60a8,8,0,0,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M132.00018,215.99219H47.66667A7.66667,7.66667,0,0,1,40,208.32552V123.992a91.99981,91.99981,0,0,1,91.99982-91.99981H132a92,92,0,0,1,92,92v.00018A91.99982,91.99982,0,0,1,132.00018,215.99219Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "99.99951",
      "y1": "111.99219",
      "x2": "159.99951",
      "y2": "111.99219",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "99.99951",
      "y1": "143.99219",
      "x2": "159.99951",
      "y2": "143.99219",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M132.00018,215.99219H47.66667A7.66667,7.66667,0,0,1,40,208.32552V123.992a91.99981,91.99981,0,0,1,91.99982-91.99981H132a92,92,0,0,1,92,92v.00018A91.99982,91.99982,0,0,1,132.00018,215.99219Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "111.99219",
      "x2": "160",
      "y2": "111.99219",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "143.99219",
      "x2": "160",
      "y2": "143.99219",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M132.00018,215.99219H47.66667A7.66667,7.66667,0,0,1,40,208.32552V123.992a91.99981,91.99981,0,0,1,91.99982-91.99981H132a92,92,0,0,1,92,92v.00018A91.99982,91.99982,0,0,1,132.00018,215.99219Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100.00049",
      "y1": "111.99219",
      "x2": "160.00049",
      "y2": "111.99219",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100.00049",
      "y1": "143.99219",
      "x2": "160.00049",
      "y2": "143.99219",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3L = [];
/* style */

const __vue_inject_styles__$3L = undefined;
/* scoped */

const __vue_scope_id__$3L = undefined;
/* module identifier */

const __vue_module_identifier__$3L = undefined;
/* functional template */

const __vue_is_functional_template__$3L = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3L = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3L,
  staticRenderFns: __vue_staticRenderFns__$3L
}, __vue_inject_styles__$3L, __vue_script__$3L, __vue_scope_id__$3L, __vue_is_functional_template__$3L, __vue_module_identifier__$3L, false, undefined, undefined, undefined);

var script$3M = Vue.extend({
  name: "PhChatText",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3M = script$3M;
/* template */

var __vue_render__$3M = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M77.98509,201.34409,45.14832,228.94793a8,8,0,0,1-13.14783-6.12372V64.00049a8,8,0,0,1,8-8h176a8,8,0,0,1,8,8v128a8,8,0,0,1-8,8H81.67142Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96.00049",
      "y1": "108",
      "x2": "160.00049",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96.00049",
      "y1": "148",
      "x2": "160.00049",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M77.98509,201.34409,45.14832,228.94793a8,8,0,0,1-13.14783-6.12372V64.00049a8,8,0,0,1,8-8h176a8,8,0,0,1,8,8v128a8,8,0,0,1-8,8H81.67142Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M77.98509,201.34409,45.14832,228.94793a8,8,0,0,1-13.14783-6.12372V64.00049a8,8,0,0,1,8-8h176a8,8,0,0,1,8,8v128a8,8,0,0,1-8,8H81.67142Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96.00049",
      "y1": "112",
      "x2": "160.00049",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96.00049",
      "y1": "144",
      "x2": "160.00049",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216.002,48.002h-176a16.02085,16.02085,0,0,0-16,16V222.82227a15.8614,15.8614,0,0,0,9.25,14.50781,16.11272,16.11272,0,0,0,6.79688,1.51562,15.86972,15.86972,0,0,0,10.25-3.77343l31.75-26.69532,133.95312-.375a16.02083,16.02083,0,0,0,16-16v-128A16.02084,16.02084,0,0,0,216.002,48.002Zm-56,104h-64a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm0-32h-64a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M77.98509,201.34409,45.14832,228.94793a8,8,0,0,1-13.14783-6.12372V64.00049a8,8,0,0,1,8-8h176a8,8,0,0,1,8,8v128a8,8,0,0,1-8,8H81.67142Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96.00049",
      "y1": "112",
      "x2": "160.00049",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96.00049",
      "y1": "144",
      "x2": "160.00049",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M77.98509,201.34409,45.14832,228.94793a8,8,0,0,1-13.14783-6.12372V64.00049a8,8,0,0,1,8-8h176a8,8,0,0,1,8,8v128a8,8,0,0,1-8,8H81.67142Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96.00049",
      "y1": "112",
      "x2": "160.00049",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96.00049",
      "y1": "144",
      "x2": "160.00049",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M77.98509,201.34409,45.14832,228.94793a8,8,0,0,1-13.14783-6.12372V64.00049a8,8,0,0,1,8-8h176a8,8,0,0,1,8,8v128a8,8,0,0,1-8,8H81.67142Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96.00049",
      "y1": "112",
      "x2": "160.00049",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96.00049",
      "y1": "144",
      "x2": "160.00049",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3M = [];
/* style */

const __vue_inject_styles__$3M = undefined;
/* scoped */

const __vue_scope_id__$3M = undefined;
/* module identifier */

const __vue_module_identifier__$3M = undefined;
/* functional template */

const __vue_is_functional_template__$3M = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3M = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3M,
  staticRenderFns: __vue_staticRenderFns__$3M
}, __vue_inject_styles__$3M, __vue_script__$3M, __vue_scope_id__$3M, __vue_is_functional_template__$3M, __vue_module_identifier__$3M, false, undefined, undefined, undefined);

var script$3N = Vue.extend({
  name: "PhChats",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3N = script$3N;
/* template */

var __vue_render__$3N = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M71.5834,144.00049l-39.58291,32v-128a8,8,0,0,1,8-8h128a8,8,0,0,1,8,8v88a8,8,0,0,1-8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80.00049,144.00048v40a8,8,0,0,0,8,8h96.41709l39.58291,32v-128a8,8,0,0,0-8-8h-40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80.00049,144.00048v40a8,8,0,0,0,8,8h96.41709l39.58291,32v-128a8,8,0,0,0-8-8h-40v48a8,8,0,0,1-8,8Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M71.5834,144.00049l-39.58291,32v-128a8,8,0,0,1,8-8h128a8,8,0,0,1,8,8v88a8,8,0,0,1-8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80.00049,144.00048v40a8,8,0,0,0,8,8h96.41709l39.58291,32v-128a8,8,0,0,0-8-8h-40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232,96.00049a16.01833,16.01833,0,0,0-16-16H184v-32a16.01833,16.01833,0,0,0-16-16H40a16.01833,16.01833,0,0,0-16,16v128a7.99978,7.99978,0,0,0,13.0293,6.22119L72,153.95032l.001,30.05017a16.01833,16.01833,0,0,0,16,16h93.58789l37.38281,30.22119a7.99979,7.99979,0,0,0,13.0293-6.22119ZM189.44727,185.7793a7.99922,7.99922,0,0,0-5.0293-1.77881H88.001l-.001-32h80a16.01833,16.01833,0,0,0,16-16v-40h32l.001,111.24512Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M71.5834,144.00049l-39.58291,32v-128a8,8,0,0,1,8-8h128a8,8,0,0,1,8,8v88a8,8,0,0,1-8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80.00049,144.00048v40a8,8,0,0,0,8,8h96.41709l39.58291,32v-128a8,8,0,0,0-8-8h-40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M71.5834,144.00049l-39.58291,32v-128a8,8,0,0,1,8-8h128a8,8,0,0,1,8,8v88a8,8,0,0,1-8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80.00049,144.00048v40a8,8,0,0,0,8,8h96.41709l39.58291,32v-128a8,8,0,0,0-8-8h-40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M71.5834,144.00049l-39.58291,32v-128a8,8,0,0,1,8-8h128a8,8,0,0,1,8,8v88a8,8,0,0,1-8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80.00049,144.00048v40a8,8,0,0,0,8,8h96.41709l39.58291,32v-128a8,8,0,0,0-8-8h-40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3N = [];
/* style */

const __vue_inject_styles__$3N = undefined;
/* scoped */

const __vue_scope_id__$3N = undefined;
/* module identifier */

const __vue_module_identifier__$3N = undefined;
/* functional template */

const __vue_is_functional_template__$3N = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3N = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3N,
  staticRenderFns: __vue_staticRenderFns__$3N
}, __vue_inject_styles__$3N, __vue_script__$3N, __vue_scope_id__$3N, __vue_is_functional_template__$3N, __vue_module_identifier__$3N, false, undefined, undefined, undefined);

var script$3O = Vue.extend({
  name: "PhChatsCircle",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3O = script$3O;
/* template */

var __vue_render__$3O = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M34.0714,140.74858a71.96979,71.96979,0,1,1,25.18031,25.1802l.00017-.00075-24.86742,7.105a6,6,0,0,1-7.41747-7.41747l7.105-24.86742Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.059,175.89247a72.04349,72.04349,0,0,0,104.68926,38.03631l-.00017-.00075,24.86742,7.105a6,6,0,0,0,7.41747-7.41747l-7.105-24.86742.00057.00046A72.01951,72.01951,0,0,0,163.93781,80.10585",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.059,175.89247a72.04349,72.04349,0,0,0,104.68926,38.03631l-.00017-.00075,24.86742,7.105a6,6,0,0,0,7.41747-7.41747l-7.105-24.86742.00057.00046A72.01951,72.01951,0,0,0,163.93781,80.10585l.00231-.00076A72.05057,72.05057,0,0,1,96,176q-1.98343,0-3.941-.106Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M34.0714,140.74858a71.96979,71.96979,0,1,1,25.18031,25.1802l.00017-.00075-24.86742,7.105a6,6,0,0,1-7.41747-7.41747l7.105-24.86742Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.059,175.89247a72.04349,72.04349,0,0,0,104.68926,38.03631l-.00017-.00075,24.86742,7.105a6,6,0,0,0,7.41747-7.41747l-7.105-24.86742.00057.00046A72.01951,72.01951,0,0,0,163.93781,80.10585",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M230.53955,189.7666A80.01439,80.01439,0,0,0,169.56543,72.58691a80.00141,80.00141,0,1,0-144.105,69.17969l-6.18457,21.6499a13.99955,13.99955,0,0,0,17.30566,17.30909l21.65235-6.186a79.84121,79.84121,0,0,0,28.18994,8.88367,80.03721,80.03721,0,0,0,111.34326,39.11584l21.65137,6.18653A14.00007,14.00007,0,0,0,236.7251,211.418Zm-15.4873-5.10791a8.00114,8.00114,0,0,0-.81641,6.28711l6.11621,21.40625-21.40625-6.11572a8.00193,8.00193,0,0,0-6.28613.8164,64.03376,64.03376,0,0,1-88.33985-23.48608,79.90524,79.90524,0,0,0,70.37549-93.85889,64.02222,64.02222,0,0,1,40.35694,94.95093Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M34.0714,140.74858a71.96979,71.96979,0,1,1,25.18031,25.1802l.00017-.00075-24.86742,7.105a6,6,0,0,1-7.41747-7.41747l7.105-24.86742Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.059,175.89247a72.04349,72.04349,0,0,0,104.68926,38.03631l-.00017-.00075,24.86742,7.105a6,6,0,0,0,7.41747-7.41747l-7.105-24.86742.00057.00046A72.01951,72.01951,0,0,0,163.93781,80.10585",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M34.0714,140.74858a71.96979,71.96979,0,1,1,25.18031,25.1802l.00017-.00075-24.86742,7.105a6,6,0,0,1-7.41747-7.41747l7.105-24.86742Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.059,175.89247a72.04349,72.04349,0,0,0,104.68926,38.03631l-.00017-.00075,24.86742,7.105a6,6,0,0,0,7.41747-7.41747l-7.105-24.86742.00057.00046A72.01951,72.01951,0,0,0,163.93781,80.10585",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M34.0714,140.74858a71.96979,71.96979,0,1,1,25.18031,25.1802l.00017-.00075-24.86742,7.105a6,6,0,0,1-7.41747-7.41747l7.105-24.86742Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.059,175.89247a72.04349,72.04349,0,0,0,104.68926,38.03631l-.00017-.00075,24.86742,7.105a6,6,0,0,0,7.41747-7.41747l-7.105-24.86742.00057.00046A72.01951,72.01951,0,0,0,163.93781,80.10585",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3O = [];
/* style */

const __vue_inject_styles__$3O = undefined;
/* scoped */

const __vue_scope_id__$3O = undefined;
/* module identifier */

const __vue_module_identifier__$3O = undefined;
/* functional template */

const __vue_is_functional_template__$3O = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3O = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3O,
  staticRenderFns: __vue_staticRenderFns__$3O
}, __vue_inject_styles__$3O, __vue_script__$3O, __vue_scope_id__$3O, __vue_is_functional_template__$3O, __vue_module_identifier__$3O, false, undefined, undefined, undefined);

var script$3P = Vue.extend({
  name: "PhChatsTeardrop",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3P = script$3P;
/* template */

var __vue_render__$3P = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M96.00014,175.99219H30a6,6,0,0,1-6-6V103.992A71.99985,71.99985,0,0,1,95.99986,31.99219H96a72,72,0,0,1,72,72v.00014A71.99986,71.99986,0,0,1,96.00014,175.99219Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.098,175.99521a72.0298,72.0298,0,0,0,67.9019,47.997H226a6,6,0,0,0,6-6V151.992a72.00294,72.00294,0,0,0-68.06587-71.8942",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M163.93962,80.09586A71.887,71.887,0,0,1,168,103.99219v.00014a71.99986,71.99986,0,0,1-71.99986,71.99986H92.098v.003a72.0298,72.0298,0,0,0,67.9019,47.997H226a6,6,0,0,0,6-6V151.992a72.00294,72.00294,0,0,0-68.06587-71.8942Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96.00014,175.99219H30a6,6,0,0,1-6-6V103.992A71.99985,71.99985,0,0,1,95.99986,31.99219H96a72,72,0,0,1,72,72v.00014A71.99986,71.99986,0,0,1,96.00014,175.99219Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.098,175.99521a72.0298,72.0298,0,0,0,67.9019,47.997H226a6,6,0,0,0,6-6V151.992a72.00294,72.00294,0,0,0-68.06587-71.8942",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M169.56592,72.5788A79.99487,79.99487,0,0,0,16,103.99219v66a14.01573,14.01573,0,0,0,14,14H86.667a80.1557,80.1557,0,0,0,73.333,48h66a14.01573,14.01573,0,0,0,14-14v-66A79.96635,79.96635,0,0,0,169.56592,72.5788ZM224,215.99219H160a64.14151,64.14151,0,0,1-55.67871-32.43335,79.90546,79.90546,0,0,0,70.37451-93.859A63.99067,63.99067,0,0,1,224,151.99219Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M96.00014,175.99219H30a6,6,0,0,1-6-6V103.992A71.99985,71.99985,0,0,1,95.99986,31.99219H96a72,72,0,0,1,72,72v.00014A71.99986,71.99986,0,0,1,96.00014,175.99219Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.098,175.99521a72.0298,72.0298,0,0,0,67.9019,47.997H226a6,6,0,0,0,6-6V151.992a72.00294,72.00294,0,0,0-68.06587-71.8942",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M96.00014,175.99219H30a6,6,0,0,1-6-6V103.992A71.99985,71.99985,0,0,1,95.99986,31.99219H96a72,72,0,0,1,72,72v.00014A71.99986,71.99986,0,0,1,96.00014,175.99219Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.098,175.99521a72.0298,72.0298,0,0,0,67.9019,47.997H226a6,6,0,0,0,6-6V151.992a72.00294,72.00294,0,0,0-68.06587-71.8942",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M96.00014,175.99219H30a6,6,0,0,1-6-6V103.992A71.99985,71.99985,0,0,1,95.99986,31.99219H96a72,72,0,0,1,72,72v.00014A71.99986,71.99986,0,0,1,96.00014,175.99219Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.098,175.99521a72.0298,72.0298,0,0,0,67.9019,47.997H226a6,6,0,0,0,6-6V151.992a72.00294,72.00294,0,0,0-68.06587-71.8942",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3P = [];
/* style */

const __vue_inject_styles__$3P = undefined;
/* scoped */

const __vue_scope_id__$3P = undefined;
/* module identifier */

const __vue_module_identifier__$3P = undefined;
/* functional template */

const __vue_is_functional_template__$3P = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3P = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3P,
  staticRenderFns: __vue_staticRenderFns__$3P
}, __vue_inject_styles__$3P, __vue_script__$3P, __vue_scope_id__$3P, __vue_is_functional_template__$3P, __vue_module_identifier__$3P, false, undefined, undefined, undefined);

var script$3Q = Vue.extend({
  name: "PhCheck",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3Q = script$3Q;
/* template */

var __vue_render__$3Q = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "216 72.005 104 184 48 128.005",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "216 72.005 104 184 48 128.005",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M103.99951,192.00012a7.97346,7.97346,0,0,1-5.65625-2.34277l-56-55.99561a7.99983,7.99983,0,1,1,11.3125-11.31445l50.34375,50.33935L210.34229,66.34778a8.00018,8.00018,0,0,1,11.31445,11.31347l-112,111.9961A7.97937,7.97937,0,0,1,103.99951,192.00012Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "216 72.005 104 184 48 128.005",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "216 72.005 104 184 48 128.005",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "216 72.005 104 184 48 128.005",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3Q = [];
/* style */

const __vue_inject_styles__$3Q = undefined;
/* scoped */

const __vue_scope_id__$3Q = undefined;
/* module identifier */

const __vue_module_identifier__$3Q = undefined;
/* functional template */

const __vue_is_functional_template__$3Q = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3Q = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3Q,
  staticRenderFns: __vue_staticRenderFns__$3Q
}, __vue_inject_styles__$3Q, __vue_script__$3Q, __vue_scope_id__$3Q, __vue_is_functional_template__$3Q, __vue_module_identifier__$3Q, false, undefined, undefined, undefined);

var script$3R = Vue.extend({
  name: "PhCheckCircle",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3R = script$3R;
/* template */

var __vue_render__$3R = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "172 104 113.333 160 84 132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "172 104 113.333 160 84 132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.12041,104.12041,0,0,0,128,24Zm49.53125,85.78906-58.67187,56a8.02441,8.02441,0,0,1-11.0625,0l-29.32813-28a8.00675,8.00675,0,0,1,11.0625-11.57812l23.79687,22.72656,53.14063-50.72656a8.00675,8.00675,0,0,1,11.0625,11.57812Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "172 104 113.333 160 84 132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "172 104 113.333 160 84 132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "172 104 113.333 160 84 132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3R = [];
/* style */

const __vue_inject_styles__$3R = undefined;
/* scoped */

const __vue_scope_id__$3R = undefined;
/* module identifier */

const __vue_module_identifier__$3R = undefined;
/* functional template */

const __vue_is_functional_template__$3R = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3R = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3R,
  staticRenderFns: __vue_staticRenderFns__$3R
}, __vue_inject_styles__$3R, __vue_script__$3R, __vue_scope_id__$3R, __vue_is_functional_template__$3R, __vue_module_identifier__$3R, false, undefined, undefined, undefined);

var script$3S = Vue.extend({
  name: "PhCheckSquare",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3S = script$3S;
/* template */

var __vue_render__$3S = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "172 104 113.333 160 84 132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "172 104 113.333 160 84 132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208.00146,32h-160a16.01582,16.01582,0,0,0-16,16V208a16.01583,16.01583,0,0,0,16,16h160a16.01582,16.01582,0,0,0,16-16V48A16.01581,16.01581,0,0,0,208.00146,32ZM177.5249,109.78125l-58.67187,56a7.98451,7.98451,0,0,1-11.04688,0l-29.32812-28a7.99571,7.99571,0,1,1,11.04687-11.5625l23.80469,22.71875L166.478,98.21875a7.99571,7.99571,0,1,1,11.04687,11.5625Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "172 104 113.333 160 84 132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "172 104 113.333 160 84 132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "172 104 113.333 160 84 132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3S = [];
/* style */

const __vue_inject_styles__$3S = undefined;
/* scoped */

const __vue_scope_id__$3S = undefined;
/* module identifier */

const __vue_module_identifier__$3S = undefined;
/* functional template */

const __vue_is_functional_template__$3S = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3S = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3S,
  staticRenderFns: __vue_staticRenderFns__$3S
}, __vue_inject_styles__$3S, __vue_script__$3S, __vue_scope_id__$3S, __vue_is_functional_template__$3S, __vue_module_identifier__$3S, false, undefined, undefined, undefined);

var script$3T = Vue.extend({
  name: "PhCheckSquareOffset",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3T = script$3T;
/* template */

var __vue_render__$3T = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M43.99951,143.27273V52a8,8,0,0,1,8-8h152a8,8,0,0,1,8,8V204a8,8,0,0,1-8,8h-68.3641",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 152 64 216 32 184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "44 44 44 196 60 212 212 212 212 44 44 44",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M43.99951,143.27273V52a8,8,0,0,1,8-8h152a8,8,0,0,1,8,8V204a8,8,0,0,1-8,8h-68.3641",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 152 64 216 32 184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M203.99951,36.00012h-152a16.01834,16.01834,0,0,0-16,16v91.27246a8,8,0,0,0,16,0V52.00012h152v152H135.63525a8,8,0,0,0,0,16h68.36426a16.01833,16.01833,0,0,0,16-16v-152A16.01833,16.01833,0,0,0,203.99951,36.00012Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M133.65674,146.34338a8.00121,8.00121,0,0,0-11.31445,0L63.99951,204.68664,37.65674,178.34338a8.00018,8.00018,0,1,0-11.31445,11.31348l32,32a8.00062,8.00062,0,0,0,11.31445,0l64-64A8,8,0,0,0,133.65674,146.34338Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M43.99951,143.27273V52a8,8,0,0,1,8-8h152a8,8,0,0,1,8,8V204a8,8,0,0,1-8,8h-68.3641",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 152 64 216 32 184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M43.99951,143.27273V52a8,8,0,0,1,8-8h152a8,8,0,0,1,8,8V204a8,8,0,0,1-8,8h-68.3641",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 152 64 216 32 184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M43.99951,143.27273V52a8,8,0,0,1,8-8h152a8,8,0,0,1,8,8V204a8,8,0,0,1-8,8h-68.3641",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 152 64 216 32 184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3T = [];
/* style */

const __vue_inject_styles__$3T = undefined;
/* scoped */

const __vue_scope_id__$3T = undefined;
/* module identifier */

const __vue_module_identifier__$3T = undefined;
/* functional template */

const __vue_is_functional_template__$3T = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3T = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3T,
  staticRenderFns: __vue_staticRenderFns__$3T
}, __vue_inject_styles__$3T, __vue_script__$3T, __vue_scope_id__$3T, __vue_is_functional_template__$3T, __vue_module_identifier__$3T, false, undefined, undefined, undefined);

var script$3U = Vue.extend({
  name: "PhChecks",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3U = script$3U;
/* template */

var __vue_render__$3U = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "144 84 56 172 12 128.002",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "244 84 156 172 139.941 155.941",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "148 84 60 172 16 128.002",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "240 84 152 172 128.627 148.628",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M153.65674,89.65686l-87.999,88a8.00062,8.00062,0,0,1-11.31347,0l-44.001-43.99805a7.99983,7.99983,0,0,1,11.3125-11.31445l38.34473,38.3418,82.3418-82.34375a8.00052,8.00052,0,0,1,11.31445,11.31445Zm92-11.31445a8.003,8.003,0,0,0-11.31445,0l-82.3418,82.34375-17.71778-17.71582a7.99983,7.99983,0,0,0-11.3125,11.31445l23.374,23.37207a8.00062,8.00062,0,0,0,11.31347,0l87.999-88A8.00121,8.00121,0,0,0,245.65674,78.34241Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "148 84 60 172 16 128.002",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "240 84 152 172 128.627 148.628",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "148 84 60 172 16 128.002",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "240 84 152 172 128.627 148.628",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "148 84 60 172 16 128.002",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "240 84 152 172 128.627 148.628",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3U = [];
/* style */

const __vue_inject_styles__$3U = undefined;
/* scoped */

const __vue_scope_id__$3U = undefined;
/* module identifier */

const __vue_module_identifier__$3U = undefined;
/* functional template */

const __vue_is_functional_template__$3U = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3U = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3U,
  staticRenderFns: __vue_staticRenderFns__$3U
}, __vue_inject_styles__$3U, __vue_script__$3U, __vue_scope_id__$3U, __vue_is_functional_template__$3U, __vue_module_identifier__$3U, false, undefined, undefined, undefined);

var script$3V = Vue.extend({
  name: "PhCircle",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3V = script$3V;
/* template */

var __vue_render__$3V = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "104"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3V = [];
/* style */

const __vue_inject_styles__$3V = undefined;
/* scoped */

const __vue_scope_id__$3V = undefined;
/* module identifier */

const __vue_module_identifier__$3V = undefined;
/* functional template */

const __vue_is_functional_template__$3V = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3V = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3V,
  staticRenderFns: __vue_staticRenderFns__$3V
}, __vue_inject_styles__$3V, __vue_script__$3V, __vue_scope_id__$3V, __vue_is_functional_template__$3V, __vue_module_identifier__$3V, false, undefined, undefined, undefined);

var script$3W = Vue.extend({
  name: "PhCircleDashed",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3W = script$3W;
/* template */

var __vue_render__$3W = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M35.25567,103.14925a95.55835,95.55835,0,0,1,24.86208-43.0315",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M60.10646,195.89357a95.55822,95.55822,0,0,1-24.83534-43.04694",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152.85078,220.74432a95.55827,95.55827,0,0,1-49.69741-.01544",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M220.74433,152.85075a95.55835,95.55835,0,0,1-24.86208,43.0315",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M195.89354,60.10643a95.55822,95.55822,0,0,1,24.83534,43.04694",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M103.14922,35.25568a95.55827,95.55827,0,0,1,49.69741.01544",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M35.25567,103.14925a95.55835,95.55835,0,0,1,24.86208-43.0315",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M60.10646,195.89357a95.55822,95.55822,0,0,1-24.83534-43.04694",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152.85078,220.74432a95.55827,95.55827,0,0,1-49.69741-.01544",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M220.74433,152.85075a95.55835,95.55835,0,0,1-24.86208,43.0315",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M195.89354,60.10643a95.55822,95.55822,0,0,1,24.83534,43.04694",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M103.14922,35.25568a95.55827,95.55827,0,0,1,49.69741.01544",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M65.77441,54.46033a8.00119,8.00119,0,0,1,0,11.31445,87.95677,87.95677,0,0,0-22.78955,39.4375,7.99995,7.99995,0,1,1-15.45849-4.127,103.97686,103.97686,0,0,1,26.93457-46.625A8.00178,8.00178,0,0,1,65.77441,54.46033Zm-22.77587,96.3164A7.99983,7.99983,0,1,0,27.544,154.91736,103.97631,103.97631,0,0,0,54.45508,201.556a7.99984,7.99984,0,0,0,11.30273-11.32422A87.96258,87.96258,0,0,1,42.99854,150.77673Zm107.7749,62.24219a87.94957,87.94957,0,0,1-45.54981-.01758,8.00007,8.00007,0,1,0-4.14062,15.45508,103.98087,103.98087,0,0,0,53.8457.01367,8.00008,8.00008,0,0,0-4.15527-15.45117Zm72.03418-67.89746a7.99909,7.99909,0,0,0-9.79248,5.666,87.951,87.951,0,0,1-22.78955,39.4375,8.00018,8.00018,0,0,0,11.31347,11.31445,103.97037,103.97037,0,0,0,26.93457-46.625A8.00058,8.00058,0,0,0,222.80762,145.12146ZM213.001,105.224a8.00006,8.00006,0,1,0,15.45507-4.14063A103.9608,103.9608,0,0,0,201.54492,54.4447a7.99984,7.99984,0,0,0-11.30273,11.32422A87.94691,87.94691,0,0,1,213.001,105.224ZM105.22656,42.98084a87.94957,87.94957,0,0,1,45.54981.01757A8.00006,8.00006,0,1,0,154.917,27.54334a104.009,104.009,0,0,0-53.8457-.01368,8.00008,8.00008,0,0,0,4.15527,15.45118Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M35.25567,103.14925a95.55835,95.55835,0,0,1,24.86208-43.0315",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M60.10646,195.89357a95.55822,95.55822,0,0,1-24.83534-43.04694",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152.85078,220.74432a95.55827,95.55827,0,0,1-49.69741-.01544",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M220.74433,152.85075a95.55835,95.55835,0,0,1-24.86208,43.0315",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M195.89354,60.10643a95.55822,95.55822,0,0,1,24.83534,43.04694",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M103.14922,35.25568a95.55827,95.55827,0,0,1,49.69741.01544",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M35.25567,103.14925a95.55835,95.55835,0,0,1,24.86208-43.0315",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M60.10646,195.89357a95.55822,95.55822,0,0,1-24.83534-43.04694",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152.85078,220.74432a95.55827,95.55827,0,0,1-49.69741-.01544",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M220.74433,152.85075a95.55835,95.55835,0,0,1-24.86208,43.0315",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M195.89354,60.10643a95.55822,95.55822,0,0,1,24.83534,43.04694",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M103.14922,35.25568a95.55827,95.55827,0,0,1,49.69741.01544",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M35.25567,103.14925a95.55835,95.55835,0,0,1,24.86208-43.0315",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M60.10646,195.89357a95.55822,95.55822,0,0,1-24.83534-43.04694",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152.85078,220.74432a95.55827,95.55827,0,0,1-49.69741-.01544",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M220.74433,152.85075a95.55835,95.55835,0,0,1-24.86208,43.0315",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M195.89354,60.10643a95.55822,95.55822,0,0,1,24.83534,43.04694",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M103.14922,35.25568a95.55827,95.55827,0,0,1,49.69741.01544",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3W = [];
/* style */

const __vue_inject_styles__$3W = undefined;
/* scoped */

const __vue_scope_id__$3W = undefined;
/* module identifier */

const __vue_module_identifier__$3W = undefined;
/* functional template */

const __vue_is_functional_template__$3W = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3W = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3W,
  staticRenderFns: __vue_staticRenderFns__$3W
}, __vue_inject_styles__$3W, __vue_script__$3W, __vue_scope_id__$3W, __vue_is_functional_template__$3W, __vue_module_identifier__$3W, false, undefined, undefined, undefined);

var script$3X = Vue.extend({
  name: "PhCircleHalf",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3X = script$3X;
/* template */

var __vue_render__$3X = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "32",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "127.99998",
      "y1": "68.00584",
      "x2": "218.91188",
      "y2": "158.91774",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128.00002",
      "y1": "140.00588",
      "x2": "189.61412",
      "y2": "201.61998",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,32a96,96,0,0,1,0,192",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "32",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.11791,104.11791,0,0,0,128,24ZM40,128a88.11715,88.11715,0,0,1,80-87.63257V215.63257A88.11715,88.11715,0,0,1,40,128Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "32",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "127.99998",
      "y1": "48.00584",
      "x2": "222.85577",
      "y2": "142.86163",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128.00002",
      "y1": "104.00588",
      "x2": "206.81368",
      "y2": "182.81953",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128.00002",
      "y1": "160.00588",
      "x2": "177.97522",
      "y2": "209.98108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "32",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "127.99998",
      "y1": "48.00584",
      "x2": "222.85577",
      "y2": "142.86163",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128.00002",
      "y1": "104.00588",
      "x2": "206.81368",
      "y2": "182.81953",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128.00002",
      "y1": "160.00588",
      "x2": "177.97522",
      "y2": "209.98108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "32",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "127.99998",
      "y1": "48.00584",
      "x2": "222.85577",
      "y2": "142.86163",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128.00002",
      "y1": "104.00588",
      "x2": "206.81368",
      "y2": "182.81953",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128.00002",
      "y1": "160.00588",
      "x2": "177.97522",
      "y2": "209.98108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3X = [];
/* style */

const __vue_inject_styles__$3X = undefined;
/* scoped */

const __vue_scope_id__$3X = undefined;
/* module identifier */

const __vue_module_identifier__$3X = undefined;
/* functional template */

const __vue_is_functional_template__$3X = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3X = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3X,
  staticRenderFns: __vue_staticRenderFns__$3X
}, __vue_inject_styles__$3X, __vue_script__$3X, __vue_scope_id__$3X, __vue_is_functional_template__$3X, __vue_module_identifier__$3X, false, undefined, undefined, undefined);

var script$3Y = Vue.extend({
  name: "PhCircleHalfTilt",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3Y = script$3Y;
/* template */

var __vue_render__$3Y = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "195.88225",
      "y1": "60.11775",
      "x2": "60.11775",
      "y2": "195.88225",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "195.88224",
      "y2": "195.88224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "164.00291",
      "y1": "91.99705",
      "x2": "221.56149",
      "y2": "149.55563",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "92.00294",
      "y1": "163.99708",
      "x2": "149.56507",
      "y2": "221.55921",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M195.88225,60.11775a96,96,0,0,1-135.7645,135.7645",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "195.88225",
      "y1": "60.11775",
      "x2": "60.11775",
      "y2": "195.88225",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M201.53906,54.46094A103.99994,103.99994,0,1,0,54.46094,201.53906,103.99994,103.99994,0,1,0,201.53906,54.46094ZM65.77539,65.77441a88.08476,88.08476,0,0,1,118.52368-5.38794L60.38086,184.30579A87.98425,87.98425,0,0,1,65.77539,65.77441Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "195.88225",
      "y1": "60.11775",
      "x2": "60.11775",
      "y2": "195.88225",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "142.00291",
      "y1": "113.99705",
      "x2": "208.43906",
      "y2": "180.4332",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "114.00294",
      "y1": "141.99708",
      "x2": "180.44043",
      "y2": "208.43457",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "86.00586",
      "y1": "170",
      "x2": "139.33798",
      "y2": "223.33212",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "170.00001",
      "y1": "86.00001",
      "x2": "223.33246",
      "y2": "139.33246",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "195.88225",
      "y1": "60.11775",
      "x2": "60.11775",
      "y2": "195.88225",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "142.00291",
      "y1": "113.99705",
      "x2": "208.43906",
      "y2": "180.4332",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "114.00294",
      "y1": "141.99708",
      "x2": "180.44043",
      "y2": "208.43457",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "86.00586",
      "y1": "170",
      "x2": "139.33798",
      "y2": "223.33212",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "170.00001",
      "y1": "86.00001",
      "x2": "223.33246",
      "y2": "139.33246",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "195.88225",
      "y1": "60.11775",
      "x2": "60.11775",
      "y2": "195.88225",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "142.00291",
      "y1": "113.99705",
      "x2": "208.43906",
      "y2": "180.4332",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "114.00294",
      "y1": "141.99708",
      "x2": "180.44043",
      "y2": "208.43457",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "86.00586",
      "y1": "170",
      "x2": "139.33798",
      "y2": "223.33212",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "170.00001",
      "y1": "86.00001",
      "x2": "223.33246",
      "y2": "139.33246",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3Y = [];
/* style */

const __vue_inject_styles__$3Y = undefined;
/* scoped */

const __vue_scope_id__$3Y = undefined;
/* module identifier */

const __vue_module_identifier__$3Y = undefined;
/* functional template */

const __vue_is_functional_template__$3Y = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3Y = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3Y,
  staticRenderFns: __vue_staticRenderFns__$3Y
}, __vue_inject_styles__$3Y, __vue_script__$3Y, __vue_scope_id__$3Y, __vue_is_functional_template__$3Y, __vue_module_identifier__$3Y, false, undefined, undefined, undefined);

var script$3Z = Vue.extend({
  name: "PhCircleWavy",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3Z = script$3Z;
/* template */

var __vue_render__$3Z = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M54.46089,201.53911c-9.204-9.204-3.09935-28.52745-7.78412-39.85C41.82037,149.95168,24,140.50492,24,127.99963,24,115.4945,41.82047,106.048,46.67683,94.31079c4.68477-11.32253-1.41993-30.6459,7.78406-39.8499s28.52746-3.09935,39.85-7.78412C106.04832,41.82037,115.49508,24,128.00037,24c12.50513,0,21.95163,17.82047,33.68884,22.67683,11.32253,4.68477,30.6459-1.41993,39.8499,7.78406s3.09935,28.52746,7.78412,39.85C214.17963,106.04832,232,115.49508,232,128.00037c0,12.50513-17.82047,21.95163-22.67683,33.68884-4.68477,11.32253,1.41993,30.6459-7.78406,39.8499s-28.52745,3.09935-39.85,7.78412C149.95168,214.17963,140.50492,232,127.99963,232c-12.50513,0-21.95163-17.82047-33.68884-22.67683C82.98826,204.6384,63.66489,210.7431,54.46089,201.53911Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M54.46089,201.53911c-9.204-9.204-3.09935-28.52745-7.78412-39.85C41.82037,149.95168,24,140.50492,24,127.99963,24,115.4945,41.82047,106.048,46.67683,94.31079c4.68477-11.32253-1.41993-30.6459,7.78406-39.8499s28.52746-3.09935,39.85-7.78412C106.04832,41.82037,115.49508,24,128.00037,24c12.50513,0,21.95163,17.82047,33.68884,22.67683,11.32253,4.68477,30.6459-1.41993,39.8499,7.78406s3.09935,28.52746,7.78412,39.85C214.17963,106.04832,232,115.49508,232,128.00037c0,12.50513-17.82047,21.95163-22.67683,33.68884-4.68477,11.32253,1.41993,30.6459-7.78406,39.8499s-28.52745,3.09935-39.85,7.78412C149.95168,214.17963,140.50492,232,127.99963,232c-12.50513,0-21.95163-17.82047-33.68884-22.67683C82.98826,204.6384,63.66489,210.7431,54.46089,201.53911Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M54.46089,201.53911c-9.204-9.204-3.09935-28.52745-7.78412-39.85C41.82037,149.95168,24,140.50492,24,127.99963,24,115.4945,41.82047,106.048,46.67683,94.31079c4.68477-11.32253-1.41993-30.6459,7.78406-39.8499s28.52746-3.09935,39.85-7.78412C106.04832,41.82037,115.49508,24,128.00037,24c12.50513,0,21.95163,17.82047,33.68884,22.67683,11.32253,4.68477,30.6459-1.41993,39.8499,7.78406s3.09935,28.52746,7.78412,39.85C214.17963,106.04832,232,115.49508,232,128.00037c0,12.50513-17.82047,21.95163-22.67683,33.68884-4.68477,11.32253,1.41993,30.6459-7.78406,39.8499s-28.52745,3.09935-39.85,7.78412C149.95168,214.17963,140.50492,232,127.99963,232c-12.50513,0-21.95163-17.82047-33.68884-22.67683C82.98826,204.6384,63.66489,210.7431,54.46089,201.53911Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M240,128c0,10.44238-7.51074,18.27441-14.1377,25.18457-3.77246,3.93359-7.67285,8-9.14648,11.56348-1.35449,3.27343-1.43652,8.69629-1.51562,13.93945-.14747,9.75879-.31446,20.81934-8.0044,28.50879-7.68945,7.68945-18.75,7.85644-28.5083,8.00391-5.24414.0791-10.667.16113-13.94043,1.51562-3.5625,1.47363-7.62988,5.374-11.5625,9.14648C146.27441,232.48926,138.44238,240,127.99951,240c-10.44238,0-18.27392-7.51074-25.18408-14.1377-3.93311-3.77246-8-7.67285-11.56348-9.14648-3.27295-1.35449-8.69531-1.43652-13.93945-1.51562-9.75879-.14747-20.81934-.31446-28.50879-8.00391s-7.85644-18.75-8.00391-28.50879c-.0791-5.24316-.16113-10.666-1.51562-13.93945-1.47363-3.56348-5.374-7.62989-9.14648-11.56348C23.51074,146.27441,16,138.44238,16,128s7.51074-18.27441,14.1377-25.18457c3.77246-3.93359,7.67285-8,9.14648-11.56348,1.35449-3.27343,1.43652-8.69629,1.51562-13.93945.14747-9.75879.31446-20.81934,8.0044-28.50879,7.68945-7.68945,18.75-7.85644,28.5083-8.00391,5.24414-.0791,10.667-.16113,13.94043-1.51562,3.5625-1.47363,7.62988-5.374,11.5625-9.14648C109.72559,23.51074,117.55762,16,128.00049,16c10.44238,0,18.27392,7.51074,25.18408,14.1377,3.93311,3.77246,8,7.67285,11.56348,9.14648,3.27295,1.35449,8.69531,1.43652,13.93945,1.51562,9.75879.14747,20.81934.31446,28.50879,8.00391s7.85644,18.75,8.00391,28.50879c.0791,5.24316.16113,10.666,1.51562,13.93945,1.47363,3.56348,5.374,7.62989,9.14648,11.56348C232.48926,109.72559,240,117.55762,240,128Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M54.46089,201.53911c-9.204-9.204-3.09935-28.52745-7.78412-39.85C41.82037,149.95168,24,140.50492,24,127.99963,24,115.4945,41.82047,106.048,46.67683,94.31079c4.68477-11.32253-1.41993-30.6459,7.78406-39.8499s28.52746-3.09935,39.85-7.78412C106.04832,41.82037,115.49508,24,128.00037,24c12.50513,0,21.95163,17.82047,33.68884,22.67683,11.32253,4.68477,30.6459-1.41993,39.8499,7.78406s3.09935,28.52746,7.78412,39.85C214.17963,106.04832,232,115.49508,232,128.00037c0,12.50513-17.82047,21.95163-22.67683,33.68884-4.68477,11.32253,1.41993,30.6459-7.78406,39.8499s-28.52745,3.09935-39.85,7.78412C149.95168,214.17963,140.50492,232,127.99963,232c-12.50513,0-21.95163-17.82047-33.68884-22.67683C82.98826,204.6384,63.66489,210.7431,54.46089,201.53911Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M54.46089,201.53911c-9.204-9.204-3.09935-28.52745-7.78412-39.85C41.82037,149.95168,24,140.50492,24,127.99963,24,115.4945,41.82047,106.048,46.67683,94.31079c4.68477-11.32253-1.41993-30.6459,7.78406-39.8499s28.52746-3.09935,39.85-7.78412C106.04832,41.82037,115.49508,24,128.00037,24c12.50513,0,21.95163,17.82047,33.68884,22.67683,11.32253,4.68477,30.6459-1.41993,39.8499,7.78406s3.09935,28.52746,7.78412,39.85C214.17963,106.04832,232,115.49508,232,128.00037c0,12.50513-17.82047,21.95163-22.67683,33.68884-4.68477,11.32253,1.41993,30.6459-7.78406,39.8499s-28.52745,3.09935-39.85,7.78412C149.95168,214.17963,140.50492,232,127.99963,232c-12.50513,0-21.95163-17.82047-33.68884-22.67683C82.98826,204.6384,63.66489,210.7431,54.46089,201.53911Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M54.46089,201.53911c-9.204-9.204-3.09935-28.52745-7.78412-39.85C41.82037,149.95168,24,140.50492,24,127.99963,24,115.4945,41.82047,106.048,46.67683,94.31079c4.68477-11.32253-1.41993-30.6459,7.78406-39.8499s28.52746-3.09935,39.85-7.78412C106.04832,41.82037,115.49508,24,128.00037,24c12.50513,0,21.95163,17.82047,33.68884,22.67683,11.32253,4.68477,30.6459-1.41993,39.8499,7.78406s3.09935,28.52746,7.78412,39.85C214.17963,106.04832,232,115.49508,232,128.00037c0,12.50513-17.82047,21.95163-22.67683,33.68884-4.68477,11.32253,1.41993,30.6459-7.78406,39.8499s-28.52745,3.09935-39.85,7.78412C149.95168,214.17963,140.50492,232,127.99963,232c-12.50513,0-21.95163-17.82047-33.68884-22.67683C82.98826,204.6384,63.66489,210.7431,54.46089,201.53911Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3Z = [];
/* style */

const __vue_inject_styles__$3Z = undefined;
/* scoped */

const __vue_scope_id__$3Z = undefined;
/* module identifier */

const __vue_module_identifier__$3Z = undefined;
/* functional template */

const __vue_is_functional_template__$3Z = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3Z = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3Z,
  staticRenderFns: __vue_staticRenderFns__$3Z
}, __vue_inject_styles__$3Z, __vue_script__$3Z, __vue_scope_id__$3Z, __vue_is_functional_template__$3Z, __vue_module_identifier__$3Z, false, undefined, undefined, undefined);

var script$3_ = Vue.extend({
  name: "PhCircleWavyCheck",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3_ = script$3_;
/* template */

var __vue_render__$3_ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M54.46089,201.53911c-9.204-9.204-3.09935-28.52745-7.78412-39.85C41.82037,149.95168,24,140.50492,24,127.99963,24,115.4945,41.82047,106.048,46.67683,94.31079c4.68477-11.32253-1.41993-30.6459,7.78406-39.8499s28.52746-3.09935,39.85-7.78412C106.04832,41.82037,115.49508,24,128.00037,24c12.50513,0,21.95163,17.82047,33.68884,22.67683,11.32253,4.68477,30.6459-1.41993,39.8499,7.78406s3.09935,28.52746,7.78412,39.85C214.17963,106.04832,232,115.49508,232,128.00037c0,12.50513-17.82047,21.95163-22.67683,33.68884-4.68477,11.32253,1.41993,30.6459-7.78406,39.8499s-28.52745,3.09935-39.85,7.78412C149.95168,214.17963,140.50492,232,127.99963,232c-12.50513,0-21.95163-17.82047-33.68884-22.67683C82.98826,204.6384,63.66489,210.7431,54.46089,201.53911Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "172 104 113.333 160 84 132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M54.46089,201.53911c-9.204-9.204-3.09935-28.52745-7.78412-39.85C41.82037,149.95168,24,140.50492,24,127.99963,24,115.4945,41.82047,106.048,46.67683,94.31079c4.68477-11.32253-1.41993-30.6459,7.78406-39.8499s28.52746-3.09935,39.85-7.78412C106.04832,41.82037,115.49508,24,128.00037,24c12.50513,0,21.95163,17.82047,33.68884,22.67683,11.32253,4.68477,30.6459-1.41993,39.8499,7.78406s3.09935,28.52746,7.78412,39.85C214.17963,106.04832,232,115.49508,232,128.00037c0,12.50513-17.82047,21.95163-22.67683,33.68884-4.68477,11.32253,1.41993,30.6459-7.78406,39.8499s-28.52745,3.09935-39.85,7.78412C149.95168,214.17963,140.50492,232,127.99963,232c-12.50513,0-21.95163-17.82047-33.68884-22.67683C82.98826,204.6384,63.66489,210.7431,54.46089,201.53911Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M54.46089,201.53911c-9.204-9.204-3.09935-28.52745-7.78412-39.85C41.82037,149.95168,24,140.50492,24,127.99963,24,115.4945,41.82047,106.048,46.67683,94.31079c4.68477-11.32253-1.41993-30.6459,7.78406-39.8499s28.52746-3.09935,39.85-7.78412C106.04832,41.82037,115.49508,24,128.00037,24c12.50513,0,21.95163,17.82047,33.68884,22.67683,11.32253,4.68477,30.6459-1.41993,39.8499,7.78406s3.09935,28.52746,7.78412,39.85C214.17963,106.04832,232,115.49508,232,128.00037c0,12.50513-17.82047,21.95163-22.67683,33.68884-4.68477,11.32253,1.41993,30.6459-7.78406,39.8499s-28.52745,3.09935-39.85,7.78412C149.95168,214.17963,140.50492,232,127.99963,232c-12.50513,0-21.95163-17.82047-33.68884-22.67683C82.98826,204.6384,63.66489,210.7431,54.46089,201.53911Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "172 104 113.333 160 84 132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M225.8623,102.81543c-3.77246-3.93359-7.67285-8-9.14648-11.56348-1.35449-3.27343-1.43652-8.69531-1.51562-13.93945-.14747-9.75879-.31446-20.81934-8.00391-28.50879s-18.75-7.85644-28.50879-8.00391c-5.24414-.0791-10.666-.16113-13.93945-1.51562-3.5625-1.47363-7.62989-5.374-11.56348-9.14648C146.27539,23.51074,138.44238,16,128,16s-18.27441,7.51074-25.18457,14.1377c-3.93359,3.77246-8,7.67285-11.56348,9.14648-3.27343,1.35449-8.69531,1.43652-13.93945,1.51562-9.75879.14747-20.81934.31446-28.50879,8.00391s-7.85644,18.75-8.00391,28.50879c-.0791,5.24414-.16113,10.666-1.51562,13.93945-1.47363,3.5625-5.374,7.62989-9.14648,11.56348C23.51074,109.72461,16,117.55762,16,128s7.51074,18.27441,14.1377,25.18457c3.77246,3.93359,7.67285,8,9.14648,11.56348,1.35449,3.27343,1.43652,8.69531,1.51562,13.93945.14747,9.75879.31446,20.81934,8.00391,28.50879s18.75,7.85644,28.50879,8.00391c5.24414.0791,10.666.16113,13.93945,1.51562,3.5625,1.47363,7.62989,5.374,11.56348,9.14648C109.72461,232.48926,117.55762,240,128,240s18.27441-7.51074,25.18457-14.1377c3.93359-3.77246,8-7.67285,11.56348-9.14648,3.27343-1.35449,8.69531-1.43652,13.93945-1.51562,9.75879-.14747,20.81934-.31446,28.50879-8.00391s7.85644-18.75,8.00391-28.50879c.0791-5.24414.16113-10.666,1.51562-13.93945,1.47363-3.5625,5.374-7.62989,9.14648-11.56348C232.48926,146.27539,240,138.44238,240,128S232.48926,109.72559,225.8623,102.81543Zm-48.33886,6.97168-58.667,56a7.99978,7.99978,0,0,1-11.04688,0l-29.333-28a7.99994,7.99994,0,1,1,11.04688-11.57422L113.333,148.94043l53.14355-50.72754a7.99994,7.99994,0,1,1,11.04688,11.57422Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M54.46089,201.53911c-9.204-9.204-3.09935-28.52745-7.78412-39.85C41.82037,149.95168,24,140.50492,24,127.99963,24,115.4945,41.82047,106.048,46.67683,94.31079c4.68477-11.32253-1.41993-30.6459,7.78406-39.8499s28.52746-3.09935,39.85-7.78412C106.04832,41.82037,115.49508,24,128.00037,24c12.50513,0,21.95163,17.82047,33.68884,22.67683,11.32253,4.68477,30.6459-1.41993,39.8499,7.78406s3.09935,28.52746,7.78412,39.85C214.17963,106.04832,232,115.49508,232,128.00037c0,12.50513-17.82047,21.95163-22.67683,33.68884-4.68477,11.32253,1.41993,30.6459-7.78406,39.8499s-28.52745,3.09935-39.85,7.78412C149.95168,214.17963,140.50492,232,127.99963,232c-12.50513,0-21.95163-17.82047-33.68884-22.67683C82.98826,204.6384,63.66489,210.7431,54.46089,201.53911Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "172 104 113.333 160 84 132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M54.46089,201.53911c-9.204-9.204-3.09935-28.52745-7.78412-39.85C41.82037,149.95168,24,140.50492,24,127.99963,24,115.4945,41.82047,106.048,46.67683,94.31079c4.68477-11.32253-1.41993-30.6459,7.78406-39.8499s28.52746-3.09935,39.85-7.78412C106.04832,41.82037,115.49508,24,128.00037,24c12.50513,0,21.95163,17.82047,33.68884,22.67683,11.32253,4.68477,30.6459-1.41993,39.8499,7.78406s3.09935,28.52746,7.78412,39.85C214.17963,106.04832,232,115.49508,232,128.00037c0,12.50513-17.82047,21.95163-22.67683,33.68884-4.68477,11.32253,1.41993,30.6459-7.78406,39.8499s-28.52745,3.09935-39.85,7.78412C149.95168,214.17963,140.50492,232,127.99963,232c-12.50513,0-21.95163-17.82047-33.68884-22.67683C82.98826,204.6384,63.66489,210.7431,54.46089,201.53911Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "172 104 113.333 160 84 132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M54.46089,201.53911c-9.204-9.204-3.09935-28.52745-7.78412-39.85C41.82037,149.95168,24,140.50492,24,127.99963,24,115.4945,41.82047,106.048,46.67683,94.31079c4.68477-11.32253-1.41993-30.6459,7.78406-39.8499s28.52746-3.09935,39.85-7.78412C106.04832,41.82037,115.49508,24,128.00037,24c12.50513,0,21.95163,17.82047,33.68884,22.67683,11.32253,4.68477,30.6459-1.41993,39.8499,7.78406s3.09935,28.52746,7.78412,39.85C214.17963,106.04832,232,115.49508,232,128.00037c0,12.50513-17.82047,21.95163-22.67683,33.68884-4.68477,11.32253,1.41993,30.6459-7.78406,39.8499s-28.52745,3.09935-39.85,7.78412C149.95168,214.17963,140.50492,232,127.99963,232c-12.50513,0-21.95163-17.82047-33.68884-22.67683C82.98826,204.6384,63.66489,210.7431,54.46089,201.53911Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "172 104 113.333 160 84 132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3_ = [];
/* style */

const __vue_inject_styles__$3_ = undefined;
/* scoped */

const __vue_scope_id__$3_ = undefined;
/* module identifier */

const __vue_module_identifier__$3_ = undefined;
/* functional template */

const __vue_is_functional_template__$3_ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3_ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3_,
  staticRenderFns: __vue_staticRenderFns__$3_
}, __vue_inject_styles__$3_, __vue_script__$3_, __vue_scope_id__$3_, __vue_is_functional_template__$3_, __vue_module_identifier__$3_, false, undefined, undefined, undefined);

var script$3$ = Vue.extend({
  name: "PhCircleWavyQuestion",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3$ = script$3$;
/* template */

var __vue_render__$3$ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M54.46089,201.53911c-9.204-9.204-3.09935-28.52745-7.78412-39.85C41.82037,149.95168,24,140.50492,24,127.99963,24,115.4945,41.82047,106.048,46.67683,94.31079c4.68477-11.32253-1.41993-30.6459,7.78406-39.8499s28.52746-3.09935,39.85-7.78412C106.04832,41.82037,115.49508,24,128.00037,24c12.50513,0,21.95163,17.82047,33.68884,22.67683,11.32253,4.68477,30.6459-1.41993,39.8499,7.78406s3.09935,28.52746,7.78412,39.85C214.17963,106.04832,232,115.49508,232,128.00037c0,12.50513-17.82047,21.95163-22.67683,33.68884-4.68477,11.32253,1.41993,30.6459-7.78406,39.8499s-28.52745,3.09935-39.85,7.78412C149.95168,214.17963,140.50492,232,127.99963,232c-12.50513,0-21.95163-17.82047-33.68884-22.67683C82.98826,204.6384,63.66489,210.7431,54.46089,201.53911Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "127.99854",
      "cy": "176",
      "r": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M127.9995,136.0045a28,28,0,1,0-28-28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M54.46089,201.53911c-9.204-9.204-3.09935-28.52745-7.78412-39.85C41.82037,149.95168,24,140.50492,24,127.99963,24,115.4945,41.82047,106.048,46.67683,94.31079c4.68477-11.32253-1.41993-30.6459,7.78406-39.8499s28.52746-3.09935,39.85-7.78412C106.04832,41.82037,115.49508,24,128.00037,24c12.50513,0,21.95163,17.82047,33.68884,22.67683,11.32253,4.68477,30.6459-1.41993,39.8499,7.78406s3.09935,28.52746,7.78412,39.85C214.17963,106.04832,232,115.49508,232,128.00037c0,12.50513-17.82047,21.95163-22.67683,33.68884-4.68477,11.32253,1.41993,30.6459-7.78406,39.8499s-28.52745,3.09935-39.85,7.78412C149.95168,214.17963,140.50492,232,127.99963,232c-12.50513,0-21.95163-17.82047-33.68884-22.67683C82.98826,204.6384,63.66489,210.7431,54.46089,201.53911Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M54.46089,201.53911c-9.204-9.204-3.09935-28.52745-7.78412-39.85C41.82037,149.95168,24,140.50492,24,127.99963,24,115.4945,41.82047,106.048,46.67683,94.31079c4.68477-11.32253-1.41993-30.6459,7.78406-39.8499s28.52746-3.09935,39.85-7.78412C106.04832,41.82037,115.49508,24,128.00037,24c12.50513,0,21.95163,17.82047,33.68884,22.67683,11.32253,4.68477,30.6459-1.41993,39.8499,7.78406s3.09935,28.52746,7.78412,39.85C214.17963,106.04832,232,115.49508,232,128.00037c0,12.50513-17.82047,21.95163-22.67683,33.68884-4.68477,11.32253,1.41993,30.6459-7.78406,39.8499s-28.52745,3.09935-39.85,7.78412C149.95168,214.17963,140.50492,232,127.99963,232c-12.50513,0-21.95163-17.82047-33.68884-22.67683C82.98826,204.6384,63.66489,210.7431,54.46089,201.53911Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "180",
      "r": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M127.9995,144.0045v-8a28,28,0,1,0-28-28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M225.8623,102.81543c-3.77246-3.93359-7.67285-8-9.14648-11.56348-1.35449-3.27343-1.43652-8.69531-1.51562-13.93945-.14747-9.75879-.31446-20.81934-8.00391-28.50879s-18.75-7.85644-28.50879-8.00391c-5.24414-.0791-10.666-.16113-13.93945-1.51562-3.5625-1.47363-7.62989-5.374-11.56348-9.14648C146.27539,23.51074,138.44238,16,128,16s-18.27441,7.51074-25.18457,14.1377c-3.93359,3.77246-8,7.67285-11.56348,9.14648-3.27343,1.35449-8.69531,1.43652-13.93945,1.51562-9.75879.14747-20.81934.31446-28.50879,8.00391s-7.85644,18.75-8.00391,28.50879c-.0791,5.24414-.16113,10.666-1.51562,13.93945-1.47363,3.5625-5.374,7.62989-9.14648,11.56348C23.51074,109.72461,16,117.55762,16,128s7.51074,18.27441,14.1377,25.18457c3.77246,3.93359,7.67285,8,9.14648,11.56348,1.35449,3.27343,1.43652,8.69531,1.51562,13.93945.14747,9.75879.31446,20.81934,8.00391,28.50879s18.75,7.85644,28.50879,8.00391c5.24414.0791,10.666.16113,13.93945,1.51562,3.5625,1.47363,7.62989,5.374,11.56348,9.14648C109.72461,232.48926,117.55762,240,128,240s18.27441-7.51074,25.18457-14.1377c3.93359-3.77246,8-7.67285,11.56348-9.14648,3.27343-1.35449,8.69531-1.43652,13.93945-1.51562,9.75879-.14747,20.81934-.31446,28.50879-8.00391s7.85644-18.75,8.00391-28.50879c.0791-5.24414.16113-10.666,1.51562-13.93945,1.47363-3.5625,5.374-7.62989,9.14648-11.56348C232.48926,146.27539,240,138.44238,240,128S232.48926,109.72559,225.8623,102.81543ZM128,192a12,12,0,1,1,12-12A12,12,0,0,1,128,192Zm7.999-48.89063v.89551a8,8,0,0,1-16,0v-8a8.00039,8.00039,0,0,1,8-8,20,20,0,1,0-20-20,8,8,0,0,1-16,0,36,36,0,1,1,44,35.10449Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M54.46089,201.53911c-9.204-9.204-3.09935-28.52745-7.78412-39.85C41.82037,149.95168,24,140.50492,24,127.99963,24,115.4945,41.82047,106.048,46.67683,94.31079c4.68477-11.32253-1.41993-30.6459,7.78406-39.8499s28.52746-3.09935,39.85-7.78412C106.04832,41.82037,115.49508,24,128.00037,24c12.50513,0,21.95163,17.82047,33.68884,22.67683,11.32253,4.68477,30.6459-1.41993,39.8499,7.78406s3.09935,28.52746,7.78412,39.85C214.17963,106.04832,232,115.49508,232,128.00037c0,12.50513-17.82047,21.95163-22.67683,33.68884-4.68477,11.32253,1.41993,30.6459-7.78406,39.8499s-28.52745,3.09935-39.85,7.78412C149.95168,214.17963,140.50492,232,127.99963,232c-12.50513,0-21.95163-17.82047-33.68884-22.67683C82.98826,204.6384,63.66489,210.7431,54.46089,201.53911Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "127.99902",
      "cy": "180",
      "r": "10"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M127.9995,144.0045v-8a28,28,0,1,0-28-28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M54.46089,201.53911c-9.204-9.204-3.09935-28.52745-7.78412-39.85C41.82037,149.95168,24,140.50492,24,127.99963,24,115.4945,41.82047,106.048,46.67683,94.31079c4.68477-11.32253-1.41993-30.6459,7.78406-39.8499s28.52746-3.09935,39.85-7.78412C106.04832,41.82037,115.49508,24,128.00037,24c12.50513,0,21.95163,17.82047,33.68884,22.67683,11.32253,4.68477,30.6459-1.41993,39.8499,7.78406s3.09935,28.52746,7.78412,39.85C214.17963,106.04832,232,115.49508,232,128.00037c0,12.50513-17.82047,21.95163-22.67683,33.68884-4.68477,11.32253,1.41993,30.6459-7.78406,39.8499s-28.52745,3.09935-39.85,7.78412C149.95168,214.17963,140.50492,232,127.99963,232c-12.50513,0-21.95163-17.82047-33.68884-22.67683C82.98826,204.6384,63.66489,210.7431,54.46089,201.53911Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "127.99951",
      "cy": "180",
      "r": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M127.9995,144.0045v-8a28,28,0,1,0-28-28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M54.46089,201.53911c-9.204-9.204-3.09935-28.52745-7.78412-39.85C41.82037,149.95168,24,140.50492,24,127.99963,24,115.4945,41.82047,106.048,46.67683,94.31079c4.68477-11.32253-1.41993-30.6459,7.78406-39.8499s28.52746-3.09935,39.85-7.78412C106.04832,41.82037,115.49508,24,128.00037,24c12.50513,0,21.95163,17.82047,33.68884,22.67683,11.32253,4.68477,30.6459-1.41993,39.8499,7.78406s3.09935,28.52746,7.78412,39.85C214.17963,106.04832,232,115.49508,232,128.00037c0,12.50513-17.82047,21.95163-22.67683,33.68884-4.68477,11.32253,1.41993,30.6459-7.78406,39.8499s-28.52745,3.09935-39.85,7.78412C149.95168,214.17963,140.50492,232,127.99963,232c-12.50513,0-21.95163-17.82047-33.68884-22.67683C82.98826,204.6384,63.66489,210.7431,54.46089,201.53911Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "180",
      "r": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M127.9995,144.0045v-8a28,28,0,1,0-28-28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3$ = [];
/* style */

const __vue_inject_styles__$3$ = undefined;
/* scoped */

const __vue_scope_id__$3$ = undefined;
/* module identifier */

const __vue_module_identifier__$3$ = undefined;
/* functional template */

const __vue_is_functional_template__$3$ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3$ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3$,
  staticRenderFns: __vue_staticRenderFns__$3$
}, __vue_inject_styles__$3$, __vue_script__$3$, __vue_scope_id__$3$, __vue_is_functional_template__$3$, __vue_module_identifier__$3$, false, undefined, undefined, undefined);

var script$40 = Vue.extend({
  name: "PhCircleWavyWarning",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$40 = script$40;
/* template */

var __vue_render__$40 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M54.46089,201.53911c-9.204-9.204-3.09935-28.52745-7.78412-39.85C41.82037,149.95168,24,140.50492,24,127.99963,24,115.4945,41.82047,106.048,46.67683,94.31079c4.68477-11.32253-1.41993-30.6459,7.78406-39.8499s28.52746-3.09935,39.85-7.78412C106.04832,41.82037,115.49508,24,128.00037,24c12.50513,0,21.95163,17.82047,33.68884,22.67683,11.32253,4.68477,30.6459-1.41993,39.8499,7.78406s3.09935,28.52746,7.78412,39.85C214.17963,106.04832,232,115.49508,232,128.00037c0,12.50513-17.82047,21.95163-22.67683,33.68884-4.68477,11.32253,1.41993,30.6459-7.78406,39.8499s-28.52745,3.09935-39.85,7.78412C149.95168,214.17963,140.50492,232,127.99963,232c-12.50513,0-21.95163-17.82047-33.68884-22.67683C82.98826,204.6384,63.66489,210.7431,54.46089,201.53911Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "127.99951",
      "y1": "80",
      "x2": "127.99951",
      "y2": "132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "127.99951",
      "cy": "172",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M54.46089,201.53911c-9.204-9.204-3.09935-28.52745-7.78412-39.85C41.82037,149.95168,24,140.50492,24,127.99963,24,115.4945,41.82047,106.048,46.67683,94.31079c4.68477-11.32253-1.41993-30.6459,7.78406-39.8499s28.52746-3.09935,39.85-7.78412C106.04832,41.82037,115.49508,24,128.00037,24c12.50513,0,21.95163,17.82047,33.68884,22.67683,11.32253,4.68477,30.6459-1.41993,39.8499,7.78406s3.09935,28.52746,7.78412,39.85C214.17963,106.04832,232,115.49508,232,128.00037c0,12.50513-17.82047,21.95163-22.67683,33.68884-4.68477,11.32253,1.41993,30.6459-7.78406,39.8499s-28.52745,3.09935-39.85,7.78412C149.95168,214.17963,140.50492,232,127.99963,232c-12.50513,0-21.95163-17.82047-33.68884-22.67683C82.98826,204.6384,63.66489,210.7431,54.46089,201.53911Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M54.46089,201.53911c-9.204-9.204-3.09935-28.52745-7.78412-39.85C41.82037,149.95168,24,140.50492,24,127.99963,24,115.4945,41.82047,106.048,46.67683,94.31079c4.68477-11.32253-1.41993-30.6459,7.78406-39.8499s28.52746-3.09935,39.85-7.78412C106.04832,41.82037,115.49508,24,128.00037,24c12.50513,0,21.95163,17.82047,33.68884,22.67683,11.32253,4.68477,30.6459-1.41993,39.8499,7.78406s3.09935,28.52746,7.78412,39.85C214.17963,106.04832,232,115.49508,232,128.00037c0,12.50513-17.82047,21.95163-22.67683,33.68884-4.68477,11.32253,1.41993,30.6459-7.78406,39.8499s-28.52745,3.09935-39.85,7.78412C149.95168,214.17963,140.50492,232,127.99963,232c-12.50513,0-21.95163-17.82047-33.68884-22.67683C82.98826,204.6384,63.66489,210.7431,54.46089,201.53911Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "127.99951",
      "y1": "80",
      "x2": "127.99951",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "127.99951",
      "cy": "172",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M225.8623,102.81543c-3.77246-3.93359-7.67285-8-9.14648-11.56348-1.35449-3.27343-1.43652-8.69531-1.51562-13.93945-.14747-9.75879-.31446-20.81934-8.00391-28.50879s-18.75-7.85644-28.50879-8.00391c-5.24414-.0791-10.666-.16113-13.93945-1.51562-3.5625-1.47363-7.62989-5.374-11.56348-9.14648C146.27539,23.51074,138.44238,16,128,16s-18.27441,7.51074-25.18457,14.1377c-3.93359,3.77246-8,7.67285-11.56348,9.14648-3.27343,1.35449-8.69531,1.43652-13.93945,1.51562-9.75879.14747-20.81934.31446-28.50879,8.00391s-7.85644,18.75-8.00391,28.50879c-.0791,5.24414-.16113,10.666-1.51562,13.93945-1.47363,3.5625-5.374,7.62989-9.14648,11.56348C23.51074,109.72461,16,117.55762,16,128s7.51074,18.27441,14.1377,25.18457c3.77246,3.93359,7.67285,8,9.14648,11.56348,1.35449,3.27343,1.43652,8.69531,1.51562,13.93945.14747,9.75879.31446,20.81934,8.00391,28.50879s18.75,7.85644,28.50879,8.00391c5.24414.0791,10.666.16113,13.93945,1.51562,3.5625,1.47363,7.62989,5.374,11.56348,9.14648C109.72461,232.48926,117.55762,240,128,240s18.27441-7.51074,25.18457-14.1377c3.93359-3.77246,8-7.67285,11.56348-9.14648,3.27343-1.35449,8.69531-1.43652,13.93945-1.51562,9.75879-.14747,20.81934-.31446,28.50879-8.00391s7.85644-18.75,8.00391-28.50879c.0791-5.24414.16113-10.666,1.51562-13.93945,1.47363-3.5625,5.374-7.62989,9.14648-11.56348C232.48926,146.27539,240,138.44238,240,128S232.48926,109.72559,225.8623,102.81543ZM119.999,80a8,8,0,0,1,16,0v56a8,8,0,0,1-16,0Zm8.00049,104a12,12,0,1,1,12-12A12,12,0,0,1,127.99951,184Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M54.46089,201.53911c-9.204-9.204-3.09935-28.52745-7.78412-39.85C41.82037,149.95168,24,140.50492,24,127.99963,24,115.4945,41.82047,106.048,46.67683,94.31079c4.68477-11.32253-1.41993-30.6459,7.78406-39.8499s28.52746-3.09935,39.85-7.78412C106.04832,41.82037,115.49508,24,128.00037,24c12.50513,0,21.95163,17.82047,33.68884,22.67683,11.32253,4.68477,30.6459-1.41993,39.8499,7.78406s3.09935,28.52746,7.78412,39.85C214.17963,106.04832,232,115.49508,232,128.00037c0,12.50513-17.82047,21.95163-22.67683,33.68884-4.68477,11.32253,1.41993,30.6459-7.78406,39.8499s-28.52745,3.09935-39.85,7.78412C149.95168,214.17963,140.50492,232,127.99963,232c-12.50513,0-21.95163-17.82047-33.68884-22.67683C82.98826,204.6384,63.66489,210.7431,54.46089,201.53911Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "127.99951",
      "y1": "80",
      "x2": "127.99951",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "127.99951",
      "cy": "172",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M54.46089,201.53911c-9.204-9.204-3.09935-28.52745-7.78412-39.85C41.82037,149.95168,24,140.50492,24,127.99963,24,115.4945,41.82047,106.048,46.67683,94.31079c4.68477-11.32253-1.41993-30.6459,7.78406-39.8499s28.52746-3.09935,39.85-7.78412C106.04832,41.82037,115.49508,24,128.00037,24c12.50513,0,21.95163,17.82047,33.68884,22.67683,11.32253,4.68477,30.6459-1.41993,39.8499,7.78406s3.09935,28.52746,7.78412,39.85C214.17963,106.04832,232,115.49508,232,128.00037c0,12.50513-17.82047,21.95163-22.67683,33.68884-4.68477,11.32253,1.41993,30.6459-7.78406,39.8499s-28.52745,3.09935-39.85,7.78412C149.95168,214.17963,140.50492,232,127.99963,232c-12.50513,0-21.95163-17.82047-33.68884-22.67683C82.98826,204.6384,63.66489,210.7431,54.46089,201.53911Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "127.99951",
      "y1": "80",
      "x2": "127.99951",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "127.99951",
      "cy": "172",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M54.46089,201.53911c-9.204-9.204-3.09935-28.52745-7.78412-39.85C41.82037,149.95168,24,140.50492,24,127.99963,24,115.4945,41.82047,106.048,46.67683,94.31079c4.68477-11.32253-1.41993-30.6459,7.78406-39.8499s28.52746-3.09935,39.85-7.78412C106.04832,41.82037,115.49508,24,128.00037,24c12.50513,0,21.95163,17.82047,33.68884,22.67683,11.32253,4.68477,30.6459-1.41993,39.8499,7.78406s3.09935,28.52746,7.78412,39.85C214.17963,106.04832,232,115.49508,232,128.00037c0,12.50513-17.82047,21.95163-22.67683,33.68884-4.68477,11.32253,1.41993,30.6459-7.78406,39.8499s-28.52745,3.09935-39.85,7.78412C149.95168,214.17963,140.50492,232,127.99963,232c-12.50513,0-21.95163-17.82047-33.68884-22.67683C82.98826,204.6384,63.66489,210.7431,54.46089,201.53911Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "80",
      "x2": "128",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "172",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$40 = [];
/* style */

const __vue_inject_styles__$40 = undefined;
/* scoped */

const __vue_scope_id__$40 = undefined;
/* module identifier */

const __vue_module_identifier__$40 = undefined;
/* functional template */

const __vue_is_functional_template__$40 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$40 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$40,
  staticRenderFns: __vue_staticRenderFns__$40
}, __vue_inject_styles__$40, __vue_script__$40, __vue_scope_id__$40, __vue_is_functional_template__$40, __vue_module_identifier__$40, false, undefined, undefined, undefined);

var script$41 = Vue.extend({
  name: "PhCirclesFour",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$41 = script$41;
/* template */

var __vue_render__$41 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "74",
      "cy": "74",
      "r": "34",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "182",
      "cy": "74",
      "r": "34",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "74",
      "cy": "182",
      "r": "34",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "182",
      "cy": "182",
      "r": "34",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "76",
      "cy": "180",
      "r": "36",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "76",
      "cy": "76",
      "r": "36",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "76",
      "r": "36",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "180",
      "r": "36",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "76",
      "cy": "76",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "76",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "180",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "76",
      "cy": "180",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('circle', {
    attrs: {
      "cx": "76",
      "cy": "76",
      "r": "44"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "76",
      "r": "44"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "76",
      "cy": "180",
      "r": "44"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "180",
      "r": "44"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "76",
      "cy": "76",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "76",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "76",
      "cy": "180",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "180",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "76",
      "cy": "76",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "76",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "76",
      "cy": "180",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "180",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "76",
      "cy": "76",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "76",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "76",
      "cy": "180",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "180",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$41 = [];
/* style */

const __vue_inject_styles__$41 = undefined;
/* scoped */

const __vue_scope_id__$41 = undefined;
/* module identifier */

const __vue_module_identifier__$41 = undefined;
/* functional template */

const __vue_is_functional_template__$41 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$41 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$41,
  staticRenderFns: __vue_staticRenderFns__$41
}, __vue_inject_styles__$41, __vue_script__$41, __vue_scope_id__$41, __vue_is_functional_template__$41, __vue_module_identifier__$41, false, undefined, undefined, undefined);

var script$42 = Vue.extend({
  name: "PhCirclesThree",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$42 = script$42;
/* template */

var __vue_render__$42 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "68",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "172",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "172",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "68",
      "r": "40",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "172",
      "r": "40",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "172",
      "r": "40",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "68",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "172",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "172",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "68",
      "r": "48"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "172",
      "r": "48"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "172",
      "r": "48"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "68",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "172",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "172",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "68",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "172",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "172",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "68",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "172",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "172",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$42 = [];
/* style */

const __vue_inject_styles__$42 = undefined;
/* scoped */

const __vue_scope_id__$42 = undefined;
/* module identifier */

const __vue_module_identifier__$42 = undefined;
/* functional template */

const __vue_is_functional_template__$42 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$42 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$42,
  staticRenderFns: __vue_staticRenderFns__$42
}, __vue_inject_styles__$42, __vue_script__$42, __vue_scope_id__$42, __vue_is_functional_template__$42, __vue_module_identifier__$42, false, undefined, undefined, undefined);

var script$43 = Vue.extend({
  name: "PhCirclesThreePlus",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$43 = script$43;
/* template */

var __vue_render__$43 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "74",
      "cy": "74",
      "r": "34",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "182",
      "cy": "74",
      "r": "34",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "74",
      "cy": "182",
      "r": "34",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('g', [_c('line', {
    attrs: {
      "x1": "182",
      "y1": "156",
      "x2": "182",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "182",
      "x2": "156",
      "y2": "182",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })])]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "76",
      "cy": "76",
      "r": "36",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "76",
      "r": "36",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "76",
      "cy": "180",
      "r": "36",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "76",
      "cy": "76",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "76",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "76",
      "cy": "180",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "180",
      "y1": "152",
      "x2": "180",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "180",
      "x2": "152",
      "y2": "180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('circle', {
    attrs: {
      "cx": "76",
      "cy": "76",
      "r": "44"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "76",
      "r": "44"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "76",
      "cy": "180",
      "r": "44"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,172H188V152a8,8,0,0,0-16,0v20H152a8,8,0,0,0,0,16h20v20a8,8,0,0,0,16,0V188h20a8,8,0,0,0,0-16Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "76",
      "cy": "76",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "76",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "76",
      "cy": "180",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "180",
      "y1": "152",
      "x2": "180",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "180",
      "x2": "152",
      "y2": "180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "76",
      "cy": "76",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "76",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "76",
      "cy": "180",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "180",
      "y1": "152",
      "x2": "180",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "180",
      "x2": "152",
      "y2": "180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "76",
      "cy": "76",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "76",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "76",
      "cy": "180",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "180",
      "y1": "152",
      "x2": "180",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "180",
      "x2": "152",
      "y2": "180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$43 = [];
/* style */

const __vue_inject_styles__$43 = undefined;
/* scoped */

const __vue_scope_id__$43 = undefined;
/* module identifier */

const __vue_module_identifier__$43 = undefined;
/* functional template */

const __vue_is_functional_template__$43 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$43 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$43,
  staticRenderFns: __vue_staticRenderFns__$43
}, __vue_inject_styles__$43, __vue_script__$43, __vue_scope_id__$43, __vue_is_functional_template__$43, __vue_module_identifier__$43, false, undefined, undefined, undefined);

var script$44 = Vue.extend({
  name: "PhClipboard",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$44 = script$44;
/* template */

var __vue_render__$44 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M160.00194,40H200a8,8,0,0,1,8,8V216a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H95.99783",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,72V64a40,40,0,0,1,80,0v8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M160.00049,40A39.82135,39.82135,0,0,1,168,64v8H88V64a39.82135,39.82135,0,0,1,7.99951-24H56a7.99977,7.99977,0,0,0-8,8V216a7.99977,7.99977,0,0,0,8,8H200a7.99977,7.99977,0,0,0,8-8V48a7.99977,7.99977,0,0,0-8-8Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160.00194,40H200a8,8,0,0,1,8,8V216a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H95.99783",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,72V64a40,40,0,0,1,80,0v8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,32H163.73877a47.91437,47.91437,0,0,0-71.47754,0H56A16.01833,16.01833,0,0,0,40,48V216a16.01833,16.01833,0,0,0,16,16H200a16.01833,16.01833,0,0,0,16-16V48A16.01833,16.01833,0,0,0,200,32Zm-72,0a32.03667,32.03667,0,0,1,32,32H96A32.03667,32.03667,0,0,1,128,32Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M160.00194,40H200a8,8,0,0,1,8,8V216a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H95.99783",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,72V64a40,40,0,0,1,80,0v8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M160.00194,40H200a8,8,0,0,1,8,8V216a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H95.99783",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,72V64a40,40,0,0,1,80,0v8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M160.00194,40H200a8,8,0,0,1,8,8V216a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H95.99783",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,72V64a40,40,0,0,1,80,0v8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$44 = [];
/* style */

const __vue_inject_styles__$44 = undefined;
/* scoped */

const __vue_scope_id__$44 = undefined;
/* module identifier */

const __vue_module_identifier__$44 = undefined;
/* functional template */

const __vue_is_functional_template__$44 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$44 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$44,
  staticRenderFns: __vue_staticRenderFns__$44
}, __vue_inject_styles__$44, __vue_script__$44, __vue_scope_id__$44, __vue_is_functional_template__$44, __vue_module_identifier__$44, false, undefined, undefined, undefined);

var script$45 = Vue.extend({
  name: "PhClipboardText",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$45 = script$45;
/* template */

var __vue_render__$45 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "156",
      "x2": "160",
      "y2": "156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "116",
      "x2": "160",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160.00194,40H200a8,8,0,0,1,8,8V216a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H95.99783",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,72V64a40,40,0,0,1,80,0v8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M160.00049,40A39.82135,39.82135,0,0,1,168,64v8H88V64a39.82135,39.82135,0,0,1,7.99951-24H56a7.99977,7.99977,0,0,0-8,8V216a7.99977,7.99977,0,0,0,8,8H200a7.99977,7.99977,0,0,0,8-8V48a7.99977,7.99977,0,0,0-8-8Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "152",
      "x2": "160",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "120",
      "x2": "160",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160.00194,40H200a8,8,0,0,1,8,8V216a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H95.99783",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,72V64a40,40,0,0,1,80,0v8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,32H163.73877a47.91437,47.91437,0,0,0-71.47754,0H56A16.01833,16.01833,0,0,0,40,48V216a16.01833,16.01833,0,0,0,16,16H200a16.01833,16.01833,0,0,0,16-16V48A16.01833,16.01833,0,0,0,200,32Zm-72,0a32.03667,32.03667,0,0,1,32,32H96A32.03667,32.03667,0,0,1,128,32Zm32,128H96a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm0-32H96a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "152",
      "x2": "160",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "120",
      "x2": "160",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160.00194,40H200a8,8,0,0,1,8,8V216a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H95.99783",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,72V64a40,40,0,0,1,80,0v8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "152",
      "x2": "160",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "120",
      "x2": "160",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160.00194,40H200a8,8,0,0,1,8,8V216a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H95.99783",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,72V64a40,40,0,0,1,80,0v8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "152",
      "x2": "160",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "120",
      "x2": "160",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160.00194,40H200a8,8,0,0,1,8,8V216a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H95.99783",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,72V64a40,40,0,0,1,80,0v8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$45 = [];
/* style */

const __vue_inject_styles__$45 = undefined;
/* scoped */

const __vue_scope_id__$45 = undefined;
/* module identifier */

const __vue_module_identifier__$45 = undefined;
/* functional template */

const __vue_is_functional_template__$45 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$45 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$45,
  staticRenderFns: __vue_staticRenderFns__$45
}, __vue_inject_styles__$45, __vue_script__$45, __vue_scope_id__$45, __vue_is_functional_template__$45, __vue_module_identifier__$45, false, undefined, undefined, undefined);

var script$46 = Vue.extend({
  name: "PhClock",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$46 = script$46;
/* template */

var __vue_render__$46 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 72 128 128 184 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 72 128 128 184 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.12041,104.12041,0,0,0,128,24Zm56,112H128a7.99541,7.99541,0,0,1-8-8V72a8,8,0,0,1,16,0v48h48a8,8,0,0,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 72 128 128 184 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 72 128 128 184 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 72 128 128 184 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$46 = [];
/* style */

const __vue_inject_styles__$46 = undefined;
/* scoped */

const __vue_scope_id__$46 = undefined;
/* module identifier */

const __vue_module_identifier__$46 = undefined;
/* functional template */

const __vue_is_functional_template__$46 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$46 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$46,
  staticRenderFns: __vue_staticRenderFns__$46
}, __vue_inject_styles__$46, __vue_script__$46, __vue_scope_id__$46, __vue_is_functional_template__$46, __vue_module_identifier__$46, false, undefined, undefined, undefined);

var script$47 = Vue.extend({
  name: "PhClockAfternoon",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$47 = script$47;
/* template */

var __vue_render__$47 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "184",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "167.59798",
      "y1": "167.59798",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "184",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "167.59798",
      "y1": "167.59798",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.11791,104.11791,0,0,0,128,24Zm56,112H147.31348l25.9414,25.94141a7.99983,7.99983,0,0,1-11.31347,11.31347l-39.59766-39.59765c-.18652-.18653-.36328-.38282-.53076-.58692-.07373-.08984-.1377-.18457-.20654-.27636-.0879-.1167-.17823-.23145-.25977-.353-.07471-.11182-.13916-.22754-.208-.34229-.06494-.10937-.13379-.21582-.19385-.32861-.0625-.1167-.11572-.23731-.17187-.35693-.05566-.11719-.11426-.23243-.16406-.353-.04785-.11572-.08643-.23389-.12842-.35108-.04639-.12841-.0957-.25585-.13574-.38769-.03565-.11816-.06153-.23779-.0918-.35693-.03369-.13379-.0708-.26563-.09814-.40186-.02686-.1377-.04346-.27637-.063-.41553-.01758-.11963-.04-.23681-.05176-.3584q-.03808-.38232-.03906-.7666L120,128l.001-.022q.00145-.38452.03906-.7666c.01172-.12159.03418-.23877.05176-.3584.01953-.13916.03613-.27783.063-.41553.02734-.13623.06445-.26807.09814-.40186.03027-.11914.05615-.23876.0918-.35693.04-.13183.08935-.25928.13574-.38769.042-.11719.08057-.23536.12842-.35108.0498-.1206.1084-.23584.16406-.353.05615-.11962.10937-.24023.17187-.35693.06006-.11279.12891-.21924.19385-.32861.06885-.11475.1333-.23047.208-.34229.08154-.12158.17187-.23633.25977-.353.06884-.09179.13281-.18652.20654-.27636a8.04468,8.04468,0,0,1,1.1167-1.1167c.09179-.0752.188-.14014.28174-.21094.11474-.08594.22705-.1748.34668-.25439.11425-.07666.23242-.14258.3496-.21241.10694-.064.21143-.13134.32129-.18994.11963-.064.24268-.11816.36475-.17578.11475-.0542.22754-.11133.34473-.16015.11914-.04932.24072-.08887.36132-.13184.12549-.04541.249-.09326.37745-.13233.12207-.03662.24609-.064.36914-.09472.12988-.03272.25732-.06885.38965-.09522.14306-.02832.28808-.04541.43261-.06591.11377-.01612.22608-.03809.34131-.04932q.39477-.03956.7915-.04H184a8,8,0,0,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "184",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "167.59798",
      "y1": "167.59798",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "184",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "167.59798",
      "y1": "167.59798",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "184",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "167.59798",
      "y1": "167.59798",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$47 = [];
/* style */

const __vue_inject_styles__$47 = undefined;
/* scoped */

const __vue_scope_id__$47 = undefined;
/* module identifier */

const __vue_module_identifier__$47 = undefined;
/* functional template */

const __vue_is_functional_template__$47 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$47 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$47,
  staticRenderFns: __vue_staticRenderFns__$47
}, __vue_inject_styles__$47, __vue_script__$47, __vue_scope_id__$47, __vue_is_functional_template__$47, __vue_module_identifier__$47, false, undefined, undefined, undefined);

var script$48 = Vue.extend({
  name: "PhClockClockwise",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$48 = script$48;
/* template */

var __vue_render__$48 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "80",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "169.56922",
      "y1": "152",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "184.167 99.716 224.167 99.716 224.167 59.716",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M190.2254,190.2254a88,88,0,1,1,0-124.4508l33.94112,33.94113",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "88",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "80",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "169.56922",
      "y1": "152",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "184.167 99.716 224.167 99.716 224.167 59.716",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M190.2254,190.2254a88,88,0,1,1,0-124.4508l33.94112,33.94113",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M136,80v43.38116l37.56934,21.69062a8,8,0,1,1-8,13.85644l-41.56934-24c-.064-.03692-.12109-.0805-.18359-.11889-.13575-.08362-.271-.16779-.40088-.2591-.10352-.07232-.20215-.14892-.30127-.22534-.10205-.0788-.20362-.15765-.30127-.24115-.11182-.09479-.21778-.19342-.32276-.29333-.0791-.07532-.15771-.15064-.23388-.22913-.10694-.11017-.2085-.22351-.30811-.339-.06933-.08026-.13769-.16083-.2041-.24377-.0918-.1156-.1792-.23352-.26416-.35352-.06738-.09473-.1333-.19019-.19629-.2879-.07226-.11194-.14062-.22547-.207-.34058-.06592-.11438-.12988-.22986-.19043-.34778-.05322-.10418-.10352-.20941-.15186-.31561-.061-.13287-.11914-.26685-.17333-.4035-.03907-.09986-.0752-.20063-.11036-.30194-.0498-.14252-.09668-.28589-.13818-.432-.03027-.10687-.05664-.21454-.083-.32257-.0332-.13928-.06543-.27881-.09131-.42084-.02392-.12842-.0415-.25757-.05908-.38714-.0166-.12226-.0332-.244-.04394-.368-.01416-.16015-.01954-.3208-.02442-.48187C120.00879,128.14313,120,128.07269,120,128V80a8,8,0,0,1,16,0Zm91.228-27.67529a7.99962,7.99962,0,0,0-8.71826,1.73437L204.1665,68.40222l-8.28466-8.28454a95.9551,95.9551,0,1,0,0,135.76464,7.99983,7.99983,0,1,0-11.31348-11.31347,80.00009,80.00009,0,1,1,0-113.1377l8.28467,8.28467L178.50977,94.05908a7.99981,7.99981,0,0,0,5.65673,13.65674h40a7.99977,7.99977,0,0,0,8-8v-40A8.00014,8.00014,0,0,0,227.228,52.32471Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "80",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "169.56922",
      "y1": "152",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "184.167 99.716 224.167 99.716 224.167 59.716",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M190.2254,190.2254a88,88,0,1,1,0-124.4508l33.94112,33.94113",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "80",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "169.56922",
      "y1": "152",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "184.167 99.716 224.167 99.716 224.167 59.716",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M190.2254,190.2254a88,88,0,1,1,0-124.4508l33.94112,33.94113",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "80",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "169.56922",
      "y1": "152",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "184.167 99.716 224.167 99.716 224.167 59.716",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M190.2254,190.2254a88,88,0,1,1,0-124.4508l33.94112,33.94113",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$48 = [];
/* style */

const __vue_inject_styles__$48 = undefined;
/* scoped */

const __vue_scope_id__$48 = undefined;
/* module identifier */

const __vue_module_identifier__$48 = undefined;
/* functional template */

const __vue_is_functional_template__$48 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$48 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$48,
  staticRenderFns: __vue_staticRenderFns__$48
}, __vue_inject_styles__$48, __vue_script__$48, __vue_scope_id__$48, __vue_is_functional_template__$48, __vue_module_identifier__$48, false, undefined, undefined, undefined);

var script$49 = Vue.extend({
  name: "PhClockCounterClockwise",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$49 = script$49;
/* template */

var __vue_render__$49 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "80",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "169.56922",
      "y1": "152",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "71.833 99.716 31.833 99.716 31.833 59.716",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M65.7746,190.2254a88,88,0,1,0,0-124.4508L31.83348,99.71573",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "88",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "80",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "169.56922",
      "y1": "152",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "71.833 99.716 31.833 99.716 31.833 59.716",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M65.7746,190.2254a88,88,0,1,0,0-124.4508L31.83348,99.71573",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M136,80v43.38116l37.56934,21.69062a8,8,0,1,1-8,13.85644l-41.56934-24c-.064-.03692-.12109-.0805-.18359-.11889-.13575-.08362-.271-.16779-.40088-.2591-.10352-.07232-.20215-.14892-.30127-.22534-.10205-.0788-.20362-.15765-.30127-.24115-.11182-.09479-.21778-.19342-.32276-.29333-.0791-.07532-.15771-.15064-.23388-.22913-.10694-.11017-.2085-.22351-.30811-.339-.06933-.08026-.13769-.16083-.2041-.24377-.0918-.1156-.1792-.23352-.26416-.35352-.06738-.09473-.1333-.19019-.19629-.2879-.07226-.11194-.14062-.22547-.207-.34058-.06592-.11438-.12988-.22986-.19043-.34778-.05322-.10418-.10352-.20941-.15185-.31561-.061-.13287-.11915-.26685-.17334-.4035-.03907-.09986-.0752-.20063-.11036-.30194-.0498-.14252-.09668-.28589-.13818-.432-.03027-.10687-.05664-.21454-.083-.32257-.0332-.13928-.06543-.27881-.09131-.42084-.02392-.12842-.0415-.25757-.05908-.38714-.0166-.12226-.0332-.244-.04394-.368-.01416-.16015-.01953-.3208-.02442-.48187C120.00879,128.14313,120,128.07269,120,128V80a8,8,0,0,1,16,0Zm59.88184-19.88232a96.10782,96.10782,0,0,0-135.76416,0L51.833,68.4021l-14.34278-14.343A7.99981,7.99981,0,0,0,23.8335,59.71582v40a7.99977,7.99977,0,0,0,8,8h40a7.99981,7.99981,0,0,0,5.65673-13.65674L63.147,79.71576l8.28467-8.28461a80.00025,80.00025,0,1,1,0,113.13721,8.00035,8.00035,0,0,0-11.314,11.31445A96.0001,96.0001,0,0,0,195.88184,60.11768Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "80",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "169.56922",
      "y1": "152",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "71.833 99.716 31.833 99.716 31.833 59.716",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M65.7746,190.2254a88,88,0,1,0,0-124.4508L31.83348,99.71573",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "80",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "169.56922",
      "y1": "152",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "71.833 99.716 31.833 99.716 31.833 59.716",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M65.7746,190.2254a88,88,0,1,0,0-124.4508L31.83348,99.71573",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "80",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "169.56922",
      "y1": "152",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "71.833 99.716 31.833 99.716 31.833 59.716",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M65.7746,190.2254a88,88,0,1,0,0-124.4508L31.83348,99.71573",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$49 = [];
/* style */

const __vue_inject_styles__$49 = undefined;
/* scoped */

const __vue_scope_id__$49 = undefined;
/* module identifier */

const __vue_module_identifier__$49 = undefined;
/* functional template */

const __vue_is_functional_template__$49 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$49 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$49,
  staticRenderFns: __vue_staticRenderFns__$49
}, __vue_inject_styles__$49, __vue_script__$49, __vue_scope_id__$49, __vue_is_functional_template__$49, __vue_module_identifier__$49, false, undefined, undefined, undefined);

var script$4a = Vue.extend({
  name: "PhClosedCaptioning",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4a = script$4a;
/* template */

var __vue_render__$4a = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M113.00272,152.80413a28,28,0,1,1-.00014-49.60833",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M185.00272,152.80413a28,28,0,1,1-.00014-49.60833",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M116,147.59582a28,28,0,1,1,.00011-39.19153",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M188,147.59582a28,28,0,1,1,.00011-39.19153",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,40H40A16.01833,16.01833,0,0,0,24,56V200a16.01833,16.01833,0,0,0,16,16H216a16.01833,16.01833,0,0,0,16-16V56A16.01833,16.01833,0,0,0,216,40ZM96,148a19.85259,19.85259,0,0,0,14.28613-6.00293,7.99956,7.99956,0,0,1,11.42774,11.19727,36,36,0,1,1,0-50.38868,7.99956,7.99956,0,0,1-11.42774,11.19727A20.00012,20.00012,0,1,0,96,148Zm72,0a19.85259,19.85259,0,0,0,14.28613-6.00293,7.99956,7.99956,0,0,1,11.42774,11.19727,36,36,0,1,1,0-50.38868,7.99956,7.99956,0,0,1-11.42774,11.19727A20.00012,20.00012,0,1,0,168,148Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M116,147.59582a28,28,0,1,1,.00011-39.19153",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M188,147.59582a28,28,0,1,1,.00011-39.19153",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M116,147.59582a28,28,0,1,1,.00011-39.19153",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M188,147.59582a28,28,0,1,1,.00011-39.19153",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M116,147.59582a28,28,0,1,1,.00011-39.19153",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M188,147.59582a28,28,0,1,1,.00011-39.19153",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4a = [];
/* style */

const __vue_inject_styles__$4a = undefined;
/* scoped */

const __vue_scope_id__$4a = undefined;
/* module identifier */

const __vue_module_identifier__$4a = undefined;
/* functional template */

const __vue_is_functional_template__$4a = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4a = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4a,
  staticRenderFns: __vue_staticRenderFns__$4a
}, __vue_inject_styles__$4a, __vue_script__$4a, __vue_scope_id__$4a, __vue_is_functional_template__$4a, __vue_module_identifier__$4a, false, undefined, undefined, undefined);

var script$4b = Vue.extend({
  name: "PhCloud",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4b = script$4b;
/* template */

var __vue_render__$4b = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,128a80,80,0,1,1,80,80H72A56,56,0,1,1,85.91924,97.74352",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,128a80,80,0,1,1,80,80H72A56,56,0,1,1,85.91924,97.74352",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,128a80,80,0,1,1,80,80H72A56,56,0,1,1,85.91924,97.74352",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M160,40A88.102,88.102,0,0,0,81.28711,88.6709l-.00537-.00049A87.464,87.464,0,0,0,71.98828,128a8,8,0,0,1-16,0,103.43561,103.43561,0,0,1,7.78-39.45264A63.99161,63.99161,0,0,0,72,216h88a88,88,0,0,0,0-176Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,128a80,80,0,1,1,80,80H72A56,56,0,1,1,85.91924,97.74352",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,128a80,80,0,1,1,80,80H72A56,56,0,1,1,85.91924,97.74352",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,128a80,80,0,1,1,80,80H72A56,56,0,1,1,85.91924,97.74352",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4b = [];
/* style */

const __vue_inject_styles__$4b = undefined;
/* scoped */

const __vue_scope_id__$4b = undefined;
/* module identifier */

const __vue_module_identifier__$4b = undefined;
/* functional template */

const __vue_is_functional_template__$4b = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4b = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4b,
  staticRenderFns: __vue_staticRenderFns__$4b
}, __vue_inject_styles__$4b, __vue_script__$4b, __vue_scope_id__$4b, __vue_is_functional_template__$4b, __vue_module_identifier__$4b, false, undefined, undefined, undefined);

var script$4c = Vue.extend({
  name: "PhCloudArrowDown",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4c = script$4c;
/* template */

var __vue_render__$4c = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "118.059 174.059 152 208 185.941 174.059",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "128",
      "x2": "152",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,208H72A56,56,0,1,1,85.91924,97.74352",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,128a80,80,0,1,1,144.00241,48.00459",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,128a80,80,0,1,1,80,80H72A56,56,0,1,1,85.91924,97.74352",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "118.053 174.059 151.994 208 185.935 174.059",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "151.99414",
      "y1": "128",
      "x2": "151.99414",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M95.99414,208h-24A56,56,0,1,1,85.91338,97.74352",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M79.99414,128a80,80,0,1,1,144.00241,48.00459",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M160.001,40A88.102,88.102,0,0,0,81.28809,88.6709l-.00538-.00049A87.46336,87.46336,0,0,0,71.98926,128a8,8,0,0,1-16,0,103.43674,103.43674,0,0,1,7.78-39.45264A63.99161,63.99161,0,0,0,72.001,216h88a88,88,0,0,0,0-176ZM191.5918,163.71582l-33.937,33.937a7.95865,7.95865,0,0,1-.59205.5354c-.08374.06885-.17224.12818-.258.19312-.12256.09253-.24317.18725-.3711.273-.10766.07177-.2196.134-.32983.20019-.11316.06812-.22412.13892-.34082.20142-.11523.06152-.23377.11377-.35132.16919-.11877.05639-.23584.11548-.35766.166-.11451.04737-.23169.08545-.34778.12744-.13.04688-.25843.09668-.39136.13672-.11694.0354-.23572.06128-.35376.09107-.1344.03393-.26721.07153-.40418.09863-.13891.02759-.27929.044-.41931.064-.11816.01684-.23437.03955-.35412.05127-.26245.02587-.52588.03979-.78931.03979s-.52685-.01392-.78931-.03979c-.11975-.01172-.236-.03443-.35412-.05127-.14-.02-.2804-.03638-.41931-.064-.137-.0271-.26978-.0647-.40418-.09863-.118-.02979-.23681-.05567-.35376-.09107-.13293-.04-.26135-.08984-.39136-.13672-.11608-.042-.23327-.08007-.34777-.12744-.12183-.05053-.2389-.10962-.35767-.166-.11755-.05542-.23608-.10767-.35132-.16919-.1167-.0625-.22766-.1333-.34082-.20142-.11023-.06616-.22217-.12842-.32983-.20019-.12793-.0857-.24854-.18042-.3711-.273-.08581-.06494-.17431-.12427-.258-.19312a7.95651,7.95651,0,0,1-.592-.5354l-33.937-33.937A7.99984,7.99984,0,1,1,123.71,152.40234l20.28418,20.28418V112a8,8,0,0,1,16,0v60.68652l20.28418-20.28418a7.99984,7.99984,0,1,1,11.31348,11.31348Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "118.059 174.059 152 208 185.941 174.059",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "128",
      "x2": "152",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,208H72A56,56,0,1,1,85.91924,97.74352",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,128a80,80,0,1,1,144.00241,48.00459",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "118.059 174.059 152 208 185.941 174.059",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "128",
      "x2": "152",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,208H72A56,56,0,1,1,85.91924,97.74352",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,128a80,80,0,1,1,144.00241,48.00459",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "118.059 174.059 152 208 185.941 174.059",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "128",
      "x2": "152",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,208H72A56,56,0,1,1,85.91924,97.74352",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,128a80,80,0,1,1,144.00241,48.00459",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4c = [];
/* style */

const __vue_inject_styles__$4c = undefined;
/* scoped */

const __vue_scope_id__$4c = undefined;
/* module identifier */

const __vue_module_identifier__$4c = undefined;
/* functional template */

const __vue_is_functional_template__$4c = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4c = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4c,
  staticRenderFns: __vue_staticRenderFns__$4c
}, __vue_inject_styles__$4c, __vue_script__$4c, __vue_scope_id__$4c, __vue_is_functional_template__$4c, __vue_module_identifier__$4c, false, undefined, undefined, undefined);

var script$4d = Vue.extend({
  name: "PhCloudArrowUp",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4d = script$4d;
/* template */

var __vue_render__$4d = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M96,207.98437H72A56,56,0,1,1,85.91924,97.7279",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,127.98437A80,80,0,1,1,224.00241,175.989",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "118.059 161.926 152 127.984 185.941 161.926",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "207.98437",
      "x2": "152",
      "y2": "127.98437",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,127.98437a80,80,0,1,1,80,80H72A56,56,0,1,1,85.91924,97.7279",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M95.99414,207.98437h-24A56,56,0,1,1,85.91338,97.7279",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M79.99414,127.98437A80,80,0,1,1,223.99655,175.989",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "118.053 161.926 151.994 127.984 185.935 161.926",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "151.99414",
      "y1": "207.98437",
      "x2": "151.99414",
      "y2": "127.98437",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M160.001,40A88.102,88.102,0,0,0,81.28809,88.6709l-.00538-.00049A87.46336,87.46336,0,0,0,71.98926,128a8,8,0,0,1-16,0,103.43674,103.43674,0,0,1,7.78-39.45264A63.99161,63.99161,0,0,0,72.001,216h88a88,88,0,0,0,0-176ZM191.5918,151.59766a7.99945,7.99945,0,0,1-11.31348,0l-20.28418-20.28418V192a8,8,0,0,1-16,0V131.31348L123.71,151.59766a7.99984,7.99984,0,1,1-11.31348-11.31348l33.937-33.937a7.95651,7.95651,0,0,1,.592-.5354c.08374-.06885.17224-.12818.258-.19312.12256-.09253.24317-.18725.3711-.273.10718-.07153.2185-.1333.32837-.19922.11377-.06836.22534-.13964.34277-.20263.11353-.06055.23022-.11182.34583-.16651.12072-.05737.23986-.11767.36389-.16894.11157-.04614.22583-.08325.33911-.124.13281-.04834.26416-.09888.40014-.14014.1128-.03394.22718-.0586.34107-.08765.13867-.0354.27612-.074.4176-.1018.12976-.02588.26087-.04053.3916-.05982.12744-.0188.25305-.04272.38233-.05518.232-.02294.465-.03271.69812-.0354.02978-.00024.05871-.00439.08862-.00439s.05884.00415.08862.00439c.23316.00269.46607.01246.69812.0354.12928.01246.25489.03638.38233.05518.13074.01929.26184.03394.3916.05982.14148.02783.27893.0664.4176.1018.11389.029.22827.05371.34107.08765.136.04126.26733.0918.40014.14014.11328.04077.22754.07788.33911.124.124.05127.24317.11157.3639.16894.1156.05469.2323.106.34582.16651.11743.063.229.13427.34277.20263.10987.06592.2212.12769.32837.19922.12793.0857.24854.18042.3711.273.08581.06494.17431.12427.258.19312a7.95865,7.95865,0,0,1,.59205.5354l33.937,33.937A7.99915,7.99915,0,0,1,191.5918,151.59766Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M96,207.98437H72A56,56,0,1,1,85.91924,97.7279",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,127.98437A80,80,0,1,1,224.00241,175.989",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "118.059 161.926 152 127.984 185.941 161.926",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "207.98437",
      "x2": "152",
      "y2": "127.98437",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M96,207.98437H72A56,56,0,1,1,85.91924,97.7279",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,127.98437A80,80,0,1,1,224.00241,175.989",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "118.059 161.926 152 127.984 185.941 161.926",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "207.98437",
      "x2": "152",
      "y2": "127.98437",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M96,207.98437H72A56,56,0,1,1,85.91924,97.7279",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,127.98437A80,80,0,1,1,224.00241,175.989",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "118.059 161.926 152 127.984 185.941 161.926",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "207.98437",
      "x2": "152",
      "y2": "127.98437",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4d = [];
/* style */

const __vue_inject_styles__$4d = undefined;
/* scoped */

const __vue_scope_id__$4d = undefined;
/* module identifier */

const __vue_module_identifier__$4d = undefined;
/* functional template */

const __vue_is_functional_template__$4d = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4d = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4d,
  staticRenderFns: __vue_staticRenderFns__$4d
}, __vue_inject_styles__$4d, __vue_script__$4d, __vue_scope_id__$4d, __vue_is_functional_template__$4d, __vue_module_identifier__$4d, false, undefined, undefined, undefined);

var script$4e = Vue.extend({
  name: "PhCloudCheck",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4e = script$4e;
/* template */

var __vue_render__$4e = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,128a80,80,0,1,1,80,80H72A56,56,0,1,1,85.91924,97.74352",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192 116 144 164 120 140",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80.00586,128a80,80,0,1,1,80,80h-88A56,56,0,1,1,85.9251,97.74352",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,128a80,80,0,1,1,80,80H72A56,56,0,1,1,85.91924,97.74352",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192 116 144 164 120 140",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M160.001,40A88.102,88.102,0,0,0,81.28809,88.6709l-.00538-.00049A87.46336,87.46336,0,0,0,71.98926,128a8,8,0,0,1-16,0,103.43674,103.43674,0,0,1,7.78-39.45264A63.99161,63.99161,0,0,0,72.001,216h88a88,88,0,0,0,0-176Zm37.65576,81.65674-48,48a7.99945,7.99945,0,0,1-11.31348,0l-24-24a7.99984,7.99984,0,0,1,11.31348-11.31348L144,152.68652l42.34326-42.34326a7.99984,7.99984,0,0,1,11.31348,11.31348Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,128a80,80,0,1,1,80,80H72A56,56,0,1,1,85.91924,97.74352",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192 116 144 164 120 140",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,128a80,80,0,1,1,80,80H72A56,56,0,1,1,85.91924,97.74352",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192 116 144 164 120 140",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,128a80,80,0,1,1,80,80H72A56,56,0,1,1,85.91924,97.74352",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192 116 144 164 120 140",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4e = [];
/* style */

const __vue_inject_styles__$4e = undefined;
/* scoped */

const __vue_scope_id__$4e = undefined;
/* module identifier */

const __vue_module_identifier__$4e = undefined;
/* functional template */

const __vue_is_functional_template__$4e = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4e = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4e,
  staticRenderFns: __vue_staticRenderFns__$4e
}, __vue_inject_styles__$4e, __vue_script__$4e, __vue_scope_id__$4e, __vue_is_functional_template__$4e, __vue_module_identifier__$4e, false, undefined, undefined, undefined);

var script$4f = Vue.extend({
  name: "PhCloudFog",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4f = script$4f;
/* template */

var __vue_render__$4f = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "120",
      "y1": "200",
      "x2": "72",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "200",
      "x2": "160",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "240",
      "x2": "104",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,92a68,68,0,1,1,68,68H76A44,44,0,1,1,90.30583,74.37792",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M88,92a68,68,0,1,1,68,68H76A44,44,0,1,1,90.30583,74.37792",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "192",
      "x2": "72",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "192",
      "x2": "160",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "224",
      "x2": "104",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,92a68,68,0,1,1,68,68H76A44,44,0,1,1,90.30583,74.37792",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M168,224a8.00008,8.00008,0,0,1-8,8H104a8,8,0,0,1,0-16h56A8.00008,8.00008,0,0,1,168,224Zm-40-32a8.00008,8.00008,0,0,0-8-8H72a8,8,0,0,0,0,16h48A8.00008,8.00008,0,0,0,128,192Zm56-8H160a8,8,0,0,0,0,16h24a8,8,0,0,0,0-16ZM156,16A76.13113,76.13113,0,0,0,85.03711,64.7832l-.00537-.001A76.1764,76.1764,0,0,0,80,92a8,8,0,0,1-16,0,92.24056,92.24056,0,0,1,4.17639-27.41064A52.00137,52.00137,0,0,0,76,168h80a76,76,0,0,0,0-152Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "120",
      "y1": "192",
      "x2": "72",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "192",
      "x2": "160",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "224",
      "x2": "104",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,92a68,68,0,1,1,68,68H76A44,44,0,1,1,90.30583,74.37792",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "120",
      "y1": "192",
      "x2": "72",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "192",
      "x2": "160",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "224",
      "x2": "104",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,92a68,68,0,1,1,68,68H76A44,44,0,1,1,90.30583,74.37792",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "120",
      "y1": "192",
      "x2": "72",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "192",
      "x2": "160",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "224",
      "x2": "104",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,92a68,68,0,1,1,68,68H76A44,44,0,1,1,90.30583,74.37792",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4f = [];
/* style */

const __vue_inject_styles__$4f = undefined;
/* scoped */

const __vue_scope_id__$4f = undefined;
/* module identifier */

const __vue_module_identifier__$4f = undefined;
/* functional template */

const __vue_is_functional_template__$4f = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4f = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4f,
  staticRenderFns: __vue_staticRenderFns__$4f
}, __vue_inject_styles__$4f, __vue_script__$4f, __vue_scope_id__$4f, __vue_is_functional_template__$4f, __vue_module_identifier__$4f, false, undefined, undefined, undefined);

var script$4g = Vue.extend({
  name: "PhCloudLightning",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4g = script$4g;
/* template */

var __vue_render__$4g = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "128 240 154.25 200 104 200 130.25 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,92a68,68,0,1,1,68,68H76A44,44,0,1,1,90.30583,74.37792",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M88,92a68,68,0,1,1,68,68H76A44,44,0,1,1,90.30583,74.37792",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 240 154.25 200 104 200 130.25 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,92a68,68,0,1,1,68,68H76A44,44,0,1,1,90.30583,74.37792",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M134.564,168l-15.75,24h35.43116a8.00016,8.00016,0,0,1,6.68847,12.38916l-26.25,40a8,8,0,1,1-13.377-8.77832L139.42627,208H103.99512a8.00017,8.00017,0,0,1-6.68848-12.38916L115.42627,168H75.99512A52.0014,52.0014,0,0,1,68.16479,64.59033,91.68713,91.68713,0,0,0,63.99512,92a8,8,0,0,0,16,0,75.62312,75.62312,0,0,1,5.03723-27.2168l.007-.01758A76.00126,76.00126,0,1,1,155.99512,168Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "128 240 154.25 200 104 200 130.25 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,92a68,68,0,1,1,68,68H76A44,44,0,1,1,90.30583,74.37792",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "128 240 154.25 200 104 200 130.25 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,92a68,68,0,1,1,68,68H76A44,44,0,1,1,90.30583,74.37792",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "128 240 154.25 200 104 200 130.25 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,92a68,68,0,1,1,68,68H76A44,44,0,1,1,90.30583,74.37792",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4g = [];
/* style */

const __vue_inject_styles__$4g = undefined;
/* scoped */

const __vue_scope_id__$4g = undefined;
/* module identifier */

const __vue_module_identifier__$4g = undefined;
/* functional template */

const __vue_is_functional_template__$4g = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4g = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4g,
  staticRenderFns: __vue_staticRenderFns__$4g
}, __vue_inject_styles__$4g, __vue_script__$4g, __vue_scope_id__$4g, __vue_is_functional_template__$4g, __vue_module_identifier__$4g, false, undefined, undefined, undefined);

var script$4h = Vue.extend({
  name: "PhCloudMoon",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4h = script$4h;
/* template */

var __vue_render__$4h = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M88,148a68,68,0,1,1,68,68H76a44,44,0,1,1,14.30583-85.62208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M49.96509,136.529A64.11761,64.11761,0,0,1,17.6218,94.37955l.00023-.001A64.0566,64.0566,0,0,0,94.37854,17.622l.00084-.00019A64.02478,64.02478,0,0,1,144,80q0,.52871-.00853,1.05539",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M90.30559,130.37786a68.14083,68.14083,0,0,1,45.47328-47.32071l.15152-.04541Q135.99975,81.51458,136,80A64.02478,64.02478,0,0,0,86.37938,17.62177l-.00084.00019A64.05661,64.05661,0,0,1,9.622,94.37856l-.00023.001A64.12919,64.12919,0,0,0,46.99,138.92889l-.00581-.00661a44.06953,44.06953,0,0,1,43.32161-8.54436Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,148a68,68,0,1,1,68,68H76a44,44,0,1,1,14.30583-85.62208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M46.99,138.92889A64.12919,64.12919,0,0,1,9.6218,94.37955l.00023-.001A64.0566,64.0566,0,0,0,86.37854,17.622l.00084-.00019A64.02478,64.02478,0,0,1,136,80q0,1.51431-.06961,3.01174",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M156,72a76.16623,76.16623,0,0,0-12.356,1.012A71.97744,71.97744,0,0,0,88.16846,9.8252a7.9997,7.9997,0,0,0-9.58741,9.58691A56.33865,56.33865,0,0,1,80,32,56.06322,56.06322,0,0,1,24,88a56.39592,56.39592,0,0,1-12.59082-1.418,8.00013,8.00013,0,0,0-9.585,9.58789A72.18778,72.18778,0,0,0,34.11353,141.2312,51.96571,51.96571,0,0,0,76,224h80a76,76,0,0,0,0-152ZM21.36816,103.95215Q22.68287,104.0005,24,104A72.08124,72.08124,0,0,0,96,32q0-1.3374-.04932-2.67285a55.64963,55.64963,0,0,1,31.98267,48.05249A76.41925,76.41925,0,0,0,85.03711,120.7832,52.31117,52.31117,0,0,0,76,120a51.69716,51.69716,0,0,0-30.02808,9.58643A56.254,56.254,0,0,1,21.36816,103.95215Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M88,148a68,68,0,1,1,68,68H76a44,44,0,1,1,14.30583-85.62208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M46.99,138.92889A64.12919,64.12919,0,0,1,9.6218,94.37955l.00023-.001A64.0566,64.0566,0,0,0,86.37854,17.622l.00084-.00019A64.02478,64.02478,0,0,1,136,80q0,1.51431-.06961,3.01174",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M88,148a68,68,0,1,1,68,68H76a44,44,0,1,1,14.30583-85.62208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M46.99,138.92889A64.12919,64.12919,0,0,1,9.6218,94.37955l.00023-.001A64.0566,64.0566,0,0,0,86.37854,17.622l.00084-.00019A64.02478,64.02478,0,0,1,136,80q0,1.51431-.06961,3.01174",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M88,148a68,68,0,1,1,68,68H76a44,44,0,1,1,14.30583-85.62208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M46.99,138.92889A64.12919,64.12919,0,0,1,9.6218,94.37955l.00023-.001A64.0566,64.0566,0,0,0,86.37854,17.622l.00084-.00019A64.02478,64.02478,0,0,1,136,80q0,1.51431-.06961,3.01174",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4h = [];
/* style */

const __vue_inject_styles__$4h = undefined;
/* scoped */

const __vue_scope_id__$4h = undefined;
/* module identifier */

const __vue_module_identifier__$4h = undefined;
/* functional template */

const __vue_is_functional_template__$4h = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4h = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4h,
  staticRenderFns: __vue_staticRenderFns__$4h
}, __vue_inject_styles__$4h, __vue_script__$4h, __vue_scope_id__$4h, __vue_is_functional_template__$4h, __vue_module_identifier__$4h, false, undefined, undefined, undefined);

var script$4i = Vue.extend({
  name: "PhCloudRain",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4i = script$4i;
/* template */

var __vue_render__$4i = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "240",
      "x2": "154.25007",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "98.74999",
      "y1": "208",
      "x2": "130.25007",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,92a68,68,0,1,1,68,68H76A44,44,0,1,1,90.30583,74.37792",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M88,92a68,68,0,1,1,68,68H76A44,44,0,1,1,90.30583,74.37792",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "240",
      "x2": "154.25007",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "98.74999",
      "y1": "208",
      "x2": "130.25007",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,92a68,68,0,1,1,68,68H76A44,44,0,1,1,90.30583,74.37792",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M160.93359,204.38916l-26.25,40a8,8,0,1,1-13.377-8.77832l26.25-40a8,8,0,1,1,13.377,8.77832ZM155.99512,16A76.1302,76.1302,0,0,0,85.03931,64.76562l-.007.01758A75.62312,75.62312,0,0,0,79.99512,92a8,8,0,0,1-16,0,91.68713,91.68713,0,0,1,4.16967-27.40967A52.0014,52.0014,0,0,0,75.99512,168h39.43115L92.05664,203.61084a8,8,0,1,0,13.37695,8.77832L134.564,168h21.43116a76,76,0,0,0,0-152Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "240",
      "x2": "154.25007",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "98.74999",
      "y1": "208",
      "x2": "130.25007",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,92a68,68,0,1,1,68,68H76A44,44,0,1,1,90.30583,74.37792",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "240",
      "x2": "154.25007",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "98.74999",
      "y1": "208",
      "x2": "130.25007",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,92a68,68,0,1,1,68,68H76A44,44,0,1,1,90.30583,74.37792",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "240",
      "x2": "154.25007",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "98.74999",
      "y1": "208",
      "x2": "130.25007",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,92a68,68,0,1,1,68,68H76A44,44,0,1,1,90.30583,74.37792",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4i = [];
/* style */

const __vue_inject_styles__$4i = undefined;
/* scoped */

const __vue_scope_id__$4i = undefined;
/* module identifier */

const __vue_module_identifier__$4i = undefined;
/* functional template */

const __vue_is_functional_template__$4i = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4i = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4i,
  staticRenderFns: __vue_staticRenderFns__$4i
}, __vue_inject_styles__$4i, __vue_script__$4i, __vue_scope_id__$4i, __vue_is_functional_template__$4i, __vue_module_identifier__$4i, false, undefined, undefined, undefined);

var script$4j = Vue.extend({
  name: "PhCloudSlash",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4j = script$4j;
/* template */

var __vue_render__$4j = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M193.8943,200.486A79.69516,79.69516,0,0,1,160,208H72A56,56,0,1,1,85.91924,97.74352",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,128A79.62931,79.62931,0,0,1,91.06793,87.375",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M119.38894,59.05967A80.01177,80.01177,0,0,1,224.76359,174.97434",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80.00586,127.6178a80,80,0,1,1,80,80h-88A56,56,0,1,1,85.9251,97.36132",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M193.8943,200.486A79.69516,79.69516,0,0,1,160,208H72A56,56,0,1,1,85.91924,97.74352",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112.63246,63.52392a80.0033,80.0033,0,0,1,107.0479,117.75254",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,128A79.62931,79.62931,0,0,1,91.06793,87.375",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M53.91943,34.61865a7.99991,7.99991,0,1,0-11.83886,10.7627L81.32349,88.54858c-.02.0398-.04187.07862-.06177.11841A64.00311,64.00311,0,1,0,72,216h88a87.30213,87.30213,0,0,0,31.79883-5.92847l10.28174,11.30982a7.99991,7.99991,0,0,0,11.83886-10.7627Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160,40a87.31991,87.31991,0,0,0-52.10938,17.08057,8.00024,8.00024,0,0,0-1.17773,11.8247L213.76074,186.65771a8.00079,8.00079,0,0,0,5.91944,2.61866h.03466A7.99883,7.99883,0,0,0,225.646,186.606,88.00035,88.00035,0,0,0,160,40Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M193.8943,200.486A79.69516,79.69516,0,0,1,160,208H72A56,56,0,1,1,85.91924,97.74352",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112.63246,63.52392a80.0033,80.0033,0,0,1,107.0479,117.75254",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,128A79.62931,79.62931,0,0,1,91.06793,87.375",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M193.8943,200.486A79.69516,79.69516,0,0,1,160,208H72A56,56,0,1,1,85.91924,97.74352",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112.63246,63.52392a80.0033,80.0033,0,0,1,107.0479,117.75254",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,128A79.62931,79.62931,0,0,1,91.06793,87.375",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M193.8943,200.486A79.69516,79.69516,0,0,1,160,208H72A56,56,0,1,1,85.91924,97.74352",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112.63246,63.52392a80.0033,80.0033,0,0,1,107.0479,117.75254",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,128A79.62931,79.62931,0,0,1,91.06793,87.375",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4j = [];
/* style */

const __vue_inject_styles__$4j = undefined;
/* scoped */

const __vue_scope_id__$4j = undefined;
/* module identifier */

const __vue_module_identifier__$4j = undefined;
/* functional template */

const __vue_is_functional_template__$4j = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4j = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4j,
  staticRenderFns: __vue_staticRenderFns__$4j
}, __vue_inject_styles__$4j, __vue_script__$4j, __vue_scope_id__$4j, __vue_is_functional_template__$4j, __vue_module_identifier__$4j, false, undefined, undefined, undefined);

var script$4k = Vue.extend({
  name: "PhCloudSnow",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4k = script$4k;
/* template */

var __vue_render__$4k = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M88,96a68,68,0,1,1,68,68H76A44,44,0,1,1,90.30583,78.37792",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "160",
      "cy": "216",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "112",
      "cy": "216",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "64",
      "cy": "216",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M88,92a68,68,0,1,1,68,68H76A44,44,0,1,1,90.30583,74.37792",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,92a68,68,0,1,1,68,68H76A44,44,0,1,1,90.30583,74.37792",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "76",
      "cy": "196",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "116",
      "cy": "212",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "196",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "236",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "236",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M175.99512,196a12,12,0,1,1-12-12A12.01375,12.01375,0,0,1,175.99512,196Zm-100-12a12,12,0,1,0,12,12A12.01375,12.01375,0,0,0,75.99512,184Zm40,16a12,12,0,1,0,12,12A12.01375,12.01375,0,0,0,115.99512,200Zm-48,24a12,12,0,1,0,12,12A12.01375,12.01375,0,0,0,67.99512,224Zm88,0a12,12,0,1,0,12,12A12.01375,12.01375,0,0,0,155.99512,224Zm0-208A76.1302,76.1302,0,0,0,85.03931,64.76562l-.007.01758A75.62312,75.62312,0,0,0,79.99512,92a8,8,0,0,1-16,0,91.68713,91.68713,0,0,1,4.16967-27.40967A52.0014,52.0014,0,0,0,75.99512,168h80a76,76,0,0,0,0-152Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M88,92a68,68,0,1,1,68,68H76A44,44,0,1,1,90.30583,74.37792",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "76",
      "cy": "196",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "116",
      "cy": "212",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "196",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "236",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "236",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M88,92a68,68,0,1,1,68,68H76A44,44,0,1,1,90.30583,74.37792",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "76",
      "cy": "196",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "116",
      "cy": "212",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "196",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "236",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "236",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M88,92a68,68,0,1,1,68,68H76A44,44,0,1,1,90.30583,74.37792",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "76",
      "cy": "196",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "116",
      "cy": "212",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "196",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "236",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "236",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4k = [];
/* style */

const __vue_inject_styles__$4k = undefined;
/* scoped */

const __vue_scope_id__$4k = undefined;
/* module identifier */

const __vue_module_identifier__$4k = undefined;
/* functional template */

const __vue_is_functional_template__$4k = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4k = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4k,
  staticRenderFns: __vue_staticRenderFns__$4k
}, __vue_inject_styles__$4k, __vue_script__$4k, __vue_scope_id__$4k, __vue_is_functional_template__$4k, __vue_module_identifier__$4k, false, undefined, undefined, undefined);

var script$4l = Vue.extend({
  name: "PhCloudSun",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4l = script$4l;
/* template */

var __vue_render__$4l = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M88,148a68,68,0,1,1,68,68H76a44,44,0,1,1,14.30583-85.62208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "79.6638",
      "y1": "56.73022",
      "x2": "75.49625",
      "y2": "33.09483",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48.68557",
      "y1": "76.45789",
      "x2": "29.02592",
      "y2": "62.69205",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40.73022",
      "y1": "112.31237",
      "x2": "17.09483",
      "y2": "116.47993",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "115.51829",
      "y1": "64.68557",
      "x2": "129.28412",
      "y2": "45.02592",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M51.64386,135.35374A48.008,48.008,0,1,1,131.83232,84.4235",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M131.83232,84.4235a48.00729,48.00729,0,1,0-80.18846,50.93024l-.00154-.00232a44.09694,44.09694,0,0,1,38.66351-4.9735l-.00024-.00007A68.15692,68.15692,0,0,1,131.83113,84.4204Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,148a68,68,0,1,1,68,68H76a44,44,0,1,1,14.30583-85.62208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "79.6638",
      "y1": "56.73022",
      "x2": "75.49625",
      "y2": "33.09483",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48.68557",
      "y1": "76.45789",
      "x2": "29.02592",
      "y2": "62.69205",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40.73022",
      "y1": "112.31237",
      "x2": "17.09483",
      "y2": "116.47993",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "115.51829",
      "y1": "64.68557",
      "x2": "129.28412",
      "y2": "45.02592",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M51.64386,135.35374A48.008,48.008,0,1,1,131.83232,84.4235",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M156,72a75.81,75.81,0,0,0-20.23584,2.73853,55.73208,55.73208,0,0,0-9.41089-11.57911l9.48413-13.54419A8.00015,8.00015,0,0,0,122.731,40.4375l-9.48413,13.54419A55.868,55.868,0,0,0,86.251,48.01953L83.37451,31.70605A7.99987,7.99987,0,1,0,67.61768,34.4834l2.87475,16.30371A55.397,55.397,0,0,0,47.17651,65.635L33.61426,56.13867A8.00027,8.00027,0,0,0,24.4375,69.24609l13.55981,9.49463a55.39532,55.39532,0,0,0-5.98669,26.98535l-16.305,2.87452a8.00079,8.00079,0,0,0,1.37988,15.87988,8.12832,8.12832,0,0,0,1.39844-.12207l16.31079-2.87573a55.95086,55.95086,0,0,0,5.85571,12.42749A51.96741,51.96741,0,0,0,76,224h80a76,76,0,0,0,0-152ZM48.62964,111.09448c-.00879-.05713-.01123-.11352-.02124-.17065-.011-.0625-.02954-.12158-.042-.18335A39.72794,39.72794,0,0,1,55.12793,81.186c.0354-.04834.07642-.08985.11084-.13916.03857-.05518.06909-.11329.106-.16895a39.72789,39.72789,0,0,1,25.48584-16.2395c.07422-.011.148-.01612.22216-.029.06983-.01221.136-.033.20508-.04688a39.95749,39.95749,0,0,1,29.17383,6.28857c.16138.13282.32336.26514.49756.38721.12671.08887.26294.15161.39282.23193a39.78776,39.78776,0,0,1,9.26489,9.31006,76.44756,76.44756,0,0,0-35.5498,40.00293A52.31117,52.31117,0,0,0,76,120a51.67572,51.67572,0,0,0-22.07556,4.93262A40.03451,40.03451,0,0,1,48.62964,111.09448Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M88,148a68,68,0,1,1,68,68H76a44,44,0,1,1,14.30583-85.62208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "79.6638",
      "y1": "56.73022",
      "x2": "75.49625",
      "y2": "33.09483",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48.68557",
      "y1": "76.45789",
      "x2": "29.02592",
      "y2": "62.69205",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40.73022",
      "y1": "112.31237",
      "x2": "17.09483",
      "y2": "116.47993",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "115.51829",
      "y1": "64.68557",
      "x2": "129.28412",
      "y2": "45.02592",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M51.64386,135.35374A48.008,48.008,0,1,1,131.83232,84.4235",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M88,148a68,68,0,1,1,68,68H76a44,44,0,1,1,14.30583-85.62208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "79.6638",
      "y1": "56.73022",
      "x2": "75.49625",
      "y2": "33.09483",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48.68557",
      "y1": "76.45789",
      "x2": "29.02592",
      "y2": "62.69205",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40.73022",
      "y1": "112.31237",
      "x2": "17.09483",
      "y2": "116.47993",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "115.51829",
      "y1": "64.68557",
      "x2": "129.28412",
      "y2": "45.02592",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M51.64386,135.35374A48.008,48.008,0,1,1,131.83232,84.4235",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M88,148a68,68,0,1,1,68,68H76a44,44,0,1,1,14.30583-85.62208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "79.6638",
      "y1": "56.73022",
      "x2": "75.49625",
      "y2": "33.09483",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48.68557",
      "y1": "76.45789",
      "x2": "29.02592",
      "y2": "62.69205",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40.73022",
      "y1": "112.31237",
      "x2": "17.09483",
      "y2": "116.47993",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "115.51829",
      "y1": "64.68557",
      "x2": "129.28412",
      "y2": "45.02592",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M51.64386,135.35374A48.008,48.008,0,1,1,131.83232,84.4235",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4l = [];
/* style */

const __vue_inject_styles__$4l = undefined;
/* scoped */

const __vue_scope_id__$4l = undefined;
/* module identifier */

const __vue_module_identifier__$4l = undefined;
/* functional template */

const __vue_is_functional_template__$4l = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4l = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4l,
  staticRenderFns: __vue_staticRenderFns__$4l
}, __vue_inject_styles__$4l, __vue_script__$4l, __vue_scope_id__$4l, __vue_is_functional_template__$4l, __vue_module_identifier__$4l, false, undefined, undefined, undefined);

var script$4m = Vue.extend({
  name: "PhClub",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4m = script$4m;
/* template */

var __vue_render__$4m = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M104.512,186.61814a47.9857,47.9857,0,1,1-17.29771-85.30105l-.00069.00287a48,48,0,1,1,81.57046.00366l-.00718-.00443a48.00516,48.00516,0,1,1-17.28893,85.299L160,232H96Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M112.51708,179.15431a47.97767,47.97767,0,1,1-25.30276-77.83722l-.00069.00287a48,48,0,1,1,81.57046.00366l-.00718-.00443a48.00575,48.00575,0,1,1-25.29289,77.8364L160,232H96Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112.51708,179.15431a47.97767,47.97767,0,1,1-25.30276-77.83722l-.00069.00287a48,48,0,1,1,81.57046.00366l-.00718-.00443a48.00575,48.00575,0,1,1-25.29289,77.8364L160,232H96Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232,148a52.00505,52.00505,0,0,1-80.459,43.52539l10.6538,34.08789A7.99984,7.99984,0,0,1,154.55908,236H101.44092a7.99954,7.99954,0,0,1-7.63526-10.38672L104.45459,191.542a51.7046,51.7046,0,0,1-29.9624,8.43653c-27.72657-.78516-50.377-24.00489-50.4917-51.75977A51.99976,51.99976,0,0,1,76,96q2.02881,0,4.04883.15625a52.00294,52.00294,0,1,1,95.89648,0,53.33621,53.33621,0,0,1,5.46387-.1377A51.70261,51.70261,0,0,1,232,148Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M112.51708,179.15431a47.97767,47.97767,0,1,1-25.30276-77.83722l-.00069.00287a48,48,0,1,1,81.57046.00366l-.00718-.00443a48.00575,48.00575,0,1,1-25.29289,77.8364L160,232H96Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M112.51708,179.15431a47.97767,47.97767,0,1,1-25.30276-77.83722l-.00069.00287a48,48,0,1,1,81.57046.00366l-.00718-.00443a48.00575,48.00575,0,1,1-25.29289,77.8364L160,232H96Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M112.51708,179.15431a47.97767,47.97767,0,1,1-25.30276-77.83722l-.00069.00287a48,48,0,1,1,81.57046.00366l-.00718-.00443a48.00575,48.00575,0,1,1-25.29289,77.8364L160,232H96Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4m = [];
/* style */

const __vue_inject_styles__$4m = undefined;
/* scoped */

const __vue_scope_id__$4m = undefined;
/* module identifier */

const __vue_module_identifier__$4m = undefined;
/* functional template */

const __vue_is_functional_template__$4m = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4m = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4m,
  staticRenderFns: __vue_staticRenderFns__$4m
}, __vue_inject_styles__$4m, __vue_script__$4m, __vue_scope_id__$4m, __vue_is_functional_template__$4m, __vue_module_identifier__$4m, false, undefined, undefined, undefined);

var script$4n = Vue.extend({
  name: "PhCode",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4n = script$4n;
/* template */

var __vue_render__$4n = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "64 88 16 128 64 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192 88 240 128 192 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "40",
      "x2": "96",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "64 88 16 128 64 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192 88 240 128 192 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "40",
      "x2": "96",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M70.146,82.87891a8.00043,8.00043,0,0,0-11.26758-1.02442l-48,40a7.99963,7.99963,0,0,0,0,12.291l48,40a7.99987,7.99987,0,1,0,10.24316-12.291L28.49658,128l40.625-33.85449A7.99977,7.99977,0,0,0,70.146,82.87891Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M245.12158,121.85449l-48-40a7.99987,7.99987,0,1,0-10.24316,12.291L227.50342,128l-40.625,33.85449a7.99987,7.99987,0,1,0,10.24316,12.291l48-40a7.99963,7.99963,0,0,0,0-12.291Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M162.73389,32.48145a8.005,8.005,0,0,0-10.25244,4.78418l-64,176a8.00034,8.00034,0,1,0,15.0371,5.46875l64-176A8.0008,8.0008,0,0,0,162.73389,32.48145Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "64 88 16 128 64 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192 88 240 128 192 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "40",
      "x2": "96",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "64 88 16 128 64 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192 88 240 128 192 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "40",
      "x2": "96",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "64 88 16 128 64 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192 88 240 128 192 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "40",
      "x2": "96",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4n = [];
/* style */

const __vue_inject_styles__$4n = undefined;
/* scoped */

const __vue_scope_id__$4n = undefined;
/* module identifier */

const __vue_module_identifier__$4n = undefined;
/* functional template */

const __vue_is_functional_template__$4n = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4n = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4n,
  staticRenderFns: __vue_staticRenderFns__$4n
}, __vue_inject_styles__$4n, __vue_script__$4n, __vue_scope_id__$4n, __vue_is_functional_template__$4n, __vue_module_identifier__$4n, false, undefined, undefined, undefined);

var script$4o = Vue.extend({
  name: "PhCodeSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4o = script$4o;
/* template */

var __vue_render__$4o = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "88 64 16 128 88 192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "168 64 240 128 168 192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "88 64 16 128 88 192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "168 64 240 128 168 192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M93.97949,58.68555a7.99976,7.99976,0,0,0-11.29443-.665l-72,64a8.00054,8.00054,0,0,0,0,11.959l72,64a8.00018,8.00018,0,0,0,10.62988-11.959L28.0415,128,93.31494,69.97949A8,8,0,0,0,93.97949,58.68555Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M245.31494,122.02051l-72-64a8.00018,8.00018,0,0,0-10.62988,11.959L227.9585,128l-65.27344,58.02051a8.00018,8.00018,0,0,0,10.62988,11.959l72-64a8.00054,8.00054,0,0,0,0-11.959Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "88 64 16 128 88 192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "168 64 240 128 168 192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "88 64 16 128 88 192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "168 64 240 128 168 192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "88 64 16 128 88 192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "168 64 240 128 168 192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4o = [];
/* style */

const __vue_inject_styles__$4o = undefined;
/* scoped */

const __vue_scope_id__$4o = undefined;
/* module identifier */

const __vue_module_identifier__$4o = undefined;
/* functional template */

const __vue_is_functional_template__$4o = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4o = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4o,
  staticRenderFns: __vue_staticRenderFns__$4o
}, __vue_inject_styles__$4o, __vue_script__$4o, __vue_scope_id__$4o, __vue_is_functional_template__$4o, __vue_module_identifier__$4o, false, undefined, undefined, undefined);

var script$4p = Vue.extend({
  name: "PhCoffee",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4p = script$4p;
/* template */

var __vue_render__$4p = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "32",
      "y1": "216",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M83.29651,216.0038A88.01441,88.01441,0,0,1,32,136V88H208v48a88.0144,88.0144,0,0,1-51.29712,80.00408",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,88h4a32,32,0,0,1,32,32V128a32,32,0,0,1-32,32h-7.37846",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "24",
      "x2": "80",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "24",
      "x2": "120",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "24",
      "x2": "160",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M83.29651,216.0038A88.01441,88.01441,0,0,1,32,136V88H208v48a88.0144,88.0144,0,0,1-51.29712,80.00408Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "24",
      "x2": "88",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "24",
      "x2": "120",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "24",
      "x2": "152",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "216",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M83.29651,216.0038A88.01441,88.01441,0,0,1,32,136V88H208v48a88.0144,88.0144,0,0,1-51.29712,80.00408",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,88h0a32,32,0,0,1,32,32V128a32,32,0,0,1-32,32h-3.37846",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,56V24a8,8,0,0,1,16,0V56a8,8,0,0,1-16,0Zm40,8a8.00008,8.00008,0,0,0,8-8V24a8,8,0,0,0-16,0V56A8.00008,8.00008,0,0,0,120,64Zm32,0a8.00008,8.00008,0,0,0,8-8V24a8,8,0,0,0-16,0V56A8.00008,8.00008,0,0,0,152,64Zm96,56v8a40.04613,40.04613,0,0,1-37.50781,39.91455A96.65441,96.65441,0,0,1,183.46387,208H208a8,8,0,0,1,0,16H156.8208c-.0376.00049-.07568.00586-.11279.00586-.02832,0-.05615-.00537-.08447-.00586H83.15869c-.04541-.001-.09033.00146-.13574,0H32a8,8,0,0,1,0-16H56.53613A96.31957,96.31957,0,0,1,24,136V88a8.00008,8.00008,0,0,1,8-8H208A40.04521,40.04521,0,0,1,248,120Zm-16,0a24.03806,24.03806,0,0,0-16-22.624V136a95.32337,95.32337,0,0,1-1.20312,15.01367A24.039,24.039,0,0,0,232,128Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "88",
      "y1": "24",
      "x2": "88",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "24",
      "x2": "120",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "24",
      "x2": "152",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "216",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M83.29651,216.0038A88.01441,88.01441,0,0,1,32,136V88H208v48a88.0144,88.0144,0,0,1-51.29712,80.00408",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,88h0a32,32,0,0,1,32,32V128a32,32,0,0,1-32,32h-3.37846",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "88",
      "y1": "24",
      "x2": "88",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "24",
      "x2": "120",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "24",
      "x2": "152",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "216",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M83.29651,216.0038A88.01441,88.01441,0,0,1,32,136V88H208v48a88.0144,88.0144,0,0,1-51.29712,80.00408",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,88h0a32,32,0,0,1,32,32V128a32,32,0,0,1-32,32h-3.37846",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "88",
      "y1": "24",
      "x2": "88",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "24",
      "x2": "120",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "24",
      "x2": "152",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "216",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M83.29651,216.0038A88.01441,88.01441,0,0,1,32,136V88H208v48a88.0144,88.0144,0,0,1-51.29712,80.00408",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,88h0a32,32,0,0,1,32,32V128a32,32,0,0,1-32,32h-3.37846",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4p = [];
/* style */

const __vue_inject_styles__$4p = undefined;
/* scoped */

const __vue_scope_id__$4p = undefined;
/* module identifier */

const __vue_module_identifier__$4p = undefined;
/* functional template */

const __vue_is_functional_template__$4p = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4p = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4p,
  staticRenderFns: __vue_staticRenderFns__$4p
}, __vue_inject_styles__$4p, __vue_script__$4p, __vue_scope_id__$4p, __vue_is_functional_template__$4p, __vue_module_identifier__$4p, false, undefined, undefined, undefined);

var script$4q = Vue.extend({
  name: "PhCoin",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4q = script$4q;
/* template */

var __vue_render__$4q = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "104",
      "rx": "104",
      "ry": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "152",
      "x2": "128",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,104v48c0,24,40,48,104,48s104-24,104-48V104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "142.10679",
      "x2": "192",
      "y2": "190.10744",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "142.10679",
      "x2": "64",
      "y2": "190.10721",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "104",
      "rx": "104",
      "ry": "48",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "104",
      "rx": "104",
      "ry": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "152",
      "x2": "128",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,104v48c0,24,40,48,104,48s104-24,104-48V104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "142.10679",
      "x2": "192",
      "y2": "190.10744",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "142.10679",
      "x2": "64",
      "y2": "190.10721",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M207.57812,63.84473C186.84668,53.47852,159.3291,48,128,48S69.15332,53.47852,48.42188,63.84473C27.81738,74.14746,16,88.7832,16,104v48c0,15.2168,11.81738,29.85254,32.42188,40.15527C69.15332,202.52148,96.6709,208,128,208s58.84668-5.47852,79.57812-15.84473C228.18262,181.85254,240,167.2168,240,152V104C240,88.7832,228.18262,74.14746,207.57812,63.84473ZM120,159.86328V191.855c-18.98486-.62207-35.02637-3.42822-48-7.49414V153.04541A203.76361,203.76361,0,0,0,120,159.86328Zm16,0a203.76361,203.76361,0,0,0,48-6.81787v31.31543c-12.97363,4.06592-29.01514,6.87207-48,7.49414ZM32,152V133.53076a82.6098,82.6098,0,0,0,16.42188,10.62451c2.43164,1.21582,4.96484,2.3584,7.57812,3.43848v30.43359C40.17334,170.16455,32,160.294,32,152Zm168,26.02734V147.59375c2.61328-1.08008,5.14648-2.22266,7.57812-3.43848A82.6098,82.6098,0,0,0,224,133.53076V152C224,160.294,215.82666,170.16455,200,178.02734Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "104",
      "rx": "104",
      "ry": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "152",
      "x2": "128",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,104v48c0,24,40,48,104,48s104-24,104-48V104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "142.10679",
      "x2": "192",
      "y2": "190.10744",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "142.10679",
      "x2": "64",
      "y2": "190.10721",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "104",
      "rx": "104",
      "ry": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "152",
      "x2": "128",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,104v48c0,24,40,48,104,48s104-24,104-48V104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "142.10679",
      "x2": "192",
      "y2": "190.10744",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "142.10679",
      "x2": "64",
      "y2": "190.10721",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "104",
      "rx": "104",
      "ry": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "152",
      "x2": "128",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,104v48c0,24,40,48,104,48s104-24,104-48V104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "142.10679",
      "x2": "192",
      "y2": "190.10744",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "142.10679",
      "x2": "64",
      "y2": "190.10721",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4q = [];
/* style */

const __vue_inject_styles__$4q = undefined;
/* scoped */

const __vue_scope_id__$4q = undefined;
/* module identifier */

const __vue_module_identifier__$4q = undefined;
/* functional template */

const __vue_is_functional_template__$4q = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4q = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4q,
  staticRenderFns: __vue_staticRenderFns__$4q
}, __vue_inject_styles__$4q, __vue_script__$4q, __vue_scope_id__$4q, __vue_is_functional_template__$4q, __vue_module_identifier__$4q, false, undefined, undefined, undefined);

var script$4r = Vue.extend({
  name: "PhColumns",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4r = script$4r;
/* template */

var __vue_render__$4r = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "-6",
      "y": "102",
      "width": "176",
      "height": "52",
      "rx": "8",
      "transform": "translate(210 46) rotate(90)",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "86",
      "y": "102",
      "width": "176",
      "height": "52",
      "rx": "8",
      "transform": "translate(302 -46) rotate(90)",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "-4",
      "y": "100",
      "width": "176",
      "height": "56",
      "rx": "8",
      "transform": "translate(212 44) rotate(90)",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "84",
      "y": "100",
      "width": "176",
      "height": "56",
      "rx": "8",
      "transform": "translate(300 -44) rotate(90)",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "-4",
      "y": "100",
      "width": "176",
      "height": "56",
      "rx": "8",
      "transform": "translate(212 44) rotate(90)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "84",
      "y": "100",
      "width": "176",
      "height": "56",
      "rx": "8",
      "transform": "translate(300 -44) rotate(90)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M120,48V208a16.01833,16.01833,0,0,1-16,16H64a16.01833,16.01833,0,0,1-16-16V48A16.01833,16.01833,0,0,1,64,32h40A16.01833,16.01833,0,0,1,120,48Zm72-16H152a16.01833,16.01833,0,0,0-16,16V208a16.01833,16.01833,0,0,0,16,16h40a16.01833,16.01833,0,0,0,16-16V48A16.01833,16.01833,0,0,0,192,32Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "-4",
      "y": "100",
      "width": "176",
      "height": "56",
      "rx": "8",
      "transform": "translate(212 44) rotate(90)",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "84",
      "y": "100",
      "width": "176",
      "height": "56",
      "rx": "8",
      "transform": "translate(300 -44) rotate(90)",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "-4",
      "y": "100",
      "width": "176",
      "height": "56",
      "rx": "8",
      "transform": "translate(212 44) rotate(90)",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "84",
      "y": "100",
      "width": "176",
      "height": "56",
      "rx": "8",
      "transform": "translate(300 -44) rotate(90)",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "-4",
      "y": "100",
      "width": "176",
      "height": "56",
      "rx": "8",
      "transform": "translate(212 44) rotate(90)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "84",
      "y": "100",
      "width": "176",
      "height": "56",
      "rx": "8",
      "transform": "translate(300 -44) rotate(90)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4r = [];
/* style */

const __vue_inject_styles__$4r = undefined;
/* scoped */

const __vue_scope_id__$4r = undefined;
/* module identifier */

const __vue_module_identifier__$4r = undefined;
/* functional template */

const __vue_is_functional_template__$4r = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4r = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4r,
  staticRenderFns: __vue_staticRenderFns__$4r
}, __vue_inject_styles__$4r, __vue_script__$4r, __vue_scope_id__$4r, __vue_is_functional_template__$4r, __vue_module_identifier__$4r, false, undefined, undefined, undefined);

var script$4s = Vue.extend({
  name: "PhCommand",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4s = script$4s;
/* template */

var __vue_render__$4s = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M180,48h.00006A27.99994,27.99994,0,0,1,208,75.99994V76a28,28,0,0,1-28,28H152a0,0,0,0,1,0,0V76a28,28,0,0,1,28-28Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,48H76a28,28,0,0,1,28,28v.00006A27.99994,27.99994,0,0,1,76.00006,104H76A28,28,0,0,1,48,76V48A0,0,0,0,1,48,48Z",
      "transform": "translate(152 152) rotate(180)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,152h28a28,28,0,0,1,28,28v.00006A27.99994,27.99994,0,0,1,180.00006,208H180a28,28,0,0,1-28-28V152A0,0,0,0,1,152,152Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76,152h.00006A27.99994,27.99994,0,0,1,104,179.99994V180a28,28,0,0,1-28,28H48a0,0,0,0,1,0,0V180A28,28,0,0,1,76,152Z",
      "transform": "translate(152 360) rotate(-180)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "104",
      "y": "104",
      "width": "48",
      "height": "48",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M180,48h.00006A27.99994,27.99994,0,0,1,208,75.99994V76a28,28,0,0,1-28,28H152a0,0,0,0,1,0,0V76a28,28,0,0,1,28-28Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,48H76a28,28,0,0,1,28,28v.00006A27.99994,27.99994,0,0,1,76.00006,104H76A28,28,0,0,1,48,76V48A0,0,0,0,1,48,48Z",
      "transform": "translate(152 152) rotate(180)",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,152h28a28,28,0,0,1,28,28v.00006A27.99994,27.99994,0,0,1,180.00006,208H180a28,28,0,0,1-28-28V152A0,0,0,0,1,152,152Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76,152h.00006A27.99994,27.99994,0,0,1,104,179.99994V180a28,28,0,0,1-28,28H48a0,0,0,0,1,0,0V180A28,28,0,0,1,76,152Z",
      "transform": "translate(152 360) rotate(-180)",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76,152h.00006A27.99994,27.99994,0,0,1,104,179.99994V180a28,28,0,0,1-28,28H48a0,0,0,0,1,0,0V180A28,28,0,0,1,76,152Z",
      "transform": "translate(152 360) rotate(-180)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M180,48h.00006A27.99994,27.99994,0,0,1,208,75.99994V76a28,28,0,0,1-28,28H152a0,0,0,0,1,0,0V76a28,28,0,0,1,28-28Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,48H76a28,28,0,0,1,28,28v.00006A27.99994,27.99994,0,0,1,76.00006,104H76A28,28,0,0,1,48,76V48A0,0,0,0,1,48,48Z",
      "transform": "translate(152 152) rotate(180)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,152h28a28,28,0,0,1,28,28v.00006A27.99994,27.99994,0,0,1,180.00006,208H180a28,28,0,0,1-28-28V152A0,0,0,0,1,152,152Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "104",
      "y": "104",
      "width": "48",
      "height": "48",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M180,144H160V112h20a36,36,0,1,0-36-36V96H112V76a36,36,0,1,0-36,36H96v32H76a36,36,0,1,0,36,36V160h32v20a36,36,0,1,0,36-36ZM160,76a20,20,0,1,1,20,20H160ZM56,76a20,20,0,0,1,40,0V96H76A20.0226,20.0226,0,0,1,56,76ZM96,180a20,20,0,1,1-20-20H96Zm16-68h32v32H112Zm68,88a20.0226,20.0226,0,0,1-20-20V160h20a20,20,0,0,1,0,40Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M180,48h.00006A27.99994,27.99994,0,0,1,208,75.99994V76a28,28,0,0,1-28,28H152a0,0,0,0,1,0,0V76a28,28,0,0,1,28-28Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,48H76a28,28,0,0,1,28,28v.00006A27.99994,27.99994,0,0,1,76.00006,104H76A28,28,0,0,1,48,76V48A0,0,0,0,1,48,48Z",
      "transform": "translate(152 152) rotate(180)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,152h28a28,28,0,0,1,28,28v.00006A27.99994,27.99994,0,0,1,180.00006,208H180a28,28,0,0,1-28-28V152A0,0,0,0,1,152,152Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76,152h.00006A27.99994,27.99994,0,0,1,104,179.99994V180a28,28,0,0,1-28,28H48a0,0,0,0,1,0,0V180A28,28,0,0,1,76,152Z",
      "transform": "translate(152 360) rotate(-180)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "104",
      "y": "104",
      "width": "48",
      "height": "48",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M180,48h.00006A27.99994,27.99994,0,0,1,208,75.99994V76a28,28,0,0,1-28,28H152a0,0,0,0,1,0,0V76a28,28,0,0,1,28-28Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,48H76a28,28,0,0,1,28,28v.00006A27.99994,27.99994,0,0,1,76.00006,104H76A28,28,0,0,1,48,76V48A0,0,0,0,1,48,48Z",
      "transform": "translate(152 152) rotate(180)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,152h28a28,28,0,0,1,28,28v.00006A27.99994,27.99994,0,0,1,180.00006,208H180a28,28,0,0,1-28-28V152A0,0,0,0,1,152,152Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76,152h.00006A27.99994,27.99994,0,0,1,104,179.99994V180a28,28,0,0,1-28,28H48a0,0,0,0,1,0,0V180A28,28,0,0,1,76,152Z",
      "transform": "translate(152 360) rotate(-180)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "104",
      "y": "104",
      "width": "48",
      "height": "48",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M180,48h.00006A27.99994,27.99994,0,0,1,208,75.99994V76a28,28,0,0,1-28,28H152a0,0,0,0,1,0,0V76a28,28,0,0,1,28-28Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,48H76a28,28,0,0,1,28,28v.00006A27.99994,27.99994,0,0,1,76.00006,104H76A28,28,0,0,1,48,76V48A0,0,0,0,1,48,48Z",
      "transform": "translate(152 152) rotate(180)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,152h28a28,28,0,0,1,28,28v.00006A27.99994,27.99994,0,0,1,180.00006,208H180a28,28,0,0,1-28-28V152A0,0,0,0,1,152,152Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76,152h.00006A27.99994,27.99994,0,0,1,104,179.99994V180a28,28,0,0,1-28,28H48a0,0,0,0,1,0,0V180A28,28,0,0,1,76,152Z",
      "transform": "translate(152 360) rotate(-180)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "104",
      "y": "104",
      "width": "48",
      "height": "48",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4s = [];
/* style */

const __vue_inject_styles__$4s = undefined;
/* scoped */

const __vue_scope_id__$4s = undefined;
/* module identifier */

const __vue_module_identifier__$4s = undefined;
/* functional template */

const __vue_is_functional_template__$4s = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4s = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4s,
  staticRenderFns: __vue_staticRenderFns__$4s
}, __vue_inject_styles__$4s, __vue_script__$4s, __vue_scope_id__$4s, __vue_is_functional_template__$4s, __vue_module_identifier__$4s, false, undefined, undefined, undefined);

var script$4t = Vue.extend({
  name: "PhCompass",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4t = script$4t;
/* template */

var __vue_render__$4t = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "144.965 144.971 167.402 88.485 111.024 111.029 88.396 167.598 144.965 144.971",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,32a96,96,0,1,0,96,96A95.99991,95.99991,0,0,0,128,32Zm16.9646,112.9707-59.397,25.45557,25.45606-59.397,62.0354-28.20069Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "144.965 144.971 173.059 82.828 111.024 111.029 85.568 170.426 144.965 144.971",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M127.99975,24a104,104,0,1,0,104,104A104.11791,104.11791,0,0,0,127.99975,24Zm52.34961,62.124-28.09472,62.14209a7.99954,7.99954,0,0,1-4.13868,4.05713L88.71948,177.7793A7.99971,7.99971,0,0,1,78.2146,167.27539l25.45507-59.39746a8.00275,8.00275,0,0,1,4.043-4.13086L169.74878,75.5459A8,8,0,0,1,180.34936,86.124Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "144.965 144.971 173.059 82.828 111.024 111.029 85.568 170.426 144.965 144.971",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "144.965 144.971 173.059 82.828 111.024 111.029 85.568 170.426 144.965 144.971",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "144.965 144.971 173.059 82.828 111.024 111.029 85.568 170.426 144.965 144.971",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4t = [];
/* style */

const __vue_inject_styles__$4t = undefined;
/* scoped */

const __vue_scope_id__$4t = undefined;
/* module identifier */

const __vue_module_identifier__$4t = undefined;
/* functional template */

const __vue_is_functional_template__$4t = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4t = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4t,
  staticRenderFns: __vue_staticRenderFns__$4t
}, __vue_inject_styles__$4t, __vue_script__$4t, __vue_scope_id__$4t, __vue_is_functional_template__$4t, __vue_module_identifier__$4t, false, undefined, undefined, undefined);

var script$4u = Vue.extend({
  name: "PhComputerTower",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4u = script$4u;
/* template */

var __vue_render__$4u = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "160",
      "y1": "76",
      "x2": "96",
      "y2": "76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "116",
      "x2": "96",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "56",
      "width": "192",
      "height": "144",
      "rx": "8",
      "transform": "translate(256 0) rotate(90)",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "184",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "56",
      "width": "192",
      "height": "144",
      "rx": "8",
      "transform": "translate(256 0) rotate(90)",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "72",
      "x2": "96",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "104",
      "x2": "96",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "56",
      "width": "192",
      "height": "144",
      "rx": "8",
      "transform": "translate(256 0) rotate(90)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "180",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M192,24H64A16.01833,16.01833,0,0,0,48,40V216a16.01833,16.01833,0,0,0,16,16H192a16.01833,16.01833,0,0,0,16-16V40A16.01833,16.01833,0,0,0,192,24ZM128,192a12,12,0,1,1,12-12A12.01343,12.01343,0,0,1,128,192Zm32-80H96a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm0-32H96a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "160",
      "y1": "72",
      "x2": "96",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "104",
      "x2": "96",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "56",
      "width": "192",
      "height": "144",
      "rx": "8",
      "transform": "translate(256 0) rotate(90)",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "180",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "160",
      "y1": "72",
      "x2": "96",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "104",
      "x2": "96",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "56",
      "width": "192",
      "height": "144",
      "rx": "8",
      "transform": "translate(256 0) rotate(90)",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "180",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "160",
      "y1": "72",
      "x2": "96",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "104",
      "x2": "96",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "56",
      "width": "192",
      "height": "144",
      "rx": "8",
      "transform": "translate(256 0) rotate(90)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "180",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4u = [];
/* style */

const __vue_inject_styles__$4u = undefined;
/* scoped */

const __vue_scope_id__$4u = undefined;
/* module identifier */

const __vue_module_identifier__$4u = undefined;
/* functional template */

const __vue_is_functional_template__$4u = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4u = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4u,
  staticRenderFns: __vue_staticRenderFns__$4u
}, __vue_inject_styles__$4u, __vue_script__$4u, __vue_scope_id__$4u, __vue_is_functional_template__$4u, __vue_module_identifier__$4u, false, undefined, undefined, undefined);

var script$4v = Vue.extend({
  name: "PhCookie",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4v = script$4v;
/* template */

var __vue_render__$4v = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M223.9944,127.41159a95.69791,95.69791,0,0,1-28.17312,68.53158c-36.94566,36.88079-97.30608,37.29538-134.72958.89956a95.99643,95.99643,0,0,1,67.48515-164.8372,8.01374,8.01374,0,0,1,7.80464,9.7612,31.99345,31.99345,0,0,0,30.85987,39.031,8.02776,8.02776,0,0,1,7.96088,7.96088,31.99346,31.99346,0,0,0,39.03035,30.86A8.01158,8.01158,0,0,1,223.9944,127.41159Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "172",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "164",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "108",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "136",
      "cy": "124",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M223.9944,127.41159a95.69791,95.69791,0,0,1-28.17312,68.53158c-36.94566,36.88079-97.30608,37.29538-134.72958.89956a95.99643,95.99643,0,0,1,67.48515-164.8372,8.01374,8.01374,0,0,1,7.80464,9.7612,31.99345,31.99345,0,0,0,30.85987,39.031,8.02776,8.02776,0,0,1,7.96088,7.96088,31.99346,31.99346,0,0,0,39.03035,30.86A8.01158,8.01158,0,0,1,223.9944,127.41159Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M223.9944,127.41159a95.69791,95.69791,0,0,1-28.17312,68.53158c-36.94566,36.88079-97.30608,37.29538-134.72958.89956a95.99643,95.99643,0,0,1,67.48515-164.8372,8.01374,8.01374,0,0,1,7.80464,9.7612,31.99345,31.99345,0,0,0,30.85987,39.031,8.02776,8.02776,0,0,1,7.96088,7.96088,31.99346,31.99346,0,0,0,39.03035,30.86A8.01158,8.01158,0,0,1,223.9944,127.41159Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "172",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "164",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "108",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "136",
      "cy": "124",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M225.94092,114.89844a15.91968,15.91968,0,0,0-13.46094-3.085,23.99389,23.99389,0,0,1-29.27832-23.14063,15.94771,15.94771,0,0,0-15.87354-15.875A23.99268,23.99268,0,0,1,144.187,43.51953a16.01308,16.01308,0,0,0-15.562-19.51367c-.21729-.001-.43018-.00195-.647-.00195A104,104,0,1,0,231.99463,127.3623v-.001A15.97461,15.97461,0,0,0,225.94092,114.89844ZM75.51465,99.51465a12.0001,12.0001,0,1,1,0,16.9707A12.00062,12.00062,0,0,1,75.51465,99.51465Zm24.9707,72.9707a12.0001,12.0001,0,1,1,0-16.9707A12.00062,12.00062,0,0,1,100.48535,172.48535Zm27.0293-40a12.0001,12.0001,0,1,1,16.9707,0A12.00019,12.00019,0,0,1,127.51465,132.48535Zm36.9707,48a12.0001,12.0001,0,1,1,0-16.9707A12.00062,12.00062,0,0,1,164.48535,180.48535Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M223.9944,127.41159a95.69791,95.69791,0,0,1-28.17312,68.53158c-36.94566,36.88079-97.30608,37.29538-134.72958.89956a95.99643,95.99643,0,0,1,67.48515-164.8372,8.01374,8.01374,0,0,1,7.80464,9.7612,31.99345,31.99345,0,0,0,30.85987,39.031,8.02776,8.02776,0,0,1,7.96088,7.96088,31.99346,31.99346,0,0,0,39.03035,30.86A8.01158,8.01158,0,0,1,223.9944,127.41159Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "172",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "164",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "108",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "136",
      "cy": "124",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M223.9944,127.41159a95.69791,95.69791,0,0,1-28.17312,68.53158c-36.94566,36.88079-97.30608,37.29538-134.72958.89956a95.99643,95.99643,0,0,1,67.48515-164.8372,8.01374,8.01374,0,0,1,7.80464,9.7612,31.99345,31.99345,0,0,0,30.85987,39.031,8.02776,8.02776,0,0,1,7.96088,7.96088,31.99346,31.99346,0,0,0,39.03035,30.86A8.01158,8.01158,0,0,1,223.9944,127.41159Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "172",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "164",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "108",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "136",
      "cy": "124",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M223.9944,127.41159a95.69791,95.69791,0,0,1-28.17312,68.53158c-36.94566,36.88079-97.30608,37.29538-134.72958.89956a95.99643,95.99643,0,0,1,67.48515-164.8372,8.01374,8.01374,0,0,1,7.80464,9.7612,31.99345,31.99345,0,0,0,30.85987,39.031,8.02776,8.02776,0,0,1,7.96088,7.96088,31.99346,31.99346,0,0,0,39.03035,30.86A8.01158,8.01158,0,0,1,223.9944,127.41159Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "172",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "164",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "108",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "136",
      "cy": "124",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4v = [];
/* style */

const __vue_inject_styles__$4v = undefined;
/* scoped */

const __vue_scope_id__$4v = undefined;
/* module identifier */

const __vue_module_identifier__$4v = undefined;
/* functional template */

const __vue_is_functional_template__$4v = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4v = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4v,
  staticRenderFns: __vue_staticRenderFns__$4v
}, __vue_inject_styles__$4v, __vue_script__$4v, __vue_scope_id__$4v, __vue_is_functional_template__$4v, __vue_module_identifier__$4v, false, undefined, undefined, undefined);

var script$4w = Vue.extend({
  name: "PhCookingPot",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4w = script$4w;
/* template */

var __vue_render__$4w = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "88",
      "y1": "16",
      "x2": "88",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "16",
      "x2": "128",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "16",
      "x2": "168",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M52,80H204a8,8,0,0,1,8,8v96a24,24,0,0,1-24,24H68a24,24,0,0,1-24-24V88A8,8,0,0,1,52,80Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "244",
      "y1": "96",
      "x2": "212",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "96",
      "x2": "44",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M48,80H208a8,8,0,0,1,8,8v96a24,24,0,0,1-24,24H64a24,24,0,0,1-24-24V88A8,8,0,0,1,48,80Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "16",
      "x2": "96",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "16",
      "x2": "128",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "16",
      "x2": "160",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,80H208a8,8,0,0,1,8,8v96a24,24,0,0,1-24,24H64a24,24,0,0,1-24-24V88A8,8,0,0,1,48,80Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "248",
      "y1": "96",
      "x2": "216",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "8",
      "y1": "96",
      "x2": "40",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M88,48V16a8,8,0,0,1,16,0V48a8,8,0,0,1-16,0Zm40,8a8.00039,8.00039,0,0,0,8-8V16a8,8,0,0,0-16,0V48A8.00039,8.00039,0,0,0,128,56Zm32,0a8.00039,8.00039,0,0,0,8-8V16a8,8,0,0,0-16,0V48A8.00039,8.00039,0,0,0,160,56Zm94.3999,35.2002a7.99886,7.99886,0,0,0-11.1997-1.6001L224,104V88a16.01833,16.01833,0,0,0-16-16H48A16.01833,16.01833,0,0,0,32,88v16L12.7998,89.6001a7.9998,7.9998,0,0,0-9.5996,12.7998L32,124v60a32.03667,32.03667,0,0,0,32,32H192a32.03667,32.03667,0,0,0,32-32V124l28.7998-21.6001A7.9993,7.9993,0,0,0,254.3999,91.2002Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "16",
      "x2": "96",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "16",
      "x2": "128",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "16",
      "x2": "160",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,80H208a8,8,0,0,1,8,8v96a24,24,0,0,1-24,24H64a24,24,0,0,1-24-24V88A8,8,0,0,1,48,80Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "248",
      "y1": "96",
      "x2": "216",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "8",
      "y1": "96",
      "x2": "40",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "16",
      "x2": "96",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "16",
      "x2": "128",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "16",
      "x2": "160",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,80H208a8,8,0,0,1,8,8v96a24,24,0,0,1-24,24H64a24,24,0,0,1-24-24V88A8,8,0,0,1,48,80Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "248",
      "y1": "96",
      "x2": "216",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "8",
      "y1": "96",
      "x2": "40",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "16",
      "x2": "96",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "16",
      "x2": "128",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "16",
      "x2": "160",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,80H208a8,8,0,0,1,8,8v96a24,24,0,0,1-24,24H64a24,24,0,0,1-24-24V88A8,8,0,0,1,48,80Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "248",
      "y1": "96",
      "x2": "216",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "8",
      "y1": "96",
      "x2": "40",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4w = [];
/* style */

const __vue_inject_styles__$4w = undefined;
/* scoped */

const __vue_scope_id__$4w = undefined;
/* module identifier */

const __vue_module_identifier__$4w = undefined;
/* functional template */

const __vue_is_functional_template__$4w = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4w = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4w,
  staticRenderFns: __vue_staticRenderFns__$4w
}, __vue_inject_styles__$4w, __vue_script__$4w, __vue_scope_id__$4w, __vue_is_functional_template__$4w, __vue_module_identifier__$4w, false, undefined, undefined, undefined);

var script$4x = Vue.extend({
  name: "PhCopy",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4x = script$4x;
/* template */

var __vue_render__$4x = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "168 167.993 216 167.993 216 39.993 88 39.993 88 87.993",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "39.99902",
      "y": "87.99414",
      "width": "128",
      "height": "128",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "168 87.993 168 167.993 216 167.993 216 39.993 88 39.993 88 87.993 168 87.993",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "168 167.993 216 167.993 216 39.993 88 39.993 88 87.993",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "39.99902",
      "y": "87.99414",
      "width": "128",
      "height": "128",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M215.99414,31.99316h-128a8.0004,8.0004,0,0,0-8,8v40.001h-40.001a8.0004,8.0004,0,0,0-8,8v128a8.0004,8.0004,0,0,0,8,8h128a8.00039,8.00039,0,0,0,8-8v-40.001h40.001a8.00039,8.00039,0,0,0,8-8v-128A8.0004,8.0004,0,0,0,215.99414,31.99316Zm-8,128h-32.001v-71.999a8.00039,8.00039,0,0,0-8-8h-71.999v-32.001h112Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "168 167.993 216 167.993 216 39.993 88 39.993 88 87.993",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "39.99902",
      "y": "87.99414",
      "width": "128",
      "height": "128",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "168 167.993 216 167.993 216 39.993 88 39.993 88 87.993",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "39.99902",
      "y": "87.99414",
      "width": "128",
      "height": "128",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "168 167.993 216 167.993 216 39.993 88 39.993 88 87.993",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "39.99902",
      "y": "87.99414",
      "width": "128",
      "height": "128",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4x = [];
/* style */

const __vue_inject_styles__$4x = undefined;
/* scoped */

const __vue_scope_id__$4x = undefined;
/* module identifier */

const __vue_module_identifier__$4x = undefined;
/* functional template */

const __vue_is_functional_template__$4x = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4x = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4x,
  staticRenderFns: __vue_staticRenderFns__$4x
}, __vue_inject_styles__$4x, __vue_script__$4x, __vue_scope_id__$4x, __vue_is_functional_template__$4x, __vue_module_identifier__$4x, false, undefined, undefined, undefined);

var script$4y = Vue.extend({
  name: "PhCopySimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4y = script$4y;
/* template */

var __vue_render__$4y = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "219.993 175.995 219.993 35.994 79.986 35.994",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "39.98633",
      "y": "75.99512",
      "width": "140.00586",
      "height": "140",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "39.98633",
      "y": "71.99512",
      "width": "144.00586",
      "height": "144",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "215.993 183.995 215.993 39.994 71.986 39.994",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "39.98633",
      "y": "71.99512",
      "width": "144.00586",
      "height": "144",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M215.99365,31.99414H71.98682a8,8,0,1,0,0,16H207.99365v136.001a8,8,0,0,0,16,0V39.99414A8.00008,8.00008,0,0,0,215.99365,31.99414Z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "31.98682",
      "y": "63.99512",
      "width": "160.00586",
      "height": "160",
      "rx": "8"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "215.993 183.995 215.993 39.994 71.986 39.994",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "39.98633",
      "y": "71.99512",
      "width": "144.00586",
      "height": "144",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "215.993 183.995 215.993 39.994 71.986 39.994",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "39.98633",
      "y": "71.99512",
      "width": "144.00586",
      "height": "144",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "215.993 183.995 215.993 39.994 71.986 39.994",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "39.98633",
      "y": "71.99512",
      "width": "144.00586",
      "height": "144",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4y = [];
/* style */

const __vue_inject_styles__$4y = undefined;
/* scoped */

const __vue_scope_id__$4y = undefined;
/* module identifier */

const __vue_module_identifier__$4y = undefined;
/* functional template */

const __vue_is_functional_template__$4y = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4y = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4y,
  staticRenderFns: __vue_staticRenderFns__$4y
}, __vue_inject_styles__$4y, __vue_script__$4y, __vue_scope_id__$4y, __vue_is_functional_template__$4y, __vue_module_identifier__$4y, false, undefined, undefined, undefined);

var script$4z = Vue.extend({
  name: "PhCopyright",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4z = script$4z;
/* template */

var __vue_render__$4z = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160.00112,152.00142a40,40,0,1,1-.00029-48.013",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160.00112,152.00142a40,40,0,1,1-.00029-48.013",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,20A108,108,0,1,0,236,128,108.12249,108.12249,0,0,0,128,20Zm0,196a88,88,0,1,1,88-88A88.09957,88.09957,0,0,1,128,216Zm0-160a72,72,0,1,0,72,72A72.08124,72.08124,0,0,0,128,56Zm.00293,103.99512a31.76384,31.76384,0,0,0,25.60254-12.79981,8,8,0,0,1,12.791,9.61182,47.99976,47.99976,0,1,1,0-57.62451,8,8,0,0,1-12.791,9.61181,32.001,32.001,0,1,0-25.60254,51.20069Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160.00112,152.00142a40,40,0,1,1-.00029-48.013",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160.00112,152.00142a40,40,0,1,1-.00029-48.013",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160.00112,152.00142a40,40,0,1,1-.00029-48.013",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4z = [];
/* style */

const __vue_inject_styles__$4z = undefined;
/* scoped */

const __vue_scope_id__$4z = undefined;
/* module identifier */

const __vue_module_identifier__$4z = undefined;
/* functional template */

const __vue_is_functional_template__$4z = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4z = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4z,
  staticRenderFns: __vue_staticRenderFns__$4z
}, __vue_inject_styles__$4z, __vue_script__$4z, __vue_scope_id__$4z, __vue_is_functional_template__$4z, __vue_module_identifier__$4z, false, undefined, undefined, undefined);

var script$4A = Vue.extend({
  name: "PhCornersIn",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4A = script$4A;
/* template */

var __vue_render__$4A = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "208 96 160 96 160 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48 160 96 160 96 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 208 160 160 208 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 48 96 96 48 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "208 96 160 96 160 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48 160 96 160 96 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 208 160 160 208 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 48 96 96 48 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M152,96V48a8.0001,8.0001,0,0,1,13.65723-5.65674l48,48A8.00038,8.00038,0,0,1,208,104H160A8.00008,8.00008,0,0,1,152,96ZM96,152H48a8.00038,8.00038,0,0,0-5.65723,13.65674l48,48A8.0001,8.0001,0,0,0,104,208V160A8.00008,8.00008,0,0,0,96,152ZM99.06152,40.60889a7.99989,7.99989,0,0,0-8.71875,1.73437l-48,48A8.00038,8.00038,0,0,0,48,104H96a8.00008,8.00008,0,0,0,8-8V48A8.00015,8.00015,0,0,0,99.06152,40.60889ZM208,152H160a8.00008,8.00008,0,0,0-8,8v48a8.00018,8.00018,0,0,0,13.65723,5.65674l48-48A8.00038,8.00038,0,0,0,208,152Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "208 96 160 96 160 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48 160 96 160 96 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 208 160 160 208 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 48 96 96 48 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "208 96 160 96 160 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48 160 96 160 96 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 208 160 160 208 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 48 96 96 48 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "208 96 160 96 160 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48 160 96 160 96 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 208 160 160 208 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 48 96 96 48 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4A = [];
/* style */

const __vue_inject_styles__$4A = undefined;
/* scoped */

const __vue_scope_id__$4A = undefined;
/* module identifier */

const __vue_module_identifier__$4A = undefined;
/* functional template */

const __vue_is_functional_template__$4A = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4A = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4A,
  staticRenderFns: __vue_staticRenderFns__$4A
}, __vue_inject_styles__$4A, __vue_script__$4A, __vue_scope_id__$4A, __vue_is_functional_template__$4A, __vue_module_identifier__$4A, false, undefined, undefined, undefined);

var script$4B = Vue.extend({
  name: "PhCornersOut",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4B = script$4B;
/* template */

var __vue_render__$4B = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "168 48 208 48 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "88 208 48 208 48 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 168 208 208 168 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48 88 48 48 88 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "168 48 208 48 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "88 208 48 208 48 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 168 208 208 168 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48 88 48 48 88 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,48V88a8.00018,8.00018,0,0,1-13.65723,5.65674l-40-40A8.00037,8.00037,0,0,1,168,40h40A8.00008,8.00008,0,0,1,216,48ZM53.65723,162.34326A8.0001,8.0001,0,0,0,40,168v40a8.00039,8.00039,0,0,0,8,8H88a8.00038,8.00038,0,0,0,5.65723-13.65674Zm157.40429-1.73437a8.00026,8.00026,0,0,0-8.71875,1.73437l-40,40A8.00037,8.00037,0,0,0,168,216h40a8.00039,8.00039,0,0,0,8-8V168A8.00065,8.00065,0,0,0,211.06152,160.60889ZM88,40H48a8.00008,8.00008,0,0,0-8,8V88a8.00018,8.00018,0,0,0,13.65723,5.65674l40-40A8.00038,8.00038,0,0,0,88,40Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "168 48 208 48 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "88 208 48 208 48 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 168 208 208 168 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48 88 48 48 88 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "168 48 208 48 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "88 208 48 208 48 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 168 208 208 168 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48 88 48 48 88 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "168 48 208 48 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "88 208 48 208 48 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 168 208 208 168 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48 88 48 48 88 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4B = [];
/* style */

const __vue_inject_styles__$4B = undefined;
/* scoped */

const __vue_scope_id__$4B = undefined;
/* module identifier */

const __vue_module_identifier__$4B = undefined;
/* functional template */

const __vue_is_functional_template__$4B = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4B = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4B,
  staticRenderFns: __vue_staticRenderFns__$4B
}, __vue_inject_styles__$4B, __vue_script__$4B, __vue_scope_id__$4B, __vue_is_functional_template__$4B, __vue_module_identifier__$4B, false, undefined, undefined, undefined);

var script$4C = Vue.extend({
  name: "PhCpu",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4C = script$4C;
/* template */

var __vue_render__$4C = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "100",
      "y": "100",
      "width": "56",
      "height": "56",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "48",
      "y": "48",
      "width": "160",
      "height": "160",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "104",
      "x2": "232",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "152",
      "x2": "232",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "104",
      "x2": "48",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "152",
      "x2": "48",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "208",
      "x2": "152",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "208",
      "x2": "104",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "24",
      "x2": "152",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "24",
      "x2": "104",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,48H56a7.99993,7.99993,0,0,0-8,8V200a7.99993,7.99993,0,0,0,8,8H200a7.99993,7.99993,0,0,0,8-8V56A7.99993,7.99993,0,0,0,200,48ZM156,156H100V100h56Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "100",
      "y": "100",
      "width": "56",
      "height": "56",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "48",
      "y": "48",
      "width": "160",
      "height": "160",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "104",
      "x2": "232",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "152",
      "x2": "232",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "104",
      "x2": "48",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "152",
      "x2": "48",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "208",
      "x2": "152",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "208",
      "x2": "104",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "24",
      "x2": "152",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "24",
      "x2": "104",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232,144H216V112h16a8,8,0,0,0,0-16H216V56a16.01833,16.01833,0,0,0-16-16H160V24a8,8,0,0,0-16,0V40H112V24a8,8,0,0,0-16,0V40H56A16.01833,16.01833,0,0,0,40,56V96H24a8,8,0,0,0,0,16H40v32H24a8,8,0,0,0,0,16H40v40a16.01833,16.01833,0,0,0,16,16H96v16a8,8,0,0,0,16,0V216h32v16a8,8,0,0,0,16,0V216h40a16.01833,16.01833,0,0,0,16-16V160h16a8,8,0,0,0,0-16Zm-68,12a8.00039,8.00039,0,0,1-8,8H100a8.00039,8.00039,0,0,1-8-8V100a8.00039,8.00039,0,0,1,8-8h56a8.00039,8.00039,0,0,1,8,8Zm-56-48h40v40H108Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "100",
      "y": "100",
      "width": "56",
      "height": "56",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "48",
      "y": "48",
      "width": "160",
      "height": "160",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "104",
      "x2": "232",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "152",
      "x2": "232",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "104",
      "x2": "48",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "152",
      "x2": "48",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "208",
      "x2": "152",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "208",
      "x2": "104",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "24",
      "x2": "152",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "24",
      "x2": "104",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "100",
      "y": "100",
      "width": "56",
      "height": "56",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "48",
      "y": "48",
      "width": "160",
      "height": "160",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "104",
      "x2": "232",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "152",
      "x2": "232",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "104",
      "x2": "48",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "152",
      "x2": "48",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "208",
      "x2": "152",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "208",
      "x2": "104",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "24",
      "x2": "152",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "24",
      "x2": "104",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "100",
      "y": "100",
      "width": "56",
      "height": "56",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "48",
      "y": "48",
      "width": "160",
      "height": "160",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "104",
      "x2": "232",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "152",
      "x2": "232",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "104",
      "x2": "48",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "152",
      "x2": "48",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "208",
      "x2": "152",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "208",
      "x2": "104",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "24",
      "x2": "152",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "24",
      "x2": "104",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4C = [];
/* style */

const __vue_inject_styles__$4C = undefined;
/* scoped */

const __vue_scope_id__$4C = undefined;
/* module identifier */

const __vue_module_identifier__$4C = undefined;
/* functional template */

const __vue_is_functional_template__$4C = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4C = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4C,
  staticRenderFns: __vue_staticRenderFns__$4C
}, __vue_inject_styles__$4C, __vue_script__$4C, __vue_scope_id__$4C, __vue_is_functional_template__$4C, __vue_module_identifier__$4C, false, undefined, undefined, undefined);

var script$4D = Vue.extend({
  name: "PhCreditCard",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4D = script$4D;
/* template */

var __vue_render__$4D = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "56",
      "width": "208",
      "height": "144",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "163.99414",
      "y1": "164",
      "x2": "195.99414",
      "y2": "164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "107.99414",
      "y1": "164",
      "x2": "123.99414",
      "y2": "164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "23.99414",
      "y1": "96.85228",
      "x2": "231.99412",
      "y2": "96.85228",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M23.99414,96.85228h208L232,192a8,8,0,0,1-8,8H32a8,8,0,0,1-8-8Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "24",
      "y": "56",
      "width": "208",
      "height": "144",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "167.99414",
      "y1": "168",
      "x2": "199.99414",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "119.99414",
      "y1": "168",
      "x2": "135.99414",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "23.99414",
      "y1": "96.85228",
      "x2": "231.99412",
      "y2": "96.85228",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,48H32A16.01833,16.01833,0,0,0,16,64V96.73633c-.00049.03906-.00586.07715-.00586.11621s.00537.07715.00586.11621V192a16.01833,16.01833,0,0,0,16,16H224a16.01833,16.01833,0,0,0,16-16V64A16.01833,16.01833,0,0,0,224,48ZM135.99414,176h-16a8,8,0,0,1,0-16h16a8,8,0,1,1,0,16Zm64,0h-32a8,8,0,0,1,0-16h32a8,8,0,1,1,0,16ZM32,88.85254V64H224l.002,24.85254Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "56",
      "width": "208",
      "height": "144",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "167.99414",
      "y1": "168",
      "x2": "199.99414",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "119.99414",
      "y1": "168",
      "x2": "135.99414",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "23.99414",
      "y1": "96.85228",
      "x2": "231.99412",
      "y2": "96.85228",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "56",
      "width": "208",
      "height": "144",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "167.99414",
      "y1": "168",
      "x2": "199.99414",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "119.99414",
      "y1": "168",
      "x2": "135.99414",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "23.99414",
      "y1": "96.85228",
      "x2": "231.99412",
      "y2": "96.85228",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "56",
      "width": "208",
      "height": "144",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "167.99414",
      "y1": "168",
      "x2": "199.99414",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "119.99414",
      "y1": "168",
      "x2": "135.99414",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "23.99414",
      "y1": "96.85228",
      "x2": "231.99412",
      "y2": "96.85228",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4D = [];
/* style */

const __vue_inject_styles__$4D = undefined;
/* scoped */

const __vue_scope_id__$4D = undefined;
/* module identifier */

const __vue_module_identifier__$4D = undefined;
/* functional template */

const __vue_is_functional_template__$4D = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4D = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4D,
  staticRenderFns: __vue_staticRenderFns__$4D
}, __vue_inject_styles__$4D, __vue_script__$4D, __vue_scope_id__$4D, __vue_is_functional_template__$4D, __vue_module_identifier__$4D, false, undefined, undefined, undefined);

var script$4E = Vue.extend({
  name: "PhCrop",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4E = script$4E;
/* template */

var __vue_render__$4E = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "63.99414",
      "y1": "64",
      "x2": "24.00244",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64.002 24 64.002 192.001 232.002 192.001",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192.002 152.001 192.002 64 103.994 64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192.00244",
      "y1": "232.00098",
      "x2": "192.00244",
      "y2": "192.00098",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "63.99414",
      "y1": "64",
      "x2": "24.00244",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64.002 24 64.002 192.001 232.002 192.001",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192.002 160.001 192.002 64 95.994 64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192.00244",
      "y1": "232.00098",
      "x2": "192.00244",
      "y2": "192.00098",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M240.00244,192.001a8.00039,8.00039,0,0,1-8,8h-32v32a8,8,0,0,1-16,0v-32h-120a8.00039,8.00039,0,0,1-8-8V72h-32a8,8,0,0,1,0-16h32V24a8,8,0,1,1,16,0V184.001h160A8.00039,8.00039,0,0,1,240.00244,192.001ZM95.99365,72h88.00879v88.001a8,8,0,0,0,16,0V64a8.00008,8.00008,0,0,0-8-8H95.99365a8,8,0,0,0,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "63.99414",
      "y1": "64",
      "x2": "24.00244",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64.002 24 64.002 192.001 232.002 192.001",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192.002 160.001 192.002 64 95.994 64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192.00244",
      "y1": "232.00098",
      "x2": "192.00244",
      "y2": "192.00098",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "63.99414",
      "y1": "64",
      "x2": "24.00244",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64.002 24 64.002 192.001 232.002 192.001",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192.002 160.001 192.002 64 95.994 64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192.00244",
      "y1": "232.00098",
      "x2": "192.00244",
      "y2": "192.00098",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "63.99414",
      "y1": "64",
      "x2": "24.00244",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64.002 24 64.002 192.001 232.002 192.001",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192.002 160.001 192.002 64 95.994 64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192.00244",
      "y1": "232.00098",
      "x2": "192.00244",
      "y2": "192.00098",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4E = [];
/* style */

const __vue_inject_styles__$4E = undefined;
/* scoped */

const __vue_scope_id__$4E = undefined;
/* module identifier */

const __vue_module_identifier__$4E = undefined;
/* functional template */

const __vue_is_functional_template__$4E = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4E = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4E,
  staticRenderFns: __vue_staticRenderFns__$4E
}, __vue_inject_styles__$4E, __vue_script__$4E, __vue_scope_id__$4E, __vue_is_functional_template__$4E, __vue_module_identifier__$4E, false, undefined, undefined, undefined);

var script$4F = Vue.extend({
  name: "PhCrosshair",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4F = script$4F;
/* template */

var __vue_render__$4F = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "20",
      "x2": "128",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "20",
      "y1": "128",
      "x2": "56",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "236",
      "x2": "128",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "236",
      "y1": "128",
      "x2": "200",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "20",
      "x2": "128",
      "y2": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "20",
      "y1": "128",
      "x2": "60",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "236",
      "x2": "128",
      "y2": "196",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "236",
      "y1": "128",
      "x2": "196",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M236,120H223.66406A96.15352,96.15352,0,0,0,136,32.33618V20a8,8,0,0,0-16,0V32.33618A96.15352,96.15352,0,0,0,32.33594,120H20a8,8,0,0,0,0,16H32.33594A96.15352,96.15352,0,0,0,120,223.66382V236a8,8,0,0,0,16,0V223.66382A96.15352,96.15352,0,0,0,223.66406,136H236a8,8,0,0,0,0-16Zm-40,16h11.59912A80.14164,80.14164,0,0,1,136,207.59912V196a8,8,0,0,0-16,0v11.59912A80.14164,80.14164,0,0,1,48.40088,136H60a8,8,0,0,0,0-16H48.40088A80.14164,80.14164,0,0,1,120,48.40088V60a8,8,0,0,0,16,0V48.40088A80.14164,80.14164,0,0,1,207.59912,120H196a8,8,0,0,0,0,16Z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "40"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "20",
      "x2": "128",
      "y2": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "20",
      "y1": "128",
      "x2": "60",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "236",
      "x2": "128",
      "y2": "196",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "236",
      "y1": "128",
      "x2": "196",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "20",
      "x2": "128",
      "y2": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "20",
      "y1": "128",
      "x2": "60",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "236",
      "x2": "128",
      "y2": "196",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "236",
      "y1": "128",
      "x2": "196",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "20",
      "x2": "128",
      "y2": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "20",
      "y1": "128",
      "x2": "60",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "236",
      "x2": "128",
      "y2": "196",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "236",
      "y1": "128",
      "x2": "196",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4F = [];
/* style */

const __vue_inject_styles__$4F = undefined;
/* scoped */

const __vue_scope_id__$4F = undefined;
/* module identifier */

const __vue_module_identifier__$4F = undefined;
/* functional template */

const __vue_is_functional_template__$4F = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4F = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4F,
  staticRenderFns: __vue_staticRenderFns__$4F
}, __vue_inject_styles__$4F, __vue_script__$4F, __vue_scope_id__$4F, __vue_is_functional_template__$4F, __vue_module_identifier__$4F, false, undefined, undefined, undefined);

var script$4G = Vue.extend({
  name: "PhCrosshairSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4G = script$4G;
/* template */

var __vue_render__$4G = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "36",
      "x2": "128",
      "y2": "76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "36",
      "y1": "128",
      "x2": "76",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "220",
      "x2": "128",
      "y2": "180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "220",
      "y1": "128",
      "x2": "180",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "92",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "36",
      "x2": "128",
      "y2": "76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "36",
      "y1": "128",
      "x2": "76",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "220",
      "x2": "128",
      "y2": "180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "220",
      "y1": "128",
      "x2": "180",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,28A100,100,0,1,0,228,128,100.113,100.113,0,0,0,128,28Zm8,183.60938V180a8,8,0,0,0-16,0v31.60938A84.13251,84.13251,0,0,1,44.39062,136H76a8,8,0,0,0,0-16H44.39062A84.13249,84.13249,0,0,1,120,44.39063V76a8,8,0,0,0,16,0V44.39063A84.13247,84.13247,0,0,1,211.60937,120H180a8,8,0,0,0,0,16h31.60937A84.13249,84.13249,0,0,1,136,211.60938Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "36",
      "x2": "128",
      "y2": "76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "36",
      "y1": "128",
      "x2": "76",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "220",
      "x2": "128",
      "y2": "180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "220",
      "y1": "128",
      "x2": "180",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "36",
      "x2": "128",
      "y2": "76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "36",
      "y1": "128",
      "x2": "76",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "220",
      "x2": "128",
      "y2": "180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "220",
      "y1": "128",
      "x2": "180",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "36",
      "x2": "128",
      "y2": "76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "36",
      "y1": "128",
      "x2": "76",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "220",
      "x2": "128",
      "y2": "180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "220",
      "y1": "128",
      "x2": "180",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4G = [];
/* style */

const __vue_inject_styles__$4G = undefined;
/* scoped */

const __vue_scope_id__$4G = undefined;
/* module identifier */

const __vue_module_identifier__$4G = undefined;
/* functional template */

const __vue_is_functional_template__$4G = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4G = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4G,
  staticRenderFns: __vue_staticRenderFns__$4G
}, __vue_inject_styles__$4G, __vue_script__$4G, __vue_scope_id__$4G, __vue_is_functional_template__$4G, __vue_module_identifier__$4G, false, undefined, undefined, undefined);

var script$4H = Vue.extend({
  name: "PhCrown",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4H = script$4H;
/* template */

var __vue_render__$4H = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M45.12859,196.01674a8.01266,8.01266,0,0,0,9.97356,5.86223,273.90053,273.90053,0,0,1,145.746-.0138,8.01268,8.01268,0,0,0,9.97132-5.85941l25.48872-108.3169a8,8,0,0,0-11.03641-9.143L174.688,101.02754a8,8,0,0,1-10.24237-3.42535l-29.4524-53.01433a8,8,0,0,0-13.98652,0L91.55434,97.60219A8,8,0,0,1,81.312,101.02754L30.72054,78.54246a8,8,0,0,0-11.03717,9.13973Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M95.99992,153.63541a313.88955,313.88955,0,0,1,64.0001,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M45.12859,196.01674a8.01266,8.01266,0,0,0,9.97356,5.86223,273.90053,273.90053,0,0,1,145.746-.0138,8.01268,8.01268,0,0,0,9.97132-5.85941l25.48872-108.3169a8,8,0,0,0-11.03641-9.143L174.688,101.02754a8,8,0,0,1-10.24237-3.42535l-29.4524-53.01433a8,8,0,0,0-13.98652,0L91.55434,97.60219A8,8,0,0,1,81.312,101.02754L30.72054,78.54246a8,8,0,0,0-11.03717,9.13973Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M45.12859,196.01674a8.01266,8.01266,0,0,0,9.97356,5.86223,273.90053,273.90053,0,0,1,145.746-.0138,8.01268,8.01268,0,0,0,9.97132-5.85941l25.48872-108.3169a8,8,0,0,0-11.03641-9.143L174.688,101.02754a8,8,0,0,1-10.24237-3.42535l-29.4524-53.01433a8,8,0,0,0-13.98652,0L91.55434,97.60219A8,8,0,0,1,81.312,101.02754L30.72054,78.54246a8,8,0,0,0-11.03717,9.13973Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M95.99993,161.6787a305.83767,305.83767,0,0,1,64.00009,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M238.72754,73.53516a15.90424,15.90424,0,0,0-16.70508-2.29981l-50.584,22.48242L141.98633,40.70312a15.999,15.999,0,0,0-27.97266,0L84.56055,93.7168,33.96875,71.23145A16.00031,16.00031,0,0,0,11.89551,89.51172l25.44531,108.333a15.83567,15.83567,0,0,0,7.4082,10.09179,16.15491,16.15491,0,0,0,12.49317,1.65137,265.89708,265.89708,0,0,1,141.46875-.01367,16.15265,16.15265,0,0,0,12.4873-1.65137,15.83531,15.83531,0,0,0,7.40821-10.084L244.0957,89.52051A15.90513,15.90513,0,0,0,238.72754,73.53516Zm-70.77149,88.98046a7.9897,7.9897,0,0,1-8.793,7.11915,298.37472,298.37472,0,0,0-62.32618,0,8,8,0,0,1-1.67382-15.91211,314.358,314.358,0,0,1,65.67382,0A7.99917,7.99917,0,0,1,167.95605,162.51562Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M45.12859,196.01674a8.01266,8.01266,0,0,0,9.97356,5.86223,273.90053,273.90053,0,0,1,145.746-.0138,8.01268,8.01268,0,0,0,9.97132-5.85941l25.48872-108.3169a8,8,0,0,0-11.03641-9.143L174.688,101.02754a8,8,0,0,1-10.24237-3.42535l-29.4524-53.01433a8,8,0,0,0-13.98652,0L91.55434,97.60219A8,8,0,0,1,81.312,101.02754L30.72054,78.54246a8,8,0,0,0-11.03717,9.13973Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M95.99993,161.6787a305.83767,305.83767,0,0,1,64.00009,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M45.12859,196.01674a8.01266,8.01266,0,0,0,9.97356,5.86223,273.90053,273.90053,0,0,1,145.746-.0138,8.01268,8.01268,0,0,0,9.97132-5.85941l25.48872-108.3169a8,8,0,0,0-11.03641-9.143L174.688,101.02754a8,8,0,0,1-10.24237-3.42535l-29.4524-53.01433a8,8,0,0,0-13.98652,0L91.55434,97.60219A8,8,0,0,1,81.312,101.02754L30.72054,78.54246a8,8,0,0,0-11.03717,9.13973Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M95.99993,161.6787a305.83767,305.83767,0,0,1,64.00009,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M45.12859,196.01674a8.01266,8.01266,0,0,0,9.97356,5.86223,273.90053,273.90053,0,0,1,145.746-.0138,8.01268,8.01268,0,0,0,9.97132-5.85941l25.48872-108.3169a8,8,0,0,0-11.03641-9.143L174.688,101.02754a8,8,0,0,1-10.24237-3.42535l-29.4524-53.01433a8,8,0,0,0-13.98652,0L91.55434,97.60219A8,8,0,0,1,81.312,101.02754L30.72054,78.54246a8,8,0,0,0-11.03717,9.13973Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M95.99993,161.6787a305.83767,305.83767,0,0,1,64.00009,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4H = [];
/* style */

const __vue_inject_styles__$4H = undefined;
/* scoped */

const __vue_scope_id__$4H = undefined;
/* module identifier */

const __vue_module_identifier__$4H = undefined;
/* functional template */

const __vue_is_functional_template__$4H = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4H = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4H,
  staticRenderFns: __vue_staticRenderFns__$4H
}, __vue_inject_styles__$4H, __vue_script__$4H, __vue_scope_id__$4H, __vue_is_functional_template__$4H, __vue_module_identifier__$4H, false, undefined, undefined, undefined);

var script$4I = Vue.extend({
  name: "PhCrownSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4I = script$4I;
/* template */

var __vue_render__$4I = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M45.12859,196.01674a8.01266,8.01266,0,0,0,9.97356,5.86223,273.90053,273.90053,0,0,1,145.746-.0138,8.01268,8.01268,0,0,0,9.97132-5.85941l25.48872-108.3169a8,8,0,0,0-11.03641-9.143L174.688,101.02754a8,8,0,0,1-10.24237-3.42535l-29.4524-53.01433a8,8,0,0,0-13.98652,0L91.55434,97.60219A8,8,0,0,1,81.312,101.02754L30.72054,78.54246a8,8,0,0,0-11.03717,9.13973Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M45.12859,196.01674a8.01266,8.01266,0,0,0,9.97356,5.86223,273.90053,273.90053,0,0,1,145.746-.0138,8.01268,8.01268,0,0,0,9.97132-5.85941l25.48872-108.3169a8,8,0,0,0-11.03641-9.143L174.688,101.02754a8,8,0,0,1-10.24237-3.42535l-29.4524-53.01433a8,8,0,0,0-13.98652,0L91.55434,97.60219A8,8,0,0,1,81.312,101.02754L30.72054,78.54246a8,8,0,0,0-11.03717,9.13973Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M45.12859,196.01674a8.01266,8.01266,0,0,0,9.97356,5.86223,273.90053,273.90053,0,0,1,145.746-.0138,8.01268,8.01268,0,0,0,9.97132-5.85941l25.48872-108.3169a8,8,0,0,0-11.03641-9.143L174.688,101.02754a8,8,0,0,1-10.24237-3.42535l-29.4524-53.01433a8,8,0,0,0-13.98652,0L91.55434,97.60219A8,8,0,0,1,81.312,101.02754L30.72054,78.54246a8,8,0,0,0-11.03717,9.13973Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M238.72754,73.53516a15.90424,15.90424,0,0,0-16.70508-2.29981l-50.584,22.48242L141.98633,40.70312a15.999,15.999,0,0,0-27.97266,0L84.56055,93.7168,33.96875,71.23145A16.00031,16.00031,0,0,0,11.89551,89.51172l25.44531,108.333a15.83567,15.83567,0,0,0,7.4082,10.09179,16.15491,16.15491,0,0,0,12.49317,1.65137,265.89708,265.89708,0,0,1,141.46875-.01367,16.15265,16.15265,0,0,0,12.4873-1.65137,15.83531,15.83531,0,0,0,7.40821-10.084L244.0957,89.52051A15.90513,15.90513,0,0,0,238.72754,73.53516Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M45.12859,196.01674a8.01266,8.01266,0,0,0,9.97356,5.86223,273.90053,273.90053,0,0,1,145.746-.0138,8.01268,8.01268,0,0,0,9.97132-5.85941l25.48872-108.3169a8,8,0,0,0-11.03641-9.143L174.688,101.02754a8,8,0,0,1-10.24237-3.42535l-29.4524-53.01433a8,8,0,0,0-13.98652,0L91.55434,97.60219A8,8,0,0,1,81.312,101.02754L30.72054,78.54246a8,8,0,0,0-11.03717,9.13973Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M45.12859,196.01674a8.01266,8.01266,0,0,0,9.97356,5.86223,273.90053,273.90053,0,0,1,145.746-.0138,8.01268,8.01268,0,0,0,9.97132-5.85941l25.48872-108.3169a8,8,0,0,0-11.03641-9.143L174.688,101.02754a8,8,0,0,1-10.24237-3.42535l-29.4524-53.01433a8,8,0,0,0-13.98652,0L91.55434,97.60219A8,8,0,0,1,81.312,101.02754L30.72054,78.54246a8,8,0,0,0-11.03717,9.13973Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M45.12859,196.01674a8.01266,8.01266,0,0,0,9.97356,5.86223,273.90053,273.90053,0,0,1,145.746-.0138,8.01268,8.01268,0,0,0,9.97132-5.85941l25.48872-108.3169a8,8,0,0,0-11.03641-9.143L174.688,101.02754a8,8,0,0,1-10.24237-3.42535l-29.4524-53.01433a8,8,0,0,0-13.98652,0L91.55434,97.60219A8,8,0,0,1,81.312,101.02754L30.72054,78.54246a8,8,0,0,0-11.03717,9.13973Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4I = [];
/* style */

const __vue_inject_styles__$4I = undefined;
/* scoped */

const __vue_scope_id__$4I = undefined;
/* module identifier */

const __vue_module_identifier__$4I = undefined;
/* functional template */

const __vue_is_functional_template__$4I = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4I = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4I,
  staticRenderFns: __vue_staticRenderFns__$4I
}, __vue_inject_styles__$4I, __vue_script__$4I, __vue_scope_id__$4I, __vue_is_functional_template__$4I, __vue_module_identifier__$4I, false, undefined, undefined, undefined);

var script$4J = Vue.extend({
  name: "PhCube",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4J = script$4J;
/* template */

var __vue_render__$4J = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,177.32117V78.67873a8,8,0,0,0-4.07791-6.9726l-88-49.5a8,8,0,0,0-7.84418,0l-88,49.5A8,8,0,0,0,32,78.67873v98.64244a8,8,0,0,0,4.07791,6.97261l88,49.5a8,8,0,0,0,7.84418,0l88-49.5A8,8,0,0,0,224,177.32117Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "222.897 74.626 128.949 128 33.108 74.617",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128.94915",
      "y1": "127.99996",
      "x2": "128.01036",
      "y2": "234.82127",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M33.10781,74.617A7.99478,7.99478,0,0,0,32,78.67873v98.64244a8,8,0,0,0,4.07791,6.97261l88,49.5A7.99527,7.99527,0,0,0,128,234.82117l.01036.0001L128.94915,128,33.108,74.61709Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,177.32117V78.67873a8,8,0,0,0-4.07791-6.9726l-88-49.5a8,8,0,0,0-7.84418,0l-88,49.5A8,8,0,0,0,32,78.67873v98.64244a8,8,0,0,0,4.07791,6.97261l88,49.5a8,8,0,0,0,7.84418,0l88-49.5A8,8,0,0,0,224,177.32117Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "222.897 74.626 128.949 128 33.108 74.617",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128.94915",
      "y1": "127.99996",
      "x2": "128.01036",
      "y2": "234.82127",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M229.92236,70.81226c-.0249-.04541-.04345-.09229-.06933-.13746-.01123-.01953-.02442-.03662-.03565-.0559a15.989,15.989,0,0,0-5.97314-5.8855l-88-49.5a16.09272,16.09272,0,0,0-15.68848,0l-88,49.5A15.99092,15.99092,0,0,0,26.168,70.64575c-.01563.0271-.03369.05127-.04883.07862-.02441.0437-.042.08886-.06543.13256A15.98294,15.98294,0,0,0,24,78.67871v98.64258a16.02048,16.02048,0,0,0,8.15576,13.94531l88.00049,49.5a15.97122,15.97122,0,0,0,7.24463,2.02222c.17871.01343.35693.03052.53906.032.02393.00049.04785.00049.07178.00049.25146,0,.499-.01465.74463-.03735a15.97135,15.97135,0,0,0,7.08789-2.01734l88-49.5A16.02048,16.02048,0,0,0,232,177.32129V78.67871A15.98584,15.98584,0,0,0,229.92236,70.81226ZM128.91016,118.821,48.37891,73.96558,128,29.17871l79.74365,44.856ZM216,177.32129l-79.87891,44.93188.78711-89.57421L216,87.74561Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,177.32117V78.67873a8,8,0,0,0-4.07791-6.9726l-88-49.5a8,8,0,0,0-7.84418,0l-88,49.5A8,8,0,0,0,32,78.67873v98.64244a8,8,0,0,0,4.07791,6.97261l88,49.5a8,8,0,0,0,7.84418,0l88-49.5A8,8,0,0,0,224,177.32117Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "222.897 74.626 128.949 128 33.108 74.617",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128.94915",
      "y1": "127.99996",
      "x2": "128.01036",
      "y2": "234.82127",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,177.32117V78.67873a8,8,0,0,0-4.07791-6.9726l-88-49.5a8,8,0,0,0-7.84418,0l-88,49.5A8,8,0,0,0,32,78.67873v98.64244a8,8,0,0,0,4.07791,6.97261l88,49.5a8,8,0,0,0,7.84418,0l88-49.5A8,8,0,0,0,224,177.32117Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "222.897 74.626 128.949 128 33.108 74.617",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128.94915",
      "y1": "127.99996",
      "x2": "128.01036",
      "y2": "234.82127",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,177.32117V78.67873a8,8,0,0,0-4.07791-6.9726l-88-49.5a8,8,0,0,0-7.84418,0l-88,49.5A8,8,0,0,0,32,78.67873v98.64244a8,8,0,0,0,4.07791,6.97261l88,49.5a8,8,0,0,0,7.84418,0l88-49.5A8,8,0,0,0,224,177.32117Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "222.897 74.626 128.949 128 33.108 74.617",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128.94915",
      "y1": "127.99996",
      "x2": "128.01036",
      "y2": "234.82127",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4J = [];
/* style */

const __vue_inject_styles__$4J = undefined;
/* scoped */

const __vue_scope_id__$4J = undefined;
/* module identifier */

const __vue_module_identifier__$4J = undefined;
/* functional template */

const __vue_is_functional_template__$4J = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4J = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4J,
  staticRenderFns: __vue_staticRenderFns__$4J
}, __vue_inject_styles__$4J, __vue_script__$4J, __vue_scope_id__$4J, __vue_is_functional_template__$4J, __vue_module_identifier__$4J, false, undefined, undefined, undefined);

var script$4K = Vue.extend({
  name: "PhCurrencyBtc",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4K = script$4K;
/* template */

var __vue_render__$4K = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,120h72a40,40,0,0,1,0,80l-72.00586-.00488v-152L140,48a36,36,0,0,1,0,72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "63.99414",
      "y1": "47.99512",
      "x2": "79.99414",
      "y2": "47.99512",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "63.99414",
      "y1": "199.99512",
      "x2": "79.99414",
      "y2": "199.99512",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "48",
      "x2": "100",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "140",
      "y1": "48",
      "x2": "140",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "224",
      "x2": "100",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "140",
      "y1": "224",
      "x2": "140",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,120h72a40,40,0,0,1,0,80l-72.00586-.00488v-152L140,48a36,36,0,0,1,0,72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "63.99414",
      "y1": "47.99512",
      "x2": "79.99414",
      "y2": "47.99512",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "63.99414",
      "y1": "199.99512",
      "x2": "79.99414",
      "y2": "199.99512",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "48",
      "x2": "104",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "48",
      "x2": "136",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "224",
      "x2": "104",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "224",
      "x2": "136",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M170.4834,115.70117A43.973,43.973,0,0,0,144,40.18994V24a8,8,0,0,0-16,0V39.999l-16-.00146V24a8,8,0,0,0-16,0V39.99658l-16.00488-.00146h-16.001a8,8,0,0,0,0,16h8v136h-8a8,8,0,0,0,0,16h15.999L96,207.99609V224a8,8,0,0,0,16,0V207.99707l16,.00147V224a8,8,0,0,0,16,0V207.99951L152,208a48.00015,48.00015,0,0,0,18.4834-92.29883ZM168,84a28.03146,28.03146,0,0,1-28,28H87.99414V55.99609l15.95215.001c.01807.00049.03564.00293.05371.00293s.03564-.00244.05371-.00293l31.94043.00244L136,56l.00586-.00049L140,56A28.03146,28.03146,0,0,1,168,84ZM152.001,192l-64.00684-.00391V128H152a32,32,0,0,1,.001,64Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,120h72a40,40,0,0,1,0,80l-72.00586-.00488v-152L140,48a36,36,0,0,1,0,72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "63.99414",
      "y1": "47.99512",
      "x2": "79.99414",
      "y2": "47.99512",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "63.99414",
      "y1": "199.99512",
      "x2": "79.99414",
      "y2": "199.99512",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "48",
      "x2": "104",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "48",
      "x2": "136",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "224",
      "x2": "104",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "224",
      "x2": "136",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,120h72a40,40,0,0,1,0,80l-72.00586-.00488v-152L140,48a36,36,0,0,1,0,72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "63.99414",
      "y1": "47.99512",
      "x2": "79.99414",
      "y2": "47.99512",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "63.99414",
      "y1": "199.99512",
      "x2": "79.99414",
      "y2": "199.99512",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "48",
      "x2": "104",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "48",
      "x2": "136",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "224",
      "x2": "104",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "224",
      "x2": "136",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,120h72a40,40,0,0,1,0,80l-72.00586-.00488v-152L140,48a36,36,0,0,1,0,72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "63.99414",
      "y1": "47.99512",
      "x2": "79.99414",
      "y2": "47.99512",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "63.99414",
      "y1": "199.99512",
      "x2": "79.99414",
      "y2": "199.99512",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "48",
      "x2": "104",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "48",
      "x2": "136",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "224",
      "x2": "104",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "224",
      "x2": "136",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4K = [];
/* style */

const __vue_inject_styles__$4K = undefined;
/* scoped */

const __vue_scope_id__$4K = undefined;
/* module identifier */

const __vue_module_identifier__$4K = undefined;
/* functional template */

const __vue_is_functional_template__$4K = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4K = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4K,
  staticRenderFns: __vue_staticRenderFns__$4K
}, __vue_inject_styles__$4K, __vue_script__$4K, __vue_scope_id__$4K, __vue_is_functional_template__$4K, __vue_module_identifier__$4K, false, undefined, undefined, undefined);

var script$4L = Vue.extend({
  name: "PhCurrencyCircleDollar",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4L = script$4L;
/* template */

var __vue_render__$4L = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "72",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "168",
      "x2": "128",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,168h36a20,20,0,0,0,0-40H116a20,20,0,0,1,0-40h36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "72",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "168",
      "x2": "128",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,168h36a20,20,0,0,0,0-40H116a20,20,0,0,1,0-40h36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.11791,104.11791,0,0,0,128,24Zm12,152h-4v8a8,8,0,0,1-16,0v-8H104a8,8,0,0,1,0-16h36a12,12,0,0,0,0-24H116a28,28,0,0,1,0-56h4V72a8,8,0,0,1,16,0v8h16a8,8,0,0,1,0,16H116a12,12,0,0,0,0,24h24a28,28,0,0,1,0,56Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "72",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "168",
      "x2": "128",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,168h36a20,20,0,0,0,0-40H116a20,20,0,0,1,0-40h36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "72",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "168",
      "x2": "128",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,168h36a20,20,0,0,0,0-40H116a20,20,0,0,1,0-40h36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "72",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "168",
      "x2": "128",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,168h36a20,20,0,0,0,0-40H116a20,20,0,0,1,0-40h36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4L = [];
/* style */

const __vue_inject_styles__$4L = undefined;
/* scoped */

const __vue_scope_id__$4L = undefined;
/* module identifier */

const __vue_module_identifier__$4L = undefined;
/* functional template */

const __vue_is_functional_template__$4L = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4L = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4L,
  staticRenderFns: __vue_staticRenderFns__$4L
}, __vue_inject_styles__$4L, __vue_script__$4L, __vue_scope_id__$4L, __vue_is_functional_template__$4L, __vue_module_identifier__$4L, false, undefined, undefined, undefined);

var script$4M = Vue.extend({
  name: "PhCurrencyCny",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4M = script$4M;
/* template */

var __vue_render__$4M = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "64",
      "y1": "64",
      "x2": "192",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "120",
      "x2": "208",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,120v56a24,24,0,0,0,24,24h40V176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,120v16a64,64,0,0,1-64,64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "64",
      "y1": "64",
      "x2": "192",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "120",
      "x2": "208",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,120v56a24,24,0,0,0,24,24h40V176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,120v16a64,64,0,0,1-64,64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56,64a8.00008,8.00008,0,0,1,8-8H192a8,8,0,0,1,0,16H64A8.00008,8.00008,0,0,1,56,64ZM216,168a8.00039,8.00039,0,0,0-8,8v16H176a16.01833,16.01833,0,0,1-16-16V128h48a8,8,0,0,0,0-16H48a8,8,0,0,0,0,16H96v8a56.0629,56.0629,0,0,1-56,56,8,8,0,0,0,0,16,72.08124,72.08124,0,0,0,72-72v-8h32v48a32.03667,32.03667,0,0,0,32,32h40a8.00039,8.00039,0,0,0,8-8V176A8.00039,8.00039,0,0,0,216,168Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "64",
      "y1": "64",
      "x2": "192",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "120",
      "x2": "208",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,120v56a24,24,0,0,0,24,24h40V176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,120v16a64,64,0,0,1-64,64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "64",
      "y1": "64",
      "x2": "192",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "120",
      "x2": "208",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,120v56a24,24,0,0,0,24,24h40V176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,120v16a64,64,0,0,1-64,64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "64",
      "y1": "64",
      "x2": "192",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "120",
      "x2": "208",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,120v56a24,24,0,0,0,24,24h40V176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,120v16a64,64,0,0,1-64,64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4M = [];
/* style */

const __vue_inject_styles__$4M = undefined;
/* scoped */

const __vue_scope_id__$4M = undefined;
/* module identifier */

const __vue_module_identifier__$4M = undefined;
/* functional template */

const __vue_is_functional_template__$4M = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4M = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4M,
  staticRenderFns: __vue_staticRenderFns__$4M
}, __vue_inject_styles__$4M, __vue_script__$4M, __vue_scope_id__$4M, __vue_is_functional_template__$4M, __vue_module_identifier__$4M, false, undefined, undefined, undefined);

var script$4N = Vue.extend({
  name: "PhCurrencyDollar",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4N = script$4N;
/* template */

var __vue_render__$4N = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "24",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,88a40,40,0,0,0-40-40H108a40,40,0,0,0,0,80h44a40,40,0,0,1,0,80H104a40,40,0,0,1-40-40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "24",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,88a40,40,0,0,0-40-40H108a40,40,0,0,0,0,80h44a40,40,0,0,1,0,80H104a40,40,0,0,1-40-40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M152,120H136V56h8a32.03635,32.03635,0,0,1,32,32,8,8,0,0,0,16,0,48.054,48.054,0,0,0-48-48h-8V24a8,8,0,0,0-16,0V40H108a48,48,0,0,0,0,96h12v64H104a32.03635,32.03635,0,0,1-32-32,8,8,0,0,0-16,0,48.054,48.054,0,0,0,48,48h16v16a8,8,0,0,0,16,0V216h16a48,48,0,0,0,0-96Zm-32,0H108a32,32,0,0,1,0-64h12Zm32,80H136V136h16a32,32,0,0,1,0,64Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "24",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,88a40,40,0,0,0-40-40H108a40,40,0,0,0,0,80h44a40,40,0,0,1,0,80H104a40,40,0,0,1-40-40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "24",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,88a40,40,0,0,0-40-40H108a40,40,0,0,0,0,80h44a40,40,0,0,1,0,80H104a40,40,0,0,1-40-40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "24",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,88a40,40,0,0,0-40-40H108a40,40,0,0,0,0,80h44a40,40,0,0,1,0,80H104a40,40,0,0,1-40-40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4N = [];
/* style */

const __vue_inject_styles__$4N = undefined;
/* scoped */

const __vue_scope_id__$4N = undefined;
/* module identifier */

const __vue_module_identifier__$4N = undefined;
/* functional template */

const __vue_is_functional_template__$4N = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4N = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4N,
  staticRenderFns: __vue_staticRenderFns__$4N
}, __vue_inject_styles__$4N, __vue_script__$4N, __vue_scope_id__$4N, __vue_is_functional_template__$4N, __vue_module_identifier__$4N, false, undefined, undefined, undefined);

var script$4O = Vue.extend({
  name: "PhCurrencyDollarSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4O = script$4O;
/* template */

var __vue_render__$4O = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "24",
      "x2": "128",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "208",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,88a40,40,0,0,0-40-40H108a40,40,0,0,0,0,80h44a40,40,0,0,1,0,80H104a40,40,0,0,1-40-40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "24",
      "x2": "128",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "208",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,88a40,40,0,0,0-40-40H108a40,40,0,0,0,0,80h44a40,40,0,0,1,0,80H104a40,40,0,0,1-40-40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,168a48.054,48.054,0,0,1-48,48H136v16a8,8,0,0,1-16,0V216H104a48.054,48.054,0,0,1-48-48,8,8,0,0,1,16,0,32.03635,32.03635,0,0,0,32,32h48a32,32,0,0,0,0-64H108a48,48,0,0,1,0-96h12V24a8,8,0,0,1,16,0V40h8a48.054,48.054,0,0,1,48,48,8,8,0,0,1-16,0,32.03635,32.03635,0,0,0-32-32H108a32,32,0,0,0,0,64h44A48.054,48.054,0,0,1,200,168Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "24",
      "x2": "128",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "208",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,88a40,40,0,0,0-40-40H108a40,40,0,0,0,0,80h44a40,40,0,0,1,0,80H104a40,40,0,0,1-40-40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "24",
      "x2": "128",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "208",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,88a40,40,0,0,0-40-40H108a40,40,0,0,0,0,80h44a40,40,0,0,1,0,80H104a40,40,0,0,1-40-40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "24",
      "x2": "128",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "208",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,88a40,40,0,0,0-40-40H108a40,40,0,0,0,0,80h44a40,40,0,0,1,0,80H104a40,40,0,0,1-40-40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4O = [];
/* style */

const __vue_inject_styles__$4O = undefined;
/* scoped */

const __vue_scope_id__$4O = undefined;
/* module identifier */

const __vue_module_identifier__$4O = undefined;
/* functional template */

const __vue_is_functional_template__$4O = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4O = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4O,
  staticRenderFns: __vue_staticRenderFns__$4O
}, __vue_inject_styles__$4O, __vue_script__$4O, __vue_scope_id__$4O, __vue_is_functional_template__$4O, __vue_module_identifier__$4O, false, undefined, undefined, undefined);

var script$4P = Vue.extend({
  name: "PhCurrencyEur",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4P = script$4P;
/* template */

var __vue_render__$4P = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M186.91167,194.91171A72,72,0,0,1,64,144V112A72,72,0,0,1,186.91167,61.08829",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "108",
      "x2": "136",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "148",
      "x2": "120",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M186.91167,194.91171A72,72,0,0,1,64,144V112A72,72,0,0,1,186.91167,61.08829",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "112",
      "x2": "136",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "144",
      "x2": "120",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M192.56934,189.25488a7.99974,7.99974,0,0,1-.001,11.314A80.00019,80.00019,0,0,1,56.40088,152H40a8,8,0,0,1,0-16H56V120H40a8,8,0,0,1,0-16H56.40088A80.00019,80.00019,0,0,1,192.56836,55.43115a7.99984,7.99984,0,1,1-11.3125,11.31446A63.98841,63.98841,0,0,0,72.51758,104H136a8,8,0,0,1,0,16H72v16h48a8,8,0,0,1,0,16H72.51758a63.98841,63.98841,0,0,0,108.73828,37.25439A8.00093,8.00093,0,0,1,192.56934,189.25488Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M186.91167,194.91171A72,72,0,0,1,64,144V112A72,72,0,0,1,186.91167,61.08829",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "112",
      "x2": "136",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "144",
      "x2": "120",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M186.91167,194.91171A72,72,0,0,1,64,144V112A72,72,0,0,1,186.91167,61.08829",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "112",
      "x2": "136",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "144",
      "x2": "120",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M186.91167,194.91171A72,72,0,0,1,64,144V112A72,72,0,0,1,186.91167,61.08829",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "112",
      "x2": "136",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "144",
      "x2": "120",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4P = [];
/* style */

const __vue_inject_styles__$4P = undefined;
/* scoped */

const __vue_scope_id__$4P = undefined;
/* module identifier */

const __vue_module_identifier__$4P = undefined;
/* functional template */

const __vue_is_functional_template__$4P = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4P = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4P,
  staticRenderFns: __vue_staticRenderFns__$4P
}, __vue_inject_styles__$4P, __vue_script__$4P, __vue_scope_id__$4P, __vue_is_functional_template__$4P, __vue_module_identifier__$4P, false, undefined, undefined, undefined);

var script$4Q = Vue.extend({
  name: "PhCurrencyGbp",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4Q = script$4Q;
/* template */

var __vue_render__$4Q = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('g', [_c('line', {
    attrs: {
      "x1": "56",
      "y1": "132",
      "x2": "136",
      "y2": "132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,208H56a36,36,0,0,0,36-36V84a44,44,0,0,1,75.11269-31.11271",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })])]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "56",
      "y1": "132",
      "x2": "136",
      "y2": "132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,208H56a36,36,0,0,0,36-36V84a44,44,0,0,1,75.11269-31.11271",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M192,208a8.00008,8.00008,0,0,1-8,8H56a8,8,0,0,1,0-16,28.03146,28.03146,0,0,0,28-28V140H56a8,8,0,0,1,0-16H84V84a52,52,0,0,1,88.76953-36.76953A8.00018,8.00018,0,0,1,161.45508,58.544,35.99961,35.99961,0,0,0,100,84v40h36a8,8,0,0,1,0,16H100v32a43.79772,43.79772,0,0,1-10.083,28H184A8.00008,8.00008,0,0,1,192,208Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('g', [_c('line', {
    attrs: {
      "x1": "56",
      "y1": "132",
      "x2": "136",
      "y2": "132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,208H56a36,36,0,0,0,36-36V84a44,44,0,0,1,75.11269-31.11271",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })])]) : _vm.displayWeight === 'thin' ? _c('g', [_c('g', [_c('line', {
    attrs: {
      "x1": "56",
      "y1": "132",
      "x2": "136",
      "y2": "132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,208H56a36,36,0,0,0,36-36V84a44,44,0,0,1,75.11269-31.11271",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })])]) : _vm.displayWeight === 'regular' ? _c('g', [_c('g', [_c('line', {
    attrs: {
      "x1": "56",
      "y1": "132",
      "x2": "136",
      "y2": "132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,208H56a36,36,0,0,0,36-36V84a44,44,0,0,1,75.11269-31.11271",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })])]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4Q = [];
/* style */

const __vue_inject_styles__$4Q = undefined;
/* scoped */

const __vue_scope_id__$4Q = undefined;
/* module identifier */

const __vue_module_identifier__$4Q = undefined;
/* functional template */

const __vue_is_functional_template__$4Q = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4Q = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4Q,
  staticRenderFns: __vue_staticRenderFns__$4Q
}, __vue_inject_styles__$4Q, __vue_script__$4Q, __vue_scope_id__$4Q, __vue_is_functional_template__$4Q, __vue_module_identifier__$4Q, false, undefined, undefined, undefined);

var script$4R = Vue.extend({
  name: "PhCurrencyInr",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4R = script$4R;
/* template */

var __vue_render__$4R = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "72",
      "y1": "80",
      "x2": "200",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "40",
      "x2": "200",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M108,40a52,52,0,0,1,0,104H72l88,80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "72",
      "y1": "80",
      "x2": "200",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "40",
      "x2": "200",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M108,40a52,52,0,0,1,0,104H72l88,80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,80a8.00039,8.00039,0,0,1-8,8H167.85156c.08789,1.32373.14844,2.65454.14844,4a60.06812,60.06812,0,0,1-60,60H92.69238l72.68946,66.08008a8.0006,8.0006,0,0,1-10.76368,11.83984l-88-80A8.0004,8.0004,0,0,1,72,136h36a44.04978,44.04978,0,0,0,44-44c0-1.34912-.0708-2.68164-.18994-4H72a8,8,0,0,1,0-16h75.17188A44.03678,44.03678,0,0,0,108,48H72a8,8,0,0,1,0-16H200a8,8,0,0,1,0,16H148.73535a60.16006,60.16006,0,0,1,15.82422,24H200A8.00039,8.00039,0,0,1,208,80Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "72",
      "y1": "80",
      "x2": "200",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "40",
      "x2": "200",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M108,40a52,52,0,0,1,0,104H72l88,80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "72",
      "y1": "80",
      "x2": "200",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "40",
      "x2": "200",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M108,40a52,52,0,0,1,0,104H72l88,80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "72",
      "y1": "80",
      "x2": "200",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "40",
      "x2": "200",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M108,40a52,52,0,0,1,0,104H72l88,80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4R = [];
/* style */

const __vue_inject_styles__$4R = undefined;
/* scoped */

const __vue_scope_id__$4R = undefined;
/* module identifier */

const __vue_module_identifier__$4R = undefined;
/* functional template */

const __vue_is_functional_template__$4R = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4R = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4R,
  staticRenderFns: __vue_staticRenderFns__$4R
}, __vue_inject_styles__$4R, __vue_script__$4R, __vue_scope_id__$4R, __vue_is_functional_template__$4R, __vue_module_identifier__$4R, false, undefined, undefined, undefined);

var script$4S = Vue.extend({
  name: "PhCurrencyJpy",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4S = script$4S;
/* template */

var __vue_render__$4S = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "80",
      "y1": "176",
      "x2": "176",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "136",
      "x2": "176",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "136",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "200 48 128 136 56 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })])]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "80",
      "y1": "168",
      "x2": "176",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "136",
      "x2": "176",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "136",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "200 48 128 136 56 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M206.19141,53.06592,144.88184,128H176a8,8,0,0,1,0,16H136v16h40a8,8,0,0,1,0,16H136v40a8,8,0,0,1-16,0V176H80a8,8,0,0,1,0-16h40V144H80a8,8,0,0,1,0-16h31.11816L49.80859,53.06592A7.99982,7.99982,0,1,1,62.19141,42.93408L128,123.3667l65.80859-80.43262a7.99982,7.99982,0,1,1,12.38282,10.13184Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "80",
      "y1": "168",
      "x2": "176",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "136",
      "x2": "176",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "136",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "200 48 128 136 56 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })])]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "80",
      "y1": "168",
      "x2": "176",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "136",
      "x2": "176",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "136",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "200 48 128 136 56 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })])]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "80",
      "y1": "168",
      "x2": "176",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "136",
      "x2": "176",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "136",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "200 48 128 136 56 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })])]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4S = [];
/* style */

const __vue_inject_styles__$4S = undefined;
/* scoped */

const __vue_scope_id__$4S = undefined;
/* module identifier */

const __vue_module_identifier__$4S = undefined;
/* functional template */

const __vue_is_functional_template__$4S = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4S = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4S,
  staticRenderFns: __vue_staticRenderFns__$4S
}, __vue_inject_styles__$4S, __vue_script__$4S, __vue_scope_id__$4S, __vue_is_functional_template__$4S, __vue_module_identifier__$4S, false, undefined, undefined, undefined);

var script$4T = Vue.extend({
  name: "PhCurrencyKrw",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4T = script$4T;
/* template */

var __vue_render__$4T = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "16",
      "y1": "136",
      "x2": "240",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "24 72 76 200 128 72 180 200 232 72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "24 72 76 200 128 72 180 200 232 72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "136",
      "x2": "240",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M240,128H217.88525l21.52686-52.98926a8.00025,8.00025,0,0,0-14.82422-6.02148L200.61523,128H159.38477L135.41211,68.98926a8.00039,8.00039,0,0,0-14.82422,0L96.61523,128H55.38477L31.41211,68.98926a8.00025,8.00025,0,0,0-14.82422,6.02148L38.11475,128H16a8,8,0,0,0,0,16H44.61475l23.97314,59.01074a8.00039,8.00039,0,0,0,14.82422,0L107.38477,144h41.23046l23.97266,59.01074a8.00039,8.00039,0,0,0,14.82422,0L211.38525,144H240a8,8,0,0,0,0-16ZM76,178.74512,61.88477,144H90.11523ZM113.88477,128,128,93.25488,142.11523,128ZM180,178.74512,165.88477,144h28.23046Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "16",
      "y1": "136",
      "x2": "240",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "24 72 76 200 128 72 180 200 232 72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "16",
      "y1": "136",
      "x2": "240",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "24 72 76 200 128 72 180 200 232 72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "24 72 76 200 128 72 180 200 232 72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "136",
      "x2": "240",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4T = [];
/* style */

const __vue_inject_styles__$4T = undefined;
/* scoped */

const __vue_scope_id__$4T = undefined;
/* module identifier */

const __vue_module_identifier__$4T = undefined;
/* functional template */

const __vue_is_functional_template__$4T = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4T = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4T,
  staticRenderFns: __vue_staticRenderFns__$4T
}, __vue_inject_styles__$4T, __vue_script__$4T, __vue_scope_id__$4T, __vue_is_functional_template__$4T, __vue_module_identifier__$4T, false, undefined, undefined, undefined);

var script$4U = Vue.extend({
  name: "PhCurrencyRub",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4U = script$4U;
/* template */

var __vue_render__$4U = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "56",
      "y1": "184",
      "x2": "144",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,216V40h60a52,52,0,0,1,0,104H56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "56",
      "y1": "176",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,216V40h60a52,52,0,0,1,0,104H56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M148,152a60,60,0,0,0,0-120H88a8.00039,8.00039,0,0,0-8,8v96H56a8,8,0,0,0,0,16H80v16H56a8,8,0,0,0,0,16H80v32a8,8,0,0,0,16,0V184h48a8,8,0,0,0,0-16H96V152ZM96,48h52a44,44,0,0,1,0,88H96Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "56",
      "y1": "176",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,216V40h60a52,52,0,0,1,0,104H56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "56",
      "y1": "176",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,216V40h60a52,52,0,0,1,0,104H56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "56",
      "y1": "176",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,216V40h60a52,52,0,0,1,0,104H56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4U = [];
/* style */

const __vue_inject_styles__$4U = undefined;
/* scoped */

const __vue_scope_id__$4U = undefined;
/* module identifier */

const __vue_module_identifier__$4U = undefined;
/* functional template */

const __vue_is_functional_template__$4U = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4U = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4U,
  staticRenderFns: __vue_staticRenderFns__$4U
}, __vue_inject_styles__$4U, __vue_script__$4U, __vue_scope_id__$4U, __vue_is_functional_template__$4U, __vue_module_identifier__$4U, false, undefined, undefined, undefined);

var script$4V = Vue.extend({
  name: "PhCursor",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4V = script$4V;
/* template */

var __vue_render__$4V = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M38.18466,48.47939l58.21413,155.2377a8,8,0,0,0,15.009-.075L134.729,139.50856a8,8,0,0,1,4.78441-4.7844l64.13348-23.32127a8,8,0,0,0,.07505-15.009L48.48428,38.17977A8,8,0,0,0,38.18466,48.47939Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136.59053",
      "y1": "136.58564",
      "x2": "208.00488",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M38.18466,48.47939l58.21413,155.2377a8,8,0,0,0,15.009-.075L134.729,139.50856a8,8,0,0,1,4.78441-4.7844l64.13348-23.32127a8,8,0,0,0,.07505-15.009L48.48428,38.17977A8,8,0,0,0,38.18466,48.47939Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M38.18466,48.47939l58.21413,155.2377a8,8,0,0,0,15.009-.075L134.729,139.50856a8,8,0,0,1,4.78441-4.7844l64.13348-23.32127a8,8,0,0,0,.07505-15.009L48.48428,38.17977A8,8,0,0,0,38.18466,48.47939Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136.59053",
      "y1": "136.58564",
      "x2": "208.00488",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M150.54443,139.22559l55.83594-20.30469a15.99964,15.99964,0,0,0,.15039-30.01758L51.29346,30.68945A15.99937,15.99937,0,0,0,30.69482,51.28906v-.00049L88.90869,206.52588a15.85524,15.85524,0,0,0,14.97656,10.38232h.084a15.86,15.86,0,0,0,14.957-10.53222L139.23047,150.54l63.11767,63.11719a8.00053,8.00053,0,0,0,11.31446-11.31446Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M38.18466,48.47939l58.21413,155.2377a8,8,0,0,0,15.009-.075L134.729,139.50856a8,8,0,0,1,4.78441-4.7844l64.13348-23.32127a8,8,0,0,0,.07505-15.009L48.48428,38.17977A8,8,0,0,0,38.18466,48.47939Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136.59053",
      "y1": "136.58564",
      "x2": "208.00488",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M38.18466,48.47939l58.21413,155.2377a8,8,0,0,0,15.009-.075L134.729,139.50856a8,8,0,0,1,4.78441-4.7844l64.13348-23.32127a8,8,0,0,0,.07505-15.009L48.48428,38.17977A8,8,0,0,0,38.18466,48.47939Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136.59053",
      "y1": "136.58564",
      "x2": "208.00488",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M38.18466,48.47939l58.21413,155.2377a8,8,0,0,0,15.009-.075L134.729,139.50856a8,8,0,0,1,4.78441-4.7844l64.13348-23.32127a8,8,0,0,0,.07505-15.009L48.48428,38.17977A8,8,0,0,0,38.18466,48.47939Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136.59053",
      "y1": "136.58564",
      "x2": "208.00488",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4V = [];
/* style */

const __vue_inject_styles__$4V = undefined;
/* scoped */

const __vue_scope_id__$4V = undefined;
/* module identifier */

const __vue_module_identifier__$4V = undefined;
/* functional template */

const __vue_is_functional_template__$4V = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4V = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4V,
  staticRenderFns: __vue_staticRenderFns__$4V
}, __vue_inject_styles__$4V, __vue_script__$4V, __vue_scope_id__$4V, __vue_is_functional_template__$4V, __vue_module_identifier__$4V, false, undefined, undefined, undefined);

var script$4W = Vue.extend({
  name: "PhDatabase",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4W = script$4W;
/* template */

var __vue_render__$4W = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "80",
      "rx": "88",
      "ry": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,80v48c0,26.50967,39.39894,48,88,48s88-21.49033,88-48V80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,128v48c0,26.50967,39.39894,48,88,48s88-21.49033,88-48V128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "80",
      "rx": "88",
      "ry": "48",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "80",
      "rx": "88",
      "ry": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,80v48c0,26.50967,39.39894,48,88,48s88-21.49033,88-48V80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,128v48c0,26.50967,39.39894,48,88,48s88-21.49033,88-48V128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24C74.168,24,32,48.59814,32,80v96c0,31.40186,42.168,56,96,56s96-24.59814,96-56V80C224,48.59814,181.832,24,128,24Zm80,104c0,9.61719-7.875,19.42871-21.60547,26.918C170.92822,163.354,150.18994,168,128,168s-42.92822-4.646-58.39453-13.082C55.875,147.42871,48,137.61719,48,128V111.35645C65.05994,126.3208,94.234,136,128,136s62.94006-9.6792,80-24.64355Zm-21.60547,74.918C170.92822,211.354,150.19043,216,128,216s-42.92822-4.646-58.39453-13.082C55.875,195.42871,48,185.61719,48,176V159.35645C65.05994,174.3208,94.234,184,128,184s62.94006-9.6792,80-24.64355V176C208,185.61719,200.125,195.42871,186.39453,202.918Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "80",
      "rx": "88",
      "ry": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,80v48c0,26.50967,39.39894,48,88,48s88-21.49033,88-48V80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,128v48c0,26.50967,39.39894,48,88,48s88-21.49033,88-48V128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "80",
      "rx": "88",
      "ry": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,80v48c0,26.50967,39.39894,48,88,48s88-21.49033,88-48V80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,128v48c0,26.50967,39.39894,48,88,48s88-21.49033,88-48V128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "80",
      "rx": "88",
      "ry": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,80v48c0,26.50967,39.39894,48,88,48s88-21.49033,88-48V80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,128v48c0,26.50967,39.39894,48,88,48s88-21.49033,88-48V128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4W = [];
/* style */

const __vue_inject_styles__$4W = undefined;
/* scoped */

const __vue_scope_id__$4W = undefined;
/* module identifier */

const __vue_module_identifier__$4W = undefined;
/* functional template */

const __vue_is_functional_template__$4W = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4W = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4W,
  staticRenderFns: __vue_staticRenderFns__$4W
}, __vue_inject_styles__$4W, __vue_script__$4W, __vue_scope_id__$4W, __vue_is_functional_template__$4W, __vue_module_identifier__$4W, false, undefined, undefined, undefined);

var script$4X = Vue.extend({
  name: "PhDesktop",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4X = script$4X;
/* template */

var __vue_render__$4X = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "140",
      "rx": "16",
      "transform": "translate(256 236) rotate(180)",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "224",
      "x2": "96",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "148",
      "x2": "224",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "192",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,152V64A16,16,0,0,1,48,48H208a16,16,0,0,1,16,16v88Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "144",
      "rx": "16",
      "transform": "translate(256 240) rotate(180)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "224",
      "x2": "96",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "152",
      "x2": "224",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "192",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,40H48A24.0275,24.0275,0,0,0,24,64V176a24.0275,24.0275,0,0,0,24,24h72v16H96a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16H136V200h72a24.0275,24.0275,0,0,0,24-24V64A24.0275,24.0275,0,0,0,208,40Zm0,144H48a8.00917,8.00917,0,0,1-8-8V160H216v16A8.00917,8.00917,0,0,1,208,184Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "144",
      "rx": "16",
      "transform": "translate(256 240) rotate(180)",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "224",
      "x2": "96",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "152",
      "x2": "224",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "192",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "144",
      "rx": "16",
      "transform": "translate(256 240) rotate(180)",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "224",
      "x2": "96",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "152",
      "x2": "224",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "192",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "144",
      "rx": "16",
      "transform": "translate(256 240) rotate(180)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "224",
      "x2": "96",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "152",
      "x2": "224",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "192",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4X = [];
/* style */

const __vue_inject_styles__$4X = undefined;
/* scoped */

const __vue_scope_id__$4X = undefined;
/* module identifier */

const __vue_module_identifier__$4X = undefined;
/* functional template */

const __vue_is_functional_template__$4X = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4X = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4X,
  staticRenderFns: __vue_staticRenderFns__$4X
}, __vue_inject_styles__$4X, __vue_script__$4X, __vue_scope_id__$4X, __vue_is_functional_template__$4X, __vue_module_identifier__$4X, false, undefined, undefined, undefined);

var script$4Y = Vue.extend({
  name: "PhDesktopTower",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4Y = script$4Y;
/* template */

var __vue_render__$4Y = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M108,180H32a16,16,0,0,1-16-16V96A16,16,0,0,1,32,80h76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "108",
      "y1": "216",
      "x2": "68",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "204",
      "y1": "76",
      "x2": "180",
      "y2": "76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "204",
      "y1": "112",
      "x2": "180",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "144",
      "y": "40",
      "width": "96",
      "height": "176",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "180",
      "x2": "88",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "192",
      "cy": "176",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "144",
      "y": "40",
      "width": "96",
      "height": "176",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112,184H32a16,16,0,0,1-16-16V96A16,16,0,0,1,32,80h80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "216",
      "x2": "64",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "72",
      "x2": "176",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "104",
      "x2": "176",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "144",
      "y": "40",
      "width": "96",
      "height": "176",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "184",
      "x2": "88",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "192",
      "cy": "180",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M120,80V184a8.00008,8.00008,0,0,1-8,8H96v16h16a8,8,0,0,1,0,16H64a8,8,0,0,1,0-16H80V192H32A24.0275,24.0275,0,0,1,8,168V96A24.0275,24.0275,0,0,1,32,72h80A8.00008,8.00008,0,0,1,120,80ZM248,48V208a16.01833,16.01833,0,0,1-16,16H152a16.01833,16.01833,0,0,1-16-16V48a16.01833,16.01833,0,0,1,16-16h80A16.01833,16.01833,0,0,1,248,48ZM204,180a12,12,0,1,0-12,12A12.01343,12.01343,0,0,0,204,180Zm20-76a8.00008,8.00008,0,0,0-8-8H168a8,8,0,0,0,0,16h48A8.00008,8.00008,0,0,0,224,104Zm0-32a8.00008,8.00008,0,0,0-8-8H168a8,8,0,0,0,0,16h48A8.00008,8.00008,0,0,0,224,72Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M112,184H32a16,16,0,0,1-16-16V96A16,16,0,0,1,32,80h80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "216",
      "x2": "64",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "72",
      "x2": "176",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "104",
      "x2": "176",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "144",
      "y": "40",
      "width": "96",
      "height": "176",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "184",
      "x2": "88",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "192",
      "cy": "180",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M112,184H32a16,16,0,0,1-16-16V96A16,16,0,0,1,32,80h80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "216",
      "x2": "64",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "72",
      "x2": "176",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "104",
      "x2": "176",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "144",
      "y": "40",
      "width": "96",
      "height": "176",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "184",
      "x2": "88",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "192",
      "cy": "180",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M112,184H32a16,16,0,0,1-16-16V96A16,16,0,0,1,32,80h80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "216",
      "x2": "64",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "72",
      "x2": "176",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "104",
      "x2": "176",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "144",
      "y": "40",
      "width": "96",
      "height": "176",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "184",
      "x2": "88",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "192",
      "cy": "180",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4Y = [];
/* style */

const __vue_inject_styles__$4Y = undefined;
/* scoped */

const __vue_scope_id__$4Y = undefined;
/* module identifier */

const __vue_module_identifier__$4Y = undefined;
/* functional template */

const __vue_is_functional_template__$4Y = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4Y = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4Y,
  staticRenderFns: __vue_staticRenderFns__$4Y
}, __vue_inject_styles__$4Y, __vue_script__$4Y, __vue_scope_id__$4Y, __vue_is_functional_template__$4Y, __vue_module_identifier__$4Y, false, undefined, undefined, undefined);

var script$4Z = Vue.extend({
  name: "PhDeviceMobile",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4Z = script$4Z;
/* template */

var __vue_render__$4Z = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "64",
      "y": "24",
      "width": "128",
      "height": "208",
      "rx": "16",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "64",
      "x2": "192",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "192",
      "x2": "192",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "64",
      "y": "56",
      "width": "128",
      "height": "144",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "64",
      "y": "24",
      "width": "128",
      "height": "208",
      "rx": "16",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "56",
      "x2": "192",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "200",
      "x2": "192",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,16H80A24.0275,24.0275,0,0,0,56,40V216a24.0275,24.0275,0,0,0,24,24h96a24.0275,24.0275,0,0,0,24-24V40A24.0275,24.0275,0,0,0,176,16ZM80,32h96a8.00917,8.00917,0,0,1,8,8v8H72V40A8.00917,8.00917,0,0,1,80,32Zm96,192H80a8.00917,8.00917,0,0,1-8-8v-8H184v8A8.00917,8.00917,0,0,1,176,224Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "64",
      "y": "24",
      "width": "128",
      "height": "208",
      "rx": "16",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "56",
      "x2": "192",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "200",
      "x2": "192",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "64",
      "y": "24",
      "width": "128",
      "height": "208",
      "rx": "16",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "56",
      "x2": "192",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "200",
      "x2": "192",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "64",
      "y": "24",
      "width": "128",
      "height": "208",
      "rx": "16",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "56",
      "x2": "192",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "200",
      "x2": "192",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4Z = [];
/* style */

const __vue_inject_styles__$4Z = undefined;
/* scoped */

const __vue_scope_id__$4Z = undefined;
/* module identifier */

const __vue_module_identifier__$4Z = undefined;
/* functional template */

const __vue_is_functional_template__$4Z = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4Z = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4Z,
  staticRenderFns: __vue_staticRenderFns__$4Z
}, __vue_inject_styles__$4Z, __vue_script__$4Z, __vue_scope_id__$4Z, __vue_is_functional_template__$4Z, __vue_module_identifier__$4Z, false, undefined, undefined, undefined);

var script$4_ = Vue.extend({
  name: "PhDeviceMobileCamera",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4_ = script$4_;
/* template */

var __vue_render__$4_ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "64",
      "width": "208",
      "height": "128",
      "rx": "16",
      "transform": "translate(256) rotate(90)",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "68",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "64",
      "width": "208",
      "height": "128",
      "rx": "16",
      "transform": "translate(256) rotate(90)",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "24",
      "y": "64",
      "width": "208",
      "height": "128",
      "rx": "16",
      "transform": "translate(256) rotate(90)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "60",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,16H80A24.0275,24.0275,0,0,0,56,40V216a24.0275,24.0275,0,0,0,24,24h96a24.0275,24.0275,0,0,0,24-24V40A24.0275,24.0275,0,0,0,176,16ZM128,72a12,12,0,1,1,12-12A12,12,0,0,1,128,72Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "64",
      "width": "208",
      "height": "128",
      "rx": "16",
      "transform": "translate(256) rotate(90)",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "60",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "64",
      "width": "208",
      "height": "128",
      "rx": "16",
      "transform": "translate(256) rotate(90)",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "60",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "64",
      "width": "208",
      "height": "128",
      "rx": "16",
      "transform": "translate(256) rotate(90)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "60",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4_ = [];
/* style */

const __vue_inject_styles__$4_ = undefined;
/* scoped */

const __vue_scope_id__$4_ = undefined;
/* module identifier */

const __vue_module_identifier__$4_ = undefined;
/* functional template */

const __vue_is_functional_template__$4_ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4_ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4_,
  staticRenderFns: __vue_staticRenderFns__$4_
}, __vue_inject_styles__$4_, __vue_script__$4_, __vue_scope_id__$4_, __vue_is_functional_template__$4_, __vue_module_identifier__$4_, false, undefined, undefined, undefined);

var script$4$ = Vue.extend({
  name: "PhDeviceMobileSpeaker",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4$ = script$4$;
/* template */

var __vue_render__$4$ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "64",
      "width": "208",
      "height": "128",
      "rx": "16",
      "transform": "translate(256) rotate(90)",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "64",
      "x2": "152",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "64",
      "width": "208",
      "height": "128",
      "rx": "16",
      "transform": "translate(256) rotate(90)",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "24",
      "y": "64",
      "width": "208",
      "height": "128",
      "rx": "16",
      "transform": "translate(256) rotate(90)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "56",
      "x2": "160",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,16H80A24.0275,24.0275,0,0,0,56,40V216a24.0275,24.0275,0,0,0,24,24h96a24.0275,24.0275,0,0,0,24-24V40A24.0275,24.0275,0,0,0,176,16ZM160,64H96a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "64",
      "width": "208",
      "height": "128",
      "rx": "16",
      "transform": "translate(256) rotate(90)",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "56",
      "x2": "160",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "64",
      "width": "208",
      "height": "128",
      "rx": "16",
      "transform": "translate(256) rotate(90)",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "56",
      "x2": "160",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "64",
      "width": "208",
      "height": "128",
      "rx": "16",
      "transform": "translate(256) rotate(90)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "56",
      "x2": "160",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4$ = [];
/* style */

const __vue_inject_styles__$4$ = undefined;
/* scoped */

const __vue_scope_id__$4$ = undefined;
/* module identifier */

const __vue_module_identifier__$4$ = undefined;
/* functional template */

const __vue_is_functional_template__$4$ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4$ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4$,
  staticRenderFns: __vue_staticRenderFns__$4$
}, __vue_inject_styles__$4$, __vue_script__$4$, __vue_scope_id__$4$, __vue_is_functional_template__$4$, __vue_module_identifier__$4$, false, undefined, undefined, undefined);

var script$50 = Vue.extend({
  name: "PhDeviceTablet",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$50 = script$50;
/* template */

var __vue_render__$50 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "16",
      "transform": "translate(256) rotate(90)",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "72",
      "x2": "208",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "184",
      "x2": "208",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "48",
      "y": "64",
      "width": "160",
      "height": "128",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "16",
      "transform": "translate(256) rotate(90)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "64",
      "x2": "208",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "192",
      "x2": "208",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M192,24H64A24.0275,24.0275,0,0,0,40,48V208a24.0275,24.0275,0,0,0,24,24H192a24.0275,24.0275,0,0,0,24-24V48A24.0275,24.0275,0,0,0,192,24ZM64,40H192a8.00917,8.00917,0,0,1,8,8v8H56V48A8.00917,8.00917,0,0,1,64,40ZM192,216H64a8.00917,8.00917,0,0,1-8-8v-8H200v8A8.00917,8.00917,0,0,1,192,216Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "16",
      "transform": "translate(256) rotate(90)",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "64",
      "x2": "208",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "192",
      "x2": "208",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "16",
      "transform": "translate(256) rotate(90)",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "64",
      "x2": "208",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "192",
      "x2": "208",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "16",
      "transform": "translate(256) rotate(90)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "64",
      "x2": "208",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "192",
      "x2": "208",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$50 = [];
/* style */

const __vue_inject_styles__$50 = undefined;
/* scoped */

const __vue_scope_id__$50 = undefined;
/* module identifier */

const __vue_module_identifier__$50 = undefined;
/* functional template */

const __vue_is_functional_template__$50 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$50 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$50,
  staticRenderFns: __vue_staticRenderFns__$50
}, __vue_inject_styles__$50, __vue_script__$50, __vue_scope_id__$50, __vue_is_functional_template__$50, __vue_module_identifier__$50, false, undefined, undefined, undefined);

var script$51 = Vue.extend({
  name: "PhDeviceTabletCamera",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$51 = script$51;
/* template */

var __vue_render__$51 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "16",
      "transform": "translate(256) rotate(90)",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "76",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "16",
      "transform": "translate(256) rotate(90)",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "16",
      "transform": "translate(256) rotate(90)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "68",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M192,24H64A24.0275,24.0275,0,0,0,40,48V208a24.0275,24.0275,0,0,0,24,24H192a24.0275,24.0275,0,0,0,24-24V48A24.0275,24.0275,0,0,0,192,24ZM128,80a12,12,0,1,1,12-12A12,12,0,0,1,128,80Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "16",
      "transform": "translate(256) rotate(90)",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "68",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "16",
      "transform": "translate(256) rotate(90)",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "68",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "16",
      "transform": "translate(256) rotate(90)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "68",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$51 = [];
/* style */

const __vue_inject_styles__$51 = undefined;
/* scoped */

const __vue_scope_id__$51 = undefined;
/* module identifier */

const __vue_module_identifier__$51 = undefined;
/* functional template */

const __vue_is_functional_template__$51 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$51 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$51,
  staticRenderFns: __vue_staticRenderFns__$51
}, __vue_inject_styles__$51, __vue_script__$51, __vue_scope_id__$51, __vue_is_functional_template__$51, __vue_module_identifier__$51, false, undefined, undefined, undefined);

var script$52 = Vue.extend({
  name: "PhDeviceTabletSpeaker",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$52 = script$52;
/* template */

var __vue_render__$52 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "16",
      "transform": "translate(256) rotate(90)",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "72",
      "x2": "160",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "16",
      "transform": "translate(256) rotate(90)",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "16",
      "transform": "translate(256) rotate(90)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "64",
      "x2": "160",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M192,24H64A24.0275,24.0275,0,0,0,40,48V208a24.0275,24.0275,0,0,0,24,24H192a24.0275,24.0275,0,0,0,24-24V48A24.0275,24.0275,0,0,0,192,24ZM160,72H96a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "16",
      "transform": "translate(256) rotate(90)",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "64",
      "x2": "160",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "16",
      "transform": "translate(256) rotate(90)",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "64",
      "x2": "160",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "16",
      "transform": "translate(256) rotate(90)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "64",
      "x2": "160",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$52 = [];
/* style */

const __vue_inject_styles__$52 = undefined;
/* scoped */

const __vue_scope_id__$52 = undefined;
/* module identifier */

const __vue_module_identifier__$52 = undefined;
/* functional template */

const __vue_is_functional_template__$52 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$52 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$52,
  staticRenderFns: __vue_staticRenderFns__$52
}, __vue_inject_styles__$52, __vue_script__$52, __vue_scope_id__$52, __vue_is_functional_template__$52, __vue_module_identifier__$52, false, undefined, undefined, undefined);

var script$53 = Vue.extend({
  name: "PhDiamond",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$53 = script$53;
/* template */

var __vue_render__$53 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "51.63247",
      "y": "51.63247",
      "width": "152.73506",
      "height": "152.73506",
      "rx": "8",
      "transform": "translate(-53.01934 128) rotate(-45)",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "51.63247",
      "y": "51.63247",
      "width": "152.73506",
      "height": "152.73506",
      "rx": "8",
      "transform": "translate(-53.01934 128) rotate(-45)",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "51.63247",
      "y": "51.63247",
      "width": "152.73506",
      "height": "152.73506",
      "rx": "8",
      "transform": "translate(-53.01934 128) rotate(-45)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M236,139.31348,139.31348,236a16.01779,16.01779,0,0,1-22.627,0L20,139.31348a16.01779,16.01779,0,0,1,0-22.627L116.68652,20a16.01779,16.01779,0,0,1,22.627,0L236,116.68652A16.01779,16.01779,0,0,1,236,139.31348Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "51.63247",
      "y": "51.63247",
      "width": "152.73506",
      "height": "152.73506",
      "rx": "8",
      "transform": "translate(-53.01934 128) rotate(-45)",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "51.63247",
      "y": "51.63247",
      "width": "152.73506",
      "height": "152.73506",
      "rx": "8",
      "transform": "translate(-53.01934 128) rotate(-45)",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "51.63247",
      "y": "51.63247",
      "width": "152.73506",
      "height": "152.73506",
      "rx": "8",
      "transform": "translate(-53.01934 128) rotate(-45)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$53 = [];
/* style */

const __vue_inject_styles__$53 = undefined;
/* scoped */

const __vue_scope_id__$53 = undefined;
/* module identifier */

const __vue_module_identifier__$53 = undefined;
/* functional template */

const __vue_is_functional_template__$53 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$53 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$53,
  staticRenderFns: __vue_staticRenderFns__$53
}, __vue_inject_styles__$53, __vue_script__$53, __vue_scope_id__$53, __vue_is_functional_template__$53, __vue_module_identifier__$53, false, undefined, undefined, undefined);

var script$54 = Vue.extend({
  name: "PhDiceFive",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$54 = script$54;
/* template */

var __vue_render__$54 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "24",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "88",
      "cy": "88",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "168",
      "cy": "88",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "88",
      "cy": "168",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "168",
      "cy": "168",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "24",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "24",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "92",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "92",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "164",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "164",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M192,32H64A32.03667,32.03667,0,0,0,32,64V192a32.03667,32.03667,0,0,0,32,32H192a32.03667,32.03667,0,0,0,32-32V64A32.03667,32.03667,0,0,0,192,32ZM92,176a12,12,0,1,1,12-12A12,12,0,0,1,92,176Zm0-72a12,12,0,1,1,12-12A12,12,0,0,1,92,104Zm36,36a12,12,0,1,1,12-12A12,12,0,0,1,128,140Zm36,36a12,12,0,1,1,12-12A12,12,0,0,1,164,176Zm0-72a12,12,0,1,1,12-12A12,12,0,0,1,164,104Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "24",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "92",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "92",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "164",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "164",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "24",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "92",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "92",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "164",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "164",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "24",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "92",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "92",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "164",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "164",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$54 = [];
/* style */

const __vue_inject_styles__$54 = undefined;
/* scoped */

const __vue_scope_id__$54 = undefined;
/* module identifier */

const __vue_module_identifier__$54 = undefined;
/* functional template */

const __vue_is_functional_template__$54 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$54 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$54,
  staticRenderFns: __vue_staticRenderFns__$54
}, __vue_inject_styles__$54, __vue_script__$54, __vue_scope_id__$54, __vue_is_functional_template__$54, __vue_module_identifier__$54, false, undefined, undefined, undefined);

var script$55 = Vue.extend({
  name: "PhDiceFour",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$55 = script$55;
/* template */

var __vue_render__$55 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "24",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "96",
      "cy": "96",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "160",
      "cy": "96",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "96",
      "cy": "160",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "160",
      "cy": "160",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "24",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "24",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "100",
      "cy": "100",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "100",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "100",
      "cy": "156",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "156",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M192,32H64A32.03667,32.03667,0,0,0,32,64V192a32.03667,32.03667,0,0,0,32,32H192a32.03667,32.03667,0,0,0,32-32V64A32.03667,32.03667,0,0,0,192,32ZM100,168a12,12,0,1,1,12-12A12,12,0,0,1,100,168Zm0-56a12,12,0,1,1,12-12A12,12,0,0,1,100,112Zm56,56a12,12,0,1,1,12-12A12,12,0,0,1,156,168Zm0-56a12,12,0,1,1,12-12A12,12,0,0,1,156,112Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "24",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "100",
      "cy": "100",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "100",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "100",
      "cy": "156",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "156",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "24",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "100",
      "cy": "100",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "100",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "100",
      "cy": "156",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "156",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "24",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "100",
      "cy": "100",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "100",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "100",
      "cy": "156",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "156",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$55 = [];
/* style */

const __vue_inject_styles__$55 = undefined;
/* scoped */

const __vue_scope_id__$55 = undefined;
/* module identifier */

const __vue_module_identifier__$55 = undefined;
/* functional template */

const __vue_is_functional_template__$55 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$55 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$55,
  staticRenderFns: __vue_staticRenderFns__$55
}, __vue_inject_styles__$55, __vue_script__$55, __vue_scope_id__$55, __vue_is_functional_template__$55, __vue_module_identifier__$55, false, undefined, undefined, undefined);

var script$56 = Vue.extend({
  name: "PhDiceOne",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$56 = script$56;
/* template */

var __vue_render__$56 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "24",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "24",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "24",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M192,32H64A32.03667,32.03667,0,0,0,32,64V192a32.03667,32.03667,0,0,0,32,32H192a32.03667,32.03667,0,0,0,32-32V64A32.03667,32.03667,0,0,0,192,32ZM128,140a12,12,0,1,1,12-12A12,12,0,0,1,128,140Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "24",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "24",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "24",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$56 = [];
/* style */

const __vue_inject_styles__$56 = undefined;
/* scoped */

const __vue_scope_id__$56 = undefined;
/* module identifier */

const __vue_module_identifier__$56 = undefined;
/* functional template */

const __vue_is_functional_template__$56 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$56 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$56,
  staticRenderFns: __vue_staticRenderFns__$56
}, __vue_inject_styles__$56, __vue_script__$56, __vue_scope_id__$56, __vue_is_functional_template__$56, __vue_module_identifier__$56, false, undefined, undefined, undefined);

var script$57 = Vue.extend({
  name: "PhDiceSix",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$57 = script$57;
/* template */

var __vue_render__$57 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "24",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "96",
      "cy": "84",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "160",
      "cy": "84",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "96",
      "cy": "128",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "160",
      "cy": "128",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "96",
      "cy": "172",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "160",
      "cy": "172",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "24",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "24",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "84",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "84",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "172",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "172",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M192,32H64A32.03667,32.03667,0,0,0,32,64V192a32.03667,32.03667,0,0,0,32,32H192a32.03667,32.03667,0,0,0,32-32V64A32.03667,32.03667,0,0,0,192,32ZM92,184a12,12,0,1,1,12-12A12,12,0,0,1,92,184Zm0-44a12,12,0,1,1,12-12A12,12,0,0,1,92,140Zm0-44a12,12,0,1,1,12-12A12,12,0,0,1,92,96Zm72,88a12,12,0,1,1,12-12A12,12,0,0,1,164,184Zm0-44a12,12,0,1,1,12-12A12,12,0,0,1,164,140Zm0-44a12,12,0,1,1,12-12A12,12,0,0,1,164,96Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "24",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "84",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "84",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "128",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "128",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "172",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "172",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "24",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "84",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "84",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "128",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "128",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "172",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "172",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "24",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "84",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "84",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "172",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "172",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$57 = [];
/* style */

const __vue_inject_styles__$57 = undefined;
/* scoped */

const __vue_scope_id__$57 = undefined;
/* module identifier */

const __vue_module_identifier__$57 = undefined;
/* functional template */

const __vue_is_functional_template__$57 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$57 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$57,
  staticRenderFns: __vue_staticRenderFns__$57
}, __vue_inject_styles__$57, __vue_script__$57, __vue_scope_id__$57, __vue_is_functional_template__$57, __vue_module_identifier__$57, false, undefined, undefined, undefined);

var script$58 = Vue.extend({
  name: "PhDiceThree",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$58 = script$58;
/* template */

var __vue_render__$58 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "24",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "88",
      "cy": "88",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "168",
      "cy": "168",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "24",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "24",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "92",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "164",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M192,32H64A32.03667,32.03667,0,0,0,32,64V192a32.03667,32.03667,0,0,0,32,32H192a32.03667,32.03667,0,0,0,32-32V64A32.03667,32.03667,0,0,0,192,32ZM92,104a12,12,0,1,1,12-12A12,12,0,0,1,92,104Zm36,36a12,12,0,1,1,12-12A12,12,0,0,1,128,140Zm36,36a12,12,0,1,1,12-12A12,12,0,0,1,164,176Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "24",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "92",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "164",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "24",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "92",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "164",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "24",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "92",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "164",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$58 = [];
/* style */

const __vue_inject_styles__$58 = undefined;
/* scoped */

const __vue_scope_id__$58 = undefined;
/* module identifier */

const __vue_module_identifier__$58 = undefined;
/* functional template */

const __vue_is_functional_template__$58 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$58 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$58,
  staticRenderFns: __vue_staticRenderFns__$58
}, __vue_inject_styles__$58, __vue_script__$58, __vue_scope_id__$58, __vue_is_functional_template__$58, __vue_module_identifier__$58, false, undefined, undefined, undefined);

var script$59 = Vue.extend({
  name: "PhDiceTwo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$59 = script$59;
/* template */

var __vue_render__$59 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "24",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "104",
      "cy": "104",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "152",
      "cy": "152",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "24",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "24",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "108",
      "cy": "108",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "148",
      "cy": "148",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M192,32H64A32.03667,32.03667,0,0,0,32,64V192a32.03667,32.03667,0,0,0,32,32H192a32.03667,32.03667,0,0,0,32-32V64A32.03667,32.03667,0,0,0,192,32Zm-84,88a12,12,0,1,1,12-12A12,12,0,0,1,108,120Zm40,40a12,12,0,1,1,12-12A12,12,0,0,1,148,160Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "24",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "108",
      "cy": "108",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "148",
      "cy": "148",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "24",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "108",
      "cy": "108",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "148",
      "cy": "148",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "24",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "108",
      "cy": "108",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "148",
      "cy": "148",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$59 = [];
/* style */

const __vue_inject_styles__$59 = undefined;
/* scoped */

const __vue_scope_id__$59 = undefined;
/* module identifier */

const __vue_module_identifier__$59 = undefined;
/* functional template */

const __vue_is_functional_template__$59 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$59 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$59,
  staticRenderFns: __vue_staticRenderFns__$59
}, __vue_inject_styles__$59, __vue_script__$59, __vue_scope_id__$59, __vue_is_functional_template__$59, __vue_module_identifier__$59, false, undefined, undefined, undefined);

var script$5a = Vue.extend({
  name: "PhDisc",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5a = script$5a;
/* template */

var __vue_render__$5a = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "128",
      "x2": "160",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "195.88225",
      "y1": "60.11775",
      "x2": "150.62742",
      "y2": "105.37258",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M160,128a32,32,0,1,1-9.3726-22.62743h0l45.25483-45.25483h0A96,96,0,1,0,224,128Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "128",
      "x2": "160",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "195.88225",
      "y1": "60.11775",
      "x2": "150.62742",
      "y2": "105.37258",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M188.29883,43.31128a8.00224,8.00224,0,0,0-1.35889-.94751,103.67838,103.67838,0,1,0,1.35889.94751ZM128,152a24,24,0,1,1,24-24A24.0275,24.0275,0,0,1,128,152Zm88-24c0,2.47168-.10791,4.91833-.30859,7.339l-47.71875-8.41419a39.84182,39.84182,0,0,0-10.95777-26.41552l27.77808-39.671A87.83762,87.83762,0,0,1,216,128Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "128",
      "x2": "160",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "195.88225",
      "y1": "60.11775",
      "x2": "150.62742",
      "y2": "105.37258",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "128",
      "x2": "160",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "195.88225",
      "y1": "60.11775",
      "x2": "150.62742",
      "y2": "105.37258",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "128",
      "x2": "160",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "195.88225",
      "y1": "60.11775",
      "x2": "150.62742",
      "y2": "105.37258",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5a = [];
/* style */

const __vue_inject_styles__$5a = undefined;
/* scoped */

const __vue_scope_id__$5a = undefined;
/* module identifier */

const __vue_module_identifier__$5a = undefined;
/* functional template */

const __vue_is_functional_template__$5a = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5a = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5a,
  staticRenderFns: __vue_staticRenderFns__$5a
}, __vue_inject_styles__$5a, __vue_script__$5a, __vue_scope_id__$5a, __vue_is_functional_template__$5a, __vue_module_identifier__$5a, false, undefined, undefined, undefined);

var script$5b = Vue.extend({
  name: "PhDiscordLogo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5b = script$5b;
/* template */

var __vue_render__$5b = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "96",
      "cy": "132.00002",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "160",
      "cy": "132.00002",
      "r": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M151.28891,174.57783l15.78018,31.56053a7.96793,7.96793,0,0,0,8.99115,4.20919c24.53876-5.99927,45.69294-16.45908,61.10024-29.85086a8.05225,8.05225,0,0,0,2.47192-8.38971L205.65855,58.86074a8.02121,8.02121,0,0,0-4.62655-5.10908,175.85294,175.85294,0,0,0-29.66452-9.18289,8.01781,8.01781,0,0,0-9.31925,5.28642L151.51644,81.45071",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104.7111,174.57783,88.93092,206.13837a7.96794,7.96794,0,0,1-8.99115,4.20918c-24.53866-5.99924-45.69277-16.459-61.10006-29.85069a8.05224,8.05224,0,0,1-2.47193-8.38972L50.34158,58.8607a8.0212,8.0212,0,0,1,4.62655-5.1091,175.85321,175.85321,0,0,1,29.66439-9.18283,8.01781,8.01781,0,0,1,9.31924,5.28642l10.53179,31.59552",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M181.08378,168.00031C165.87906,173.0549,147.6274,176,128,176s-37.87933-2.94514-53.08411-7.9998",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,86.42155A174.46263,174.46263,0,0,0,128,80a174.46238,174.46238,0,0,0-48,6.42156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M100.95624,182.08757l-12.02532,24.0508a7.96794,7.96794,0,0,1-8.99115,4.20918c-24.53866-5.99924-45.69277-16.459-61.10006-29.85069a8.05224,8.05224,0,0,1-2.47193-8.38972L50.34158,58.8607a8.0212,8.0212,0,0,1,4.62655-5.1091,175.85349,175.85349,0,0,1,29.66439-9.18283,8.0178,8.0178,0,0,1,9.31924,5.28642l7.97318,23.91964,0-.00016a192.44676,192.44676,0,0,1,52.15015,0l0,.00016,7.97318-23.91964a8.01781,8.01781,0,0,1,9.31925-5.28642A175.85294,175.85294,0,0,1,201.032,53.75166a8.02121,8.02121,0,0,1,4.62655,5.10908L239.6324,172.107a8.05225,8.05225,0,0,1-2.47192,8.38971c-15.4073,13.39178-36.56148,23.85159-61.10024,29.85086a7.96793,7.96793,0,0,1-8.99115-4.20919l-12.02517-24.05042A189.308,189.308,0,0,1,128,184a189.3097,189.3097,0,0,1-27.04382-1.912Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "96",
      "cy": "144.00002",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "160",
      "cy": "144.00002",
      "r": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M74.4017,80A175.32467,175.32467,0,0,1,128,72a175.32507,175.32507,0,0,1,53.59754,7.99971",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M181.59717,176.00041A175.32523,175.32523,0,0,1,128,184a175.32505,175.32505,0,0,1-53.59753-7.99971",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M155.04392,182.08789l12.02517,24.05047a7.96793,7.96793,0,0,0,8.99115,4.20919c24.53876-5.99927,45.69294-16.45908,61.10024-29.85086a8.05225,8.05225,0,0,0,2.47192-8.38971L205.65855,58.86074a8.02121,8.02121,0,0,0-4.62655-5.10908,175.85294,175.85294,0,0,0-29.66452-9.18289,8.01781,8.01781,0,0,0-9.31925,5.28642l-7.97318,23.91964",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M100.95624,182.08757l-12.02532,24.0508a7.96794,7.96794,0,0,1-8.99115,4.20918c-24.53866-5.99924-45.69277-16.459-61.10006-29.85069a8.05224,8.05224,0,0,1-2.47193-8.38972L50.34158,58.8607a8.0212,8.0212,0,0,1,4.62655-5.1091,175.85349,175.85349,0,0,1,29.66439-9.18283,8.0178,8.0178,0,0,1,9.31924,5.28642l7.97318,23.91964",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M247.29492,169.80862,213.32129,56.56252A15.953,15.953,0,0,0,204.084,46.35744l-.53759.16309.54931-.1919a185.84371,185.84371,0,0,0-34.53515-10.30712,8.00026,8.00026,0,1,0-3.12012,15.69336q6.72656,1.3374,13.18457,3.14746a7.97792,7.97792,0,0,1-4.46045,15.07714,188.85309,188.85309,0,0,0-93.26074-.18359,7.99484,7.99484,0,0,1-5.56592-14.87305l.03418.01172q6.4541-1.80762,13.20068-3.15185a8.00026,8.00026,0,0,0-3.12011-15.69336A185.88539,185.88539,0,0,0,51.917,46.35647a15.95771,15.95771,0,0,0-9.23828,10.20507L8.70508,169.80862a16.09028,16.09028,0,0,0,4.88672,16.72656c.95459.83008,1.9331,1.645,2.92529,2.45166.02344.019.04346.041.06689.06006,16.23047,13.166,37.50342,23.22461,61.51856,29.08691a7.99977,7.99977,0,0,0,3.79492-15.543,160.72734,160.72734,0,0,1-31.33789-11.0664l.06592.00488a7.99746,7.99746,0,0,1,8.59912-13.24219C78.21,186.74367,102.063,192,128,192s49.80664-5.26269,68.792-13.71924a7.997,7.997,0,0,1,8.58252,13.24854l.06592-.00488a160.72734,160.72734,0,0,1-31.33789,11.0664,7.99978,7.99978,0,1,0,3.79492,15.543c24.01514-5.8623,45.28809-15.9209,61.51856-29.08691.02441-.01953.04492-.042.06884-.062h.00049c.99121-.80615,1.96973-1.62109,2.92383-2.45068A16.09062,16.09062,0,0,0,247.29492,169.80862ZM96,156a12,12,0,1,1,12-12A12,12,0,0,1,96,156Zm64,0a12,12,0,1,1,12-12A12,12,0,0,1,160,156Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "96",
      "cy": "144.00002",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "160",
      "cy": "144.00002",
      "r": "10"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M74.4017,80A175.32467,175.32467,0,0,1,128,72a175.32507,175.32507,0,0,1,53.59754,7.99971",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M181.59717,176.00041A175.32523,175.32523,0,0,1,128,184a175.32505,175.32505,0,0,1-53.59753-7.99971",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M155.04392,182.08789l12.02517,24.05047a7.96793,7.96793,0,0,0,8.99115,4.20919c24.53876-5.99927,45.69294-16.45908,61.10024-29.85086a8.05225,8.05225,0,0,0,2.47192-8.38971L205.65855,58.86074a8.02121,8.02121,0,0,0-4.62655-5.10908,175.85294,175.85294,0,0,0-29.66452-9.18289,8.01781,8.01781,0,0,0-9.31925,5.28642l-7.97318,23.91964",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M100.95624,182.08757l-12.02532,24.0508a7.96794,7.96794,0,0,1-8.99115,4.20918c-24.53866-5.99924-45.69277-16.459-61.10006-29.85069a8.05224,8.05224,0,0,1-2.47193-8.38972L50.34158,58.8607a8.0212,8.0212,0,0,1,4.62655-5.1091,175.85349,175.85349,0,0,1,29.66439-9.18283,8.0178,8.0178,0,0,1,9.31924,5.28642l7.97318,23.91964",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "96",
      "cy": "144.00002",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "160",
      "cy": "144.00002",
      "r": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M74.4017,80A175.32467,175.32467,0,0,1,128,72a175.32507,175.32507,0,0,1,53.59754,7.99971",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M181.59717,176.00041A175.32523,175.32523,0,0,1,128,184a175.32505,175.32505,0,0,1-53.59753-7.99971",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M155.04392,182.08789l12.02517,24.05047a7.96793,7.96793,0,0,0,8.99115,4.20919c24.53876-5.99927,45.69294-16.45908,61.10024-29.85086a8.05225,8.05225,0,0,0,2.47192-8.38971L205.65855,58.86074a8.02121,8.02121,0,0,0-4.62655-5.10908,175.85294,175.85294,0,0,0-29.66452-9.18289,8.01781,8.01781,0,0,0-9.31925,5.28642l-7.97318,23.91964",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M100.95624,182.08757l-12.02532,24.0508a7.96794,7.96794,0,0,1-8.99115,4.20918c-24.53866-5.99924-45.69277-16.459-61.10006-29.85069a8.05224,8.05224,0,0,1-2.47193-8.38972L50.34158,58.8607a8.0212,8.0212,0,0,1,4.62655-5.1091,175.85349,175.85349,0,0,1,29.66439-9.18283,8.0178,8.0178,0,0,1,9.31924,5.28642l7.97318,23.91964",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "96",
      "cy": "144.00002",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "160",
      "cy": "144.00002",
      "r": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M74.4017,80A175.32467,175.32467,0,0,1,128,72a175.32507,175.32507,0,0,1,53.59754,7.99971",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M181.59717,176.00041A175.32523,175.32523,0,0,1,128,184a175.32505,175.32505,0,0,1-53.59753-7.99971",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M155.04392,182.08789l12.02517,24.05047a7.96793,7.96793,0,0,0,8.99115,4.20919c24.53876-5.99927,45.69294-16.45908,61.10024-29.85086a8.05225,8.05225,0,0,0,2.47192-8.38971L205.65855,58.86074a8.02121,8.02121,0,0,0-4.62655-5.10908,175.85294,175.85294,0,0,0-29.66452-9.18289,8.01781,8.01781,0,0,0-9.31925,5.28642l-7.97318,23.91964",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M100.95624,182.08757l-12.02532,24.0508a7.96794,7.96794,0,0,1-8.99115,4.20918c-24.53866-5.99924-45.69277-16.459-61.10006-29.85069a8.05224,8.05224,0,0,1-2.47193-8.38972L50.34158,58.8607a8.0212,8.0212,0,0,1,4.62655-5.1091,175.85349,175.85349,0,0,1,29.66439-9.18283,8.0178,8.0178,0,0,1,9.31924,5.28642l7.97318,23.91964",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "96",
      "cy": "144.00002",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "160",
      "cy": "144.00002",
      "r": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M74.4017,80A175.32467,175.32467,0,0,1,128,72a175.32507,175.32507,0,0,1,53.59754,7.99971",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M181.59717,176.00041A175.32523,175.32523,0,0,1,128,184a175.32505,175.32505,0,0,1-53.59753-7.99971",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M155.04392,182.08789l12.02517,24.05047a7.96793,7.96793,0,0,0,8.99115,4.20919c24.53876-5.99927,45.69294-16.45908,61.10024-29.85086a8.05225,8.05225,0,0,0,2.47192-8.38971L205.65855,58.86074a8.02121,8.02121,0,0,0-4.62655-5.10908,175.85294,175.85294,0,0,0-29.66452-9.18289,8.01781,8.01781,0,0,0-9.31925,5.28642l-7.97318,23.91964",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M100.95624,182.08757l-12.02532,24.0508a7.96794,7.96794,0,0,1-8.99115,4.20918c-24.53866-5.99924-45.69277-16.459-61.10006-29.85069a8.05224,8.05224,0,0,1-2.47193-8.38972L50.34158,58.8607a8.0212,8.0212,0,0,1,4.62655-5.1091,175.85349,175.85349,0,0,1,29.66439-9.18283,8.0178,8.0178,0,0,1,9.31924,5.28642l7.97318,23.91964",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5b = [];
/* style */

const __vue_inject_styles__$5b = undefined;
/* scoped */

const __vue_scope_id__$5b = undefined;
/* module identifier */

const __vue_module_identifier__$5b = undefined;
/* functional template */

const __vue_is_functional_template__$5b = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5b = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5b,
  staticRenderFns: __vue_staticRenderFns__$5b
}, __vue_inject_styles__$5b, __vue_script__$5b, __vue_scope_id__$5b, __vue_is_functional_template__$5b, __vue_module_identifier__$5b, false, undefined, undefined, undefined);

var script$5c = Vue.extend({
  name: "PhDivide",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5c = script$5c;
/* template */

var __vue_render__$5c = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "64",
      "r": "20"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "192",
      "r": "20"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "64",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "192",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,128a8.00008,8.00008,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8.00008,8.00008,0,0,1,224,128ZM128,80a16,16,0,1,0-16-16A16.01833,16.01833,0,0,0,128,80Zm0,96a16,16,0,1,0,16,16A16.01833,16.01833,0,0,0,128,176Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "64",
      "r": "14"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "192",
      "r": "14"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "64",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "192",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "64",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "192",
      "r": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5c = [];
/* style */

const __vue_inject_styles__$5c = undefined;
/* scoped */

const __vue_scope_id__$5c = undefined;
/* module identifier */

const __vue_module_identifier__$5c = undefined;
/* functional template */

const __vue_is_functional_template__$5c = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5c = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5c,
  staticRenderFns: __vue_staticRenderFns__$5c
}, __vue_inject_styles__$5c, __vue_script__$5c, __vue_scope_id__$5c, __vue_is_functional_template__$5c, __vue_module_identifier__$5c, false, undefined, undefined, undefined);

var script$5d = Vue.extend({
  name: "PhDog",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5d = script$5d;
/* template */

var __vue_render__$5d = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "192",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "136",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "136",
      "r": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 176 128 192 112 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,48l55.76169-13.94042a8,8,0,0,1,9.80326,6.28683l16.41859,87.56583c1.54221,8.22509-8.98332,12.99712-14.15352,6.41688Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,48,48.23831,34.05958A8,8,0,0,0,38.435,40.34641L22.01646,127.91224c-1.54221,8.22509,8.98332,12.99712,14.15352,6.41688Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "48",
      "x2": "152",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,119.27273V184a32,32,0,0,1-32,32H80a32,32,0,0,1-32-32V119.27273",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,119.27273V184a32,32,0,0,1-32,32H80a32,32,0,0,1-32-32V119.27273L104,48h48Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "192",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "140",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "140",
      "r": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 176 128 192 112 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,48l55.76169-13.94042a8,8,0,0,1,9.80326,6.28683l16.41859,87.56583c1.54221,8.22509-8.98332,12.99712-14.15352,6.41688Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,48,48.23831,34.05958A8,8,0,0,0,38.435,40.34641L22.01646,127.91224c-1.54221,8.22509,8.98332,12.99712,14.15352,6.41688Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "48",
      "x2": "152",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,119.27273V184a32,32,0,0,1-32,32H80a32,32,0,0,1-32-32V119.27273",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M104,140a12,12,0,1,1-12-12A12,12,0,0,1,104,140Zm60-12a12,12,0,1,0,12,12A12,12,0,0,0,164,128Zm68.72656,15.959a16.26177,16.26177,0,0,1-6.72363,1.47657A15.60358,15.60358,0,0,1,216,141.7915V184a40.04552,40.04552,0,0,1-40,40H80a40.04552,40.04552,0,0,1-40-40V141.7915a15.60358,15.60358,0,0,1-10.00293,3.644,16.254,16.254,0,0,1-6.72363-1.47657,15.76942,15.76942,0,0,1-9.12012-17.521l16.418-87.56592A16.00071,16.00071,0,0,1,50.17871,26.29834L104.98535,40h46.0293l54.80664-13.70166a15.99961,15.99961,0,0,1,19.60644,12.57227L241.84668,126.438A15.76942,15.76942,0,0,1,232.72656,143.959ZM200,184V122.04L148.11133,56H107.88867L56,122.04V184a24.0275,24.0275,0,0,0,24,24h40V195.314l-13.65723-13.65722a8.00018,8.00018,0,0,1,11.31446-11.31348L128,180.68652l10.34277-10.34326a8.00018,8.00018,0,0,1,11.31446,11.31348L136,195.314V208h40A24.0275,24.0275,0,0,0,200,184Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "192",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "140",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "140",
      "r": "10"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 176 128 192 112 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,48l55.76169-13.94042a8,8,0,0,1,9.80326,6.28683l16.41859,87.56583c1.54221,8.22509-8.98332,12.99712-14.15352,6.41688Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,48,48.23831,34.05958A8,8,0,0,0,38.435,40.34641L22.01646,127.91224c-1.54221,8.22509,8.98332,12.99712,14.15352,6.41688Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "48",
      "x2": "152",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,119.27273V184a32,32,0,0,1-32,32H80a32,32,0,0,1-32-32V119.27273",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "192",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "140",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "140",
      "r": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 176 128 192 112 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,48l55.76169-13.94042a8,8,0,0,1,9.80326,6.28683l16.41859,87.56583c1.54221,8.22509-8.98332,12.99712-14.15352,6.41688Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,48,48.23831,34.05958A8,8,0,0,0,38.435,40.34641L22.01646,127.91224c-1.54221,8.22509,8.98332,12.99712,14.15352,6.41688Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "48",
      "x2": "152",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,119.27273V184a32,32,0,0,1-32,32H80a32,32,0,0,1-32-32V119.27273",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "192",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "140",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "140",
      "r": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 176 128 192 112 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,48l55.76169-13.94042a8,8,0,0,1,9.80326,6.28683l16.41859,87.56583c1.54221,8.22509-8.98332,12.99712-14.15352,6.41688Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,48,48.23831,34.05958A8,8,0,0,0,38.435,40.34641L22.01646,127.91224c-1.54221,8.22509,8.98332,12.99712,14.15352,6.41688Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "48",
      "x2": "152",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,119.27273V184a32,32,0,0,1-32,32H80a32,32,0,0,1-32-32V119.27273",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5d = [];
/* style */

const __vue_inject_styles__$5d = undefined;
/* scoped */

const __vue_scope_id__$5d = undefined;
/* module identifier */

const __vue_module_identifier__$5d = undefined;
/* functional template */

const __vue_is_functional_template__$5d = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5d = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5d,
  staticRenderFns: __vue_staticRenderFns__$5d
}, __vue_inject_styles__$5d, __vue_script__$5d, __vue_scope_id__$5d, __vue_is_functional_template__$5d, __vue_module_identifier__$5d, false, undefined, undefined, undefined);

var script$5e = Vue.extend({
  name: "PhDoor",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5e = script$5e;
/* template */

var __vue_render__$5e = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "24",
      "y1": "224",
      "x2": "232",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,224V40a8,8,0,0,1,8-8H192a8,8,0,0,1,8,8V224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "128",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56,224V40a8,8,0,0,1,8-8H192a8,8,0,0,1,8,8V224Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "224",
      "x2": "232",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,224V40a8,8,0,0,1,8-8H192a8,8,0,0,1,8,8V224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "128",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232,216H208V40a16.01833,16.01833,0,0,0-16-16H64A16.01833,16.01833,0,0,0,48,40V216H24a8,8,0,0,0,0,16H232a8,8,0,0,0,0-16Zm-68-76a12,12,0,1,1,12-12A12,12,0,0,1,164,140Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "24",
      "y1": "224",
      "x2": "232",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,224V40a8,8,0,0,1,8-8H192a8,8,0,0,1,8,8V224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "128",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "24",
      "y1": "224",
      "x2": "232",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,224V40a8,8,0,0,1,8-8H192a8,8,0,0,1,8,8V224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "128",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "24",
      "y1": "224",
      "x2": "232",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,224V40a8,8,0,0,1,8-8H192a8,8,0,0,1,8,8V224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "128",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5e = [];
/* style */

const __vue_inject_styles__$5e = undefined;
/* scoped */

const __vue_scope_id__$5e = undefined;
/* module identifier */

const __vue_module_identifier__$5e = undefined;
/* functional template */

const __vue_is_functional_template__$5e = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5e = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5e,
  staticRenderFns: __vue_staticRenderFns__$5e
}, __vue_inject_styles__$5e, __vue_script__$5e, __vue_scope_id__$5e, __vue_is_functional_template__$5e, __vue_module_identifier__$5e, false, undefined, undefined, undefined);

var script$5f = Vue.extend({
  name: "PhDotsNine",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5f = script$5f;
/* template */

var __vue_render__$5f = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "60",
      "cy": "60",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "60",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "196",
      "cy": "60",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "60",
      "cy": "128",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "196",
      "cy": "128",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "60",
      "cy": "196",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "196",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "196",
      "cy": "196",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "60",
      "cy": "60",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "60",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "196",
      "cy": "60",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "60",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "196",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "60",
      "cy": "196",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "196",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "196",
      "cy": "196",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M60,48A12,12,0,1,0,72,60,12.01375,12.01375,0,0,0,60,48Zm68,0a12,12,0,1,0,12,12A12.01375,12.01375,0,0,0,128,48Zm68,24a12,12,0,1,0-12-12A12.01375,12.01375,0,0,0,196,72ZM60,184a12,12,0,1,0,12,12A12.01375,12.01375,0,0,0,60,184Zm68,0a12,12,0,1,0,12,12A12.01375,12.01375,0,0,0,128,184Zm68,0a12,12,0,1,0,12,12A12.01375,12.01375,0,0,0,196,184ZM60,116a12,12,0,1,0,12,12A12.01375,12.01375,0,0,0,60,116Zm68,0a12,12,0,1,0,12,12A12.01375,12.01375,0,0,0,128,116Zm68,0a12,12,0,1,0,12,12A12.01375,12.01375,0,0,0,196,116Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "60",
      "cy": "60",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "60",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "196",
      "cy": "60",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "60",
      "cy": "128",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "196",
      "cy": "128",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "60",
      "cy": "196",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "196",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "196",
      "cy": "196",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "60",
      "cy": "60",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "60",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "196",
      "cy": "60",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "60",
      "cy": "128",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "196",
      "cy": "128",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "60",
      "cy": "196",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "196",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "196",
      "cy": "196",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "60",
      "cy": "60",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "60",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "196",
      "cy": "60",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "60",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "196",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "60",
      "cy": "196",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "196",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "196",
      "cy": "196",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5f = [];
/* style */

const __vue_inject_styles__$5f = undefined;
/* scoped */

const __vue_scope_id__$5f = undefined;
/* module identifier */

const __vue_module_identifier__$5f = undefined;
/* functional template */

const __vue_is_functional_template__$5f = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5f = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5f,
  staticRenderFns: __vue_staticRenderFns__$5f
}, __vue_inject_styles__$5f, __vue_script__$5f, __vue_scope_id__$5f, __vue_is_functional_template__$5f, __vue_module_identifier__$5f, false, undefined, undefined, undefined);

var script$5g = Vue.extend({
  name: "PhDotsSix",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5g = script$5g;
/* template */

var __vue_render__$5g = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "60",
      "cy": "92",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "92",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "196",
      "cy": "92",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "60",
      "cy": "164",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "164.0001",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "196",
      "cy": "164",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "60",
      "cy": "92",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "92",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "196",
      "cy": "92",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "60",
      "cy": "164",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "164.0001",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "196",
      "cy": "164",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M72,92.0001a12,12,0,1,1-12-12A12,12,0,0,1,72,92.0001Zm56-12a12,12,0,1,0,12,12A12,12,0,0,0,128,80.0001Zm68,24a12,12,0,1,0-12-12A12,12,0,0,0,196,104.0001Zm-136,48a12,12,0,1,0,12,12A12,12,0,0,0,60,152.0001Zm68,0a12,12,0,1,0,12,12A12,12,0,0,0,128,152.0001Zm68,0a12,12,0,1,0,12,12A12,12,0,0,0,196,152.0001Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "60",
      "cy": "92",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "92",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "196",
      "cy": "92",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "60",
      "cy": "164",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "164.0001",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "196",
      "cy": "164",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "60",
      "cy": "92",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "92",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "196",
      "cy": "92",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "60",
      "cy": "164",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "164.0001",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "196",
      "cy": "164",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "60",
      "cy": "92",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "92",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "196",
      "cy": "92",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "60",
      "cy": "164",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "164.0001",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "196",
      "cy": "164",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5g = [];
/* style */

const __vue_inject_styles__$5g = undefined;
/* scoped */

const __vue_scope_id__$5g = undefined;
/* module identifier */

const __vue_module_identifier__$5g = undefined;
/* functional template */

const __vue_is_functional_template__$5g = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5g = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5g,
  staticRenderFns: __vue_staticRenderFns__$5g
}, __vue_inject_styles__$5g, __vue_script__$5g, __vue_scope_id__$5g, __vue_is_functional_template__$5g, __vue_module_identifier__$5g, false, undefined, undefined, undefined);

var script$5h = Vue.extend({
  name: "PhDotsSixVertical",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5h = script$5h;
/* template */

var __vue_render__$5h = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "92",
      "cy": "60",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "60",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "128",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "128",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "196",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "196",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "92",
      "cy": "60",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "60",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "196",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "196",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M104,60.0001a12,12,0,1,1-12-12A12,12,0,0,1,104,60.0001Zm60,12a12,12,0,1,0-12-12A12,12,0,0,0,164,72.0001Zm-72,44a12,12,0,1,0,12,12A12,12,0,0,0,92,116.0001Zm72,0a12,12,0,1,0,12,12A12,12,0,0,0,164,116.0001Zm-72,68a12,12,0,1,0,12,12A12,12,0,0,0,92,184.0001Zm72,0a12,12,0,1,0,12,12A12,12,0,0,0,164,184.0001Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "92",
      "cy": "60",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "60",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "128",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "128",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "196",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "196",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "92",
      "cy": "60",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "60",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "128",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "128",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "196",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "196",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "92",
      "cy": "60",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "60",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "196",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "196",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5h = [];
/* style */

const __vue_inject_styles__$5h = undefined;
/* scoped */

const __vue_scope_id__$5h = undefined;
/* module identifier */

const __vue_module_identifier__$5h = undefined;
/* functional template */

const __vue_is_functional_template__$5h = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5h = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5h,
  staticRenderFns: __vue_staticRenderFns__$5h
}, __vue_inject_styles__$5h, __vue_script__$5h, __vue_scope_id__$5h, __vue_is_functional_template__$5h, __vue_module_identifier__$5h, false, undefined, undefined, undefined);

var script$5i = Vue.extend({
  name: "PhDotsThree",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5i = script$5i;
/* template */

var __vue_render__$5i = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "64",
      "cy": "128",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "192",
      "cy": "128",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "192",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "64",
      "cy": "128",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M140,128a12,12,0,1,1-12-12A12,12,0,0,1,140,128Zm52-12a12,12,0,1,0,12,12A12,12,0,0,0,192,116ZM64,116a12,12,0,1,0,12,12A12,12,0,0,0,64,116Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "64",
      "cy": "128",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "192",
      "cy": "128",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "64",
      "cy": "128",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "192",
      "cy": "128",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "192",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "64",
      "cy": "128",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5i = [];
/* style */

const __vue_inject_styles__$5i = undefined;
/* scoped */

const __vue_scope_id__$5i = undefined;
/* module identifier */

const __vue_module_identifier__$5i = undefined;
/* functional template */

const __vue_is_functional_template__$5i = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5i = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5i,
  staticRenderFns: __vue_staticRenderFns__$5i
}, __vue_inject_styles__$5i, __vue_script__$5i, __vue_scope_id__$5i, __vue_is_functional_template__$5i, __vue_module_identifier__$5i, false, undefined, undefined, undefined);

var script$5j = Vue.extend({
  name: "PhDotsThreeCircle",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5j = script$5j;
/* template */

var __vue_render__$5j = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "100",
      "cy": "128",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "128",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "80",
      "cy": "128",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.12041,104.12041,0,0,0,128,24ZM80,140a12,12,0,1,1,12-12A12.0006,12.0006,0,0,1,80,140Zm48,0a12,12,0,1,1,12-12A12.0006,12.0006,0,0,1,128,140Zm48,0a12,12,0,1,1,12-12A12.0006,12.0006,0,0,1,176,140Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "80",
      "cy": "128",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "128",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "80",
      "cy": "128",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "128",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "80",
      "cy": "128",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5j = [];
/* style */

const __vue_inject_styles__$5j = undefined;
/* scoped */

const __vue_scope_id__$5j = undefined;
/* module identifier */

const __vue_module_identifier__$5j = undefined;
/* functional template */

const __vue_is_functional_template__$5j = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5j = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5j,
  staticRenderFns: __vue_staticRenderFns__$5j
}, __vue_inject_styles__$5j, __vue_script__$5j, __vue_scope_id__$5j, __vue_is_functional_template__$5j, __vue_module_identifier__$5j, false, undefined, undefined, undefined);

var script$5k = Vue.extend({
  name: "PhDotsThreeCircleVertical",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5k = script$5k;
/* template */

var __vue_render__$5k = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "100",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "156",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "80",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "176",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232,128A104,104,0,1,0,128,232,104.12041,104.12041,0,0,0,232,128ZM116,80a12,12,0,1,1,12,12A12.0006,12.0006,0,0,1,116,80Zm0,48a12,12,0,1,1,12,12A12.0006,12.0006,0,0,1,116,128Zm0,48a12,12,0,1,1,12,12A12.0006,12.0006,0,0,1,116,176Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "80",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "176",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "80",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "176",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "80",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "176",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5k = [];
/* style */

const __vue_inject_styles__$5k = undefined;
/* scoped */

const __vue_scope_id__$5k = undefined;
/* module identifier */

const __vue_module_identifier__$5k = undefined;
/* functional template */

const __vue_is_functional_template__$5k = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5k = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5k,
  staticRenderFns: __vue_staticRenderFns__$5k
}, __vue_inject_styles__$5k, __vue_script__$5k, __vue_scope_id__$5k, __vue_is_functional_template__$5k, __vue_module_identifier__$5k, false, undefined, undefined, undefined);

var script$5l = Vue.extend({
  name: "PhDotsThreeOutline",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5l = script$5l;
/* template */

var __vue_render__$5l = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "208",
      "cy": "128",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "48",
      "cy": "128",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "24",
      "opacity": "0.1"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "48",
      "cy": "128",
      "r": "24",
      "opacity": "0.1"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "208",
      "cy": "128",
      "r": "24",
      "opacity": "0.1"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "48",
      "cy": "128",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "208",
      "cy": "128",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M156,128a28,28,0,1,1-28-28A28.02769,28.02769,0,0,1,156,128ZM48,100a28,28,0,1,0,28,28A28.02769,28.02769,0,0,0,48,100Zm160,0a28,28,0,1,0,28,28A28.02769,28.02769,0,0,0,208,100Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "48",
      "cy": "128",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "208",
      "cy": "128",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "48",
      "cy": "128",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "208",
      "cy": "128",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "48",
      "cy": "128",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "208",
      "cy": "128",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5l = [];
/* style */

const __vue_inject_styles__$5l = undefined;
/* scoped */

const __vue_scope_id__$5l = undefined;
/* module identifier */

const __vue_module_identifier__$5l = undefined;
/* functional template */

const __vue_is_functional_template__$5l = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5l = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5l,
  staticRenderFns: __vue_staticRenderFns__$5l
}, __vue_inject_styles__$5l, __vue_script__$5l, __vue_scope_id__$5l, __vue_is_functional_template__$5l, __vue_module_identifier__$5l, false, undefined, undefined, undefined);

var script$5m = Vue.extend({
  name: "PhDotsThreeOutlineVertical",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5m = script$5m;
/* template */

var __vue_render__$5m = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "48",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "208",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "24",
      "opacity": "0.1"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "48",
      "r": "24",
      "opacity": "0.1"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "208",
      "r": "24",
      "opacity": "0.1"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "48",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "208",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M156,128a28,28,0,1,1-28-28A28.02769,28.02769,0,0,1,156,128ZM128,76a28,28,0,1,0-28-28A28.02769,28.02769,0,0,0,128,76Zm0,104a28,28,0,1,0,28,28A28.02769,28.02769,0,0,0,128,180Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "48",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "208",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "48",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "208",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "48",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "208",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5m = [];
/* style */

const __vue_inject_styles__$5m = undefined;
/* scoped */

const __vue_scope_id__$5m = undefined;
/* module identifier */

const __vue_module_identifier__$5m = undefined;
/* functional template */

const __vue_is_functional_template__$5m = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5m = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5m,
  staticRenderFns: __vue_staticRenderFns__$5m
}, __vue_inject_styles__$5m, __vue_script__$5m, __vue_scope_id__$5m, __vue_is_functional_template__$5m, __vue_module_identifier__$5m, false, undefined, undefined, undefined);

var script$5n = Vue.extend({
  name: "PhDotsThreeVertical",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5n = script$5n;
/* template */

var __vue_render__$5n = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "64",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "192",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "64",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "192",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M140,128a12,12,0,1,1-12-12A12,12,0,0,1,140,128ZM128,76a12,12,0,1,0-12-12A12,12,0,0,0,128,76Zm0,104a12,12,0,1,0,12,12A12,12,0,0,0,128,180Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "64",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "192",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "64",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "192",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "64",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "192",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5n = [];
/* style */

const __vue_inject_styles__$5n = undefined;
/* scoped */

const __vue_scope_id__$5n = undefined;
/* module identifier */

const __vue_module_identifier__$5n = undefined;
/* functional template */

const __vue_is_functional_template__$5n = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5n = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5n,
  staticRenderFns: __vue_staticRenderFns__$5n
}, __vue_inject_styles__$5n, __vue_script__$5n, __vue_scope_id__$5n, __vue_is_functional_template__$5n, __vue_module_identifier__$5n, false, undefined, undefined, undefined);

var script$5o = Vue.extend({
  name: "PhDownload",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5o = script$5o;
/* template */

var __vue_render__$5o = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "24",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 80 128 128 176 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184.56836,128H224a8,8,0,0,1,8,8v64a8,8,0,0,1-8,8H32a8,8,0,0,1-8-8V136a8,8,0,0,1,8-8H71.43164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "168",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "128",
      "width": "208",
      "height": "80",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,128h48a8,8,0,0,1,8,8v64a8,8,0,0,1-8,8H32a8,8,0,0,1-8-8V136a8,8,0,0,1,8-8H80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "24",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 80 128 128 176 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "168",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M122.34326,133.65723c.02588.02588.05469.04785.08106.07324.16211.15771.32861.31152.50341.45508.09766.08008.20118.15039.30176.22558.1084.08106.21485.165.32764.24073.11621.07812.2373.1455.35693.21679.10449.0625.20655.12793.31446.18555.12011.06445.24414.11914.36669.17676.11426.0542.22657.11084.34327.15967.11816.04882.23925.08837.35937.13134.126.04541.251.09375.37988.13282.11963.03613.24122.063.36231.09326.13184.0332.26269.07031.397.09716.13965.02735.28028.04395.42041.064.11817.01709.23389.03906.353.05078.26269.02588.52588.04.78955.04s.52686-.01416.78955-.04c.11914-.01172.23486-.03369.353-.05078.14013-.02.28076-.03662.42041-.064.13428-.02685.26513-.064.397-.09716.12109-.03028.24268-.05713.36231-.09326.1289-.03907.2539-.08741.37988-.13282.12012-.043.24121-.08252.35937-.13134.1167-.04883.229-.10547.34327-.15967.12255-.05762.24658-.11231.36669-.17676.10791-.05762.21-.12305.31446-.18555.11963-.07129.24072-.13867.35693-.21679.11279-.07569.21924-.15967.32764-.24073.10058-.07519.2041-.1455.30176-.22558.17822-.14649.34765-.30225.51269-.46338.023-.023.04883-.042.07178-.06494l48-48a8.00018,8.00018,0,1,0-11.31348-11.31446L136,108.68652V24a8,8,0,0,0-16,0v84.68652L85.65674,74.34277A8.00018,8.00018,0,0,0,74.34326,85.65723Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,120H169.94141L144.9707,144.9707a24.00066,24.00066,0,0,1-33.9414,0L86.05859,120H32a16.01833,16.01833,0,0,0-16,16v64a16.01833,16.01833,0,0,0,16,16H224a16.01833,16.01833,0,0,0,16-16V136A16.01833,16.01833,0,0,0,224,120Zm-35.99951,60a12,12,0,1,1,12-12A12,12,0,0,1,188.00049,180Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,128h48a8,8,0,0,1,8,8v64a8,8,0,0,1-8,8H32a8,8,0,0,1-8-8V136a8,8,0,0,1,8-8H80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "24",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 80 128 128 176 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "168",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,128h48a8,8,0,0,1,8,8v64a8,8,0,0,1-8,8H32a8,8,0,0,1-8-8V136a8,8,0,0,1,8-8H80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "24",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 80 128 128 176 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "168",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,128h48a8,8,0,0,1,8,8v64a8,8,0,0,1-8,8H32a8,8,0,0,1-8-8V136a8,8,0,0,1,8-8H80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "24",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 80 128 128 176 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "168",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5o = [];
/* style */

const __vue_inject_styles__$5o = undefined;
/* scoped */

const __vue_scope_id__$5o = undefined;
/* module identifier */

const __vue_module_identifier__$5o = undefined;
/* functional template */

const __vue_is_functional_template__$5o = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5o = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5o,
  staticRenderFns: __vue_staticRenderFns__$5o
}, __vue_inject_styles__$5o, __vue_script__$5o, __vue_scope_id__$5o, __vue_is_functional_template__$5o, __vue_module_identifier__$5o, false, undefined, undefined, undefined);

var script$5p = Vue.extend({
  name: "PhDownloadSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5p = script$5p;
/* template */

var __vue_render__$5p = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "86 110.011 128 152 170 110.011",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "151.97057",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,152v56a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "86 110.011 128 152 170 110.011",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "151.97057",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,152v56a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80.34375,115.668A8,8,0,0,1,86,102.01074h34V40a8,8,0,0,1,16,0v62.01074h34a8,8,0,0,1,5.65625,13.65723l-42,41.98926a7.99945,7.99945,0,0,1-11.3125,0ZM216,144a8.00039,8.00039,0,0,0-8,8v56H48V152a8,8,0,0,0-16,0v56a16.01833,16.01833,0,0,0,16,16H208a16.01833,16.01833,0,0,0,16-16V152A8.00039,8.00039,0,0,0,216,144Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "86 110.011 128 152 170 110.011",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "151.97057",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,152v56a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "86 110.011 128 152 170 110.011",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "151.97057",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,152v56a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "86 110.011 128 152 170 110.011",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "151.97057",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,152v56a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5p = [];
/* style */

const __vue_inject_styles__$5p = undefined;
/* scoped */

const __vue_scope_id__$5p = undefined;
/* module identifier */

const __vue_module_identifier__$5p = undefined;
/* functional template */

const __vue_is_functional_template__$5p = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5p = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5p,
  staticRenderFns: __vue_staticRenderFns__$5p
}, __vue_inject_styles__$5p, __vue_script__$5p, __vue_scope_id__$5p, __vue_is_functional_template__$5p, __vue_module_identifier__$5p, false, undefined, undefined, undefined);

var script$5q = Vue.extend({
  name: "PhDribbbleLogo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5q = script$5q;
/* template */

var __vue_render__$5q = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128.0009",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M71.0247,205.27206A159.91145,159.91145,0,0,1,208.00586,127.999q8.09514,0,15.99054.78906",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M188.0294,53.09173A159.68573,159.68573,0,0,1,64.00586,111.999a160.8502,160.8502,0,0,1-30.15138-2.83671",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M85.93041,41.686a159.92755,159.92755,0,0,1,78.99267,138.00723,160.35189,160.35189,0,0,1-4.73107,38.77687",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M71.0247,205.27116a159.91145,159.91145,0,0,1,136.98116-77.27311q8.09514,0,15.99054.78906",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M188.0294,53.09083A159.68573,159.68573,0,0,1,64.00586,111.99805a160.8502,160.8502,0,0,1-30.15138-2.83671",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M85.93041,41.68508a159.92755,159.92755,0,0,1,78.99267,138.00723,160.35189,160.35189,0,0,1-4.73107,38.77687",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M86.26123,32.74414a103.85849,103.85849,0,0,1,100.148,9.25537,153.22442,153.22442,0,0,1-44.543,40.48438A169.26114,169.26114,0,0,0,86.26123,32.74414Zm41.31543,57.28955A152.978,152.978,0,0,0,69.4624,42.09863a104.382,104.382,0,0,0-41.543,57.561A151.8095,151.8095,0,0,0,64,103.99805,151.0488,151.0488,0,0,0,127.57666,90.03369Zm104.22119,31.65772a103.76547,103.76547,0,0,0-32.88965-69.689,169.34119,169.34119,0,0,1-48.39453,43.94092,167.29388,167.29388,0,0,1,13.542,29.89746,168.13983,168.13983,0,0,1,67.74219-4.14941Zm-63.33008,19.53125a167.82141,167.82141,0,0,1,4.44922,38.46972,168.65237,168.65237,0,0,1-6.084,44.77832,104.24218,104.24218,0,0,0,64.68213-86.65185,152.38875,152.38875,0,0,0-63.04737,3.40381Zm-19.64062-10.45459a151.39932,151.39932,0,0,0-12.3916-27.20557A166.974,166.974,0,0,1,64,119.99805a167.82812,167.82812,0,0,1-39.23633-4.6377,103.89032,103.89032,0,0,0,35.958,91.88281A168.9649,168.9649,0,0,1,148.82715,130.76807ZM73.78369,216.72021a103.93363,103.93363,0,0,0,74.58447,13.27051,152.66635,152.66635,0,0,0,8.54883-50.29834,151.825,151.825,0,0,0-3.73291-33.46289A152.89185,152.89185,0,0,0,73.78369,216.72021Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M71.0247,205.27116a159.91145,159.91145,0,0,1,136.98116-77.27311q8.09514,0,15.99054.78906",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M188.0294,53.09083A159.68573,159.68573,0,0,1,64.00586,111.99805a160.8502,160.8502,0,0,1-30.15138-2.83671",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M85.93041,41.68508a159.92755,159.92755,0,0,1,78.99267,138.00723,160.35189,160.35189,0,0,1-4.73107,38.77687",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M71.0247,205.27116a159.91145,159.91145,0,0,1,136.98116-77.27311q8.09514,0,15.99054.78906",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M188.0294,53.09083A159.68573,159.68573,0,0,1,64.00586,111.99805a160.8502,160.8502,0,0,1-30.15138-2.83671",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M85.93041,41.68508a159.92755,159.92755,0,0,1,78.99267,138.00723,160.35189,160.35189,0,0,1-4.73107,38.77687",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M71.0247,205.27116a159.91145,159.91145,0,0,1,136.98116-77.27311q8.09514,0,15.99054.78906",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M188.0294,53.09083A159.68573,159.68573,0,0,1,64.00586,111.99805a160.8502,160.8502,0,0,1-30.15138-2.83671",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M85.93041,41.68508a159.92755,159.92755,0,0,1,78.99267,138.00723,160.35189,160.35189,0,0,1-4.73107,38.77687",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5q = [];
/* style */

const __vue_inject_styles__$5q = undefined;
/* scoped */

const __vue_scope_id__$5q = undefined;
/* module identifier */

const __vue_module_identifier__$5q = undefined;
/* functional template */

const __vue_is_functional_template__$5q = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5q = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5q,
  staticRenderFns: __vue_staticRenderFns__$5q
}, __vue_inject_styles__$5q, __vue_script__$5q, __vue_scope_id__$5q, __vue_is_functional_template__$5q, __vue_module_identifier__$5q, false, undefined, undefined, undefined);

var script$5r = Vue.extend({
  name: "PhDrop",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5r = script$5r;
/* template */

var __vue_render__$5r = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,144c0-72-80-128-80-128S48,72,48,144a80,80,0,0,0,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M163.1078,152.00061a36.05137,36.05137,0,0,1-27.10744,27.10724",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,144c0-72-80-128-80-128S48,72,48,144a80,80,0,0,0,160,0Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,144c0-72-80-128-80-128S48,72,48,144a80,80,0,0,0,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M136.11987,191.216a47.923,47.923,0,0,0,39.20472-39.1564",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M174.03662,47.75049a254.574,254.574,0,0,0-41.44873-38.3042,7.99885,7.99885,0,0,0-9.17578,0,254.574,254.574,0,0,0-41.44873,38.3042C54.51074,79.3208,40,112.60352,40,144a88,88,0,0,0,176,0C216,112.60352,201.48926,79.3208,174.03662,47.75049Zm9.17578,105.646a55.85216,55.85216,0,0,1-45.76562,45.7085,8,8,0,1,1-2.6543-15.77832,39.8386,39.8386,0,0,0,32.64453-32.604,8.00019,8.00019,0,0,1,15.77539,2.67382Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,144c0-72-80-128-80-128S48,72,48,144a80,80,0,0,0,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M136.11987,191.216a47.923,47.923,0,0,0,39.20472-39.1564",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,144c0-72-80-128-80-128S48,72,48,144a80,80,0,0,0,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M136.11987,191.216a47.923,47.923,0,0,0,39.20472-39.1564",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,144c0-72-80-128-80-128S48,72,48,144a80,80,0,0,0,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M136.11987,191.216a47.923,47.923,0,0,0,39.20472-39.1564",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5r = [];
/* style */

const __vue_inject_styles__$5r = undefined;
/* scoped */

const __vue_scope_id__$5r = undefined;
/* module identifier */

const __vue_module_identifier__$5r = undefined;
/* functional template */

const __vue_is_functional_template__$5r = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5r = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5r,
  staticRenderFns: __vue_staticRenderFns__$5r
}, __vue_inject_styles__$5r, __vue_script__$5r, __vue_scope_id__$5r, __vue_is_functional_template__$5r, __vue_module_identifier__$5r, false, undefined, undefined, undefined);

var script$5s = Vue.extend({
  name: "PhDropHalf",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5s = script$5s;
/* template */

var __vue_render__$5s = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,144c0-72-80-128-80-128S48,72,48,144a80,80,0,0,0,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "224",
      "x2": "128",
      "y2": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "127.99999",
      "y1": "79.99999",
      "x2": "206.65864",
      "y2": "158.65864",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "127.99999",
      "y1": "139.99999",
      "x2": "186.53165",
      "y2": "198.53165",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,224a80,80,0,0,0,80-80c0-72-80-128-80-128Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,144c0-72-80-128-80-128S48,72,48,144a80,80,0,0,0,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "224",
      "x2": "128",
      "y2": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,144c0-72-80-128-80-128S48,72,48,144a80,80,0,0,0,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,224a80,80,0,0,0,80-80c0-72-80-128-80-128Z"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "224",
      "x2": "128",
      "y2": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,144c0-72-80-128-80-128S48,72,48,144a80,80,0,0,0,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "224",
      "x2": "128",
      "y2": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "127.99999",
      "y1": "63.99999",
      "x2": "208",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "127.99999",
      "y1": "111.99999",
      "x2": "198.26945",
      "y2": "182.26945",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('g', [_c('line', {
    attrs: {
      "x1": "127.99999",
      "y1": "159.99999",
      "x2": "176.00281",
      "y2": "208.00281",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "127.99999",
      "y1": "159.99999",
      "x2": "176.00281",
      "y2": "208.00281",
      "fill": "#231f20"
    }
  })])]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,144c0-72-80-128-80-128S48,72,48,144a80,80,0,0,0,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "224",
      "x2": "128",
      "y2": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "127.99999",
      "y1": "63.99999",
      "x2": "208",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "127.99999",
      "y1": "111.99999",
      "x2": "198.26945",
      "y2": "182.26945",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('g', [_c('line', {
    attrs: {
      "x1": "127.99999",
      "y1": "159.99999",
      "x2": "176.00281",
      "y2": "208.00281",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "127.99999",
      "y1": "159.99999",
      "x2": "176.00281",
      "y2": "208.00281",
      "fill": "#231f20"
    }
  })])]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,144c0-72-80-128-80-128S48,72,48,144a80,80,0,0,0,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "224",
      "x2": "128",
      "y2": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "127.99999",
      "y1": "63.99999",
      "x2": "208",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "127.99999",
      "y1": "111.99999",
      "x2": "198.26945",
      "y2": "182.26945",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('g', [_c('line', {
    attrs: {
      "x1": "127.99999",
      "y1": "159.99999",
      "x2": "176.00281",
      "y2": "208.00281",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "127.99999",
      "y1": "159.99999",
      "x2": "176.00281",
      "y2": "208.00281",
      "fill": "#231f20"
    }
  })])]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5s = [];
/* style */

const __vue_inject_styles__$5s = undefined;
/* scoped */

const __vue_scope_id__$5s = undefined;
/* module identifier */

const __vue_module_identifier__$5s = undefined;
/* functional template */

const __vue_is_functional_template__$5s = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5s = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5s,
  staticRenderFns: __vue_staticRenderFns__$5s
}, __vue_inject_styles__$5s, __vue_script__$5s, __vue_scope_id__$5s, __vue_is_functional_template__$5s, __vue_module_identifier__$5s, false, undefined, undefined, undefined);

var script$5t = Vue.extend({
  name: "PhEar",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5t = script$5t;
/* template */

var __vue_render__$5t = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M161.93948,216.0039A44.00107,44.00107,0,0,1,84,188c0-41.49014-36-28-36-84a80,80,0,0,1,160,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M178.33575,160.00017A20.00334,20.00334,0,0,1,140,152c0-24,28-24,28-48a40,40,0,0,0-80,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M161.93951,216.00391A44.00109,44.00109,0,0,1,84,188c0-41.49014-36-28-36-84a80,80,0,0,1,160,0C208,144,208.97171,168.97171,161.93951,216.00391Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M180,152a20,20,0,0,1-40,0c0-24,28-24,28-48a40,40,0,0,0-80,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M161.93948,216.0039A44.00107,44.00107,0,0,1,84,188c0-41.49014-36-28-36-84a80,80,0,0,1,160,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M188,152a28,28,0,0,1-56,0c0-15.67969,9.31152-23.66113,16.79346-30.07422C155.95068,115.791,160,111.93457,160,104a32,32,0,0,0-64,0,8,8,0,0,1-16,0,48,48,0,0,1,96,0c0,15.67969-9.31152,23.66113-16.79346,30.07422C152.04932,140.209,148,144.06543,148,152a12,12,0,0,0,24,0,8,8,0,0,1,16,0ZM128,16a88.09957,88.09957,0,0,0-88,88c0,33.49512,12.45557,45.50488,22.46387,55.15527C70.32227,166.73242,76,172.207,76,188a52.00105,52.00105,0,0,0,92.10742,33.09863,8,8,0,1,0-12.33594-10.18945A36.001,36.001,0,0,1,92,188c0-22.5918-9.7915-32.0332-18.43018-40.36328C64.53418,138.9248,56,130.69629,56,104a72,72,0,0,1,144,0,8,8,0,0,0,16,0A88.09957,88.09957,0,0,0,128,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M180,152a20,20,0,0,1-40,0c0-24,28-24,28-48a40,40,0,0,0-80,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M161.93948,216.0039A44.00107,44.00107,0,0,1,84,188c0-41.49014-36-28-36-84a80,80,0,0,1,160,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M180,152a20,20,0,0,1-40,0c0-24,28-24,28-48a40,40,0,0,0-80,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M161.93948,216.0039A44.00107,44.00107,0,0,1,84,188c0-41.49014-36-28-36-84a80,80,0,0,1,160,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M180,152a20,20,0,0,1-40,0c0-24,28-24,28-48a40,40,0,0,0-80,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M161.93948,216.0039A44.00107,44.00107,0,0,1,84,188c0-41.49014-36-28-36-84a80,80,0,0,1,160,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5t = [];
/* style */

const __vue_inject_styles__$5t = undefined;
/* scoped */

const __vue_scope_id__$5t = undefined;
/* module identifier */

const __vue_module_identifier__$5t = undefined;
/* functional template */

const __vue_is_functional_template__$5t = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5t = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5t,
  staticRenderFns: __vue_staticRenderFns__$5t
}, __vue_inject_styles__$5t, __vue_script__$5t, __vue_scope_id__$5t, __vue_is_functional_template__$5t, __vue_module_identifier__$5t, false, undefined, undefined, undefined);

var script$5u = Vue.extend({
  name: "PhEarSlash",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5u = script$5u;
/* template */

var __vue_render__$5u = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M91.42886,87.7719A39.8604,39.8604,0,0,0,88,104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M161.93948,216.0039A44.00107,44.00107,0,0,1,84,188c0-41.49014-36-28-36-84A79.63961,79.63961,0,0,1,63.34376,56.87833",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M166.89165,170.78091A20.01341,20.01341,0,0,1,140,152a24.94024,24.94024,0,0,1,1.58781-9.05283",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M94.27434,31.43528A80.03716,80.03716,0,0,1,208,104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M166.97308,111.4048A25.6972,25.6972,0,0,0,168,104a40.00005,40.00005,0,0,0-40-40q-1.99815,0-3.94767.19234",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M161.93951,216.00391A44.00109,44.00109,0,0,1,84,188c0-41.49014-36-28-36-84a80,80,0,0,1,160,0C208,144,208.97171,168.97171,161.93951,216.00391Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M91.42886,87.7719A39.8604,39.8604,0,0,0,88,104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M86.97786,35.304A80.01863,80.01863,0,0,1,208,104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M161.93948,216.0039A44.00107,44.00107,0,0,1,84,188c0-41.49014-36-28-36-84A79.63961,79.63961,0,0,1,63.34376,56.87833",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M163.07477,119.00866A23.8953,23.8953,0,0,0,168,104a40.02881,40.02881,0,0,0-52.976-37.8483",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M166.89165,170.78091A20.01341,20.01341,0,0,1,140,152a24.94024,24.94024,0,0,1,1.58781-9.05283",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M213.91943,210.61816a8.00024,8.00024,0,0,1-11.83886,10.76368L164.1604,179.66943A27.8785,27.8785,0,0,1,132,152a34.92369,34.92369,0,0,1,.68823-6.94971L95.9668,104.65674A7.99677,7.99677,0,0,1,80,104a47.77032,47.77032,0,0,1,2.22388-14.46045L64.5011,70.04443A71.47341,71.47341,0,0,0,56,104c0,26.69629,8.53418,34.9248,17.56982,43.63672C82.2085,155.9668,92,165.4082,92,188a36.001,36.001,0,0,0,63.77148,22.90918,8,8,0,1,1,12.33594,10.18945A52.00105,52.00105,0,0,1,76,188c0-15.793-5.67773-21.26758-13.53613-28.84473C52.45557,149.50488,40,137.49512,40,104a87.3043,87.3043,0,0,1,13.206-46.37988L42.08057,45.38184A8.00024,8.00024,0,1,1,53.91943,34.61816L69.2439,51.4751l.04455.04883L97.25708,82.28955l.02832.03125L172.736,165.31641l.01026.01123ZM91.08594,42.169A72.01834,72.01834,0,0,1,200,104a8,8,0,0,0,16,0A88.01954,88.01954,0,0,0,82.87012,28.43848,8.0004,8.0004,0,0,0,91.08594,42.169Zm67.186,83.23828a8.00079,8.00079,0,0,0,11.20069-1.59571A31.86061,31.86061,0,0,0,176,104a48.02849,48.02849,0,0,0-63.56982-45.416,7.99955,7.99955,0,1,0,5.1875,15.13477A32.03087,32.03087,0,0,1,160,104a15.97942,15.97942,0,0,1-3.32324,10.20605A8.00086,8.00086,0,0,0,158.272,125.40723Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M91.42886,87.7719A39.8604,39.8604,0,0,0,88,104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M86.97786,35.304A80.01863,80.01863,0,0,1,208,104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M161.93948,216.0039A44.00107,44.00107,0,0,1,84,188c0-41.49014-36-28-36-84A79.63961,79.63961,0,0,1,63.34376,56.87833",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M163.07477,119.00866A23.8953,23.8953,0,0,0,168,104a40.02881,40.02881,0,0,0-52.976-37.8483",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M166.89165,170.78091A20.01341,20.01341,0,0,1,140,152a24.94024,24.94024,0,0,1,1.58781-9.05283",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M91.42886,87.7719A39.8604,39.8604,0,0,0,88,104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M86.97786,35.304A80.01863,80.01863,0,0,1,208,104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M161.93948,216.0039A44.00107,44.00107,0,0,1,84,188c0-41.49014-36-28-36-84A79.63961,79.63961,0,0,1,63.34376,56.87833",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M163.07477,119.00866A23.8953,23.8953,0,0,0,168,104a40.02881,40.02881,0,0,0-52.976-37.8483",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M166.89165,170.78091A20.01341,20.01341,0,0,1,140,152a24.94024,24.94024,0,0,1,1.58781-9.05283",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M91.42886,87.7719A39.8604,39.8604,0,0,0,88,104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M86.97786,35.304A80.01863,80.01863,0,0,1,208,104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M161.93948,216.0039A44.00107,44.00107,0,0,1,84,188c0-41.49014-36-28-36-84A79.63961,79.63961,0,0,1,63.34376,56.87833",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M163.07477,119.00866A23.8953,23.8953,0,0,0,168,104a40.02881,40.02881,0,0,0-52.976-37.8483",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M166.89165,170.78091A20.01341,20.01341,0,0,1,140,152a24.94024,24.94024,0,0,1,1.58781-9.05283",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5u = [];
/* style */

const __vue_inject_styles__$5u = undefined;
/* scoped */

const __vue_scope_id__$5u = undefined;
/* module identifier */

const __vue_module_identifier__$5u = undefined;
/* functional template */

const __vue_is_functional_template__$5u = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5u = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5u,
  staticRenderFns: __vue_staticRenderFns__$5u
}, __vue_inject_styles__$5u, __vue_script__$5u, __vue_scope_id__$5u, __vue_is_functional_template__$5u, __vue_module_identifier__$5u, false, undefined, undefined, undefined);

var script$5v = Vue.extend({
  name: "PhEject",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5v = script$5v;
/* template */

var __vue_render__$5v = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M122.12157,38.3683,45.03989,118.45222A8,8,0,0,0,50.80376,132H205.19624a8,8,0,0,0,5.76387-13.54778L133.87843,38.3683A8,8,0,0,0,122.12157,38.3683Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "108",
      "y": "100",
      "width": "40",
      "height": "176",
      "rx": "8",
      "transform": "translate(-60 316) rotate(-90)",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M122.12157,38.3683,44.39345,122.57376A8,8,0,0,0,50.27188,136H205.72812a8,8,0,0,0,5.87843-13.42624L133.87843,38.3683A8,8,0,0,0,122.12157,38.3683Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "108",
      "y": "100",
      "width": "40",
      "height": "176",
      "rx": "8",
      "transform": "translate(-60 316) rotate(-90)",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M122.12157,38.3683,44.39345,122.57376A8,8,0,0,0,50.27188,136H205.72812a8,8,0,0,0,5.87843-13.42624L133.87843,38.3683A8,8,0,0,0,122.12157,38.3683Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "108",
      "y": "100",
      "width": "40",
      "height": "176",
      "rx": "8",
      "transform": "translate(-60 316) rotate(-90)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M35.61523,134.41724a15.79789,15.79789,0,0,1,2.90039-17.26978l77.72657-84.20532h.001a15.99956,15.99956,0,0,1,23.51368,0l77.72851,84.20532A16.0003,16.0003,0,0,1,205.72852,144H50.27148A15.79772,15.79772,0,0,1,35.61523,134.41724ZM208,160H48a16.01833,16.01833,0,0,0-16,16v24a16.01833,16.01833,0,0,0,16,16H208a16.01833,16.01833,0,0,0,16-16V176A16.01833,16.01833,0,0,0,208,160Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M122.12157,38.3683,44.39345,122.57376A8,8,0,0,0,50.27188,136H205.72812a8,8,0,0,0,5.87843-13.42624L133.87843,38.3683A8,8,0,0,0,122.12157,38.3683Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "108",
      "y": "100",
      "width": "40",
      "height": "176",
      "rx": "8",
      "transform": "translate(-60 316) rotate(-90)",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M122.12157,38.3683,44.39345,122.57376A8,8,0,0,0,50.27188,136H205.72812a8,8,0,0,0,5.87843-13.42624L133.87843,38.3683A8,8,0,0,0,122.12157,38.3683Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "108",
      "y": "100",
      "width": "40",
      "height": "176",
      "rx": "8",
      "transform": "translate(-60 316) rotate(-90)",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M122.12157,38.3683,44.39345,122.57376A8,8,0,0,0,50.27188,136H205.72812a8,8,0,0,0,5.87843-13.42624L133.87843,38.3683A8,8,0,0,0,122.12157,38.3683Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "108",
      "y": "100",
      "width": "40",
      "height": "176",
      "rx": "8",
      "transform": "translate(-60 316) rotate(-90)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5v = [];
/* style */

const __vue_inject_styles__$5v = undefined;
/* scoped */

const __vue_scope_id__$5v = undefined;
/* module identifier */

const __vue_module_identifier__$5v = undefined;
/* functional template */

const __vue_is_functional_template__$5v = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5v = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5v,
  staticRenderFns: __vue_staticRenderFns__$5v
}, __vue_inject_styles__$5v, __vue_script__$5v, __vue_scope_id__$5v, __vue_is_functional_template__$5v, __vue_module_identifier__$5v, false, undefined, undefined, undefined);

var script$5w = Vue.extend({
  name: "PhEjectSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5w = script$5w;
/* template */

var __vue_render__$5w = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M121.79109,39.64174,34.59885,146.95526A8,8,0,0,0,40.80776,160H215.19224a8,8,0,0,0,6.20891-13.04474L134.20891,39.64174A8,8,0,0,0,121.79109,39.64174Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "208",
      "x2": "32",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M121.79109,39.64174,34.59885,146.95526A8,8,0,0,0,40.80776,160H215.19224a8,8,0,0,0,6.20891-13.04474L134.20891,39.64174A8,8,0,0,0,121.79109,39.64174Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M121.79109,39.64174,34.59885,146.95526A8,8,0,0,0,40.80776,160H215.19224a8,8,0,0,0,6.20891-13.04474L134.20891,39.64174A8,8,0,0,0,121.79109,39.64174Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "208",
      "x2": "32",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M26.36035,158.87646a15.86839,15.86839,0,0,1,2.0293-16.96582L115.582,34.59668a15.99968,15.99968,0,0,1,24.83594.00049l87.19238,107.313A16.00008,16.00008,0,0,1,215.19238,168H40.80762A15.87032,15.87032,0,0,1,26.36035,158.87646ZM224,200H32a8,8,0,0,0,0,16H224a8,8,0,0,0,0-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M121.79109,39.64174,34.59885,146.95526A8,8,0,0,0,40.80776,160H215.19224a8,8,0,0,0,6.20891-13.04474L134.20891,39.64174A8,8,0,0,0,121.79109,39.64174Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "208",
      "x2": "32",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M121.79109,39.64174,34.59885,146.95526A8,8,0,0,0,40.80776,160H215.19224a8,8,0,0,0,6.20891-13.04474L134.20891,39.64174A8,8,0,0,0,121.79109,39.64174Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "208",
      "x2": "32",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M121.79109,39.64174,34.59885,146.95526A8,8,0,0,0,40.80776,160H215.19224a8,8,0,0,0,6.20891-13.04474L134.20891,39.64174A8,8,0,0,0,121.79109,39.64174Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "208",
      "x2": "32",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5w = [];
/* style */

const __vue_inject_styles__$5w = undefined;
/* scoped */

const __vue_scope_id__$5w = undefined;
/* module identifier */

const __vue_module_identifier__$5w = undefined;
/* functional template */

const __vue_is_functional_template__$5w = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5w = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5w,
  staticRenderFns: __vue_staticRenderFns__$5w
}, __vue_inject_styles__$5w, __vue_script__$5w, __vue_scope_id__$5w, __vue_is_functional_template__$5w, __vue_module_identifier__$5w, false, undefined, undefined, undefined);

var script$5x = Vue.extend({
  name: "PhEnvelope",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5x = script$5x;
/* template */

var __vue_render__$5x = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "224 56 128 144 32 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,56H224a0,0,0,0,1,0,0V192a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V56A0,0,0,0,1,32,56Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "110.54541",
      "y1": "128.00013",
      "x2": "34.4668",
      "y2": "197.73926",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "221.53418",
      "y1": "197.73926",
      "x2": "145.45424",
      "y2": "127.99964",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "224.006 56 128.006 144 32.006 56 224.006 56",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "224 56 128 144 32 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,56H224a0,0,0,0,1,0,0V192a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V56A0,0,0,0,1,32,56Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "110.54541",
      "y1": "128.00013",
      "x2": "34.4668",
      "y2": "197.73926",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "221.53418",
      "y1": "197.73926",
      "x2": "145.45424",
      "y2": "127.99964",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M231.99023,55.80933q-.00511-.22192-.02246-.44312-.01391-.18054-.03564-.35864c-.01709-.13819-.03858-.27564-.063-.41309-.022-.124-.0459-.24707-.07324-.36889-.02979-.13038-.064-.25953-.1001-.38843-.03467-.12329-.07031-.24536-.11035-.366-.042-.126-.08887-.25-.13721-.374-.0459-.11865-.09326-.23609-.14453-.35156-.05469-.12207-.11377-.24195-.17432-.36158-.05761-.11352-.11669-.22583-.17919-.33618-.06543-.114-.13428-.22607-.20508-.33765-.07178-.11254-.14551-.2229-.22266-.33154-.07226-.10229-.148-.20263-.22558-.30224-.0879-.11206-.17872-.221-.272-.32813-.04394-.05054-.082-.10425-.12744-.154-.03857-.042-.08105-.07764-.1206-.11865-.0962-.10108-.19629-.198-.29786-.29395-.09423-.08887-.189-.177-.28662-.26074-.09619-.082-.19531-.15967-.29541-.23731-.10937-.085-.21826-.16919-.33105-.24755-.09766-.06812-.19873-.13135-.29932-.19507-.11914-.0752-.23779-.15015-.35986-.21851-.10645-.05957-.21582-.11352-.32471-.16821-.1206-.0603-.24023-.1211-.36328-.175-.11963-.05274-.24219-.09863-.36475-.14551-.11767-.04492-.23486-.09057-.354-.12964-.12939-.04272-.26172-.07837-.39355-.1145-.11866-.03223-.23633-.0647-.35547-.09131-.13184-.02954-.26563-.05273-.39991-.07568-.12646-.02149-.25293-.04248-.38037-.05786-.12646-.01538-.2539-.02564-.38232-.03491-.13965-.01026-.2793-.01832-.41943-.02125C224.1123,48.00732,224.05713,48,224,48H32c-.05371,0-.10547.00708-.15918.00806-.14746.00293-.29492.01123-.44189.02221-.12159.00928-.24219.0188-.36182.03321-.13428.01611-.26758.03808-.40137.06128-.12744.022-.25488.0437-.37988.07177-.126.02808-.25.06226-.375.09644-.126.03467-.25195.0686-.37549.10913-.125.041-.248.08862-.37158.136-.1167.04492-.23389.08886-.34815.13891-.12744.05591-.252.1189-.377.18189-.105.05273-.21.10424-.312.16137-.125.07007-.24707.147-.36914.22437-.09766.062-.19629.12353-.291.1897-.11474.07959-.22558.165-.33642.25146-.09864.07642-.19629.15308-.291.23413-.09863.08423-.19385.17285-.28955.26294-.10107.09522-.20019.1919-.29639.29224-.03906.04126-.082.07715-.1206.11914-.04541.0498-.0835.10351-.12744.154-.09326.10718-.18408.21607-.272.32813-.07763.09961-.15332.2-.22558.30224-.07715.10864-.15088.219-.22266.33154-.0708.11158-.13965.22364-.20508.33765-.0625.11035-.12158.22266-.17919.33618-.06055.11963-.11963.23951-.17432.36158-.05127.11547-.09863.23291-.14453.35156-.04834.124-.09522.248-.13721.374-.04.12061-.07568.24268-.11035.366-.03613.1289-.07031.25805-.1001.38843-.02734.12182-.05127.24487-.07324.36889-.02441.13745-.0459.2749-.063.41309q-.022.17834-.03564.35864-.01758.22156-.02246.44312C24.0083,55.87329,24,55.93555,24,56V192a16.01833,16.01833,0,0,0,16,16H216a16.01833,16.01833,0,0,0,16-16V56C232,55.93555,231.9917,55.87329,231.99023,55.80933ZM40,74.18628l58.70605,53.814L40,181.814ZM52.56738,192l57.97852-53.14673,12.04785,11.04395a8.00113,8.00113,0,0,0,10.8125,0L145.45459,138.853,203.43311,192ZM157.294,128l58.70751-53.81519.00782,107.63672Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "224 56 128 144 32 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,56H224a0,0,0,0,1,0,0V192a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V56A0,0,0,0,1,32,56Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "110.54541",
      "y1": "128.00013",
      "x2": "34.4668",
      "y2": "197.73926",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "221.53418",
      "y1": "197.73926",
      "x2": "145.45424",
      "y2": "127.99964",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "224 56 128 144 32 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,56H224a0,0,0,0,1,0,0V192a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V56A0,0,0,0,1,32,56Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "110.54541",
      "y1": "128.00013",
      "x2": "34.4668",
      "y2": "197.73926",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "221.53418",
      "y1": "197.73926",
      "x2": "145.45424",
      "y2": "127.99964",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "224 56 128 144 32 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,56H224a0,0,0,0,1,0,0V192a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V56A0,0,0,0,1,32,56Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "110.54541",
      "y1": "128.00013",
      "x2": "34.4668",
      "y2": "197.73926",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "221.53418",
      "y1": "197.73926",
      "x2": "145.45424",
      "y2": "127.99964",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5x = [];
/* style */

const __vue_inject_styles__$5x = undefined;
/* scoped */

const __vue_scope_id__$5x = undefined;
/* module identifier */

const __vue_module_identifier__$5x = undefined;
/* functional template */

const __vue_is_functional_template__$5x = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5x = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5x,
  staticRenderFns: __vue_staticRenderFns__$5x
}, __vue_inject_styles__$5x, __vue_script__$5x, __vue_scope_id__$5x, __vue_is_functional_template__$5x, __vue_module_identifier__$5x, false, undefined, undefined, undefined);

var script$5y = Vue.extend({
  name: "PhEnvelopeOpen",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5y = script$5y;
/* template */

var __vue_render__$5y = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,96V200a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V96l96-64Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "110.54541",
      "y1": "152.00008",
      "x2": "34.4668",
      "y2": "205.73921",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "221.53418",
      "y1": "205.73921",
      "x2": "145.45424",
      "y2": "151.99959",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "224 96 145.455 152 110.545 152 32 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "224 96 145.455 152 110.545 152 32 96 128 32 224 96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,96V200a8,8,0,0,0,8,8H216a8,8,0,0,0,8-8V96L128,32Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "110.54541",
      "y1": "152.00008",
      "x2": "34.4668",
      "y2": "205.73921",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "221.53418",
      "y1": "205.73921",
      "x2": "145.45424",
      "y2": "151.99959",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "224 96 145.455 152 110.545 152 32 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M231.99512,95.92334a7.926,7.926,0,0,0-.22608-1.8147c-.0166-.06909-.03759-.13672-.05615-.20532q-.09154-.33618-.2124-.666c-.03028-.08129-.061-.16186-.09326-.24218-.0835-.20459-.17725-.40625-.27832-.606-.03955-.07764-.07618-.15625-.11768-.23267-.11914-.21679-.25146-.429-.39307-.63745-.03125-.04614-.05761-.09521-.08984-.14062l-.01465-.023a8.19273,8.19273,0,0,0-.55469-.6897c-.04345-.04834-.0913-.09228-.13574-.13965-.16845-.17944-.34228-.35083-.52344-.51172-.061-.05371-.124-.10473-.18652-.15673q-.27686-.23071-.56933-.43311c-.03711-.02563-.06934-.05591-.10645-.08081l-96-64a8.00131,8.00131,0,0,0-8.875,0l-96,64c-.03613.02393-.06689.05322-.102.07764q-.29736.20508-.57666.43847c-.061.05078-.12256.10035-.18164.15284-.18311.16235-.35889.3352-.52832.5166-.04346.0459-.08985.08886-.13233.13574a8.114,8.114,0,0,0-.55517.69043l-.01465.023c-.03223.04541-.05859.09448-.08984.14062-.14161.2085-.27393.42066-.39307.63745-.0415.07642-.07813.155-.11768.23267-.10107.19971-.19482.40137-.27832.606-.03222.08032-.063.16089-.09326.24218q-.12157.33-.2124.666c-.01856.0686-.03955.13623-.05615.20532a7.926,7.926,0,0,0-.22608,1.8147C24.00439,95.94922,24,95.97412,24,96V200a16.01833,16.01833,0,0,0,16,16H216a16.01833,16.01833,0,0,0,16-16V96C232,95.97412,231.99561,95.94922,231.99512,95.92334ZM40,111.52881l56.72266,40.44092L40,192.03662ZM113.08594,160h29.82812L199.543,200H56.45752Zm46.1914-8.03027L216,111.52881v80.50732Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,96V200a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V96l96-64Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "110.54541",
      "y1": "152.00008",
      "x2": "34.4668",
      "y2": "205.73921",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "221.53418",
      "y1": "205.73921",
      "x2": "145.45424",
      "y2": "151.99959",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "224 96 145.455 152 110.545 152 32 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,96V200a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V96l96-64Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "110.54541",
      "y1": "152.00008",
      "x2": "34.4668",
      "y2": "205.73921",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "221.53418",
      "y1": "205.73921",
      "x2": "145.45424",
      "y2": "151.99959",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "224 96 145.455 152 110.545 152 32 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,96V200a8,8,0,0,0,8,8H216a8,8,0,0,0,8-8V96L128,32Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "110.54541",
      "y1": "152.00008",
      "x2": "34.4668",
      "y2": "205.73921",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "221.53418",
      "y1": "205.73921",
      "x2": "145.45424",
      "y2": "151.99959",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "224 96 145.455 152 110.545 152 32 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5y = [];
/* style */

const __vue_inject_styles__$5y = undefined;
/* scoped */

const __vue_scope_id__$5y = undefined;
/* module identifier */

const __vue_module_identifier__$5y = undefined;
/* functional template */

const __vue_is_functional_template__$5y = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5y = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5y,
  staticRenderFns: __vue_staticRenderFns__$5y
}, __vue_inject_styles__$5y, __vue_script__$5y, __vue_scope_id__$5y, __vue_is_functional_template__$5y, __vue_module_identifier__$5y, false, undefined, undefined, undefined);

var script$5z = Vue.extend({
  name: "PhEnvelopeSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5z = script$5z;
/* template */

var __vue_render__$5z = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,56H224a0,0,0,0,1,0,0V192a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V56A0,0,0,0,1,32,56Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "224 56 128 144 32 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "224 56 128 144 32 56 224 56",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,56H224a0,0,0,0,1,0,0V192a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V56A0,0,0,0,1,32,56Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "224 56 128 144 32 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M231.99121,55.80933q-.00513-.22192-.02246-.44312-.01392-.18054-.03564-.35864c-.01709-.13819-.03858-.27564-.063-.41284-.022-.12427-.0459-.24756-.07325-.36963-.02978-.12989-.064-.25855-.0996-.38721-.03467-.12353-.07081-.24634-.11133-.36743-.04151-.12549-.08789-.24927-.13623-.3728-.04639-.1189-.09375-.23682-.14551-.35279-.0542-.12133-.11279-.24072-.17334-.35986-.05811-.11426-.11719-.2273-.18066-.33814-.06446-.11328-.13282-.2246-.20362-.33544-.07178-.11329-.146-.22461-.22363-.334-.07227-.10156-.147-.20117-.22461-.30029-.08838-.11255-.1792-.22193-.273-.32959-.04394-.05029-.08154-.10376-.12695-.15332-.03858-.042-.08106-.07764-.12012-.11841-.09668-.10107-.19678-.19849-.29834-.29443-.09424-.08887-.189-.17676-.28662-.26026-.09619-.08227-.19531-.15991-.29541-.23755-.10938-.085-.21826-.16919-.33106-.24755-.09765-.06812-.19873-.13135-.29931-.19507-.11914-.0752-.23779-.15015-.35938-.21851-.10693-.05981-.21679-.11377-.32666-.16894-.11963-.05982-.23877-.12012-.36084-.17383-.12109-.05347-.2456-.1001-.37011-.14771-.11475-.0437-.2295-.08838-.3462-.12671-.1333-.04394-.269-.08081-.40527-.11767-.11426-.031-.228-.0625-.34326-.08838-.13574-.03027-.27344-.0542-.41162-.07764-.12256-.02075-.24414-.041-.36719-.05615-.13135-.01611-.26318-.02661-.396-.03613-.13476-.00977-.26953-.01758-.40429-.02051-.05908-.00122-.1167-.00879-.17578-.00879h-192c-.05469,0-.10743.00708-.16211.0083-.14551.00293-.29.011-.43506.022-.12354.009-.2461.0188-.36768.03345-.13281.01611-.26465.03784-.39648.06055-.12891.02221-.25781.04443-.38477.07251-.124.02783-.24609.06152-.36914.09521-.12793.03491-.25586.06958-.38135.11084-.124.04053-.24511.08765-.36718.13428-.11768.04541-.23584.0896-.35108.14014-.127.05566-.25146.11865-.37646.18139-.105.05274-.21.10449-.312.16187-.12549.07007-.24756.147-.36963.22436-.09766.06177-.1958.123-.29053.18921-.11475.07984-.22607.16553-.33691.2522-.09864.07642-.19629.15283-.29053.23364-.09863.08423-.19385.17285-.28906.2627-.10157.09546-.20069.19238-.29737.293-.03906.041-.08154.07666-.12011.11865-.04541.04956-.083.103-.127.15332-.09375.10766-.18457.217-.27295.32959-.07763.09912-.15234.19873-.22461.30029-.07763.10938-.15185.2207-.22363.334-.0708.11084-.13916.22216-.20361.33544-.06348.11084-.12256.22388-.18067.33814-.06054.11914-.11914.23853-.17334.35986-.05175.116-.09912.23389-.1455.35279-.04834.12353-.09473.24731-.13623.3728-.04053.12109-.07666.2439-.11133.36743-.03565.12866-.06983.25732-.09961.38721-.02735.12207-.05127.24536-.07324.36963-.02442.1372-.0459.27465-.063.41284q-.022.17834-.03565.35864-.01758.22156-.02246.44312c-.00146.064-.00976.12622-.00976.19067V192a16.01833,16.01833,0,0,0,16,16h176a16.01833,16.01833,0,0,0,16-16V56C232.001,55.93555,231.99268,55.87329,231.99121,55.80933ZM216.001,192h-176V74.18652l82.59375,75.71094a8.0018,8.0018,0,0,0,10.8125,0l82.59521-75.7124.0083,117.81445Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,56H224a0,0,0,0,1,0,0V192a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V56A0,0,0,0,1,32,56Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "224 56 128 144 32 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,56H224a0,0,0,0,1,0,0V192a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V56A0,0,0,0,1,32,56Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "224 56 128 144 32 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,56H224a0,0,0,0,1,0,0V192a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V56A0,0,0,0,1,32,56Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "224 56 128 144 32 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5z = [];
/* style */

const __vue_inject_styles__$5z = undefined;
/* scoped */

const __vue_scope_id__$5z = undefined;
/* module identifier */

const __vue_module_identifier__$5z = undefined;
/* functional template */

const __vue_is_functional_template__$5z = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5z = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5z,
  staticRenderFns: __vue_staticRenderFns__$5z
}, __vue_inject_styles__$5z, __vue_script__$5z, __vue_scope_id__$5z, __vue_is_functional_template__$5z, __vue_module_identifier__$5z, false, undefined, undefined, undefined);

var script$5A = Vue.extend({
  name: "PhEnvelopeSimpleOpen",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5A = script$5A;
/* template */

var __vue_render__$5A = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,96V200a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V96l96-64Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "224 96 145.455 152 110.545 152 32 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "224 96 145.455 152 110.545 152 32 96 128 32 224 96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,96V200a8,8,0,0,0,8,8H216a8,8,0,0,0,8-8V96L128,32Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "224 96 145.455 152 110.545 152 32 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M231.99512,95.92334a7.928,7.928,0,0,0-.22608-1.81494c-.0166-.06885-.03759-.13672-.05615-.20508q-.09154-.33618-.2124-.666c-.03028-.08154-.061-.16162-.09326-.24218-.0835-.20459-.17725-.40625-.27832-.606-.03955-.07764-.07618-.15625-.11768-.23242-.11914-.21729-.25146-.4292-.39307-.6377-.03125-.04638-.05761-.09521-.08984-.14062l-.01465-.023a8.1872,8.1872,0,0,0-.55469-.68945c-.04345-.04883-.0913-.09278-.13574-.13965-.16845-.17969-.34228-.35108-.52344-.51172-.061-.0542-.124-.105-.18652-.15723q-.27686-.23-.56933-.4331c-.03711-.02539-.06934-.05567-.10645-.08057l-96-64a8.00131,8.00131,0,0,0-8.875,0l-96,64c-.03613.02393-.06689.05322-.102.07764q-.29736.20508-.57666.43847c-.061.05078-.12256.10059-.18164.15284-.18311.1621-.35889.335-.52832.5166-.04346.0459-.08985.08886-.13233.13574a8.114,8.114,0,0,0-.55517.69043l-.01465.023c-.03223.04541-.05859.09424-.08984.14062-.14161.2085-.27393.42041-.39307.6377-.0415.07617-.07813.15478-.11768.23242-.10107.19971-.19482.40137-.27832.606-.03222.08056-.063.16064-.09326.24218q-.12157.33033-.2124.666c-.01856.06836-.03955.13623-.05615.20508a7.928,7.928,0,0,0-.22608,1.81494C24.00439,95.94922,24,95.97412,24,96V200a16.01833,16.01833,0,0,0,16,16H216a16.01833,16.01833,0,0,0,16-16V96C232,95.97412,231.99561,95.94922,231.99512,95.92334ZM40,200V111.52881l65.90137,46.98486A8.00118,8.00118,0,0,0,110.5459,160h34.9082a8.00118,8.00118,0,0,0,4.64453-1.48633L216,111.52881V200Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,96V200a8,8,0,0,0,8,8H216a8,8,0,0,0,8-8V96L128,32Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "224 96 145.455 152 110.545 152 32 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,96V200a8,8,0,0,0,8,8H216a8,8,0,0,0,8-8V96L128,32Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "224 96 145.455 152 110.545 152 32 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,96V200a8,8,0,0,0,8,8H216a8,8,0,0,0,8-8V96L128,32Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "224 96 145.455 152 110.545 152 32 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5A = [];
/* style */

const __vue_inject_styles__$5A = undefined;
/* scoped */

const __vue_scope_id__$5A = undefined;
/* module identifier */

const __vue_module_identifier__$5A = undefined;
/* functional template */

const __vue_is_functional_template__$5A = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5A = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5A,
  staticRenderFns: __vue_staticRenderFns__$5A
}, __vue_inject_styles__$5A, __vue_script__$5A, __vue_scope_id__$5A, __vue_is_functional_template__$5A, __vue_module_identifier__$5A, false, undefined, undefined, undefined);

var script$5B = Vue.extend({
  name: "PhEquals",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5B = script$5B;
/* template */

var __vue_render__$5B = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "160",
      "x2": "216",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "96",
      "x2": "216",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "160",
      "x2": "216",
      "y2": "160",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "96",
      "x2": "216",
      "y2": "96",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M216,152H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,104H216a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "160",
      "x2": "216",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "96",
      "x2": "216",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "160",
      "x2": "216",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "96",
      "x2": "216",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "160",
      "x2": "216",
      "y2": "160",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "96",
      "x2": "216",
      "y2": "96",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5B = [];
/* style */

const __vue_inject_styles__$5B = undefined;
/* scoped */

const __vue_scope_id__$5B = undefined;
/* module identifier */

const __vue_module_identifier__$5B = undefined;
/* functional template */

const __vue_is_functional_template__$5B = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5B = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5B,
  staticRenderFns: __vue_staticRenderFns__$5B
}, __vue_inject_styles__$5B, __vue_script__$5B, __vue_scope_id__$5B, __vue_is_functional_template__$5B, __vue_module_identifier__$5B, false, undefined, undefined, undefined);

var script$5C = Vue.extend({
  name: "PhEraser",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5C = script$5C;
/* template */

var __vue_render__$5C = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "91.55018",
      "y1": "99.54921",
      "x2": "159.43243",
      "y2": "167.43146",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216.00049,215.83348H72.07L34.98164,178.74517a16,16,0,0,1,0-22.62742L148.11873,42.98066a16,16,0,0,1,22.62741,0L216.001,88.2355a16,16,0,0,1,0,22.62742L111.03042,215.83347",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M111.03042,215.83347H72.07L34.98164,178.74517a16,16,0,0,1,0-22.62742L91.55018,99.54921l67.88225,67.88225Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "91.55018",
      "y1": "99.54921",
      "x2": "159.43243",
      "y2": "167.43146",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216.00049,215.83348H72.07L34.98164,178.74517a16,16,0,0,1,0-22.62742L148.11873,42.98066a16,16,0,0,1,22.62741,0L216.001,88.2355a16,16,0,0,1,0,22.62742L111.03042,215.83347",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216.001,207.833H130.34375l34.72949-34.72949.0166-.01465.01465-.0166,56.55371-56.55274a24.02962,24.02962,0,0,0,0-33.94141L176.40332,37.32324a24.0007,24.0007,0,0,0-33.94141,0L85.90283,93.88232l-.01025.00928-.00928.01026L29.32422,150.46094a24.00066,24.00066,0,0,0,0,33.9414l37.08887,37.08789a8.00232,8.00232,0,0,0,5.65722,2.34278H216.001a8,8,0,0,0,0-16ZM153.77637,48.6377a7.99708,7.99708,0,0,1,11.3125,0l45.25488,45.25488a8.00888,8.00888,0,0,1,0,11.31347l-50.91113,50.91114L102.86475,99.54932Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "91.55018",
      "y1": "99.54921",
      "x2": "159.43243",
      "y2": "167.43146",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216.00049,215.83348H72.07L34.98164,178.74517a16,16,0,0,1,0-22.62742L148.11873,42.98066a16,16,0,0,1,22.62741,0L216.001,88.2355a16,16,0,0,1,0,22.62742L111.03042,215.83347",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "91.55018",
      "y1": "99.54921",
      "x2": "159.43243",
      "y2": "167.43146",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216.00049,215.83348H72.07L34.98164,178.74517a16,16,0,0,1,0-22.62742L148.11873,42.98066a16,16,0,0,1,22.62741,0L216.001,88.2355a16,16,0,0,1,0,22.62742L111.03042,215.83347",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "91.55018",
      "y1": "99.54921",
      "x2": "159.43243",
      "y2": "167.43146",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216.00049,215.83348H72.07L34.98164,178.74517a16,16,0,0,1,0-22.62742L148.11873,42.98066a16,16,0,0,1,22.62741,0L216.001,88.2355a16,16,0,0,1,0,22.62742L111.03042,215.83347",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5C = [];
/* style */

const __vue_inject_styles__$5C = undefined;
/* scoped */

const __vue_scope_id__$5C = undefined;
/* module identifier */

const __vue_module_identifier__$5C = undefined;
/* functional template */

const __vue_is_functional_template__$5C = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5C = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5C,
  staticRenderFns: __vue_staticRenderFns__$5C
}, __vue_inject_styles__$5C, __vue_script__$5C, __vue_scope_id__$5C, __vue_is_functional_template__$5C, __vue_module_identifier__$5C, false, undefined, undefined, undefined);

var script$5D = Vue.extend({
  name: "PhExport",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5D = script$5D;
/* template */

var __vue_render__$5D = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "86 57.989 128 16 170 57.989",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "16.02943",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,100h24a8,8,0,0,1,8,8V208a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V108a8,8,0,0,1,8-8H80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "48",
      "y": "96",
      "width": "160",
      "height": "120",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "86 57.989 128 16 170 57.989",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "16.02943",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,96h24a8,8,0,0,1,8,8V208a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V104a8,8,0,0,1,8-8H80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M136,88H120V35.3103L91.65625,63.64648A7.99983,7.99983,0,1,1,80.34375,52.332l42-41.98926a8.00063,8.00063,0,0,1,11.3125,0l42,41.98926a7.99983,7.99983,0,1,1-11.3125,11.31445L136,35.3103Zm64,0H136v40a8,8,0,0,1-16,0V88H56a16.01833,16.01833,0,0,0-16,16V208a16.01833,16.01833,0,0,0,16,16H200a16.01833,16.01833,0,0,0,16-16V104A16.01833,16.01833,0,0,0,200,88Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "86 57.989 128 16 170 57.989",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "16.02943",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,96h24a8,8,0,0,1,8,8V208a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V104a8,8,0,0,1,8-8H80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "86 57.989 128 16 170 57.989",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "16.02943",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,96h24a8,8,0,0,1,8,8V208a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V104a8,8,0,0,1,8-8H80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "86 57.989 128 16 170 57.989",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "16.02943",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,96h24a8,8,0,0,1,8,8V208a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V104a8,8,0,0,1,8-8H80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5D = [];
/* style */

const __vue_inject_styles__$5D = undefined;
/* scoped */

const __vue_scope_id__$5D = undefined;
/* module identifier */

const __vue_module_identifier__$5D = undefined;
/* functional template */

const __vue_is_functional_template__$5D = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5D = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5D,
  staticRenderFns: __vue_staticRenderFns__$5D
}, __vue_inject_styles__$5D, __vue_script__$5D, __vue_scope_id__$5D, __vue_is_functional_template__$5D, __vue_module_identifier__$5D, false, undefined, undefined, undefined);

var script$5E = Vue.extend({
  name: "PhEye",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5E = script$5E;
/* template */

var __vue_render__$5E = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,55.99219C48,55.99219,16,128,16,128s32,71.99219,112,71.99219S240,128,240,128,208,55.99219,128,55.99219Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M127.99414,55.99231c-80,0-112,72.00781-112,72.00781s32,71.99219,112,71.99219,112-71.99219,112-71.99219S207.99414,55.99231,127.99414,55.99231Zm0,112.0083a40,40,0,1,1,40-40A40.0001,40.0001,0,0,1,127.99414,168.00061Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M127.99414,55.99219c-80,0-112,72.00781-112,72.00781s32,71.99219,112,71.99219,112-71.99219,112-71.99219S207.99414,55.99219,127.99414,55.99219Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "127.99414",
      "cy": "128.00061",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M247.31055,124.75061c-.35157-.79-8.81934-19.57617-27.65332-38.41113C194.57324,61.25256,162.87793,47.99182,128,47.99182S61.42676,61.25256,36.34277,86.33948c-18.834,18.835-27.30175,37.62109-27.65332,38.41113a8.00282,8.00282,0,0,0,0,6.49805c.35157.791,8.82032,19.57226,27.6543,38.40429C61.42773,194.734,93.12207,207.99182,128,207.99182S194.57227,194.734,219.65625,169.653c18.834-18.832,27.30273-37.61328,27.6543-38.40429A8.00282,8.00282,0,0,0,247.31055,124.75061ZM128,92.00061a36,36,0,1,1-36,36A36.04061,36.04061,0,0,1,128,92.00061Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,55.99219C48,55.99219,16,128,16,128s32,71.99219,112,71.99219S240,128,240,128,208,55.99219,128,55.99219Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128.00061",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,55.99219C48,55.99219,16,128,16,128s32,71.99219,112,71.99219S240,128,240,128,208,55.99219,128,55.99219Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128.00061",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,55.99219C48,55.99219,16,128,16,128s32,71.99219,112,71.99219S240,128,240,128,208,55.99219,128,55.99219Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128.00061",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5E = [];
/* style */

const __vue_inject_styles__$5E = undefined;
/* scoped */

const __vue_scope_id__$5E = undefined;
/* module identifier */

const __vue_module_identifier__$5E = undefined;
/* functional template */

const __vue_is_functional_template__$5E = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5E = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5E,
  staticRenderFns: __vue_staticRenderFns__$5E
}, __vue_inject_styles__$5E, __vue_script__$5E, __vue_scope_id__$5E, __vue_is_functional_template__$5E, __vue_module_identifier__$5E, false, undefined, undefined, undefined);

var script$5F = Vue.extend({
  name: "PhEyeClosed",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5F = script$5F;
/* template */

var __vue_render__$5F = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "201.14971",
      "y1": "127.30467",
      "x2": "223.95961",
      "y2": "166.81257",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "154.18201",
      "y1": "149.26298",
      "x2": "161.29573",
      "y2": "189.60689",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "101.72972",
      "y1": "149.24366",
      "x2": "94.61483",
      "y2": "189.59423",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "54.80859",
      "y1": "127.27241",
      "x2": "31.88882",
      "y2": "166.97062",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M31.99943,104.87509C48.81193,125.68556,79.63353,152,128,152c48.36629,0,79.18784-26.31424,96.00039-47.12468",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "201.14971",
      "y1": "127.30467",
      "x2": "223.95961",
      "y2": "166.81257",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "154.18201",
      "y1": "149.26298",
      "x2": "161.29573",
      "y2": "189.60689",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "101.72972",
      "y1": "149.24366",
      "x2": "94.61483",
      "y2": "189.59423",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "54.80859",
      "y1": "127.27241",
      "x2": "31.88882",
      "y2": "166.97062",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M31.99943,104.87509C48.81193,125.68556,79.63353,152,128,152c48.36629,0,79.18784-26.31424,96.00039-47.12468",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M211.50122,129.23535a147.78919,147.78919,0,0,0,18.72144-19.333,7.99973,7.99973,0,0,0-12.44532-10.05468,128.72532,128.72532,0,0,1-21.28466,20.9541c-.05372.03808-.103.08008-.15528.11963A109.58952,109.58952,0,0,1,128,144a109.59068,109.59068,0,0,1-68.35156-23.08887c-.061-.04638-.11841-.0957-.18115-.14062A128.70627,128.70627,0,0,1,38.22168,99.84766a7.99972,7.99972,0,1,0-12.44531,10.05468,147.761,147.761,0,0,0,18.68188,19.29834l-19.49731,33.77a7.99959,7.99959,0,1,0,13.85547,8l18.49-32.02539a123.57956,123.57956,0,0,0,35.24438,16.28174l-5.81445,32.978a8.00124,8.00124,0,0,0,6.49023,9.26758,8.12,8.12,0,0,0,1.39844.12207,8.00272,8.00272,0,0,0,7.86914-6.61231l5.71729-32.42724a136.26072,136.26072,0,0,0,39.4873.01367l5.71826,32.42724a8.00278,8.00278,0,0,0,7.86914,6.61133,8.13106,8.13106,0,0,0,1.39942-.12207,8.00173,8.00173,0,0,0,6.48925-9.26855l-5.813-32.96436a123.56028,123.56028,0,0,0,35.28808-16.27832l18.38233,31.83838a7.99959,7.99959,0,0,0,13.85547-8Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "201.14971",
      "y1": "127.30467",
      "x2": "223.95961",
      "y2": "166.81257",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "154.18201",
      "y1": "149.26298",
      "x2": "161.29573",
      "y2": "189.60689",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "101.72972",
      "y1": "149.24366",
      "x2": "94.61483",
      "y2": "189.59423",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "54.80859",
      "y1": "127.27241",
      "x2": "31.88882",
      "y2": "166.97062",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M31.99943,104.87509C48.81193,125.68556,79.63353,152,128,152c48.36629,0,79.18784-26.31424,96.00039-47.12468",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "201.14971",
      "y1": "127.30467",
      "x2": "223.95961",
      "y2": "166.81257",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "154.18201",
      "y1": "149.26298",
      "x2": "161.29573",
      "y2": "189.60689",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "101.72972",
      "y1": "149.24366",
      "x2": "94.61483",
      "y2": "189.59423",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "54.80859",
      "y1": "127.27241",
      "x2": "31.88882",
      "y2": "166.97062",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M31.99943,104.87509C48.81193,125.68556,79.63353,152,128,152c48.36629,0,79.18784-26.31424,96.00039-47.12468",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "201.14971",
      "y1": "127.30467",
      "x2": "223.95961",
      "y2": "166.81257",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "154.18201",
      "y1": "149.26298",
      "x2": "161.29573",
      "y2": "189.60689",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "101.72972",
      "y1": "149.24366",
      "x2": "94.61483",
      "y2": "189.59423",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "54.80859",
      "y1": "127.27241",
      "x2": "31.88882",
      "y2": "166.97062",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M31.99943,104.87509C48.81193,125.68556,79.63353,152,128,152c48.36629,0,79.18784-26.31424,96.00039-47.12468",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5F = [];
/* style */

const __vue_inject_styles__$5F = undefined;
/* scoped */

const __vue_scope_id__$5F = undefined;
/* module identifier */

const __vue_module_identifier__$5F = undefined;
/* functional template */

const __vue_is_functional_template__$5F = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5F = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5F,
  staticRenderFns: __vue_staticRenderFns__$5F
}, __vue_inject_styles__$5F, __vue_script__$5F, __vue_scope_id__$5F, __vue_is_functional_template__$5F, __vue_module_identifier__$5F, false, undefined, undefined, undefined);

var script$5G = Vue.extend({
  name: "PhEyeSlash",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5G = script$5G;
/* template */

var __vue_render__$5G = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M73.99446,68.59357C33.22519,89.23912,16,128,16,128s32,71.99219,112,71.99219a118.0238,118.0238,0,0,0,53.99756-12.59461",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M214.40925,163.58516C232.12131,145.72513,240,128,240,128S208,55.99219,128,55.99219q-5.64912,0-10.9808.46371",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,56C48,56,16,128.00781,16,128.00781S48,200,128,200s112-71.99219,112-71.99219S208,56,128,56Zm0,112.0083a40,40,0,1,1,40-40A40.0001,40.0001,0,0,1,128,168.0083Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154.9071,157.59781a40.00028,40.00028,0,0,1-53.8142-59.19562",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M73.99446,68.59357C33.22519,89.23912,16,128,16,128s32,71.99219,112,71.99219a118.0238,118.0238,0,0,0,53.99756-12.59461",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208.60953,169.09937C230.41132,149.5722,240,128,240,128S208,55.99219,128,55.99219a125.31923,125.31923,0,0,0-20.68221,1.68414",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M135.52737,88.70779a40.02413,40.02413,0,0,1,32.29785,35.52875",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M247.31055,124.75842c-.35157-.79-8.81934-19.57519-27.65332-38.41113C194.57324,61.26038,162.87793,47.99963,128,47.99963a133.97063,133.97063,0,0,0-21.99512,1.793,8.00028,8.00028,0,0,0-4.60254,13.27246L202.69336,174.485a8.00126,8.00126,0,0,0,11.25781.57715c22.8125-20.43359,32.93946-42.86035,33.35938-43.80566A8.00282,8.00282,0,0,0,247.31055,124.75842Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M53.91992,34.6178A8.0006,8.0006,0,1,0,42.08008,45.38147l19.24121,21.165c-36.321,22.291-51.93628,56.648-52.63184,58.21191a8.00282,8.00282,0,0,0,0,6.49805c.35157.791,8.82032,19.57226,27.6543,38.4043,25.084,25.081,56.77832,38.33886,91.65625,38.33886a126.97091,126.97091,0,0,0,52.06567-10.834l22.01441,24.21582a8.0006,8.0006,0,0,0,11.83984-10.76367ZM128,164.00012a35.98594,35.98594,0,0,1-29.52319-56.582l47.20459,51.9248A35.78086,35.78086,0,0,1,128,164.00012Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154.9071,157.59781a40.00028,40.00028,0,0,1-53.8142-59.19562",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M73.99446,68.59357C33.22519,89.23912,16,128,16,128s32,71.99219,112,71.99219a118.0238,118.0238,0,0,0,53.99756-12.59461",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208.60953,169.09937C230.41132,149.5722,240,128,240,128S208,55.99219,128,55.99219a125.31923,125.31923,0,0,0-20.68221,1.68414",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M135.52737,88.70779a40.02413,40.02413,0,0,1,32.29785,35.52875",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154.9071,157.59781a40.00028,40.00028,0,0,1-53.8142-59.19562",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M73.99446,68.59357C33.22519,89.23912,16,128,16,128s32,71.99219,112,71.99219a118.0238,118.0238,0,0,0,53.99756-12.59461",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208.60953,169.09937C230.41132,149.5722,240,128,240,128S208,55.99219,128,55.99219a125.31923,125.31923,0,0,0-20.68221,1.68414",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M135.52737,88.70779a40.02413,40.02413,0,0,1,32.29785,35.52875",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "40.00122",
      "x2": "208",
      "y2": "216.00122",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154.9071,157.599a40.00028,40.00028,0,0,1-53.8142-59.19562",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M73.99446,68.59479C33.22519,89.24034,16,128.00122,16,128.00122s32,71.99219,112,71.99219a118.0238,118.0238,0,0,0,53.99756-12.59461",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208.60953,169.10059C230.41132,149.57342,240,128.00122,240,128.00122S208,55.99341,128,55.99341a125.31923,125.31923,0,0,0-20.68221,1.68414",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M135.52737,88.709a40.02411,40.02411,0,0,1,32.29785,35.52874",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5G = [];
/* style */

const __vue_inject_styles__$5G = undefined;
/* scoped */

const __vue_scope_id__$5G = undefined;
/* module identifier */

const __vue_module_identifier__$5G = undefined;
/* functional template */

const __vue_is_functional_template__$5G = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5G = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5G,
  staticRenderFns: __vue_staticRenderFns__$5G
}, __vue_inject_styles__$5G, __vue_script__$5G, __vue_scope_id__$5G, __vue_is_functional_template__$5G, __vue_module_identifier__$5G, false, undefined, undefined, undefined);

var script$5H = Vue.extend({
  name: "PhEyedropper",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5H = script$5H;
/* template */

var __vue_render__$5H = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M158.62742,142.62742l-56,56a31.98729,31.98729,0,0,1-30.91154,8.28721L48.31361,217.131A8,8,0,0,1,39.456,215.456h0a5.74381,5.74381,0,0,1-1.20256-6.35955l10.832-24.81212a31.9873,31.9873,0,0,1,8.28715-30.91177l56-56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M187.799,107.799l4.88728,4.88728a16,16,0,0,1,0,22.62742l-15.02944,15.02944a8,8,0,0,1-11.3137,0l-60.6863-60.6863a8,8,0,0,1,0-11.3137l15.02944-15.02944a16,16,0,0,1,22.62742,0l4.8873,4.8873,19.58813-19.58813c10.78822-10.78822,28.36591-11.4491,39.44579-.96065A28.00039,28.00039,0,0,1,207.799,87.799Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M179.799,115.799l4.88728,4.88728a16,16,0,0,1,0,22.62742l-7.02944,7.02944a8,8,0,0,1-11.3137,0l-60.6863-60.6863a8,8,0,0,1,0-11.3137l7.02944-7.02944a16,16,0,0,1,22.62742,0l4.8873,4.8873,27.58813-27.58813c10.78822-10.78822,28.36591-11.4491,39.44579-.96065A28.00039,28.00039,0,0,1,207.799,87.799Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M179.799,115.799l4.88728,4.88728a16,16,0,0,1,0,22.62742l-7.02944,7.02944a8,8,0,0,1-11.3137,0l-60.6863-60.6863a8,8,0,0,1,0-11.3137l7.02944-7.02944a16,16,0,0,1,22.62742,0l4.8873,4.8873,27.58813-27.58813c10.78822-10.78822,28.36591-11.4491,39.44579-.96065A28.00039,28.00039,0,0,1,207.799,87.799Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M158.62742,142.62742l-56,56a31.98729,31.98729,0,0,1-30.91154,8.28721L48.31361,217.131A8,8,0,0,1,39.456,215.456h0a5.74381,5.74381,0,0,1-1.20256-6.35955l10.832-24.81212a31.9873,31.9873,0,0,1,8.28715-30.91177l56-56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M223.99658,67.50391a35.73557,35.73557,0,0,0-11.26172-25.66114c-14.01806-13.2705-36.71875-12.771-50.60254,1.11328L140.18408,64.90479a24.02939,24.02939,0,0,0-33.15429.75195L100,72.68652a16.01779,16.01779,0,0,0,0,22.627l2.05908,2.05908L51.71533,147.71582a40.15638,40.15638,0,0,0-11.01074,35.771l-9.78271,22.40869a13.66329,13.66329,0,0,0,2.87744,15.21728,15.915,15.915,0,0,0,11.27929,4.70313,16.077,16.077,0,0,0,6.43555-1.353l20.999-9.16748a40.15391,40.15391,0,0,0,35.771-11.01123l50.34326-50.34326L160.68652,156a16.01779,16.01779,0,0,0,22.627,0l7.02978-7.02979a24.02843,24.02843,0,0,0,.752-33.15429l22.36036-22.36035A35.71726,35.71726,0,0,0,223.99658,67.50391ZM96.9707,192.9707a24.09567,24.09567,0,0,1-23.1914,6.21436,8.0052,8.0052,0,0,0-5.26416.39746L47.044,208.95605l9.37353-21.47119a8.00234,8.00234,0,0,0,.39746-5.26416,24.0986,24.0986,0,0,1,6.21436-23.1914L113.37256,108.686l33.9414,33.9414Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M179.799,115.799l4.88728,4.88728a16,16,0,0,1,0,22.62742l-7.02944,7.02944a8,8,0,0,1-11.3137,0l-60.6863-60.6863a8,8,0,0,1,0-11.3137l7.02944-7.02944a16,16,0,0,1,22.62742,0l4.8873,4.8873,27.58813-27.58813c10.78822-10.78822,28.36591-11.4491,39.44579-.96065A28.00039,28.00039,0,0,1,207.799,87.799Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M158.62742,142.62742l-56,56a31.98729,31.98729,0,0,1-30.91154,8.28721L48.31361,217.131A8,8,0,0,1,39.456,215.456h0a5.74381,5.74381,0,0,1-1.20256-6.35955l10.832-24.81212a31.9873,31.9873,0,0,1,8.28715-30.91177l56-56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M179.799,115.799l4.88728,4.88728a16,16,0,0,1,0,22.62742l-7.02944,7.02944a8,8,0,0,1-11.3137,0l-60.6863-60.6863a8,8,0,0,1,0-11.3137l7.02944-7.02944a16,16,0,0,1,22.62742,0l4.8873,4.8873,27.58813-27.58813c10.78822-10.78822,28.36591-11.4491,39.44579-.96065A28.00039,28.00039,0,0,1,207.799,87.799Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M158.62742,142.62742l-56,56a31.98729,31.98729,0,0,1-30.91154,8.28721L48.31361,217.131A8,8,0,0,1,39.456,215.456h0a5.74381,5.74381,0,0,1-1.20256-6.35955l10.832-24.81212a31.9873,31.9873,0,0,1,8.28715-30.91177l56-56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M179.799,115.799l4.88728,4.88728a16,16,0,0,1,0,22.62742l-7.02944,7.02944a8,8,0,0,1-11.3137,0l-60.6863-60.6863a8,8,0,0,1,0-11.3137l7.02944-7.02944a16,16,0,0,1,22.62742,0l4.8873,4.8873,27.58813-27.58813c10.78822-10.78822,28.36591-11.4491,39.44579-.96065A28.00039,28.00039,0,0,1,207.799,87.799Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M158.62742,142.62742l-56,56a31.98729,31.98729,0,0,1-30.91154,8.28721L48.31361,217.131A8,8,0,0,1,39.456,215.456h0a5.74381,5.74381,0,0,1-1.20256-6.35955l10.832-24.81212a31.9873,31.9873,0,0,1,8.28715-30.91177l56-56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5H = [];
/* style */

const __vue_inject_styles__$5H = undefined;
/* scoped */

const __vue_scope_id__$5H = undefined;
/* module identifier */

const __vue_module_identifier__$5H = undefined;
/* functional template */

const __vue_is_functional_template__$5H = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5H = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5H,
  staticRenderFns: __vue_staticRenderFns__$5H
}, __vue_inject_styles__$5H, __vue_script__$5H, __vue_scope_id__$5H, __vue_is_functional_template__$5H, __vue_module_identifier__$5H, false, undefined, undefined, undefined);

var script$5I = Vue.extend({
  name: "PhFaceMask",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5I = script$5I;
/* template */

var __vue_render__$5I = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,136c0,50.95006-66.22217,68.789-78.16566,71.59207a8.00537,8.00537,0,0,1-3.66868,0C114.22217,204.789,48,186.95006,48,136V77.41626a8,8,0,0,1,5.02887-7.42781l72-28.8a8,8,0,0,1,5.94226,0l72,28.8A8,8,0,0,1,208,77.41626Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "108",
      "x2": "168",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "144",
      "x2": "168",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M205.40982,152H220a24,24,0,0,0,24-24V104a24,24,0,0,0-24-24H208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M50.59121,152H36a24,24,0,0,1-24-24V104A24,24,0,0,1,36,80H48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,136c0,51.50493-74.43964,69.17367-86.39,71.67832a7.80809,7.80809,0,0,1-3.21992,0C114.43964,205.17367,40,187.50493,40,136V77.60342a8,8,0,0,1,5.26606-7.51835l80-29.09091a8,8,0,0,1,5.46788,0l80,29.09091A8,8,0,0,1,216,77.60342Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,136c0,51.50493-74.43964,69.17367-86.39,71.67832a7.80809,7.80809,0,0,1-3.21992,0C114.43964,205.17367,40,187.50493,40,136V77.60342a8,8,0,0,1,5.26606-7.51835l80-29.09091a8,8,0,0,1,5.46788,0l80,29.09091A8,8,0,0,1,216,77.60342Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "112",
      "x2": "168",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "144",
      "x2": "168",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M213.40982,152H224a24,24,0,0,0,24-24V104a24,24,0,0,0-24-24h-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M42.59121,152H32A24,24,0,0,1,8,128V104A24,24,0,0,1,32,80h8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,72h-1.03125a16.03948,16.03948,0,0,0-9.501-9.43311l-80-29.0913a16.02485,16.02485,0,0,0-10.93554,0l-80,29.09082A16.04022,16.04022,0,0,0,33.03125,72H32A32.03635,32.03635,0,0,0,0,104v24a32.03635,32.03635,0,0,0,32,32h5.19678c6.561,14.38086,19.25537,26.99854,37.63183,37.20752,21.02246,11.67871,43.52491,16.96045,49.91944,18.30029a15.72388,15.72388,0,0,0,6.50293,0c6.3955-1.33984,28.898-6.62158,49.92041-18.30029,18.37646-10.209,31.0708-22.82666,37.63183-37.20752H224a32.03635,32.03635,0,0,0,32-32V104A32.03635,32.03635,0,0,0,224,72ZM32,144a16.01833,16.01833,0,0,1-16-16V104A16.01833,16.01833,0,0,1,32,88v48a58.66962,58.66962,0,0,0,.55273,8Zm136,8H88a8,8,0,0,1,0-16h80a8,8,0,0,1,0,16Zm0-32H88a8,8,0,0,1,0-16h80a8,8,0,0,1,0,16Zm72,8a16.01833,16.01833,0,0,1-16,16h-.55273A58.66962,58.66962,0,0,0,224,136V88a16.01833,16.01833,0,0,1,16,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,136c0,51.50493-74.43964,69.17367-86.39,71.67832a7.80809,7.80809,0,0,1-3.21992,0C114.43964,205.17367,40,187.50493,40,136V77.60342a8,8,0,0,1,5.26606-7.51835l80-29.09091a8,8,0,0,1,5.46788,0l80,29.09091A8,8,0,0,1,216,77.60342Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "112",
      "x2": "168",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "144",
      "x2": "168",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M213.40982,152H224a24,24,0,0,0,24-24V104a24,24,0,0,0-24-24h-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M42.59121,152H32A24,24,0,0,1,8,128V104A24,24,0,0,1,32,80h8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,136c0,51.50493-74.43964,69.17367-86.39,71.67832a7.80809,7.80809,0,0,1-3.21992,0C114.43964,205.17367,40,187.50493,40,136V77.60342a8,8,0,0,1,5.26606-7.51835l80-29.09091a8,8,0,0,1,5.46788,0l80,29.09091A8,8,0,0,1,216,77.60342Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "112",
      "x2": "168",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "144",
      "x2": "168",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M213.40982,152H224a24,24,0,0,0,24-24V104a24,24,0,0,0-24-24h-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M42.59121,152H32A24,24,0,0,1,8,128V104A24,24,0,0,1,32,80h8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,136c0,51.50493-74.43964,69.17367-86.39,71.67832a7.80809,7.80809,0,0,1-3.21992,0C114.43964,205.17367,40,187.50493,40,136V77.60342a8,8,0,0,1,5.26606-7.51835l80-29.09091a8,8,0,0,1,5.46788,0l80,29.09091A8,8,0,0,1,216,77.60342Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "112",
      "x2": "168",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "144",
      "x2": "168",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M213.40982,152H224a24,24,0,0,0,24-24V104a24,24,0,0,0-24-24h-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M42.59121,152H32A24,24,0,0,1,8,128V104A24,24,0,0,1,32,80h8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5I = [];
/* style */

const __vue_inject_styles__$5I = undefined;
/* scoped */

const __vue_scope_id__$5I = undefined;
/* module identifier */

const __vue_module_identifier__$5I = undefined;
/* functional template */

const __vue_is_functional_template__$5I = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5I = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5I,
  staticRenderFns: __vue_staticRenderFns__$5I
}, __vue_inject_styles__$5I, __vue_script__$5I, __vue_scope_id__$5I, __vue_is_functional_template__$5I, __vue_module_identifier__$5I, false, undefined, undefined, undefined);

var script$5J = Vue.extend({
  name: "PhFacebookLogo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5J = script$5J;
/* template */

var __vue_render__$5J = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,88.00094H152a24,24,0,0,0-24,24v112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "144.00094",
      "x2": "160",
      "y2": "144.00094",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,88.00094H152a24,24,0,0,0-24,24v112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "144.00094",
      "x2": "160",
      "y2": "144.00094",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24a104.0018,104.0018,0,0,0-8,207.69531V152.00094H96a8,8,0,0,1,0-16h24v-24a32.03667,32.03667,0,0,1,32-32h16a8,8,0,0,1,0,16H152a16.01833,16.01833,0,0,0-16,16v24h24a8,8,0,0,1,0,16H136v79.69434A104.0018,104.0018,0,0,0,128,24Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,88.00094H152a24,24,0,0,0-24,24v112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "144.00094",
      "x2": "160",
      "y2": "144.00094",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,88.00094H152a24,24,0,0,0-24,24v112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "144.00094",
      "x2": "160",
      "y2": "144.00094",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,88.00094H152a24,24,0,0,0-24,24v112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "144.00094",
      "x2": "160",
      "y2": "144.00094",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5J = [];
/* style */

const __vue_inject_styles__$5J = undefined;
/* scoped */

const __vue_scope_id__$5J = undefined;
/* module identifier */

const __vue_module_identifier__$5J = undefined;
/* functional template */

const __vue_is_functional_template__$5J = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5J = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5J,
  staticRenderFns: __vue_staticRenderFns__$5J
}, __vue_inject_styles__$5J, __vue_script__$5J, __vue_scope_id__$5J, __vue_is_functional_template__$5J, __vue_module_identifier__$5J, false, undefined, undefined, undefined);

var script$5K = Vue.extend({
  name: "PhFactory",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5K = script$5K;
/* template */

var __vue_render__$5K = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "80",
      "y1": "176",
      "x2": "108",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "148",
      "y1": "176",
      "x2": "176",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "216 216 216 136 168 136 104 88 104 136 40 88 40 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "215.98316",
      "x2": "240",
      "y2": "215.98316",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,136,200.98123,30.86863A8,8,0,0,0,193.06164,24H174.93836a8,8,0,0,0-7.91959,6.86863l-13.47038,94.29266",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "216 216 216 136 168 136 104 88 104 136 40 88 40 216 216 216",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "176",
      "x2": "108",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "148",
      "y1": "176",
      "x2": "176",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "216 216 216 136 168 136 104 88 104 136 40 88 40 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "215.98316",
      "x2": "240",
      "y2": "215.98316",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,136,200.98123,30.86863A8,8,0,0,0,193.06164,24H174.93836a8,8,0,0,0-7.91959,6.86863l-13.47038,94.29266",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M240,207.9834H224V136c0-.04785-.00635-.09375-.00708-.14111-.00269-.14307-.01147-.28662-.02173-.43116-.00976-.13769-.021-.2749-.0376-.41064-.00634-.0498-.00659-.09863-.01367-.14844L208.90137,29.73633A16.08054,16.08054,0,0,0,193.06152,16h-18.123a16.08053,16.08053,0,0,0-15.83985,13.7373l-11.55908,80.91749L108.7998,81.6001A7.99978,7.99978,0,0,0,96,88v32L44.7998,81.6001A7.99978,7.99978,0,0,0,32,88V207.9834H16a8,8,0,0,0,0,16H39.6665c.11158.00439.221.0166.3335.0166s.22192-.01221.3335-.0166h175.333c.11158.00439.22095.0166.3335.0166s.22192-.01221.3335-.0166H240a8,8,0,0,0,0-16ZM100,184H72a8,8,0,0,1,0-16h28a8,8,0,0,1,0,16Zm84,0H156a8,8,0,0,1,0-16h28a8,8,0,0,1,0,16Zm-13.333-56-8.52832-6.39648L174.93848,32h18.123l13.71411,96Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "80",
      "y1": "176",
      "x2": "108",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "148",
      "y1": "176",
      "x2": "176",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "216 216 216 136 168 136 104 88 104 136 40 88 40 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "215.98316",
      "x2": "240",
      "y2": "215.98316",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,136,200.98123,30.86863A8,8,0,0,0,193.06164,24H174.93836a8,8,0,0,0-7.91959,6.86863l-13.47038,94.29266",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "80",
      "y1": "176",
      "x2": "108",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "148",
      "y1": "176",
      "x2": "176",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "216 216 216 136 168 136 104 88 104 136 40 88 40 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "215.98316",
      "x2": "240",
      "y2": "215.98316",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,136,200.98123,30.86863A8,8,0,0,0,193.06164,24H174.93836a8,8,0,0,0-7.91959,6.86863l-13.47038,94.29266",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "80",
      "y1": "176",
      "x2": "108",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "148",
      "y1": "176",
      "x2": "176",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "216 216 216 136 168 136 104 88 104 136 40 88 40 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "215.98316",
      "x2": "240",
      "y2": "215.98316",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,136,200.98123,30.86863A8,8,0,0,0,193.06164,24H174.93836a8,8,0,0,0-7.91959,6.86863l-13.47038,94.29266",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5K = [];
/* style */

const __vue_inject_styles__$5K = undefined;
/* scoped */

const __vue_scope_id__$5K = undefined;
/* module identifier */

const __vue_module_identifier__$5K = undefined;
/* functional template */

const __vue_is_functional_template__$5K = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5K = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5K,
  staticRenderFns: __vue_staticRenderFns__$5K
}, __vue_inject_styles__$5K, __vue_script__$5K, __vue_scope_id__$5K, __vue_is_functional_template__$5K, __vue_module_identifier__$5K, false, undefined, undefined, undefined);

var script$5L = Vue.extend({
  name: "PhFaders",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5L = script$5L;
/* template */

var __vue_render__$5L = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128.00098",
      "y1": "124",
      "x2": "128.0011",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128.0011",
      "y1": "40",
      "x2": "128.00098",
      "y2": "84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200.00098",
      "y1": "204",
      "x2": "200.00181",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200.00181",
      "y1": "40",
      "x2": "200.00098",
      "y2": "164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224.00098",
      "y1": "164",
      "x2": "176.00098",
      "y2": "164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56.00098",
      "y1": "172",
      "x2": "56.00039",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56.00039",
      "y1": "40",
      "x2": "56.00098",
      "y2": "132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32.00098",
      "y1": "132",
      "x2": "80.00098",
      "y2": "132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152.00098",
      "y1": "84",
      "x2": "104.00098",
      "y2": "84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128.00098",
      "y1": "120",
      "x2": "128.0011",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128.0011",
      "y1": "40",
      "x2": "128.00098",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200.00098",
      "y1": "200",
      "x2": "200.00181",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200.00181",
      "y1": "40",
      "x2": "200.00098",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224.00098",
      "y1": "168",
      "x2": "176.00098",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56.00098",
      "y1": "168",
      "x2": "56.00039",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56.00039",
      "y1": "40",
      "x2": "56.00098",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32.00098",
      "y1": "136",
      "x2": "80.00098",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152.00098",
      "y1": "88",
      "x2": "104.00098",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M128.001,111.99988a8.00008,8.00008,0,0,0-8,8v96a8,8,0,0,0,16,0v-96A8.00008,8.00008,0,0,0,128.001,111.99988Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200.001,191.99988a7.99987,7.99987,0,0,0-8,8.00049l.001,16a8,8,0,0,0,16-.001l-.001-16A8,8,0,0,0,200.001,191.99988Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224.001,159.99988h-16l.001-120a8,8,0,1,0-16,0l-.001,120h-16a8,8,0,0,0,0,16h48a8,8,0,0,0,0-16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56.001,159.99988a8.00039,8.00039,0,0,0-8,8l-.00049,48a8,8,0,0,0,16,0l.00049-48A8.00009,8.00009,0,0,0,56.001,159.99988Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80.001,127.99988h-16l-.00049-88a8,8,0,0,0-16,0l.00049,88h-16a8,8,0,0,0,0,16h48a8,8,0,1,0,0-16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152.001,79.99988h-16v-40a8,8,0,1,0-16,0v40h-16a8,8,0,0,0,0,16h48a8,8,0,0,0,0-16Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128.00098",
      "y1": "120",
      "x2": "128.0011",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128.0011",
      "y1": "40",
      "x2": "128.00098",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200.00098",
      "y1": "200",
      "x2": "200.00181",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200.00181",
      "y1": "40",
      "x2": "200.00098",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224.00098",
      "y1": "168",
      "x2": "176.00098",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56.00098",
      "y1": "168",
      "x2": "56.00039",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56.00039",
      "y1": "40",
      "x2": "56.00098",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32.00098",
      "y1": "136",
      "x2": "80.00098",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152.00098",
      "y1": "88",
      "x2": "104.00098",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128.00098",
      "y1": "120",
      "x2": "128.0011",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128.0011",
      "y1": "40",
      "x2": "128.00098",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200.00098",
      "y1": "200",
      "x2": "200.00181",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200.00181",
      "y1": "40",
      "x2": "200.00098",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224.00098",
      "y1": "168",
      "x2": "176.00098",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56.00098",
      "y1": "168",
      "x2": "56.00039",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56.00039",
      "y1": "40",
      "x2": "56.00098",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32.00098",
      "y1": "136",
      "x2": "80.00098",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152.00098",
      "y1": "88",
      "x2": "104.00098",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128.00098",
      "y1": "120",
      "x2": "128.0011",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128.0011",
      "y1": "40",
      "x2": "128.00098",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200.00098",
      "y1": "200",
      "x2": "200.00181",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200.00181",
      "y1": "40",
      "x2": "200.00098",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224.00098",
      "y1": "168",
      "x2": "176.00098",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56.00098",
      "y1": "168",
      "x2": "56.00039",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56.00039",
      "y1": "40",
      "x2": "56.00098",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32.00098",
      "y1": "136",
      "x2": "80.00098",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152.00098",
      "y1": "88",
      "x2": "104.00098",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5L = [];
/* style */

const __vue_inject_styles__$5L = undefined;
/* scoped */

const __vue_scope_id__$5L = undefined;
/* module identifier */

const __vue_module_identifier__$5L = undefined;
/* functional template */

const __vue_is_functional_template__$5L = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5L = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5L,
  staticRenderFns: __vue_staticRenderFns__$5L
}, __vue_inject_styles__$5L, __vue_script__$5L, __vue_scope_id__$5L, __vue_is_functional_template__$5L, __vue_module_identifier__$5L, false, undefined, undefined, undefined);

var script$5M = Vue.extend({
  name: "PhFadersHorizontal",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5M = script$5M;
/* template */

var __vue_render__$5M = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "131.99902",
      "y1": "171.99304",
      "x2": "39.99902",
      "y2": "171.99317",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "215.99902",
      "y1": "171.99317",
      "x2": "171.99902",
      "y2": "171.99304",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "67.99902",
      "y1": "83.99304",
      "x2": "39.99902",
      "y2": "83.99246",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "215.99902",
      "y1": "83.99246",
      "x2": "107.99902",
      "y2": "83.99304",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "107.99902",
      "y1": "59.99304",
      "x2": "107.99902",
      "y2": "107.99304",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "171.99902",
      "y1": "195.99304",
      "x2": "171.99902",
      "y2": "147.99304",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "135.99902",
      "y1": "171.99304",
      "x2": "39.99902",
      "y2": "171.99317",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "215.99902",
      "y1": "171.99317",
      "x2": "167.99902",
      "y2": "171.99304",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "71.99902",
      "y1": "83.99304",
      "x2": "39.99902",
      "y2": "83.99246",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "215.99902",
      "y1": "83.99246",
      "x2": "103.99902",
      "y2": "83.99304",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "103.99902",
      "y1": "59.99304",
      "x2": "103.99902",
      "y2": "107.99304",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "167.99902",
      "y1": "195.99304",
      "x2": "167.99902",
      "y2": "147.99304",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M135.999,163.99353h-96a8,8,0,0,0,0,16h96a8,8,0,0,0,0-16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M215.999,163.99353h-40v-16a8,8,0,0,0-16,0v48a8,8,0,0,0,16,0v-16h40a8,8,0,0,0,0-16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M39.999,91.99255l32,.001a8,8,0,0,0,0-16l-32-.001a8,8,0,0,0,0,16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M103.999,115.99353a8.00039,8.00039,0,0,0,8-8v-16l104-.001a8,8,0,1,0,0-16l-104,.001v-16a8,8,0,1,0-16,0v48A8.00039,8.00039,0,0,0,103.999,115.99353Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "135.99902",
      "y1": "171.99304",
      "x2": "39.99902",
      "y2": "171.99317",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "215.99902",
      "y1": "171.99317",
      "x2": "167.99902",
      "y2": "171.99304",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "71.99902",
      "y1": "83.99304",
      "x2": "39.99902",
      "y2": "83.99246",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "215.99902",
      "y1": "83.99246",
      "x2": "103.99902",
      "y2": "83.99304",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "103.99902",
      "y1": "59.99304",
      "x2": "103.99902",
      "y2": "107.99304",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "167.99902",
      "y1": "195.99304",
      "x2": "167.99902",
      "y2": "147.99304",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "135.99902",
      "y1": "171.99304",
      "x2": "39.99902",
      "y2": "171.99317",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "215.99902",
      "y1": "171.99317",
      "x2": "167.99902",
      "y2": "171.99304",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "71.99902",
      "y1": "83.99304",
      "x2": "39.99902",
      "y2": "83.99246",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "215.99902",
      "y1": "83.99246",
      "x2": "103.99902",
      "y2": "83.99304",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "103.99902",
      "y1": "59.99304",
      "x2": "103.99902",
      "y2": "107.99304",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "167.99902",
      "y1": "195.99304",
      "x2": "167.99902",
      "y2": "147.99304",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "135.99902",
      "y1": "171.99304",
      "x2": "39.99902",
      "y2": "171.99317",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "215.99902",
      "y1": "171.99317",
      "x2": "167.99902",
      "y2": "171.99304",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "71.99902",
      "y1": "83.99304",
      "x2": "39.99902",
      "y2": "83.99246",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "215.99902",
      "y1": "83.99246",
      "x2": "103.99902",
      "y2": "83.99304",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "103.99902",
      "y1": "59.99304",
      "x2": "103.99902",
      "y2": "107.99304",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "167.99902",
      "y1": "195.99304",
      "x2": "167.99902",
      "y2": "147.99304",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5M = [];
/* style */

const __vue_inject_styles__$5M = undefined;
/* scoped */

const __vue_scope_id__$5M = undefined;
/* module identifier */

const __vue_module_identifier__$5M = undefined;
/* functional template */

const __vue_is_functional_template__$5M = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5M = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5M,
  staticRenderFns: __vue_staticRenderFns__$5M
}, __vue_inject_styles__$5M, __vue_script__$5M, __vue_scope_id__$5M, __vue_is_functional_template__$5M, __vue_module_identifier__$5M, false, undefined, undefined, undefined);

var script$5N = Vue.extend({
  name: "PhFastForward",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5N = script$5N;
/* template */

var __vue_render__$5N = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M237.532,121.27057,148.32606,63.9239A8,8,0,0,0,136,70.65332V185.34668a8,8,0,0,0,12.32606,6.72942L237.532,134.72943A8,8,0,0,0,237.532,121.27057Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M129.532,121.27057,40.32606,63.9239A8,8,0,0,0,28,70.65332V185.34668a8,8,0,0,0,12.32606,6.72942L129.532,134.72943A8,8,0,0,0,129.532,121.27057Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M241.532,121.27057,152.32606,63.9239A8,8,0,0,0,140,70.65332V185.34668a8,8,0,0,0,12.32606,6.72942L241.532,134.72943A8,8,0,0,0,241.532,121.27057Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M129.532,121.27057,40.32606,63.9239A8,8,0,0,0,28,70.65332V185.34668a8,8,0,0,0,12.32606,6.72942L129.532,134.72943A8,8,0,0,0,129.532,121.27057Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M241.532,121.27057,152.32606,63.9239A8,8,0,0,0,140,70.65332V185.34668a8,8,0,0,0,12.32606,6.72942L241.532,134.72943A8,8,0,0,0,241.532,121.27057Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M129.532,121.27057,40.32606,63.9239A8,8,0,0,0,28,70.65332V185.34668a8,8,0,0,0,12.32606,6.72942L129.532,134.72943A8,8,0,0,0,129.532,121.27057Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M253.20605,128a15.9352,15.9352,0,0,1-7.34765,13.459l-89.20606,57.34668A16.00057,16.00057,0,0,1,132,185.34668V142.65381L44.65234,198.80566A16.00057,16.00057,0,0,1,20,185.34668V70.65332a16.00057,16.00057,0,0,1,24.65234-13.459L132,113.34619V70.65332a16.00057,16.00057,0,0,1,24.65234-13.459L245.8584,114.541A15.9352,15.9352,0,0,1,253.20605,128Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M241.532,121.27057,152.32606,63.9239A8,8,0,0,0,140,70.65332V185.34668a8,8,0,0,0,12.32606,6.72942L241.532,134.72943A8,8,0,0,0,241.532,121.27057Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M129.532,121.27057,40.32606,63.9239A8,8,0,0,0,28,70.65332V185.34668a8,8,0,0,0,12.32606,6.72942L129.532,134.72943A8,8,0,0,0,129.532,121.27057Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M241.532,121.27057,152.32606,63.9239A8,8,0,0,0,140,70.65332V185.34668a8,8,0,0,0,12.32606,6.72942L241.532,134.72943A8,8,0,0,0,241.532,121.27057Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M129.532,121.27057,40.32606,63.9239A8,8,0,0,0,28,70.65332V185.34668a8,8,0,0,0,12.32606,6.72942L129.532,134.72943A8,8,0,0,0,129.532,121.27057Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M241.532,121.27057,152.32606,63.9239A8,8,0,0,0,140,70.65332V185.34668a8,8,0,0,0,12.32606,6.72942L241.532,134.72943A8,8,0,0,0,241.532,121.27057Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M129.532,121.27057,40.32606,63.9239A8,8,0,0,0,28,70.65332V185.34668a8,8,0,0,0,12.32606,6.72942L129.532,134.72943A8,8,0,0,0,129.532,121.27057Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5N = [];
/* style */

const __vue_inject_styles__$5N = undefined;
/* scoped */

const __vue_scope_id__$5N = undefined;
/* module identifier */

const __vue_module_identifier__$5N = undefined;
/* functional template */

const __vue_is_functional_template__$5N = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5N = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5N,
  staticRenderFns: __vue_staticRenderFns__$5N
}, __vue_inject_styles__$5N, __vue_script__$5N, __vue_scope_id__$5N, __vue_is_functional_template__$5N, __vue_module_identifier__$5N, false, undefined, undefined, undefined);

var script$5O = Vue.extend({
  name: "PhFastForwardCircle",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5O = script$5O;
/* template */

var __vue_render__$5O = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "88 156 124 128 88 100 88 156",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "144 156 180 128 144 100 144 156",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,32a96,96,0,1,0,96,96A95.99991,95.99991,0,0,0,128,32ZM80,160V96l48,32Zm64,0V96l48,32Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "80 160 128 128 80 96 80 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "144 160 192 128 144 96 144 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.11791,104.11791,0,0,0,128,24Zm56.58789,110.55371-40,28A8.00015,8.00015,0,0,1,132,156V128a7.99968,7.99968,0,0,1-3.41211,6.55371l-40,28A8.00015,8.00015,0,0,1,76,156V100a8.00015,8.00015,0,0,1,12.58789-6.55371l40,28A7.99968,7.99968,0,0,1,132,128V100a8.00015,8.00015,0,0,1,12.58789-6.55371l40,28a8,8,0,0,1,0,13.10742Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "84 160 132 128 84 96 84 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "140 160 188 128 140 96 140 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "84 160 132 128 84 96 84 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "140 160 188 128 140 96 140 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "80 160 128 128 80 96 80 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "144 160 192 128 144 96 144 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5O = [];
/* style */

const __vue_inject_styles__$5O = undefined;
/* scoped */

const __vue_scope_id__$5O = undefined;
/* module identifier */

const __vue_module_identifier__$5O = undefined;
/* functional template */

const __vue_is_functional_template__$5O = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5O = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5O,
  staticRenderFns: __vue_staticRenderFns__$5O
}, __vue_inject_styles__$5O, __vue_script__$5O, __vue_scope_id__$5O, __vue_is_functional_template__$5O, __vue_module_identifier__$5O, false, undefined, undefined, undefined);

var script$5P = Vue.extend({
  name: "PhFigmaLogo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5P = script$5P;
/* template */

var __vue_render__$5P = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "162",
      "cy": "128",
      "r": "34",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,94V26.00089H94a34,34,0,0,0,0,68Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,161.99911V94H94a34,34,0,0,0,0,68Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,94V26.00089h34a34,34,0,0,1,0,68Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,161.99911v34.00044A34,34,0,1,1,94,162Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "162",
      "cy": "128",
      "r": "34",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,94V26.00089H94a34,34,0,0,0,0,68Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,161.99911v34.00044A34,34,0,1,1,94,162Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "162",
      "cy": "128",
      "r": "34",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,94V26.00089H94a34,34,0,0,0,0,68Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,161.99911V94H94a34,34,0,0,0,0,68Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,94V26.00089h34a34,34,0,0,1,0,68Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,161.99911v34.00044A34,34,0,1,1,94,162Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M186.61523,94.00049A41.97934,41.97934,0,0,0,162,18.001H94A41.97934,41.97934,0,0,0,69.38477,94.00049a41.93894,41.93894,0,0,0,.00048,67.99939A41.9892,41.9892,0,1,0,136,195.99951V160.948a41.97356,41.97356,0,1,0,50.61523-66.94751ZM188,60.001a26.02916,26.02916,0,0,1-25.98047,25.99951L162,86l-.03857.001L136,86V34.001h26A26.02947,26.02947,0,0,1,188,60.001ZM162,154a25.99952,25.99952,0,0,1-.03857-51.999H162l.019-.00049A25.99976,25.99976,0,0,1,162,154Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "162",
      "cy": "128",
      "r": "34",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,94V26.00089H94a34,34,0,0,0,0,68Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,161.99911V94H94a34,34,0,0,0,0,68Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,94V26.00089h34a34,34,0,0,1,0,68Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,161.99911v34.00044A34,34,0,1,1,94,162Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "162",
      "cy": "128",
      "r": "34",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,94V26.00089H94a34,34,0,0,0,0,68Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,161.99911V94H94a34,34,0,0,0,0,68Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,94V26.00089h34a34,34,0,0,1,0,68Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,161.99911v34.00044A34,34,0,1,1,94,162Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "162",
      "cy": "128",
      "r": "34",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,94V26.00089H94a34,34,0,0,0,0,68Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,161.99911V94H94a34,34,0,0,0,0,68Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,94V26.00089h34a34,34,0,0,1,0,68Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,161.99911v34.00044A34,34,0,1,1,94,162Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5P = [];
/* style */

const __vue_inject_styles__$5P = undefined;
/* scoped */

const __vue_scope_id__$5P = undefined;
/* module identifier */

const __vue_module_identifier__$5P = undefined;
/* functional template */

const __vue_is_functional_template__$5P = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5P = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5P,
  staticRenderFns: __vue_staticRenderFns__$5P
}, __vue_inject_styles__$5P, __vue_script__$5P, __vue_scope_id__$5P, __vue_is_functional_template__$5P, __vue_module_identifier__$5P, false, undefined, undefined, undefined);

var script$5Q = Vue.extend({
  name: "PhFile",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5Q = script$5Q;
/* template */

var __vue_render__$5Q = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200.00039,224H55.99961A7.99981,7.99981,0,0,1,48,216V40a7.99981,7.99981,0,0,1,7.99961-8l96.00312,0L208,88V216A7.99981,7.99981,0,0,1,200.00039,224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "148 32 148 92 208.008 92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "152 32 152 88 208.008 88 152 32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200.00039,224H55.99961A7.99981,7.99981,0,0,1,48,216V40a7.99981,7.99981,0,0,1,7.99961-8l96.00312,0L208,88V216A7.99981,7.99981,0,0,1,200.00039,224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208.008 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M213.58936,82.2749,157.65723,26.34277c-.08008-.08007-.167-.15039-.25-.22656-.10791-.09912-.21289-.20166-.32618-.29492-.07519-.06152-.15576-.11524-.23291-.17432-.13085-.10009-.26025-.20166-.397-.29394-.062-.04151-.12793-.07617-.19043-.11573-.15869-.10009-.31738-.1997-.4834-.28906-.04492-.02392-.09179-.04248-.13672-.06543-.1875-.09668-.377-.18945-.57275-.271-.03027-.0127-.0625-.022-.09326-.03418-.21045-.08448-.42383-.16358-.64258-.23-.03174-.00977-.06445-.01563-.09619-.02491-.2168-.063-.436-.12109-.66064-.166-.07129-.01416-.145-.02051-.2168-.03272-.18555-.03222-.37012-.06494-.55908-.08349A7.91349,7.91349,0,0,0,152,24H55.99219a16.01833,16.01833,0,0,0-16,16V216a16.01833,16.01833,0,0,0,16,16H200a16.01833,16.01833,0,0,0,16-16V88.15479c.001-.05225.00781-.10254.00781-.15479A7.97147,7.97147,0,0,0,213.58936,82.2749ZM152,88V43.31348L196.68555,88Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200.00039,224H55.99961A7.99981,7.99981,0,0,1,48,216V40a7.99981,7.99981,0,0,1,7.99961-8l96.00312,0L208,88V216A7.99981,7.99981,0,0,1,200.00039,224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208.008 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200.00039,224H55.99961A7.99981,7.99981,0,0,1,48,216V40a7.99981,7.99981,0,0,1,7.99961-8l96.00312,0L208,88V216A7.99981,7.99981,0,0,1,200.00039,224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208.008 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200.00039,224H55.99961A7.99981,7.99981,0,0,1,48,216V40a7.99981,7.99981,0,0,1,7.99961-8l96.00312,0L208,88V216A7.99981,7.99981,0,0,1,200.00039,224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208.008 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5Q = [];
/* style */

const __vue_inject_styles__$5Q = undefined;
/* scoped */

const __vue_scope_id__$5Q = undefined;
/* module identifier */

const __vue_module_identifier__$5Q = undefined;
/* functional template */

const __vue_is_functional_template__$5Q = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5Q = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5Q,
  staticRenderFns: __vue_staticRenderFns__$5Q
}, __vue_inject_styles__$5Q, __vue_script__$5Q, __vue_scope_id__$5Q, __vue_is_functional_template__$5Q, __vue_module_identifier__$5Q, false, undefined, undefined, undefined);

var script$5R = Vue.extend({
  name: "PhFileArrowDown",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5R = script$5R;
/* template */

var __vue_render__$5R = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,224.00005H55.99219a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8L152,32l56,56v128A8,8,0,0,1,200,224.00005Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "148 32 148 92 208.008 92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "100 156 128 184 156 156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "124",
      "x2": "128",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "152 32 152 88 208.008 88 152 32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,224.00005H55.99219a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8L152,32l56,56v128A8,8,0,0,1,200,224.00005Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208.008 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "100 156 128 184 156 156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "120",
      "x2": "128",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M213.58936,82.2749,157.65723,26.34277c-.08008-.08007-.167-.15039-.25-.22656-.10791-.09912-.21289-.20166-.32618-.29492-.07519-.06152-.15576-.11524-.23291-.17432-.13085-.10009-.26025-.20166-.397-.29394-.062-.04151-.12793-.07617-.19043-.11573-.15869-.10009-.31738-.1997-.4834-.28906-.04492-.02392-.09179-.04248-.13672-.06543-.1875-.09668-.377-.18945-.57275-.271-.03027-.0127-.0625-.022-.09326-.03418-.21045-.08448-.42383-.16358-.64258-.23-.03174-.00977-.06445-.01563-.09619-.02491-.2168-.063-.436-.12109-.66064-.166-.07129-.01416-.145-.02051-.2168-.03272-.18555-.03222-.37012-.06494-.55908-.08349A7.91349,7.91349,0,0,0,152,24H55.99219a16.01833,16.01833,0,0,0-16,16V216a16.01833,16.01833,0,0,0,16,16H200a16.01833,16.01833,0,0,0,16-16V88.15479c.001-.05225.00781-.10254.00781-.15479A7.97147,7.97147,0,0,0,213.58936,82.2749Zm-51.93262,79.38233-28,28c-.023.02313-.04883.04223-.07178.06506-.165.16089-.33447.317-.51269.46326-.09766.08032-.20118.15039-.30176.22534-.1084.08111-.21485.1654-.32764.241-.11621.07794-.2373.1455-.35693.21667-.10449.06244-.20655.12817-.31446.18585-.12011.06439-.24414.119-.36669.17676-.11426.05389-.22657.1109-.34327.15942-.11816.049-.23925.08838-.35937.13135-.126.04541-.251.09387-.37988.133-.11963.03613-.24122.06262-.36231.09308-.13184.03338-.26269.07037-.397.097-.13965.02765-.28028.044-.42041.06415-.11817.01691-.23389.03925-.353.051C128.52686,191.986,128.26367,192,128,192s-.52686-.014-.78955-.03986c-.11914-.01171-.23486-.03405-.353-.051-.14013-.02014-.28076-.0365-.42041-.06415-.13428-.02667-.26513-.06366-.397-.097-.12109-.03046-.24268-.057-.36231-.09308-.1289-.03913-.2539-.08759-.37988-.133-.12012-.043-.24121-.0824-.35937-.13135-.1167-.04852-.229-.10553-.34327-.15942-.12255-.0578-.24658-.11237-.36669-.17676-.10791-.05768-.21-.12341-.31446-.18585-.11963-.07117-.24072-.13873-.35693-.21667-.11279-.07557-.21924-.15986-.32764-.241-.10058-.075-.2041-.145-.30176-.22534-.1748-.14374-.3413-.29718-.50341-.455-.02637-.02563-.05518-.04724-.08106-.0733l-28-28a8,8,0,0,1,11.31348-11.314L120,164.68652V120a8,8,0,0,1,16,0v44.68652l14.34326-14.34326a8,8,0,0,1,11.31348,11.314ZM152,88V43.31348L196.68555,88Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,224.00005H55.99219a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8L152,32l56,56v128A8,8,0,0,1,200,224.00005Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208.008 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "100 156 128 184 156 156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "120",
      "x2": "128",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,224.00005H55.99219a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8L152,32l56,56v128A8,8,0,0,1,200,224.00005Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208.008 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "100 156 128 184 156 156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "120",
      "x2": "128",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,224.00005H55.99219a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8L152,32l56,56v128A8,8,0,0,1,200,224.00005Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208.008 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "100 156 128 184 156 156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "120",
      "x2": "128",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5R = [];
/* style */

const __vue_inject_styles__$5R = undefined;
/* scoped */

const __vue_scope_id__$5R = undefined;
/* module identifier */

const __vue_module_identifier__$5R = undefined;
/* functional template */

const __vue_is_functional_template__$5R = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5R = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5R,
  staticRenderFns: __vue_staticRenderFns__$5R
}, __vue_inject_styles__$5R, __vue_script__$5R, __vue_scope_id__$5R, __vue_is_functional_template__$5R, __vue_module_identifier__$5R, false, undefined, undefined, undefined);

var script$5S = Vue.extend({
  name: "PhFileArrowUp",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5S = script$5S;
/* template */

var __vue_render__$5S = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,224.00005H55.99219a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8L152,32l56,56v128A8,8,0,0,1,200,224.00005Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "148 32 148 92 208.008 92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "100 152 128 124 156 152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "184",
      "x2": "128",
      "y2": "124",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "152 32 152 88 208.008 88 152 32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,224.00005H55.99219a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8L152,32l56,56v128A8,8,0,0,1,200,224.00005Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208.008 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "100 148 128 120 156 148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "184",
      "x2": "128",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M213.58936,82.2749,157.65723,26.34277c-.08008-.08007-.167-.15039-.25-.22656-.10791-.09912-.21289-.20166-.32618-.29492-.07519-.06152-.15576-.11524-.23291-.17432-.13085-.10009-.26025-.20166-.397-.29394-.062-.04151-.12793-.07617-.19043-.11573-.15869-.10009-.31738-.1997-.4834-.28906-.04492-.02392-.09179-.04248-.13672-.06543-.1875-.09668-.377-.18945-.57275-.271-.03027-.0127-.0625-.022-.09326-.03418-.21045-.08448-.42383-.16358-.64258-.23-.03174-.00977-.06445-.01563-.09619-.02491-.2168-.063-.436-.12109-.66064-.166-.07129-.01416-.145-.02051-.2168-.03272-.18555-.03222-.37012-.06494-.55908-.08349A7.91349,7.91349,0,0,0,152,24H55.99219a16.01833,16.01833,0,0,0-16,16V216a16.01833,16.01833,0,0,0,16,16H200a16.01833,16.01833,0,0,0,16-16V88.15479c.001-.05225.00781-.10254.00781-.15479A7.97147,7.97147,0,0,0,213.58936,82.2749Zm-51.93262,71.38184a8,8,0,0,1-11.31348,0L136,139.31348V184a8,8,0,0,1-16,0V139.31348l-14.34326,14.34326a8,8,0,0,1-11.31348-11.314l28-28c.02588-.02606.05469-.04767.08106-.0733.16211-.15784.32861-.31128.50341-.455.09766-.08032.20118-.15039.30176-.22534.1084-.08111.21485-.1654.32764-.241.11621-.07794.2373-.1455.35693-.21667.10449-.06244.20655-.12817.31446-.18585.12011-.06439.24414-.119.36669-.17676.11426-.05389.22657-.1109.34327-.15942.11816-.049.23925-.08838.35937-.13135.126-.04541.251-.09387.37988-.133.11963-.03613.24122-.06262.36231-.09308.13184-.03338.26269-.07037.397-.097.13965-.02765.28028-.044.42041-.06415.11817-.01691.23389-.03925.353-.051C127.47314,112.014,127.73633,112,128,112s.52686.014.78955.03986c.11914.01171.23486.034.353.051.14013.02014.28076.0365.42041.06415.13428.02667.26513.06366.397.097.12109.03046.24268.057.36231.09308.1289.03913.2539.08759.37988.133.12012.043.24121.0824.35937.13135.1167.04852.229.10553.34327.15942.12255.0578.24658.11237.36669.17676.10791.05768.21.12341.31446.18585.11963.07117.24072.13873.35693.21667.11279.07557.21924.15986.32764.241.10058.075.2041.145.30176.22534.17822.1463.34765.30237.51269.46326.023.02283.04883.04193.07178.06506l28,28A7.99974,7.99974,0,0,1,161.65674,153.65674ZM152,88V43.31348L196.68555,88Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,224.00005H55.99219a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8L152,32l56,56v128A8,8,0,0,1,200,224.00005Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208.008 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "100 148 128 120 156 148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "184",
      "x2": "128",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,224.00005H55.99219a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8L152,32l56,56v128A8,8,0,0,1,200,224.00005Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208.008 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "100 148 128 120 156 148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "184",
      "x2": "128",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,224.00005H55.99219a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8L152,32l56,56v128A8,8,0,0,1,200,224.00005Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208.008 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "100 148 128 120 156 148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "184",
      "x2": "128",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5S = [];
/* style */

const __vue_inject_styles__$5S = undefined;
/* scoped */

const __vue_scope_id__$5S = undefined;
/* module identifier */

const __vue_module_identifier__$5S = undefined;
/* functional template */

const __vue_is_functional_template__$5S = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5S = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5S,
  staticRenderFns: __vue_staticRenderFns__$5S
}, __vue_inject_styles__$5S, __vue_script__$5S, __vue_scope_id__$5S, __vue_is_functional_template__$5S, __vue_module_identifier__$5S, false, undefined, undefined, undefined);

var script$5T = Vue.extend({
  name: "PhFileDotted",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5T = script$5T;
/* template */

var __vue_render__$5T = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "148 32 148 92 208.008 92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,224.00005H55.99219a8,8,0,0,1-8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "120 32 152 32 208 88 208 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M47.99219,64V40a8,8,0,0,1,8-8L80,32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,176v40a8,8,0,0,1-8,8h-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "104",
      "x2": "48",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "224",
      "x2": "152",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "152 32 152 88 208.008 88 152 32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,224.00005H55.99219a8,8,0,0,1-8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "120 32 152 32 208 88 208 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M47.99219,64V40a8,8,0,0,1,8-8L80,32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208.008 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,176v40a8,8,0,0,1-8,8h-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "104",
      "x2": "48",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "224",
      "x2": "152",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,224a8.00039,8.00039,0,0,1-8,8H55.99219a16.01833,16.01833,0,0,1-16-16V184a8,8,0,0,1,16,0v32H72A8.00039,8.00039,0,0,1,80,224ZM80,24H55.99219a16.01833,16.01833,0,0,0-16,16V64a8,8,0,0,0,16,0V40H80a8,8,0,0,0,0-16ZM216.00781,88a7.9698,7.9698,0,0,0-2.4248-5.731L157.65723,26.34277c-.0542-.05407-.11426-.10089-.16944-.15326-.1333-.126-.26611-.25268-.4082-.36932-.06738-.05566-.14014-.10364-.20947-.15686-.13819-.1062-.27539-.21356-.41992-.31079-.05811-.03882-.11963-.07129-.17872-.10858-.1621-.10279-.3247-.20478-.49462-.2959-.04248-.02271-.08692-.04059-.12989-.0625-.18945-.09747-.38135-.19141-.57959-.2738-.02832-.01191-.05859-.02045-.0874-.03205-.2124-.08539-.42725-.16492-.64844-.23218-.02978-.00909-.06054-.01452-.09033-.02325-.21875-.06384-.43994-.12225-.666-.16742-.07032-.0141-.14209-.0202-.21241-.03241-.18652-.032-.373-.06518-.564-.08411A7.98793,7.98793,0,0,0,152,24H120a8,8,0,0,0,0,16h24V88a8.00039,8.00039,0,0,0,8,8h48v40a8,8,0,0,0,16,0V88.15942C216.001,88.106,216.00781,88.05383,216.00781,88ZM208,168a8.00039,8.00039,0,0,0-8,8v40h-8a8,8,0,0,0,0,16h8a16.01833,16.01833,0,0,0,16-16V176A8.00039,8.00039,0,0,0,208,168ZM48,152a8.00039,8.00039,0,0,0,8-8V104a8,8,0,0,0-16,0v40A8.00039,8.00039,0,0,0,48,152Zm104,64H112a8,8,0,0,0,0,16h40a8,8,0,0,0,0-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M72,224.00005H55.99219a8,8,0,0,1-8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "120 32 152 32 208 88 208 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M47.99219,64V40a8,8,0,0,1,8-8L80,32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208.008 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,176v40a8,8,0,0,1-8,8h-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "104",
      "x2": "48",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "224",
      "x2": "152",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M72,224.00005H55.99219a8,8,0,0,1-8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "120 32 152 32 208 88 208 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M47.99219,64V40a8,8,0,0,1,8-8L80,32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208.008 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,176v40a8,8,0,0,1-8,8h-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "104",
      "x2": "48",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "224",
      "x2": "152",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M72,224.00005H55.99219a8,8,0,0,1-8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "120 32 152 32 208 88 208 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M47.99219,64V40a8,8,0,0,1,8-8L80,32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208.008 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,176v40a8,8,0,0,1-8,8h-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "104",
      "x2": "48",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "224",
      "x2": "152",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5T = [];
/* style */

const __vue_inject_styles__$5T = undefined;
/* scoped */

const __vue_scope_id__$5T = undefined;
/* module identifier */

const __vue_module_identifier__$5T = undefined;
/* functional template */

const __vue_is_functional_template__$5T = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5T = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5T,
  staticRenderFns: __vue_staticRenderFns__$5T
}, __vue_inject_styles__$5T, __vue_script__$5T, __vue_scope_id__$5T, __vue_is_functional_template__$5T, __vue_module_identifier__$5T, false, undefined, undefined, undefined);

var script$5U = Vue.extend({
  name: "PhFileMinus",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5U = script$5U;
/* template */

var __vue_render__$5U = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,224.00005H55.99219a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8L152,32l56,56v128A8,8,0,0,1,200,224.00005Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "148 32 148 92 208.008 92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "152",
      "x2": "152",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "152 32 152 88 208.008 88 152 32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,224.00005H55.99219a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8L152,32l56,56v128A8,8,0,0,1,200,224.00005Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208.008 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "152",
      "x2": "152",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M213.58936,82.2749,157.65723,26.34277c-.08008-.08007-.167-.15039-.25-.22656-.10791-.09912-.21289-.20166-.32618-.29492-.07519-.06152-.15576-.11524-.23291-.17432-.13085-.10009-.26025-.20166-.397-.29394-.062-.04151-.12793-.07617-.19043-.11573-.15869-.10009-.31738-.1997-.4834-.28906-.04492-.02392-.09179-.04248-.13672-.06543-.1875-.09668-.377-.18945-.57275-.271-.03027-.0127-.0625-.022-.09326-.03418-.21045-.08448-.42383-.16358-.64258-.23-.03174-.00977-.06445-.01563-.09619-.02491-.2168-.063-.436-.12109-.66064-.166-.07129-.01416-.145-.02051-.2168-.03272-.18555-.03222-.37012-.06494-.55908-.08349A7.91349,7.91349,0,0,0,152,24H55.99219a16.01833,16.01833,0,0,0-16,16V216a16.01833,16.01833,0,0,0,16,16H200a16.01833,16.01833,0,0,0,16-16V88.15479c.001-.05225.00781-.10254.00781-.15479A7.97147,7.97147,0,0,0,213.58936,82.2749ZM152,160H104a8,8,0,0,1,0-16h48a8,8,0,0,1,0,16Zm0-72V43.31348L196.68555,88Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,224.00005H55.99219a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8L152,32l56,56v128A8,8,0,0,1,200,224.00005Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208.008 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "152",
      "x2": "152",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,224.00005H55.99219a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8L152,32l56,56v128A8,8,0,0,1,200,224.00005Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208.008 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "152",
      "x2": "152",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,224.00005H55.99219a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8L152,32l56,56v128A8,8,0,0,1,200,224.00005Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208.008 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "152",
      "x2": "152",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5U = [];
/* style */

const __vue_inject_styles__$5U = undefined;
/* scoped */

const __vue_scope_id__$5U = undefined;
/* module identifier */

const __vue_module_identifier__$5U = undefined;
/* functional template */

const __vue_is_functional_template__$5U = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5U = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5U,
  staticRenderFns: __vue_staticRenderFns__$5U
}, __vue_inject_styles__$5U, __vue_script__$5U, __vue_scope_id__$5U, __vue_is_functional_template__$5U, __vue_module_identifier__$5U, false, undefined, undefined, undefined);

var script$5V = Vue.extend({
  name: "PhFilePdf",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5V = script$5V;
/* template */

var __vue_render__$5V = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M124,216c13.25483,0,24-12,24-28s-10.74517-28-24-28H112v56Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "216 160 184 160 184 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "212",
      "y1": "196",
      "x2": "184",
      "y2": "196",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M47.99219,124.00005V48a8,8,0,0,1,8-8L152,40l56,56v28.00005",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "148 40 148 100 208.008 100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,200H56a20,20,0,0,0,0-40H40v56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "152 40 152 96 208.008 96 152 40",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M47.99219,136V48a8,8,0,0,1,8-8L152,40l56,56v40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 40 152 96 208.008 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,200H64a16,16,0,0,0,0-32H48v48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M124,216a24,24,0,0,0,0-48H112v48Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 168 180 168 180 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "204",
      "y1": "196",
      "x2": "180",
      "y2": "196",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M213.58936,90.2749,157.65723,34.34277c-.08008-.08007-.167-.15039-.25-.22656-.10791-.09912-.21289-.20166-.32618-.29492-.07519-.06152-.15576-.11524-.23291-.17432-.13085-.10009-.26025-.20166-.397-.29394-.062-.04151-.12793-.07617-.19043-.11573-.15869-.10009-.31738-.1997-.4834-.28906-.04492-.02392-.09179-.04248-.13672-.06543-.1875-.09668-.377-.18945-.57275-.271-.03027-.0127-.0625-.022-.09326-.03418-.21045-.08448-.42383-.16358-.64258-.23-.03174-.00977-.06445-.01563-.09619-.02491-.2168-.063-.436-.12109-.66064-.166-.07129-.01416-.145-.02051-.2168-.03272-.18555-.03222-.37012-.06494-.55908-.08349A7.91349,7.91349,0,0,0,152,32H55.99219a16.00008,16.00008,0,0,0-16,16v88a7.99989,7.99989,0,0,0,8,8H208a7.99989,7.99989,0,0,0,8-8V96.15479c.001-.05225.00781-.10254.00781-.15479A7.97147,7.97147,0,0,0,213.58936,90.2749ZM152,96V51.31348L196.68555,96ZM64,160H48a8.00039,8.00039,0,0,0-8,8v48a8,8,0,0,0,16,0v-8h8a24,24,0,0,0,0-48Zm0,32H56V176h8a8,8,0,0,1,0,16Zm60-32H112a8.00039,8.00039,0,0,0-8,8v48a8.00039,8.00039,0,0,0,8,8h12a32,32,0,0,0,0-64Zm0,48h-4V176h4a16,16,0,0,1,0,32Zm92-40a8.00039,8.00039,0,0,1-8,8H188v12h16a8,8,0,0,1,0,16H188v12a8,8,0,0,1-16,0V168a8.00039,8.00039,0,0,1,8-8h28A8.00039,8.00039,0,0,1,216,168Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M47.99219,136V48a8,8,0,0,1,8-8L152,40l56,56v40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 40 152 96 208.008 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,200H64a16,16,0,0,0,0-32H48v48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M124,216a24,24,0,0,0,0-48H112v48Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 168 180 168 180 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "204",
      "y1": "196",
      "x2": "180",
      "y2": "196",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M47.99219,136V48a8,8,0,0,1,8-8L152,40l56,56v40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 40 152 96 208.008 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,200H64a16,16,0,0,0,0-32H48v48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M124,216a24,24,0,0,0,0-48H112v48Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 168 180 168 180 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "204",
      "y1": "196",
      "x2": "180",
      "y2": "196",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M47.99219,136V48a8,8,0,0,1,8-8L152,40l56,56v40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 40 152 96 208.008 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,200H64a16,16,0,0,0,0-32H48v48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M124,216a24,24,0,0,0,0-48H112v48Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 168 180 168 180 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "204",
      "y1": "196",
      "x2": "180",
      "y2": "196",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5V = [];
/* style */

const __vue_inject_styles__$5V = undefined;
/* scoped */

const __vue_scope_id__$5V = undefined;
/* module identifier */

const __vue_module_identifier__$5V = undefined;
/* functional template */

const __vue_is_functional_template__$5V = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5V = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5V,
  staticRenderFns: __vue_staticRenderFns__$5V
}, __vue_inject_styles__$5V, __vue_script__$5V, __vue_scope_id__$5V, __vue_is_functional_template__$5V, __vue_module_identifier__$5V, false, undefined, undefined, undefined);

var script$5W = Vue.extend({
  name: "PhFilePlus",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5W = script$5W;
/* template */

var __vue_render__$5W = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,224.00005H55.99219a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8L152,32l56,56v128A8,8,0,0,1,200,224.00005Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "148 32 148 92 208.008 92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "152",
      "x2": "152",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "152 32 152 88 208.008 88 152 32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,224.00005H55.99219a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8L152,32l56,56v128A8,8,0,0,1,200,224.00005Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208.008 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "152",
      "x2": "152",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M213.58936,82.2749,157.65723,26.34277c-.08008-.08007-.167-.15039-.25-.22656-.10791-.09912-.21289-.20166-.32618-.29492-.07519-.06152-.15576-.11524-.23291-.17432-.13085-.10009-.26025-.20166-.397-.29394-.062-.04151-.12793-.07617-.19043-.11573-.15869-.10009-.31738-.1997-.4834-.28906-.04492-.02392-.09179-.04248-.13672-.06543-.1875-.09668-.377-.18945-.57275-.271-.03027-.0127-.0625-.022-.09326-.03418-.21045-.08448-.42383-.16358-.64258-.23-.03174-.00977-.06445-.01563-.09619-.02491-.2168-.063-.436-.12109-.66064-.166-.07129-.01416-.145-.02051-.2168-.03272-.18555-.03222-.37012-.06494-.55908-.08349A7.91349,7.91349,0,0,0,152,24H55.99219a16.01833,16.01833,0,0,0-16,16V216a16.01833,16.01833,0,0,0,16,16H200a16.01833,16.01833,0,0,0,16-16V88.15479c.001-.05225.00781-.10254.00781-.15479A7.97147,7.97147,0,0,0,213.58936,82.2749ZM152,160H136v16a8,8,0,0,1-16,0V160H104a8,8,0,0,1,0-16h16V128a8,8,0,0,1,16,0v16h16a8,8,0,0,1,0,16Zm0-72V43.31348L196.68555,88Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,224.00005H55.99219a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8L152,32l56,56v128A8,8,0,0,1,200,224.00005Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208.008 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "152",
      "x2": "152",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,224.00005H55.99219a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8L152,32l56,56v128A8,8,0,0,1,200,224.00005Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208.008 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "152",
      "x2": "152",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,224.00005H55.99219a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8L152,32l56,56v128A8,8,0,0,1,200,224.00005Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208.008 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "152",
      "x2": "152",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5W = [];
/* style */

const __vue_inject_styles__$5W = undefined;
/* scoped */

const __vue_scope_id__$5W = undefined;
/* module identifier */

const __vue_module_identifier__$5W = undefined;
/* functional template */

const __vue_is_functional_template__$5W = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5W = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5W,
  staticRenderFns: __vue_staticRenderFns__$5W
}, __vue_inject_styles__$5W, __vue_script__$5W, __vue_scope_id__$5W, __vue_is_functional_template__$5W, __vue_module_identifier__$5W, false, undefined, undefined, undefined);

var script$5X = Vue.extend({
  name: "PhFileSearch",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5X = script$5X;
/* template */

var __vue_render__$5X = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,224.00005H55.99219a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8L152,32l56,56v128A8,8,0,0,1,200,224.00005Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "148 32 148 92 208.008 92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "123.9941",
      "cy": "148",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "140.96467",
      "y1": "164.97053",
      "x2": "159.79313",
      "y2": "183.79899",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "152 32 152 88 208.008 88 152 32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,224.00005H55.99219a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8L152,32l56,56v128A8,8,0,0,1,200,224.00005Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208.008 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "143.79313",
      "y1": "167.79899",
      "x2": "159.79313",
      "y2": "183.79899",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "123.99414",
      "cy": "148",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M213.58936,82.2749,157.65723,26.34277c-.08008-.08007-.167-.15039-.25-.22656-.10791-.09912-.21289-.20166-.32618-.29492-.07519-.06152-.15576-.11524-.23291-.17432-.13085-.10009-.26025-.20166-.397-.29394-.062-.04151-.12793-.07617-.19043-.11573-.15869-.10009-.31738-.1997-.4834-.28906-.04492-.02392-.09179-.04248-.13672-.06543-.1875-.09668-.377-.18945-.57275-.271-.03027-.0127-.0625-.022-.09326-.03418-.21045-.08448-.42383-.16358-.64258-.23-.03174-.00977-.06445-.01563-.09619-.02491-.2168-.063-.436-.12109-.66064-.166-.07129-.01416-.145-.02051-.2168-.03272-.18555-.03222-.37012-.06494-.55908-.08349A7.91349,7.91349,0,0,0,152,24H55.99219a16.01833,16.01833,0,0,0-16,16V216a16.01833,16.01833,0,0,0,16,16H200a16.01833,16.01833,0,0,0,16-16V88.15479c.001-.05225.00781-.10254.00781-.15479A7.97147,7.97147,0,0,0,213.58936,82.2749ZM165.44971,189.45605a8.00061,8.00061,0,0,1-11.31348,0l-10.98511-10.9851a35.95132,35.95132,0,1,1,11.32093-11.307l10.97766,10.97766A8.00032,8.00032,0,0,1,165.44971,189.45605ZM152,88V43.31348L196.68555,88Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M123.99414,128.00977a19.98432,19.98432,0,1,0,14.14209,5.84863A19.93593,19.93593,0,0,0,123.99414,128.00977Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,224.00005H55.99219a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8L152,32l56,56v128A8,8,0,0,1,200,224.00005Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208.008 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "143.79313",
      "y1": "167.79899",
      "x2": "159.79313",
      "y2": "183.79899",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "123.99414",
      "cy": "148",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,224.00005H55.99219a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8L152,32l56,56v128A8,8,0,0,1,200,224.00005Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208.008 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "143.79313",
      "y1": "167.79899",
      "x2": "159.79313",
      "y2": "183.79899",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "123.99414",
      "cy": "148",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,224.00005H55.99219a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8L152,32l56,56v128A8,8,0,0,1,200,224.00005Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208.008 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "143.79313",
      "y1": "167.79899",
      "x2": "159.79313",
      "y2": "183.79899",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "123.99414",
      "cy": "148",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5X = [];
/* style */

const __vue_inject_styles__$5X = undefined;
/* scoped */

const __vue_scope_id__$5X = undefined;
/* module identifier */

const __vue_module_identifier__$5X = undefined;
/* functional template */

const __vue_is_functional_template__$5X = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5X = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5X,
  staticRenderFns: __vue_staticRenderFns__$5X
}, __vue_inject_styles__$5X, __vue_script__$5X, __vue_scope_id__$5X, __vue_is_functional_template__$5X, __vue_module_identifier__$5X, false, undefined, undefined, undefined);

var script$5Y = Vue.extend({
  name: "PhFileText",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5Y = script$5Y;
/* template */

var __vue_render__$5Y = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,224.00005H55.99219a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8L152,32l56,56v128A8,8,0,0,1,200,224.00005Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "148 32 148 92 208.008 92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "132",
      "x2": "160",
      "y2": "132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "172",
      "x2": "160",
      "y2": "172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "152 32 152 88 208.008 88 152 32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,224.00005H55.99219a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8L152,32l56,56v128A8,8,0,0,1,200,224.00005Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208.008 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "136",
      "x2": "160",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "168",
      "x2": "160",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M213.58936,82.2749,157.65723,26.34277c-.08008-.08007-.167-.15039-.25-.22656-.10791-.09912-.21289-.20166-.32618-.29492-.07519-.06152-.15576-.11524-.23291-.17432-.13085-.10009-.26025-.20166-.397-.29394-.062-.04151-.12793-.07617-.19043-.11573-.15869-.10009-.31738-.1997-.4834-.28906-.04492-.02392-.09179-.04248-.13672-.06543-.1875-.09668-.377-.18945-.57275-.271-.03027-.0127-.0625-.022-.09326-.03418-.21045-.08448-.42383-.16358-.64258-.23-.03174-.00977-.06445-.01563-.09619-.02491-.2168-.063-.436-.12109-.66064-.166-.07129-.01416-.145-.02051-.2168-.03272-.18555-.03222-.37012-.06494-.55908-.08349A7.91349,7.91349,0,0,0,152,24H55.99219a16.01833,16.01833,0,0,0-16,16V216a16.01833,16.01833,0,0,0,16,16H200a16.01833,16.01833,0,0,0,16-16V88.15479c.001-.05225.00781-.10254.00781-.15479A7.97147,7.97147,0,0,0,213.58936,82.2749ZM160,176H96a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm0-32H96a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm-8-56V43.31348L196.68555,88Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,224.00005H55.99219a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8L152,32l56,56v128A8,8,0,0,1,200,224.00005Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208.008 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "136",
      "x2": "160",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "168",
      "x2": "160",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,224.00005H55.99219a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8L152,32l56,56v128A8,8,0,0,1,200,224.00005Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208.008 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "136",
      "x2": "160",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "168",
      "x2": "160",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200.00039,224H55.99961A7.99981,7.99981,0,0,1,48,216V40a7.99981,7.99981,0,0,1,7.99961-8l96.00312,0L208,88V216A7.99981,7.99981,0,0,1,200.00039,224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208.008 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "136",
      "x2": "160",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "168",
      "x2": "160",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5Y = [];
/* style */

const __vue_inject_styles__$5Y = undefined;
/* scoped */

const __vue_scope_id__$5Y = undefined;
/* module identifier */

const __vue_module_identifier__$5Y = undefined;
/* functional template */

const __vue_is_functional_template__$5Y = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5Y = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5Y,
  staticRenderFns: __vue_staticRenderFns__$5Y
}, __vue_inject_styles__$5Y, __vue_script__$5Y, __vue_scope_id__$5Y, __vue_is_functional_template__$5Y, __vue_module_identifier__$5Y, false, undefined, undefined, undefined);

var script$5Z = Vue.extend({
  name: "PhFileX",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5Z = script$5Z;
/* template */

var __vue_render__$5Z = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,224.00005H55.99219a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8L152,32l56,56v128A8,8,0,0,1,200,224.00005Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "148 32 148 92 208.008 92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "103.98242",
      "y1": "128",
      "x2": "151.98242",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "151.98242",
      "y1": "128",
      "x2": "103.98242",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "152 32 152 88 208.008 88 152 32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,224.00005H55.99219a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8L152,32l56,56v128A8,8,0,0,1,200,224.00005Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208.008 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "103.9707",
      "y1": "128",
      "x2": "151.9707",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "151.9707",
      "y1": "128",
      "x2": "103.9707",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M213.58936,82.2749,157.65723,26.34277c-.08008-.08007-.167-.15039-.25-.22656-.10791-.09912-.21289-.20166-.32618-.29492-.07519-.06152-.15576-.11524-.23291-.17432-.13085-.10009-.26025-.20166-.397-.29394-.062-.04151-.12793-.07617-.19043-.11573-.15869-.10009-.31738-.1997-.4834-.28906-.04492-.02392-.09179-.04248-.13672-.06543-.1875-.09668-.377-.18945-.57275-.271-.03027-.0127-.0625-.022-.09326-.03418-.21045-.08448-.42383-.16358-.64258-.23-.03174-.00977-.06445-.01563-.09619-.02491-.2168-.063-.436-.12109-.66064-.166-.07129-.01416-.145-.02051-.2168-.03272-.18555-.03222-.37012-.06494-.55908-.08349A7.91349,7.91349,0,0,0,152,24H55.99219a16.01833,16.01833,0,0,0-16,16V216a16.01833,16.01833,0,0,0,16,16H200a16.01833,16.01833,0,0,0,16-16V88.15479c.001-.05225.00781-.10254.00781-.15479A7.97147,7.97147,0,0,0,213.58936,82.2749Zm-55.96192,88.06836A7.99984,7.99984,0,1,1,146.314,181.65674L127.9707,163.31348l-18.34326,18.34326A7.99984,7.99984,0,1,1,98.314,170.34326L116.65723,152,98.314,133.65674a7.99984,7.99984,0,1,1,11.31348-11.31348l18.34326,18.34326L146.314,122.34326a7.99984,7.99984,0,1,1,11.31348,11.31348L139.28418,152ZM152,88V43.31348L196.68555,88Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,224.00005H55.99219a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8L152,32l56,56v128A8,8,0,0,1,200,224.00005Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208.008 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "103.98828",
      "y1": "128",
      "x2": "151.98828",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "151.98828",
      "y1": "128",
      "x2": "103.98828",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,224.00005H55.99219a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8L152,32l56,56v128A8,8,0,0,1,200,224.00005Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208.008 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "103.99414",
      "y1": "128",
      "x2": "151.99414",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "151.99414",
      "y1": "128",
      "x2": "103.99414",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,224.00005H55.99219a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8L152,32l56,56v128A8,8,0,0,1,200,224.00005Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208.008 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "128",
      "x2": "152",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "128",
      "x2": "104",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5Z = [];
/* style */

const __vue_inject_styles__$5Z = undefined;
/* scoped */

const __vue_scope_id__$5Z = undefined;
/* module identifier */

const __vue_module_identifier__$5Z = undefined;
/* functional template */

const __vue_is_functional_template__$5Z = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5Z = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5Z,
  staticRenderFns: __vue_staticRenderFns__$5Z
}, __vue_inject_styles__$5Z, __vue_script__$5Z, __vue_scope_id__$5Z, __vue_is_functional_template__$5Z, __vue_module_identifier__$5Z, false, undefined, undefined, undefined);

var script$5_ = Vue.extend({
  name: "PhFiles",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5_ = script$5_;
/* template */

var __vue_render__$5_ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M164,224H56a8,8,0,0,1-8-8V76a8,8,0,0,1,8-8l76,0,40,40V216A8,8,0,0,1,164,224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M84,68V36a8,8,0,0,1,8-8l80,0,40,40V176a8,8,0,0,1-8,8H172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "144",
      "x2": "132",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "184",
      "x2": "132",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,192h24a8,8,0,0,0,8-8V72L168,32,88,32a8,8,0,0,0-8,8V64l56,0,40,40Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,224H56a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8l80,0,40,40V216A8,8,0,0,1,168,224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,64V40a8,8,0,0,1,8-8l80,0,40,40V184a8,8,0,0,1-8,8H176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "152",
      "x2": "136",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "184",
      "x2": "136",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M213.65723,66.34326l-40-40A8.00076,8.00076,0,0,0,168,24H88A16.01833,16.01833,0,0,0,72,40V56H56A16.01833,16.01833,0,0,0,40,72V216a16.01833,16.01833,0,0,0,16,16H168a16.01833,16.01833,0,0,0,16-16V200h16a16.01833,16.01833,0,0,0,16-16V72A8.00035,8.00035,0,0,0,213.65723,66.34326ZM136,192H88a8,8,0,0,1,0-16h48a8,8,0,0,1,0,16Zm0-32H88a8,8,0,0,1,0-16h48a8,8,0,0,1,0,16Zm64,24H184V104a8.00035,8.00035,0,0,0-2.34277-5.65674l-40-40A8.00076,8.00076,0,0,0,136,56H88V40h76.68652L200,75.314Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M168,224H56a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8l80,0,40,40V216A8,8,0,0,1,168,224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,64V40a8,8,0,0,1,8-8l80,0,40,40V184a8,8,0,0,1-8,8H176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "152",
      "x2": "136",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "184",
      "x2": "136",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M168,224H56a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8l80,0,40,40V216A8,8,0,0,1,168,224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,64V40a8,8,0,0,1,8-8l80,0,40,40V184a8,8,0,0,1-8,8H176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "152",
      "x2": "136",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "184",
      "x2": "136",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M168,224H56a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8l80,0,40,40V216A8,8,0,0,1,168,224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,64V40a8,8,0,0,1,8-8l80,0,40,40V184a8,8,0,0,1-8,8H176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "152",
      "x2": "136",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "184",
      "x2": "136",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5_ = [];
/* style */

const __vue_inject_styles__$5_ = undefined;
/* scoped */

const __vue_scope_id__$5_ = undefined;
/* module identifier */

const __vue_module_identifier__$5_ = undefined;
/* functional template */

const __vue_is_functional_template__$5_ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5_ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5_,
  staticRenderFns: __vue_staticRenderFns__$5_
}, __vue_inject_styles__$5_, __vue_script__$5_, __vue_scope_id__$5_, __vue_is_functional_template__$5_, __vue_module_identifier__$5_, false, undefined, undefined, undefined);

var script$5$ = Vue.extend({
  name: "PhFilmStrip",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5$ = script$5$;
/* template */

var __vue_render__$5$ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "204",
      "y1": "88",
      "x2": "224",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "204",
      "y1": "168",
      "x2": "224",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "88",
      "x2": "52",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "168",
      "x2": "52",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "92",
      "y1": "88",
      "x2": "108",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "92",
      "y1": "168",
      "x2": "108",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "148",
      "y1": "88",
      "x2": "164",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "148",
      "y1": "168",
      "x2": "164",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "204",
      "y1": "80",
      "x2": "224",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "204",
      "y1": "176",
      "x2": "224",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "80",
      "x2": "52",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "176",
      "x2": "52",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "92",
      "y1": "80",
      "x2": "108",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "92",
      "y1": "176",
      "x2": "108",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "148",
      "y1": "80",
      "x2": "164",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "148",
      "y1": "176",
      "x2": "164",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,64h24V56a16.01833,16.01833,0,0,0-16-16H40A16.01833,16.01833,0,0,0,24,56v8H48a8,8,0,0,1,0,16H24v96H48a8,8,0,0,1,0,16H24v8a16.01833,16.01833,0,0,0,16,16H216a16.01833,16.01833,0,0,0,16-16v-8H208a8,8,0,0,1,0-16h24V80H208a8,8,0,0,1,0-16ZM108,192H88a8,8,0,0,1,0-16h20a8,8,0,0,1,0,16Zm0-112H88a8,8,0,0,1,0-16h20a8,8,0,0,1,0,16Zm60,112H148a8,8,0,0,1,0-16h20a8,8,0,0,1,0,16Zm0-112H148a8,8,0,0,1,0-16h20a8,8,0,0,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "204",
      "y1": "80",
      "x2": "224",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "204",
      "y1": "176",
      "x2": "224",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "80",
      "x2": "52",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "176",
      "x2": "52",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "92",
      "y1": "80",
      "x2": "108",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "92",
      "y1": "176",
      "x2": "108",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "148",
      "y1": "80",
      "x2": "164",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "148",
      "y1": "176",
      "x2": "164",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "204",
      "y1": "80",
      "x2": "224",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "204",
      "y1": "176",
      "x2": "224",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "80",
      "x2": "52",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "176",
      "x2": "52",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "92",
      "y1": "80",
      "x2": "108",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "92",
      "y1": "176",
      "x2": "108",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "148",
      "y1": "80",
      "x2": "164",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "148",
      "y1": "176",
      "x2": "164",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "204",
      "y1": "80",
      "x2": "224",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "204",
      "y1": "176",
      "x2": "224",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "80",
      "x2": "52",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "176",
      "x2": "52",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "92",
      "y1": "80",
      "x2": "108",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "92",
      "y1": "176",
      "x2": "108",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "148",
      "y1": "80",
      "x2": "164",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "148",
      "y1": "176",
      "x2": "164",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5$ = [];
/* style */

const __vue_inject_styles__$5$ = undefined;
/* scoped */

const __vue_scope_id__$5$ = undefined;
/* module identifier */

const __vue_module_identifier__$5$ = undefined;
/* functional template */

const __vue_is_functional_template__$5$ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5$ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5$,
  staticRenderFns: __vue_staticRenderFns__$5$
}, __vue_inject_styles__$5$, __vue_script__$5$, __vue_scope_id__$5$, __vue_is_functional_template__$5$, __vue_module_identifier__$5$, false, undefined, undefined, undefined);

var script$60 = Vue.extend({
  name: "PhFingerprint",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$60 = script$60;
/* template */

var __vue_render__$60 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M107.99406,128.00837a20,20,0,1,1,40,0,211.06573,211.06573,0,0,1-24.95471,99.87857",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M127.99406,68.00837a60,60,0,0,1,60,60q0,12.14234-1.128,24.00022",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M51.34928,192.22271a131.40267,131.40267,0,0,0,16.64478-64.21434,59.85046,59.85046,0,0,1,19.99759-44.72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M103.31853,168.00854a170.97437,170.97437,0,0,1-20.308,49.32367",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M179.79526,192.00879a250.02989,250.02989,0,0,1-8.39355,26.119",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M22.276,160.00875a91.80964,91.80964,0,0,0,5.71806-32.00038l.0118.0001a100,100,0,0,1,200,0l-.0118-.0001a293.00937,293.00937,0,0,1-7.03556,64.00068",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M50.68905,184.92207a127.4728,127.4728,0,0,0,13.31718-56.913A63.88065,63.88065,0,0,1,88.0059,78.04632",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128.00623,128.009a191.13407,191.13407,0,0,1-23.97573,92.98042",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96.00623,128.009a32,32,0,0,1,64,0A223.13818,223.13818,0,0,1,138.731,223.41536",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M218.56486,184.00845a289.42035,289.42035,0,0,0,5.441-56,96,96,0,0,0-192,0,95.845,95.845,0,0,1-5.46267,32.00025",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.80577,160.00843a158.95129,158.95129,0,0,1-18.1147,47.84483",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M120.00621,64.50418a64.051,64.051,0,0,1,72,63.50485,258.52451,258.52451,0,0,1-1.98054,31.99945",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M183.94126,192.00844q-2.2851,8.87835-5.18116,17.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M128.00586,24.00842a104.11791,104.11791,0,0,0-104,104A87.786,87.786,0,0,1,19,157.34241a8.00025,8.00025,0,1,0,15.08594,5.332,103.74958,103.74958,0,0,0,5.91992-34.666,88,88,0,0,1,176,0,282.27848,282.27848,0,0,1-5.29,54.45313,7.99962,7.99962,0,1,0,15.69727,3.09375,298.25279,298.25279,0,0,0,5.59277-57.54688A104.11791,104.11791,0,0,0,128.00586,24.00842Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M93.00977,84.2887A8.00025,8.00025,0,0,0,83.00195,71.80432,71.69909,71.69909,0,0,0,56.00586,128.0094,118.80142,118.80142,0,0,1,43.52637,181.361,7.99964,7.99964,0,1,0,57.85254,188.484,134.64637,134.64637,0,0,0,72.00586,128.0094,55.77314,55.77314,0,0,1,93.00977,84.2887Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128.00586,120.0094a8.00039,8.00039,0,0,0-8,8A184.12954,184.12954,0,0,1,97.03418,217.11a7.99993,7.99993,0,1,0,13.99219,7.75977,200.16824,200.16824,0,0,0,24.97949-96.86035A8.00039,8.00039,0,0,0,128.00586,120.0094Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128.00586,88.0094a40.04583,40.04583,0,0,0-40,40,8,8,0,0,0,16,0,24,24,0,0,1,48,0,214.09658,214.09658,0,0,1-20.51074,91.99512,8,8,0,1,0,14.47265,6.82226,229.98738,229.98738,0,0,0,22.03809-98.81738A40.04583,40.04583,0,0,0,128.00586,88.0094Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M94.39648,152.16858a8.00778,8.00778,0,0,0-9.43066,6.249,150.78976,150.78976,0,0,1-17.2041,45.4375,8.00031,8.00031,0,1,0,13.85937,7.9961,166.73312,166.73312,0,0,0,19.02442-50.252A7.99971,7.99971,0,0,0,94.39648,152.16858Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128.00586,56.0094a72.92874,72.92874,0,0,0-8.99121.55664A8.00012,8.00012,0,1,0,120.99707,72.443a56.70946,56.70946,0,0,1,7.00879-.43359,56.0629,56.0629,0,0,1,56,56,251.41194,251.41194,0,0,1-1.919,31.00879,8,8,0,1,0,15.877,1.98047,267.59018,267.59018,0,0,0,2.042-32.98926A72.08124,72.08124,0,0,0,128.00586,56.0094Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M185.93555,184.26135a7.99377,7.99377,0,0,0-9.74121,5.75293c-1.46485,5.68848-3.15332,11.39063-5.01856,16.94824a7.9999,7.9999,0,1,0,15.168,5.0918c1.9873-5.91992,3.78613-11.99316,5.34473-18.05176A7.999,7.999,0,0,0,185.93555,184.26135Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M50.68905,184.92207a127.4728,127.4728,0,0,0,13.31718-56.913A63.88065,63.88065,0,0,1,88.0059,78.04632",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128.00623,128.009a191.13407,191.13407,0,0,1-23.97573,92.98042",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96.00623,128.009a32,32,0,0,1,64,0A223.13818,223.13818,0,0,1,138.731,223.41536",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M218.56486,184.00845a289.42035,289.42035,0,0,0,5.441-56,96,96,0,0,0-192,0,95.845,95.845,0,0,1-5.46267,32.00025",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.80577,160.00843a158.95129,158.95129,0,0,1-18.1147,47.84483",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M120.00621,64.50418a64.051,64.051,0,0,1,72,63.50485,258.52451,258.52451,0,0,1-1.98054,31.99945",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M183.94126,192.00844q-2.2851,8.87835-5.18116,17.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M50.68905,184.92207a127.4728,127.4728,0,0,0,13.31718-56.913A63.88065,63.88065,0,0,1,88.0059,78.04632",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128.00623,128.009a191.13407,191.13407,0,0,1-23.97573,92.98042",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96.00623,128.009a32,32,0,0,1,64,0A223.13818,223.13818,0,0,1,138.731,223.41536",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M218.56486,184.00845a289.42035,289.42035,0,0,0,5.441-56,96,96,0,0,0-192,0,95.845,95.845,0,0,1-5.46267,32.00025",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.80577,160.00843a158.95129,158.95129,0,0,1-18.1147,47.84483",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M120.00621,64.50418a64.051,64.051,0,0,1,72,63.50485,258.52451,258.52451,0,0,1-1.98054,31.99945",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M183.94126,192.00844q-2.2851,8.87835-5.18116,17.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M50.68905,184.92207a127.4728,127.4728,0,0,0,13.31718-56.913A63.88065,63.88065,0,0,1,88.0059,78.04632",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128.00623,128.009a191.13407,191.13407,0,0,1-23.97573,92.98042",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96.00623,128.009a32,32,0,0,1,64,0A223.13818,223.13818,0,0,1,138.731,223.41536",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M218.56486,184.00845a289.42035,289.42035,0,0,0,5.441-56,96,96,0,0,0-192,0,95.845,95.845,0,0,1-5.46267,32.00025",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.80577,160.00843a158.95129,158.95129,0,0,1-18.1147,47.84483",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M120.00621,64.50418a64.051,64.051,0,0,1,72,63.50485,258.52451,258.52451,0,0,1-1.98054,31.99945",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M183.94126,192.00844q-2.2851,8.87835-5.18116,17.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$60 = [];
/* style */

const __vue_inject_styles__$60 = undefined;
/* scoped */

const __vue_scope_id__$60 = undefined;
/* module identifier */

const __vue_module_identifier__$60 = undefined;
/* functional template */

const __vue_is_functional_template__$60 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$60 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$60,
  staticRenderFns: __vue_staticRenderFns__$60
}, __vue_inject_styles__$60, __vue_script__$60, __vue_scope_id__$60, __vue_is_functional_template__$60, __vue_module_identifier__$60, false, undefined, undefined, undefined);

var script$61 = Vue.extend({
  name: "PhFingerprintSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$61 = script$61;
/* template */

var __vue_render__$61 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M175.98828,128.009a239.296,239.296,0,0,1-17.934,91.1974",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M163.76327,96.006a48.00042,48.00042,0,0,0-83.775,32.003,143.35055,143.35055,0,0,1-17.98007,69.73221",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M95.98767,37.47183A96.06707,96.06707,0,0,1,223.98828,128.009a288.94528,288.94528,0,0,1-7.13641,63.99948",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M23.28359,168.00907a95.64559,95.64559,0,0,0,8.70469-40A95.76081,95.76081,0,0,1,63.988,56.45385",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M110.567,208.009q-3.04226,6.62844-6.56532,12.97841",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M127.97656,128.00842a192.34737,192.34737,0,0,1-6.0489,48.00023",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M175.97656,128.009a239.296,239.296,0,0,1-17.934,91.1974",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M163.75156,96.006a48.00043,48.00043,0,0,0-83.775,32.003,143.35055,143.35055,0,0,1-17.98007,69.73221",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M95.976,37.47183A96.06707,96.06707,0,0,1,223.97656,128.009a288.94528,288.94528,0,0,1-7.13641,63.99948",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M23.27187,168.00907a95.64559,95.64559,0,0,0,8.70469-40A95.76081,95.76081,0,0,1,63.97631,56.45385",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M110.55525,208.009q-3.04226,6.62844-6.56531,12.97841",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M127.96484,128.00842a192.34737,192.34737,0,0,1-6.0489,48.00023",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M175.98242,120.0094a8.00039,8.00039,0,0,0-8,8,230.70455,230.70455,0,0,1-17.333,88.15527,8.00032,8.00032,0,1,0,14.79883,6.084,246.6394,246.6394,0,0,0,18.53418-94.23926A8.00039,8.00039,0,0,0,175.98242,120.0094Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M127.98242,88.0094a40.06442,40.06442,0,0,1,29.81445,13.333,8.00032,8.00032,0,1,0,11.92188-10.67188A56.00093,56.00093,0,0,0,71.98242,128.0094,136.088,136.088,0,0,1,55.00586,193.861a7.99993,7.99993,0,1,0,13.99219,7.75977A152.12935,152.12935,0,0,0,87.98242,128.0094,40.04583,40.04583,0,0,1,127.98242,88.0094Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M69.31738,62.41467A7.99966,7.99966,0,1,0,58.64746,50.4928a104.15766,104.15766,0,0,0-34.665,77.5166,87.28655,87.28655,0,0,1-7.97558,36.66308,7.9997,7.9997,0,1,0,14.541,6.67383,103.15936,103.15936,0,0,0,9.43457-43.33691A88.1429,88.1429,0,0,1,69.31738,62.41467Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M127.98242,24.0094a103.7636,103.7636,0,0,0-34.667,5.91992,8.00025,8.00025,0,0,0,5.332,15.08594,88.06652,88.06652,0,0,1,117.335,82.99414,281.58357,281.58357,0,0,1-6.93847,62.22851,8.00013,8.00013,0,1,0,15.60351,3.541,297.64323,297.64323,0,0,0,7.335-65.76953A104.11791,104.11791,0,0,0,127.98242,24.0094Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M113.89844,200.73889a8.00188,8.00188,0,0,0-10.60742,3.93359c-1.92676,4.19727-4.044,8.38086-6.291,12.43555a7.99945,7.99945,0,1,0,13.99219,7.75781c2.44336-4.40625,4.74511-8.95507,6.83984-13.51953A7.999,7.999,0,0,0,113.89844,200.73889Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M127.9707,120.00842a8.00039,8.00039,0,0,0-8,8,184.6862,184.6862,0,0,1-5.79687,46.00586,8.00008,8.00008,0,1,0,15.49512,3.98828,200.70138,200.70138,0,0,0,6.30175-49.99414A8.00039,8.00039,0,0,0,127.9707,120.00842Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M175.99414,128.009a239.296,239.296,0,0,1-17.934,91.1974",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M163.76913,96.006a48.00042,48.00042,0,0,0-83.775,32.003,143.35045,143.35045,0,0,1-17.98008,69.73221",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M95.99353,37.47183A96.06707,96.06707,0,0,1,223.99414,128.009a288.94528,288.94528,0,0,1-7.13641,63.99948",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M23.28945,168.00907a95.64559,95.64559,0,0,0,8.70469-40A95.76081,95.76081,0,0,1,63.99389,56.45385",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M110.57283,208.009q-3.04225,6.62844-6.56532,12.97841",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M127.98242,128.00842a192.34737,192.34737,0,0,1-6.0489,48.00023",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,128.009a239.296,239.296,0,0,1-17.934,91.1974",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M163.775,96.006A48.00042,48.00042,0,0,0,80,128.009a143.35045,143.35045,0,0,1-17.98008,69.73221",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M95.99938,37.47183A96.06708,96.06708,0,0,1,224,128.009a288.94528,288.94528,0,0,1-7.13641,63.99948",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M23.29531,168.00907A95.64559,95.64559,0,0,0,32,128.009,95.76081,95.76081,0,0,1,63.99975,56.45385",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M110.57869,208.009q-3.04225,6.62844-6.56532,12.97841",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M127.98828,128.00842a192.34737,192.34737,0,0,1-6.0489,48.00023",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176.00586,128.009a239.296,239.296,0,0,1-17.934,91.1974",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M163.78085,96.006a48.00042,48.00042,0,0,0-83.775,32.003,143.35045,143.35045,0,0,1-17.98008,69.73221",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96.00524,37.47183A96.06708,96.06708,0,0,1,224.00586,128.009a288.94587,288.94587,0,0,1-7.13641,63.99948",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M23.30117,168.00907a95.64559,95.64559,0,0,0,8.70469-40A95.76078,95.76078,0,0,1,64.00561,56.45385",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M110.58455,208.009q-3.04225,6.62844-6.56532,12.97841",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M127.99414,128.00842a192.34737,192.34737,0,0,1-6.0489,48.00023",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$61 = [];
/* style */

const __vue_inject_styles__$61 = undefined;
/* scoped */

const __vue_scope_id__$61 = undefined;
/* module identifier */

const __vue_module_identifier__$61 = undefined;
/* functional template */

const __vue_is_functional_template__$61 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$61 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$61,
  staticRenderFns: __vue_staticRenderFns__$61
}, __vue_inject_styles__$61, __vue_script__$61, __vue_scope_id__$61, __vue_is_functional_template__$61, __vue_module_identifier__$61, false, undefined, undefined, undefined);

var script$62 = Vue.extend({
  name: "PhFinnTheHuman",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$62 = script$62;
/* template */

var __vue_render__$62 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "56",
      "y": "100.00002",
      "width": "144",
      "height": "80",
      "rx": "32",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M20,64a24,24,0,1,1,48,0H188a24,24,0,0,1,48,0v88a64,64,0,0,1-64,64H84a64,64,0,0,1-64-64Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "96",
      "cy": "140",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "160",
      "cy": "140",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,40a23.99994,23.99994,0,0,0-24,24H72a24,24,0,0,0-48,0v80a64,64,0,0,0,64,64h80a64,64,0,0,0,64-64V64A23.99994,23.99994,0,0,0,208,40Zm-8,104a32,32,0,0,1-32,32H88a32.00034,32.00034,0,0,1-32-32v-8a32,32,0,0,1,32-32h80a31.99971,31.99971,0,0,1,32,32Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "56",
      "y": "104.00002",
      "width": "144",
      "height": "72",
      "rx": "32",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,64a24,24,0,0,1,48,0H184a24,24,0,0,1,48,0v80a64,64,0,0,1-64,64H88a64,64,0,0,1-64-64Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "140",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "140",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,140a12,12,0,1,1-12-12A12.01343,12.01343,0,0,1,176,140ZM92,128a12,12,0,1,0,12,12A12.01343,12.01343,0,0,0,92,128ZM240,64v80a72.08124,72.08124,0,0,1-72,72H88a72.08124,72.08124,0,0,1-72-72V64a32.00221,32.00221,0,0,1,62.98779-8h98.02442A32.00221,32.00221,0,0,1,240,64Zm-40,72a31.99971,31.99971,0,0,0-32-32H88a32,32,0,0,0-32,32v8a32.00034,32.00034,0,0,0,32,32h80a32,32,0,0,0,32-32Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "56",
      "y": "104.00002",
      "width": "144",
      "height": "72",
      "rx": "32",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,64a24,24,0,0,1,48,0H184a24,24,0,0,1,48,0v80a64,64,0,0,1-64,64H88a64,64,0,0,1-64-64Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "140",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "140",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "56",
      "y": "104.00002",
      "width": "144",
      "height": "72",
      "rx": "32",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,64a24,24,0,0,1,48,0H184a24,24,0,0,1,48,0v80a64,64,0,0,1-64,64H88a64,64,0,0,1-64-64Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "140",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "140",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "56",
      "y": "104.00002",
      "width": "144",
      "height": "72",
      "rx": "32",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,64a24,24,0,0,1,48,0H184a24,24,0,0,1,48,0v80a64,64,0,0,1-64,64H88a64,64,0,0,1-64-64Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "140",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "140",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$62 = [];
/* style */

const __vue_inject_styles__$62 = undefined;
/* scoped */

const __vue_scope_id__$62 = undefined;
/* module identifier */

const __vue_module_identifier__$62 = undefined;
/* functional template */

const __vue_is_functional_template__$62 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$62 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$62,
  staticRenderFns: __vue_staticRenderFns__$62
}, __vue_inject_styles__$62, __vue_script__$62, __vue_scope_id__$62, __vue_is_functional_template__$62, __vue_module_identifier__$62, false, undefined, undefined, undefined);

var script$63 = Vue.extend({
  name: "PhFire",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$63 = script$63;
/* template */

var __vue_render__$63 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M171.82072,143.999a44.025,44.025,0,0,1-35.82032,39.2754",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72.03592,65.35733C56.59774,88.63059,44,115.21513,44,140a84,84,0,0,0,168,0c0-52-36-92-65.17642-121.12849l-.00087.00081L112,92,72.037,65.358Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M72.03592,65.35733C56.59774,88.63059,44,115.21513,44,140a84,84,0,0,0,168,0c0-52-36-92-65.17642-121.12849l-.00087.00081L112,92,72.037,65.358Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M179.3884,148.00007a52.03842,52.03842,0,0,1-43.388,43.38828",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72.03592,65.35733C56.59774,88.63059,44,115.21513,44,140a84,84,0,0,0,168,0c0-52-36-92-65.17642-121.12849l-.00087.00081L112,92,72.037,65.358Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M197.12793,66.60449c-13.07471-20.82129-29.90967-38.67578-44.65332-53.39355a7.99863,7.99863,0,0,0-12.87451,2.22168L108.74951,80.21875,76.47363,58.70117a7.99925,7.99925,0,0,0-11.104,2.23438C45.88135,90.31348,36,116.915,36,140a92,92,0,0,0,184,0C220,115.12207,212.51855,91.11426,197.12793,66.60449Zm-9.8335,82.61621a59.69692,59.69692,0,0,1-50.07275,50.07422,8.11543,8.11543,0,0,1-1.231.09473,8.00055,8.00055,0,0,1-1.21142-15.90723,44.31739,44.31739,0,0,0,36.70263-36.70312,7.99993,7.99993,0,1,1,15.8125,2.4414Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M179.3884,148.00007a52.03842,52.03842,0,0,1-43.388,43.38828",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72.03592,65.35733C56.59774,88.63059,44,115.21513,44,140a84,84,0,0,0,168,0c0-52-36-92-65.17642-121.12849l-.00087.00081L112,92,72.037,65.358Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M179.3884,148.00007a52.03842,52.03842,0,0,1-43.388,43.38828",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72.03592,65.35733C56.59774,88.63059,44,115.21513,44,140a84,84,0,0,0,168,0c0-52-36-92-65.17642-121.12849l-.00087.00081L112,92,72.037,65.358Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M179.3884,148.00007a52.03842,52.03842,0,0,1-43.388,43.38828",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72.03592,65.35733C56.59774,88.63059,44,115.21513,44,140a84,84,0,0,0,168,0c0-52-36-92-65.17642-121.12849l-.00087.00081L112,92,72.037,65.358Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$63 = [];
/* style */

const __vue_inject_styles__$63 = undefined;
/* scoped */

const __vue_scope_id__$63 = undefined;
/* module identifier */

const __vue_module_identifier__$63 = undefined;
/* functional template */

const __vue_is_functional_template__$63 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$63 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$63,
  staticRenderFns: __vue_staticRenderFns__$63
}, __vue_inject_styles__$63, __vue_script__$63, __vue_scope_id__$63, __vue_is_functional_template__$63, __vue_module_identifier__$63, false, undefined, undefined, undefined);

var script$64 = Vue.extend({
  name: "PhFireSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$64 = script$64;
/* template */

var __vue_render__$64 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M71.91751,65.35733C56.47932,88.63059,43.88159,115.21513,43.88159,140a84,84,0,0,0,168,0c0-52-36-92-65.17642-121.12849l-.00087.00081L111.88159,92l-39.963-26.642Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M71.91751,65.35733C56.47932,88.63059,43.88159,115.21513,43.88159,140a84,84,0,0,0,168,0c0-52-36-92-65.17642-121.12849l-.00087.00081L111.88159,92l-39.963-26.642Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M71.91751,65.35733C56.47932,88.63059,43.88159,115.21513,43.88159,140a84,84,0,0,0,168,0c0-52-36-92-65.17642-121.12849l-.00087.00081L111.88159,92l-39.963-26.642Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M219.88159,140a92,92,0,0,1-184,0c0-23.085,9.88135-49.68652,29.36963-79.06445a7.99925,7.99925,0,0,1,11.104-2.23438L108.6311,80.21875l30.85059-64.78613a7.99863,7.99863,0,0,1,12.87451-2.22168c14.74365,14.71777,31.57861,32.57226,44.65332,53.39355C212.40014,91.11426,219.88159,115.12207,219.88159,140Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M71.91751,65.35733C56.47932,88.63059,43.88159,115.21513,43.88159,140a84,84,0,0,0,168,0c0-52-36-92-65.17642-121.12849l-.00087.00081L111.88159,92l-39.963-26.642Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M71.91751,65.35733C56.47932,88.63059,43.88159,115.21513,43.88159,140a84,84,0,0,0,168,0c0-52-36-92-65.17642-121.12849l-.00087.00081L111.88159,92l-39.963-26.642Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M71.91751,65.35733C56.47932,88.63059,43.88159,115.21513,43.88159,140a84,84,0,0,0,168,0c0-52-36-92-65.17642-121.12849l-.00087.00081L111.88159,92l-39.963-26.642Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$64 = [];
/* style */

const __vue_inject_styles__$64 = undefined;
/* scoped */

const __vue_scope_id__$64 = undefined;
/* module identifier */

const __vue_module_identifier__$64 = undefined;
/* functional template */

const __vue_is_functional_template__$64 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$64 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$64,
  staticRenderFns: __vue_staticRenderFns__$64
}, __vue_inject_styles__$64, __vue_script__$64, __vue_scope_id__$64, __vue_is_functional_template__$64, __vue_module_identifier__$64, false, undefined, undefined, undefined);

var script$65 = Vue.extend({
  name: "PhFirstAid",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$65 = script$65;
/* template */

var __vue_render__$65 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M96,160H40a8,8,0,0,1-8-8V104a8,8,0,0,1,8-8H96V40a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8V96h56a8,8,0,0,1,8,8v48a8,8,0,0,1-8,8H160v56a8,8,0,0,1-8,8H104a8,8,0,0,1-8-8V160Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M96,160H40a8,8,0,0,1-8-8V104a8,8,0,0,1,8-8H96V40a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8V96h56a8,8,0,0,1,8,8v48a8,8,0,0,1-8,8H160v56a8,8,0,0,1-8,8H104a8,8,0,0,1-8-8V160Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,160H40a8,8,0,0,1-8-8V104a8,8,0,0,1,8-8H96V40a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8V96h56a8,8,0,0,1,8,8v48a8,8,0,0,1-8,8H160v56a8,8,0,0,1-8,8H104a8,8,0,0,1-8-8V160Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232,104v48a16.01833,16.01833,0,0,1-16,16H168v48a16.01833,16.01833,0,0,1-16,16H104a16.01833,16.01833,0,0,1-16-16V168H40a16.01833,16.01833,0,0,1-16-16V104A16.01833,16.01833,0,0,1,40,88H88V40a16.01833,16.01833,0,0,1,16-16h48a16.01833,16.01833,0,0,1,16,16V88h48A16.01833,16.01833,0,0,1,232,104Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M96,160H40a8,8,0,0,1-8-8V104a8,8,0,0,1,8-8H96V40a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8V96h56a8,8,0,0,1,8,8v48a8,8,0,0,1-8,8H160v56a8,8,0,0,1-8,8H104a8,8,0,0,1-8-8V160Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M96,160H40a8,8,0,0,1-8-8V104a8,8,0,0,1,8-8H96V40a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8V96h56a8,8,0,0,1,8,8v48a8,8,0,0,1-8,8H160v56a8,8,0,0,1-8,8H104a8,8,0,0,1-8-8V160Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M96,160H40a8,8,0,0,1-8-8V104a8,8,0,0,1,8-8H96V40a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8V96h56a8,8,0,0,1,8,8v48a8,8,0,0,1-8,8H160v56a8,8,0,0,1-8,8H104a8,8,0,0,1-8-8V160Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$65 = [];
/* style */

const __vue_inject_styles__$65 = undefined;
/* scoped */

const __vue_scope_id__$65 = undefined;
/* module identifier */

const __vue_module_identifier__$65 = undefined;
/* functional template */

const __vue_is_functional_template__$65 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$65 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$65,
  staticRenderFns: __vue_staticRenderFns__$65
}, __vue_inject_styles__$65, __vue_script__$65, __vue_scope_id__$65, __vue_is_functional_template__$65, __vue_module_identifier__$65, false, undefined, undefined, undefined);

var script$66 = Vue.extend({
  name: "PhFirstAidKit",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$66 = script$66;
/* template */

var __vue_render__$66 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "116",
      "x2": "128",
      "y2": "172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "144",
      "x2": "100",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32.00781",
      "y": "72.00005",
      "width": "192",
      "height": "144",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,72V52a16,16,0,0,0-16-16H104A16,16,0,0,0,88,52V72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32.00781",
      "y": "72.00005",
      "width": "192",
      "height": "144",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "116",
      "x2": "128",
      "y2": "172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "144",
      "x2": "100",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32.00781",
      "y": "72.00005",
      "width": "192",
      "height": "144",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,72V56a16,16,0,0,0-16-16H104A16,16,0,0,0,88,56V72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216.00781,64H176V56a24.0275,24.0275,0,0,0-24-24H104A24.0275,24.0275,0,0,0,80,56v8H40.00781a16.01833,16.01833,0,0,0-16,16V208a16.01833,16.01833,0,0,0,16,16h176a16.01833,16.01833,0,0,0,16-16V80A16.01833,16.01833,0,0,0,216.00781,64ZM96,56a8.00917,8.00917,0,0,1,8-8h48a8.00917,8.00917,0,0,1,8,8v8H96Zm60,96H136v20a8,8,0,0,1-16,0V152H100a8,8,0,0,1,0-16h20V116a8,8,0,0,1,16,0v20h20a8,8,0,0,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "116",
      "x2": "128",
      "y2": "172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "144",
      "x2": "100",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32.00781",
      "y": "72.00005",
      "width": "192",
      "height": "144",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,72V56a16,16,0,0,0-16-16H104A16,16,0,0,0,88,56V72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "116",
      "x2": "128",
      "y2": "172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "144",
      "x2": "100",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32.00781",
      "y": "72.00005",
      "width": "192",
      "height": "144",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,72V56a16,16,0,0,0-16-16H104A16,16,0,0,0,88,56V72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "144",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,72V56a16,16,0,0,0-16-16H104A16,16,0,0,0,88,56V72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "116",
      "x2": "128",
      "y2": "172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "144",
      "x2": "100",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$66 = [];
/* style */

const __vue_inject_styles__$66 = undefined;
/* scoped */

const __vue_scope_id__$66 = undefined;
/* module identifier */

const __vue_module_identifier__$66 = undefined;
/* functional template */

const __vue_is_functional_template__$66 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$66 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$66,
  staticRenderFns: __vue_staticRenderFns__$66
}, __vue_inject_styles__$66, __vue_script__$66, __vue_scope_id__$66, __vue_is_functional_template__$66, __vue_module_identifier__$66, false, undefined, undefined, undefined);

var script$67 = Vue.extend({
  name: "PhFish",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$67 = script$67;
/* template */

var __vue_render__$67 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "156",
      "cy": "76",
      "r": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M186.30284,167.94573Q185.15821,167.99979,184,168a48,48,0,0,1-48-48A48,48,0,0,1,88,72q0-1.16456.05488-2.31579",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M62.177,153.17849,12,175.96316,64,192l16,52,22.8003-50.20045v.00009c138.35934-3.2851,120.00626-122.89746,114.38209-148.8602a7.98721,7.98721,0,0,0-6.1218-6.12182C185.099,33.19376,65.49508,14.84213,62.17691,153.17849Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M88.05489,69.68421c-14.74239,17.88968-24.94149,44.45157-25.878,83.49428h.0001L8,175.96316,64,192l16,56,22.8003-54.20045v.00009c39.04488-.92705,65.60976-11.118,83.50255-25.85391Q185.1582,167.99979,184,168a48,48,0,0,1-48-48A48,48,0,0,1,88,72Q88,70.83544,88.05489,69.68421Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "76",
      "r": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M186.30284,167.94573Q185.15821,167.99979,184,168a48,48,0,0,1-48-48A48,48,0,0,1,88,72q0-1.16456.05488-2.31579",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M62.177,153.17849,8,175.96316,64,192l16,56,22.8003-54.20045v.00009c138.35934-3.2851,120.00626-122.89746,114.38209-148.8602a7.98721,7.98721,0,0,0-6.1218-6.12182C185.099,33.19376,65.49508,14.84213,62.17691,153.17849Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M168,76a12,12,0,1,1-12-12A12,12,0,0,1,168,76Zm37.708,83.49292c-20.42774,25.95142-53.21875,40.1106-97.51758,42.12524L87.374,251.10205A7.99987,7.99987,0,0,1,80.00293,256c-.16016,0-.32129-.00488-.48242-.01416a8.0008,8.0008,0,0,1-7.21289-5.78809l-14.7793-51.72949L5.79785,183.6543a8.00035,8.00035,0,0,1-.89941-15.06543l49.46094-20.80152c2.02539-44.28955,16.19042-77.074,42.14355-97.49829,41.11816-32.35791,99.376-22.94629,116.251-19.29A16.03051,16.03051,0,0,1,225.001,43.24487C228.65723,60.12231,238.07031,118.3811,205.708,159.49292Zm3.65625-112.85986C194.2168,43.35449,142.02148,34.82642,106.39844,62.8623a78.69585,78.69585,0,0,0-10.38086,9.83619A40.03964,40.03964,0,0,0,136,112a8.00024,8.00024,0,0,1,8,8,40.039,40.039,0,0,0,39.29077,39.98193,78.64492,78.64492,0,0,0,9.845-10.38549C221.17383,113.978,212.64551,61.78223,209.36426,46.63306Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "156",
      "cy": "76",
      "r": "10"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M186.30284,167.94573Q185.15821,167.99979,184,168a48,48,0,0,1-48-48A48,48,0,0,1,88,72q0-1.16456.05488-2.31579",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M62.177,153.17849,8,175.96316,64,192l16,56,22.8003-54.20045v.00009c138.35934-3.2851,120.00626-122.89746,114.38209-148.8602a7.98721,7.98721,0,0,0-6.1218-6.12182C185.099,33.19376,65.49508,14.84213,62.17691,153.17849Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "156",
      "cy": "76",
      "r": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M186.30284,167.94573Q185.15821,167.99979,184,168a48,48,0,0,1-48-48A48,48,0,0,1,88,72q0-1.16456.05488-2.31579",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M62.177,153.17849,8,175.96316,64,192l16,56,22.8003-54.20045v.00009c138.35934-3.2851,120.00626-122.89746,114.38209-148.8602a7.98721,7.98721,0,0,0-6.1218-6.12182C185.099,33.19376,65.49508,14.84213,62.17691,153.17849Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "156",
      "cy": "76",
      "r": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M186.30284,167.94573Q185.15821,167.99979,184,168a48,48,0,0,1-48-48A48,48,0,0,1,88,72q0-1.16456.05488-2.31579",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M62.177,153.17849,8,175.96316,64,192l16,56,22.8003-54.20045v.00009c138.35934-3.2851,120.00626-122.89746,114.38209-148.8602a7.98721,7.98721,0,0,0-6.1218-6.12182C185.099,33.19376,65.49508,14.84213,62.17691,153.17849Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$67 = [];
/* style */

const __vue_inject_styles__$67 = undefined;
/* scoped */

const __vue_scope_id__$67 = undefined;
/* module identifier */

const __vue_module_identifier__$67 = undefined;
/* functional template */

const __vue_is_functional_template__$67 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$67 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$67,
  staticRenderFns: __vue_staticRenderFns__$67
}, __vue_inject_styles__$67, __vue_script__$67, __vue_scope_id__$67, __vue_is_functional_template__$67, __vue_module_identifier__$67, false, undefined, undefined, undefined);

var script$68 = Vue.extend({
  name: "PhFishSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$68 = script$68;
/* template */

var __vue_render__$68 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "156",
      "cy": "76",
      "r": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16,183.96316C247.8414,234.71183,223.79084,75.46765,217.18687,44.9601a8.01954,8.01954,0,0,0-6.147-6.147C180.5321,32.20917,21.28468,8.15854,72,240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M201.34694,151.99061A96.0002,96.0002,0,0,1,104.00959,54.639",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M104.00858,54.63764C75.88186,75.1517,55.69935,115.413,63.9833,191.98326h0c76.58162,8.3037,116.85108-11.867,137.3707-39.98746l-.00709-.00518A96.0002,96.0002,0,0,1,104.00959,54.639Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "76",
      "r": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16,183.96316C247.8414,234.71183,223.79084,75.46765,217.18687,44.9601a8.01954,8.01954,0,0,0-6.147-6.147C180.5321,32.20917,21.28468,8.15854,72,240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M201.34694,151.99061A96.0002,96.0002,0,0,1,104.00959,54.639",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M168,76a12,12,0,1,1-12-12A12,12,0,0,1,168,76Zm30.166,91.978c-26.47168,26.41015-68.41309,37.40625-125.05957,32.89013q2.40673,17.75244,6.709,37.42237a8.0002,8.0002,0,1,1-15.63086,3.41894q-4.894-22.377-7.40723-42.52148-20.12549-2.51661-42.48828-7.40967a8,8,0,1,1,3.42188-15.62988q19.64795,4.30077,37.38965,6.70947c-4.501-56.63525,6.502-98.55469,32.91113-125.02148C129.00684,16.752,193.83984,26.90332,212.73242,30.99414a16.05936,16.05936,0,0,1,12.27246,12.273C229.0957,62.16064,239.24805,126.99023,198.166,167.978Zm11.20117-121.3252c-15.00171-3.26269-62.22412-10.852-97.31543,12.15283a87.969,87.969,0,0,0,85.14136,85.13916C220.20068,108.85791,212.61182,61.63721,209.36719,46.65283Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "156",
      "cy": "76",
      "r": "10"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16,183.96316C247.8414,234.71183,223.79084,75.46765,217.18687,44.9601a8.01954,8.01954,0,0,0-6.147-6.147C180.5321,32.20917,21.28468,8.15854,72,240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M201.34694,151.99061A96.0002,96.0002,0,0,1,104.00959,54.639",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "156",
      "cy": "76",
      "r": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16,183.96316C247.8414,234.71183,223.79084,75.46765,217.18687,44.9601a8.01954,8.01954,0,0,0-6.147-6.147C180.5321,32.20917,21.28468,8.15854,72,240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M201.34694,151.99061A96.0002,96.0002,0,0,1,104.00959,54.639",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "156",
      "cy": "76",
      "r": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16,183.96316C247.8414,234.71183,223.79084,75.46765,217.18687,44.9601a8.01954,8.01954,0,0,0-6.147-6.147C180.5321,32.20917,21.28468,8.15854,72,240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M201.34694,151.99061A96.0002,96.0002,0,0,1,104.00959,54.639",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$68 = [];
/* style */

const __vue_inject_styles__$68 = undefined;
/* scoped */

const __vue_scope_id__$68 = undefined;
/* module identifier */

const __vue_module_identifier__$68 = undefined;
/* functional template */

const __vue_is_functional_template__$68 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$68 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$68,
  staticRenderFns: __vue_staticRenderFns__$68
}, __vue_inject_styles__$68, __vue_script__$68, __vue_scope_id__$68, __vue_is_functional_template__$68, __vue_module_identifier__$68, false, undefined, undefined, undefined);

var script$69 = Vue.extend({
  name: "PhFlag",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$69 = script$69;
/* template */

var __vue_render__$69 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "216.00452",
      "x2": "40",
      "y2": "48.00452",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M39.99951,168.00452c64-48,112,48,176,0v-120c-64,48-112-48-176,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M39.99951,168.00452c64-48,112,48,176,0v-120c-64,48-112-48-176,0Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "216.00452",
      "x2": "40",
      "y2": "48.00452",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M39.99951,168.00452c64-48,112,48,176,0v-120c-64,48-112-48-176,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M219.57764,40.84924a7.99605,7.99605,0,0,0-8.37793.75489c-28.29981,21.22558-52.28223,10.94726-80.04883-.95313-28.24414-12.10449-60.25488-25.81934-95.95117.95313-.04737.0354-.08838.07568-.13428.11181-.11084.08692-.21777.17676-.32373.26929-.09912.08667-.19727.17407-.291.26465-.0874.08423-.17138.17138-.25488.25952-.1001.10547-.19873.21142-.292.32129-.0708.08349-.1377.16968-.20508.25586-.09277.11865-.18457.23779-.26953.36084-.06348.09082-.12158.18457-.18115.27807-.07715.12232-.1543.24439-.22461.37036-.06006.10694-.11475.217-.16992.32715-.05811.1167-.11719.23291-.16944.35181-.05566.126-.105.25513-.15429.38428-.04151.10913-.0835.218-.12012.32861-.04541.137-.084.27661-.12207.417-.03028.11084-.06055.22119-.08594.33325-.03027.13526-.05518.27271-.07861.41065-.02149.12524-.042.25024-.05762.37646-.01514.12427-.02588.24927-.03564.37525-.01075.14575-.01856.2915-.022.43774-.001.05615-.0083.11035-.0083.16651v168a8,8,0,0,0,16,0V172.13879c26.92334-18.16259,50.13623-8.22973,76.84863,3.21924,16.26368,6.96973,33.7754,14.47559,52.52247,14.47461,13.80859,0,28.2871-4.07226,43.42871-15.42773a8.00094,8.00094,0,0,0,3.20019-6.40039v-120A8.00023,8.00023,0,0,0,219.57764,40.84924Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "216.00452",
      "x2": "40",
      "y2": "48.00452",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M39.99951,168.00452c64-48,112,48,176,0v-120c-64,48-112-48-176,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "216.00452",
      "x2": "40",
      "y2": "48.00452",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M39.99951,168.00452c64-48,112,48,176,0v-120c-64,48-112-48-176,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "216.00452",
      "x2": "40",
      "y2": "48.00452",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M39.99951,168.00452c64-48,112,48,176,0v-120c-64,48-112-48-176,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$69 = [];
/* style */

const __vue_inject_styles__$69 = undefined;
/* scoped */

const __vue_scope_id__$69 = undefined;
/* module identifier */

const __vue_module_identifier__$69 = undefined;
/* functional template */

const __vue_is_functional_template__$69 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$69 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$69,
  staticRenderFns: __vue_staticRenderFns__$69
}, __vue_inject_styles__$69, __vue_script__$69, __vue_scope_id__$69, __vue_is_functional_template__$69, __vue_module_identifier__$69, false, undefined, undefined, undefined);

var script$6a = Vue.extend({
  name: "PhFlagBanner",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6a = script$6a;
/* template */

var __vue_render__$6a = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "40 216 40 48 40 48 224 48 176 108 224 168 40 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "40 48 40 48 224 48 176 108 224 168 40 168 40 48",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "40 216 40 48 40 48 224 48 176 108 224 168 40 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M230.24694,163.00293A8,8,0,0,1,223.99988,176H48v40a8,8,0,1,1-16,0V48a8.00039,8.00039,0,0,1,8-8H223.99988a8,8,0,0,1,6.24706,12.99707L186.245,108Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "40 216 40 48 40 48 224 48 176 108 224 168 40 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "40 216 40 48 40 48 224 48 176 108 224 168 40 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "40 216 40 48 40 48 224 48 176 108 224 168 40 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6a = [];
/* style */

const __vue_inject_styles__$6a = undefined;
/* scoped */

const __vue_scope_id__$6a = undefined;
/* module identifier */

const __vue_module_identifier__$6a = undefined;
/* functional template */

const __vue_is_functional_template__$6a = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6a = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6a,
  staticRenderFns: __vue_staticRenderFns__$6a
}, __vue_inject_styles__$6a, __vue_script__$6a, __vue_scope_id__$6a, __vue_is_functional_template__$6a, __vue_module_identifier__$6a, false, undefined, undefined, undefined);

var script$6b = Vue.extend({
  name: "PhFlame",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6b = script$6b;
/* template */

var __vue_render__$6b = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,144c0-72-80-120-80-120S48,72,48,144a80,80,0,0,0,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,184a40,40,0,0,0,80,0c0-40-40-64-40-64S88,144,88,184Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24S48,72,48,144a79.98371,79.98371,0,0,0,77.94141,79.948A40.00143,40.00143,0,0,1,88,184c0-40,40-64,40-64s40,24,40,64a40.00143,40.00143,0,0,1-37.94141,39.948A79.98337,79.98337,0,0,0,208,144C208,72,128,24,128,24Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,144c0-72-80-120-80-120S48,72,48,144a80,80,0,0,0,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,184a40,40,0,0,0,80,0c0-40-40-64-40-64S88,144,88,184Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M173.793,51.48242a220.94852,220.94852,0,0,0-41.67676-34.34277,8.00334,8.00334,0,0,0-8.23242,0A220.94852,220.94852,0,0,0,82.207,51.48242C54.59473,80.47559,40,112.4668,40,144a88,88,0,0,0,176,0C216,112.4668,201.40527,80.47559,173.793,51.48242ZM96,184c0-27.67285,22.52637-47.27734,31.999-54.29688C137.48193,136.72949,160,156.332,160,184a32,32,0,0,1-64,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,144c0-72-80-120-80-120S48,72,48,144a80,80,0,0,0,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,184a40,40,0,0,0,80,0c0-40-40-64-40-64S88,144,88,184Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,144c0-72-80-120-80-120S48,72,48,144a80,80,0,0,0,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,184a40,40,0,0,0,80,0c0-40-40-64-40-64S88,144,88,184Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,144c0-72-80-120-80-120S48,72,48,144a80,80,0,0,0,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,184a40,40,0,0,0,80,0c0-40-40-64-40-64S88,144,88,184Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6b = [];
/* style */

const __vue_inject_styles__$6b = undefined;
/* scoped */

const __vue_scope_id__$6b = undefined;
/* module identifier */

const __vue_module_identifier__$6b = undefined;
/* functional template */

const __vue_is_functional_template__$6b = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6b = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6b,
  staticRenderFns: __vue_staticRenderFns__$6b
}, __vue_inject_styles__$6b, __vue_script__$6b, __vue_scope_id__$6b, __vue_is_functional_template__$6b, __vue_module_identifier__$6b, false, undefined, undefined, undefined);

var script$6c = Vue.extend({
  name: "PhFlashlight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6c = script$6c;
/* template */

var __vue_render__$6c = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M72.00244,24h112a8,8,0,0,1,8,8V77.33333a8,8,0,0,1-1.6,4.8l-20.8,27.73334a8,8,0,0,0-1.6,4.8V224a8,8,0,0,1-8,8h-64a8,8,0,0,1-8-8V114.66667a8,8,0,0,0-1.6-4.8l-20.8-27.73334a8,8,0,0,1-1.6-4.8V32A8,8,0,0,1,72.00244,24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128.00244",
      "y1": "120",
      "x2": "128.00244",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64.00244",
      "y1": "64",
      "x2": "192.00244",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M192.00244,77.33333a8,8,0,0,1-1.6,4.8l-20.8,27.73334a8,8,0,0,0-1.6,4.8V224a8,8,0,0,1-8,8h-64a8,8,0,0,1-8-8V114.66667a8,8,0,0,0-1.6-4.8l-20.8-27.73334a8,8,0,0,1-1.6-4.8V64h128Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72.00244,24h112a8,8,0,0,1,8,8V77.33333a8,8,0,0,1-1.6,4.8l-20.8,27.73334a8,8,0,0,0-1.6,4.8V224a8,8,0,0,1-8,8h-64a8,8,0,0,1-8-8V114.66667a8,8,0,0,0-1.6-4.8l-20.8-27.73334a8,8,0,0,1-1.6-4.8V32A8,8,0,0,1,72.00244,24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128.00244",
      "y1": "120",
      "x2": "128.00244",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64.00244",
      "y1": "64",
      "x2": "192.00244",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M184.00244,16h-112a16.01833,16.01833,0,0,0-16,16V77.333a16.10105,16.10105,0,0,0,3.2002,9.60058l20.7998,27.7334V224a16.01833,16.01833,0,0,0,16,16h64a16.01833,16.01833,0,0,0,16-16l-.001-109.334,20.80274-27.7334a16.10719,16.10719,0,0,0,3.19824-9.59961V32A16.01833,16.01833,0,0,0,184.00244,16Zm-48,136a8,8,0,0,1-16,0V120a8,8,0,0,1,16,0ZM71.99805,56l-.00537-24H184.00244l.00049,24Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M72.00244,24h112a8,8,0,0,1,8,8V77.33333a8,8,0,0,1-1.6,4.8l-20.8,27.73334a8,8,0,0,0-1.6,4.8V224a8,8,0,0,1-8,8h-64a8,8,0,0,1-8-8V114.66667a8,8,0,0,0-1.6-4.8l-20.8-27.73334a8,8,0,0,1-1.6-4.8V32A8,8,0,0,1,72.00244,24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128.00244",
      "y1": "120",
      "x2": "128.00244",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64.00244",
      "y1": "64",
      "x2": "192.00244",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M72.00244,24h112a8,8,0,0,1,8,8V77.33333a8,8,0,0,1-1.6,4.8l-20.8,27.73334a8,8,0,0,0-1.6,4.8V224a8,8,0,0,1-8,8h-64a8,8,0,0,1-8-8V114.66667a8,8,0,0,0-1.6-4.8l-20.8-27.73334a8,8,0,0,1-1.6-4.8V32A8,8,0,0,1,72.00244,24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128.00244",
      "y1": "120",
      "x2": "128.00244",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64.00244",
      "y1": "64",
      "x2": "192.00244",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M72.00244,24h112a8,8,0,0,1,8,8V77.33333a8,8,0,0,1-1.6,4.8l-20.8,27.73334a8,8,0,0,0-1.6,4.8V224a8,8,0,0,1-8,8h-64a8,8,0,0,1-8-8V114.66667a8,8,0,0,0-1.6-4.8l-20.8-27.73334a8,8,0,0,1-1.6-4.8V32A8,8,0,0,1,72.00244,24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128.00244",
      "y1": "120",
      "x2": "128.00244",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64.00244",
      "y1": "64",
      "x2": "192.00244",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6c = [];
/* style */

const __vue_inject_styles__$6c = undefined;
/* scoped */

const __vue_scope_id__$6c = undefined;
/* module identifier */

const __vue_module_identifier__$6c = undefined;
/* functional template */

const __vue_is_functional_template__$6c = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6c = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6c,
  staticRenderFns: __vue_staticRenderFns__$6c
}, __vue_inject_styles__$6c, __vue_script__$6c, __vue_scope_id__$6c, __vue_is_functional_template__$6c, __vue_module_identifier__$6c, false, undefined, undefined, undefined);

var script$6d = Vue.extend({
  name: "PhFlask",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6d = script$6d;
/* template */

var __vue_render__$6d = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M104,32V93.78413a7.99992,7.99992,0,0,1-1.14006,4.116L39.26958,203.884A8,8,0,0,0,46.12952,216h163.741a8,8,0,0,0,6.85994-12.116L153.14006,97.90009A7.99992,7.99992,0,0,1,152,93.78413V32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "32",
      "x2": "168",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M62.61682,164.96456C74.44058,156.34675,94.73752,151.36876,128,168c35.70432,17.85216,56.4696,10.80591,67.852,1.08577",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M104,32V93.78413a7.99992,7.99992,0,0,1-1.14006,4.116L39.26958,203.884A8,8,0,0,0,46.12952,216h163.741a8,8,0,0,0,6.85994-12.116L153.14006,97.90009A7.99992,7.99992,0,0,1,152,93.78413V32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "32",
      "x2": "168",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M62.61682,164.96456C74.44058,156.34675,94.73752,151.36876,128,168c35.70432,17.85216,56.4696,10.80591,67.852,1.08577",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M62.62009,164.96652,39.26958,203.884A8,8,0,0,0,46.12952,216h163.741a8,8,0,0,0,6.85994-12.116l-20.87883-34.798.00037-.00022C184.4696,178.80591,163.70432,185.85216,128,168c-33.26248-16.63124-53.55942-11.65325-65.38318-3.03544Z",
      "opacity": "0.2"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M223.59033,199.76855,160,93.78418V40h8a8,8,0,0,0,0-16H88a8,8,0,0,0,0,16h8V93.78418l-40.17285,66.955c-.044.07067-.08643.1416-.12793.2135L32.40967,199.76807A15.99968,15.99968,0,0,0,46.12988,224H209.87012a15.99944,15.99944,0,0,0,13.72021-24.23145Zm-113.87109-97.752A15.99829,15.99829,0,0,0,112,93.78418V40h32V93.78418a15.99947,15.99947,0,0,0,2.28027,8.23193l38.86328,64.77222c-13.10742,7.11157-31.4458,5.11572-53.56591-5.9436-14.25293-7.127-32.667-13.52124-50.31055-11.4076Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M104,32V93.78413a7.99992,7.99992,0,0,1-1.14006,4.116L39.26958,203.884A8,8,0,0,0,46.12952,216h163.741a8,8,0,0,0,6.85994-12.116L153.14006,97.90009A7.99992,7.99992,0,0,1,152,93.78413V32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "32",
      "x2": "168",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M62.61682,164.96456C74.44058,156.34675,94.73752,151.36876,128,168c35.70432,17.85216,56.4696,10.80591,67.852,1.08577",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M104,32V93.78413a7.99992,7.99992,0,0,1-1.14006,4.116L39.26958,203.884A8,8,0,0,0,46.12952,216h163.741a8,8,0,0,0,6.85994-12.116L153.14006,97.90009A7.99992,7.99992,0,0,1,152,93.78413V32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "32",
      "x2": "168",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M62.61682,164.96456C74.44058,156.34675,94.73752,151.36876,128,168c35.70432,17.85216,56.4696,10.80591,67.852,1.08577",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M104,32V93.78413a7.99992,7.99992,0,0,1-1.14006,4.116L39.26958,203.884A8,8,0,0,0,46.12952,216h163.741a8,8,0,0,0,6.85994-12.116L153.14006,97.90009A7.99992,7.99992,0,0,1,152,93.78413V32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "32",
      "x2": "168",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M62.61682,164.96456C74.44058,156.34675,94.73752,151.36876,128,168c35.70432,17.85216,56.4696,10.80591,67.852,1.08577",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6d = [];
/* style */

const __vue_inject_styles__$6d = undefined;
/* scoped */

const __vue_scope_id__$6d = undefined;
/* module identifier */

const __vue_module_identifier__$6d = undefined;
/* functional template */

const __vue_is_functional_template__$6d = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6d = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6d,
  staticRenderFns: __vue_staticRenderFns__$6d
}, __vue_inject_styles__$6d, __vue_script__$6d, __vue_scope_id__$6d, __vue_is_functional_template__$6d, __vue_module_identifier__$6d, false, undefined, undefined, undefined);

var script$6e = Vue.extend({
  name: "PhFloppyDisk",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6e = script$6e;
/* template */

var __vue_render__$6e = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,91.31371V208a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H164.68629a8,8,0,0,1,5.65686,2.34315l43.3137,43.3137A8,8,0,0,1,216,91.31371Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,216.00842v-64a8,8,0,0,1,8-8h80a8,8,0,0,1,8,8v64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "80.00903",
      "x2": "96",
      "y2": "80.00903",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,216.00842v-64a8,8,0,0,1,8-8h80a8,8,0,0,1,8,8v64L208,216a8,8,0,0,0,8-8V91.31371a8,8,0,0,0-2.34315-5.65686l-43.3137-43.3137A8,8,0,0,0,164.68629,40H48a8,8,0,0,0-8,8V208a8,8,0,0,0,8,8Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,91.31371V208a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H164.68629a8,8,0,0,1,5.65686,2.34315l43.3137,43.3137A8,8,0,0,1,216,91.31371Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,216.00842v-64a8,8,0,0,1,8-8h80a8,8,0,0,1,8,8v64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "72.00903",
      "x2": "96",
      "y2": "72.00903",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M219.31445,79.99963,176.001,36.68811a15.88944,15.88944,0,0,0-11.31446-4.68848H48a16.01833,16.01833,0,0,0-16,16v160a16.01833,16.01833,0,0,0,16,16H79.82617c.05835.00122.11524.00879.17383.00879s.11548-.00757.17383-.00879h95.65234c.05835.00122.11524.00879.17383.00879s.11548-.00757.17383-.00879H208a16.01833,16.01833,0,0,0,16-16V91.31409A15.898,15.898,0,0,0,219.31445,79.99963ZM208,91.31409V207.99963H184V152.00842a16.01833,16.01833,0,0,0-16-16H88a16.01833,16.01833,0,0,0-16,16v55.99121H48v-160l116.68555.001L208,91.31409v-.001l8,.001ZM160,72.0094a8.00039,8.00039,0,0,1-8,8H96a8,8,0,0,1,0-16h56A8.00039,8.00039,0,0,1,160,72.0094Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,91.31371V208a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H164.68629a8,8,0,0,1,5.65686,2.34315l43.3137,43.3137A8,8,0,0,1,216,91.31371Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,216.00842v-64a8,8,0,0,1,8-8h80a8,8,0,0,1,8,8v64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "72.00903",
      "x2": "96",
      "y2": "72.00903",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,91.31371V208a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H164.68629a8,8,0,0,1,5.65686,2.34315l43.3137,43.3137A8,8,0,0,1,216,91.31371Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,216.00842v-64a8,8,0,0,1,8-8h80a8,8,0,0,1,8,8v64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "72.00903",
      "x2": "96",
      "y2": "72.00903",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,91.31371V208a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H164.68629a8,8,0,0,1,5.65686,2.34315l43.3137,43.3137A8,8,0,0,1,216,91.31371Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,216.00842v-64a8,8,0,0,1,8-8h80a8,8,0,0,1,8,8v64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "72.00903",
      "x2": "96",
      "y2": "72.00903",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6e = [];
/* style */

const __vue_inject_styles__$6e = undefined;
/* scoped */

const __vue_scope_id__$6e = undefined;
/* module identifier */

const __vue_module_identifier__$6e = undefined;
/* functional template */

const __vue_is_functional_template__$6e = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6e = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6e,
  staticRenderFns: __vue_staticRenderFns__$6e
}, __vue_inject_styles__$6e, __vue_script__$6e, __vue_scope_id__$6e, __vue_is_functional_template__$6e, __vue_module_identifier__$6e, false, undefined, undefined, undefined);

var script$6f = Vue.extend({
  name: "PhFloppyDiskBack",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6f = script$6f;
/* template */

var __vue_render__$6f = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,91.31371V208a8,8,0,0,0,8,8H208a8,8,0,0,0,8-8V48a8,8,0,0,0-8-8H91.31371a8,8,0,0,0-5.65686,2.34315l-43.3137,43.3137A8,8,0,0,0,40,91.31371Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128.0059",
      "cy": "148.009",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "104 80.009 160 80.009 160 40.009",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,40.00012H91.31372a8.00052,8.00052,0,0,0-5.657,2.343L42.34326,85.65686A7.99918,7.99918,0,0,0,40,91.3136V208.00012a8.00009,8.00009,0,0,0,8,8H208a8.00009,8.00009,0,0,0,8-8v-160A7.99993,7.99993,0,0,0,208,40.00012ZM128.00586,176.00891a28,28,0,1,1,28-28A28,28,0,0,1,128.00586,176.00891Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,91.31371V208a8,8,0,0,0,8,8H208a8,8,0,0,0,8-8V48a8,8,0,0,0-8-8H91.31371a8,8,0,0,0-5.65686,2.34315l-43.3137,43.3137A8,8,0,0,0,40,91.31371Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128.0059",
      "cy": "148.009",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 80.009 160 80.009 160 40.009",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,31.99963H168V80.0094a8.00039,8.00039,0,0,1-8,8H96a8,8,0,0,1,0-16h56V31.99963H91.31348A15.89171,15.89171,0,0,0,80,36.68616L36.68555,79.99963A15.898,15.898,0,0,0,32,91.31409V207.99963a16.01833,16.01833,0,0,0,16,16H208a16.01833,16.01833,0,0,0,16-16v-160A16.01833,16.01833,0,0,0,208,31.99963ZM128,176a28,28,0,1,1,28-28A28.0316,28.0316,0,0,1,128,176Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,91.31371V208a8,8,0,0,0,8,8H208a8,8,0,0,0,8-8V48a8,8,0,0,0-8-8H91.31371a8,8,0,0,0-5.65686,2.34315l-43.3137,43.3137A8,8,0,0,0,40,91.31371Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128.0059",
      "cy": "148.009",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 80.009 160 80.009 160 40.009",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,91.31371V208a8,8,0,0,0,8,8H208a8,8,0,0,0,8-8V48a8,8,0,0,0-8-8H91.31371a8,8,0,0,0-5.65686,2.34315l-43.3137,43.3137A8,8,0,0,0,40,91.31371Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128.0059",
      "cy": "148.009",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 80.009 160 80.009 160 40.009",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,91.31371V208a8,8,0,0,0,8,8H208a8,8,0,0,0,8-8V48a8,8,0,0,0-8-8H91.31371a8,8,0,0,0-5.65686,2.34315l-43.3137,43.3137A8,8,0,0,0,40,91.31371Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128.0059",
      "cy": "148.009",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 80.009 160 80.009 160 40.009",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6f = [];
/* style */

const __vue_inject_styles__$6f = undefined;
/* scoped */

const __vue_scope_id__$6f = undefined;
/* module identifier */

const __vue_module_identifier__$6f = undefined;
/* functional template */

const __vue_is_functional_template__$6f = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6f = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6f,
  staticRenderFns: __vue_staticRenderFns__$6f
}, __vue_inject_styles__$6f, __vue_script__$6f, __vue_scope_id__$6f, __vue_is_functional_template__$6f, __vue_module_identifier__$6f, false, undefined, undefined, undefined);

var script$6g = Vue.extend({
  name: "PhFlowArrow",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6g = script$6g;
/* template */

var __vue_render__$6g = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "44",
      "cy": "176",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "200 40 240 80 200 120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,176h8.00005a48,48,0,0,0,48-48V128A48,48,0,0,1,176,80h64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "44",
      "cy": "176",
      "r": "28",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "44",
      "cy": "176",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "200 40 240 80 200 120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,176h8.00005a48,48,0,0,0,48-48V128A48,48,0,0,1,176,80h64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M245.81592,85.48145c-.0542.0581-.10205.11914-.15869.17578l-40,40a8.00053,8.00053,0,0,1-11.31446-11.31446L220.68652,88H176a40.04584,40.04584,0,0,0-40,40,56.0629,56.0629,0,0,1-56,56h-.90723a36,36,0,1,1,0-16H80a40.04584,40.04584,0,0,0,40-40,56.0629,56.0629,0,0,1,56-56h44.68652L194.34277,45.65723a8.00053,8.00053,0,0,1,11.31446-11.31446l40,40c.05664.05664.10449.11768.15869.17578.12549.13282.251.26514.36719.40625.0913.11084.17138.22706.25537.3418.07031.09522.14453.188.21093.28662.085.12647.15918.25782.23584.38819.05567.09423.11524.186.167.2832.06933.12891.12841.26172.18994.39355.04931.10547.10205.209.147.31641.05225.127.09522.25586.14063.38477.042.11816.0874.23437.124.355.03906.1289.06787.25976.10058.39013.03077.12305.06543.24414.09034.36914.02978.15186.04834.30469.06933.45752.01465.106.03516.20948.0459.3169a8.02276,8.02276,0,0,1,0,1.584c-.01074.10742-.03125.21094-.0459.3169-.021.15283-.03955.30566-.06933.45752-.02491.125-.05957.24609-.09034.36914-.03271.13037-.06152.26123-.10058.39013-.03662.12061-.082.23682-.124.355-.04541.12891-.08838.25782-.14063.38477-.04492.10742-.09766.21094-.147.31641-.06153.13183-.12061.26464-.18994.39355-.05176.09717-.11133.189-.167.2832-.07666.13037-.15087.26172-.23584.38819-.0664.09863-.14062.1914-.21093.28662-.084.11474-.16407.231-.25537.3418C246.06689,85.21631,245.94141,85.34863,245.81592,85.48145Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "44",
      "cy": "176",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "200 40 240 80 200 120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,176h8.00005a48,48,0,0,0,48-48V128A48,48,0,0,1,176,80h64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "44",
      "cy": "176",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "200 40 240 80 200 120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,176h8.00005a48,48,0,0,0,48-48V128A48,48,0,0,1,176,80h64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "44",
      "cy": "176",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "200 40 240 80 200 120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,176h8.00005a48,48,0,0,0,48-48V128A48,48,0,0,1,176,80h64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6g = [];
/* style */

const __vue_inject_styles__$6g = undefined;
/* scoped */

const __vue_scope_id__$6g = undefined;
/* module identifier */

const __vue_module_identifier__$6g = undefined;
/* functional template */

const __vue_is_functional_template__$6g = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6g = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6g,
  staticRenderFns: __vue_staticRenderFns__$6g
}, __vue_inject_styles__$6g, __vue_script__$6g, __vue_scope_id__$6g, __vue_is_functional_template__$6g, __vue_module_identifier__$6g, false, undefined, undefined, undefined);

var script$6h = Vue.extend({
  name: "PhFlower",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6h = script$6h;
/* template */

var __vue_render__$6h = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M115.02821,103.18241C107.70283,87.77847,100,68.588,100,56a28,28,0,0,1,56,0c0,12.588-7.70285,31.7785-15.02823,47.18245",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M100.02144,126.8251c-17.00289-1.358-37.47372-4.28238-48.37527-10.57639a28,28,0,0,1,28-48.49742c10.90156,6.294,23.66957,22.56011,33.34708,36.606",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112.99323,151.64269c-9.67751,14.04594-22.44551,30.312-33.34706,36.606a28,28,0,0,1-28-48.49742c10.90156-6.294,31.37241-9.21839,48.37532-10.5764",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M140.97179,152.81759C148.29717,168.22153,156,187.412,156,200a28,28,0,0,1-56,0c0-12.588,7.70285-31.7785,15.02823-47.18245",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M155.97856,129.1749c17.00289,1.358,37.47372,4.28238,48.37527,10.57639a28,28,0,0,1-28,48.49742c-10.90156-6.294-23.66957-22.56011-33.34708-36.606",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M143.00677,104.35731c9.67751-14.04594,22.44551-30.312,33.34706-36.606a28,28,0,0,1,28,48.49742c-10.90156,6.294-31.37241,9.21839-48.37532,10.5764",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M115.02706,103.18019a28.05031,28.05031,0,0,1,25.94589,0l-.00118.00225C148.29715,87.7785,156,68.588,156,56a28,28,0,0,0-56,0c0,12.588,7.70283,31.77847,15.02821,47.18241Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M100.01894,126.825a28.05038,28.05038,0,0,1,12.97295-22.4698l.00136.00215c-9.67751-14.04594-22.44552-30.312-33.34708-36.606a28,28,0,0,0-28,48.49742c10.90155,6.294,31.37238,9.21839,48.37527,10.57639Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112.99188,151.6448a28.05037,28.05037,0,0,1-12.97294-22.4698l.00255-.00011c-17.00291,1.358-37.47376,4.28238-48.37532,10.5764a28,28,0,0,0,28,48.49742c10.90155-6.294,23.66955-22.56008,33.34706-36.606Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M140.97294,152.81981a28.05031,28.05031,0,0,1-25.94589,0l.00118-.00225C107.70285,168.2215,100,187.412,100,200a28,28,0,0,0,56,0c0-12.588-7.70283-31.77847-15.02821-47.18241Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M155.98106,129.175a28.05038,28.05038,0,0,1-12.973,22.4698l-.00136-.00215c9.67751,14.04594,22.44552,30.312,33.34708,36.606a28,28,0,0,0,28-48.49742c-10.90155-6.294-31.37238-9.21839-48.37527-10.57639Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M143.00812,104.3552a28.05037,28.05037,0,0,1,12.97294,22.4698l-.00255.00011c17.00291-1.358,37.47376-4.28238,48.37532-10.5764a28,28,0,0,0-28-48.49742c-10.90155,6.294-23.66955,22.56008-33.34706,36.606Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M115.02821,103.18241C107.70283,87.77847,100,68.588,100,56a28,28,0,0,1,56,0c0,12.588-7.70285,31.7785-15.02823,47.18245",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M100.02144,126.8251c-17.00289-1.358-37.47372-4.28238-48.37527-10.57639a28,28,0,0,1,28-48.49742c10.90156,6.294,23.66957,22.56011,33.34708,36.606",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112.99323,151.64269c-9.67751,14.04594-22.44551,30.312-33.34706,36.606a28,28,0,0,1-28-48.49742c10.90156-6.294,31.37241-9.21839,48.37532-10.5764",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M140.97179,152.81759C148.29717,168.22153,156,187.412,156,200a28,28,0,0,1-56,0c0-12.588,7.70285-31.7785,15.02823-47.18245",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M155.97856,129.1749c17.00289,1.358,37.47372,4.28238,48.37527,10.57639a28,28,0,0,1-28,48.49742c-10.90156-6.294-23.66957-22.56011-33.34708-36.606",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M143.00677,104.35731c9.67751-14.04594,22.44551-30.312,33.34706-36.606a28,28,0,0,1,28,48.49742c-10.90156,6.294-31.37241,9.21839-48.37532,10.5764",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208.35352,132.82324A57.99826,57.99826,0,0,0,196.93994,128a58.016,58.016,0,0,0,11.41406-4.82324,36,36,0,1,0-36.00048-62.35352,58.00132,58.00132,0,0,0-9.88331,7.47266A58.01937,58.01937,0,0,0,164,56a36,36,0,0,0-72,0,58.01145,58.01145,0,0,0,1.52979,12.29541A58.01465,58.01465,0,0,0,83.646,60.82227a36.00017,36.00017,0,0,0-35.99952,62.35449A57.99826,57.99826,0,0,0,59.06006,128,58.016,58.016,0,0,0,47.646,132.82324a36,36,0,0,0,36.00048,62.35352,58.00132,58.00132,0,0,0,9.88331-7.47266A58.01937,58.01937,0,0,0,92,200a36,36,0,0,0,72,0,58.01145,58.01145,0,0,0-1.52979-12.29541,58.01465,58.01465,0,0,0,9.88379,7.47314,36.00017,36.00017,0,0,0,35.99952-62.35449ZM128,152a24,24,0,1,1,24-24A24.02687,24.02687,0,0,1,128,152Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M115.02821,103.18241C107.70283,87.77847,100,68.588,100,56a28,28,0,0,1,56,0c0,12.588-7.70285,31.7785-15.02823,47.18245",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M100.02144,126.8251c-17.00289-1.358-37.47372-4.28238-48.37527-10.57639a28,28,0,0,1,28-48.49742c10.90156,6.294,23.66957,22.56011,33.34708,36.606",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112.99323,151.64269c-9.67751,14.04594-22.44551,30.312-33.34706,36.606a28,28,0,0,1-28-48.49742c10.90156-6.294,31.37241-9.21839,48.37532-10.5764",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M140.97179,152.81759C148.29717,168.22153,156,187.412,156,200a28,28,0,0,1-56,0c0-12.588,7.70285-31.7785,15.02823-47.18245",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M155.97856,129.1749c17.00289,1.358,37.47372,4.28238,48.37527,10.57639a28,28,0,0,1-28,48.49742c-10.90156-6.294-23.66957-22.56011-33.34708-36.606",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M143.00677,104.35731c9.67751-14.04594,22.44551-30.312,33.34706-36.606a28,28,0,0,1,28,48.49742c-10.90156,6.294-31.37241,9.21839-48.37532,10.5764",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M115.02821,103.18241C107.70283,87.77847,100,68.588,100,56a28,28,0,0,1,56,0c0,12.588-7.70285,31.7785-15.02823,47.18245",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M100.02144,126.8251c-17.00289-1.358-37.47372-4.28238-48.37527-10.57639a28,28,0,0,1,28-48.49742c10.90156,6.294,23.66957,22.56011,33.34708,36.606",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112.99323,151.64269c-9.67751,14.04594-22.44551,30.312-33.34706,36.606a28,28,0,0,1-28-48.49742c10.90156-6.294,31.37241-9.21839,48.37532-10.5764",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M140.97179,152.81759C148.29717,168.22153,156,187.412,156,200a28,28,0,0,1-56,0c0-12.588,7.70285-31.7785,15.02823-47.18245",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M155.97856,129.1749c17.00289,1.358,37.47372,4.28238,48.37527,10.57639a28,28,0,0,1-28,48.49742c-10.90156-6.294-23.66957-22.56011-33.34708-36.606",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M143.00677,104.35731c9.67751-14.04594,22.44551-30.312,33.34706-36.606a28,28,0,0,1,28,48.49742c-10.90156,6.294-31.37241,9.21839-48.37532,10.5764",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M115.02821,103.18241C107.70283,87.77847,100,68.588,100,56a28,28,0,0,1,56,0c0,12.588-7.70285,31.7785-15.02823,47.18245",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M100.02144,126.8251c-17.00289-1.358-37.47372-4.28238-48.37527-10.57639a28,28,0,0,1,28-48.49742c10.90156,6.294,23.66957,22.56011,33.34708,36.606",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112.99323,151.64269c-9.67751,14.04594-22.44551,30.312-33.34706,36.606a28,28,0,0,1-28-48.49742c10.90156-6.294,31.37241-9.21839,48.37532-10.5764",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M140.97179,152.81759C148.29717,168.22153,156,187.412,156,200a28,28,0,0,1-56,0c0-12.588,7.70285-31.7785,15.02823-47.18245",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M155.97856,129.1749c17.00289,1.358,37.47372,4.28238,48.37527,10.57639a28,28,0,0,1-28,48.49742c-10.90156-6.294-23.66957-22.56011-33.34708-36.606",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M143.00677,104.35731c9.67751-14.04594,22.44551-30.312,33.34706-36.606a28,28,0,0,1,28,48.49742c-10.90156,6.294-31.37241,9.21839-48.37532,10.5764",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6h = [];
/* style */

const __vue_inject_styles__$6h = undefined;
/* scoped */

const __vue_scope_id__$6h = undefined;
/* module identifier */

const __vue_module_identifier__$6h = undefined;
/* functional template */

const __vue_is_functional_template__$6h = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6h = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6h,
  staticRenderFns: __vue_staticRenderFns__$6h
}, __vue_inject_styles__$6h, __vue_script__$6h, __vue_scope_id__$6h, __vue_is_functional_template__$6h, __vue_module_identifier__$6h, false, undefined, undefined, undefined);

var script$6i = Vue.extend({
  name: "PhFlowerLotus",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6i = script$6i;
/* template */

var __vue_render__$6i = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,200s40-21.81818,40-80c0-45.58443-24.55378-68.84723-35.18644-76.78386a8.03282,8.03282,0,0,0-9.62712,0C112.55378,51.15277,88,74.41557,88,120,88,178.18182,128,200,128,200Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,200c11.99027-2.55021,44.33-20.78184,63.71281-54.35383S206.32158,85.26679,202.535,73.60781a7.99178,7.99178,0,0,0-9.27184-5.3531,77.437,77.437,0,0,0-31.35645,15.135",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M94.09282,83.38935a77.43686,77.43686,0,0,0-31.356-15.13464,7.99178,7.99178,0,0,0-9.27184,5.3531c-3.78659,11.659-8.56062,38.46637,10.82218,72.03836S116.00973,197.44979,128,200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,200c16,0,41.83868-.1803,72.27252-17.75129s40.28226-39.5825,43.43363-50.85144a7.95859,7.95859,0,0,0-5.67817-9.83489c-7.2816-1.86638-19.78443-3.55592-35.86354.13268",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M53.83554,121.69505c-16.0791-3.68859-28.58193-1.999-35.86352-.13267a7.95859,7.95859,0,0,0-5.67817,9.83489c3.15137,11.26894,12.99979,33.28046,43.43363,50.85144S112,200,128,200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,200s-40-21.81818-40-80a107.00551,107.00551,0,0,1,6.09189-36.611l.00093.00032A77.45432,77.45432,0,0,0,62.77111,68.262,8.012,8.012,0,0,0,53.467,73.6017c-2.83963,8.74013-6.23716,26.00178.41465,48.2482l.0002-.00005c-16.39783-3.88948-29.14419-2.17963-36.52582-.28778a7.95673,7.95673,0,0,0-5.68022,9.8322c3.15047,11.268,12.99793,33.2819,43.43447,50.85444C85.54411,199.8197,112,200,128,200",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,200s40-21.81818,40-80a107.00551,107.00551,0,0,0-6.09189-36.611l-.00093.00032A77.45432,77.45432,0,0,1,193.22889,68.262a8.012,8.012,0,0,1,9.30412,5.3397c2.83963,8.74013,6.23716,26.00178-.41465,48.2482l-.0002-.00005c16.39783-3.88948,29.14419-2.17963,36.52582-.28778a7.95673,7.95673,0,0,1,5.68022,9.8322c-3.15047,11.268-12.99793,33.2819-43.43447,50.85444C170.45589,199.8197,144,200,128,200",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,200c16,0,42.45589-.1803,72.88973-17.75129s40.28225-39.5825,43.43363-50.85144a7.95859,7.95859,0,0,0-5.67818-9.83489c-7.38178-1.89206-20.12947-3.60238-36.52927.288",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M53.88184,121.84985c-16.39872-3.88969-29.14558-2.17944-36.527-.28747a7.95859,7.95859,0,0,0-5.67818,9.83489c3.15138,11.26894,12.99979,33.28046,43.43363,50.85144S112,200,128,200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,200s40-21.81818,40-80c0-45.58443-24.55378-68.84723-35.18644-76.78386a8.03282,8.03282,0,0,0-9.62712,0C112.55378,51.15277,88,74.41557,88,120,88,178.18182,128,200,128,200Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,200c11.99027-2.55021,44.33-20.78184,63.71281-54.35383S206.32158,85.26679,202.535,73.60781a7.99178,7.99178,0,0,0-9.27184-5.3531,77.437,77.437,0,0,0-31.35645,15.135",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M94.09282,83.38935a77.43686,77.43686,0,0,0-31.356-15.13464,7.99178,7.99178,0,0,0-9.27184,5.3531c-3.78659,11.659-8.56062,38.46637,10.82218,72.03836S116.00973,197.44979,128,200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M250.47559,121.28906a15.82032,15.82032,0,0,0-9.84375-7.47558,80.056,80.056,0,0,0-27.957-1.85254,85.73919,85.73919,0,0,0-2.53125-40.8252,15.96177,15.96177,0,0,0-18.54394-10.706,82.56127,82.56127,0,0,0-26.1582,10.74511,94.07116,94.07116,0,0,0-27.84034-34.36816,15.94439,15.94439,0,0,0-19.20361.001A94.06121,94.06121,0,0,0,90.55859,71.1748,82.56738,82.56738,0,0,0,64.40234,60.42969a15.96626,15.96626,0,0,0-18.54589,10.707A85.73054,85.73054,0,0,0,43.3252,111.96a80.01629,80.01629,0,0,0-27.957,1.85352,15.957,15.957,0,0,0-11.3955,19.73828c3.53808,12.65332,14.36767,36.70508,47.13769,55.626C83.67676,207.979,112.45654,208,127.94629,208c.01562,0,.03027.00195.0459.00195L128,208.00146l.00781.00049c.01563,0,.03028-.00195.0459-.00195,15.48975,0,44.26953-.021,76.83594-18.82324,32.77-18.91992,43.59961-42.97168,47.13769-55.625A15.81809,15.81809,0,0,0,250.47559,121.28906ZM128.03027,49.62793C137.64258,56.80469,160,78.02832,160,120s-22.35742,63.19531-31.96826,70.37109a.0448.0448,0,0,1-.06348,0C118.355,183.19238,96,161.96875,96,120,96,78.02832,118.35742,56.80469,128.03027,49.62793ZM19.3418,129.31152a66.43813,66.43813,0,0,1,28.34814-.57763,123.02667,123.02667,0,0,0,9.669,20.91259,138.33271,138.33271,0,0,0,33.27295,38.52344,121.79948,121.79948,0,0,1-31.52149-12.84863C31.25732,159.23926,22.26367,139.54883,19.3418,129.31152Zm177.54785,46.00879a121.79928,121.79928,0,0,1-31.521,12.84912,138.33687,138.33687,0,0,0,33.27246-38.523,123.02667,123.02667,0,0,0,9.66895-20.91259,67.45364,67.45364,0,0,1,28.30908.50927C233.73633,139.54883,224.74268,159.23926,196.88965,175.32031Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,200c16,0,42.45589-.1803,72.88973-17.75129s40.28225-39.5825,43.43363-50.85144a7.95859,7.95859,0,0,0-5.67818-9.83489c-7.38178-1.89206-20.12947-3.60238-36.52927.288",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M53.88184,121.84985c-16.39872-3.88969-29.14558-2.17944-36.527-.28747a7.95859,7.95859,0,0,0-5.67818,9.83489c3.15138,11.26894,12.99979,33.28046,43.43363,50.85144S112,200,128,200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,200s40-21.81818,40-80c0-45.58443-24.55378-68.84723-35.18644-76.78386a8.03282,8.03282,0,0,0-9.62712,0C112.55378,51.15277,88,74.41557,88,120,88,178.18182,128,200,128,200Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,200c11.99027-2.55021,44.33-20.78184,63.71281-54.35383S206.32158,85.26679,202.535,73.60781a7.99178,7.99178,0,0,0-9.27184-5.3531,77.437,77.437,0,0,0-31.35645,15.135",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M94.09282,83.38935a77.43686,77.43686,0,0,0-31.356-15.13464,7.99178,7.99178,0,0,0-9.27184,5.3531c-3.78659,11.659-8.56062,38.46637,10.82218,72.03836S116.00973,197.44979,128,200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,200c16,0,42.45589-.1803,72.88973-17.75129s40.28225-39.5825,43.43363-50.85144a7.95859,7.95859,0,0,0-5.67818-9.83489c-7.38178-1.89206-20.12947-3.60238-36.52927.288",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M53.88184,121.84985c-16.39872-3.88969-29.14558-2.17944-36.527-.28747a7.95859,7.95859,0,0,0-5.67818,9.83489c3.15138,11.26894,12.99979,33.28046,43.43363,50.85144S112,200,128,200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,200s40-21.81818,40-80c0-45.58443-24.55378-68.84723-35.18644-76.78386a8.03282,8.03282,0,0,0-9.62712,0C112.55378,51.15277,88,74.41557,88,120,88,178.18182,128,200,128,200Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,200c11.99027-2.55021,44.33-20.78184,63.71281-54.35383S206.32158,85.26679,202.535,73.60781a7.99178,7.99178,0,0,0-9.27184-5.3531,77.437,77.437,0,0,0-31.35645,15.135",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M94.09282,83.38935a77.43686,77.43686,0,0,0-31.356-15.13464,7.99178,7.99178,0,0,0-9.27184,5.3531c-3.78659,11.659-8.56062,38.46637,10.82218,72.03836S116.00973,197.44979,128,200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,200c16,0,42.45589-.1803,72.88973-17.75129s40.28225-39.5825,43.43363-50.85144a7.95859,7.95859,0,0,0-5.67818-9.83489c-7.38178-1.89206-20.12947-3.60238-36.52927.288",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M53.88184,121.84985c-16.39872-3.88969-29.14558-2.17944-36.527-.28747a7.95859,7.95859,0,0,0-5.67818,9.83489c3.15138,11.26894,12.99979,33.28046,43.43363,50.85144S112,200,128,200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,200s40-21.81818,40-80c0-45.58443-24.55378-68.84723-35.18644-76.78386a8.03282,8.03282,0,0,0-9.62712,0C112.55378,51.15277,88,74.41557,88,120,88,178.18182,128,200,128,200Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,200c11.99027-2.55021,44.33-20.78184,63.71281-54.35383S206.32158,85.26679,202.535,73.60781a7.99178,7.99178,0,0,0-9.27184-5.3531,77.437,77.437,0,0,0-31.35645,15.135",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M94.09282,83.38935a77.43686,77.43686,0,0,0-31.356-15.13464,7.99178,7.99178,0,0,0-9.27184,5.3531c-3.78659,11.659-8.56062,38.46637,10.82218,72.03836S116.00973,197.44979,128,200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6i = [];
/* style */

const __vue_inject_styles__$6i = undefined;
/* scoped */

const __vue_scope_id__$6i = undefined;
/* module identifier */

const __vue_module_identifier__$6i = undefined;
/* functional template */

const __vue_is_functional_template__$6i = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6i = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6i,
  staticRenderFns: __vue_staticRenderFns__$6i
}, __vue_inject_styles__$6i, __vue_script__$6i, __vue_scope_id__$6i, __vue_is_functional_template__$6i, __vue_module_identifier__$6i, false, undefined, undefined, undefined);

var script$6j = Vue.extend({
  name: "PhFolder",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6j = script$6j;
/* template */

var __vue_render__$6j = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216.88889,208H39.38462A7.40633,7.40633,0,0,1,32,200.61538V80H216a8,8,0,0,1,8,8V200.88889A7.11111,7.11111,0,0,1,216.88889,208Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M98.38675,46.68509,128,80H32V52a8,8,0,0,1,8-8H92.40747A8,8,0,0,1,98.38675,46.68509Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M98.34315,50.34315,128,80H32V56a8,8,0,0,1,8-8H92.68629A8,8,0,0,1,98.34315,50.34315Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216.88889,208H39.38462A7.40633,7.40633,0,0,1,32,200.61538V80H216a8,8,0,0,1,8,8V200.88889A7.11111,7.11111,0,0,1,216.88889,208Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,80V56a8,8,0,0,1,8-8H92.68629a8,8,0,0,1,5.65686,2.34315L128,80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M215.99512,71.99805h-84.6875l-27.3125-27.3125a15.8907,15.8907,0,0,0-11.3125-4.6875H39.99512a16.01581,16.01581,0,0,0-16,16V200.61523a15.404,15.404,0,0,0,15.39062,15.38282h177.5a15.13062,15.13062,0,0,0,15.10938-15.10938V87.99805A16.01582,16.01582,0,0,0,215.99512,71.99805Zm-176-16h52.6875l16,16H39.99512Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216.88889,208H39.38462A7.40633,7.40633,0,0,1,32,200.61538V80H216a8,8,0,0,1,8,8V200.88889A7.11111,7.11111,0,0,1,216.88889,208Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,80V56a8,8,0,0,1,8-8H92.68629a8,8,0,0,1,5.65686,2.34315L128,80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216.88889,208H39.38462A7.40633,7.40633,0,0,1,32,200.61538V80H216a8,8,0,0,1,8,8V200.88889A7.11111,7.11111,0,0,1,216.88889,208Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,80V56a8,8,0,0,1,8-8H92.68629a8,8,0,0,1,5.65686,2.34315L128,80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216.88889,208H39.38462A7.40633,7.40633,0,0,1,32,200.61538V80H216a8,8,0,0,1,8,8V200.88889A7.11111,7.11111,0,0,1,216.88889,208Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,80V56a8,8,0,0,1,8-8H92.68629a8,8,0,0,1,5.65686,2.34315L128,80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6j = [];
/* style */

const __vue_inject_styles__$6j = undefined;
/* scoped */

const __vue_scope_id__$6j = undefined;
/* module identifier */

const __vue_module_identifier__$6j = undefined;
/* functional template */

const __vue_is_functional_template__$6j = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6j = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6j,
  staticRenderFns: __vue_staticRenderFns__$6j
}, __vue_inject_styles__$6j, __vue_script__$6j, __vue_scope_id__$6j, __vue_is_functional_template__$6j, __vue_module_identifier__$6j, false, undefined, undefined, undefined);

var script$6k = Vue.extend({
  name: "PhFolderMinus",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6k = script$6k;
/* template */

var __vue_render__$6k = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216.88889,208H39.38462A7.40633,7.40633,0,0,1,32,200.61538V80H216a8,8,0,0,1,8,8V200.88889A7.11111,7.11111,0,0,1,216.88889,208Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,80V52a8,8,0,0,1,8-8H92.40747a8,8,0,0,1,5.97928,2.68509L128,80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "144",
      "x2": "152",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M98.34315,50.34315,128,80H32V56a8,8,0,0,1,8-8H92.68629A8,8,0,0,1,98.34315,50.34315Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216.88889,208H39.38462A7.40633,7.40633,0,0,1,32,200.61538V80H216a8,8,0,0,1,8,8V200.88889A7.11111,7.11111,0,0,1,216.88889,208Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,80V56a8,8,0,0,1,8-8H92.68629a8,8,0,0,1,5.65686,2.34315L128,80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "144",
      "x2": "152",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M215.99512,71.99805h-84.6875l-27.3125-27.3125a15.8907,15.8907,0,0,0-11.3125-4.6875H39.99512a16.01581,16.01581,0,0,0-16,16V200.61523a15.404,15.404,0,0,0,15.39062,15.38282h177.5a15.13062,15.13062,0,0,0,15.10938-15.10938V87.99805A16.01582,16.01582,0,0,0,215.99512,71.99805Zm-176-16h52.6875l16,16H39.99512Zm112,96.00195h-48a8,8,0,1,1,0-16h48a8,8,0,0,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216.88889,208H39.38462A7.40633,7.40633,0,0,1,32,200.61538V80H216a8,8,0,0,1,8,8V200.88889A7.11111,7.11111,0,0,1,216.88889,208Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,80V56a8,8,0,0,1,8-8H92.68629a8,8,0,0,1,5.65686,2.34315L128,80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "144",
      "x2": "152",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216.88889,208H39.38462A7.40633,7.40633,0,0,1,32,200.61538V80H216a8,8,0,0,1,8,8V200.88889A7.11111,7.11111,0,0,1,216.88889,208Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,80V56a8,8,0,0,1,8-8H92.68629a8,8,0,0,1,5.65686,2.34315L128,80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "144",
      "x2": "152",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216.88889,208H39.38462A7.40633,7.40633,0,0,1,32,200.61538V80H216a8,8,0,0,1,8,8V200.88889A7.11111,7.11111,0,0,1,216.88889,208Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,80V56a8,8,0,0,1,8-8H92.68629a8,8,0,0,1,5.65686,2.34315L128,80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "144",
      "x2": "152",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6k = [];
/* style */

const __vue_inject_styles__$6k = undefined;
/* scoped */

const __vue_scope_id__$6k = undefined;
/* module identifier */

const __vue_module_identifier__$6k = undefined;
/* functional template */

const __vue_is_functional_template__$6k = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6k = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6k,
  staticRenderFns: __vue_staticRenderFns__$6k
}, __vue_inject_styles__$6k, __vue_script__$6k, __vue_scope_id__$6k, __vue_is_functional_template__$6k, __vue_module_identifier__$6k, false, undefined, undefined, undefined);

var script$6l = Vue.extend({
  name: "PhFolderNotch",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6l = script$6l;
/* template */

var __vue_render__$6l = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,80h88a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H40a8.02352,8.02352,0,0,1-8-8V104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M93.33333,104H32V64a8,8,0,0,1,8-8H93.33333a8,8,0,0,1,4.8,1.6L128,80,98.13333,102.4A8,8,0,0,1,93.33333,104Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M93.33333,104H32V64a8,8,0,0,1,8-8H93.33333a8,8,0,0,1,4.8,1.6L128,80,98.13333,102.4A8,8,0,0,1,93.33333,104Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,80h88a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H40a8.02352,8.02352,0,0,1-8-8V104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M93.33333,104H32V64a8,8,0,0,1,8-8H93.33333a8,8,0,0,1,4.8,1.6L128,80,98.13333,102.4A8,8,0,0,1,93.33333,104Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M215.99512,71.99805H130.65625L102.917,51.19336a16.07363,16.07363,0,0,0-9.57812-3.19531H39.99512a16.01581,16.01581,0,0,0-16,16v136a16.01582,16.01582,0,0,0,16,16h176a16.01583,16.01583,0,0,0,16-16v-112A16.01582,16.01582,0,0,0,215.99512,71.99805Zm-176-8H93.33887l21.32617,15.999-21.3418,16.001H39.99512Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,80h88a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H40a8.02352,8.02352,0,0,1-8-8V104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M93.33333,104H32V64a8,8,0,0,1,8-8H93.33333a8,8,0,0,1,4.8,1.6L128,80,98.13333,102.4A8,8,0,0,1,93.33333,104Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,80h88a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H40a8.02352,8.02352,0,0,1-8-8V104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M93.33333,104H32V64a8,8,0,0,1,8-8H93.33333a8,8,0,0,1,4.8,1.6L128,80,98.13333,102.4A8,8,0,0,1,93.33333,104Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,80h88a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H40a8.02352,8.02352,0,0,1-8-8V104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M93.33333,104H32V64a8,8,0,0,1,8-8H93.33333a8,8,0,0,1,4.8,1.6L128,80,98.13333,102.4A8,8,0,0,1,93.33333,104Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6l = [];
/* style */

const __vue_inject_styles__$6l = undefined;
/* scoped */

const __vue_scope_id__$6l = undefined;
/* module identifier */

const __vue_module_identifier__$6l = undefined;
/* functional template */

const __vue_is_functional_template__$6l = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6l = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6l,
  staticRenderFns: __vue_staticRenderFns__$6l
}, __vue_inject_styles__$6l, __vue_script__$6l, __vue_scope_id__$6l, __vue_is_functional_template__$6l, __vue_module_identifier__$6l, false, undefined, undefined, undefined);

var script$6m = Vue.extend({
  name: "PhFolderNotchMinus",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6m = script$6m;
/* template */

var __vue_render__$6m = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,80h88a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H40a8.02352,8.02352,0,0,1-8-8V104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M93.33333,104H32V64a8,8,0,0,1,8-8H93.33333a8,8,0,0,1,4.8,1.6L128,80,98.13333,102.4A8,8,0,0,1,93.33333,104Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "103.99707",
      "y1": "148",
      "x2": "151.99707",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M93.33333,104H32V64a8,8,0,0,1,8-8H93.33333a8,8,0,0,1,4.8,1.6L128,80,98.13333,102.4A8,8,0,0,1,93.33333,104Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,80h88a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H40a8.02352,8.02352,0,0,1-8-8V104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M93.33333,104H32V64a8,8,0,0,1,8-8H93.33333a8,8,0,0,1,4.8,1.6L128,80,98.13333,102.4A8,8,0,0,1,93.33333,104Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "103.99121",
      "y1": "148",
      "x2": "151.99121",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M215.99512,71.99805H130.65625L102.917,51.19336a16.07363,16.07363,0,0,0-9.57812-3.19531H39.99512a16.01581,16.01581,0,0,0-16,16v136a16.01582,16.01582,0,0,0,16,16h176a16.01583,16.01583,0,0,0,16-16v-112A16.01582,16.01582,0,0,0,215.99512,71.99805Zm-176,24v-32H93.33887l21.32617,15.999-21.3418,16.001ZM151.99707,156h-48a8,8,0,0,1,0-16h48a8,8,0,0,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,80h88a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H40a8.02352,8.02352,0,0,1-8-8V104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M93.33333,104H32V64a8,8,0,0,1,8-8H93.33333a8,8,0,0,1,4.8,1.6L128,80,98.13333,102.4A8,8,0,0,1,93.33333,104Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "103.99707",
      "y1": "148",
      "x2": "151.99707",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,80h88a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H40a8.02352,8.02352,0,0,1-8-8V104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M93.33333,104H32V64a8,8,0,0,1,8-8H93.33333a8,8,0,0,1,4.8,1.6L128,80,98.13333,102.4A8,8,0,0,1,93.33333,104Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "103.99707",
      "y1": "148",
      "x2": "151.99707",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,80h88a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H40a8.02352,8.02352,0,0,1-8-8V104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M93.33333,104H32V64a8,8,0,0,1,8-8H93.33333a8,8,0,0,1,4.8,1.6L128,80,98.13333,102.4A8,8,0,0,1,93.33333,104Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "103.99707",
      "y1": "148",
      "x2": "151.99707",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6m = [];
/* style */

const __vue_inject_styles__$6m = undefined;
/* scoped */

const __vue_scope_id__$6m = undefined;
/* module identifier */

const __vue_module_identifier__$6m = undefined;
/* functional template */

const __vue_is_functional_template__$6m = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6m = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6m,
  staticRenderFns: __vue_staticRenderFns__$6m
}, __vue_inject_styles__$6m, __vue_script__$6m, __vue_scope_id__$6m, __vue_is_functional_template__$6m, __vue_module_identifier__$6m, false, undefined, undefined, undefined);

var script$6n = Vue.extend({
  name: "PhFolderNotchOpen",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6n = script$6n;
/* template */

var __vue_render__$6n = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,208V64a8,8,0,0,1,8-8H93.33333a8,8,0,0,1,4.8,1.6l27.73334,20.8a8,8,0,0,0,4.8,1.6H200a8,8,0,0,1,8,8v24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,208l29.93872-71.10446A8,8,0,0,1,69.3118,132h48.266a8,8,0,0,0,4.43761-1.3436l19.9692-13.3128A8,8,0,0,1,146.42221,116h82.32506a8,8,0,0,1,7.556,10.62816L208,208Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M69.416,128h48.16162a8.00257,8.00257,0,0,0,4.438-1.34375l19.96876-13.3125A8.00257,8.00257,0,0,1,146.42236,112H208V88a7.99977,7.99977,0,0,0-8-8H130.6665a7.9995,7.9995,0,0,1-4.7998-1.6001L98.1333,57.6001A7.9995,7.9995,0,0,0,93.3335,56H40a7.99977,7.99977,0,0,0-8,8V208l29.98828-74.97119A8.00025,8.00025,0,0,1,69.416,128Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,208V64a8,8,0,0,1,8-8H93.33333a8,8,0,0,1,4.8,1.6l27.73334,20.8a8,8,0,0,0,4.8,1.6H200a8,8,0,0,1,8,8v24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,208l29.98845-74.97113A8,8,0,0,1,69.41626,128h48.16153a8,8,0,0,0,4.43761-1.3436l19.9692-13.3128A8,8,0,0,1,146.42221,112h82.47838a8,8,0,0,1,7.58947,10.52982L208,208Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M241.88037,110.64453A16.03934,16.03934,0,0,0,228.90039,104H216V88a16.01833,16.01833,0,0,0-16-16H130.667l-27.7334-20.7998A16.10323,16.10323,0,0,0,93.333,48H40A16.01833,16.01833,0,0,0,24,64V208a8.06184,8.06184,0,0,0,.04541.8457c.00293.02735.00928.0542.0127.08155a7.86829,7.86829,0,0,0,.13818.81543c.01562.07226.03711.14306.05517.21484.05665.22559.12159.44775.19727.665.02734.07812.05566.15527.08545.23242q.126.33033.28076.64551c.03076.064.05908.12842.09229.1914a7.98135,7.98135,0,0,0,1.01318,1.49952c.06055.07129.12451.13769.1875.20654.14063.15381.28662.30176.43945.44434.07276.06787.145.13525.22022.20068.17187.14844.3501.28808.53418.42187.05469.04.10693.084.16308.12207a7.91673,7.91673,0,0,0,.77246.47168c.0254.01368.05225.02442.07764.0376a7.86248,7.86248,0,0,0,.73779.33594c.07129.02832.14405.05322.2168.07959q.31715.11572.64649.20459c.085.023.16894.04541.25439.06543.21875.05127.44092.09131.666.124.08154.01221.16259.02783.24462.0376A8.04614,8.04614,0,0,0,32,216H208a8.00117,8.00117,0,0,0,7.58984-5.47021l28.48926-85.47022A16.03873,16.03873,0,0,0,241.88037,110.64453ZM93.333,64l27.7334,20.7998A16.10323,16.10323,0,0,0,130.667,88H200v16H146.42188a15.9479,15.9479,0,0,0-8.875,2.6875L117.57812,120H69.416a15.92344,15.92344,0,0,0-14.85547,10.05762L40,166.45947V64Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,208V64a8,8,0,0,1,8-8H93.33333a8,8,0,0,1,4.8,1.6l27.73334,20.8a8,8,0,0,0,4.8,1.6H200a8,8,0,0,1,8,8v24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,208l29.98845-74.97113A8,8,0,0,1,69.41626,128h48.16153a8,8,0,0,0,4.43761-1.3436l19.9692-13.3128A8,8,0,0,1,146.42221,112h82.47838a8,8,0,0,1,7.58947,10.52982L208,208Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,208V64a8,8,0,0,1,8-8H93.33333a8,8,0,0,1,4.8,1.6l27.73334,20.8a8,8,0,0,0,4.8,1.6H200a8,8,0,0,1,8,8v24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,208l29.98845-74.97113A8,8,0,0,1,69.41626,128h48.16153a8,8,0,0,0,4.43761-1.3436l19.9692-13.3128A8,8,0,0,1,146.42221,112h82.47838a8,8,0,0,1,7.58947,10.52982L208,208Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,208V64a8,8,0,0,1,8-8H93.33333a8,8,0,0,1,4.8,1.6l27.73334,20.8a8,8,0,0,0,4.8,1.6H200a8,8,0,0,1,8,8v24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,208l29.98845-74.97113A8,8,0,0,1,69.41626,128h48.16153a8,8,0,0,0,4.43761-1.3436l19.9692-13.3128A8,8,0,0,1,146.42221,112h82.47838a8,8,0,0,1,7.58947,10.52982L208,208Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6n = [];
/* style */

const __vue_inject_styles__$6n = undefined;
/* scoped */

const __vue_scope_id__$6n = undefined;
/* module identifier */

const __vue_module_identifier__$6n = undefined;
/* functional template */

const __vue_is_functional_template__$6n = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6n = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6n,
  staticRenderFns: __vue_staticRenderFns__$6n
}, __vue_inject_styles__$6n, __vue_script__$6n, __vue_scope_id__$6n, __vue_is_functional_template__$6n, __vue_module_identifier__$6n, false, undefined, undefined, undefined);

var script$6o = Vue.extend({
  name: "PhFolderNotchPlus",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6o = script$6o;
/* template */

var __vue_render__$6o = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,80h88a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H40a8.02352,8.02352,0,0,1-8-8V104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M93.33333,104H32V64a8,8,0,0,1,8-8H93.33333a8,8,0,0,1,4.8,1.6L128,80,98.13333,102.4A8,8,0,0,1,93.33333,104Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "103.99707",
      "y1": "148",
      "x2": "151.99707",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "127.99707",
      "y1": "124",
      "x2": "127.99707",
      "y2": "172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M93.33333,104H32V64a8,8,0,0,1,8-8H93.33333a8,8,0,0,1,4.8,1.6L128,80,98.13333,102.4A8,8,0,0,1,93.33333,104Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,80h88a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H40a8.02352,8.02352,0,0,1-8-8V104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M93.33333,104H32V64a8,8,0,0,1,8-8H93.33333a8,8,0,0,1,4.8,1.6L128,80,98.13333,102.4A8,8,0,0,1,93.33333,104Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "103.99121",
      "y1": "148",
      "x2": "151.99121",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "127.99121",
      "y1": "124",
      "x2": "127.99121",
      "y2": "172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M215.99512,71.99805H130.65625L102.917,51.19336a16.07363,16.07363,0,0,0-9.57812-3.19531H39.99512a16.01581,16.01581,0,0,0-16,16v136a16.01582,16.01582,0,0,0,16,16h176a16.01583,16.01583,0,0,0,16-16v-112A16.01582,16.01582,0,0,0,215.99512,71.99805Zm-176,24v-32H93.33887l21.32617,15.999-21.3418,16.001ZM151.99707,156h-16v16a8,8,0,0,1-16,0V156h-16a8,8,0,0,1,0-16h16V124a8,8,0,0,1,16,0v16h16a8,8,0,0,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,80h88a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H40a8.02352,8.02352,0,0,1-8-8V104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M93.33333,104H32V64a8,8,0,0,1,8-8H93.33333a8,8,0,0,1,4.8,1.6L128,80,98.13333,102.4A8,8,0,0,1,93.33333,104Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "103.99707",
      "y1": "148",
      "x2": "151.99707",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "127.99707",
      "y1": "124",
      "x2": "127.99707",
      "y2": "172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,80h88a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H40a8.02352,8.02352,0,0,1-8-8V104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M93.33333,104H32V64a8,8,0,0,1,8-8H93.33333a8,8,0,0,1,4.8,1.6L128,80,98.13333,102.4A8,8,0,0,1,93.33333,104Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "103.99707",
      "y1": "148",
      "x2": "151.99707",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "127.99707",
      "y1": "124",
      "x2": "127.99707",
      "y2": "172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,80h88a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H40a8.02352,8.02352,0,0,1-8-8V104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M93.33333,104H32V64a8,8,0,0,1,8-8H93.33333a8,8,0,0,1,4.8,1.6L128,80,98.13333,102.4A8,8,0,0,1,93.33333,104Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "103.99707",
      "y1": "148",
      "x2": "151.99707",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "127.99707",
      "y1": "124",
      "x2": "127.99707",
      "y2": "172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6o = [];
/* style */

const __vue_inject_styles__$6o = undefined;
/* scoped */

const __vue_scope_id__$6o = undefined;
/* module identifier */

const __vue_module_identifier__$6o = undefined;
/* functional template */

const __vue_is_functional_template__$6o = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6o = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6o,
  staticRenderFns: __vue_staticRenderFns__$6o
}, __vue_inject_styles__$6o, __vue_script__$6o, __vue_scope_id__$6o, __vue_is_functional_template__$6o, __vue_module_identifier__$6o, false, undefined, undefined, undefined);

var script$6p = Vue.extend({
  name: "PhFolderOpen",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6p = script$6p;
/* template */

var __vue_render__$6p = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,208V64a8,8,0,0,1,8-8H93.33333a8,8,0,0,1,4.8,1.6l27.73334,20.8a8,8,0,0,0,4.8,1.6H200a8,8,0,0,1,8,8v24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,208l30.13154-86.62816A8,8,0,0,1,69.68751,116H228.74727a8,8,0,0,1,7.556,10.62816L208,208Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,208l30.17661-90.52982A8,8,0,0,1,69.76607,112H208V88a8,8,0,0,0-8-8H130.66667a8,8,0,0,1-4.8-1.6L98.13333,57.6a8,8,0,0,0-4.8-1.6H40a8,8,0,0,0-8,8Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,208V64a8,8,0,0,1,8-8H93.33333a8,8,0,0,1,4.8,1.6l27.73334,20.8a8,8,0,0,0,4.8,1.6H200a8,8,0,0,1,8,8v24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,208l30.17661-90.52982A8,8,0,0,1,69.76607,112H228.90059a8,8,0,0,1,7.58947,10.52982L208,208Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M241.88037,110.64453A16.03934,16.03934,0,0,0,228.90039,104H216V88a16.01833,16.01833,0,0,0-16-16H130.667l-27.7334-20.7998A16.10323,16.10323,0,0,0,93.333,48H40A16.01833,16.01833,0,0,0,24,64V208c0,.05127.00684.10059.00781.15137.002.1123.00977.22412.0166.33642.01172.19043.02832.37891.05274.56592q.02051.15234.04639.30371c.03515.20459.07861.40576.1289.605.021.08252.04.16553.064.24756.06836.23877.14843.47217.23779.70117.0166.042.02978.08545.04687.12793a7.867,7.867,0,0,0,.39014.81592c.01563.02881.03467.05566.05078.084q.1919.33912.41553.65625c.019.02686.0332.05567.05225.08252.03564.04883.07763.09082.11377.13916.12255.16163.24951.31885.38378.47022.06836.07764.13672.1543.20752.22851.14161.14844.29.29.44287.42725.064.05713.125.11768.19043.17285a7.94692,7.94692,0,0,0,.69581.52832l.01953.01172a7.96822,7.96822,0,0,0,.73632.43311c.064.0332.12989.0625.19483.09375.19971.09765.40332.18847.61182.26953.0791.03027.1582.05859.23828.08691q.30176.1062.61377.188c.08447.02246.168.04541.25293.06494.21386.04883.43164.08643.65185.11817.0791.01123.15674.02685.23633.03613A8.06189,8.06189,0,0,0,32,216H208a8.00117,8.00117,0,0,0,7.58984-5.47021l28.48926-85.47022A16.039,16.039,0,0,0,241.88037,110.64453ZM93.333,64l27.7334,20.7998A16.10323,16.10323,0,0,0,130.667,88H200v16H69.76611a15.98037,15.98037,0,0,0-15.1792,10.94043L40,158.70166V64Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,208V64a8,8,0,0,1,8-8H93.33333a8,8,0,0,1,4.8,1.6l27.73334,20.8a8,8,0,0,0,4.8,1.6H200a8,8,0,0,1,8,8v24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,208l30.17661-90.52982A8,8,0,0,1,69.76607,112H228.90059a8,8,0,0,1,7.58947,10.52982L208,208Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,208V64a8,8,0,0,1,8-8H93.33333a8,8,0,0,1,4.8,1.6l27.73334,20.8a8,8,0,0,0,4.8,1.6H200a8,8,0,0,1,8,8v24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,208l30.17661-90.52982A8,8,0,0,1,69.76607,112H228.90059a8,8,0,0,1,7.58947,10.52982L208,208Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,208V64a8,8,0,0,1,8-8H93.33333a8,8,0,0,1,4.8,1.6l27.73334,20.8a8,8,0,0,0,4.8,1.6H200a8,8,0,0,1,8,8v24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,208l30.17661-90.52982A8,8,0,0,1,69.76607,112H228.90059a8,8,0,0,1,7.58947,10.52982L208,208Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6p = [];
/* style */

const __vue_inject_styles__$6p = undefined;
/* scoped */

const __vue_scope_id__$6p = undefined;
/* module identifier */

const __vue_module_identifier__$6p = undefined;
/* functional template */

const __vue_is_functional_template__$6p = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6p = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6p,
  staticRenderFns: __vue_staticRenderFns__$6p
}, __vue_inject_styles__$6p, __vue_script__$6p, __vue_scope_id__$6p, __vue_is_functional_template__$6p, __vue_module_identifier__$6p, false, undefined, undefined, undefined);

var script$6q = Vue.extend({
  name: "PhFolderPlus",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6q = script$6q;
/* template */

var __vue_render__$6q = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216.88889,208H39.38462A7.40633,7.40633,0,0,1,32,200.61538V80H216a8,8,0,0,1,8,8V200.88889A7.11111,7.11111,0,0,1,216.88889,208Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,80V52a8,8,0,0,1,8-8H92.40747a8,8,0,0,1,5.97928,2.68509L128,80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "144",
      "x2": "152",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "120",
      "x2": "128",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M98.34315,50.34315,128,80H32V56a8,8,0,0,1,8-8H92.68629A8,8,0,0,1,98.34315,50.34315Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216.88889,208H39.38462A7.40633,7.40633,0,0,1,32,200.61538V80H216a8,8,0,0,1,8,8V200.88889A7.11111,7.11111,0,0,1,216.88889,208Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,80V56a8,8,0,0,1,8-8H92.68629a8,8,0,0,1,5.65686,2.34315L128,80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "103.99414",
      "y1": "144",
      "x2": "151.99414",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "127.99414",
      "y1": "120",
      "x2": "127.99414",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M215.99512,71.99805h-84.6875l-27.3125-27.3125a15.8907,15.8907,0,0,0-11.3125-4.6875H39.99512a16.01581,16.01581,0,0,0-16,16V200.61523a15.404,15.404,0,0,0,15.39062,15.38282h177.5a15.13062,15.13062,0,0,0,15.10938-15.10938V87.99805A16.01582,16.01582,0,0,0,215.99512,71.99805Zm-176-16h52.6875l16,16H39.99512Zm112,96.00195h-16v16a8,8,0,1,1-16,0V152h-16a8,8,0,1,1,0-16h16V120a8,8,0,1,1,16,0v16h16a8,8,0,0,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216.88889,208H39.38462A7.40633,7.40633,0,0,1,32,200.61538V80H216a8,8,0,0,1,8,8V200.88889A7.11111,7.11111,0,0,1,216.88889,208Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,80V56a8,8,0,0,1,8-8H92.68629a8,8,0,0,1,5.65686,2.34315L128,80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "144",
      "x2": "152",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "120",
      "x2": "128",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216.88889,208H39.38462A7.40633,7.40633,0,0,1,32,200.61538V80H216a8,8,0,0,1,8,8V200.88889A7.11111,7.11111,0,0,1,216.88889,208Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,80V56a8,8,0,0,1,8-8H92.68629a8,8,0,0,1,5.65686,2.34315L128,80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "144",
      "x2": "152",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "120",
      "x2": "128",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216.88889,208H39.38462A7.40633,7.40633,0,0,1,32,200.61538V80H216a8,8,0,0,1,8,8V200.88889A7.11111,7.11111,0,0,1,216.88889,208Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,80V56a8,8,0,0,1,8-8H92.68629a8,8,0,0,1,5.65686,2.34315L128,80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "144",
      "x2": "152",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "120",
      "x2": "128",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6q = [];
/* style */

const __vue_inject_styles__$6q = undefined;
/* scoped */

const __vue_scope_id__$6q = undefined;
/* module identifier */

const __vue_module_identifier__$6q = undefined;
/* functional template */

const __vue_is_functional_template__$6q = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6q = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6q,
  staticRenderFns: __vue_staticRenderFns__$6q
}, __vue_inject_styles__$6q, __vue_script__$6q, __vue_scope_id__$6q, __vue_is_functional_template__$6q, __vue_module_identifier__$6q, false, undefined, undefined, undefined);

var script$6r = Vue.extend({
  name: "PhFolderSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6r = script$6r;
/* template */

var __vue_render__$6r = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,88V200.88889A7.11111,7.11111,0,0,1,216.88889,208H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.33333a8,8,0,0,1,4.8,1.6l27.73334,20.8a8,8,0,0,0,4.8,1.6H216A8,8,0,0,1,224,88Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,88V200.88889A7.11111,7.11111,0,0,1,216.88889,208H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.33333a8,8,0,0,1,4.8,1.6l27.73334,20.8a8,8,0,0,0,4.8,1.6H216A8,8,0,0,1,224,88Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,88V200.88889A7.11111,7.11111,0,0,1,216.88889,208H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.33333a8,8,0,0,1,4.8,1.6l27.73334,20.8a8,8,0,0,0,4.8,1.6H216A8,8,0,0,1,224,88Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M215.99512,71.99805H130.667l-27.75-20.80469a16.07363,16.07363,0,0,0-9.57812-3.19531H39.99512a16.01581,16.01581,0,0,0-16,16v136a16.01582,16.01582,0,0,0,16,16H216.88574a15.13062,15.13062,0,0,0,15.10938-15.10938V87.99805A16.01582,16.01582,0,0,0,215.99512,71.99805Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,88V200.88889A7.11111,7.11111,0,0,1,216.88889,208H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.33333a8,8,0,0,1,4.8,1.6l27.73334,20.8a8,8,0,0,0,4.8,1.6H216A8,8,0,0,1,224,88Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,88V200.88889A7.11111,7.11111,0,0,1,216.88889,208H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.33333a8,8,0,0,1,4.8,1.6l27.73334,20.8a8,8,0,0,0,4.8,1.6H216A8,8,0,0,1,224,88Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,88V200.88889A7.11111,7.11111,0,0,1,216.88889,208H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.33333a8,8,0,0,1,4.8,1.6l27.73334,20.8a8,8,0,0,0,4.8,1.6H216A8,8,0,0,1,224,88Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6r = [];
/* style */

const __vue_inject_styles__$6r = undefined;
/* scoped */

const __vue_scope_id__$6r = undefined;
/* module identifier */

const __vue_module_identifier__$6r = undefined;
/* functional template */

const __vue_is_functional_template__$6r = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6r = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6r,
  staticRenderFns: __vue_staticRenderFns__$6r
}, __vue_inject_styles__$6r, __vue_script__$6r, __vue_scope_id__$6r, __vue_is_functional_template__$6r, __vue_module_identifier__$6r, false, undefined, undefined, undefined);

var script$6s = Vue.extend({
  name: "PhFolderSimpleMinus",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6s = script$6s;
/* template */

var __vue_render__$6s = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "104",
      "y1": "144",
      "x2": "152",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,88V200.88889A7.11111,7.11111,0,0,1,216.88889,208H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.33333a8,8,0,0,1,4.8,1.6l27.73334,20.8a8,8,0,0,0,4.8,1.6H216A8,8,0,0,1,224,88Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,88V200.88889A7.11111,7.11111,0,0,1,216.88889,208H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.33333a8,8,0,0,1,4.8,1.6l27.73334,20.8a8,8,0,0,0,4.8,1.6H216A8,8,0,0,1,224,88Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "103.99414",
      "y1": "144",
      "x2": "151.99414",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,88V200.88889A7.11111,7.11111,0,0,1,216.88889,208H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.33333a8,8,0,0,1,4.8,1.6l27.73334,20.8a8,8,0,0,0,4.8,1.6H216A8,8,0,0,1,224,88Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M215.99512,71.99805H130.667l-27.75-20.80469a16.07363,16.07363,0,0,0-9.57812-3.19531H39.99512a16.01581,16.01581,0,0,0-16,16v136a16.01582,16.01582,0,0,0,16,16H216.88574a15.13062,15.13062,0,0,0,15.10938-15.10938V87.99805A16.01582,16.01582,0,0,0,215.99512,71.99805ZM151.99414,152h-48a8,8,0,0,1,0-16h48a8,8,0,1,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "104",
      "y1": "144",
      "x2": "152",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,88V200.88889A7.11111,7.11111,0,0,1,216.88889,208H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.33333a8,8,0,0,1,4.8,1.6l27.73334,20.8a8,8,0,0,0,4.8,1.6H216A8,8,0,0,1,224,88Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "104",
      "y1": "144",
      "x2": "152",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,88V200.88889A7.11111,7.11111,0,0,1,216.88889,208H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.33333a8,8,0,0,1,4.8,1.6l27.73334,20.8a8,8,0,0,0,4.8,1.6H216A8,8,0,0,1,224,88Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "104",
      "y1": "144",
      "x2": "152",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,88V200.88889A7.11111,7.11111,0,0,1,216.88889,208H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.33333a8,8,0,0,1,4.8,1.6l27.73334,20.8a8,8,0,0,0,4.8,1.6H216A8,8,0,0,1,224,88Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6s = [];
/* style */

const __vue_inject_styles__$6s = undefined;
/* scoped */

const __vue_scope_id__$6s = undefined;
/* module identifier */

const __vue_module_identifier__$6s = undefined;
/* functional template */

const __vue_is_functional_template__$6s = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6s = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6s,
  staticRenderFns: __vue_staticRenderFns__$6s
}, __vue_inject_styles__$6s, __vue_script__$6s, __vue_scope_id__$6s, __vue_is_functional_template__$6s, __vue_module_identifier__$6s, false, undefined, undefined, undefined);

var script$6t = Vue.extend({
  name: "PhFolderSimplePlus",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6t = script$6t;
/* template */

var __vue_render__$6t = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,88V200.88889A7.11111,7.11111,0,0,1,216.88889,208H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.33333a8,8,0,0,1,4.8,1.6l27.73334,20.8a8,8,0,0,0,4.8,1.6H216A8,8,0,0,1,224,88Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "144",
      "x2": "152",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "120",
      "x2": "128",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,88V200.88889A7.11111,7.11111,0,0,1,216.88889,208H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.33333a8,8,0,0,1,4.8,1.6l27.73334,20.8a8,8,0,0,0,4.8,1.6H216A8,8,0,0,1,224,88Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,88V200.88889A7.11111,7.11111,0,0,1,216.88889,208H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.33333a8,8,0,0,1,4.8,1.6l27.73334,20.8a8,8,0,0,0,4.8,1.6H216A8,8,0,0,1,224,88Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "103.99414",
      "y1": "144",
      "x2": "151.99414",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "127.99414",
      "y1": "120",
      "x2": "127.99414",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M215.99512,71.99805H130.667l-27.75-20.80469a16.07363,16.07363,0,0,0-9.57812-3.19531H39.99512a16.01581,16.01581,0,0,0-16,16v136a16.01582,16.01582,0,0,0,16,16H216.88574a15.13062,15.13062,0,0,0,15.10938-15.10938V87.99805A16.01582,16.01582,0,0,0,215.99512,71.99805ZM152,152H136v16a8,8,0,0,1-16,0V152H104a8,8,0,0,1,0-16h16V120a8,8,0,0,1,16,0v16h16a8,8,0,0,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,88V200.88889A7.11111,7.11111,0,0,1,216.88889,208H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.33333a8,8,0,0,1,4.8,1.6l27.73334,20.8a8,8,0,0,0,4.8,1.6H216A8,8,0,0,1,224,88Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "144",
      "x2": "152",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "120",
      "x2": "128",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,88V200.88889A7.11111,7.11111,0,0,1,216.88889,208H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.33333a8,8,0,0,1,4.8,1.6l27.73334,20.8a8,8,0,0,0,4.8,1.6H216A8,8,0,0,1,224,88Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "144",
      "x2": "152",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "120",
      "x2": "128",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,88V200.88889A7.11111,7.11111,0,0,1,216.88889,208H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.33333a8,8,0,0,1,4.8,1.6l27.73334,20.8a8,8,0,0,0,4.8,1.6H216A8,8,0,0,1,224,88Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "144",
      "x2": "152",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "120",
      "x2": "128",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6t = [];
/* style */

const __vue_inject_styles__$6t = undefined;
/* scoped */

const __vue_scope_id__$6t = undefined;
/* module identifier */

const __vue_module_identifier__$6t = undefined;
/* functional template */

const __vue_is_functional_template__$6t = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6t = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6t,
  staticRenderFns: __vue_staticRenderFns__$6t
}, __vue_inject_styles__$6t, __vue_script__$6t, __vue_scope_id__$6t, __vue_is_functional_template__$6t, __vue_module_identifier__$6t, false, undefined, undefined, undefined);

var script$6u = Vue.extend({
  name: "PhFolders",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6u = script$6u;
/* template */

var __vue_render__$6u = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M196,116v88.88889A7.11111,7.11111,0,0,1,188.88889,212H36a8,8,0,0,1-8-8V92a8,8,0,0,1,8-8H81.33333a8,8,0,0,1,4.8,1.6l27.73334,20.8a8,8,0,0,0,4.8,1.6H188A8,8,0,0,1,196,116Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M68,84V52a8,8,0,0,1,8-8h45.33333a8,8,0,0,1,4.8,1.6l27.73334,20.8a8,8,0,0,0,4.8,1.6H228a8,8,0,0,1,8,8v88.88889A7.11111,7.11111,0,0,1,228.88889,172H196",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,72H154.6665a7.99938,7.99938,0,0,1-4.7998-1.6L122.1333,49.6a7.99938,7.99938,0,0,0-4.7998-1.6H72a7.99993,7.99993,0,0,0-8,8V80H85.3335a7.99938,7.99938,0,0,1,4.7998,1.6l27.7334,20.8a7.99938,7.99938,0,0,0,4.7998,1.6H192a7.99993,7.99993,0,0,1,8,8v64h24.88867A7.1111,7.1111,0,0,0,232,168.88892V80A7.99993,7.99993,0,0,0,224,72Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,112v88.88889A7.11111,7.11111,0,0,1,192.88889,208H40a8,8,0,0,1-8-8V88a8,8,0,0,1,8-8H85.33333a8,8,0,0,1,4.8,1.6l27.73334,20.8a8,8,0,0,0,4.8,1.6H192A8,8,0,0,1,200,112Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,80V56a8,8,0,0,1,8-8h45.33333a8,8,0,0,1,4.8,1.6l27.73334,20.8a8,8,0,0,0,4.8,1.6H224a8,8,0,0,1,8,8v88.88889A7.11111,7.11111,0,0,1,224.88889,176H200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,64H154.667l-27.7334-20.7998A16.10323,16.10323,0,0,0,117.333,40H72A16.01833,16.01833,0,0,0,56,56V72H40A16.01833,16.01833,0,0,0,24,88V200a16.01833,16.01833,0,0,0,16,16H192.88867A15.12831,15.12831,0,0,0,208,200.88867V184h16.88867A15.12831,15.12831,0,0,0,240,168.88867V80A16.01833,16.01833,0,0,0,224,64Zm0,104H208V112a16.01833,16.01833,0,0,0-16-16H122.667L94.93359,75.2002A16.10323,16.10323,0,0,0,85.333,72H72V56h45.333l27.7334,20.7998A16.10323,16.10323,0,0,0,154.667,80H224Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,112v88.88889A7.11111,7.11111,0,0,1,192.88889,208H40a8,8,0,0,1-8-8V88a8,8,0,0,1,8-8H85.33333a8,8,0,0,1,4.8,1.6l27.73334,20.8a8,8,0,0,0,4.8,1.6H192A8,8,0,0,1,200,112Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,80V56a8,8,0,0,1,8-8h45.33333a8,8,0,0,1,4.8,1.6l27.73334,20.8a8,8,0,0,0,4.8,1.6H224a8,8,0,0,1,8,8v88.88889A7.11111,7.11111,0,0,1,224.88889,176H200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,112v88.88889A7.11111,7.11111,0,0,1,192.88889,208H40a8,8,0,0,1-8-8V88a8,8,0,0,1,8-8H85.33333a8,8,0,0,1,4.8,1.6l27.73334,20.8a8,8,0,0,0,4.8,1.6H192A8,8,0,0,1,200,112Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,80V56a8,8,0,0,1,8-8h45.33333a8,8,0,0,1,4.8,1.6l27.73334,20.8a8,8,0,0,0,4.8,1.6H224a8,8,0,0,1,8,8v88.88889A7.11111,7.11111,0,0,1,224.88889,176H200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,112v88.88889A7.11111,7.11111,0,0,1,192.88889,208H40a8,8,0,0,1-8-8V88a8,8,0,0,1,8-8H85.33333a8,8,0,0,1,4.8,1.6l27.73334,20.8a8,8,0,0,0,4.8,1.6H192A8,8,0,0,1,200,112Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,112v88.88889A7.11111,7.11111,0,0,1,192.88889,208H40a8,8,0,0,1-8-8V88a8,8,0,0,1,8-8H85.33333a8,8,0,0,1,4.8,1.6l27.73334,20.8a8,8,0,0,0,4.8,1.6H192A8,8,0,0,1,200,112Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,80V56a8,8,0,0,1,8-8h45.33333a8,8,0,0,1,4.8,1.6l27.73334,20.8a8,8,0,0,0,4.8,1.6H224a8,8,0,0,1,8,8v88.88889A7.11111,7.11111,0,0,1,224.88889,176H200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6u = [];
/* style */

const __vue_inject_styles__$6u = undefined;
/* scoped */

const __vue_scope_id__$6u = undefined;
/* module identifier */

const __vue_module_identifier__$6u = undefined;
/* functional template */

const __vue_is_functional_template__$6u = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6u = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6u,
  staticRenderFns: __vue_staticRenderFns__$6u
}, __vue_inject_styles__$6u, __vue_script__$6u, __vue_scope_id__$6u, __vue_is_functional_template__$6u, __vue_module_identifier__$6u, false, undefined, undefined, undefined);

var script$6v = Vue.extend({
  name: "PhFootball",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6v = script$6v;
/* template */

var __vue_render__$6v = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M184.56854,184.56854c-41.52913,41.52913-99.19529,38.21906-126.92237,33.52363a24.07744,24.07744,0,0,1-19.73834-19.73834c-4.69543-27.72708-8.0055-85.39324,33.52363-126.92237S170.62675,33.2124,198.35383,37.90783a24.07744,24.07744,0,0,1,19.73834,19.73834C222.7876,85.37325,226.09767,143.03941,184.56854,184.56854Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "96",
      "x2": "96",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "124.68629",
      "y1": "102.05887",
      "x2": "153.94113",
      "y2": "131.31371",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "102.05887",
      "y1": "124.68629",
      "x2": "131.31371",
      "y2": "153.94113",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "148.22436",
      "y1": "36.22436",
      "x2": "219.77587",
      "y2": "107.77587",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "36.22399",
      "y1": "148.22399",
      "x2": "107.77612",
      "y2": "219.77612",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M184.56854,184.56854c-41.52913,41.52913-99.19529,38.21906-126.92237,33.52363a24.07744,24.07744,0,0,1-19.73834-19.73834c-4.69543-27.72708-8.0055-85.39324,33.52363-126.92237S170.62675,33.2124,198.35383,37.90783a24.07744,24.07744,0,0,1,19.73834,19.73834C222.7876,85.37325,226.09767,143.03941,184.56854,184.56854Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "96",
      "x2": "96",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "124.68629",
      "y1": "102.05887",
      "x2": "153.94113",
      "y2": "131.31371",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "102.05887",
      "y1": "124.68629",
      "x2": "131.31371",
      "y2": "153.94113",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "148.22436",
      "y1": "36.22436",
      "x2": "219.77587",
      "y2": "107.77587",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "36.22399",
      "y1": "148.22399",
      "x2": "107.77612",
      "y2": "219.77612",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M36.22334,148.22391c2.7732-25.26889,11.97219-53.55653,35.20812-76.79245s51.5238-32.435,76.79278-35.20816l.00012.00106,71.55151,71.55151.00081.00009c-2.77319,25.26892-11.97217,53.55662-35.20814,76.79258s-51.5235,32.4349-76.79237,35.20811Z",
      "opacity": "0.2"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M225.98,56.31055a32.13113,32.13113,0,0,0-26.29-26.29053c-31.35058-5.30908-90.43652-7.72363-133.915,35.75439-43.478,43.478-41.064,102.56446-35.75488,133.915a32.13113,32.13113,0,0,0,26.29,26.29053,200.74409,200.74409,0,0,0,33.27637,2.83984c31.082,0,69.78955-7.74511,100.63867-38.59423C233.70361,146.74756,231.28906,87.66113,225.98,56.31055Zm-166.998,153.894a16.11587,16.11587,0,0,1-13.18652-13.18652,184.687,184.687,0,0,1-2.68555-30.59473l46.48267,46.48291A185.002,185.002,0,0,1,58.98193,210.20459ZM165.65674,101.65674,150.6272,116.68652l8.97046,8.97022a8,8,0,0,1-11.31348,11.314L139.31372,128l-11.314,11.314,8.97045,8.97022a7.99983,7.99983,0,1,1-11.31347,11.31348l-8.97046-8.97022-15.02954,15.0293a7.99984,7.99984,0,0,1-11.31348-11.31348l15.02954-15.02978-8.97046-8.97022a8,8,0,0,1,11.31348-11.314L116.68628,128l11.314-11.314-8.97045-8.97022a7.99983,7.99983,0,1,1,11.31347-11.31348l8.97046,8.97022,15.02954-15.0293a7.99984,7.99984,0,0,1,11.31348,11.31348Zm.75024-58.563a185.0087,185.0087,0,0,1,30.61109,2.70166,16.11531,16.11531,0,0,1,13.18652,13.18652,184.687,184.687,0,0,1,2.68555,30.59473Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M184.56854,184.56854c-41.52913,41.52913-99.19529,38.21906-126.92237,33.52363a24.07744,24.07744,0,0,1-19.73834-19.73834c-4.69543-27.72708-8.0055-85.39324,33.52363-126.92237S170.62675,33.2124,198.35383,37.90783a24.07744,24.07744,0,0,1,19.73834,19.73834C222.7876,85.37325,226.09767,143.03941,184.56854,184.56854Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "96",
      "x2": "96",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "124.68629",
      "y1": "102.05887",
      "x2": "153.94113",
      "y2": "131.31371",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "102.05887",
      "y1": "124.68629",
      "x2": "131.31371",
      "y2": "153.94113",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "148.22436",
      "y1": "36.22436",
      "x2": "219.77587",
      "y2": "107.77587",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "36.22399",
      "y1": "148.22399",
      "x2": "107.77612",
      "y2": "219.77612",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M184.56854,184.56854c-41.52913,41.52913-99.19529,38.21906-126.92237,33.52363a24.07744,24.07744,0,0,1-19.73834-19.73834c-4.69543-27.72708-8.0055-85.39324,33.52363-126.92237S170.62675,33.2124,198.35383,37.90783a24.07744,24.07744,0,0,1,19.73834,19.73834C222.7876,85.37325,226.09767,143.03941,184.56854,184.56854Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "96",
      "x2": "96",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "124.68629",
      "y1": "102.05887",
      "x2": "153.94113",
      "y2": "131.31371",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "102.05887",
      "y1": "124.68629",
      "x2": "131.31371",
      "y2": "153.94113",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "148.22436",
      "y1": "36.22436",
      "x2": "219.77587",
      "y2": "107.77587",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "36.22399",
      "y1": "148.22399",
      "x2": "107.77612",
      "y2": "219.77612",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M184.56854,184.56854c-41.52913,41.52913-99.19529,38.21906-126.92237,33.52363a24.07744,24.07744,0,0,1-19.73834-19.73834c-4.69543-27.72708-8.0055-85.39324,33.52363-126.92237S170.62675,33.2124,198.35383,37.90783a24.07744,24.07744,0,0,1,19.73834,19.73834C222.7876,85.37325,226.09767,143.03941,184.56854,184.56854Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "96",
      "x2": "96",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "124.68629",
      "y1": "102.05887",
      "x2": "153.94113",
      "y2": "131.31371",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "102.05887",
      "y1": "124.68629",
      "x2": "131.31371",
      "y2": "153.94113",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "148.22436",
      "y1": "36.22436",
      "x2": "219.77587",
      "y2": "107.77587",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "36.22399",
      "y1": "148.22399",
      "x2": "107.77612",
      "y2": "219.77612",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6v = [];
/* style */

const __vue_inject_styles__$6v = undefined;
/* scoped */

const __vue_scope_id__$6v = undefined;
/* module identifier */

const __vue_module_identifier__$6v = undefined;
/* functional template */

const __vue_is_functional_template__$6v = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6v = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6v,
  staticRenderFns: __vue_staticRenderFns__$6v
}, __vue_inject_styles__$6v, __vue_script__$6v, __vue_scope_id__$6v, __vue_is_functional_template__$6v, __vue_module_identifier__$6v, false, undefined, undefined, undefined);

var script$6w = Vue.extend({
  name: "PhForkKnife",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6w = script$6w;
/* template */

var __vue_render__$6w = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "84",
      "y1": "32",
      "x2": "84",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "84",
      "y1": "116",
      "x2": "84",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M120,32V80a36,36,0,0,1-72,0V32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M204,160H148S160,48,204,32V224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M204,160H148S160,48,204,32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "84",
      "y1": "32",
      "x2": "84",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "84",
      "y1": "116",
      "x2": "84",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112,32l8,48a36,36,0,0,1-72,0l8-48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M204,160H148S160,48,204,32V224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M127.98877,79.77539c-.00439-.14453-.00977-.28906-.022-.43457-.01221-.146-.03028-.29-.04981-.43359-.01074-.07422-.01367-.14795-.02588-.22266l-8-48a8,8,0,1,0-15.78222,2.63086L110.55615,72H92V32a8,8,0,0,0-16,0V72H57.44385l6.44726-38.68457a8,8,0,1,0-15.78222-2.63086l-8,48c-.01221.07471-.01514.14844-.02588.22266-.01953.14355-.0376.28759-.04981.43359-.0122.14551-.01758.29-.022.43457C40.00928,79.85059,40,79.92432,40,80c0,.07129.00488.14111.00537.21191.00147.04932.00147.09815.00391.147A44.06056,44.06056,0,0,0,76,123.25781V224a8,8,0,0,0,16,0V123.25781a44.06056,44.06056,0,0,0,35.99072-42.89892c.00244-.04883.00244-.09766.00391-.147C127.99512,80.14111,128,80.07129,128,80,128,79.92432,127.99072,79.85059,127.98877,79.77539Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M211.99268,31.8584c-.00245-.165-.01172-.33008-.02491-.49561-.00879-.1123-.019-.22363-.03271-.33447-.01709-.13818-.03858-.27637-.063-.41455-.02441-.13916-.05127-.27686-.08252-.41309-.02539-.10839-.05371-.2163-.0835-.32422-.04443-.16064-.09228-.31884-.14648-.47509-.01514-.04492-.0249-.09033-.041-.13526-.01806-.04834-.041-.09326-.05957-.14111q-.09081-.23511-.19531-.46191-.06738-.148-.14062-.292-.09888-.19335-.208-.38037c-.06445-.11181-.13037-.22168-.19971-.32959-.06592-.10156-.13476-.20019-.20508-.29883-.08447-.11914-.17041-.23584-.26123-.34912-.0664-.08349-.13574-.16406-.20507-.24463-.1001-.11523-.20166-.229-.30762-.33789-.07422-.07617-.15137-.14941-.22852-.22265-.10644-.10156-.21386-.20117-.32568-.29639-.08984-.07666-.18311-.14892-.27637-.22168-.10449-.08105-.20947-.16162-.31787-.23779-.11084-.07764-.2251-.15039-.33984-.22217-.09717-.061-.19434-.12256-.29444-.1792-.13037-.07422-.26367-.14258-.39843-.20947-.09229-.0459-.18409-.0918-.27832-.13428-.14161-.06348-.28565-.12109-.43165-.17676-.09667-.03662-.19287-.07324-.2915-.10644-.13965-.04737-.28174-.08887-.4248-.12842-.11426-.03174-.228-.06152-.34327-.08838-.12695-.02881-.25537-.05371-.38427-.07666-.14063-.02539-.28076-.04687-.42285-.06445-.10889-.01319-.21827-.02393-.32862-.03321q-.24535-.01977-.49365-.0249C204.10352,24.00684,204.05273,24,204,24c-.04834,0-.0957.00635-.14355.00732-.16407.00293-.32813.01172-.49268.02491-.11279.00879-.22461.019-.33594.03271-.13818.01709-.27588.03858-.41406.063-.13916.02441-.27686.05127-.41309.083-.10839.0249-.2163.05322-.32422.083-.16064.04394-.31884.09228-.47509.14648-.04492.01514-.09033.0249-.13526.041-.09863.03613-.1958.0791-.29394.11572-.03711.01513-.0752.02832-.11231.04394-20.60986,7.74561-37.11474,33.0293-49.05713,75.17823a398.22183,398.22183,0,0,0-11.75683,59.32812A8.00051,8.00051,0,0,0,148,168h48v56a8,8,0,0,0,16,0V32C212,31.95215,211.99365,31.90625,211.99268,31.8584Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "84",
      "y1": "32",
      "x2": "84",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "84",
      "y1": "116",
      "x2": "84",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112,32l8,48a36,36,0,0,1-72,0l8-48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M204,160H148S160,48,204,32V224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "84",
      "y1": "32",
      "x2": "84",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "84",
      "y1": "116",
      "x2": "84",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112,32l8,48a36,36,0,0,1-72,0l8-48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M204,160H148S160,48,204,32V224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "84",
      "y1": "32",
      "x2": "84",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "84",
      "y1": "116",
      "x2": "84",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112,32l8,48a36,36,0,0,1-72,0l8-48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M204,160H148S160,48,204,32V224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6w = [];
/* style */

const __vue_inject_styles__$6w = undefined;
/* scoped */

const __vue_scope_id__$6w = undefined;
/* module identifier */

const __vue_module_identifier__$6w = undefined;
/* functional template */

const __vue_is_functional_template__$6w = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6w = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6w,
  staticRenderFns: __vue_staticRenderFns__$6w
}, __vue_inject_styles__$6w, __vue_script__$6w, __vue_scope_id__$6w, __vue_is_functional_template__$6w, __vue_module_identifier__$6w, false, undefined, undefined, undefined);

var script$6x = Vue.extend({
  name: "PhFrameCorners",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6x = script$6x;
/* template */

var __vue_render__$6x = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "152 88 184 88 184 120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "104 168 72 168 72 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 80 192 80 192 112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 176 64 176 64 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,40H40A16.01833,16.01833,0,0,0,24,56V200a16.01833,16.01833,0,0,0,16,16H216a16.01833,16.01833,0,0,0,16-16V56A16.01833,16.01833,0,0,0,216,40ZM88,192H56a8.00008,8.00008,0,0,1-8-8V152a8,8,0,0,1,16,0v24H88a8,8,0,0,1,0,16Zm120-88a8,8,0,0,1-16,0V80H168a8,8,0,0,1,0-16h32a8.00008,8.00008,0,0,1,8,8Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "160 80 192 80 192 112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 176 64 176 64 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "160 80 192 80 192 112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 176 64 176 64 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "160 80 192 80 192 112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 176 64 176 64 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6x = [];
/* style */

const __vue_inject_styles__$6x = undefined;
/* scoped */

const __vue_scope_id__$6x = undefined;
/* module identifier */

const __vue_module_identifier__$6x = undefined;
/* functional template */

const __vue_is_functional_template__$6x = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6x = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6x,
  staticRenderFns: __vue_staticRenderFns__$6x
}, __vue_inject_styles__$6x, __vue_script__$6x, __vue_scope_id__$6x, __vue_is_functional_template__$6x, __vue_module_identifier__$6x, false, undefined, undefined, undefined);

var script$6y = Vue.extend({
  name: "PhFramerLogo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6y = script$6y;
/* template */

var __vue_render__$6y = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "56 100 56 168 128 236 128 168 200 168 56 32 200 32 200 100 56 100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "56 100 56 168 128 236 128 168 200 168 56 32 200 32 200 100 56 100",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "56 100 56 168 128 236 128 168 200 168 56 32 200 32 200 100 56 100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,100V32a8.00008,8.00008,0,0,0-8-8H56a8,8,0,0,0-5.49316,13.81592L107.87793,92H56a8.00008,8.00008,0,0,0-8,8v68a7.99941,7.99941,0,0,0,2.50684,5.81592l72,68A7.99984,7.99984,0,0,0,136,236V176h64a8,8,0,0,0,5.49316-13.81592L148.12207,108H200A8.00008,8.00008,0,0,0,208,100Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "56 100 56 168 128 236 128 168 200 168 56 32 200 32 200 100 56 100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "56 100 56 168 128 236 128 168 200 168 56 32 200 32 200 100 56 100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "56 100 56 168 128 236 128 168 200 168 56 32 200 32 200 100 56 100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6y = [];
/* style */

const __vue_inject_styles__$6y = undefined;
/* scoped */

const __vue_scope_id__$6y = undefined;
/* module identifier */

const __vue_module_identifier__$6y = undefined;
/* functional template */

const __vue_is_functional_template__$6y = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6y = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6y,
  staticRenderFns: __vue_staticRenderFns__$6y
}, __vue_inject_styles__$6y, __vue_script__$6y, __vue_scope_id__$6y, __vue_is_functional_template__$6y, __vue_module_identifier__$6y, false, undefined, undefined, undefined);

var script$6z = Vue.extend({
  name: "PhFunnel",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6z = script$6z;
/* template */

var __vue_render__$6z = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M42.08441,48H213.91559a8,8,0,0,1,5.91952,13.38138l-65.75463,72.33009A8,8,0,0,0,152,139.09285v56.62568a8,8,0,0,1-3.5624,6.6564l-32,21.33334A8,8,0,0,1,104,217.05186v-77.959a8,8,0,0,0-2.08048-5.38138L36.16489,61.38138A8,8,0,0,1,42.08441,48Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M42.08441,48H213.91559a8,8,0,0,1,5.91952,13.38138l-65.75463,72.33009A8,8,0,0,0,152,139.09285v56.62568a8,8,0,0,1-3.5624,6.6564l-32,21.33334A8,8,0,0,1,104,217.05186v-77.959a8,8,0,0,0-2.08048-5.38138L36.16489,61.38138A8,8,0,0,1,42.08441,48Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M42.08441,48H213.91559a8,8,0,0,1,5.91952,13.38138l-65.75463,72.33009A8,8,0,0,0,152,139.09285v56.62568a8,8,0,0,1-3.5624,6.6564l-32,21.33334A8,8,0,0,1,104,217.05186v-77.959a8,8,0,0,0-2.08048-5.38138L36.16489,61.38138A8,8,0,0,1,42.08441,48Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M228.54736,49.52637A15.80639,15.80639,0,0,0,213.91553,40H42.08447A16.00043,16.00043,0,0,0,30.24561,66.76367L96,139.09277v77.959a15.99388,15.99388,0,0,0,24.875,13.3125l31.99951-21.332A15.96822,15.96822,0,0,0,160,195.71875v-56.625l65.75488-72.331A15.80708,15.80708,0,0,0,228.54736,49.52637Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M42.08441,48H213.91559a8,8,0,0,1,5.91952,13.38138l-65.75463,72.33009A8,8,0,0,0,152,139.09285v56.62568a8,8,0,0,1-3.5624,6.6564l-32,21.33334A8,8,0,0,1,104,217.05186v-77.959a8,8,0,0,0-2.08048-5.38138L36.16489,61.38138A8,8,0,0,1,42.08441,48Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M42.08441,48H213.91559a8,8,0,0,1,5.91952,13.38138l-65.75463,72.33009A8,8,0,0,0,152,139.09285v56.62568a8,8,0,0,1-3.5624,6.6564l-32,21.33334A8,8,0,0,1,104,217.05186v-77.959a8,8,0,0,0-2.08048-5.38138L36.16489,61.38138A8,8,0,0,1,42.08441,48Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M42.08441,48H213.91559a8,8,0,0,1,5.91952,13.38138l-65.75463,72.33009A8,8,0,0,0,152,139.09285v56.62568a8,8,0,0,1-3.5624,6.6564l-32,21.33334A8,8,0,0,1,104,217.05186v-77.959a8,8,0,0,0-2.08048-5.38138L36.16489,61.38138A8,8,0,0,1,42.08441,48Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6z = [];
/* style */

const __vue_inject_styles__$6z = undefined;
/* scoped */

const __vue_scope_id__$6z = undefined;
/* module identifier */

const __vue_module_identifier__$6z = undefined;
/* functional template */

const __vue_is_functional_template__$6z = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6z = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6z,
  staticRenderFns: __vue_staticRenderFns__$6z
}, __vue_inject_styles__$6z, __vue_script__$6z, __vue_scope_id__$6z, __vue_is_functional_template__$6z, __vue_module_identifier__$6z, false, undefined, undefined, undefined);

var script$6A = Vue.extend({
  name: "PhFunnelSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6A = script$6A;
/* template */

var __vue_render__$6A = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "64",
      "y1": "128",
      "x2": "192",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "80",
      "x2": "232",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "176",
      "x2": "152",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "64",
      "y1": "128",
      "x2": "192",
      "y2": "128",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "80",
      "x2": "232",
      "y2": "80",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "176",
      "x2": "152",
      "y2": "176",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M192,120H64a8,8,0,0,0,0,16H192a8,8,0,0,0,0-16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M232,72H24a8,8,0,0,0,0,16H232a8,8,0,0,0,0-16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,168H104a8,8,0,0,0,0,16h48a8,8,0,0,0,0-16Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "64",
      "y1": "128",
      "x2": "192",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "80",
      "x2": "232",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "176",
      "x2": "152",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "64",
      "y1": "128",
      "x2": "192",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "80",
      "x2": "232",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "176",
      "x2": "152",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "64",
      "y1": "128",
      "x2": "192",
      "y2": "128",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "80",
      "x2": "232",
      "y2": "80",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "176",
      "x2": "152",
      "y2": "176",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6A = [];
/* style */

const __vue_inject_styles__$6A = undefined;
/* scoped */

const __vue_scope_id__$6A = undefined;
/* module identifier */

const __vue_module_identifier__$6A = undefined;
/* functional template */

const __vue_is_functional_template__$6A = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6A = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6A,
  staticRenderFns: __vue_staticRenderFns__$6A
}, __vue_inject_styles__$6A, __vue_script__$6A, __vue_scope_id__$6A, __vue_is_functional_template__$6A, __vue_module_identifier__$6A, false, undefined, undefined, undefined);

var script$6B = Vue.extend({
  name: "PhGameController",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6B = script$6B;
/* template */

var __vue_render__$6B = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "152",
      "y1": "108",
      "x2": "184",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "108",
      "x2": "104",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "92",
      "x2": "88",
      "y2": "124",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M172.01831,55.7398,84.00446,56A52.01509,52.01509,0,0,0,32.78594,98.96873l.00852.00156-16.3644,84.16289A28.00192,28.00192,0,0,0,63.80532,207.796l-.00165-.00173L107.03924,160l64.97907-.2602a52,52,0,0,0,0-104Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M223.22831,98.71009l16.351,84.42309A28.00192,28.00192,0,0,1,192.204,207.796l.00166-.00173L149,159.832",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M149,159.832l23.01835-.09217a52.04589,52.04589,0,0,0,51.21853-61.03119l-.00853.00148,16.351,84.42309A28.00192,28.00192,0,0,1,192.204,207.796l.00166-.00173L149,159.832Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "108",
      "x2": "184",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "108",
      "x2": "104",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "92",
      "x2": "88",
      "y2": "124",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M172.01831,55.7398,84.00446,56A52.01509,52.01509,0,0,0,32.78594,98.96873l.00852.00156-16.3644,84.16289A28.00192,28.00192,0,0,0,63.80532,207.796l-.00165-.00173L107.03924,160l64.97907-.2602a52,52,0,0,0,0-104Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M223.22831,98.71009l16.351,84.42309A28.00192,28.00192,0,0,1,192.204,207.796l.00166-.00173L149,159.832",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M247.45752,181.74316c-.00781-.04394-.01611-.08789-.02441-.13183L231.08252,97.18848c-.01221-.06348-.0321-.123-.0459-.186a60.08639,60.08639,0,0,0-59.01855-49.26221h-.02344L84.00439,48A59.86832,59.86832,0,0,0,24.90625,97.58887c-.0127.07226-.02441.14551-.03516.21777L8.57715,181.60547c-.00879.0459-.01709.0918-.02539.13769A36.00238,36.00238,0,0,0,69.45752,213.457q.21753-.2168.416-.44726l40.729-45.02442,34.84961-.13916,40.67139,45.14893q.20361.2373.42822.46191a36.00125,36.00125,0,0,0,60.90576-31.71387ZM104,116H96v8a8,8,0,0,1-16,0v-8H72a8,8,0,0,1,0-16h8V92a8,8,0,0,1,16,0v8h8a8,8,0,0,1,0,16Zm40-8a8.00008,8.00008,0,0,1,8-8h32a8,8,0,0,1,0,16H152A8.00008,8.00008,0,0,1,144,108Zm71.47754,99.69141a20.03371,20.03371,0,0,1-17.45606-5.39453l-31.11169-34.53614,5.10828-.02051a60.00525,60.00525,0,0,0,50.94067-28.34961l8.75269,45.19239A20.02155,20.02155,0,0,1,215.47754,207.69141Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "152",
      "y1": "108",
      "x2": "184",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "108",
      "x2": "104",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "92",
      "x2": "88",
      "y2": "124",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M172.01831,55.7398,84.00446,56A52.01509,52.01509,0,0,0,32.78594,98.96873l.00852.00156-16.3644,84.16289A28.00192,28.00192,0,0,0,63.80532,207.796l-.00165-.00173L107.03924,160l64.97907-.2602a52,52,0,0,0,0-104Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M223.22831,98.71009l16.351,84.42309A28.00192,28.00192,0,0,1,192.204,207.796l.00166-.00173L149,159.832",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "152",
      "y1": "108",
      "x2": "184",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "108",
      "x2": "104",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "92",
      "x2": "88",
      "y2": "124",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M172.01831,55.7398,84.00446,56A52.01509,52.01509,0,0,0,32.78594,98.96873l.00852.00156-16.3644,84.16289A28.00192,28.00192,0,0,0,63.80532,207.796l-.00165-.00173L107.03924,160l64.97907-.2602a52,52,0,0,0,0-104Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M223.22831,98.71009l16.351,84.42309A28.00192,28.00192,0,0,1,192.204,207.796l.00166-.00173L149,159.832",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "152",
      "y1": "108",
      "x2": "184",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "108",
      "x2": "104",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "92",
      "x2": "88",
      "y2": "124",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M172.01831,55.7398,84.00446,56A52.01509,52.01509,0,0,0,32.78594,98.96873l.00852.00156-16.3644,84.16289A28.00192,28.00192,0,0,0,63.80532,207.796l-.00165-.00173L107.03924,160l64.97907-.2602a52,52,0,0,0,0-104Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M223.22831,98.71009l16.351,84.42309A28.00192,28.00192,0,0,1,192.204,207.796l.00166-.00173L149,159.832",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6B = [];
/* style */

const __vue_inject_styles__$6B = undefined;
/* scoped */

const __vue_scope_id__$6B = undefined;
/* module identifier */

const __vue_module_identifier__$6B = undefined;
/* functional template */

const __vue_is_functional_template__$6B = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6B = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6B,
  staticRenderFns: __vue_staticRenderFns__$6B
}, __vue_inject_styles__$6B, __vue_script__$6B, __vue_scope_id__$6B, __vue_is_functional_template__$6B, __vue_module_identifier__$6B, false, undefined, undefined, undefined);

var script$6C = Vue.extend({
  name: "PhGasPump",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6C = script$6C;
/* template */

var __vue_render__$6C = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56,216V56A16,16,0,0,1,72,40h80a16,16,0,0,1,16,16V216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "216",
      "x2": "192",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,112h24a16,16,0,0,1,16,16v40a16,16,0,0,0,16,16h4a16,16,0,0,0,16-16V86.62742a16,16,0,0,0-4.68629-11.31371L220,56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "112",
      "x2": "96",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56,216V56A16,16,0,0,1,72,40h80a16,16,0,0,1,16,16V216",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,216V56A16,16,0,0,1,72,40h80a16,16,0,0,1,16,16V216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "216",
      "x2": "192",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,112h24a16,16,0,0,1,16,16v40a16,16,0,0,0,16,16h0a16,16,0,0,0,16-16V86.62741a16,16,0,0,0-4.68629-11.3137L216,56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "112",
      "x2": "88",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M240.9707,69.65625l-19.314-19.31348a8.00018,8.00018,0,1,0-11.31348,11.31446l19.313,19.3125A7.94757,7.94757,0,0,1,232,86.62695V168a8,8,0,0,1-16,0V128a24.0275,24.0275,0,0,0-24-24H176V56a24.0275,24.0275,0,0,0-24-24H72A24.0275,24.0275,0,0,0,48,56V208H32a8,8,0,0,0,0,16H192a8,8,0,0,0,0-16H176V120h16a8.00917,8.00917,0,0,1,8,8v40a24,24,0,0,0,48,0V86.62695A23.84506,23.84506,0,0,0,240.9707,69.65625ZM144,120H80a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56,216V56A16,16,0,0,1,72,40h80a16,16,0,0,1,16,16V216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "216",
      "x2": "192",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,112h24a16,16,0,0,1,16,16v40a16,16,0,0,0,16,16h0a16,16,0,0,0,16-16V86.62741a16,16,0,0,0-4.68629-11.3137L216,56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "112",
      "x2": "88",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56,216V56A16,16,0,0,1,72,40h80a16,16,0,0,1,16,16V216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "216",
      "x2": "192",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,112h24a16,16,0,0,1,16,16v40a16,16,0,0,0,16,16h0a16,16,0,0,0,16-16V86.62741a16,16,0,0,0-4.68629-11.3137L216,56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "112",
      "x2": "88",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56,216V56A16,16,0,0,1,72,40h80a16,16,0,0,1,16,16V216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "216",
      "x2": "192",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,112h24a16,16,0,0,1,16,16v40a16,16,0,0,0,16,16h0a16,16,0,0,0,16-16V86.62741a16,16,0,0,0-4.68629-11.3137L216,56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "112",
      "x2": "88",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6C = [];
/* style */

const __vue_inject_styles__$6C = undefined;
/* scoped */

const __vue_scope_id__$6C = undefined;
/* module identifier */

const __vue_module_identifier__$6C = undefined;
/* functional template */

const __vue_is_functional_template__$6C = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6C = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6C,
  staticRenderFns: __vue_staticRenderFns__$6C
}, __vue_inject_styles__$6C, __vue_script__$6C, __vue_scope_id__$6C, __vue_is_functional_template__$6C, __vue_module_identifier__$6C, false, undefined, undefined, undefined);

var script$6D = Vue.extend({
  name: "PhGauge",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6D = script$6D;
/* template */

var __vue_render__$6D = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M24,184V161.12886C24,103.65,70.15361,56.19953,127.63214,56.00066A104,104,0,0,1,232,160v24a8,8,0,0,1-8,8H32A8,8,0,0,1,24,184Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "56",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "27.54371",
      "y1": "133.08282",
      "x2": "58.45334",
      "y2": "141.36503",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "228.45629",
      "y1": "133.08282",
      "x2": "197.54666",
      "y2": "141.36503",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "103.44553",
      "y1": "192.00001",
      "x2": "171.83082",
      "y2": "102.87856",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M24,184V161.12886C24,103.65,70.15361,56.19953,127.63214,56.00066A104,104,0,0,1,232,160v24a8,8,0,0,1-8,8H32A8,8,0,0,1,24,184Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,184V161.12886C24,103.65,70.15361,56.19953,127.63214,56.00066A104,104,0,0,1,232,160v24a8,8,0,0,1-8,8H32A8,8,0,0,1,24,184Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "56",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "27.54371",
      "y1": "133.08282",
      "x2": "58.45334",
      "y2": "141.36503",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "228.45629",
      "y1": "133.08282",
      "x2": "197.54666",
      "y2": "141.36503",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "103.44553",
      "y1": "192.00001",
      "x2": "171.83082",
      "y2": "102.87856",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M215.07227,144.95117a8.00019,8.00019,0,0,1-4.14161-15.45508l22.95557-6.15088A112.20282,112.20282,0,0,0,136,48.28271V72a8,8,0,0,1-16,0V48.29443c-45.14648,3.23975-83.01074,33.69385-97.582,75.13233l22.65137,6.06933a8.0002,8.0002,0,1,1-4.14161,15.45508L18.18945,138.8584A114.064,114.064,0,0,0,16,161.12891V184a16.01833,16.01833,0,0,0,16,16H87.22314L165.48389,98.00879a8.00009,8.00009,0,0,1,12.69384,9.74023L107.39062,200H224a16.01833,16.01833,0,0,0,16-16V160a113.2326,113.2326,0,0,0-1.99658-21.19336Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M24,184V161.12886C24,103.65,70.15361,56.19953,127.63214,56.00066A104,104,0,0,1,232,160v24a8,8,0,0,1-8,8H32A8,8,0,0,1,24,184Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "56",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "27.54371",
      "y1": "133.08282",
      "x2": "58.45334",
      "y2": "141.36503",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "228.45629",
      "y1": "133.08282",
      "x2": "197.54666",
      "y2": "141.36503",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "103.44553",
      "y1": "192.00001",
      "x2": "171.83082",
      "y2": "102.87856",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M24,184V161.12886C24,103.65,70.15361,56.19953,127.63214,56.00066A104,104,0,0,1,232,160v24a8,8,0,0,1-8,8H32A8,8,0,0,1,24,184Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "56",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "27.54371",
      "y1": "133.08282",
      "x2": "58.45334",
      "y2": "141.36503",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "228.45629",
      "y1": "133.08282",
      "x2": "197.54666",
      "y2": "141.36503",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "103.44553",
      "y1": "192.00001",
      "x2": "171.83082",
      "y2": "102.87856",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M24,184V161.12886C24,103.65,70.15361,56.19953,127.63214,56.00066A104,104,0,0,1,232,160v24a8,8,0,0,1-8,8H32A8,8,0,0,1,24,184Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "56",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "27.54371",
      "y1": "133.08282",
      "x2": "58.45334",
      "y2": "141.36503",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "228.45629",
      "y1": "133.08282",
      "x2": "197.54666",
      "y2": "141.36503",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "103.44553",
      "y1": "192.00001",
      "x2": "171.83082",
      "y2": "102.87856",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6D = [];
/* style */

const __vue_inject_styles__$6D = undefined;
/* scoped */

const __vue_scope_id__$6D = undefined;
/* module identifier */

const __vue_module_identifier__$6D = undefined;
/* functional template */

const __vue_is_functional_template__$6D = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6D = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6D,
  staticRenderFns: __vue_staticRenderFns__$6D
}, __vue_inject_styles__$6D, __vue_script__$6D, __vue_scope_id__$6D, __vue_is_functional_template__$6D, __vue_module_identifier__$6D, false, undefined, undefined, undefined);

var script$6E = Vue.extend({
  name: "PhGear",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6E = script$6E;
/* template */

var __vue_render__$6E = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "44",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M183.6638,65.08649a84.52233,84.52233,0,0,1,7.2522,7.2521l27.32234,3.90156A103.36981,103.36981,0,0,1,228.40205,100.801L211.84758,122.8728s.20824,6.83942.00065,10.2547l16.561,22.07863a103.36931,103.36931,0,0,1-10.18033,24.554L190.916,183.66144s-4.689,4.98345-7.25071,7.25163l-3.90155,27.32234a103.36971,103.36971,0,0,1-24.56087,10.16371L133.1325,211.84524a84.521,84.521,0,0,1-10.25609.00006l-22.07863,16.561A103.36914,103.36914,0,0,1,76.2438,218.226L72.343,190.91449a84.521,84.521,0,0,1-7.2522-7.25211l-27.32235-3.90155A103.36968,103.36968,0,0,1,27.60479,155.2l16.55447-22.07178s-.20824-6.83942-.00066-10.2547l-16.561-22.07863a103.37,103.37,0,0,1,10.18033-24.554l27.31149-3.90076a84.52233,84.52233,0,0,1,7.2521-7.2522l3.90156-27.32235a103.37019,103.37019,0,0,1,24.56086-10.1637l22.0704,16.55388a84.52281,84.52281,0,0,1,10.25608-.00007l22.07864-16.561A103.37014,103.37014,0,0,1,179.763,37.775Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M211.8501,133.12744c.20752-3.41528-.00049-10.25464-.00049-10.25464l16.5542-22.07177a103.36316,103.36316,0,0,0-10.16358-24.5608L190.918,72.33862a84.52765,84.52765,0,0,0-7.25195-7.25219L179.76514,37.7749a103.36081,103.36081,0,0,0-24.5542-10.18017l-22.07862,16.561a84.505,84.505,0,0,0-10.25586,0l-22.0708-16.55395A103.37063,103.37063,0,0,0,76.24512,37.76562L72.34375,65.08789a84.46168,84.46168,0,0,0-7.25244,7.2522L37.77979,76.24072a103.37861,103.37861,0,0,0-10.18018,24.5542l16.561,22.07862c-.20752,3.41528.00049,10.25463.00049,10.25463L27.60693,155.2a103.36309,103.36309,0,0,0,10.16358,24.56079l27.32226,3.90161a84.46312,84.46312,0,0,0,7.25244,7.2522l3.9004,27.31152a103.36018,103.36018,0,0,0,24.55419,10.18018l22.07862-16.561a84.50294,84.50294,0,0,0,10.25586,0l22.0708,16.554a103.37032,103.37032,0,0,0,24.56054-10.16382l3.90186-27.32226c2.56152-2.26807,7.25049-7.25171,7.25049-7.25171l27.313-3.90113a103.37883,103.37883,0,0,0,10.18017-24.5542ZM128.00488,176a48,48,0,1,1,48-48A47.99988,47.99988,0,0,1,128.00488,176Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128.00488",
      "cy": "128",
      "r": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M183.66575,65.08649a84.52233,84.52233,0,0,1,7.2522,7.2521l27.32235,3.90156A103.37019,103.37019,0,0,1,228.404,100.801L211.84953,122.8728s.20824,6.83942.00066,10.2547l16.561,22.07863a103.37014,103.37014,0,0,1-10.18033,24.554L190.918,183.66144s-4.689,4.98345-7.2507,7.25163l-3.90156,27.32234a103.36981,103.36981,0,0,1-24.56086,10.16371l-22.0704-16.55388a84.521,84.521,0,0,1-10.25609.00006l-22.07863,16.561a103.36931,103.36931,0,0,1-24.554-10.18033L72.345,190.91449a84.521,84.521,0,0,1-7.2522-7.25211l-27.32234-3.90155A103.36971,103.36971,0,0,1,27.60674,155.2l16.55447-22.07178s-.20824-6.83942-.00065-10.2547l-16.561-22.07863a103.36914,103.36914,0,0,1,10.18033-24.554l27.31148-3.90076a84.521,84.521,0,0,1,7.25211-7.2522L76.245,37.76556a103.37009,103.37009,0,0,1,24.56087-10.1637l22.07039,16.55388a84.523,84.523,0,0,1,10.25609-.00007l22.07863-16.561A103.37,103.37,0,0,1,179.765,37.775Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M234.80957,150.40576l-14.87793-19.835c.02246-1.75244.0044-3.62207-.02148-5.11377l14.89257-19.856a8.0008,8.0008,0,0,0,1.32422-6.88476,111.46438,111.46438,0,0,0-10.95068-26.46094,7.99971,7.99971,0,0,0-5.80615-3.93457l-24.48731-3.49707q-1.7981-1.90282-3.70312-3.70361l-3.4961-24.47657a8.00016,8.00016,0,0,0-3.93261-5.80419,111.45413,111.45413,0,0,0-26.45313-10.96729,8.00181,8.00181,0,0,0-6.88818,1.32275L130.62207,36.0376c-1.74414-.04834-3.49316-.04834-5.2373,0l-19.7793-14.83545a8.003,8.003,0,0,0-6.88526-1.32373A111.45813,111.45813,0,0,0,72.25928,30.82861a8.00164,8.00164,0,0,0-3.93506,5.80616L64.82764,61.12158q-1.90211,1.79809-3.70362,3.7041L36.64746,68.32129a7.99959,7.99959,0,0,0-5.8042,3.93213A111.45433,111.45433,0,0,0,19.876,98.70752a7.99838,7.99838,0,0,0,1.32324,6.88769l14.87793,19.835c-.02246,1.75244-.0044,3.62207.02148,5.11377l-14.89258,19.856a8.00086,8.00086,0,0,0-1.32421,6.88477,111.46455,111.46455,0,0,0,10.95068,26.46094,7.99971,7.99971,0,0,0,5.80615,3.93457L61.126,191.17725q1.7981,1.90283,3.70312,3.70361l3.4961,24.47656a8.00016,8.00016,0,0,0,3.93261,5.8042,111.45413,111.45413,0,0,0,26.45313,10.96729,7.9997,7.9997,0,0,0,6.88818-1.32276l19.7876-14.84277c1.74414.04932,3.49316.04932,5.2373,0l19.7793,14.83545a7.99882,7.99882,0,0,0,6.88525,1.32373,111.45806,111.45806,0,0,0,26.46094-10.9502,8.00161,8.00161,0,0,0,3.93506-5.80615l3.50488-24.54541c1.25489-1.22363,2.56348-2.5581,3.60059-3.63135l24.57129-3.50976a7.99959,7.99959,0,0,0,5.8042-3.93213,111.45433,111.45433,0,0,0,10.96728-26.4541A7.9984,7.9984,0,0,0,234.80957,150.40576ZM128.00391,172a44,44,0,1,1,44-44A44.04978,44.04978,0,0,1,128.00391,172Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128.00195",
      "cy": "128",
      "r": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M183.66282,65.08649a84.52233,84.52233,0,0,1,7.2522,7.2521l27.32235,3.90156a103.37019,103.37019,0,0,1,10.1637,24.56086L211.8466,122.8728s.20824,6.83942.00066,10.2547l16.561,22.07863a103.37014,103.37014,0,0,1-10.18033,24.554L190.915,183.66144s-4.689,4.98345-7.2507,7.25163l-3.90156,27.32234a103.36981,103.36981,0,0,1-24.56086,10.16371l-22.0704-16.55388a84.521,84.521,0,0,1-10.25609.00006l-22.07863,16.561a103.36931,103.36931,0,0,1-24.554-10.18033l-3.90076-27.31148a84.521,84.521,0,0,1-7.2522-7.25211l-27.32234-3.90155A103.36971,103.36971,0,0,1,27.60381,155.2l16.55447-22.07178s-.20824-6.83942-.00065-10.2547l-16.561-22.07863A103.36914,103.36914,0,0,1,37.777,76.24087l27.31148-3.90076a84.521,84.521,0,0,1,7.25211-7.2522L76.2421,37.76556A103.37009,103.37009,0,0,1,100.803,27.60186l22.07039,16.55388a84.523,84.523,0,0,1,10.25609-.00007l22.07863-16.561a103.37,103.37,0,0,1,24.554,10.18033Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128.00098",
      "cy": "128",
      "r": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M183.66185,65.08649a84.52221,84.52221,0,0,1,7.25219,7.2521l27.32235,3.90156a103.36936,103.36936,0,0,1,10.1637,24.56086L211.84563,122.8728s.20824,6.83942.00065,10.2547l16.561,22.07863a103.37014,103.37014,0,0,1-10.18033,24.554l-27.31288,3.90133s-4.689,4.98345-7.25071,7.25163l-3.90155,27.32234a103.36988,103.36988,0,0,1-24.56087,10.16371l-22.07039-16.55388a84.521,84.521,0,0,1-10.25609.00006l-22.07863,16.561a103.369,103.369,0,0,1-24.554-10.18033l-3.90077-27.31148a84.52089,84.52089,0,0,1-7.25219-7.25211l-27.32235-3.90155A103.36926,103.36926,0,0,1,27.60284,155.2L44.1573,133.12818s-.20824-6.83942-.00065-10.2547l-16.561-22.07863A103.37,103.37,0,0,1,37.776,76.24087l27.31149-3.90076a84.52089,84.52089,0,0,1,7.2521-7.2522l3.90155-27.32235A103.37026,103.37026,0,0,1,100.802,27.60186l22.07039,16.55388a84.523,84.523,0,0,1,10.25609-.00007l22.07863-16.561a103.36979,103.36979,0,0,1,24.554,10.18033Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M183.66087,65.08649a84.52233,84.52233,0,0,1,7.2522,7.2521l27.32234,3.90156A103.36981,103.36981,0,0,1,228.39912,100.801L211.84465,122.8728s.20824,6.83942.00065,10.2547l16.561,22.07863a103.36931,103.36931,0,0,1-10.18033,24.554l-27.31288,3.90133s-4.689,4.98345-7.25071,7.25163l-3.90155,27.32234A103.36971,103.36971,0,0,1,155.2,228.39912l-22.07039-16.55388a84.521,84.521,0,0,1-10.25609.00006l-22.07863,16.561a103.36914,103.36914,0,0,1-24.554-10.18033l-3.90076-27.31148a84.521,84.521,0,0,1-7.2522-7.25211l-27.32235-3.90155A103.37009,103.37009,0,0,1,27.60186,155.2l16.55447-22.07178s-.20824-6.83942-.00066-10.2547l-16.561-22.07863A103.37,103.37,0,0,1,37.775,76.24087l27.31149-3.90076a84.52233,84.52233,0,0,1,7.2521-7.2522l3.90156-27.32235A103.37019,103.37019,0,0,1,100.801,27.60186l22.0704,16.55388a84.523,84.523,0,0,1,10.25609-.00007l22.07863-16.561a103.37014,103.37014,0,0,1,24.554,10.18033Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6E = [];
/* style */

const __vue_inject_styles__$6E = undefined;
/* scoped */

const __vue_scope_id__$6E = undefined;
/* module identifier */

const __vue_module_identifier__$6E = undefined;
/* functional template */

const __vue_is_functional_template__$6E = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6E = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6E,
  staticRenderFns: __vue_staticRenderFns__$6E
}, __vue_inject_styles__$6E, __vue_script__$6E, __vue_scope_id__$6E, __vue_is_functional_template__$6E, __vue_module_identifier__$6E, false, undefined, undefined, undefined);

var script$6F = Vue.extend({
  name: "PhGearSix",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6F = script$6F;
/* template */

var __vue_render__$6F = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128.00098",
      "cy": "128.00195",
      "r": "44",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M197.40919,80.65057a83.91174,83.91174,0,0,1,6.28744,10.91L229.6429,105.964a103.88962,103.88962,0,0,1,.03183,44.05764L203.714,164.433a83.912,83.912,0,0,1-6.30466,10.90011l.49943,29.67182a103.88959,103.88959,0,0,1-38.13912,22.05638l-25.46093-15.27692a83.91075,83.91075,0,0,1-12.5921-.01L96.26983,227.04288a103.88979,103.88979,0,0,1-38.17095-22.00126l.49974-29.68828a83.91174,83.91174,0,0,1-6.28744-10.91005L26.36491,150.0399a103.88962,103.88962,0,0,1-.03182-44.05764L52.29376,91.5709a83.9124,83.9124,0,0,1,6.30466-10.9001L58.099,50.999A103.88973,103.88973,0,0,1,96.23811,28.94259l25.46094,15.27693a83.91061,83.91061,0,0,1,12.59209.00995L159.738,28.961a103.88951,103.88951,0,0,1,38.171,22.00126Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M229.645,105.96387,203.69873,91.56055a83.92517,83.92517,0,0,0-6.2876-10.90992l.5-29.68823a103.88966,103.88966,0,0,0-38.17138-22.00146L134.293,44.22949a83.89083,83.89083,0,0,0-12.5918-.01L96.24023,28.94263A103.8856,103.8856,0,0,0,58.10107,50.999l.49952,29.67188A83.85065,83.85065,0,0,0,52.2959,91.5708L26.335,105.98218A103.8963,103.8963,0,0,0,26.3667,150.04L52.313,164.44336a83.92506,83.92506,0,0,0,6.2876,10.90991l-.5,29.68823A103.88954,103.88954,0,0,0,96.272,227.043l25.44678-15.26856a83.89083,83.89083,0,0,0,12.5918.01l25.46093,15.27686a103.88532,103.88532,0,0,0,38.13916-22.0564l-.49951-29.67187a83.79517,83.79517,0,0,0,6.30469-10.8999l25.96094-14.41138A103.8963,103.8963,0,0,0,229.645,105.96387ZM128.00586,176.002a48,48,0,1,1,48-48A47.99987,47.99987,0,0,1,128.00586,176.002Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128.00586",
      "cy": "128.00195",
      "r": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M197.41115,80.65057a83.91167,83.91167,0,0,1,6.28743,10.91L229.64485,105.964a103.88962,103.88962,0,0,1,.03183,44.05764L203.716,164.433a83.91089,83.91089,0,0,1-6.30466,10.90011l.49944,29.67182a103.88963,103.88963,0,0,1-38.13913,22.05638l-25.46093-15.27692a83.91075,83.91075,0,0,1-12.5921-.01L96.27178,227.04288a103.88987,103.88987,0,0,1-38.171-22.00126l.49974-29.68828a83.91167,83.91167,0,0,1-6.28743-10.91005L26.36687,150.0399a103.88946,103.88946,0,0,1-.03183-44.05764L52.29571,91.5709a83.91132,83.91132,0,0,1,6.30467-10.9001L58.10094,50.999A103.88969,103.88969,0,0,1,96.24007,28.94259L121.701,44.21952a83.91075,83.91075,0,0,1,12.5921.00995L159.73994,28.961a103.88959,103.88959,0,0,1,38.171,22.00126Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M237.46191,104.26611a8.00135,8.00135,0,0,0-3.93554-5.29687L209.75049,85.77051c-1.31592-2.55078-2.75391-5.04639-4.29981-7.46094l.458-27.2124a8.00049,8.00049,0,0,0-2.62158-6.05811A111.13811,111.13811,0,0,0,162.17773,21.3418a8.00131,8.00131,0,0,0-6.55468.75927l-23.31836,13.9917c-2.86865-.13672-5.75-.13916-8.61133-.00683L100.35547,22.08252a8.003,8.003,0,0,0-6.55762-.75879A111.15557,111.15557,0,0,0,52.7207,45.07715a8.00055,8.00055,0,0,0-2.61963,6.05664l.45752,27.18994c-1.55078,2.41455-2.99365,4.90869-4.31152,7.4541l-23.7959,13.21a8.0003,8.0003,0,0,0-3.93555,5.29932,111.13522,111.13522,0,0,0,.03223,47.45068,8.00135,8.00135,0,0,0,3.93555,5.29688L46.25928,170.2334c1.31592,2.55078,2.7539,5.04639,4.2998,7.46094l-.458,27.2124a8.00053,8.00053,0,0,0,2.62159,6.0581A111.13809,111.13809,0,0,0,93.832,234.66211a8.00177,8.00177,0,0,0,6.55469-.75928l23.31836-13.9917c2.86816.13623,5.749.13867,8.61133.00684l23.33789,14.00342a8.00237,8.00237,0,0,0,6.55761.75879,111.15549,111.15549,0,0,0,41.07715-23.75342,8.00052,8.00052,0,0,0,2.61963-6.05664l-.45752-27.18994c1.55078-2.41455,2.99365-4.9087,4.31153-7.45411l23.79589-13.21a8.0002,8.0002,0,0,0,3.93555-5.29931A111.13527,111.13527,0,0,0,237.46191,104.26611ZM172.0049,128.002a44,44,0,1,1-44-44A44.04972,44.04972,0,0,1,172.0049,128.002Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128.00293",
      "cy": "128.00195",
      "r": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M197.40822,80.65057a83.91167,83.91167,0,0,1,6.28743,10.91L229.64192,105.964a103.88962,103.88962,0,0,1,.03183,44.05764L203.71308,164.433a83.9121,83.9121,0,0,1-6.30467,10.90011l.49944,29.67182a103.88955,103.88955,0,0,1-38.13913,22.05638l-25.46093-15.27692a83.91075,83.91075,0,0,1-12.5921-.01L96.26885,227.04288A103.88987,103.88987,0,0,1,58.0979,205.04162l.49974-29.68828a83.91167,83.91167,0,0,1-6.28743-10.91005L26.36394,150.0399a103.88946,103.88946,0,0,1-.03183-44.05764L52.29278,91.5709a83.91132,83.91132,0,0,1,6.30467-10.9001L58.098,50.999A103.88969,103.88969,0,0,1,96.23714,28.94259l25.46093,15.27693a83.91075,83.91075,0,0,1,12.5921.00995L159.737,28.961a103.88959,103.88959,0,0,1,38.171,22.00126Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128.00195",
      "cy": "128.00195",
      "r": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M197.40724,80.65057a83.91052,83.91052,0,0,1,6.28743,10.91L229.641,105.964a103.88962,103.88962,0,0,1,.03182,44.05764L203.7121,164.433a83.91318,83.91318,0,0,1-6.30466,10.90011l.49943,29.67182a103.88959,103.88959,0,0,1-38.13912,22.05638l-25.46094-15.27692a83.91075,83.91075,0,0,1-12.5921-.01L96.26788,227.04288a103.88971,103.88971,0,0,1-38.171-22.00126l.49974-29.68828a83.91174,83.91174,0,0,1-6.28744-10.91005L26.363,150.0399a103.88962,103.88962,0,0,1-.03183-44.05764L52.29181,91.5709a83.91125,83.91125,0,0,1,6.30466-10.9001L58.097,50.999A103.88973,103.88973,0,0,1,96.23616,28.94259l25.46093,15.27693a83.91075,83.91075,0,0,1,12.5921.00995L159.736,28.961a103.88951,103.88951,0,0,1,38.171,22.00126Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128.00098",
      "cy": "128.00195",
      "r": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M197.40626,80.65057a83.91174,83.91174,0,0,1,6.28744,10.91L229.64,105.964a103.88962,103.88962,0,0,1,.03183,44.05764L203.71112,164.433a83.912,83.912,0,0,1-6.30466,10.90011l.49943,29.67182a103.88959,103.88959,0,0,1-38.13912,22.05638l-25.46093-15.27692a83.91075,83.91075,0,0,1-12.5921-.01L96.2669,227.04288a103.88979,103.88979,0,0,1-38.171-22.00126l.49974-29.68828a83.91052,83.91052,0,0,1-6.28743-10.91005L26.362,150.0399a103.88962,103.88962,0,0,1-.03182-44.05764L52.29083,91.5709a83.9124,83.9124,0,0,1,6.30466-10.9001L58.09606,50.999A103.88973,103.88973,0,0,1,96.23518,28.94259l25.46094,15.27693a83.91075,83.91075,0,0,1,12.5921.00995L159.73505,28.961a103.88943,103.88943,0,0,1,38.171,22.00126Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6F = [];
/* style */

const __vue_inject_styles__$6F = undefined;
/* scoped */

const __vue_scope_id__$6F = undefined;
/* module identifier */

const __vue_module_identifier__$6F = undefined;
/* functional template */

const __vue_is_functional_template__$6F = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6F = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6F,
  staticRenderFns: __vue_staticRenderFns__$6F
}, __vue_inject_styles__$6F, __vue_script__$6F, __vue_scope_id__$6F, __vue_is_functional_template__$6F, __vue_module_identifier__$6F, false, undefined, undefined, undefined);

var script$6G = Vue.extend({
  name: "PhGenderFemale",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6G = script$6G;
/* template */

var __vue_render__$6G = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "96",
      "r": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "168",
      "x2": "128",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "208",
      "x2": "168",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "96",
      "r": "72",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "96",
      "r": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "168",
      "x2": "128",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "208",
      "x2": "168",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,96a80,80,0,1,0-88,79.59912V200H88a8,8,0,0,0,0,16h32v24a8,8,0,0,0,16,0V216h32a8,8,0,0,0,0-16H136V175.59912A80.1104,80.1104,0,0,0,208,96ZM64,96a64,64,0,1,1,64,64A64.07239,64.07239,0,0,1,64,96Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "96",
      "r": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "168",
      "x2": "128",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "208",
      "x2": "168",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "96",
      "r": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "168",
      "x2": "128",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "208",
      "x2": "168",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "96",
      "r": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "168",
      "x2": "128",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "208",
      "x2": "168",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6G = [];
/* style */

const __vue_inject_styles__$6G = undefined;
/* scoped */

const __vue_scope_id__$6G = undefined;
/* module identifier */

const __vue_module_identifier__$6G = undefined;
/* functional template */

const __vue_is_functional_template__$6G = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6G = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6G,
  staticRenderFns: __vue_staticRenderFns__$6G
}, __vue_inject_styles__$6G, __vue_script__$6G, __vue_scope_id__$6G, __vue_is_functional_template__$6G, __vue_module_identifier__$6G, false, undefined, undefined, undefined);

var script$6H = Vue.extend({
  name: "PhGenderIntersex",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6H = script$6H;
/* template */

var __vue_render__$6H = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "120",
      "cy": "108",
      "r": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "168",
      "x2": "120",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "204",
      "x2": "152",
      "y2": "204",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "172 24 208 24 208 60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "164.37913",
      "y1": "67.62087",
      "x2": "208",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "120",
      "cy": "108",
      "r": "60",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "120",
      "cy": "108",
      "r": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "168",
      "x2": "120",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "204",
      "x2": "152",
      "y2": "204",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "168 24 208 24 208 64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "164.37913",
      "y1": "67.62087",
      "x2": "208",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M215.96008,23.20947c-.01111-.11377-.03271-.22412-.04858-.33642-.02063-.146-.038-.29248-.06677-.4375-.02588-.13086-.06214-.2583-.09449-.38721-.03112-.124-.05835-.24854-.09545-.37158-.03846-.12647-.08594-.24854-.13038-.37256-.04394-.12256-.08435-.24609-.13427-.3667-.04785-.11523-.104-.22559-.157-.33838-.05835-.124-.11364-.249-.17871-.3706-.05774-.10791-.12353-.21-.186-.31495-.07105-.11914-.13867-.24023-.21655-.35644-.07593-.11328-.16065-.22022-.242-.3291-.0747-.1001-.14429-.20264-.22436-.3003-.1521-.18505-.31372-.36181-.48169-.53271-.0166-.01709-.0304-.03564-.04712-.05225-.01929-.01953-.04077-.03515-.0603-.05468-.16846-.165-.34253-.32422-.525-.47413-.09424-.07763-.19372-.145-.29053-.21728-.1123-.084-.22229-.1709-.339-.249-.11242-.0752-.229-.14063-.34423-.20948-.10913-.06494-.21582-.1333-.32813-.19384-.115-.06153-.23328-.11329-.35058-.16895-.11963-.05664-.23755-.11621-.36036-.167-.11071-.0459-.22387-.08252-.33618-.123-.13415-.04883-.267-.09961-.40429-.1416-.1084-.03223-.21851-.05615-.32789-.084-.14331-.03663-.28515-.07666-.43151-.10547-.12085-.02393-.2428-.03711-.36451-.05567-.13659-.02051-.27136-.04541-.41-.05908-.2019-.01953-.40442-.02588-.60693-.03076C208.11768,16.00781,208.05981,16,208,16H168a8,8,0,0,0,0,16h20.686L164.2522,56.43359A67.97437,67.97437,0,1,0,112,175.51367V196H88a8,8,0,0,0,0,16h24v20a8,8,0,0,0,16,0V212h24a8,8,0,0,0,0-16H128V175.51367A67.9301,67.9301,0,0,0,175.09692,68.2168L200,43.314V64a8,8,0,0,0,16,0V24.00244C216,23.73779,215.98608,23.47314,215.96008,23.20947ZM120,160a52,52,0,1,1,52-52A52.059,52.059,0,0,1,120,160Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "120",
      "cy": "108",
      "r": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "168",
      "x2": "120",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "204",
      "x2": "152",
      "y2": "204",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "168 24 208 24 208 64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "164.37913",
      "y1": "67.62087",
      "x2": "208",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "120",
      "cy": "108",
      "r": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "168",
      "x2": "120",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "204",
      "x2": "152",
      "y2": "204",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "168 24 208 24 208 64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "164.37913",
      "y1": "67.62087",
      "x2": "208",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "120",
      "cy": "108",
      "r": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "168",
      "x2": "120",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "204",
      "x2": "152",
      "y2": "204",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "168 24 208 24 208 64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "164.37913",
      "y1": "67.62087",
      "x2": "208",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6H = [];
/* style */

const __vue_inject_styles__$6H = undefined;
/* scoped */

const __vue_scope_id__$6H = undefined;
/* module identifier */

const __vue_module_identifier__$6H = undefined;
/* functional template */

const __vue_is_functional_template__$6H = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6H = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6H,
  staticRenderFns: __vue_staticRenderFns__$6H
}, __vue_inject_styles__$6H, __vue_script__$6H, __vue_scope_id__$6H, __vue_is_functional_template__$6H, __vue_module_identifier__$6H, false, undefined, undefined, undefined);

var script$6I = Vue.extend({
  name: "PhGenderMale",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6I = script$6I;
/* template */

var __vue_render__$6I = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "104",
      "cy": "152",
      "r": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "154.91169",
      "y1": "101.08831",
      "x2": "216",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "168 40 216 40 216 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "104",
      "cy": "152",
      "r": "72",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "104",
      "cy": "152",
      "r": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "154.91169",
      "y1": "101.08831",
      "x2": "216",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "168 40 216 40 216 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M223.96008,39.20947c-.01111-.11377-.03271-.22412-.04858-.33642-.02063-.146-.038-.29248-.06677-.4375-.02588-.13086-.06214-.2583-.09449-.38721-.03112-.124-.05835-.24854-.09545-.37158-.03846-.12647-.08594-.24854-.13038-.37256-.04394-.12256-.08435-.24609-.13427-.3667-.04785-.11523-.104-.22559-.157-.33838-.05835-.124-.11364-.249-.17871-.3706-.05774-.10791-.12353-.21-.186-.315-.07105-.11914-.13867-.24023-.21655-.35644-.07593-.11328-.16065-.22022-.242-.3291-.0747-.1001-.14429-.20264-.22436-.3003-.1521-.185-.31372-.36181-.48169-.53271-.0166-.01709-.0304-.03564-.04712-.05225-.019-.019-.04-.03466-.05908-.05322-.16895-.16553-.34351-.32568-.52662-.47607-.0913-.07471-.1875-.14014-.28125-.21-.1156-.08692-.22888-.17627-.34924-.25684-.10754-.07227-.21936-.13428-.32971-.2002-.114-.06884-.22595-.14013-.34363-.20312-.109-.05811-.22131-.10742-.3324-.16016-.12573-.06006-.24975-.12207-.37915-.17578-.10327-.04248-.209-.07666-.31372-.11474-.1416-.05176-.2821-.10547-.42736-.14942-.09778-.02978-.197-.05029-.29554-.07617-.15417-.04-.30737-.08252-.46484-.11328-.10376-.02051-.20874-.03174-.31323-.04785-.15284-.02393-.30445-.05127-.46021-.06641-.15869-.01562-.31787-.01807-.477-.02441C216.20215,32.01172,216.10254,32,216,32H168a8,8,0,0,0,0,16h28.68591L154.62817,90.05762a80.001,80.001,0,1,0,11.31385,11.314L208,59.314V88a8,8,0,0,0,16,0V40.00244C224,39.73779,223.98608,39.47314,223.96008,39.20947Zm-74.7052,158.04541a63.96974,63.96974,0,1,1,0-90.50976A64.07169,64.07169,0,0,1,149.25488,197.25488Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "104",
      "cy": "152",
      "r": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "154.91169",
      "y1": "101.08831",
      "x2": "216",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "168 40 216 40 216 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "104",
      "cy": "152",
      "r": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "154.91169",
      "y1": "101.08831",
      "x2": "216",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "168 40 216 40 216 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "104",
      "cy": "152",
      "r": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "154.91169",
      "y1": "101.08831",
      "x2": "216",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "168 40 216 40 216 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6I = [];
/* style */

const __vue_inject_styles__$6I = undefined;
/* scoped */

const __vue_scope_id__$6I = undefined;
/* module identifier */

const __vue_module_identifier__$6I = undefined;
/* functional template */

const __vue_is_functional_template__$6I = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6I = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6I,
  staticRenderFns: __vue_staticRenderFns__$6I
}, __vue_inject_styles__$6I, __vue_script__$6I, __vue_scope_id__$6I, __vue_is_functional_template__$6I, __vue_module_identifier__$6I, false, undefined, undefined, undefined);

var script$6J = Vue.extend({
  name: "PhGenderNeuter",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6J = script$6J;
/* template */

var __vue_render__$6J = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "104",
      "r": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "176",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "104",
      "r": "72",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "104",
      "r": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "176",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,104a80,80,0,1,0-88,79.59912V232a8,8,0,0,0,16,0V183.59912A80.1104,80.1104,0,0,0,208,104Zm-80,64a64,64,0,1,1,64-64A64.07239,64.07239,0,0,1,128,168Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "104",
      "r": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "176",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "104",
      "r": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "176",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "104",
      "r": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "176",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6J = [];
/* style */

const __vue_inject_styles__$6J = undefined;
/* scoped */

const __vue_scope_id__$6J = undefined;
/* module identifier */

const __vue_module_identifier__$6J = undefined;
/* functional template */

const __vue_is_functional_template__$6J = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6J = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6J,
  staticRenderFns: __vue_staticRenderFns__$6J
}, __vue_inject_styles__$6J, __vue_script__$6J, __vue_scope_id__$6J, __vue_is_functional_template__$6J, __vue_module_identifier__$6J, false, undefined, undefined, undefined);

var script$6K = Vue.extend({
  name: "PhGenderNonbinary",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6K = script$6K;
/* template */

var __vue_render__$6K = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "164",
      "r": "68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "163.71281",
      "y1": "64",
      "x2": "92.28719",
      "y2": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "92.28719",
      "y1": "64",
      "x2": "163.71281",
      "y2": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "96",
      "x2": "128",
      "y2": "41.99999",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "164",
      "r": "68",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "164",
      "r": "68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "163.71281",
      "y1": "68",
      "x2": "92.28719",
      "y2": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "92.28719",
      "y1": "68",
      "x2": "163.71281",
      "y2": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "96",
      "x2": "128",
      "y2": "44.00003",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M136,88.42383V59.01465l23.25049,15.625a7.99987,7.99987,0,1,0,8.9248-13.2793L142.34253,44l25.83276-17.36035a7.99987,7.99987,0,1,0-8.9248-13.2793L128,34.36133l-31.25049-21.001a7.99987,7.99987,0,1,0-8.9248,13.2793L113.65747,44,87.82471,61.36035a7.99987,7.99987,0,1,0,8.9248,13.2793L120,59.01465V88.42383a76,76,0,1,0,16,0ZM128,224a60,60,0,1,1,60-60A60.06812,60.06812,0,0,1,128,224Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "164",
      "r": "68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "163.71281",
      "y1": "68",
      "x2": "92.28719",
      "y2": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "92.28719",
      "y1": "68",
      "x2": "163.71281",
      "y2": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "96",
      "x2": "128",
      "y2": "44.00003",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "164",
      "r": "68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "163.71281",
      "y1": "68",
      "x2": "92.28719",
      "y2": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "92.28719",
      "y1": "68",
      "x2": "163.71281",
      "y2": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "96",
      "x2": "128",
      "y2": "44.00003",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "164",
      "r": "68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "163.71281",
      "y1": "68",
      "x2": "92.28719",
      "y2": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "92.28719",
      "y1": "68",
      "x2": "163.71281",
      "y2": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "96",
      "x2": "128",
      "y2": "44.00003",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6K = [];
/* style */

const __vue_inject_styles__$6K = undefined;
/* scoped */

const __vue_scope_id__$6K = undefined;
/* module identifier */

const __vue_module_identifier__$6K = undefined;
/* functional template */

const __vue_is_functional_template__$6K = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6K = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6K,
  staticRenderFns: __vue_staticRenderFns__$6K
}, __vue_inject_styles__$6K, __vue_script__$6K, __vue_scope_id__$6K, __vue_is_functional_template__$6K, __vue_module_identifier__$6K, false, undefined, undefined, undefined);

var script$6L = Vue.extend({
  name: "PhGenderTransgender",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6L = script$6L;
/* template */

var __vue_render__$6L = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "96",
      "cy": "160",
      "r": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "141.25483",
      "y1": "114.74517",
      "x2": "216",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "172 40 216 40 216 84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "64",
      "x2": "192",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "96",
      "cy": "160",
      "r": "64",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "96",
      "cy": "160",
      "r": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "141.25483",
      "y1": "114.74517",
      "x2": "216",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "168 40 216 40 216 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "64",
      "x2": "192",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M223.96008,39.20947c-.01111-.11377-.03271-.22412-.04858-.33642-.02063-.146-.038-.29248-.06677-.4375-.02588-.13086-.06214-.2583-.09449-.38721-.03112-.124-.05835-.24854-.09545-.37158-.03846-.12647-.08594-.24854-.13038-.37256-.04394-.12256-.08435-.24609-.13427-.3667-.04785-.11523-.104-.22559-.157-.33838-.05835-.124-.11364-.249-.17871-.3706-.05774-.10791-.12353-.21-.186-.315-.07105-.11914-.13867-.24023-.21655-.35644-.07593-.11328-.16065-.22022-.242-.3291-.0747-.1001-.14429-.20264-.22436-.3003-.1521-.185-.31372-.36181-.48169-.53271-.0166-.01709-.0304-.03564-.04712-.05225-.01929-.01953-.04077-.03515-.0603-.05468-.16846-.165-.34253-.32422-.525-.47413-.09424-.07763-.19372-.145-.29053-.21728-.1123-.084-.22229-.1709-.339-.249-.11242-.0752-.229-.14063-.34423-.20948-.10913-.06494-.21582-.1333-.32813-.19384-.115-.06153-.23328-.11329-.35058-.16895-.11963-.05664-.23755-.11621-.36036-.167-.11071-.0459-.22387-.08252-.33618-.12305-.13415-.04883-.267-.09961-.40429-.1416-.1084-.03223-.21851-.05615-.32789-.084-.14331-.03663-.28515-.07666-.43151-.10547-.12085-.02393-.2428-.03711-.36451-.05567-.13659-.02051-.27136-.04541-.41-.05908-.2019-.01953-.40442-.02588-.60693-.03076C216.11768,32.00781,216.05981,32,216,32H168a8,8,0,0,0,0,16h28.686L168,76.686,149.65674,58.34277a8.00018,8.00018,0,0,0-11.31348,11.31446L156.686,88l-15.75293,15.75293a71.99442,71.99442,0,1,0,11.31567,11.3125L168,99.314l18.34326,18.34327a8.00018,8.00018,0,0,0,11.31348-11.31446L179.314,88,208,59.314V88a8,8,0,0,0,16,0V40.00244C224,39.73779,223.98608,39.47314,223.96008,39.20947ZM135.59814,199.59766A55.99961,55.99961,0,1,1,152,160,56.06457,56.06457,0,0,1,135.59814,199.59766Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "96",
      "cy": "160",
      "r": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "141.25483",
      "y1": "114.74517",
      "x2": "216",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "168 40 216 40 216 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "64",
      "x2": "192",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "96",
      "cy": "160",
      "r": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "141.25483",
      "y1": "114.74517",
      "x2": "216",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "168 40 216 40 216 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "64",
      "x2": "192",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "96",
      "cy": "160",
      "r": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "141.25483",
      "y1": "114.74517",
      "x2": "216",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "168 40 216 40 216 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "64",
      "x2": "192",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6L = [];
/* style */

const __vue_inject_styles__$6L = undefined;
/* scoped */

const __vue_scope_id__$6L = undefined;
/* module identifier */

const __vue_module_identifier__$6L = undefined;
/* functional template */

const __vue_is_functional_template__$6L = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6L = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6L,
  staticRenderFns: __vue_staticRenderFns__$6L
}, __vue_inject_styles__$6L, __vue_script__$6L, __vue_scope_id__$6L, __vue_is_functional_template__$6L, __vue_module_identifier__$6L, false, undefined, undefined, undefined);

var script$6M = Vue.extend({
  name: "PhGhost",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6M = script$6M;
/* template */

var __vue_render__$6M = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "100",
      "cy": "116",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "116",
      "r": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,216l-29.33333-24-29.33334,24L128,192,98.66667,216,69.33333,192,40,216V120a88,88,0,0,1,176,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,216l-29.33333-24-29.33334,24L128,192,98.66667,216,69.33333,192,40,216V120a88,88,0,0,1,176,0Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "100",
      "cy": "116",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "116",
      "r": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,216l-29.33333-24-29.33334,24L128,192,98.66667,216,69.33333,192,40,216V120a88,88,0,0,1,176,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24.00006A96.10871,96.10871,0,0,0,32,120v95.99994a7.9995,7.9995,0,0,0,13.06543,6.19141l24.26758-19.855,24.26855,19.855a8,8,0,0,0,10.13184,0L128,202.33638l24.2666,19.855a7.99878,7.99878,0,0,0,10.13184,0l24.26855-19.855,24.26758,19.855A7.9995,7.9995,0,0,0,224,215.99994V120A96.10871,96.10871,0,0,0,128,24.00006ZM100,128a12,12,0,1,1,12-12A12,12,0,0,1,100,128Zm56,0a12,12,0,1,1,12-12A12,12,0,0,1,156,128Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "100",
      "cy": "116",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "116",
      "r": "10"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,216l-29.33333-24-29.33334,24L128,192,98.66667,216,69.33333,192,40,216V120a88,88,0,0,1,176,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "100",
      "cy": "116",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "116",
      "r": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,216l-29.33333-24-29.33334,24L128,192,98.66667,216,69.33333,192,40,216V120a88,88,0,0,1,176,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "100",
      "cy": "116",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "116",
      "r": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,216l-29.33333-24-29.33334,24L128,192,98.66667,216,69.33333,192,40,216V120a88,88,0,0,1,176,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6M = [];
/* style */

const __vue_inject_styles__$6M = undefined;
/* scoped */

const __vue_scope_id__$6M = undefined;
/* module identifier */

const __vue_module_identifier__$6M = undefined;
/* functional template */

const __vue_is_functional_template__$6M = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6M = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6M,
  staticRenderFns: __vue_staticRenderFns__$6M
}, __vue_inject_styles__$6M, __vue_script__$6M, __vue_scope_id__$6M, __vue_is_functional_template__$6M, __vue_module_identifier__$6M, false, undefined, undefined, undefined);

var script$6N = Vue.extend({
  name: "PhGif",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6N = script$6N;
/* template */

var __vue_render__$6N = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "136",
      "y1": "72",
      "x2": "136",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "228 72 180 72 180 184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "128",
      "x2": "180",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,132H96v20a32,32,0,0,1-64,0V104a32.0045,32.0045,0,0,1,62.99185-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "136",
      "y1": "72",
      "x2": "136",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "228 72 180 72 180 184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "128",
      "x2": "180",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,128H96v24a32,32,0,0,1-64,0V104a32.0045,32.0045,0,0,1,62.99185-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M136,64a8.00039,8.00039,0,0,0-8,8V184a8,8,0,0,0,16,0V72A8.00039,8.00039,0,0,0,136,64Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M228,64H180a8.00039,8.00039,0,0,0-8,8V184a8,8,0,0,0,16,0V136h28a8,8,0,0,0,0-16H188V80h40a8,8,0,0,0,0-16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,120H72a8,8,0,0,0,0,16H88v16a24,24,0,0,1-48,0V104a24.00492,24.00492,0,0,1,47.24512-6.00586,7.99961,7.99961,0,1,0,15.49414-3.98828A40.00446,40.00446,0,0,0,24,104v48a40,40,0,0,0,80,0V128A8.00039,8.00039,0,0,0,96,120Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "136",
      "y1": "72",
      "x2": "136",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "228 72 180 72 180 184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "128",
      "x2": "180",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,128H96v24a32,32,0,0,1-64,0V104a32.0045,32.0045,0,0,1,62.99185-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "136",
      "y1": "72",
      "x2": "136",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "228 72 180 72 180 184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "128",
      "x2": "180",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,128H96v24a32,32,0,0,1-64,0V104a32.0045,32.0045,0,0,1,62.99185-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "136",
      "y1": "72",
      "x2": "136",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "228 72 180 72 180 184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "128",
      "x2": "180",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,128H96v24a32,32,0,0,1-64,0V104a32.0045,32.0045,0,0,1,62.99185-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6N = [];
/* style */

const __vue_inject_styles__$6N = undefined;
/* scoped */

const __vue_scope_id__$6N = undefined;
/* module identifier */

const __vue_module_identifier__$6N = undefined;
/* functional template */

const __vue_is_functional_template__$6N = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6N = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6N,
  staticRenderFns: __vue_staticRenderFns__$6N
}, __vue_inject_styles__$6N, __vue_script__$6N, __vue_scope_id__$6N, __vue_is_functional_template__$6N, __vue_module_identifier__$6N, false, undefined, undefined, undefined);

var script$6O = Vue.extend({
  name: "PhGift",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6O = script$6O;
/* template */

var __vue_render__$6O = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "80",
      "width": "192",
      "height": "48",
      "rx": "7.99999",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,128v72a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "80",
      "x2": "128",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M173.25483,68.68629C161.94113,80,128,80,128,80s0-33.94113,11.31371-45.25483a24,24,0,0,1,33.94112,33.94112Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M82.74517,68.68629C94.05887,80,128,80,128,80s0-33.94113-11.31371-45.25483A24,24,0,0,0,82.74517,68.68629Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "80",
      "width": "192",
      "height": "48",
      "rx": "7.99999",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,128v72a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "80",
      "x2": "128",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M173.25483,68.68629C161.94113,80,128,80,128,80s0-33.94113,11.31371-45.25483a24,24,0,0,1,33.94112,33.94112Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M82.74517,68.68629C94.05887,80,128,80,128,80s0-33.94113-11.31371-45.25483A24,24,0,0,0,82.74517,68.68629Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,128v72a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V128Z",
      "opacity": "0.2"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,72H181.03271a31.99968,31.99968,0,0,0-47.37646-42.91162A30.99155,30.99155,0,0,0,128,37.2998a31.01227,31.01227,0,0,0-5.65723-8.21191A31.99948,31.99948,0,0,0,74.96729,72H40A16.01817,16.01817,0,0,0,24,88v32a16.01817,16.01817,0,0,0,16,16v64a16.01833,16.01833,0,0,0,16,16H200a16.01833,16.01833,0,0,0,16-16V136a16.01817,16.01817,0,0,0,16-16V88A16.01817,16.01817,0,0,0,216,72ZM144.96973,40.4021a16.00019,16.00019,0,1,1,22.62793,22.62744c-4.94043,4.94116-19.22559,7.71582-31.25684,8.6294C137.25488,59.62671,140.0293,45.34277,144.96973,40.4021Zm-56.56836,0a16.0194,16.0194,0,0,1,22.62793-.00024c4.9414,4.94116,7.71582,19.22631,8.62988,31.25683-12.03223-.91382-26.31641-3.68848-31.25684-8.62915A16.01925,16.01925,0,0,1,88.40137,40.4021ZM216,120H136v72a8,8,0,0,1-16,0V120H40V88h80v32h16V88h80l.00977,31.99951Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "80",
      "width": "192",
      "height": "48",
      "rx": "7.99999",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,128v72a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "80",
      "x2": "128",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M173.25483,68.68629C161.94113,80,128,80,128,80s0-33.94113,11.31371-45.25483a24,24,0,0,1,33.94112,33.94112Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M82.74517,68.68629C94.05887,80,128,80,128,80s0-33.94113-11.31371-45.25483A24,24,0,0,0,82.74517,68.68629Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "80",
      "width": "192",
      "height": "48",
      "rx": "7.99999",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,128v72a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "80",
      "x2": "128",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M173.25483,68.68629C161.94113,80,128,80,128,80s0-33.94113,11.31371-45.25483a24,24,0,0,1,33.94112,33.94112Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M82.74517,68.68629C94.05887,80,128,80,128,80s0-33.94113-11.31371-45.25483A24,24,0,0,0,82.74517,68.68629Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "80",
      "width": "192",
      "height": "48",
      "rx": "7.99999",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,128v72a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "80",
      "x2": "128",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M173.25483,68.68629C161.94113,80,128,80,128,80s0-33.94113,11.31371-45.25483a24,24,0,0,1,33.94112,33.94112Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M82.74517,68.68629C94.05887,80,128,80,128,80s0-33.94113-11.31371-45.25483A24,24,0,0,0,82.74517,68.68629Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6O = [];
/* style */

const __vue_inject_styles__$6O = undefined;
/* scoped */

const __vue_scope_id__$6O = undefined;
/* module identifier */

const __vue_module_identifier__$6O = undefined;
/* functional template */

const __vue_is_functional_template__$6O = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6O = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6O,
  staticRenderFns: __vue_staticRenderFns__$6O
}, __vue_inject_styles__$6O, __vue_script__$6O, __vue_scope_id__$6O, __vue_is_functional_template__$6O, __vue_module_identifier__$6O, false, undefined, undefined, undefined);

var script$6P = Vue.extend({
  name: "PhGitBranch",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6P = script$6P;
/* template */

var __vue_render__$6P = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M68,160v-8.00018a23.99955,23.99955,0,0,1,23.99951-23.99909l72.001-.00146A23.99955,23.99955,0,0,0,188,104.00018V96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "68",
      "y1": "96",
      "x2": "68",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "188",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "67.99756",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "67.99756",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "188",
      "cy": "67.99756",
      "r": "28",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M67.98779,160v-8.00018A23.99955,23.99955,0,0,1,91.9873,128.00073l72.001-.00146a23.99955,23.99955,0,0,0,23.99951-23.99909V96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "67.98779",
      "y1": "96",
      "x2": "67.98779",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "188",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "67.99756",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "67.99756",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224.00049,67.99756a36,36,0,1,0-44,35.09289v.9076a16.01865,16.01865,0,0,1-16,16l-72.001.00146a31.80375,31.80375,0,0,0-15.999,4.29444v-21.2035a36,36,0,1,0-16,0V152.9071a36,36,0,1,0,16,0v-.90759a16.01844,16.01844,0,0,1,15.999-16l72.001-.00146a32.0373,32.0373,0,0,0,32-32v-.9076A36.05514,36.05514,0,0,0,224.00049,67.99756Zm-176,0a20,20,0,1,1,20,20A20.0226,20.0226,0,0,1,48.00049,67.99756ZM88.00049,188a20,20,0,1,1-20-20A20.0226,20.0226,0,0,1,88.00049,188Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M68,160v-8.00018a23.99955,23.99955,0,0,1,23.99951-23.99909l72.001-.00146A23.99955,23.99955,0,0,0,188,104.00018V96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "68",
      "y1": "96",
      "x2": "68",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "188",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "67.99756",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "67.99756",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M68,160v-8.00018a23.99955,23.99955,0,0,1,23.99951-23.99909l72.001-.00146A23.99955,23.99955,0,0,0,188,104.00018V96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "68",
      "y1": "96",
      "x2": "68",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "188",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "67.99756",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "67.99756",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "68",
      "cy": "188",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "67.99756",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "67.99756",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M68,160v-8.00018a23.99955,23.99955,0,0,1,23.99951-23.99909l72.001-.00146A23.99955,23.99955,0,0,0,188,104.00018V96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "68",
      "y1": "96",
      "x2": "68",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6P = [];
/* style */

const __vue_inject_styles__$6P = undefined;
/* scoped */

const __vue_scope_id__$6P = undefined;
/* module identifier */

const __vue_module_identifier__$6P = undefined;
/* functional template */

const __vue_is_functional_template__$6P = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6P = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6P,
  staticRenderFns: __vue_staticRenderFns__$6P
}, __vue_inject_styles__$6P, __vue_script__$6P, __vue_scope_id__$6P, __vue_is_functional_template__$6P, __vue_module_identifier__$6P, false, undefined, undefined, undefined);

var script$6Q = Vue.extend({
  name: "PhGitCommit",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6Q = script$6Q;
/* template */

var __vue_render__$6Q = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128.00244",
      "cy": "128",
      "r": "52",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "12.00244",
      "y1": "128",
      "x2": "76.00244",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "180.00244",
      "y1": "128",
      "x2": "244.00244",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128.00244",
      "cy": "128",
      "r": "52",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128.00244",
      "cy": "128",
      "r": "52",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "8.00244",
      "y1": "128",
      "x2": "76.00244",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "180.00244",
      "y1": "128",
      "x2": "248.00244",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M248.00244,120H187.45312a59.98446,59.98446,0,0,0-118.90136,0H8.00244a8,8,0,0,0,0,16H68.55176a59.98446,59.98446,0,0,0,118.90136,0h60.54932a8,8,0,0,0,0-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128.00244",
      "cy": "128",
      "r": "52",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "8.00244",
      "y1": "128",
      "x2": "76.00244",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "180.00244",
      "y1": "128",
      "x2": "248.00244",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128.00244",
      "cy": "128",
      "r": "52",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "8.00244",
      "y1": "128",
      "x2": "76.00244",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "180.00244",
      "y1": "128",
      "x2": "248.00244",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128.00244",
      "cy": "128",
      "r": "52",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "8.00244",
      "y1": "128",
      "x2": "76.00244",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "180.00244",
      "y1": "128",
      "x2": "248.00244",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6Q = [];
/* style */

const __vue_inject_styles__$6Q = undefined;
/* scoped */

const __vue_scope_id__$6Q = undefined;
/* module identifier */

const __vue_module_identifier__$6Q = undefined;
/* functional template */

const __vue_is_functional_template__$6Q = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6Q = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6Q,
  staticRenderFns: __vue_staticRenderFns__$6Q
}, __vue_inject_styles__$6Q, __vue_script__$6Q, __vue_scope_id__$6Q, __vue_is_functional_template__$6Q, __vue_module_identifier__$6Q, false, undefined, undefined, undefined);

var script$6R = Vue.extend({
  name: "PhGitDiff",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6R = script$6R;
/* template */

var __vue_render__$6R = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "196.00244",
      "cy": "188",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M196.00244,160l-.00163-40.11889a48,48,0,0,0-14.05888-33.93918L144,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 88 144 48 184 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "60",
      "cy": "68",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M60,96l.00163,40.11889a48,48,0,0,0,14.05888,33.93918L112.00244,208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "112.002 168 112.002 208 72.002 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "196.00244",
      "cy": "188",
      "r": "28",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "60",
      "cy": "68",
      "r": "28",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "196.00244",
      "cy": "188",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M196.00244,160l-.00163-40.11889a48,48,0,0,0-14.05888-33.93918L144,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 88 144 48 184 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "60",
      "cy": "68",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M60,96l.00163,40.11889a48,48,0,0,0,14.05888,33.93918L112.00244,208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "112.002 168 112.002 208 72.002 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M204.002,152.907l-.00146-33.02612a55.63313,55.63313,0,0,0-16.40137-39.5957L163.31445,56h20.686a8,8,0,0,0,0-16h-40c-.14893,0-.29444.01416-.44141.02222-.11133.0061-.22314.00622-.334.017-.17188.01648-.33985.046-.50879.07325-.08789.01428-.17725.02331-.26514.04052-.168.033-.33105.0774-.49512.12073-.08837.02319-.17773.042-.26562.06824-.15283.046-.30078.10229-.44971.1571-.09717.03589-.1958.06739-.29248.10718-.13428.05542-.26318.12-.39355.1825-.10694.0509-.21485.098-.31934.15393-.1206.06421-.23486.1372-.35107.20727-.1084.06494-.21826.12586-.32373.19641-.11768.079-.229.16675-.34229.25159-.09668.07239-.19629.13965-.29.2168-.1499.123-.291.25586-.43115.3894-.05029.04773-.10449.08936-.15381.13867-.05957.05945-.10986.12415-.167.18506-.12207.12964-.24512.2583-.3584.396-.09424.115-.17773.236-.26514.355-.06689.09106-.13769.179-.20068.273-.0874.13037-.16406.26538-.24268.39941-.05322.09058-.11084.17871-.16064.27149-.07129.13281-.13184.26928-.19482.405-.04737.10168-.09864.20117-.14161.30517-.05419.13013-.09814.26318-.145.39551-.04052.1145-.085.22729-.12011.34424-.04.13208-.06983.26611-.103.3999-.02978.11987-.06348.238-.08789.36011-.03076.15429-.04981.31006-.07129.4657-.01416.10327-.03418.20459-.04443.30908q-.03955.39752-.04.79736V88a8,8,0,0,0,16,0V67.31482l24.28418,24.28479a39.731,39.731,0,0,1,11.71582,28.28125l.00146,33.02637a35.99994,35.99994,0,1,0,16-.00025Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112.00244,160a8.00039,8.00039,0,0,0-8,8v20.68555L79.71728,164.40039a39.73582,39.73582,0,0,1-11.71582-28.28125l-.001-33.02624a35.99974,35.99974,0,1,0-16,.00012l.001,33.0271a55.63733,55.63733,0,0,0,16.40137,39.59472L92.688,200H72.00244a8,8,0,1,0,0,16h40c.26367,0,.52734-.014.78955-.03992.11817-.01159.23242-.03369.34912-.05041.1416-.02027.28418-.03687.42481-.0647.13281-.02637.26123-.06274.3916-.0957.123-.03076.24658-.05786.36816-.09473.12647-.03833.24854-.08569.37207-.13.12305-.04395.24659-.0846.36768-.13465.11328-.047.22168-.10217.332-.15405.127-.05957.2544-.116.37842-.18237.10205-.05481.19922-.11731.29834-.17627.12549-.07422.25146-.14527.37353-.22681.10352-.06946.20069-.14722.30078-.22119.10987-.0813.22168-.158.32813-.24561.144-.11792.27881-.246.41406-.37353.05518-.05249.11475-.09851.169-.15283.05664-.0564.10449-.11792.15869-.17554.12549-.13281.251-.26538.36719-.40649.09131-.11072.17138-.22718.25537-.34156.07031-.0957.14453-.188.21094-.28686.085-.12659.15917-.25782.23583-.38806.05567-.09436.11524-.18616.167-.28309.06933-.12915.12842-.26184.18994-.39379.04931-.10547.10205-.20874.147-.31665.05225-.12647.09522-.25562.14063-.38428.042-.11817.0874-.2345.124-.35523.03906-.1289.06787-.25976.10059-.39013.03076-.12305.06543-.24414.09033-.36939.02978-.15137.04834-.30444.06933-.457.01465-.106.03516-.21.0459-.31714q.03956-.39769.04-.79712V168A8.00039,8.00039,0,0,0,112.00244,160Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "196.00244",
      "cy": "188",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M196.00244,160l-.00163-40.11889a48,48,0,0,0-14.05888-33.93918L144,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 88 144 48 184 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "60",
      "cy": "68",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M60,96l.00163,40.11889a48,48,0,0,0,14.05888,33.93918L112.00244,208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "112.002 168 112.002 208 72.002 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "196.00244",
      "cy": "188",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M196.00244,160l-.00163-40.11889a48,48,0,0,0-14.05888-33.93918L144,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 88 144 48 184 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "60",
      "cy": "68",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M60,96l.00163,40.11889a48,48,0,0,0,14.05888,33.93918L112.00244,208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "112.002 168 112.002 208 72.002 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "196.00244",
      "cy": "188",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M196.00244,160l-.00163-40.11889a48,48,0,0,0-14.05888-33.93918L144,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 88 144 48 184 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "60",
      "cy": "68",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M60,96l.00163,40.11889a48,48,0,0,0,14.05888,33.93918L112.00244,208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "112.002 168 112.002 208 72.002 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6R = [];
/* style */

const __vue_inject_styles__$6R = undefined;
/* scoped */

const __vue_scope_id__$6R = undefined;
/* module identifier */

const __vue_module_identifier__$6R = undefined;
/* functional template */

const __vue_is_functional_template__$6R = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6R = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6R,
  staticRenderFns: __vue_staticRenderFns__$6R
}, __vue_inject_styles__$6R, __vue_script__$6R, __vue_scope_id__$6R, __vue_is_functional_template__$6R, __vue_module_identifier__$6R, false, undefined, undefined, undefined);

var script$6S = Vue.extend({
  name: "PhGitFork",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6S = script$6S;
/* template */

var __vue_render__$6S = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "188",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "67.99756",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "67.99756",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M68,95.99756v8.002a24,24,0,0,0,24.00049,24l72-.00146a24,24,0,0,0,23.99951-24V95.99756",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128.00244",
      "y1": "128",
      "x2": "128",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "188",
      "cy": "67.99756",
      "r": "28",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "67.99756",
      "r": "28",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "188",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "67.99756",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "67.99756",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M68,95.99756v8.002a24,24,0,0,0,24.00049,24l72-.00146a24,24,0,0,0,23.99951-24V95.99756",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128.00244",
      "y1": "128",
      "x2": "128",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224.00049,67.99756a36,36,0,1,0-44,35.09289v.9076a16.01865,16.01865,0,0,1-16,16l-72,.00146a15.99994,15.99994,0,0,1-16-16v-.90906a36,36,0,1,0-16,0v.90906a31.99909,31.99909,0,0,0,32,32L120.002,135.999l-.001,16.908a35.99993,35.99993,0,1,0,16,.00019l.001-16.90857,27.99854-.00055a32.0373,32.0373,0,0,0,32-32v-.9076A36.05514,36.05514,0,0,0,224.00049,67.99756ZM148.00049,188a20,20,0,1,1-20-20A20.02229,20.02229,0,0,1,148.00049,188Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "188",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "67.99756",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "67.99756",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M68,95.99756v8.002a24,24,0,0,0,24.00049,24l72-.00146a24,24,0,0,0,23.99951-24V95.99756",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128.00244",
      "y1": "128",
      "x2": "128",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "188",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "67.99756",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "67.99756",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M68,95.99756v8.002a24,24,0,0,0,24.00049,24l72-.00146a24,24,0,0,0,23.99951-24V95.99756",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128.00244",
      "y1": "128",
      "x2": "128",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "188",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "67.99756",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "67.99756",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M68,95.99756v8.002a24,24,0,0,0,24.00049,24l72-.00146a24,24,0,0,0,23.99951-24V95.99756",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128.00244",
      "y1": "128",
      "x2": "128",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6S = [];
/* style */

const __vue_inject_styles__$6S = undefined;
/* scoped */

const __vue_scope_id__$6S = undefined;
/* module identifier */

const __vue_module_identifier__$6S = undefined;
/* functional template */

const __vue_is_functional_template__$6S = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6S = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6S,
  staticRenderFns: __vue_staticRenderFns__$6S
}, __vue_inject_styles__$6S, __vue_script__$6S, __vue_scope_id__$6S, __vue_is_functional_template__$6S, __vue_module_identifier__$6S, false, undefined, undefined, undefined);

var script$6T = Vue.extend({
  name: "PhGitMerge",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6T = script$6T;
/* template */

var __vue_render__$6T = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "67.99512",
      "cy": "188",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "67.99512",
      "cy": "68",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "187.99756",
      "cy": "140",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M159.99756,144H130.47711a48,48,0,0,1-36.87462-17.27115L67.99512,96v64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "67.99023",
      "cy": "68",
      "r": "28",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "67.99023",
      "cy": "188",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "67.99023",
      "cy": "68",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "187.99268",
      "cy": "140",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M159.99268,144H130.47223a48,48,0,0,1-36.87462-17.27115L67.99023,96v64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M187.99268,104a36.04766,36.04766,0,0,0-35.77247,32h-21.748a39.89636,39.89636,0,0,1-30.72949-14.39258L82.51123,100.93005a35.99422,35.99422,0,1,0-22.52148,2.16285v49.8142a36,36,0,1,0,16,0V118.09668l11.46191,13.75293A55.84986,55.84986,0,0,0,130.47217,152h23.585a35.99769,35.99769,0,1,0,33.93555-48ZM87.98975,188a20,20,0,1,1-20-20A20.02229,20.02229,0,0,1,87.98975,188Zm100.00293-28a20,20,0,1,1,20-20A20.02229,20.02229,0,0,1,187.99268,160Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "67.99756",
      "cy": "188",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "67.99756",
      "cy": "68",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "140",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160,144H130.47956a48,48,0,0,1-36.87463-17.27115L67.99756,96v64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "68",
      "cy": "188",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "68",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188.00244",
      "cy": "140",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160.00244,144H130.482a48,48,0,0,1-36.87462-17.27115L68,96v64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "68",
      "cy": "188",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "68",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188.00244",
      "cy": "140",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160.00244,144H130.482a48,48,0,0,1-36.87462-17.27115L68,96v64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6T = [];
/* style */

const __vue_inject_styles__$6T = undefined;
/* scoped */

const __vue_scope_id__$6T = undefined;
/* module identifier */

const __vue_module_identifier__$6T = undefined;
/* functional template */

const __vue_is_functional_template__$6T = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6T = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6T,
  staticRenderFns: __vue_staticRenderFns__$6T
}, __vue_inject_styles__$6T, __vue_script__$6T, __vue_scope_id__$6T, __vue_is_functional_template__$6T, __vue_module_identifier__$6T, false, undefined, undefined, undefined);

var script$6U = Vue.extend({
  name: "PhGitPullRequest",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6U = script$6U;
/* template */

var __vue_render__$6U = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "68",
      "cy": "188",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "68",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "68",
      "y1": "96",
      "x2": "68",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188.00244",
      "cy": "188",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M188.00244,160l-.00163-40.11889a48,48,0,0,0-14.05888-33.93918L136,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "136 88 136 48 176 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "68",
      "cy": "68",
      "r": "28",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188.00244",
      "cy": "188",
      "r": "28",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "188",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "68",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188.00244",
      "cy": "188",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "68",
      "y1": "96",
      "x2": "68",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M188.00244,160l-.00163-40.11889a48,48,0,0,0-14.05888-33.93918L136,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "136 88 136 48 176 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M104.00049,68a36,36,0,1,0-44,35.0929v49.8142a36,36,0,1,0,16,0V103.0929A36.05516,36.05516,0,0,0,104.00049,68Zm-16,120a20,20,0,1,1-20-20A20.0226,20.0226,0,0,1,88.00049,188Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M196.002,152.907l-.00146-33.02563a55.63508,55.63508,0,0,0-16.40137-39.59619L155.31445,56h20.686a8,8,0,0,0,0-16h-40c-.01563,0-.03028.00226-.0459.00232-.24756.0014-.49463.01318-.74121.03747-.12842.01252-.25293.0362-.3794.05469-.13086.01929-.2622.03418-.39257.05994-.145.02862-.28516.068-.42725.10431-.11035.02826-.22168.052-.33057.085-.14013.04224-.2749.0943-.41162.14386-.10937.03961-.21972.07538-.32763.12-.12745.05268-.24952.11432-.37354.17328-.11279.05347-.22656.10328-.33691.16236-.11914.0636-.23243.13574-.34766.20508-.1084.0653-.21875.12652-.3252.19751-.12353.08264-.23974.17443-.35839.26367-.09082.06823-.18409.1311-.27246.20361-.1875.15381-.36622.31714-.53907.487-.01562.0152-.03222.02783-.04785.04315-.02051.02051-.0376.04321-.05762.06391-.16357.16711-.32177.33941-.47021.52032-.083.10059-.15527.20648-.23193.31006-.07862.10571-.16065.20862-.23438.3183-.08057.12072-.15088.24591-.22461.36993-.05957.1-.12207.19757-.17724.30036-.06788.12591-.125.25531-.18506.384-.05078.1084-.10547.21466-.15137.32568-.05127.12463-.09326.25189-.13867.37848-.04248.11987-.08887.238-.126.36047-.03857.12775-.06738.25757-.09912.38678-.03125.124-.06592.24622-.09131.37244-.02978.15088-.04785.30328-.06933.45544-.01465.10645-.03516.21094-.0459.31867q-.03955.39752-.04.79706V88a8,8,0,0,0,16,0V67.31415l24.28418,24.28448a39.73874,39.73874,0,0,1,11.71582,28.28321l.00146,33.02533a36.00007,36.00007,0,1,0,16-.00019Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "68",
      "cy": "188",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "68",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "68",
      "y1": "96",
      "x2": "68",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188.00244",
      "cy": "188",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M188.00244,160l-.00163-40.11889a48,48,0,0,0-14.05888-33.93918L136,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "136 88 136 48 176 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "68",
      "cy": "188",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "68",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "68",
      "y1": "96",
      "x2": "68",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188.00244",
      "cy": "188",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M188.00244,160l-.00163-40.11889a48,48,0,0,0-14.05888-33.93918L136,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "136 88 136 48 176 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "68",
      "cy": "188",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "68",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "68",
      "y1": "96",
      "x2": "68",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188.00244",
      "cy": "188",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M188.00244,160l-.00163-40.11889a48,48,0,0,0-14.05888-33.93918L136,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "136 88 136 48 176 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6U = [];
/* style */

const __vue_inject_styles__$6U = undefined;
/* scoped */

const __vue_scope_id__$6U = undefined;
/* module identifier */

const __vue_module_identifier__$6U = undefined;
/* functional template */

const __vue_is_functional_template__$6U = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6U = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6U,
  staticRenderFns: __vue_staticRenderFns__$6U
}, __vue_inject_styles__$6U, __vue_script__$6U, __vue_scope_id__$6U, __vue_is_functional_template__$6U, __vue_module_identifier__$6U, false, undefined, undefined, undefined);

var script$6V = Vue.extend({
  name: "PhGithubLogo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6V = script$6V;
/* template */

var __vue_render__$6V = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M84,240a24,24,0,0,0,24-24V168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M172,240a24,24,0,0,1-24-24V168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,168h16a24,24,0,0,1,24,24v8a24,24,0,0,0,24,24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,168H88a24,24,0,0,0-24,24v8a24,24,0,0,1-24,24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M111.825,63.99934A51.9599,51.9599,0,0,0,68,40a51.90058,51.90058,0,0,0-3.48841,44.7036A49.25789,49.25789,0,0,0,56,112v8a48,48,0,0,0,48,48h48a48,48,0,0,0,48-48v-8a49.25769,49.25769,0,0,0-8.5116-27.29639A51.90061,51.90061,0,0,0,188,40a51.95992,51.95992,0,0,0-43.82535,23.99983Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M111.825,63.99934A51.9599,51.9599,0,0,0,68,40a51.90058,51.90058,0,0,0-3.48841,44.7036A49.25789,49.25789,0,0,0,56,112v8a48,48,0,0,0,48,48h48a48,48,0,0,0,48-48v-8a49.25769,49.25769,0,0,0-8.5116-27.29639A51.90061,51.90061,0,0,0,188,40a51.95992,51.95992,0,0,0-43.82535,23.99983Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M84,240a24,24,0,0,0,24-24V168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M172,240a24,24,0,0,1-24-24V168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,168h16a24,24,0,0,1,24,24v8a24,24,0,0,0,24,24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,168H88a24,24,0,0,0-24,24v8a24,24,0,0,1-24,24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M111.825,63.99934A51.9599,51.9599,0,0,0,68,40a51.90058,51.90058,0,0,0-3.48841,44.7036A49.25789,49.25789,0,0,0,56,112v8a48,48,0,0,0,48,48h48a48,48,0,0,0,48-48v-8a49.25769,49.25769,0,0,0-8.5116-27.29639A51.90061,51.90061,0,0,0,188,40a51.95992,51.95992,0,0,0-43.82535,23.99983Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,224a8.00039,8.00039,0,0,1-8,8,32.03667,32.03667,0,0,1-32-32v-8a16.01833,16.01833,0,0,0-16-16H156v40a16.01833,16.01833,0,0,0,16,16,8,8,0,0,1,0,16,32.03667,32.03667,0,0,1-32-32V176H116v40a32.03667,32.03667,0,0,1-32,32,8,8,0,0,1,0-16,16.01833,16.01833,0,0,0,16-16V176H88a16.01833,16.01833,0,0,0-16,16v8a32.03667,32.03667,0,0,1-32,32,8,8,0,0,1,0-16,16.01833,16.01833,0,0,0,16-16v-8a31.9949,31.9949,0,0,1,14.78076-26.95068A55.951,55.951,0,0,1,48,120v-8a58.0419,58.0419,0,0,1,7.69482-28.32031A59.73551,59.73551,0,0,1,61.07178,36,7.99908,7.99908,0,0,1,68,32a59.74952,59.74952,0,0,1,48.00732,23.999L139.99219,56A59.74792,59.74792,0,0,1,188,32a7.99908,7.99908,0,0,1,6.92822,4,59.73339,59.73339,0,0,1,5.37647,47.67969A58.04124,58.04124,0,0,1,208,112v8a55.951,55.951,0,0,1-22.78076,45.04932A31.9949,31.9949,0,0,1,200,192v8a16.01833,16.01833,0,0,0,16,16A8.00039,8.00039,0,0,1,224,224Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M84,240a24,24,0,0,0,24-24V168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M172,240a24,24,0,0,1-24-24V168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,168h16a24,24,0,0,1,24,24v8a24,24,0,0,0,24,24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,168H88a24,24,0,0,0-24,24v8a24,24,0,0,1-24,24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M111.825,63.99934A51.9599,51.9599,0,0,0,68,40a51.90058,51.90058,0,0,0-3.48841,44.7036A49.25789,49.25789,0,0,0,56,112v8a48,48,0,0,0,48,48h48a48,48,0,0,0,48-48v-8a49.25769,49.25769,0,0,0-8.5116-27.29639A51.90061,51.90061,0,0,0,188,40a51.95992,51.95992,0,0,0-43.82535,23.99983Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M84,240a24,24,0,0,0,24-24V168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M172,240a24,24,0,0,1-24-24V168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,168h16a24,24,0,0,1,24,24v8a24,24,0,0,0,24,24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,168H88a24,24,0,0,0-24,24v8a24,24,0,0,1-24,24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M111.825,63.99934A51.9599,51.9599,0,0,0,68,40a51.90058,51.90058,0,0,0-3.48841,44.7036A49.25789,49.25789,0,0,0,56,112v8a48,48,0,0,0,48,48h48a48,48,0,0,0,48-48v-8a49.25769,49.25769,0,0,0-8.5116-27.29639A51.90061,51.90061,0,0,0,188,40a51.95992,51.95992,0,0,0-43.82535,23.99983Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M84,240a24,24,0,0,0,24-24V168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M172,240a24,24,0,0,1-24-24V168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,168h16a24,24,0,0,1,24,24v8a24,24,0,0,0,24,24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,168H88a24,24,0,0,0-24,24v8a24,24,0,0,1-24,24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M111.825,63.99934A51.9599,51.9599,0,0,0,68,40a51.90058,51.90058,0,0,0-3.48841,44.7036A49.25789,49.25789,0,0,0,56,112v8a48,48,0,0,0,48,48h48a48,48,0,0,0,48-48v-8a49.25769,49.25769,0,0,0-8.5116-27.29639A51.90061,51.90061,0,0,0,188,40a51.95992,51.95992,0,0,0-43.82535,23.99983Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6V = [];
/* style */

const __vue_inject_styles__$6V = undefined;
/* scoped */

const __vue_scope_id__$6V = undefined;
/* module identifier */

const __vue_module_identifier__$6V = undefined;
/* functional template */

const __vue_is_functional_template__$6V = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6V = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6V,
  staticRenderFns: __vue_staticRenderFns__$6V
}, __vue_inject_styles__$6V, __vue_script__$6V, __vue_scope_id__$6V, __vue_is_functional_template__$6V, __vue_module_identifier__$6V, false, undefined, undefined, undefined);

var script$6W = Vue.extend({
  name: "PhGitlabLogo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6W = script$6W;
/* template */

var __vue_render__$6W = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M83,112h90l22.61071-60.29524a4,4,0,0,1,7.61026.37384l27.32935,102.4851a8,8,0,0,1-3.1762,8.63883l-94.82044,65.64492a8,8,0,0,1-9.10736,0L28.62588,163.20255a8,8,0,0,1-3.1762-8.63883L52.779,52.07862a4,4,0,0,1,7.61026-.37384Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('g', [_c('line', {
    attrs: {
      "x1": "128.65903",
      "y1": "230.2426",
      "x2": "173",
      "y2": "112.00002",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "83 112 83 112 127.341 230.243",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })])]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M127.341,230.2426,83,112h90L128.659,230.2426l0,.0002a8.017,8.017,0,0,1-1.3181,0Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M219.2,112l-15.979-59.9214a4,4,0,0,0-7.61026-.37384L173,112Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M36.8,112l15.979-59.9214a4,4,0,0,1,7.61026-.37384L83,112H36.8Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M83,112h90l22.61071-60.29524a4,4,0,0,1,7.61026.37384l27.32935,102.4851a8,8,0,0,1-3.1762,8.63883l-94.82044,65.64492a8,8,0,0,1-9.10736,0L28.62588,163.20255a8,8,0,0,1-3.1762-8.63883L52.779,52.07862a4,4,0,0,1,7.61026-.37384Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128.659 230.243 173 112 219.2 112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "36.8 112 83 112 83 112 127.341 230.243",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M238.28027,152.50246,210.95068,50.01662a12.00021,12.00021,0,0,0-22.83056-1.12109L167.45605,104H88.544L67.87988,48.89651a12.00012,12.00012,0,0,0-22.831,1.12109L17.71973,152.50246a16.03981,16.03981,0,0,0,6.35254,17.27783l94.82031,65.64454a15.91589,15.91589,0,0,0,7.093,2.69336c.22131.03808.44567.05517.67065.0747.09387.00781.1875.01514.28149.02149.13526.00683.26807.03076.40406.03076.06445,0,.12939-.00733.19409-.00879.15478.00439.30932.01709.46411.01709s.30933-.0127.46411-.01709c.0647.00146.12964.00879.19409.00879.13587,0,.26831-.02393.40345-.03076q.1419-.00952.2832-.02149c.22436-.02.44812-.03662.66882-.0747a15.91868,15.91868,0,0,0,7.09375-2.69336l94.82031-65.64454A16.03981,16.03981,0,0,0,238.28027,152.50246ZM33.17969,156.625,42.94617,120H77.45605l34.07544,90.86865Zm111.28882,54.24365L178.544,120h34.50988l9.76648,36.625Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M83,112h90l22.61071-60.29524a4,4,0,0,1,7.61026.37384l27.32935,102.4851a8,8,0,0,1-3.1762,8.63883l-94.82044,65.64492a8,8,0,0,1-9.10736,0L28.62588,163.20255a8,8,0,0,1-3.1762-8.63883L52.779,52.07862a4,4,0,0,1,7.61026-.37384Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('g', [_c('polyline', {
    attrs: {
      "points": "128.659 230.243 173 112 219.2 112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "36.8 112 83 112 83 112 127.341 230.243",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })])]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M83,112h90l22.61071-60.29524a4,4,0,0,1,7.61026.37384l27.32935,102.4851a8,8,0,0,1-3.1762,8.63883l-94.82044,65.64492a8,8,0,0,1-9.10736,0L28.62588,163.20255a8,8,0,0,1-3.1762-8.63883L52.779,52.07862a4,4,0,0,1,7.61026-.37384Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('g', [_c('polyline', {
    attrs: {
      "points": "128.659 230.243 173 112 219.2 112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "36.8 112 83 112 83 112 127.341 230.243",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })])]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M83,112h90l22.61071-60.29524a4,4,0,0,1,7.61026.37384l27.32935,102.4851a8,8,0,0,1-3.1762,8.63883l-94.82044,65.64492a8,8,0,0,1-9.10736,0L28.62588,163.20255a8,8,0,0,1-3.1762-8.63883L52.779,52.07862a4,4,0,0,1,7.61026-.37384Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('g', [_c('polyline', {
    attrs: {
      "points": "128.659 230.243 173 112 219.2 112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "36.8 112 83 112 83 112 127.341 230.243",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })])]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6W = [];
/* style */

const __vue_inject_styles__$6W = undefined;
/* scoped */

const __vue_scope_id__$6W = undefined;
/* module identifier */

const __vue_module_identifier__$6W = undefined;
/* functional template */

const __vue_is_functional_template__$6W = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6W = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6W,
  staticRenderFns: __vue_staticRenderFns__$6W
}, __vue_inject_styles__$6W, __vue_script__$6W, __vue_scope_id__$6W, __vue_is_functional_template__$6W, __vue_module_identifier__$6W, false, undefined, undefined, undefined);

var script$6X = Vue.extend({
  name: "PhGitlabLogoSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6X = script$6X;
/* template */

var __vue_render__$6X = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M83,112h90l22.61071-60.29524a4,4,0,0,1,7.61026.37384l27.32935,102.4851a8,8,0,0,1-3.1762,8.63883l-94.82044,65.64492a8,8,0,0,1-9.10736,0L28.62588,163.20255a8,8,0,0,1-3.1762-8.63883L52.779,52.07862a4,4,0,0,1,7.61026-.37384Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M83,112h90l22.61071-60.29524a4,4,0,0,1,7.61026.37384l27.32935,102.4851a8,8,0,0,1-3.1762,8.63883l-94.82044,65.64492a8,8,0,0,1-9.10736,0L28.62588,163.20255a8,8,0,0,1-3.1762-8.63883L52.779,52.07862a4,4,0,0,1,7.61026-.37384Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M83,112h90l22.61071-60.29524a4,4,0,0,1,7.61026.37384l27.32935,102.4851a8,8,0,0,1-3.1762,8.63883l-94.82044,65.64492a8,8,0,0,1-9.10736,0L28.62588,163.20255a8,8,0,0,1-3.1762-8.63883L52.779,52.07862a4,4,0,0,1,7.61026-.37384Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M231.92773,169.78029l-94.82031,65.64454a16.07612,16.07612,0,0,1-18.21484,0L24.07227,169.78029a16.03981,16.03981,0,0,1-6.35254-17.27783L45.04883,50.0176a12.00012,12.00012,0,0,1,22.831-1.12109L88.544,104h78.9121l20.66407-55.10449a12.00021,12.00021,0,0,1,22.83056,1.12109l27.32959,102.48584A16.03981,16.03981,0,0,1,231.92773,169.78029Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M83,112h90l22.61071-60.29524a4,4,0,0,1,7.61026.37384l27.32935,102.4851a8,8,0,0,1-3.1762,8.63883l-94.82044,65.64492a8,8,0,0,1-9.10736,0L28.62588,163.20255a8,8,0,0,1-3.1762-8.63883L52.779,52.07862a4,4,0,0,1,7.61026-.37384Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M83,112h90l22.61071-60.29524a4,4,0,0,1,7.61026.37384l27.32935,102.4851a8,8,0,0,1-3.1762,8.63883l-94.82044,65.64492a8,8,0,0,1-9.10736,0L28.62588,163.20255a8,8,0,0,1-3.1762-8.63883L52.779,52.07862a4,4,0,0,1,7.61026-.37384Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M83,112h90l22.61071-60.29524a4,4,0,0,1,7.61026.37384l27.32935,102.4851a8,8,0,0,1-3.1762,8.63883l-94.82044,65.64492a8,8,0,0,1-9.10736,0L28.62588,163.20255a8,8,0,0,1-3.1762-8.63883L52.779,52.07862a4,4,0,0,1,7.61026-.37384Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6X = [];
/* style */

const __vue_inject_styles__$6X = undefined;
/* scoped */

const __vue_scope_id__$6X = undefined;
/* module identifier */

const __vue_module_identifier__$6X = undefined;
/* functional template */

const __vue_is_functional_template__$6X = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6X = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6X,
  staticRenderFns: __vue_staticRenderFns__$6X
}, __vue_inject_styles__$6X, __vue_script__$6X, __vue_scope_id__$6X, __vue_is_functional_template__$6X, __vue_module_identifier__$6X, false, undefined, undefined, undefined);

var script$6Y = Vue.extend({
  name: "PhGlobe",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6Y = script$6Y;
/* template */

var __vue_render__$6Y = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "37.46679",
      "y1": "96",
      "x2": "218.53174",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "37.47057",
      "y1": "160",
      "x2": "218.53448",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "40",
      "ry": "93.42294",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "37.46679",
      "y1": "96",
      "x2": "218.53174",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "37.47057",
      "y1": "160",
      "x2": "218.53448",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "40",
      "ry": "93.42294",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M225.86035,163.20862a7.94949,7.94949,0,0,0,.373-1.05676,104.00629,104.00629,0,0,0-.01026-68.33094,7.96,7.96,0,0,0-.35546-1.00793A104.17669,104.17669,0,0,0,128.042,24.00086L128,23.96423l-.042.03663A104.17672,104.17672,0,0,0,30.13623,92.80164a7.94362,7.94362,0,0,0-.36475,1.03454,104.00383,104.00383,0,0,0,.01319,68.36658,7.975,7.975,0,0,0,.34179.968,104.17624,104.17624,0,0,0,97.83057,68.8291l.043.0376.043-.0376A104.1768,104.1768,0,0,0,225.86035,163.20862ZM128,45.559a110.409,110.409,0,0,1,25.52246,42.44141H102.47754A110.409,110.409,0,0,1,128,45.559ZM102.478,168.00037H153.522A110.41425,110.41425,0,0,1,128,210.44177,110.41425,110.41425,0,0,1,102.478,168.00037Zm-4.18848-16a126.93369,126.93369,0,0,1,0-48h59.4209a126.93369,126.93369,0,0,1,0,48Zm75.73877-48h38.645a88.23665,88.23665,0,0,1,0,48h-38.645a147.05417,147.05417,0,0,0,0-48Zm32.34375-16H170.40771A127.43992,127.43992,0,0,0,146.2749,41.91406,88.31787,88.31787,0,0,1,206.37207,88.00037ZM146.27441,214.08679a127.44456,127.44456,0,0,0,24.13282-46.08642h35.96484A88.31753,88.31753,0,0,1,146.27441,214.08679Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "37.46679",
      "y1": "96",
      "x2": "218.53174",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "37.47057",
      "y1": "160",
      "x2": "218.53448",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "40",
      "ry": "93.42294",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "37.46679",
      "y1": "96",
      "x2": "218.53174",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "37.47057",
      "y1": "160",
      "x2": "218.53448",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "40",
      "ry": "93.42294",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "37.46679",
      "y1": "96",
      "x2": "218.53174",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "37.47057",
      "y1": "160",
      "x2": "218.53448",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "40",
      "ry": "93.42294",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6Y = [];
/* style */

const __vue_inject_styles__$6Y = undefined;
/* scoped */

const __vue_scope_id__$6Y = undefined;
/* module identifier */

const __vue_module_identifier__$6Y = undefined;
/* functional template */

const __vue_is_functional_template__$6Y = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6Y = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6Y,
  staticRenderFns: __vue_staticRenderFns__$6Y
}, __vue_inject_styles__$6Y, __vue_script__$6Y, __vue_scope_id__$6Y, __vue_is_functional_template__$6Y, __vue_module_identifier__$6Y, false, undefined, undefined, undefined);

var script$6Z = Vue.extend({
  name: "PhGlobeHemisphereEast",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6Z = script$6Z;
/* template */

var __vue_render__$6Z = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "127.99707",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M49.58344,183.394l12.0855-7.29563a8,8,0,0,0,3.82681-6.06228l3.65864-37.03127a8,8,0,0,1,1.21718-3.51665l19.71585-30.899a8,8,0,0,1,11.88909-1.82285l15.42768,12.95708a8,8,0,0,0,6.21864,1.80156l31.14623-4.218a8,8,0,0,0,4.97543-2.69227L181.9016,79.01382a8,8,0,0,0,1.94172-5.61949L182.675,49.09089",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M187.064,203.68283l-10.73163-10.75292a8,8,0,0,0-3.6318-2.08674l-21.45845-5.63128a8,8,0,0,1-5.884-8.90337l2.38477-16.19606a8,8,0,0,1,4.84416-6.22191l30.45053-12.65666a8,8,0,0,1,8.46961,1.48392l24.8944,22.768",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M187.06231,203.68216l-10.731-10.75225a7.99991,7.99991,0,0,0-3.6318-2.08674l-21.45845-5.63128a8,8,0,0,1-5.884-8.90337l2.38477-16.19606a8,8,0,0,1,4.84416-6.22191l30.45054-12.65666a8,8,0,0,1,8.4696,1.48392l24.89413,22.76769.05166-.118a96.30537,96.30537,0,0,1-29.18668,38.157Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M49.58112,183.39494A96.011,96.011,0,0,1,182.678,49.08523l-.004.00566,1.16831,24.30344a8,8,0,0,1-1.94173,5.61949l-22.1571,25.60081a8,8,0,0,1-4.97544,2.69227l-31.48043,4.2633a8,8,0,0,1-5.76724-1.44922L97.86462,95.88032a8,8,0,0,0-11.43769,2.17521L66.58435,129.15314a8.0001,8.0001,0,0,0-1.25581,4.2583l-.2028,36.12908a8,8,0,0,1-3.86545,6.80393L49.58246,183.394Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "127.99609",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M49.58246,183.394l11.67783-7.04953a8,8,0,0,0,3.86545-6.80393l.2028-36.12908a8.0001,8.0001,0,0,1,1.25581-4.2583L86.42693,98.05553a8,8,0,0,1,11.43769-2.17521L117.52041,110.121a8,8,0,0,0,5.76724,1.44922l31.48043-4.2633a8,8,0,0,0,4.97544-2.69227l22.1571-25.60081a8,8,0,0,0,1.94173-5.61949L182.674,49.09089",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M187.063,203.68283l-10.73163-10.75292a7.99991,7.99991,0,0,0-3.6318-2.08674l-21.45845-5.63128a8,8,0,0,1-5.884-8.90337l2.38477-16.19606a8,8,0,0,1,4.84416-6.22191l30.45054-12.65666a8,8,0,0,1,8.4696,1.48392l24.89441,22.768",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M223.4873,169.18066a7.96262,7.96262,0,0,0,.49805-1.166A103.91753,103.91753,0,0,0,187.772,42.94336a8.06306,8.06306,0,0,0-1.13965-.79053A103.94567,103.94567,0,0,0,42.61768,187.31152c.04.07129.07324.145.11572.21582a7.9667,7.9667,0,0,0,.80664,1.08985A103.847,103.847,0,0,0,191.2627,210.48242a7.98,7.98,0,0,0,1.40283-1.0957A104.572,104.572,0,0,0,223.4873,169.18066ZM61.48,185.55664l3.91345-2.362A16.00133,16.00133,0,0,0,73.126,169.585l.18967-33.81841a8.0001,8.0001,0,0,1,1.25578-4.2583L88.60582,109.513a8,8,0,0,1,11.43777-2.17522l12.78356,9.26186a15.95634,15.95634,0,0,0,11.53418,2.89844l31.48144-4.26367a15.99269,15.99269,0,0,0,9.94971-5.38477L187.94873,84.25A15.92874,15.92874,0,0,0,191.833,73.01074l-.2793-5.813a87.914,87.914,0,0,1,21.28272,84.187l-15.93116-14.57032a16.05451,16.05451,0,0,0-16.939-2.96777l-30.45166,12.65723a15.99852,15.99852,0,0,0-9.68738,12.44255l-2.38489,16.19612a15.98468,15.98468,0,0,0,11.76807,17.80762l21.4585,5.63085,3.98828,3.9961A87.85932,87.85932,0,0,1,61.48,185.55664Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "127.99805",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M49.58442,183.394l11.67782-7.04953a8,8,0,0,0,3.86545-6.80393l.20281-36.12908a7.99993,7.99993,0,0,1,1.25581-4.2583L86.42888,98.05553a8,8,0,0,1,11.43769-2.17521L117.52236,110.121a8,8,0,0,0,5.76724,1.44922L154.77,107.3069a8,8,0,0,0,4.97543-2.69227l22.15711-25.60081a8.00006,8.00006,0,0,0,1.94172-5.61949L182.676,49.09089",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M187.06492,203.68283,176.3333,192.92991a8,8,0,0,0-3.6318-2.08674L151.243,185.21189a8,8,0,0,1-5.884-8.90337l2.38476-16.19606a8,8,0,0,1,4.84416-6.22191l30.45054-12.65666a8,8,0,0,1,8.4696,1.48392l24.89441,22.768",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "127.99902",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M49.58539,183.394l11.67783-7.04953a8,8,0,0,0,3.86545-6.80393l.2028-36.12908a8.0001,8.0001,0,0,1,1.25581-4.2583L86.42986,98.05553a8,8,0,0,1,11.43769-2.17521L117.52334,110.121a8,8,0,0,0,5.76724,1.44922l31.48043-4.2633a8,8,0,0,0,4.97544-2.69227l22.1571-25.60081a8,8,0,0,0,1.94172-5.61949L182.677,49.09089",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M187.0659,203.68283l-10.73163-10.75292a8,8,0,0,0-3.6318-2.08674L151.244,185.21189a8,8,0,0,1-5.884-8.90337l2.38477-16.19606a8,8,0,0,1,4.84416-6.22191l30.45054-12.65666a8,8,0,0,1,8.4696,1.48392l24.89441,22.768",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M49.58637,183.394l11.67782-7.04953a8,8,0,0,0,3.86546-6.80393l.2028-36.12908a7.99993,7.99993,0,0,1,1.25581-4.2583L86.43083,98.05553a8,8,0,0,1,11.43769-2.17521l19.6558,14.24066a8,8,0,0,0,5.76724,1.44922l31.48043-4.2633a8,8,0,0,0,4.97543-2.69227l22.15711-25.60081a8,8,0,0,0,1.94172-5.61949L182.678,49.09089",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M187.06688,203.68283l-10.73163-10.75292a8,8,0,0,0-3.6318-2.08674L151.245,185.21189a8,8,0,0,1-5.884-8.90337l2.38477-16.19606a8,8,0,0,1,4.84416-6.22191l30.45053-12.65666a8,8,0,0,1,8.46961,1.48392l24.8944,22.768",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6Z = [];
/* style */

const __vue_inject_styles__$6Z = undefined;
/* scoped */

const __vue_scope_id__$6Z = undefined;
/* module identifier */

const __vue_module_identifier__$6Z = undefined;
/* functional template */

const __vue_is_functional_template__$6Z = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6Z = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6Z,
  staticRenderFns: __vue_staticRenderFns__$6Z
}, __vue_inject_styles__$6Z, __vue_script__$6Z, __vue_scope_id__$6Z, __vue_is_functional_template__$6Z, __vue_module_identifier__$6Z, false, undefined, undefined, undefined);

var script$6_ = Vue.extend({
  name: "PhGlobeHemisphereWest",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6_ = script$6_;
/* template */

var __vue_render__$6_ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M214.16458,170.37222l-54.28632-33.38846a7.99993,7.99993,0,0,0-3.12236-1.114l-22.81867-3.07595a8,8,0,0,0-8.37592,4.67178l-13.69878,30.73831a8,8,0,0,0,1.433,8.68736l18.79995,20.33464a8,8,0,0,1,1.98022,6.9502l-3.8294,19.79638",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64.95216,55.60635,56.00794,76.75607a8,8,0,0,0-.12321,5.92293l11.49086,30.66819a8,8,0,0,0,5.81037,5.01448l21.42993,4.60592a8,8,0,0,1,5.5197,4.3358l3.80564,7.862a8,8,0,0,0,7.20075,4.51442h13.43256",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152.45823,35.14852l9.33366,16.7184a8,8,0,0,1-1.6191,9.83314L133.26192,86.0376a8.00033,8.00033,0,0,1-1.49868,1.06968l-12.24176,6.76034a8,8,0,0,1-3.86737.9969H94.30873a8,8,0,0,0-7.37259,4.89437l-8.32721,19.76833",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M130.24636,223.97423a96.01036,96.01036,0,0,0,83.92-53.60107l-.00178-.00094-54.28632-33.38846a7.99993,7.99993,0,0,0-3.12236-1.114l-22.81867-3.07595a8,8,0,0,0-8.37592,4.67178l-13.69878,30.73831a8,8,0,0,0,1.433,8.68736l18.79995,20.33464a8,8,0,0,1,1.98022,6.9502l-3.8294,19.79638Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64.95216,55.60635,56.00794,76.75607a8,8,0,0,0-.12321,5.92293l11.49086,30.66819a8,8,0,0,0,5.81037,5.01448l5.423,1.16555,8.32721-19.76833a8,8,0,0,1,7.37259-4.89437h21.34538a8,8,0,0,0,3.86737-.9969l12.24176-6.76034a8.00033,8.00033,0,0,0,1.49868-1.06968l26.91087-24.33754a8,8,0,0,0,1.6191-9.83314l-9.33366-16.7184.00122-.00463A96.18805,96.18805,0,0,0,64.95081,55.60478Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M214.16458,170.37222l-54.28632-33.38846a7.99993,7.99993,0,0,0-3.12236-1.114l-22.81867-3.07595a8,8,0,0,0-8.37592,4.67178l-13.69878,30.73831a8,8,0,0,0,1.433,8.68736l18.79995,20.33464a8,8,0,0,1,1.98022,6.9502l-3.8294,19.79638",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64.95216,55.60635,56.00794,76.75607a8,8,0,0,0-.12321,5.92293l11.49086,30.66819a8,8,0,0,0,5.81037,5.01448l21.42993,4.60592a8,8,0,0,1,5.5197,4.3358l3.80564,7.862a8,8,0,0,0,7.20075,4.51442h13.43256",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152.45823,35.14852l9.33366,16.7184a8,8,0,0,1-1.6191,9.83314L133.26192,86.0376a8.00033,8.00033,0,0,1-1.49868,1.06968l-12.24176,6.76034a8,8,0,0,1-3.86737.9969H94.30873a8,8,0,0,0-7.37259,4.89437l-8.32721,19.76833",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M221.59668,173.31348A103.97882,103.97882,0,0,0,154.84473,27.51953c-.18018-.05615-.36231-.10449-.5459-.14795A103.90813,103.90813,0,0,0,60.3916,49.041a7.94439,7.94439,0,0,0-1.33545,1.168A103.94993,103.94993,0,0,0,128,232c.73584,0,1.46875-.0127,2.20117-.02783.01807,0,.03613.00244.05371.00244.03516,0,.06885-.00391.10352-.0044A104.12933,104.12933,0,0,0,220.96387,174.585l.01465-.02148A7.967,7.967,0,0,0,221.59668,173.31348ZM216,128a87.57766,87.57766,0,0,1-5.53125,30.70654L164.06836,130.168a15.90244,15.90244,0,0,0-6.24365-2.22656l-22.81836-3.07618a16.10781,16.10781,0,0,0-15.32178,6.81446h-8.543l-3.80469-7.86035A16.00216,16.00216,0,0,0,96.295,115.14608l-6.5655-1.41073,2.51745-5.97658a8,8,0,0,1,7.37265-4.89451H115.6543a16.02745,16.02745,0,0,0,7.73437-1.99414l12.24317-6.76074a16.03672,16.03672,0,0,0,2.99609-2.1377l26.91064-24.33789a15.90675,15.90675,0,0,0,4.4336-16.96289A88.07506,88.07506,0,0,1,216,128ZM40,128a87.46223,87.46223,0,0,1,9.46094-39.665l10.42334,27.82031a15.93042,15.93042,0,0,0,11.6206,10.02735l5.5127,1.18506.04541.00976,12.05371,2.591a8,8,0,0,1,5.51942,4.33553l2.10451,4.34726a16.00022,16.00022,0,0,0,14.40146,9.02849H112.251l-7.69532,17.26758a15.98365,15.98365,0,0,0,2.86622,17.375l16.05,17.36021a8,8,0,0,1,1.98025,6.95l-1.791,9.25958A88.10889,88.10889,0,0,1,40,128Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M214.16458,170.37222l-54.28632-33.38846a7.99993,7.99993,0,0,0-3.12236-1.114l-22.81867-3.07595a8,8,0,0,0-8.37592,4.67178l-13.69878,30.73831a8,8,0,0,0,1.433,8.68736l18.79995,20.33464a8,8,0,0,1,1.98022,6.9502l-3.8294,19.79638",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64.95216,55.60635,56.00794,76.75607a8,8,0,0,0-.12321,5.92293l11.49086,30.66819a8,8,0,0,0,5.81037,5.01448l21.42993,4.60592a8,8,0,0,1,5.5197,4.3358l3.80564,7.862a8,8,0,0,0,7.20075,4.51442h13.43256",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152.45823,35.14852l9.33366,16.7184a8,8,0,0,1-1.6191,9.83314L133.26192,86.0376a8.00033,8.00033,0,0,1-1.49868,1.06968l-12.24176,6.76034a8,8,0,0,1-3.86737.9969H94.30873a8,8,0,0,0-7.37259,4.89437l-8.32721,19.76833",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M214.16458,170.37222l-54.28632-33.38846a7.99993,7.99993,0,0,0-3.12236-1.114l-22.81867-3.07595a8,8,0,0,0-8.37592,4.67178l-13.69878,30.73831a8,8,0,0,0,1.433,8.68736l18.79995,20.33464a8,8,0,0,1,1.98022,6.9502l-3.8294,19.79638",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64.95216,55.60635,56.00794,76.75607a8,8,0,0,0-.12321,5.92293l11.49086,30.66819a8,8,0,0,0,5.81037,5.01448l21.42993,4.60592a8,8,0,0,1,5.5197,4.3358l3.80564,7.862a8,8,0,0,0,7.20075,4.51442h13.43256",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152.45823,35.14852l9.33366,16.7184a8,8,0,0,1-1.6191,9.83314L133.26192,86.0376a8.00033,8.00033,0,0,1-1.49868,1.06968l-12.24176,6.76034a8,8,0,0,1-3.86737.9969H94.30873a8,8,0,0,0-7.37259,4.89437l-8.32721,19.76833",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M214.16458,170.37222l-54.28632-33.38846a7.99993,7.99993,0,0,0-3.12236-1.114l-22.81867-3.07595a8,8,0,0,0-8.37592,4.67178l-13.69878,30.73831a8,8,0,0,0,1.433,8.68736l18.79995,20.33464a8,8,0,0,1,1.98022,6.9502l-3.8294,19.79638",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64.95216,55.60635,56.00794,76.75607a8,8,0,0,0-.12321,5.92293l11.49086,30.66819a8,8,0,0,0,5.81037,5.01448l21.42993,4.60592a8,8,0,0,1,5.5197,4.3358l3.80564,7.862a8,8,0,0,0,7.20075,4.51442h13.43256",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152.45823,35.14852l9.33366,16.7184a8,8,0,0,1-1.6191,9.83314L133.26192,86.0376a8.00033,8.00033,0,0,1-1.49868,1.06968l-12.24176,6.76034a8,8,0,0,1-3.86737.9969H94.30873a8,8,0,0,0-7.37259,4.89437l-8.32721,19.76833",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6_ = [];
/* style */

const __vue_inject_styles__$6_ = undefined;
/* scoped */

const __vue_scope_id__$6_ = undefined;
/* module identifier */

const __vue_module_identifier__$6_ = undefined;
/* functional template */

const __vue_is_functional_template__$6_ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6_ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6_,
  staticRenderFns: __vue_staticRenderFns__$6_
}, __vue_inject_styles__$6_, __vue_script__$6_, __vue_scope_id__$6_, __vue_is_functional_template__$6_, __vue_module_identifier__$6_, false, undefined, undefined, undefined);

var script$6$ = Vue.extend({
  name: "PhGlobeSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6$ = script$6$;
/* template */

var __vue_render__$6$ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "128",
      "x2": "224",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "40",
      "ry": "93.42294",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "128",
      "x2": "224",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "40",
      "ry": "93.42294",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232,128.00037A104.11767,104.11767,0,0,0,128.042,24.00086L128,23.96423l-.042.03663a103.99952,103.99952,0,0,0-.001,207.999l.043.0376.043-.0376A104.11763,104.11763,0,0,0,232,128.00037Zm-16.36768-8h-39.853c-1.5918-29.637-12.01123-57.01758-29.5044-78.08643A88.1919,88.1919,0,0,1,215.63232,120.00037Zm-119.37353,16h63.48242C157.93164,164.75623,146.44678,191.703,128,210.44177,109.55322,191.703,98.06836,164.75623,96.25879,136.00037Zm0-16C98.06836,91.24353,109.55322,64.29675,128,45.559c18.44678,18.73779,29.93164,45.68457,31.74121,74.44141Zm50.01562,94.08642c17.49317-21.06933,27.9126-48.45044,29.50489-78.08642h39.853A88.19181,88.19181,0,0,1,146.27441,214.08679Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "128",
      "x2": "224",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "40",
      "ry": "93.42294",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "128",
      "x2": "224",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "40",
      "ry": "93.42294",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "128",
      "x2": "224",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "40",
      "ry": "93.42294",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6$ = [];
/* style */

const __vue_inject_styles__$6$ = undefined;
/* scoped */

const __vue_scope_id__$6$ = undefined;
/* module identifier */

const __vue_module_identifier__$6$ = undefined;
/* functional template */

const __vue_is_functional_template__$6$ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6$ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6$,
  staticRenderFns: __vue_staticRenderFns__$6$
}, __vue_inject_styles__$6$, __vue_script__$6$, __vue_scope_id__$6$, __vue_is_functional_template__$6$, __vue_module_identifier__$6$, false, undefined, undefined, undefined);

var script$70 = Vue.extend({
  name: "PhGlobeStand",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$70 = script$70;
/* template */

var __vue_render__$70 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "96",
      "r": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M201.53911,169.53264A104,104,0,0,1,54.46089,22.45443",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "235.99353",
      "x2": "160",
      "y2": "235.99353",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "199.99353",
      "x2": "128",
      "y2": "235.99353",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "95.99353",
      "r": "72",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "95.99353",
      "r": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M201.53911,169.53264A104,104,0,0,1,54.46089,22.45443",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "231.99353",
      "x2": "160",
      "y2": "231.99353",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "199.99353",
      "x2": "128",
      "y2": "231.99353",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "95.99316",
      "r": "80"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M207.19629,175.18945A8.00052,8.00052,0,0,0,195.88184,163.875,95.99942,95.99942,0,1,1,60.11816,28.11133,8.00052,8.00052,0,0,0,48.80371,16.79688,112.00314,112.00314,0,0,0,120,207.71v16.2832H96a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16H136V207.71A111.16718,111.16718,0,0,0,207.19629,175.18945Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "95.99353",
      "r": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M201.53911,169.53264A104,104,0,0,1,54.46089,22.45443",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "231.99353",
      "x2": "160",
      "y2": "231.99353",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "199.99353",
      "x2": "128",
      "y2": "231.99353",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "95.99353",
      "r": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M201.53911,169.53264A104,104,0,0,1,54.46089,22.45443",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "231.99353",
      "x2": "160",
      "y2": "231.99353",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "199.99353",
      "x2": "128",
      "y2": "231.99353",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "95.99353",
      "r": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M201.53911,169.53264A104,104,0,0,1,54.46089,22.45443",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "231.99353",
      "x2": "160",
      "y2": "231.99353",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "199.99353",
      "x2": "128",
      "y2": "231.99353",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$70 = [];
/* style */

const __vue_inject_styles__$70 = undefined;
/* scoped */

const __vue_scope_id__$70 = undefined;
/* module identifier */

const __vue_module_identifier__$70 = undefined;
/* functional template */

const __vue_is_functional_template__$70 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$70 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$70,
  staticRenderFns: __vue_staticRenderFns__$70
}, __vue_inject_styles__$70, __vue_script__$70, __vue_scope_id__$70, __vue_is_functional_template__$70, __vue_module_identifier__$70, false, undefined, undefined, undefined);

var script$71 = Vue.extend({
  name: "PhGoogleLogo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$71 = script$71;
/* template */

var __vue_render__$71 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,128h88a88,88,0,1,1-25.77461-62.2254",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,128h88a88,88,0,1,1-25.77461-62.2254",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.11791,104.11791,0,0,0,128,24Zm0,184A80,80,0,1,1,184.56836,71.43164a7.99984,7.99984,0,1,1-11.31348,11.31348A63.99718,63.99718,0,1,0,191.50244,136H128a8,8,0,0,1,0-16h72a8.00008,8.00008,0,0,1,8,8A80.09041,80.09041,0,0,1,128,208Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,128h88a88,88,0,1,1-25.77461-62.2254",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,128h88a88,88,0,1,1-25.77461-62.2254",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,128h88a88,88,0,1,1-25.77461-62.2254",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$71 = [];
/* style */

const __vue_inject_styles__$71 = undefined;
/* scoped */

const __vue_scope_id__$71 = undefined;
/* module identifier */

const __vue_module_identifier__$71 = undefined;
/* functional template */

const __vue_is_functional_template__$71 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$71 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$71,
  staticRenderFns: __vue_staticRenderFns__$71
}, __vue_inject_styles__$71, __vue_script__$71, __vue_scope_id__$71, __vue_is_functional_template__$71, __vue_module_identifier__$71, false, undefined, undefined, undefined);

var script$72 = Vue.extend({
  name: "PhGooglePlayLogo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$72 = script$72;
/* template */

var __vue_render__$72 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M39.8134,224.14386a8.01831,8.01831,0,0,0,12.06378,6.771L219.71391,134.8442a7.763,7.763,0,0,0,0-13.6884L51.87718,25.08518a8.01831,8.01831,0,0,0-12.06378,6.771Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "42.23444",
      "y1": "26.23444",
      "x2": "175.91527",
      "y2": "159.91527",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "42.23498",
      "y1": "229.76502",
      "x2": "175.91497",
      "y2": "96.08503",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M42.23345,26.2334a7.65514,7.65514,0,0,0-2.42,5.62274V224.14386a7.65467,7.65467,0,0,0,2.40789,5.61122l.01369.00994L144,128,42.23444,26.23444Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M39.8134,224.14386a8.01831,8.01831,0,0,0,12.06378,6.771L219.71391,134.8442a7.763,7.763,0,0,0,0-13.6884L51.87718,25.08518a8.01831,8.01831,0,0,0-12.06378,6.771Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "42.23444",
      "y1": "26.23444",
      "x2": "175.91527",
      "y2": "159.91527",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "42.23498",
      "y1": "229.76502",
      "x2": "175.91497",
      "y2": "96.08503",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M223.63476,114.18213l-167.7832-96.04a15.98949,15.98949,0,0,0-16.123.0459,15.66312,15.66312,0,0,0-7.915,13.66846v192.2871a15.66312,15.66312,0,0,0,7.915,13.66846,15.98874,15.98874,0,0,0,16.12305.0459l167.7832-96.04a15.76194,15.76194,0,0,0,0-27.63574ZM144,139.31348l18.85644,18.85644L74.666,208.64746ZM74.65478,47.34082,162.85742,97.8291,144,116.68652ZM177.24707,149.93359,155.31348,128l21.93457-21.93408L215.56738,128Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M39.8134,224.14386a8.01831,8.01831,0,0,0,12.06378,6.771L219.71391,134.8442a7.763,7.763,0,0,0,0-13.6884L51.87718,25.08518a8.01831,8.01831,0,0,0-12.06378,6.771Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "42.23444",
      "y1": "26.23444",
      "x2": "175.91527",
      "y2": "159.91527",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "42.23498",
      "y1": "229.76502",
      "x2": "175.91497",
      "y2": "96.08503",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M39.8134,224.14386a8.01831,8.01831,0,0,0,12.06378,6.771L219.71391,134.8442a7.763,7.763,0,0,0,0-13.6884L51.87718,25.08518a8.01831,8.01831,0,0,0-12.06378,6.771Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "42.23444",
      "y1": "26.23444",
      "x2": "175.91527",
      "y2": "159.91527",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "42.23498",
      "y1": "229.76502",
      "x2": "175.91497",
      "y2": "96.08503",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M39.8134,224.14386a8.01831,8.01831,0,0,0,12.06378,6.771L219.71391,134.8442a7.763,7.763,0,0,0,0-13.6884L51.87718,25.08518a8.01831,8.01831,0,0,0-12.06378,6.771Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "42.23444",
      "y1": "26.23444",
      "x2": "175.91527",
      "y2": "159.91527",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "42.23498",
      "y1": "229.76502",
      "x2": "175.91497",
      "y2": "96.08503",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$72 = [];
/* style */

const __vue_inject_styles__$72 = undefined;
/* scoped */

const __vue_scope_id__$72 = undefined;
/* module identifier */

const __vue_module_identifier__$72 = undefined;
/* functional template */

const __vue_is_functional_template__$72 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$72 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$72,
  staticRenderFns: __vue_staticRenderFns__$72
}, __vue_inject_styles__$72, __vue_script__$72, __vue_scope_id__$72, __vue_is_functional_template__$72, __vue_module_identifier__$72, false, undefined, undefined, undefined);

var script$73 = Vue.extend({
  name: "PhGraduationCap",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$73 = script$73;
/* template */

var __vue_render__$73 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "12 96 128 32 244 96 128 160 12 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "186 240 186 128 128 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,107.03448v58.15691a7.956,7.956,0,0,1-1.86924,5.13972C214.4464,179.42273,183.06948,212,128,212s-86.4464-32.57727-94.13076-41.66889A7.956,7.956,0,0,1,32,165.19139V107.03448",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M36,110.93333v54.5208a7.95694,7.95694,0,0,0,1.58951,4.78692C44.32618,179.20536,72.7471,212,128,212s83.67382-32.79464,90.41049-41.75895A7.95694,7.95694,0,0,0,220,165.45413v-54.5208L128,160Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "8 96 128 32 248 96 128 160 8 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "188 240 188 128 128 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M220,110.93333v54.5208a7.95694,7.95694,0,0,1-1.58951,4.78692C211.67382,179.20536,183.2529,212,128,212s-83.67382-32.79464-90.41049-41.75895A7.95694,7.95694,0,0,1,36,165.45413v-54.5208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M180,209.59229a118.30523,118.30523,0,0,0,16-8.4668V240a8,8,0,0,1-16,0ZM120.94141,92.23535a7.99969,7.99969,0,0,0,3.29394,10.82324L171.00049,128,188,118.93359,131.76465,88.94141A7.99776,7.99776,0,0,0,120.94141,92.23535Zm130.82324-3.29394-120-64a7.99984,7.99984,0,0,0-7.5293,0l-120,64a7.99956,7.99956,0,0,0,0,14.11718L28,115.73315v49.721a16.05975,16.05975,0,0,0,3.19434,9.59326C39.11914,185.59277,69.51953,220,128,220a128.69017,128.69017,0,0,0,52-10.45557V132.7998L171.00049,128,128,150.93359,39.83643,103.91284l-.05713-.03052L25,96,128,41.06641,231,96l-14.7793,7.88232-.05713.03052L188,118.93359l3.76465,2.00782A8.10305,8.10305,0,0,1,196,128v73.06665a110.42518,110.42518,0,0,0,28.80469-26.01831A16.05929,16.05929,0,0,0,228,165.4541v-49.721l23.76465-12.67456a7.99956,7.99956,0,0,0,0-14.11718Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "8 96 128 32 248 96 128 160 8 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "188 240 188 128 128 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M220,110.93333v54.5208a7.95694,7.95694,0,0,1-1.58951,4.78692C211.67382,179.20536,183.2529,212,128,212s-83.67382-32.79464-90.41049-41.75895A7.95694,7.95694,0,0,1,36,165.45413v-54.5208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "8 96 128 32 248 96 128 160 8 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "188 240 188 128 128 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M220,110.93333v54.5208a7.95694,7.95694,0,0,1-1.58951,4.78692C211.67382,179.20536,183.2529,212,128,212s-83.67382-32.79464-90.41049-41.75895A7.95694,7.95694,0,0,1,36,165.45413v-54.5208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "8 96 128 32 248 96 128 160 8 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "188 240 188 128 128 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M220,110.93333v54.5208a7.95694,7.95694,0,0,1-1.58951,4.78692C211.67382,179.20536,183.2529,212,128,212s-83.67382-32.79464-90.41049-41.75895A7.95694,7.95694,0,0,1,36,165.45413v-54.5208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$73 = [];
/* style */

const __vue_inject_styles__$73 = undefined;
/* scoped */

const __vue_scope_id__$73 = undefined;
/* module identifier */

const __vue_module_identifier__$73 = undefined;
/* functional template */

const __vue_is_functional_template__$73 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$73 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$73,
  staticRenderFns: __vue_staticRenderFns__$73
}, __vue_inject_styles__$73, __vue_script__$73, __vue_scope_id__$73, __vue_is_functional_template__$73, __vue_module_identifier__$73, false, undefined, undefined, undefined);

var script$74 = Vue.extend({
  name: "PhGridFour",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$74 = script$74;
/* template */

var __vue_render__$74 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "44",
      "y": "44",
      "width": "168",
      "height": "168",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "44",
      "x2": "128",
      "y2": "212",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "212",
      "y1": "128",
      "x2": "44",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,128H44V52a8,8,0,0,1,8-8h76Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "44",
      "y": "44",
      "width": "168",
      "height": "168",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "44",
      "x2": "128",
      "y2": "212",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "212",
      "y1": "128",
      "x2": "44",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M204,36H52A16.01833,16.01833,0,0,0,36,52V204a16.01833,16.01833,0,0,0,16,16H204a16.01833,16.01833,0,0,0,16-16V52A16.01833,16.01833,0,0,0,204,36Zm.00439,92H128V52h76ZM52,128h76v76H52Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "44",
      "y": "44",
      "width": "168",
      "height": "168",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "44",
      "x2": "128",
      "y2": "212",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "212",
      "y1": "128",
      "x2": "44",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "44",
      "y": "44",
      "width": "168",
      "height": "168",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "44",
      "x2": "128",
      "y2": "212",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "212",
      "y1": "128",
      "x2": "44",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "44",
      "y": "44",
      "width": "168",
      "height": "168",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "44",
      "x2": "128",
      "y2": "212",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "212",
      "y1": "128",
      "x2": "44",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$74 = [];
/* style */

const __vue_inject_styles__$74 = undefined;
/* scoped */

const __vue_scope_id__$74 = undefined;
/* module identifier */

const __vue_module_identifier__$74 = undefined;
/* functional template */

const __vue_is_functional_template__$74 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$74 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$74,
  staticRenderFns: __vue_staticRenderFns__$74
}, __vue_inject_styles__$74, __vue_script__$74, __vue_scope_id__$74, __vue_is_functional_template__$74, __vue_module_identifier__$74, false, undefined, undefined, undefined);

var script$75 = Vue.extend({
  name: "PhHand",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$75 = script$75;
/* template */

var __vue_render__$75 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M168,120V68a20,20,0,0,1,40,0v84a80,80,0,0,1-80,80c-44.18278,0-64-24-96.56854-92.71349a20,20,0,1,1,34.641-20L88,157.26608V52a20,20,0,0,1,40,0v68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,120V36a20,20,0,0,0-40,0v84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,52V36a20,20,0,0,1,40,0V68a20,20,0,0,1,40,0v84a80,80,0,0,1-80,80c-44.18278,0-64-24-96.56854-92.71349a20,20,0,1,1,34.641-20L88,157.26608V52a20,20,0,0,1,40,0Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,120V68a20,20,0,0,1,40,0v84a80,80,0,0,1-80,80c-44.18278,0-64-24-96.56854-92.71349a20,20,0,1,1,34.641-20L88,157.26608V52a20,20,0,0,1,40,0v68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,120V36a20,20,0,0,0-40,0v84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M188,40a27.82979,27.82979,0,0,0-12,2.707V36a27.99792,27.99792,0,0,0-54.64209-8.60278A27.992,27.992,0,0,0,80,52v75.41016l-6.999-12.12354a28.00028,28.00028,0,0,0-48.6709,27.69629C56.77832,211.39941,78.39355,240,128,240a88.09957,88.09957,0,0,0,88-88V68A28.03146,28.03146,0,0,0,188,40Zm12,112a72.08124,72.08124,0,0,1-72,72c-20.17871,0-34.22656-5.45459-46.97461-18.23828-12.499-12.53369-24.77246-32.78565-42.36426-69.90137q-.13916-.293-.30175-.57422a12.00011,12.00011,0,0,1,20.78515-11.99951l21.92774,37.97949a7.9997,7.9997,0,0,0,14.92773-4V52a12,12,0,0,1,24,0v68a8,8,0,0,0,16,0V36a12,12,0,0,1,24,0v84a8,8,0,0,0,16,0V68a12,12,0,0,1,24,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M168,120V68a20,20,0,0,1,40,0v84a80,80,0,0,1-80,80c-44.18278,0-64-24-96.56854-92.71349a20,20,0,1,1,34.641-20L88,157.26608V52a20,20,0,0,1,40,0v68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,120V36a20,20,0,0,0-40,0v84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M168,120V68a20,20,0,0,1,40,0v84a80,80,0,0,1-80,80c-44.18278,0-64-24-96.56854-92.71349a20,20,0,1,1,34.641-20L88,157.26608V52a20,20,0,0,1,40,0v68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,120V36a20,20,0,0,0-40,0v84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M168,120V68a20,20,0,0,1,40,0v84a80,80,0,0,1-80,80c-44.18278,0-64-24-96.56854-92.71349a20,20,0,1,1,34.641-20L88,157.26608V52a20,20,0,0,1,40,0v68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,120V36a20,20,0,0,0-40,0v84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$75 = [];
/* style */

const __vue_inject_styles__$75 = undefined;
/* scoped */

const __vue_scope_id__$75 = undefined;
/* module identifier */

const __vue_module_identifier__$75 = undefined;
/* functional template */

const __vue_is_functional_template__$75 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$75 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$75,
  staticRenderFns: __vue_staticRenderFns__$75
}, __vue_inject_styles__$75, __vue_script__$75, __vue_scope_id__$75, __vue_is_functional_template__$75, __vue_module_identifier__$75, false, undefined, undefined, undefined);

var script$76 = Vue.extend({
  name: "PhHandFist",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$76 = script$76;
/* template */

var __vue_render__$76 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,104a24,24,0,0,1-48,0V64a24,24,0,0,1,48,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,64a24,24,0,0,1,48,0V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,176a40,40,0,0,1,40-40H152a24,24,0,0,1-24-24V96a8,8,0,0,1,8-8h64a24,24,0,0,1,24,24v16a96,96,0,0,1-192,0V88a24,24,0,0,1,48,0v16a24,24,0,0,1-48,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,64a24,24,0,0,1,48,0V88h24a24,24,0,0,1,24,24v16a96,96,0,0,1-192,0V88a24,24,0,0,1,48,0V64a24,24,0,0,1,48,0",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,104a24,24,0,0,1-48,0V64a24,24,0,0,1,48,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,64a24,24,0,0,1,48,0V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,176a40,40,0,0,1,40-40H152a24,24,0,0,1-24-24V96a8,8,0,0,1,8-8h64a24,24,0,0,1,24,24v16a96,96,0,0,1-192,0V88a24,24,0,0,1,48,0v16a24,24,0,0,1-48,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,80H184V64a31.97943,31.97943,0,0,0-56-21.13208A31.97443,31.97443,0,0,0,72.20508,60.4231,31.978,31.978,0,0,0,24,88v40a104,104,0,0,0,208,0V112A32.03635,32.03635,0,0,0,200,80ZM152,48a16.01833,16.01833,0,0,1,16,16V80H136V64A16.01833,16.01833,0,0,1,152,48ZM88,64a16,16,0,0,1,32,0v40a16,16,0,0,1-32,0V64ZM40,88a16,16,0,0,1,32,0v16a16,16,0,0,1-32,0Zm88,128a88.10627,88.10627,0,0,1-87.9209-84.249A31.94065,31.94065,0,0,0,80,125.13208a31.92587,31.92587,0,0,0,44.58057,3.34595,32.23527,32.23527,0,0,0,11.79443,11.4414A47.906,47.906,0,0,0,120,176a8,8,0,0,0,16,0,32.03635,32.03635,0,0,1,32-32,8,8,0,0,0,0-16H152a16.01833,16.01833,0,0,1-16-16V96h64a16.01833,16.01833,0,0,1,16,16v16A88.09957,88.09957,0,0,1,128,216Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,104a24,24,0,0,1-48,0V64a24,24,0,0,1,48,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,64a24,24,0,0,1,48,0V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,176a40,40,0,0,1,40-40H152a24,24,0,0,1-24-24V96a8,8,0,0,1,8-8h64a24,24,0,0,1,24,24v16a96,96,0,0,1-192,0V88a24,24,0,0,1,48,0v16a24,24,0,0,1-48,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,104a24,24,0,0,1-48,0V64a24,24,0,0,1,48,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,64a24,24,0,0,1,48,0V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,176a40,40,0,0,1,40-40H152a24,24,0,0,1-24-24V96a8,8,0,0,1,8-8h64a24,24,0,0,1,24,24v16a96,96,0,0,1-192,0V88a24,24,0,0,1,48,0v16a24,24,0,0,1-48,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,104a24,24,0,0,1-48,0V64a24,24,0,0,1,48,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,64a24,24,0,0,1,48,0V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,176a40,40,0,0,1,40-40H152a24,24,0,0,1-24-24V96a8,8,0,0,1,8-8h64a24,24,0,0,1,24,24v16a96,96,0,0,1-192,0V88a24,24,0,0,1,48,0v16a24,24,0,0,1-48,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$76 = [];
/* style */

const __vue_inject_styles__$76 = undefined;
/* scoped */

const __vue_scope_id__$76 = undefined;
/* module identifier */

const __vue_module_identifier__$76 = undefined;
/* functional template */

const __vue_is_functional_template__$76 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$76 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$76,
  staticRenderFns: __vue_staticRenderFns__$76
}, __vue_inject_styles__$76, __vue_script__$76, __vue_scope_id__$76, __vue_is_functional_template__$76, __vue_module_identifier__$76, false, undefined, undefined, undefined);

var script$77 = Vue.extend({
  name: "PhHandGrabbing",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$77 = script$77;
/* template */

var __vue_render__$77 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,124V92a20,20,0,0,0-40,0v56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,124V92a20,20,0,0,0-40,0v32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,148V116H68a20,20,0,0,0-20,20v16a80,80,0,0,0,160,0V108a20,20,0,0,0-40,0v16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M88,116H68a20,20,0,0,0-20,20v16a80,80,0,0,0,160,0V108a20,20,0,0,0-40,0V92a20,20,0,0,0-40,0,20,20,0,0,0-40,0Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,124V92a20,20,0,0,0-40,0v56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,124V92a20,20,0,0,0-40,0v32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,148V116H68a20,20,0,0,0-20,20v16a80,80,0,0,0,160,0V108a20,20,0,0,0-40,0v16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M188,80a27.82885,27.82885,0,0,0-13.35791,3.39716A27.97426,27.97426,0,0,0,128,72.43066,27.9817,27.9817,0,0,0,80,92v16H68a28.03146,28.03146,0,0,0-28,28v16a88,88,0,0,0,176,0V108A28.03146,28.03146,0,0,0,188,80Zm12,72a72,72,0,0,1-144,0V136a12.01343,12.01343,0,0,1,12-12H80v24a8,8,0,0,0,16,0V92a12,12,0,0,1,24,0v32a8,8,0,0,0,16,0V92a12,12,0,0,1,24,0v32a8,8,0,0,0,16,0V108a12,12,0,0,1,24,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,124V92a20,20,0,0,0-40,0v56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,124V92a20,20,0,0,0-40,0v32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,148V116H68a20,20,0,0,0-20,20v16a80,80,0,0,0,160,0V108a20,20,0,0,0-40,0v16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,124V92a20,20,0,0,0-40,0v56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,124V92a20,20,0,0,0-40,0v32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,148V116H68a20,20,0,0,0-20,20v16a80,80,0,0,0,160,0V108a20,20,0,0,0-40,0v16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,124V92a20,20,0,0,0-40,0v56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,124V92a20,20,0,0,0-40,0v32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,148V116H68a20,20,0,0,0-20,20v16a80,80,0,0,0,160,0V108a20,20,0,0,0-40,0v16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$77 = [];
/* style */

const __vue_inject_styles__$77 = undefined;
/* scoped */

const __vue_scope_id__$77 = undefined;
/* module identifier */

const __vue_module_identifier__$77 = undefined;
/* functional template */

const __vue_is_functional_template__$77 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$77 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$77,
  staticRenderFns: __vue_staticRenderFns__$77
}, __vue_inject_styles__$77, __vue_script__$77, __vue_scope_id__$77, __vue_is_functional_template__$77, __vue_module_identifier__$77, false, undefined, undefined, undefined);

var script$78 = Vue.extend({
  name: "PhHandPalm",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$78 = script$78;
/* template */

var __vue_render__$78 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,104V52a20,20,0,0,1,40,0v80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,112V36a20,20,0,0,1,40,0v68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,172a40,40,0,0,1,40-40V112a20,20,0,0,1,40,0v40a80,80,0,0,1-160,0V68a20,20,0,0,1,40,0v44",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M168,112a20,20,0,0,1,40,0v40a80,80,0,0,1-160,0V68a20,20,0,0,1,40,0V36a20,20,0,0,1,40,0V52a20,20,0,0,1,40,0Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,104V52a20,20,0,0,1,40,0v80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,112V36a20,20,0,0,1,40,0v68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,172a40,40,0,0,1,40-40V112a20,20,0,0,1,40,0v40a80,80,0,0,1-160,0V68a20,20,0,0,1,40,0v44",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M188,84a27.83152,27.83152,0,0,0-12,2.707V52a27.992,27.992,0,0,0-41.35791-24.60278A27.99792,27.99792,0,0,0,80,36v6.707A27.991,27.991,0,0,0,40,68v84a88,88,0,0,0,176,0V112A28.03146,28.03146,0,0,0,188,84Zm12,68a72,72,0,0,1-144,0V68a12,12,0,0,1,24,0v44a8,8,0,0,0,16,0V36a12,12,0,0,1,24,0v68a8,8,0,0,0,16,0V52a12,12,0,0,1,24,0v72.6665A48.07871,48.07871,0,0,0,120,172a8,8,0,0,0,16,0,32.03635,32.03635,0,0,1,32-32,8.00008,8.00008,0,0,0,8-8V112a12,12,0,0,1,24,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,104V52a20,20,0,0,1,40,0v80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,112V36a20,20,0,0,1,40,0v68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,172a40,40,0,0,1,40-40V112a20,20,0,0,1,40,0v40a80,80,0,0,1-160,0V68a20,20,0,0,1,40,0v44",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,104V52a20,20,0,0,1,40,0v80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,112V36a20,20,0,0,1,40,0v68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,172a40,40,0,0,1,40-40V112a20,20,0,0,1,40,0v40a80,80,0,0,1-160,0V68a20,20,0,0,1,40,0v44",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,104V52a20,20,0,0,1,40,0v80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,112V36a20,20,0,0,1,40,0v68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,172a40,40,0,0,1,40-40V112a20,20,0,0,1,40,0v40a80,80,0,0,1-160,0V68a20,20,0,0,1,40,0v44",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$78 = [];
/* style */

const __vue_inject_styles__$78 = undefined;
/* scoped */

const __vue_scope_id__$78 = undefined;
/* module identifier */

const __vue_module_identifier__$78 = undefined;
/* functional template */

const __vue_is_functional_template__$78 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$78 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$78,
  staticRenderFns: __vue_staticRenderFns__$78
}, __vue_inject_styles__$78, __vue_script__$78, __vue_scope_id__$78, __vue_is_functional_template__$78, __vue_module_identifier__$78, false, undefined, undefined, undefined);

var script$79 = Vue.extend({
  name: "PhHandPointing",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$79 = script$79;
/* template */

var __vue_render__$79 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,104V36a20,20,0,0,0-40,0V157.26608L66.07247,119.28651a20,20,0,1,0-34.641,20C64,208,83.81722,232,128,232a80,80,0,0,0,80-80V112a20,20,0,0,0-40,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,112V100a20,20,0,0,0-40,0v4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M168,112V100a20,20,0,0,0-40,0V36a20,20,0,0,0-40,0V157.26608L66.07247,119.28651a20,20,0,1,0-34.641,20C64,208,83.81722,232,128,232a80,80,0,0,0,80-80V112a20,20,0,0,0-40,0Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,104V36a20,20,0,0,0-40,0V157.26608L66.07247,119.28651a20,20,0,1,0-34.641,20C64,208,83.81722,232,128,232a80,80,0,0,0,80-80V112a20,20,0,0,0-40,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,112V100a20,20,0,0,0-40,0v4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M188,84a27.82842,27.82842,0,0,0-14.6416,4.145A27.97776,27.97776,0,0,0,136,74.707V36a28,28,0,0,0-56,0v91.41016l-6.999-12.12354a28.00028,28.00028,0,0,0-48.6709,27.69629C56.77832,211.39941,78.39355,240,128,240a88.09957,88.09957,0,0,0,88-88V112A28.03146,28.03146,0,0,0,188,84Zm12,68a72.08124,72.08124,0,0,1-72,72c-20.17871,0-34.22656-5.45459-46.97461-18.23828-12.499-12.53369-24.77246-32.78565-42.36426-69.90137q-.13916-.293-.30175-.57422a12.00011,12.00011,0,0,1,20.78515-11.99951l21.92774,37.97949a7.9997,7.9997,0,0,0,14.92773-4V36a12,12,0,0,1,24,0v68a8,8,0,0,0,16,0v-4a12,12,0,0,1,24,0v12a8,8,0,0,0,16,0,12,12,0,0,1,24,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,104V36a20,20,0,0,0-40,0V157.26608L66.07247,119.28651a20,20,0,1,0-34.641,20C64,208,83.81722,232,128,232a80,80,0,0,0,80-80V112a20,20,0,0,0-40,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,112V100a20,20,0,0,0-40,0v4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,104V36a20,20,0,0,0-40,0V157.26608L66.07247,119.28651a20,20,0,1,0-34.641,20C64,208,83.81722,232,128,232a80,80,0,0,0,80-80V112a20,20,0,0,0-40,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,112V100a20,20,0,0,0-40,0v4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,104V36a20,20,0,0,0-40,0V157.26608L66.07247,119.28651a20,20,0,1,0-34.641,20C64,208,83.81722,232,128,232a80,80,0,0,0,80-80V112a20,20,0,0,0-40,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,112V100a20,20,0,0,0-40,0v4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$79 = [];
/* style */

const __vue_inject_styles__$79 = undefined;
/* scoped */

const __vue_scope_id__$79 = undefined;
/* module identifier */

const __vue_module_identifier__$79 = undefined;
/* functional template */

const __vue_is_functional_template__$79 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$79 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$79,
  staticRenderFns: __vue_staticRenderFns__$79
}, __vue_inject_styles__$79, __vue_script__$79, __vue_scope_id__$79, __vue_is_functional_template__$79, __vue_module_identifier__$79, false, undefined, undefined, undefined);

var script$7a = Vue.extend({
  name: "PhHandSoap",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7a = script$7a;
/* template */

var __vue_render__$7a = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,108h96a32,32,0,0,1,32,32v76a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V140A32,32,0,0,1,80,108Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,108V92a24,24,0,0,1,24-24h48a24,24,0,0,1,24,24v16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,40a16,16,0,0,0-16-16H104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "24",
      "x2": "128",
      "y2": "68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,104h96a32,32,0,0,1,32,32v80a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V136A32,32,0,0,1,80,104Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,104h96a32,32,0,0,1,32,32v80a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V136A32,32,0,0,1,80,104Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,104V88a24,24,0,0,1,24-24h48a24,24,0,0,1,24,24v16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,40a16,16,0,0,0-16-16H104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "24",
      "x2": "128",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M184,96.80469V88a32.03667,32.03667,0,0,0-32-32H136V32h32a8.00917,8.00917,0,0,1,8,8,8,8,0,0,0,16,0,24.0275,24.0275,0,0,0-24-24H104a8,8,0,0,0,0,16h16V56H104A32.03667,32.03667,0,0,0,72,88v8.80469A40.06815,40.06815,0,0,0,40,136v80a16.01833,16.01833,0,0,0,16,16H200a16.01833,16.01833,0,0,0,16-16V136A40.06815,40.06815,0,0,0,184,96.80469ZM104,72h48a16.01833,16.01833,0,0,1,16,16v8H88V88A16.01833,16.01833,0,0,1,104,72Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,104h96a32,32,0,0,1,32,32v80a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V136A32,32,0,0,1,80,104Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,104V88a24,24,0,0,1,24-24h48a24,24,0,0,1,24,24v16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,40a16,16,0,0,0-16-16H104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "24",
      "x2": "128",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,104h96a32,32,0,0,1,32,32v80a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V136A32,32,0,0,1,80,104Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,104V88a24,24,0,0,1,24-24h48a24,24,0,0,1,24,24v16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,40a16,16,0,0,0-16-16H104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "24",
      "x2": "128",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,104h96a32,32,0,0,1,32,32v80a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V136A32,32,0,0,1,80,104Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,104V88a24,24,0,0,1,24-24h48a24,24,0,0,1,24,24v16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,40a16,16,0,0,0-16-16H104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "24",
      "x2": "128",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7a = [];
/* style */

const __vue_inject_styles__$7a = undefined;
/* scoped */

const __vue_scope_id__$7a = undefined;
/* module identifier */

const __vue_module_identifier__$7a = undefined;
/* functional template */

const __vue_is_functional_template__$7a = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7a = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7a,
  staticRenderFns: __vue_staticRenderFns__$7a
}, __vue_inject_styles__$7a, __vue_script__$7a, __vue_scope_id__$7a, __vue_is_functional_template__$7a, __vue_module_identifier__$7a, false, undefined, undefined, undefined);

var script$7b = Vue.extend({
  name: "PhHandWaving",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7b = script$7b;
/* template */

var __vue_render__$7b = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M119.99332,106.41921l-26-45.03332a20,20,0,0,1,34.641-20l40,69.282",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M89.35231,133.34742l-38-65.81793a20,20,0,1,1,34.641-20l34,58.88972",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M153.99332,165.30894a40,40,0,0,1,14.641-54.641l-10-17.32051a20,20,0,1,1,34.641-20l20,34.641a80,80,0,1,1-138.56406,80l-42-72.74613a20,20,0,0,1,34.641-20l22,38.10512",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,22.99A59.97614,59.97614,0,0,1,227.96152,53",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M66.93521,240.00025A119.74962,119.74962,0,0,1,40.0943,207.99",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M158.63434,93.34742a20,20,0,1,1,34.641-20l20,34.641a80,80,0,1,1-138.56406,80l-42-72.74613a20,20,0,0,1,34.641-20l-16-27.71281a20,20,0,1,1,34.641-20l8,13.8564a20,20,0,0,1,34.641-20Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M119.99332,106.41921l-26-45.03332a20,20,0,0,1,34.641-20l40,69.282",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M89.35231,133.34742l-38-65.81793a20,20,0,1,1,34.641-20l34,58.88972",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M153.99332,165.30894a40,40,0,0,1,14.641-54.641l-10-17.32051a20,20,0,1,1,34.641-20l20,34.641a80,80,0,1,1-138.56406,80l-42-72.74613a20,20,0,0,1,34.641-20l22,38.10512",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M81.09415,240.0027A111.54975,111.54975,0,0,1,48,203.99065",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,31A51.97065,51.97065,0,0,1,221.0258,57.00434",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M220.20312,103.98828l-19.999-34.64062a28.02682,28.02682,0,0,0-47.29834-1.92243l-17.34326-30.04a27.99212,27.99212,0,0,0-48.11328-.63549A28.003,28.003,0,0,0,44.4248,71.5293l3.35352,5.80877A27.991,27.991,0,0,0,25.7832,119.24219l42,72.74609a87.99976,87.99976,0,1,0,152.41992-88ZM213.54,166.62354A72,72,0,0,1,81.63965,183.98828l-42-72.7456A11.99994,11.99994,0,0,1,60.42383,99.24219l22,38.10547a8.01625,8.01625,0,0,0,.55566.82623c.05274.07.1084.13617.16309.204q.23657.2926.4956.5578c.0586.0603.11621.12207.17627.1803a8.00346,8.00346,0,0,0,.72412.62359l.01758.012a8.0088,8.0088,0,0,0,.76807.50262c.07519.04346.15088.08325.22705.12421q.31714.17148.64844.313c.07373.03149.1455.06524.22021.09454a8.05256,8.05256,0,0,0,.88867.29571c.01953.00519.03955.00782.05909.01288a8.05171,8.05171,0,0,0,.85449.16712c.08545.01226.1709.02105.25683.03058q.36036.03992.72412.04675c.05274.001.1045.01019.15723.01019.02539,0,.05127-.0047.07666-.00494a7.94421,7.94421,0,0,0,.93018-.05963c.0249-.00318.0498-.00965.0747-.01307a7.93311,7.93311,0,0,0,.84131-.16473c.08985-.0224.17823-.049.26758-.07465q.33692-.09659.66748-.22454c.08692-.03351.17383-.06482.26026-.10157a7.95946,7.95946,0,0,0,3.80175-11.35833l-22-38.106-.00293-.00519L58.28027,63.52881A12.00012,12.00012,0,0,1,79.06543,51.5293l7.9834,13.82818.01562.02826,26,45.03369a8,8,0,1,0,13.85645-8l-25.999-45.03369a12.00023,12.00023,0,1,1,20.78515-12l29.99756,51.95752.00244.0044,6.3291,10.96338a48.025,48.025,0,0,0-10.9707,60.998,7.99959,7.99959,0,1,0,13.85547-8,32.00043,32.00043,0,0,1,11.71387-43.71289,7.96868,7.96868,0,0,0,.66992-.43329c.18017-.12921.34961-.26849.51562-.41009.03174-.02692.06641-.05048.09766-.07788.19092-.16761.37109-.344.543-.52668l.01611-.01586q.25928-.27687.48779-.575l.01758-.02087c.14453-.1886.27783-.384.4043-.5835.01318-.021.02832-.0404.0415-.06152.11377-.18286.21533-.37158.31348-.5622.022-.04248.04736-.08258.06885-.12548.0874-.17847.16308-.36206.2373-.54621.02344-.05877.05225-.115.07471-.17444.08056-.215.14892-.43408.21094-.655.0083-.03028.0205-.059.0288-.08942.00782-.02966.01172-.05988.01954-.0896.05664-.22278.10742-.44714.145-.67419.01171-.06977.01513-.14.0249-.2099.02636-.18915.05224-.3783.06494-.56922.00391-.05823.00146-.11633.00391-.17456.00927-.20325.01611-.40661.00976-.61078-.00146-.03888-.00732-.07739-.00879-.11621-.01025-.2218-.02588-.44366-.05469-.66522-.00341-.02515-.00976-.04981-.01318-.07489-.03271-.23193-.07275-.46344-.126-.69373-.00683-.02783-.0166-.05481-.02294-.08252-.05469-.22387-.11573-.4469-.19043-.66772-.022-.06525-.05127-.12811-.0752-.19281-.06641-.18012-.13184-.36029-.21191-.53735a7.98085,7.98085,0,0,0-.36475-.7121l-10-17.3208a12.00012,12.00012,0,0,1,20.78516-11.99951l20,34.64062A71.53255,71.53255,0,0,1,213.54,166.62354ZM87.668,244.56152a7.999,7.999,0,0,1-11.13281,2.01563,118.949,118.949,0,0,1-35.46289-38.58643,7.99959,7.99959,0,1,1,13.85546-8,103.08083,103.08083,0,0,0,30.72461,33.438A8.00009,8.00009,0,0,1,87.668,244.56152ZM168,30.99268A8.00009,8.00009,0,0,1,176,23h.00781A60.21143,60.21143,0,0,1,227.9541,53.00439a8.00044,8.00044,0,1,1-13.85742,8A44.16357,44.16357,0,0,0,175.99219,39,8,8,0,0,1,168,30.99268Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M119.99332,106.41921l-26-45.03332a20,20,0,0,1,34.641-20l40,69.282",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M89.35231,133.34742l-38-65.81793a20,20,0,1,1,34.641-20l34,58.88972",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M153.99332,165.30894a40,40,0,0,1,14.641-54.641l-10-17.32051a20,20,0,1,1,34.641-20l20,34.641a80,80,0,1,1-138.56406,80l-42-72.74613a20,20,0,0,1,34.641-20l22,38.10512",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M81.09415,240.0027A111.54975,111.54975,0,0,1,48,203.99065",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,31A51.97065,51.97065,0,0,1,221.0258,57.00434",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M119.99332,106.41921l-26-45.03332a20,20,0,0,1,34.641-20l40,69.282",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M89.35231,133.34742l-38-65.81793a20,20,0,1,1,34.641-20l34,58.88972",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M153.99332,165.30894a40,40,0,0,1,14.641-54.641l-10-17.32051a20,20,0,1,1,34.641-20l20,34.641a80,80,0,1,1-138.56406,80l-42-72.74613a20,20,0,0,1,34.641-20l22,38.10512",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M81.09415,240.0027A111.54975,111.54975,0,0,1,48,203.99065",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,31A51.97065,51.97065,0,0,1,221.0258,57.00434",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M119.99332,106.41921l-26-45.03332a20,20,0,0,1,34.641-20l40,69.282",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M89.35231,133.34742l-38-65.81793a20,20,0,1,1,34.641-20l34,58.88972",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M153.99332,165.30894a40,40,0,0,1,14.641-54.641l-10-17.32051a20,20,0,1,1,34.641-20l20,34.641a80,80,0,1,1-138.56406,80l-42-72.74613a20,20,0,0,1,34.641-20l22,38.10512",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M81.09415,240.0027A111.54975,111.54975,0,0,1,48,203.99065",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,31A51.97065,51.97065,0,0,1,221.0258,57.00434",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7b = [];
/* style */

const __vue_inject_styles__$7b = undefined;
/* scoped */

const __vue_scope_id__$7b = undefined;
/* module identifier */

const __vue_module_identifier__$7b = undefined;
/* functional template */

const __vue_is_functional_template__$7b = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7b = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7b,
  staticRenderFns: __vue_staticRenderFns__$7b
}, __vue_inject_styles__$7b, __vue_script__$7b, __vue_scope_id__$7b, __vue_is_functional_template__$7b, __vue_module_identifier__$7b, false, undefined, undefined, undefined);

var script$7c = Vue.extend({
  name: "PhHandbag",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7c = script$7c;
/* template */

var __vue_render__$7c = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208.83966,72H47.16034a8,8,0,0,0-7.95107,7.11655l-14.22222,128A8,8,0,0,0,32.93812,216H223.06188a8,8,0,0,0,7.95107-8.88345l-14.22222-128A8,8,0,0,0,208.83966,72Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,104V72a40,40,0,0,1,80,0v32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208.83966,72H47.16034a8,8,0,0,0-7.95107,7.11655l-14.22222,128A8,8,0,0,0,32.93812,216H223.06188a8,8,0,0,0,7.95107-8.88345l-14.22222-128A8,8,0,0,0,208.83966,72Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208.83966,72H47.16034a8,8,0,0,0-7.95107,7.11655l-14.22222,128A8,8,0,0,0,32.93812,216H223.06188a8,8,0,0,0,7.95107-8.88345l-14.22222-128A8,8,0,0,0,208.83966,72Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,104V72a40,40,0,0,1,80,0v32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M238.96387,206.2334,224.74219,78.23291A15.98372,15.98372,0,0,0,208.83984,64h-33.519a47.99073,47.99073,0,0,0-94.6416,0h-33.519A15.98375,15.98375,0,0,0,31.25781,78.2334l-14.22168,128A16.00031,16.00031,0,0,0,32.93848,224h190.123a16.00031,16.00031,0,0,0,15.90235-17.7666ZM95.99219,104a8,8,0,0,1-16,0V88a8,8,0,0,1,16,0ZM97.0127,64a32.00443,32.00443,0,0,1,61.9746,0Zm78.97949,40a8,8,0,0,1-16,0V88a8,8,0,0,1,16,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208.83966,72H47.16034a8,8,0,0,0-7.95107,7.11655l-14.22222,128A8,8,0,0,0,32.93812,216H223.06188a8,8,0,0,0,7.95107-8.88345l-14.22222-128A8,8,0,0,0,208.83966,72Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,104V72a40,40,0,0,1,80,0v32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208.83966,72H47.16034a8,8,0,0,0-7.95107,7.11655l-14.22222,128A8,8,0,0,0,32.93812,216H223.06188a8,8,0,0,0,7.95107-8.88345l-14.22222-128A8,8,0,0,0,208.83966,72Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,104V72a40,40,0,0,1,80,0v32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208.83966,72H47.16034a8,8,0,0,0-7.95107,7.11655l-14.22222,128A8,8,0,0,0,32.93812,216H223.06188a8,8,0,0,0,7.95107-8.88345l-14.22222-128A8,8,0,0,0,208.83966,72Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,104V72a40,40,0,0,1,80,0v32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7c = [];
/* style */

const __vue_inject_styles__$7c = undefined;
/* scoped */

const __vue_scope_id__$7c = undefined;
/* module identifier */

const __vue_module_identifier__$7c = undefined;
/* functional template */

const __vue_is_functional_template__$7c = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7c = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7c,
  staticRenderFns: __vue_staticRenderFns__$7c
}, __vue_inject_styles__$7c, __vue_script__$7c, __vue_scope_id__$7c, __vue_is_functional_template__$7c, __vue_module_identifier__$7c, false, undefined, undefined, undefined);

var script$7d = Vue.extend({
  name: "PhHandbagSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7d = script$7d;
/* template */

var __vue_render__$7d = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208.83966,72H47.16034a8,8,0,0,0-7.95107,7.11655l-14.22222,128A8,8,0,0,0,32.93812,216H223.06188a8,8,0,0,0,7.95107-8.88345l-14.22222-128A8,8,0,0,0,208.83966,72Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,72a40,40,0,0,1,80,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208.83966,72H47.16034a8,8,0,0,0-7.95107,7.11655l-14.22222,128A8,8,0,0,0,32.93812,216H223.06188a8,8,0,0,0,7.95107-8.88345l-14.22222-128A8,8,0,0,0,208.83966,72Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208.83966,72H47.16034a8,8,0,0,0-7.95107,7.11655l-14.22222,128A8,8,0,0,0,32.93812,216H223.06188a8,8,0,0,0,7.95107-8.88345l-14.22222-128A8,8,0,0,0,208.83966,72Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,72a40,40,0,0,1,80,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M238.96387,206.2334,224.74219,78.23291A15.98372,15.98372,0,0,0,208.83984,64h-33.519a47.99073,47.99073,0,0,0-94.6416,0h-33.519A15.98375,15.98375,0,0,0,31.25781,78.2334l-14.22168,128A16.00031,16.00031,0,0,0,32.93848,224h190.123a16.00031,16.00031,0,0,0,15.90235-17.7666ZM128,40a32.05773,32.05773,0,0,1,30.9873,24H97.0127A32.05773,32.05773,0,0,1,128,40Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208.83966,72H47.16034a8,8,0,0,0-7.95107,7.11655l-14.22222,128A8,8,0,0,0,32.93812,216H223.06188a8,8,0,0,0,7.95107-8.88345l-14.22222-128A8,8,0,0,0,208.83966,72Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,72a40,40,0,0,1,80,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208.83966,72H47.16034a8,8,0,0,0-7.95107,7.11655l-14.22222,128A8,8,0,0,0,32.93812,216H223.06188a8,8,0,0,0,7.95107-8.88345l-14.22222-128A8,8,0,0,0,208.83966,72Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,72a40,40,0,0,1,80,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208.83966,72H47.16034a8,8,0,0,0-7.95107,7.11655l-14.22222,128A8,8,0,0,0,32.93812,216H223.06188a8,8,0,0,0,7.95107-8.88345l-14.22222-128A8,8,0,0,0,208.83966,72Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,72a40,40,0,0,1,80,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7d = [];
/* style */

const __vue_inject_styles__$7d = undefined;
/* scoped */

const __vue_scope_id__$7d = undefined;
/* module identifier */

const __vue_module_identifier__$7d = undefined;
/* functional template */

const __vue_is_functional_template__$7d = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7d = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7d,
  staticRenderFns: __vue_staticRenderFns__$7d
}, __vue_inject_styles__$7d, __vue_script__$7d, __vue_scope_id__$7d, __vue_is_functional_template__$7d, __vue_module_identifier__$7d, false, undefined, undefined, undefined);

var script$7e = Vue.extend({
  name: "PhHandsClapping",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7e = script$7e;
/* template */

var __vue_render__$7e = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M111.99332,114.41921l-26-45.03332a20,20,0,0,1,34.641-20l40,69.282",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M85.35231,148.27562l-42-72.74613a20,20,0,1,1,34.641-20l42,72.74613",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168.63434,132.52433l-18-31.17691a20,20,0,1,1,34.641-20l20,34.641a80,80,0,1,1-138.56406,80l-42-72.74613a20,20,0,0,1,34.641-20l22,38.10512",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]), _vm._v(" "), _c('g', [_c('line', {
    attrs: {
      "x1": "156",
      "y1": "12",
      "x2": "156",
      "y2": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "204",
      "y1": "24.86156",
      "x2": "196",
      "y2": "38.71797",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "239.13844",
      "y1": "60",
      "x2": "225.28203",
      "y2": "68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })])]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M76.988,93.50979l-8-13.8564a17.92489,17.92489,0,0,0-9.12085-7.79857l-.00017.00051L57.52388,67.797a18,18,0,1,1,31.17691-18L99.04433,67.71252l.0004-.001A18.00053,18.00053,0,0,0,76.988,93.50979",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M156.22214,94.745a18.00053,18.00053,0,0,0-22.05725,25.79811l-26-45.03332a17.92489,17.92489,0,0,0-9.12016-7.7983l-.0004.001-2.34352-4.0591a18,18,0,1,1,31.1769-18l28.3439,49.09309Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M153.87771,90.68671a18,18,0,1,1,31.17691-18l17,29.44486a72.02623,72.02623,0,0,1-14.0179,89.38343l.00006,0a71.83347,71.83347,0,0,0-5.695-59.527l-17-29.44487a17.925,17.925,0,0,0-9.11967-7.79811l-.00053.00148Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M51.81106,121.9021a18,18,0,1,0-31.17691,18l37,64.08588a72,72,0,0,0,124.70766-72l-17-29.44487a18,18,0,0,0-31.17692,18",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M106.988,145.47132l-38-65.81793a18,18,0,0,0-31.17692,18l38,65.81793",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M150.16489,148.25593l-42-72.74614a18,18,0,0,0-31.17691,18",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M99.04433,67.71252,88.70079,49.797a18,18,0,1,0-31.17691,18L59.867,71.85533",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M188.03672,191.515a72.02623,72.02623,0,0,0,14.0179-89.38343l-17-29.44486a18,18,0,1,0-31.17691,18",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M156.22161,94.74648l-28.3439-49.09309a18,18,0,0,0-31.17692,18",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176.84663",
      "y1": "11.27112",
      "x2": "172.70552",
      "y2": "26.72593",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "207.06334",
      "y1": "25.3614",
      "x2": "197.88611",
      "y2": "38.46784",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "230.6386",
      "y1": "48.93666",
      "x2": "217.53216",
      "y2": "58.11389",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M190.251,69.68652a23.9764,23.9764,0,0,0-41.56055.01514L133.07422,42.65332a23.97141,23.97141,0,0,0-41.8042.45459A24.00171,24.00171,0,0,0,49.90137,64.916a23.98424,23.98424,0,0,0-17.28614,35.7373L36.23,106.91455A23.98051,23.98051,0,0,0,15.4375,142.90234l37,64.08594a77.99184,77.99184,0,0,0,140.75391-12.09082A78.372,78.372,0,0,0,207.251,99.13184Zm-37.2627,155.459a66.077,66.077,0,0,1-90.1582-24.15723l-37-64.08594a12.00023,12.00023,0,0,1,20.78515-12l.001.00122,23.999,41.56812a6.00012,6.00012,0,1,0,10.39258-6l-38-65.81836a11.99981,11.99981,0,1,1,20.78418-12l38,65.81836a6.00012,6.00012,0,0,0,10.39258-6l-30-51.96143v-.00048a11.99981,11.99981,0,1,1,20.78418-12l42,72.74609a6.00012,6.00012,0,0,0,10.39258-6L139.36182,117.5437l-.00049-.00073a11.99981,11.99981,0,0,1,20.78418-12l17,29.44531a65.999,65.999,0,0,1-24.15723,90.15723Zm13.9209-199.97266,4.1416-15.4541a6.00029,6.00029,0,0,1,11.5918,3.10547l-4.1416,15.4541a6.00029,6.00029,0,0,1-11.5918-3.10547Zm26.06152,9.85352,9.17774-13.10645a6.00007,6.00007,0,0,1,9.83008,6.88281l-9.17774,13.10645a6.00007,6.00007,0,0,1-9.83008-6.88281Zm41.10938,18.82519L220.97363,63.0293a6.00007,6.00007,0,0,1-6.88281-9.83008l13.10645-9.17774a6.00007,6.00007,0,0,1,6.88281,9.83008Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M51.81106,121.9021a18,18,0,1,0-31.17691,18l37,64.08588a72,72,0,0,0,124.70766-72l-17-29.44487a18,18,0,0,0-31.17692,18",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M106.988,145.47132l-38-65.81793a18,18,0,0,0-31.17692,18l38,65.81793",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M150.16489,148.25593l-42-72.74614a18,18,0,0,0-31.17691,18",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M99.04433,67.71252,88.70079,49.797a18,18,0,1,0-31.17691,18L59.867,71.85533",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M188.03672,191.515a72.02623,72.02623,0,0,0,14.0179-89.38343l-17-29.44486a18,18,0,1,0-31.17691,18",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M156.22161,94.74648l-28.3439-49.09309a18,18,0,0,0-31.17692,18",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176.84663",
      "y1": "11.27112",
      "x2": "172.70552",
      "y2": "26.72593",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "207.06334",
      "y1": "25.3614",
      "x2": "197.88611",
      "y2": "38.46784",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "230.6386",
      "y1": "48.93666",
      "x2": "217.53216",
      "y2": "58.11389",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M51.81106,121.9021a18,18,0,1,0-31.17691,18l37,64.08588a72,72,0,0,0,124.70766-72l-17-29.44487a18,18,0,0,0-31.17692,18",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M106.988,145.47132l-38-65.81793a18,18,0,0,0-31.17692,18l38,65.81793",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M150.16489,148.25593l-42-72.74614a18,18,0,0,0-31.17691,18",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M99.04433,67.71252,88.70079,49.797a18,18,0,1,0-31.17691,18L59.867,71.85533",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M188.03672,191.515a72.02623,72.02623,0,0,0,14.0179-89.38343l-17-29.44486a18,18,0,1,0-31.17691,18",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M156.22161,94.74648l-28.3439-49.09309a18,18,0,0,0-31.17692,18",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176.84663",
      "y1": "11.27112",
      "x2": "172.70552",
      "y2": "26.72593",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "207.06334",
      "y1": "25.3614",
      "x2": "197.88611",
      "y2": "38.46784",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "230.6386",
      "y1": "48.93666",
      "x2": "217.53216",
      "y2": "58.11389",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M51.81106,121.9021a18,18,0,1,0-31.17691,18l37,64.08588a72,72,0,0,0,124.70766-72l-17-29.44487a18,18,0,0,0-31.17692,18",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M106.988,145.47132l-38-65.81793a18,18,0,0,0-31.17692,18l38,65.81793",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M150.16489,148.25593l-42-72.74614a18,18,0,0,0-31.17691,18",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M99.04433,67.71252,88.70079,49.797a18,18,0,1,0-31.17691,18L59.867,71.85533",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M188.03672,191.515a72.02623,72.02623,0,0,0,14.0179-89.38343l-17-29.44486a18,18,0,1,0-31.17691,18",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M156.22161,94.74648l-28.3439-49.09309a18,18,0,0,0-31.17692,18",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176.84663",
      "y1": "11.27112",
      "x2": "172.70552",
      "y2": "26.72593",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "207.06334",
      "y1": "25.3614",
      "x2": "197.88611",
      "y2": "38.46784",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "230.6386",
      "y1": "48.93666",
      "x2": "217.53216",
      "y2": "58.11389",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7e = [];
/* style */

const __vue_inject_styles__$7e = undefined;
/* scoped */

const __vue_scope_id__$7e = undefined;
/* module identifier */

const __vue_module_identifier__$7e = undefined;
/* functional template */

const __vue_is_functional_template__$7e = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7e = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7e,
  staticRenderFns: __vue_staticRenderFns__$7e
}, __vue_inject_styles__$7e, __vue_script__$7e, __vue_scope_id__$7e, __vue_is_functional_template__$7e, __vue_module_identifier__$7e, false, undefined, undefined, undefined);

var script$7f = Vue.extend({
  name: "PhHandshake",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7f = script$7f;
/* template */

var __vue_render__$7f = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M236.71765,121.78477,212,134.14359l-32-61.282,24.9693-12.48465a8,8,0,0,1,10.66912,3.45246l24.59293,47.097A8,8,0,0,1,236.71765,121.78477Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M44,133.0718,19.28235,120.713a8,8,0,0,1-3.5137-10.85838l24.59293-47.097A8,8,0,0,1,51.0307,59.30511L76,71.78976Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M212,134.14359l-12,18.718L163.20286,189.6587a8,8,0,0,1-7.59714,2.10429L97.64881,177.27376a7.99992,7.99992,0,0,1-2.98764-1.45911L44,133.0718",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,152.86156l-44-32-12.8,9.6a32,32,0,0,1-38.4,0L99.37926,126.396a8,8,0,0,1-.85685-12.05686l39.13444-39.13444a8,8,0,0,1,5.65686-2.34315H180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76.57437,71.78976l47.32-14.96153a8,8,0,0,1,5.537.39169L164,72.86156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M108,220.86156,77.86056,213.3267a7.99993,7.99993,0,0,1-3.308-1.7233L52,192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })])]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,152.86156,163.20286,189.6587a8,8,0,0,1-7.59714,2.10429L97.64881,177.27376a7.99992,7.99992,0,0,1-2.98764-1.45911L40,133.0718l32.57437-61.282,51.32-14.96153a8,8,0,0,1,5.537.39169L164,72.86156H143.31371a8,8,0,0,0-5.65686,2.34315L98.52241,114.33915a8,8,0,0,0,.85685,12.05686L104.8,130.46156a32,32,0,0,0,38.4,0l12.8-9.6Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M240.71765,121.78477,216,134.14359l-32-61.282,24.9693-12.48465a8,8,0,0,1,10.66912,3.45246l24.59293,47.097A8,8,0,0,1,240.71765,121.78477Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,133.0718,15.28235,120.713a8,8,0,0,1-3.5137-10.85838l24.59293-47.097A8,8,0,0,1,47.0307,59.30511L72,71.78976Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,134.14359l-16,18.718L163.20286,189.6587a8,8,0,0,1-7.59714,2.10429L97.64881,177.27376a7.99992,7.99992,0,0,1-2.98764-1.45911L40,133.0718",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,152.86156l-44-32-12.8,9.6a32,32,0,0,1-38.4,0L99.37926,126.396a8,8,0,0,1-.85685-12.05686l39.13444-39.13444a8,8,0,0,1,5.65686-2.34315H184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72.57437,71.78976l51.32-14.96153a8,8,0,0,1,5.537.39169L164,72.86156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112,212.86156,81.86056,205.3267a7.99993,7.99993,0,0,1-3.308-1.7233L56,184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M119.76074,214.80176a7.98886,7.98886,0,0,1-9.70117,5.82031l-30.13965-7.53418a16.0992,16.0992,0,0,1-6.61719-3.44727L50.752,190.03809a8,8,0,0,1,10.4961-12.07618l22.55273,19.60352,30.13965,7.53516A7.99856,7.99856,0,0,1,119.76074,214.80176Zm132.60156-95.2461a15.88206,15.88206,0,0,1-8.0664,9.38428L221.02783,140.574l-14.94678,17.48553c-.05224.061-.10937.11725-.16308.17664-.04932.05413-.09815.10785-.14844.16034-.03808.03985-.07324.08245-.1123.12152l-36.79688,36.79834a16.0981,16.0981,0,0,1-11.35058,4.67968,15.8477,15.8477,0,0,1-3.84473-.47265L95.708,185.03418a15.9025,15.9025,0,0,1-5.97559-2.918L35.7041,139.86829l-24-12.00013a16.0014,16.0014,0,0,1-7.02734-21.7163L29.26953,59.05469A16.07985,16.07985,0,0,1,50.6084,52.1499l22.375,11.18744L121.65527,49.148a16.01609,16.01609,0,0,1,11.07325.78271l32.99707,14.93067H182.1123l23.28028-11.63965A16.07317,16.07317,0,0,1,226.73047,60.127l24.59277,47.09619A15.87906,15.87906,0,0,1,252.3623,119.55566Zm-64.63916,34.26886-31.6499-23.01788L148,136.86133a40.20558,40.20558,0,0,1-48,0l-5.4209-4.06543a16.00034,16.00034,0,0,1-1.71387-24.11328L132,69.54785a16.1947,16.1947,0,0,1,1.8335-1.55548l-7.69971-3.48407L77.41016,78.71265,50.17432,130.872,99.58887,169.5127l57.957,14.48925Zm18.68311-20.76959-27.25439-52.1936h-15.1294l-.02734.002c-.0127,0-.02491-.00189-.03711-.002H143.31348l-39.13379,39.13476,5.41992,4.06543a24.1254,24.1254,0,0,0,28.80078,0l12.79981-9.60009a7.99783,7.99783,0,0,1,9.50488-.06983l38.019,27.65027Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M240.71765,121.78477,216,134.14359l-32-61.282,24.9693-12.48465a8,8,0,0,1,10.66912,3.45246l24.59293,47.097A8,8,0,0,1,240.71765,121.78477Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,133.0718,15.28235,120.713a8,8,0,0,1-3.5137-10.85838l24.59293-47.097A8,8,0,0,1,47.0307,59.30511L72,71.78976Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,134.14359l-16,18.718L163.20286,189.6587a8,8,0,0,1-7.59714,2.10429L97.64881,177.27376a7.99992,7.99992,0,0,1-2.98764-1.45911L40,133.0718",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,152.86156l-44-32-12.8,9.6a32,32,0,0,1-38.4,0L99.37926,126.396a8,8,0,0,1-.85685-12.05686l39.13444-39.13444a8,8,0,0,1,5.65686-2.34315H184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72.57437,71.78976l51.32-14.96153a8,8,0,0,1,5.537.39169L164,72.86156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112,212.86156,81.86056,205.3267a7.99993,7.99993,0,0,1-3.308-1.7233L56,184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M240.71765,121.78477,216,134.14359l-32-61.282,24.9693-12.48465a8,8,0,0,1,10.66912,3.45246l24.59293,47.097A8,8,0,0,1,240.71765,121.78477Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,133.0718,15.28235,120.713a8,8,0,0,1-3.5137-10.85838l24.59293-47.097A8,8,0,0,1,47.0307,59.30511L72,71.78976Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,134.14359l-16,18.718L163.20286,189.6587a8,8,0,0,1-7.59714,2.10429L97.64881,177.27376a7.99992,7.99992,0,0,1-2.98764-1.45911L40,133.0718",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,152.86156l-44-32-12.8,9.6a32,32,0,0,1-38.4,0L99.37926,126.396a8,8,0,0,1-.85685-12.05686l39.13444-39.13444a8,8,0,0,1,5.65686-2.34315H184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72.57437,71.78976l51.32-14.96153a8,8,0,0,1,5.537.39169L164,72.86156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112,212.86156,81.86056,205.3267a7.99993,7.99993,0,0,1-3.308-1.7233L56,184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M240.71765,121.78477,216,134.14359l-32-61.282,24.9693-12.48465a8,8,0,0,1,10.66912,3.45246l24.59293,47.097A8,8,0,0,1,240.71765,121.78477Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,133.0718,15.28235,120.713a8,8,0,0,1-3.5137-10.85838l24.59293-47.097A8,8,0,0,1,47.0307,59.30511L72,71.78976Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,134.14359l-16,18.718L163.20286,189.6587a8,8,0,0,1-7.59714,2.10429L97.64881,177.27376a7.99992,7.99992,0,0,1-2.98764-1.45911L40,133.0718",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,152.86156l-44-32-12.8,9.6a32,32,0,0,1-38.4,0L99.37926,126.396a8,8,0,0,1-.85685-12.05686l39.13444-39.13444a8,8,0,0,1,5.65686-2.34315H184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72.57437,71.78976l51.32-14.96153a8,8,0,0,1,5.537.39169L164,72.86156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112,212.86156,81.86056,205.3267a7.99993,7.99993,0,0,1-3.308-1.7233L56,184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7f = [];
/* style */

const __vue_inject_styles__$7f = undefined;
/* scoped */

const __vue_scope_id__$7f = undefined;
/* module identifier */

const __vue_module_identifier__$7f = undefined;
/* functional template */

const __vue_is_functional_template__$7f = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7f = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7f,
  staticRenderFns: __vue_staticRenderFns__$7f
}, __vue_inject_styles__$7f, __vue_script__$7f, __vue_scope_id__$7f, __vue_is_functional_template__$7f, __vue_module_identifier__$7f, false, undefined, undefined, undefined);

var script$7g = Vue.extend({
  name: "PhHardDrive",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7g = script$7g;
/* template */

var __vue_render__$7g = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "72",
      "width": "208",
      "height": "112",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "128",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "72",
      "width": "208",
      "height": "112",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "24",
      "y": "72",
      "width": "208",
      "height": "112",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "128",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,64H32A16.01833,16.01833,0,0,0,16,80v96a16.01833,16.01833,0,0,0,16,16H224a16.01833,16.01833,0,0,0,16-16V80A16.01833,16.01833,0,0,0,224,64Zm-35.99951,76a12,12,0,1,1,12-12A12,12,0,0,1,188.00049,140Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "72",
      "width": "208",
      "height": "112",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "128",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "72",
      "width": "208",
      "height": "112",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "128",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "72",
      "width": "208",
      "height": "112",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "128",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7g = [];
/* style */

const __vue_inject_styles__$7g = undefined;
/* scoped */

const __vue_scope_id__$7g = undefined;
/* module identifier */

const __vue_module_identifier__$7g = undefined;
/* functional template */

const __vue_is_functional_template__$7g = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7g = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7g,
  staticRenderFns: __vue_staticRenderFns__$7g
}, __vue_inject_styles__$7g, __vue_script__$7g, __vue_scope_id__$7g, __vue_is_functional_template__$7g, __vue_module_identifier__$7g, false, undefined, undefined, undefined);

var script$7h = Vue.extend({
  name: "PhHardDrives",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7h = script$7h;
/* template */

var __vue_render__$7h = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "48",
      "width": "176",
      "height": "160",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "128",
      "x2": "40",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "88",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "168",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "144",
      "width": "176",
      "height": "64",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "48",
      "width": "176",
      "height": "64",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "144",
      "width": "176",
      "height": "64",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "48",
      "width": "176",
      "height": "64",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "80",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "176",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M208,40H48A16.01833,16.01833,0,0,0,32,56v48a16.01833,16.01833,0,0,0,16,16H208a16.01833,16.01833,0,0,0,16-16V56A16.01833,16.01833,0,0,0,208,40ZM180.00049,92a12,12,0,1,1,12-12A12,12,0,0,1,180.00049,92Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,136H48a16.01833,16.01833,0,0,0-16,16v48a16.01833,16.01833,0,0,0,16,16H208a16.01833,16.01833,0,0,0,16-16V152A16.01833,16.01833,0,0,0,208,136Zm-27.99951,52a12,12,0,1,1,12-12A12,12,0,0,1,180.00049,188Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "144",
      "width": "176",
      "height": "64",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "48",
      "width": "176",
      "height": "64",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "80",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "176",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "144",
      "width": "176",
      "height": "64",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "48",
      "width": "176",
      "height": "64",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "176",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "80",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "144",
      "width": "176",
      "height": "64",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "48",
      "width": "176",
      "height": "64",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "80",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "176",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7h = [];
/* style */

const __vue_inject_styles__$7h = undefined;
/* scoped */

const __vue_scope_id__$7h = undefined;
/* module identifier */

const __vue_module_identifier__$7h = undefined;
/* functional template */

const __vue_is_functional_template__$7h = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7h = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7h,
  staticRenderFns: __vue_staticRenderFns__$7h
}, __vue_inject_styles__$7h, __vue_script__$7h, __vue_scope_id__$7h, __vue_is_functional_template__$7h, __vue_module_identifier__$7h, false, undefined, undefined, undefined);

var script$7i = Vue.extend({
  name: "PhHash",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7i = script$7i;
/* template */

var __vue_render__$7i = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "43.63636",
      "y1": "96",
      "x2": "224",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "40",
      "x2": "144",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "40",
      "x2": "80",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "160",
      "x2": "212.36376",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "43.63636",
      "y1": "96",
      "x2": "224",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "40",
      "x2": "144",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "40",
      "x2": "80",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "160",
      "x2": "212.36376",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,88H175.40381l8.46728-46.56934a8.00005,8.00005,0,1,0-15.74218-2.86132L159.1416,88H111.40381l8.46728-46.56934a8.00005,8.00005,0,1,0-15.74218-2.86132L95.1416,88H43.63672a8,8,0,0,0,0,16h48.5957l-8.72754,48H32a8,8,0,0,0,0,16H80.59619l-8.46728,46.56934a8.00005,8.00005,0,1,0,15.74218,2.86132L96.8584,168h47.73779l-8.46728,46.56934a8.00005,8.00005,0,1,0,15.74218,2.86132L160.8584,168h51.50488a8,8,0,1,0,0-16h-48.5957l8.72754-48H224a8,8,0,0,0,0-16Zm-76.49512,64H99.76758l8.72754-48h47.7373Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "43.63636",
      "y1": "96",
      "x2": "224",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "40",
      "x2": "144",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "40",
      "x2": "80",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "160",
      "x2": "212.36376",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "43.63636",
      "y1": "96",
      "x2": "224",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "40",
      "x2": "144",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "40",
      "x2": "80",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "160",
      "x2": "212.36376",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "43.63636",
      "y1": "96",
      "x2": "224",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "40",
      "x2": "144",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "40",
      "x2": "80",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "160",
      "x2": "212.36376",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7i = [];
/* style */

const __vue_inject_styles__$7i = undefined;
/* scoped */

const __vue_scope_id__$7i = undefined;
/* module identifier */

const __vue_module_identifier__$7i = undefined;
/* functional template */

const __vue_is_functional_template__$7i = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7i = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7i,
  staticRenderFns: __vue_staticRenderFns__$7i
}, __vue_inject_styles__$7i, __vue_script__$7i, __vue_scope_id__$7i, __vue_is_functional_template__$7i, __vue_module_identifier__$7i, false, undefined, undefined, undefined);

var script$7j = Vue.extend({
  name: "PhHashStraight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7j = script$7j;
/* template */

var __vue_render__$7j = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "96",
      "x2": "216",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "160",
      "x2": "216",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "40",
      "x2": "160",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "40",
      "x2": "96",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "96",
      "x2": "216",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "160",
      "x2": "216",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "40",
      "x2": "160",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "40",
      "x2": "96",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,152H168V104h48a8,8,0,0,0,0-16H168V40a8,8,0,0,0-16,0V88H104V40a8,8,0,0,0-16,0V88H40a8,8,0,0,0,0,16H88v48H40a8,8,0,0,0,0,16H88v48a8,8,0,0,0,16,0V168h48v48a8,8,0,0,0,16,0V168h48a8,8,0,0,0,0-16Zm-112,0V104h48v48Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "96",
      "x2": "216",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "160",
      "x2": "216",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "40",
      "x2": "160",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "40",
      "x2": "96",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "96",
      "x2": "216",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "160",
      "x2": "216",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "40",
      "x2": "160",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "40",
      "x2": "96",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "96",
      "x2": "216",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "160",
      "x2": "216",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "40",
      "x2": "160",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "40",
      "x2": "96",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7j = [];
/* style */

const __vue_inject_styles__$7j = undefined;
/* scoped */

const __vue_scope_id__$7j = undefined;
/* module identifier */

const __vue_module_identifier__$7j = undefined;
/* functional template */

const __vue_is_functional_template__$7j = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7j = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7j,
  staticRenderFns: __vue_staticRenderFns__$7j
}, __vue_inject_styles__$7j, __vue_script__$7j, __vue_scope_id__$7j, __vue_is_functional_template__$7j, __vue_module_identifier__$7j, false, undefined, undefined, undefined);

var script$7k = Vue.extend({
  name: "PhHeadlights",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7k = script$7k;
/* template */

var __vue_render__$7k = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "176",
      "y1": "80",
      "x2": "240",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "176",
      "x2": "240",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "128",
      "x2": "240",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,200a72.00008,72.00008,0,0,1-71.998-72.54593C16.29634,87.75464,49.20335,56,88.90387,56H128a8,8,0,0,1,8,8V192a8,8,0,0,1-8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M88,200a72.00008,72.00008,0,0,1-71.998-72.54593C16.29634,87.75464,49.20335,56,88.90387,56H128a8,8,0,0,1,8,8V192a8,8,0,0,1-8,8Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "80",
      "x2": "240",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "176",
      "x2": "240",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "112",
      "x2": "240",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "144",
      "x2": "240",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,200a72.00008,72.00008,0,0,1-71.998-72.54593C16.29634,87.75464,49.20335,56,88.90387,56H128a8,8,0,0,1,8,8V192a8,8,0,0,1-8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M160,80a8.00039,8.00039,0,0,1,8-8h72a8,8,0,0,1,0,16H168A8.00039,8.00039,0,0,1,160,80Zm80,88H168a8,8,0,0,0,0,16h72a8,8,0,0,0,0-16Zm0-64H168a8,8,0,0,0,0,16h72a8,8,0,0,0,0-16Zm0,32H168a8,8,0,0,0,0,16h72a8,8,0,0,0,0-16ZM128,48H88.90381C44.61914,48,8.32715,83.61621,8.002,127.39453A79.99987,79.99987,0,0,0,88,208h40a16.01833,16.01833,0,0,0,16-16V64A16.01833,16.01833,0,0,0,128,48Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "168",
      "y1": "80",
      "x2": "240",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "176",
      "x2": "240",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "112",
      "x2": "240",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "144",
      "x2": "240",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,200a72.00008,72.00008,0,0,1-71.998-72.54593C16.29634,87.75464,49.20335,56,88.90387,56H128a8,8,0,0,1,8,8V192a8,8,0,0,1-8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "168",
      "y1": "80",
      "x2": "240",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "176",
      "x2": "240",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "112",
      "x2": "240",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "144",
      "x2": "240",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,200a72.00008,72.00008,0,0,1-71.998-72.54593C16.29634,87.75464,49.20335,56,88.90387,56H128a8,8,0,0,1,8,8V192a8,8,0,0,1-8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "168",
      "y1": "80",
      "x2": "240",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "176",
      "x2": "240",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "112",
      "x2": "240",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "144",
      "x2": "240",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,200a72.00008,72.00008,0,0,1-71.998-72.54593C16.29634,87.75464,49.20335,56,88.90387,56H128a8,8,0,0,1,8,8V192a8,8,0,0,1-8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7k = [];
/* style */

const __vue_inject_styles__$7k = undefined;
/* scoped */

const __vue_scope_id__$7k = undefined;
/* module identifier */

const __vue_module_identifier__$7k = undefined;
/* functional template */

const __vue_is_functional_template__$7k = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7k = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7k,
  staticRenderFns: __vue_staticRenderFns__$7k
}, __vue_inject_styles__$7k, __vue_script__$7k, __vue_scope_id__$7k, __vue_is_functional_template__$7k, __vue_module_identifier__$7k, false, undefined, undefined, undefined);

var script$7l = Vue.extend({
  name: "PhHeadphones",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7l = script$7l;
/* template */

var __vue_render__$7l = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M225.45581,136h-32a16,16,0,0,0-16,16v40a16,16,0,0,0,16,16h16a16,16,0,0,0,16-16V136A96.0001,96.0001,0,0,0,128.7279,40.0027,96.00009,96.00009,0,0,0,32,136v56a16,16,0,0,0,16,16H64a16,16,0,0,0,16-16V152a16,16,0,0,0-16-16H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,136v56a16,16,0,0,0,16,16H64a16,16,0,0,0,16-16V152a16,16,0,0,0-16-16Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M225.45581,136h-32a16,16,0,0,0-16,16v40a16,16,0,0,0,16,16h16a16,16,0,0,0,16-16Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M225.45581,136h-32a16,16,0,0,0-16,16v40a16,16,0,0,0,16,16h16a16,16,0,0,0,16-16V136A96.0001,96.0001,0,0,0,128.7279,40.0027,96.00009,96.00009,0,0,0,32,136v56a16,16,0,0,0,16,16H64a16,16,0,0,0,16-16V152a16,16,0,0,0-16-16H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M202.7207,62.1875A103.28167,103.28167,0,0,0,129.46289,32c-.24414,0-.49121.001-.73535.00244A104.00025,104.00025,0,0,0,24,136v56a24.0275,24.0275,0,0,0,24,24H64a24.0275,24.0275,0,0,0,24-24V152a24.0275,24.0275,0,0,0-24-24H40.35547A88.01928,88.01928,0,0,1,128.668,48.00244c.041.00049.07812.00049.11914,0A88.01738,88.01738,0,0,1,217.10059,128H193.45605a24.0275,24.0275,0,0,0-24,24v40a24.0275,24.0275,0,0,0,24,24h16a24.0275,24.0275,0,0,0,24-24V136A103.28343,103.28343,0,0,0,202.7207,62.1875Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M225.45581,136h-32a16,16,0,0,0-16,16v40a16,16,0,0,0,16,16h16a16,16,0,0,0,16-16V136A96.0001,96.0001,0,0,0,128.7279,40.0027,96.00009,96.00009,0,0,0,32,136v56a16,16,0,0,0,16,16H64a16,16,0,0,0,16-16V152a16,16,0,0,0-16-16H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M225.45581,136h-32a16,16,0,0,0-16,16v40a16,16,0,0,0,16,16h16a16,16,0,0,0,16-16V136A96.0001,96.0001,0,0,0,128.7279,40.0027,96.00009,96.00009,0,0,0,32,136v56a16,16,0,0,0,16,16H64a16,16,0,0,0,16-16V152a16,16,0,0,0-16-16H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M225.45581,136h-32a16,16,0,0,0-16,16v40a16,16,0,0,0,16,16h16a16,16,0,0,0,16-16V136A96.0001,96.0001,0,0,0,128.7279,40.0027,96.00009,96.00009,0,0,0,32,136v56a16,16,0,0,0,16,16H64a16,16,0,0,0,16-16V152a16,16,0,0,0-16-16H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7l = [];
/* style */

const __vue_inject_styles__$7l = undefined;
/* scoped */

const __vue_scope_id__$7l = undefined;
/* module identifier */

const __vue_module_identifier__$7l = undefined;
/* functional template */

const __vue_is_functional_template__$7l = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7l = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7l,
  staticRenderFns: __vue_staticRenderFns__$7l
}, __vue_inject_styles__$7l, __vue_script__$7l, __vue_scope_id__$7l, __vue_is_functional_template__$7l, __vue_module_identifier__$7l, false, undefined, undefined, undefined);

var script$7m = Vue.extend({
  name: "PhHeadset",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7m = script$7m;
/* template */

var __vue_render__$7m = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M225.45581,128h-32a16,16,0,0,0-16,16v40a16,16,0,0,0,16,16h16a16,16,0,0,0,16-16V128A96.0001,96.0001,0,0,0,128.7279,32.0027,96.00009,96.00009,0,0,0,32,128v56a16,16,0,0,0,16,16H64a16,16,0,0,0,16-16V144a16,16,0,0,0-16-16H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M225.45581,184v24a32,32,0,0,1-32,32H136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,128v56a16,16,0,0,0,16,16H64a16,16,0,0,0,16-16V144a16,16,0,0,0-16-16Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M225.45581,128h-32a16,16,0,0,0-16,16v40a16,16,0,0,0,16,16h16a16,16,0,0,0,16-16Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M225.45581,128h-32a16,16,0,0,0-16,16v40a16,16,0,0,0,16,16h16a16,16,0,0,0,16-16V128A96.0001,96.0001,0,0,0,128.7279,32.0027,96.00009,96.00009,0,0,0,32,128v56a16,16,0,0,0,16,16H64a16,16,0,0,0,16-16V144a16,16,0,0,0-16-16H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M225.45581,184v24a32,32,0,0,1-32,32H136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M233.45605,128v80a40.04551,40.04551,0,0,1-40,40H136a8,8,0,0,1,0-16h57.45605a24.0275,24.0275,0,0,0,24-24v-1.376a23.89418,23.89418,0,0,1-8,1.376h-16a24.0275,24.0275,0,0,1-24-24V144a24.0275,24.0275,0,0,1,24-24h23.64454a88.01738,88.01738,0,0,0-88.31348-79.99756c-.041.00049-.07813.00049-.11914,0A88.01928,88.01928,0,0,0,40.35547,120H64a24.0275,24.0275,0,0,1,24,24v40a24.0275,24.0275,0,0,1-24,24H48a24.0275,24.0275,0,0,1-24-24V128A104.00025,104.00025,0,0,1,128.72754,24.00244c.24414-.00146.49121-.00244.73535-.00244A104.00007,104.00007,0,0,1,233.45605,128Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M225.45581,128h-32a16,16,0,0,0-16,16v40a16,16,0,0,0,16,16h16a16,16,0,0,0,16-16V128A96.0001,96.0001,0,0,0,128.7279,32.0027,96.00009,96.00009,0,0,0,32,128v56a16,16,0,0,0,16,16H64a16,16,0,0,0,16-16V144a16,16,0,0,0-16-16H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M225.45581,184v24a32,32,0,0,1-32,32H136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M225.45581,128h-32a16,16,0,0,0-16,16v40a16,16,0,0,0,16,16h16a16,16,0,0,0,16-16V128A96.0001,96.0001,0,0,0,128.7279,32.0027,96.00009,96.00009,0,0,0,32,128v56a16,16,0,0,0,16,16H64a16,16,0,0,0,16-16V144a16,16,0,0,0-16-16H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M225.45581,184v24a32,32,0,0,1-32,32H136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M225.45581,128h-32a16,16,0,0,0-16,16v40a16,16,0,0,0,16,16h16a16,16,0,0,0,16-16V128A96.0001,96.0001,0,0,0,128.7279,32.0027,96.00009,96.00009,0,0,0,32,128v56a16,16,0,0,0,16,16H64a16,16,0,0,0,16-16V144a16,16,0,0,0-16-16H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M225.45581,184v24a32,32,0,0,1-32,32H136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7m = [];
/* style */

const __vue_inject_styles__$7m = undefined;
/* scoped */

const __vue_scope_id__$7m = undefined;
/* module identifier */

const __vue_module_identifier__$7m = undefined;
/* functional template */

const __vue_is_functional_template__$7m = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7m = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7m,
  staticRenderFns: __vue_staticRenderFns__$7m
}, __vue_inject_styles__$7m, __vue_script__$7m, __vue_scope_id__$7m, __vue_is_functional_template__$7m, __vue_module_identifier__$7m, false, undefined, undefined, undefined);

var script$7n = Vue.extend({
  name: "PhHeart",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7n = script$7n;
/* template */

var __vue_render__$7n = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128.01758,216s-100-56-100-124A52.00881,52.00881,0,0,1,128.01766,71.965l-.0002.00008A52.00882,52.00882,0,0,1,228.01758,92C228.01758,160,128.01758,216,128.01758,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128.0293,216s-100-56-100-124A52.00881,52.00881,0,0,1,128.02938,71.965l-.0002.00008A52.00882,52.00882,0,0,1,228.0293,92C228.0293,160,128.0293,216,128.0293,216Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128.0293,216s-100-56-100-124A52.00881,52.00881,0,0,1,128.02938,71.965l-.0002.00008A52.00882,52.00882,0,0,1,228.0293,92C228.0293,160,128.0293,216,128.0293,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176.02344,32a59.85506,59.85506,0,0,0-48,23.95947A60.02029,60.02029,0,0,0,20.02344,92c0,71.86279,99.84082,128.6001,104.09082,130.98a8.00089,8.00089,0,0,0,7.81836,0A317.34027,317.34027,0,0,0,183.375,185.44629C218.30957,154.00488,236.02344,122.56494,236.02344,92A60.06812,60.06812,0,0,0,176.02344,32Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128.01172,216s-100-56-100-124A52.00881,52.00881,0,0,1,128.0118,71.965l-.00019.00008A52.00881,52.00881,0,0,1,228.01172,92C228.01172,160,128.01172,216,128.01172,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128.00586,216s-100-56-100-124A52.00881,52.00881,0,0,1,128.00594,71.965l-.00019.00008A52.00881,52.00881,0,0,1,228.00586,92C228.00586,160,128.00586,216,128.00586,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,216S28,160,28,92A52.00881,52.00881,0,0,1,128.00008,71.965l-.00019.00008A52.00881,52.00881,0,0,1,228,92C228,160,128,216,128,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7n = [];
/* style */

const __vue_inject_styles__$7n = undefined;
/* scoped */

const __vue_scope_id__$7n = undefined;
/* module identifier */

const __vue_module_identifier__$7n = undefined;
/* functional template */

const __vue_is_functional_template__$7n = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7n = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7n,
  staticRenderFns: __vue_staticRenderFns__$7n
}, __vue_inject_styles__$7n, __vue_script__$7n, __vue_scope_id__$7n, __vue_is_functional_template__$7n, __vue_module_identifier__$7n, false, undefined, undefined, undefined);

var script$7o = Vue.extend({
  name: "PhHeartStraight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7o = script$7o;
/* template */

var __vue_render__$7o = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M133.65683,211.88227l81.0323-81.0322c19.9104-19.91038,22.84784-52.666,4.00583-73.59029a52.0026,52.0026,0,0,0-75.46451-2.02934L127.99994,70.46082,114.85007,57.3109C94.93972,37.40047,62.18409,34.463,41.25979,53.305a52.00261,52.00261,0,0,0-2.02934,75.46452l83.11268,83.11272A8,8,0,0,0,133.65683,211.88227Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M133.65683,211.88227l81.0323-81.0322c19.9104-19.91038,22.84784-52.666,4.00583-73.59029a52.0026,52.0026,0,0,0-75.46451-2.02934L127.99994,70.46082,114.85007,57.3109C94.93972,37.40047,62.18409,34.463,41.25979,53.305a52.00261,52.00261,0,0,0-2.02934,75.46452l83.11268,83.11272A8,8,0,0,0,133.65683,211.88227Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M133.65683,211.88227l81.0323-81.0322c19.9104-19.91038,22.84784-52.666,4.00583-73.59029a52.0026,52.0026,0,0,0-75.46451-2.02934L127.99994,70.46082,114.85007,57.3109C94.93972,37.40047,62.18409,34.463,41.25979,53.305a52.00261,52.00261,0,0,0-2.02934,75.46452l83.11268,83.11272A8,8,0,0,0,133.65683,211.88227Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224.627,51.90625a59.54956,59.54956,0,0,0-43.0625-19.89063,60.69786,60.69786,0,0,0-43.98437,17.55469L128.002,59.14844l-7.5-7.49219c-23.32812-23.35156-61.29687-25.3125-84.57812-4.29687a59.974,59.974,0,0,0-2.34375,87.07031l83.10937,83.10937a16.013,16.013,0,0,0,22.625,0l81.03125-81.03125C243.68945,113.15625,245.61133,75.20312,224.627,51.90625Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M133.65683,211.88227l81.0323-81.0322c19.9104-19.91038,22.84784-52.666,4.00583-73.59029a52.0026,52.0026,0,0,0-75.46451-2.02934L127.99994,70.46082,114.85007,57.3109C94.93972,37.40047,62.18409,34.463,41.25979,53.305a52.00261,52.00261,0,0,0-2.02934,75.46452l83.11268,83.11272A8,8,0,0,0,133.65683,211.88227Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M133.65683,211.88227l81.0323-81.0322c19.9104-19.91038,22.84784-52.666,4.00583-73.59029a52.0026,52.0026,0,0,0-75.46451-2.02934L127.99994,70.46082,114.85007,57.3109C94.93972,37.40047,62.18409,34.463,41.25979,53.305a52.00261,52.00261,0,0,0-2.02934,75.46452l83.11268,83.11272A8,8,0,0,0,133.65683,211.88227Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M133.65683,211.88227l81.0323-81.0322c19.9104-19.91038,22.84784-52.666,4.00583-73.59029a52.0026,52.0026,0,0,0-75.46451-2.02934L127.99994,70.46082,114.85007,57.3109C94.93972,37.40047,62.18409,34.463,41.25979,53.305a52.00261,52.00261,0,0,0-2.02934,75.46452l83.11268,83.11272A8,8,0,0,0,133.65683,211.88227Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7o = [];
/* style */

const __vue_inject_styles__$7o = undefined;
/* scoped */

const __vue_scope_id__$7o = undefined;
/* module identifier */

const __vue_module_identifier__$7o = undefined;
/* functional template */

const __vue_is_functional_template__$7o = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7o = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7o,
  staticRenderFns: __vue_staticRenderFns__$7o
}, __vue_inject_styles__$7o, __vue_script__$7o, __vue_scope_id__$7o, __vue_is_functional_template__$7o, __vue_module_identifier__$7o, false, undefined, undefined, undefined);

var script$7p = Vue.extend({
  name: "PhHeartbeat",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7p = script$7p;
/* template */

var __vue_render__$7p = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "32 128 72 128 88 104 120 152 136 128 160 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M28.13612,88.20841a52.01064,52.01064,0,0,1,99.864-16.24342l-.00019.00008A52.00881,52.00881,0,0,1,228,92c0,68-100,124-100,124s-33.69291-18.868-61.96423-47.99889",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,216S28,160,28,92A52.00881,52.00881,0,0,1,128.00008,71.965l-.00019.00008A52.00881,52.00881,0,0,1,228,92C228,160,128,216,128,216Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "32 128 72 128 88 104 120 152 136 128 160 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M28.11427,95.99348Q28.00077,94.004,28,92A52.00881,52.00881,0,0,1,128.00008,71.965l-.00019.00008A52.00881,52.00881,0,0,1,228,92c0,68-100,124-100,124s-39.94466-22.369-69.34251-55.99891",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,32a59.85506,59.85506,0,0,0-48,23.95947A60.02029,60.02029,0,0,0,20,92a85.2156,85.2156,0,0,0,4.92969,28H67.71875l13.625-20.4375a7.99959,7.99959,0,0,1,13.3125,0L120,137.57764l9.34375-14.01514A7.99943,7.99943,0,0,1,136,120h24a8,8,0,0,1,0,16H140.28125l-13.625,20.4375a7.99959,7.99959,0,0,1-13.3125,0L88,118.42236,78.65625,132.4375A7.99943,7.99943,0,0,1,72,136H31.98389c26.65088,49.81006,88.77392,85.11328,92.10693,86.98a8.00089,8.00089,0,0,0,7.81836,0,317.34027,317.34027,0,0,0,51.44238-37.53369C218.28613,154.00488,236,122.56494,236,92A60.06812,60.06812,0,0,0,176,32Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "32 128 72 128 88 104 120 152 136 128 160 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M28.11427,95.99348Q28.00077,94.004,28,92A52.00881,52.00881,0,0,1,128.00008,71.965l-.00019.00008A52.00881,52.00881,0,0,1,228,92c0,68-100,124-100,124s-39.94466-22.369-69.34251-55.99891",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "32 128 72 128 88 104 120 152 136 128 160 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M28.11427,95.99348Q28.00077,94.004,28,92A52.00881,52.00881,0,0,1,128.00008,71.965l-.00019.00008A52.00881,52.00881,0,0,1,228,92c0,68-100,124-100,124s-39.94466-22.369-69.34251-55.99891",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "32 128 72 128 88 104 120 152 136 128 160 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M28.11427,95.99348Q28.00077,94.004,28,92A52.00881,52.00881,0,0,1,128.00008,71.965l-.00019.00008A52.00881,52.00881,0,0,1,228,92c0,68-100,124-100,124s-39.94466-22.369-69.34251-55.99891",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7p = [];
/* style */

const __vue_inject_styles__$7p = undefined;
/* scoped */

const __vue_scope_id__$7p = undefined;
/* module identifier */

const __vue_module_identifier__$7p = undefined;
/* functional template */

const __vue_is_functional_template__$7p = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7p = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7p,
  staticRenderFns: __vue_staticRenderFns__$7p
}, __vue_inject_styles__$7p, __vue_script__$7p, __vue_scope_id__$7p, __vue_is_functional_template__$7p, __vue_module_identifier__$7p, false, undefined, undefined, undefined);

var script$7q = Vue.extend({
  name: "PhHexagon",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7q = script$7q;
/* template */

var __vue_render__$7q = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M220,175.33228V80.66772a8,8,0,0,0-4.06354-6.9645l-84-47.47826a8,8,0,0,0-7.87292,0l-84,47.47826A8,8,0,0,0,36,80.66772v94.66456a8,8,0,0,0,4.06354,6.96451l84,47.47826a8,8,0,0,0,7.87292,0l84-47.47826A8,8,0,0,0,220,175.33228Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M220,175.33228V80.66772a8,8,0,0,0-4.06354-6.9645l-84-47.47826a8,8,0,0,0-7.87292,0l-84,47.47826A8,8,0,0,0,36,80.66772v94.66456a8,8,0,0,0,4.06354,6.96451l84,47.47826a8,8,0,0,0,7.87292,0l84-47.47826A8,8,0,0,0,220,175.33228Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M220,175.33228V80.66772a8,8,0,0,0-4.06354-6.9645l-84-47.47826a8,8,0,0,0-7.87292,0l-84,47.47826A8,8,0,0,0,36,80.66772v94.66456a8,8,0,0,0,4.06354,6.96451l84,47.47826a8,8,0,0,0,7.87292,0l84-47.47826A8,8,0,0,0,220,175.33228Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M219.87305,66.73828l-84-47.478a16.08654,16.08654,0,0,0-15.7461,0l-84,47.47852A16.0255,16.0255,0,0,0,28,80.668V175.332a16.02688,16.02688,0,0,0,8.127,13.92969l84,47.478a16.08782,16.08782,0,0,0,15.7461,0l84-47.47852A16.0255,16.0255,0,0,0,228,175.332V80.668A16.02688,16.02688,0,0,0,219.87305,66.73828Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M220,175.33228V80.66772a8,8,0,0,0-4.06354-6.9645l-84-47.47826a8,8,0,0,0-7.87292,0l-84,47.47826A8,8,0,0,0,36,80.66772v94.66456a8,8,0,0,0,4.06354,6.96451l84,47.47826a8,8,0,0,0,7.87292,0l84-47.47826A8,8,0,0,0,220,175.33228Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M220,175.33228V80.66772a8,8,0,0,0-4.06354-6.9645l-84-47.47826a8,8,0,0,0-7.87292,0l-84,47.47826A8,8,0,0,0,36,80.66772v94.66456a8,8,0,0,0,4.06354,6.96451l84,47.47826a8,8,0,0,0,7.87292,0l84-47.47826A8,8,0,0,0,220,175.33228Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M220,175.33228V80.66772a8,8,0,0,0-4.06354-6.9645l-84-47.47826a8,8,0,0,0-7.87292,0l-84,47.47826A8,8,0,0,0,36,80.66772v94.66456a8,8,0,0,0,4.06354,6.96451l84,47.47826a8,8,0,0,0,7.87292,0l84-47.47826A8,8,0,0,0,220,175.33228Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7q = [];
/* style */

const __vue_inject_styles__$7q = undefined;
/* scoped */

const __vue_scope_id__$7q = undefined;
/* module identifier */

const __vue_module_identifier__$7q = undefined;
/* functional template */

const __vue_is_functional_template__$7q = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7q = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7q,
  staticRenderFns: __vue_staticRenderFns__$7q
}, __vue_inject_styles__$7q, __vue_script__$7q, __vue_scope_id__$7q, __vue_is_functional_template__$7q, __vue_module_identifier__$7q, false, undefined, undefined, undefined);

var script$7r = Vue.extend({
  name: "PhHighlighterCircle",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7r = script$7r;
/* template */

var __vue_render__$7r = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "104 148 104 104 152 80 152 148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,215.29789V156a8,8,0,0,0-8-8H96a8,8,0,0,0-8,8v59.29789",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M195.88232,60.11774A96.00007,96.00007,0,1,0,88,215.28711V152a8,8,0,0,1,8-8h8V96l48-24v72h8a8,8,0,0,1,8,8v63.28711A96.03847,96.03847,0,0,0,195.88232,60.11774Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "104 144 104 96 152 72 152 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,215.29789V152a8,8,0,0,0-8-8H96a8,8,0,0,0-8,8v63.29789",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M201.53906,54.46094A103.99994,103.99994,0,1,0,54.46094,201.53906,103.99994,103.99994,0,1,0,201.53906,54.46094ZM96,209.9989V152h64v57.9989a88.31824,88.31824,0,0,1-64,0Zm94.22461-19.77429A88.78305,88.78305,0,0,1,176,201.76886V152a16.01833,16.01833,0,0,0-16-16V72a8,8,0,0,0-11.57812-7.15527l-48,24A7.99967,7.99967,0,0,0,96,96v40a16.01833,16.01833,0,0,0-16,16v49.76886a88.78631,88.78631,0,0,1-14.22461-11.54425,88,88,0,1,1,124.44922,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "104 144 104 96 152 72 152 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,215.29789V152a8,8,0,0,0-8-8H96a8,8,0,0,0-8,8v63.29789",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "104 144 104 96 152 72 152 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,215.29789V152a8,8,0,0,0-8-8H96a8,8,0,0,0-8,8v63.29789",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "104 144 104 96 152 72 152 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,215.29789V152a8,8,0,0,0-8-8H96a8,8,0,0,0-8,8v63.29789",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7r = [];
/* style */

const __vue_inject_styles__$7r = undefined;
/* scoped */

const __vue_scope_id__$7r = undefined;
/* module identifier */

const __vue_module_identifier__$7r = undefined;
/* functional template */

const __vue_is_functional_template__$7r = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7r = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7r,
  staticRenderFns: __vue_staticRenderFns__$7r
}, __vue_inject_styles__$7r, __vue_script__$7r, __vue_scope_id__$7r, __vue_is_functional_template__$7r, __vue_module_identifier__$7r, false, undefined, undefined, undefined);

var script$7s = Vue.extend({
  name: "PhHorse",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7s = script$7s;
/* template */

var __vue_render__$7s = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,120a48,48,0,0,1-48,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M63.99958,199.555a95.66337,95.66337,0,0,0,65.94315,24.42575c51.479-1.01726,93.33139-43.12958,94.04775-94.61366A96.00033,96.00033,0,0,0,128,32h-8V64L16,128l13.78709,19.11608a24.02393,24.02393,0,0,0,23.51449,9.61538c17.46763-2.95714,48.06093-4.71406,74.69861,11.26833L128,168,92.76585,217.32781",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "104",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.76616,217.32808a95.841,95.841,0,0,0,37.17657,6.65271c51.479-1.01726,93.33139-43.12958,94.04775-94.61366A96.00033,96.00033,0,0,0,128,32h-8V64L16,128l13.78709,19.11608a24.02393,24.02393,0,0,0,23.51449,9.61538c17.46763-2.95714,48.06093-4.71406,74.69861,11.26833L128,168Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,120a48,48,0,0,1-48,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M63.99958,199.555a95.66337,95.66337,0,0,0,65.94315,24.42575c51.479-1.01726,93.33139-43.12958,94.04775-94.61366A96.00033,96.00033,0,0,0,128,32h-8V64L16,128l13.78709,19.11608a24.02393,24.02393,0,0,0,23.51449,9.61538c17.46763-2.95714,48.06093-4.71406,74.69861,11.26833L128,168,92.76585,217.32781",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "124",
      "cy": "100",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M202.053,54.97754A103.25514,103.25514,0,0,0,128.00009,24h-8a8.00009,8.00009,0,0,0-8,8V59.52979L11.80743,121.18652a8.00038,8.00038,0,0,0-2.29591,11.49317L23.29867,151.7959a31.8353,31.8353,0,0,0,31.338,12.82324c13.6514-2.31055,38.5919-4.23193,61.52457,6.19092L90.02246,207.40479a87.94472,87.94472,0,0,1-20.68657-13.81055A8.00032,8.00032,0,0,0,58.664,205.51611,103.66177,103.66177,0,0,0,128.01279,232q1.043,0,2.0879-.02051A104.001,104.001,0,0,0,202.053,54.97754ZM124,112a12,12,0,1,1,12-12A12,12,0,0,1,124,112Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,120a48,48,0,0,1-48,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M63.99958,199.555a95.66337,95.66337,0,0,0,65.94315,24.42575c51.479-1.01726,93.33139-43.12958,94.04775-94.61366A96.00033,96.00033,0,0,0,128,32h-8V64L16,128l13.78709,19.11608a24.02393,24.02393,0,0,0,23.51449,9.61538c17.46763-2.95714,48.06093-4.71406,74.69861,11.26833L128,168,92.76585,217.32781",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "124",
      "cy": "100",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,120a48,48,0,0,1-48,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M63.99958,199.555a95.66337,95.66337,0,0,0,65.94315,24.42575c51.479-1.01726,93.33139-43.12958,94.04775-94.61366A96.00033,96.00033,0,0,0,128,32h-8V64L16,128l13.78709,19.11608a24.02393,24.02393,0,0,0,23.51449,9.61538c17.46763-2.95714,48.06093-4.71406,74.69861,11.26833L128,168,92.76585,217.32781",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "124",
      "cy": "100",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,120a48,48,0,0,1-48,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M63.99958,199.555a95.66337,95.66337,0,0,0,65.94315,24.42575c51.479-1.01726,93.33139-43.12958,94.04775-94.61366A96.00033,96.00033,0,0,0,128,32h-8V64L16,128l13.78709,19.11608a24.02393,24.02393,0,0,0,23.51449,9.61538c17.46763-2.95714,48.06093-4.71406,74.69861,11.26833L128,168,92.76585,217.32781",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "124",
      "cy": "100",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7s = [];
/* style */

const __vue_inject_styles__$7s = undefined;
/* scoped */

const __vue_scope_id__$7s = undefined;
/* module identifier */

const __vue_module_identifier__$7s = undefined;
/* functional template */

const __vue_is_functional_template__$7s = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7s = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7s,
  staticRenderFns: __vue_staticRenderFns__$7s
}, __vue_inject_styles__$7s, __vue_script__$7s, __vue_scope_id__$7s, __vue_is_functional_template__$7s, __vue_module_identifier__$7s, false, undefined, undefined, undefined);

var script$7t = Vue.extend({
  name: "PhHourglass",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7t = script$7t;
/* template */

var __vue_render__$7t = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,128,67.2,82.4A8,8,0,0,1,64,76V40a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8V75.6412a8,8,0,0,1-3.17594,6.38188L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,128,67.2,173.6A8,8,0,0,0,64,180v36a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V180.3588a8,8,0,0,0-3.17594-6.38188L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,128,67.2,82.4A8,8,0,0,1,64,76V40a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8V75.6412a8,8,0,0,1-3.17594,6.38188L128,128h0",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,128,67.2,173.6A8,8,0,0,0,64,180v36a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V180.3588a8,8,0,0,0-3.17594-6.38188L128,128h0",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,128,67.2,82.4A8,8,0,0,1,64,76V40a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8V75.6412a8,8,0,0,1-3.17594,6.38188L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,128,67.2,173.6A8,8,0,0,0,64,180v36a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V180.3588a8,8,0,0,0-3.17594-6.38188L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,75.64392V40.0033a16.02084,16.02084,0,0,0-16-16H72a16.02084,16.02084,0,0,0-16,16v36a16.08093,16.08093,0,0,0,6.40625,12.79687l52.26563,39.20313L62.39844,167.20642A16.07348,16.07348,0,0,0,56,180.0033v36a16.02085,16.02085,0,0,0,16,16H184a16.02085,16.02085,0,0,0,16-16V180.36267a16.033,16.033,0,0,0-6.35937-12.76562l-52.377-39.59375,52.377-39.59375A16.05549,16.05549,0,0,0,200,75.64392Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,128,67.2,82.4A8,8,0,0,1,64,76V40a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8V75.6412a8,8,0,0,1-3.17594,6.38188L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,128,67.2,173.6A8,8,0,0,0,64,180v36a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V180.3588a8,8,0,0,0-3.17594-6.38188L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,128,67.2,82.4A8,8,0,0,1,64,76V40a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8V75.6412a8,8,0,0,1-3.17594,6.38188L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,128,67.2,173.6A8,8,0,0,0,64,180v36a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V180.3588a8,8,0,0,0-3.17594-6.38188L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,128,67.2,82.4A8,8,0,0,1,64,76V40a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8V75.6412a8,8,0,0,1-3.17594,6.38188L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,128,67.2,173.6A8,8,0,0,0,64,180v36a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V180.3588a8,8,0,0,0-3.17594-6.38188L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7t = [];
/* style */

const __vue_inject_styles__$7t = undefined;
/* scoped */

const __vue_scope_id__$7t = undefined;
/* module identifier */

const __vue_module_identifier__$7t = undefined;
/* functional template */

const __vue_is_functional_template__$7t = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7t = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7t,
  staticRenderFns: __vue_staticRenderFns__$7t
}, __vue_inject_styles__$7t, __vue_script__$7t, __vue_scope_id__$7t, __vue_is_functional_template__$7t, __vue_module_identifier__$7t, false, undefined, undefined, undefined);

var script$7u = Vue.extend({
  name: "PhHourglassHigh",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7u = script$7u;
/* template */

var __vue_render__$7u = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,128,67.2,82.4A8,8,0,0,1,64,76V40a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8V75.6412a8,8,0,0,1-3.17594,6.38188L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,128,67.2,173.6A8,8,0,0,0,64,180v36a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V180.3588a8,8,0,0,0-3.17594-6.38188L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "71.99548",
      "x2": "192",
      "y2": "71.99548",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,128,67.2,82.4A8,8,0,0,1,64,76V63.99548H192V75.6412a8,8,0,0,1-3.17594,6.38188L128,128h0",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "63.99548",
      "x2": "192",
      "y2": "63.99548",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,128,67.2,82.4A8,8,0,0,1,64,76V40a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8V75.6412a8,8,0,0,1-3.17594,6.38188L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,128,67.2,173.6A8,8,0,0,0,64,180v36a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V180.3588a8,8,0,0,0-3.17594-6.38188L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,75.64111V40a16.01833,16.01833,0,0,0-16-16H72A16.01833,16.01833,0,0,0,56,40V76a16.07553,16.07553,0,0,0,6.3999,12.7998L114.667,128l-52.2666,39.2002A16.07459,16.07459,0,0,0,56,180v36a16.01833,16.01833,0,0,0,16,16H184a16.01833,16.01833,0,0,0,16-16V180.35889a16.08452,16.08452,0,0,0-6.352-12.76416L141.2666,128l52.38184-39.59473A16.08547,16.08547,0,0,0,200,75.64111ZM184,40V63.99561H72V40Zm0,176H72V180l55.98145-41.98584L184,180.35889Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,128,67.2,82.4A8,8,0,0,1,64,76V40a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8V75.6412a8,8,0,0,1-3.17594,6.38188L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,128,67.2,173.6A8,8,0,0,0,64,180v36a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V180.3588a8,8,0,0,0-3.17594-6.38188L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "63.99548",
      "x2": "192",
      "y2": "63.99548",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,128,67.2,82.4A8,8,0,0,1,64,76V40a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8V75.6412a8,8,0,0,1-3.17594,6.38188L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,128,67.2,173.6A8,8,0,0,0,64,180v36a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V180.3588a8,8,0,0,0-3.17594-6.38188L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "63.99548",
      "x2": "192",
      "y2": "63.99548",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,128,67.2,82.4A8,8,0,0,1,64,76V40a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8V75.6412a8,8,0,0,1-3.17594,6.38188L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,128,67.2,173.6A8,8,0,0,0,64,180v36a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V180.3588a8,8,0,0,0-3.17594-6.38188L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "63.99548",
      "x2": "192",
      "y2": "63.99548",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7u = [];
/* style */

const __vue_inject_styles__$7u = undefined;
/* scoped */

const __vue_scope_id__$7u = undefined;
/* module identifier */

const __vue_module_identifier__$7u = undefined;
/* functional template */

const __vue_is_functional_template__$7u = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7u = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7u,
  staticRenderFns: __vue_staticRenderFns__$7u
}, __vue_inject_styles__$7u, __vue_script__$7u, __vue_scope_id__$7u, __vue_is_functional_template__$7u, __vue_module_identifier__$7u, false, undefined, undefined, undefined);

var script$7v = Vue.extend({
  name: "PhHourglassLow",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7v = script$7v;
/* template */

var __vue_render__$7v = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,128,67.2,82.4A8,8,0,0,1,64,76V40a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8V75.6412a8,8,0,0,1-3.17594,6.38188L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,128,67.2,173.6A8,8,0,0,0,64,180v36a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V180.3588a8,8,0,0,0-3.17594-6.38188L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "180.3588",
      "x2": "64",
      "y2": "180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M64,180v36a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V180.3588Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,128,67.2,82.4A8,8,0,0,1,64,76V40a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8V75.6412a8,8,0,0,1-3.17594,6.38188L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,128,67.2,173.6A8,8,0,0,0,64,180v36a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V180.3588a8,8,0,0,0-3.17594-6.38188L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "180.3588",
      "x2": "64",
      "y2": "180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,75.64111V40a16.01833,16.01833,0,0,0-16-16H72A16.01833,16.01833,0,0,0,56,40V76a16.07589,16.07589,0,0,0,6.3999,12.7998L114.667,128l-52.2666,39.2002a16.06134,16.06134,0,0,0-6.34814,11.92236A7.943,7.943,0,0,0,56,180v36a16.01833,16.01833,0,0,0,16,16H184a16.01833,16.01833,0,0,0,16-16V180.35889a8.04861,8.04861,0,0,0-.05273-.89307,16.06854,16.06854,0,0,0-6.29932-11.87061L141.2666,128l52.38184-39.595A16.08467,16.08467,0,0,0,200,75.64111ZM82.59717,172.052l45.38428-34.03784,45.36572,34.29248ZM184,75.64136l-56.01855,42.34448L72,76V40H184Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,128,67.2,82.4A8,8,0,0,1,64,76V40a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8V75.6412a8,8,0,0,1-3.17594,6.38188L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,128,67.2,173.6A8,8,0,0,0,64,180v36a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V180.3588a8,8,0,0,0-3.17594-6.38188L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "180.3588",
      "x2": "64",
      "y2": "180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,128,67.2,82.4A8,8,0,0,1,64,76V40a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8V75.6412a8,8,0,0,1-3.17594,6.38188L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,128,67.2,173.6A8,8,0,0,0,64,180v36a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V180.3588a8,8,0,0,0-3.17594-6.38188L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "180.3588",
      "x2": "64",
      "y2": "180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,128,67.2,82.4A8,8,0,0,1,64,76V40a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8V75.6412a8,8,0,0,1-3.17594,6.38188L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,128,67.2,173.6A8,8,0,0,0,64,180v36a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V180.3588a8,8,0,0,0-3.17594-6.38188L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "180.3588",
      "x2": "64",
      "y2": "180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7v = [];
/* style */

const __vue_inject_styles__$7v = undefined;
/* scoped */

const __vue_scope_id__$7v = undefined;
/* module identifier */

const __vue_module_identifier__$7v = undefined;
/* functional template */

const __vue_is_functional_template__$7v = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7v = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7v,
  staticRenderFns: __vue_staticRenderFns__$7v
}, __vue_inject_styles__$7v, __vue_script__$7v, __vue_scope_id__$7v, __vue_is_functional_template__$7v, __vue_module_identifier__$7v, false, undefined, undefined, undefined);

var script$7w = Vue.extend({
  name: "PhHourglassMedium",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7w = script$7w;
/* template */

var __vue_render__$7w = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "69.32731",
      "y1": "83.99548",
      "x2": "186.21472",
      "y2": "83.99548",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,128,67.2,82.4A8,8,0,0,1,64,76V40a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8V75.6412a8,8,0,0,1-3.17594,6.38188L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,128,67.2,173.6A8,8,0,0,0,64,180v36a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V180.3588a8,8,0,0,0-3.17594-6.38188L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "167.99548",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "128 128 180.923 87.995 74.661 87.995 128 128",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,128,67.2,82.4A8,8,0,0,1,64,76V40a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8V75.6412a8,8,0,0,1-3.17594,6.38188L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,128,67.2,173.6A8,8,0,0,0,64,180v36a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V180.3588a8,8,0,0,0-3.17594-6.38188L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "167.99548",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "74.66065",
      "y1": "87.99548",
      "x2": "180.92301",
      "y2": "87.99548",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M193.64844,88.40527A16.08547,16.08547,0,0,0,200,75.64111V40a16.01833,16.01833,0,0,0-16-16H72A16.01833,16.01833,0,0,0,56,40V76a16.07553,16.07553,0,0,0,6.3999,12.7998l18.127,13.59522.00048.00049L114.6665,128,62.40039,167.2002A16.07459,16.07459,0,0,0,56,180v36a16.01833,16.01833,0,0,0,16,16H184a16.01833,16.01833,0,0,0,16-16V180.35889a16.08452,16.08452,0,0,0-6.352-12.76416L141.2666,128l22.70459-17.16211ZM72,40H184V75.6416l-5.76025,4.354H77.32764L72,76ZM184,180.35889V216H72V180l48-36v23.99561a8,8,0,0,0,16,0V144.07568Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "74.66065",
      "y1": "87.99548",
      "x2": "180.92301",
      "y2": "87.99548",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,128,67.2,82.4A8,8,0,0,1,64,76V40a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8V75.6412a8,8,0,0,1-3.17594,6.38188L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,128,67.2,173.6A8,8,0,0,0,64,180v36a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V180.3588a8,8,0,0,0-3.17594-6.38188L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "167.99548",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "74.66065",
      "y1": "87.99548",
      "x2": "180.92301",
      "y2": "87.99548",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,128,67.2,82.4A8,8,0,0,1,64,76V40a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8V75.6412a8,8,0,0,1-3.17594,6.38188L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,128,67.2,173.6A8,8,0,0,0,64,180v36a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V180.3588a8,8,0,0,0-3.17594-6.38188L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "167.99548",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,128,67.2,82.4A8,8,0,0,1,64,76V40a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8V75.6412a8,8,0,0,1-3.17594,6.38188L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,128,67.2,173.6A8,8,0,0,0,64,180v36a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V180.3588a8,8,0,0,0-3.17594-6.38188L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "74.66065",
      "y1": "87.99548",
      "x2": "180.92301",
      "y2": "87.99548",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "167.99548",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7w = [];
/* style */

const __vue_inject_styles__$7w = undefined;
/* scoped */

const __vue_scope_id__$7w = undefined;
/* module identifier */

const __vue_module_identifier__$7w = undefined;
/* functional template */

const __vue_is_functional_template__$7w = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7w = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7w,
  staticRenderFns: __vue_staticRenderFns__$7w
}, __vue_inject_styles__$7w, __vue_script__$7w, __vue_scope_id__$7w, __vue_is_functional_template__$7w, __vue_module_identifier__$7w, false, undefined, undefined, undefined);

var script$7x = Vue.extend({
  name: "PhHourglassSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7x = script$7x;
/* template */

var __vue_render__$7x = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M59.31371,40H196.68629a8,8,0,0,1,5.65686,13.65685L128,128,53.65685,53.65685A8,8,0,0,1,59.31371,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M59.31371,216H196.68629a8,8,0,0,0,5.65686-13.65685L128,128,53.65685,202.34315A8,8,0,0,0,59.31371,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M59.31371,40H196.68629a8,8,0,0,1,5.65686,13.65685L53.65685,202.34315A8,8,0,0,0,59.31371,216H196.68629a8,8,0,0,0,5.65686-13.65685L53.65685,53.65685A8,8,0,0,1,59.31371,40Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M59.31371,40H196.68629a8,8,0,0,1,5.65686,13.65685L128,128,53.65685,53.65685A8,8,0,0,1,59.31371,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M59.31371,216H196.68629a8,8,0,0,0,5.65686-13.65685L128,128,53.65685,202.34315A8,8,0,0,0,59.31371,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M139.31543,127.99854,208,59.31348A15.9999,15.9999,0,0,0,196.68652,32H59.31348A15.9999,15.9999,0,0,0,48,59.31348l68.68457,68.688L48,196.68652A15.9999,15.9999,0,0,0,59.31348,224h137.373A15.9999,15.9999,0,0,0,208,196.68652Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M59.31371,40H196.68629a8,8,0,0,1,5.65686,13.65685L128,128,53.65685,53.65685A8,8,0,0,1,59.31371,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M59.31371,216H196.68629a8,8,0,0,0,5.65686-13.65685L128,128,53.65685,202.34315A8,8,0,0,0,59.31371,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M59.31371,40H196.68629a8,8,0,0,1,5.65686,13.65685L128,128,53.65685,53.65685A8,8,0,0,1,59.31371,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M59.31371,216H196.68629a8,8,0,0,0,5.65686-13.65685L128,128,53.65685,202.34315A8,8,0,0,0,59.31371,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M59.31371,40H196.68629a8,8,0,0,1,5.65686,13.65685L128,128,53.65685,53.65685A8,8,0,0,1,59.31371,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M59.31371,216H196.68629a8,8,0,0,0,5.65686-13.65685L128,128,53.65685,202.34315A8,8,0,0,0,59.31371,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7x = [];
/* style */

const __vue_inject_styles__$7x = undefined;
/* scoped */

const __vue_scope_id__$7x = undefined;
/* module identifier */

const __vue_module_identifier__$7x = undefined;
/* functional template */

const __vue_is_functional_template__$7x = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7x = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7x,
  staticRenderFns: __vue_staticRenderFns__$7x
}, __vue_inject_styles__$7x, __vue_script__$7x, __vue_scope_id__$7x, __vue_is_functional_template__$7x, __vue_module_identifier__$7x, false, undefined, undefined, undefined);

var script$7y = Vue.extend({
  name: "PhHourglassSimpleHigh",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7y = script$7y;
/* template */

var __vue_render__$7y = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M59.31371,40H196.68629a8,8,0,0,1,5.65686,13.65685L128,128,53.65685,53.65685A8,8,0,0,1,59.31371,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M59.31371,216H196.68629a8,8,0,0,0,5.65686-13.65685L128,128,53.65685,202.34315A8,8,0,0,0,59.31371,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "80",
      "x2": "176",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "128 128 184 72 72 72 128 128",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M59.31371,40H196.68629a8,8,0,0,1,5.65686,13.65685L128,128,53.65685,53.65685A8,8,0,0,1,59.31371,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M59.31371,216H196.68629a8,8,0,0,0,5.65686-13.65685L128,128,53.65685,202.34315A8,8,0,0,0,59.31371,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "72",
      "x2": "184",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M139.31543,127.99854l50.34082-50.34107.001-.00122L208,59.31348A15.9999,15.9999,0,0,0,196.68652,32H59.31348A15.9999,15.9999,0,0,0,48,59.31348l68.68457,68.688L48,196.68652A15.9999,15.9999,0,0,0,59.31348,224h137.373A15.9999,15.9999,0,0,0,208,196.68652Zm57.36621-79.99366L180.68652,64H75.31982L59.32031,48ZM59.31836,207.99512l68.67969-68.67969L196.67969,208Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M59.31371,40H196.68629a8,8,0,0,1,5.65686,13.65685L128,128,53.65685,53.65685A8,8,0,0,1,59.31371,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M59.31371,216H196.68629a8,8,0,0,0,5.65686-13.65685L128,128,53.65685,202.34315A8,8,0,0,0,59.31371,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "72",
      "x2": "184",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M59.31371,40H196.68629a8,8,0,0,1,5.65686,13.65685L128,128,53.65685,53.65685A8,8,0,0,1,59.31371,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M59.31371,216H196.68629a8,8,0,0,0,5.65686-13.65685L128,128,53.65685,202.34315A8,8,0,0,0,59.31371,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "72",
      "x2": "184",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M59.31371,40H196.68629a8,8,0,0,1,5.65686,13.65685L128,128,53.65685,53.65685A8,8,0,0,1,59.31371,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M59.31371,216H196.68629a8,8,0,0,0,5.65686-13.65685L128,128,53.65685,202.34315A8,8,0,0,0,59.31371,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "72",
      "x2": "184",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7y = [];
/* style */

const __vue_inject_styles__$7y = undefined;
/* scoped */

const __vue_scope_id__$7y = undefined;
/* module identifier */

const __vue_module_identifier__$7y = undefined;
/* functional template */

const __vue_is_functional_template__$7y = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7y = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7y,
  staticRenderFns: __vue_staticRenderFns__$7y
}, __vue_inject_styles__$7y, __vue_script__$7y, __vue_scope_id__$7y, __vue_is_functional_template__$7y, __vue_module_identifier__$7y, false, undefined, undefined, undefined);

var script$7z = Vue.extend({
  name: "PhHourglassSimpleLow",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7z = script$7z;
/* template */

var __vue_render__$7z = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M59.31371,40H196.68629a8,8,0,0,1,5.65686,13.65685L128,128,53.65685,53.65685A8,8,0,0,1,59.31371,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M59.31371,216H196.68629a8,8,0,0,0,5.65686-13.65685L128,128,53.65685,202.34315A8,8,0,0,0,59.31371,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "176",
      "x2": "80",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M53.65685,202.34315A8,8,0,0,0,59.31371,216H196.68629a8,8,0,0,0,5.65686-13.65685L176,176H80Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M59.31371,40H196.68629a8,8,0,0,1,5.65686,13.65685L128,128,53.65685,53.65685A8,8,0,0,1,59.31371,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M59.31371,216H196.68629a8,8,0,0,0,5.65686-13.65685L128,128,53.65685,202.34315A8,8,0,0,0,59.31371,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "176",
      "x2": "80",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M139.31543,127.99854,208,59.31348A15.9999,15.9999,0,0,0,196.68652,32H59.31348A15.9999,15.9999,0,0,0,48,59.31348l68.68457,68.688L48,196.68652A15.9999,15.9999,0,0,0,59.31348,224h137.373A15.9999,15.9999,0,0,0,208,196.68652ZM59.32031,48l137.36133.00488L128.002,116.68457Zm68.67774,91.31543L156.68115,168H99.31348Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M59.31371,40H196.68629a8,8,0,0,1,5.65686,13.65685L128,128,53.65685,53.65685A8,8,0,0,1,59.31371,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M59.31371,216H196.68629a8,8,0,0,0,5.65686-13.65685L128,128,53.65685,202.34315A8,8,0,0,0,59.31371,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "176",
      "x2": "80",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M59.31371,40H196.68629a8,8,0,0,1,5.65686,13.65685L128,128,53.65685,53.65685A8,8,0,0,1,59.31371,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M59.31371,216H196.68629a8,8,0,0,0,5.65686-13.65685L128,128,53.65685,202.34315A8,8,0,0,0,59.31371,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "176",
      "x2": "80",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M59.31371,40H196.68629a8,8,0,0,1,5.65686,13.65685L128,128,53.65685,53.65685A8,8,0,0,1,59.31371,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M59.31371,216H196.68629a8,8,0,0,0,5.65686-13.65685L128,128,53.65685,202.34315A8,8,0,0,0,59.31371,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "176",
      "x2": "80",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7z = [];
/* style */

const __vue_inject_styles__$7z = undefined;
/* scoped */

const __vue_scope_id__$7z = undefined;
/* module identifier */

const __vue_module_identifier__$7z = undefined;
/* functional template */

const __vue_is_functional_template__$7z = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7z = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7z,
  staticRenderFns: __vue_staticRenderFns__$7z
}, __vue_inject_styles__$7z, __vue_script__$7z, __vue_scope_id__$7z, __vue_is_functional_template__$7z, __vue_module_identifier__$7z, false, undefined, undefined, undefined);

var script$7A = Vue.extend({
  name: "PhHourglassSimpleMedium",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7A = script$7A;
/* template */

var __vue_render__$7A = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M59.31371,40H196.68629a8,8,0,0,1,5.65686,13.65685L128,128,53.65685,53.65685A8,8,0,0,1,59.31371,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M59.31371,216H196.68629a8,8,0,0,0,5.65686-13.65685L128,128,53.65685,202.34315A8,8,0,0,0,59.31371,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "80",
      "x2": "80",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "128 128 176 80 80 80 128 128",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M59.31371,40H196.68629a8,8,0,0,1,5.65686,13.65685L128,128,53.65685,53.65685A8,8,0,0,1,59.31371,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M59.31371,216H196.68629a8,8,0,0,0,5.65686-13.65685L128,128,53.65685,202.34315A8,8,0,0,0,59.31371,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "80",
      "x2": "80",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M139.31543,127.99854l34.34082-34.34107.001-.00122L208,59.31348A15.9999,15.9999,0,0,0,196.68652,32H59.31348A15.9999,15.9999,0,0,0,48,59.31348l68.68457,68.688L48,196.68652A15.9999,15.9999,0,0,0,59.31348,224h137.373A15.9999,15.9999,0,0,0,208,196.68652Zm57.36621-79.99366L172.68652,72H83.31934l-23.999-24ZM59.31836,207.99512,120,147.31348V168a8,8,0,0,0,16,0V147.31775L196.67969,208Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M59.31371,40H196.68629a8,8,0,0,1,5.65686,13.65685L128,128,53.65685,53.65685A8,8,0,0,1,59.31371,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M59.31371,216H196.68629a8,8,0,0,0,5.65686-13.65685L128,128,53.65685,202.34315A8,8,0,0,0,59.31371,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "80",
      "x2": "80",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M59.31371,40H196.68629a8,8,0,0,1,5.65686,13.65685L128,128,53.65685,53.65685A8,8,0,0,1,59.31371,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M59.31371,216H196.68629a8,8,0,0,0,5.65686-13.65685L128,128,53.65685,202.34315A8,8,0,0,0,59.31371,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "80",
      "x2": "80",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M59.31371,40H196.68629a8,8,0,0,1,5.65686,13.65685L128,128,53.65685,53.65685A8,8,0,0,1,59.31371,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M59.31371,216H196.68629a8,8,0,0,0,5.65686-13.65685L128,128,53.65685,202.34315A8,8,0,0,0,59.31371,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "80",
      "x2": "80",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7A = [];
/* style */

const __vue_inject_styles__$7A = undefined;
/* scoped */

const __vue_scope_id__$7A = undefined;
/* module identifier */

const __vue_module_identifier__$7A = undefined;
/* functional template */

const __vue_is_functional_template__$7A = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7A = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7A,
  staticRenderFns: __vue_staticRenderFns__$7A
}, __vue_inject_styles__$7A, __vue_script__$7A, __vue_scope_id__$7A, __vue_is_functional_template__$7A, __vue_module_identifier__$7A, false, undefined, undefined, undefined);

var script$7B = Vue.extend({
  name: "PhHouse",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7B = script$7B;
/* template */

var __vue_render__$7B = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M151.99414,207.99263v-48.001a8,8,0,0,0-8-8h-32a8,8,0,0,0-8,8v48.001a8,8,0,0,1-7.999,8l-47.99414.00632a8,8,0,0,1-8.001-8v-92.4604a8,8,0,0,1,2.61811-5.91906l79.9945-72.73477a8,8,0,0,1,10.76339-.00036l80.0055,72.73509A8,8,0,0,1,216,115.53887V207.999a8,8,0,0,1-8.001,8l-48.00586-.00632A8,8,0,0,1,151.99414,207.99263Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M151.99414,207.99263v-48.001a8,8,0,0,0-8-8h-32a8,8,0,0,0-8,8v48.001a8,8,0,0,1-7.999,8l-47.99414.00632a8,8,0,0,1-8.001-8v-92.4604a8,8,0,0,1,2.61811-5.91906l79.9945-72.73477a8,8,0,0,1,10.76339-.00036l80.0055,72.73509A8,8,0,0,1,216,115.53887V207.999a8,8,0,0,1-8.001,8l-48.00586-.00632A8,8,0,0,1,151.99414,207.99263Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M151.99414,207.99263v-48.001a8,8,0,0,0-8-8h-32a8,8,0,0,0-8,8v48.001a8,8,0,0,1-7.999,8l-47.99414.00632a8,8,0,0,1-8.001-8v-92.4604a8,8,0,0,1,2.61811-5.91906l79.9945-72.73477a8,8,0,0,1,10.76339-.00036l80.0055,72.73509A8,8,0,0,1,216,115.53887V207.999a8,8,0,0,1-8.001,8l-48.00586-.00632A8,8,0,0,1,151.99414,207.99263Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M218.76367,103.7002,138.75684,30.96436a15.93657,15.93657,0,0,0-21.52637.00146L37.2373,103.69971A16.03108,16.03108,0,0,0,32,115.53857l0,92.09522a16.47275,16.47275,0,0,0,4.01066,10.96174A15.91729,15.91729,0,0,0,48.002,223.999H95.96484a8,8,0,0,0,8-8V167.9917a8,8,0,0,1,8-8h32a8,8,0,0,1,8,8V215.999a8,8,0,0,0,8,8h48.05731a15.40625,15.40625,0,0,0,7.53406-1.85584A16.08415,16.08415,0,0,0,224,207.999v-92.46A16.03567,16.03567,0,0,0,218.76367,103.7002Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M151.99414,207.99263v-48.001a8,8,0,0,0-8-8h-32a8,8,0,0,0-8,8v48.001a8,8,0,0,1-7.999,8l-47.99414.00632a8,8,0,0,1-8.001-8v-92.4604a8,8,0,0,1,2.61811-5.91906l79.9945-72.73477a8,8,0,0,1,10.76339-.00036l80.0055,72.73509A8,8,0,0,1,216,115.53887V207.999a8,8,0,0,1-8.001,8l-48.00586-.00632A8,8,0,0,1,151.99414,207.99263Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M151.99414,207.99263v-48.001a8,8,0,0,0-8-8h-32a8,8,0,0,0-8,8v48.001a8,8,0,0,1-7.999,8l-47.99414.00632a8,8,0,0,1-8.001-8v-92.4604a8,8,0,0,1,2.61811-5.91906l79.9945-72.73477a8,8,0,0,1,10.76339-.00036l80.0055,72.73509A8,8,0,0,1,216,115.53887V207.999a8,8,0,0,1-8.001,8l-48.00586-.00632A8,8,0,0,1,151.99414,207.99263Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M151.99414,207.99263v-48.001a8,8,0,0,0-8-8h-32a8,8,0,0,0-8,8v48.001a8,8,0,0,1-7.999,8l-47.99414.00632a8,8,0,0,1-8.001-8v-92.4604a8,8,0,0,1,2.61811-5.91906l79.9945-72.73477a8,8,0,0,1,10.76339-.00036l80.0055,72.73509A8,8,0,0,1,216,115.53887V207.999a8,8,0,0,1-8.001,8l-48.00586-.00632A8,8,0,0,1,151.99414,207.99263Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7B = [];
/* style */

const __vue_inject_styles__$7B = undefined;
/* scoped */

const __vue_scope_id__$7B = undefined;
/* module identifier */

const __vue_module_identifier__$7B = undefined;
/* functional template */

const __vue_is_functional_template__$7B = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7B = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7B,
  staticRenderFns: __vue_staticRenderFns__$7B
}, __vue_inject_styles__$7B, __vue_script__$7B, __vue_scope_id__$7B, __vue_is_functional_template__$7B, __vue_module_identifier__$7B, false, undefined, undefined, undefined);

var script$7C = Vue.extend({
  name: "PhHouseLine",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7C = script$7C;
/* template */

var __vue_render__$7C = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M215.98242,216V115.53887a8,8,0,0,0-2.6185-5.91942l-80.0055-72.73509a8,8,0,0,0-10.76339.00036l-79.9945,72.73477a8,8,0,0,0-2.61811,5.91906V216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "15.98242",
      "y1": "216",
      "x2": "239.98242",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M151.97656,215.99158v-56a8,8,0,0,0-8-8h-32a8,8,0,0,0-8,8v56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M151.96484,215.99158v-64h-48v64L39.9707,216V115.53855a8,8,0,0,1,2.61811-5.91906l79.9945-72.73477a8,8,0,0,1,10.76339-.00036l80.0055,72.73509a8,8,0,0,1,2.6185,5.91942V216Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M215.9707,216V115.53887a8,8,0,0,0-2.6185-5.91942L133.3467,36.88436a8,8,0,0,0-10.76339.00036l-79.9945,72.73477a8,8,0,0,0-2.61811,5.91906V216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "15.9707",
      "y1": "216",
      "x2": "239.9707",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M151.96484,215.99158v-56a8,8,0,0,0-8-8h-32a8,8,0,0,0-8,8v56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M239.9707,208h-16V115.53882A16.03729,16.03729,0,0,0,218.73437,103.7L138.72754,30.96484a15.93607,15.93607,0,0,0-21.52637.001L37.207,103.7a16.034,16.034,0,0,0-5.23633,11.83862V208h-16a8,8,0,1,0,0,16h224a8,8,0,0,0,0-16Zm-88.00586-.0083h-8V208h-32v-.0083h-8v-48a8.00009,8.00009,0,0,1,8-8h32a8.00008,8.00008,0,0,1,8,8Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M215.98828,216V115.53887a8,8,0,0,0-2.6185-5.91942l-80.0055-72.73509a8,8,0,0,0-10.76339.00036l-79.9945,72.73477a8,8,0,0,0-2.61811,5.91906V216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "15.98828",
      "y1": "216",
      "x2": "239.98828",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M151.98242,215.99158v-56a8,8,0,0,0-8-8h-32a8,8,0,0,0-8,8v56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M215.99414,216V115.53887a8,8,0,0,0-2.6185-5.91942l-80.0055-72.73509a8,8,0,0,0-10.76339.00036l-79.9945,72.73477a8,8,0,0,0-2.61811,5.91906V216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "15.99414",
      "y1": "216",
      "x2": "239.99414",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M151.98828,215.99158v-56a8,8,0,0,0-8-8h-32a8,8,0,0,0-8,8v56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,216V115.53887a8,8,0,0,0-2.6185-5.91942L133.376,36.88436a8,8,0,0,0-10.76339.00036l-79.9945,72.73477A8,8,0,0,0,40,115.53855V216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "216",
      "x2": "240",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M151.99414,215.99158v-56a8,8,0,0,0-8-8h-32a8,8,0,0,0-8,8v56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7C = [];
/* style */

const __vue_inject_styles__$7C = undefined;
/* scoped */

const __vue_scope_id__$7C = undefined;
/* module identifier */

const __vue_module_identifier__$7C = undefined;
/* functional template */

const __vue_is_functional_template__$7C = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7C = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7C,
  staticRenderFns: __vue_staticRenderFns__$7C
}, __vue_inject_styles__$7C, __vue_script__$7C, __vue_scope_id__$7C, __vue_is_functional_template__$7C, __vue_module_identifier__$7C, false, undefined, undefined, undefined);

var script$7D = Vue.extend({
  name: "PhHouseSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7D = script$7D;
/* template */

var __vue_render__$7D = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M213.3815,109.61945,133.376,36.88436a8,8,0,0,0-10.76339.00036l-79.9945,72.73477A8,8,0,0,0,40,115.53855V208a8,8,0,0,0,8,8H208a8,8,0,0,0,8-8V115.53887A8,8,0,0,0,213.3815,109.61945Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M213.3815,109.61945,133.376,36.88436a8,8,0,0,0-10.76339.00036l-79.9945,72.73477A8,8,0,0,0,40,115.53855V208a8,8,0,0,0,8,8H208a8,8,0,0,0,8-8V115.53887A8,8,0,0,0,213.3815,109.61945Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M213.3815,109.61945,133.376,36.88436a8,8,0,0,0-10.76339.00036l-79.9945,72.73477A8,8,0,0,0,40,115.53855V208a8,8,0,0,0,8,8H208a8,8,0,0,0,8-8V115.53887A8,8,0,0,0,213.3815,109.61945Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M218.76465,103.70117l-.001-.001L138.75684,30.96484a15.93607,15.93607,0,0,0-21.52637.001L37.23633,103.7002A16.03346,16.03346,0,0,0,32,115.53857V208a16.01833,16.01833,0,0,0,16,16H208a16.01833,16.01833,0,0,0,16-16V115.53906A16.03466,16.03466,0,0,0,218.76465,103.70117Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M213.3815,109.61945,133.376,36.88436a8,8,0,0,0-10.76339.00036l-79.9945,72.73477A8,8,0,0,0,40,115.53855V208a8,8,0,0,0,8,8H208a8,8,0,0,0,8-8V115.53887A8,8,0,0,0,213.3815,109.61945Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M213.3815,109.61945,133.376,36.88436a8,8,0,0,0-10.76339.00036l-79.9945,72.73477A8,8,0,0,0,40,115.53855V208a8,8,0,0,0,8,8H208a8,8,0,0,0,8-8V115.53887A8,8,0,0,0,213.3815,109.61945Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M213.3815,109.61945,133.376,36.88436a8,8,0,0,0-10.76339.00036l-79.9945,72.73477A8,8,0,0,0,40,115.53855V208a8,8,0,0,0,8,8H208a8,8,0,0,0,8-8V115.53887A8,8,0,0,0,213.3815,109.61945Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7D = [];
/* style */

const __vue_inject_styles__$7D = undefined;
/* scoped */

const __vue_scope_id__$7D = undefined;
/* module identifier */

const __vue_module_identifier__$7D = undefined;
/* functional template */

const __vue_is_functional_template__$7D = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7D = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7D,
  staticRenderFns: __vue_staticRenderFns__$7D
}, __vue_inject_styles__$7D, __vue_script__$7D, __vue_scope_id__$7D, __vue_is_functional_template__$7D, __vue_module_identifier__$7D, false, undefined, undefined, undefined);

var script$7E = Vue.extend({
  name: "PhIdentificationBadge",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7E = script$7E;
/* template */

var __vue_render__$7E = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "transform": "translate(256) rotate(90)",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "68",
      "x2": "160",
      "y2": "68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "136",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M83.99963,187.20785a60.00083,60.00083,0,0,1,88.00067-.00007",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,32H56a8,8,0,0,0-8,8V216a8,8,0,0,0,8,8H200a8,8,0,0,0,8-8V40A8,8,0,0,0,200,32ZM128,168a32,32,0,1,1,32-32A32,32,0,0,1,128,168Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "136",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M79.998,191.99792a60.00877,60.00877,0,0,1,96.004-.00225",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "transform": "translate(256) rotate(90)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "64",
      "x2": "160",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,24H56A16.01833,16.01833,0,0,0,40,40V216a16.01833,16.01833,0,0,0,16,16H200a16.01833,16.01833,0,0,0,16-16V40A16.01833,16.01833,0,0,0,200,24ZM96,48h64a8,8,0,0,1,0,16H96a8,8,0,0,1,0-16Zm84.80713,150.39258a8.00059,8.00059,0,0,1-11.20117-1.5918,52.0088,52.0088,0,0,0-83.21143.00195,8,8,0,0,1-12.793-9.60937,67.80944,67.80944,0,0,1,27.428-21.68237,40,40,0,1,1,53.94141-.00037,67.81238,67.81238,0,0,1,27.427,21.68079A8.00016,8.00016,0,0,1,180.80713,198.39258ZM152,136a24,24,0,1,1-24-24A24.0275,24.0275,0,0,1,152,136Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "136",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M79.998,191.99792a60.00877,60.00877,0,0,1,96.004-.00225",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "transform": "translate(256) rotate(90)",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "64",
      "x2": "160",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "136",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M79.998,191.99792a60.00877,60.00877,0,0,1,96.004-.00225",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "transform": "translate(256) rotate(90)",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "64",
      "x2": "160",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "136",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M79.998,191.99792a60.00877,60.00877,0,0,1,96.004-.00225",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "transform": "translate(256) rotate(90)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "64",
      "x2": "160",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7E = [];
/* style */

const __vue_inject_styles__$7E = undefined;
/* scoped */

const __vue_scope_id__$7E = undefined;
/* module identifier */

const __vue_module_identifier__$7E = undefined;
/* functional template */

const __vue_is_functional_template__$7E = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7E = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7E,
  staticRenderFns: __vue_staticRenderFns__$7E
}, __vue_inject_styles__$7E, __vue_script__$7E, __vue_scope_id__$7E, __vue_is_functional_template__$7E, __vue_module_identifier__$7E, false, undefined, undefined, undefined);

var script$7F = Vue.extend({
  name: "PhIdentificationCard",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7F = script$7F;
/* template */

var __vue_render__$7F = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "152",
      "y1": "108",
      "x2": "184",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "148",
      "x2": "184",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "94.1004",
      "cy": "116.00005",
      "r": "22",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72.1004,164a22,22,0,0,1,44,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48.00005",
      "width": "192",
      "height": "160",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,48H40a8,8,0,0,0-8,8V200a8,8,0,0,0,8,8H216a8,8,0,0,0,8-8V56A8,8,0,0,0,216,48ZM92.10046,144a24,24,0,1,1,24-24A23.99994,23.99994,0,0,1,92.10046,144Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "112",
      "x2": "192",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "144",
      "x2": "192",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92.10043",
      "cy": "120",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M61.10869,167.99952a32.01032,32.01032,0,0,1,61.98292-.00215",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48.00005",
      "width": "192",
      "height": "160",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M216,40H40A16.01833,16.01833,0,0,0,24,56V200a16.01833,16.01833,0,0,0,16,16H216a16.01833,16.01833,0,0,0,16-16V56A16.01833,16.01833,0,0,0,216,40ZM125.08643,175.74512a8.00256,8.00256,0,0,1-9.74219-5.75293,24.01011,24.01011,0,0,0-46.48779.00146,8.00008,8.00008,0,1,1-15.49512-3.98828,39.896,39.896,0,0,1,16.36023-23.16162,32.00008,32.00008,0,1,1,44.75793,0,39.89755,39.89755,0,0,1,16.35987,23.15918A8.00051,8.00051,0,0,1,125.08643,175.74512ZM192,152H152a8,8,0,0,1,0-16h40a8,8,0,0,1,0,16Zm0-32H152a8,8,0,0,1,0-16h40a8,8,0,0,1,0,16Z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92.10059",
      "cy": "120",
      "r": "16"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "152",
      "y1": "112",
      "x2": "192",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "144",
      "x2": "192",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92.10043",
      "cy": "120",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M61.10869,167.99952a32.01032,32.01032,0,0,1,61.98292-.00215",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48.00005",
      "width": "192",
      "height": "160",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "152",
      "y1": "112",
      "x2": "192",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "144",
      "x2": "192",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92.10043",
      "cy": "120",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M61.10869,167.99952a32.01032,32.01032,0,0,1,61.98292-.00215",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48.00005",
      "width": "192",
      "height": "160",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "152",
      "y1": "112",
      "x2": "192",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "144",
      "x2": "192",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92.10043",
      "cy": "120",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M61.10869,167.99952a32.01032,32.01032,0,0,1,61.98292-.00215",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48.00005",
      "width": "192",
      "height": "160",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7F = [];
/* style */

const __vue_inject_styles__$7F = undefined;
/* scoped */

const __vue_scope_id__$7F = undefined;
/* module identifier */

const __vue_module_identifier__$7F = undefined;
/* functional template */

const __vue_is_functional_template__$7F = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7F = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7F,
  staticRenderFns: __vue_staticRenderFns__$7F
}, __vue_inject_styles__$7F, __vue_script__$7F, __vue_scope_id__$7F, __vue_is_functional_template__$7F, __vue_module_identifier__$7F, false, undefined, undefined, undefined);

var script$7G = Vue.extend({
  name: "PhImage",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7G = script$7G;
/* template */

var __vue_render__$7G = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,167.99982l50.343-50.343a8,8,0,0,1,11.31371,0l44.68629,44.6863a8,8,0,0,0,11.31371,0l20.68629-20.6863a8,8,0,0,1,11.31371,0L223.99982,184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "100",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,167.99982l50.343-50.343a8,8,0,0,1,11.31371,0l44.68629,44.6863a8,8,0,0,0,11.31371,0l20.68629-20.6863a8,8,0,0,1,11.31371,0L223.99982,184,224,56a8,8,0,0,0-8-8H40a8,8,0,0,0-8,8Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,167.99982l50.343-50.343a8,8,0,0,1,11.31371,0l44.68629,44.6863a8,8,0,0,0,11.31371,0l20.68629-20.6863a8,8,0,0,1,11.31371,0L223.99982,184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "100",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M168.001,100.00017v.00341a12.00175,12.00175,0,1,1,0-.00341ZM232,56V200a16.01835,16.01835,0,0,1-16,16H40a16.01835,16.01835,0,0,1-16-16V56A16.01835,16.01835,0,0,1,40,40H216A16.01835,16.01835,0,0,1,232,56Zm-15.9917,108.6936L216,56H40v92.68575L76.68652,112.0002a16.01892,16.01892,0,0,1,22.62793,0L144.001,156.68685l20.68554-20.68658a16.01891,16.01891,0,0,1,22.62793,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,167.99982l50.343-50.343a8,8,0,0,1,11.31371,0l44.68629,44.6863a8,8,0,0,0,11.31371,0l20.68629-20.6863a8,8,0,0,1,11.31371,0L223.99982,184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "100",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,167.99982l50.343-50.343a8,8,0,0,1,11.31371,0l44.68629,44.6863a8,8,0,0,0,11.31371,0l20.68629-20.6863a8,8,0,0,1,11.31371,0L223.99982,184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "100",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,167.99982l50.343-50.343a8,8,0,0,1,11.31371,0l44.68629,44.6863a8,8,0,0,0,11.31371,0l20.68629-20.6863a8,8,0,0,1,11.31371,0L223.99982,184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "100",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7G = [];
/* style */

const __vue_inject_styles__$7G = undefined;
/* scoped */

const __vue_scope_id__$7G = undefined;
/* module identifier */

const __vue_module_identifier__$7G = undefined;
/* functional template */

const __vue_is_functional_template__$7G = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7G = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7G,
  staticRenderFns: __vue_staticRenderFns__$7G
}, __vue_inject_styles__$7G, __vue_script__$7G, __vue_scope_id__$7G, __vue_is_functional_template__$7G, __vue_module_identifier__$7G, false, undefined, undefined, undefined);

var script$7H = Vue.extend({
  name: "PhImageSquare",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7H = script$7H;
/* template */

var __vue_render__$7H = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M215.99982,159.99982l-42.343-42.343a8,8,0,0,0-11.3137,0l-44.6863,44.6863a8,8,0,0,1-11.3137,0l-20.6863-20.6863a8,8,0,0,0-11.3137,0L40,176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "100",
      "cy": "92",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,176V48a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8V160l-.00018-.00018-42.343-42.343a8,8,0,0,0-11.3137,0l-44.6863,44.6863a8,8,0,0,1-11.3137,0l-20.6863-20.6863a8,8,0,0,0-11.3137,0Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M215.99982,159.99982l-42.343-42.343a8,8,0,0,0-11.3137,0l-44.6863,44.6863a8,8,0,0,1-11.3137,0l-20.6863-20.6863a8,8,0,0,0-11.3137,0L40,176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "100",
      "cy": "92",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('circle', {
    attrs: {
      "cx": "99.99951",
      "cy": "92",
      "r": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208.00049,31.99963h-160a16.01833,16.01833,0,0,0-16,16V175.97369l-.001.0307.001,31.99524a16.01833,16.01833,0,0,0,16,16h160a16.01833,16.01833,0,0,0,16-16v-160A16.01834,16.01834,0,0,0,208.00049,31.99963Zm-28.68653,80a16.019,16.019,0,0,0-22.62792,0l-44.68555,44.68653L91.314,135.99963a16.02161,16.02161,0,0,0-22.62792,0L48.00049,156.68457V47.99963h160l.00586,92.6922Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M215.99982,159.99982l-42.343-42.343a8,8,0,0,0-11.3137,0l-44.6863,44.6863a8,8,0,0,1-11.3137,0l-20.6863-20.6863a8,8,0,0,0-11.3137,0L40,176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "100",
      "cy": "92",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M215.99982,159.99982l-42.343-42.343a8,8,0,0,0-11.3137,0l-44.6863,44.6863a8,8,0,0,1-11.3137,0l-20.6863-20.6863a8,8,0,0,0-11.3137,0L40,176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "100",
      "cy": "92",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M215.99982,159.99982l-42.343-42.343a8,8,0,0,0-11.3137,0l-44.6863,44.6863a8,8,0,0,1-11.3137,0l-20.6863-20.6863a8,8,0,0,0-11.3137,0L40,176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "100",
      "cy": "92",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7H = [];
/* style */

const __vue_inject_styles__$7H = undefined;
/* scoped */

const __vue_scope_id__$7H = undefined;
/* module identifier */

const __vue_module_identifier__$7H = undefined;
/* functional template */

const __vue_is_functional_template__$7H = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7H = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7H,
  staticRenderFns: __vue_staticRenderFns__$7H
}, __vue_inject_styles__$7H, __vue_script__$7H, __vue_scope_id__$7H, __vue_is_functional_template__$7H, __vue_module_identifier__$7H, false, undefined, undefined, undefined);

var script$7I = Vue.extend({
  name: "PhInfinity",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7I = script$7I;
/* template */

var __vue_render__$7I = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M101.28431,158.16615l-3.34318,3.775a48,48,0,1,1,0-67.88226l60.11774,67.88226a48,48,0,1,0,0-67.88226l-3.34318,3.775",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M106.62747,152.1329l-8.68634,9.80823a48,48,0,1,1,0-67.88226l60.11774,67.88226a48,48,0,1,0,0-67.88226l-8.68634,9.80823",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M248,128a55.99955,55.99955,0,0,1-95.59766,39.59766q-.17137-.17139-.332-.35254L92.11963,99.55225a40,40,0,1,0,0,56.8955l8.519-9.61914a8,8,0,1,1,11.97754,10.6084l-8.68652,9.80811q-.16041.1809-.332.35254a56,56,0,1,1,0-79.19532q.17137.17139.332.35254l59.95068,67.69287a40,40,0,1,0,0-56.8955l-8.519,9.61914A8,8,0,0,1,143.38379,98.563l8.68652-9.80811q.16041-.1809.332-.35254A56,56,0,0,1,248,128Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M106.62747,152.1329l-8.68634,9.80823a48,48,0,1,1,0-67.88226l60.11774,67.88226a48,48,0,1,0,0-67.88226l-8.68634,9.80823",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M106.62747,152.1329l-8.68634,9.80823a48,48,0,1,1,0-67.88226l60.11774,67.88226a48,48,0,1,0,0-67.88226l-8.68634,9.80823",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M106.62747,152.1329l-8.68634,9.80823a48,48,0,1,1,0-67.88226l60.11774,67.88226a48,48,0,1,0,0-67.88226l-8.68634,9.80823",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7I = [];
/* style */

const __vue_inject_styles__$7I = undefined;
/* scoped */

const __vue_scope_id__$7I = undefined;
/* module identifier */

const __vue_module_identifier__$7I = undefined;
/* functional template */

const __vue_is_functional_template__$7I = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7I = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7I,
  staticRenderFns: __vue_staticRenderFns__$7I
}, __vue_inject_styles__$7I, __vue_script__$7I, __vue_scope_id__$7I, __vue_is_functional_template__$7I, __vue_module_identifier__$7I, false, undefined, undefined, undefined);

var script$7J = Vue.extend({
  name: "PhInfo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7J = script$7J;
/* template */

var __vue_render__$7J = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('g', {
    attrs: {
      "opacity": "0.1"
    }
  }, [_c('rect', {
    attrs: {
      "x": "0.00146",
      "width": "256",
      "height": "256",
      "fill": "none"
    }
  })]), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128.00146",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "120.001 124 128.001 124 128.001 176 136.001 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "126",
      "cy": "84",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('g', {
    attrs: {
      "opacity": "0.1"
    }
  }, [_c('rect', {
    attrs: {
      "x": "0.00244",
      "width": "256",
      "height": "256",
      "fill": "none"
    }
  })]), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128.00244",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128.00244",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "120.002 120 128.002 120 128.002 176 136.002 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "126.00244",
      "cy": "84",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', {
    attrs: {
      "opacity": "0.1"
    }
  }, [_c('rect', {
    attrs: {
      "x": "0.00195",
      "width": "256",
      "height": "256",
      "fill": "none"
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128.00146,23.99963a104,104,0,1,0,104,104A104.11791,104.11791,0,0,0,128.00146,23.99963ZM126.002,72a12,12,0,1,1-12,12A12,12,0,0,1,126.002,72Zm9.99951,111.99963h-8a8.0004,8.0004,0,0,1-8-8v-48a8,8,0,1,1,0-16h8a8.00039,8.00039,0,0,1,8,8v48a8,8,0,0,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('g', {
    attrs: {
      "opacity": "0.1"
    }
  }, [_c('rect', {
    attrs: {
      "x": "0.00098",
      "width": "256",
      "height": "256",
      "fill": "none"
    }
  })]), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128.00098",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "120 120 128.001 120 128 176 136 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "126",
      "cy": "84",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('g', {
    attrs: {
      "opacity": "0.1"
    }
  }, [_c('rect', {
    attrs: {
      "x": "0.00049",
      "width": "256",
      "height": "256",
      "fill": "none"
    }
  })]), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128.00049",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "120 120 128 120 128 176 136 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "126.00049",
      "cy": "84",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('g', {
    attrs: {
      "opacity": "0.1"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "120 120 128 120 128 176 136 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "126",
      "cy": "84",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7J = [];
/* style */

const __vue_inject_styles__$7J = undefined;
/* scoped */

const __vue_scope_id__$7J = undefined;
/* module identifier */

const __vue_module_identifier__$7J = undefined;
/* functional template */

const __vue_is_functional_template__$7J = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7J = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7J,
  staticRenderFns: __vue_staticRenderFns__$7J
}, __vue_inject_styles__$7J, __vue_script__$7J, __vue_scope_id__$7J, __vue_is_functional_template__$7J, __vue_module_identifier__$7J, false, undefined, undefined, undefined);

var script$7K = Vue.extend({
  name: "PhInstagramLogo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7K = script$7K;
/* template */

var __vue_render__$7K = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "34",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "32",
      "width": "192",
      "height": "192",
      "rx": "48",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "75.99998",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M172,36H84A47.99987,47.99987,0,0,0,36,84v88a47.99988,47.99988,0,0,0,48,48h88a47.99988,47.99988,0,0,0,48-48V84A47.99987,47.99987,0,0,0,172,36ZM128,168a40,40,0,1,1,40-40A40.0001,40.0001,0,0,1,128,168Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "36",
      "y": "36",
      "width": "184",
      "height": "184",
      "rx": "48",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "75.99998",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "32"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M172,28H84A56.06353,56.06353,0,0,0,28,84v88a56.06353,56.06353,0,0,0,56,56h88a56.06353,56.06353,0,0,0,56-56V84A56.06353,56.06353,0,0,0,172,28ZM128,176a48,48,0,1,1,48-48A48.05436,48.05436,0,0,1,128,176Zm52-88a12,12,0,1,1,12-12A12,12,0,0,1,180,88Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "36",
      "y": "36",
      "width": "184",
      "height": "184",
      "rx": "48",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "75.99998",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "36",
      "y": "36",
      "width": "184",
      "height": "184",
      "rx": "48",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "75.99998",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "36",
      "y": "36",
      "width": "184",
      "height": "184",
      "rx": "48",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "75.99998",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7K = [];
/* style */

const __vue_inject_styles__$7K = undefined;
/* scoped */

const __vue_scope_id__$7K = undefined;
/* module identifier */

const __vue_module_identifier__$7K = undefined;
/* functional template */

const __vue_is_functional_template__$7K = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7K = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7K,
  staticRenderFns: __vue_staticRenderFns__$7K
}, __vue_inject_styles__$7K, __vue_script__$7K, __vue_scope_id__$7K, __vue_is_functional_template__$7K, __vue_module_identifier__$7K, false, undefined, undefined, undefined);

var script$7L = Vue.extend({
  name: "PhIntersect",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7L = script$7L;
/* template */

var __vue_render__$7L = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "96",
      "cy": "96",
      "r": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "160",
      "cy": "160",
      "r": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "109.08829",
      "y1": "109.08829",
      "x2": "146.9117",
      "y2": "146.9117",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M88,160a70.51259,70.51259,0,0,0,.73242,7.26758A70.51259,70.51259,0,0,0,96,168a71.99981,71.99981,0,0,0,72-72,70.51259,70.51259,0,0,0-.73242-7.26758A70.51259,70.51259,0,0,0,160,88,71.99981,71.99981,0,0,0,88,160Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "96",
      "cy": "96",
      "r": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "160",
      "cy": "160",
      "r": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M174.63477,81.36523a79.99168,79.99168,0,1,0-93.26954,93.26954,79.99168,79.99168,0,1,0,93.26954-93.26954ZM32,96A64.00385,64.00385,0,0,1,157.98779,80.05127,80.06522,80.06522,0,0,0,80.051,157.98779,64.1144,64.1144,0,0,1,32,96ZM160,224a64.11421,64.11421,0,0,1-61.98779-48.05127A80.06522,80.06522,0,0,0,175.949,98.01221,64.00389,64.00389,0,0,1,160,224Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "96",
      "cy": "96",
      "r": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "160",
      "cy": "160",
      "r": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "122.51701",
      "y1": "98.51701",
      "x2": "157.48457",
      "y2": "133.48457",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "98.51562",
      "y1": "122.51562",
      "x2": "133.48323",
      "y2": "157.48323",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "96",
      "cy": "96",
      "r": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "160",
      "cy": "160",
      "r": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "122.51701",
      "y1": "98.51701",
      "x2": "157.48457",
      "y2": "133.48457",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "98.51562",
      "y1": "122.51562",
      "x2": "133.48323",
      "y2": "157.48323",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "96",
      "cy": "96",
      "r": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "160",
      "cy": "160",
      "r": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "122.51701",
      "y1": "98.51701",
      "x2": "157.48457",
      "y2": "133.48457",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "98.51562",
      "y1": "122.51562",
      "x2": "133.48323",
      "y2": "157.48323",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7L = [];
/* style */

const __vue_inject_styles__$7L = undefined;
/* scoped */

const __vue_scope_id__$7L = undefined;
/* module identifier */

const __vue_module_identifier__$7L = undefined;
/* functional template */

const __vue_is_functional_template__$7L = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7L = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7L,
  staticRenderFns: __vue_staticRenderFns__$7L
}, __vue_inject_styles__$7L, __vue_script__$7L, __vue_scope_id__$7L, __vue_is_functional_template__$7L, __vue_module_identifier__$7L, false, undefined, undefined, undefined);

var script$7M = Vue.extend({
  name: "PhJeep",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7M = script$7M;
/* template */

var __vue_render__$7M = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M220,176v32a8,8,0,0,1-8,8H188a8,8,0,0,1-8-8V176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76,176v32a8,8,0,0,1-8,8H44a8,8,0,0,1-8-8V176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "96",
      "x2": "240",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "136",
      "x2": "128",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "136",
      "x2": "168",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "136",
      "x2": "88",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M220,176H36V96.00005l7.01877-49.13142A8,8,0,0,1,50.93836,40H205.06164a8,8,0,0,1,7.91959,6.86863L220,96.00005Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M220,176v32a8,8,0,0,1-8,8H188a8,8,0,0,1-8-8V176Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76,176v32a8,8,0,0,1-8,8H44a8,8,0,0,1-8-8V176Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M36,96.00005l7.01877-49.13142A8,8,0,0,1,50.93836,40H205.06164a8,8,0,0,1,7.91959,6.86863L220,96.00005Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M220,176v32a8,8,0,0,1-8,8H188a8,8,0,0,1-8-8V176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76,176v32a8,8,0,0,1-8,8H44a8,8,0,0,1-8-8V176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "96",
      "x2": "240",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "128",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "128",
      "x2": "112",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M220,176H36V96.00005l7.01877-49.13142A8,8,0,0,1,50.93836,40H205.06164a8,8,0,0,1,7.91959,6.86863L220,96.00005Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "72",
      "cy": "132",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "184",
      "cy": "132",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M240,88H226.93848l-6.03809-42.26465A16.07879,16.07879,0,0,0,205.06152,32H50.93848A16.08053,16.08053,0,0,0,35.09863,45.7373L29.06128,88H16a8,8,0,0,0,0,16H28V208a16.01833,16.01833,0,0,0,16,16H68a16.01833,16.01833,0,0,0,16-16V184h20V128a8,8,0,0,1,16,0v56h16V128a8,8,0,0,1,16,0v56h20v24a16.01833,16.01833,0,0,0,16,16h24a16.01833,16.01833,0,0,0,16-16V104h12a8,8,0,0,0,0-16ZM72,144a12,12,0,1,1,12-12A12,12,0,0,1,72,144Zm112,0a12,12,0,1,1,12-12A12,12,0,0,1,184,144Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M220,176v32a8,8,0,0,1-8,8H188a8,8,0,0,1-8-8V176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76,176v32a8,8,0,0,1-8,8H44a8,8,0,0,1-8-8V176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "96",
      "x2": "240",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "128",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "128",
      "x2": "112",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M220,176H36V96.00005l7.01877-49.13142A8,8,0,0,1,50.93836,40H205.06164a8,8,0,0,1,7.91959,6.86863L220,96.00005Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "184",
      "cy": "132",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "72",
      "cy": "132",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M220,176v32a8,8,0,0,1-8,8H188a8,8,0,0,1-8-8V176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76,176v32a8,8,0,0,1-8,8H44a8,8,0,0,1-8-8V176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "96",
      "x2": "240",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "128",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "128",
      "x2": "112",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M220,176H36V96.00005l7.01877-49.13142A8,8,0,0,1,50.93836,40H205.06164a8,8,0,0,1,7.91959,6.86863L220,96.00005Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "72",
      "cy": "132",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "184",
      "cy": "132",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M220,176v32a8,8,0,0,1-8,8H188a8,8,0,0,1-8-8V176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76,176v32a8,8,0,0,1-8,8H44a8,8,0,0,1-8-8V176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "96",
      "x2": "240",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "128",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "128",
      "x2": "112",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M220,176H36V96.00005l7.01877-49.13142A8,8,0,0,1,50.93836,40H205.06164a8,8,0,0,1,7.91959,6.86863L220,96.00005Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "72",
      "cy": "132",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "184",
      "cy": "132",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7M = [];
/* style */

const __vue_inject_styles__$7M = undefined;
/* scoped */

const __vue_scope_id__$7M = undefined;
/* module identifier */

const __vue_module_identifier__$7M = undefined;
/* functional template */

const __vue_is_functional_template__$7M = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7M = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7M,
  staticRenderFns: __vue_staticRenderFns__$7M
}, __vue_inject_styles__$7M, __vue_script__$7M, __vue_scope_id__$7M, __vue_is_functional_template__$7M, __vue_module_identifier__$7M, false, undefined, undefined, undefined);

var script$7N = Vue.extend({
  name: "PhKey",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7N = script$7N;
/* template */

var __vue_render__$7N = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M93.16866,122.8328a71.93648,71.93648,0,1,1,40.0009,40.001l.00062-.00149L120.00244,176h-24v24h-24v24h-40V184l61.168-61.168Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "76",
      "r": "4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24",
      "opacity": "0.5"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "76",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M93.16866,122.8328a71.93648,71.93648,0,1,1,40.0009,40.001l.00062-.00149L120.00244,176h-24v24h-24v24h-40V184l61.168-61.168Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M93.16866,122.8328a71.93648,71.93648,0,1,1,40.0009,40.001l.00062-.00149L120.00244,176h-24v24h-24v24h-40V184l61.168-61.168Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "76",
      "r": "4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16",
      "opacity": "0.5"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "76",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M160.00244,16A80.05817,80.05817,0,0,0,83.91357,120.77539L26.34521,178.34277A8.00235,8.00235,0,0,0,24.00244,184v40a8.00039,8.00039,0,0,0,8,8h40a8.00039,8.00039,0,0,0,8-8V208h16a8.00039,8.00039,0,0,0,8-8V184h16a8.00235,8.00235,0,0,0,5.65723-2.34277l9.56738-9.56836A80.00922,80.00922,0,1,0,160.00244,16ZM180,92a16,16,0,1,1,16-16A16.00016,16.00016,0,0,1,180,92Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M93.16866,122.8328a71.93648,71.93648,0,1,1,40.0009,40.001l.00062-.00149L120.00244,176h-24v24h-24v24h-40V184l61.168-61.168Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "76",
      "r": "4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12",
      "opacity": "0.5"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "76",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M93.16866,122.8328a71.93648,71.93648,0,1,1,40.0009,40.001l.00062-.00149L120.00244,176h-24v24h-24v24h-40V184l61.168-61.168Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "76",
      "r": "4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8",
      "opacity": "0.5"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "76",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M93.16866,122.8328a71.93648,71.93648,0,1,1,40.0009,40.001l.00062-.00149L120.00244,176h-24v24h-24v24h-40V184l61.168-61.168Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "76",
      "r": "4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16",
      "opacity": "0.5"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "76",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7N = [];
/* style */

const __vue_inject_styles__$7N = undefined;
/* scoped */

const __vue_scope_id__$7N = undefined;
/* module identifier */

const __vue_module_identifier__$7N = undefined;
/* functional template */

const __vue_is_functional_template__$7N = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7N = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7N,
  staticRenderFns: __vue_staticRenderFns__$7N
}, __vue_inject_styles__$7N, __vue_script__$7N, __vue_scope_id__$7N, __vue_is_functional_template__$7N, __vue_module_identifier__$7N, false, undefined, undefined, undefined);

var script$7O = Vue.extend({
  name: "PhKeyReturn",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7O = script$7O;
/* template */

var __vue_render__$7O = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 104 176 136 80 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "104 112 80 136 104 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176 104 176 136 80 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "104 112 80 136 104 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,40H40A16.01833,16.01833,0,0,0,24,56V200a16.01833,16.01833,0,0,0,16,16H216a16.01833,16.01833,0,0,0,16-16V56A16.01833,16.01833,0,0,0,216,40Zm-32,96a8.00039,8.00039,0,0,1-8,8H99.314l10.34327,10.34277a8.00053,8.00053,0,0,1-11.31446,11.31446l-24-24c-.05664-.05664-.10449-.11768-.15869-.17578-.12549-.13282-.251-.26514-.36719-.40625-.0913-.11084-.17138-.22706-.25537-.3418-.07031-.09522-.14453-.188-.21093-.28662-.085-.12647-.15918-.25782-.23584-.38819-.05567-.09423-.11524-.186-.167-.2832-.06933-.12891-.12841-.26172-.18994-.39355-.04931-.10547-.10205-.209-.147-.31641-.05225-.12695-.09522-.25586-.14063-.38477-.042-.11816-.0874-.23437-.124-.355-.03906-.1289-.06787-.25976-.10058-.39013-.03077-.12305-.06543-.24414-.09034-.36914-.02978-.15186-.04834-.30469-.06933-.45752-.01465-.106-.03516-.20948-.0459-.3169a8.02276,8.02276,0,0,1,0-1.584c.01074-.10742.03125-.21094.0459-.3169.021-.15283.03955-.30566.06933-.45752.02491-.125.05957-.24609.09034-.36914.03271-.13037.06152-.26123.10058-.39013.03662-.12061.082-.23682.124-.355.04541-.12891.08838-.25782.14063-.38477.04492-.10742.09766-.21094.147-.31641.06153-.13183.12061-.26464.18994-.39355.05176-.09717.11133-.189.167-.2832.07666-.13037.15087-.26172.23584-.38819.0664-.09863.14062-.1914.21093-.28662.084-.11474.16407-.231.25537-.3418.11622-.14111.2417-.27343.36719-.40625.0542-.0581.10205-.11914.15869-.17578l24-24a8.00053,8.00053,0,0,1,11.31446,11.31446L99.314,128H168V104a8,8,0,0,1,16,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 104 176 136 80 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "104 112 80 136 104 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 104 176 136 80 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "104 112 80 136 104 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 104 176 136 80 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "104 112 80 136 104 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7O = [];
/* style */

const __vue_inject_styles__$7O = undefined;
/* scoped */

const __vue_scope_id__$7O = undefined;
/* module identifier */

const __vue_module_identifier__$7O = undefined;
/* functional template */

const __vue_is_functional_template__$7O = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7O = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7O,
  staticRenderFns: __vue_staticRenderFns__$7O
}, __vue_inject_styles__$7O, __vue_script__$7O, __vue_scope_id__$7O, __vue_is_functional_template__$7O, __vue_module_identifier__$7O, false, undefined, undefined, undefined);

var script$7P = Vue.extend({
  name: "PhKeyboard",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7P = script$7P;
/* template */

var __vue_render__$7P = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "56",
      "width": "208",
      "height": "144",
      "rx": "8.48528",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "128",
      "x2": "192",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "92",
      "x2": "192",
      "y2": "92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "164",
      "x2": "72",
      "y2": "164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "108",
      "y1": "164",
      "x2": "148",
      "y2": "164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "164",
      "x2": "192",
      "y2": "164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "56",
      "width": "208",
      "height": "144",
      "rx": "8.48528",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "24",
      "y": "56",
      "width": "208",
      "height": "144",
      "rx": "8.48528",
      "stroke-width": "16.97056",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "128",
      "x2": "200",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "96",
      "x2": "200",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "160",
      "x2": "64",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "160",
      "x2": "160",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "160",
      "x2": "200",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M223.51465,47.51465H32.48535a16.99025,16.99025,0,0,0-16.9707,16.9707v127.0293a16.99025,16.99025,0,0,0,16.9707,16.9707h191.0293a16.99025,16.99025,0,0,0,16.9707-16.9707V64.48535A16.99025,16.99025,0,0,0,223.51465,47.51465ZM64,168H56a8,8,0,0,1,0-16h8a8,8,0,0,1,0,16Zm96,0H96a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm40,0h-8a8,8,0,0,1,0-16h8a8,8,0,0,1,0,16Zm0-32H56a8,8,0,0,1,0-16H200a8,8,0,0,1,0,16Zm0-32H56a8,8,0,0,1,0-16H200a8,8,0,0,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "56",
      "width": "208",
      "height": "144",
      "rx": "8.48528",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "128",
      "x2": "200",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "96",
      "x2": "200",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "160",
      "x2": "64",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "160",
      "x2": "160",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "160",
      "x2": "200",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "56",
      "width": "208",
      "height": "144",
      "rx": "8.48528",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "128",
      "x2": "200",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "96",
      "x2": "200",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "160",
      "x2": "64",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "160",
      "x2": "160",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "160",
      "x2": "200",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "56",
      "width": "208",
      "height": "144",
      "rx": "8.48528",
      "stroke-width": "16.97056",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "128",
      "x2": "200",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "96",
      "x2": "200",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "160",
      "x2": "64",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "160",
      "x2": "160",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "160",
      "x2": "200",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7P = [];
/* style */

const __vue_inject_styles__$7P = undefined;
/* scoped */

const __vue_scope_id__$7P = undefined;
/* module identifier */

const __vue_module_identifier__$7P = undefined;
/* functional template */

const __vue_is_functional_template__$7P = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7P = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7P,
  staticRenderFns: __vue_staticRenderFns__$7P
}, __vue_inject_styles__$7P, __vue_script__$7P, __vue_scope_id__$7P, __vue_is_functional_template__$7P, __vue_module_identifier__$7P, false, undefined, undefined, undefined);

var script$7Q = Vue.extend({
  name: "PhKnife",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7Q = script$7Q;
/* template */

var __vue_render__$7Q = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M146.49075,90.49075,200,144s-72,96-176,72L197.85786,37.85786a20,20,0,1,1,28.28427,28.28427l-50.3665,53.64542",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M146.49075,90.49075l51.36711-52.63289a20,20,0,1,1,28.28427,28.28427l-50.3665,53.64542Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M146.49075,90.49075,200,144s-72,96-176,72L197.85786,37.85786a20,20,0,1,1,28.28427,28.28427l-50.3665,53.64542",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M231.79883,32.2002a28.05536,28.05536,0,0,0-39.667.06933L18.27441,210.41211a8,8,0,0,0,3.92676,13.38281,155.06019,155.06019,0,0,0,34.957,4.00293c33.4209-.001,66.877-10.86914,98.32813-32.1748,31.74512-21.50391,50.14551-45.79981,50.91406-46.82325a8.00114,8.00114,0,0,0-.74316-10.457L186.919,119.60547l44.97753-47.90332A28.03445,28.03445,0,0,0,231.79883,32.2002ZM189.207,144.52148a225.51045,225.51045,0,0,1-43.10351,38.13184c-34.46973,23.23145-69.999,32.665-105.83887,28.13477l106.29492-108.915,23.30176,23.30175q.208.22852.43847.44434l.082.07617Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M146.49075,90.49075,200,144s-72,96-176,72L197.85786,37.85786a20,20,0,1,1,28.28427,28.28427l-50.3665,53.64542",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M146.49075,90.49075,200,144s-72,96-176,72L197.85786,37.85786a20,20,0,1,1,28.28427,28.28427l-50.3665,53.64542",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M146.49075,90.49075,200,144s-72,96-176,72L197.85786,37.85786a20,20,0,1,1,28.28427,28.28427l-50.3665,53.64542",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7Q = [];
/* style */

const __vue_inject_styles__$7Q = undefined;
/* scoped */

const __vue_scope_id__$7Q = undefined;
/* module identifier */

const __vue_module_identifier__$7Q = undefined;
/* functional template */

const __vue_is_functional_template__$7Q = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7Q = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7Q,
  staticRenderFns: __vue_staticRenderFns__$7Q
}, __vue_inject_styles__$7Q, __vue_script__$7Q, __vue_scope_id__$7Q, __vue_is_functional_template__$7Q, __vue_module_identifier__$7Q, false, undefined, undefined, undefined);

var script$7R = Vue.extend({
  name: "PhLamp",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7R = script$7R;
/* template */

var __vue_render__$7R = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M69.27517,40H186.72483a8,8,0,0,1,7.35316,4.84865l41.14286,96A8,8,0,0,1,227.86769,152H28.13231a8,8,0,0,1-7.35316-11.15135l41.14286-96A8,8,0,0,1,69.27517,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "152",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "216",
      "x2": "160",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "152",
      "x2": "200",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M69.27517,40H186.72483a8,8,0,0,1,7.35316,4.84865l41.14286,96A8,8,0,0,1,227.86769,152H28.13231a8,8,0,0,1-7.35316-11.15135l41.14286-96A8,8,0,0,1,69.27517,40Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M69.27517,40H186.72483a8,8,0,0,1,7.35316,4.84865l41.14286,96A8,8,0,0,1,227.86769,152H28.13231a8,8,0,0,1-7.35316-11.15135l41.14286-96A8,8,0,0,1,69.27517,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "152",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "216",
      "x2": "160",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "152",
      "x2": "200",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M241.22559,152.80762A15.95794,15.95794,0,0,1,227.86768,160H208v32a8,8,0,0,1-16,0V160H136v48h24a8,8,0,0,1,0,16H96a8,8,0,0,1,0-16h24V160H28.13232a15.99943,15.99943,0,0,1-14.706-22.30273l41.14258-96A15.98283,15.98283,0,0,1,69.27539,32H186.72461a15.98283,15.98283,0,0,1,14.70654,9.69727l41.14258,96A15.95836,15.95836,0,0,1,241.22559,152.80762Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M69.27517,40H186.72483a8,8,0,0,1,7.35316,4.84865l41.14286,96A8,8,0,0,1,227.86769,152H28.13231a8,8,0,0,1-7.35316-11.15135l41.14286-96A8,8,0,0,1,69.27517,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "152",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "216",
      "x2": "160",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "152",
      "x2": "200",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M69.27517,40H186.72483a8,8,0,0,1,7.35316,4.84865l41.14286,96A8,8,0,0,1,227.86769,152H28.13231a8,8,0,0,1-7.35316-11.15135l41.14286-96A8,8,0,0,1,69.27517,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "152",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "216",
      "x2": "160",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "152",
      "x2": "200",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M69.27517,40H186.72483a8,8,0,0,1,7.35316,4.84865l41.14286,96A8,8,0,0,1,227.86769,152H28.13231a8,8,0,0,1-7.35316-11.15135l41.14286-96A8,8,0,0,1,69.27517,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "152",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "216",
      "x2": "160",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "152",
      "x2": "200",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7R = [];
/* style */

const __vue_inject_styles__$7R = undefined;
/* scoped */

const __vue_scope_id__$7R = undefined;
/* module identifier */

const __vue_module_identifier__$7R = undefined;
/* functional template */

const __vue_is_functional_template__$7R = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7R = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7R,
  staticRenderFns: __vue_staticRenderFns__$7R
}, __vue_inject_styles__$7R, __vue_script__$7R, __vue_scope_id__$7R, __vue_is_functional_template__$7R, __vue_module_identifier__$7R, false, undefined, undefined, undefined);

var script$7S = Vue.extend({
  name: "PhLaptop",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7S = script$7S;
/* template */

var __vue_render__$7S = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,168V72A16,16,0,0,1,56,56H200a16,16,0,0,1,16,16v96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,168H232a0,0,0,0,1,0,0v24a16,16,0,0,1-16,16H40a16,16,0,0,1-16-16V168a0,0,0,0,1,0,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "96",
      "x2": "112",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,176V72A16,16,0,0,1,56,56H200a16,16,0,0,1,16,16V176Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,176V72A16,16,0,0,1,56,56H200a16,16,0,0,1,16,16V176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,176H232a0,0,0,0,1,0,0v16a16,16,0,0,1-16,16H40a16,16,0,0,1-16-16V176A0,0,0,0,1,24,176Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "88",
      "x2": "112",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232,168h-8V72a24.0275,24.0275,0,0,0-24-24H56A24.0275,24.0275,0,0,0,32,72v96H24a8.00008,8.00008,0,0,0-8,8v16a24.0275,24.0275,0,0,0,24,24H216a24.0275,24.0275,0,0,0,24-24V176A8.00008,8.00008,0,0,0,232,168ZM112,72h32a8,8,0,0,1,0,16H112a8,8,0,0,1,0-16ZM224,192a8.00917,8.00917,0,0,1-8,8H40a8.00917,8.00917,0,0,1-8-8v-8H224Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,176V72A16,16,0,0,1,56,56H200a16,16,0,0,1,16,16V176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,176H232a0,0,0,0,1,0,0v16a16,16,0,0,1-16,16H40a16,16,0,0,1-16-16V176A0,0,0,0,1,24,176Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "88",
      "x2": "112",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,176V72A16,16,0,0,1,56,56H200a16,16,0,0,1,16,16V176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,176H232a0,0,0,0,1,0,0v16a16,16,0,0,1-16,16H40a16,16,0,0,1-16-16V176A0,0,0,0,1,24,176Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "88",
      "x2": "112",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,176V72A16,16,0,0,1,56,56H200a16,16,0,0,1,16,16V176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,176H232a0,0,0,0,1,0,0v16a16,16,0,0,1-16,16H40a16,16,0,0,1-16-16V176A0,0,0,0,1,24,176Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "88",
      "x2": "112",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7S = [];
/* style */

const __vue_inject_styles__$7S = undefined;
/* scoped */

const __vue_scope_id__$7S = undefined;
/* module identifier */

const __vue_module_identifier__$7S = undefined;
/* functional template */

const __vue_is_functional_template__$7S = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7S = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7S,
  staticRenderFns: __vue_staticRenderFns__$7S
}, __vue_inject_styles__$7S, __vue_script__$7S, __vue_scope_id__$7S, __vue_is_functional_template__$7S, __vue_module_identifier__$7S, false, undefined, undefined, undefined);

var script$7T = Vue.extend({
  name: "PhLayout",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7T = script$7T;
/* template */

var __vue_render__$7T = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "104",
      "y1": "104",
      "x2": "104",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "104",
      "x2": "224",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M104,208V104H32v96a8,8,0,0,0,8,8H96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "104",
      "x2": "224",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "104",
      "x2": "104",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,40H40A16.01833,16.01833,0,0,0,24,56V200a16.01833,16.01833,0,0,0,16,16H216a16.01833,16.01833,0,0,0,16-16V56A16.01833,16.01833,0,0,0,216,40ZM40,56H216l.00269,40.00012L216,96H40ZM216,200H112V112H216l.00391-.00024L216.00977,200Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "104",
      "y1": "104",
      "x2": "104",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "104",
      "x2": "224",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "104",
      "y1": "104",
      "x2": "104",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "104",
      "x2": "224",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "104",
      "y1": "104",
      "x2": "104",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "104",
      "x2": "224",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7T = [];
/* style */

const __vue_inject_styles__$7T = undefined;
/* scoped */

const __vue_scope_id__$7T = undefined;
/* module identifier */

const __vue_module_identifier__$7T = undefined;
/* functional template */

const __vue_is_functional_template__$7T = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7T = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7T,
  staticRenderFns: __vue_staticRenderFns__$7T
}, __vue_inject_styles__$7T, __vue_script__$7T, __vue_scope_id__$7T, __vue_is_functional_template__$7T, __vue_module_identifier__$7T, false, undefined, undefined, undefined);

var script$7U = Vue.extend({
  name: "PhLeaf",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7U = script$7U;
/* template */

var __vue_render__$7U = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "160",
      "y1": "96",
      "x2": "40",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,192C16,112,80,32,216,40,224,176,144,240,64,192Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M64,192C16,112,80,32,216,40,224,176,144,240,64,192Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "96",
      "x2": "40",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,192C16,112,80,32,216,40,224,176,144,240,64,192Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M223.98633,39.53027a8.00074,8.00074,0,0,0-7.5166-7.5166C140.15625,27.521,79.05371,50.53076,52.99756,93.55322A87.32048,87.32048,0,0,0,40.21191,142.687c.56861,15.95679,5.22315,32.06415,13.824,47.96326l100.30737-100.307a7.99984,7.99984,0,0,1,11.31348,11.31348L65.34961,201.96429c15.89893,8.60053,32.00647,13.25525,47.96338,13.8238,1.11719.04,2.22705.05957,3.33545.05957a87.1861,87.1861,0,0,0,45.79834-12.84473C205.46924,176.94629,228.47461,115.83447,223.98633,39.53027Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M57.14014,196.11621c-1.09119-1.8186-2.11719-3.64123-3.10425-5.46594l-19.69263,19.6925a8.00018,8.00018,0,0,0,11.31348,11.31446l19.69287-19.69294c-1.82446-.98693-3.647-2.01287-5.46533-3.10394A7.99592,7.99592,0,0,1,57.14014,196.11621Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "160",
      "y1": "96",
      "x2": "40",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,192C16,112,80,32,216,40,224,176,144,240,64,192Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "160",
      "y1": "96",
      "x2": "40",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,192C16,112,80,32,216,40,224,176,144,240,64,192Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "160",
      "y1": "96",
      "x2": "40",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,192C16,112,80,32,216,40,224,176,144,240,64,192Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7U = [];
/* style */

const __vue_inject_styles__$7U = undefined;
/* scoped */

const __vue_scope_id__$7U = undefined;
/* module identifier */

const __vue_module_identifier__$7U = undefined;
/* functional template */

const __vue_is_functional_template__$7U = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7U = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7U,
  staticRenderFns: __vue_staticRenderFns__$7U
}, __vue_inject_styles__$7U, __vue_script__$7U, __vue_scope_id__$7U, __vue_is_functional_template__$7U, __vue_module_identifier__$7U, false, undefined, undefined, undefined);

var script$7V = Vue.extend({
  name: "PhLifebuoy",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7V = script$7V;
/* template */

var __vue_render__$7V = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "99.71573",
      "y1": "99.71573",
      "x2": "60.11775",
      "y2": "60.11775",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156.28427",
      "y1": "99.71573",
      "x2": "195.88225",
      "y2": "60.11775",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156.28427",
      "y1": "156.28427",
      "x2": "195.88225",
      "y2": "195.88225",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "99.71573",
      "y1": "156.28427",
      "x2": "60.11775",
      "y2": "195.88225",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M195.88225,60.11775a96,96,0,0,1,0,135.7645l-39.598-39.598a40,40,0,0,0,0-56.56854Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M60.11775,195.88225a96,96,0,0,1,0-135.7645l39.598,39.598a40,40,0,0,0,0,56.56854Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "99.71573",
      "y1": "99.71573",
      "x2": "60.11775",
      "y2": "60.11775",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156.28427",
      "y1": "99.71573",
      "x2": "195.88225",
      "y2": "60.11775",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156.28427",
      "y1": "156.28427",
      "x2": "195.88225",
      "y2": "195.88225",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "99.71573",
      "y1": "156.28427",
      "x2": "60.11775",
      "y2": "195.88225",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M202.16064,200.833a103.80643,103.80643,0,0,0,0-145.666,7.39654,7.39654,0,0,0-1.32666-1.32666,103.80639,103.80639,0,0,0-145.668,0A7.39654,7.39654,0,0,0,53.83936,55.167a103.80643,103.80643,0,0,0,0,145.666,8.09893,8.09893,0,0,0,.62158.70605,8.01767,8.01767,0,0,0,.70556.6211,103.80643,103.80643,0,0,0,145.667,0,8.01767,8.01767,0,0,0,.70556-.6211A8.09893,8.09893,0,0,0,202.16064,200.833ZM96,128a32,32,0,1,1,32,32A32.03667,32.03667,0,0,1,96,128Zm88.28076-67.59521L155.7876,88.898a47.83822,47.83822,0,0,0-55.5752,0L71.71924,60.40479a87.81956,87.81956,0,0,1,112.56152,0ZM71.71924,195.59521l28.49316-28.49316a47.83822,47.83822,0,0,0,55.5752,0l28.49316,28.49316a87.81956,87.81956,0,0,1-112.56152,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "99.71573",
      "y1": "99.71573",
      "x2": "60.11775",
      "y2": "60.11775",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156.28427",
      "y1": "99.71573",
      "x2": "195.88225",
      "y2": "60.11775",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156.28427",
      "y1": "156.28427",
      "x2": "195.88225",
      "y2": "195.88225",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "99.71573",
      "y1": "156.28427",
      "x2": "60.11775",
      "y2": "195.88225",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "99.71573",
      "y1": "99.71573",
      "x2": "60.11775",
      "y2": "60.11775",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156.28427",
      "y1": "99.71573",
      "x2": "195.88225",
      "y2": "60.11775",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156.28427",
      "y1": "156.28427",
      "x2": "195.88225",
      "y2": "195.88225",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "99.71573",
      "y1": "156.28427",
      "x2": "60.11775",
      "y2": "195.88225",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "99.71573",
      "y1": "99.71573",
      "x2": "60.11775",
      "y2": "60.11775",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156.28427",
      "y1": "99.71573",
      "x2": "195.88225",
      "y2": "60.11775",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156.28427",
      "y1": "156.28427",
      "x2": "195.88225",
      "y2": "195.88225",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "99.71573",
      "y1": "156.28427",
      "x2": "60.11775",
      "y2": "195.88225",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7V = [];
/* style */

const __vue_inject_styles__$7V = undefined;
/* scoped */

const __vue_scope_id__$7V = undefined;
/* module identifier */

const __vue_module_identifier__$7V = undefined;
/* functional template */

const __vue_is_functional_template__$7V = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7V = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7V,
  staticRenderFns: __vue_staticRenderFns__$7V
}, __vue_inject_styles__$7V, __vue_script__$7V, __vue_scope_id__$7V, __vue_is_functional_template__$7V, __vue_module_identifier__$7V, false, undefined, undefined, undefined);

var script$7W = Vue.extend({
  name: "PhLightbulb",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7W = script$7W;
/* template */

var __vue_render__$7W = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "88.00244",
      "y1": "232",
      "x2": "168.00244",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M79.96926,167.98091A79.87808,79.87808,0,0,1,48.00369,104.4514c-.23961-43.36225,34.71874-79.40834,78.06972-80.42868a80.00431,80.00431,0,0,1,49.774,144.09929,19.791,19.791,0,0,0-7.84468,15.87805v.00023a8,8,0,0,1-8,7.99971H96.00212a8,8,0,0,1-8-7.99967v-.22676A19.80385,19.80385,0,0,0,79.96926,167.98091Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M163.11025,95.99939a36.05137,36.05137,0,0,0-27.10744-27.10724",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M78.70616,167.0114a79.86047,79.86047,0,0,1-30.70247-62.55993c-.23962-43.36232,34.71874-79.40841,78.06972-80.42875a80.00322,80.00322,0,0,1,51.34165,142.89737,24.288,24.288,0,0,0-9.4124,19.05581l-.00009,6.02423a8,8,0,0,1-8,7.99987H96.0023a8,8,0,0,1-8-7.99986l-.0001-6.0311A24.10047,24.10047,0,0,0,78.70616,167.0114Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88.00244",
      "y1": "232",
      "x2": "168.00244",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M78.70616,167.0114a79.86047,79.86047,0,0,1-30.70247-62.55993c-.23962-43.36232,34.71874-79.40841,78.06972-80.42875a80.00322,80.00322,0,0,1,51.34165,142.89737,24.288,24.288,0,0,0-9.4124,19.05581l-.00009,6.02423a8,8,0,0,1-8,7.99987H96.0023a8,8,0,0,1-8-7.99986l-.0001-6.0311A24.10047,24.10047,0,0,0,78.70616,167.0114Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M136.12232,56.784A47.923,47.923,0,0,1,175.327,95.94041",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176.00244,232a8.00039,8.00039,0,0,1-8,8h-80a8,8,0,1,1,0-16h80A8.00039,8.00039,0,0,1,176.00244,232Zm40-128a87.54306,87.54306,0,0,1-33.6416,69.208,16.23078,16.23078,0,0,0-6.3584,12.76758V192a16.01833,16.01833,0,0,1-16,16h-64a16.01833,16.01833,0,0,1-16-16v-6.03125A16.01813,16.01813,0,0,0,73.773,173.30957a87.57621,87.57621,0,0,1-33.76953-68.81445c-.2627-47.66211,38.26367-87.34961,85.88183-88.47071A88.00123,88.00123,0,0,1,216.00244,104Zm-32.78808-9.39648a55.85,55.85,0,0,0-45.76465-45.708,7.99953,7.99953,0,1,0-2.6543,15.77734A39.83978,39.83978,0,0,1,167.439,97.27734a8.00261,8.00261,0,0,0,7.87793,6.66407,8.103,8.103,0,0,0,1.34668-.11329A8,8,0,0,0,183.21436,94.60352Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "88.00244",
      "y1": "232",
      "x2": "168.00244",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M78.70616,167.0114a79.86047,79.86047,0,0,1-30.70247-62.55993c-.23962-43.36232,34.71874-79.40841,78.06972-80.42875a80.00322,80.00322,0,0,1,51.34165,142.89737,24.288,24.288,0,0,0-9.4124,19.05581l-.00009,6.02423a8,8,0,0,1-8,7.99987H96.0023a8,8,0,0,1-8-7.99986l-.0001-6.0311A24.10047,24.10047,0,0,0,78.70616,167.0114Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M136.12232,56.784A47.923,47.923,0,0,1,175.327,95.94041",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "88.00244",
      "y1": "232",
      "x2": "168.00244",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M78.70616,167.0114a79.86047,79.86047,0,0,1-30.70247-62.55993c-.23962-43.36232,34.71874-79.40841,78.06972-80.42875a80.00322,80.00322,0,0,1,51.34165,142.89737,24.288,24.288,0,0,0-9.4124,19.05581l-.00009,6.02423a8,8,0,0,1-8,7.99987H96.0023a8,8,0,0,1-8-7.99986l-.0001-6.0311A24.10047,24.10047,0,0,0,78.70616,167.0114Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M136.12232,56.784A47.923,47.923,0,0,1,175.327,95.94041",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "88",
      "y1": "232",
      "x2": "168",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M78.7037,167.0114a79.86051,79.86051,0,0,1-30.70248-62.55993C47.76161,61.08915,82.72,25.04306,126.071,24.02272a80.00322,80.00322,0,0,1,51.34165,142.89737,24.288,24.288,0,0,0-9.4124,19.05581l-.00009,6.02422a8,8,0,0,1-8,7.99988H95.99984a8,8,0,0,1-8-7.99986l-.0001-6.0311A24.10047,24.10047,0,0,0,78.7037,167.0114Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M136.12232,56.784A47.923,47.923,0,0,1,175.327,95.94041",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7W = [];
/* style */

const __vue_inject_styles__$7W = undefined;
/* scoped */

const __vue_scope_id__$7W = undefined;
/* module identifier */

const __vue_module_identifier__$7W = undefined;
/* functional template */

const __vue_is_functional_template__$7W = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7W = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7W,
  staticRenderFns: __vue_staticRenderFns__$7W
}, __vue_inject_styles__$7W, __vue_script__$7W, __vue_scope_id__$7W, __vue_is_functional_template__$7W, __vue_module_identifier__$7W, false, undefined, undefined, undefined);

var script$7X = Vue.extend({
  name: "PhLightbulbFilament",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7X = script$7X;
/* template */

var __vue_render__$7X = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "192",
      "x2": "128",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 112 128 144 160 112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "232",
      "x2": "168",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M79.96682,167.98091A79.87808,79.87808,0,0,1,48.00125,104.4514C47.76163,61.08915,82.72,25.04306,126.071,24.02272A80.00431,80.00431,0,0,1,175.845,168.122a19.791,19.791,0,0,0-7.84468,15.87805v.00023a8,8,0,0,1-8,7.99971H95.99967a8,8,0,0,1-8-7.99967v-.22676A19.80385,19.80385,0,0,0,79.96682,167.98091Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M78.70372,167.0114a79.86047,79.86047,0,0,1-30.70247-62.55993C47.76163,61.08915,82.72,25.04306,126.071,24.02272a80.00322,80.00322,0,0,1,51.34165,142.89737,24.288,24.288,0,0,0-9.4124,19.05581l-.00009,6.02423a8,8,0,0,1-8,7.99987H95.99986a8,8,0,0,1-8-7.99986l-.0001-6.0311A24.10047,24.10047,0,0,0,78.70372,167.0114Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "232",
      "x2": "168",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "200",
      "x2": "128",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 112 128 144 160 112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M78.70372,167.0114a79.86047,79.86047,0,0,1-30.70247-62.55993C47.76163,61.08915,82.72,25.04306,126.071,24.02272a80.00322,80.00322,0,0,1,51.34165,142.89737,24.288,24.288,0,0,0-9.4124,19.05581l-.00009,6.02423a8,8,0,0,1-8,7.99987H95.99986a8,8,0,0,1-8-7.99986l-.0001-6.0311A24.10047,24.10047,0,0,0,78.70372,167.0114Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,232a8.00008,8.00008,0,0,1-8,8H88a8,8,0,0,1,0-16h80A8.00008,8.00008,0,0,1,176,232Zm40-128a87.54352,87.54352,0,0,1-33.64209,69.208A16.2351,16.2351,0,0,0,176,185.97656V192a16.01833,16.01833,0,0,1-16,16H96a16.01833,16.01833,0,0,1-16-16v-6.03125a16.02005,16.02005,0,0,0-6.23-12.65918,87.57531,87.57531,0,0,1-33.76856-68.81445c-.26318-47.66211,38.2627-87.34961,85.88086-88.47071A88.0021,88.0021,0,0,1,216,104Zm-50.34326,2.34277a8.00182,8.00182,0,0,0-11.31348,0L128,132.68652l-26.34326-26.34375a8.00018,8.00018,0,0,0-11.31348,11.31446L120,147.314V184a8,8,0,0,0,16,0V147.314l29.65674-29.65673A8.00034,8.00034,0,0,0,165.65674,106.34277Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "88",
      "y1": "232",
      "x2": "168",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "200",
      "x2": "128",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 112 128 144 160 112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M78.70372,167.0114a79.86047,79.86047,0,0,1-30.70247-62.55993C47.76163,61.08915,82.72,25.04306,126.071,24.02272a80.00322,80.00322,0,0,1,51.34165,142.89737,24.288,24.288,0,0,0-9.4124,19.05581l-.00009,6.02423a8,8,0,0,1-8,7.99987H95.99986a8,8,0,0,1-8-7.99986l-.0001-6.0311A24.10047,24.10047,0,0,0,78.70372,167.0114Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "88",
      "y1": "232",
      "x2": "168",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "200",
      "x2": "128",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 112 128 144 160 112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M78.70372,167.0114a79.86047,79.86047,0,0,1-30.70247-62.55993C47.76163,61.08915,82.72,25.04306,126.071,24.02272a80.00322,80.00322,0,0,1,51.34165,142.89737,24.288,24.288,0,0,0-9.4124,19.05581l-.00009,6.02423a8,8,0,0,1-8,7.99987H95.99986a8,8,0,0,1-8-7.99986l-.0001-6.0311A24.10047,24.10047,0,0,0,78.70372,167.0114Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "88",
      "y1": "232",
      "x2": "168",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "200",
      "x2": "128",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 112 128 144 160 112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M78.70372,167.0114a79.86047,79.86047,0,0,1-30.70247-62.55993C47.76163,61.08915,82.72,25.04306,126.071,24.02272a80.00322,80.00322,0,0,1,51.34165,142.89737,24.288,24.288,0,0,0-9.4124,19.05581l-.00009,6.02423a8,8,0,0,1-8,7.99987H95.99986a8,8,0,0,1-8-7.99986l-.0001-6.0311A24.10047,24.10047,0,0,0,78.70372,167.0114Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7X = [];
/* style */

const __vue_inject_styles__$7X = undefined;
/* scoped */

const __vue_scope_id__$7X = undefined;
/* module identifier */

const __vue_module_identifier__$7X = undefined;
/* functional template */

const __vue_is_functional_template__$7X = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7X = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7X,
  staticRenderFns: __vue_staticRenderFns__$7X
}, __vue_inject_styles__$7X, __vue_script__$7X, __vue_scope_id__$7X, __vue_is_functional_template__$7X, __vue_module_identifier__$7X, false, undefined, undefined, undefined);

var script$7Y = Vue.extend({
  name: "PhLightning",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7Y = script$7Y;
/* template */

var __vue_render__$7Y = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "96 239.992 112 159.992 48 135.992 160 15.992 144 95.992 208 119.992 96 239.992",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "96 239.992 112 159.992 48 135.992 160 15.992 144 95.992 208 119.992 96 239.992",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "96 239.992 112 159.992 48 135.992 160 15.992 144 95.992 208 119.992 96 239.992",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M215.78857,118.16406a8.00125,8.00125,0,0,0-4.97949-5.6626L153.17871,90.89014l14.666-73.3291a8.00018,8.00018,0,0,0-13.69336-7.02735l-112,120a7.99995,7.99995,0,0,0,3.03955,12.94922l57.63037,21.61133-14.666,73.3291a7.99991,7.99991,0,0,0,13.69336,7.02734l112-120A8.00057,8.00057,0,0,0,215.78857,118.16406Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "96 239.992 112 159.992 48 135.992 160 15.992 144 95.992 208 119.992 96 239.992",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "96 239.992 112 159.992 48 135.992 160 15.992 144 95.992 208 119.992 96 239.992",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "96 239.992 112 159.992 48 135.992 160 15.992 144 95.992 208 119.992 96 239.992",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7Y = [];
/* style */

const __vue_inject_styles__$7Y = undefined;
/* scoped */

const __vue_scope_id__$7Y = undefined;
/* module identifier */

const __vue_module_identifier__$7Y = undefined;
/* functional template */

const __vue_is_functional_template__$7Y = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7Y = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7Y,
  staticRenderFns: __vue_staticRenderFns__$7Y
}, __vue_inject_styles__$7Y, __vue_script__$7Y, __vue_scope_id__$7Y, __vue_is_functional_template__$7Y, __vue_module_identifier__$7Y, false, undefined, undefined, undefined);

var script$7Z = Vue.extend({
  name: "PhLightningSlash",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7Z = script$7Z;
/* template */

var __vue_render__$7Z = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "40.00391",
      "x2": "208",
      "y2": "216.00391",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "163.777 167.359 96 239.977 112 159.977 48 135.976 92.198 88.622",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "119.583 59.281 160 15.977 144 95.976 208 119.977 191.162 138.018",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "96 239.969 112 159.969 48 135.969 160 15.969 144 95.969 208 119.969 96 239.969",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "39.99609",
      "x2": "208",
      "y2": "215.99609",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "163.777 167.351 96 239.969 112 159.969 48 135.969 92.198 88.614",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "114.106 65.141 160 15.969 144 95.969 208 119.969 185.685 143.878",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M53.91943,34.61475A7.99991,7.99991,0,1,0,42.08057,45.37744l39.24072,43.1648-39.16992,41.968a8.00053,8.00053,0,0,0,3.03955,12.94922l57.63037,21.61133-14.666,73.3291a7.99991,7.99991,0,0,0,13.69336,7.02735l61.85083-66.26892,38.38111,42.21911a7.99991,7.99991,0,1,0,11.83886-10.76269Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M179.76562,149.25928a8.00013,8.00013,0,0,0,5.86719,2.61865h.05225a8.00073,8.00073,0,0,0,5.84863-2.5415l22.31494-23.90918a7.99994,7.99994,0,0,0-3.03955-12.94922L153.17871,90.8667l14.666-73.3291a8.00018,8.00018,0,0,0-13.69336-7.02735l-45.894,49.17237a8.00006,8.00006,0,0,0-.0708,10.83984Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "39.99609",
      "x2": "208",
      "y2": "215.99609",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "163.777 167.351 96 239.969 112 159.969 48 135.969 92.198 88.614",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "114.106 65.141 160 15.969 144 95.969 208 119.969 185.685 143.878",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "39.99609",
      "x2": "208",
      "y2": "215.99609",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "163.777 167.351 96 239.969 112 159.969 48 135.969 92.198 88.614",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "114.106 65.141 160 15.969 144 95.969 208 119.969 185.685 143.878",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "39.99609",
      "x2": "208",
      "y2": "215.99609",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "163.777 167.351 96 239.969 112 159.969 48 135.969 92.198 88.614",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "114.106 65.141 160 15.969 144 95.969 208 119.969 185.685 143.878",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7Z = [];
/* style */

const __vue_inject_styles__$7Z = undefined;
/* scoped */

const __vue_scope_id__$7Z = undefined;
/* module identifier */

const __vue_module_identifier__$7Z = undefined;
/* functional template */

const __vue_is_functional_template__$7Z = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7Z = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7Z,
  staticRenderFns: __vue_staticRenderFns__$7Z
}, __vue_inject_styles__$7Z, __vue_script__$7Z, __vue_scope_id__$7Z, __vue_is_functional_template__$7Z, __vue_module_identifier__$7Z, false, undefined, undefined, undefined);

var script$7_ = Vue.extend({
  name: "PhLineSegment",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7_ = script$7_;
/* template */

var __vue_render__$7_ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "64",
      "cy": "192",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "192",
      "cy": "64",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "175.02944",
      "y1": "80.97056",
      "x2": "80.97056",
      "y2": "175.02944",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "64",
      "cy": "192",
      "r": "24",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "192",
      "cy": "64",
      "r": "24",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "64",
      "cy": "192",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "192",
      "cy": "64",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "175.02944",
      "y1": "80.97056",
      "x2": "80.97056",
      "y2": "175.02944",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M214.62793,86.62695a32.0716,32.0716,0,0,1-38.88245,4.94141L91.56836,175.74561a32.00172,32.00172,0,1,1-50.19629-6.37256l.00049-.001a32.05731,32.05731,0,0,1,38.88208-4.94043l84.177-84.17725a32.00172,32.00172,0,1,1,50.19629,6.37256Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "64",
      "cy": "192",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "192",
      "cy": "64",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "175.02944",
      "y1": "80.97056",
      "x2": "80.97056",
      "y2": "175.02944",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "64",
      "cy": "192",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "192",
      "cy": "64",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "175.02944",
      "y1": "80.97056",
      "x2": "80.97056",
      "y2": "175.02944",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "64",
      "cy": "192",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "192",
      "cy": "64",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "175.02944",
      "y1": "80.97056",
      "x2": "80.97056",
      "y2": "175.02944",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7_ = [];
/* style */

const __vue_inject_styles__$7_ = undefined;
/* scoped */

const __vue_scope_id__$7_ = undefined;
/* module identifier */

const __vue_module_identifier__$7_ = undefined;
/* functional template */

const __vue_is_functional_template__$7_ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7_ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7_,
  staticRenderFns: __vue_staticRenderFns__$7_
}, __vue_inject_styles__$7_, __vue_script__$7_, __vue_scope_id__$7_, __vue_is_functional_template__$7_, __vue_module_identifier__$7_, false, undefined, undefined, undefined);

var script$7$ = Vue.extend({
  name: "PhLineSegments",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7$ = script$7$;
/* template */

var __vue_render__$7$ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "40",
      "cy": "200",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "96",
      "cy": "96",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "160",
      "cy": "160",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "216",
      "cy": "56",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "84.61991",
      "y1": "117.13444",
      "x2": "51.37906",
      "y2": "178.86746",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "143.02941",
      "y1": "143.02941",
      "x2": "112.97057",
      "y2": "112.97057",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "204.62096",
      "y1": "77.1325",
      "x2": "171.37906",
      "y2": "138.86746",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "40",
      "cy": "200",
      "r": "24",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "96",
      "cy": "96",
      "r": "24",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "160",
      "cy": "160",
      "r": "24",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "216",
      "cy": "56",
      "r": "24",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "40",
      "cy": "200",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "96",
      "cy": "96",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "160",
      "cy": "160",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "216",
      "cy": "56",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "84.61991",
      "y1": "117.13444",
      "x2": "51.37906",
      "y2": "178.86746",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "143.02941",
      "y1": "143.02941",
      "x2": "112.97057",
      "y2": "112.97057",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "204.62096",
      "y1": "77.1325",
      "x2": "171.37906",
      "y2": "138.86746",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M238.62793,78.62695A31.90289,31.90289,0,0,1,216,87.98438a32.23919,32.23919,0,0,1-7.64124-.91846l-26.629,49.45312c.30212.27979.60412.55957.8977.853a32.00038,32.00038,0,1,1-50.1958,6.37354l-20.17749-20.17774a32.157,32.157,0,0,1-23.89526,3.49805L61.72974,176.519c.30212.27979.60412.55957.8977.853a32.00038,32.00038,0,1,1-45.25537.001l.00049-.001a32.0127,32.0127,0,0,1,30.269-8.43848l26.62866-49.45214c-.302-.28028-.60412-.56006-.8977-.85352a32.03718,32.03718,0,0,1-.00049-45.25488l.00049-.001a32.00216,32.00216,0,0,1,50.1958,38.88232l20.177,20.17725a32.12466,32.12466,0,0,1,23.89624-3.498L194.27026,79.481c-.30212-.27979-.60412-.55957-.8977-.853a32.03718,32.03718,0,0,1-.00049-45.25488l.00049-.001a32.00021,32.00021,0,0,1,45.25537,45.25488Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "40",
      "cy": "200",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "96",
      "cy": "96",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "160",
      "cy": "160",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "216",
      "cy": "56",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "84.61991",
      "y1": "117.13444",
      "x2": "51.37906",
      "y2": "178.86746",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "143.02941",
      "y1": "143.02941",
      "x2": "112.97057",
      "y2": "112.97057",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "204.62096",
      "y1": "77.1325",
      "x2": "171.37906",
      "y2": "138.86746",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "40",
      "cy": "200",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "96",
      "cy": "96",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "160",
      "cy": "160",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "216",
      "cy": "56",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "84.61991",
      "y1": "117.13444",
      "x2": "51.37906",
      "y2": "178.86746",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "143.02941",
      "y1": "143.02941",
      "x2": "112.97057",
      "y2": "112.97057",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "204.62096",
      "y1": "77.1325",
      "x2": "171.37906",
      "y2": "138.86746",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "40",
      "cy": "200",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "96",
      "cy": "96",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "160",
      "cy": "160",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "216",
      "cy": "56",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "84.61991",
      "y1": "117.13444",
      "x2": "51.37906",
      "y2": "178.86746",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "143.02941",
      "y1": "143.02941",
      "x2": "112.97057",
      "y2": "112.97057",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "204.62096",
      "y1": "77.1325",
      "x2": "171.37906",
      "y2": "138.86746",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7$ = [];
/* style */

const __vue_inject_styles__$7$ = undefined;
/* scoped */

const __vue_scope_id__$7$ = undefined;
/* module identifier */

const __vue_module_identifier__$7$ = undefined;
/* functional template */

const __vue_is_functional_template__$7$ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7$ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7$,
  staticRenderFns: __vue_staticRenderFns__$7$
}, __vue_inject_styles__$7$, __vue_script__$7$, __vue_scope_id__$7$, __vue_is_functional_template__$7$, __vue_module_identifier__$7$, false, undefined, undefined, undefined);

var script$80 = Vue.extend({
  name: "PhLink",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$80 = script$80;
/* template */

var __vue_render__$80 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M132.49413,61.28047l9.648-9.648a44,44,0,1,1,62.22539,62.22539l-30.28427,30.28428a44,44,0,0,1-62.2254,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M123.50407,194.72133l-9.64621,9.6462a44,44,0,1,1-62.22539-62.22539l30.28427-30.28428a44,44,0,0,1,62.2254,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M122.34315,71.43146l19.799-19.799a44,44,0,1,1,62.22539,62.22539l-28.28427,28.28428a44,44,0,0,1-62.2254,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M133.65685,184.56854l-19.799,19.799a44,44,0,1,1-62.22539-62.22539l28.28427-28.28428a44,44,0,0,1,62.2254,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M210.0249,45.97559a52.00107,52.00107,0,0,0-73.54,0L116.686,65.77441a8.00053,8.00053,0,1,0,11.31445,11.31446L147.79932,57.29a35.99926,35.99926,0,1,1,50.91113,50.91016l-28.2832,28.28515a36.04088,36.04088,0,0,1-50.91211,0,8.00053,8.00053,0,0,0-11.31446,11.31445,52.0625,52.0625,0,0,0,73.54,0l28.28418-28.28515a52.00226,52.00226,0,0,0,0-73.53906Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M127.99951,178.91113,108.20068,198.71A35.99926,35.99926,0,1,1,57.28955,147.7998l28.2832-28.28515a36.03821,36.03821,0,0,1,50.91211,0,8.00053,8.00053,0,1,0,11.31446-11.31445,52.0625,52.0625,0,0,0-73.54,0L45.9751,136.48535a52.00031,52.00031,0,0,0,73.54,73.53906L139.314,190.22559a8.00053,8.00053,0,0,0-11.31445-11.31446Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M122.34315,71.43146l19.799-19.799a44,44,0,1,1,62.22539,62.22539l-28.28427,28.28428a44,44,0,0,1-62.2254,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M133.65685,184.56854l-19.799,19.799a44,44,0,1,1-62.22539-62.22539l28.28427-28.28428a44,44,0,0,1,62.2254,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M122.34315,71.43146l19.799-19.799a44,44,0,1,1,62.22539,62.22539l-28.28427,28.28428a44,44,0,0,1-62.2254,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M133.65685,184.56854l-19.799,19.799a44,44,0,1,1-62.22539-62.22539l28.28427-28.28428a44,44,0,0,1,62.2254,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M122.34315,71.43146l19.799-19.799a44,44,0,1,1,62.22539,62.22539l-28.28427,28.28428a44,44,0,0,1-62.2254,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M133.65685,184.56854l-19.799,19.799a44,44,0,1,1-62.22539-62.22539l28.28427-28.28428a44,44,0,0,1,62.2254,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$80 = [];
/* style */

const __vue_inject_styles__$80 = undefined;
/* scoped */

const __vue_scope_id__$80 = undefined;
/* module identifier */

const __vue_module_identifier__$80 = undefined;
/* functional template */

const __vue_is_functional_template__$80 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$80 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$80,
  staticRenderFns: __vue_staticRenderFns__$80
}, __vue_inject_styles__$80, __vue_script__$80, __vue_scope_id__$80, __vue_is_functional_template__$80, __vue_module_identifier__$80, false, undefined, undefined, undefined);

var script$81 = Vue.extend({
  name: "PhLinkBreak",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$81 = script$81;
/* template */

var __vue_render__$81 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "95.99951",
      "y1": "68",
      "x2": "95.99951",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "159.99951",
      "y1": "208",
      "x2": "159.99951",
      "y2": "188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "67.99951",
      "y1": "96",
      "x2": "47.99951",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "207.99951",
      "y1": "160",
      "x2": "187.99951",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M67.02944,132.402l-7.31371,7.31371a40,40,0,0,0,56.56854,56.56854l7.31371-7.31371",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M188.97056,123.598l7.31371-7.31371a40,40,0,0,0-56.56854-56.56854L132.402,67.02944",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "95.99951",
      "y1": "72",
      "x2": "95.99951",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "159.99951",
      "y1": "208",
      "x2": "159.99951",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "71.99951",
      "y1": "96",
      "x2": "47.99951",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "207.99951",
      "y1": "160",
      "x2": "183.99951",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M71.02944,128.402,59.71573,139.71573a40,40,0,0,0,56.56854,56.56854L127.598,184.97056",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184.97056,127.598l11.31371-11.31371a40,40,0,0,0-56.56854-56.56854L128.402,71.02944",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M87.99951,72V48a8,8,0,1,1,16,0V72a8,8,0,0,1-16,0Zm72,104a8.00039,8.00039,0,0,0-8,8v24a8,8,0,0,0,16,0V184A8.00039,8.00039,0,0,0,159.99951,176Zm-112-72h24a8,8,0,0,0,0-16h-24a8,8,0,1,0,0,16Zm160,48h-24a8,8,0,0,0,0,16h24a8,8,0,0,0,0-16Zm-86.05859,27.31348L110.62744,190.627a32,32,0,0,1-45.25586-45.2539L76.686,134.05957a7.99983,7.99983,0,0,0-11.3125-11.31445L54.05811,134.05957a48.00041,48.00041,0,0,0,67.88378,67.88184l11.31348-11.31348a8.00052,8.00052,0,0,0-11.31445-11.31445ZM190.62744,65.37207a32.03762,32.03762,0,0,1,.001,45.25488L179.314,121.94043a7.99983,7.99983,0,1,0,11.3125,11.31445l11.31543-11.31445a48.0004,48.0004,0,1,0-67.88378-67.88184L122.74463,65.37207a8.00052,8.00052,0,0,0,11.31445,11.31445l11.31348-11.31347A32.035,32.035,0,0,1,190.62744,65.37207Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "95.99951",
      "y1": "72",
      "x2": "95.99951",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "159.99951",
      "y1": "208",
      "x2": "159.99951",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "71.99951",
      "y1": "96",
      "x2": "47.99951",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "207.99951",
      "y1": "160",
      "x2": "183.99951",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M71.02944,128.402,59.71573,139.71573a40,40,0,0,0,56.56854,56.56854L127.598,184.97056",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184.97056,127.598l11.31371-11.31371a40,40,0,0,0-56.56854-56.56854L128.402,71.02944",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "95.99951",
      "y1": "72",
      "x2": "95.99951",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "159.99951",
      "y1": "208",
      "x2": "159.99951",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "71.99951",
      "y1": "96",
      "x2": "47.99951",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "207.99951",
      "y1": "160",
      "x2": "183.99951",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M71.02944,128.402,59.71573,139.71573a40,40,0,0,0,56.56854,56.56854L127.598,184.97056",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184.97056,127.598l11.31371-11.31371a40,40,0,0,0-56.56854-56.56854L128.402,71.02944",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "95.99951",
      "y1": "72",
      "x2": "95.99951",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "159.99951",
      "y1": "208",
      "x2": "159.99951",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "71.99951",
      "y1": "96",
      "x2": "47.99951",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "207.99951",
      "y1": "160",
      "x2": "183.99951",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M71.02944,128.402,59.71573,139.71573a40,40,0,0,0,56.56854,56.56854L127.598,184.97056",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184.97056,127.598l11.31371-11.31371a40,40,0,0,0-56.56854-56.56854L128.402,71.02944",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$81 = [];
/* style */

const __vue_inject_styles__$81 = undefined;
/* scoped */

const __vue_scope_id__$81 = undefined;
/* module identifier */

const __vue_module_identifier__$81 = undefined;
/* functional template */

const __vue_is_functional_template__$81 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$81 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$81,
  staticRenderFns: __vue_staticRenderFns__$81
}, __vue_inject_styles__$81, __vue_script__$81, __vue_scope_id__$81, __vue_is_functional_template__$81, __vue_module_identifier__$81, false, undefined, undefined, undefined);

var script$82 = Vue.extend({
  name: "PhLinkSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$82 = script$82;
/* template */

var __vue_render__$82 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "94.05365",
      "y1": "161.93204",
      "x2": "161.9359",
      "y2": "94.04979",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M144.96326,178.9102,116.679,207.19447a48,48,0,0,1-67.88225-67.88225L77.081,111.028",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M178.90922,144.96424,207.19349,116.68a48,48,0,0,0-67.88225-67.88225L111.027,77.082",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "94.05267",
      "y1": "161.93204",
      "x2": "161.93492",
      "y2": "94.04979",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M144.96229,178.9102,116.678,207.19447a48,48,0,0,1-67.88226-67.88225L77.08,111.028",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M178.90825,144.96424,207.19252,116.68a48,48,0,0,0-67.88225-67.88225L111.026,77.082",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M156.27783,88.39258,88.396,156.27441a8.00053,8.00053,0,0,0,11.31445,11.31446L167.59229,99.707a8.00053,8.00053,0,1,0-11.31446-11.31445Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M139.30518,173.25293,111.021,201.53711a39.99918,39.99918,0,1,1-56.56739-56.56738l28.28418-28.28418a8.00053,8.00053,0,1,0-11.31445-11.31446L43.13916,133.65527a56.00023,56.00023,0,0,0,79.19629,79.19629l28.28418-28.28418a8.00052,8.00052,0,0,0-11.31445-11.31445Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M212.8501,43.14062a56.002,56.002,0,0,0-79.19629,0L105.36963,71.4248a8.00053,8.00053,0,0,0,11.31445,11.31446l28.28418-28.28418a39.99918,39.99918,0,0,1,56.56738,56.56738l-28.28418,28.28418a8.00053,8.00053,0,0,0,11.31446,11.31445l28.28418-28.28418A56.06459,56.06459,0,0,0,212.8501,43.14062Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "94.05413",
      "y1": "161.93204",
      "x2": "161.93639",
      "y2": "94.04979",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M144.96375,178.9102l-28.28427,28.28427a48,48,0,0,1-67.88225-67.88225L77.0815,111.028",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M178.90971,144.96424,207.194,116.68a48,48,0,0,0-67.88225-67.88225L111.02746,77.082",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "94.05462",
      "y1": "161.93204",
      "x2": "161.93687",
      "y2": "94.04979",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M144.96424,178.9102,116.68,207.19447a48,48,0,0,1-67.88225-67.88225L77.082,111.028",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M178.9102,144.96424,207.19447,116.68a48,48,0,0,0-67.88225-67.88225L111.028,77.082",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "94.05511",
      "y1": "161.93204",
      "x2": "161.93736",
      "y2": "94.04979",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M144.96473,178.9102l-28.28427,28.28427a48,48,0,0,1-67.88225-67.88225L77.08248,111.028",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M178.91069,144.96424,207.195,116.68a48,48,0,0,0-67.88225-67.88225L111.02844,77.082",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$82 = [];
/* style */

const __vue_inject_styles__$82 = undefined;
/* scoped */

const __vue_scope_id__$82 = undefined;
/* module identifier */

const __vue_module_identifier__$82 = undefined;
/* functional template */

const __vue_is_functional_template__$82 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$82 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$82,
  staticRenderFns: __vue_staticRenderFns__$82
}, __vue_inject_styles__$82, __vue_script__$82, __vue_scope_id__$82, __vue_is_functional_template__$82, __vue_module_identifier__$82, false, undefined, undefined, undefined);

var script$83 = Vue.extend({
  name: "PhLinkSimpleBreak",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$83 = script$83;
/* template */

var __vue_render__$83 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M144.96473,178.9102l-28.28427,28.28427a48,48,0,0,1-67.88225-67.88225L77.08248,111.028",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M178.91069,144.96424,207.195,116.68a48,48,0,0,0-67.88225-67.88225L111.02844,77.082",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M144.96473,178.9102l-28.28427,28.28427a48,48,0,0,1-67.88225-67.88225L77.08248,111.028",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M178.91069,144.96424,207.195,116.68a48,48,0,0,0-67.88225-67.88225L111.02844,77.082",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M139.30713,173.25293,111.023,201.53711a39.99918,39.99918,0,0,1-56.56738-56.56738l28.28418-28.28418a8.00053,8.00053,0,0,0-11.31446-11.31446L43.14111,133.65527a56.00023,56.00023,0,0,0,79.19629,79.19629l28.28418-28.28418a8.00052,8.00052,0,1,0-11.31445-11.31445Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M212.85205,43.14062a56.002,56.002,0,0,0-79.19629,0L105.37158,71.4248A8.00053,8.00053,0,1,0,116.686,82.73926l28.28417-28.28418a39.99918,39.99918,0,0,1,56.56739,56.56738l-28.28418,28.28418a8.00052,8.00052,0,0,0,11.31445,11.31445l28.28418-28.28418A56.06457,56.06457,0,0,0,212.85205,43.14062Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M144.96473,178.9102l-28.28427,28.28427a48,48,0,0,1-67.88225-67.88225L77.08248,111.028",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M178.91069,144.96424,207.195,116.68a48,48,0,0,0-67.88225-67.88225L111.02844,77.082",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M144.96473,178.9102l-28.28427,28.28427a48,48,0,0,1-67.88225-67.88225L77.08248,111.028",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M178.91069,144.96424,207.195,116.68a48,48,0,0,0-67.88225-67.88225L111.02844,77.082",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M144.96473,178.9102l-28.28427,28.28427a48,48,0,0,1-67.88225-67.88225L77.08248,111.028",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M178.91069,144.96424,207.195,116.68a48,48,0,0,0-67.88225-67.88225L111.02844,77.082",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M144.96473,178.9102l-28.28427,28.28427a48,48,0,0,1-67.88225-67.88225L77.08248,111.028",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M178.91069,144.96424,207.195,116.68a48,48,0,0,0-67.88225-67.88225L111.02844,77.082",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$83 = [];
/* style */

const __vue_inject_styles__$83 = undefined;
/* scoped */

const __vue_scope_id__$83 = undefined;
/* module identifier */

const __vue_module_identifier__$83 = undefined;
/* functional template */

const __vue_is_functional_template__$83 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$83 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$83,
  staticRenderFns: __vue_staticRenderFns__$83
}, __vue_inject_styles__$83, __vue_script__$83, __vue_scope_id__$83, __vue_is_functional_template__$83, __vue_module_identifier__$83, false, undefined, undefined, undefined);

var script$84 = Vue.extend({
  name: "PhLinkSimpleHorizontal",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$84 = script$84;
/* template */

var __vue_render__$84 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "79.97949",
      "y1": "127.99219",
      "x2": "175.97949",
      "y2": "127.99219",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M103.97266,175.99609h-40a48,48,0,0,1,0-96h40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M151.97949,175.99609h40a48,48,0,0,0,0-96h-40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "79.96582",
      "y1": "127.99219",
      "x2": "175.96582",
      "y2": "127.99219",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M103.959,175.99609h-40a48,48,0,0,1,0-96h40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M151.96582,175.99609h40a48,48,0,0,0,0-96h-40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M71.97266,127.99219a8.00009,8.00009,0,0,0,8,8h96a8,8,0,0,0,0-16h-96A8.00008,8.00008,0,0,0,71.97266,127.99219Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M103.96582,167.99609h-40a40,40,0,0,1,0-80h40a8,8,0,0,0,0-16h-40a56,56,0,0,0,0,112h40a8,8,0,0,0,0-16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M191.97266,71.99609h-40a8,8,0,0,0,0,16h40a40,40,0,0,1,0,80h-40a8,8,0,0,0,0,16h40a56,56,0,0,0,0-112Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "79.98633",
      "y1": "127.99219",
      "x2": "175.98633",
      "y2": "127.99219",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M103.97949,175.99609h-40a48,48,0,0,1,0-96h40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M151.98633,175.99609h40a48,48,0,0,0,0-96h-40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "79.99316",
      "y1": "127.99219",
      "x2": "175.99316",
      "y2": "127.99219",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M103.98633,175.99609h-40a48,48,0,0,1,0-96h40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M151.99316,175.99609h40a48,48,0,0,0,0-96h-40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "80",
      "y1": "127.99219",
      "x2": "176",
      "y2": "127.99219",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M103.99316,175.99609h-40a48,48,0,0,1,0-96h40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,175.99609h40a48,48,0,0,0,0-96H152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$84 = [];
/* style */

const __vue_inject_styles__$84 = undefined;
/* scoped */

const __vue_scope_id__$84 = undefined;
/* module identifier */

const __vue_module_identifier__$84 = undefined;
/* functional template */

const __vue_is_functional_template__$84 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$84 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$84,
  staticRenderFns: __vue_staticRenderFns__$84
}, __vue_inject_styles__$84, __vue_script__$84, __vue_scope_id__$84, __vue_is_functional_template__$84, __vue_module_identifier__$84, false, undefined, undefined, undefined);

var script$85 = Vue.extend({
  name: "PhLinkSimpleHorizontalBreak",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$85 = script$85;
/* template */

var __vue_render__$85 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M103.99316,175.99609h-40a48,48,0,0,1,0-96h40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,175.99609h40a48,48,0,0,0,0-96H152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M103.99316,175.99609h-40a48,48,0,0,1,0-96h40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,175.99609h40a48,48,0,0,0,0-96H152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M103.99316,167.99609h-40a40,40,0,0,1,0-80h40a8,8,0,0,0,0-16h-40a56,56,0,0,0,0,112h40a8,8,0,1,0,0-16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M192,71.99609H152a8,8,0,0,0,0,16h40a40,40,0,0,1,0,80H152a8,8,0,0,0,0,16h40a56,56,0,0,0,0-112Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M103.99316,175.99609h-40a48,48,0,0,1,0-96h40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,175.99609h40a48,48,0,0,0,0-96H152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M103.99316,175.99609h-40a48,48,0,0,1,0-96h40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,175.99609h40a48,48,0,0,0,0-96H152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M103.99316,175.99609h-40a48,48,0,0,1,0-96h40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,175.99609h40a48,48,0,0,0,0-96H152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$85 = [];
/* style */

const __vue_inject_styles__$85 = undefined;
/* scoped */

const __vue_scope_id__$85 = undefined;
/* module identifier */

const __vue_module_identifier__$85 = undefined;
/* functional template */

const __vue_is_functional_template__$85 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$85 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$85,
  staticRenderFns: __vue_staticRenderFns__$85
}, __vue_inject_styles__$85, __vue_script__$85, __vue_scope_id__$85, __vue_is_functional_template__$85, __vue_module_identifier__$85, false, undefined, undefined, undefined);

var script$86 = Vue.extend({
  name: "PhLinkedinLogo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$86 = script$86;
/* template */

var __vue_render__$86 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "36",
      "y": "36",
      "width": "184",
      "height": "184",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "124",
      "y1": "120.00094",
      "x2": "124",
      "y2": "176.00094",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "84",
      "y1": "120.00094",
      "x2": "84",
      "y2": "176.00094",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M124,148.00094a28,28,0,1,1,56,0v28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "79.99998",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "36",
      "y": "36",
      "width": "184",
      "height": "184",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "36",
      "y": "36",
      "width": "184",
      "height": "184",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "112.00094",
      "x2": "120",
      "y2": "176.00094",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "112.00094",
      "x2": "88",
      "y2": "176.00094",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M120,140.00094a28,28,0,1,1,56,0v36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "88",
      "cy": "79.99998",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M212,28H44A16.01817,16.01817,0,0,0,28,44V212a16.01833,16.01833,0,0,0,16,16H212a16.01833,16.01833,0,0,0,16-16V44A16.01817,16.01817,0,0,0,212,28ZM96,176.001a8,8,0,1,1-16,0v-64a8,8,0,0,1,16,0ZM88,92a12,12,0,1,1,12-12A12,12,0,0,1,88,92Zm96,84.001a8,8,0,1,1-16,0v-36a20,20,0,0,0-40,0v36a8,8,0,1,1-16,0v-64a7.99729,7.99729,0,0,1,15.79492-1.77857A35.98125,35.98125,0,0,1,184,140.001Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "36",
      "y": "36",
      "width": "184",
      "height": "184",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "112.00094",
      "x2": "120",
      "y2": "176.00094",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "112.00094",
      "x2": "88",
      "y2": "176.00094",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M120,140.00094a28,28,0,1,1,56,0v36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "88",
      "cy": "79.99998",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "36",
      "y": "36",
      "width": "184",
      "height": "184",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "112.00094",
      "x2": "120",
      "y2": "176.00094",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "112.00094",
      "x2": "88",
      "y2": "176.00094",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M120,140.00094a28,28,0,1,1,56,0v36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "88",
      "cy": "79.99998",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "36",
      "y": "36",
      "width": "184",
      "height": "184",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "112.00094",
      "x2": "120",
      "y2": "176.00094",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "112.00094",
      "x2": "88",
      "y2": "176.00094",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M120,140.00094a28,28,0,1,1,56,0v36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "88",
      "cy": "79.99998",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$86 = [];
/* style */

const __vue_inject_styles__$86 = undefined;
/* scoped */

const __vue_scope_id__$86 = undefined;
/* module identifier */

const __vue_module_identifier__$86 = undefined;
/* functional template */

const __vue_is_functional_template__$86 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$86 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$86,
  staticRenderFns: __vue_staticRenderFns__$86
}, __vue_inject_styles__$86, __vue_script__$86, __vue_scope_id__$86, __vue_is_functional_template__$86, __vue_module_identifier__$86, false, undefined, undefined, undefined);

var script$87 = Vue.extend({
  name: "PhList",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$87 = script$87;
/* template */

var __vue_render__$87 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "64",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "192",
      "x2": "216",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "64",
      "x2": "216",
      "y2": "64",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "192",
      "x2": "216",
      "y2": "192",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M215.999,120.00037h-176a8,8,0,0,0,0,16h176a8,8,0,0,0,0-16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M39.999,72.00037h176a8,8,0,0,0,0-16h-176a8,8,0,1,0,0,16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M215.999,184.00037h-176a8,8,0,0,0,0,16h176a8,8,0,0,0,0-16Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "64",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "192",
      "x2": "216",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "64",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "192",
      "x2": "216",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "64",
      "x2": "216",
      "y2": "64",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "192",
      "x2": "216",
      "y2": "192",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$87 = [];
/* style */

const __vue_inject_styles__$87 = undefined;
/* scoped */

const __vue_scope_id__$87 = undefined;
/* module identifier */

const __vue_module_identifier__$87 = undefined;
/* functional template */

const __vue_is_functional_template__$87 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$87 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$87,
  staticRenderFns: __vue_staticRenderFns__$87
}, __vue_inject_styles__$87, __vue_script__$87, __vue_scope_id__$87, __vue_is_functional_template__$87, __vue_module_identifier__$87, false, undefined, undefined, undefined);

var script$88 = Vue.extend({
  name: "PhListBullets",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$88 = script$88;
/* template */

var __vue_render__$88 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "88",
      "y1": "64",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88.00614",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88.00614",
      "y1": "192",
      "x2": "216",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "44",
      "cy": "128",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "44",
      "cy": "64",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "44",
      "cy": "192",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "88",
      "y1": "64",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88.00614",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88.00614",
      "y1": "192",
      "x2": "216",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "44",
      "cy": "64",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "44",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "44",
      "cy": "192",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,64a8.00008,8.00008,0,0,1,8-8H216a8,8,0,0,1,0,16H88A8.00008,8.00008,0,0,1,80,64Zm136,56H88.00586a8,8,0,1,0,0,16H216a8,8,0,0,0,0-16Zm0,64H88.00586a8,8,0,1,0,0,16H216a8,8,0,0,0,0-16ZM44,116a12,12,0,1,0,12,12A12.01343,12.01343,0,0,0,44,116Zm0-64A12,12,0,1,0,56,64,12.01343,12.01343,0,0,0,44,52Zm0,128a12,12,0,1,0,12,12A12.01343,12.01343,0,0,0,44,180Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "88",
      "y1": "64",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88.00614",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88.00614",
      "y1": "192",
      "x2": "216",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "44",
      "cy": "64",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "44",
      "cy": "192",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "44",
      "cy": "128",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "88",
      "y1": "64",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88.00614",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88.00614",
      "y1": "192",
      "x2": "216",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "44",
      "cy": "128",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "44",
      "cy": "64",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "44",
      "cy": "192",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "88",
      "y1": "64",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88.00614",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88.00614",
      "y1": "192",
      "x2": "216",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "44",
      "cy": "64",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "44",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "44",
      "cy": "192",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$88 = [];
/* style */

const __vue_inject_styles__$88 = undefined;
/* scoped */

const __vue_scope_id__$88 = undefined;
/* module identifier */

const __vue_module_identifier__$88 = undefined;
/* functional template */

const __vue_is_functional_template__$88 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$88 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$88,
  staticRenderFns: __vue_staticRenderFns__$88
}, __vue_inject_styles__$88, __vue_script__$88, __vue_scope_id__$88, __vue_is_functional_template__$88, __vue_module_identifier__$88, false, undefined, undefined, undefined);

var script$89 = Vue.extend({
  name: "PhListDashes",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$89 = script$89;
/* template */

var __vue_render__$89 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "64",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96.00614",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96.00614",
      "y1": "192",
      "x2": "216",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "64",
      "x2": "56",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40.00614",
      "y1": "128",
      "x2": "56",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40.00614",
      "y1": "192",
      "x2": "56",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "64",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96.00614",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96.00614",
      "y1": "192",
      "x2": "216",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "64",
      "x2": "56",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40.00614",
      "y1": "128",
      "x2": "56",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40.00614",
      "y1": "192",
      "x2": "56",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M88,64a8.00008,8.00008,0,0,1,8-8H216a8,8,0,0,1,0,16H96A8.00008,8.00008,0,0,1,88,64Zm128,56H96.00586a8,8,0,1,0,0,16H216a8,8,0,0,0,0-16Zm0,64H96.00586a8,8,0,1,0,0,16H216a8,8,0,0,0,0-16ZM56,56H40a8,8,0,0,0,0,16H56a8,8,0,0,0,0-16Zm0,64H40.00586a8,8,0,1,0,0,16H56a8,8,0,0,0,0-16Zm0,64H40.00586a8,8,0,1,0,0,16H56a8,8,0,0,0,0-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "64",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96.00614",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96.00614",
      "y1": "192",
      "x2": "216",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "64",
      "x2": "56",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40.00614",
      "y1": "128",
      "x2": "56",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40.00614",
      "y1": "192",
      "x2": "56",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "64",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96.00614",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96.00614",
      "y1": "192",
      "x2": "216",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "64",
      "x2": "56",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40.00614",
      "y1": "128",
      "x2": "56",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40.00614",
      "y1": "192",
      "x2": "56",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "64",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96.00614",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96.00614",
      "y1": "192",
      "x2": "216",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "64",
      "x2": "56",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40.00614",
      "y1": "128",
      "x2": "56",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40.00614",
      "y1": "192",
      "x2": "56",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$89 = [];
/* style */

const __vue_inject_styles__$89 = undefined;
/* scoped */

const __vue_scope_id__$89 = undefined;
/* module identifier */

const __vue_module_identifier__$89 = undefined;
/* functional template */

const __vue_is_functional_template__$89 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$89 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$89,
  staticRenderFns: __vue_staticRenderFns__$89
}, __vue_inject_styles__$89, __vue_script__$89, __vue_scope_id__$89, __vue_is_functional_template__$89, __vue_module_identifier__$89, false, undefined, undefined, undefined);

var script$8a = Vue.extend({
  name: "PhListNumbers",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8a = script$8a;
/* template */

var __vue_render__$8a = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "108",
      "y1": "128",
      "x2": "215.99902",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "108",
      "y1": "64",
      "x2": "215.99902",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "107.99902",
      "y1": "192",
      "x2": "215.99902",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "40 60 56 52 56 107.994",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M41.10018,152.55059A14.00226,14.00226,0,1,1,65.609,165.82752L40,200H68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "104",
      "y1": "128",
      "x2": "215.99902",
      "y2": "128",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "64",
      "x2": "215.99902",
      "y2": "64",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "103.99902",
      "y1": "192",
      "x2": "215.99902",
      "y2": "192",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "40 60 56 52 56 107.994",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M41.10018,152.55059A14.00226,14.00226,0,1,1,65.609,165.82752L40,200H68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M223.999,128a8.00039,8.00039,0,0,1-8,8H104a8,8,0,0,1,0-16H215.999A8.00039,8.00039,0,0,1,223.999,128ZM104,72H215.999a8,8,0,0,0,0-16H104a8,8,0,0,0,0,16ZM215.999,184h-112a8,8,0,1,0,0,16h112a8,8,0,0,0,0-16ZM43.57764,67.15527,48,64.94434v43.0498a8,8,0,1,0,16,0V52a7.99928,7.99928,0,0,0-11.57764-7.15527l-16,8a7.99984,7.99984,0,1,0,7.15528,14.31054ZM72.23828,170.30566a22.00226,22.00226,0,1,0-38.50635-20.87109A8,8,0,1,0,48.46826,155.667a6.00233,6.00233,0,1,1,10.59717,5.55176l-25.46729,33.9834A8.00013,8.00013,0,0,0,40,208H68a8,8,0,0,0,0-16H55.99219l16.01855-21.375Q72.12867,170.46827,72.23828,170.30566Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "104",
      "y1": "128",
      "x2": "215.99902",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "64",
      "x2": "215.99902",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "103.99902",
      "y1": "192",
      "x2": "215.99902",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "40 60 56 52 56 107.994",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M41.10018,152.55059A14.00226,14.00226,0,1,1,65.609,165.82752L40,200H68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "104",
      "y1": "128",
      "x2": "215.99902",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "64",
      "x2": "215.99902",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "103.99902",
      "y1": "192",
      "x2": "215.99902",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "40 60 56 52 56 107.994",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M41.10018,152.55059A14.00226,14.00226,0,1,1,65.609,165.82752L40,200H68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "104",
      "y1": "128",
      "x2": "215.99902",
      "y2": "128",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "64",
      "x2": "215.99902",
      "y2": "64",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "103.99902",
      "y1": "192",
      "x2": "215.99902",
      "y2": "192",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "40 60 56 52 56 107.994",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M41.10018,152.55059A14.00226,14.00226,0,1,1,65.609,165.82752L40,200H68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8a = [];
/* style */

const __vue_inject_styles__$8a = undefined;
/* scoped */

const __vue_scope_id__$8a = undefined;
/* module identifier */

const __vue_module_identifier__$8a = undefined;
/* functional template */

const __vue_is_functional_template__$8a = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8a = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8a,
  staticRenderFns: __vue_staticRenderFns__$8a
}, __vue_inject_styles__$8a, __vue_script__$8a, __vue_scope_id__$8a, __vue_is_functional_template__$8a, __vue_module_identifier__$8a, false, undefined, undefined, undefined);

var script$8b = Vue.extend({
  name: "PhListPlus",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8b = script$8b;
/* template */

var __vue_render__$8b = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "64",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "192",
      "x2": "144",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "192",
      "x2": "232",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "168",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "64.00586",
      "x2": "216",
      "y2": "64.00586",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "128.00586",
      "x2": "216",
      "y2": "128.00586",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "192.00586",
      "x2": "144",
      "y2": "192.00586",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "192.00586",
      "x2": "232",
      "y2": "192.00586",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "168.00586",
      "x2": "208",
      "y2": "216.00586",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,64.00586a8.00008,8.00008,0,0,1,8-8H216a8,8,0,0,1,0,16H40A8.00008,8.00008,0,0,1,32,64.00586Zm8,72H216a8,8,0,0,0,0-16H40a8,8,0,1,0,0,16Zm104,48H40a8,8,0,0,0,0,16H144a8,8,0,0,0,0-16Zm88,0H216v-16a8,8,0,1,0-16,0v16H184a8,8,0,0,0,0,16h16v16a8,8,0,0,0,16,0v-16h16a8,8,0,0,0,0-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "64.00586",
      "x2": "216",
      "y2": "64.00586",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "128.00586",
      "x2": "216",
      "y2": "128.00586",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "192.00586",
      "x2": "144",
      "y2": "192.00586",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "192.00586",
      "x2": "232",
      "y2": "192.00586",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "168.00586",
      "x2": "208",
      "y2": "216.00586",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "64",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "192",
      "x2": "144",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "192",
      "x2": "232",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "168",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "64",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "192",
      "x2": "144",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "192",
      "x2": "232",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "168",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8b = [];
/* style */

const __vue_inject_styles__$8b = undefined;
/* scoped */

const __vue_scope_id__$8b = undefined;
/* module identifier */

const __vue_module_identifier__$8b = undefined;
/* functional template */

const __vue_is_functional_template__$8b = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8b = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8b,
  staticRenderFns: __vue_staticRenderFns__$8b
}, __vue_inject_styles__$8b, __vue_script__$8b, __vue_scope_id__$8b, __vue_is_functional_template__$8b, __vue_module_identifier__$8b, false, undefined, undefined, undefined);

var script$8c = Vue.extend({
  name: "PhLock",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8c = script$8c;
/* template */

var __vue_render__$8c = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92,88V52a36,36,0,0,1,72,0V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "152",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92,88V52a36,36,0,0,1,72,0V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "152",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,80H172V52a44,44,0,0,0-88,0V80H48A16.01833,16.01833,0,0,0,32,96V208a16.01833,16.01833,0,0,0,16,16H208a16.01833,16.01833,0,0,0,16-16V96A16.01833,16.01833,0,0,0,208,80Zm-80.00586,84a12,12,0,1,1,12-12A12,12,0,0,1,127.99414,164ZM156,80H100V52a28,28,0,0,1,56,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92,88V52a36,36,0,0,1,72,0V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "152",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92,88V52a36,36,0,0,1,72,0V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "152",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92,88V52a36,36,0,0,1,72,0V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "152",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8c = [];
/* style */

const __vue_inject_styles__$8c = undefined;
/* scoped */

const __vue_scope_id__$8c = undefined;
/* module identifier */

const __vue_module_identifier__$8c = undefined;
/* functional template */

const __vue_is_functional_template__$8c = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8c = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8c,
  staticRenderFns: __vue_staticRenderFns__$8c
}, __vue_inject_styles__$8c, __vue_script__$8c, __vue_scope_id__$8c, __vue_is_functional_template__$8c, __vue_module_identifier__$8c, false, undefined, undefined, undefined);

var script$8d = Vue.extend({
  name: "PhLockKey",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8d = script$8d;
/* template */

var __vue_render__$8d = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "39.99414",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M91.99414,88V52a36,36,0,1,1,72,0V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "127.99414",
      "cy": "144",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "127.99414",
      "y1": "164",
      "x2": "127.99414",
      "y2": "180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M207.99414,88h-160a8,8,0,0,0-8,8V208a8,8,0,0,0,8,8h160a8,8,0,0,0,8-8V96A8,8,0,0,0,207.99414,88Zm-80,72a20,20,0,1,1,20-20A20.00006,20.00006,0,0,1,127.99414,160Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "127.99414",
      "cy": "140",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "127.99414",
      "y1": "160",
      "x2": "127.99414",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "39.99414",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M91.99414,88V52a36,36,0,1,1,72,0V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('circle', {
    attrs: {
      "cx": "127.99414",
      "cy": "140",
      "r": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M207.99414,80h-36V52a44,44,0,1,0-88,0V80h-36a16.01833,16.01833,0,0,0-16,16V208a16.01833,16.01833,0,0,0,16,16h160a16.01833,16.01833,0,0,0,16-16V96A16.01833,16.01833,0,0,0,207.99414,80Zm-72,86.82935V184a8,8,0,1,1-16,0V166.82935a28,28,0,1,1,16,0Zm20-86.82935h-56V52a28,28,0,1,1,56,0Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "127.99414",
      "cy": "140",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "127.99414",
      "y1": "160",
      "x2": "127.99414",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "39.99414",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M91.99414,88V52a36,36,0,1,1,72,0V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "127.99414",
      "cy": "140",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "127.99414",
      "y1": "160",
      "x2": "127.99414",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "39.99414",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M91.99414,88V52a36,36,0,1,1,72,0V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "127.99414",
      "cy": "140",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "127.99414",
      "y1": "160",
      "x2": "127.99414",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "39.99414",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M91.99414,88V52a36,36,0,1,1,72,0V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8d = [];
/* style */

const __vue_inject_styles__$8d = undefined;
/* scoped */

const __vue_scope_id__$8d = undefined;
/* module identifier */

const __vue_module_identifier__$8d = undefined;
/* functional template */

const __vue_is_functional_template__$8d = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8d = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8d,
  staticRenderFns: __vue_staticRenderFns__$8d
}, __vue_inject_styles__$8d, __vue_script__$8d, __vue_scope_id__$8d, __vue_is_functional_template__$8d, __vue_module_identifier__$8d, false, undefined, undefined, undefined);

var script$8e = Vue.extend({
  name: "PhLockKeyOpen",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8e = script$8e;
/* template */

var __vue_render__$8e = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "127.99414",
      "cy": "144",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "127.99414",
      "y1": "164",
      "x2": "127.99414",
      "y2": "180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "39.99414",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M91.99414,88V52a36.00169,36.00169,0,0,1,71.78028-4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M207.99414,88h-160a8,8,0,0,0-8,8V208a8,8,0,0,0,8,8h160a8,8,0,0,0,8-8V96A8,8,0,0,0,207.99414,88Zm-80,72a20,20,0,1,1,20-20A20.00006,20.00006,0,0,1,127.99414,160Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "127.99414",
      "cy": "140",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "127.99414",
      "y1": "160",
      "x2": "127.99414",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "39.99414",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M91.99414,88V52a36,36,0,1,1,72,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('circle', {
    attrs: {
      "cx": "127.99414",
      "cy": "140",
      "r": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M207.99414,80h-108V52a28,28,0,1,1,56,0,8,8,0,0,0,16,0,44,44,0,1,0-88,0V80h-36a16.01833,16.01833,0,0,0-16,16V208a16.01833,16.01833,0,0,0,16,16h160a16.01833,16.01833,0,0,0,16-16V96A16.01833,16.01833,0,0,0,207.99414,80Zm-72,86.82935V184a8,8,0,1,1-16,0V166.82935a28,28,0,1,1,16,0Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "127.99414",
      "cy": "140",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "127.99414",
      "y1": "160",
      "x2": "127.99414",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "39.99414",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M91.99414,88V52a36,36,0,1,1,72,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "127.99414",
      "cy": "140",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "127.99414",
      "y1": "160",
      "x2": "127.99414",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "39.99414",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M91.99414,88V52a36,36,0,1,1,72,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "127.99414",
      "cy": "140",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "127.99414",
      "y1": "160",
      "x2": "127.99414",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "39.99414",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M91.99414,88V52a36,36,0,1,1,72,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8e = [];
/* style */

const __vue_inject_styles__$8e = undefined;
/* scoped */

const __vue_scope_id__$8e = undefined;
/* module identifier */

const __vue_module_identifier__$8e = undefined;
/* functional template */

const __vue_is_functional_template__$8e = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8e = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8e,
  staticRenderFns: __vue_staticRenderFns__$8e
}, __vue_inject_styles__$8e, __vue_script__$8e, __vue_scope_id__$8e, __vue_is_functional_template__$8e, __vue_module_identifier__$8e, false, undefined, undefined, undefined);

var script$8f = Vue.extend({
  name: "PhLockLaminated",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8f = script$8f;
/* template */

var __vue_render__$8f = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "39.99414",
      "y1": "132",
      "x2": "215.99414",
      "y2": "132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "39.99414",
      "y1": "172",
      "x2": "215.99414",
      "y2": "172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "39.99414",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M91.99414,88V52a36,36,0,1,1,72,0V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "39.99414",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "39.99414",
      "y1": "120",
      "x2": "215.99414",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "39.99414",
      "y1": "152",
      "x2": "215.99414",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "39.99414",
      "y1": "184",
      "x2": "215.99414",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "39.99414",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M91.99414,88V52a36,36,0,1,1,72,0V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M207.96484,80h-36V52a44,44,0,0,0-88,0V80h-36a16.01833,16.01833,0,0,0-16,16V208a16.01833,16.01833,0,0,0,16,16h160a16.01833,16.01833,0,0,0,16-16V96A16.01833,16.01833,0,0,0,207.96484,80Zm-108-28a28,28,0,0,1,56,0V80h-56Zm84,140h-112a8,8,0,1,1,0-16h112a8,8,0,0,1,0,16Zm0-32h-112a8,8,0,1,1,0-16h112a8,8,0,0,1,0,16Zm0-32h-112a8,8,0,1,1,0-16h112a8,8,0,0,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "39.99414",
      "y1": "120",
      "x2": "215.99414",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "39.99414",
      "y1": "152",
      "x2": "215.99414",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "39.99414",
      "y1": "184",
      "x2": "215.99414",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "39.99414",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M91.99414,88V52a36,36,0,1,1,72,0V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "39.99414",
      "y1": "120",
      "x2": "215.99414",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "39.99414",
      "y1": "152",
      "x2": "215.99414",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "39.99414",
      "y1": "184",
      "x2": "215.99414",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "39.99414",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M91.99414,88V52a36,36,0,1,1,72,0V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "39.99414",
      "y1": "120",
      "x2": "215.99414",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "39.99414",
      "y1": "152",
      "x2": "215.99414",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "39.99414",
      "y1": "184",
      "x2": "215.99414",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "39.99414",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M91.99414,88V52a36,36,0,1,1,72,0V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8f = [];
/* style */

const __vue_inject_styles__$8f = undefined;
/* scoped */

const __vue_scope_id__$8f = undefined;
/* module identifier */

const __vue_module_identifier__$8f = undefined;
/* functional template */

const __vue_is_functional_template__$8f = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8f = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8f,
  staticRenderFns: __vue_staticRenderFns__$8f
}, __vue_inject_styles__$8f, __vue_script__$8f, __vue_scope_id__$8f, __vue_is_functional_template__$8f, __vue_module_identifier__$8f, false, undefined, undefined, undefined);

var script$8g = Vue.extend({
  name: "PhLockLaminatedOpen",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8g = script$8g;
/* template */

var __vue_render__$8g = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40.0127",
      "y1": "132",
      "x2": "216.0127",
      "y2": "132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40.0127",
      "y1": "172",
      "x2": "216.0127",
      "y2": "172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40.0127",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.0127,88V52A36.00169,36.00169,0,0,1,163.793,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "39.99414",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "39.99414",
      "y1": "120",
      "x2": "215.99414",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "39.99414",
      "y1": "152",
      "x2": "215.99414",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "39.99414",
      "y1": "184",
      "x2": "215.99414",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "39.99414",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M91.99414,88V52a36,36,0,1,1,72,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M207.99463,80h-108V52a28,28,0,0,1,56,0,8,8,0,0,0,16,0,44,44,0,0,0-88,0V80h-36a16.01833,16.01833,0,0,0-16,16V208a16.01833,16.01833,0,0,0,16,16h160a16.01833,16.01833,0,0,0,16-16V96A16.01833,16.01833,0,0,0,207.99463,80ZM183.99268,192H71.99463a8,8,0,0,1,0-16H183.99268a8,8,0,0,1,0,16Zm0-32H71.99463a8,8,0,0,1,0-16H183.99268a8,8,0,0,1,0,16Zm0-32H71.99463a8,8,0,0,1,0-16H183.99268a8,8,0,0,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "39.99414",
      "y1": "120",
      "x2": "215.99414",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "39.99414",
      "y1": "152",
      "x2": "215.99414",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "39.99414",
      "y1": "184",
      "x2": "215.99414",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "39.99414",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M91.99414,88V52a36,36,0,1,1,72,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "39.99414",
      "y1": "120",
      "x2": "215.99414",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "39.99414",
      "y1": "152",
      "x2": "215.99414",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "39.99414",
      "y1": "184",
      "x2": "215.99414",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "39.99414",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M91.99414,88V52a36,36,0,1,1,72,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "39.99414",
      "y1": "120",
      "x2": "215.99414",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "39.99414",
      "y1": "152",
      "x2": "215.99414",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "39.99414",
      "y1": "184",
      "x2": "215.99414",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "39.99414",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M91.99414,88V52a36,36,0,1,1,72,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8g = [];
/* style */

const __vue_inject_styles__$8g = undefined;
/* scoped */

const __vue_scope_id__$8g = undefined;
/* module identifier */

const __vue_module_identifier__$8g = undefined;
/* functional template */

const __vue_is_functional_template__$8g = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8g = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8g,
  staticRenderFns: __vue_staticRenderFns__$8g
}, __vue_inject_styles__$8g, __vue_script__$8g, __vue_scope_id__$8g, __vue_is_functional_template__$8g, __vue_module_identifier__$8g, false, undefined, undefined, undefined);

var script$8h = Vue.extend({
  name: "PhLockOpen",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8h = script$8h;
/* template */

var __vue_render__$8h = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92,88V52a36.00169,36.00169,0,0,1,71.78028-4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "152",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92,88V52a36,36,0,0,1,72,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "152",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,80H100V52a28,28,0,0,1,56,0,8,8,0,0,0,16,0,44,44,0,0,0-88,0V80H48A16.01833,16.01833,0,0,0,32,96V208a16.01833,16.01833,0,0,0,16,16H208a16.01833,16.01833,0,0,0,16-16V96A16.01833,16.01833,0,0,0,208,80Zm-80.00586,84a12,12,0,1,1,12-12A12,12,0,0,1,127.99414,164Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92,88V52a36,36,0,0,1,72,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "152",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92,88V52a36,36,0,0,1,72,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "152",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92,88V52a36,36,0,0,1,72,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "152",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8h = [];
/* style */

const __vue_inject_styles__$8h = undefined;
/* scoped */

const __vue_scope_id__$8h = undefined;
/* module identifier */

const __vue_module_identifier__$8h = undefined;
/* functional template */

const __vue_is_functional_template__$8h = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8h = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8h,
  staticRenderFns: __vue_staticRenderFns__$8h
}, __vue_inject_styles__$8h, __vue_script__$8h, __vue_scope_id__$8h, __vue_is_functional_template__$8h, __vue_module_identifier__$8h, false, undefined, undefined, undefined);

var script$8i = Vue.extend({
  name: "PhLockSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8i = script$8i;
/* template */

var __vue_render__$8i = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "39.99414",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M91.99414,88V52a36,36,0,1,1,72,0V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "39.99414",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "39.99414",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M91.99414,88V52a36,36,0,1,1,72,0V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M207.99463,80h-36V52a44,44,0,0,0-88,0V80h-36a16.01833,16.01833,0,0,0-16,16V208a16.01833,16.01833,0,0,0,16,16h160a16.01833,16.01833,0,0,0,16-16V96A16.01833,16.01833,0,0,0,207.99463,80Zm-108-28a28,28,0,0,1,56,0V80h-56Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "39.99414",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M91.99414,88V52a36,36,0,1,1,72,0V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "39.99414",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M91.99414,88V52a36,36,0,1,1,72,0V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "39.99414",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M91.99414,88V52a36,36,0,1,1,72,0V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8i = [];
/* style */

const __vue_inject_styles__$8i = undefined;
/* scoped */

const __vue_scope_id__$8i = undefined;
/* module identifier */

const __vue_module_identifier__$8i = undefined;
/* functional template */

const __vue_is_functional_template__$8i = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8i = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8i,
  staticRenderFns: __vue_staticRenderFns__$8i
}, __vue_inject_styles__$8i, __vue_script__$8i, __vue_scope_id__$8i, __vue_is_functional_template__$8i, __vue_module_identifier__$8i, false, undefined, undefined, undefined);

var script$8j = Vue.extend({
  name: "PhLockSimpleOpen",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8j = script$8j;
/* template */

var __vue_render__$8j = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "39.99414",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.0127,88V52A36.00169,36.00169,0,0,1,163.793,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "39.99414",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "39.99414",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M91.99414,88V52a36,36,0,1,1,72,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M207.99463,80h-108V52a28,28,0,0,1,56,0,8,8,0,0,0,16,0,44,44,0,0,0-88,0V80h-36a16.01833,16.01833,0,0,0-16,16V208a16.01833,16.01833,0,0,0,16,16h160a16.01833,16.01833,0,0,0,16-16V96A16.01833,16.01833,0,0,0,207.99463,80Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "39.99414",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M91.99414,88V52a36,36,0,1,1,72,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "39.99414",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M91.99414,88V52a36,36,0,1,1,72,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "39.99414",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M91.99414,88V52a36,36,0,1,1,72,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8j = [];
/* style */

const __vue_inject_styles__$8j = undefined;
/* scoped */

const __vue_scope_id__$8j = undefined;
/* module identifier */

const __vue_module_identifier__$8j = undefined;
/* functional template */

const __vue_is_functional_template__$8j = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8j = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8j,
  staticRenderFns: __vue_staticRenderFns__$8j
}, __vue_inject_styles__$8j, __vue_script__$8j, __vue_scope_id__$8j, __vue_is_functional_template__$8j, __vue_module_identifier__$8j, false, undefined, undefined, undefined);

var script$8k = Vue.extend({
  name: "PhMagicWand",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8k = script$8k;
/* template */

var __vue_render__$8k = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "220",
      "y1": "128",
      "x2": "220",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "196",
      "y1": "152",
      "x2": "244",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "36",
      "x2": "80",
      "y2": "76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "60",
      "y1": "56",
      "x2": "100",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "164",
      "y1": "188",
      "x2": "164",
      "y2": "220",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "148",
      "y1": "204",
      "x2": "180",
      "y2": "204",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "14.86292",
      "y": "105.37258",
      "width": "226.27417",
      "height": "45.25483",
      "rx": "8",
      "transform": "translate(-53.01934 128) rotate(-45)",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "80",
      "x2": "176",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M69.65685,218.34315a8,8,0,0,1-11.3137,0l-20.6863-20.6863a8,8,0,0,1,0-11.3137L144,80l32,32Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "128",
      "x2": "216",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "152",
      "x2": "240",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "84",
      "y1": "40",
      "x2": "84",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "60",
      "x2": "104",
      "y2": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "184",
      "x2": "168",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "200",
      "x2": "184",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "14.86292",
      "y": "105.37258",
      "width": "226.27417",
      "height": "45.25483",
      "rx": "8",
      "transform": "translate(-53.01934 128) rotate(-45)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "80",
      "x2": "176",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M248,152a8.00008,8.00008,0,0,1-8,8H224v16a8,8,0,0,1-16,0V160H192a8,8,0,0,1,0-16h16V128a8,8,0,0,1,16,0v16h16A8.00008,8.00008,0,0,1,248,152ZM64,68H76V80a8,8,0,0,0,16,0V68h12a8,8,0,0,0,0-16H92V40a8,8,0,0,0-16,0V52H64a8,8,0,0,0,0,16ZM184,192h-8v-8a8,8,0,0,0-16,0v8h-8a8,8,0,0,0,0,16h8v8a8,8,0,0,0,16,0v-8h8a8,8,0,0,0,0-16Zm-2.34619-74.33984L75.31445,224a16.02252,16.02252,0,0,1-22.62793.001L32,203.31348a15.99888,15.99888,0,0,1,.001-22.62793L180.68555,32a16.02162,16.02162,0,0,1,22.62793-.001L224,52.68652a15.99888,15.99888,0,0,1-.001,22.62793l-42.33886,42.33887-.00293.00342ZM155.314,80,176,100.686,212.68555,64l.001-.001.00684-.00732L192,43.31348Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "216",
      "y1": "128",
      "x2": "216",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "152",
      "x2": "240",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "84",
      "y1": "40",
      "x2": "84",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "60",
      "x2": "104",
      "y2": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "184",
      "x2": "168",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "200",
      "x2": "184",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "14.86292",
      "y": "105.37258",
      "width": "226.27417",
      "height": "45.25483",
      "rx": "8",
      "transform": "translate(-53.01934 128) rotate(-45)",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "80",
      "x2": "176",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "216",
      "y1": "128",
      "x2": "216",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "152",
      "x2": "240",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "84",
      "y1": "40",
      "x2": "84",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "60",
      "x2": "104",
      "y2": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "184",
      "x2": "168",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "200",
      "x2": "184",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "14.86292",
      "y": "105.37258",
      "width": "226.27417",
      "height": "45.25483",
      "rx": "8",
      "transform": "translate(-53.01934 128) rotate(-45)",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "80",
      "x2": "176",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "216",
      "y1": "128",
      "x2": "216",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "152",
      "x2": "240",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "84",
      "y1": "40",
      "x2": "84",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "60",
      "x2": "104",
      "y2": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "184",
      "x2": "168",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "200",
      "x2": "184",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "14.86292",
      "y": "105.37258",
      "width": "226.27417",
      "height": "45.25483",
      "rx": "8",
      "transform": "translate(-53.01934 128) rotate(-45)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "80",
      "x2": "176",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8k = [];
/* style */

const __vue_inject_styles__$8k = undefined;
/* scoped */

const __vue_scope_id__$8k = undefined;
/* module identifier */

const __vue_module_identifier__$8k = undefined;
/* functional template */

const __vue_is_functional_template__$8k = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8k = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8k,
  staticRenderFns: __vue_staticRenderFns__$8k
}, __vue_inject_styles__$8k, __vue_script__$8k, __vue_scope_id__$8k, __vue_is_functional_template__$8k, __vue_module_identifier__$8k, false, undefined, undefined, undefined);

var script$8l = Vue.extend({
  name: "PhMagnet",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8l = script$8l;
/* template */

var __vue_render__$8l = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M127.28929,95.02944a24.00012,24.00012,0,0,1,33.60985-.325c9.693,9.33217,9.46338,25.13406-.0509,34.64834L93.83171,194.34449a8,8,0,0,0-.08742,11.3998L122.3982,234.3982a8,8,0,0,0,11.25812.055l66.46192-65.17456C231.30992,138.087,232.21531,87.284,201.25572,55.862a80.00007,80.00007,0,0,0-113.56441-.43051l-66.103,66.91189a8,8,0,0,0,.03429,11.27921l28.65427,28.65427a8,8,0,0,0,11.37925-.0663Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "126.77456",
      "y1": "162.39696",
      "x2": "166.56227",
      "y2": "202.18467",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "53.95657",
      "y1": "89.57897",
      "x2": "93.74372",
      "y2": "129.36612",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M126.77456,162.397l39.78771,39.78771-32.906,32.26858a8,8,0,0,1-11.25812-.055L93.74429,205.74429a8,8,0,0,1,.08742-11.3998Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M93.74372,129.36612,53.95657,89.579l-32.3683,32.76438a8,8,0,0,0,.03429,11.27921l28.65427,28.65427a8,8,0,0,0,11.37925-.0663Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M127.28929,95.02944a24.00012,24.00012,0,0,1,33.60985-.325c9.693,9.33217,9.46338,25.13406-.0509,34.64834L93.83171,194.34449a8,8,0,0,0-.08742,11.3998L122.3982,234.3982a8,8,0,0,0,11.25812.055l66.46192-65.17456C231.30992,138.087,232.21531,87.284,201.25572,55.862a80.00007,80.00007,0,0,0-113.56441-.43051l-66.103,66.91189a8,8,0,0,0,.03429,11.27921l28.65427,28.65427a8,8,0,0,0,11.37925-.0663Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "126.77456",
      "y1": "162.39696",
      "x2": "166.56227",
      "y2": "202.18467",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "53.95657",
      "y1": "89.57897",
      "x2": "93.74372",
      "y2": "129.36612",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M206.9541,50.24707A87.40283,87.40283,0,0,0,144.58789,24.001C144.47461,24,144.36426,24,144.252,24A87.41952,87.41952,0,0,0,82,49.80957L48.30078,83.92084l-.001.001-.00146.00147L15.89746,116.7207a16.03806,16.03806,0,0,0,.06836,22.55957l28.65332,28.65332a15.889,15.889,0,0,0,11.3125,4.68653h.0957a15.88936,15.88936,0,0,0,11.35157-4.81836l32.0205-32.77661.002-.00171.00293-.003,33.57226-34.36518a16.07987,16.07987,0,0,1,22.374-.18847,15.58821,15.58821,0,0,1,4.72558,11.19629,16.88015,16.88015,0,0,1-4.84472,11.99316l-34.10694,33.07623-.00732.00678-.00391.004L88.2627,188.60156a15.99983,15.99983,0,0,0-.17579,22.79981l28.6543,28.65429a16.052,16.052,0,0,0,22.5166.10938l32.957-32.31885.00489-.00439.00293-.0033,33.55273-32.903C240.22363,140.48633,240.75293,84.55176,206.9541,50.24707ZM55.93359,156.61914,27.2793,127.96582l26.71191-27.03827L82.49512,129.4314Zm72.12207,72.12207L99.40137,200.08789l27.28711-26.46283,28.50439,28.50421Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M127.28929,95.02944a24.00012,24.00012,0,0,1,33.60985-.325c9.693,9.33217,9.46338,25.13406-.0509,34.64834L93.83171,194.34449a8,8,0,0,0-.08742,11.3998L122.3982,234.3982a8,8,0,0,0,11.25812.055l66.46192-65.17456C231.30992,138.087,232.21531,87.284,201.25572,55.862a80.00007,80.00007,0,0,0-113.56441-.43051l-66.103,66.91189a8,8,0,0,0,.03429,11.27921l28.65427,28.65427a8,8,0,0,0,11.37925-.0663Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "126.77456",
      "y1": "162.39696",
      "x2": "166.56227",
      "y2": "202.18467",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "53.95657",
      "y1": "89.57897",
      "x2": "93.74372",
      "y2": "129.36612",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M127.28929,95.02944a24.00012,24.00012,0,0,1,33.60985-.325c9.693,9.33217,9.46338,25.13406-.0509,34.64834L93.83171,194.34449a8,8,0,0,0-.08742,11.3998L122.3982,234.3982a8,8,0,0,0,11.25812.055l66.46192-65.17456C231.30992,138.087,232.21531,87.284,201.25572,55.862a80.00007,80.00007,0,0,0-113.56441-.43051l-66.103,66.91189a8,8,0,0,0,.03429,11.27921l28.65427,28.65427a8,8,0,0,0,11.37925-.0663Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "126.77456",
      "y1": "162.39696",
      "x2": "166.56227",
      "y2": "202.18467",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "53.95657",
      "y1": "89.57897",
      "x2": "93.74372",
      "y2": "129.36612",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M127.28929,95.02944a24.00012,24.00012,0,0,1,33.60985-.325c9.693,9.33217,9.46338,25.13406-.0509,34.64834L93.83171,194.34449a8,8,0,0,0-.08742,11.3998L122.3982,234.3982a8,8,0,0,0,11.25812.055l66.46192-65.17456C231.30992,138.087,232.21531,87.284,201.25572,55.862a80.00007,80.00007,0,0,0-113.56441-.43051l-66.103,66.91189a8,8,0,0,0,.03429,11.27921l28.65427,28.65427a8,8,0,0,0,11.37925-.0663Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "126.77456",
      "y1": "162.39696",
      "x2": "166.56227",
      "y2": "202.18467",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "53.95657",
      "y1": "89.57897",
      "x2": "93.74372",
      "y2": "129.36612",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8l = [];
/* style */

const __vue_inject_styles__$8l = undefined;
/* scoped */

const __vue_scope_id__$8l = undefined;
/* module identifier */

const __vue_module_identifier__$8l = undefined;
/* functional template */

const __vue_is_functional_template__$8l = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8l = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8l,
  staticRenderFns: __vue_staticRenderFns__$8l
}, __vue_inject_styles__$8l, __vue_script__$8l, __vue_scope_id__$8l, __vue_is_functional_template__$8l, __vue_module_identifier__$8l, false, undefined, undefined, undefined);

var script$8m = Vue.extend({
  name: "PhMagnetStraight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8m = script$8m;
/* template */

var __vue_render__$8m = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "96",
      "x2": "104",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "96",
      "x2": "208",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,144a24,24,0,0,0,48,0V56a8,8,0,0,1,8-8h40a8,8,0,0,1,8,8v86.9957c0,44.11169-35.28293,80.675-79.39341,81.00205A80.00008,80.00008,0,0,1,48,144V56a8,8,0,0,1,8-8H96a8,8,0,0,1,8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M48,56a8,8,0,0,1,8-8H96a8,8,0,0,1,8,8V96H48Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,56a8,8,0,0,1,8-8h40a8,8,0,0,1,8,8V96H152Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "96",
      "x2": "104",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "96",
      "x2": "208",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,144a24,24,0,0,0,48,0V56a8,8,0,0,1,8-8h40a8,8,0,0,1,8,8v86.9957c0,44.11169-35.28293,80.675-79.39341,81.00205A80.00008,80.00008,0,0,1,48,144V56a8,8,0,0,1,8-8H96a8,8,0,0,1,8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,40H160a16.01833,16.01833,0,0,0-16,16v88a16,16,0,0,1-32,0V56A16.01833,16.01833,0,0,0,96,40H56A16.01833,16.01833,0,0,0,40,56v88a87.99955,87.99955,0,0,0,87.99512,88c.22265,0,.44726-.001.6709-.00195,48.15625-.35743,87.334-40.28321,87.334-89.002V56A16.01833,16.01833,0,0,0,200,40Zm0,16V96H160V56ZM96,56V96H56V56Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "96",
      "x2": "104",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "96",
      "x2": "208",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,144a24,24,0,0,0,48,0V56a8,8,0,0,1,8-8h40a8,8,0,0,1,8,8v86.9957c0,44.11169-35.28293,80.675-79.39341,81.00205A80.00008,80.00008,0,0,1,48,144V56a8,8,0,0,1,8-8H96a8,8,0,0,1,8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "96",
      "x2": "104",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "96",
      "x2": "208",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,144a24,24,0,0,0,48,0V56a8,8,0,0,1,8-8h40a8,8,0,0,1,8,8v86.9957c0,44.11169-35.28293,80.675-79.39341,81.00205A80.00008,80.00008,0,0,1,48,144V56a8,8,0,0,1,8-8H96a8,8,0,0,1,8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "96",
      "x2": "104",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "96",
      "x2": "208",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,144a24,24,0,0,0,48,0V56a8,8,0,0,1,8-8h40a8,8,0,0,1,8,8v86.9957c0,44.11169-35.28293,80.675-79.39341,81.00205A80.00008,80.00008,0,0,1,48,144V56a8,8,0,0,1,8-8H96a8,8,0,0,1,8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8m = [];
/* style */

const __vue_inject_styles__$8m = undefined;
/* scoped */

const __vue_scope_id__$8m = undefined;
/* module identifier */

const __vue_module_identifier__$8m = undefined;
/* functional template */

const __vue_is_functional_template__$8m = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8m = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8m,
  staticRenderFns: __vue_staticRenderFns__$8m
}, __vue_inject_styles__$8m, __vue_script__$8m, __vue_scope_id__$8m, __vue_is_functional_template__$8m, __vue_module_identifier__$8m, false, undefined, undefined, undefined);

var script$8n = Vue.extend({
  name: "PhMagnifyingGlass",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8n = script$8n;
/* template */

var __vue_render__$8n = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "115.99707",
      "cy": "116",
      "r": "84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "175.39063",
      "y1": "175.40039",
      "x2": "223.99121",
      "y2": "224.00098",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "115.99512",
      "cy": "116",
      "r": "84",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "115.99512",
      "cy": "116",
      "r": "84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "175.38868",
      "y1": "175.40039",
      "x2": "223.98926",
      "y2": "224.00098",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M175.99609,116a60,60,0,1,1-60-60A60.06812,60.06812,0,0,1,175.99609,116Zm53.65137,113.65771a8.0006,8.0006,0,0,1-11.31445,0l-43.2229-43.2229a92.11513,92.11513,0,1,1,11.31445-11.31347l43.2229,43.2229A8,8,0,0,1,229.64746,229.65771ZM115.99609,192a76,76,0,1,0-76-76A76.08614,76.08614,0,0,0,115.99609,192Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "115.99805",
      "cy": "116",
      "r": "84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "175.39161",
      "y1": "175.40039",
      "x2": "223.99219",
      "y2": "224.00098",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "115.99902",
      "cy": "116",
      "r": "84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "175.39258",
      "y1": "175.40039",
      "x2": "223.99316",
      "y2": "224.00098",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "116",
      "cy": "116",
      "r": "84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "175.39356",
      "y1": "175.40039",
      "x2": "223.99414",
      "y2": "224.00098",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8n = [];
/* style */

const __vue_inject_styles__$8n = undefined;
/* scoped */

const __vue_scope_id__$8n = undefined;
/* module identifier */

const __vue_module_identifier__$8n = undefined;
/* functional template */

const __vue_is_functional_template__$8n = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8n = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8n,
  staticRenderFns: __vue_staticRenderFns__$8n
}, __vue_inject_styles__$8n, __vue_script__$8n, __vue_scope_id__$8n, __vue_is_functional_template__$8n, __vue_module_identifier__$8n, false, undefined, undefined, undefined);

var script$8o = Vue.extend({
  name: "PhMagnifyingGlassMinus",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8o = script$8o;
/* template */

var __vue_render__$8o = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "83.99707",
      "y1": "116",
      "x2": "147.99707",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "115.99707",
      "cy": "115.99707",
      "r": "84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "175.39063",
      "y1": "175.39747",
      "x2": "223.99121",
      "y2": "223.99805",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "115.99512",
      "cy": "115.99707",
      "r": "84",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "83.99512",
      "y1": "116",
      "x2": "147.99512",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "115.99512",
      "cy": "115.99707",
      "r": "84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "175.38868",
      "y1": "175.39747",
      "x2": "223.98926",
      "y2": "223.99805",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M229.64746,218.34131l-43.2229-43.22284a92.11145,92.11145,0,1,0-11.31445,11.31341l43.2229,43.22291a8.00018,8.00018,0,0,0,11.31445-11.31348ZM147.99609,124h-64a8,8,0,1,1,0-16h64a8,8,0,0,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "83.99805",
      "y1": "116",
      "x2": "147.99805",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "115.99805",
      "cy": "115.99707",
      "r": "84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "175.39161",
      "y1": "175.39747",
      "x2": "223.99219",
      "y2": "223.99805",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "83.99902",
      "y1": "116",
      "x2": "147.99902",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "115.99902",
      "cy": "115.99707",
      "r": "84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "175.39258",
      "y1": "175.39747",
      "x2": "223.99316",
      "y2": "223.99805",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "84",
      "y1": "116",
      "x2": "148",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "116",
      "cy": "115.99707",
      "r": "84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "175.39356",
      "y1": "175.39747",
      "x2": "223.99414",
      "y2": "223.99805",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8o = [];
/* style */

const __vue_inject_styles__$8o = undefined;
/* scoped */

const __vue_scope_id__$8o = undefined;
/* module identifier */

const __vue_module_identifier__$8o = undefined;
/* functional template */

const __vue_is_functional_template__$8o = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8o = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8o,
  staticRenderFns: __vue_staticRenderFns__$8o
}, __vue_inject_styles__$8o, __vue_script__$8o, __vue_scope_id__$8o, __vue_is_functional_template__$8o, __vue_module_identifier__$8o, false, undefined, undefined, undefined);

var script$8p = Vue.extend({
  name: "PhMagnifyingGlassPlus",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8p = script$8p;
/* template */

var __vue_render__$8p = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "83.99707",
      "y1": "116",
      "x2": "147.99707",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "115.99707",
      "y1": "84",
      "x2": "115.99707",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "115.99707",
      "cy": "115.99609",
      "r": "84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "175.39063",
      "y1": "175.39649",
      "x2": "223.99121",
      "y2": "223.99707",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "115.99512",
      "cy": "115.99609",
      "r": "84",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "83.99512",
      "y1": "116",
      "x2": "147.99512",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "115.99512",
      "y1": "84",
      "x2": "115.99512",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "115.99512",
      "cy": "115.99609",
      "r": "84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "175.38868",
      "y1": "175.39649",
      "x2": "223.98926",
      "y2": "223.99707",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M229.64746,218.34033l-43.2229-43.22284a92.11133,92.11133,0,1,0-11.31445,11.31342l43.2229,43.2229a8.00018,8.00018,0,1,0,11.31445-11.31348ZM147.99609,124h-24v24a8,8,0,0,1-16,0V124h-24a8,8,0,1,1,0-16h24V84a8,8,0,0,1,16,0v24h24a8,8,0,0,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "83.99805",
      "y1": "116",
      "x2": "147.99805",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "115.99805",
      "y1": "84",
      "x2": "115.99805",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "115.99805",
      "cy": "115.99609",
      "r": "84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "175.39161",
      "y1": "175.39649",
      "x2": "223.99219",
      "y2": "223.99707",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "83.99902",
      "y1": "116",
      "x2": "147.99902",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "115.99902",
      "y1": "84",
      "x2": "115.99902",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "115.99902",
      "cy": "115.99609",
      "r": "84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "175.39258",
      "y1": "175.39649",
      "x2": "223.99316",
      "y2": "223.99707",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "84",
      "y1": "116",
      "x2": "148",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "116",
      "y1": "84",
      "x2": "116",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "116",
      "cy": "115.99609",
      "r": "84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "175.39356",
      "y1": "175.39649",
      "x2": "223.99414",
      "y2": "223.99707",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8p = [];
/* style */

const __vue_inject_styles__$8p = undefined;
/* scoped */

const __vue_scope_id__$8p = undefined;
/* module identifier */

const __vue_module_identifier__$8p = undefined;
/* functional template */

const __vue_is_functional_template__$8p = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8p = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8p,
  staticRenderFns: __vue_staticRenderFns__$8p
}, __vue_inject_styles__$8p, __vue_script__$8p, __vue_scope_id__$8p, __vue_is_functional_template__$8p, __vue_module_identifier__$8p, false, undefined, undefined, undefined);

var script$8q = Vue.extend({
  name: "PhMapPin",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8q = script$8q;
/* template */

var __vue_render__$8q = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "104",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,104c0,72-80,128-80,128S48,176,48,104a80,80,0,0,1,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24a80.0002,80.0002,0,0,0-80,80c0,72,80,128,80,128s80-56,80-128A80.0002,80.0002,0,0,0,128,24Zm0,112a32,32,0,1,1,32-32A32.00034,32.00034,0,0,1,128,136Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "104",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,104c0,72-80,128-80,128S48,176,48,104a80,80,0,0,1,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M127.99414,15.9971a88.1046,88.1046,0,0,0-88,88c0,75.29688,80,132.17188,83.40625,134.55469a8.023,8.023,0,0,0,9.1875,0c3.40625-2.38281,83.40625-59.25781,83.40625-134.55469A88.10459,88.10459,0,0,0,127.99414,15.9971ZM128,72a32,32,0,1,1-32,32A31.99909,31.99909,0,0,1,128,72Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "104",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,104c0,72-80,128-80,128S48,176,48,104a80,80,0,0,1,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "104",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,104c0,72-80,128-80,128S48,176,48,104a80,80,0,0,1,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "104",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,104c0,72-80,128-80,128S48,176,48,104a80,80,0,0,1,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8q = [];
/* style */

const __vue_inject_styles__$8q = undefined;
/* scoped */

const __vue_scope_id__$8q = undefined;
/* module identifier */

const __vue_module_identifier__$8q = undefined;
/* functional template */

const __vue_is_functional_template__$8q = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8q = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8q,
  staticRenderFns: __vue_staticRenderFns__$8q
}, __vue_inject_styles__$8q, __vue_script__$8q, __vue_scope_id__$8q, __vue_is_functional_template__$8q, __vue_module_identifier__$8q, false, undefined, undefined, undefined);

var script$8r = Vue.extend({
  name: "PhMapPinLine",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8r = script$8r;
/* template */

var __vue_render__$8r = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "56",
      "y1": "232",
      "x2": "200",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "104",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,104c0,72-80,128-80,128S48,176,48,104a80,80,0,0,1,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24a80.0002,80.0002,0,0,0-80,80c0,72,80,128,80,128s80-56,80-128A80.0002,80.0002,0,0,0,128,24Zm0,112a32,32,0,1,1,32-32A32.00034,32.00034,0,0,1,128,136Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "232",
      "x2": "200",
      "y2": "232",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "104",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,104c0,72-80,128-80,128S48,176,48,104a80,80,0,0,1,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M199.99975,224h-49.4602a266.47606,266.47606,0,0,0,23.49731-23.75049c27.45215-31.5708,41.96289-64.853,41.96289-96.24951a88,88,0,0,0-176,0c0,31.39648,14.51075,64.67871,41.96289,96.24951A266.476,266.476,0,0,0,105.46,224H55.99975a8,8,0,0,0,0,16h144a8,8,0,0,0,0-16ZM128,72a32,32,0,1,1-32,32A31.99971,31.99971,0,0,1,128,72Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "56",
      "y1": "232",
      "x2": "200",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "104",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,104c0,72-80,128-80,128S48,176,48,104a80,80,0,0,1,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "56",
      "y1": "232",
      "x2": "200",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "104",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,104c0,72-80,128-80,128S48,176,48,104a80,80,0,0,1,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "56",
      "y1": "232",
      "x2": "200",
      "y2": "232",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "104",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,104c0,72-80,128-80,128S48,176,48,104a80,80,0,0,1,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8r = [];
/* style */

const __vue_inject_styles__$8r = undefined;
/* scoped */

const __vue_scope_id__$8r = undefined;
/* module identifier */

const __vue_module_identifier__$8r = undefined;
/* functional template */

const __vue_is_functional_template__$8r = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8r = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8r,
  staticRenderFns: __vue_staticRenderFns__$8r
}, __vue_inject_styles__$8r, __vue_script__$8r, __vue_scope_id__$8r, __vue_is_functional_template__$8r, __vue_module_identifier__$8r, false, undefined, undefined, undefined);

var script$8s = Vue.extend({
  name: "PhMapTrifold",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8s = script$8s;
/* template */

var __vue_render__$8s = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "96 184 32 200 32 56 96 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "160 216 96 184 96 40 160 72 160 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 72 224 56 224 200 160 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "160 216 96 184 96 40 160 72 160 216",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 184 32 200 32 56 96 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "160 216 96 184 96 40 160 72 160 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 72 224 56 224 200 160 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M228.9226,49.69434a7.99952,7.99952,0,0,0-6.86328-1.45557L160.93066,63.521,99.57788,32.84448c-.01758-.00879-.03613-.01416-.054-.0227a8.0283,8.0283,0,0,0-.86059-.363c-.05152-.01831-.10425-.03125-.156-.04858q-.36695-.12121-.7456-.207c-.082-.01855-.16407-.03515-.24659-.051q-.35778-.06921-.72338-.105c-.06934-.00708-.13843-.01709-.208-.02222a7.93012,7.93012,0,0,0-.94019-.01684l-.02392.00219a7.97484,7.97484,0,0,0-.8833.09571c-.1001.01611-.19874.03857-.29834.05859-.12623.0249-.25245.04273-.37867.07422l-64,16A7.99985,7.99985,0,0,0,23.99975,56V200a8.00045,8.00045,0,0,0,9.94043,7.76123L95.06909,192.479l61.35254,30.67627c.03637.01807.0747.03.11133.04761q.32482.15673.66308.28442c.04175.01563.08277.0337.125.04883a7.95445,7.95445,0,0,0,.81494.24146c.04273.01025.08545.01782.12818.02734q.36034.0802.72925.12671c.05078.00659.10131.01392.15234.01929a7.29318,7.29318,0,0,0,1.89233-.02222c.11182-.01465.22144-.04248.33277-.06177.18994-.0332.37939-.05835.56933-.10571l64-16A8,8,0,0,0,231.99975,200V56A7.99871,7.99871,0,0,0,228.9226,49.69434ZM151.99975,203.05566l-48-24V52.94434l48,24Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "96 184 32 200 32 56 96 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "160 216 96 184 96 40 160 72 160 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 72 224 56 224 200 160 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "96 184 32 200 32 56 96 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "160 216 96 184 96 40 160 72 160 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 72 224 56 224 200 160 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "96 184 32 200 32 56 96 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "160 216 96 184 96 40 160 72 160 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 72 224 56 224 200 160 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8s = [];
/* style */

const __vue_inject_styles__$8s = undefined;
/* scoped */

const __vue_scope_id__$8s = undefined;
/* module identifier */

const __vue_module_identifier__$8s = undefined;
/* functional template */

const __vue_is_functional_template__$8s = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8s = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8s,
  staticRenderFns: __vue_staticRenderFns__$8s
}, __vue_inject_styles__$8s, __vue_script__$8s, __vue_scope_id__$8s, __vue_is_functional_template__$8s, __vue_module_identifier__$8s, false, undefined, undefined, undefined);

var script$8t = Vue.extend({
  name: "PhMarkerCircle",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8t = script$8t;
/* template */

var __vue_render__$8t = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,211.16115V176a8,8,0,0,0-8-8H88a8,8,0,0,0-8,8v35.16442",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,168V136a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8v32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M147.83843,128,135.70664,84.4441a8,8,0,0,0-15.41328,0L108.16157,128Z",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M175.99816,211.158a96,96,0,1,0-95.99492.00082L80,211.16442V176a8,8,0,0,1,8-8h8V144a8,8,0,0,1,8-8h4.1616l12.00656-57.63163c1.769-8.49116,13.89469-8.49116,15.66368,0L147.83843,136H152a8,8,0,0,1,8,8v24h8a8,8,0,0,1,8,8v35.16115Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,211.16115V176a8,8,0,0,0-8-8H88a8,8,0,0,0-8,8v35.16442",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,168V144a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8v24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M147.83843,136,135.83184,78.36837c-1.769-8.49116-13.89469-8.49116-15.66368,0L108.16157,136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M201.53906,54.46094A103.99994,103.99994,0,1,0,54.46094,201.53906,103.99994,103.99994,0,1,0,201.53906,54.46094ZM88,206.37012V176h80v30.37012A88.38031,88.38031,0,0,1,88,206.37012ZM104,136h43.78662c.01514.00006.03027.00195.04541.00195.01148,0,.02344-.00189.03491-.00195H152v24H104Zm86.22461,54.22559c-2.0022,2.00225-4.08447,3.87616-6.22461,5.64471V176a16.01833,16.01833,0,0,0-16-16V136a16.01128,16.01128,0,0,0-13.7356-15.82068L143.60156,73.2998a15.99991,15.99991,0,0,0-31.20312-.00048l-10.66284,46.88A16.01132,16.01132,0,0,0,88,136v24a16.01833,16.01833,0,0,0-16,16v19.8703c-2.14014-1.76855-4.22241-3.64246-6.22461-5.64471a88,88,0,1,1,124.44922,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,211.16115V176a8,8,0,0,0-8-8H88a8,8,0,0,0-8,8v35.16442",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,168V144a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8v24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M147.83843,136,135.83184,78.36837c-1.769-8.49116-13.89469-8.49116-15.66368,0L108.16157,136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,211.16115V176a8,8,0,0,0-8-8H88a8,8,0,0,0-8,8v35.16442",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,168V144a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8v24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M147.83843,136,135.83184,78.36837c-1.769-8.49116-13.89469-8.49116-15.66368,0L108.16157,136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,211.16115V176a8,8,0,0,0-8-8H88a8,8,0,0,0-8,8v35.16442",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,168V144a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8v24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M147.83843,136,135.83184,78.36837c-1.769-8.49116-13.89469-8.49116-15.66368,0L108.16157,136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8t = [];
/* style */

const __vue_inject_styles__$8t = undefined;
/* scoped */

const __vue_scope_id__$8t = undefined;
/* module identifier */

const __vue_module_identifier__$8t = undefined;
/* functional template */

const __vue_is_functional_template__$8t = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8t = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8t,
  staticRenderFns: __vue_staticRenderFns__$8t
}, __vue_inject_styles__$8t, __vue_script__$8t, __vue_scope_id__$8t, __vue_is_functional_template__$8t, __vue_module_identifier__$8t, false, undefined, undefined, undefined);

var script$8u = Vue.extend({
  name: "PhMartini",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8u = script$8u;
/* template */

var __vue_render__$8u = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "24 40 232 40 128 144 24 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "144",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "216",
      "x2": "168",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "60",
      "y1": "76",
      "x2": "196",
      "y2": "76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "56 72 200 72 128 144 56 72",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "24 40 232 40 128 144 24 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "144",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "216",
      "x2": "168",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "72",
      "x2": "200",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M237.65723,45.65674A8.0001,8.0001,0,0,0,232,32H24a8.0001,8.0001,0,0,0-5.65723,13.65674L120,147.314V208H88a8,8,0,0,0,0,16h80a8,8,0,0,0,0-16H136V147.314ZM212.68652,48l-16,16H59.31348l-16-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "24 40 232 40 128 144 24 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "144",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "216",
      "x2": "168",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "72",
      "x2": "200",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "24 40 232 40 128 144 24 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "144",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "216",
      "x2": "168",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "72",
      "x2": "200",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "24 40 232 40 128 144 24 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "144",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "216",
      "x2": "168",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "72",
      "x2": "200",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8u = [];
/* style */

const __vue_inject_styles__$8u = undefined;
/* scoped */

const __vue_scope_id__$8u = undefined;
/* module identifier */

const __vue_module_identifier__$8u = undefined;
/* functional template */

const __vue_is_functional_template__$8u = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8u = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8u,
  staticRenderFns: __vue_staticRenderFns__$8u
}, __vue_inject_styles__$8u, __vue_script__$8u, __vue_scope_id__$8u, __vue_is_functional_template__$8u, __vue_module_identifier__$8u, false, undefined, undefined, undefined);

var script$8v = Vue.extend({
  name: "PhMathOperations",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8v = script$8v;
/* template */

var __vue_render__$8v = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "184",
      "x2": "104",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "152",
      "x2": "72",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "72",
      "x2": "40",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "164.0664",
      "x2": "152",
      "y2": "164.0664",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "203.9336",
      "x2": "152",
      "y2": "203.9336",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "48",
      "x2": "160",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "96",
      "x2": "160",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "184",
      "x2": "104",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "152",
      "x2": "72",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "72",
      "x2": "40",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "168.0664",
      "x2": "152",
      "y2": "168.0664",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "199.9336",
      "x2": "152",
      "y2": "199.9336",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "48",
      "x2": "160",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "96",
      "x2": "160",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M104,176H80V152a8,8,0,0,0-16,0v24H40a8,8,0,0,0,0,16H64v24a8,8,0,0,0,16,0V192h24a8,8,0,0,0,0-16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,64H40a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,176.06641h64a8,8,0,0,0,0-16H152a8,8,0,0,0,0,16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,191.93359H152a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154.34326,101.65674a7.99945,7.99945,0,0,0,11.31348,0L184,83.31348l18.34326,18.34326a7.99984,7.99984,0,1,0,11.31348-11.31348L195.3136,72l18.34314-18.34326a7.99984,7.99984,0,0,0-11.31348-11.31348L184,60.68652,165.65674,42.34326a7.99984,7.99984,0,0,0-11.31348,11.31348L172.6864,72,154.34326,90.34326A7.99915,7.99915,0,0,0,154.34326,101.65674Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "184",
      "x2": "104",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "152",
      "x2": "72",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "72",
      "x2": "40",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "168.0664",
      "x2": "152",
      "y2": "168.0664",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "199.9336",
      "x2": "152",
      "y2": "199.9336",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "48",
      "x2": "160",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "96",
      "x2": "160",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "184",
      "x2": "104",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "152",
      "x2": "72",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "72",
      "x2": "40",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "168.0664",
      "x2": "152",
      "y2": "168.0664",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "199.9336",
      "x2": "152",
      "y2": "199.9336",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "48",
      "x2": "160",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "96",
      "x2": "160",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "184",
      "x2": "104",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "152",
      "x2": "72",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "72",
      "x2": "40",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "168.0664",
      "x2": "152",
      "y2": "168.0664",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "199.9336",
      "x2": "152",
      "y2": "199.9336",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "48",
      "x2": "160",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "96",
      "x2": "160",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8v = [];
/* style */

const __vue_inject_styles__$8v = undefined;
/* scoped */

const __vue_scope_id__$8v = undefined;
/* module identifier */

const __vue_module_identifier__$8v = undefined;
/* functional template */

const __vue_is_functional_template__$8v = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8v = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8v,
  staticRenderFns: __vue_staticRenderFns__$8v
}, __vue_inject_styles__$8v, __vue_script__$8v, __vue_scope_id__$8v, __vue_is_functional_template__$8v, __vue_module_identifier__$8v, false, undefined, undefined, undefined);

var script$8w = Vue.extend({
  name: "PhMedal",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8w = script$8w;
/* template */

var __vue_render__$8w = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "127.99414",
      "cy": "96",
      "r": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "96",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176 159.995 176 240 127.993 216 80 240 80 160.002",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "127.99414",
      "cy": "96",
      "r": "48",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "127.99414",
      "cy": "96",
      "r": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "127.99414",
      "cy": "96",
      "r": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176 159.995 176 240 127.993 216 80 240 80 160.002",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('circle', {
    attrs: {
      "cx": "127.99414",
      "cy": "96",
      "r": "56"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M127.99414,8A87.96624,87.96624,0,0,0,72,163.8374V240a7.99951,7.99951,0,0,0,11.57812,7.15527l44.415-22.21093,44.42969,22.21142A8,8,0,0,0,184,240V163.82764A87.96617,87.96617,0,0,0,127.99414,8Zm0,160a72,72,0,1,1,72-72A72.08124,72.08124,0,0,1,127.99414,168Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "127.99414",
      "cy": "96",
      "r": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "127.99414",
      "cy": "96",
      "r": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176 159.995 176 240 127.993 216 80 240 80 160.002",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "127.99414",
      "cy": "96",
      "r": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "127.99414",
      "cy": "96",
      "r": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176 159.995 176 240 127.993 216 80 240 80 160.002",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "127.99414",
      "cy": "96",
      "r": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "127.99414",
      "cy": "96",
      "r": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176 159.995 176 240 127.993 216 80 240 80 160.002",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8w = [];
/* style */

const __vue_inject_styles__$8w = undefined;
/* scoped */

const __vue_scope_id__$8w = undefined;
/* module identifier */

const __vue_module_identifier__$8w = undefined;
/* functional template */

const __vue_is_functional_template__$8w = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8w = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8w,
  staticRenderFns: __vue_staticRenderFns__$8w
}, __vue_inject_styles__$8w, __vue_script__$8w, __vue_scope_id__$8w, __vue_is_functional_template__$8w, __vue_module_identifier__$8w, false, undefined, undefined, undefined);

var script$8x = Vue.extend({
  name: "PhMediumLogo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8x = script$8x;
/* template */

var __vue_render__$8x = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "70",
      "cy": "128",
      "rx": "54",
      "ry": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "182",
      "cy": "128",
      "rx": "22",
      "ry": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "240",
      "y1": "72.00003",
      "x2": "240",
      "y2": "184.00001",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "72",
      "cy": "128",
      "rx": "56",
      "ry": "60",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "184",
      "cy": "128",
      "rx": "24",
      "ry": "55.99999",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "72",
      "cy": "128",
      "rx": "56",
      "ry": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "184",
      "cy": "128",
      "rx": "24",
      "ry": "55.99999",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "240",
      "y1": "72.00003",
      "x2": "240",
      "y2": "184.00001",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M136,128c0,37.49512-28.71,68-64,68S8,165.49514,8,128,36.71,60,72,60,136,90.5049,136,128Zm48-64c-5.68262,0-16.39941,2.76074-24.32373,21.251C154.72607,96.8008,152,111.98342,152,128s2.72607,31.19922,7.67627,42.749C167.60059,189.23928,178.31738,192,184,192s16.39941-2.76074,24.32373-21.251C213.27393,159.19924,216,144.01662,216,128s-2.72607-31.19922-7.67627-42.749C200.39941,66.76076,189.68262,64,184,64Zm56,0a8.00039,8.00039,0,0,0-8,8V184a8,8,0,0,0,16,0V72A8.00039,8.00039,0,0,0,240,64Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "72",
      "cy": "128",
      "rx": "56",
      "ry": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "184",
      "cy": "128",
      "rx": "24",
      "ry": "55.99999",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "240",
      "y1": "72.00003",
      "x2": "240",
      "y2": "184.00001",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "72",
      "cy": "128",
      "rx": "56",
      "ry": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "184",
      "cy": "128",
      "rx": "24",
      "ry": "55.99999",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "240",
      "y1": "72.00003",
      "x2": "240",
      "y2": "184.00001",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "72",
      "cy": "128",
      "rx": "56",
      "ry": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "184",
      "cy": "128",
      "rx": "24",
      "ry": "55.99999",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "240",
      "y1": "72.00003",
      "x2": "240",
      "y2": "184.00001",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8x = [];
/* style */

const __vue_inject_styles__$8x = undefined;
/* scoped */

const __vue_scope_id__$8x = undefined;
/* module identifier */

const __vue_module_identifier__$8x = undefined;
/* functional template */

const __vue_is_functional_template__$8x = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8x = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8x,
  staticRenderFns: __vue_staticRenderFns__$8x
}, __vue_inject_styles__$8x, __vue_script__$8x, __vue_scope_id__$8x, __vue_is_functional_template__$8x, __vue_module_identifier__$8x, false, undefined, undefined, undefined);

var script$8y = Vue.extend({
  name: "PhMegaphone",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8y = script$8y;
/* template */

var __vue_render__$8y = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M143.99951,79.46017V203.05573a8,8,0,0,0,4.42229,7.15542L167.07945,219.54a8,8,0,0,0,11.33885-5.21513L191.99951,160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M191.99951,160a40,40,0,0,0,0-80h-40S97.54779,80,45.14845,36.05237a7.99844,7.99844,0,0,0-13.14894,6.11524V197.83239a7.99844,7.99844,0,0,0,13.14894,6.11524C97.54779,160,151.99951,160,151.99951,160Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M151.99951,160h40a40,40,0,0,0,0-80h-40Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M151.99951,80V203.71853a8,8,0,0,0,3.5624,6.6564L166.554,217.703a8,8,0,0,0,12.19875-4.71612L191.99951,160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M191.99951,160a40,40,0,0,0,0-80h-40S97.54779,80,45.14845,36.05237a7.99844,7.99844,0,0,0-13.14894,6.11524V197.83239a7.99844,7.99844,0,0,0,13.14894,6.11524C97.54779,160,151.99951,160,151.99951,160Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M240,120a48.055,48.055,0,0,0-48-48H152.0166c-.51855-.00195-52.38086-.68945-101.72656-42.07617A15.999,15.999,0,0,0,23.999,42.168V197.832a15.83932,15.83932,0,0,0,9.2295,14.49121,16.07273,16.07273,0,0,0,6.80664,1.52539,15.91249,15.91249,0,0,0,10.2539-3.77148C88.1665,178.30859,127.52344,170.521,144,168.61572v35.103a15.965,15.965,0,0,0,7.124,13.3125l10.99317,7.3291a16.00058,16.00058,0,0,0,24.39648-9.43262L198.354,167.56641A48.06327,48.06327,0,0,0,240,120Zm-69.00879,91.04688L160,203.71875V168h21.75391ZM192,152H160V88h32a32,32,0,0,1,0,64Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M151.99951,80V203.71853a8,8,0,0,0,3.5624,6.6564L166.554,217.703a8,8,0,0,0,12.19875-4.71612L191.99951,160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M191.99951,160a40,40,0,0,0,0-80h-40S97.54779,80,45.14845,36.05237a7.99844,7.99844,0,0,0-13.14894,6.11524V197.83239a7.99844,7.99844,0,0,0,13.14894,6.11524C97.54779,160,151.99951,160,151.99951,160Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M151.99951,80V203.71853a8,8,0,0,0,3.5624,6.6564L166.554,217.703a8,8,0,0,0,12.19875-4.71612L191.99951,160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M191.99951,160a40,40,0,0,0,0-80h-40S97.54779,80,45.14845,36.05237a7.99844,7.99844,0,0,0-13.14894,6.11524V197.83239a7.99844,7.99844,0,0,0,13.14894,6.11524C97.54779,160,151.99951,160,151.99951,160Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M152,80V203.71853a8,8,0,0,0,3.5624,6.6564l10.99213,7.32809a8,8,0,0,0,12.19874-4.71612L192,160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M192,160a40,40,0,0,0,0-80H152S97.54828,80,45.14894,36.05237A7.99844,7.99844,0,0,0,32,42.16761V197.83239a7.99844,7.99844,0,0,0,13.14894,6.11524C97.54828,160,152,160,152,160Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8y = [];
/* style */

const __vue_inject_styles__$8y = undefined;
/* scoped */

const __vue_scope_id__$8y = undefined;
/* module identifier */

const __vue_module_identifier__$8y = undefined;
/* functional template */

const __vue_is_functional_template__$8y = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8y = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8y,
  staticRenderFns: __vue_staticRenderFns__$8y
}, __vue_inject_styles__$8y, __vue_script__$8y, __vue_scope_id__$8y, __vue_is_functional_template__$8y, __vue_module_identifier__$8y, false, undefined, undefined, undefined);

var script$8z = Vue.extend({
  name: "PhMegaphoneSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8z = script$8z;
/* template */

var __vue_render__$8z = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M31.99414,50.66667V189.33333a8,8,0,0,0,10.24,7.68l176-51.33333a8,8,0,0,0,5.76-7.68V102a8,8,0,0,0-5.76-7.68l-176-51.33333A8,8,0,0,0,31.99414,50.66667Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,155.665V192a8,8,0,0,1-8,8H144a8,8,0,0,1-8-8V70.335",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M42.23414,42.98667a8,8,0,0,0-10.24,7.68V189.33333a8,8,0,0,0,10.24,7.68L136,169.665V70.335Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M31.99414,50.66667V189.33333a8,8,0,0,0,10.24,7.68l176-51.33333a8,8,0,0,0,5.76-7.68V102a8,8,0,0,0-5.76-7.68l-176-51.33333A8,8,0,0,0,31.99414,50.66667Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,155.665V192a8,8,0,0,1-8,8H144a8,8,0,0,1-8-8V70.335",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M220.47461,86.64062,138.395,62.70068l-.05127-.01513L44.47363,35.30664A15.99966,15.99966,0,0,0,23.99414,50.667V189.333A16.0247,16.0247,0,0,0,39.94922,205.3457a16.16154,16.16154,0,0,0,4.52539-.65234L128,180.332V192a16.01833,16.01833,0,0,0,16,16h32a16.01833,16.01833,0,0,0,16-16V161.665l28.47363-8.30469A16.0825,16.0825,0,0,0,231.99414,138V102A16.08075,16.08075,0,0,0,220.47461,86.64062ZM176,192H144V175.665l32-9.333Zm39.99414-54-34.35352,10.01953-.02832.0083L144,158.99805V81.00146L215.99414,102Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M31.99414,50.66667V189.33333a8,8,0,0,0,10.24,7.68l176-51.33333a8,8,0,0,0,5.76-7.68V102a8,8,0,0,0-5.76-7.68l-176-51.33333A8,8,0,0,0,31.99414,50.66667Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,155.665V192a8,8,0,0,1-8,8H144a8,8,0,0,1-8-8V70.335",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M31.99414,50.66667V189.33333a8,8,0,0,0,10.24,7.68l176-51.33333a8,8,0,0,0,5.76-7.68V102a8,8,0,0,0-5.76-7.68l-176-51.33333A8,8,0,0,0,31.99414,50.66667Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,155.665V192a8,8,0,0,1-8,8H144a8,8,0,0,1-8-8V70.335",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M31.99414,50.66667V189.33333a8,8,0,0,0,10.24,7.68l176-51.33333a8,8,0,0,0,5.76-7.68V102a8,8,0,0,0-5.76-7.68l-176-51.33333A8,8,0,0,0,31.99414,50.66667Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,155.665V192a8,8,0,0,1-8,8H144a8,8,0,0,1-8-8V70.335",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8z = [];
/* style */

const __vue_inject_styles__$8z = undefined;
/* scoped */

const __vue_scope_id__$8z = undefined;
/* module identifier */

const __vue_module_identifier__$8z = undefined;
/* functional template */

const __vue_is_functional_template__$8z = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8z = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8z,
  staticRenderFns: __vue_staticRenderFns__$8z
}, __vue_inject_styles__$8z, __vue_script__$8z, __vue_scope_id__$8z, __vue_is_functional_template__$8z, __vue_module_identifier__$8z, false, undefined, undefined, undefined);

var script$8A = Vue.extend({
  name: "PhMessengerLogo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8A = script$8A;
/* template */

var __vue_render__$8A = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M45.42853,176.99811A95.95978,95.95978,0,1,1,79.00228,210.5717l.00023-.001L45.84594,220.044a8,8,0,0,1-9.89-9.89l9.47331-33.15657Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 144 112 112 144 144 176 112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M45.42853,176.99811A95.95978,95.95978,0,1,1,79.00228,210.5717l.00023-.001L45.84594,220.044a8,8,0,0,1-9.89-9.89l9.47331-33.15657Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M45.42853,176.99811A95.95978,95.95978,0,1,1,79.00228,210.5717l.00023-.001L45.84594,220.044a8,8,0,0,1-9.89-9.89l9.47331-33.15657Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 144 112 112 144 144 176 112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104.02809,104.02809,0,0,0,36.811,178.041l-8.54737,29.915a16.00023,16.00023,0,0,0,19.77979,19.78027l29.916-8.54639A104.00746,104.00746,0,1,0,128,24Zm53.65674,93.65674-32,32a7.99945,7.99945,0,0,1-11.31348,0L112,123.3135,85.65674,149.65676a7.99984,7.99984,0,1,1-11.31348-11.31348l32-32a8,8,0,0,1,11.31348,0L144,132.68654l26.34326-26.34326a7.99984,7.99984,0,0,1,11.31348,11.31348Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M45.42853,176.99811A95.95978,95.95978,0,1,1,79.00228,210.5717l.00023-.001L45.84594,220.044a8,8,0,0,1-9.89-9.89l9.47331-33.15657Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 144 112 112 144 144 176 112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M45.42853,176.99811A95.95978,95.95978,0,1,1,79.00228,210.5717l.00023-.001L45.84594,220.044a8,8,0,0,1-9.89-9.89l9.47331-33.15657Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 144 112 112 144 144 176 112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M45.42853,176.99811A95.95978,95.95978,0,1,1,79.00228,210.5717l.00023-.001L45.84594,220.044a8,8,0,0,1-9.89-9.89l9.47331-33.15657Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 144 112 112 144 144 176 112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8A = [];
/* style */

const __vue_inject_styles__$8A = undefined;
/* scoped */

const __vue_scope_id__$8A = undefined;
/* module identifier */

const __vue_module_identifier__$8A = undefined;
/* functional template */

const __vue_is_functional_template__$8A = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8A = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8A,
  staticRenderFns: __vue_staticRenderFns__$8A
}, __vue_inject_styles__$8A, __vue_script__$8A, __vue_scope_id__$8A, __vue_is_functional_template__$8A, __vue_module_identifier__$8A, false, undefined, undefined, undefined);

var script$8B = Vue.extend({
  name: "PhMicrophone",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8B = script$8B;
/* template */

var __vue_render__$8B = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M127.99991,24H128a40,40,0,0,1,40,40v56a40,40,0,0,1-40,40h-.00008A39.99991,39.99991,0,0,1,88,120.00009V63.99991A39.99991,39.99991,0,0,1,127.99991,24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,120a80,80,0,0,1-160,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "200",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M127.99991,24H128a40,40,0,0,1,40,40v64a40,40,0,0,1-40,40h-.00008A39.99991,39.99991,0,0,1,88,128.00009V63.99991A39.99991,39.99991,0,0,1,127.99991,24Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M127.99991,24H128a40,40,0,0,1,40,40v64a40,40,0,0,1-40,40h-.00008A39.99991,39.99991,0,0,1,88,128.00009V63.99991A39.99991,39.99991,0,0,1,127.99991,24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "200",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M199.56055,136.00017a72.00715,72.00715,0,0,1-143.12111-.00011",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M127.99414,175.99609a48.05083,48.05083,0,0,0,48-47.99218V63.99609a48,48,0,1,0-96,0v64A48.05249,48.05249,0,0,0,127.99414,175.99609Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200.43164,128.05078a8.07828,8.07828,0,0,0-8.82812,7.07813,64.00856,64.00856,0,0,1-127.21875-.00782,8.09865,8.09865,0,0,0-8.82813-7.07031,8.01056,8.01056,0,0,0-7.07812,8.83594A79.60051,79.60051,0,0,0,119.99414,207.251v24.74511a8,8,0,1,0,16,0V207.252a79.577,79.577,0,0,0,71.51563-70.373A8.00321,8.00321,0,0,0,200.43164,128.05078Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M127.99991,24H128a40,40,0,0,1,40,40v64a40,40,0,0,1-40,40h-.00008A39.99991,39.99991,0,0,1,88,128.00009V63.99991A39.99991,39.99991,0,0,1,127.99991,24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "200",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M199.56055,136.00017a72.00715,72.00715,0,0,1-143.12111-.00011",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M127.99991,24H128a40,40,0,0,1,40,40v64a40,40,0,0,1-40,40h-.00008A39.99991,39.99991,0,0,1,88,128.00009V63.99991A39.99991,39.99991,0,0,1,127.99991,24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "200",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M199.56055,136.00017a72.00715,72.00715,0,0,1-143.12111-.00011",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M127.99991,24H128a40,40,0,0,1,40,40v64a40,40,0,0,1-40,40h-.00008A39.99991,39.99991,0,0,1,88,128.00009V63.99991A39.99991,39.99991,0,0,1,127.99991,24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "200",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M199.56055,136.00017a72.00715,72.00715,0,0,1-143.12111-.00011",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8B = [];
/* style */

const __vue_inject_styles__$8B = undefined;
/* scoped */

const __vue_scope_id__$8B = undefined;
/* module identifier */

const __vue_module_identifier__$8B = undefined;
/* functional template */

const __vue_is_functional_template__$8B = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8B = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8B,
  staticRenderFns: __vue_staticRenderFns__$8B
}, __vue_inject_styles__$8B, __vue_script__$8B, __vue_scope_id__$8B, __vue_is_functional_template__$8B, __vue_module_identifier__$8B, false, undefined, undefined, undefined);

var script$8C = Vue.extend({
  name: "PhMicrophoneSlash",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8C = script$8C;
/* template */

var __vue_render__$8C = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "200",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M150.68227,152.95168A39.81525,39.81525,0,0,1,128.00009,160H128a40,40,0,0,1-40-40V84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M98.91341,36.54133A39.88791,39.88791,0,0,1,128,24h.00008A39.99991,39.99991,0,0,1,168,63.99991v48.53544",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M177.71207,182.68344A80.00376,80.00376,0,0,1,48,120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,120a79.77285,79.77285,0,0,1-5.85339,30.09425",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M127.99991,24H128a40,40,0,0,1,40,40v64a40,40,0,0,1-40,40h-.00008A39.99991,39.99991,0,0,1,88,128.00009V63.99991A39.99991,39.99991,0,0,1,127.99991,24Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176.42693,181.28138A72.00558,72.00558,0,0,1,56.43944,136.00006",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154.90249,157.60205A39.85421,39.85421,0,0,1,128.00009,168H128a40,40,0,0,1-40-40V84.00214",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "200",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M93.95906,42.98434A39.97457,39.97457,0,0,1,128,24h.00008A39.99991,39.99991,0,0,1,168,63.99991V124.4291",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M199.56055,136.00017a71.54827,71.54827,0,0,1-4.48193,18.2151",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M213.91992,210.61816l-160-176A8.0006,8.0006,0,1,0,42.08008,45.38184L80,87.09375V128a47.9902,47.9902,0,0,0,73.91211,40.39685l10.875,11.96252A63.99208,63.99208,0,0,1,64.39062,135.12109a7.9996,7.9996,0,0,0-15.90234,1.75782A79.83705,79.83705,0,0,0,120,207.59692V232a8,8,0,0,0,16,0V207.59082a79.72,79.72,0,0,0,39.62012-15.31506l26.46,29.10608a8.0006,8.0006,0,1,0,11.83984-10.76368Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M162.08008,129.81055A8.0004,8.0004,0,0,0,176,124.42871V64A48.0045,48.0045,0,0,0,87.15527,38.77539a8.00113,8.00113,0,0,0,.88379,9.59082Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M192.165,161.665a7.99262,7.99262,0,0,0,10.36426-4.53613,79.61568,79.61568,0,0,0,4.98242-20.25,7.9996,7.9996,0,0,0-15.90235-1.75782,63.67417,63.67417,0,0,1-3.98046,16.17969A7.99991,7.99991,0,0,0,192.165,161.665Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "200",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154.90713,157.59783A39.85426,39.85426,0,0,1,128.00009,168H128a40,40,0,0,1-40-40V84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176.43278,181.27606a72.00558,72.00558,0,0,1-119.99334-45.276",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M199.56055,136.00017a71.52052,71.52052,0,0,1-6.20937,22.26059",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M93.95908,42.98431A39.97458,39.97458,0,0,1,128,24h.00008A39.99991,39.99991,0,0,1,168,63.99991V124.4291",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "200",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176.43278,181.27606a72.00558,72.00558,0,0,1-119.99334-45.276",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154.90713,157.59783A39.85426,39.85426,0,0,1,128.00009,168H128a40,40,0,0,1-40-40V84.0087",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M93.95908,42.98431A39.97458,39.97458,0,0,1,128,24h.00008A39.99991,39.99991,0,0,1,168,63.99991V124.4291",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M199.56055,136.00017a71.54833,71.54833,0,0,1-4.482,18.21516",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176.42693,181.28138A72.00558,72.00558,0,0,1,56.43944,136.00006",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154.90249,157.60205A39.85421,39.85421,0,0,1,128.00009,168H128a40,40,0,0,1-40-40V84.00214",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "200",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M93.95906,42.98434A39.97457,39.97457,0,0,1,128,24h.00008A39.99991,39.99991,0,0,1,168,63.99991V124.4291",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M199.56055,136.00017a71.54827,71.54827,0,0,1-4.48193,18.2151",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8C = [];
/* style */

const __vue_inject_styles__$8C = undefined;
/* scoped */

const __vue_scope_id__$8C = undefined;
/* module identifier */

const __vue_module_identifier__$8C = undefined;
/* functional template */

const __vue_is_functional_template__$8C = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8C = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8C,
  staticRenderFns: __vue_staticRenderFns__$8C
}, __vue_inject_styles__$8C, __vue_script__$8C, __vue_scope_id__$8C, __vue_is_functional_template__$8C, __vue_module_identifier__$8C, false, undefined, undefined, undefined);

var script$8D = Vue.extend({
  name: "PhMinus",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8D = script$8D;
/* template */

var __vue_render__$8D = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,136H40a8,8,0,0,1,0-16H216a8,8,0,0,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8D = [];
/* style */

const __vue_inject_styles__$8D = undefined;
/* scoped */

const __vue_scope_id__$8D = undefined;
/* module identifier */

const __vue_module_identifier__$8D = undefined;
/* functional template */

const __vue_is_functional_template__$8D = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8D = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8D,
  staticRenderFns: __vue_staticRenderFns__$8D
}, __vue_inject_styles__$8D, __vue_script__$8D, __vue_scope_id__$8D, __vue_is_functional_template__$8D, __vue_module_identifier__$8D, false, undefined, undefined, undefined);

var script$8E = Vue.extend({
  name: "PhMinusCircle",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8E = script$8E;
/* template */

var __vue_render__$8E = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "128",
      "x2": "168",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "128",
      "x2": "168",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.12041,104.12041,0,0,0,128,24Zm40,112H88a8,8,0,0,1,0-16h80a8,8,0,0,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "128",
      "x2": "168",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "128",
      "x2": "168",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "128",
      "x2": "168",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8E = [];
/* style */

const __vue_inject_styles__$8E = undefined;
/* scoped */

const __vue_scope_id__$8E = undefined;
/* module identifier */

const __vue_module_identifier__$8E = undefined;
/* functional template */

const __vue_is_functional_template__$8E = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8E = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8E,
  staticRenderFns: __vue_staticRenderFns__$8E
}, __vue_inject_styles__$8E, __vue_script__$8E, __vue_scope_id__$8E, __vue_is_functional_template__$8E, __vue_module_identifier__$8E, false, undefined, undefined, undefined);

var script$8F = Vue.extend({
  name: "PhMoney",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8F = script$8F;
/* template */

var __vue_render__$8F = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "16",
      "y": "64",
      "width": "224",
      "height": "128",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "64",
      "x2": "240",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "192",
      "x2": "240",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "64",
      "x2": "16",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "192",
      "x2": "16",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M232,64H176l64,56V72A7.99993,7.99993,0,0,0,232,64Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M232,192a7.99993,7.99993,0,0,0,8-8V136l-64,56Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16,72v48L80,64H24A7.99993,7.99993,0,0,0,16,72Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16,184a7.99993,7.99993,0,0,0,8,8H80L16,136Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "16",
      "y": "64",
      "width": "224",
      "height": "128",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "64",
      "x2": "240",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "192",
      "x2": "240",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "64",
      "x2": "16",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "192",
      "x2": "16",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232,56H24A16.01833,16.01833,0,0,0,8,72V184a16.01833,16.01833,0,0,0,16,16H232a16.01833,16.01833,0,0,0,16-16V72A16.01833,16.01833,0,0,0,232,56ZM74.95947,184,24,140.32056V115.67944L74.95947,72H181.04053l50.96338,43.68262.002,24.63281L181.04053,184ZM168,128a40,40,0,1,1-40-40A40.04584,40.04584,0,0,1,168,128Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "16",
      "y": "64",
      "width": "224",
      "height": "128",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "64",
      "x2": "240",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "192",
      "x2": "240",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "64",
      "x2": "16",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "192",
      "x2": "16",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "16",
      "y": "64",
      "width": "224",
      "height": "128",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "64",
      "x2": "240",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "192",
      "x2": "240",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "64",
      "x2": "16",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "192",
      "x2": "16",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "16",
      "y": "64",
      "width": "224",
      "height": "128",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "64",
      "x2": "240",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "192",
      "x2": "240",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "64",
      "x2": "16",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "192",
      "x2": "16",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8F = [];
/* style */

const __vue_inject_styles__$8F = undefined;
/* scoped */

const __vue_scope_id__$8F = undefined;
/* module identifier */

const __vue_module_identifier__$8F = undefined;
/* functional template */

const __vue_is_functional_template__$8F = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8F = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8F,
  staticRenderFns: __vue_staticRenderFns__$8F
}, __vue_inject_styles__$8F, __vue_script__$8F, __vue_scope_id__$8F, __vue_is_functional_template__$8F, __vue_module_identifier__$8F, false, undefined, undefined, undefined);

var script$8G = Vue.extend({
  name: "PhMonitor",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8G = script$8G;
/* template */

var __vue_render__$8G = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "144",
      "rx": "16",
      "transform": "translate(256 240) rotate(180)",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "228",
      "x2": "96",
      "y2": "228",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "144",
      "rx": "16",
      "transform": "translate(256 240) rotate(180)",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "144",
      "rx": "16",
      "transform": "translate(256 240) rotate(180)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "224",
      "x2": "96",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "40.0002",
      "width": "208",
      "height": "160",
      "rx": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160,216.0002H96a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "144",
      "rx": "16",
      "transform": "translate(256 240) rotate(180)",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "224",
      "x2": "96",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "144",
      "rx": "16",
      "transform": "translate(256 240) rotate(180)",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "224",
      "x2": "96",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "144",
      "rx": "16",
      "transform": "translate(256 240) rotate(180)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "224",
      "x2": "96",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8G = [];
/* style */

const __vue_inject_styles__$8G = undefined;
/* scoped */

const __vue_scope_id__$8G = undefined;
/* module identifier */

const __vue_module_identifier__$8G = undefined;
/* functional template */

const __vue_is_functional_template__$8G = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8G = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8G,
  staticRenderFns: __vue_staticRenderFns__$8G
}, __vue_inject_styles__$8G, __vue_script__$8G, __vue_scope_id__$8G, __vue_is_functional_template__$8G, __vue_module_identifier__$8G, false, undefined, undefined, undefined);

var script$8H = Vue.extend({
  name: "PhMonitorPlay",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8H = script$8H;
/* template */

var __vue_render__$8H = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "156 120 116 92 116 148 156 120",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "144",
      "rx": "16",
      "transform": "translate(256 240) rotate(180)",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "228",
      "x2": "96",
      "y2": "228",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,48H48A16.00016,16.00016,0,0,0,32,64V176a16.00016,16.00016,0,0,0,16,16H208a16.00016,16.00016,0,0,0,16-16V64A16.00016,16.00016,0,0,0,208,48ZM112,152V88l48,32Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "144",
      "rx": "16",
      "transform": "translate(256 240) rotate(180)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "224",
      "x2": "96",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "160 120 112 88 112 152 160 120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M168,224a8.00008,8.00008,0,0,1-8,8H96a8,8,0,0,1,0-16h64A8.00008,8.00008,0,0,1,168,224ZM232,64V176a24.0275,24.0275,0,0,1-24,24H48a24.0275,24.0275,0,0,1-24-24V64A24.02734,24.02734,0,0,1,48,40H208A24.02734,24.02734,0,0,1,232,64Zm-68,56a8.00014,8.00014,0,0,0-3.70508-6.74927l-44-28A7.99989,7.99989,0,0,0,104,92v56a7.99991,7.99991,0,0,0,12.29492,6.74927l44-28A8.00014,8.00014,0,0,0,164,120Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "160 120 112 88 112 152 160 120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "144",
      "rx": "16",
      "transform": "translate(256 240) rotate(180)",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "224",
      "x2": "96",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "160 120 112 88 112 152 160 120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "144",
      "rx": "16",
      "transform": "translate(256 240) rotate(180)",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "224",
      "x2": "96",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "144",
      "rx": "16",
      "transform": "translate(256 240) rotate(180)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "224",
      "x2": "96",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "160 120 112 88 112 152 160 120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8H = [];
/* style */

const __vue_inject_styles__$8H = undefined;
/* scoped */

const __vue_scope_id__$8H = undefined;
/* module identifier */

const __vue_module_identifier__$8H = undefined;
/* functional template */

const __vue_is_functional_template__$8H = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8H = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8H,
  staticRenderFns: __vue_staticRenderFns__$8H
}, __vue_inject_styles__$8H, __vue_script__$8H, __vue_scope_id__$8H, __vue_is_functional_template__$8H, __vue_module_identifier__$8H, false, undefined, undefined, undefined);

var script$8I = Vue.extend({
  name: "PhMoon",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8I = script$8I;
/* template */

var __vue_render__$8I = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216.66238,152.64951A92.03175,92.03175,0,0,1,103.35039,39.338l.00255.00078A92.01376,92.01376,0,1,0,216.66147,152.64624Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216.66238,152.64951A92.03175,92.03175,0,0,1,103.35039,39.338l.00255.00078A92.01376,92.01376,0,1,0,216.66147,152.64624Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216.66238,152.64951A92.03175,92.03175,0,0,1,103.35039,39.338l.00255.00078A92.01376,92.01376,0,1,0,216.66147,152.64624Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224.30762,150.29346a8.00288,8.00288,0,0,0-10.01416-5.28955A84.03122,84.03122,0,0,1,111.01514,41.6377a8.00207,8.00207,0,0,0-9.96582-9.96192,100.01386,100.01386,0,1,0,123.29,123.2207A8.0018,8.0018,0,0,0,224.30762,150.29346Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216.66238,152.64951A92.03175,92.03175,0,0,1,103.35039,39.338l.00255.00078A92.01376,92.01376,0,1,0,216.66147,152.64624Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216.66238,152.64951A92.03175,92.03175,0,0,1,103.35039,39.338l.00255.00078A92.01376,92.01376,0,1,0,216.66147,152.64624Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216.66238,152.64951A92.03175,92.03175,0,0,1,103.35039,39.338l.00255.00078A92.01376,92.01376,0,1,0,216.66147,152.64624Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8I = [];
/* style */

const __vue_inject_styles__$8I = undefined;
/* scoped */

const __vue_scope_id__$8I = undefined;
/* module identifier */

const __vue_module_identifier__$8I = undefined;
/* functional template */

const __vue_is_functional_template__$8I = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8I = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8I,
  staticRenderFns: __vue_staticRenderFns__$8I
}, __vue_inject_styles__$8I, __vue_script__$8I, __vue_scope_id__$8I, __vue_is_functional_template__$8I, __vue_module_identifier__$8I, false, undefined, undefined, undefined);

var script$8J = Vue.extend({
  name: "PhMoonStars",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8J = script$8J;
/* template */

var __vue_render__$8J = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "216",
      "y1": "112",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "240",
      "y1": "88",
      "x2": "192",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "24",
      "x2": "168",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "40",
      "x2": "152",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216.66238,152.64951A92.03175,92.03175,0,0,1,103.35039,39.338l.00255.00078A92.01376,92.01376,0,1,0,216.66147,152.64624Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216.66238,152.64951A92.03175,92.03175,0,0,1,103.35039,39.338l.00255.00078A92.01376,92.01376,0,1,0,216.66147,152.64624Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "112",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "240",
      "y1": "88",
      "x2": "192",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "24",
      "x2": "168",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "40",
      "x2": "152",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216.66238,152.64951A92.03175,92.03175,0,0,1,103.35039,39.338l.00255.00078A92.01376,92.01376,0,1,0,216.66147,152.64624Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M240,80H224V64a8,8,0,0,0-16,0V80H192a8,8,0,0,0,0,16h16v16a8,8,0,0,0,16,0V96h16a8,8,0,0,0,0-16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,48h8v8a8,8,0,0,0,16,0V48h8a8,8,0,0,0,0-16h-8V24a8,8,0,0,0-16,0v8h-8a8,8,0,0,0,0,16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216.457,144.64941a7.985,7.985,0,0,0-2.15576.35254A84.0314,84.0314,0,0,1,111.01514,41.6377a8.00171,8.00171,0,0,0-9.96485-9.96192A100.01377,100.01377,0,1,0,224.33936,154.89746a8.00114,8.00114,0,0,0-7.88233-10.24805Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "216",
      "y1": "112",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "240",
      "y1": "88",
      "x2": "192",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "24",
      "x2": "168",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "40",
      "x2": "152",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216.66238,152.64951A92.03175,92.03175,0,0,1,103.35039,39.338l.00255.00078A92.01376,92.01376,0,1,0,216.66147,152.64624Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "216",
      "y1": "112",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "240",
      "y1": "88",
      "x2": "192",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "24",
      "x2": "168",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "40",
      "x2": "152",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216.66238,152.64951A92.03175,92.03175,0,0,1,103.35039,39.338l.00255.00078A92.01376,92.01376,0,1,0,216.66147,152.64624Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "216",
      "y1": "112",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "240",
      "y1": "88",
      "x2": "192",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "24",
      "x2": "168",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "40",
      "x2": "152",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216.66238,152.64951A92.03175,92.03175,0,0,1,103.35039,39.338l.00255.00078A92.01376,92.01376,0,1,0,216.66147,152.64624Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8J = [];
/* style */

const __vue_inject_styles__$8J = undefined;
/* scoped */

const __vue_scope_id__$8J = undefined;
/* module identifier */

const __vue_module_identifier__$8J = undefined;
/* functional template */

const __vue_is_functional_template__$8J = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8J = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8J,
  staticRenderFns: __vue_staticRenderFns__$8J
}, __vue_inject_styles__$8J, __vue_script__$8J, __vue_scope_id__$8J, __vue_is_functional_template__$8J, __vue_module_identifier__$8J, false, undefined, undefined, undefined);

var script$8K = Vue.extend({
  name: "PhMouse",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8K = script$8K;
/* template */

var __vue_render__$8K = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "52",
      "y": "32",
      "width": "152",
      "height": "192",
      "rx": "56",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "52",
      "y1": "112",
      "x2": "204",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "112",
      "x2": "128.00007",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128.00007,32H108A56,56,0,0,0,52,88v24h76Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "52",
      "y": "32",
      "width": "152",
      "height": "192",
      "rx": "56",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "52",
      "y1": "112",
      "x2": "204",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "112",
      "x2": "128.00007",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M148,24H108A64.07239,64.07239,0,0,0,44,88v80a64.07239,64.07239,0,0,0,64,64h40a64.07239,64.07239,0,0,0,64-64V88A64.07239,64.07239,0,0,0,148,24Zm48,64v16H136V40h12A48.05468,48.05468,0,0,1,196,88ZM108,40h12v64H60V88A48.05468,48.05468,0,0,1,108,40Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "52",
      "y": "32",
      "width": "152",
      "height": "192",
      "rx": "56",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "52",
      "y1": "112",
      "x2": "204",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "112",
      "x2": "128.00007",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "52",
      "y": "32",
      "width": "152",
      "height": "192",
      "rx": "56",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "52",
      "y1": "112",
      "x2": "204",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "112",
      "x2": "128.00007",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "52",
      "y": "32",
      "width": "152",
      "height": "192",
      "rx": "56",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "52",
      "y1": "112",
      "x2": "204",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "112",
      "x2": "128.00007",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8K = [];
/* style */

const __vue_inject_styles__$8K = undefined;
/* scoped */

const __vue_scope_id__$8K = undefined;
/* module identifier */

const __vue_module_identifier__$8K = undefined;
/* functional template */

const __vue_is_functional_template__$8K = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8K = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8K,
  staticRenderFns: __vue_staticRenderFns__$8K
}, __vue_inject_styles__$8K, __vue_script__$8K, __vue_scope_id__$8K, __vue_is_functional_template__$8K, __vue_module_identifier__$8K, false, undefined, undefined, undefined);

var script$8L = Vue.extend({
  name: "PhMouseSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8L = script$8L;
/* template */

var __vue_render__$8L = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "52",
      "y": "32",
      "width": "152",
      "height": "192",
      "rx": "56",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "116",
      "x2": "128.00007",
      "y2": "76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "52",
      "y": "32",
      "width": "152",
      "height": "192",
      "rx": "56",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "52",
      "y": "32",
      "width": "152",
      "height": "192",
      "rx": "56",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "112",
      "x2": "128.00007",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M148,24H108A64.07207,64.07207,0,0,0,44,88v80a64.07207,64.07207,0,0,0,64,64h40a64.07207,64.07207,0,0,0,64-64V88A64.07207,64.07207,0,0,0,148,24Zm-12,88a8,8,0,0,1-16,0V64a8,8,0,0,1,16,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "52",
      "y": "32",
      "width": "152",
      "height": "192",
      "rx": "56",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "112",
      "x2": "128.00007",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "52",
      "y": "32",
      "width": "152",
      "height": "192",
      "rx": "56",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "112",
      "x2": "128.00007",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "52",
      "y": "32",
      "width": "152",
      "height": "192",
      "rx": "56",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "112",
      "x2": "128.00007",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8L = [];
/* style */

const __vue_inject_styles__$8L = undefined;
/* scoped */

const __vue_scope_id__$8L = undefined;
/* module identifier */

const __vue_module_identifier__$8L = undefined;
/* functional template */

const __vue_is_functional_template__$8L = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8L = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8L,
  staticRenderFns: __vue_staticRenderFns__$8L
}, __vue_inject_styles__$8L, __vue_script__$8L, __vue_scope_id__$8L, __vue_is_functional_template__$8L, __vue_module_identifier__$8L, false, undefined, undefined, undefined);

var script$8M = Vue.extend({
  name: "PhMusicNote",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8M = script$8M;
/* template */

var __vue_render__$8M = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "88",
      "cy": "184",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 184 128 40 208 64 208 112 128 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "88",
      "cy": "184",
      "r": "40",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "88",
      "cy": "184",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 184 128 40 208 64 208 112 128 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M210.29883,56.3374l-80-24A7.99991,7.99991,0,0,0,120,40V87.82031q-.0044.1831,0,.36573v60.07519A47.97353,47.97353,0,1,0,136,184V98.75195l69.70117,20.91065A7.99991,7.99991,0,0,0,216,112V64A7.99972,7.99972,0,0,0,210.29883,56.3374Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "88",
      "cy": "184",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 184 128 40 208 64 208 112 128 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "88",
      "cy": "184",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 184 128 40 208 64 208 112 128 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "88",
      "cy": "184",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 184 128 40 208 64 208 112 128 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8M = [];
/* style */

const __vue_inject_styles__$8M = undefined;
/* scoped */

const __vue_scope_id__$8M = undefined;
/* module identifier */

const __vue_module_identifier__$8M = undefined;
/* functional template */

const __vue_is_functional_template__$8M = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8M = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8M,
  staticRenderFns: __vue_staticRenderFns__$8M
}, __vue_inject_styles__$8M, __vue_script__$8M, __vue_scope_id__$8M, __vue_is_functional_template__$8M, __vue_module_identifier__$8M, false, undefined, undefined, undefined);

var script$8N = Vue.extend({
  name: "PhMusicNoteSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8N = script$8N;
/* template */

var __vue_render__$8N = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "88",
      "cy": "184",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 184 128 40 208 64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "88",
      "cy": "184",
      "r": "40",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "88",
      "cy": "184",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 184 128 40 208 64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M210.29883,56.3374l-80-24A7.99991,7.99991,0,0,0,120,40V148.26123A47.97353,47.97353,0,1,0,136,184V50.75244L205.70117,71.6626a8,8,0,1,0,4.59766-15.3252Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "88",
      "cy": "184",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 184 128 40 208 64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "88",
      "cy": "184",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 184 128 40 208 64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "88",
      "cy": "184",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 184 128 40 208 64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8N = [];
/* style */

const __vue_inject_styles__$8N = undefined;
/* scoped */

const __vue_scope_id__$8N = undefined;
/* module identifier */

const __vue_module_identifier__$8N = undefined;
/* functional template */

const __vue_is_functional_template__$8N = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8N = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8N,
  staticRenderFns: __vue_staticRenderFns__$8N
}, __vue_inject_styles__$8N, __vue_script__$8N, __vue_scope_id__$8N, __vue_is_functional_template__$8N, __vue_module_identifier__$8N, false, undefined, undefined, undefined);

var script$8O = Vue.extend({
  name: "PhMusicNotes",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8O = script$8O;
/* template */

var __vue_render__$8O = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "180",
      "cy": "172",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "52",
      "cy": "204",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "80",
      "x2": "80",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 204 80 64 208 32 208 172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "180",
      "cy": "172",
      "r": "28",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "52",
      "cy": "204",
      "r": "28",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "172",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "52",
      "cy": "204",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "80",
      "x2": "80",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 204 80 64 208 32 208 172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M212.916,25.69144a7.896,7.896,0,0,0-6.85938-1.45313l-128,32a7.99686,7.99686,0,0,0-6.0625,7.75782v110.0957a35.98113,35.98113,0,1,0,16,29.9043V110.23831l112-28v59.85352a35.98113,35.98113,0,1,0,16,29.9043v-140A8.01525,8.01525,0,0,0,212.916,25.69144Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "180",
      "cy": "172",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "52",
      "cy": "204",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "80",
      "x2": "80",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 204 80 64 208 32 208 172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "180",
      "cy": "172",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "52",
      "cy": "204",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "80",
      "x2": "80",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 204 80 64 208 32 208 172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "180",
      "cy": "172",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "52",
      "cy": "204",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "80",
      "x2": "80",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 204 80 64 208 32 208 172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8O = [];
/* style */

const __vue_inject_styles__$8O = undefined;
/* scoped */

const __vue_scope_id__$8O = undefined;
/* module identifier */

const __vue_module_identifier__$8O = undefined;
/* functional template */

const __vue_is_functional_template__$8O = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8O = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8O,
  staticRenderFns: __vue_staticRenderFns__$8O
}, __vue_inject_styles__$8O, __vue_script__$8O, __vue_scope_id__$8O, __vue_is_functional_template__$8O, __vue_module_identifier__$8O, false, undefined, undefined, undefined);

var script$8P = Vue.extend({
  name: "PhMusicNotesSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8P = script$8P;
/* template */

var __vue_render__$8P = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "180",
      "cy": "172",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "52",
      "cy": "204",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 204 80 64 208 32 208 172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "180",
      "cy": "172",
      "r": "28",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "52",
      "cy": "204",
      "r": "28",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "172",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "52",
      "cy": "204",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 204 80 64 208 32 208 172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M212.92285,25.69434a7.99949,7.99949,0,0,0-6.86328-1.45557l-128,32A7.99964,7.99964,0,0,0,72,64V174.0835A35.98908,35.98908,0,1,0,88,204V70.24609l112-28V142.0835A35.98908,35.98908,0,1,0,216,172V32A7.99874,7.99874,0,0,0,212.92285,25.69434Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "180",
      "cy": "172",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "52",
      "cy": "204",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 204 80 64 208 32 208 172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "180",
      "cy": "172",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "52",
      "cy": "204",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 204 80 64 208 32 208 172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "180",
      "cy": "172",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "52",
      "cy": "204",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 204 80 64 208 32 208 172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8P = [];
/* style */

const __vue_inject_styles__$8P = undefined;
/* scoped */

const __vue_scope_id__$8P = undefined;
/* module identifier */

const __vue_module_identifier__$8P = undefined;
/* functional template */

const __vue_is_functional_template__$8P = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8P = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8P,
  staticRenderFns: __vue_staticRenderFns__$8P
}, __vue_inject_styles__$8P, __vue_script__$8P, __vue_scope_id__$8P, __vue_is_functional_template__$8P, __vue_module_identifier__$8P, false, undefined, undefined, undefined);

var script$8Q = Vue.extend({
  name: "PhNavigationArrow",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8Q = script$8Q;
/* template */

var __vue_render__$8Q = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M37.39014,47.56448l58.605,169.30343a8,8,0,0,0,15.20612-.2642l23.5556-76.5557a8,8,0,0,1,5.29355-5.29355l76.5557-23.5556a8,8,0,0,0,.2642-15.20612L47.56692,37.3877A8,8,0,0,0,37.39014,47.56448Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M37.39014,47.56448l58.605,169.30343a8,8,0,0,0,15.20612-.2642l23.5556-76.5557a8,8,0,0,1,5.29355-5.29355l76.5557-23.5556a8,8,0,0,0,.2642-15.20612L47.56692,37.3877A8,8,0,0,0,37.39014,47.56448Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M37.39014,47.56448l58.605,169.30343a8,8,0,0,0,15.20612-.2642l23.5556-76.5557a8,8,0,0,1,5.29355-5.29355l76.5557-23.5556a8,8,0,0,0,.2642-15.20612L47.56692,37.3877A8,8,0,0,0,37.39014,47.56448Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M219.4873,88.43359,50.18457,29.82812A15.99955,15.99955,0,0,0,29.83105,50.18164l58.6045,169.30371A15.75666,15.75666,0,0,0,103.53516,230.251c.09863,0,.19922-.001.29785-.00293a15.76424,15.76424,0,0,0,15.01465-11.292l23.55566-76.55468L218.96,118.8457a16.00021,16.00021,0,0,0,.52734-30.41211Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M37.39014,47.56448l58.605,169.30343a8,8,0,0,0,15.20612-.2642l23.5556-76.5557a8,8,0,0,1,5.29355-5.29355l76.5557-23.5556a8,8,0,0,0,.2642-15.20612L47.56692,37.3877A8,8,0,0,0,37.39014,47.56448Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M37.39014,47.56448l58.605,169.30343a8,8,0,0,0,15.20612-.2642l23.5556-76.5557a8,8,0,0,1,5.29355-5.29355l76.5557-23.5556a8,8,0,0,0,.2642-15.20612L47.56692,37.3877A8,8,0,0,0,37.39014,47.56448Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M37.39014,47.56448l58.605,169.30343a8,8,0,0,0,15.20612-.2642l23.5556-76.5557a8,8,0,0,1,5.29355-5.29355l76.5557-23.5556a8,8,0,0,0,.2642-15.20612L47.56692,37.3877A8,8,0,0,0,37.39014,47.56448Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8Q = [];
/* style */

const __vue_inject_styles__$8Q = undefined;
/* scoped */

const __vue_scope_id__$8Q = undefined;
/* module identifier */

const __vue_module_identifier__$8Q = undefined;
/* functional template */

const __vue_is_functional_template__$8Q = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8Q = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8Q,
  staticRenderFns: __vue_staticRenderFns__$8Q
}, __vue_inject_styles__$8Q, __vue_script__$8Q, __vue_scope_id__$8Q, __vue_is_functional_template__$8Q, __vue_module_identifier__$8Q, false, undefined, undefined, undefined);

var script$8R = Vue.extend({
  name: "PhNewspaper",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8R = script$8R;
/* template */

var __vue_render__$8R = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M16,88v92a20,20,0,0,0,20,20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "108",
      "x2": "176",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "148",
      "x2": "176",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,180V64a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V184a16,16,0,0,1-16,16H36A20,20,0,0,0,56,180Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,200a16,16,0,0,0,16-16V64a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V184a16,16,0,0,1-16,16Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "112",
      "x2": "176",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "144",
      "x2": "176",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,200a16,16,0,0,0,16-16V64a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V184a16,16,0,0,1-16,16Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,200a16,16,0,0,1-16-16V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,48H56A16.01833,16.01833,0,0,0,40,64V184a8,8,0,0,1-16,0V88A8,8,0,0,0,8,88v96.10645A24.02715,24.02715,0,0,0,32,208H208a24.0275,24.0275,0,0,0,24-24V64A16.01833,16.01833,0,0,0,216,48ZM176,152H96a8,8,0,0,1,0-16h80a8,8,0,0,1,0,16Zm0-32H96a8,8,0,0,1,0-16h80a8,8,0,0,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "112",
      "x2": "176",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "144",
      "x2": "176",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,200a16,16,0,0,0,16-16V64a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V184a16,16,0,0,1-16,16Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,200a16,16,0,0,1-16-16V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "112",
      "x2": "176",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "144",
      "x2": "176",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,200a16,16,0,0,0,16-16V64a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V184a16,16,0,0,1-16,16Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,200a16,16,0,0,1-16-16V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "112",
      "x2": "176",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "144",
      "x2": "176",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,200a16,16,0,0,0,16-16V64a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V184a16,16,0,0,1-16,16Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,200a16,16,0,0,1-16-16V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8R = [];
/* style */

const __vue_inject_styles__$8R = undefined;
/* scoped */

const __vue_scope_id__$8R = undefined;
/* module identifier */

const __vue_module_identifier__$8R = undefined;
/* functional template */

const __vue_is_functional_template__$8R = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8R = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8R,
  staticRenderFns: __vue_staticRenderFns__$8R
}, __vue_inject_styles__$8R, __vue_script__$8R, __vue_scope_id__$8R, __vue_is_functional_template__$8R, __vue_module_identifier__$8R, false, undefined, undefined, undefined);

var script$8S = Vue.extend({
  name: "PhNewspaperClipping",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8S = script$8S;
/* template */

var __vue_render__$8S = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,216V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V216l-32-16-32,16-32-16L96,216,64,200Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "148",
      "y1": "108",
      "x2": "184",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "148",
      "y1": "148",
      "x2": "184",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "72",
      "y": "96",
      "width": "40",
      "height": "64",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,48H40a8.00009,8.00009,0,0,0-8,8V216l32-16,32,16,32-16,32,16,32-16,32,16V56A8.00009,8.00009,0,0,0,216,48ZM112,160H64V96h48Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,216V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V216l-32-16-32,16-32-16L96,216,64,200Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "112",
      "x2": "192",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "144",
      "x2": "192",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "64",
      "y": "96",
      "width": "48",
      "height": "64",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M72,104h32v48H72ZM232,56V216a7.99951,7.99951,0,0,1-11.57812,7.15527L192,208.94434l-28.42188,14.21093a8.00049,8.00049,0,0,1-7.15624,0L128,208.94434,99.57812,223.15527a7.99634,7.99634,0,0,1-7.15624,0L64,208.94434,35.57812,223.15527A7.99951,7.99951,0,0,1,24,216V56A16.01833,16.01833,0,0,1,40,40H216A16.01833,16.01833,0,0,1,232,56ZM120,96a8.00039,8.00039,0,0,0-8-8H64a8.00039,8.00039,0,0,0-8,8v64a8.00039,8.00039,0,0,0,8,8h48a8.00039,8.00039,0,0,0,8-8Zm80,48a8.00039,8.00039,0,0,0-8-8H144a8,8,0,0,0,0,16h48A8.00039,8.00039,0,0,0,200,144Zm0-32a8.00039,8.00039,0,0,0-8-8H144a8,8,0,0,0,0,16h48A8.00039,8.00039,0,0,0,200,112Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,216V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V216l-32-16-32,16-32-16L96,216,64,200Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "112",
      "x2": "192",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "144",
      "x2": "192",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "64",
      "y": "96",
      "width": "48",
      "height": "64",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,216V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V216l-32-16-32,16-32-16L96,216,64,200Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "112",
      "x2": "192",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "144",
      "x2": "192",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "64",
      "y": "96",
      "width": "48",
      "height": "64",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,216V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V216l-32-16-32,16-32-16L96,216,64,200Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "112",
      "x2": "192",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "144",
      "x2": "192",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "64",
      "y": "96",
      "width": "48",
      "height": "64",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8S = [];
/* style */

const __vue_inject_styles__$8S = undefined;
/* scoped */

const __vue_scope_id__$8S = undefined;
/* module identifier */

const __vue_module_identifier__$8S = undefined;
/* functional template */

const __vue_is_functional_template__$8S = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8S = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8S,
  staticRenderFns: __vue_staticRenderFns__$8S
}, __vue_inject_styles__$8S, __vue_script__$8S, __vue_scope_id__$8S, __vue_is_functional_template__$8S, __vue_module_identifier__$8S, false, undefined, undefined, undefined);

var script$8T = Vue.extend({
  name: "PhNote",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8T = script$8T;
/* template */

var __vue_render__$8T = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "108",
      "x2": "160",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "148",
      "x2": "116",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M156.68629,216H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8V156.68629a8,8,0,0,1-2.34315,5.65686l-51.3137,51.3137A8,8,0,0,1,156.68629,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "215.277 155.992 156 155.992 156 215.272",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "216 159.992 160 159.992 160 216 216 159.992",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "96",
      "x2": "160",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "128",
      "x2": "160",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "160",
      "x2": "128",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M156.68629,216H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8V156.68629a8,8,0,0,1-2.34315,5.65686l-51.3137,51.3137A8,8,0,0,1,156.68629,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "215.28 159.992 160 159.992 160 215.275",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,32H48A16.01081,16.01081,0,0,0,32,48V208a16.01081,16.01081,0,0,0,16,16H156.6875A15.92313,15.92313,0,0,0,168,219.3125L219.3125,168A15.92313,15.92313,0,0,0,224,156.6875V48A16.01081,16.01081,0,0,0,208,32ZM96,88h64a8,8,0,0,1,0,16H96a8,8,0,0,1,0-16Zm32,80H96a8,8,0,0,1,0-16h32a8,8,0,0,1,0,16ZM96,136a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm64,68.6875V159.98438h44.70312Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "96",
      "x2": "160",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "128",
      "x2": "160",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "160",
      "x2": "128",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M156.68629,216H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8V156.68629a8,8,0,0,1-2.34315,5.65686l-51.3137,51.3137A8,8,0,0,1,156.68629,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "215.277 159.992 160 159.992 160 215.272",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "96",
      "x2": "160",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "128",
      "x2": "160",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "160",
      "x2": "128",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M156.68629,216H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8V156.68629a8,8,0,0,1-2.34315,5.65686l-51.3137,51.3137A8,8,0,0,1,156.68629,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "215.277 159.992 160 159.992 160 215.272",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "96",
      "x2": "160",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "128",
      "x2": "160",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "160",
      "x2": "128",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M156.68629,216H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8V156.68629a8,8,0,0,1-2.34315,5.65686l-51.3137,51.3137A8,8,0,0,1,156.68629,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "215.276 159.992 160 159.992 160 215.272",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8T = [];
/* style */

const __vue_inject_styles__$8T = undefined;
/* scoped */

const __vue_scope_id__$8T = undefined;
/* module identifier */

const __vue_module_identifier__$8T = undefined;
/* functional template */

const __vue_is_functional_template__$8T = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8T = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8T,
  staticRenderFns: __vue_staticRenderFns__$8T
}, __vue_inject_styles__$8T, __vue_script__$8T, __vue_scope_id__$8T, __vue_is_functional_template__$8T, __vue_module_identifier__$8T, false, undefined, undefined, undefined);

var script$8U = Vue.extend({
  name: "PhNoteBlank",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8U = script$8U;
/* template */

var __vue_render__$8U = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M156.68629,216H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8V156.68629a8,8,0,0,1-2.34315,5.65686l-51.3137,51.3137A8,8,0,0,1,156.68629,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "215.284 155.992 156 155.992 156 215.275",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "216 159.992 160 159.992 160 216 216 159.992",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M156.68629,216H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8V156.68629a8,8,0,0,1-2.34315,5.65686l-51.3137,51.3137A8,8,0,0,1,156.68629,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "215.279 159.992 160 159.992 160 215.275",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,32H48A16.01833,16.01833,0,0,0,32,48V208a16.01833,16.01833,0,0,0,16,16H156.68652A15.89354,15.89354,0,0,0,168,219.31348L219.31348,168A15.89557,15.89557,0,0,0,224,156.68652V48A16.01833,16.01833,0,0,0,208,32ZM160,204.68652V159.99219h44.69458Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M156.68629,216H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8V156.68629a8,8,0,0,1-2.34315,5.65686l-51.3137,51.3137A8,8,0,0,1,156.68629,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "215.279 159.992 160 159.992 160 215.278",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M156.68629,216H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8V156.68629a8,8,0,0,1-2.34315,5.65686l-51.3137,51.3137A8,8,0,0,1,156.68629,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "215.279 159.992 160 159.992 160 215.272",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M156.68629,216H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8V156.68629a8,8,0,0,1-2.34315,5.65686l-51.3137,51.3137A8,8,0,0,1,156.68629,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "215.281 159.992 160 159.992 160 215.272",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8U = [];
/* style */

const __vue_inject_styles__$8U = undefined;
/* scoped */

const __vue_scope_id__$8U = undefined;
/* module identifier */

const __vue_module_identifier__$8U = undefined;
/* functional template */

const __vue_is_functional_template__$8U = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8U = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8U,
  staticRenderFns: __vue_staticRenderFns__$8U
}, __vue_inject_styles__$8U, __vue_script__$8U, __vue_scope_id__$8U, __vue_is_functional_template__$8U, __vue_module_identifier__$8U, false, undefined, undefined, undefined);

var script$8V = Vue.extend({
  name: "PhNotePencil",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8V = script$8V;
/* template */

var __vue_render__$8V = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "128 160 96 160 96 128 192 32 224 64 128 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "164",
      "y1": "60",
      "x2": "196",
      "y2": "92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,128.56836V208a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8h79.43163",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "128 160 96 160 96 128 168 56 200 88 128 160",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "128 160 96 160 96 128 192 32 224 64 128 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "56",
      "x2": "200",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,120v88a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8h88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M223.99414,120v88a16.01833,16.01833,0,0,1-16,16h-160a16.01833,16.01833,0,0,1-16-16V48a16.01833,16.01833,0,0,1,16-16h88a8,8,0,0,1,0,16h-88V208h160V120a8,8,0,0,1,16,0Zm5.65723-50.34326-96,96A8.00076,8.00076,0,0,1,127.99414,168h-32a8.00039,8.00039,0,0,1-8-8V128a8.00035,8.00035,0,0,1,2.34277-5.65674l96-96a8.00034,8.00034,0,0,1,11.31446,0l32,32A8,8,0,0,1,229.65137,69.65674ZM212.68066,64,191.99414,43.31348,179.30811,56l20.68628,20.68652Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "128 160 96 160 96 128 192 32 224 64 128 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "56",
      "x2": "200",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,120v88a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8h88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "128 160 96 160 96 128 192 32 224 64 128 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "56",
      "x2": "200",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,120v88a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8h88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "128 160 96 160 96 128 192 32 224 64 128 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "56",
      "x2": "200",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,120v88a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8h88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8V = [];
/* style */

const __vue_inject_styles__$8V = undefined;
/* scoped */

const __vue_scope_id__$8V = undefined;
/* module identifier */

const __vue_module_identifier__$8V = undefined;
/* functional template */

const __vue_is_functional_template__$8V = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8V = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8V,
  staticRenderFns: __vue_staticRenderFns__$8V
}, __vue_inject_styles__$8V, __vue_script__$8V, __vue_scope_id__$8V, __vue_is_functional_template__$8V, __vue_module_identifier__$8V, false, undefined, undefined, undefined);

var script$8W = Vue.extend({
  name: "PhNotebook",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8W = script$8W;
/* template */

var __vue_render__$8W = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "120",
      "y1": "108",
      "x2": "176",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "148",
      "x2": "176",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "40",
      "x2": "80",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,216H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H80Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "112",
      "x2": "176",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "144",
      "x2": "176",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "40",
      "x2": "80",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,32H48A16.01833,16.01833,0,0,0,32,48V208a16.01833,16.01833,0,0,0,16,16H208a16.01833,16.01833,0,0,0,16-16V48A16.01833,16.01833,0,0,0,208,32ZM80,208H48V48H80Zm96-56H112a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm0-32H112a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "112",
      "y1": "112",
      "x2": "176",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "144",
      "x2": "176",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "40",
      "x2": "80",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "112",
      "y1": "112",
      "x2": "176",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "144",
      "x2": "176",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "40",
      "x2": "80",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "112",
      "y1": "112",
      "x2": "176",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "144",
      "x2": "176",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "40",
      "x2": "80",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8W = [];
/* style */

const __vue_inject_styles__$8W = undefined;
/* scoped */

const __vue_scope_id__$8W = undefined;
/* module identifier */

const __vue_module_identifier__$8W = undefined;
/* functional template */

const __vue_is_functional_template__$8W = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8W = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8W,
  staticRenderFns: __vue_staticRenderFns__$8W
}, __vue_inject_styles__$8W, __vue_script__$8W, __vue_scope_id__$8W, __vue_is_functional_template__$8W, __vue_module_identifier__$8W, false, undefined, undefined, undefined);

var script$8X = Vue.extend({
  name: "PhNotepad",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8X = script$8X;
/* template */

var __vue_render__$8X = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "124.00586",
      "x2": "160",
      "y2": "124.00586",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "164.00586",
      "x2": "160",
      "y2": "164.00586",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,40.00586H200a8,8,0,0,1,8,8v152a24,24,0,0,1-24,24H72a24,24,0,0,1-24-24v-152A8,8,0,0,1,56,40.00586Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "84",
      "y1": "24.00586",
      "x2": "84",
      "y2": "56.00586",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "24.00586",
      "x2": "128",
      "y2": "56.00586",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "172",
      "y1": "24.00586",
      "x2": "172",
      "y2": "56.00586",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56,40.00586H200a8,8,0,0,1,8,8v152a24,24,0,0,1-24,24H72a24,24,0,0,1-24-24v-152A8,8,0,0,1,56,40.00586Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "128.00586",
      "x2": "160",
      "y2": "128.00586",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "160.00586",
      "x2": "160",
      "y2": "160.00586",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,40.00586H200a8,8,0,0,1,8,8v152a24,24,0,0,1-24,24H72a24,24,0,0,1-24-24v-152A8,8,0,0,1,56,40.00586Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "24.00586",
      "x2": "80",
      "y2": "56.00586",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "24.00586",
      "x2": "128",
      "y2": "56.00586",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "24.00586",
      "x2": "176",
      "y2": "56.00586",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,32.00586H184v-8a8,8,0,1,0-16,0v8H136v-8a8,8,0,1,0-16,0v8H88v-8a8,8,0,0,0-16,0v8H56a16.01833,16.01833,0,0,0-16,16v152a32.03667,32.03667,0,0,0,32,32H184a32.03667,32.03667,0,0,0,32-32v-152A16.01833,16.01833,0,0,0,200,32.00586Zm-40,136H96a8,8,0,1,1,0-16h64a8,8,0,0,1,0,16Zm0-32H96a8,8,0,1,1,0-16h64a8,8,0,0,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "128.00586",
      "x2": "160",
      "y2": "128.00586",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "160.00586",
      "x2": "160",
      "y2": "160.00586",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,40.00586H200a8,8,0,0,1,8,8v152a24,24,0,0,1-24,24H72a24,24,0,0,1-24-24v-152A8,8,0,0,1,56,40.00586Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "24.00586",
      "x2": "80",
      "y2": "56.00586",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "24.00586",
      "x2": "128",
      "y2": "56.00586",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "24.00586",
      "x2": "176",
      "y2": "56.00586",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "128.00586",
      "x2": "160",
      "y2": "128.00586",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "160.00586",
      "x2": "160",
      "y2": "160.00586",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,40.00586H200a8,8,0,0,1,8,8v152a24,24,0,0,1-24,24H72a24,24,0,0,1-24-24v-152A8,8,0,0,1,56,40.00586Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "24.00586",
      "x2": "80",
      "y2": "56.00586",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "24.00586",
      "x2": "128",
      "y2": "56.00586",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "24.00586",
      "x2": "176",
      "y2": "56.00586",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "128.00586",
      "x2": "160",
      "y2": "128.00586",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "160.00586",
      "x2": "160",
      "y2": "160.00586",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,40.00586H200a8,8,0,0,1,8,8v152a24,24,0,0,1-24,24H72a24,24,0,0,1-24-24v-152A8,8,0,0,1,56,40.00586Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "24.00586",
      "x2": "80",
      "y2": "56.00586",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "24.00586",
      "x2": "128",
      "y2": "56.00586",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "24.00586",
      "x2": "176",
      "y2": "56.00586",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8X = [];
/* style */

const __vue_inject_styles__$8X = undefined;
/* scoped */

const __vue_scope_id__$8X = undefined;
/* module identifier */

const __vue_module_identifier__$8X = undefined;
/* functional template */

const __vue_is_functional_template__$8X = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8X = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8X,
  staticRenderFns: __vue_staticRenderFns__$8X
}, __vue_inject_styles__$8X, __vue_script__$8X, __vue_scope_id__$8X, __vue_is_functional_template__$8X, __vue_module_identifier__$8X, false, undefined, undefined, undefined);

var script$8Y = Vue.extend({
  name: "PhNotification",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8Y = script$8Y;
/* template */

var __vue_render__$8Y = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,128v80a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8h80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "196",
      "cy": "60",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "196",
      "cy": "60",
      "r": "28",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,128v80a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8h80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "196",
      "cy": "60",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,128v80a16.01833,16.01833,0,0,1-16,16H48a16.01833,16.01833,0,0,1-16-16V56A16.01833,16.01833,0,0,1,48,40h80a8,8,0,0,1,0,16H48V208H200V128a8,8,0,0,1,16,0ZM196,24a36,36,0,1,0,36,36A36.04061,36.04061,0,0,0,196,24Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,128v80a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8h80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "196",
      "cy": "60",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,128v80a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8h80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "196",
      "cy": "60",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,128v80a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8h80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "196",
      "cy": "60",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8Y = [];
/* style */

const __vue_inject_styles__$8Y = undefined;
/* scoped */

const __vue_scope_id__$8Y = undefined;
/* module identifier */

const __vue_module_identifier__$8Y = undefined;
/* functional template */

const __vue_is_functional_template__$8Y = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8Y = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8Y,
  staticRenderFns: __vue_staticRenderFns__$8Y
}, __vue_inject_styles__$8Y, __vue_script__$8Y, __vue_scope_id__$8Y, __vue_is_functional_template__$8Y, __vue_module_identifier__$8Y, false, undefined, undefined, undefined);

var script$8Z = Vue.extend({
  name: "PhNumberCircleEight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8Z = script$8Z;
/* template */

var __vue_render__$8Z = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M150,102a22,22,0,1,1-6.44365-15.55635A21.93114,21.93114,0,0,1,150,102Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154,150a26,26,0,1,1-7.61522-18.38478A25.91866,25.91866,0,0,1,154,150Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M150,102a22,22,0,1,1-6.44365-15.55635A21.93114,21.93114,0,0,1,150,102Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154,150a26,26,0,1,1-7.61522-18.38478A25.91866,25.91866,0,0,1,154,150Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.12041,104.12041,0,0,0,128,24Zm24.03125,150.04688a33.99637,33.99637,0,1,1-48.0625-48.09375,30.89828,30.89828,0,0,1,3.10645-2.50782c-.0918-.08984-.20313-.15136-.29395-.24218a29.98907,29.98907,0,0,1,.01563-42.42188c11.29687-11.3125,31.09375-11.32812,42.42187.01563a29.98907,29.98907,0,0,1-.01562,42.42187c-.08594.08594-.19141.14355-.27833.22852a30.83759,30.83759,0,0,1,3.12208,2.52148,33.98762,33.98762,0,0,1-.01563,48.07813Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M137.89063,111.90625a14,14,0,1,0-19.79688-.01562A14.318,14.318,0,0,0,137.89063,111.90625Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,132a17.99808,17.99808,0,0,0-12.73437,30.71875,18.43509,18.43509,0,0,0,25.45312.01563A18,18,0,0,0,128,132Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M150,102a22,22,0,1,1-6.44365-15.55635A21.93114,21.93114,0,0,1,150,102Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154,150a26,26,0,1,1-7.61522-18.38478A25.91866,25.91866,0,0,1,154,150Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M150,102a22,22,0,1,1-6.44365-15.55635A21.93114,21.93114,0,0,1,150,102Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154,150a26,26,0,1,1-7.61522-18.38478A25.91866,25.91866,0,0,1,154,150Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M150,102a22,22,0,1,1-6.44365-15.55635A21.93114,21.93114,0,0,1,150,102Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154,150a26,26,0,1,1-7.61522-18.38478A25.91866,25.91866,0,0,1,154,150Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8Z = [];
/* style */

const __vue_inject_styles__$8Z = undefined;
/* scoped */

const __vue_scope_id__$8Z = undefined;
/* module identifier */

const __vue_module_identifier__$8Z = undefined;
/* functional template */

const __vue_is_functional_template__$8Z = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8Z = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8Z,
  staticRenderFns: __vue_staticRenderFns__$8Z
}, __vue_inject_styles__$8Z, __vue_script__$8Z, __vue_scope_id__$8Z, __vue_is_functional_template__$8Z, __vue_module_identifier__$8Z, false, undefined, undefined, undefined);

var script$8_ = Vue.extend({
  name: "PhNumberCircleFive",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8_ = script$8_;
/* template */

var __vue_render__$8_ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,84H111.83477L104,132.20232a27.99935,27.99935,0,1,1,0,39.5969",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,84H111.83477L104,132.20232a27.99935,27.99935,0,1,1,0,39.5969",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.11791,104.11791,0,0,0,128,24ZM123.88184,116.002A35.99912,35.99912,0,1,1,98.35449,177.4668a7.99985,7.99985,0,1,1,11.291-11.33594,20.20173,20.20173,0,0,0,28.47461-.001,19.91646,19.91646,0,0,0-.001-28.25976,20.20412,20.20412,0,0,0-28.47461.001,7.99971,7.99971,0,0,1-13.541-6.95214l7.835-48.20215A8.00076,8.00076,0,0,1,111.835,76H152a8,8,0,0,1,0,16H118.63965L114.542,117.21094A36.413,36.413,0,0,1,123.88184,116.002Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,84H111.83477L104,132.20232a27.99935,27.99935,0,1,1,0,39.5969",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,84H111.83477L104,132.20232a27.99935,27.99935,0,1,1,0,39.5969",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,84H111.83477L104,132.20232a27.99935,27.99935,0,1,1,0,39.5969",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8_ = [];
/* style */

const __vue_inject_styles__$8_ = undefined;
/* scoped */

const __vue_scope_id__$8_ = undefined;
/* module identifier */

const __vue_module_identifier__$8_ = undefined;
/* functional template */

const __vue_is_functional_template__$8_ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8_ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8_,
  staticRenderFns: __vue_staticRenderFns__$8_
}, __vue_inject_styles__$8_, __vue_script__$8_, __vue_scope_id__$8_, __vue_is_functional_template__$8_, __vue_module_identifier__$8_, false, undefined, undefined, undefined);

var script$8$ = Vue.extend({
  name: "PhNumberCircleFour",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8$ = script$8$;
/* template */

var __vue_render__$8$ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "123.998 76 100 144 148 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "148",
      "y1": "112",
      "x2": "148",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "123.998 76 100 144 148 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "148",
      "y1": "112",
      "x2": "148",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.11791,104.11791,0,0,0,128,24Zm28,152a8,8,0,0,1-16,0V152H100a7.99995,7.99995,0,0,1-7.54395-10.66211l23.998-68A7.99987,7.99987,0,1,1,131.542,78.66211L111.30664,136H140V112a8,8,0,0,1,16,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "123.998 76 100 144 148 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "148",
      "y1": "112",
      "x2": "148",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "123.998 76 100 144 148 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "148",
      "y1": "112",
      "x2": "148",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "123.998 76 100 144 148 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "148",
      "y1": "112",
      "x2": "148",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8$ = [];
/* style */

const __vue_inject_styles__$8$ = undefined;
/* scoped */

const __vue_scope_id__$8$ = undefined;
/* module identifier */

const __vue_module_identifier__$8$ = undefined;
/* functional template */

const __vue_is_functional_template__$8$ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8$ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8$,
  staticRenderFns: __vue_staticRenderFns__$8$
}, __vue_inject_styles__$8$, __vue_script__$8$, __vue_scope_id__$8$, __vue_is_functional_template__$8$, __vue_module_identifier__$8$, false, undefined, undefined, undefined);

var script$90 = Vue.extend({
  name: "PhNumberCircleNine",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$90 = script$90;
/* template */

var __vue_render__$90 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152.24871",
      "y1": "126.00466",
      "x2": "120",
      "y2": "180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "112",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152.24871",
      "y1": "126.00466",
      "x2": "120",
      "y2": "180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "112",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M148,112a20,20,0,1,1-20-20A20.02229,20.02229,0,0,1,148,112Zm84,16A104,104,0,1,1,128,24,104.11791,104.11791,0,0,1,232,128Zm-68-16a36,36,0,1,0-36,36q.91626,0,1.82129-.04639l-16.68945,27.94385a8.00015,8.00015,0,1,0,13.73632,8.20508l32.249-53.99512c.09668-.16162.178-.32812.262-.49365A35.76587,35.76587,0,0,0,164,112Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152.24871",
      "y1": "126.00466",
      "x2": "120",
      "y2": "180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "112",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152.24871",
      "y1": "126.00466",
      "x2": "120",
      "y2": "180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "112",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152.24871",
      "y1": "126.00466",
      "x2": "120",
      "y2": "180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "112",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$90 = [];
/* style */

const __vue_inject_styles__$90 = undefined;
/* scoped */

const __vue_scope_id__$90 = undefined;
/* module identifier */

const __vue_module_identifier__$90 = undefined;
/* functional template */

const __vue_is_functional_template__$90 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$90 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$90,
  staticRenderFns: __vue_staticRenderFns__$90
}, __vue_inject_styles__$90, __vue_script__$90, __vue_scope_id__$90, __vue_is_functional_template__$90, __vue_module_identifier__$90, false, undefined, undefined, undefined);

var script$91 = Vue.extend({
  name: "PhNumberCircleOne",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$91 = script$91;
/* template */

var __vue_render__$91 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 99.993 132 84 132 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 99.993 132 84 132 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.11791,104.11791,0,0,0,128,24Zm12,152a8,8,0,0,1-16,0V98.94434l-11.56348,7.70605a8.00008,8.00008,0,1,1-8.873-13.31445l24-15.99317A8.00039,8.00039,0,0,1,140,84Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 99.993 132 84 132 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 99.993 132 84 132 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 99.993 132 84 132 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$91 = [];
/* style */

const __vue_inject_styles__$91 = undefined;
/* scoped */

const __vue_scope_id__$91 = undefined;
/* module identifier */

const __vue_module_identifier__$91 = undefined;
/* functional template */

const __vue_is_functional_template__$91 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$91 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$91,
  staticRenderFns: __vue_staticRenderFns__$91
}, __vue_inject_styles__$91, __vue_script__$91, __vue_scope_id__$91, __vue_is_functional_template__$91, __vue_module_identifier__$91, false, undefined, undefined, undefined);

var script$92 = Vue.extend({
  name: "PhNumberCircleSeven",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$92 = script$92;
/* template */

var __vue_render__$92 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "104 84 152 84 120 180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "104 84 152 84 120 180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.11791,104.11791,0,0,0,128,24Zm31.58984,62.53027-32,96a8.0005,8.0005,0,1,1-15.17968-5.06054L140.90039,92H104a8,8,0,0,1,0-16h48a8.00022,8.00022,0,0,1,7.58984,10.53027Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "104 84 152 84 120 180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "104 84 152 84 120 180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "104 84 152 84 120 180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$92 = [];
/* style */

const __vue_inject_styles__$92 = undefined;
/* scoped */

const __vue_scope_id__$92 = undefined;
/* module identifier */

const __vue_module_identifier__$92 = undefined;
/* functional template */

const __vue_is_functional_template__$92 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$92 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$92,
  staticRenderFns: __vue_staticRenderFns__$92
}, __vue_inject_styles__$92, __vue_script__$92, __vue_scope_id__$92, __vue_is_functional_template__$92, __vue_module_identifier__$92, false, undefined, undefined, undefined);

var script$93 = Vue.extend({
  name: "PhNumberCircleSix",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$93 = script$93;
/* template */

var __vue_render__$93 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "103.75129",
      "y1": "129.98956",
      "x2": "136",
      "y2": "76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "144",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "103.75129",
      "y1": "129.98956",
      "x2": "136",
      "y2": "76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "144",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M148,144a20,20,0,1,1-20-20A20.02229,20.02229,0,0,1,148,144Zm84-16A104,104,0,1,1,128,24,104.11791,104.11791,0,0,1,232,128Zm-68,16a36.04061,36.04061,0,0,0-36-36q-.917,0-1.82324.04639l16.6914-27.94385a8.00015,8.00015,0,0,0-13.73632-8.20508l-32.249,53.98926c-.11157.18652-.20776.37793-.30224.56982A35.99384,35.99384,0,1,0,164,144Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "103.75129",
      "y1": "129.98956",
      "x2": "136",
      "y2": "76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "144",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "103.75129",
      "y1": "129.98956",
      "x2": "136",
      "y2": "76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "144",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "103.75129",
      "y1": "129.98956",
      "x2": "136",
      "y2": "76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "144",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$93 = [];
/* style */

const __vue_inject_styles__$93 = undefined;
/* scoped */

const __vue_scope_id__$93 = undefined;
/* module identifier */

const __vue_module_identifier__$93 = undefined;
/* functional template */

const __vue_is_functional_template__$93 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$93 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$93,
  staticRenderFns: __vue_staticRenderFns__$93
}, __vue_inject_styles__$93, __vue_script__$93, __vue_scope_id__$93, __vue_is_functional_template__$93, __vue_module_identifier__$93, false, undefined, undefined, undefined);

var script$94 = Vue.extend({
  name: "PhNumberCircleThree",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$94 = script$94;
/* template */

var __vue_render__$94 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M103.99683,83.99216h48L124.00317,124a28,28,0,1,1-19.799,47.799",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M103.99683,83.99216h48L124.00317,124a28,28,0,1,1-19.799,47.799",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.11791,104.11791,0,0,0,128,24Zm21.458,153.45605a35.99982,35.99982,0,0,1-50.91113,0,8.00052,8.00052,0,0,1,11.31445-11.31445A19.99959,19.99959,0,1,0,124.00293,132a8,8,0,0,1-6.55469-12.58691l19.1875-27.4209H103.99707a8,8,0,0,1,0-16h48a8,8,0,0,1,6.55469,12.58691L137.5332,118.61816A36.019,36.019,0,0,1,149.458,177.45605Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M103.99683,83.99216h48L124.00317,124a28,28,0,1,1-19.799,47.799",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M103.99683,83.99216h48L124.00317,124a28,28,0,1,1-19.799,47.799",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M103.99683,83.99216h48L124.00317,124a28,28,0,1,1-19.799,47.799",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$94 = [];
/* style */

const __vue_inject_styles__$94 = undefined;
/* scoped */

const __vue_scope_id__$94 = undefined;
/* module identifier */

const __vue_module_identifier__$94 = undefined;
/* functional template */

const __vue_is_functional_template__$94 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$94 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$94,
  staticRenderFns: __vue_staticRenderFns__$94
}, __vue_inject_styles__$94, __vue_script__$94, __vue_scope_id__$94, __vue_is_functional_template__$94, __vue_module_identifier__$94, false, undefined, undefined, undefined);

var script$95 = Vue.extend({
  name: "PhNumberCircleTwo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$95 = script$95;
/* template */

var __vue_render__$95 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M105.886,94.65812a24.00387,24.00387,0,1,1,42.01514,22.7605v0L104,176v-.00575h48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M105.886,94.65812a24.00387,24.00387,0,1,1,42.01514,22.7605v0L104,176v-.00575h48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.11791,104.11791,0,0,0,128,24Zm24,143.99414a8,8,0,0,1,0,16H104.31738c-.10644.00391-.21289.00684-.31836.00684a8.00343,8.00343,0,0,1-6.30175-12.93164L141.37012,112.794a16.00416,16.00416,0,1,0-28.11621-15.01954A8,8,0,1,1,98.51758,91.542a32.00411,32.00411,0,1,1,56.01269,30.35547c-.07324.1084-.14843.21484-.22754.31934l-34.30566,45.77734Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M105.886,94.65812a24.00387,24.00387,0,1,1,42.01514,22.7605v0L104,176v-.00575h48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M105.886,94.65812a24.00387,24.00387,0,1,1,42.01514,22.7605v0L104,176v-.00575h48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M105.886,94.65812a24.00387,24.00387,0,1,1,42.01514,22.7605v0L104,176v-.00575h48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$95 = [];
/* style */

const __vue_inject_styles__$95 = undefined;
/* scoped */

const __vue_scope_id__$95 = undefined;
/* module identifier */

const __vue_module_identifier__$95 = undefined;
/* functional template */

const __vue_is_functional_template__$95 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$95 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$95,
  staticRenderFns: __vue_staticRenderFns__$95
}, __vue_inject_styles__$95, __vue_script__$95, __vue_scope_id__$95, __vue_is_functional_template__$95, __vue_module_identifier__$95, false, undefined, undefined, undefined);

var script$96 = Vue.extend({
  name: "PhNumberCircleZero",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$96 = script$96;
/* template */

var __vue_render__$96 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "32",
      "ry": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "32",
      "ry": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "24",
      "ry": "40"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.12041,104.12041,0,0,0,128,24Zm0,160c-27.63281,0-40-28.125-40-56s12.36719-56,40-56,40,28.125,40,56S155.63281,184,128,184Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "32",
      "ry": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "32",
      "ry": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "32",
      "ry": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$96 = [];
/* style */

const __vue_inject_styles__$96 = undefined;
/* scoped */

const __vue_scope_id__$96 = undefined;
/* module identifier */

const __vue_module_identifier__$96 = undefined;
/* functional template */

const __vue_is_functional_template__$96 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$96 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$96,
  staticRenderFns: __vue_staticRenderFns__$96
}, __vue_inject_styles__$96, __vue_script__$96, __vue_scope_id__$96, __vue_is_functional_template__$96, __vue_module_identifier__$96, false, undefined, undefined, undefined);

var script$97 = Vue.extend({
  name: "PhNumberEight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$97 = script$97;
/* template */

var __vue_render__$97 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M178.76923,71.66667a46.108,46.108,0,0,1-14.87,33.70542,53.13546,53.13546,0,0,1-71.79854,0,45.63467,45.63467,0,0,1,0-67.41085,53.13546,53.13546,0,0,1,71.79854,0A46.108,46.108,0,0,1,178.76923,71.66667Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M188,175.66667a54.49122,54.49122,0,0,1-17.57359,39.83368,62.79644,62.79644,0,0,1-84.85282,0,53.93188,53.93188,0,0,1,0-79.66737,62.79644,62.79644,0,0,1,84.85282,0A54.49124,54.49124,0,0,1,188,175.66667Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M178.76923,71.66667a46.108,46.108,0,0,1-14.87,33.70542,53.13546,53.13546,0,0,1-71.79854,0,45.63467,45.63467,0,0,1,0-67.41085,53.13546,53.13546,0,0,1,71.79854,0A46.108,46.108,0,0,1,178.76923,71.66667Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M188,175.66667a54.49122,54.49122,0,0,1-17.57359,39.83368,62.79644,62.79644,0,0,1-84.85282,0,53.93188,53.93188,0,0,1,0-79.66737,62.79644,62.79644,0,0,1,84.85282,0A54.49124,54.49124,0,0,1,188,175.66667Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M175.90234,130.00049a68.12024,68.12024,0,0,0-16.36377-11.356,58.78324,58.78324,0,0,0,9.83643-7.43994,53.63156,53.63156,0,0,0,0-79.0752,61.13213,61.13213,0,0,0-82.75,0,53.63156,53.63156,0,0,0,0,79.0752,58.76231,58.76231,0,0,0,9.83667,7.43994,68.1188,68.1188,0,0,0-16.364,11.35645,61.93012,61.93012,0,0,0,0,91.332,70.79516,70.79516,0,0,0,95.80468-.00049,61.93012,61.93012,0,0,0,0-91.332ZM97.57617,99.53955a37.63752,37.63752,0,0,1,0-55.74609,45.13922,45.13922,0,0,1,60.84766,0,37.63752,37.63752,0,0,1,0,55.74609,45.13783,45.13783,0,0,1-60.84766,0Zm67.375,110.12842a54.80089,54.80089,0,0,1-73.90234.00049,45.936,45.936,0,0,1,0-68.00293,54.80089,54.80089,0,0,1,73.90234-.00049,45.936,45.936,0,0,1,0,68.00293Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M178.76923,71.66667a46.108,46.108,0,0,1-14.87,33.70542,53.13546,53.13546,0,0,1-71.79854,0,45.63467,45.63467,0,0,1,0-67.41085,53.13546,53.13546,0,0,1,71.79854,0A46.108,46.108,0,0,1,178.76923,71.66667Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M188,175.66667a54.49122,54.49122,0,0,1-17.57359,39.83368,62.79644,62.79644,0,0,1-84.85282,0,53.93188,53.93188,0,0,1,0-79.66737,62.79644,62.79644,0,0,1,84.85282,0A54.49124,54.49124,0,0,1,188,175.66667Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M178.76923,71.66667a46.108,46.108,0,0,1-14.87,33.70542,53.13546,53.13546,0,0,1-71.79854,0,45.63467,45.63467,0,0,1,0-67.41085,53.13546,53.13546,0,0,1,71.79854,0A46.108,46.108,0,0,1,178.76923,71.66667Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M188,175.66667a54.49122,54.49122,0,0,1-17.57359,39.83368,62.79644,62.79644,0,0,1-84.85282,0,53.93188,53.93188,0,0,1,0-79.66737,62.79644,62.79644,0,0,1,84.85282,0A54.49124,54.49124,0,0,1,188,175.66667Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M178.76923,71.66667a46.108,46.108,0,0,1-14.87,33.70542,53.13546,53.13546,0,0,1-71.79854,0,45.63467,45.63467,0,0,1,0-67.41085,53.13546,53.13546,0,0,1,71.79854,0A46.108,46.108,0,0,1,178.76923,71.66667Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M188,175.66667a54.49122,54.49122,0,0,1-17.57359,39.83368,62.79644,62.79644,0,0,1-84.85282,0,53.93188,53.93188,0,0,1,0-79.66737,62.79644,62.79644,0,0,1,84.85282,0A54.49124,54.49124,0,0,1,188,175.66667Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$97 = [];
/* style */

const __vue_inject_styles__$97 = undefined;
/* scoped */

const __vue_scope_id__$97 = undefined;
/* module identifier */

const __vue_module_identifier__$97 = undefined;
/* functional template */

const __vue_is_functional_template__$97 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$97 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$97,
  staticRenderFns: __vue_staticRenderFns__$97
}, __vue_inject_styles__$97, __vue_script__$97, __vue_scope_id__$97, __vue_is_functional_template__$97, __vue_module_identifier__$97, false, undefined, undefined, undefined);

var script$98 = Vue.extend({
  name: "PhNumberFive",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$98 = script$98;
/* template */

var __vue_render__$98 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,32H95.66955L80,128.40465a55.99871,55.99871,0,1,1,0,79.19378",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,32H95.66955L80,128.40465a55.99871,55.99871,0,1,1,0,79.19378",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M165.17383,122.73535a64.11724,64.11724,0,0,1-90.81836,90.53174,7.99968,7.99968,0,1,1,11.28906-11.3374,47.99883,47.99883,0,1,0,0-67.85645,7.99971,7.99971,0,0,1-13.541-6.95215L87.77344,30.7168A8.00076,8.00076,0,0,1,95.66992,24H176a8,8,0,0,1,0,16H102.47461l-11.501,70.75537a64.53171,64.53171,0,0,1,74.2002,11.98Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,32H95.66955L80,128.40465a55.99871,55.99871,0,1,1,0,79.19378",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,32H95.66955L80,128.40465a55.99871,55.99871,0,1,1,0,79.19378",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,32H95.66955L80,128.40465a55.99871,55.99871,0,1,1,0,79.19378",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$98 = [];
/* style */

const __vue_inject_styles__$98 = undefined;
/* scoped */

const __vue_scope_id__$98 = undefined;
/* module identifier */

const __vue_module_identifier__$98 = undefined;
/* functional template */

const __vue_is_functional_template__$98 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$98 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$98,
  staticRenderFns: __vue_staticRenderFns__$98
}, __vue_inject_styles__$98, __vue_script__$98, __vue_scope_id__$98, __vue_is_functional_template__$98, __vue_module_identifier__$98, false, undefined, undefined, undefined);

var script$99 = Vue.extend({
  name: "PhNumberFour",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$99 = script$99;
/* template */

var __vue_render__$99 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "123.997 24 76 160 172 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "172",
      "y1": "95.98859",
      "x2": "172",
      "y2": "223.98844",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "123.997 24 76 160 172 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "172",
      "y1": "96",
      "x2": "172",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M180,96V224a8,8,0,0,1-16,0V168H76a8.00033,8.00033,0,0,1-7.54395-10.66211l47.99707-136a7.99988,7.99988,0,0,1,15.0879,5.32422L87.30664,152H164V96a8,8,0,0,1,16,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "123.997 24 76 160 172 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "172",
      "y1": "96",
      "x2": "172",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "123.997 24 76 160 172 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "172",
      "y1": "96",
      "x2": "172",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "123.997 24 76 160 172 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "172",
      "y1": "96",
      "x2": "172",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$99 = [];
/* style */

const __vue_inject_styles__$99 = undefined;
/* scoped */

const __vue_scope_id__$99 = undefined;
/* module identifier */

const __vue_module_identifier__$99 = undefined;
/* functional template */

const __vue_is_functional_template__$99 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$99 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$99,
  staticRenderFns: __vue_staticRenderFns__$99
}, __vue_inject_styles__$99, __vue_script__$99, __vue_scope_id__$99, __vue_is_functional_template__$99, __vue_module_identifier__$99, false, undefined, undefined, undefined);

var script$9a = Vue.extend({
  name: "PhNumberNine",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9a = script$9a;
/* template */

var __vue_render__$9a = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "176.48933",
      "y1": "115.99533",
      "x2": "111.75",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "88",
      "r": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "176.48933",
      "y1": "115.99533",
      "x2": "111.75",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "88",
      "r": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24a64,64,0,1,0,19.38452,124.99121l-42.49585,70.896a7.99956,7.99956,0,1,0,13.72266,8.22558L182.68848,121.2124c.02881-.04736.05664-.095.08545-.14233l.57666-.96216c.10473-.17456.19409-.354.28393-.533A63.95216,63.95216,0,0,0,128,24Zm41.18115,88.62769-.22778.37988a48.6994,48.6994,0,1,1,.22778-.37988Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "176.48933",
      "y1": "115.99533",
      "x2": "111.75",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "88",
      "r": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "176.48933",
      "y1": "115.99533",
      "x2": "111.75",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "88",
      "r": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "176.48933",
      "y1": "115.99533",
      "x2": "111.75",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "88",
      "r": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9a = [];
/* style */

const __vue_inject_styles__$9a = undefined;
/* scoped */

const __vue_scope_id__$9a = undefined;
/* module identifier */

const __vue_module_identifier__$9a = undefined;
/* functional template */

const __vue_is_functional_template__$9a = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9a = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9a,
  staticRenderFns: __vue_staticRenderFns__$9a
}, __vue_inject_styles__$9a, __vue_script__$9a, __vue_scope_id__$9a, __vue_is_functional_template__$9a, __vue_module_identifier__$9a, false, undefined, undefined, undefined);

var script$9b = Vue.extend({
  name: "PhNumberOne",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9b = script$9b;
/* template */

var __vue_render__$9b = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "84 63.986 132 32 132 224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "84 63.986 132 32 132 224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M131.99574,232a8.00252,8.00252,0,0,1-8.00427-8.00045V46.95129l-35.54531,23.691A8.00167,8.00167,0,1,1,79.56448,57.3298L127.55489,25.344A8.0046,8.0046,0,0,1,140,32.00038V223.99955A8.00252,8.00252,0,0,1,131.99574,232Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "84 63.986 132 32 132 224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "84 63.986 132 32 132 224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "84 63.986 132 32 132 224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9b = [];
/* style */

const __vue_inject_styles__$9b = undefined;
/* scoped */

const __vue_scope_id__$9b = undefined;
/* module identifier */

const __vue_module_identifier__$9b = undefined;
/* functional template */

const __vue_is_functional_template__$9b = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9b = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9b,
  staticRenderFns: __vue_staticRenderFns__$9b
}, __vue_inject_styles__$9b, __vue_script__$9b, __vue_scope_id__$9b, __vue_is_functional_template__$9b, __vue_module_identifier__$9b, false, undefined, undefined, undefined);

var script$9c = Vue.extend({
  name: "PhNumberSeven",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9c = script$9c;
/* template */

var __vue_render__$9c = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 40 176 40 112 232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 40 176 40 112 232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M112.001,240a8.00547,8.00547,0,0,1-7.59082-10.53164L164.90043,47.99985H80A7.99993,7.99993,0,1,1,80,32h96a8,8,0,0,1,7.58984,10.52969l-64,191.99819A8.00469,8.00469,0,0,1,112.001,240Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 40 176 40 112 232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 40 176 40 112 232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 40 176 40 112 232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9c = [];
/* style */

const __vue_inject_styles__$9c = undefined;
/* scoped */

const __vue_scope_id__$9c = undefined;
/* module identifier */

const __vue_module_identifier__$9c = undefined;
/* functional template */

const __vue_is_functional_template__$9c = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9c = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9c,
  staticRenderFns: __vue_staticRenderFns__$9c
}, __vue_inject_styles__$9c, __vue_script__$9c, __vue_scope_id__$9c, __vue_is_functional_template__$9c, __vue_module_identifier__$9c, false, undefined, undefined, undefined);

var script$9d = Vue.extend({
  name: "PhNumberSix",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9d = script$9d;
/* template */

var __vue_render__$9d = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "79.51067",
      "y1": "140.00467",
      "x2": "144",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "168",
      "r": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "79.51067",
      "y1": "140.00467",
      "x2": "144",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "168",
      "r": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,104a63.75508,63.75508,0,0,0-19.49121,3.04492l42.36035-70.9436a8.00043,8.00043,0,0,0-13.73828-8.20288L72.6416,135.90332c-.10449.17529-.19385.355-.28369.53442A63.97854,63.97854,0,1,0,128,104Zm0,112a47.97612,47.97612,0,0,1-41.15674-72.67017l.17749-.29736A47.99419,47.99419,0,1,1,128,216Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "79.51067",
      "y1": "140.00467",
      "x2": "144",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "168",
      "r": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "79.51067",
      "y1": "140.00467",
      "x2": "144",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "168",
      "r": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "79.51067",
      "y1": "140.00467",
      "x2": "144",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "168",
      "r": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9d = [];
/* style */

const __vue_inject_styles__$9d = undefined;
/* scoped */

const __vue_scope_id__$9d = undefined;
/* module identifier */

const __vue_module_identifier__$9d = undefined;
/* functional template */

const __vue_is_functional_template__$9d = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9d = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9d,
  staticRenderFns: __vue_staticRenderFns__$9d
}, __vue_inject_styles__$9d, __vue_script__$9d, __vue_scope_id__$9d, __vue_is_functional_template__$9d, __vue_module_identifier__$9d, false, undefined, undefined, undefined);

var script$9e = Vue.extend({
  name: "PhNumberSquareEight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9e = script$9e;
/* template */

var __vue_render__$9e = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M150,102a22,22,0,1,1-6.44365-15.55635A21.93114,21.93114,0,0,1,150,102Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154,150a26,26,0,1,1-7.61522-18.38478A25.91866,25.91866,0,0,1,154,150Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M150,102a22,22,0,1,1-6.44365-15.55635A21.93114,21.93114,0,0,1,150,102Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154,150a26,26,0,1,1-7.61522-18.38478A25.91866,25.91866,0,0,1,154,150Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M137.89062,111.90625a14,14,0,1,0-19.79687-.01562A14.318,14.318,0,0,0,137.89062,111.90625Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,132a17.99808,17.99808,0,0,0-12.73438,30.71875,18.43511,18.43511,0,0,0,25.45313.01563A18,18,0,0,0,128,132Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,32H48A16.02085,16.02085,0,0,0,32,48V208a16.02085,16.02085,0,0,0,16,16H208a16.02085,16.02085,0,0,0,16-16V48A16.02085,16.02085,0,0,0,208,32ZM152.03125,174.04688a33.99637,33.99637,0,1,1-48.0625-48.09375,30.89715,30.89715,0,0,1,3.10645-2.50782c-.0918-.08984-.20313-.15136-.29395-.24218a29.98908,29.98908,0,0,1,.01562-42.42188c11.29688-11.3125,31.09375-11.32812,42.42188.01563a29.98906,29.98906,0,0,1-.01563,42.42187c-.08593.08594-.1914.14355-.27832.22852a30.83637,30.83637,0,0,1,3.12207,2.52148,33.98761,33.98761,0,0,1-.01562,48.07813Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M150,102a22,22,0,1,1-6.44365-15.55635A21.93114,21.93114,0,0,1,150,102Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154,150a26,26,0,1,1-7.61522-18.38478A25.91866,25.91866,0,0,1,154,150Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M150,102a22,22,0,1,1-6.44365-15.55635A21.93114,21.93114,0,0,1,150,102Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154,150a26,26,0,1,1-7.61522-18.38478A25.91866,25.91866,0,0,1,154,150Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M150,102a22,22,0,1,1-6.44365-15.55635A21.93114,21.93114,0,0,1,150,102Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154,150a26,26,0,1,1-7.61522-18.38478A25.91866,25.91866,0,0,1,154,150Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9e = [];
/* style */

const __vue_inject_styles__$9e = undefined;
/* scoped */

const __vue_scope_id__$9e = undefined;
/* module identifier */

const __vue_module_identifier__$9e = undefined;
/* functional template */

const __vue_is_functional_template__$9e = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9e = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9e,
  staticRenderFns: __vue_staticRenderFns__$9e
}, __vue_inject_styles__$9e, __vue_script__$9e, __vue_scope_id__$9e, __vue_is_functional_template__$9e, __vue_module_identifier__$9e, false, undefined, undefined, undefined);

var script$9f = Vue.extend({
  name: "PhNumberSquareFive",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9f = script$9f;
/* template */

var __vue_render__$9f = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M152,80H111.83477L104,128.20232a27.99935,27.99935,0,1,1,0,39.5969",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,80H111.83477L104,128.20232a27.99935,27.99935,0,1,1,0,39.5969",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,32H48A16.01833,16.01833,0,0,0,32,48V208a16.01833,16.01833,0,0,0,16,16H208a16.01833,16.01833,0,0,0,16-16V48A16.01833,16.01833,0,0,0,208,32ZM123.88184,112.002A35.99912,35.99912,0,1,1,98.35449,173.4668a7.99985,7.99985,0,1,1,11.291-11.33594,20.20173,20.20173,0,0,0,28.47461-.001,19.91646,19.91646,0,0,0-.001-28.25976,20.20412,20.20412,0,0,0-28.47461.001,7.99971,7.99971,0,0,1-13.541-6.95214l7.835-48.20215A8.00076,8.00076,0,0,1,111.835,72H152a8,8,0,0,1,0,16H118.63965L114.542,113.21094A36.413,36.413,0,0,1,123.88184,112.002Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M152,80H111.83477L104,128.20232a27.99935,27.99935,0,1,1,0,39.5969",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M152,80H111.83477L104,128.20232a27.99935,27.99935,0,1,1,0,39.5969",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M152,80H111.83477L104,128.20232a27.99935,27.99935,0,1,1,0,39.5969",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9f = [];
/* style */

const __vue_inject_styles__$9f = undefined;
/* scoped */

const __vue_scope_id__$9f = undefined;
/* module identifier */

const __vue_module_identifier__$9f = undefined;
/* functional template */

const __vue_is_functional_template__$9f = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9f = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9f,
  staticRenderFns: __vue_staticRenderFns__$9f
}, __vue_inject_styles__$9f, __vue_script__$9f, __vue_scope_id__$9f, __vue_is_functional_template__$9f, __vue_module_identifier__$9f, false, undefined, undefined, undefined);

var script$9g = Vue.extend({
  name: "PhNumberSquareFour",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9g = script$9g;
/* template */

var __vue_render__$9g = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "123.998 76 100 144 148 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "148",
      "y1": "111.99435",
      "x2": "148",
      "y2": "175.99435",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "123.998 76 100 144 148 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "148",
      "y1": "112",
      "x2": "148",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,32H48A16.01833,16.01833,0,0,0,32,48V208a16.01833,16.01833,0,0,0,16,16H208a16.01833,16.01833,0,0,0,16-16V48A16.01833,16.01833,0,0,0,208,32ZM156,176a8,8,0,0,1-16,0V152H100a8.00052,8.00052,0,0,1-7.54395-10.6626l23.998-68A8,8,0,0,1,131.542,78.6626L111.30664,136H140V112a8,8,0,0,1,16,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "123.998 76 100 144 148 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "148",
      "y1": "112",
      "x2": "148",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "123.998 76 100 144 148 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "148",
      "y1": "112",
      "x2": "148",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "123.998 76 100 144 148 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "148",
      "y1": "112",
      "x2": "148",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9g = [];
/* style */

const __vue_inject_styles__$9g = undefined;
/* scoped */

const __vue_scope_id__$9g = undefined;
/* module identifier */

const __vue_module_identifier__$9g = undefined;
/* functional template */

const __vue_is_functional_template__$9g = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9g = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9g,
  staticRenderFns: __vue_staticRenderFns__$9g
}, __vue_inject_styles__$9g, __vue_script__$9g, __vue_scope_id__$9g, __vue_is_functional_template__$9g, __vue_module_identifier__$9g, false, undefined, undefined, undefined);

var script$9h = Vue.extend({
  name: "PhNumberSquareNine",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9h = script$9h;
/* template */

var __vue_render__$9h = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "152.24871",
      "y1": "126.00466",
      "x2": "120",
      "y2": "180.00001",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "112",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152.24871",
      "y1": "126.00466",
      "x2": "120",
      "y2": "180.00001",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "112",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M148,112a20,20,0,1,1-20-20A20.02229,20.02229,0,0,1,148,112Zm76-64V208a16.01833,16.01833,0,0,1-16,16H48a16.01833,16.01833,0,0,1-16-16V48A16.01833,16.01833,0,0,1,48,32H208A16.01833,16.01833,0,0,1,224,48Zm-60,64a36,36,0,1,0-36,36q.91626,0,1.82129-.04614l-16.68945,27.9436a8.00015,8.00015,0,1,0,13.73632,8.20508l32.249-53.99512c.09668-.16162.178-.32812.262-.49341A35.76746,35.76746,0,0,0,164,112Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "152.24871",
      "y1": "126.00466",
      "x2": "120",
      "y2": "180.00001",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "112",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "152.24871",
      "y1": "126.00466",
      "x2": "120",
      "y2": "180.00001",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "112",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "152.24871",
      "y1": "126.00466",
      "x2": "120",
      "y2": "180.00001",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "112",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9h = [];
/* style */

const __vue_inject_styles__$9h = undefined;
/* scoped */

const __vue_scope_id__$9h = undefined;
/* module identifier */

const __vue_module_identifier__$9h = undefined;
/* functional template */

const __vue_is_functional_template__$9h = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9h = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9h,
  staticRenderFns: __vue_staticRenderFns__$9h
}, __vue_inject_styles__$9h, __vue_script__$9h, __vue_scope_id__$9h, __vue_is_functional_template__$9h, __vue_module_identifier__$9h, false, undefined, undefined, undefined);

var script$9i = Vue.extend({
  name: "PhNumberSquareOne",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9i = script$9i;
/* template */

var __vue_render__$9i = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "108 99.993 132 84 132 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 99.993 132 84 132 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,32H48A16.02085,16.02085,0,0,0,32,48V208a16.02085,16.02085,0,0,0,16,16H208a16.02085,16.02085,0,0,0,16-16V48A16.02085,16.02085,0,0,0,208,32ZM139.99219,175.99219a8,8,0,0,1-16,0V98.95313l-11.54688,7.69531a7.99982,7.99982,0,1,1-8.875-13.3125l23.98438-15.99219A7.99941,7.99941,0,0,1,139.99219,84Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "108 99.993 132 84 132 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "108 99.993 132 84 132 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "108 99.993 132 84 132 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9i = [];
/* style */

const __vue_inject_styles__$9i = undefined;
/* scoped */

const __vue_scope_id__$9i = undefined;
/* module identifier */

const __vue_module_identifier__$9i = undefined;
/* functional template */

const __vue_is_functional_template__$9i = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9i = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9i,
  staticRenderFns: __vue_staticRenderFns__$9i
}, __vue_inject_styles__$9i, __vue_script__$9i, __vue_scope_id__$9i, __vue_is_functional_template__$9i, __vue_module_identifier__$9i, false, undefined, undefined, undefined);

var script$9j = Vue.extend({
  name: "PhNumberSquareSeven",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9j = script$9j;
/* template */

var __vue_render__$9j = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "104 84 152 84 120 180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "104 84 152 84 120 180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,32H48A16.01833,16.01833,0,0,0,32,48V208a16.01833,16.01833,0,0,0,16,16H208a16.01833,16.01833,0,0,0,16-16V48A16.01833,16.01833,0,0,0,208,32ZM159.58984,86.53027l-32,96a8.0005,8.0005,0,1,1-15.17968-5.06054L140.90039,92H104a8,8,0,0,1,0-16h48a8.00022,8.00022,0,0,1,7.58984,10.53027Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "104 84 152 84 120 180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "104 84 152 84 120 180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "104 84 152 84 120 180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9j = [];
/* style */

const __vue_inject_styles__$9j = undefined;
/* scoped */

const __vue_scope_id__$9j = undefined;
/* module identifier */

const __vue_module_identifier__$9j = undefined;
/* functional template */

const __vue_is_functional_template__$9j = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9j = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9j,
  staticRenderFns: __vue_staticRenderFns__$9j
}, __vue_inject_styles__$9j, __vue_script__$9j, __vue_scope_id__$9j, __vue_is_functional_template__$9j, __vue_module_identifier__$9j, false, undefined, undefined, undefined);

var script$9k = Vue.extend({
  name: "PhNumberSquareSix",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9k = script$9k;
/* template */

var __vue_render__$9k = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "103.75534",
      "y1": "134.00234",
      "x2": "136",
      "y2": "79.99421",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "148",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "103.75534",
      "y1": "134.00234",
      "x2": "136",
      "y2": "79.99421",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "148",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M148,148a20,20,0,1,1-20-20A20.02229,20.02229,0,0,1,148,148ZM224,48V208a16.01833,16.01833,0,0,1-16,16H48a16.01833,16.01833,0,0,1-16-16V48A16.01833,16.01833,0,0,1,48,32H208A16.01833,16.01833,0,0,1,224,48ZM164,148a36.04061,36.04061,0,0,0-36-36q-.91517,0-1.81909.04614l16.68823-27.95141a8,8,0,0,0-13.73828-8.20118L96.88574,129.90137c-.06152.103-.11035.20984-.16675.31445A35.99282,35.99282,0,1,0,164,148Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "103.75534",
      "y1": "134.00234",
      "x2": "136",
      "y2": "79.99421",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "148",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "103.75534",
      "y1": "134.00234",
      "x2": "136",
      "y2": "79.99421",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "148",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "103.75534",
      "y1": "134.00234",
      "x2": "136",
      "y2": "79.99421",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "148",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9k = [];
/* style */

const __vue_inject_styles__$9k = undefined;
/* scoped */

const __vue_scope_id__$9k = undefined;
/* module identifier */

const __vue_module_identifier__$9k = undefined;
/* functional template */

const __vue_is_functional_template__$9k = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9k = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9k,
  staticRenderFns: __vue_staticRenderFns__$9k
}, __vue_inject_styles__$9k, __vue_script__$9k, __vue_scope_id__$9k, __vue_is_functional_template__$9k, __vue_module_identifier__$9k, false, undefined, undefined, undefined);

var script$9l = Vue.extend({
  name: "PhNumberSquareThree",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9l = script$9l;
/* template */

var __vue_render__$9l = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M104,84h47.99366l-27.99,40.00455a27.99773,27.99773,0,1,1-19.79638,47.79511",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,84h47.99366l-27.99,40.00455a27.99773,27.99773,0,1,1-19.79638,47.79511",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,32H48A16.01833,16.01833,0,0,0,32,48V208a16.01833,16.01833,0,0,0,16,16H208a16.01833,16.01833,0,0,0,16-16V48A16.01833,16.01833,0,0,0,208,32ZM149.457,177.45654a35.9963,35.9963,0,0,1-50.90723,0,8.00018,8.00018,0,0,1,11.31446-11.31347,19.99683,19.99683,0,1,0,14.13965-34.13868,7.99971,7.99971,0,0,1-6.55469-12.58642L136.63281,92H104a8,8,0,0,1,0-16h47.99414a7.99973,7.99973,0,0,1,6.55469,12.58643L137.5332,118.62305A36.01783,36.01783,0,0,1,149.457,177.45654Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M104,84h47.99366l-27.99,40.00455a27.99773,27.99773,0,1,1-19.79638,47.79511",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M104,84h47.99366l-27.99,40.00455a27.99773,27.99773,0,1,1-19.79638,47.79511",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M104,84h47.99366l-27.99,40.00455a27.99773,27.99773,0,1,1-19.79638,47.79511",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9l = [];
/* style */

const __vue_inject_styles__$9l = undefined;
/* scoped */

const __vue_scope_id__$9l = undefined;
/* module identifier */

const __vue_module_identifier__$9l = undefined;
/* functional template */

const __vue_is_functional_template__$9l = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9l = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9l,
  staticRenderFns: __vue_staticRenderFns__$9l
}, __vue_inject_styles__$9l, __vue_script__$9l, __vue_scope_id__$9l, __vue_is_functional_template__$9l, __vue_module_identifier__$9l, false, undefined, undefined, undefined);

var script$9m = Vue.extend({
  name: "PhNumberSquareTwo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9m = script$9m;
/* template */

var __vue_render__$9m = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M105.886,94.65812a24.00387,24.00387,0,1,1,42.01514,22.7605v0L104,176v-.00575h48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M105.886,94.65812a24.00387,24.00387,0,1,1,42.01514,22.7605v0L104,176v-.00575h48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,32H48A16.01833,16.01833,0,0,0,32,48V208a16.01833,16.01833,0,0,0,16,16H208a16.01833,16.01833,0,0,0,16-16V48A16.01833,16.01833,0,0,0,208,32ZM152,167.99414a8,8,0,0,1,0,16H104.31738c-.10644.0044-.21191.00635-.31836.00635a8.00251,8.00251,0,0,1-6.30078-12.93164L141.37012,112.793a16.0039,16.0039,0,1,0-28.11621-15.01856A8,8,0,1,1,98.51758,91.542a32.00411,32.00411,0,1,1,56.01269,30.35547c-.07324.10791-.14843.21436-.22754.31836l-34.30566,45.77832Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M105.886,94.65812a24.00387,24.00387,0,1,1,42.01514,22.7605v0L104,176v-.00575h48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M105.886,94.65812a24.00387,24.00387,0,1,1,42.01514,22.7605v0L104,176v-.00575h48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M105.886,94.65812a24.00387,24.00387,0,1,1,42.01514,22.7605v0L104,176v-.00575h48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9m = [];
/* style */

const __vue_inject_styles__$9m = undefined;
/* scoped */

const __vue_scope_id__$9m = undefined;
/* module identifier */

const __vue_module_identifier__$9m = undefined;
/* functional template */

const __vue_is_functional_template__$9m = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9m = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9m,
  staticRenderFns: __vue_staticRenderFns__$9m
}, __vue_inject_styles__$9m, __vue_script__$9m, __vue_scope_id__$9m, __vue_is_functional_template__$9m, __vue_module_identifier__$9m, false, undefined, undefined, undefined);

var script$9n = Vue.extend({
  name: "PhNumberSquareZero",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9n = script$9n;
/* template */

var __vue_render__$9n = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "32",
      "ry": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "32",
      "ry": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "24",
      "ry": "40"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,32H48A16.02085,16.02085,0,0,0,32,48V208a16.02085,16.02085,0,0,0,16,16H208a16.02085,16.02085,0,0,0,16-16V48A16.02085,16.02085,0,0,0,208,32ZM128,184c-27.63281,0-40-28.125-40-56s12.36719-56,40-56,40,28.125,40,56S155.63281,184,128,184Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "32",
      "ry": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "32",
      "ry": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "32",
      "ry": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9n = [];
/* style */

const __vue_inject_styles__$9n = undefined;
/* scoped */

const __vue_scope_id__$9n = undefined;
/* module identifier */

const __vue_module_identifier__$9n = undefined;
/* functional template */

const __vue_is_functional_template__$9n = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9n = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9n,
  staticRenderFns: __vue_staticRenderFns__$9n
}, __vue_inject_styles__$9n, __vue_script__$9n, __vue_scope_id__$9n, __vue_is_functional_template__$9n, __vue_module_identifier__$9n, false, undefined, undefined, undefined);

var script$9o = Vue.extend({
  name: "PhNumberThree",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9o = script$9o;
/* template */

var __vue_render__$9o = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,32h95.98733l-55.97994,80.0091a55.99545,55.99545,0,1,1-39.59275,95.59021",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,32h95.98733l-55.97994,80.0091a55.99545,55.99545,0,1,1-39.59275,95.59021",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M184,168.00488a63.99178,63.99178,0,0,1-109.24219,45.251,8,8,0,0,1,11.31446-11.313,47.994,47.994,0,1,0,33.93554-81.93408,7.99947,7.99947,0,0,1-6.55469-12.58594L160.626,40H80a8,8,0,0,1,0-16h95.9873A7.99946,7.99946,0,0,1,182.542,36.58594l-48.28125,69.00683A64.055,64.055,0,0,1,184,168.00488Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,32h95.98733l-55.97994,80.0091a55.99545,55.99545,0,1,1-39.59275,95.59021",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,32h95.98733l-55.97994,80.0091a55.99545,55.99545,0,1,1-39.59275,95.59021",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,32h95.98733l-55.97994,80.0091a55.99545,55.99545,0,1,1-39.59275,95.59021",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9o = [];
/* style */

const __vue_inject_styles__$9o = undefined;
/* scoped */

const __vue_scope_id__$9o = undefined;
/* module identifier */

const __vue_module_identifier__$9o = undefined;
/* functional template */

const __vue_is_functional_template__$9o = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9o = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9o,
  staticRenderFns: __vue_staticRenderFns__$9o
}, __vue_inject_styles__$9o, __vue_script__$9o, __vue_scope_id__$9o, __vue_is_functional_template__$9o, __vue_module_identifier__$9o, false, undefined, undefined, undefined);

var script$9p = Vue.extend({
  name: "PhNumberTwo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9p = script$9p;
/* template */

var __vue_render__$9p = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M83.77207,61.31625a48.00774,48.00774,0,1,1,84.03029,45.521v0L80,224v-.01149h96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M83.77207,61.31625a48.00774,48.00774,0,1,1,84.03029,45.521v0L80,224v-.01149h96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M184,223.98828a8.00008,8.00008,0,0,1-8,8H80.43555q-.21827.01245-.43653.01221a8.00346,8.00346,0,0,1-6.26757-12.9751l87.54687-116.82178a40.00778,40.00778,0,1,0-70.1377-37.771A8,8,0,1,1,76.4043,58.2002a56.00758,56.00758,0,1,1,98.02734,53.11523c-.07324.1084-.14844.21484-.22754.31934L96.001,215.98828H176A8.00039,8.00039,0,0,1,184,223.98828Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M83.77207,61.31625a48.00774,48.00774,0,1,1,84.03029,45.521v0L80,224v-.01149h96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M83.77207,61.31625a48.00774,48.00774,0,1,1,84.03029,45.521v0L80,224v-.01149h96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M83.77207,61.31625a48.00774,48.00774,0,1,1,84.03029,45.521v0L80,224v-.01149h96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9p = [];
/* style */

const __vue_inject_styles__$9p = undefined;
/* scoped */

const __vue_scope_id__$9p = undefined;
/* module identifier */

const __vue_module_identifier__$9p = undefined;
/* functional template */

const __vue_is_functional_template__$9p = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9p = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9p,
  staticRenderFns: __vue_staticRenderFns__$9p
}, __vue_inject_styles__$9p, __vue_script__$9p, __vue_scope_id__$9p, __vue_is_functional_template__$9p, __vue_module_identifier__$9p, false, undefined, undefined, undefined);

var script$9q = Vue.extend({
  name: "PhNumberZero",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9q = script$9q;
/* template */

var __vue_render__$9q = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "72",
      "ry": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "72",
      "ry": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,240c-25.75977,0-46.99219-12.57129-61.40039-36.35474C54.60547,183.848,48,156.98334,48,128c0-28.98566,6.60547-55.8512,18.59961-75.64771C81.00781,28.57043,102.24023,16,128,16s46.99219,12.57043,61.40039,36.35229C201.39453,72.1488,208,99.01434,208,128c0,28.98334-6.60547,55.848-18.59961,75.64526C174.99219,227.42871,153.75977,240,128,240Zm0-208c-44.21094,0-64,48.2157-64,96s19.78906,96,64,96,64-48.2157,64-96S172.21094,32,128,32Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "72",
      "ry": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "72",
      "ry": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "72",
      "ry": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9q = [];
/* style */

const __vue_inject_styles__$9q = undefined;
/* scoped */

const __vue_scope_id__$9q = undefined;
/* module identifier */

const __vue_module_identifier__$9q = undefined;
/* functional template */

const __vue_is_functional_template__$9q = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9q = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9q,
  staticRenderFns: __vue_staticRenderFns__$9q
}, __vue_inject_styles__$9q, __vue_script__$9q, __vue_scope_id__$9q, __vue_is_functional_template__$9q, __vue_module_identifier__$9q, false, undefined, undefined, undefined);

var script$9r = Vue.extend({
  name: "PhNut",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9r = script$9r;
/* template */

var __vue_render__$9r = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M219.999,175.33228V80.66772a8,8,0,0,0-4.06354-6.9645l-84-47.47826a8,8,0,0,0-7.87291,0l-84,47.47826a8,8,0,0,0-4.06355,6.9645v94.66456a8,8,0,0,0,4.06355,6.96451l84,47.47826a8,8,0,0,0,7.87291,0l84-47.47826A8,8,0,0,0,219.999,175.33228Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "127.99902",
      "cy": "128",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M215.93555,73.70325l-84-47.47815a7.99926,7.99926,0,0,0-7.87305,0l-84,47.47815A8.00029,8.00029,0,0,0,35.999,80.66772v94.66456a8.00065,8.00065,0,0,0,4.06348,6.9646l84,47.47814a7.99987,7.99987,0,0,0,7.87305,0l84-47.47814a8.00064,8.00064,0,0,0,4.06347-6.9646V80.66772A8.00028,8.00028,0,0,0,215.93555,73.70325ZM127.999,164a36,36,0,1,1,36-36A35.99991,35.99991,0,0,1,127.999,164Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M219.999,175.33228V80.66772a8,8,0,0,0-4.06354-6.9645l-84-47.47826a8,8,0,0,0-7.87291,0l-84,47.47826a8,8,0,0,0-4.06355,6.9645v94.66456a8,8,0,0,0,4.06355,6.96451l84,47.47826a8,8,0,0,0,7.87291,0l84-47.47826A8,8,0,0,0,219.999,175.33228Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "127.99902",
      "cy": "128",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M219.87207,66.73877l-84-47.478a16.08529,16.08529,0,0,0-15.74609,0l-84,47.478a16.0253,16.0253,0,0,0-8.127,13.92871v94.665a16.0253,16.0253,0,0,0,8.127,13.92871l84,47.478a16.08113,16.08113,0,0,0,15.74609,0l84-47.478a16.02529,16.02529,0,0,0,8.12695-13.92871v-94.665A16.02529,16.02529,0,0,0,219.87207,66.73877ZM127.999,164a36,36,0,1,1,36-36A36.04074,36.04074,0,0,1,127.999,164Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M219.999,175.33228V80.66772a8,8,0,0,0-4.06354-6.9645l-84-47.47826a8,8,0,0,0-7.87291,0l-84,47.47826a8,8,0,0,0-4.06355,6.9645v94.66456a8,8,0,0,0,4.06355,6.96451l84,47.47826a8,8,0,0,0,7.87291,0l84-47.47826A8,8,0,0,0,219.999,175.33228Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "127.99902",
      "cy": "128",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M219.999,175.33228V80.66772a8,8,0,0,0-4.06354-6.9645l-84-47.47826a8,8,0,0,0-7.87291,0l-84,47.47826a8,8,0,0,0-4.06355,6.9645v94.66456a8,8,0,0,0,4.06355,6.96451l84,47.47826a8,8,0,0,0,7.87291,0l84-47.47826A8,8,0,0,0,219.999,175.33228Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "127.99902",
      "cy": "128",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M220,175.33228V80.66772a8,8,0,0,0-4.06354-6.9645l-84-47.47826a8,8,0,0,0-7.87292,0l-84,47.47826A8,8,0,0,0,36,80.66772v94.66456a8,8,0,0,0,4.06354,6.96451l84,47.47826a8,8,0,0,0,7.87292,0l84-47.47826A8,8,0,0,0,220,175.33228Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9r = [];
/* style */

const __vue_inject_styles__$9r = undefined;
/* scoped */

const __vue_scope_id__$9r = undefined;
/* module identifier */

const __vue_module_identifier__$9r = undefined;
/* functional template */

const __vue_is_functional_template__$9r = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9r = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9r,
  staticRenderFns: __vue_staticRenderFns__$9r
}, __vue_inject_styles__$9r, __vue_script__$9r, __vue_scope_id__$9r, __vue_is_functional_template__$9r, __vue_module_identifier__$9r, false, undefined, undefined, undefined);

var script$9s = Vue.extend({
  name: "PhNyTimesLogo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9s = script$9s;
/* template */

var __vue_render__$9s = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "168",
      "cy": "148",
      "r": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M205.57177,163.35784A80.00853,80.00853,0,1,1,127.92969,64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M67.24858,91.86653A28.00107,28.00107,0,0,1,70,36L186,92a28,28,0,0,0,0-56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48.589 154.315 127.93 112 127.93 224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "91.92969",
      "y1": "131.2",
      "x2": "91.92969",
      "y2": "215.45913",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M95.92964,217.34328a79.7299,79.7299,0,0,0,32,6.65672V112l-32,17.06667h0v88.2765Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "171.92969",
      "cy": "148",
      "r": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M205.57177,163.35784A80.00853,80.00853,0,1,1,127.92969,64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M67.24858,91.86653A28.00107,28.00107,0,0,1,70,36L186,92a28,28,0,0,0,0-56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48.589 154.315 127.93 112 127.93 224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "95.92969",
      "y1": "129.06667",
      "x2": "95.92969",
      "y2": "217.34317",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M183.92969,148a12,12,0,1,1-12-12A12,12,0,0,1,183.92969,148Zm29.40576,17.28711A88.006,88.006,0,0,1,93.26221,224.87793a7.95208,7.95208,0,0,1-1.15674-.50684,88.23576,88.23576,0,0,1-51.48218-69.30615l-.00439-.03857A88.47326,88.47326,0,0,1,39.92969,144a87.47889,87.47889,0,0,1,14.0874-47.707A36.02189,36.02189,0,0,1,70,28a8.00159,8.00159,0,0,1,3.478.79541L187.68457,83.92969A20.0004,20.0004,0,0,0,186,44a8,8,0,0,1,0-16,36,36,0,0,1,0,72,8.00156,8.00156,0,0,1-3.478-.79541L126.25781,72.04248a72.06449,72.06449,0,0,0-70.25952,69.2544L92.0946,122.04541l.053-.02832L124.165,104.94141A8,8,0,0,1,135.92969,112V215.54541a71.8116,71.8116,0,0,0,61.87841-54.11719,7.99984,7.99984,0,1,1,15.52735,3.85889ZM119.92969,125.3335l-16,8.5332v78.00488a71.4173,71.4173,0,0,0,16,3.67334ZM64.36792,83.20215A88.16232,88.16232,0,0,1,101.459,60.0708L68.31543,44.07031a20.00737,20.00737,0,0,0-3.94751,39.13184ZM87.92969,203.833V142.3999L57.43481,158.66406A72.1802,72.1802,0,0,0,87.92969,203.833Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "172",
      "cy": "148",
      "r": "10"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M205.57177,163.35784A80.00853,80.00853,0,1,1,127.92969,64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M67.24858,91.86653A28.00107,28.00107,0,0,1,70,36L186,92a28,28,0,0,0,0-56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48.589 154.315 127.93 112 127.93 224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "95.92969",
      "y1": "129.06667",
      "x2": "95.92969",
      "y2": "217.34317",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "172",
      "cy": "148",
      "r": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M205.57177,163.35784A80.00853,80.00853,0,1,1,127.92969,64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M67.24858,91.86653A28.00107,28.00107,0,0,1,70,36L186,92a28,28,0,0,0,0-56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48.589 154.315 127.93 112 127.93 224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "95.92969",
      "y1": "129.06667",
      "x2": "95.92969",
      "y2": "217.34317",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "171.92969",
      "cy": "148",
      "r": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M205.57177,163.35784A80.00853,80.00853,0,1,1,127.92969,64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M67.24858,91.86653A28.00107,28.00107,0,0,1,70,36L186,92a28,28,0,0,0,0-56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48.589 154.315 127.93 112 127.93 224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "95.92969",
      "y1": "129.06667",
      "x2": "95.92969",
      "y2": "217.34317",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9s = [];
/* style */

const __vue_inject_styles__$9s = undefined;
/* scoped */

const __vue_scope_id__$9s = undefined;
/* module identifier */

const __vue_module_identifier__$9s = undefined;
/* functional template */

const __vue_is_functional_template__$9s = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9s = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9s,
  staticRenderFns: __vue_staticRenderFns__$9s
}, __vue_inject_styles__$9s, __vue_script__$9s, __vue_scope_id__$9s, __vue_is_functional_template__$9s, __vue_module_identifier__$9s, false, undefined, undefined, undefined);

var script$9t = Vue.extend({
  name: "PhOctagon",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9t = script$9t;
/* template */

var __vue_render__$9t = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M164.45079,32H91.54921a8,8,0,0,0-5.65686,2.34315l-51.5492,51.5492A8,8,0,0,0,32,91.54921v72.90158a8,8,0,0,0,2.34315,5.65686l51.5492,51.5492A8,8,0,0,0,91.54921,224h72.90158a8,8,0,0,0,5.65686-2.34315l51.5492-51.5492A8,8,0,0,0,224,164.45079V91.54921a8,8,0,0,0-2.34315-5.65686l-51.5492-51.5492A8,8,0,0,0,164.45079,32Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M164.45079,32H91.54921a8,8,0,0,0-5.65686,2.34315l-51.5492,51.5492A8,8,0,0,0,32,91.54921v72.90158a8,8,0,0,0,2.34315,5.65686l51.5492,51.5492A8,8,0,0,0,91.54921,224h72.90158a8,8,0,0,0,5.65686-2.34315l51.5492-51.5492A8,8,0,0,0,224,164.45079V91.54921a8,8,0,0,0-2.34315-5.65686l-51.5492-51.5492A8,8,0,0,0,164.45079,32Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M164.45079,32H91.54921a8,8,0,0,0-5.65686,2.34315l-51.5492,51.5492A8,8,0,0,0,32,91.54921v72.90158a8,8,0,0,0,2.34315,5.65686l51.5492,51.5492A8,8,0,0,0,91.54921,224h72.90158a8,8,0,0,0,5.65686-2.34315l51.5492-51.5492A8,8,0,0,0,224,164.45079V91.54921a8,8,0,0,0-2.34315-5.65686l-51.5492-51.5492A8,8,0,0,0,164.45079,32Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M227.3125,80.23438,175.76562,28.6875A16.11511,16.11511,0,0,0,164.45312,24H91.54687a16.11515,16.11515,0,0,0-11.3125,4.6875L28.6875,80.23438A16.11511,16.11511,0,0,0,24,91.54688v72.90625a16.11515,16.11515,0,0,0,4.6875,11.3125L80.23437,227.3125A16.11515,16.11515,0,0,0,91.54687,232h72.90625a16.11511,16.11511,0,0,0,11.3125-4.6875l51.54688-51.54687A16.11515,16.11515,0,0,0,232,164.45313V91.54688A16.11511,16.11511,0,0,0,227.3125,80.23438Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M164.45079,32H91.54921a8,8,0,0,0-5.65686,2.34315l-51.5492,51.5492A8,8,0,0,0,32,91.54921v72.90158a8,8,0,0,0,2.34315,5.65686l51.5492,51.5492A8,8,0,0,0,91.54921,224h72.90158a8,8,0,0,0,5.65686-2.34315l51.5492-51.5492A8,8,0,0,0,224,164.45079V91.54921a8,8,0,0,0-2.34315-5.65686l-51.5492-51.5492A8,8,0,0,0,164.45079,32Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M164.45079,32H91.54921a8,8,0,0,0-5.65686,2.34315l-51.5492,51.5492A8,8,0,0,0,32,91.54921v72.90158a8,8,0,0,0,2.34315,5.65686l51.5492,51.5492A8,8,0,0,0,91.54921,224h72.90158a8,8,0,0,0,5.65686-2.34315l51.5492-51.5492A8,8,0,0,0,224,164.45079V91.54921a8,8,0,0,0-2.34315-5.65686l-51.5492-51.5492A8,8,0,0,0,164.45079,32Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M164.45079,32H91.54921a8,8,0,0,0-5.65686,2.34315l-51.5492,51.5492A8,8,0,0,0,32,91.54921v72.90158a8,8,0,0,0,2.34315,5.65686l51.5492,51.5492A8,8,0,0,0,91.54921,224h72.90158a8,8,0,0,0,5.65686-2.34315l51.5492-51.5492A8,8,0,0,0,224,164.45079V91.54921a8,8,0,0,0-2.34315-5.65686l-51.5492-51.5492A8,8,0,0,0,164.45079,32Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9t = [];
/* style */

const __vue_inject_styles__$9t = undefined;
/* scoped */

const __vue_scope_id__$9t = undefined;
/* module identifier */

const __vue_module_identifier__$9t = undefined;
/* functional template */

const __vue_is_functional_template__$9t = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9t = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9t,
  staticRenderFns: __vue_staticRenderFns__$9t
}, __vue_inject_styles__$9t, __vue_script__$9t, __vue_scope_id__$9t, __vue_is_functional_template__$9t, __vue_module_identifier__$9t, false, undefined, undefined, undefined);

var script$9u = Vue.extend({
  name: "PhPackage",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9u = script$9u;
/* template */

var __vue_render__$9u = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,177.32122V78.67878a8,8,0,0,0-4.07791-6.9726l-88-49.5a8,8,0,0,0-7.84418,0l-88,49.5A8,8,0,0,0,32,78.67878v98.64244a8,8,0,0,0,4.07791,6.9726l88,49.5a8,8,0,0,0,7.84418,0l88-49.5A8,8,0,0,0,224,177.32122Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "177.022 152.511 177.022 100.511 80 47",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "222.897 74.627 128.949 128 33.108 74.617",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128.94915",
      "y1": "128",
      "x2": "128.01036",
      "y2": "234.82131",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M33.10781,74.617A7.99475,7.99475,0,0,0,32,78.67878v98.64244a8,8,0,0,0,4.07791,6.9726l88,49.5A7.99528,7.99528,0,0,0,128,234.82122l.01036.00009L128.94915,128,33.108,74.61714Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,177.32122V78.67878a8,8,0,0,0-4.07791-6.9726l-88-49.5a8,8,0,0,0-7.84418,0l-88,49.5A8,8,0,0,0,32,78.67878v98.64244a8,8,0,0,0,4.07791,6.9726l88,49.5a8,8,0,0,0,7.84418,0l88-49.5A8,8,0,0,0,224,177.32122Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "177.022 152.511 177.022 100.511 80 47",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "222.897 74.627 128.949 128 33.108 74.617",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128.94915",
      "y1": "128",
      "x2": "128.01036",
      "y2": "234.82131",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M229.927,70.82178c-.02612-.04883-.04639-.09864-.07373-.147-.01172-.0205-.02612-.03906-.03809-.05957a15.98449,15.98449,0,0,0-5.97168-5.88183l-87.999-49.5a16.09525,16.09525,0,0,0-15.68848,0L32.155,64.73389A15.99355,15.99355,0,0,0,26.168,70.646c-.01539.02685-.03394.05127-.04908.07861-.02441.04346-.042.08887-.06543.13281a15.9818,15.9818,0,0,0-2.05371,7.82129v98.64258A16.02109,16.02109,0,0,0,32.156,191.2666l88.001,49.50049a15.97809,15.97809,0,0,0,7.23486,2.02148c.18189.01416.363.03077.54834.03272h.07227c.25195,0,.50049-.01465.74658-.0376a15.95877,15.95877,0,0,0,7.08447-2.01709l88-49.5a16.01817,16.01817,0,0,0,8.15625-13.94531V78.67871A15.98036,15.98036,0,0,0,229.927,70.82178ZM127.99975,29.17871l79.74366,44.856-30.62061,17.396L96.43969,46.93115Zm.91016,89.64258L48.37866,73.96582,80.03833,56.15723l80.76513,44.54492Zm7.21167,103.43164.78686-89.57373,32.11377-18.24463v38.07617a8,8,0,0,0,16,0v-47.166l30.97754-17.59864v89.5752Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,177.32122V78.67878a8,8,0,0,0-4.07791-6.9726l-88-49.5a8,8,0,0,0-7.84418,0l-88,49.5A8,8,0,0,0,32,78.67878v98.64244a8,8,0,0,0,4.07791,6.9726l88,49.5a8,8,0,0,0,7.84418,0l88-49.5A8,8,0,0,0,224,177.32122Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "177.022 152.511 177.022 100.511 80 47",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "222.897 74.627 128.949 128 33.108 74.617",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128.94915",
      "y1": "128",
      "x2": "128.01036",
      "y2": "234.82131",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,177.32122V78.67878a8,8,0,0,0-4.07791-6.9726l-88-49.5a8,8,0,0,0-7.84418,0l-88,49.5A8,8,0,0,0,32,78.67878v98.64244a8,8,0,0,0,4.07791,6.9726l88,49.5a8,8,0,0,0,7.84418,0l88-49.5A8,8,0,0,0,224,177.32122Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "177.022 152.511 177.022 100.511 80 47",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "222.897 74.627 128.949 128 33.108 74.617",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128.94915",
      "y1": "128",
      "x2": "128.01036",
      "y2": "234.82131",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,177.32122V78.67878a8,8,0,0,0-4.07791-6.9726l-88-49.5a8,8,0,0,0-7.84418,0l-88,49.5A8,8,0,0,0,32,78.67878v98.64244a8,8,0,0,0,4.07791,6.9726l88,49.5a8,8,0,0,0,7.84418,0l88-49.5A8,8,0,0,0,224,177.32122Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "177.022 152.511 177.022 100.511 80 47",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "222.897 74.627 128.949 128 33.108 74.617",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128.94915",
      "y1": "128",
      "x2": "128.01036",
      "y2": "234.82131",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9u = [];
/* style */

const __vue_inject_styles__$9u = undefined;
/* scoped */

const __vue_scope_id__$9u = undefined;
/* module identifier */

const __vue_module_identifier__$9u = undefined;
/* functional template */

const __vue_is_functional_template__$9u = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9u = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9u,
  staticRenderFns: __vue_staticRenderFns__$9u
}, __vue_inject_styles__$9u, __vue_script__$9u, __vue_scope_id__$9u, __vue_is_functional_template__$9u, __vue_module_identifier__$9u, false, undefined, undefined, undefined);

var script$9v = Vue.extend({
  name: "PhPaintBrush",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9v = script$9v;
/* template */

var __vue_render__$9v = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M20,216H92a52,52,0,1,0-52-52C40,200,20,216,20,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112.40713,116.15918c19.194-25.86782,68.02669-85.12974,112.56343-85.12974,0,44.53626-59.26065,93.36835-85.12891,112.56282",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M138.41669,84.55047a92.45653,92.45653,0,0,1,33.01749,33.00663",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M132.96191,90.647A84.40614,84.40614,0,0,1,165.353,123.03809C192.66992,99.12988,224.9707,63.91016,224.9707,31.0293,192.08984,31.0293,156.87012,63.33008,132.96191,90.647Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M20,216H92a52,52,0,1,0-52-52C40,200,20,216,20,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112.40713,116.15918c19.194-25.86782,68.02669-85.12974,112.56343-85.12974,0,44.53626-59.26065,93.36835-85.12891,112.56282",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M132.9608,90.6464a84.40058,84.40058,0,0,1,32.3928,32.3928",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224.9707,23.0293c-21.30468,0-45.23242,11.74316-71.11914,34.90234-18.04687,16.146-33.54394,34.64258-44.27978,48.69922A59.99965,59.99965,0,0,0,32,164c0,31.21094-16.23926,45.12109-17.041,45.78809A8,8,0,0,0,20,224H92a60.00007,60.00007,0,0,0,57.36914-77.57227c14.05664-10.73535,32.55371-26.23193,48.7002-44.28027C221.22852,76.26172,232.9707,52.334,232.9707,31.0293A8.00039,8.00039,0,0,0,224.9707,23.0293ZM124.44189,113.56689c2.8628-3.66259,6.29053-7.91308,10.1753-12.49218a76.22114,76.22114,0,0,1,20.3081,20.3081c-4.5791,3.88477-8.82959,7.3125-12.49267,10.1753A60.4544,60.4544,0,0,0,124.44189,113.56689Zm42.54883-2.86718a92.19891,92.19891,0,0,0-21.69043-21.69043c19.60987-21.18408,45.98389-44.37354,70.79834-49.10791C211.36426,64.71631,188.1748,91.08984,166.99072,110.69971Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M20,216H92a52,52,0,1,0-52-52C40,200,20,216,20,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112.40713,116.15918c19.194-25.86782,68.02669-85.12974,112.56343-85.12974,0,44.53626-59.26065,93.36835-85.12891,112.56282",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M132.9608,90.6464a84.40058,84.40058,0,0,1,32.3928,32.3928",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M20,216H92a52,52,0,1,0-52-52C40,200,20,216,20,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112.40713,116.15918c19.194-25.86782,68.02669-85.12974,112.56343-85.12974,0,44.53626-59.26065,93.36835-85.12891,112.56282",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M132.9608,90.6464a84.40058,84.40058,0,0,1,32.3928,32.3928",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M20,216H92a52,52,0,1,0-52-52C40,200,20,216,20,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112.40713,116.15918c19.194-25.86782,68.02669-85.12974,112.56343-85.12974,0,44.53626-59.26065,93.36835-85.12891,112.56282",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M132.9608,90.6464a84.40058,84.40058,0,0,1,32.3928,32.3928",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9v = [];
/* style */

const __vue_inject_styles__$9v = undefined;
/* scoped */

const __vue_scope_id__$9v = undefined;
/* module identifier */

const __vue_module_identifier__$9v = undefined;
/* functional template */

const __vue_is_functional_template__$9v = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9v = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9v,
  staticRenderFns: __vue_staticRenderFns__$9v
}, __vue_inject_styles__$9v, __vue_script__$9v, __vue_scope_id__$9v, __vue_is_functional_template__$9v, __vue_module_identifier__$9v, false, undefined, undefined, undefined);

var script$9w = Vue.extend({
  name: "PhPaintBrushBroad",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9w = script$9w;
/* template */

var __vue_render__$9w = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "112",
      "x2": "216",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "32",
      "x2": "176",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M156.59181,152H200a16,16,0,0,0,16-16V32H72A32,32,0,0,0,40,64v72a16,16,0,0,0,16,16H99.40819a8,8,0,0,1,7.97967,8.57L104,208a24,24,0,0,0,48,0l-3.38786-47.43A8,8,0,0,1,156.59181,152Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,112H216v24a16,16,0,0,1-16,16H153.2241a8,8,0,0,0-7.9196,9.13137L152,208a24,24,0,0,1-48,0l6.69555-46.86862A8,8,0,0,0,102.776,152H56a16,16,0,0,1-16-16Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "112",
      "x2": "216",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M102.776,152H56a16,16,0,0,1-16-16V64A32,32,0,0,1,72,32H216V136a16,16,0,0,1-16,16H153.2241a8,8,0,0,0-7.9196,9.13137L152,208a24,24,0,0,1-48,0l6.69555-46.86862A8,8,0,0,0,102.776,152Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "32",
      "x2": "184",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,24H72A40.04552,40.04552,0,0,0,32,64v72a24.0275,24.0275,0,0,0,24,24h46.77588l-6.69531,46.86816A7.97979,7.97979,0,0,0,96,208a32,32,0,0,0,64,0,7.97979,7.97979,0,0,0-.08057-1.13184L153.22412,160H200a24.0275,24.0275,0,0,0,24-24V32A8.00008,8.00008,0,0,0,216,24ZM72,40H176V80a8,8,0,0,0,16,0V40h16v64H48V64A24.0275,24.0275,0,0,1,72,40Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "112",
      "x2": "216",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M102.776,152H56a16,16,0,0,1-16-16V64A32,32,0,0,1,72,32H216V136a16,16,0,0,1-16,16H153.2241a8,8,0,0,0-7.9196,9.13137L152,208a24,24,0,0,1-48,0l6.69555-46.86862A8,8,0,0,0,102.776,152Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "32",
      "x2": "184",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "112",
      "x2": "216",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M102.776,152H56a16,16,0,0,1-16-16V64A32,32,0,0,1,72,32H216V136a16,16,0,0,1-16,16H153.2241a8,8,0,0,0-7.9196,9.13137L152,208a24,24,0,0,1-48,0l6.69555-46.86862A8,8,0,0,0,102.776,152Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "32",
      "x2": "184",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "112",
      "x2": "216",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M102.776,152H56a16,16,0,0,1-16-16V64A32,32,0,0,1,72,32H216V136a16,16,0,0,1-16,16H153.2241a8,8,0,0,0-7.9196,9.13137L152,208a24,24,0,0,1-48,0l6.69555-46.86862A8,8,0,0,0,102.776,152Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "32",
      "x2": "184",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9w = [];
/* style */

const __vue_inject_styles__$9w = undefined;
/* scoped */

const __vue_scope_id__$9w = undefined;
/* module identifier */

const __vue_module_identifier__$9w = undefined;
/* functional template */

const __vue_is_functional_template__$9w = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9w = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9w,
  staticRenderFns: __vue_staticRenderFns__$9w
}, __vue_inject_styles__$9w, __vue_script__$9w, __vue_scope_id__$9w, __vue_is_functional_template__$9w, __vue_module_identifier__$9w, false, undefined, undefined, undefined);

var script$9x = Vue.extend({
  name: "PhPaintBrushHousehold",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9x = script$9x;
/* template */

var __vue_render__$9x = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "72",
      "y1": "104",
      "x2": "151.99999",
      "y2": "183.99999",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "188",
      "x2": "70.56478",
      "y2": "214.56478",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "68",
      "y1": "160",
      "x2": "42.56478",
      "y2": "186.56478",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M136.12716,92.20308l54.90228-61.17364a24,24,0,1,1,33.94112,33.94112l-61.17364,54.90228a8,8,0,0,0-.31342,11.61065l9.20279,9.2028a16,16,0,0,1,0,22.62742L96,240,16,160,92.68629,83.31371a16,16,0,0,1,22.62742,0l9.2028,9.2028A8,8,0,0,0,136.12716,92.20308Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.68629,83.31371a16,16,0,0,1,22.62742,0l9.2028,9.2028a8,8,0,0,0,11.61065-.31343l54.90228-61.17364a24,24,0,1,1,33.94112,33.94112l-61.17364,54.90228a8,8,0,0,0-.31342,11.61065l9.2028,9.20281a16,16,0,0,1,0,22.62741L152,184,72,104Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "104",
      "x2": "151.99999",
      "y2": "183.99999",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "101.75578",
      "y1": "183.37379",
      "x2": "70.56478",
      "y2": "214.56478",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "73.75578",
      "y1": "155.37379",
      "x2": "42.56478",
      "y2": "186.56478",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M136.12716,92.20308l54.90228-61.17364a24,24,0,1,1,33.94112,33.94112l-61.17364,54.90228a8,8,0,0,0-.31342,11.61065l9.20279,9.2028a16,16,0,0,1,0,22.62742L96,240,16,160,92.68629,83.31371a16,16,0,0,1,22.62742,0l9.2028,9.2028A8,8,0,0,0,136.12716,92.20308Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M230.627,25.37207a32.03909,32.03909,0,0,0-45.2539,0c-.10254.10156-.20117.207-.29785.31348L130.17383,86.85938l-9.20313-9.20313a24.00066,24.00066,0,0,0-33.9414,0L10.34277,154.34277a8.00122,8.00122,0,0,0,0,11.31446l80,80a8.00181,8.00181,0,0,0,11.31446,0l76.68652-76.68653a24.00066,24.00066,0,0,0,0-33.9414l-9.20313-9.20215L230.31445,70.9248c.10645-.09668.21192-.19531.31348-.29785A32.03761,32.03761,0,0,0,230.627,25.37207ZM96,228.68652,81.87842,214.56494l25.53467-25.53369A8.00053,8.00053,0,0,0,96.09863,177.7168L70.564,203.25049,53.87842,186.56494l25.53467-25.53369A8.00053,8.00053,0,0,0,68.09863,149.7168L42.564,175.25049,27.31348,160,72,115.31445,140.68555,184Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "72",
      "y1": "104",
      "x2": "151.99999",
      "y2": "183.99999",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "101.75578",
      "y1": "183.37379",
      "x2": "70.56478",
      "y2": "214.56478",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "73.75578",
      "y1": "155.37379",
      "x2": "42.56478",
      "y2": "186.56478",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M136.12716,92.20308l54.90228-61.17364a24,24,0,1,1,33.94112,33.94112l-61.17364,54.90228a8,8,0,0,0-.31342,11.61065l9.20279,9.2028a16,16,0,0,1,0,22.62742L96,240,16,160,92.68629,83.31371a16,16,0,0,1,22.62742,0l9.2028,9.2028A8,8,0,0,0,136.12716,92.20308Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "72",
      "y1": "104",
      "x2": "151.99999",
      "y2": "183.99999",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "101.75578",
      "y1": "183.37379",
      "x2": "70.56478",
      "y2": "214.56478",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "73.75578",
      "y1": "155.37379",
      "x2": "42.56478",
      "y2": "186.56478",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M136.12716,92.20308l54.90228-61.17364a24,24,0,1,1,33.94112,33.94112l-61.17364,54.90228a8,8,0,0,0-.31342,11.61065l9.20279,9.2028a16,16,0,0,1,0,22.62742L96,240,16,160,92.68629,83.31371a16,16,0,0,1,22.62742,0l9.2028,9.2028A8,8,0,0,0,136.12716,92.20308Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "72",
      "y1": "104",
      "x2": "151.99999",
      "y2": "183.99999",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "101.75578",
      "y1": "183.37379",
      "x2": "70.56478",
      "y2": "214.56478",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "73.75578",
      "y1": "155.37379",
      "x2": "42.56478",
      "y2": "186.56478",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M136.12716,92.20308l54.90228-61.17364a24,24,0,1,1,33.94112,33.94112l-61.17364,54.90228a8,8,0,0,0-.31342,11.61065l9.20279,9.2028a16,16,0,0,1,0,22.62742L96,240,16,160,92.68629,83.31371a16,16,0,0,1,22.62742,0l9.2028,9.2028A8,8,0,0,0,136.12716,92.20308Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9x = [];
/* style */

const __vue_inject_styles__$9x = undefined;
/* scoped */

const __vue_scope_id__$9x = undefined;
/* module identifier */

const __vue_module_identifier__$9x = undefined;
/* functional template */

const __vue_is_functional_template__$9x = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9x = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9x,
  staticRenderFns: __vue_staticRenderFns__$9x
}, __vue_inject_styles__$9x, __vue_script__$9x, __vue_scope_id__$9x, __vue_is_functional_template__$9x, __vue_module_identifier__$9x, false, undefined, undefined, undefined);

var script$9y = Vue.extend({
  name: "PhPaintBucket",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9y = script$9y;
/* template */

var __vue_render__$9y = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M222.9646,123.48437,126.79808,219.6509a16,16,0,0,1-22.62741,0l-84.857-84.857a16,16,0,0,1,0-22.62742L115.48023,16Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "124",
      "cy": "116",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M204,216c0-19.99414,20-40,20-40s20,20.00586,20,40a20,20,0,0,1-40,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "107.02944",
      "y1": "99.02944",
      "x2": "37.85786",
      "y2": "29.86372",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "124",
      "cy": "116.00586",
      "r": "20",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,204c0-19.99414,20-40,20-40s20,20.00586,20,40a20,20,0,0,1-40,0Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M222.9646,123.48437,126.79808,219.6509a16,16,0,0,1-22.62741,0l-84.857-84.857a16,16,0,0,1,0-22.62742L115.48023,16Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "124",
      "cy": "116.00586",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,204c0-19.99414,20-40,20-40s20,20.00586,20,40a20,20,0,0,1-40,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "109.85786",
      "y1": "101.86372",
      "x2": "37.85786",
      "y2": "29.86372",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M256,204a28,28,0,0,1-56,0c0-23.042,21.42969-44.74365,22.34277-45.65625a7.99945,7.99945,0,0,1,11.31446,0C234.57031,159.25635,256,180.958,256,204ZM132.48535,124.49121a12.0001,12.0001,0,1,0-16.9707.00049A12.01451,12.01451,0,0,0,132.48535,124.49121Zm98.47949-1.00684a8.00033,8.00033,0,0,0-2.34277-5.65673L121.1377,10.34326a8.00122,8.00122,0,0,0-11.31446,0L69.73682,50.4292l40.949,40.949a27.99954,27.99954,0,1,1-11.31421,11.31372L58.42285,61.74316l-44.7666,44.76661a24.029,24.029,0,0,0,0,33.94091l84.85742,84.85694a23.99952,23.99952,0,0,0,33.94141,0l96.167-96.16651A8.00034,8.00034,0,0,0,230.96484,123.48437ZM43.51465,24.207A8.00018,8.00018,0,0,0,32.2002,35.52051L58.42285,61.74316l11.314-11.314Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M222.9646,123.48437,126.79808,219.6509a16,16,0,0,1-22.62741,0l-84.857-84.857a16,16,0,0,1,0-22.62742L115.48023,16Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "124",
      "cy": "116.00586",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,204c0-19.99414,20-40,20-40s20,20.00586,20,40a20,20,0,0,1-40,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "109.85786",
      "y1": "101.86372",
      "x2": "37.85786",
      "y2": "29.86372",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M222.9646,123.48437,126.79808,219.6509a16,16,0,0,1-22.62741,0l-84.857-84.857a16,16,0,0,1,0-22.62742L115.48023,16Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "124",
      "cy": "116.00586",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,204c0-19.99414,20-40,20-40s20,20.00586,20,40a20,20,0,0,1-40,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "109.85786",
      "y1": "101.86372",
      "x2": "37.85786",
      "y2": "29.86372",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M222.9646,123.48437,126.79808,219.6509a16,16,0,0,1-22.62741,0l-84.857-84.857a16,16,0,0,1,0-22.62742L115.48023,16Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "124",
      "cy": "116.00586",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,204c0-19.99414,20-40,20-40s20,20.00586,20,40a20,20,0,0,1-40,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "109.85786",
      "y1": "101.86372",
      "x2": "37.85786",
      "y2": "29.86372",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9y = [];
/* style */

const __vue_inject_styles__$9y = undefined;
/* scoped */

const __vue_scope_id__$9y = undefined;
/* module identifier */

const __vue_module_identifier__$9y = undefined;
/* functional template */

const __vue_is_functional_template__$9y = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9y = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9y,
  staticRenderFns: __vue_staticRenderFns__$9y
}, __vue_inject_styles__$9y, __vue_script__$9y, __vue_scope_id__$9y, __vue_is_functional_template__$9y, __vue_module_identifier__$9y, false, undefined, undefined, undefined);

var script$9z = Vue.extend({
  name: "PhPaintRoller",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9z = script$9z;
/* template */

var __vue_render__$9z = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "44",
      "y": "56",
      "width": "160",
      "height": "80",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M204,96h28a8,8,0,0,1,8,8v49.96559a8,8,0,0,1-5.80223,7.69219L133.80223,190.34222A8,8,0,0,0,128,198.03441V232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "44",
      "y1": "96",
      "x2": "16",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "56",
      "width": "168",
      "height": "80",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "56",
      "width": "168",
      "height": "80",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,96h24a8,8,0,0,1,8,8v49.96559a8,8,0,0,1-5.80223,7.69219L133.80223,190.34222A8,8,0,0,0,128,198.03441V232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "96",
      "x2": "16",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M248,104v49.96582a16.06941,16.06941,0,0,1-11.60352,15.38477L135.999,198.03418,136,232a8,8,0,0,1-16,0V198.03418a16.06941,16.06941,0,0,1,11.60352-15.38477L232.001,153.96582,232,104H216v24a16.01833,16.01833,0,0,1-16,16H48a16.01833,16.01833,0,0,1-16-16V104H16a8,8,0,0,1,0-16H32V64A16.01833,16.01833,0,0,1,48,48H200a16.01833,16.01833,0,0,1,16,16V88h16A16.01833,16.01833,0,0,1,248,104Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "56",
      "width": "168",
      "height": "80",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,96h24a8,8,0,0,1,8,8v49.96559a8,8,0,0,1-5.80223,7.69219L133.80223,190.34222A8,8,0,0,0,128,198.03441V232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "96",
      "x2": "16",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "56",
      "width": "168",
      "height": "80",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,96h24a8,8,0,0,1,8,8v49.96559a8,8,0,0,1-5.80223,7.69219L133.80223,190.34222A8,8,0,0,0,128,198.03441V232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "96",
      "x2": "16",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "56",
      "width": "168",
      "height": "80",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,96h24a8,8,0,0,1,8,8v49.96559a8,8,0,0,1-5.80223,7.69219L133.80223,190.34222A8,8,0,0,0,128,198.03441V232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "96",
      "x2": "16",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9z = [];
/* style */

const __vue_inject_styles__$9z = undefined;
/* scoped */

const __vue_scope_id__$9z = undefined;
/* module identifier */

const __vue_module_identifier__$9z = undefined;
/* functional template */

const __vue_is_functional_template__$9z = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9z = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9z,
  staticRenderFns: __vue_staticRenderFns__$9z
}, __vue_inject_styles__$9z, __vue_script__$9z, __vue_scope_id__$9z, __vue_is_functional_template__$9z, __vue_module_identifier__$9z, false, undefined, undefined, undefined);

var script$9A = Vue.extend({
  name: "PhPalette",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9A = script$9A;
/* template */

var __vue_render__$9A = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M221.61367,149.35463a96.28545,96.28545,0,0,0,2.38287-22.17837c-.44383-52.82934-44.1551-95.70346-96.98364-95.17129a96.01642,96.01642,0,0,0-30.989,186.54089A24.002,24.002,0,0,0,128,195.90236V192a24,24,0,0,1,24-24h46.20931A23.99131,23.99131,0,0,0,221.61367,149.35463Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "76",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "82.96668",
      "cy": "102",
      "r": "15.99733"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "82.96668",
      "cy": "154",
      "r": "15.99733"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "173.03332",
      "cy": "102",
      "r": "15.99733"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M221.61367,149.35463a96.28545,96.28545,0,0,0,2.38287-22.17837c-.44383-52.82934-44.1551-95.70346-96.98364-95.17129a96.01642,96.01642,0,0,0-30.989,186.54089A24.002,24.002,0,0,0,128,195.90236V192a24,24,0,0,1,24-24h46.20931A23.99131,23.99131,0,0,0,221.61367,149.35463Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M221.61367,149.35463a96.28545,96.28545,0,0,0,2.38287-22.17837c-.44383-52.82934-44.1551-95.70346-96.98364-95.17129a96.01642,96.01642,0,0,0-30.989,186.54089A24.002,24.002,0,0,0,128,195.90236V192a24,24,0,0,1,24-24h46.20931A23.99131,23.99131,0,0,0,221.61367,149.35463Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "76",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "82.96668",
      "cy": "102",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "82.96668",
      "cy": "154",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "173.03332",
      "cy": "102",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200.772,53.88965A103.28,103.28,0,0,0,127.99756,24q-.53247,0-1.06543.00488a104.01647,104.01647,0,0,0-33.57227,202.084A32.00105,32.00105,0,0,0,136,195.90234V192a16.01833,16.01833,0,0,1,16-16h46.20947a31.81973,31.81973,0,0,0,31.20508-24.87207,104.49414,104.49414,0,0,0,2.58154-24.01953A103.2063,103.2063,0,0,0,200.772,53.88965ZM88.96667,164.39209A12,12,0,1,1,93.359,148,11.99983,11.99983,0,0,1,88.96667,164.39209ZM93.359,108a12,12,0,1,1-4.39234-16.39258A12,12,0,0,1,93.359,108ZM128,88a12,12,0,1,1,12-12A12,12,0,0,1,128,88Zm51.03333,24.39209A12,12,0,1,1,183.42566,96,11.99981,11.99981,0,0,1,179.03333,112.39209Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M221.61367,149.35463a96.28545,96.28545,0,0,0,2.38287-22.17837c-.44383-52.82934-44.1551-95.70346-96.98364-95.17129a96.01642,96.01642,0,0,0-30.989,186.54089A24.002,24.002,0,0,0,128,195.90236V192a24,24,0,0,1,24-24h46.20931A23.99131,23.99131,0,0,0,221.61367,149.35463Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "76",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "82.96668",
      "cy": "102",
      "r": "9.99833"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "82.96668",
      "cy": "154",
      "r": "9.99833"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "173.03332",
      "cy": "102",
      "r": "9.99833"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M221.61367,149.35463a96.28545,96.28545,0,0,0,2.38287-22.17837c-.44383-52.82934-44.1551-95.70346-96.98364-95.17129a96.01642,96.01642,0,0,0-30.989,186.54089A24.002,24.002,0,0,0,128,195.90236V192a24,24,0,0,1,24-24h46.20931A23.99131,23.99131,0,0,0,221.61367,149.35463Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "76",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "82.9667",
      "cy": "102",
      "r": "7.99867"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "82.9667",
      "cy": "154",
      "r": "7.99866"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "173.0333",
      "cy": "102",
      "r": "7.99866"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M221.61367,149.35463a96.28545,96.28545,0,0,0,2.38287-22.17837c-.44383-52.82934-44.1551-95.70346-96.98364-95.17129a96.01642,96.01642,0,0,0-30.989,186.54089A24.002,24.002,0,0,0,128,195.90236V192a24,24,0,0,1,24-24h46.20931A23.99131,23.99131,0,0,0,221.61367,149.35463Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "76",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "82.96668",
      "cy": "102",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "82.96668",
      "cy": "154",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "173.03332",
      "cy": "102",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9A = [];
/* style */

const __vue_inject_styles__$9A = undefined;
/* scoped */

const __vue_scope_id__$9A = undefined;
/* module identifier */

const __vue_module_identifier__$9A = undefined;
/* functional template */

const __vue_is_functional_template__$9A = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9A = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9A,
  staticRenderFns: __vue_staticRenderFns__$9A
}, __vue_inject_styles__$9A, __vue_script__$9A, __vue_scope_id__$9A, __vue_is_functional_template__$9A, __vue_module_identifier__$9A, false, undefined, undefined, undefined);

var script$9B = Vue.extend({
  name: "PhPaperPlane",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9B = script$9B;
/* template */

var __vue_render__$9B = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M120.90154,36.46437,26.30921,205.37925A8,8,0,0,0,35.98,216.822l89.211-31.86106a8,8,0,0,1,5.38138,0l89.211,31.86106a8,8,0,0,0,9.67074-11.44277L134.86164,36.46437A8,8,0,0,0,120.90154,36.46437Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "127.88159",
      "y1": "184",
      "x2": "127.88159",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M120.90154,36.46437,26.30921,205.37925A8,8,0,0,0,35.98,216.822l89.211-31.86106a8,8,0,0,1,5.38138,0l89.211,31.86106a8,8,0,0,0,9.67074-11.44277L134.86164,36.46437A8,8,0,0,0,120.90154,36.46437Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M120.90154,36.46437,26.30921,205.37925A8,8,0,0,0,35.98,216.822l89.211-31.86106a8,8,0,0,1,5.38138,0l89.211,31.86106a8,8,0,0,0,9.67074-11.44277L134.86164,36.46437A8,8,0,0,0,120.90154,36.46437Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "127.88159",
      "y1": "184",
      "x2": "127.88159",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M236.43432,201.4707l-94.59179-168.915a16.00119,16.00119,0,0,0-27.92188,0L19.32885,201.47021A16.00042,16.00042,0,0,0,38.67065,224.356l81.21094-29.00391V120a8,8,0,1,1,16,0v75.352L217.09253,224.356a16.171,16.171,0,0,0,5.44531.95117,16.02221,16.02221,0,0,0,13.89648-23.83643Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M120.90154,36.46437,26.30921,205.37925A8,8,0,0,0,35.98,216.822l89.211-31.86106a8,8,0,0,1,5.38138,0l89.211,31.86106a8,8,0,0,0,9.67074-11.44277L134.86164,36.46437A8,8,0,0,0,120.90154,36.46437Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "127.88159",
      "y1": "184",
      "x2": "127.88159",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M120.90154,36.46437,26.30921,205.37925A8,8,0,0,0,35.98,216.822l89.211-31.86106a8,8,0,0,1,5.38138,0l89.211,31.86106a8,8,0,0,0,9.67074-11.44277L134.86164,36.46437A8,8,0,0,0,120.90154,36.46437Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "127.88159",
      "y1": "184",
      "x2": "127.88159",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M120.90154,36.46437,26.30921,205.37925A8,8,0,0,0,35.98,216.822l89.211-31.86106a8,8,0,0,1,5.38138,0l89.211,31.86106a8,8,0,0,0,9.67074-11.44277L134.86164,36.46437A8,8,0,0,0,120.90154,36.46437Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "127.88159",
      "y1": "184",
      "x2": "127.88159",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9B = [];
/* style */

const __vue_inject_styles__$9B = undefined;
/* scoped */

const __vue_scope_id__$9B = undefined;
/* module identifier */

const __vue_module_identifier__$9B = undefined;
/* functional template */

const __vue_is_functional_template__$9B = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9B = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9B,
  staticRenderFns: __vue_staticRenderFns__$9B
}, __vue_inject_styles__$9B, __vue_script__$9B, __vue_scope_id__$9B, __vue_is_functional_template__$9B, __vue_module_identifier__$9B, false, undefined, undefined, undefined);

var script$9C = Vue.extend({
  name: "PhPaperPlaneRight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9C = script$9C;
/* template */

var __vue_render__$9C = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M219.53563,121.02,50.62075,26.42762A8,8,0,0,0,39.178,36.09836l31.86106,89.211a8,8,0,0,1,0,5.38138L39.178,219.90164a8,8,0,0,0,11.44277,9.67074l168.91488-94.59233A8,8,0,0,0,219.53563,121.02Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "128",
      "x2": "136",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M219.53563,121.02,50.62075,26.42762A8,8,0,0,0,39.178,36.09836l31.86106,89.211a8,8,0,0,1,0,5.38138L39.178,219.90164a8,8,0,0,0,11.44277,9.67074l168.91488-94.59233A8,8,0,0,0,219.53563,121.02Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M219.53563,121.02,50.62075,26.42762A8,8,0,0,0,39.178,36.09836l31.86106,89.211a8,8,0,0,1,0,5.38138L39.178,219.90164a8,8,0,0,0,11.44277,9.67074l168.91488-94.59233A8,8,0,0,0,219.53563,121.02Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "128",
      "x2": "136",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M223.44434,114.03906,54.5293,19.44727A16.00042,16.00042,0,0,0,31.64355,38.78906L60.64746,120H136a8,8,0,0,1,0,16H60.64746L31.64355,217.21094a16.0398,16.0398,0,0,0,15.041,21.4082,16.039,16.039,0,0,0,7.8457-2.06641l168.91309-94.59179a16.00165,16.00165,0,0,0,.001-27.92188Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M219.53563,121.02,50.62075,26.42762A8,8,0,0,0,39.178,36.09836l31.86106,89.211a8,8,0,0,1,0,5.38138L39.178,219.90164a8,8,0,0,0,11.44277,9.67074l168.91488-94.59233A8,8,0,0,0,219.53563,121.02Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "128",
      "x2": "136",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M219.53563,121.02,50.62075,26.42762A8,8,0,0,0,39.178,36.09836l31.86106,89.211a8,8,0,0,1,0,5.38138L39.178,219.90164a8,8,0,0,0,11.44277,9.67074l168.91488-94.59233A8,8,0,0,0,219.53563,121.02Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "128",
      "x2": "136",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M219.53563,121.02,50.62075,26.42762A8,8,0,0,0,39.178,36.09836l31.86106,89.211a8,8,0,0,1,0,5.38138L39.178,219.90164a8,8,0,0,0,11.44277,9.67074l168.91488-94.59233A8,8,0,0,0,219.53563,121.02Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "128",
      "x2": "136",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9C = [];
/* style */

const __vue_inject_styles__$9C = undefined;
/* scoped */

const __vue_scope_id__$9C = undefined;
/* module identifier */

const __vue_module_identifier__$9C = undefined;
/* functional template */

const __vue_is_functional_template__$9C = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9C = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9C,
  staticRenderFns: __vue_staticRenderFns__$9C
}, __vue_inject_styles__$9C, __vue_script__$9C, __vue_scope_id__$9C, __vue_is_functional_template__$9C, __vue_module_identifier__$9C, false, undefined, undefined, undefined);

var script$9D = Vue.extend({
  name: "PhPaperPlaneTilt",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9D = script$9D;
/* template */

var __vue_render__$9D = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M210.25072,35.878,23.923,88.432a8,8,0,0,0-1.253,14.9295l85.61084,40.5525a8.00008,8.00008,0,0,1,3.80521,3.80521L152.63852,233.33a8,8,0,0,0,14.9295-1.253L220.122,45.74928A8,8,0,0,0,210.25072,35.878Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "110.86292",
      "y1": "145.13708",
      "x2": "156.11775",
      "y2": "99.88225",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M210.25072,35.878,23.923,88.432a8,8,0,0,0-1.253,14.9295l85.61084,40.5525a8.00008,8.00008,0,0,1,3.80521,3.80521L152.63852,233.33a8,8,0,0,0,14.9295-1.253L220.122,45.74928A8,8,0,0,0,210.25072,35.878Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M210.25072,35.878,23.923,88.432a8,8,0,0,0-1.253,14.9295l85.61084,40.5525a8.00008,8.00008,0,0,1,3.80521,3.80521L152.63852,233.33a8,8,0,0,0,14.9295-1.253L220.122,45.74928A8,8,0,0,0,210.25072,35.878Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "110.86292",
      "y1": "145.13708",
      "x2": "156.11775",
      "y2": "99.88225",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M223.73633,32.26367a16.01051,16.01051,0,0,0-15.65723-4.085L21.751,80.73242a15.9995,15.9995,0,0,0-2.50586,29.8584l77.93359,36.916,53.28223-53.28223a8.00052,8.00052,0,0,1,11.31445,11.31445l-53.28223,53.28223,36.916,77.93359a15.85235,15.85235,0,0,0,14.41406,9.15235q.687,0,1.38379-.05762A15.86994,15.86994,0,0,0,175.26758,234.249L227.82129,47.9209A16.0173,16.0173,0,0,0,223.73633,32.26367Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M210.25072,35.878,23.923,88.432a8,8,0,0,0-1.253,14.9295l85.61084,40.5525a8.00008,8.00008,0,0,1,3.80521,3.80521L152.63852,233.33a8,8,0,0,0,14.9295-1.253L220.122,45.74928A8,8,0,0,0,210.25072,35.878Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "110.86292",
      "y1": "145.13708",
      "x2": "156.11775",
      "y2": "99.88225",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M210.25072,35.878,23.923,88.432a8,8,0,0,0-1.253,14.9295l85.61084,40.5525a8.00008,8.00008,0,0,1,3.80521,3.80521L152.63852,233.33a8,8,0,0,0,14.9295-1.253L220.122,45.74928A8,8,0,0,0,210.25072,35.878Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "110.86292",
      "y1": "145.13708",
      "x2": "156.11775",
      "y2": "99.88225",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M210.25072,35.878,23.923,88.432a8,8,0,0,0-1.253,14.9295l85.61084,40.5525a8.00008,8.00008,0,0,1,3.80521,3.80521L152.63852,233.33a8,8,0,0,0,14.9295-1.253L220.122,45.74928A8,8,0,0,0,210.25072,35.878Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "110.86292",
      "y1": "145.13708",
      "x2": "156.11775",
      "y2": "99.88225",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9D = [];
/* style */

const __vue_inject_styles__$9D = undefined;
/* scoped */

const __vue_scope_id__$9D = undefined;
/* module identifier */

const __vue_module_identifier__$9D = undefined;
/* functional template */

const __vue_is_functional_template__$9D = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9D = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9D,
  staticRenderFns: __vue_staticRenderFns__$9D
}, __vue_inject_styles__$9D, __vue_script__$9D, __vue_scope_id__$9D, __vue_is_functional_template__$9D, __vue_module_identifier__$9D, false, undefined, undefined, undefined);

var script$9E = Vue.extend({
  name: "PhPaperclip",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9E = script$9E;
/* template */

var __vue_render__$9E = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M95.99414,175.99512,191.799,83.799a28,28,0,0,0-39.598-39.598L54.05887,142.05887a48,48,0,0,0,67.88226,67.88226l82.053-81.946",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M159.99414,79.99512,76.68629,164.68629a16,16,0,0,0,22.62742,22.62742L198.62156,86.62253A32,32,0,1,0,153.36672,41.3677L54.05887,142.05887a48,48,0,0,0,67.88226,67.88226l82.053-81.946",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M209.65479,122.3418a8,8,0,0,1-.00733,11.31347l-82.05322,81.94629a56.00006,56.00006,0,0,1-79.1919-79.20019L147.6709,35.751A39.99954,39.99954,0,1,1,204.27832,92.2793l-99.269,100.65136A23.99954,23.99954,0,1,1,71.02979,159.0293L154.291,74.38477a8.0001,8.0001,0,0,1,11.40625,11.2207L82.38965,170.29688a8,8,0,1,0,11.2666,11.36035L192.92578,81.00488a23.99971,23.99971,0,1,0-33.90185-33.97949L59.75488,147.67578a40.00024,40.00024,0,1,0,56.5293,56.6084L198.34082,122.335A7.99885,7.99885,0,0,1,209.65479,122.3418Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M159.99414,79.99512,76.68629,164.68629a16,16,0,0,0,22.62742,22.62742L198.62156,86.62253A32,32,0,1,0,153.36672,41.3677L54.05887,142.05887a48,48,0,0,0,67.88226,67.88226l82.053-81.946",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M159.99414,79.99512,76.68629,164.68629a16,16,0,0,0,22.62742,22.62742L198.62156,86.62253A32,32,0,1,0,153.36672,41.3677L54.05887,142.05887a48,48,0,0,0,67.88226,67.88226l82.053-81.946",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M159.99414,79.99512,76.68629,164.68629a16,16,0,0,0,22.62742,22.62742L198.62156,86.62253A32,32,0,1,0,153.36672,41.3677L54.05887,142.05887a48,48,0,0,0,67.88226,67.88226l82.053-81.946",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9E = [];
/* style */

const __vue_inject_styles__$9E = undefined;
/* scoped */

const __vue_scope_id__$9E = undefined;
/* module identifier */

const __vue_module_identifier__$9E = undefined;
/* functional template */

const __vue_is_functional_template__$9E = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9E = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9E,
  staticRenderFns: __vue_staticRenderFns__$9E
}, __vue_inject_styles__$9E, __vue_script__$9E, __vue_scope_id__$9E, __vue_is_functional_template__$9E, __vue_module_identifier__$9E, false, undefined, undefined, undefined);

var script$9F = Vue.extend({
  name: "PhPaperclipHorizontal",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9F = script$9F;
/* template */

var __vue_render__$9F = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M183.99414,120H48a28,28,0,0,0,0,56H187.99414a48,48,0,1,0,0-96h-112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M78,143.99968H190A15.99984,15.99984,0,0,0,190,112H46c-17.23852,0-31.2131,14.32689-31.2131,32S28.76146,176,46,176H191.99414a48,48,0,1,0,0-96h-112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M191.99414,184H46c-21.62207,0-39.21289-17.94434-39.21289-40S24.37793,104,46,104H190a24,24,0,0,1,0,48H78a8,8,0,0,1,0-16H190a8,8,0,0,0,0-16H46c-12.7998,0-23.21289,10.7666-23.21289,24S33.2002,168,46,168H191.99414a40,40,0,1,0,0-80h-112a8,8,0,0,1,0-16h112a56,56,0,1,1,0,112Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M78,143.99968H190A15.99984,15.99984,0,0,0,190,112H46c-17.23852,0-31.2131,14.32689-31.2131,32S28.76146,176,46,176H191.99414a48,48,0,1,0,0-96h-112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M78,143.99968H190A15.99984,15.99984,0,0,0,190,112H46c-17.23852,0-31.2131,14.32689-31.2131,32S28.76146,176,46,176H191.99414a48,48,0,1,0,0-96h-112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M78,143.99968H190A15.99984,15.99984,0,0,0,190,112H46c-17.23852,0-31.2131,14.32689-31.2131,32S28.76146,176,46,176H191.99414a48,48,0,1,0,0-96h-112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9F = [];
/* style */

const __vue_inject_styles__$9F = undefined;
/* scoped */

const __vue_scope_id__$9F = undefined;
/* module identifier */

const __vue_module_identifier__$9F = undefined;
/* functional template */

const __vue_is_functional_template__$9F = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9F = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9F,
  staticRenderFns: __vue_staticRenderFns__$9F
}, __vue_inject_styles__$9F, __vue_script__$9F, __vue_scope_id__$9F, __vue_is_functional_template__$9F, __vue_module_identifier__$9F, false, undefined, undefined, undefined);

var script$9G = Vue.extend({
  name: "PhPath",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9G = script$9G;
/* template */

var __vue_render__$9G = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "200",
      "cy": "200",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,56h96a32,32,0,0,1,0,64H72a40,40,0,0,0,0,80H176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "200",
      "cy": "200",
      "r": "24",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "200",
      "cy": "200",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,56h96a32,32,0,0,1,0,64H72a40,40,0,0,0,0,80H176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,168a32.05794,32.05794,0,0,0-30.9873,24H72a32,32,0,0,1,0-64h96a40,40,0,0,0,0-80H72a8,8,0,0,0,0,16h96a24,24,0,0,1,0,48H72a48,48,0,0,0,0,96h97.0127A32.0015,32.0015,0,1,0,200,168Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "200",
      "cy": "200",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,56h96a32,32,0,0,1,0,64H72a40,40,0,0,0,0,80H176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "200",
      "cy": "200",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,56h96a32,32,0,0,1,0,64H72a40,40,0,0,0,0,80H176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "200",
      "cy": "200",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,56h96a32,32,0,0,1,0,64H72a40,40,0,0,0,0,80H176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9G = [];
/* style */

const __vue_inject_styles__$9G = undefined;
/* scoped */

const __vue_scope_id__$9G = undefined;
/* module identifier */

const __vue_module_identifier__$9G = undefined;
/* functional template */

const __vue_is_functional_template__$9G = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9G = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9G,
  staticRenderFns: __vue_staticRenderFns__$9G
}, __vue_inject_styles__$9G, __vue_script__$9G, __vue_scope_id__$9G, __vue_is_functional_template__$9G, __vue_module_identifier__$9G, false, undefined, undefined, undefined);

var script$9H = Vue.extend({
  name: "PhPause",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9H = script$9H;
/* template */

var __vue_render__$9H = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "156",
      "y": "40",
      "width": "52",
      "height": "176",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "48",
      "y": "40",
      "width": "52",
      "height": "176",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "156",
      "y": "40",
      "width": "52",
      "height": "176",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "48",
      "y": "40",
      "width": "52",
      "height": "176",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "156",
      "y": "40",
      "width": "52",
      "height": "176",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "48",
      "y": "40",
      "width": "52",
      "height": "176",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,48V208a16.01833,16.01833,0,0,1-16,16H164a16.01833,16.01833,0,0,1-16-16V48a16.01833,16.01833,0,0,1,16-16h36A16.01833,16.01833,0,0,1,216,48ZM92,32H56A16.01833,16.01833,0,0,0,40,48V208a16.01833,16.01833,0,0,0,16,16H92a16.01833,16.01833,0,0,0,16-16V48A16.01833,16.01833,0,0,0,92,32Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "156",
      "y": "40",
      "width": "52",
      "height": "176",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "48",
      "y": "40",
      "width": "52",
      "height": "176",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "156",
      "y": "40",
      "width": "52",
      "height": "176",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "48",
      "y": "40",
      "width": "52",
      "height": "176",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "156",
      "y": "40",
      "width": "52",
      "height": "176",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "48",
      "y": "40",
      "width": "52",
      "height": "176",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9H = [];
/* style */

const __vue_inject_styles__$9H = undefined;
/* scoped */

const __vue_scope_id__$9H = undefined;
/* module identifier */

const __vue_module_identifier__$9H = undefined;
/* functional template */

const __vue_is_functional_template__$9H = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9H = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9H,
  staticRenderFns: __vue_staticRenderFns__$9H
}, __vue_inject_styles__$9H, __vue_script__$9H, __vue_scope_id__$9H, __vue_is_functional_template__$9H, __vue_module_identifier__$9H, false, undefined, undefined, undefined);

var script$9I = Vue.extend({
  name: "PhPauseCircle",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9I = script$9I;
/* template */

var __vue_render__$9I = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "96",
      "x2": "104",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "96",
      "x2": "152",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "96",
      "x2": "104",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "96",
      "x2": "152",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.12041,104.12041,0,0,0,128,24ZM112,160a8,8,0,0,1-16,0V96a8,8,0,0,1,16,0Zm48,0a8,8,0,0,1-16,0V96a8,8,0,0,1,16,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "96",
      "x2": "104",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "96",
      "x2": "152",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "96",
      "x2": "104",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "96",
      "x2": "152",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "96",
      "x2": "104",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "96",
      "x2": "152",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9I = [];
/* style */

const __vue_inject_styles__$9I = undefined;
/* scoped */

const __vue_scope_id__$9I = undefined;
/* module identifier */

const __vue_module_identifier__$9I = undefined;
/* functional template */

const __vue_is_functional_template__$9I = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9I = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9I,
  staticRenderFns: __vue_staticRenderFns__$9I
}, __vue_inject_styles__$9I, __vue_script__$9I, __vue_scope_id__$9I, __vue_is_functional_template__$9I, __vue_module_identifier__$9I, false, undefined, undefined, undefined);

var script$9J = Vue.extend({
  name: "PhPawPrint",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9J = script$9J;
/* template */

var __vue_render__$9J = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M183.23572,155.85352a43.541,43.541,0,0,1-20.667-25.90381l-.00092.001a35.9985,35.9985,0,0,0-69.13562,0l-.00092-.001a43.541,43.541,0,0,1-20.667,25.90381,32.00736,32.00736,0,0,0,27.72266,57.61767,72.51938,72.51938,0,0,1,55.02612,0,32.00679,32.00679,0,0,0,27.72266-57.61767Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "208",
      "cy": "104",
      "r": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "48",
      "cy": "104",
      "r": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "96",
      "cy": "56",
      "r": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "160",
      "cy": "56",
      "r": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "212",
      "cy": "108",
      "r": "20",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "44",
      "cy": "108",
      "r": "20",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "60",
      "r": "20",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "60",
      "r": "20",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M183.23572,155.85352a43.541,43.541,0,0,1-20.667-25.90381l-.00092.001a35.9985,35.9985,0,0,0-69.13562,0l-.00092-.001a43.541,43.541,0,0,1-20.667,25.90381,32.00736,32.00736,0,0,0,27.72266,57.61767,72.51938,72.51938,0,0,1,55.02612,0,32.00679,32.00679,0,0,0,27.72266-57.61767Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "212",
      "cy": "108",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "44",
      "cy": "108",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "60",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "60",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M183.23572,155.85352a43.541,43.541,0,0,1-20.667-25.90381l-.00092.001a35.9985,35.9985,0,0,0-69.13562,0l-.00092-.001a43.541,43.541,0,0,1-20.667,25.90381,32.00736,32.00736,0,0,0,27.72266,57.61767,72.51938,72.51938,0,0,1,55.02612,0,32.00679,32.00679,0,0,0,27.72266-57.61767Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M240,108a28,28,0,1,1-28-28A28.03146,28.03146,0,0,1,240,108ZM72,108a28,28,0,1,0-28,28A28.03146,28.03146,0,0,0,72,108ZM92,88A28,28,0,1,0,64,60,28.03146,28.03146,0,0,0,92,88Zm72,0a28,28,0,1,0-28-28A28.03146,28.03146,0,0,0,164,88Zm23.0918,60.84473a35.3317,35.3317,0,0,1-16.8418-21.124,43.99839,43.99839,0,0,0-84.5-.00439,35.2806,35.2806,0,0,1-16.7998,21.105,40.00718,40.00718,0,0,0,34.57226,72.05176,64.08634,64.08634,0,0,1,48.86524-.03711,40.0067,40.0067,0,0,0,34.7041-71.99121Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "212",
      "cy": "108",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "44",
      "cy": "108",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "60",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "60",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M183.23572,155.85352a43.541,43.541,0,0,1-20.667-25.90381l-.00092.001a35.9985,35.9985,0,0,0-69.13562,0l-.00092-.001a43.541,43.541,0,0,1-20.667,25.90381,32.00736,32.00736,0,0,0,27.72266,57.61767,72.51938,72.51938,0,0,1,55.02612,0,32.00679,32.00679,0,0,0,27.72266-57.61767Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "212",
      "cy": "108",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "44",
      "cy": "108",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "60",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "60",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M183.23572,155.85352a43.541,43.541,0,0,1-20.667-25.90381l-.00092.001a35.9985,35.9985,0,0,0-69.13562,0l-.00092-.001a43.541,43.541,0,0,1-20.667,25.90381,32.00736,32.00736,0,0,0,27.72266,57.61767,72.51938,72.51938,0,0,1,55.02612,0,32.00679,32.00679,0,0,0,27.72266-57.61767Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "212",
      "cy": "108",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "44",
      "cy": "108",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "60",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "60",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M183.23572,155.85352a43.541,43.541,0,0,1-20.667-25.90381l-.00092.001a35.9985,35.9985,0,0,0-69.13562,0l-.00092-.001a43.541,43.541,0,0,1-20.667,25.90381,32.00736,32.00736,0,0,0,27.72266,57.61767,72.51938,72.51938,0,0,1,55.02612,0,32.00679,32.00679,0,0,0,27.72266-57.61767Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9J = [];
/* style */

const __vue_inject_styles__$9J = undefined;
/* scoped */

const __vue_scope_id__$9J = undefined;
/* module identifier */

const __vue_module_identifier__$9J = undefined;
/* functional template */

const __vue_is_functional_template__$9J = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9J = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9J,
  staticRenderFns: __vue_staticRenderFns__$9J
}, __vue_inject_styles__$9J, __vue_script__$9J, __vue_scope_id__$9J, __vue_is_functional_template__$9J, __vue_module_identifier__$9J, false, undefined, undefined, undefined);

var script$9K = Vue.extend({
  name: "PhPeace",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9K = script$9K;
/* template */

var __vue_render__$9K = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "206.6386",
      "y2": "183.06334",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "49.3614",
      "y2": "183.06334",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "206.6386",
      "y2": "183.06334",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "49.3614",
      "y2": "183.06334",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M213.6377,186.938a104,104,0,1,0-171.2754,0,8.09637,8.09637,0,0,0,.44532.71387c.12011.17163.25537.32543.38623.48461a103.91407,103.91407,0,0,0,169.61279-.001c.13086-.15894.26563-.31226.38574-.48364A8.09637,8.09637,0,0,0,213.6377,186.938ZM216,128a87.46128,87.46128,0,0,1-11.63916,43.70215L136,123.8352V40.36743A88.117,88.117,0,0,1,216,128ZM120,40.36743V123.8352L51.63916,171.70215A87.96692,87.96692,0,0,1,120,40.36743Zm-59.16162,144.426L120,143.36816v72.26441A87.90216,87.90216,0,0,1,60.83838,184.79346ZM136,215.63257V143.36816l59.16162,41.4253A87.90216,87.90216,0,0,1,136,215.63257Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "206.6386",
      "y2": "183.06334",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "49.3614",
      "y2": "183.06334",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "206.6386",
      "y2": "183.06334",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "49.3614",
      "y2": "183.06334",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "206.6386",
      "y2": "183.06334",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "49.3614",
      "y2": "183.06334",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9K = [];
/* style */

const __vue_inject_styles__$9K = undefined;
/* scoped */

const __vue_scope_id__$9K = undefined;
/* module identifier */

const __vue_module_identifier__$9K = undefined;
/* functional template */

const __vue_is_functional_template__$9K = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9K = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9K,
  staticRenderFns: __vue_staticRenderFns__$9K
}, __vue_inject_styles__$9K, __vue_script__$9K, __vue_scope_id__$9K, __vue_is_functional_template__$9K, __vue_module_identifier__$9K, false, undefined, undefined, undefined);

var script$9L = Vue.extend({
  name: "PhPen",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9L = script$9L;
/* template */

var __vue_render__$9L = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.68629,216H48a8,8,0,0,1-8-8V163.31371a8,8,0,0,1,2.34315-5.65686l120-120a8,8,0,0,1,11.3137,0l44.6863,44.6863a8,8,0,0,1,0,11.3137l-120,120A8,8,0,0,1,92.68629,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "64",
      "x2": "192",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "164 200 204 160 192 120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "43.99996",
      "y1": "155.99997",
      "x2": "99.99999",
      "y2": "212.00001",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M192,120,136,64l26.34315-26.34315a8,8,0,0,1,11.3137,0l44.6863,44.6863a8,8,0,0,1,0,11.3137Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.68629,216H48a8,8,0,0,1-8-8V163.31371a8,8,0,0,1,2.34315-5.65686l120-120a8,8,0,0,1,11.3137,0l44.6863,44.6863a8,8,0,0,1,0,11.3137l-120,120A8,8,0,0,1,92.68629,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "64",
      "x2": "192",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 192 200 152 192 120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40.5088",
      "y1": "160.5088",
      "x2": "95.49114",
      "y2": "215.49114",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M228.68652,88A15.89427,15.89427,0,0,0,224,76.68652L179.31348,31.999A16.02162,16.02162,0,0,0,156.68555,32l-120,120.00049a15.953,15.953,0,0,0-3.56836,5.4458,7.95719,7.95719,0,0,0-.27149.75976A16.00722,16.00722,0,0,0,32,163.31348V208a16.01833,16.01833,0,0,0,16,16H92.68652a16.00666,16.00666,0,0,0,5.15869-.86377c.23829-.07324.47388-.15674.70582-.25244A15.94661,15.94661,0,0,0,104,219.31348l83.666-83.666,3.4746,13.89844-36.79785,36.79736a8.00018,8.00018,0,0,0,11.31446,11.31348l40-40a8.00081,8.00081,0,0,0,2.10351-7.59717l-6.90136-27.60547L223.999,99.31445A15.895,15.895,0,0,0,228.68652,88ZM192,108.68555,147.314,64,168,43.31348,212.68555,88Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.68629,216H48a8,8,0,0,1-8-8V163.31371a8,8,0,0,1,2.34315-5.65686l120-120a8,8,0,0,1,11.3137,0l44.6863,44.6863a8,8,0,0,1,0,11.3137l-120,120A8,8,0,0,1,92.68629,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "64",
      "x2": "192",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 192 200 152 192 120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40.50833",
      "y1": "160.50833",
      "x2": "95.49164",
      "y2": "215.49164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.68629,216H48a8,8,0,0,1-8-8V163.31371a8,8,0,0,1,2.34315-5.65686l120-120a8,8,0,0,1,11.3137,0l44.6863,44.6863a8,8,0,0,1,0,11.3137l-120,120A8,8,0,0,1,92.68629,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "64",
      "x2": "192",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 192 200 152 192 120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40.50826",
      "y1": "160.50826",
      "x2": "95.49177",
      "y2": "215.49177",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.68629,216H48a8,8,0,0,1-8-8V163.31371a8,8,0,0,1,2.34315-5.65686l120-120a8,8,0,0,1,11.3137,0l44.6863,44.6863a8,8,0,0,1,0,11.3137l-120,120A8,8,0,0,1,92.68629,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "64",
      "x2": "192",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 192 200 152 192 120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40.50826",
      "y1": "160.50826",
      "x2": "95.49177",
      "y2": "215.49177",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9L = [];
/* style */

const __vue_inject_styles__$9L = undefined;
/* scoped */

const __vue_scope_id__$9L = undefined;
/* module identifier */

const __vue_module_identifier__$9L = undefined;
/* functional template */

const __vue_is_functional_template__$9L = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9L = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9L,
  staticRenderFns: __vue_staticRenderFns__$9L
}, __vue_inject_styles__$9L, __vue_script__$9L, __vue_scope_id__$9L, __vue_is_functional_template__$9L, __vue_module_identifier__$9L, false, undefined, undefined, undefined);

var script$9M = Vue.extend({
  name: "PhPenNib",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9M = script$9M;
/* template */

var __vue_render__$9M = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "116",
      "cy": "140",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32.00586,224.00342l139.44573-23.241a8,8,0,0,0,6.17544-5.08216l22.37883-59.67688-80-80L60.329,78.38225a8,8,0,0,0-5.08217,6.17544Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200.00586,136.00342,226.349,109.66027a8,8,0,0,0,0-11.31371l-68.6863-68.68629a8,8,0,0,0-11.3137,0L120.00586,56.00342",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32.00586",
      "y1": "224.00342",
      "x2": "99.02963",
      "y2": "156.97074",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M120.00586,56.00342,60.3291,78.38232a7.99941,7.99941,0,0,0-5.08227,6.1753l-23.241,139.4458,139.4458-23.24121a7.99949,7.99949,0,0,0,6.17529-5.082l22.37891-59.67676ZM116,160a20,20,0,1,1,20-20A19.9999,19.9999,0,0,1,116,160Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "116",
      "cy": "140",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32.00586",
      "y1": "224.00342",
      "x2": "101.85786",
      "y2": "154.14214",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32.00586,224.00342l139.44573-23.241a8,8,0,0,0,6.17544-5.08216l22.37883-59.67688-80-80L60.329,78.38225a8,8,0,0,0-5.08217,6.17544Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200.00586,136.00342,226.349,109.66027a8,8,0,0,0,0-11.31371l-68.6863-68.68629a8,8,0,0,0-11.3137,0L120.00586,56.00342",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232.00586,92.68994l-68.68652-68.6875a16.02162,16.02162,0,0,0-22.62793.001L115.57349,49.12158l-58.053,21.77a16.045,16.045,0,0,0-10.165,12.35108L26.58887,207.83984a4,4,0,0,0,6.77417,3.48584l55.08423-55.08545a32.0378,32.0378,0,1,1,11.311,11.31543L44.667,222.64893a4,4,0,0,0,3.48609,6.77392l124.61352-20.769a16.0433,16.0433,0,0,0,12.35059-10.16406l21.77-58.05371,25.11767-25.11817a15.99888,15.99888,0,0,0,.001-22.62793Zm-32,31.99951-68.686-68.686,20.686-20.68653,68.68555,68.68653Z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "116.00586",
      "cy": "140.00342",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "116",
      "cy": "140",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32.00586",
      "y1": "224.00342",
      "x2": "101.85786",
      "y2": "154.14214",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32.00586,224.00342l139.44573-23.241a8,8,0,0,0,6.17544-5.08216l22.37883-59.67688-80-80L60.329,78.38225a8,8,0,0,0-5.08217,6.17544Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200.00586,136.00342,226.349,109.66027a8,8,0,0,0,0-11.31371l-68.6863-68.68629a8,8,0,0,0-11.3137,0L120.00586,56.00342",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "116",
      "cy": "140",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32.00586",
      "y1": "224.00342",
      "x2": "101.85786",
      "y2": "154.14214",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32.00586,224.00342l139.44573-23.241a8,8,0,0,0,6.17544-5.08216l22.37883-59.67688-80-80L60.329,78.38225a8,8,0,0,0-5.08217,6.17544Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200.00586,136.00342,226.349,109.66027a8,8,0,0,0,0-11.31371l-68.6863-68.68629a8,8,0,0,0-11.3137,0L120.00586,56.00342",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "116",
      "cy": "140",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32.00586",
      "y1": "224.00342",
      "x2": "101.85786",
      "y2": "154.14214",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32.00586,224.00342l139.44573-23.241a8,8,0,0,0,6.17544-5.08216l22.37883-59.67688-80-80L60.329,78.38225a8,8,0,0,0-5.08217,6.17544Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200.00586,136.00342,226.349,109.66027a8,8,0,0,0,0-11.31371l-68.6863-68.68629a8,8,0,0,0-11.3137,0L120.00586,56.00342",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9M = [];
/* style */

const __vue_inject_styles__$9M = undefined;
/* scoped */

const __vue_scope_id__$9M = undefined;
/* module identifier */

const __vue_module_identifier__$9M = undefined;
/* functional template */

const __vue_is_functional_template__$9M = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9M = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9M,
  staticRenderFns: __vue_staticRenderFns__$9M
}, __vue_inject_styles__$9M, __vue_script__$9M, __vue_scope_id__$9M, __vue_is_functional_template__$9M, __vue_module_identifier__$9M, false, undefined, undefined, undefined);

var script$9N = Vue.extend({
  name: "PhPenNibStraight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9N = script$9N;
/* template */

var __vue_render__$9N = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128.00587",
      "y1": "156.00342",
      "x2": "128.00587",
      "y2": "244.00342",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128.00587",
      "cy": "132.00342",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72.00586,72.00342v-40a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8v40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "72.006 72.003 42.463 131.799 128.006 244.003 213.549 131.799 184.006 72.003 72.006 72.003",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M211.39209,127.43359,184.00586,72.00342h-112L44.61914,127.43408a8.0009,8.0009,0,0,0,.73,8.28662l82.65674,112.28272,82.65625-112.28321A7.99983,7.99983,0,0,0,211.39209,127.43359Zm-83.38623,24.56983a20,20,0,1,1,20-20A19.99974,19.99974,0,0,1,128.00586,152.00342Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128.00587",
      "y1": "152.00342",
      "x2": "128.00586",
      "y2": "248.00342",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128.00587",
      "cy": "132.00342",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72.00586,72.00342v-40a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8v40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72.00586,72.00342l-27.3866,55.43077a8,8,0,0,0,.72977,8.28632l82.65684,112.28291,82.65647-112.28335a8,8,0,0,0,.72976-8.28628L184.00586,72.00342Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128.00586",
      "cy": "132.00342",
      "r": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M218.56445,123.89014,192.00586,70.13477V32.00342a16,16,0,0,0-16-16h-96a16,16,0,0,0-16,16V70.13477L37.44678,123.89062a15.944,15.944,0,0,0,1.45947,16.57276l73.87832,100.35748a4,4,0,0,0,7.22129-2.37135V162.99072a32,32,0,1,1,16,0v75.45864a4,4,0,0,0,7.2213,2.37133L217.105,140.4624A15.94312,15.94312,0,0,0,218.56445,123.89014ZM176.00586,64.00342h-96v-32h96Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128.00587",
      "y1": "152.00342",
      "x2": "128.00587",
      "y2": "248.00342",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128.00587",
      "cy": "132.00342",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72.00586,72.00342v-40a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8v40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72.00586,72.00342l-27.3866,55.43077a8,8,0,0,0,.72977,8.28632l82.65684,112.28291,82.65647-112.28335a8,8,0,0,0,.72976-8.28628L184.00586,72.00342Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128.00587",
      "y1": "152.00342",
      "x2": "128.00587",
      "y2": "248.00342",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128.00587",
      "cy": "132.00342",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72.00586,72.00342v-40a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8v40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72.00586,72.00342l-27.3866,55.43077a8,8,0,0,0,.72977,8.28632l82.65684,112.28291,82.65647-112.28335a8,8,0,0,0,.72976-8.28628L184.00586,72.00342Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128.00587",
      "y1": "152.00342",
      "x2": "128.00587",
      "y2": "248.00342",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128.00587",
      "cy": "132.00342",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72.00586,72.00342v-40a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8v40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72.00586,72.00342l-27.3866,55.43077a8,8,0,0,0,.72977,8.28632l82.65684,112.28291,82.65647-112.28335a8,8,0,0,0,.72976-8.28628L184.00586,72.00342Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9N = [];
/* style */

const __vue_inject_styles__$9N = undefined;
/* scoped */

const __vue_scope_id__$9N = undefined;
/* module identifier */

const __vue_module_identifier__$9N = undefined;
/* functional template */

const __vue_is_functional_template__$9N = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9N = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9N,
  staticRenderFns: __vue_staticRenderFns__$9N
}, __vue_inject_styles__$9N, __vue_script__$9N, __vue_scope_id__$9N, __vue_is_functional_template__$9N, __vue_module_identifier__$9N, false, undefined, undefined, undefined);

var script$9O = Vue.extend({
  name: "PhPencil",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9O = script$9O;
/* template */

var __vue_render__$9O = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.68629,216H48a8,8,0,0,1-8-8V163.31371a8,8,0,0,1,2.34315-5.65686l120-120a8,8,0,0,1,11.3137,0l44.6863,44.6863a8,8,0,0,1,0,11.3137l-120,120A8,8,0,0,1,92.68629,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "64",
      "x2": "192",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "44",
      "y1": "156",
      "x2": "100",
      "y2": "212",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M136,64l56,56,26.34315-26.34315a8,8,0,0,0,0-11.3137l-44.6863-44.6863a8,8,0,0,0-11.3137,0Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "95.48882",
      "y1": "215.48882",
      "x2": "40.5088",
      "y2": "160.5088",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.68629,216H48a8,8,0,0,1-8-8V163.31371a8,8,0,0,1,2.34315-5.65686l120-120a8,8,0,0,1,11.3137,0l44.6863,44.6863a8,8,0,0,1,0,11.3137l-120,120A8,8,0,0,1,92.68629,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "64",
      "x2": "192",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,76.68652,179.314,32a15.99948,15.99948,0,0,0-22.62744,0L130.34473,58.3418l-.00147.00146-.00146.00147L36.687,151.99951A15.89429,15.89429,0,0,0,32,163.31348V208a16.01833,16.01833,0,0,0,16,16H92.68652A15.89438,15.89438,0,0,0,104,219.31348l120.00049-120A16.01823,16.01823,0,0,0,224,76.68652Zm-32,32L147.31372,64,168,43.31348,212.68652,88Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.68629,216H48a8,8,0,0,1-8-8V163.31371a8,8,0,0,1,2.34315-5.65686l120-120a8,8,0,0,1,11.3137,0l44.6863,44.6863a8,8,0,0,1,0,11.3137l-120,120A8,8,0,0,1,92.68629,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "64",
      "x2": "192",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "95.48882",
      "y1": "215.48882",
      "x2": "40.5088",
      "y2": "160.5088",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.68629,216H48a8,8,0,0,1-8-8V163.31371a8,8,0,0,1,2.34315-5.65686l120-120a8,8,0,0,1,11.3137,0l44.6863,44.6863a8,8,0,0,1,0,11.3137l-120,120A8,8,0,0,1,92.68629,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "64",
      "x2": "192",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "95.48882",
      "y1": "215.48882",
      "x2": "40.5088",
      "y2": "160.5088",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.68629,216H48a8,8,0,0,1-8-8V163.31371a8,8,0,0,1,2.34315-5.65686l120-120a8,8,0,0,1,11.3137,0l44.6863,44.6863a8,8,0,0,1,0,11.3137l-120,120A8,8,0,0,1,92.68629,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "64",
      "x2": "192",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "95.48882",
      "y1": "215.48882",
      "x2": "40.5088",
      "y2": "160.5088",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9O = [];
/* style */

const __vue_inject_styles__$9O = undefined;
/* scoped */

const __vue_scope_id__$9O = undefined;
/* module identifier */

const __vue_module_identifier__$9O = undefined;
/* functional template */

const __vue_is_functional_template__$9O = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9O = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9O,
  staticRenderFns: __vue_staticRenderFns__$9O
}, __vue_inject_styles__$9O, __vue_script__$9O, __vue_scope_id__$9O, __vue_is_functional_template__$9O, __vue_module_identifier__$9O, false, undefined, undefined, undefined);

var script$9P = Vue.extend({
  name: "PhPencilCircle",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9P = script$9P;
/* template */

var __vue_render__$9P = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176 211.161 176 176 128 72 80 176 80 211.164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,200a24,24,0,0,1,48,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,224V200a24,24,0,0,0-48,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "98.4615",
      "y1": "136",
      "x2": "157.53847",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80.00324,211.15879a96,96,0,1,1,95.99492-.00082l.00184.00318V176L128,72,80,176v35.16442Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176 211.161 176 176 128 72 80 176 80 211.164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,192a24,24,0,0,1,48,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,224V192a24,24,0,0,0-48,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "102.15385",
      "y1": "128",
      "x2": "153.84615",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M201.53906,54.46094A103.99994,103.99994,0,1,0,54.46094,201.53906,103.99994,103.99994,0,1,0,201.53906,54.46094ZM128,170.86786a31.92926,31.92926,0,0,0-32.31274-9.76618L110.96484,128h34.07032l15.27758,33.10168A31.92926,31.92926,0,0,0,128,170.86786Zm40,35.50226a87.94109,87.94109,0,0,1-32,9.21777V192a16,16,0,0,1,32,0Zm22.22461-16.14453c-2.0022,2.00225-4.08447,3.87616-6.22461,5.64471V176a7.99689,7.99689,0,0,0-.73633-3.35254l-48-104c-.00683-.01477-.0166-.02759-.02344-.0423a8.0006,8.0006,0,0,0-.4956-.89727c-.03858-.06073-.07959-.1186-.11987-.1781a7.94887,7.94887,0,0,0-.54834-.72388c-.03052-.03559-.05835-.07337-.08936-.1084a7.95215,7.95215,0,0,0-.73462-.727c-.04346-.03778-.08935-.0719-.1333-.1087a7.96445,7.96445,0,0,0-.69189-.51453c-.06617-.044-.13086-.08893-.19825-.131a8.07167,8.07167,0,0,0-.87646-.48l-.0166-.00665c-.0232-.01069-.04785-.01813-.07129-.02863a8.04837,8.04837,0,0,0-.88355-.33075c-.08471-.02649-.16992-.05-.25561-.07367a7.93969,7.93969,0,0,0-.87573-.1922c-.04273-.00677-.08423-.01715-.1272-.02325a7.93122,7.93122,0,0,0-1.04224-.07538C128.05322,64.00555,128.0271,64,128,64c-.04321,0-.08472.00854-.12769.00922a7.97635,7.97635,0,0,0-.905.06549c-.0564.00732-.11353.0108-.16944.01935a8.00689,8.00689,0,0,0-.97119.21307c-.083.02344-.16357.05127-.24561.07733a8.01776,8.01776,0,0,0-.7644.28619c-.06616.02869-.1333.05365-.19849.08405a8.00888,8.00888,0,0,0-.87207.47528c-.05517.03473-.10742.07288-.16186.10889a7.946,7.946,0,0,0-.69946.5202c-.04883.04047-.09864.07874-.14624.12036a7.92641,7.92641,0,0,0-.73365.7262c-.02563.02893-.04809.06042-.07324.08972a7.92917,7.92917,0,0,0-.55127.72778c-.04736.06989-.09424.13928-.1394.21088a8.01437,8.01437,0,0,0-.50464.91345l-22.1543,48-.00244.006-25.84326,55.994A7.99689,7.99689,0,0,0,72,176v19.8703c-2.14014-1.76855-4.22241-3.64246-6.22461-5.64471a88,88,0,1,1,124.44922,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176 211.161 176 176 128 72 80 176 80 211.164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,192a24,24,0,0,1,48,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,224V192a24,24,0,0,0-48,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "102.15385",
      "y1": "128",
      "x2": "153.84615",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176 211.161 176 176 128 72 80 176 80 211.164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,192a24,24,0,0,1,48,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,224V192a24,24,0,0,0-48,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "102.15385",
      "y1": "128",
      "x2": "153.84615",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176 211.161 176 176 128 72 80 176 80 211.164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,192a24,24,0,0,1,48,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,224V192a24,24,0,0,0-48,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "102.15385",
      "y1": "128",
      "x2": "153.84615",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9P = [];
/* style */

const __vue_inject_styles__$9P = undefined;
/* scoped */

const __vue_scope_id__$9P = undefined;
/* module identifier */

const __vue_module_identifier__$9P = undefined;
/* functional template */

const __vue_is_functional_template__$9P = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9P = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9P,
  staticRenderFns: __vue_staticRenderFns__$9P
}, __vue_inject_styles__$9P, __vue_script__$9P, __vue_scope_id__$9P, __vue_is_functional_template__$9P, __vue_module_identifier__$9P, false, undefined, undefined, undefined);

var script$9Q = Vue.extend({
  name: "PhPencilLine",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9Q = script$9Q;
/* template */

var __vue_render__$9Q = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M96,216H48a8,8,0,0,1-8-8V163.31371a8,8,0,0,1,2.34315-5.65686l120-120a8,8,0,0,1,11.3137,0l44.6863,44.6863a8,8,0,0,1,0,11.3137Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "64",
      "x2": "192",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "44",
      "y1": "156",
      "x2": "103.99998",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "216",
      "x2": "96",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M192,120,136,64l26.34315-26.34315a8,8,0,0,1,11.3137,0l44.6863,44.6863a8,8,0,0,1,0,11.3137Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,216H48a8,8,0,0,1-8-8V163.31371a8,8,0,0,1,2.34315-5.65686l120-120a8,8,0,0,1,11.3137,0l44.6863,44.6863a8,8,0,0,1,0,11.3137Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "64",
      "x2": "192",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "216 216 96 216 40.509 160.509",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,208H115.314l82.33838-82.33887.00489-.00439.00439-.00488L223.999,99.31445A15.99888,15.99888,0,0,0,224,76.68652L179.31348,31.999A16.02162,16.02162,0,0,0,156.68555,32l-120,120.00049a15.95392,15.95392,0,0,0-3.572,5.45654c-.08228.19971-.15162.40283-.21705.60742A15.9896,15.9896,0,0,0,32,163.31348V208a16.01833,16.01833,0,0,0,16,16H216a8,8,0,0,0,0-16ZM168,43.31348,212.68555,88,192,108.68555,147.314,64Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M96,216H48a8,8,0,0,1-8-8V163.31371a8,8,0,0,1,2.34315-5.65686l120-120a8,8,0,0,1,11.3137,0l44.6863,44.6863a8,8,0,0,1,0,11.3137Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "64",
      "x2": "192",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "216 216 96 216 40.509 160.509",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M96,216H48a8,8,0,0,1-8-8V163.31371a8,8,0,0,1,2.34315-5.65686l120-120a8,8,0,0,1,11.3137,0l44.6863,44.6863a8,8,0,0,1,0,11.3137Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "64",
      "x2": "192",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "216 216 96 216 40.509 160.509",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M96,216H48a8,8,0,0,1-8-8V163.31371a8,8,0,0,1,2.34315-5.65686l120-120a8,8,0,0,1,11.3137,0l44.6863,44.6863a8,8,0,0,1,0,11.3137Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "64",
      "x2": "192",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "216 216 96 216 40.509 160.509",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9Q = [];
/* style */

const __vue_inject_styles__$9Q = undefined;
/* scoped */

const __vue_scope_id__$9Q = undefined;
/* module identifier */

const __vue_module_identifier__$9Q = undefined;
/* functional template */

const __vue_is_functional_template__$9Q = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9Q = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9Q,
  staticRenderFns: __vue_staticRenderFns__$9Q
}, __vue_inject_styles__$9Q, __vue_script__$9Q, __vue_scope_id__$9Q, __vue_is_functional_template__$9Q, __vue_module_identifier__$9Q, false, undefined, undefined, undefined);

var script$9R = Vue.extend({
  name: "PhPencilSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9R = script$9R;
/* template */

var __vue_render__$9R = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M96,216H48a8,8,0,0,1-8-8V163.31371a8,8,0,0,1,2.34315-5.65686l120-120a8,8,0,0,1,11.3137,0l44.6863,44.6863a8,8,0,0,1,0,11.3137Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "64",
      "x2": "192",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M136,64l56,56,26.34315-26.34315a8,8,0,0,0,0-11.3137l-44.6863-44.6863a8,8,0,0,0-11.3137,0Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "64",
      "x2": "192",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,216H48a8,8,0,0,1-8-8V163.31371a8,8,0,0,1,2.34315-5.65686l120-120a8,8,0,0,1,11.3137,0l44.6863,44.6863a8,8,0,0,1,0,11.3137Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,76.68652,179.314,32a15.99948,15.99948,0,0,0-22.62744,0L130.34473,58.3418l-.00147.00146-.00146.00147L36.687,151.99951A15.89429,15.89429,0,0,0,32,163.31348V208a16.01833,16.01833,0,0,0,16,16H92.68652A15.89438,15.89438,0,0,0,104,219.31348l120.00049-120A16.01823,16.01823,0,0,0,224,76.68652Zm-32,32L147.31372,64,168,43.31348,212.68652,88Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M96,216H48a8,8,0,0,1-8-8V163.31371a8,8,0,0,1,2.34315-5.65686l120-120a8,8,0,0,1,11.3137,0l44.6863,44.6863a8,8,0,0,1,0,11.3137Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "64",
      "x2": "192",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M96,216H48a8,8,0,0,1-8-8V163.31371a8,8,0,0,1,2.34315-5.65686l120-120a8,8,0,0,1,11.3137,0l44.6863,44.6863a8,8,0,0,1,0,11.3137Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "64",
      "x2": "192",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M96,216H48a8,8,0,0,1-8-8V163.31371a8,8,0,0,1,2.34315-5.65686l120-120a8,8,0,0,1,11.3137,0l44.6863,44.6863a8,8,0,0,1,0,11.3137Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "64",
      "x2": "192",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9R = [];
/* style */

const __vue_inject_styles__$9R = undefined;
/* scoped */

const __vue_scope_id__$9R = undefined;
/* module identifier */

const __vue_module_identifier__$9R = undefined;
/* functional template */

const __vue_is_functional_template__$9R = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9R = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9R,
  staticRenderFns: __vue_staticRenderFns__$9R
}, __vue_inject_styles__$9R, __vue_script__$9R, __vue_scope_id__$9R, __vue_is_functional_template__$9R, __vue_module_identifier__$9R, false, undefined, undefined, undefined);

var script$9S = Vue.extend({
  name: "PhPercent",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9S = script$9S;
/* template */

var __vue_render__$9S = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "200",
      "y1": "56",
      "x2": "56",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "76",
      "cy": "76",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "180",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "76",
      "cy": "76",
      "r": "28",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "180",
      "r": "28",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "56",
      "x2": "56",
      "y2": "200",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "76",
      "cy": "76",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "180",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M205.65674,61.65674l-144,144a7.99984,7.99984,0,0,1-11.31348-11.31348l144-144a7.99984,7.99984,0,0,1,11.31348,11.31348ZM50.54443,101.45581A36.0403,36.0403,0,1,1,76,111.98315,35.76294,35.76294,0,0,1,50.54443,101.45581ZM56,76A20,20,0,1,0,90.14209,61.85791v-.00024A20,20,0,0,0,56,76ZM216,180a36.00012,36.00012,0,1,1-10.54443-25.45581A35.76281,35.76281,0,0,1,216,180Zm-16,0a20.00016,20.00016,0,1,0-5.85791,14.14209A19.86721,19.86721,0,0,0,200,180Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "200",
      "y1": "56",
      "x2": "56",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "76",
      "cy": "76",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "180",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "200",
      "y1": "56",
      "x2": "56",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "76",
      "cy": "76",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "180",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "200",
      "y1": "56",
      "x2": "56",
      "y2": "200",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "76",
      "cy": "76",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "180",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9S = [];
/* style */

const __vue_inject_styles__$9S = undefined;
/* scoped */

const __vue_scope_id__$9S = undefined;
/* module identifier */

const __vue_module_identifier__$9S = undefined;
/* functional template */

const __vue_is_functional_template__$9S = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9S = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9S,
  staticRenderFns: __vue_staticRenderFns__$9S
}, __vue_inject_styles__$9S, __vue_script__$9S, __vue_scope_id__$9S, __vue_is_functional_template__$9S, __vue_module_identifier__$9S, false, undefined, undefined, undefined);

var script$9T = Vue.extend({
  name: "PhPerson",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9T = script$9T;
/* template */

var __vue_render__$9T = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "127.88745",
      "cy": "44",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M153.91044,134.715,188.657,161.74012a12,12,0,1,0,16.97056-16.97057l-39.598-50.91169A19.93738,19.93738,0,0,0,151.88746,88h-48a19.93739,19.93739,0,0,0-14.14213,5.85786l-39.598,50.91169A12,12,0,1,0,67.1179,161.74012L101.86446,134.715,74.13088,222.3089a12,12,0,0,0,21.75139,10.14284l32.0052-50.37108h0l32.0052,50.37108A12,12,0,0,0,181.644,222.3089Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "127.88745",
      "cy": "44",
      "r": "28",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M153.91044,134.715,188.657,161.74012a12,12,0,1,0,16.97056-16.97057l-39.598-50.91169A19.93738,19.93738,0,0,0,151.88746,88h-48a19.93739,19.93739,0,0,0-14.14213,5.85786l-39.598,50.91169A12,12,0,1,0,67.1179,161.74012L101.86446,134.715,74.13088,222.3089a12,12,0,0,0,21.75139,10.14284l32.0052-50.37108h0l32.0052,50.37108A12,12,0,0,0,181.644,222.3089Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "127.88745",
      "cy": "44",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M153.91044,134.715,188.657,161.74012a12,12,0,1,0,16.97056-16.97057l-39.598-50.91169A19.93738,19.93738,0,0,0,151.88746,88h-48a19.93739,19.93739,0,0,0-14.14213,5.85786l-39.598,50.91169A12,12,0,1,0,67.1179,161.74012L101.86446,134.715,74.13088,222.3089a12,12,0,0,0,21.75139,10.14284l32.0052-50.37108h0l32.0052,50.37108A12,12,0,0,0,181.644,222.3089Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('circle', {
    attrs: {
      "cx": "127.88745",
      "cy": "44",
      "r": "36"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M211.67456,139.51367,172.34448,88.94629a7.93269,7.93269,0,0,0-.65723-.74512A27.81868,27.81868,0,0,0,151.88745,80h-48a27.81872,27.81872,0,0,0-19.79981,8.20117,7.93259,7.93259,0,0,0-.65722.74512L44.09936,139.51416A20.00055,20.00055,0,0,0,72.37378,167.7876l14.09961-10.96729-19.832,62.64014a20.00009,20.00009,0,0,0,36.23731,16.897l25.00879-39.35937,25.00879,39.35937a20.00007,20.00007,0,0,0,36.2373-16.897l-19.832-62.64014,14.09961,10.96729a20.00035,20.00035,0,0,0,28.27344-28.27393Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "127.88745",
      "cy": "44",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M153.91044,134.715,188.657,161.74012a12,12,0,1,0,16.97056-16.97057l-39.598-50.91169A19.93738,19.93738,0,0,0,151.88746,88h-48a19.93739,19.93739,0,0,0-14.14213,5.85786l-39.598,50.91169A12,12,0,1,0,67.1179,161.74012L101.86446,134.715,74.13088,222.3089a12,12,0,0,0,21.75139,10.14284l32.0052-50.37108h0l32.0052,50.37108A12,12,0,0,0,181.644,222.3089Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "127.88745",
      "cy": "44",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M153.91044,134.715,188.657,161.74012a12,12,0,1,0,16.97056-16.97057l-39.598-50.91169A19.93738,19.93738,0,0,0,151.88746,88h-48a19.93739,19.93739,0,0,0-14.14213,5.85786l-39.598,50.91169A12,12,0,1,0,67.1179,161.74012L101.86446,134.715,74.13088,222.3089a12,12,0,0,0,21.75139,10.14284l32.0052-50.37108h0l32.0052,50.37108A12,12,0,0,0,181.644,222.3089Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "127.88745",
      "cy": "44",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M153.91044,134.715,188.657,161.74012a12,12,0,1,0,16.97056-16.97057l-39.598-50.91169A19.93738,19.93738,0,0,0,151.88746,88h-48a19.93739,19.93739,0,0,0-14.14213,5.85786l-39.598,50.91169A12,12,0,1,0,67.1179,161.74012L101.86446,134.715,74.13088,222.3089a12,12,0,0,0,21.75139,10.14284l32.0052-50.37108h0l32.0052,50.37108A12,12,0,0,0,181.644,222.3089Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9T = [];
/* style */

const __vue_inject_styles__$9T = undefined;
/* scoped */

const __vue_scope_id__$9T = undefined;
/* module identifier */

const __vue_module_identifier__$9T = undefined;
/* functional template */

const __vue_is_functional_template__$9T = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9T = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9T,
  staticRenderFns: __vue_staticRenderFns__$9T
}, __vue_inject_styles__$9T, __vue_script__$9T, __vue_scope_id__$9T, __vue_is_functional_template__$9T, __vue_module_identifier__$9T, false, undefined, undefined, undefined);

var script$9U = Vue.extend({
  name: "PhPersonSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9U = script$9U;
/* template */

var __vue_render__$9U = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "127.88745",
      "cy": "48",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "108",
      "x2": "128",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 224 128 152 192 224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,132s40-24,96-24,96,24,96,24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "127.88745",
      "cy": "48",
      "r": "24",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "127.88745",
      "cy": "48",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "104",
      "x2": "128",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 224 128 152 192 224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,128s40-24,96-24,96,24,96,24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M95.8877,48a32,32,0,1,1,32,32A32.03635,32.03635,0,0,1,95.8877,48Zm132.22851,73.13965C226.40527,120.11328,185.5542,96,128,96S29.59473,120.11328,27.88379,121.13965a8.00047,8.00047,0,0,0,8.23242,13.7207c.36133-.21686,34.9165-20.59765,83.88379-22.676v36.77447L58.02051,218.68555a7.99985,7.99985,0,1,0,11.959,10.6289L128,164.042l58.02051,65.27246a7.99985,7.99985,0,1,0,11.959-10.6289L136,148.95886V112.18567c48.769,2.08642,83.5293,22.46252,83.88379,22.67468a8.00047,8.00047,0,0,0,8.23242-13.7207Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "127.88745",
      "cy": "48",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "104",
      "x2": "128",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 224 128 152 192 224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,128s40-24,96-24,96,24,96,24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "127.88745",
      "cy": "48",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "104",
      "x2": "128",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 224 128 152 192 224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,128s40-24,96-24,96,24,96,24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "127.88745",
      "cy": "48",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "104",
      "x2": "128",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 224 128 152 192 224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,128s40-24,96-24,96,24,96,24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9U = [];
/* style */

const __vue_inject_styles__$9U = undefined;
/* scoped */

const __vue_scope_id__$9U = undefined;
/* module identifier */

const __vue_module_identifier__$9U = undefined;
/* functional template */

const __vue_is_functional_template__$9U = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9U = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9U,
  staticRenderFns: __vue_staticRenderFns__$9U
}, __vue_inject_styles__$9U, __vue_script__$9U, __vue_scope_id__$9U, __vue_is_functional_template__$9U, __vue_module_identifier__$9U, false, undefined, undefined, undefined);

var script$9V = Vue.extend({
  name: "PhPersonSimpleRun",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9V = script$9V;
/* template */

var __vue_render__$9V = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "152",
      "cy": "56",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,109.551s32-29.551,80,8c50.46853,39.48219,80,24,80,24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M110.64453,161.16016C128.46874,164.96875,176,180,176,232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M131.742,120.40547C121.75874,149.3673,91.80634,205.98063,32,200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "152",
      "cy": "56",
      "r": "24",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "152",
      "cy": "56",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,101.551s32-29.551,80,8c50.46853,39.48219,80,24,80,24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M135.07558,108.83476C130.73311,129.2401,101.55844,206.95584,32,200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M110.64453,161.16016C128.46874,164.96875,176,180,176,232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M120,56a32,32,0,1,1,32,32A32.03667,32.03667,0,0,1,120,56Zm104,77.551a7.99494,7.99494,0,0,0-11.71338-7.08265l-.00146-.00256.11621-.05957c-.06348.03027-6.48926,3.05566-18.22754,1.85059-11.165-1.13965-29.46582-6.4043-53.24463-25.00684-14.99365-11.73047-38.3457-24.65918-64.44092-19.63672C60.7041,86.65039,51.563,94.75879,50.57227,95.67383a7.99984,7.99984,0,0,0,10.80957,11.7959c1.07714-.96436,25.82421-22.34973,64.61084,4.636a149.52,149.52,0,0,1-21.84522,44.39148c-.02588.03552-.05273.06946-.07812.10559-.77246,1.05445-1.56006,2.104-2.374,3.14331C82.8125,183.85742,59.63184,194.71777,32.7959,192.04A7.99965,7.99965,0,1,0,31.2041,207.96q4.87208.4878,9.50195.48145c32.63331,0,56.58155-17.4513,73.14649-38.29175C133.30127,175.27991,168,190.28955,168,232a8,8,0,0,0,16,0c0-24.65332-10.08008-45.35254-29.15039-59.85938a104.37686,104.37686,0,0,0-31.29541-15.8081,165.70877,165.70877,0,0,0,16.08447-34.14417c25.72168,17.94129,46.18653,22.30079,59.99414,22.29993,12.4209-.001,19.458-3.52539,20.082-3.85254l-.00146-.0022A7.99461,7.99461,0,0,0,224,133.551Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "152",
      "cy": "56",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,101.551s32-29.551,80,8c50.46853,39.48219,80,24,80,24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M135.07558,108.83476C130.73311,129.2401,101.55844,206.95584,32,200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M110.64453,161.16016C128.46874,164.96875,176,180,176,232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "152",
      "cy": "56",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,101.551s32-29.551,80,8c50.46853,39.48219,80,24,80,24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M135.07558,108.83476C130.73311,129.2401,101.55844,206.95584,32,200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M110.64453,161.16016C128.46874,164.96875,176,180,176,232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "152",
      "cy": "56",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,101.551s32-29.551,80,8c50.46853,39.48219,80,24,80,24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M135.07558,108.83476C130.73311,129.2401,101.55844,206.95584,32,200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M110.64453,161.16016C128.46874,164.96875,176,180,176,232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9V = [];
/* style */

const __vue_inject_styles__$9V = undefined;
/* scoped */

const __vue_scope_id__$9V = undefined;
/* module identifier */

const __vue_module_identifier__$9V = undefined;
/* functional template */

const __vue_is_functional_template__$9V = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9V = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9V,
  staticRenderFns: __vue_staticRenderFns__$9V
}, __vue_inject_styles__$9V, __vue_script__$9V, __vue_scope_id__$9V, __vue_is_functional_template__$9V, __vue_module_identifier__$9V, false, undefined, undefined, undefined);

var script$9W = Vue.extend({
  name: "PhPersonSimpleWalk",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9W = script$9W;
/* template */

var __vue_render__$9W = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "152",
      "cy": "48",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M44,132s56-56,88-26.449C149.94081,122.11882,164,148,204,148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 232 152 176 109.536 145.668",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128.27612",
      "y1": "102.56493",
      "x2": "72",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "152",
      "cy": "48",
      "r": "24",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "152",
      "cy": "48",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,128s56-56,88-26.449C153.94081,118.11882,168,144,208,144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "130.51056",
      "y1": "97.4257",
      "x2": "72",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 232 152 176 109.536 145.668",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M120,48a32,32,0,1,1,32,32A32.03667,32.03667,0,0,1,120,48Zm88,88c-28.49561,0-41.65088-14.13086-55.57861-29.09277-3.52686-3.78809-7.17383-7.70606-10.99366-11.2334-37.2207-34.374-96.57617,24.16113-99.085,26.66894a8.00019,8.00019,0,0,0,11.31055,11.31739A165.05558,165.05558,0,0,1,84.21191,110.501c14.32227-8.15454,26.27442-11.08594,35.71534-8.79737l-17.69483,40.698-.02441.05567L64.66309,228.81055a8.00018,8.00018,0,1,0,14.67382,6.3789l33.59327-77.26538L144,180.11719V232a8,8,0,0,0,16,0V176a8.00054,8.00054,0,0,0-3.3501-6.50977L119.45312,142.9209,133.6084,110.364c2.33789,2.33814,4.67285,4.83619,7.10205,7.44556C154.89111,133.042,172.53906,152,208,152a8,8,0,0,0,0-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "152",
      "cy": "48",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,128s56-56,88-26.449C153.94081,118.11882,168,144,208,144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "130.51056",
      "y1": "97.4257",
      "x2": "72",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 232 152 176 109.536 145.668",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "152",
      "cy": "48",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,128s56-56,88-26.449C153.94081,118.11882,168,144,208,144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "130.51056",
      "y1": "97.4257",
      "x2": "72",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 232 152 176 109.536 145.668",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "152",
      "cy": "48",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,128s56-56,88-26.449C153.94081,118.11882,168,144,208,144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "130.51056",
      "y1": "97.4257",
      "x2": "72",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 232 152 176 109.536 145.668",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9W = [];
/* style */

const __vue_inject_styles__$9W = undefined;
/* scoped */

const __vue_scope_id__$9W = undefined;
/* module identifier */

const __vue_module_identifier__$9W = undefined;
/* functional template */

const __vue_is_functional_template__$9W = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9W = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9W,
  staticRenderFns: __vue_staticRenderFns__$9W
}, __vue_inject_styles__$9W, __vue_script__$9W, __vue_scope_id__$9W, __vue_is_functional_template__$9W, __vue_module_identifier__$9W, false, undefined, undefined, undefined);

var script$9X = Vue.extend({
  name: "PhPhone",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9X = script$9X;
/* template */

var __vue_render__$9X = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.47629,124.81528a84.34782,84.34782,0,0,0,39.05334,38.8759,7.92754,7.92754,0,0,0,7.8287-.59231L164.394,146.40453a8,8,0,0,1,7.58966-.69723l46.837,20.073A7.97345,7.97345,0,0,1,223.619,174.077,48.00882,48.00882,0,0,1,176,216,136,136,0,0,1,40,80,48.00882,48.00882,0,0,1,81.923,32.381a7.97345,7.97345,0,0,1,8.29668,4.79823L110.31019,84.0571a8,8,0,0,1-.65931,7.53226L93.01449,117.00909A7.9287,7.9287,0,0,0,92.47629,124.81528Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.47629,124.81528a84.34782,84.34782,0,0,0,39.05334,38.8759,7.92754,7.92754,0,0,0,7.8287-.59231L164.394,146.40453a8,8,0,0,1,7.58966-.69723l46.837,20.073A7.97345,7.97345,0,0,1,223.619,174.077,48.00882,48.00882,0,0,1,176,216,136,136,0,0,1,40,80,48.00882,48.00882,0,0,1,81.923,32.381a7.97345,7.97345,0,0,1,8.29668,4.79823L110.31019,84.0571a8,8,0,0,1-.65931,7.53226L93.01449,117.00909A7.9287,7.9287,0,0,0,92.47629,124.81528Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.47629,124.81528a84.34782,84.34782,0,0,0,39.05334,38.8759,7.92754,7.92754,0,0,0,7.8287-.59231L164.394,146.40453a8,8,0,0,1,7.58966-.69723l46.837,20.073A7.97345,7.97345,0,0,1,223.619,174.077,48.00882,48.00882,0,0,1,176,216,136,136,0,0,1,40,80,48.00882,48.00882,0,0,1,81.923,32.381a7.97345,7.97345,0,0,1,8.29668,4.79823L110.31019,84.0571a8,8,0,0,1-.65931,7.53226L93.01449,117.00909A7.9287,7.9287,0,0,0,92.47629,124.81528Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M221.97168,158.42676l-46.83789-20.07324a15.95139,15.95139,0,0,0-15.17871,1.39453l-25.043,16.69336A76.54083,76.54083,0,0,1,99.707,121.3916l.00195-.00195,16.63477-25.418a15.96924,15.96924,0,0,0,1.32031-15.06641L97.57227,34.02734a16.02839,16.02839,0,0,0-16.65235-9.583A56.07029,56.07029,0,0,0,32,80c0,79.40234,64.59766,144,144,144a56.07032,56.07032,0,0,0,55.55566-48.9209A16.03476,16.03476,0,0,0,221.97168,158.42676Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.47629,124.81528a84.34782,84.34782,0,0,0,39.05334,38.8759,7.92754,7.92754,0,0,0,7.8287-.59231L164.394,146.40453a8,8,0,0,1,7.58966-.69723l46.837,20.073A7.97345,7.97345,0,0,1,223.619,174.077,48.00882,48.00882,0,0,1,176,216,136,136,0,0,1,40,80,48.00882,48.00882,0,0,1,81.923,32.381a7.97345,7.97345,0,0,1,8.29668,4.79823L110.31019,84.0571a8,8,0,0,1-.65931,7.53226L93.01449,117.00909A7.9287,7.9287,0,0,0,92.47629,124.81528Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.47629,124.81528a84.34782,84.34782,0,0,0,39.05334,38.8759,7.92754,7.92754,0,0,0,7.8287-.59231L164.394,146.40453a8,8,0,0,1,7.58966-.69723l46.837,20.073A7.97345,7.97345,0,0,1,223.619,174.077,48.00882,48.00882,0,0,1,176,216,136,136,0,0,1,40,80,48.00882,48.00882,0,0,1,81.923,32.381a7.97345,7.97345,0,0,1,8.29668,4.79823L110.31019,84.0571a8,8,0,0,1-.65931,7.53226L93.01449,117.00909A7.9287,7.9287,0,0,0,92.47629,124.81528Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.47629,124.81528a84.34782,84.34782,0,0,0,39.05334,38.8759,7.92754,7.92754,0,0,0,7.8287-.59231L164.394,146.40453a8,8,0,0,1,7.58966-.69723l46.837,20.073A7.97345,7.97345,0,0,1,223.619,174.077,48.00882,48.00882,0,0,1,176,216,136,136,0,0,1,40,80,48.00882,48.00882,0,0,1,81.923,32.381a7.97345,7.97345,0,0,1,8.29668,4.79823L110.31019,84.0571a8,8,0,0,1-.65931,7.53226L93.01449,117.00909A7.9287,7.9287,0,0,0,92.47629,124.81528Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9X = [];
/* style */

const __vue_inject_styles__$9X = undefined;
/* scoped */

const __vue_scope_id__$9X = undefined;
/* module identifier */

const __vue_module_identifier__$9X = undefined;
/* functional template */

const __vue_is_functional_template__$9X = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9X = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9X,
  staticRenderFns: __vue_staticRenderFns__$9X
}, __vue_inject_styles__$9X, __vue_script__$9X, __vue_scope_id__$9X, __vue_is_functional_template__$9X, __vue_module_identifier__$9X, false, undefined, undefined, undefined);

var script$9Y = Vue.extend({
  name: "PhPhoneCall",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9Y = script$9Y;
/* template */

var __vue_render__$9Y = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M159.41743,40A80.14832,80.14832,0,0,1,216,96.58261",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.47629,124.81528a84.34782,84.34782,0,0,0,39.05334,38.8759,7.92754,7.92754,0,0,0,7.8287-.59231L164.394,146.40453a8,8,0,0,1,7.58966-.69723l46.837,20.073A7.97345,7.97345,0,0,1,223.619,174.077,48.00882,48.00882,0,0,1,176,216,136,136,0,0,1,40,80,48.00882,48.00882,0,0,1,81.923,32.381a7.97345,7.97345,0,0,1,8.29668,4.79823L110.31019,84.0571a8,8,0,0,1-.65931,7.53226L93.01449,117.00909A7.9287,7.9287,0,0,0,92.47629,124.81528Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M149.229,78.02345a44.10448,44.10448,0,0,1,28.74753,28.74747",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.47629,124.81528a84.34782,84.34782,0,0,0,39.05334,38.8759,7.92754,7.92754,0,0,0,7.8287-.59231L164.394,146.40453a8,8,0,0,1,7.58966-.69723l46.837,20.073A7.97345,7.97345,0,0,1,223.619,174.077,48.00882,48.00882,0,0,1,176,216,136,136,0,0,1,40,80,48.00882,48.00882,0,0,1,81.923,32.381a7.97345,7.97345,0,0,1,8.29668,4.79823L110.31019,84.0571a8,8,0,0,1-.65931,7.53226L93.01449,117.00909A7.9287,7.9287,0,0,0,92.47629,124.81528Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.47629,124.81528a84.34782,84.34782,0,0,0,39.05334,38.8759,7.92754,7.92754,0,0,0,7.8287-.59231L164.394,146.40453a8,8,0,0,1,7.58966-.69723l46.837,20.073A7.97345,7.97345,0,0,1,223.619,174.077,48.00882,48.00882,0,0,1,176,216,136,136,0,0,1,40,80,48.00882,48.00882,0,0,1,81.923,32.381a7.97345,7.97345,0,0,1,8.29668,4.79823L110.31019,84.0571a8,8,0,0,1-.65931,7.53226L93.01449,117.00909A7.9287,7.9287,0,0,0,92.47629,124.81528Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M159.41743,40A80.14832,80.14832,0,0,1,216,96.58261",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M151.13313,70.91728a48.089,48.089,0,0,1,33.94958,33.9496",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M221.97168,158.42676l-46.83789-20.07324a15.95139,15.95139,0,0,0-15.17871,1.39453l-25.043,16.69336A76.54083,76.54083,0,0,1,99.707,121.3916l.00195-.00195,16.63477-25.418a15.96924,15.96924,0,0,0,1.32031-15.06641L97.57227,34.02734a16.02839,16.02839,0,0,0-16.65235-9.583A56.07029,56.07029,0,0,0,32,80c0,79.40234,64.59766,144,144,144a56.07032,56.07032,0,0,0,55.55566-48.9209A16.03476,16.03476,0,0,0,221.97168,158.42676Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M157.35156,47.72852a72.12078,72.12078,0,0,1,50.91992,50.91992,7.99975,7.99975,0,0,0,15.457-4.13086,88.16381,88.16381,0,0,0-62.2461-62.2461,7.99975,7.99975,0,0,0-4.13086,15.457Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M149.06738,78.64551a40.06626,40.06626,0,0,1,28.28711,28.28711,7.99975,7.99975,0,0,0,15.457-4.13086,56.10589,56.10589,0,0,0-39.61328-39.61328,7.99975,7.99975,0,0,0-4.13086,15.457Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M159.41743,40A80.14832,80.14832,0,0,1,216,96.58261",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M151.13313,70.91728a48.089,48.089,0,0,1,33.94958,33.9496",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.47629,124.81528a84.34782,84.34782,0,0,0,39.05334,38.8759,7.92754,7.92754,0,0,0,7.8287-.59231L164.394,146.40453a8,8,0,0,1,7.58966-.69723l46.837,20.073A7.97345,7.97345,0,0,1,223.619,174.077,48.00882,48.00882,0,0,1,176,216,136,136,0,0,1,40,80,48.00882,48.00882,0,0,1,81.923,32.381a7.97345,7.97345,0,0,1,8.29668,4.79823L110.31019,84.0571a8,8,0,0,1-.65931,7.53226L93.01449,117.00909A7.9287,7.9287,0,0,0,92.47629,124.81528Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M159.41743,40A80.14832,80.14832,0,0,1,216,96.58261",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M151.13313,70.91728a48.089,48.089,0,0,1,33.94958,33.9496",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.47629,124.81528a84.34782,84.34782,0,0,0,39.05334,38.8759,7.92754,7.92754,0,0,0,7.8287-.59231L164.394,146.40453a8,8,0,0,1,7.58966-.69723l46.837,20.073A7.97345,7.97345,0,0,1,223.619,174.077,48.00882,48.00882,0,0,1,176,216,136,136,0,0,1,40,80,48.00882,48.00882,0,0,1,81.923,32.381a7.97345,7.97345,0,0,1,8.29668,4.79823L110.31019,84.0571a8,8,0,0,1-.65931,7.53226L93.01449,117.00909A7.9287,7.9287,0,0,0,92.47629,124.81528Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M159.41743,40A80.14832,80.14832,0,0,1,216,96.58261",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M151.13313,70.91728a48.089,48.089,0,0,1,33.94958,33.9496",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.47629,124.81528a84.34782,84.34782,0,0,0,39.05334,38.8759,7.92754,7.92754,0,0,0,7.8287-.59231L164.394,146.40453a8,8,0,0,1,7.58966-.69723l46.837,20.073A7.97345,7.97345,0,0,1,223.619,174.077,48.00882,48.00882,0,0,1,176,216,136,136,0,0,1,40,80,48.00882,48.00882,0,0,1,81.923,32.381a7.97345,7.97345,0,0,1,8.29668,4.79823L110.31019,84.0571a8,8,0,0,1-.65931,7.53226L93.01449,117.00909A7.9287,7.9287,0,0,0,92.47629,124.81528Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9Y = [];
/* style */

const __vue_inject_styles__$9Y = undefined;
/* scoped */

const __vue_scope_id__$9Y = undefined;
/* module identifier */

const __vue_module_identifier__$9Y = undefined;
/* functional template */

const __vue_is_functional_template__$9Y = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9Y = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9Y,
  staticRenderFns: __vue_staticRenderFns__$9Y
}, __vue_inject_styles__$9Y, __vue_script__$9Y, __vue_scope_id__$9Y, __vue_is_functional_template__$9Y, __vue_module_identifier__$9Y, false, undefined, undefined, undefined);

var script$9Z = Vue.extend({
  name: "PhPhoneDisconnect",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9Z = script$9Z;
/* template */

var __vue_render__$9Z = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M155.371,101.25063a84.3478,84.3478,0,0,0-55.10429.12547,7.92755,7.92755,0,0,0-5.1169,5.95455l-5.89824,29.5076a8,8,0,0,1-4.87369,5.85972L37.06532,161.623a7.97345,7.97345,0,0,1-9.2595-2.47378,48.00881,48.00881,0,0,1,4.02766-63.31573,136,136,0,0,1,192.333,0,48.00881,48.00881,0,0,1,4.02766,63.31573,7.97345,7.97345,0,0,1-9.2595,2.47378l-47.35377-18.94151a8,8,0,0,1-4.85991-5.79231L160.51024,107.151A7.9287,7.9287,0,0,0,155.371,101.25063Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "200",
      "x2": "216",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M155.371,101.25063a84.3478,84.3478,0,0,0-55.10429.12547,7.92755,7.92755,0,0,0-5.1169,5.95455l-5.89824,29.5076a8,8,0,0,1-4.87369,5.85972L37.06532,161.623a7.97345,7.97345,0,0,1-9.2595-2.47378,48.00881,48.00881,0,0,1,4.02766-63.31573,136,136,0,0,1,192.333,0,48.00881,48.00881,0,0,1,4.02766,63.31573,7.97345,7.97345,0,0,1-9.2595,2.47378l-47.35377-18.94151a8,8,0,0,1-4.85991-5.79231L160.51024,107.151A7.9287,7.9287,0,0,0,155.371,101.25063Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M155.371,101.25063a84.3478,84.3478,0,0,0-55.10429.12547,7.92755,7.92755,0,0,0-5.1169,5.95455l-5.89824,29.5076a8,8,0,0,1-4.87369,5.85972L37.06532,161.623a7.97345,7.97345,0,0,1-9.2595-2.47378,48.00881,48.00881,0,0,1,4.02766-63.31573,136,136,0,0,1,192.333,0,48.00881,48.00881,0,0,1,4.02766,63.31573,7.97345,7.97345,0,0,1-9.2595,2.47378l-47.35377-18.94151a8,8,0,0,1-4.85991-5.79231L160.51024,107.151A7.9287,7.9287,0,0,0,155.371,101.25063Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "200",
      "x2": "216",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M229.82422,90.17578c-56.14551-56.14355-147.501-56.14648-203.64844.001a56.07211,56.07211,0,0,0-4.69043,73.87695,16.03254,16.03254,0,0,0,18.55078,4.99707L87.35059,150.125a15.94917,15.94917,0,0,0,9.74609-11.71875l5.90527-29.51172a76.51611,76.51611,0,0,1,49.67676-.10937v.00195l6.21094,29.73828a15.963,15.963,0,0,0,9.7207,11.584l47.35254,18.9414a16.03618,16.03618,0,0,0,18.55273-4.99805A56.07343,56.07343,0,0,0,229.82422,90.17578Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,192H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M155.371,101.25063a84.3478,84.3478,0,0,0-55.10429.12547,7.92755,7.92755,0,0,0-5.1169,5.95455l-5.89824,29.5076a8,8,0,0,1-4.87369,5.85972L37.06532,161.623a7.97345,7.97345,0,0,1-9.2595-2.47378,48.00881,48.00881,0,0,1,4.02766-63.31573,136,136,0,0,1,192.333,0,48.00881,48.00881,0,0,1,4.02766,63.31573,7.97345,7.97345,0,0,1-9.2595,2.47378l-47.35377-18.94151a8,8,0,0,1-4.85991-5.79231L160.51024,107.151A7.9287,7.9287,0,0,0,155.371,101.25063Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "200",
      "x2": "216",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M155.371,101.25063a84.3478,84.3478,0,0,0-55.10429.12547,7.92755,7.92755,0,0,0-5.1169,5.95455l-5.89824,29.5076a8,8,0,0,1-4.87369,5.85972L37.06532,161.623a7.97345,7.97345,0,0,1-9.2595-2.47378,48.00881,48.00881,0,0,1,4.02766-63.31573,136,136,0,0,1,192.333,0,48.00881,48.00881,0,0,1,4.02766,63.31573,7.97345,7.97345,0,0,1-9.2595,2.47378l-47.35377-18.94151a8,8,0,0,1-4.85991-5.79231L160.51024,107.151A7.9287,7.9287,0,0,0,155.371,101.25063Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "200",
      "x2": "216",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M155.371,101.25063a84.3478,84.3478,0,0,0-55.10429.12547,7.92755,7.92755,0,0,0-5.1169,5.95455l-5.89824,29.5076a8,8,0,0,1-4.87369,5.85972L37.06532,161.623a7.97345,7.97345,0,0,1-9.2595-2.47378,48.00881,48.00881,0,0,1,4.02766-63.31573,136,136,0,0,1,192.333,0,48.00881,48.00881,0,0,1,4.02766,63.31573,7.97345,7.97345,0,0,1-9.2595,2.47378l-47.35377-18.94151a8,8,0,0,1-4.85991-5.79231L160.51024,107.151A7.9287,7.9287,0,0,0,155.371,101.25063Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "200",
      "x2": "216",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9Z = [];
/* style */

const __vue_inject_styles__$9Z = undefined;
/* scoped */

const __vue_scope_id__$9Z = undefined;
/* module identifier */

const __vue_module_identifier__$9Z = undefined;
/* functional template */

const __vue_is_functional_template__$9Z = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9Z = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9Z,
  staticRenderFns: __vue_staticRenderFns__$9Z
}, __vue_inject_styles__$9Z, __vue_script__$9Z, __vue_scope_id__$9Z, __vue_is_functional_template__$9Z, __vue_module_identifier__$9Z, false, undefined, undefined, undefined);

var script$9_ = Vue.extend({
  name: "PhPhoneIncoming",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9_ = script$9_;
/* template */

var __vue_render__$9_ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.47629,124.81528a84.34782,84.34782,0,0,0,39.05334,38.8759,7.92754,7.92754,0,0,0,7.8287-.59231L164.394,146.40453a8,8,0,0,1,7.58966-.69723l46.837,20.073A7.97345,7.97345,0,0,1,223.619,174.077,48.00882,48.00882,0,0,1,176,216,136,136,0,0,1,40,80,48.00882,48.00882,0,0,1,81.923,32.381a7.97345,7.97345,0,0,1,8.29668,4.79823L110.31019,84.0571a8,8,0,0,1-.65931,7.53226L93.01449,117.00909A7.9287,7.9287,0,0,0,92.47629,124.81528Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 56 160 96 200 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "96",
      "x2": "208",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.47629,124.81528a84.34782,84.34782,0,0,0,39.05334,38.8759,7.92754,7.92754,0,0,0,7.8287-.59231L164.394,146.40453a8,8,0,0,1,7.58966-.69723l46.837,20.073A7.97345,7.97345,0,0,1,223.619,174.077,48.00882,48.00882,0,0,1,176,216,136,136,0,0,1,40,80,48.00882,48.00882,0,0,1,81.923,32.381a7.97345,7.97345,0,0,1,8.29668,4.79823L110.31019,84.0571a8,8,0,0,1-.65931,7.53226L93.01449,117.00909A7.9287,7.9287,0,0,0,92.47629,124.81528Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.47629,124.81528a84.34782,84.34782,0,0,0,39.05334,38.8759,7.92754,7.92754,0,0,0,7.8287-.59231L164.394,146.40453a8,8,0,0,1,7.58966-.69723l46.837,20.073A7.97345,7.97345,0,0,1,223.619,174.077,48.00882,48.00882,0,0,1,176,216,136,136,0,0,1,40,80,48.00882,48.00882,0,0,1,81.923,32.381a7.97345,7.97345,0,0,1,8.29668,4.79823L110.31019,84.0571a8,8,0,0,1-.65931,7.53226L93.01449,117.00909A7.9287,7.9287,0,0,0,92.47629,124.81528Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 56 160 96 200 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "96",
      "x2": "208",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M221.97168,158.42676l-46.83789-20.07324a15.94874,15.94874,0,0,0-15.17871,1.39453l-25.043,16.69336A76.54083,76.54083,0,0,1,99.707,121.3916l.00195-.00195,16.63477-25.418a15.96924,15.96924,0,0,0,1.32031-15.06641L97.57227,34.02734a16.036,16.036,0,0,0-16.65235-9.583A56.07029,56.07029,0,0,0,32,80c0,79.40234,64.59766,144,144,144a56.07032,56.07032,0,0,0,55.55566-48.9209A16.03476,16.03476,0,0,0,221.97168,158.42676Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152.08594,97.10889c.021.15283.03955.30566.06933.45752.02491.125.05957.24609.09034.36914.03271.13037.06152.26123.10058.39013.03662.12061.082.23682.124.355.04541.12891.08838.25782.14063.38477.04492.10742.09766.21094.147.31641.06153.13183.12061.26464.18994.39355.05176.09717.11133.189.167.2832.07666.13037.15087.26172.23584.38819.0664.09863.14062.1914.21093.28662.084.11474.16407.231.25537.3418.11622.14111.2417.27343.36719.40625.0542.0581.10205.11914.15869.17578.0542.0542.11377.10058.16895.15283.13525.12744.27.25537.41406.37353.10645.08789.21826.16455.32813.24561.10009.07422.19726.15185.30078.22119.12207.08154.248.15234.37353.22656.09912.05909.19629.12159.29834.17627.124.0669.25147.12305.37842.18262.11035.05176.21875.10693.332.15381.1211.05029.24463.09082.36768.13476.12353.04444.2456.0918.37207.13038.12158.03662.24512.06347.36816.09472.13037.03272.25879.06885.3916.09522.14063.02832.28321.04492.42481.06494.1167.0166.231.03857.34912.05029.26221.02588.52588.04.78955.04h40a8,8,0,0,0,0-16H179.31445l34.34278-34.34277a8.00053,8.00053,0,0,0-11.31446-11.31446L168,76.68555V56a8,8,0,0,0-16,0V95.99512c0,.26562.01367.53174.04.79687C152.05078,96.89941,152.07129,97.00293,152.08594,97.10889Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.47629,124.81528a84.34782,84.34782,0,0,0,39.05334,38.8759,7.92754,7.92754,0,0,0,7.8287-.59231L164.394,146.40453a8,8,0,0,1,7.58966-.69723l46.837,20.073A7.97345,7.97345,0,0,1,223.619,174.077,48.00882,48.00882,0,0,1,176,216,136,136,0,0,1,40,80,48.00882,48.00882,0,0,1,81.923,32.381a7.97345,7.97345,0,0,1,8.29668,4.79823L110.31019,84.0571a8,8,0,0,1-.65931,7.53226L93.01449,117.00909A7.9287,7.9287,0,0,0,92.47629,124.81528Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 56 160 96 200 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "96",
      "x2": "208",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.47629,124.81528a84.34782,84.34782,0,0,0,39.05334,38.8759,7.92754,7.92754,0,0,0,7.8287-.59231L164.394,146.40453a8,8,0,0,1,7.58966-.69723l46.837,20.073A7.97345,7.97345,0,0,1,223.619,174.077,48.00882,48.00882,0,0,1,176,216,136,136,0,0,1,40,80,48.00882,48.00882,0,0,1,81.923,32.381a7.97345,7.97345,0,0,1,8.29668,4.79823L110.31019,84.0571a8,8,0,0,1-.65931,7.53226L93.01449,117.00909A7.9287,7.9287,0,0,0,92.47629,124.81528Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 56 160 96 200 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "96",
      "x2": "208",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.47629,124.81528a84.34782,84.34782,0,0,0,39.05334,38.8759,7.92754,7.92754,0,0,0,7.8287-.59231L164.394,146.40453a8,8,0,0,1,7.58966-.69723l46.837,20.073A7.97345,7.97345,0,0,1,223.619,174.077,48.00882,48.00882,0,0,1,176,216,136,136,0,0,1,40,80,48.00882,48.00882,0,0,1,81.923,32.381a7.97345,7.97345,0,0,1,8.29668,4.79823L110.31019,84.0571a8,8,0,0,1-.65931,7.53226L93.01449,117.00909A7.9287,7.9287,0,0,0,92.47629,124.81528Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 56 160 96 200 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "96",
      "x2": "208",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9_ = [];
/* style */

const __vue_inject_styles__$9_ = undefined;
/* scoped */

const __vue_scope_id__$9_ = undefined;
/* module identifier */

const __vue_module_identifier__$9_ = undefined;
/* functional template */

const __vue_is_functional_template__$9_ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9_ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9_,
  staticRenderFns: __vue_staticRenderFns__$9_
}, __vue_inject_styles__$9_, __vue_script__$9_, __vue_scope_id__$9_, __vue_is_functional_template__$9_, __vue_module_identifier__$9_, false, undefined, undefined, undefined);

var script$9$ = Vue.extend({
  name: "PhPhoneOutgoing",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9$ = script$9$;
/* template */

var __vue_render__$9$ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.47629,124.81528a84.34782,84.34782,0,0,0,39.05334,38.8759,7.92754,7.92754,0,0,0,7.8287-.59231L164.394,146.40453a8,8,0,0,1,7.58966-.69723l46.837,20.073A7.97345,7.97345,0,0,1,223.619,174.077,48.00882,48.00882,0,0,1,176,216,136,136,0,0,1,40,80,48.00882,48.00882,0,0,1,81.923,32.381a7.97345,7.97345,0,0,1,8.29668,4.79823L110.31019,84.0571a8,8,0,0,1-.65931,7.53226L93.01449,117.00909A7.9287,7.9287,0,0,0,92.47629,124.81528Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "168 48 208 48 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "96",
      "x2": "208",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.47629,124.81528a84.34782,84.34782,0,0,0,39.05334,38.8759,7.92754,7.92754,0,0,0,7.8287-.59231L164.394,146.40453a8,8,0,0,1,7.58966-.69723l46.837,20.073A7.97345,7.97345,0,0,1,223.619,174.077,48.00882,48.00882,0,0,1,176,216,136,136,0,0,1,40,80,48.00882,48.00882,0,0,1,81.923,32.381a7.97345,7.97345,0,0,1,8.29668,4.79823L110.31019,84.0571a8,8,0,0,1-.65931,7.53226L93.01449,117.00909A7.9287,7.9287,0,0,0,92.47629,124.81528Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.47629,124.81528a84.34782,84.34782,0,0,0,39.05334,38.8759,7.92754,7.92754,0,0,0,7.8287-.59231L164.394,146.40453a8,8,0,0,1,7.58966-.69723l46.837,20.073A7.97345,7.97345,0,0,1,223.619,174.077,48.00882,48.00882,0,0,1,176,216,136,136,0,0,1,40,80,48.00882,48.00882,0,0,1,81.923,32.381a7.97345,7.97345,0,0,1,8.29668,4.79823L110.31019,84.0571a8,8,0,0,1-.65931,7.53226L93.01449,117.00909A7.9287,7.9287,0,0,0,92.47629,124.81528Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "168 48 208 48 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "96",
      "x2": "208",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M221.97168,158.42676l-46.83789-20.07324a15.95139,15.95139,0,0,0-15.17871,1.39453l-25.043,16.69336A76.54083,76.54083,0,0,1,99.707,121.3916l.00195-.00195,16.63477-25.418a15.96924,15.96924,0,0,0,1.32031-15.06641L97.57227,34.02734a16.02839,16.02839,0,0,0-16.65235-9.583A56.07029,56.07029,0,0,0,32,80c0,79.40234,64.59766,144,144,144a56.07032,56.07032,0,0,0,55.55566-48.9209A16.03476,16.03476,0,0,0,221.97168,158.42676Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160,104a7.97772,7.97772,0,0,0,5.65723-2.34277L200,67.31445V88a8,8,0,0,0,16,0V48.00488c0-.26562-.01367-.53174-.04-.79687-.01074-.10742-.03125-.21094-.0459-.3169-.021-.15283-.03955-.30566-.06933-.45752-.02491-.125-.05957-.24609-.09034-.36914-.03271-.13037-.06152-.26123-.10058-.39013-.03662-.12061-.082-.23682-.124-.355-.04541-.12891-.08838-.25782-.14063-.38477-.04492-.10742-.09766-.21094-.147-.31641-.06153-.13183-.12061-.26464-.18994-.39355-.05176-.09717-.11133-.189-.167-.2832-.07666-.13037-.15087-.26172-.23584-.38819-.0664-.09863-.14062-.1914-.21093-.28662-.084-.11474-.16407-.231-.25537-.3418-.11622-.14111-.2417-.27343-.36719-.40625-.0542-.0581-.10205-.11914-.15869-.17578-.05323-.05322-.11133-.09863-.166-.1499-.13623-.12891-.27246-.25781-.417-.377-.10449-.08545-.21436-.16065-.32178-.24024-.10254-.07617-.20166-.15527-.3081-.22656-.11817-.0791-.24073-.148-.36231-.22021-.10351-.06153-.2041-.12647-.31055-.1836-.11865-.063-.24023-.1167-.36084-.17334-.11669-.05517-.23144-.11328-.35107-.16308-.1123-.04639-.22754-.084-.3418-.125-.13281-.04834-.26367-.09864-.39941-.13965-.10938-.0332-.2207-.05713-.33106-.08545-.14257-.03613-.2832-.07568-.42822-.10449-.12158-.02393-.24414-.0376-.3667-.05567-.13574-.02051-.27-.04541-.4082-.05908-.20215-.01953-.40479-.02637-.60742-.03076C208.11768,40.00781,208.05957,40,208,40H168a8,8,0,0,0,0,16h20.68555L154.34277,90.34277A8,8,0,0,0,160,104Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.47629,124.81528a84.34782,84.34782,0,0,0,39.05334,38.8759,7.92754,7.92754,0,0,0,7.8287-.59231L164.394,146.40453a8,8,0,0,1,7.58966-.69723l46.837,20.073A7.97345,7.97345,0,0,1,223.619,174.077,48.00882,48.00882,0,0,1,176,216,136,136,0,0,1,40,80,48.00882,48.00882,0,0,1,81.923,32.381a7.97345,7.97345,0,0,1,8.29668,4.79823L110.31019,84.0571a8,8,0,0,1-.65931,7.53226L93.01449,117.00909A7.9287,7.9287,0,0,0,92.47629,124.81528Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "168 48 208 48 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "96",
      "x2": "208",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.47629,124.81528a84.34782,84.34782,0,0,0,39.05334,38.8759,7.92754,7.92754,0,0,0,7.8287-.59231L164.394,146.40453a8,8,0,0,1,7.58966-.69723l46.837,20.073A7.97345,7.97345,0,0,1,223.619,174.077,48.00882,48.00882,0,0,1,176,216,136,136,0,0,1,40,80,48.00882,48.00882,0,0,1,81.923,32.381a7.97345,7.97345,0,0,1,8.29668,4.79823L110.31019,84.0571a8,8,0,0,1-.65931,7.53226L93.01449,117.00909A7.9287,7.9287,0,0,0,92.47629,124.81528Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "168 48 208 48 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "96",
      "x2": "208",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.47629,124.81528a84.34782,84.34782,0,0,0,39.05334,38.8759,7.92754,7.92754,0,0,0,7.8287-.59231L164.394,146.40453a8,8,0,0,1,7.58966-.69723l46.837,20.073A7.97345,7.97345,0,0,1,223.619,174.077,48.00882,48.00882,0,0,1,176,216,136,136,0,0,1,40,80,48.00882,48.00882,0,0,1,81.923,32.381a7.97345,7.97345,0,0,1,8.29668,4.79823L110.31019,84.0571a8,8,0,0,1-.65931,7.53226L93.01449,117.00909A7.9287,7.9287,0,0,0,92.47629,124.81528Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "168 48 208 48 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "96",
      "x2": "208",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9$ = [];
/* style */

const __vue_inject_styles__$9$ = undefined;
/* scoped */

const __vue_scope_id__$9$ = undefined;
/* module identifier */

const __vue_module_identifier__$9$ = undefined;
/* functional template */

const __vue_is_functional_template__$9$ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9$ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9$,
  staticRenderFns: __vue_staticRenderFns__$9$
}, __vue_inject_styles__$9$, __vue_script__$9$, __vue_scope_id__$9$, __vue_is_functional_template__$9$, __vue_module_identifier__$9$, false, undefined, undefined, undefined);

var script$a0 = Vue.extend({
  name: "PhPhoneSlash",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$a0 = script$a0;
/* template */

var __vue_render__$a0 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M114.9947,113.69328a83.97034,83.97034,0,0,0-14.728,3.68282,7.92755,7.92755,0,0,0-5.1169,5.95455l-5.89824,29.5076a8,8,0,0,1-4.87369,5.85972L37.06532,177.623a7.97345,7.97345,0,0,1-9.2595-2.47378,48.00881,48.00881,0,0,1,4.02766-63.31573,135.45028,135.45028,0,0,1,51.9466-32.47622",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M131.18495,72.03707a135.5393,135.5393,0,0,1,92.98157,39.79641,48.00881,48.00881,0,0,1,4.02766,63.31573,7.8198,7.8198,0,0,1-1.76283,1.66165",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M155.371,117.25063a84.3478,84.3478,0,0,0-55.10429.12547,7.92755,7.92755,0,0,0-5.1169,5.95455l-5.89824,29.5076a8,8,0,0,1-4.87369,5.85972L37.06532,177.623a7.97345,7.97345,0,0,1-9.2595-2.47378,48.00881,48.00881,0,0,1,4.02766-63.31573,136,136,0,0,1,192.333,0,48.00881,48.00881,0,0,1,4.02766,63.31573,7.97345,7.97345,0,0,1-9.2595,2.47378l-47.35377-18.94151a8,8,0,0,1-4.85991-5.79231L160.51024,123.151A7.9287,7.9287,0,0,0,155.371,117.25063Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M114.9947,113.69328a83.97034,83.97034,0,0,0-14.728,3.68282,7.92755,7.92755,0,0,0-5.1169,5.95455l-5.89824,29.5076a8,8,0,0,1-4.87369,5.85972L37.06532,177.623a7.97345,7.97345,0,0,1-9.2595-2.47378,48.00881,48.00881,0,0,1,4.02766-63.31573,135.45028,135.45028,0,0,1,51.9466-32.47622",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M120.52563,72.20427a135.66,135.66,0,0,1,103.64089,39.62921,48.00881,48.00881,0,0,1,4.02766,63.31573,7.97345,7.97345,0,0,1-9.2595,2.47378l-4.04895-1.61958",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M120.8877,108.28271c-.01416-.01562-.02832-.03173-.043-.04736l-31.083-34.19092c-.01611-.01855-.03272-.03613-.04883-.0542l-35.793-39.37207A8.0006,8.0006,0,1,0,42.08008,45.38184L70.03857,76.13623a142.75371,142.75371,0,0,0-43.86279,30.04053,56.07211,56.07211,0,0,0-4.69043,73.87695,16.03254,16.03254,0,0,0,18.55078,4.99707L87.35059,166.125a15.94917,15.94917,0,0,0,9.74609-11.71875l5.90527-29.51172a76.1958,76.1958,0,0,1,9.07422-2.51709l90.00391,99.0044a8.0006,8.0006,0,1,0,11.83984-10.76368Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M229.82422,106.17578a144.20418,144.20418,0,0,0-109.73633-41.96A8.00053,8.00053,0,0,0,114.60547,77.585l94.36035,103.79883a8.0075,8.0075,0,0,0,2.94824,2.04687l4.04883,1.62012a16.03429,16.03429,0,0,0,18.55273-4.99805A56.07343,56.07343,0,0,0,229.82422,106.17578Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M114.9947,113.69328a83.97034,83.97034,0,0,0-14.728,3.68282,7.92755,7.92755,0,0,0-5.1169,5.95455l-5.89824,29.5076a8,8,0,0,1-4.87369,5.85972L37.06532,177.623a7.97345,7.97345,0,0,1-9.2595-2.47378,48.00881,48.00881,0,0,1,4.02766-63.31573,135.45028,135.45028,0,0,1,51.9466-32.47622",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M120.52563,72.20427a135.66,135.66,0,0,1,103.64089,39.62921,48.00881,48.00881,0,0,1,4.02766,63.31573,7.97345,7.97345,0,0,1-9.2595,2.47378l-4.04895-1.61958",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M114.9947,113.69328a83.97034,83.97034,0,0,0-14.728,3.68282,7.92755,7.92755,0,0,0-5.1169,5.95455l-5.89824,29.5076a8,8,0,0,1-4.87369,5.85972L37.06532,177.623a7.97345,7.97345,0,0,1-9.2595-2.47378,48.00881,48.00881,0,0,1,4.02766-63.31573,135.45028,135.45028,0,0,1,51.9466-32.47622",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M120.52563,72.20427a135.66,135.66,0,0,1,103.64089,39.62921,48.00881,48.00881,0,0,1,4.02766,63.31573,7.97345,7.97345,0,0,1-9.2595,2.47378l-4.04895-1.61958",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M114.9947,113.69328a83.97034,83.97034,0,0,0-14.728,3.68282,7.92755,7.92755,0,0,0-5.1169,5.95455l-5.89824,29.5076a8,8,0,0,1-4.87369,5.85972L37.06532,177.623a7.97345,7.97345,0,0,1-9.2595-2.47378,48.00881,48.00881,0,0,1,4.02766-63.31573,135.45028,135.45028,0,0,1,51.9466-32.47622",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M120.52563,72.20427a135.66,135.66,0,0,1,103.64089,39.62921,48.00881,48.00881,0,0,1,4.02766,63.31573,7.97345,7.97345,0,0,1-9.2595,2.47378l-4.04895-1.61958",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$a0 = [];
/* style */

const __vue_inject_styles__$a0 = undefined;
/* scoped */

const __vue_scope_id__$a0 = undefined;
/* module identifier */

const __vue_module_identifier__$a0 = undefined;
/* functional template */

const __vue_is_functional_template__$a0 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$a0 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$a0,
  staticRenderFns: __vue_staticRenderFns__$a0
}, __vue_inject_styles__$a0, __vue_script__$a0, __vue_scope_id__$a0, __vue_is_functional_template__$a0, __vue_module_identifier__$a0, false, undefined, undefined, undefined);

var script$a1 = Vue.extend({
  name: "PhPhoneX",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$a1 = script$a1;
/* template */

var __vue_render__$a1 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.47629,124.81528a84.34782,84.34782,0,0,0,39.05334,38.8759,7.92754,7.92754,0,0,0,7.8287-.59231L164.394,146.40453a8,8,0,0,1,7.58966-.69723l46.837,20.073A7.97345,7.97345,0,0,1,223.619,174.077,48.00882,48.00882,0,0,1,176,216,136,136,0,0,1,40,80,48.00882,48.00882,0,0,1,81.923,32.381a7.97345,7.97345,0,0,1,8.29668,4.79823L110.31019,84.0571a8,8,0,0,1-.65931,7.53226L93.01449,117.00909A7.9287,7.9287,0,0,0,92.47629,124.81528Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "48",
      "x2": "208",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "48",
      "x2": "160",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.47629,124.81528a84.34782,84.34782,0,0,0,39.05334,38.8759,7.92754,7.92754,0,0,0,7.8287-.59231L164.394,146.40453a8,8,0,0,1,7.58966-.69723l46.837,20.073A7.97345,7.97345,0,0,1,223.619,174.077,48.00882,48.00882,0,0,1,176,216,136,136,0,0,1,40,80,48.00882,48.00882,0,0,1,81.923,32.381a7.97345,7.97345,0,0,1,8.29668,4.79823L110.31019,84.0571a8,8,0,0,1-.65931,7.53226L93.01449,117.00909A7.9287,7.9287,0,0,0,92.47629,124.81528Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.47629,124.81528a84.34782,84.34782,0,0,0,39.05334,38.8759,7.92754,7.92754,0,0,0,7.8287-.59231L164.394,146.40453a8,8,0,0,1,7.58966-.69723l46.837,20.073A7.97345,7.97345,0,0,1,223.619,174.077,48.00882,48.00882,0,0,1,176,216,136,136,0,0,1,40,80,48.00882,48.00882,0,0,1,81.923,32.381a7.97345,7.97345,0,0,1,8.29668,4.79823L110.31019,84.0571a8,8,0,0,1-.65931,7.53226L93.01449,117.00909A7.9287,7.9287,0,0,0,92.47629,124.81528Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "48",
      "x2": "208",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "48",
      "x2": "160",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M221.97168,158.42676l-46.83789-20.07324a15.94874,15.94874,0,0,0-15.17871,1.39453l-25.043,16.69336A76.54083,76.54083,0,0,1,99.707,121.3916l.00195-.00195,16.63477-25.418a15.96924,15.96924,0,0,0,1.32031-15.06641L97.57227,34.02734a16.03093,16.03093,0,0,0-16.65235-9.583A56.07029,56.07029,0,0,0,32,80c0,79.40234,64.59766,144,144,144a56.07032,56.07032,0,0,0,55.55566-48.9209A16.03476,16.03476,0,0,0,221.97168,158.42676Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154.34277,101.65723a8.00181,8.00181,0,0,0,11.31446,0L184,83.31445l18.34277,18.34278a8.00053,8.00053,0,0,0,11.31446-11.31446L195.31445,72l18.34278-18.34277a8.00053,8.00053,0,0,0-11.31446-11.31446L184,60.68555,165.65723,42.34277a8.00053,8.00053,0,0,0-11.31446,11.31446L172.68555,72,154.34277,90.34277A8.00122,8.00122,0,0,0,154.34277,101.65723Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.47629,124.81528a84.34782,84.34782,0,0,0,39.05334,38.8759,7.92754,7.92754,0,0,0,7.8287-.59231L164.394,146.40453a8,8,0,0,1,7.58966-.69723l46.837,20.073A7.97345,7.97345,0,0,1,223.619,174.077,48.00882,48.00882,0,0,1,176,216,136,136,0,0,1,40,80,48.00882,48.00882,0,0,1,81.923,32.381a7.97345,7.97345,0,0,1,8.29668,4.79823L110.31019,84.0571a8,8,0,0,1-.65931,7.53226L93.01449,117.00909A7.9287,7.9287,0,0,0,92.47629,124.81528Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "48",
      "x2": "208",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "48",
      "x2": "160",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.47629,124.81528a84.34782,84.34782,0,0,0,39.05334,38.8759,7.92754,7.92754,0,0,0,7.8287-.59231L164.394,146.40453a8,8,0,0,1,7.58966-.69723l46.837,20.073A7.97345,7.97345,0,0,1,223.619,174.077,48.00882,48.00882,0,0,1,176,216,136,136,0,0,1,40,80,48.00882,48.00882,0,0,1,81.923,32.381a7.97345,7.97345,0,0,1,8.29668,4.79823L110.31019,84.0571a8,8,0,0,1-.65931,7.53226L93.01449,117.00909A7.9287,7.9287,0,0,0,92.47629,124.81528Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "48",
      "x2": "208",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "48",
      "x2": "160",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.47629,124.81528a84.34782,84.34782,0,0,0,39.05334,38.8759,7.92754,7.92754,0,0,0,7.8287-.59231L164.394,146.40453a8,8,0,0,1,7.58966-.69723l46.837,20.073A7.97345,7.97345,0,0,1,223.619,174.077,48.00882,48.00882,0,0,1,176,216,136,136,0,0,1,40,80,48.00882,48.00882,0,0,1,81.923,32.381a7.97345,7.97345,0,0,1,8.29668,4.79823L110.31019,84.0571a8,8,0,0,1-.65931,7.53226L93.01449,117.00909A7.9287,7.9287,0,0,0,92.47629,124.81528Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "48",
      "x2": "208",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "48",
      "x2": "160",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$a1 = [];
/* style */

const __vue_inject_styles__$a1 = undefined;
/* scoped */

const __vue_scope_id__$a1 = undefined;
/* module identifier */

const __vue_module_identifier__$a1 = undefined;
/* functional template */

const __vue_is_functional_template__$a1 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$a1 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$a1,
  staticRenderFns: __vue_staticRenderFns__$a1
}, __vue_inject_styles__$a1, __vue_script__$a1, __vue_scope_id__$a1, __vue_is_functional_template__$a1, __vue_module_identifier__$a1, false, undefined, undefined, undefined);

var script$a2 = Vue.extend({
  name: "PhPhosphorLogo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$a2 = script$a2;
/* template */

var __vue_render__$a2 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "68",
      "y1": "32",
      "x2": "134",
      "y2": "164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "68",
      "y": "32",
      "width": "66",
      "height": "132",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M134,164v66a66,66,0,0,1-66-66",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M134,164h8a66,66,0,0,0,0-132h-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "68 32 68 164 134 164 68 32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "68",
      "y1": "32",
      "x2": "134",
      "y2": "164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "68",
      "y": "32",
      "width": "66",
      "height": "132",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M134,164v66a66,66,0,0,1-66-66",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M134,164h8a66,66,0,0,0,0-132h-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M134,164h8a66,66,0,0,0,0-132h-8Z",
      "opacity": "0.2"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M142,24H68c-.06836,0-.13477.00855-.20264.01026-.16162.004-.32275.01056-.48486.02447-.11377.00971-.22607.02387-.33838.03833-.14307.0185-.28613.039-.42871.06543-.13232.02429-.26221.05359-.39209.08435-.11865.02826-.23682.05725-.35449.09113-.15088.04315-.29883.09216-.4458.14386-.09668.034-.19287.06769-.28907.10565-.16113.06366-.31787.134-.47363.20764-.05566.02625-.11279.046-.168.07361-.03027.0152-.05761.03412-.08789.04968-.14795.0766-.2915.15979-.43408.24512-.0918.05481-.18457.10828-.27393.16626-.11572.07574-.22607.15729-.33789.23871-.10644.07776-.21435.15423-.3164.23657-.084.06811-.16309.14117-.24463.21258-.11719.10267-.23438.20472-.34473.31336-.06543.06445-.12549.13342-.18847.20007-.11426.12036-.228.2403-.3335.36682-.064.07611-.12158.15693-.18213.23542-.09424.12188-.18945.24267-.27637.36926-.07129.10406-.13476.21338-.20166.321-.06591.10669-.13427.21155-.19482.321-.0752.13513-.14111.27551-.2085.41528-.04248.08838-.08838.17493-.12744.26471-.0664.15186-.123.30841-.18017.465-.03125.08538-.06543.16943-.09375.25586-.04834.14813-.08741.2998-.127.45159-.02685.10328-.05664.20563-.07959.31-.02832.13-.04931.26233-.07129.39453-.02246.134-.04541.2674-.06152.40259-.01221.10742-.01855.21619-.02637.32483-.01269.16376-.023.32745-.0249.49225C60.00488,31.93187,60,31.96537,60,32V164a74.08385,74.08385,0,0,0,74,74,8.00008,8.00008,0,0,0,8-8V172a74,74,0,0,0,0-148ZM126,130.11137,80.94434,40H126ZM76.55176,172H126v49.4502A58.12735,58.12735,0,0,1,76.55176,172ZM142,156V40a58,58,0,0,1,0,116Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "68",
      "y1": "32",
      "x2": "134",
      "y2": "164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "68",
      "y": "32",
      "width": "66",
      "height": "132",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M134,164v66a66,66,0,0,1-66-66",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M134,164h8a66,66,0,0,0,0-132h-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "68",
      "y1": "32",
      "x2": "134",
      "y2": "164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "68",
      "y": "32",
      "width": "66",
      "height": "132",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M134,164v66a66,66,0,0,1-66-66",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M134,164h8a66,66,0,0,0,0-132h-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('g', [_c('line', {
    attrs: {
      "x1": "68",
      "y1": "32",
      "x2": "134",
      "y2": "164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "68",
      "y": "32",
      "width": "66",
      "height": "132",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M134,164v66a66,66,0,0,1-66-66",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M134,164h8a66,66,0,0,0,0-132h-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })])]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$a2 = [];
/* style */

const __vue_inject_styles__$a2 = undefined;
/* scoped */

const __vue_scope_id__$a2 = undefined;
/* module identifier */

const __vue_module_identifier__$a2 = undefined;
/* functional template */

const __vue_is_functional_template__$a2 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$a2 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$a2,
  staticRenderFns: __vue_staticRenderFns__$a2
}, __vue_inject_styles__$a2, __vue_script__$a2, __vue_scope_id__$a2, __vue_is_functional_template__$a2, __vue_module_identifier__$a2, false, undefined, undefined, undefined);

var script$a3 = Vue.extend({
  name: "PhPictureInPicture",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$a3 = script$a3;
/* template */

var __vue_render__$a3 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "56",
      "width": "192",
      "height": "144",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M136,200V136a8,8,0,0,1,8-8h80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,56H40a7.99993,7.99993,0,0,0-8,8V192a7.99993,7.99993,0,0,0,8,8h96V136a7.99993,7.99993,0,0,1,8-8h80V64A7.99993,7.99993,0,0,0,216,56Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "56",
      "width": "192",
      "height": "144",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M136,200V136a8,8,0,0,1,8-8h80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,48H40A16.01833,16.01833,0,0,0,24,64V192a16.01833,16.01833,0,0,0,16,16H216a16.01833,16.01833,0,0,0,16-16V64A16.01833,16.01833,0,0,0,216,48ZM40,64H216l.00439,56H144a16.01833,16.01833,0,0,0-16,16v56H40Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "56",
      "width": "192",
      "height": "144",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M136,200V136a8,8,0,0,1,8-8h80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "56",
      "width": "192",
      "height": "144",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M136,200V136a8,8,0,0,1,8-8h80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "56",
      "width": "192",
      "height": "144",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M136,200V136a8,8,0,0,1,8-8h80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$a3 = [];
/* style */

const __vue_inject_styles__$a3 = undefined;
/* scoped */

const __vue_scope_id__$a3 = undefined;
/* module identifier */

const __vue_module_identifier__$a3 = undefined;
/* functional template */

const __vue_is_functional_template__$a3 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$a3 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$a3,
  staticRenderFns: __vue_staticRenderFns__$a3
}, __vue_inject_styles__$a3, __vue_script__$a3, __vue_scope_id__$a3, __vue_is_functional_template__$a3, __vue_module_identifier__$a3, false, undefined, undefined, undefined);

var script$a4 = Vue.extend({
  name: "PhPill",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$a4 = script$a4;
/* template */

var __vue_render__$a4 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "14.86292",
      "y": "82.74517",
      "width": "226.27417",
      "height": "90.50967",
      "rx": "45.25479",
      "transform": "translate(-53.01934 128) rotate(-45)",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "96",
      "x2": "160",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160.06933",
      "y1": "104.06932",
      "x2": "176.48528",
      "y2": "88.48528",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M112,208A45.25478,45.25478,0,0,1,48,208L48,208A45.25478,45.25478,0,0,1,48,144L96,96l64,64Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "14.86292",
      "y": "82.74517",
      "width": "226.27417",
      "height": "90.50967",
      "rx": "45.25479",
      "transform": "translate(-53.01934 128) rotate(-45)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "96",
      "x2": "160",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160.06933",
      "y1": "112.06932",
      "x2": "184.48528",
      "y2": "88.48528",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M213.65723,42.34326a53.25535,53.25535,0,0,0-75.31446,0l-96,96a53.255,53.255,0,0,0,75.31446,75.31348l96-96A53.31558,53.31558,0,0,0,213.65723,42.34326Zm-11.31446,64L160,148.68628,107.31348,96l42.34375-42.34326a37.25465,37.25465,0,0,1,52.68554,52.68652Zm-12.10351-23.416a7.99946,7.99946,0,0,1-.19629,11.312l-24.416,23.584a7.99966,7.99966,0,1,1-11.11523-11.50781l24.416-23.584A7.99843,7.99843,0,0,1,190.23926,82.92725Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "14.86292",
      "y": "82.74517",
      "width": "226.27417",
      "height": "90.50967",
      "rx": "45.25479",
      "transform": "translate(-53.01934 128) rotate(-45)",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "96",
      "x2": "160",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160.06933",
      "y1": "112.06932",
      "x2": "184.48528",
      "y2": "88.48528",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "14.86292",
      "y": "82.74517",
      "width": "226.27417",
      "height": "90.50967",
      "rx": "45.25479",
      "transform": "translate(-53.01934 128) rotate(-45)",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "96",
      "x2": "160",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160.06933",
      "y1": "112.06932",
      "x2": "184.48528",
      "y2": "88.48528",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "14.86292",
      "y": "82.74517",
      "width": "226.27417",
      "height": "90.50967",
      "rx": "45.25479",
      "transform": "translate(-53.01934 128) rotate(-45)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "96",
      "x2": "160",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160.06933",
      "y1": "112.06932",
      "x2": "184.48528",
      "y2": "88.48528",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$a4 = [];
/* style */

const __vue_inject_styles__$a4 = undefined;
/* scoped */

const __vue_scope_id__$a4 = undefined;
/* module identifier */

const __vue_module_identifier__$a4 = undefined;
/* functional template */

const __vue_is_functional_template__$a4 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$a4 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$a4,
  staticRenderFns: __vue_staticRenderFns__$a4
}, __vue_inject_styles__$a4, __vue_script__$a4, __vue_scope_id__$a4, __vue_is_functional_template__$a4, __vue_module_identifier__$a4, false, undefined, undefined, undefined);

var script$a5 = Vue.extend({
  name: "PhPinterestLogo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$a5 = script$a5;
/* template */

var __vue_render__$a5 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "120",
      "y1": "88.00002",
      "x2": "88",
      "y2": "224.00002",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M61.54451,156.55327A80.00347,80.00347,0,1,1,208,112c0,44.18278-32,72-64,72s-41.63152-21.06651-41.63152-21.06651",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "120",
      "y1": "88.00002",
      "x2": "88",
      "y2": "224.00002",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M61.54451,156.55327A80.00347,80.00347,0,1,1,208,112c0,44.18278-32,72-64,72s-41.63152-21.06651-41.63152-21.06651",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232,128a104.02405,104.02405,0,0,1-132.74316,99.957l9.8164-39.26513A50.31473,50.31473,0,0,0,136,196c35.29,0,64-30.50488,64-68A72,72,0,1,0,61.2373,155.00393,8.00011,8.00011,0,0,0,76.06836,149,56.00735,56.00735,0,1,1,184,128c0,28.67285-21.53271,52-48,52-10.49072,0-17.78076-3.66064-22.75049-8.01269l14.51172-58.04688a8.00012,8.00012,0,0,0-15.52246-3.88086L84.17822,222.30178A103.99416,103.99416,0,1,1,232,128Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "120",
      "y1": "88.00002",
      "x2": "88",
      "y2": "224.00002",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M61.54451,156.55327A80.00347,80.00347,0,1,1,208,112c0,44.18278-32,72-64,72s-41.63152-21.06651-41.63152-21.06651",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "120",
      "y1": "88.00002",
      "x2": "88",
      "y2": "224.00002",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M61.54451,156.55327A80.00347,80.00347,0,1,1,208,112c0,44.18278-32,72-64,72s-41.63152-21.06651-41.63152-21.06651",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "120",
      "y1": "88.00002",
      "x2": "88",
      "y2": "224.00002",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M61.54451,156.55327A80.00347,80.00347,0,1,1,208,112c0,44.18278-32,72-64,72s-41.63152-21.06651-41.63152-21.06651",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$a5 = [];
/* style */

const __vue_inject_styles__$a5 = undefined;
/* scoped */

const __vue_scope_id__$a5 = undefined;
/* module identifier */

const __vue_module_identifier__$a5 = undefined;
/* functional template */

const __vue_is_functional_template__$a5 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$a5 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$a5,
  staticRenderFns: __vue_staticRenderFns__$a5
}, __vue_inject_styles__$a5, __vue_script__$a5, __vue_scope_id__$a5, __vue_is_functional_template__$a5, __vue_module_identifier__$a5, false, undefined, undefined, undefined);

var script$a6 = Vue.extend({
  name: "PhPizza",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$a6 = script$a6;
/* template */

var __vue_render__$a6 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M23.44054,75.69239a8.02578,8.02578,0,0,1,2.13281-10.834,176.07221,176.07221,0,0,1,204.85329,0,8.02577,8.02577,0,0,1,2.13281,10.834L134.74929,229.394a8,8,0,0,1-13.49858,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M41.07368,103.4019a136.0151,136.0151,0,0,1,173.85255-.00008",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M159.4017,190.65505a28.00364,28.00364,0,1,1,29.099-45.72666",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M59.71643,132.69767a28.00252,28.00252,0,1,1,29.18265,45.85854",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M144,156a27.9931,27.9931,0,0,1,49.13477-18.35474l26.11962-41.04492a144.01914,144.01914,0,0,0-182.50878,0l21.15918,33.25025A27.99977,27.99977,0,1,1,84,168c-.62646,0-1.24561-.02808-1.86182-.06836L121.251,229.394a8,8,0,0,0,13.49853,0l29.5708-46.46924A28.00554,28.00554,0,0,1,144,156Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M23.44054,75.69239a8.02578,8.02578,0,0,1,2.13281-10.834,176.07221,176.07221,0,0,1,204.85329,0,8.02577,8.02577,0,0,1,2.13281,10.834L134.74929,229.394a8,8,0,0,1-13.49858,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M36.74566,96.60039a144.01884,144.01884,0,0,1,182.50866,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M164.31747,182.93292a28.00353,28.00353,0,1,1,28.82269-45.29368",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M57.89918,129.84281A28.00328,28.00328,0,1,1,84,168q-.91436,0-1.81448-.05785",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M239.30908,79.9873a16.03867,16.03867,0,0,0-4.22119-21.63085,184.07289,184.07289,0,0,0-214.17578,0A16.03867,16.03867,0,0,0,16.69092,79.9873h.00049l97.81,153.70166a15.99973,15.99973,0,0,0,26.99708,0l58.41259-91.79052c.01807-.0293.0376-.05811.05567-.08789ZM23.44043,75.69238ZM128,225.09912,95.54053,174.09155a36.00171,36.00171,0,1,0-37.55469-59.0144L47.40723,98.45361a135.99256,135.99256,0,0,1,161.18554,0L191.30127,125.626a35.99008,35.99008,0,0,0-38.64453,60.7268Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M23.44054,75.69239a8.02578,8.02578,0,0,1,2.13281-10.834,176.07221,176.07221,0,0,1,204.85329,0,8.02577,8.02577,0,0,1,2.13281,10.834L134.74929,229.394a8,8,0,0,1-13.49858,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M36.74566,96.60039a144.01884,144.01884,0,0,1,182.50866,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M164.31747,182.93292a28.00353,28.00353,0,1,1,28.82269-45.29368",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M57.89918,129.84281A28.00328,28.00328,0,1,1,84,168q-.91436,0-1.81448-.05785",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M23.44054,75.69239a8.02578,8.02578,0,0,1,2.13281-10.834,176.07221,176.07221,0,0,1,204.85329,0,8.02577,8.02577,0,0,1,2.13281,10.834L134.74929,229.394a8,8,0,0,1-13.49858,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M36.74566,96.60039a144.01884,144.01884,0,0,1,182.50866,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M164.31747,182.93292a28.00353,28.00353,0,1,1,28.82269-45.29368",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M57.89918,129.84281A28.00328,28.00328,0,1,1,84,168q-.91436,0-1.81448-.05785",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M23.44054,75.69239a8.02578,8.02578,0,0,1,2.13281-10.834,176.07221,176.07221,0,0,1,204.85329,0,8.02577,8.02577,0,0,1,2.13281,10.834L134.74929,229.394a8,8,0,0,1-13.49858,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M36.74566,96.60039a144.01884,144.01884,0,0,1,182.50866,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M164.31747,182.93292a28.00353,28.00353,0,1,1,28.82269-45.29368",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M57.89918,129.84281A28.00328,28.00328,0,1,1,84,168q-.91436,0-1.81448-.05785",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$a6 = [];
/* style */

const __vue_inject_styles__$a6 = undefined;
/* scoped */

const __vue_scope_id__$a6 = undefined;
/* module identifier */

const __vue_module_identifier__$a6 = undefined;
/* functional template */

const __vue_is_functional_template__$a6 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$a6 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$a6,
  staticRenderFns: __vue_staticRenderFns__$a6
}, __vue_inject_styles__$a6, __vue_script__$a6, __vue_scope_id__$a6, __vue_is_functional_template__$a6, __vue_module_identifier__$a6, false, undefined, undefined, undefined);

var script$a7 = Vue.extend({
  name: "PhPlaceholder",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$a7 = script$a7;
/* template */

var __vue_render__$a7 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "42.34314",
      "y1": "42.34314",
      "x2": "213.65687",
      "y2": "213.65687",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "42.34314",
      "y1": "42.34314",
      "x2": "213.65687",
      "y2": "213.65687",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "42.34314",
      "y1": "42.34314",
      "x2": "213.65687",
      "y2": "213.65687",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,32H48A16.01833,16.01833,0,0,0,32,48V208a16.01833,16.01833,0,0,0,16,16H208a16.01833,16.01833,0,0,0,16-16V48A16.01833,16.01833,0,0,0,208,32ZM187.31348,187.31445a8.00061,8.00061,0,0,1-11.31348,0L68.68652,80A8.00018,8.00018,0,0,1,80,68.68555L187.31348,176A8.00032,8.00032,0,0,1,187.31348,187.31445Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "42.34314",
      "y1": "42.34314",
      "x2": "213.65687",
      "y2": "213.65687",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "42.34314",
      "y1": "42.34314",
      "x2": "213.65687",
      "y2": "213.65687",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "42.34314",
      "y1": "42.34314",
      "x2": "213.65687",
      "y2": "213.65687",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$a7 = [];
/* style */

const __vue_inject_styles__$a7 = undefined;
/* scoped */

const __vue_scope_id__$a7 = undefined;
/* module identifier */

const __vue_module_identifier__$a7 = undefined;
/* functional template */

const __vue_is_functional_template__$a7 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$a7 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$a7,
  staticRenderFns: __vue_staticRenderFns__$a7
}, __vue_inject_styles__$a7, __vue_script__$a7, __vue_scope_id__$a7, __vue_is_functional_template__$a7, __vue_module_identifier__$a7, false, undefined, undefined, undefined);

var script$a8 = Vue.extend({
  name: "PhPlanet",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$a8 = script$a8;
/* template */

var __vue_render__$a8 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M179.45516,61.6015c30.106-8.94046,52.92047-8.81761,59.39609,2.3985C249.897,83.1317,209.22146,127.29479,148,162.641S28.19444,211.1317,17.14875,192c-6.47514-11.21527,4.82354-31.03251,27.61578-52.63295",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "88",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184.17224,60.25854c27.75785-7.55343,48.54608-6.88109,54.679,3.74146C249.897,83.1317,209.22146,127.29479,148,162.641S28.19444,211.1317,17.14875,192c-6.13187-10.6207,3.67551-28.95548,24.08867-49.21359",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M223.251,115.99854A96.03076,96.03076,0,0,1,128,224a95.50329,95.50329,0,0,1-57.96045-19.52515C94.58984,198.321,123.48145,186.03418,152,169.56934,180.542,153.09009,205.645,134.196,223.251,115.99854ZM245.7793,60c-5.46875-9.47119-20.31592-18.42773-59.82373-8.47852A95.94717,95.94717,0,0,0,32,128a96.48271,96.48271,0,0,0,.748,11.99414C4.41748,169.2085,4.75488,186.5332,10.2207,196c3.69336,6.39746,11.875,12.78809,29.81348,12.78809a117.6895,117.6895,0,0,0,25.47559-3.23243c1.49121-.33447,3.0039-.69824,4.52978-1.08081a96.84991,96.84991,0,0,1-14.24219-13.27978c-18.65527,3.31811-29.31591.96924-31.72021-3.19507-1.501-2.59961-.6582-7.48535,2.31152-13.4043a83.04134,83.04134,0,0,1,10.74121-15.61841,96.04543,96.04543,0,0,0,18.66748,32.21778q2.97071-.52845,6.20948-1.25171c23.94628-5.37207,53.06543-17.5293,81.99316-34.23047s54.01514-35.84082,70.6416-53.89258q2.27271-2.46827,4.228-4.79883a96.04556,96.04556,0,0,0-18.668-32.21752A83.29551,83.29551,0,0,1,219.1543,63.2998c6.61328.38672,11.26758,2.09961,12.76855,4.7002,2.40186,4.15967-.88428,14.54932-13.05322,29.02148a95.19186,95.19186,0,0,1,4.38135,18.97706c1.07959-1.11548,2.1372-2.229,3.15918-3.33838C251.69678,85.20508,250.90039,68.86914,245.7793,60Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184.17224,60.25854c27.75785-7.55343,48.54608-6.88109,54.679,3.74146C249.897,83.1317,209.22146,127.29479,148,162.641S28.19444,211.1317,17.14875,192c-6.13187-10.6207,3.67551-28.95548,24.08867-49.21359",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184.17224,60.25854c27.75785-7.55343,48.54608-6.88109,54.679,3.74146C249.897,83.1317,209.22146,127.29479,148,162.641S28.19444,211.1317,17.14875,192c-6.13187-10.6207,3.67551-28.95548,24.08867-49.21359",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184.17224,60.25854c27.75785-7.55343,48.54608-6.88109,54.679,3.74146C249.897,83.1317,209.22146,127.29479,148,162.641S28.19444,211.1317,17.14875,192c-6.13187-10.6207,3.67551-28.95548,24.08867-49.21359",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$a8 = [];
/* style */

const __vue_inject_styles__$a8 = undefined;
/* scoped */

const __vue_scope_id__$a8 = undefined;
/* module identifier */

const __vue_module_identifier__$a8 = undefined;
/* functional template */

const __vue_is_functional_template__$a8 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$a8 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$a8,
  staticRenderFns: __vue_staticRenderFns__$a8
}, __vue_inject_styles__$a8, __vue_script__$a8, __vue_scope_id__$a8, __vue_is_functional_template__$a8, __vue_module_identifier__$a8, false, undefined, undefined, undefined);

var script$a9 = Vue.extend({
  name: "PhPlay",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$a9 = script$a9;
/* template */

var __vue_render__$a9 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M228.14833,121.17381,84.1717,33.18517A8,8,0,0,0,72,40.01136V215.98864a8,8,0,0,0,12.1717,6.82619l143.97663-87.98864A8,8,0,0,0,228.14833,121.17381Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M228.14833,121.17381,84.1717,33.18517A8,8,0,0,0,72,40.01136V215.98864a8,8,0,0,0,12.1717,6.82619l143.97663-87.98864A8,8,0,0,0,228.14833,121.17381Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M228.14833,121.17381,84.1717,33.18517A8,8,0,0,0,72,40.01136V215.98864a8,8,0,0,0,12.1717,6.82619l143.97663-87.98864A8,8,0,0,0,228.14833,121.17381Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232.3125,114.34375,88.34375,26.35937A15.99781,15.99781,0,0,0,64,40.00781V215.99219a16.00521,16.00521,0,0,0,24.34375,13.64843L232.3125,141.65625a16.00727,16.00727,0,0,0,0-27.3125Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M228.14833,121.17381,84.1717,33.18517A8,8,0,0,0,72,40.01136V215.98864a8,8,0,0,0,12.1717,6.82619l143.97663-87.98864A8,8,0,0,0,228.14833,121.17381Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M228.14833,121.17381,84.1717,33.18517A8,8,0,0,0,72,40.01136V215.98864a8,8,0,0,0,12.1717,6.82619l143.97663-87.98864A8,8,0,0,0,228.14833,121.17381Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M228.14833,121.17381,84.1717,33.18517A8,8,0,0,0,72,40.01136V215.98864a8,8,0,0,0,12.1717,6.82619l143.97663-87.98864A8,8,0,0,0,228.14833,121.17381Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$a9 = [];
/* style */

const __vue_inject_styles__$a9 = undefined;
/* scoped */

const __vue_scope_id__$a9 = undefined;
/* module identifier */

const __vue_module_identifier__$a9 = undefined;
/* functional template */

const __vue_is_functional_template__$a9 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$a9 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$a9,
  staticRenderFns: __vue_staticRenderFns__$a9
}, __vue_inject_styles__$a9, __vue_script__$a9, __vue_scope_id__$a9, __vue_is_functional_template__$a9, __vue_module_identifier__$a9, false, undefined, undefined, undefined);

var script$aa = Vue.extend({
  name: "PhPlayCircle",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$aa = script$aa;
/* template */

var __vue_render__$aa = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "156 128 116 100 116 156 156 128",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,32a96,96,0,1,0,96,96A95.99975,95.99975,0,0,0,128,32ZM112,160V96l48,32Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "160 128 112 96 112 160 160 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.12041,104.12041,0,0,0,128,24Zm36.4375,110.65625-48,32A7.99612,7.99612,0,0,1,104,160V96a7.99612,7.99612,0,0,1,12.4375-6.65625l48,32a7.99959,7.99959,0,0,1,0,13.3125Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "160 128 112 96 112 160 160 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "160 128 112 96 112 160 160 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "160 128 112 96 112 160 160 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$aa = [];
/* style */

const __vue_inject_styles__$aa = undefined;
/* scoped */

const __vue_scope_id__$aa = undefined;
/* module identifier */

const __vue_module_identifier__$aa = undefined;
/* functional template */

const __vue_is_functional_template__$aa = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$aa = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$aa,
  staticRenderFns: __vue_staticRenderFns__$aa
}, __vue_inject_styles__$aa, __vue_script__$aa, __vue_scope_id__$aa, __vue_is_functional_template__$aa, __vue_module_identifier__$aa, false, undefined, undefined, undefined);

var script$ab = Vue.extend({
  name: "PhPlaylist",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$ab = script$ab;
/* template */

var __vue_render__$ab = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "64",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "160",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "192",
      "x2": "112",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "192",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "200 192 200 112 240 124",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "176",
      "cy": "192",
      "r": "24",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "64",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "160",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "192",
      "x2": "112",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "192",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "200 192 200 112 240 124",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,64a8.00008,8.00008,0,0,1,8-8H216a8,8,0,0,1,0,16H40A8.00008,8.00008,0,0,1,32,64Zm8,72H160a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16Zm72,48H40a8,8,0,0,0,0,16h72a8,8,0,0,0,0-16Zm130.29883-67.6626-40-12A7.99991,7.99991,0,0,0,192,112v52.30518A31.98859,31.98859,0,1,0,208,192V122.75244l29.70117,8.91016a8,8,0,1,0,4.59766-15.3252Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "64",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "160",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "192",
      "x2": "112",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "192",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "200 192 200 112 240 124",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "64",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "160",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "192",
      "x2": "112",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "192",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "200 192 200 112 240 124",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "64",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "160",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "192",
      "x2": "112",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "192",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "200 192 200 112 240 124",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$ab = [];
/* style */

const __vue_inject_styles__$ab = undefined;
/* scoped */

const __vue_scope_id__$ab = undefined;
/* module identifier */

const __vue_module_identifier__$ab = undefined;
/* functional template */

const __vue_is_functional_template__$ab = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$ab = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$ab,
  staticRenderFns: __vue_staticRenderFns__$ab
}, __vue_inject_styles__$ab, __vue_script__$ab, __vue_scope_id__$ab, __vue_is_functional_template__$ab, __vue_module_identifier__$ab, false, undefined, undefined, undefined);

var script$ac = Vue.extend({
  name: "PhPlus",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$ac = script$ac;
/* template */

var __vue_render__$ac = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,120H136V40a8,8,0,0,0-16,0v80H40a8,8,0,0,0,0,16h80v80a8,8,0,0,0,16,0V136h80a8,8,0,0,0,0-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$ac = [];
/* style */

const __vue_inject_styles__$ac = undefined;
/* scoped */

const __vue_scope_id__$ac = undefined;
/* module identifier */

const __vue_module_identifier__$ac = undefined;
/* functional template */

const __vue_is_functional_template__$ac = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$ac = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$ac,
  staticRenderFns: __vue_staticRenderFns__$ac
}, __vue_inject_styles__$ac, __vue_script__$ac, __vue_scope_id__$ac, __vue_is_functional_template__$ac, __vue_module_identifier__$ac, false, undefined, undefined, undefined);

var script$ad = Vue.extend({
  name: "PhPlusCircle",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$ad = script$ad;
/* template */

var __vue_render__$ad = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "128",
      "x2": "168",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "88",
      "x2": "128",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "128",
      "x2": "168",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "88",
      "x2": "128",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,23.99805a104,104,0,1,0,104,104A104.12041,104.12041,0,0,0,128,23.99805Zm40,112H136v32a8,8,0,1,1-16,0v-32H88a8,8,0,0,1,0-16h32v-32a8,8,0,0,1,16,0v32h32a8,8,0,0,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "128",
      "x2": "168",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "88",
      "x2": "128",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "128",
      "x2": "168",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "88",
      "x2": "128",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "128",
      "x2": "168",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "88",
      "x2": "128",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$ad = [];
/* style */

const __vue_inject_styles__$ad = undefined;
/* scoped */

const __vue_scope_id__$ad = undefined;
/* module identifier */

const __vue_module_identifier__$ad = undefined;
/* functional template */

const __vue_is_functional_template__$ad = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$ad = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$ad,
  staticRenderFns: __vue_staticRenderFns__$ad
}, __vue_inject_styles__$ad, __vue_script__$ad, __vue_scope_id__$ad, __vue_is_functional_template__$ad, __vue_module_identifier__$ad, false, undefined, undefined, undefined);

var script$ae = Vue.extend({
  name: "PhPlusMinus",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$ae = script$ae;
/* template */

var __vue_render__$ae = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "200",
      "y1": "56",
      "x2": "56",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "72",
      "x2": "112",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "32",
      "x2": "72",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "184",
      "x2": "224",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "200",
      "y1": "56",
      "x2": "56",
      "y2": "200",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "72",
      "x2": "112",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "32",
      "x2": "72",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "184",
      "x2": "224",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M205.65674,50.34326a8,8,0,0,0-11.31348,0l-144,144a7.99984,7.99984,0,1,0,11.31348,11.31348l144-144A7.99915,7.99915,0,0,0,205.65674,50.34326Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,112a8,8,0,0,0,16,0V80h32a8,8,0,0,0,0-16H80V32a8,8,0,0,0-16,0V64H32a8,8,0,0,0,0,16H64Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,176H144a8,8,0,0,0,0,16h80a8,8,0,0,0,0-16Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "200",
      "y1": "56",
      "x2": "56",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "72",
      "x2": "112",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "32",
      "x2": "72",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "184",
      "x2": "224",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "200",
      "y1": "56",
      "x2": "56",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "72",
      "x2": "112",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "32",
      "x2": "72",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "184",
      "x2": "224",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "200",
      "y1": "56",
      "x2": "56",
      "y2": "200",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "72",
      "x2": "112",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "32",
      "x2": "72",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "184",
      "x2": "224",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$ae = [];
/* style */

const __vue_inject_styles__$ae = undefined;
/* scoped */

const __vue_scope_id__$ae = undefined;
/* module identifier */

const __vue_module_identifier__$ae = undefined;
/* functional template */

const __vue_is_functional_template__$ae = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$ae = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$ae,
  staticRenderFns: __vue_staticRenderFns__$ae
}, __vue_inject_styles__$ae, __vue_script__$ae, __vue_scope_id__$ae, __vue_is_functional_template__$ae, __vue_module_identifier__$ae, false, undefined, undefined, undefined);

var script$af = Vue.extend({
  name: "PhPokerChip",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$af = script$af;
/* template */

var __vue_render__$af = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "80",
      "x2": "128",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "94.05887",
      "y1": "94.05887",
      "x2": "60.11775",
      "y2": "60.11775",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "128",
      "x2": "32",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "94.05887",
      "y1": "161.94113",
      "x2": "60.11775",
      "y2": "195.88225",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "176",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "161.94113",
      "y1": "161.94113",
      "x2": "195.88225",
      "y2": "195.88225",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "128",
      "x2": "224",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "161.94113",
      "y1": "94.05887",
      "x2": "195.88225",
      "y2": "60.11775",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,32a96,96,0,1,0,96,96A95.99991,95.99991,0,0,0,128,32Zm0,152a56,56,0,1,1,56-56A56.00012,56.00012,0,0,1,128,184Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "72",
      "x2": "128",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88.40202",
      "y1": "88.40202",
      "x2": "60.11775",
      "y2": "60.11775",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "128",
      "x2": "32",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88.40202",
      "y1": "167.59798",
      "x2": "60.11775",
      "y2": "195.88225",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "184",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "167.59798",
      "y1": "167.59798",
      "x2": "195.88225",
      "y2": "195.88225",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "128",
      "x2": "224",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "167.59798",
      "y1": "88.40202",
      "x2": "195.88225",
      "y2": "60.11775",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M202.16064,200.833a103.80643,103.80643,0,0,0,0-145.666,7.39654,7.39654,0,0,0-1.32666-1.32666,103.80639,103.80639,0,0,0-145.668,0A7.39654,7.39654,0,0,0,53.83936,55.167a103.80643,103.80643,0,0,0,0,145.666,7.39012,7.39012,0,0,0,1.32714,1.3269,103.80581,103.80581,0,0,0,145.667,0,7.39012,7.39012,0,0,0,1.32714-1.3269ZM40.36768,136h24.1499a63.6708,63.6708,0,0,0,12.95605,31.21216l-17.06884,17.0686A87.60592,87.60592,0,0,1,40.36768,136ZM60.40479,71.71924l17.06884,17.0686A63.6708,63.6708,0,0,0,64.51758,120H40.36768A87.60592,87.60592,0,0,1,60.40479,71.71924ZM215.63232,120h-24.1499a63.6708,63.6708,0,0,0-12.95605-31.21216l17.06884-17.0686A87.60592,87.60592,0,0,1,215.63232,120ZM167.21191,77.47339A63.66789,63.66789,0,0,0,136,64.51782V40.36743a87.60765,87.60765,0,0,1,48.28076,20.03736ZM120,64.51782A63.66789,63.66789,0,0,0,88.78809,77.47339L71.71924,60.40479A87.60765,87.60765,0,0,1,120,40.36743ZM88.78809,178.52661A63.66789,63.66789,0,0,0,120,191.48218v24.15039a87.60765,87.60765,0,0,1-48.28076-20.03736ZM136,191.48218a63.66789,63.66789,0,0,0,31.21191-12.95557l17.06885,17.0686A87.60765,87.60765,0,0,1,136,215.63257Zm42.52637-24.27A63.6708,63.6708,0,0,0,191.48242,136h24.1499a87.60592,87.60592,0,0,1-20.03711,48.28076Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "72",
      "x2": "128",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88.40202",
      "y1": "88.40202",
      "x2": "60.11775",
      "y2": "60.11775",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "128",
      "x2": "32",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88.40202",
      "y1": "167.59798",
      "x2": "60.11775",
      "y2": "195.88225",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "184",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "167.59798",
      "y1": "167.59798",
      "x2": "195.88225",
      "y2": "195.88225",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "128",
      "x2": "224",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "167.59798",
      "y1": "88.40202",
      "x2": "195.88225",
      "y2": "60.11775",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "72",
      "x2": "128",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88.40202",
      "y1": "88.40202",
      "x2": "60.11775",
      "y2": "60.11775",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "128",
      "x2": "32",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88.40202",
      "y1": "167.59798",
      "x2": "60.11775",
      "y2": "195.88225",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "184",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "167.59798",
      "y1": "167.59798",
      "x2": "195.88225",
      "y2": "195.88225",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "128",
      "x2": "224",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "167.59798",
      "y1": "88.40202",
      "x2": "195.88225",
      "y2": "60.11775",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "72",
      "x2": "128",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88.40202",
      "y1": "88.40202",
      "x2": "60.11775",
      "y2": "60.11775",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "128",
      "x2": "32",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88.40202",
      "y1": "167.59798",
      "x2": "60.11775",
      "y2": "195.88225",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "184",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "167.59798",
      "y1": "167.59798",
      "x2": "195.88225",
      "y2": "195.88225",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "128",
      "x2": "224",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "167.59798",
      "y1": "88.40202",
      "x2": "195.88225",
      "y2": "60.11775",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$af = [];
/* style */

const __vue_inject_styles__$af = undefined;
/* scoped */

const __vue_scope_id__$af = undefined;
/* module identifier */

const __vue_module_identifier__$af = undefined;
/* functional template */

const __vue_is_functional_template__$af = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$af = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$af,
  staticRenderFns: __vue_staticRenderFns__$af
}, __vue_inject_styles__$af, __vue_script__$af, __vue_scope_id__$af, __vue_is_functional_template__$af, __vue_module_identifier__$af, false, undefined, undefined, undefined);

var script$ag = Vue.extend({
  name: "PhPolygon",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$ag = script$ag;
/* template */

var __vue_render__$ag = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "120",
      "cy": "48",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "40",
      "cy": "120",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "160",
      "cy": "208",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "208",
      "cy": "72",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184.84844",
      "y1": "65.68594",
      "x2": "143.15155",
      "y2": "54.31406",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "102.16099",
      "y1": "64.05511",
      "x2": "57.83902",
      "y2": "103.94489",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "59.35636",
      "y1": "134.19466",
      "x2": "140.64365",
      "y2": "193.80534",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "167.98938",
      "y1": "185.36342",
      "x2": "200.01089",
      "y2": "94.6358",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "120",
      "cy": "48",
      "r": "24",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "40",
      "cy": "120",
      "r": "24",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "160",
      "cy": "208",
      "r": "24",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "208",
      "cy": "72",
      "r": "24",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "120",
      "cy": "48",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "40",
      "cy": "120",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "160",
      "cy": "208",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "208",
      "cy": "72",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184.84844",
      "y1": "65.68594",
      "x2": "143.15155",
      "y2": "54.31406",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "102.16099",
      "y1": "64.05511",
      "x2": "57.83902",
      "y2": "103.94489",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "59.35636",
      "y1": "134.19466",
      "x2": "140.64365",
      "y2": "193.80534",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "167.98938",
      "y1": "185.36342",
      "x2": "200.01089",
      "y2": "94.6358",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M230.62744,49.37207a32.03673,32.03673,0,0,0-45.25488,0l-.00049.001a31.9114,31.9114,0,0,0-5.15478,6.75781l-28.24256-7.70215A31.978,31.978,0,0,0,97.37256,25.37207l-.00049.001a32.056,32.056,0,0,0-5.75415,37.4082L57.68018,93.3252a32.05378,32.05378,0,0,0-40.30762,4.04687l-.00049.001a32.00105,32.00105,0,0,0,42.88257,47.40039l70.03247,51.35791A32.00685,32.00685,0,1,0,177.855,181.44727l27.38355-77.58692c.91882.07861,1.84.124,2.76147.124a31.98463,31.98463,0,0,0,22.62744-54.61231Zm-67.866,126.7666a31.96846,31.96846,0,0,0-23.0166,7.0874l-70.032-51.35742a32.15784,32.15784,0,0,0-1.33081-26.6499L102.31982,74.6748a31.98394,31.98394,0,0,0,45.46289-10.80566l28.24256,7.70215a31.91307,31.91307,0,0,0,14.11951,26.98144Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "120",
      "cy": "48",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "40",
      "cy": "120",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "160",
      "cy": "208",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "208",
      "cy": "72",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184.84844",
      "y1": "65.68594",
      "x2": "143.15155",
      "y2": "54.31406",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "102.16099",
      "y1": "64.05511",
      "x2": "57.83902",
      "y2": "103.94489",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "59.35636",
      "y1": "134.19466",
      "x2": "140.64365",
      "y2": "193.80534",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "167.98938",
      "y1": "185.36342",
      "x2": "200.01089",
      "y2": "94.6358",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "120",
      "cy": "48",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "40",
      "cy": "120",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "160",
      "cy": "208",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "208",
      "cy": "72",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184.84844",
      "y1": "65.68594",
      "x2": "143.15155",
      "y2": "54.31406",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "102.16099",
      "y1": "64.05511",
      "x2": "57.83902",
      "y2": "103.94489",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "59.35636",
      "y1": "134.19466",
      "x2": "140.64365",
      "y2": "193.80534",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "167.98938",
      "y1": "185.36342",
      "x2": "200.01089",
      "y2": "94.6358",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "120",
      "cy": "48",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "40",
      "cy": "120",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "160",
      "cy": "208",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "208",
      "cy": "72",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184.84844",
      "y1": "65.68594",
      "x2": "143.15155",
      "y2": "54.31406",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "102.16099",
      "y1": "64.05511",
      "x2": "57.83902",
      "y2": "103.94489",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "59.35636",
      "y1": "134.19466",
      "x2": "140.64365",
      "y2": "193.80534",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "167.98938",
      "y1": "185.36342",
      "x2": "200.01089",
      "y2": "94.6358",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$ag = [];
/* style */

const __vue_inject_styles__$ag = undefined;
/* scoped */

const __vue_scope_id__$ag = undefined;
/* module identifier */

const __vue_module_identifier__$ag = undefined;
/* functional template */

const __vue_is_functional_template__$ag = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$ag = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$ag,
  staticRenderFns: __vue_staticRenderFns__$ag
}, __vue_inject_styles__$ag, __vue_script__$ag, __vue_scope_id__$ag, __vue_is_functional_template__$ag, __vue_module_identifier__$ag, false, undefined, undefined, undefined);

var script$ah = Vue.extend({
  name: "PhPower",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$ah = script$ah;
/* template */

var __vue_render__$ah = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "127.99219",
      "y1": "48.00288",
      "x2": "127.99219",
      "y2": "124.00288",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176.00189,54.23268a88,88,0,1,1-96.00346-.00021",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "127.99219",
      "y1": "48.00288",
      "x2": "127.99219",
      "y2": "124.00288",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176.00189,54.23268a88,88,0,1,1-96.00346-.00021",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,23.99988a104,104,0,1,0,104,104A104.11786,104.11786,0,0,0,128,23.99988Zm-8.00781,32.00293a8,8,0,0,1,16,0v60a8,8,0,1,1-16,0ZM128,207.99988A79.98292,79.98292,0,0,1,83.53516,61.52136a8,8,0,1,1,8.91357,13.28711,63.99978,63.99978,0,1,0,71.08838-.00976,8,8,0,0,1,8.91016-13.28955A79.98322,79.98322,0,0,1,128,207.99988Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "127.99219",
      "y1": "48.00288",
      "x2": "127.99219",
      "y2": "124.00288",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176.00189,54.23268a88,88,0,1,1-96.00346-.00021",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "127.99219",
      "y1": "48.00288",
      "x2": "127.99219",
      "y2": "124.00288",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176.00189,54.23268a88,88,0,1,1-96.00346-.00021",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "127.99219",
      "y1": "48.00288",
      "x2": "127.99219",
      "y2": "124.00288",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176.00189,54.23268a88,88,0,1,1-96.00346-.00021",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$ah = [];
/* style */

const __vue_inject_styles__$ah = undefined;
/* scoped */

const __vue_scope_id__$ah = undefined;
/* module identifier */

const __vue_module_identifier__$ah = undefined;
/* functional template */

const __vue_is_functional_template__$ah = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$ah = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$ah,
  staticRenderFns: __vue_staticRenderFns__$ah
}, __vue_inject_styles__$ah, __vue_script__$ah, __vue_scope_id__$ah, __vue_is_functional_template__$ah, __vue_module_identifier__$ah, false, undefined, undefined, undefined);

var script$ai = Vue.extend({
  name: "PhPrescription",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$ai = script$ai;
/* template */

var __vue_render__$ai = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M72,128h48a44,44,0,0,0,0-88H72V192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "128",
      "x2": "200",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "160",
      "x2": "144",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M72,128h48a44,44,0,0,0,0-88H72V192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,128h48a44,44,0,0,0,0-88H72Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "128",
      "x2": "200",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "160",
      "x2": "144",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M183.31348,188l22.34326-22.34326a7.99984,7.99984,0,0,0-11.31348-11.31348L172,176.68652l-41.71289-41.71277A52.0008,52.0008,0,0,0,120,32H72a8.00008,8.00008,0,0,0-8,8V192a8,8,0,0,0,16,0V136h28.68652l52,52-22.34326,22.34326a7.99984,7.99984,0,1,0,11.31348,11.31348L172,199.31348l22.34326,22.34326a7.99984,7.99984,0,0,0,11.31348-11.31348ZM80,48h40a36,36,0,0,1,0,72H80Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M72,128h48a44,44,0,0,0,0-88H72V192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "128",
      "x2": "200",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "160",
      "x2": "144",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M72,128h48a44,44,0,0,0,0-88H72V192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "128",
      "x2": "200",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "160",
      "x2": "144",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M72,128h48a44,44,0,0,0,0-88H72V192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "128",
      "x2": "200",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "160",
      "x2": "144",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$ai = [];
/* style */

const __vue_inject_styles__$ai = undefined;
/* scoped */

const __vue_scope_id__$ai = undefined;
/* module identifier */

const __vue_module_identifier__$ai = undefined;
/* functional template */

const __vue_is_functional_template__$ai = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$ai = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$ai,
  staticRenderFns: __vue_staticRenderFns__$ai
}, __vue_inject_styles__$ai, __vue_script__$ai, __vue_scope_id__$ai, __vue_is_functional_template__$ai, __vue_module_identifier__$ai, false, undefined, undefined, undefined);

var script$aj = Vue.extend({
  name: "PhPresentation",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$aj = script$aj;
/* template */

var __vue_render__$aj = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "136",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "184",
      "x2": "192",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "184",
      "x2": "64",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "48",
      "x2": "128",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "136",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "136",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "184",
      "x2": "192",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "184",
      "x2": "64",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "48",
      "x2": "128",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,40H136V24a8,8,0,0,0-16,0V40H40A16.01833,16.01833,0,0,0,24,56V176a16.01833,16.01833,0,0,0,16,16H79.35547L57.75293,219.00293a7.99979,7.99979,0,1,0,12.49414,9.99414L99.84473,192h56.31054l29.59766,36.99707a7.99979,7.99979,0,0,0,12.49414-9.99414L176.64453,192H216a16.01833,16.01833,0,0,0,16-16V56A16.01833,16.01833,0,0,0,216,40Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "136",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "184",
      "x2": "192",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "184",
      "x2": "64",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "48",
      "x2": "128",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "136",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "184",
      "x2": "192",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "184",
      "x2": "64",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "48",
      "x2": "128",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "136",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "184",
      "x2": "192",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "184",
      "x2": "64",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "48",
      "x2": "128",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$aj = [];
/* style */

const __vue_inject_styles__$aj = undefined;
/* scoped */

const __vue_scope_id__$aj = undefined;
/* module identifier */

const __vue_module_identifier__$aj = undefined;
/* functional template */

const __vue_is_functional_template__$aj = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$aj = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$aj,
  staticRenderFns: __vue_staticRenderFns__$aj
}, __vue_inject_styles__$aj, __vue_script__$aj, __vue_scope_id__$aj, __vue_is_functional_template__$aj, __vue_module_identifier__$aj, false, undefined, undefined, undefined);

var script$ak = Vue.extend({
  name: "PhPresentationChart",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$ak = script$ak;
/* template */

var __vue_render__$ak = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "136",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "184",
      "x2": "192",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "184",
      "x2": "64",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "92",
      "y1": "120",
      "x2": "92",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "104",
      "x2": "128",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "164",
      "y1": "88",
      "x2": "164",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "48",
      "x2": "128",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "136",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "136",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "184",
      "x2": "192",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "184",
      "x2": "64",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "120",
      "x2": "96",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "104",
      "x2": "128",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "88",
      "x2": "160",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "48",
      "x2": "128",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,40H136V24a8,8,0,0,0-16,0V40H40A16.01833,16.01833,0,0,0,24,56V176a16.01833,16.01833,0,0,0,16,16H79.35547L57.75293,219.00293a7.99979,7.99979,0,1,0,12.49414,9.99414L99.84473,192h56.31054l29.59766,36.99707a7.99979,7.99979,0,0,0,12.49414-9.99414L176.64453,192H216a16.01833,16.01833,0,0,0,16-16V56A16.01833,16.01833,0,0,0,216,40ZM104,144a8,8,0,0,1-16,0V120a8,8,0,0,1,16,0Zm32,0a8,8,0,0,1-16,0V104a8,8,0,0,1,16,0Zm32,0a8,8,0,0,1-16,0V88a8,8,0,0,1,16,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "136",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "184",
      "x2": "192",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "184",
      "x2": "64",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "120",
      "x2": "96",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "104",
      "x2": "128",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "88",
      "x2": "160",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "48",
      "x2": "128",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "136",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "184",
      "x2": "192",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "184",
      "x2": "64",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "120",
      "x2": "96",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "104",
      "x2": "128",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "88",
      "x2": "160",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "48",
      "x2": "128",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "136",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "184",
      "x2": "192",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "184",
      "x2": "64",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "120",
      "x2": "96",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "104",
      "x2": "128",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "88",
      "x2": "160",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "48",
      "x2": "128",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$ak = [];
/* style */

const __vue_inject_styles__$ak = undefined;
/* scoped */

const __vue_scope_id__$ak = undefined;
/* module identifier */

const __vue_module_identifier__$ak = undefined;
/* functional template */

const __vue_is_functional_template__$ak = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$ak = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$ak,
  staticRenderFns: __vue_staticRenderFns__$ak
}, __vue_inject_styles__$ak, __vue_script__$ak, __vue_scope_id__$ak, __vue_is_functional_template__$ak, __vue_module_identifier__$ak, false, undefined, undefined, undefined);

var script$al = Vue.extend({
  name: "PhPrinter",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$al = script$al;
/* template */

var __vue_render__$al = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "63.99414",
      "y": "40",
      "width": "128",
      "height": "40",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "63.99414",
      "y": "156",
      "width": "128",
      "height": "64",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M63.99414,176h-36V96c0-8.83656,7.7604-16,17.33333-16H210.66081c9.57293,0,17.33333,7.16344,17.33333,16v80h-36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "116",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M210.66083,80H45.32751c-9.57293,0-17.33337,7.16357-17.33337,16v80h36V152h128v24h36V96C227.99414,87.16357,220.23376,80,210.66083,80Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "63.99414",
      "y": "40",
      "width": "128",
      "height": "40",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "63.99414",
      "y": "152",
      "width": "128",
      "height": "68",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M63.99414,176h-36V96c0-8.83656,7.7604-16,17.33333-16H210.66081c9.57293,0,17.33333,7.16344,17.33333,16v80h-36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "116",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M210.66064,72h-10.6665V40a8.00008,8.00008,0,0,0-8-8h-128a8.00008,8.00008,0,0,0-8,8V72H45.32764c-13.96875,0-25.3335,10.7666-25.3335,24v80a8.00008,8.00008,0,0,0,8,8h28v36a8.00008,8.00008,0,0,0,8,8h128a8.00008,8.00008,0,0,0,8-8V184h28a8.00008,8.00008,0,0,0,8-8V96C235.99414,82.7666,224.62939,72,210.66064,72ZM71.99414,48h112V72h-112Zm112,164h-112V160h112Zm4-84a12,12,0,1,1,12-12A12,12,0,0,1,187.99414,128Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "63.994 80 63.994 40 191.994 40 191.994 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "63.99414",
      "y": "152",
      "width": "128",
      "height": "68",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M63.99414,176h-36V96c0-8.83656,7.7604-16,17.33333-16H210.66081c9.57293,0,17.33333,7.16344,17.33333,16v80h-36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "116",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "63.994 80 63.994 40 191.994 40 191.994 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "63.99414",
      "y": "152",
      "width": "128",
      "height": "68",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M63.99414,176h-36V96c0-8.83656,7.7604-16,17.33333-16H210.66081c9.57293,0,17.33333,7.16344,17.33333,16v80h-36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "116",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "63.994 80 63.994 40 191.994 40 191.994 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "63.99414",
      "y": "152",
      "width": "128",
      "height": "68",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M63.99414,176h-36V96c0-8.83656,7.7604-16,17.33333-16H210.66081c9.57293,0,17.33333,7.16344,17.33333,16v80h-36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "116",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$al = [];
/* style */

const __vue_inject_styles__$al = undefined;
/* scoped */

const __vue_scope_id__$al = undefined;
/* module identifier */

const __vue_module_identifier__$al = undefined;
/* functional template */

const __vue_is_functional_template__$al = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$al = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$al,
  staticRenderFns: __vue_staticRenderFns__$al
}, __vue_inject_styles__$al, __vue_script__$al, __vue_scope_id__$al, __vue_is_functional_template__$al, __vue_module_identifier__$al, false, undefined, undefined, undefined);

var script$am = Vue.extend({
  name: "PhProhibit",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$am = script$am;
/* template */

var __vue_render__$am = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128.00049",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "60.11824",
      "y1": "60.11775",
      "x2": "195.88274",
      "y2": "195.88225",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128.00049",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128.00049",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "60.11824",
      "y1": "60.11775",
      "x2": "195.88274",
      "y2": "195.88225",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,128.00012a71.6357,71.6357,0,0,1-15.78027,44.90527L83.09424,71.78039A71.94387,71.94387,0,0,1,200,128.00012Zm-144,0a71.94342,71.94342,0,0,0,116.90576,56.21924L71.78027,83.09436A71.63607,71.63607,0,0,0,56,128.00012Zm180,0a108,108,0,1,1-108-108A108.12249,108.12249,0,0,1,236,128.00012Zm-20,0a88,88,0,1,0-88,88A88.09957,88.09957,0,0,0,216,128.00012Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128.00049",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "60.11824",
      "y1": "60.11775",
      "x2": "195.88274",
      "y2": "195.88225",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128.00049",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "60.11824",
      "y1": "60.11775",
      "x2": "195.88274",
      "y2": "195.88225",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128.00049",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "60.11824",
      "y1": "60.11775",
      "x2": "195.88274",
      "y2": "195.88225",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$am = [];
/* style */

const __vue_inject_styles__$am = undefined;
/* scoped */

const __vue_scope_id__$am = undefined;
/* module identifier */

const __vue_module_identifier__$am = undefined;
/* functional template */

const __vue_is_functional_template__$am = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$am = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$am,
  staticRenderFns: __vue_staticRenderFns__$am
}, __vue_inject_styles__$am, __vue_script__$am, __vue_scope_id__$am, __vue_is_functional_template__$am, __vue_module_identifier__$am, false, undefined, undefined, undefined);

var script$an = Vue.extend({
  name: "PhProhibitInset",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$an = script$an;
/* template */

var __vue_render__$an = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128.00049",
      "cy": "128.00452",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "99.71622",
      "y1": "99.72024",
      "x2": "156.28476",
      "y2": "156.28879",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128.00049",
      "cy": "128.00452",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128.00049",
      "cy": "128.00452",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "99.71622",
      "y1": "99.72024",
      "x2": "156.28476",
      "y2": "156.28879",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128.00049,24.00452a104,104,0,1,0,104,104A104.12041,104.12041,0,0,0,128.00049,24.00452Zm22.62742,137.94112L94.05936,105.3771a8,8,0,0,1,11.31371-11.31371l56.56854,56.56854a8,8,0,1,1-11.3137,11.31371Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128.00049",
      "cy": "128.00452",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "99.71622",
      "y1": "99.72024",
      "x2": "156.28476",
      "y2": "156.28879",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128.00049",
      "cy": "128.00452",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "99.71622",
      "y1": "99.72024",
      "x2": "156.28476",
      "y2": "156.28879",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128.00049",
      "cy": "128.00452",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "99.71622",
      "y1": "99.72024",
      "x2": "156.28476",
      "y2": "156.28879",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$an = [];
/* style */

const __vue_inject_styles__$an = undefined;
/* scoped */

const __vue_scope_id__$an = undefined;
/* module identifier */

const __vue_module_identifier__$an = undefined;
/* functional template */

const __vue_is_functional_template__$an = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$an = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$an,
  staticRenderFns: __vue_staticRenderFns__$an
}, __vue_inject_styles__$an, __vue_script__$an, __vue_scope_id__$an, __vue_is_functional_template__$an, __vue_module_identifier__$an, false, undefined, undefined, undefined);

var script$ao = Vue.extend({
  name: "PhProjectorScreen",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$ao = script$ao;
/* template */

var __vue_render__$ao = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "176",
      "x2": "48",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "80",
      "x2": "208",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "40",
      "width": "192",
      "height": "40",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "176",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "232",
      "r": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "176",
      "x2": "224",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "48",
      "y": "72",
      "width": "160",
      "height": "112",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "184",
      "x2": "48",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "72",
      "x2": "208",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "40",
      "width": "192",
      "height": "32",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "184",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "232",
      "r": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "184",
      "x2": "224",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232,64V48a16.01833,16.01833,0,0,0-16-16H40A16.01833,16.01833,0,0,0,24,48V64A16.01833,16.01833,0,0,0,40,80v96H32a8,8,0,0,0,0,16h88v17.37622a24,24,0,1,0,16,0V192h88a8,8,0,0,0,0-16h-8V80A16.01833,16.01833,0,0,0,232,64ZM128,240a8,8,0,1,1,8-8A8.00917,8.00917,0,0,1,128,240ZM40,48H216l.00977,16H40Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "184",
      "x2": "48",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "72",
      "x2": "208",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "40",
      "width": "192",
      "height": "32",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "184",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "232",
      "r": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "184",
      "x2": "224",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "184",
      "x2": "48",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "72",
      "x2": "208",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "40",
      "width": "192",
      "height": "32",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "184",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "232",
      "r": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "184",
      "x2": "224",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "184",
      "x2": "48",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "72",
      "x2": "208",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "40",
      "width": "192",
      "height": "32",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "184",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "232",
      "r": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "184",
      "x2": "224",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$ao = [];
/* style */

const __vue_inject_styles__$ao = undefined;
/* scoped */

const __vue_scope_id__$ao = undefined;
/* module identifier */

const __vue_module_identifier__$ao = undefined;
/* functional template */

const __vue_is_functional_template__$ao = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$ao = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$ao,
  staticRenderFns: __vue_staticRenderFns__$ao
}, __vue_inject_styles__$ao, __vue_script__$ao, __vue_scope_id__$ao, __vue_is_functional_template__$ao, __vue_module_identifier__$ao, false, undefined, undefined, undefined);

var script$ap = Vue.extend({
  name: "PhProjectorScreenChart",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$ap = script$ap;
/* template */

var __vue_render__$ap = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "92",
      "y1": "128",
      "x2": "92",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "124",
      "x2": "128",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "164",
      "y1": "120",
      "x2": "164",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "176",
      "x2": "48",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "80",
      "x2": "208",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "40",
      "width": "192",
      "height": "40",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "176",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "232",
      "r": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "176",
      "x2": "224",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "48",
      "y": "72",
      "width": "160",
      "height": "112",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "184",
      "x2": "48",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "72",
      "x2": "208",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "128",
      "x2": "96",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "120",
      "x2": "128",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "112",
      "x2": "160",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "40",
      "width": "192",
      "height": "32",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "184",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "232",
      "r": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "184",
      "x2": "224",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232,64V48a16.01833,16.01833,0,0,0-16-16H40A16.01833,16.01833,0,0,0,24,48V64A16.01833,16.01833,0,0,0,40,80v96H32a8,8,0,0,0,0,16h88v17.37622a24,24,0,1,0,16,0V192h88a8,8,0,0,0,0-16h-8V80A16.01833,16.01833,0,0,0,232,64ZM104,144a8,8,0,0,1-16,0V128a8,8,0,0,1,16,0Zm24,96a8,8,0,1,1,8-8A8.00917,8.00917,0,0,1,128,240Zm8-96a8,8,0,0,1-16,0V120a8,8,0,0,1,16,0Zm32,0a8,8,0,0,1-16,0V112a8,8,0,0,1,16,0ZM40,64V48H216l.00977,16H40Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "184",
      "x2": "48",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "72",
      "x2": "208",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "128",
      "x2": "96",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "120",
      "x2": "128",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "112",
      "x2": "160",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "40",
      "width": "192",
      "height": "32",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "184",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "232",
      "r": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "184",
      "x2": "224",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "184",
      "x2": "48",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "72",
      "x2": "208",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "128",
      "x2": "96",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "120",
      "x2": "128",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "112",
      "x2": "160",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "40",
      "width": "192",
      "height": "32",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "184",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "232",
      "r": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "184",
      "x2": "224",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "184",
      "x2": "48",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "72",
      "x2": "208",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "128",
      "x2": "96",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "120",
      "x2": "128",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "112",
      "x2": "160",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "40",
      "width": "192",
      "height": "32",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "184",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "232",
      "r": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "184",
      "x2": "224",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$ap = [];
/* style */

const __vue_inject_styles__$ap = undefined;
/* scoped */

const __vue_scope_id__$ap = undefined;
/* module identifier */

const __vue_module_identifier__$ap = undefined;
/* functional template */

const __vue_is_functional_template__$ap = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$ap = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$ap,
  staticRenderFns: __vue_staticRenderFns__$ap
}, __vue_inject_styles__$ap, __vue_script__$ap, __vue_scope_id__$ap, __vue_is_functional_template__$ap, __vue_module_identifier__$ap, false, undefined, undefined, undefined);

var script$aq = Vue.extend({
  name: "PhPushPin",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$aq = script$aq;
/* template */

var __vue_render__$aq = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "88",
      "y1": "168",
      "x2": "48",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154.34315,29.65685,92,92S64.256,78.128,34.60125,102.05044a8.01406,8.01406,0,0,0-.64838,11.90243L141.84933,221.84933a7.99324,7.99324,0,0,0,12.04036-.83167C162.28278,209.86184,175.46546,186.93092,164,164l62.34315-62.34315a8,8,0,0,0,0-11.3137l-60.6863-60.6863A8,8,0,0,0,154.34315,29.65685Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M154.34315,29.65685,92,92S64.256,78.128,34.60125,102.05044a8.01406,8.01406,0,0,0-.64838,11.90243L141.84933,221.84933a7.99324,7.99324,0,0,0,12.04036-.83167C162.28278,209.86184,175.46546,186.93092,164,164l62.34315-62.34315a8,8,0,0,0,0-11.3137l-60.6863-60.6863A8,8,0,0,0,154.34315,29.65685Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "168",
      "x2": "48",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154.34315,29.65685,92,92S64.256,78.128,34.60125,102.05044a8.01406,8.01406,0,0,0-.64838,11.90243L141.84933,221.84933a7.99324,7.99324,0,0,0,12.04036-.83167C162.28278,209.86184,175.46546,186.93092,164,164l62.34315-62.34315a8,8,0,0,0,0-11.3137l-60.6863-60.6863A8,8,0,0,0,154.34315,29.65685Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M231.999,107.31445,173.47168,165.8418c4.55664,12.67968,6.44531,33.88965-13.18945,59.98584a15.96991,15.96991,0,0,1-11.64649,6.33007q-.5625.03955-1.124.03956a16.0039,16.0039,0,0,1-11.31934-4.69141L88,179.314,53.65723,213.65674a8.00018,8.00018,0,0,1-11.31446-11.31348L76.686,168,28.2959,119.60986a16.01339,16.01339,0,0,1,1.2832-23.78613C55.00488,75.312,79.34082,79.35205,89.99316,82.69287L148.68555,24l.001-.001a16.02135,16.02135,0,0,1,22.627,0L232,84.68652a15.99888,15.99888,0,0,1-.001,22.62793Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "88",
      "y1": "168",
      "x2": "48",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154.34315,29.65685,92,92S64.256,78.128,34.60125,102.05044a8.01406,8.01406,0,0,0-.64838,11.90243L141.84933,221.84933a7.99324,7.99324,0,0,0,12.04036-.83167C162.28278,209.86184,175.46546,186.93092,164,164l62.34315-62.34315a8,8,0,0,0,0-11.3137l-60.6863-60.6863A8,8,0,0,0,154.34315,29.65685Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "88",
      "y1": "168",
      "x2": "48",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154.34315,29.65685,92,92S64.256,78.128,34.60125,102.05044a8.01406,8.01406,0,0,0-.64838,11.90243L141.84933,221.84933a7.99324,7.99324,0,0,0,12.04036-.83167C162.28278,209.86184,175.46546,186.93092,164,164l62.34315-62.34315a8,8,0,0,0,0-11.3137l-60.6863-60.6863A8,8,0,0,0,154.34315,29.65685Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "88",
      "y1": "168",
      "x2": "48",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154.34315,29.65685,92,92S64.256,78.128,34.60125,102.05044a8.01406,8.01406,0,0,0-.64838,11.90243L141.84933,221.84933a7.99324,7.99324,0,0,0,12.04036-.83167C162.28278,209.86184,175.46546,186.93092,164,164l62.34315-62.34315a8,8,0,0,0,0-11.3137l-60.6863-60.6863A8,8,0,0,0,154.34315,29.65685Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$aq = [];
/* style */

const __vue_inject_styles__$aq = undefined;
/* scoped */

const __vue_scope_id__$aq = undefined;
/* module identifier */

const __vue_module_identifier__$aq = undefined;
/* functional template */

const __vue_is_functional_template__$aq = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$aq = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$aq,
  staticRenderFns: __vue_staticRenderFns__$aq
}, __vue_inject_styles__$aq, __vue_script__$aq, __vue_scope_id__$aq, __vue_is_functional_template__$aq, __vue_module_identifier__$aq, false, undefined, undefined, undefined);

var script$ar = Vue.extend({
  name: "PhPushPinSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$ar = script$ar;
/* template */

var __vue_render__$ar = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "176",
      "x2": "128",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "40",
      "x2": "192",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "176",
      "x2": "216",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "176",
      "x2": "80",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "40",
      "x2": "200",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "56 176 80 40 176 40 200 176 56 176",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "176",
      "x2": "128",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "40",
      "x2": "192",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "176",
      "x2": "216",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "176",
      "x2": "80",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "40",
      "x2": "200",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,176a8.00008,8.00008,0,0,1-8,8H200.02393l-.0337.00146L199.95752,184H136v56a8,8,0,0,1-16,0V184H56.04248l-.03271.00146L55.97607,184H40a8,8,0,0,1,0-16h9.28857L70.46484,48H64a8,8,0,0,1,0-16H192a8,8,0,0,1,0,16h-6.46484l21.17627,120H216A8.00008,8.00008,0,0,1,224,176Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "176",
      "x2": "128",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "40",
      "x2": "192",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "176",
      "x2": "216",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "176",
      "x2": "80",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "40",
      "x2": "200",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "176",
      "x2": "128",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "40",
      "x2": "192",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "176",
      "x2": "216",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "176",
      "x2": "80",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "40",
      "x2": "200",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "176",
      "x2": "128",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "40",
      "x2": "192",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "176",
      "x2": "216",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "176",
      "x2": "80",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "40",
      "x2": "200",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$ar = [];
/* style */

const __vue_inject_styles__$ar = undefined;
/* scoped */

const __vue_scope_id__$ar = undefined;
/* module identifier */

const __vue_module_identifier__$ar = undefined;
/* functional template */

const __vue_is_functional_template__$ar = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$ar = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$ar,
  staticRenderFns: __vue_staticRenderFns__$ar
}, __vue_inject_styles__$ar, __vue_script__$ar, __vue_scope_id__$ar, __vue_is_functional_template__$ar, __vue_module_identifier__$ar, false, undefined, undefined, undefined);

var script$as = Vue.extend({
  name: "PhPushPinSimpleSlash",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$as = script$as;
/* template */

var __vue_render__$as = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "176",
      "x2": "128",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "171.63638",
      "y1": "176",
      "x2": "40",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "176",
      "x2": "74.79803",
      "y2": "69.47783",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "102.05828",
      "y1": "40",
      "x2": "192",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "40",
      "x2": "193.81077",
      "y2": "140.92769",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "56 176 80 40 176 40 200 176 56 176",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "91.24627",
      "y1": "40",
      "x2": "192",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "176",
      "x2": "128",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "40",
      "x2": "196.41513",
      "y2": "155.68575",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "171.63638",
      "y1": "176",
      "x2": "40",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "176",
      "x2": "74.79803",
      "y2": "69.47783",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M213.38184,221.91943a8.00088,8.00088,0,0,1-11.30176-.53808L168.09717,184H136v56a8,8,0,0,1-16,0V184H56.1543c-.04883.001-.09668.00146-.14453.00146-.04883,0-.09668-.00048-.14551-.00146H40a8,8,0,0,1,0-16h9.28809L66.2373,71.95459,42.08008,45.38135a8.00027,8.00027,0,0,1,11.83984-10.7627l75.21729,82.739,48.41943,53.261.002.00293,36.36133,39.99707A8.00084,8.00084,0,0,1,213.38184,221.91943Zm-22.88672-60.85254a8,8,0,0,0,13.79785-6.77148L185.53516,48H192a8,8,0,0,0,0-16H91.19922a8.00042,8.00042,0,0,0-7.94043,7.54443c-.01367.24073-.0166.48194-.00879.72217a7.97263,7.97263,0,0,0,2.09863,5.13916Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "91.24627",
      "y1": "40",
      "x2": "192",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "176",
      "x2": "128",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "40",
      "x2": "196.41513",
      "y2": "155.68575",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "171.63638",
      "y1": "176",
      "x2": "40",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "176",
      "x2": "74.79803",
      "y2": "69.47783",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "91.24627",
      "y1": "40",
      "x2": "192",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "176",
      "x2": "128",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "40",
      "x2": "196.41513",
      "y2": "155.68575",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "171.63638",
      "y1": "176",
      "x2": "40",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "176",
      "x2": "74.79803",
      "y2": "69.47783",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "91.24627",
      "y1": "40",
      "x2": "192",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "176",
      "x2": "128",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "40",
      "x2": "196.41513",
      "y2": "155.68575",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "171.63638",
      "y1": "176",
      "x2": "40",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "176",
      "x2": "74.79803",
      "y2": "69.47783",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$as = [];
/* style */

const __vue_inject_styles__$as = undefined;
/* scoped */

const __vue_scope_id__$as = undefined;
/* module identifier */

const __vue_module_identifier__$as = undefined;
/* functional template */

const __vue_is_functional_template__$as = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$as = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$as,
  staticRenderFns: __vue_staticRenderFns__$as
}, __vue_inject_styles__$as, __vue_script__$as, __vue_scope_id__$as, __vue_is_functional_template__$as, __vue_module_identifier__$as, false, undefined, undefined, undefined);

var script$at = Vue.extend({
  name: "PhPushPinSlash",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$at = script$at;
/* template */

var __vue_render__$at = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "88",
      "y1": "168",
      "x2": "48",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M93.71428,90.28572,92,92S64.256,78.128,34.60125,102.05044a8.01406,8.01406,0,0,0-.64838,11.90243L141.84933,221.84933a7.99324,7.99324,0,0,0,12.04036-.83167c7.60268-10.10523,19.13532-29.87219,12.71834-50.549",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M190.60211,137.39789l35.741-35.741a8,8,0,0,0,0-11.3137l-60.6863-60.6863a8,8,0,0,0-11.3137,0L122.03066,61.96934",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M154.34315,29.65685,92,92S64.256,78.128,34.60125,102.05044a8.01406,8.01406,0,0,0-.64838,11.90243L141.84933,221.84933a7.99324,7.99324,0,0,0,12.04036-.83167C162.28278,209.86184,175.46546,186.93092,164,164l62.34315-62.34315a8,8,0,0,0,0-11.3137l-60.6863-60.6863A8,8,0,0,0,154.34315,29.65685Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "168",
      "x2": "48",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M93.71428,90.28572,92,92S64.256,78.128,34.60125,102.05044a8.01406,8.01406,0,0,0-.64838,11.90243L141.84933,221.84933a7.99324,7.99324,0,0,0,12.04036-.83167c7.60268-10.10523,19.13532-29.87219,12.71834-50.549",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184.9386,143.0614l41.40455-41.40455a8,8,0,0,0,0-11.3137l-60.6863-60.6863a8,8,0,0,0-11.3137,0l-37.976,37.976",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M213.91992,210.61865a8.00027,8.00027,0,0,1-11.83984,10.7627l-26.42334-29.06543c-2.45459,14.17285-9.88623,26.21582-15.37451,33.51123a15.96882,15.96882,0,0,1-11.64649,6.33056q-.5625.03955-1.124.03956a16.0039,16.0039,0,0,1-11.31934-4.69141L88,179.314,53.65723,213.65674a8.00018,8.00018,0,0,1-11.31446-11.31348L76.686,168,28.2959,119.60986a16.01339,16.01339,0,0,1,1.2832-23.78613c16.17676-13.05029,31.90967-16.16064,43.96-15.8374l-31.459-34.605a8.00027,8.00027,0,0,1,11.83984-10.7627ZM232,84.68652,171.31348,23.999A16.02162,16.02162,0,0,0,148.68555,24L110.71,61.97607a8.00034,8.00034,0,0,0-.26269,11.03809l68.57128,75.42871a8.00133,8.00133,0,0,0,5.7295,2.61621c.06347.00147.12695.00244.19043.00244a8.00139,8.00139,0,0,0,5.65722-2.34326L231.999,107.31445A15.99888,15.99888,0,0,0,232,84.68652Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "88",
      "y1": "168",
      "x2": "48",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M93.71428,90.28572,92,92S64.256,78.128,34.60125,102.05044a8.01406,8.01406,0,0,0-.64838,11.90243L141.84933,221.84933a7.99324,7.99324,0,0,0,12.04036-.83167c7.60268-10.10523,19.13532-29.87219,12.71834-50.549",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184.9386,143.0614l41.40455-41.40455a8,8,0,0,0,0-11.3137l-60.6863-60.6863a8,8,0,0,0-11.3137,0l-37.976,37.976",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "88",
      "y1": "168",
      "x2": "48",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M93.71428,90.28572,92,92S64.256,78.128,34.60125,102.05044a8.01406,8.01406,0,0,0-.64838,11.90243L141.84933,221.84933a7.99324,7.99324,0,0,0,12.04036-.83167c7.60268-10.10523,19.13532-29.87219,12.71834-50.549",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184.9386,143.0614l41.40455-41.40455a8,8,0,0,0,0-11.3137l-60.6863-60.6863a8,8,0,0,0-11.3137,0l-37.976,37.976",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "88",
      "y1": "168",
      "x2": "48",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M93.71428,90.28572,92,92S64.256,78.128,34.60125,102.05044a8.01406,8.01406,0,0,0-.64838,11.90243L141.84933,221.84933a7.99324,7.99324,0,0,0,12.04036-.83167c7.60268-10.10523,19.13532-29.87219,12.71834-50.549",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184.9386,143.0614l41.40455-41.40455a8,8,0,0,0,0-11.3137l-60.6863-60.6863a8,8,0,0,0-11.3137,0l-37.976,37.976",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$at = [];
/* style */

const __vue_inject_styles__$at = undefined;
/* scoped */

const __vue_scope_id__$at = undefined;
/* module identifier */

const __vue_module_identifier__$at = undefined;
/* functional template */

const __vue_is_functional_template__$at = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$at = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$at,
  staticRenderFns: __vue_staticRenderFns__$at
}, __vue_inject_styles__$at, __vue_script__$at, __vue_scope_id__$at, __vue_is_functional_template__$at, __vue_module_identifier__$at, false, undefined, undefined, undefined);

var script$au = Vue.extend({
  name: "PhPuzzlePiece",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$au = script$au;
/* template */

var __vue_render__$au = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M63.99986,216a8,8,0,0,1-8-8.00009l.00053-42.69468a28,28,0,1,1,0-50.61044L55.99988,72.0001A8,8,0,0,1,64,64l46.69456.00053a27.99993,27.99993,0,1,1,50.61031,0L207.99939,64a8,8,0,0,1,8.00007,7.9999L216,114.69478a28,28,0,1,0,0,50.61044l-.00053,42.69487a8,8,0,0,1-8,7.9999Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M63.99986,216a8,8,0,0,1-8-8.00009l.00053-42.69468a28,28,0,1,1,0-50.61044L55.99988,72.0001A8,8,0,0,1,64,64l46.69456.00053a27.99993,27.99993,0,1,1,50.61031,0L207.99939,64a8,8,0,0,1,8.00007,7.9999L216,114.69478a28,28,0,1,0,0,50.61044l-.00053,42.69487a8,8,0,0,1-8,7.9999Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M63.99986,216a8,8,0,0,1-8-8.00009l.00053-42.69468a28,28,0,1,1,0-50.61044L55.99988,72.0001A8,8,0,0,1,64,64l46.69456.00053a27.99993,27.99993,0,1,1,50.61031,0L207.99939,64a8,8,0,0,1,8.00007,7.9999L216,114.69478a28,28,0,1,0,0,50.61044l-.00053,42.69487a8,8,0,0,1-8,7.9999Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M165.78027,224.001,207.99951,224a16.018,16.018,0,0,0,16-16L224,170.34863a7.99966,7.99966,0,0,0-11.05957-7.3916A23.25464,23.25464,0,0,1,204,164.72754c-13.2334,0-24-11.09277-24-24.72754s10.7666-24.72754,24-24.72754a23.25464,23.25464,0,0,1,8.94043,1.77051A7.99966,7.99966,0,0,0,224,109.65137L223.99951,72A16.01812,16.01812,0,0,0,207.999,56l-36.21728.001A36.60975,36.60975,0,0,0,171.99951,52a36,36,0,0,0-72,0,36.60975,36.60975,0,0,0,.21778,4.001L63.99951,56a16.018,16.018,0,0,0-16,16L48,104.21777A36.47481,36.47481,0,0,0,43.99951,104a36,36,0,0,0,0,72A36.47481,36.47481,0,0,0,48,175.78223L47.99951,208A16.01791,16.01791,0,0,0,63.999,224l42.22071.001h0"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M63.99986,216a8,8,0,0,1-8-8.00009l.00053-42.69468a28,28,0,1,1,0-50.61044L55.99988,72.0001A8,8,0,0,1,64,64l46.69456.00053a27.99993,27.99993,0,1,1,50.61031,0L207.99939,64a8,8,0,0,1,8.00007,7.9999L216,114.69478a28,28,0,1,0,0,50.61044l-.00053,42.69487a8,8,0,0,1-8,7.9999Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M63.99986,216a8,8,0,0,1-8-8.00009l.00053-42.69468a28,28,0,1,1,0-50.61044L55.99988,72.0001A8,8,0,0,1,64,64l46.69456.00053a27.99993,27.99993,0,1,1,50.61031,0L207.99939,64a8,8,0,0,1,8.00007,7.9999L216,114.69478a28,28,0,1,0,0,50.61044l-.00053,42.69487a8,8,0,0,1-8,7.9999Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M63.99986,216a8,8,0,0,1-8-8.00009l.00053-42.69468a28,28,0,1,1,0-50.61044L55.99988,72.0001A8,8,0,0,1,64,64l46.69456.00053a27.99993,27.99993,0,1,1,50.61031,0L207.99939,64a8,8,0,0,1,8.00007,7.9999L216,114.69478a28,28,0,1,0,0,50.61044l-.00053,42.69487a8,8,0,0,1-8,7.9999Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$au = [];
/* style */

const __vue_inject_styles__$au = undefined;
/* scoped */

const __vue_scope_id__$au = undefined;
/* module identifier */

const __vue_module_identifier__$au = undefined;
/* functional template */

const __vue_is_functional_template__$au = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$au = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$au,
  staticRenderFns: __vue_staticRenderFns__$au
}, __vue_inject_styles__$au, __vue_script__$au, __vue_scope_id__$au, __vue_is_functional_template__$au, __vue_module_identifier__$au, false, undefined, undefined, undefined);

var script$av = Vue.extend({
  name: "PhQrCode",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$av = script$av;
/* template */

var __vue_render__$av = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "48.00244",
      "y": "48",
      "width": "60",
      "height": "60",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "48.00244",
      "y": "148",
      "width": "60",
      "height": "60",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "148.00244",
      "y": "48",
      "width": "60",
      "height": "60",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "148.00244",
      "y1": "148",
      "x2": "148.00244",
      "y2": "172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "148.002 208 184.002 208 184.002 148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184.00244",
      "y1": "164",
      "x2": "208.00244",
      "y2": "164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "48.00244",
      "y": "48",
      "width": "64",
      "height": "64",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "48.00244",
      "y": "144",
      "width": "64",
      "height": "64",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "144.00244",
      "y": "48",
      "width": "64",
      "height": "64",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "48.00244",
      "y": "48",
      "width": "64",
      "height": "64",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "48.00244",
      "y": "144",
      "width": "64",
      "height": "64",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "144.00244",
      "y": "48",
      "width": "64",
      "height": "64",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144.00244",
      "y1": "144",
      "x2": "144.00244",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144.002 208 176.002 208 176.002 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176.00244",
      "y1": "160",
      "x2": "208.00244",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208.00244",
      "y1": "192",
      "x2": "208.00244",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('rect', {
    attrs: {
      "x": "40.00244",
      "y": "40",
      "width": "80",
      "height": "80",
      "rx": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40.00244",
      "y": "136",
      "width": "80",
      "height": "80",
      "rx": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "136.00244",
      "y": "40",
      "width": "80",
      "height": "80",
      "rx": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M144.00244,184a8.00039,8.00039,0,0,0,8-8V144a8,8,0,0,0-16,0v32A8.00039,8.00039,0,0,0,144.00244,184Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208.00244,152h-24v-8a8,8,0,0,0-16,0v56h-24a8,8,0,1,0,0,16h32a8.00039,8.00039,0,0,0,8-8V168h24a8,8,0,0,0,0-16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208.00244,184a8.00039,8.00039,0,0,0-8,8v16a8,8,0,0,0,16,0V192A8.00039,8.00039,0,0,0,208.00244,184Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "48.00244",
      "y": "48",
      "width": "64",
      "height": "64",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "48.00244",
      "y": "144",
      "width": "64",
      "height": "64",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "144.00244",
      "y": "48",
      "width": "64",
      "height": "64",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144.00244",
      "y1": "144",
      "x2": "144.00244",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144.002 208 176.002 208 176.002 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176.00244",
      "y1": "160",
      "x2": "208.00244",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208.00244",
      "y1": "192",
      "x2": "208.00244",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "48.00244",
      "y": "48",
      "width": "64",
      "height": "64",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "48.00244",
      "y": "144",
      "width": "64",
      "height": "64",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "144.00244",
      "y": "48",
      "width": "64",
      "height": "64",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144.00244",
      "y1": "144",
      "x2": "144.00244",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144.002 208 176.002 208 176.002 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176.00244",
      "y1": "160",
      "x2": "208.00244",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208.00244",
      "y1": "192",
      "x2": "208.00244",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "48.00244",
      "y": "48",
      "width": "64",
      "height": "64",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "48.00244",
      "y": "144",
      "width": "64",
      "height": "64",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "144.00244",
      "y": "48",
      "width": "64",
      "height": "64",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144.00244",
      "y1": "144",
      "x2": "144.00244",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144.002 208 176.002 208 176.002 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176.00244",
      "y1": "160",
      "x2": "208.00244",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208.00244",
      "y1": "192",
      "x2": "208.00244",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$av = [];
/* style */

const __vue_inject_styles__$av = undefined;
/* scoped */

const __vue_scope_id__$av = undefined;
/* module identifier */

const __vue_module_identifier__$av = undefined;
/* functional template */

const __vue_is_functional_template__$av = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$av = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$av,
  staticRenderFns: __vue_staticRenderFns__$av
}, __vue_inject_styles__$av, __vue_script__$av, __vue_scope_id__$av, __vue_is_functional_template__$av, __vue_module_identifier__$av, false, undefined, undefined, undefined);

var script$aw = Vue.extend({
  name: "PhQuestion",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$aw = script$aw;
/* template */

var __vue_render__$aw = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128.00146",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "176",
      "r": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128.001,136.0045a28,28,0,1,0-28-28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128.00244",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128.00244",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128.00244",
      "cy": "180",
      "r": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128.00194,144.0045v-8a28,28,0,1,0-28-28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128.00146,23.99963a104,104,0,1,0,104,104A104.11791,104.11791,0,0,0,128.00146,23.99963ZM128.002,192a12,12,0,1,1,12-12A12,12,0,0,1,128.002,192Zm7.99951-48.891v.89551a8,8,0,1,1-16,0v-8a8.0004,8.0004,0,0,1,8-8,20,20,0,1,0-20-20,8,8,0,0,1-16,0,36,36,0,1,1,44,35.10449Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128.00098",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "180",
      "r": "10"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128.00048,144.0045v-8a28,28,0,1,0-28-28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128.00049",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "180",
      "r": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,144.0045v-8a28,28,0,1,0-28-28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "180",
      "r": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M127.9995,144.0045v-8a28,28,0,1,0-28-28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$aw = [];
/* style */

const __vue_inject_styles__$aw = undefined;
/* scoped */

const __vue_scope_id__$aw = undefined;
/* module identifier */

const __vue_module_identifier__$aw = undefined;
/* functional template */

const __vue_is_functional_template__$aw = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$aw = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$aw,
  staticRenderFns: __vue_staticRenderFns__$aw
}, __vue_inject_styles__$aw, __vue_script__$aw, __vue_scope_id__$aw, __vue_is_functional_template__$aw, __vue_module_identifier__$aw, false, undefined, undefined, undefined);

var script$ax = Vue.extend({
  name: "PhQueue",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$ax = script$ax;
/* template */

var __vue_render__$ax = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "64",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "136",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "192",
      "x2": "136",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "240 160 176 200 176 120 240 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "240 160 176 200 176 120 240 160",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "64",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "136",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "192",
      "x2": "136",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "240 160 176 200 176 120 240 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,64a8.00008,8.00008,0,0,1,8-8H216a8,8,0,0,1,0,16H40A8.00008,8.00008,0,0,1,32,64Zm104,56H40a8,8,0,0,0,0,16h96a8,8,0,0,0,0-16Zm0,64H40a8,8,0,0,0,0,16h96a8,8,0,0,0,0-16Zm108.24023-30.78418-64-40A8.00044,8.00044,0,0,0,168,120v80a8.00043,8.00043,0,0,0,12.24023,6.78418l64-40a8.00062,8.00062,0,0,0,0-13.56836Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "64",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "136",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "192",
      "x2": "136",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "240 160 176 200 176 120 240 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "64",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "136",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "192",
      "x2": "136",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "240 160 176 200 176 120 240 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "64",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "136",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "192",
      "x2": "136",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "240 160 176 200 176 120 240 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$ax = [];
/* style */

const __vue_inject_styles__$ax = undefined;
/* scoped */

const __vue_scope_id__$ax = undefined;
/* module identifier */

const __vue_module_identifier__$ax = undefined;
/* functional template */

const __vue_is_functional_template__$ax = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$ax = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$ax,
  staticRenderFns: __vue_staticRenderFns__$ax
}, __vue_inject_styles__$ax, __vue_script__$ax, __vue_scope_id__$ax, __vue_is_functional_template__$ax, __vue_module_identifier__$ax, false, undefined, undefined, undefined);

var script$ay = Vue.extend({
  name: "PhQuotes",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$ay = script$ay;
/* template */

var __vue_render__$ay = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M108,144H40a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8h60a8,8,0,0,1,8,8v88a40,40,0,0,1-40,40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,144H156a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8h60a8,8,0,0,1,8,8v88a40,40,0,0,1-40,40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M108,144H40a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8h60a8,8,0,0,1,8,8Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,144H156a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8h60a8,8,0,0,1,8,8Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M108,144H40a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8h60a8,8,0,0,1,8,8v88a40,40,0,0,1-40,40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,144H156a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8h60a8,8,0,0,1,8,8v88a40,40,0,0,1-40,40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M116,72v88a48.05436,48.05436,0,0,1-48,48,8,8,0,0,1,0-16,32.036,32.036,0,0,0,32-32v-8H40a16.01833,16.01833,0,0,1-16-16V72A16.01833,16.01833,0,0,1,40,56h60A16.01833,16.01833,0,0,1,116,72ZM216,56H156a16.01833,16.01833,0,0,0-16,16v64a16.01833,16.01833,0,0,0,16,16h60v8a32.036,32.036,0,0,1-32,32,8,8,0,0,0,0,16,48.05436,48.05436,0,0,0,48-48V72A16.01833,16.01833,0,0,0,216,56Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M108,144H40a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8h60a8,8,0,0,1,8,8v88a40,40,0,0,1-40,40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,144H156a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8h60a8,8,0,0,1,8,8v88a40,40,0,0,1-40,40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M108,144H40a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8h60a8,8,0,0,1,8,8v88a40,40,0,0,1-40,40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,144H156a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8h60a8,8,0,0,1,8,8v88a40,40,0,0,1-40,40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M108,144H40a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8h60a8,8,0,0,1,8,8v88a40,40,0,0,1-40,40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,144H156a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8h60a8,8,0,0,1,8,8v88a40,40,0,0,1-40,40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$ay = [];
/* style */

const __vue_inject_styles__$ay = undefined;
/* scoped */

const __vue_scope_id__$ay = undefined;
/* module identifier */

const __vue_module_identifier__$ay = undefined;
/* functional template */

const __vue_is_functional_template__$ay = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$ay = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$ay,
  staticRenderFns: __vue_staticRenderFns__$ay
}, __vue_inject_styles__$ay, __vue_script__$ay, __vue_scope_id__$ay, __vue_is_functional_template__$ay, __vue_module_identifier__$ay, false, undefined, undefined, undefined);

var script$az = Vue.extend({
  name: "PhRadical",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$az = script$az;
/* template */

var __vue_render__$az = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "232 96 232 72 120 72 72 200 24 72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "232 96 232 72 120 72 72 200 24 72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M72,208a7.99963,7.99963,0,0,1-7.49072-5.19092l-48-128a8.00011,8.00011,0,0,1,14.98144-5.61816L72,177.21582l40.50928-108.0249A7.99963,7.99963,0,0,1,120,64H232a7.99977,7.99977,0,0,1,8,8V96a8,8,0,0,1-16,0V80H125.544L79.49072,202.80908A7.99963,7.99963,0,0,1,72,208Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "232 96 232 72 120 72 72 200 24 72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "232 96 232 72 120 72 72 200 24 72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "232 96 232 72 120 72 72 200 24 72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$az = [];
/* style */

const __vue_inject_styles__$az = undefined;
/* scoped */

const __vue_scope_id__$az = undefined;
/* module identifier */

const __vue_module_identifier__$az = undefined;
/* functional template */

const __vue_is_functional_template__$az = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$az = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$az,
  staticRenderFns: __vue_staticRenderFns__$az
}, __vue_inject_styles__$az, __vue_script__$az, __vue_scope_id__$az, __vue_is_functional_template__$az, __vue_module_identifier__$az, false, undefined, undefined, undefined);

var script$aA = Vue.extend({
  name: "PhRadio",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$aA = script$aA;
/* template */

var __vue_render__$aA = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,80H216a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V80A0,0,0,0,1,32,80Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "80",
      "x2": "192",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "160",
      "cy": "144",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "124",
      "x2": "96",
      "y2": "124",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "164",
      "x2": "96",
      "y2": "164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,80H32V200a8.00009,8.00009,0,0,0,8,8H216a8.00009,8.00009,0,0,0,8-8V88A8.00009,8.00009,0,0,0,216,80Zm-56,96a32,32,0,1,1,32-32A32,32,0,0,1,160,176Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,80H216a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V80A0,0,0,0,1,32,80Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "80",
      "x2": "192",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "160",
      "cy": "144",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "112",
      "x2": "96",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "144",
      "x2": "96",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "176",
      "x2": "96",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,72H86.509l107.7898-32.33691a8.00047,8.00047,0,0,0-4.59766-15.32618l-160,48-.022.00782c-.21753.06591-.4292.144-.63818.22729-.04.01587-.082.02808-.12159.04444-.1792.075-.35229.16174-.5249.249-.06665.03369-.13672.06225-.20239.09765-.06421.03467-.12378.07642-.187.1128a7.95455,7.95455,0,0,0-2.10157,1.7511c-.02563.03039-.05444.05786-.07983.08862-.08984.10925-.16992.22546-.25366.33923-.071.096-.14624.18836-.21289.2876-.03638.05432-.06665.11231-.10181.1676a7.94225,7.94225,0,0,0-.989,2.27381c-.03443.1322-.074.26269-.102.39685-.00782.03869-.01123.07885-.0188.11767-.043.22473-.07984.451-.10352.68006-.00146.01342-.00122.0271-.00244.04052-.02515.25391-.03857.50977-.03882.76734L24,80V200a16.01833,16.01833,0,0,0,16,16H216a16.01833,16.01833,0,0,0,16-16V88A16.01833,16.01833,0,0,0,216,72ZM96,184H56a8,8,0,0,1,0-16H96a8,8,0,0,1,0,16Zm0-32H56a8,8,0,0,1,0-16H96a8,8,0,0,1,0,16Zm0-32H56a8,8,0,0,1,0-16H96a8,8,0,0,1,0,16Zm72,52a28,28,0,1,1,28-28A28.03209,28.03209,0,0,1,168,172Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,80H216a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V80A0,0,0,0,1,32,80Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "80",
      "x2": "192",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "160",
      "cy": "144",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "112",
      "x2": "96",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "144",
      "x2": "96",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "176",
      "x2": "96",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,80H216a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V80A0,0,0,0,1,32,80Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "80",
      "x2": "192",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "160",
      "cy": "144",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "112",
      "x2": "96",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "144",
      "x2": "96",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "176",
      "x2": "96",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,80H216a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V80A0,0,0,0,1,32,80Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "80",
      "x2": "192",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "160",
      "cy": "144",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "112",
      "x2": "96",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "144",
      "x2": "96",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "176",
      "x2": "96",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$aA = [];
/* style */

const __vue_inject_styles__$aA = undefined;
/* scoped */

const __vue_scope_id__$aA = undefined;
/* module identifier */

const __vue_module_identifier__$aA = undefined;
/* functional template */

const __vue_is_functional_template__$aA = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$aA = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$aA,
  staticRenderFns: __vue_staticRenderFns__$aA
}, __vue_inject_styles__$aA, __vue_script__$aA, __vue_scope_id__$aA, __vue_is_functional_template__$aA, __vue_module_identifier__$aA, false, undefined, undefined, undefined);

var script$aB = Vue.extend({
  name: "PhRainbow",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$aB = script$aB;
/* template */

var __vue_render__$aB = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M12,180v-8a116,116,0,0,1,232,0v8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,180v-4a24,24,0,0,0-48,0v4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,180v-4a72,72,0,0,0-144,0v4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,184V168a48,48,0,0,0-96,0v16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,184V168a80,80,0,0,0-160,0v16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M240,184V168a112,112,0,0,0-224,0v16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M184,168v16a8,8,0,0,1-16,0V168a40,40,0,0,0-80,0v16a8,8,0,0,1-16,0V168a56,56,0,0,1,112,0ZM128,80a88.09957,88.09957,0,0,0-88,88v16a8,8,0,0,0,16,0V168a72,72,0,0,1,144,0v16a8,8,0,0,0,16,0V168A88.09957,88.09957,0,0,0,128,80Zm0-32A120.13623,120.13623,0,0,0,8,168v16a8,8,0,0,0,16,0V168a104,104,0,0,1,208,0v16a8,8,0,0,0,16,0V168A120.13623,120.13623,0,0,0,128,48Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,184V168a48,48,0,0,0-96,0v16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,184V168a80,80,0,0,0-160,0v16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M240,184V168a112,112,0,0,0-224,0v16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,184V168a48,48,0,0,0-96,0v16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,184V168a80,80,0,0,0-160,0v16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M240,184V168a112,112,0,0,0-224,0v16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,184V168a48,48,0,0,0-96,0v16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,184V168a80,80,0,0,0-160,0v16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M240,184V168a112,112,0,0,0-224,0v16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$aB = [];
/* style */

const __vue_inject_styles__$aB = undefined;
/* scoped */

const __vue_scope_id__$aB = undefined;
/* module identifier */

const __vue_module_identifier__$aB = undefined;
/* functional template */

const __vue_is_functional_template__$aB = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$aB = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$aB,
  staticRenderFns: __vue_staticRenderFns__$aB
}, __vue_inject_styles__$aB, __vue_script__$aB, __vue_scope_id__$aB, __vue_is_functional_template__$aB, __vue_module_identifier__$aB, false, undefined, undefined, undefined);

var script$aC = Vue.extend({
  name: "PhRainbowCloud",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$aC = script$aC;
/* template */

var __vue_render__$aC = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M156,200c-13.25483,0-24-11.14314-24-24.88889s10.74517-24.88889,24-24.88889a23.18816,23.18816,0,0,1,8.81117,1.73087l-.00141-.0003A40.00363,40.00363,0,1,1,204,200Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92,176V160a19.96611,19.96611,0,0,1,7.739-15.80207",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M52,176V160a60.01385,60.01385,0,0,1,90.83207-51.48275",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M12,176V160A100.00166,100.00166,0,0,1,177.59331,84.51611",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M152,200c-13.25483,0-24-11.14314-24-24.88889s10.74517-24.88889,24-24.88889a23.18816,23.18816,0,0,1,8.81117,1.73087l-.00141-.0003A40.00363,40.00363,0,1,1,200,200Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,200c-13.25483,0-24-11.14314-24-24.88889s10.74517-24.88889,24-24.88889a23.18816,23.18816,0,0,1,8.81117,1.73087l-.00141-.0003A40.00363,40.00363,0,1,1,200,200Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16,176V160A96.00006,96.00006,0,0,1,178.92582,91.17453",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,176V160a64.00543,64.00543,0,0,1,101.86674-51.60093",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,176V160a32.02814,32.02814,0,0,1,39.42145-31.135",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M248,160a48.054,48.054,0,0,1-48,48H152c-17.645,0-32-14.75391-32-32.88867s14.355-32.88867,32-32.88867a31.5421,31.5421,0,0,1,3.33545.17578A48.00491,48.00491,0,0,1,248,160ZM112,72a87.53238,87.53238,0,0,1,61.34814,24.91016,8.00027,8.00027,0,0,0,11.15528-11.47071A104.00011,104.00011,0,0,0,8,160v16a8,8,0,0,0,16,0V160A88.09957,88.09957,0,0,1,112,72Zm0,32a55.55123,55.55123,0,0,1,33.12842,10.84473A7.99959,7.99959,0,1,0,154.605,101.9541,72.00452,72.00452,0,0,0,40,160v16a8,8,0,0,0,16,0V160A56.06322,56.06322,0,0,1,112,104Zm15.20508,26.71289a7.99944,7.99944,0,0,0-5.936-9.63086A40.02529,40.02529,0,0,0,72,160v16a8,8,0,0,0,16,0V160a24.02909,24.02909,0,0,1,29.57373-23.35156A7.99553,7.99553,0,0,0,127.20508,130.71289Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M152,200c-13.25483,0-24-11.14314-24-24.88889s10.74517-24.88889,24-24.88889a23.18816,23.18816,0,0,1,8.81117,1.73087l-.00141-.0003A40.00363,40.00363,0,1,1,200,200Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16,176V160A96.00006,96.00006,0,0,1,178.92582,91.17453",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,176V160a64.00543,64.00543,0,0,1,101.86674-51.60093",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,176V160a32.02814,32.02814,0,0,1,39.42145-31.135",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M152,200c-13.25483,0-24-11.14314-24-24.88889s10.74517-24.88889,24-24.88889a23.18816,23.18816,0,0,1,8.81117,1.73087l-.00141-.0003A40.00363,40.00363,0,1,1,200,200Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16,176V160A96.00006,96.00006,0,0,1,178.92582,91.17453",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,176V160a64.00543,64.00543,0,0,1,101.86674-51.60093",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,176V160a32.02814,32.02814,0,0,1,39.42145-31.135",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M152,200c-13.25483,0-24-11.14314-24-24.88889s10.74517-24.88889,24-24.88889a23.18816,23.18816,0,0,1,8.81117,1.73087l-.00141-.0003A40.00363,40.00363,0,1,1,200,200Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16,176V160A96.00006,96.00006,0,0,1,178.92582,91.17453",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,176V160a64.00543,64.00543,0,0,1,101.86674-51.60093",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,176V160a32.02814,32.02814,0,0,1,39.42145-31.135",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$aC = [];
/* style */

const __vue_inject_styles__$aC = undefined;
/* scoped */

const __vue_scope_id__$aC = undefined;
/* module identifier */

const __vue_module_identifier__$aC = undefined;
/* functional template */

const __vue_is_functional_template__$aC = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$aC = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$aC,
  staticRenderFns: __vue_staticRenderFns__$aC
}, __vue_inject_styles__$aC, __vue_script__$aC, __vue_scope_id__$aC, __vue_is_functional_template__$aC, __vue_module_identifier__$aC, false, undefined, undefined, undefined);

var script$aD = Vue.extend({
  name: "PhReceipt",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$aD = script$aD;
/* template */

var __vue_render__$aD = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "76",
      "y1": "100",
      "x2": "180",
      "y2": "100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "76",
      "y1": "140",
      "x2": "180",
      "y2": "140",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,208V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V208l-32-16-32,16-32-16L96,208,64,192Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,208V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V208l-32-16-32,16-32-16L96,208,64,192Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "76",
      "y1": "104",
      "x2": "180",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "76",
      "y1": "136",
      "x2": "180",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,208V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V208l-32-16-32,16-32-16L96,208,64,192Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,40H40A16.01833,16.01833,0,0,0,24,56V208a8,8,0,0,0,11.57812,7.15527L64,200.94434l28.42188,14.21093a8.00257,8.00257,0,0,0,7.15624,0L128,200.94434l28.42188,14.21093a8.00049,8.00049,0,0,0,7.15624,0L192,200.94434l28.42188,14.21093A8,8,0,0,0,232,208V56A16.01833,16.01833,0,0,0,216,40ZM180,144H76a8,8,0,0,1,0-16H180a8,8,0,0,1,0,16Zm0-32H76a8,8,0,0,1,0-16H180a8,8,0,0,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "76",
      "y1": "104",
      "x2": "180",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "76",
      "y1": "136",
      "x2": "180",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,208V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V208l-32-16-32,16-32-16L96,208,64,192Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "76",
      "y1": "104",
      "x2": "180",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "76",
      "y1": "136",
      "x2": "180",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,208V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V208l-32-16-32,16-32-16L96,208,64,192Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "76",
      "y1": "104",
      "x2": "180",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "76",
      "y1": "136",
      "x2": "180",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,208V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V208l-32-16-32,16-32-16L96,208,64,192Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$aD = [];
/* style */

const __vue_inject_styles__$aD = undefined;
/* scoped */

const __vue_scope_id__$aD = undefined;
/* module identifier */

const __vue_module_identifier__$aD = undefined;
/* functional template */

const __vue_is_functional_template__$aD = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$aD = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$aD,
  staticRenderFns: __vue_staticRenderFns__$aD
}, __vue_inject_styles__$aD, __vue_script__$aD, __vue_scope_id__$aD, __vue_is_functional_template__$aD, __vue_module_identifier__$aD, false, undefined, undefined, undefined);

var script$aE = Vue.extend({
  name: "PhRecord",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$aE = script$aE;
/* template */

var __vue_render__$aE = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "64",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.11791,104.11791,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.09957,88.09957,0,0,1,128,216Z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "72"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$aE = [];
/* style */

const __vue_inject_styles__$aE = undefined;
/* scoped */

const __vue_scope_id__$aE = undefined;
/* module identifier */

const __vue_module_identifier__$aE = undefined;
/* functional template */

const __vue_is_functional_template__$aE = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$aE = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$aE,
  staticRenderFns: __vue_staticRenderFns__$aE
}, __vue_inject_styles__$aE, __vue_script__$aE, __vue_scope_id__$aE, __vue_is_functional_template__$aE, __vue_module_identifier__$aE, false, undefined, undefined, undefined);

var script$aF = Vue.extend({
  name: "PhRectangle",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$aF = script$aF;
/* template */

var __vue_render__$aF = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32.00781",
      "y": "48.00005",
      "width": "192",
      "height": "160",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32.00781",
      "y": "48.00005",
      "width": "192",
      "height": "160",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32.00781",
      "y": "48.00005",
      "width": "192",
      "height": "160",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('rect', {
    attrs: {
      "x": "24.00781",
      "y": "40",
      "width": "208",
      "height": "176",
      "rx": "16"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32.00781",
      "y": "48.00005",
      "width": "192",
      "height": "160",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32.00781",
      "y": "48.00005",
      "width": "192",
      "height": "160",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$aF = [];
/* style */

const __vue_inject_styles__$aF = undefined;
/* scoped */

const __vue_scope_id__$aF = undefined;
/* module identifier */

const __vue_module_identifier__$aF = undefined;
/* functional template */

const __vue_is_functional_template__$aF = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$aF = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$aF,
  staticRenderFns: __vue_staticRenderFns__$aF
}, __vue_inject_styles__$aF, __vue_script__$aF, __vue_scope_id__$aF, __vue_is_functional_template__$aF, __vue_module_identifier__$aF, false, undefined, undefined, undefined);

var script$aG = Vue.extend({
  name: "PhRecycle",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$aG = script$aG;
/* template */

var __vue_render__$aG = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "152 232 128 207.992 152 184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "194.627 75.192 185.836 107.981 153.058 99.192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "78.956 140.769 70.164 107.981 37.386 116.769",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,207.99231h87.97627A16,16,0,0,0,229.82386,183.977l-19.948-34.46311",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M185.83571,107.98085,141.84757,31.98472a16,16,0,0,0-27.69514,0L94.21,66.43832",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M70.1643,107.98084,26.17616,183.977a16.00005,16.00005,0,0,0,13.84762,24.01535H80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "152 232 128 207.992 152 184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "194.627 75.192 185.836 107.981 153.058 99.192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "78.956 140.769 70.164 107.981 37.386 116.769",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,207.99231h87.97627A16,16,0,0,0,229.82386,183.977l-23.95094-41.37884",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M70.1643,107.98084,26.17616,183.977a16.00005,16.00005,0,0,0,13.84762,24.01535H87.99992",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M185.83571,107.98085,141.84757,31.98472a16,16,0,0,0-27.69514,0L90.20239,73.362",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M236.76758,203.98145a23.75493,23.75493,0,0,1-20.791,12.01074H160V232a8.00052,8.00052,0,0,1-13.6582,5.65625l-24-24.00781a8.0018,8.0018,0,0,1,.00195-11.31446l24-23.99218A8.00042,8.00042,0,0,1,160,184v15.99219h55.97656a8.00079,8.00079,0,0,0,6.92383-12.00781l-23.95117-41.37793a8.00013,8.00013,0,1,1,13.84766-8.01563l23.95117,41.37793A23.75534,23.75534,0,0,1,236.76758,203.98145ZM88,199.99219H40.02344a8.00079,8.00079,0,0,1-6.92383-12.00781L61.062,139.67554l13.894,8.02173a7.99907,7.99907,0,0,0,11.72657-9l-8.792-32.78907a7.99883,7.99883,0,0,0-9.79882-5.65429L35.31445,109.043a7.99934,7.99934,0,0,0-1.92773,14.6543l13.81836,7.978L19.252,179.96875a24.00019,24.00019,0,0,0,20.77149,36.02344H88a8,8,0,0,0,0-16ZM128,32a7.86145,7.86145,0,0,1,6.92383,3.99219l27.95361,48.2937-13.81982,7.97876a7.9999,7.9999,0,0,0,1.92871,14.65527l32.77832,8.78809a7.99309,7.99309,0,0,0,9.79883-5.65625l8.791-32.78809a8,8,0,0,0-11.72754-8.999l-13.89306,8.021L148.77148,27.97656a24.00073,24.00073,0,0,0-41.543,0L83.27832,69.35449A8.00013,8.00013,0,0,0,97.126,77.37012l23.95019-41.37793A7.86145,7.86145,0,0,1,128,32Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "152 232 128 207.992 152 184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "194.627 75.192 185.836 107.981 153.058 99.192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "78.956 140.769 70.164 107.981 37.386 116.769",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,207.99231h87.97627A16,16,0,0,0,229.82386,183.977l-23.95094-41.37884",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M70.1643,107.98084,26.17616,183.977a16.00005,16.00005,0,0,0,13.84762,24.01535H87.99992",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M185.83571,107.98085,141.84757,31.98472a16,16,0,0,0-27.69514,0L90.20239,73.362",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "152 232 128 207.992 152 184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "194.627 75.192 185.836 107.981 153.058 99.192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "78.956 140.769 70.164 107.981 37.386 116.769",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,207.99231h87.97627A16,16,0,0,0,229.82386,183.977l-23.95094-41.37884",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M70.1643,107.98084,26.17616,183.977a16.00005,16.00005,0,0,0,13.84762,24.01535H87.99992",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M185.83571,107.98085,141.84757,31.98472a16,16,0,0,0-27.69514,0L90.20239,73.362",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "152 232 128 207.992 152 184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "194.627 75.192 185.836 107.981 153.058 99.192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "78.956 140.769 70.164 107.981 37.386 116.769",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,207.99231h87.97627A16,16,0,0,0,229.82386,183.977l-23.95094-41.37884",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M70.1643,107.98084,26.17616,183.977a16.00005,16.00005,0,0,0,13.84762,24.01535H87.99992",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M185.83571,107.98085,141.84757,31.98472a16,16,0,0,0-27.69514,0L90.20239,73.362",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$aG = [];
/* style */

const __vue_inject_styles__$aG = undefined;
/* scoped */

const __vue_scope_id__$aG = undefined;
/* module identifier */

const __vue_module_identifier__$aG = undefined;
/* functional template */

const __vue_is_functional_template__$aG = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$aG = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$aG,
  staticRenderFns: __vue_staticRenderFns__$aG
}, __vue_inject_styles__$aG, __vue_script__$aG, __vue_scope_id__$aG, __vue_is_functional_template__$aG, __vue_module_identifier__$aG, false, undefined, undefined, undefined);

var script$aH = Vue.extend({
  name: "PhRedditLogo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$aH = script$aH;
/* template */

var __vue_render__$aH = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "188",
      "cy": "32.00002",
      "r": "12",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M161.026,172.00058a72.17425,72.17425,0,0,1-66.05159.0002",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M59.408,89.87843C77.71654,78.7483,101.71994,72,128,72s50.28346,6.7483,68.592,17.87843l-.00129.00213a24.002,24.002,0,1,1,31.61564,34.788l.002-.00083A51.61606,51.61606,0,0,1,232,144c0,39.7645-46.56239,72-104,72S24,183.7645,24,144a51.61624,51.61624,0,0,1,3.79162-19.3323l.00206.00082a24.00228,24.00228,0,1,1,31.61564-34.788Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 72 136 24 176.138 30.175",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "88",
      "cy": "128",
      "r": "20"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "168",
      "cy": "128",
      "r": "20"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M240,104a24.00125,24.00125,0,0,0-43.40918-14.11938l.001-.0022C178.28369,78.74831,154.28027,72,128,72S77.7168,78.74831,59.4082,89.87844l.001.0022A24.00186,24.00186,0,1,0,27.794,124.66848l-.00245-.00073A51.62014,51.62014,0,0,0,24,144c0,39.76441,46.5625,72,104,72s104-32.23559,104-72a51.62014,51.62014,0,0,0-3.7915-19.33227l-.002.00073A23.98866,23.98866,0,0,0,240,104Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "32.00002",
      "r": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M161.026,176.00058a72.17425,72.17425,0,0,1-66.05159.0002",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 72 136 24 172.185 29.567",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M59.408,89.87843C77.71654,78.7483,101.71994,72,128,72s50.28346,6.7483,68.592,17.87843l-.00129.00213a24.002,24.002,0,1,1,31.61564,34.788l.002-.00083A51.61606,51.61606,0,0,1,232,144c0,39.7645-46.56239,72-104,72S24,183.7645,24,144a51.61624,51.61624,0,0,1,3.79162-19.3323l.00206.00082a24.00228,24.00228,0,1,1,31.61564-34.788Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "88",
      "cy": "132",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "168",
      "cy": "132",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M248,104a31.99228,31.99228,0,0,0-52.9375-24.19043c-16.75439-8.90112-36.76172-14.279-57.666-15.52539l5.19581-31.17578,21.83105,3.3584a24.00409,24.00409,0,1,0,2.43506-15.814l-29.64209-4.56006a7.996,7.996,0,0,0-9.10742,6.5918l-6.91309,41.478c-21.83887.94165-42.813,6.37891-60.2583,15.647a31.99266,31.99266,0,0,0-42.59229,47.74024A59.04669,59.04669,0,0,0,16,144c0,21.93457,12.042,42.35156,33.90723,57.48926C70.875,216.00588,98.60938,224,128,224s57.125-7.99414,78.09277-22.51074C227.958,186.35158,240,165.93459,240,144a59.01726,59.01726,0,0,0-2.3457-16.44922A32.17163,32.17163,0,0,0,248,104ZM72,132a16,16,0,1,1,16,16A16.01833,16.01833,0,0,1,72,132Zm92.69629,51.10938a80.122,80.122,0,0,1-73.39209,0,8,8,0,0,1,7.34033-14.2168,64.09433,64.09433,0,0,0,58.71094,0,8.00008,8.00008,0,0,1,7.34082,14.2168ZM168,148a16,16,0,1,1,16-16A16.01833,16.01833,0,0,1,168,148Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "188",
      "cy": "32.00002",
      "r": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M161.026,176.00058a72.17425,72.17425,0,0,1-66.05159.0002",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 72 136 24 172.185 29.567",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M59.408,89.87843C77.71654,78.7483,101.71994,72,128,72s50.28346,6.7483,68.592,17.87843l-.00129.00213a24.002,24.002,0,1,1,31.61564,34.788l.002-.00083A51.61606,51.61606,0,0,1,232,144c0,39.7645-46.56239,72-104,72S24,183.7645,24,144a51.61624,51.61624,0,0,1,3.79162-19.3323l.00206.00082a24.00228,24.00228,0,1,1,31.61564-34.788Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "88",
      "cy": "132.00002",
      "r": "14"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "168",
      "cy": "132.00002",
      "r": "14"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "188",
      "cy": "32.00002",
      "r": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M161.026,176.00058a72.17425,72.17425,0,0,1-66.05159.0002",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 72 136 24 172.185 29.567",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M59.408,89.87843C77.71654,78.7483,101.71994,72,128,72s50.28346,6.7483,68.592,17.87843l-.00129.00213a24.002,24.002,0,1,1,31.61564,34.788l.002-.00083A51.61606,51.61606,0,0,1,232,144c0,39.7645-46.56239,72-104,72S24,183.7645,24,144a51.61624,51.61624,0,0,1,3.79162-19.3323l.00206.00082a24.00228,24.00228,0,1,1,31.61564-34.788Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "88",
      "cy": "132.00002",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "168",
      "cy": "132.00002",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "188",
      "cy": "32.00002",
      "r": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M161.026,176.00058a72.17425,72.17425,0,0,1-66.05159.0002",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 72 136 24 172.185 29.567",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M59.408,89.87843C77.71654,78.7483,101.71994,72,128,72s50.28346,6.7483,68.592,17.87843l-.00129.00213a24.002,24.002,0,1,1,31.61564,34.788l.002-.00083A51.61606,51.61606,0,0,1,232,144c0,39.7645-46.56239,72-104,72S24,183.7645,24,144a51.61624,51.61624,0,0,1,3.79162-19.3323l.00206.00082a24.00228,24.00228,0,1,1,31.61564-34.788Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "88",
      "cy": "132",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "168",
      "cy": "132",
      "r": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$aH = [];
/* style */

const __vue_inject_styles__$aH = undefined;
/* scoped */

const __vue_scope_id__$aH = undefined;
/* module identifier */

const __vue_module_identifier__$aH = undefined;
/* functional template */

const __vue_is_functional_template__$aH = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$aH = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$aH,
  staticRenderFns: __vue_staticRenderFns__$aH
}, __vue_inject_styles__$aH, __vue_script__$aH, __vue_scope_id__$aH, __vue_is_functional_template__$aH, __vue_module_identifier__$aH, false, undefined, undefined, undefined);

var script$aI = Vue.extend({
  name: "PhRepeat",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$aI = script$aI;
/* template */

var __vue_render__$aI = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "200 88 224 64 200 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,128A64,64,0,0,1,96,64H224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "56 168 32 192 56 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,128a64,64,0,0,1-64,64H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "200 88 224 64 200 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,128A64,64,0,0,1,96,64H224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "56 168 32 192 56 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,128a64,64,0,0,1-64,64H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M24,128A72.08124,72.08124,0,0,1,96,56h96V40a8.0001,8.0001,0,0,1,13.65723-5.65674l24,24a8,8,0,0,1,0,11.31348l-24,24A8.0001,8.0001,0,0,1,192,88V72H96a56.06322,56.06322,0,0,0-56,56,8,8,0,0,1-16,0Zm200-8a8.00039,8.00039,0,0,0-8,8,56.06322,56.06322,0,0,1-56,56H64V168a8.0001,8.0001,0,0,0-13.65723-5.65674l-24,24a8,8,0,0,0,0,11.31348l24,24A8.0001,8.0001,0,0,0,64,216V200h96a72.08124,72.08124,0,0,0,72-72A8.00039,8.00039,0,0,0,224,120Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "200 88 224 64 200 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,128A64,64,0,0,1,96,64H224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "56 168 32 192 56 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,128a64,64,0,0,1-64,64H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "200 88 224 64 200 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,128A64,64,0,0,1,96,64H224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "56 168 32 192 56 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,128a64,64,0,0,1-64,64H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "200 88 224 64 200 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,128A64,64,0,0,1,96,64H224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "56 168 32 192 56 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,128a64,64,0,0,1-64,64H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$aI = [];
/* style */

const __vue_inject_styles__$aI = undefined;
/* scoped */

const __vue_scope_id__$aI = undefined;
/* module identifier */

const __vue_module_identifier__$aI = undefined;
/* functional template */

const __vue_is_functional_template__$aI = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$aI = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$aI,
  staticRenderFns: __vue_staticRenderFns__$aI
}, __vue_inject_styles__$aI, __vue_script__$aI, __vue_scope_id__$aI, __vue_is_functional_template__$aI, __vue_module_identifier__$aI, false, undefined, undefined, undefined);

var script$aJ = Vue.extend({
  name: "PhRepeatOnce",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$aJ = script$aJ;
/* template */

var __vue_render__$aJ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "200 88 224 64 200 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,128A64,64,0,0,1,96,64H224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "56 168 32 192 56 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,128a64,64,0,0,1-64,64H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "116 111.993 132 104 132 152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "200 88 224 64 200 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,128A64,64,0,0,1,96,64H224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "56 168 32 192 56 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,128a64,64,0,0,1-64,64H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "116 111.993 132 104 132 152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M24,128A72.08124,72.08124,0,0,1,96,56h96V40a8.0001,8.0001,0,0,1,13.65723-5.65674l24,24a8,8,0,0,1,0,11.31348l-24,24A8.0001,8.0001,0,0,1,192,88V72H96a56.06322,56.06322,0,0,0-56,56,8,8,0,0,1-16,0Zm200-8a8.00039,8.00039,0,0,0-8,8,56.06322,56.06322,0,0,1-56,56H64V168a8.0001,8.0001,0,0,0-13.65723-5.65674l-24,24a8,8,0,0,0,0,11.31348l24,24A8.0001,8.0001,0,0,0,64,216V200h96a72.08124,72.08124,0,0,0,72-72A8.00039,8.00039,0,0,0,224,120Zm-92,40a8.00039,8.00039,0,0,0,8-8V104a7.99986,7.99986,0,0,0-11.5752-7.15674l-16,7.99268a8.00006,8.00006,0,0,0,7.1504,14.31347l4.4248-2.21V152A8.00039,8.00039,0,0,0,132,160Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "200 88 224 64 200 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,128A64,64,0,0,1,96,64H224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "56 168 32 192 56 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,128a64,64,0,0,1-64,64H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "116 111.993 132 104 132 152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "200 88 224 64 200 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,128A64,64,0,0,1,96,64H224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "56 168 32 192 56 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,128a64,64,0,0,1-64,64H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "116 111.993 132 104 132 152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "200 88 224 64 200 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,128A64,64,0,0,1,96,64H224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "56 168 32 192 56 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,128a64,64,0,0,1-64,64H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "116 111.993 132 104 132 152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$aJ = [];
/* style */

const __vue_inject_styles__$aJ = undefined;
/* scoped */

const __vue_scope_id__$aJ = undefined;
/* module identifier */

const __vue_module_identifier__$aJ = undefined;
/* functional template */

const __vue_is_functional_template__$aJ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$aJ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$aJ,
  staticRenderFns: __vue_staticRenderFns__$aJ
}, __vue_inject_styles__$aJ, __vue_script__$aJ, __vue_scope_id__$aJ, __vue_is_functional_template__$aJ, __vue_module_identifier__$aJ, false, undefined, undefined, undefined);

var script$aK = Vue.extend({
  name: "PhRewind",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$aK = script$aK;
/* template */

var __vue_render__$aK = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M18.468,121.27057,107.67394,63.9239A8,8,0,0,1,120,70.65332V185.34668a8,8,0,0,1-12.32606,6.72942L18.468,134.72943A8,8,0,0,1,18.468,121.27057Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M126.468,121.27057,215.67394,63.9239A8,8,0,0,1,228,70.65332V185.34668a8,8,0,0,1-12.32606,6.72942L126.468,134.72943A8,8,0,0,1,126.468,121.27057Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M14.468,121.27057,103.67394,63.9239A8,8,0,0,1,116,70.65332V185.34668a8,8,0,0,1-12.32606,6.72942L14.468,134.72943A8,8,0,0,1,14.468,121.27057Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M126.468,121.27057,215.67394,63.9239A8,8,0,0,1,228,70.65332V185.34668a8,8,0,0,1-12.32606,6.72942L126.468,134.72943A8,8,0,0,1,126.468,121.27057Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M14.468,121.27057,103.67394,63.9239A8,8,0,0,1,116,70.65332V185.34668a8,8,0,0,1-12.32606,6.72942L14.468,134.72943A8,8,0,0,1,14.468,121.27057Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M126.468,121.27057,215.67394,63.9239A8,8,0,0,1,228,70.65332V185.34668a8,8,0,0,1-12.32606,6.72942L126.468,134.72943A8,8,0,0,1,126.468,121.27057Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M10.1416,114.541,99.34766,57.19434A16.00057,16.00057,0,0,1,124,70.65332v42.69287l87.34766-56.15185A16.00057,16.00057,0,0,1,236,70.65332V185.34668a15.99914,15.99914,0,0,1-24.65234,13.459L124,142.65381v42.69287a15.99914,15.99914,0,0,1-24.65234,13.459L10.1416,141.459a16.0005,16.0005,0,0,1,0-26.918Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M14.468,121.27057,103.67394,63.9239A8,8,0,0,1,116,70.65332V185.34668a8,8,0,0,1-12.32606,6.72942L14.468,134.72943A8,8,0,0,1,14.468,121.27057Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M126.468,121.27057,215.67394,63.9239A8,8,0,0,1,228,70.65332V185.34668a8,8,0,0,1-12.32606,6.72942L126.468,134.72943A8,8,0,0,1,126.468,121.27057Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M14.468,121.27057,103.67394,63.9239A8,8,0,0,1,116,70.65332V185.34668a8,8,0,0,1-12.32606,6.72942L14.468,134.72943A8,8,0,0,1,14.468,121.27057Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M126.468,121.27057,215.67394,63.9239A8,8,0,0,1,228,70.65332V185.34668a8,8,0,0,1-12.32606,6.72942L126.468,134.72943A8,8,0,0,1,126.468,121.27057Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M14.468,121.27057,103.67394,63.9239A8,8,0,0,1,116,70.65332V185.34668a8,8,0,0,1-12.32606,6.72942L14.468,134.72943A8,8,0,0,1,14.468,121.27057Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M126.468,121.27057,215.67394,63.9239A8,8,0,0,1,228,70.65332V185.34668a8,8,0,0,1-12.32606,6.72942L126.468,134.72943A8,8,0,0,1,126.468,121.27057Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$aK = [];
/* style */

const __vue_inject_styles__$aK = undefined;
/* scoped */

const __vue_scope_id__$aK = undefined;
/* module identifier */

const __vue_module_identifier__$aK = undefined;
/* functional template */

const __vue_is_functional_template__$aK = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$aK = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$aK,
  staticRenderFns: __vue_staticRenderFns__$aK
}, __vue_inject_styles__$aK, __vue_script__$aK, __vue_scope_id__$aK, __vue_is_functional_template__$aK, __vue_module_identifier__$aK, false, undefined, undefined, undefined);

var script$aL = Vue.extend({
  name: "PhRewindCircle",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$aL = script$aL;
/* template */

var __vue_render__$aL = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "168 156 132 128 168 100 168 156",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "112 156 76 128 112 100 112 156",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,32a96,96,0,1,0,96,96A95.99991,95.99991,0,0,0,128,32ZM112,160,64,128l48-32Zm64,0-48-32,48-32Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "176 160 128 128 176 96 176 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "112 160 64 128 112 96 112 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M24,128A104,104,0,1,0,128,24,104.11791,104.11791,0,0,0,24,128Zm44,0a7.99968,7.99968,0,0,1,3.41211-6.55371l40-28A8.00015,8.00015,0,0,1,124,100v28a7.99968,7.99968,0,0,1,3.41211-6.55371l40-28A8.00015,8.00015,0,0,1,180,100v56a8,8,0,0,1-12.58789,6.55371l-40-28A7.99968,7.99968,0,0,1,124,128v28a8,8,0,0,1-12.58789,6.55371l-40-28A7.99968,7.99968,0,0,1,68,128Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "172 160 124 128 172 96 172 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "116 160 68 128 116 96 116 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "172 160 124 128 172 96 172 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "116 160 68 128 116 96 116 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "176 160 128 128 176 96 176 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "112 160 64 128 112 96 112 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$aL = [];
/* style */

const __vue_inject_styles__$aL = undefined;
/* scoped */

const __vue_scope_id__$aL = undefined;
/* module identifier */

const __vue_module_identifier__$aL = undefined;
/* functional template */

const __vue_is_functional_template__$aL = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$aL = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$aL,
  staticRenderFns: __vue_staticRenderFns__$aL
}, __vue_inject_styles__$aL, __vue_script__$aL, __vue_scope_id__$aL, __vue_is_functional_template__$aL, __vue_module_identifier__$aL, false, undefined, undefined, undefined);

var script$aM = Vue.extend({
  name: "PhRobot",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$aM = script$aM;
/* template */

var __vue_render__$aM = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "56",
      "width": "192",
      "height": "160",
      "rx": "24",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "68",
      "y": "144",
      "width": "120",
      "height": "36",
      "rx": "15.99998",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "108",
      "y1": "144",
      "x2": "108",
      "y2": "180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "148",
      "y1": "144",
      "x2": "148",
      "y2": "180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "56",
      "x2": "128",
      "y2": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "104",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "172",
      "cy": "104",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,56H56A23.99994,23.99994,0,0,0,32,80V192a23.99994,23.99994,0,0,0,24,24H200a23.99994,23.99994,0,0,0,24-24V80A23.99994,23.99994,0,0,0,200,56ZM164,184H92a20,20,0,0,1,0-40h72a20,20,0,0,1,0,40Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "56",
      "width": "192",
      "height": "160",
      "rx": "24",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "72",
      "y": "144",
      "width": "112",
      "height": "40",
      "rx": "19.99998",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "148",
      "y1": "144",
      "x2": "148",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "108",
      "y1": "144",
      "x2": "108",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "56",
      "x2": "128",
      "y2": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "108",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "172",
      "cy": "108",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,48H136V16a8,8,0,0,0-16,0V48H56A32.03635,32.03635,0,0,0,24,80V192a32.03635,32.03635,0,0,0,32,32H200a32.03635,32.03635,0,0,0,32-32V80A32.03635,32.03635,0,0,0,200,48ZM72,108a12,12,0,1,1,12,12A12,12,0,0,1,72,108Zm28,76H92a16,16,0,0,1,0-32h8Zm40,0H116V152h24Zm24,0h-8V152h8a16,16,0,0,1,0,32Zm8-64a12,12,0,1,1,12-12A12,12,0,0,1,172,120Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "56",
      "width": "192",
      "height": "160",
      "rx": "24",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "72",
      "y": "144",
      "width": "112",
      "height": "40",
      "rx": "19.99998",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "148",
      "y1": "144",
      "x2": "148",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "108",
      "y1": "144",
      "x2": "108",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "56",
      "x2": "128",
      "y2": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "108",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "172",
      "cy": "108",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "56",
      "width": "192",
      "height": "160",
      "rx": "24",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "72",
      "y": "144",
      "width": "112",
      "height": "40",
      "rx": "19.99998",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "148",
      "y1": "144",
      "x2": "148",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "108",
      "y1": "144",
      "x2": "108",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "56",
      "x2": "128",
      "y2": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "108",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "172",
      "cy": "108",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "56",
      "width": "192",
      "height": "160",
      "rx": "24",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "72",
      "y": "144",
      "width": "112",
      "height": "40",
      "rx": "19.99998",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "148",
      "y1": "144",
      "x2": "148",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "108",
      "y1": "144",
      "x2": "108",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "56",
      "x2": "128",
      "y2": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "108",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "172",
      "cy": "108",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$aM = [];
/* style */

const __vue_inject_styles__$aM = undefined;
/* scoped */

const __vue_scope_id__$aM = undefined;
/* module identifier */

const __vue_module_identifier__$aM = undefined;
/* functional template */

const __vue_is_functional_template__$aM = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$aM = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$aM,
  staticRenderFns: __vue_staticRenderFns__$aM
}, __vue_inject_styles__$aM, __vue_script__$aM, __vue_scope_id__$aM, __vue_is_functional_template__$aM, __vue_module_identifier__$aM, false, undefined, undefined, undefined);

var script$aN = Vue.extend({
  name: "PhRocket",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$aN = script$aN;
/* template */

var __vue_render__$aN = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "144",
      "y1": "228",
      "x2": "112",
      "y2": "228",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M122.97053,19.76275C103.97814,34.97686,40.45429,95.77187,96,192h64c54.39078-96.16-8.20388-156.9371-26.9971-172.20489A7.98387,7.98387,0,0,0,122.97053,19.76275Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M73.86661,111.36007,42.51644,148.98028a8,8,0,0,0-1.66373,6.85692l12.36292,55.63314a8,8,0,0,0,12.80706,4.51151L96,192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M181.53142,110.63771l31.95214,38.34257a8,8,0,0,1,1.66373,6.85692l-12.36292,55.63314a8,8,0,0,1-12.80706,4.51151L160,192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "96",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M73.87573,111.39355l-.009-.03369L42.51636,148.98047a7.99958,7.99958,0,0,0-1.66358,6.85693l12.3628,55.63281a8,8,0,0,0,12.80713,4.51172L96,192C78.36523,161.44922,72.74268,134.47656,73.87573,111.39355Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M181.52239,110.6714l.009-.03369,31.35034,37.6206a7.99958,7.99958,0,0,1,1.66358,6.85693l-12.3628,55.63282a8,8,0,0,1-12.80712,4.51172l-29.9773-23.98194C177.03289,160.72706,182.65544,133.75441,181.52239,110.6714Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "224",
      "x2": "112",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M122.97053,19.76275C103.97814,34.97686,40.45429,95.77187,96,192h64c54.39078-96.16-8.20388-156.9371-26.9971-172.20489A7.98387,7.98387,0,0,0,122.97053,19.76275Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M73.86661,111.36007,42.51644,148.98028a8,8,0,0,0-1.66373,6.85692l12.36292,55.63314a8,8,0,0,0,12.80706,4.51151L96,192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M181.53142,110.63771l31.95214,38.34257a8,8,0,0,1,1.66373,6.85692l-12.36292,55.63314a8,8,0,0,1-12.80706,4.51151L160,192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "96",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M144,216H112a8,8,0,0,0,0,16h32a8,8,0,0,0,0-16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M219.62891,143.85889l-30.23658-36.28418a124.52267,124.52267,0,0,0-7.98022-34.8833c-11.61719-30.21192-32.15625-49.999-43.36523-59.10547a16.07708,16.07708,0,0,0-20.07813-.0669C106.61328,22.61621,85.81055,42.38867,74.07617,72.605A122.76188,122.76188,0,0,0,65.979,108.32861L36.37109,143.85889A16.10066,16.10066,0,0,0,33.043,157.57275l12.36328,55.63282a15.98523,15.98523,0,0,0,25.61328,9.023L98.80566,200h58.38868l27.78515,22.22852a15.91184,15.91184,0,0,0,9.96485,3.51709,16.0905,16.0905,0,0,0,5.34668-.91944,15.90581,15.90581,0,0,0,10.30273-11.62012L222.957,157.57373A16.102,16.102,0,0,0,219.62891,143.85889Zm-158.60352,65.876-12.36328-55.6333,17.92651-21.5122q3.40906,28.0371,19.14038,57.38281ZM128,108a12,12,0,1,1,12-12A12,12,0,0,1,128,108Zm66.97461,101.73486-24.74976-19.7998q15.53064-29.55175,18.74341-57.87695l18.36963,22.04345Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "144",
      "y1": "224",
      "x2": "112",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M122.97053,19.76275C103.97814,34.97686,40.45429,95.77187,96,192h64c54.39078-96.16-8.20388-156.9371-26.9971-172.20489A7.98387,7.98387,0,0,0,122.97053,19.76275Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M73.86661,111.36007,42.51644,148.98028a8,8,0,0,0-1.66373,6.85692l12.36292,55.63314a8,8,0,0,0,12.80706,4.51151L96,192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M181.53142,110.63771l31.95214,38.34257a8,8,0,0,1,1.66373,6.85692l-12.36292,55.63314a8,8,0,0,1-12.80706,4.51151L160,192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "96",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "144",
      "y1": "224",
      "x2": "112",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M122.97053,19.76275C103.97814,34.97686,40.45429,95.77187,96,192h64c54.39078-96.16-8.20388-156.9371-26.9971-172.20489A7.98387,7.98387,0,0,0,122.97053,19.76275Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M73.86661,111.36007,42.51644,148.98028a8,8,0,0,0-1.66373,6.85692l12.36292,55.63314a8,8,0,0,0,12.80706,4.51151L96,192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M181.53142,110.63771l31.95214,38.34257a8,8,0,0,1,1.66373,6.85692l-12.36292,55.63314a8,8,0,0,1-12.80706,4.51151L160,192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "96",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "144",
      "y1": "224",
      "x2": "112",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M122.97053,19.76275C103.97814,34.97686,40.45429,95.77187,96,192h64c54.39078-96.16-8.20388-156.9371-26.9971-172.20489A7.98387,7.98387,0,0,0,122.97053,19.76275Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M73.86661,111.36007,42.51644,148.98028a8,8,0,0,0-1.66373,6.85692l12.36292,55.63314a8,8,0,0,0,12.80706,4.51151L96,192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M181.53142,110.63771l31.95214,38.34257a8,8,0,0,1,1.66373,6.85692l-12.36292,55.63314a8,8,0,0,1-12.80706,4.51151L160,192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "96",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$aN = [];
/* style */

const __vue_inject_styles__$aN = undefined;
/* scoped */

const __vue_scope_id__$aN = undefined;
/* module identifier */

const __vue_module_identifier__$aN = undefined;
/* functional template */

const __vue_is_functional_template__$aN = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$aN = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$aN,
  staticRenderFns: __vue_staticRenderFns__$aN
}, __vue_inject_styles__$aN, __vue_script__$aN, __vue_scope_id__$aN, __vue_is_functional_template__$aN, __vue_module_identifier__$aN, false, undefined, undefined, undefined);

var script$aO = Vue.extend({
  name: "PhRocketLaunch",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$aO = script$aO;
/* template */

var __vue_render__$aO = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M195.88225,105.37258,128,173.25483,82.74517,128l67.88225-67.88225c25.70415-25.70415,51.40829-25.45342,62.37042-23.81787a7.96343,7.96343,0,0,1,6.70228,6.70228C221.33567,53.96429,221.5864,79.66843,195.88225,105.37258Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184.56854,116.68629v64.56854a8,8,0,0,1-2.34314,5.65686l-32.34176,32.34176a8,8,0,0,1-13.5015-4.08793L128,173.25483",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M139.31371,71.43146H74.74517a8,8,0,0,0-5.65686,2.34314L36.74655,106.11636a8,8,0,0,0,4.08793,13.5015L82.74517,128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M90.56048,192.38144c-15.05815,26.12823-53.07015,26.12823-53.07015,26.12823s0-38.012,26.12827-53.07018",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M94.05887,184.56854c-11.3137,33.94113-56.56854,33.94113-56.56854,33.94113s0-45.25484,33.94113-56.56854Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184.56854,116.68629v64.56854a8,8,0,0,1-2.34314,5.65686l-32.34176,32.34176a8,8,0,0,1-13.5015-4.08793L128,173.25483Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M139.31371,71.43146H74.74517a8,8,0,0,0-5.65686,2.34314L36.74655,106.11636a8,8,0,0,0,4.08793,13.5015L82.74517,128Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M94.05887,184.56854c-11.3137,33.94113-56.56854,33.94113-56.56854,33.94113s0-45.25484,33.94113-56.56854",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M195.88225,105.37258,128,173.25483,82.74517,128l67.88225-67.88225c25.70415-25.70415,51.40829-25.45342,62.37042-23.81787a7.96343,7.96343,0,0,1,6.70228,6.70228C221.33567,53.96429,221.5864,79.66843,195.88225,105.37258Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184.56854,116.68629v64.56854a8,8,0,0,1-2.34314,5.65686l-32.34176,32.34176a8,8,0,0,1-13.5015-4.08793L128,173.25483",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M139.31371,71.43146H74.74517a8,8,0,0,0-5.65686,2.34314L36.74655,106.11636a8,8,0,0,0,4.08793,13.5015L82.74517,128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M96.58887,176.979a8.00118,8.00118,0,0,0-10.12012,5.06006C79.916,201.69775,58.57422,207.78613,46.332,209.669c1.88281-12.24854,7.97168-33.58594,27.62988-40.13819a8.00027,8.00027,0,1,0-5.06054-15.1792c-16.36035,5.45362-28.37891,18.45069-34.75782,37.58692a92.73335,92.73335,0,0,0-4.65332,26.57129,8.00041,8.00041,0,0,0,8,8,92.73569,92.73569,0,0,0,26.57129-4.65332c19.13575-6.37842,32.13282-18.39747,37.58692-34.75782A8.001,8.001,0,0,0,96.58887,176.979Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M227.6123,41.82031A15.879,15.879,0,0,0,214.17871,28.3877c-11.28613-1.68409-40.62109-2.51319-69.209,26.07324l-8.97046,8.9707H74.74512a15.90118,15.90118,0,0,0-11.31446,4.686L31.08887,100.46a16.00008,16.00008,0,0,0,8.17675,27.00244l39.53492,7.90723,41.82983,41.82959,7.90674,39.53516a15.99768,15.99768,0,0,0,27.00391,8.17578l32.34179-32.34229a15.8955,15.8955,0,0,0,4.68555-11.313V120l8.9707-8.9707C230.127,82.44141,229.29688,53.10645,227.6123,41.82031ZM74.74512,79.43164h45.25439l-39.884,39.88379-37.71216-7.542ZM176.56836,181.25488l-32.3418,32.3418-7.54223-37.71191,39.884-39.88428Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M94.05887,184.56854c-11.3137,33.94113-56.56854,33.94113-56.56854,33.94113s0-45.25484,33.94113-56.56854",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M195.88225,105.37258,128,173.25483,82.74517,128l67.88225-67.88225c25.70415-25.70415,51.40829-25.45342,62.37042-23.81787a7.96343,7.96343,0,0,1,6.70228,6.70228C221.33567,53.96429,221.5864,79.66843,195.88225,105.37258Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184.56854,116.68629v64.56854a8,8,0,0,1-2.34314,5.65686l-32.34176,32.34176a8,8,0,0,1-13.5015-4.08793L128,173.25483",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M139.31371,71.43146H74.74517a8,8,0,0,0-5.65686,2.34314L36.74655,106.11636a8,8,0,0,0,4.08793,13.5015L82.74517,128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M94.05887,184.56854c-11.3137,33.94113-56.56854,33.94113-56.56854,33.94113s0-45.25484,33.94113-56.56854",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M195.88225,105.37258,128,173.25483,82.74517,128l67.88225-67.88225c25.70415-25.70415,51.40829-25.45342,62.37042-23.81787a7.96343,7.96343,0,0,1,6.70228,6.70228C221.33567,53.96429,221.5864,79.66843,195.88225,105.37258Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184.56854,116.68629v64.56854a8,8,0,0,1-2.34314,5.65686l-32.34176,32.34176a8,8,0,0,1-13.5015-4.08793L128,173.25483",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M139.31371,71.43146H74.74517a8,8,0,0,0-5.65686,2.34314L36.74655,106.11636a8,8,0,0,0,4.08793,13.5015L82.74517,128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M94.05887,184.56854c-11.3137,33.94113-56.56854,33.94113-56.56854,33.94113s0-45.25484,33.94113-56.56854",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M195.88225,105.37258,128,173.25483,82.74517,128l67.88225-67.88225c25.70415-25.70415,51.40829-25.45342,62.37042-23.81787a7.96343,7.96343,0,0,1,6.70228,6.70228C221.33567,53.96429,221.5864,79.66843,195.88225,105.37258Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184.56854,116.68629v64.56854a8,8,0,0,1-2.34314,5.65686l-32.34176,32.34176a8,8,0,0,1-13.5015-4.08793L128,173.25483",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M139.31371,71.43146H74.74517a8,8,0,0,0-5.65686,2.34314L36.74655,106.11636a8,8,0,0,0,4.08793,13.5015L82.74517,128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$aO = [];
/* style */

const __vue_inject_styles__$aO = undefined;
/* scoped */

const __vue_scope_id__$aO = undefined;
/* module identifier */

const __vue_module_identifier__$aO = undefined;
/* functional template */

const __vue_is_functional_template__$aO = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$aO = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$aO,
  staticRenderFns: __vue_staticRenderFns__$aO
}, __vue_inject_styles__$aO, __vue_script__$aO, __vue_scope_id__$aO, __vue_is_functional_template__$aO, __vue_module_identifier__$aO, false, undefined, undefined, undefined);

var script$aP = Vue.extend({
  name: "PhRows",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$aP = script$aP;
/* template */

var __vue_render__$aP = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "144",
      "width": "176",
      "height": "56",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "56",
      "width": "176",
      "height": "56",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "144",
      "width": "176",
      "height": "56",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "56",
      "width": "176",
      "height": "56",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "144",
      "width": "176",
      "height": "56",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "56",
      "width": "176",
      "height": "56",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,152v40a16.01833,16.01833,0,0,1-16,16H48a16.01833,16.01833,0,0,1-16-16V152a16.01833,16.01833,0,0,1,16-16H208A16.01833,16.01833,0,0,1,224,152ZM208,48H48A16.01833,16.01833,0,0,0,32,64v40a16.01833,16.01833,0,0,0,16,16H208a16.01833,16.01833,0,0,0,16-16V64A16.01833,16.01833,0,0,0,208,48Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "144",
      "width": "176",
      "height": "56",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "56",
      "width": "176",
      "height": "56",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "144",
      "width": "176",
      "height": "56",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "56",
      "width": "176",
      "height": "56",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "144",
      "width": "176",
      "height": "56",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "56",
      "width": "176",
      "height": "56",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$aP = [];
/* style */

const __vue_inject_styles__$aP = undefined;
/* scoped */

const __vue_scope_id__$aP = undefined;
/* module identifier */

const __vue_module_identifier__$aP = undefined;
/* functional template */

const __vue_is_functional_template__$aP = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$aP = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$aP,
  staticRenderFns: __vue_staticRenderFns__$aP
}, __vue_inject_styles__$aP, __vue_script__$aP, __vue_scope_id__$aP, __vue_is_functional_template__$aP, __vue_module_identifier__$aP, false, undefined, undefined, undefined);

var script$aQ = Vue.extend({
  name: "PhRss",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$aQ = script$aQ;
/* template */

var __vue_render__$aQ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M47.99414,144a64,64,0,0,1,64,64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M47.99414,96a112,112,0,0,1,112,112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M47.99414,48a160,160,0,0,1,160,160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "52",
      "cy": "204",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M47.99414,144a64,64,0,0,1,64,64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M47.99414,96a112,112,0,0,1,112,112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M47.99414,48a160,160,0,0,1,160,160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "52",
      "cy": "204",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M98.90576,157.08752a71.531,71.531,0,0,1,21.08838,50.91211,8,8,0,0,1-16,0,56.00027,56.00027,0,0,0-56-56,8,8,0,1,1,0-16A71.53147,71.53147,0,0,1,98.90576,157.08752ZM47.99414,87.99963a8,8,0,1,0,0,16,104.00183,104.00183,0,0,1,104,104,8,8,0,0,0,16,0,120.00093,120.00093,0,0,0-120-120Zm118.794,1.20606A166.90561,166.90561,0,0,0,47.99414,39.99963a8,8,0,0,0,0,16,151.00491,151.00491,0,0,1,107.48047,44.52051,151.00328,151.00328,0,0,1,44.51953,107.47949,8,8,0,0,0,16,0A166.90191,166.90191,0,0,0,166.78809,89.20569ZM51.99414,191.99963a12,12,0,1,0,12,12A12.01344,12.01344,0,0,0,51.99414,191.99963Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M47.99414,144a64,64,0,0,1,64,64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M47.99414,96a112,112,0,0,1,112,112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M47.99414,48a160,160,0,0,1,160,160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "52",
      "cy": "204",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M47.99414,144a64,64,0,0,1,64,64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M47.99414,96a112,112,0,0,1,112,112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M47.99414,48a160,160,0,0,1,160,160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "52",
      "cy": "204",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M48,144a64,64,0,0,1,64,64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,96A112,112,0,0,1,160,208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,48A160,160,0,0,1,208,208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "52",
      "cy": "204",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$aQ = [];
/* style */

const __vue_inject_styles__$aQ = undefined;
/* scoped */

const __vue_scope_id__$aQ = undefined;
/* module identifier */

const __vue_module_identifier__$aQ = undefined;
/* functional template */

const __vue_is_functional_template__$aQ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$aQ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$aQ,
  staticRenderFns: __vue_staticRenderFns__$aQ
}, __vue_inject_styles__$aQ, __vue_script__$aQ, __vue_scope_id__$aQ, __vue_is_functional_template__$aQ, __vue_module_identifier__$aQ, false, undefined, undefined, undefined);

var script$aR = Vue.extend({
  name: "PhRssSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$aR = script$aR;
/* template */

var __vue_render__$aR = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56,48A152,152,0,0,1,208,200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,120a80,80,0,0,1,80,80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "56",
      "cy": "200",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M55.99414,48a152,152,0,0,1,152,152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M55.99414,120a80,80,0,0,1,80,80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "56",
      "cy": "200",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M215.99414,199.99963a8,8,0,0,1-16,0c0-79.40234-64.59814-144-144-144a8,8,0,0,1,0-16C144.21826,39.99963,215.99414,111.775,215.99414,199.99963Zm-160-88a8,8,0,1,0,0,16,72.08124,72.08124,0,0,1,72,72,8,8,0,0,0,16,0A88.09957,88.09957,0,0,0,55.99414,111.99963Zm0,76a12,12,0,1,0,12,12A12.01344,12.01344,0,0,0,55.99414,187.99963Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56,48A152,152,0,0,1,208,200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,120a80,80,0,0,1,80,80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "56",
      "cy": "200",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56,48A152,152,0,0,1,208,200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,120a80,80,0,0,1,80,80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "56",
      "cy": "200",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56,48A152,152,0,0,1,208,200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,120a80,80,0,0,1,80,80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "56",
      "cy": "200",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$aR = [];
/* style */

const __vue_inject_styles__$aR = undefined;
/* scoped */

const __vue_scope_id__$aR = undefined;
/* module identifier */

const __vue_module_identifier__$aR = undefined;
/* functional template */

const __vue_is_functional_template__$aR = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$aR = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$aR,
  staticRenderFns: __vue_staticRenderFns__$aR
}, __vue_inject_styles__$aR, __vue_script__$aR, __vue_scope_id__$aR, __vue_is_functional_template__$aR, __vue_module_identifier__$aR, false, undefined, undefined, undefined);

var script$aS = Vue.extend({
  name: "PhRuler",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$aS = script$aS;
/* template */

var __vue_render__$aS = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "26.17662",
      "y": "82.74517",
      "width": "203.64675",
      "height": "90.50967",
      "rx": "8",
      "transform": "translate(-53.01934 128) rotate(-45)",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "132",
      "y1": "60",
      "x2": "164",
      "y2": "92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "96",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "60",
      "y1": "132",
      "x2": "92",
      "y2": "164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "26.17662",
      "y": "82.74517",
      "width": "203.64675",
      "height": "90.50967",
      "rx": "8",
      "transform": "translate(-53.01934 128) rotate(-45)",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "26.17662",
      "y": "82.74517",
      "width": "203.64675",
      "height": "90.50967",
      "rx": "8",
      "transform": "translate(-53.01934 128) rotate(-45)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "132",
      "y1": "60",
      "x2": "164",
      "y2": "92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "96",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "60",
      "y1": "132",
      "x2": "92",
      "y2": "164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232,76.68652,179.31348,23.999A16.02162,16.02162,0,0,0,156.68555,24L132,48.686l37.65723,37.65722a8.00018,8.00018,0,0,1-11.31446,11.31348L120.686,60,96,84.686l37.65723,37.65722a8.00018,8.00018,0,0,1-11.31446,11.31348L84.686,96,60,120.686l37.65723,37.65722a8.00018,8.00018,0,0,1-11.31446,11.31348L48.686,132,24.001,156.68555A15.99888,15.99888,0,0,0,24,179.31348L76.68652,232.001A16.02252,16.02252,0,0,0,99.31445,232L232,99.31348a15.9989,15.9989,0,0,0,0-22.627Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "26.17662",
      "y": "82.74517",
      "width": "203.64675",
      "height": "90.50967",
      "rx": "8",
      "transform": "translate(-53.01934 128) rotate(-45)",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "132",
      "y1": "60",
      "x2": "164",
      "y2": "92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "96",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "60",
      "y1": "132",
      "x2": "92",
      "y2": "164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "26.17662",
      "y": "82.74517",
      "width": "203.64675",
      "height": "90.50967",
      "rx": "8",
      "transform": "translate(-53.01934 128) rotate(-45)",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "132",
      "y1": "60",
      "x2": "164",
      "y2": "92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "96",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "60",
      "y1": "132",
      "x2": "92",
      "y2": "164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "26.17662",
      "y": "82.74517",
      "width": "203.64675",
      "height": "90.50967",
      "rx": "8",
      "transform": "translate(-53.01934 128) rotate(-45)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "132",
      "y1": "60",
      "x2": "164",
      "y2": "92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "96",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "60",
      "y1": "132",
      "x2": "92",
      "y2": "164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$aS = [];
/* style */

const __vue_inject_styles__$aS = undefined;
/* scoped */

const __vue_scope_id__$aS = undefined;
/* module identifier */

const __vue_module_identifier__$aS = undefined;
/* functional template */

const __vue_is_functional_template__$aS = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$aS = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$aS,
  staticRenderFns: __vue_staticRenderFns__$aS
}, __vue_inject_styles__$aS, __vue_script__$aS, __vue_scope_id__$aS, __vue_is_functional_template__$aS, __vue_module_identifier__$aS, false, undefined, undefined, undefined);

var script$aT = Vue.extend({
  name: "PhScales",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$aT = script$aT;
/* template */

var __vue_render__$aT = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "216",
      "x2": "152",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "88",
      "x2": "200",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,168c0,17.67311,20,24,32,24s32-6.32689,32-24L56,88Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,136c0,17.67311,20,24,32,24s32-6.32689,32-24L200,56Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M24,168c0,17.67311,20,24,32,24s32-6.32689,32-24L56,88Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,136c0,17.67311,20,24,32,24s32-6.32689,32-24L200,56Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "216",
      "x2": "152",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "88",
      "x2": "200",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,168c0,17.67311,20,24,32,24s32-6.32689,32-24L56,88Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,136c0,17.67311,20,24,32,24s32-6.32689,32-24L200,56Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M239.42773,133.0293l-32-80c-.0122-.03076-.03076-.05762-.04345-.08838a7.94631,7.94631,0,0,0-.481-.98145c-.01465-.02441-.03125-.04687-.0459-.07129a7.93042,7.93042,0,0,0-.5708-.82275c-.04443-.05615-.08691-.11328-.13281-.168a7.96437,7.96437,0,0,0-.71143-.75635c-.0459-.04248-.09472-.08007-.1416-.12158a8.00092,8.00092,0,0,0-.69189-.54639c-.06787-.04785-.13428-.09765-.20362-.144a8.16785,8.16785,0,0,0-.87256-.50146c-.06787-.03321-.13769-.06153-.20654-.09278a7.92639,7.92639,0,0,0-.82617-.32519c-.06494-.02149-.12842-.0459-.19434-.06592a8.04279,8.04279,0,0,0-1.0249-.23584c-.06445-.01025-.12939-.0166-.19385-.02588a7.97774,7.97774,0,0,0-.99365-.07519C200.062,48.00684,200.03174,48,200,48c-.01221,0-.02393.00293-.03613.00293a7.87125,7.87125,0,0,0-1.07032.081c-.08789.01221-.17382.02881-.26074.044-.123.02148-.24511.03516-.36816.0625L136,62.02686V40a8,8,0,0,0-16,0V65.58252L54.26465,80.19043c-.16553.03662-.32373.0874-.48438.13379-.06933.02-.14013.03564-.209.05762a7.95224,7.95224,0,0,0-.97656.38378c-.05762.02735-.1128.05762-.16944.08643a7.92974,7.92974,0,0,0-.81787.47022c-.04394.0288-.08935.05517-.13281.085a7.96988,7.96988,0,0,0-.82764.65381c-.04834.04345-.09326.08984-.14062.13476a8.08693,8.08693,0,0,0-.63086.66992c-.04053.04834-.0835.09375-.123.14356a8.00617,8.00617,0,0,0-.58935.84961c-.041.06787-.07862.1372-.11768.20605a8.00524,8.00524,0,0,0-.45752.93262c-.00439.01123-.01123.02051-.01562.03174l-.00977.0249-.01416.03467L16.57227,165.0293A7.99723,7.99723,0,0,0,16,168c0,23.3125,24.53516,32,40,32s40-8.6875,40-32a7.99723,7.99723,0,0,0-.57227-2.9707L66.92334,93.76758,120,81.97314V208H104a8,8,0,0,0,0,16h48a8,8,0,0,0,0-16H136V78.41748l50.94531-11.32129-26.373,65.93311A7.99723,7.99723,0,0,0,160,136c0,23.3125,24.53516,32,40,32s40-8.6875,40-32A7.99723,7.99723,0,0,0,239.42773,133.0293ZM32.61621,168,56,109.541,79.38379,168Zm144-32L200,77.541,223.38379,136Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "216",
      "x2": "152",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "88",
      "x2": "200",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,168c0,17.67311,20,24,32,24s32-6.32689,32-24L56,88Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,136c0,17.67311,20,24,32,24s32-6.32689,32-24L200,56Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "216",
      "x2": "152",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "88",
      "x2": "200",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,168c0,17.67311,20,24,32,24s32-6.32689,32-24L56,88Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,136c0,17.67311,20,24,32,24s32-6.32689,32-24L200,56Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "216",
      "x2": "152",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "88",
      "x2": "200",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,168c0,17.67311,20,24,32,24s32-6.32689,32-24L56,88Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,136c0,17.67311,20,24,32,24s32-6.32689,32-24L200,56Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$aT = [];
/* style */

const __vue_inject_styles__$aT = undefined;
/* scoped */

const __vue_scope_id__$aT = undefined;
/* module identifier */

const __vue_module_identifier__$aT = undefined;
/* functional template */

const __vue_is_functional_template__$aT = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$aT = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$aT,
  staticRenderFns: __vue_staticRenderFns__$aT
}, __vue_inject_styles__$aT, __vue_script__$aT, __vue_scope_id__$aT, __vue_is_functional_template__$aT, __vue_module_identifier__$aT, false, undefined, undefined, undefined);

var script$aU = Vue.extend({
  name: "PhScissors",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$aU = script$aU;
/* template */

var __vue_render__$aU = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "60",
      "cy": "76",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "60",
      "cy": "180",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "128",
      "x2": "83.10669",
      "y2": "164.19016",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "193.68421",
      "x2": "83.10611",
      "y2": "91.80944",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "62.31579",
      "x2": "171.41815",
      "y2": "103.76653",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "60",
      "cy": "76",
      "r": "28",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "60",
      "cy": "180",
      "r": "28",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "60",
      "cy": "76",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "60",
      "cy": "180",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "128",
      "x2": "83.10669",
      "y2": "164.19016",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "62.31579",
      "x2": "164.33455",
      "y2": "108.6132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "193.68421",
      "x2": "83.10611",
      "y2": "91.80944",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M157.73193,113.13086a8.00047,8.00047,0,0,1,2.085-11.12012l67.66553-46.29785A8.00013,8.00013,0,0,1,236.51758,68.918l-67.66553,46.29785a7.99794,7.99794,0,0,1-11.12012-2.085Zm80.87061,85.07129a7.99794,7.99794,0,0,1-11.12012,2.085l-91.4826-62.59351L93.49408,166.77686a36.034,36.034,0,1,1-9.05035-13.19458l37.38867-25.582-37.3891-25.582a35.84637,35.84637,0,1,1,9.0506-13.19458L236.51758,187.082A8.00047,8.00047,0,0,1,238.60254,198.20215ZM80,180a20,20,0,1,0-5.85791,14.1416A19.86692,19.86692,0,0,0,80,180ZM74.14209,90.1416a20,20,0,1,0-28.28418,0A19.86692,19.86692,0,0,0,74.14209,90.1416Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "60",
      "cy": "76",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "60",
      "cy": "180",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "128",
      "x2": "83.10669",
      "y2": "164.19016",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "62.31579",
      "x2": "164.33455",
      "y2": "108.6132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "193.68421",
      "x2": "83.10611",
      "y2": "91.80944",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "60",
      "cy": "76",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "60",
      "cy": "180",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "128",
      "x2": "83.10669",
      "y2": "164.19016",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "62.31579",
      "x2": "164.33455",
      "y2": "108.6132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "193.68421",
      "x2": "83.10611",
      "y2": "91.80944",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "60",
      "cy": "76",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "60",
      "cy": "180",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "128",
      "x2": "83.10669",
      "y2": "164.19016",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "62.31579",
      "x2": "164.33455",
      "y2": "108.6132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "193.68421",
      "x2": "83.10611",
      "y2": "91.80944",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$aU = [];
/* style */

const __vue_inject_styles__$aU = undefined;
/* scoped */

const __vue_scope_id__$aU = undefined;
/* module identifier */

const __vue_module_identifier__$aU = undefined;
/* functional template */

const __vue_is_functional_template__$aU = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$aU = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$aU,
  staticRenderFns: __vue_staticRenderFns__$aU
}, __vue_inject_styles__$aU, __vue_script__$aU, __vue_scope_id__$aU, __vue_is_functional_template__$aU, __vue_module_identifier__$aU, false, undefined, undefined, undefined);

var script$aV = Vue.extend({
  name: "PhScreencast",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$aV = script$aV;
/* template */

var __vue_render__$aV = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M35.99414,68V60a8,8,0,0,1,8-8h168a8,8,0,0,1,8,8V196a8,8,0,0,1-8,8h-40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M35.99414,188a16,16,0,0,1,16,16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M35.99414,148a56,56,0,0,1,56,56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M35.99414,108a96,96,0,0,1,96,96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M215.99463,47.99561h-176a7.99988,7.99988,0,0,0-8,8V192A15.99986,15.99986,0,0,1,47.9939,207.99561H215.99463a8,8,0,0,0,8-8v-144A7.99989,7.99989,0,0,0,215.99463,47.99561Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M31.99414,96V56a8,8,0,0,1,8-8h176a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8h-72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M31.99414,192a16,16,0,0,1,16,16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M31.99414,160a48,48,0,0,1,48,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M31.99414,128a80,80,0,0,1,80,80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M31.99414,184a8,8,0,0,0,0,16,8.00917,8.00917,0,0,1,8,8,8,8,0,0,0,16,0A24.02718,24.02718,0,0,0,31.99414,184Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M31.99414,152a8,8,0,0,0,0,16,40.04552,40.04552,0,0,1,40,40,8,8,0,0,0,16,0A56.06322,56.06322,0,0,0,31.99414,152Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M31.99414,120a8,8,0,0,0,0,16,72.08124,72.08124,0,0,1,72,72,8,8,0,0,0,16,0A88.09957,88.09957,0,0,0,31.99414,120Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M215.99414,40h-176a16.01833,16.01833,0,0,0-16,16V96a8.00008,8.00008,0,0,0,8,8,104.11791,104.11791,0,0,1,104,104,8.00008,8.00008,0,0,0,8,8h72a16.01833,16.01833,0,0,0,16-16V56A16.01833,16.01833,0,0,0,215.99414,40Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M31.99414,96V56a8,8,0,0,1,8-8h176a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8h-72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M31.99414,192a16,16,0,0,1,16,16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M31.99414,160a48,48,0,0,1,48,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M31.99414,128a80,80,0,0,1,80,80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M31.99414,96V56a8,8,0,0,1,8-8h176a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8h-72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M31.99414,192a16,16,0,0,1,16,16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M31.99414,160a48,48,0,0,1,48,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M31.99414,128a80,80,0,0,1,80,80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M31.99414,96V56a8,8,0,0,1,8-8h176a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8h-72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M31.99414,192a16,16,0,0,1,16,16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M31.99414,160a48,48,0,0,1,48,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M31.99414,128a80,80,0,0,1,80,80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$aV = [];
/* style */

const __vue_inject_styles__$aV = undefined;
/* scoped */

const __vue_scope_id__$aV = undefined;
/* module identifier */

const __vue_module_identifier__$aV = undefined;
/* functional template */

const __vue_is_functional_template__$aV = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$aV = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$aV,
  staticRenderFns: __vue_staticRenderFns__$aV
}, __vue_inject_styles__$aV, __vue_script__$aV, __vue_scope_id__$aV, __vue_is_functional_template__$aV, __vue_module_identifier__$aV, false, undefined, undefined, undefined);

var script$aW = Vue.extend({
  name: "PhScribbleLoop",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$aW = script$aW;
/* template */

var __vue_render__$aW = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M24,92.8S56,48,104,48c104,0,96,160,0,160-64,0-64-96,32-96,64,0,104,48,104,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M24,92.8S56,48,104,48c104,0,96,160,0,160-64,0-64-96,32-96,64,0,104,48,104,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M246.14551,154.87842c-1.24219-1.49072-22.92774-27.03711-59.82129-41.3501C184.21387,95.708,177.43262,79.4668,166.709,66.91113,151.6709,49.30566,129.98633,40,104,40,52.47559,40,18.89453,86.18408,17.49023,88.1499A8.00013,8.00013,0,0,0,30.50293,97.46C30.80078,97.04541,60.8125,56,104,56c21.16113,0,38.63867,7.36621,50.542,21.30273a69.15627,69.15627,0,0,1,14.69629,30.792A136.9288,136.9288,0,0,0,136,104c-26.06055,0-47.93848,6.80957-63.26758,19.69189-13.55957,11.39551-21.33691,27.27149-21.33691,43.55665a47.58841,47.58841,0,0,0,13.87207,34.05468C74.92871,210.918,88.32227,216,104,216c25.22266,0,46.68848-9.97607,62.0752-28.84961,12.21484-14.98291,19.65136-35.09668,20.79882-55.90185,29.38184,13.26708,46.73145,33.57617,46.98047,33.873a7.99987,7.99987,0,1,0,12.291-10.24316ZM104,200c-25.28613,0-36.60449-16.44922-36.60449-32.75146C67.39551,144.49219,88.86426,120,136,120a120.00113,120.00113,0,0,1,35.0293,5.27344c0,.10937.001.22021.001.32959C171.03027,162.57373,148.00586,200,104,200Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M24,92.8S56,48,104,48c104,0,96,160,0,160-64,0-64-96,32-96,64,0,104,48,104,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M24,92.8S56,48,104,48c104,0,96,160,0,160-64,0-64-96,32-96,64,0,104,48,104,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M24,92.8S56,48,104,48c104,0,96,160,0,160-64,0-64-96,32-96,64,0,104,48,104,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$aW = [];
/* style */

const __vue_inject_styles__$aW = undefined;
/* scoped */

const __vue_scope_id__$aW = undefined;
/* module identifier */

const __vue_module_identifier__$aW = undefined;
/* functional template */

const __vue_is_functional_template__$aW = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$aW = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$aW,
  staticRenderFns: __vue_staticRenderFns__$aW
}, __vue_inject_styles__$aW, __vue_script__$aW, __vue_scope_id__$aW, __vue_is_functional_template__$aW, __vue_module_identifier__$aW, false, undefined, undefined, undefined);

var script$aX = Vue.extend({
  name: "PhSelection",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$aX = script$aX;
/* template */

var __vue_render__$aX = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "144",
      "y1": "40",
      "x2": "112",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "216",
      "x2": "144",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,40h24a8,8,0,0,1,8,8V71.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "143.99963",
      "x2": "216",
      "y2": "111.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,216h24a8,8,0,0,0,8-8V183.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "111.99963",
      "x2": "40",
      "y2": "143.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,216H48a8,8,0,0,1-8-8V183.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,40H48a8,8,0,0,0-8,8V71.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "144",
      "y1": "40",
      "x2": "112",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "216",
      "x2": "144",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,40h24a8,8,0,0,1,8,8V71.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "143.99963",
      "x2": "216",
      "y2": "111.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,216h24a8,8,0,0,0,8-8V183.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "111.99963",
      "x2": "40",
      "y2": "143.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,216H48a8,8,0,0,1-8-8V183.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,40H48a8,8,0,0,0-8,8V71.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M152,40a7.99977,7.99977,0,0,1-8,8H112a8,8,0,0,1,0-16h32A7.99977,7.99977,0,0,1,152,40Zm-8,168H112a8,8,0,0,0,0,16h32a8,8,0,0,0,0-16ZM208,32H184a8,8,0,0,0,0,16h24V71.99951a8,8,0,0,0,16,0V48A16.01833,16.01833,0,0,0,208,32Zm8,71.99951a7.99977,7.99977,0,0,0-8,8v32a8,8,0,0,0,16,0v-32A7.99977,7.99977,0,0,0,216,103.99951Zm0,72a7.99977,7.99977,0,0,0-8,8V208H184a8,8,0,0,0,0,16h24a16.01833,16.01833,0,0,0,16-16V183.99951A7.99977,7.99977,0,0,0,216,175.99951Zm-176-24a7.99977,7.99977,0,0,0,8-8v-32a8,8,0,1,0-16,0v32A7.99977,7.99977,0,0,0,40,151.99951ZM72,208H48V183.99951a8,8,0,0,0-16,0V208a16.01833,16.01833,0,0,0,16,16H72a8,8,0,0,0,0-16ZM72,32H48A16.01833,16.01833,0,0,0,32,48V71.99951a8,8,0,0,0,16,0V48H72a8,8,0,0,0,0-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "144",
      "y1": "40",
      "x2": "112",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "216",
      "x2": "144",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,40h24a8,8,0,0,1,8,8V71.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "143.99963",
      "x2": "216",
      "y2": "111.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,216h24a8,8,0,0,0,8-8V183.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "111.99963",
      "x2": "40",
      "y2": "143.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,216H48a8,8,0,0,1-8-8V183.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,40H48a8,8,0,0,0-8,8V71.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "144",
      "y1": "40",
      "x2": "112",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "216",
      "x2": "144",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,40h24a8,8,0,0,1,8,8V71.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "143.99963",
      "x2": "216",
      "y2": "111.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,216h24a8,8,0,0,0,8-8V183.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "111.99963",
      "x2": "40",
      "y2": "143.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,216H48a8,8,0,0,1-8-8V183.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,40H48a8,8,0,0,0-8,8V71.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "144",
      "y1": "40",
      "x2": "112",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "216",
      "x2": "144",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,40h24a8,8,0,0,1,8,8V71.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "143.99963",
      "x2": "216",
      "y2": "111.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,216h24a8,8,0,0,0,8-8V183.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "111.99963",
      "x2": "40",
      "y2": "143.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,216H48a8,8,0,0,1-8-8V183.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,40H48a8,8,0,0,0-8,8V71.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$aX = [];
/* style */

const __vue_inject_styles__$aX = undefined;
/* scoped */

const __vue_scope_id__$aX = undefined;
/* module identifier */

const __vue_module_identifier__$aX = undefined;
/* functional template */

const __vue_is_functional_template__$aX = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$aX = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$aX,
  staticRenderFns: __vue_staticRenderFns__$aX
}, __vue_inject_styles__$aX, __vue_script__$aX, __vue_scope_id__$aX, __vue_is_functional_template__$aX, __vue_module_identifier__$aX, false, undefined, undefined, undefined);

var script$aY = Vue.extend({
  name: "PhSelectionAll",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$aY = script$aY;
/* template */

var __vue_render__$aY = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "144",
      "y1": "40",
      "x2": "112",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "216",
      "x2": "144",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,40h24a8,8,0,0,1,8,8V71.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "143.99963",
      "x2": "216",
      "y2": "111.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,216h24a8,8,0,0,0,8-8V183.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "111.99963",
      "x2": "40",
      "y2": "143.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,216H48a8,8,0,0,1-8-8V183.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,40H48a8,8,0,0,0-8,8V71.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "80",
      "y": "80",
      "width": "96",
      "height": "96",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "80",
      "y": "80",
      "width": "96",
      "height": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "40",
      "x2": "112",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "216",
      "x2": "144",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,40h24a8,8,0,0,1,8,8V71.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "143.99963",
      "x2": "216",
      "y2": "111.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,216h24a8,8,0,0,0,8-8V183.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "111.99963",
      "x2": "40",
      "y2": "143.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,216H48a8,8,0,0,1-8-8V183.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,40H48a8,8,0,0,0-8,8V71.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "80",
      "y": "80",
      "width": "96",
      "height": "96",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M104,40a8.00008,8.00008,0,0,1,8-8h32a8,8,0,0,1,0,16H112A8.00008,8.00008,0,0,1,104,40Zm40,168H112a8,8,0,0,0,0,16h32a8,8,0,0,0,0-16ZM208,32H184a8,8,0,0,0,0,16h24V72a8,8,0,0,0,16,0V48A16.01833,16.01833,0,0,0,208,32Zm8,72a8.00008,8.00008,0,0,0-8,8v32a8,8,0,0,0,16,0V112A8.00008,8.00008,0,0,0,216,104Zm0,72a8.00008,8.00008,0,0,0-8,8v24H184a8,8,0,0,0,0,16h24a16.01833,16.01833,0,0,0,16-16V184A8.00008,8.00008,0,0,0,216,176ZM40,152a8.00008,8.00008,0,0,0,8-8V112a8,8,0,0,0-16,0v32A8.00008,8.00008,0,0,0,40,152Zm32,56H48V184a8,8,0,0,0-16,0v24a16.01833,16.01833,0,0,0,16,16H72a8,8,0,0,0,0-16ZM40,80a8.00008,8.00008,0,0,0,8-8V48H72a8,8,0,0,0,0-16H48A16.01833,16.01833,0,0,0,32,48V72A8.00008,8.00008,0,0,0,40,80ZM176,184H80a8.00008,8.00008,0,0,1-8-8V80a8.00008,8.00008,0,0,1,8-8h96a8.00008,8.00008,0,0,1,8,8v96A8.00008,8.00008,0,0,1,176,184Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "144",
      "y1": "40",
      "x2": "112",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "216",
      "x2": "144",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,40h24a8,8,0,0,1,8,8V71.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "143.99963",
      "x2": "216",
      "y2": "111.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,216h24a8,8,0,0,0,8-8V183.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "111.99963",
      "x2": "40",
      "y2": "143.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,216H48a8,8,0,0,1-8-8V183.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,40H48a8,8,0,0,0-8,8V71.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "80",
      "y": "80",
      "width": "96",
      "height": "96",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "144",
      "y1": "40",
      "x2": "112",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "216",
      "x2": "144",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,40h24a8,8,0,0,1,8,8V71.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "143.99963",
      "x2": "216",
      "y2": "111.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,216h24a8,8,0,0,0,8-8V183.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "111.99963",
      "x2": "40",
      "y2": "143.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,216H48a8,8,0,0,1-8-8V183.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,40H48a8,8,0,0,0-8,8V71.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "80",
      "y": "80",
      "width": "96",
      "height": "96",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "144",
      "y1": "40",
      "x2": "112",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "216",
      "x2": "144",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,40h24a8,8,0,0,1,8,8V71.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "143.99963",
      "x2": "216",
      "y2": "111.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,216h24a8,8,0,0,0,8-8V183.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "111.99963",
      "x2": "40",
      "y2": "143.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,216H48a8,8,0,0,1-8-8V183.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,40H48a8,8,0,0,0-8,8V71.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "80",
      "y": "80",
      "width": "96",
      "height": "96",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$aY = [];
/* style */

const __vue_inject_styles__$aY = undefined;
/* scoped */

const __vue_scope_id__$aY = undefined;
/* module identifier */

const __vue_module_identifier__$aY = undefined;
/* functional template */

const __vue_is_functional_template__$aY = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$aY = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$aY,
  staticRenderFns: __vue_staticRenderFns__$aY
}, __vue_inject_styles__$aY, __vue_script__$aY, __vue_scope_id__$aY, __vue_is_functional_template__$aY, __vue_module_identifier__$aY, false, undefined, undefined, undefined);

var script$aZ = Vue.extend({
  name: "PhSelectionBackground",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$aZ = script$aZ;
/* template */

var __vue_render__$aZ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "39.99902",
      "y": "91.99414",
      "width": "124",
      "height": "124",
      "rx": "7.75",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "40",
      "x2": "144",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,40h8a8,8,0,0,1,8,8v7.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "111.99963",
      "x2": "216",
      "y2": "95.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,168h8a8,8,0,0,0,8-8v-8.00037",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,40H96a8,8,0,0,0-8,8v7.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "39.99902",
      "y": "87.99414",
      "width": "128",
      "height": "128",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "40",
      "x2": "144",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,40h8a8,8,0,0,1,8,8v7.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "111.99963",
      "x2": "216",
      "y2": "95.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,168h8a8,8,0,0,0,8-8v-8.00037",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,40H96a8,8,0,0,0-8,8v7.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,40H96a8,8,0,0,0-8,8V88h72a8,8,0,0,1,8,8v72h40a8,8,0,0,0,8-8V48A8,8,0,0,0,208,40Z",
      "opacity": "0.2"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,56V48A16.01833,16.01833,0,0,1,96,32h8a8,8,0,0,1,0,16H96v8a8,8,0,0,1-16,0Zm64-8h16a8,8,0,0,0,0-16H144a8,8,0,0,0,0,16Zm64-16h-8a8,8,0,0,0,0,16h8v8a8,8,0,0,0,16,0V48A16.01833,16.01833,0,0,0,208,32Zm8,56a8.00008,8.00008,0,0,0-8,8v16a8,8,0,0,0,16,0V96A8.00008,8.00008,0,0,0,216,88Zm-40.001,7.99414v112a16.01833,16.01833,0,0,1-16,16h-112a16.01833,16.01833,0,0,1-16-16v-112a16.01833,16.01833,0,0,1,16-16h112A16.01833,16.01833,0,0,1,175.999,95.99414Zm-16,0h-112v112h112ZM216,144a8.00008,8.00008,0,0,0-8,8v8h-8a8,8,0,0,0,0,16h8a16.01833,16.01833,0,0,0,16-16v-8A8.00008,8.00008,0,0,0,216,144Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "39.99902",
      "y": "87.99414",
      "width": "128",
      "height": "128",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "40",
      "x2": "144",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,40h8a8,8,0,0,1,8,8v7.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "111.99963",
      "x2": "216",
      "y2": "95.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,168h8a8,8,0,0,0,8-8v-8.00037",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,40H96a8,8,0,0,0-8,8v7.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "39.99902",
      "y": "87.99414",
      "width": "128",
      "height": "128",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "40",
      "x2": "144",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,40h8a8,8,0,0,1,8,8v7.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "111.99963",
      "x2": "216",
      "y2": "95.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,168h8a8,8,0,0,0,8-8v-8.00037",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,40H96a8,8,0,0,0-8,8v7.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "39.99902",
      "y": "87.99414",
      "width": "128",
      "height": "128",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "40",
      "x2": "144",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,40h8a8,8,0,0,1,8,8v7.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "111.99963",
      "x2": "216",
      "y2": "95.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,168h8a8,8,0,0,0,8-8v-8.00037",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,40H96a8,8,0,0,0-8,8v7.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$aZ = [];
/* style */

const __vue_inject_styles__$aZ = undefined;
/* scoped */

const __vue_scope_id__$aZ = undefined;
/* module identifier */

const __vue_module_identifier__$aZ = undefined;
/* functional template */

const __vue_is_functional_template__$aZ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$aZ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$aZ,
  staticRenderFns: __vue_staticRenderFns__$aZ
}, __vue_inject_styles__$aZ, __vue_script__$aZ, __vue_scope_id__$aZ, __vue_is_functional_template__$aZ, __vue_module_identifier__$aZ, false, undefined, undefined, undefined);

var script$a_ = Vue.extend({
  name: "PhSelectionForeground",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$a_ = script$a_;
/* template */

var __vue_render__$a_ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56,216H48a8,8,0,0,1-8-8v-8.00037",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "88",
      "x2": "92",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "216",
      "x2": "96",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "163.99963",
      "x2": "168",
      "y2": "143.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "159.99963",
      "x2": "40",
      "y2": "143.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,216h8a8,8,0,0,0,8-8v-8.00037",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,88h8a8,8,0,0,1,8,8v7.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,88H48a8,8,0,0,0-8,8v7.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M169.501,164H208.25a7.75,7.75,0,0,0,7.75-7.75V47.75A7.75,7.75,0,0,0,208.25,40H99.75A7.75,7.75,0,0,0,92,47.75V86.50568",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "88",
      "width": "128",
      "height": "128",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,216H48a8,8,0,0,1-8-8v-8.00037",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "88",
      "x2": "88",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "216",
      "x2": "96",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "167.99963",
      "x2": "168",
      "y2": "143.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "159.99963",
      "x2": "40",
      "y2": "143.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,216h8a8,8,0,0,0,8-8v-8.00037",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,88h8a8,8,0,0,1,8,8v7.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,88H48a8,8,0,0,0-8,8v7.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,167.99414h39.999a8,8,0,0,0,8-8v-112a8,8,0,0,0-8-8h-112a8,8,0,0,0-8,8V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M64,216a8.00008,8.00008,0,0,1-8,8H48a16.01833,16.01833,0,0,1-16-16v-8a8,8,0,0,1,16,0v8h8A8.00008,8.00008,0,0,1,64,216Zm48-8H96a8,8,0,0,0,0,16h16a8,8,0,0,0,0-16ZM40,168a8.00008,8.00008,0,0,0,8-8V144a8,8,0,0,0-16,0v16A8.00008,8.00008,0,0,0,40,168Zm128,24a8.00008,8.00008,0,0,0-8,8v8h-8a8,8,0,0,0,0,16h8a16.01833,16.01833,0,0,0,16-16v-8A8.00008,8.00008,0,0,0,168,192Zm0-80a8.00008,8.00008,0,0,0,8-8V96a16.01833,16.01833,0,0,0-16-16h-8a8,8,0,0,0,0,16h8v8A8.00008,8.00008,0,0,0,168,112ZM56,80H48A16.01833,16.01833,0,0,0,32,96v8a8,8,0,0,0,16,0V96h8a8,8,0,0,0,0-16ZM207.999,31.99414h-112a16.01833,16.01833,0,0,0-16,16V88a8.00009,8.00009,0,0,0,8,8H112a8,8,0,0,0,0-16H95.999V47.99414h112v112H176V144a8,8,0,0,0-16,0v24a8.00008,8.00008,0,0,0,8,8c.03918,0,.0769-.00537.116-.00586H207.999a16.01833,16.01833,0,0,0,16-16v-112A16.01833,16.01833,0,0,0,207.999,31.99414Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56,216H48a8,8,0,0,1-8-8v-8.00037",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "88",
      "x2": "88",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "216",
      "x2": "96",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "167.99963",
      "x2": "168",
      "y2": "143.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "159.99963",
      "x2": "40",
      "y2": "143.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,216h8a8,8,0,0,0,8-8v-8.00037",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,88h8a8,8,0,0,1,8,8v7.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,88H48a8,8,0,0,0-8,8v7.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,167.99414h39.999a8,8,0,0,0,8-8v-112a8,8,0,0,0-8-8h-112a8,8,0,0,0-8,8V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56,216H48a8,8,0,0,1-8-8v-8.00037",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "88",
      "x2": "88",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "216",
      "x2": "96",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "167.99963",
      "x2": "168",
      "y2": "143.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "159.99963",
      "x2": "40",
      "y2": "143.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,216h8a8,8,0,0,0,8-8v-8.00037",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,88h8a8,8,0,0,1,8,8v7.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,88H48a8,8,0,0,0-8,8v7.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,167.99414h39.999a8,8,0,0,0,8-8v-112a8,8,0,0,0-8-8h-112a8,8,0,0,0-8,8V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56,216H48a8,8,0,0,1-8-8v-8.00037",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "88",
      "x2": "88",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "216",
      "x2": "96",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "167.99963",
      "x2": "168",
      "y2": "143.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "159.99963",
      "x2": "40",
      "y2": "143.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,216h8a8,8,0,0,0,8-8v-8.00037",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,88h8a8,8,0,0,1,8,8v7.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,88H48a8,8,0,0,0-8,8v7.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,167.99414h39.999a8,8,0,0,0,8-8v-112a8,8,0,0,0-8-8h-112a8,8,0,0,0-8,8V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$a_ = [];
/* style */

const __vue_inject_styles__$a_ = undefined;
/* scoped */

const __vue_scope_id__$a_ = undefined;
/* module identifier */

const __vue_module_identifier__$a_ = undefined;
/* functional template */

const __vue_is_functional_template__$a_ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$a_ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$a_,
  staticRenderFns: __vue_staticRenderFns__$a_
}, __vue_inject_styles__$a_, __vue_script__$a_, __vue_scope_id__$a_, __vue_is_functional_template__$a_, __vue_module_identifier__$a_, false, undefined, undefined, undefined);

var script$a$ = Vue.extend({
  name: "PhSelectionInverse",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$a$ = script$a$;
/* template */

var __vue_render__$a$ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "112",
      "y1": "216",
      "x2": "144",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "111.99963",
      "x2": "40",
      "y2": "143.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,216H48a8,8,0,0,1-8-8V183.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,216h24a8,8,0,0,0,8-8V48a8,8,0,0,0-8-8H48a8,8,0,0,0-8,8V71.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "42.3432",
      "y1": "42.3432",
      "x2": "213.65681",
      "y2": "213.65681",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M42.3432,42.3432,213.65681,213.65681l0,0A7.975,7.975,0,0,0,216,208V48a8,8,0,0,0-8-8H48a7.975,7.975,0,0,0-5.65683,2.34314Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "216",
      "x2": "144",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "111.99963",
      "x2": "40",
      "y2": "143.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,216H48a8,8,0,0,1-8-8V183.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,216h24a8,8,0,0,0,8-8V48a8,8,0,0,0-8-8H48a8,8,0,0,0-8,8V71.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "42.3432",
      "y1": "42.3432",
      "x2": "213.65681",
      "y2": "213.65681",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M152,216a8.00008,8.00008,0,0,1-8,8H112a8,8,0,0,1,0-16h32A8.00008,8.00008,0,0,1,152,216ZM40,152a8.00008,8.00008,0,0,0,8-8V112a8,8,0,0,0-16,0v32A8.00008,8.00008,0,0,0,40,152Zm32,56H48V184a8,8,0,0,0-16,0v24a16.01833,16.01833,0,0,0,16,16H72a8,8,0,0,0,0-16ZM224,48a16.01833,16.01833,0,0,0-16-16H48a15.9167,15.9167,0,0,0-10.66406,4.106,7.68793,7.68793,0,0,0-1.23023,1.23022A15.917,15.917,0,0,0,32,48V72a8,8,0,0,0,16,0V59.31348L196.68555,208H184a8,8,0,0,0,0,16h24a15.9162,15.9162,0,0,0,10.66284-4.105,7.68852,7.68852,0,0,0,1.23145-1.2312A15.917,15.917,0,0,0,224,208Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "112",
      "y1": "216",
      "x2": "144",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "111.99963",
      "x2": "40",
      "y2": "143.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,216H48a8,8,0,0,1-8-8V183.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,216h24a8,8,0,0,0,8-8V48a8,8,0,0,0-8-8H48a8,8,0,0,0-8,8V71.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "42.3432",
      "y1": "42.3432",
      "x2": "213.65681",
      "y2": "213.65681",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "112",
      "y1": "216",
      "x2": "144",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "111.99963",
      "x2": "40",
      "y2": "143.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,216H48a8,8,0,0,1-8-8V183.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,216h24a8,8,0,0,0,8-8V48a8,8,0,0,0-8-8H48a8,8,0,0,0-8,8V71.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "42.3432",
      "y1": "42.3432",
      "x2": "213.65681",
      "y2": "213.65681",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "112",
      "y1": "216",
      "x2": "144",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "111.99963",
      "x2": "40",
      "y2": "143.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,216H48a8,8,0,0,1-8-8V183.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,216h24a8,8,0,0,0,8-8V48a8,8,0,0,0-8-8H48a8,8,0,0,0-8,8V71.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "42.3432",
      "y1": "42.3432",
      "x2": "213.65681",
      "y2": "213.65681",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$a$ = [];
/* style */

const __vue_inject_styles__$a$ = undefined;
/* scoped */

const __vue_scope_id__$a$ = undefined;
/* module identifier */

const __vue_module_identifier__$a$ = undefined;
/* functional template */

const __vue_is_functional_template__$a$ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$a$ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$a$,
  staticRenderFns: __vue_staticRenderFns__$a$
}, __vue_inject_styles__$a$, __vue_script__$a$, __vue_scope_id__$a$, __vue_is_functional_template__$a$, __vue_module_identifier__$a$, false, undefined, undefined, undefined);

var script$b0 = Vue.extend({
  name: "PhSelectionPlus",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$b0 = script$b0;
/* template */

var __vue_render__$b0 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "140",
      "y1": "48",
      "x2": "116",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "116",
      "y1": "208",
      "x2": "140",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M180,48h20a8.00011,8.00011,0,0,1,8,8.00012V76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "139.99963",
      "x2": "208",
      "y2": "115.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "115.99963",
      "x2": "48",
      "y2": "139.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76.00006,208.00006H56a8,8,0,0,1-8-7.99992v-20.0002",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76,48H56a8.00011,8.00011,0,0,0-8,8.00012V76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "180",
      "x2": "208",
      "y2": "236",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "236",
      "y1": "208",
      "x2": "180",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "140",
      "y1": "48",
      "x2": "116",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "116",
      "y1": "208",
      "x2": "140",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M180,48h20a8.00011,8.00011,0,0,1,8,8.00012V76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "139.99963",
      "x2": "208",
      "y2": "115.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "115.99963",
      "x2": "48",
      "y2": "139.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76.00006,208.00006H56a8,8,0,0,1-8-7.99992v-20.0002",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76,48H56a8.00011,8.00011,0,0,0-8,8.00012V76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "180",
      "x2": "208",
      "y2": "236",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "236",
      "y1": "208",
      "x2": "180",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M148,48a7.99977,7.99977,0,0,1-8,8H116a8,8,0,0,1,0-16h24A7.99977,7.99977,0,0,1,148,48Zm-8,152H116a8,8,0,0,0,0,16h24a8,8,0,0,0,0-16ZM180,56h20V76a8,8,0,0,0,16,0V56a16.01833,16.01833,0,0,0-16-16H180a8,8,0,0,0,0,16Zm28,51.99951a7.99977,7.99977,0,0,0-8,8v24a8,8,0,0,0,16,0v-24A7.99977,7.99977,0,0,0,208,107.99951Zm-160,40a7.99977,7.99977,0,0,0,8-8v-24a8,8,0,1,0-16,0v24A7.99977,7.99977,0,0,0,48,147.99951ZM76,200H56V180a8,8,0,0,0-16,0v20a16.01833,16.01833,0,0,0,16,16H76a8,8,0,0,0,0-16ZM76,40H56A16.01833,16.01833,0,0,0,40,56V76a8,8,0,0,0,16,0V56H76a8,8,0,0,0,0-16ZM236,200H216V180a8,8,0,0,0-16,0v20H180a8,8,0,0,0,0,16h20v20a8,8,0,0,0,16,0V216h20a8,8,0,0,0,0-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "140",
      "y1": "48",
      "x2": "116",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "116",
      "y1": "208",
      "x2": "140",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M180,48h20a8.00011,8.00011,0,0,1,8,8.00012V76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "139.99963",
      "x2": "208",
      "y2": "115.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "115.99963",
      "x2": "48",
      "y2": "139.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76.00006,208.00006H56a8,8,0,0,1-8-7.99992v-20.0002",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76,48H56a8.00011,8.00011,0,0,0-8,8.00012V76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "180",
      "x2": "208",
      "y2": "236",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "236",
      "y1": "208",
      "x2": "180",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "140",
      "y1": "48",
      "x2": "116",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "116",
      "y1": "208",
      "x2": "140",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M180,48h20a8.00011,8.00011,0,0,1,8,8.00012V76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "139.99963",
      "x2": "208",
      "y2": "115.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "115.99963",
      "x2": "48",
      "y2": "139.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76.00006,208.00006H56a8,8,0,0,1-8-7.99992v-20.0002",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76,48H56a8.00011,8.00011,0,0,0-8,8.00012V76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "180",
      "x2": "208",
      "y2": "236",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "236",
      "y1": "208",
      "x2": "180",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "140",
      "y1": "48",
      "x2": "116",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "116",
      "y1": "208",
      "x2": "140",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M180,48h20a8.00011,8.00011,0,0,1,8,8.00012V76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "139.99963",
      "x2": "208",
      "y2": "115.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "115.99963",
      "x2": "48",
      "y2": "139.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76.00006,208.00006H56a8,8,0,0,1-8-7.99992v-20.0002",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76,48H56a8.00011,8.00011,0,0,0-8,8.00012V76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "180",
      "x2": "208",
      "y2": "236",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "236",
      "y1": "208",
      "x2": "180",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$b0 = [];
/* style */

const __vue_inject_styles__$b0 = undefined;
/* scoped */

const __vue_scope_id__$b0 = undefined;
/* module identifier */

const __vue_module_identifier__$b0 = undefined;
/* functional template */

const __vue_is_functional_template__$b0 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$b0 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$b0,
  staticRenderFns: __vue_staticRenderFns__$b0
}, __vue_inject_styles__$b0, __vue_script__$b0, __vue_scope_id__$b0, __vue_is_functional_template__$b0, __vue_module_identifier__$b0, false, undefined, undefined, undefined);

var script$b1 = Vue.extend({
  name: "PhSelectionSlash",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$b1 = script$b1;
/* template */

var __vue_render__$b1 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "144",
      "y1": "40",
      "x2": "112",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "216",
      "x2": "144",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,40h24a8,8,0,0,1,8,8V71.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "143.99963",
      "x2": "216",
      "y2": "111.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "111.99963",
      "x2": "40",
      "y2": "143.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,216H48a8,8,0,0,1-8-8V183.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "144",
      "y1": "40",
      "x2": "112",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "216",
      "x2": "144",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,40h24a8,8,0,0,1,8,8V71.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "143.99963",
      "x2": "216",
      "y2": "111.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "111.99963",
      "x2": "40",
      "y2": "143.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,216H48a8,8,0,0,1-8-8V183.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M104,40a7.99977,7.99977,0,0,1,8-8h32a8,8,0,0,1,0,16H112A7.99977,7.99977,0,0,1,104,40Zm40,168H112a8,8,0,0,0,0,16h32a8,8,0,0,0,0-16ZM208,32H184a8,8,0,0,0,0,16h24V71.99951a8,8,0,0,0,16,0V48A16.01833,16.01833,0,0,0,208,32Zm8,71.99951a7.99977,7.99977,0,0,0-8,8v32a8,8,0,0,0,16,0v-32A7.99977,7.99977,0,0,0,216,103.99951Zm-176,48a7.99977,7.99977,0,0,0,8-8v-32a8,8,0,1,0-16,0v32A7.99977,7.99977,0,0,0,40,151.99951ZM72,208H48V184a8,8,0,0,0-16,0v24a16.01833,16.01833,0,0,0,16,16H72a8,8,0,0,0,0-16ZM53.91943,34.61865a7.99991,7.99991,0,1,0-11.83886,10.7627l160,176.00049a8.00024,8.00024,0,1,0,11.83886-10.76368Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "144",
      "y1": "40",
      "x2": "112",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "216",
      "x2": "144",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,40h24a8,8,0,0,1,8,8V71.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "143.99963",
      "x2": "216",
      "y2": "111.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "111.99963",
      "x2": "40",
      "y2": "143.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,216H48a8,8,0,0,1-8-8V183.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "144",
      "y1": "40",
      "x2": "112",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "216",
      "x2": "144",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,40h24a8,8,0,0,1,8,8V71.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "143.99963",
      "x2": "216",
      "y2": "111.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "111.99963",
      "x2": "40",
      "y2": "143.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,216H48a8,8,0,0,1-8-8V183.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "144",
      "y1": "40",
      "x2": "112",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "216",
      "x2": "144",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,40h24a8,8,0,0,1,8,8V71.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "143.99963",
      "x2": "216",
      "y2": "111.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "111.99963",
      "x2": "40",
      "y2": "143.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,216H48a8,8,0,0,1-8-8V183.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$b1 = [];
/* style */

const __vue_inject_styles__$b1 = undefined;
/* scoped */

const __vue_scope_id__$b1 = undefined;
/* module identifier */

const __vue_module_identifier__$b1 = undefined;
/* functional template */

const __vue_is_functional_template__$b1 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$b1 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$b1,
  staticRenderFns: __vue_staticRenderFns__$b1
}, __vue_inject_styles__$b1, __vue_script__$b1, __vue_scope_id__$b1, __vue_is_functional_template__$b1, __vue_module_identifier__$b1, false, undefined, undefined, undefined);

var script$b2 = Vue.extend({
  name: "PhShare",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$b2 = script$b2;
/* template */

var __vue_render__$b2 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 152 224 104 176 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M192,216H40a8,8,0,0,1-8-8V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M75.0245,175.99967A96.04041,96.04041,0,0,1,168,104h56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 152 224 104 176 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M192,216H40a8,8,0,0,1-8-8V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M75.0245,175.99967A96.04041,96.04041,0,0,1,168,104h56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M229.65723,109.65723l-48,48A8.00066,8.00066,0,0,1,168,152V112a87.94718,87.94718,0,0,0-85.22852,65.99414,7.99961,7.99961,0,0,1-15.49414-3.98828A103.9414,103.9414,0,0,1,168,96V56a8.00066,8.00066,0,0,1,13.65723-5.65723l48,48A8.00122,8.00122,0,0,1,229.65723,109.65723ZM192,208H40V88a8,8,0,0,0-16,0V208a16.01833,16.01833,0,0,0,16,16H192a8,8,0,0,0,0-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 152 224 104 176 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M192,216H40a8,8,0,0,1-8-8V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M75.0245,175.99967A96.04041,96.04041,0,0,1,168,104h56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 152 224 104 176 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M192,216H40a8,8,0,0,1-8-8V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M75.0245,175.99967A96.04041,96.04041,0,0,1,168,104h56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 152 224 104 176 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M192,216H40a8,8,0,0,1-8-8V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M75.0245,175.99967A96.04041,96.04041,0,0,1,168,104h56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$b2 = [];
/* style */

const __vue_inject_styles__$b2 = undefined;
/* scoped */

const __vue_scope_id__$b2 = undefined;
/* module identifier */

const __vue_module_identifier__$b2 = undefined;
/* functional template */

const __vue_is_functional_template__$b2 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$b2 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$b2,
  staticRenderFns: __vue_staticRenderFns__$b2
}, __vue_inject_styles__$b2, __vue_script__$b2, __vue_scope_id__$b2, __vue_is_functional_template__$b2, __vue_module_identifier__$b2, false, undefined, undefined, undefined);

var script$b3 = Vue.extend({
  name: "PhShareNetwork",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$b3 = script$b3;
/* template */

var __vue_render__$b3 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "64",
      "cy": "128",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "200",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "56",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "149.08436",
      "y1": "73.30291",
      "x2": "90.91323",
      "y2": "110.69864",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "90.9132",
      "y1": "145.30134",
      "x2": "149.08428",
      "y2": "182.69704",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "176",
      "cy": "200",
      "r": "32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "56",
      "r": "32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "64",
      "cy": "128",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "200",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "56",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "149.08436",
      "y1": "73.30291",
      "x2": "90.91323",
      "y2": "110.69864",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "90.9132",
      "y1": "145.30134",
      "x2": "149.08428",
      "y2": "182.69704",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,160a39.87518,39.87518,0,0,0-28.61768,12.09277L101.28467,142.4585a39.85174,39.85174,0,0,0,0-28.917l46.09765-29.63427a39.94957,39.94957,0,1,0-8.667-13.44947L92.61719,100.09229a40,40,0,1,0,0,55.81542l46.09814,29.63453A39.99342,39.99342,0,1,0,176,160Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "64",
      "cy": "128",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "200",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "56",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "149.08436",
      "y1": "73.30291",
      "x2": "90.91323",
      "y2": "110.69864",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "90.9132",
      "y1": "145.30134",
      "x2": "149.08428",
      "y2": "182.69704",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "64",
      "cy": "128",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "200",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "56",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "149.08436",
      "y1": "73.30291",
      "x2": "90.91323",
      "y2": "110.69864",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "90.9132",
      "y1": "145.30134",
      "x2": "149.08428",
      "y2": "182.69704",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "64",
      "cy": "128",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "200",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "56",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "149.08436",
      "y1": "73.30291",
      "x2": "90.91323",
      "y2": "110.69864",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "90.9132",
      "y1": "145.30134",
      "x2": "149.08428",
      "y2": "182.69704",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$b3 = [];
/* style */

const __vue_inject_styles__$b3 = undefined;
/* scoped */

const __vue_scope_id__$b3 = undefined;
/* module identifier */

const __vue_module_identifier__$b3 = undefined;
/* functional template */

const __vue_is_functional_template__$b3 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$b3 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$b3,
  staticRenderFns: __vue_staticRenderFns__$b3
}, __vue_inject_styles__$b3, __vue_script__$b3, __vue_scope_id__$b3, __vue_is_functional_template__$b3, __vue_module_identifier__$b3, false, undefined, undefined, undefined);

var script$b4 = Vue.extend({
  name: "PhShield",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$b4 = script$b4;
/* template */

var __vue_render__$b4 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,114.66667V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.66667c0,84.01533-71.306,111.85016-85.5438,116.57058a7.54755,7.54755,0,0,1-4.9124,0C111.306,226.51683,40,198.682,40,114.66667Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,114.66667V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.66667c0,84.01533-71.306,111.85016-85.5438,116.57058a7.54755,7.54755,0,0,1-4.9124,0C111.306,226.51683,40,198.682,40,114.66667Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,114.66667V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.66667c0,84.01533-71.306,111.85016-85.5438,116.57058a7.54755,7.54755,0,0,1-4.9124,0C111.306,226.51683,40,198.682,40,114.66667Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208.00146,40h-160a16.02085,16.02085,0,0,0-16,16v58.66406c0,89.46094,75.82032,119.125,91.03125,124.16406a15.45824,15.45824,0,0,0,9.9375,0c15.20313-5.03906,91.03125-34.69531,91.03125-124.16406V56A16.02084,16.02084,0,0,0,208.00146,40Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,114.66667V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.66667c0,84.01533-71.306,111.85016-85.5438,116.57058a7.54755,7.54755,0,0,1-4.9124,0C111.306,226.51683,40,198.682,40,114.66667Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,114.66667V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.66667c0,84.01533-71.306,111.85016-85.5438,116.57058a7.54755,7.54755,0,0,1-4.9124,0C111.306,226.51683,40,198.682,40,114.66667Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,114.66667V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.66667c0,84.01533-71.306,111.85016-85.5438,116.57058a7.54755,7.54755,0,0,1-4.9124,0C111.306,226.51683,40,198.682,40,114.66667Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$b4 = [];
/* style */

const __vue_inject_styles__$b4 = undefined;
/* scoped */

const __vue_scope_id__$b4 = undefined;
/* module identifier */

const __vue_module_identifier__$b4 = undefined;
/* functional template */

const __vue_is_functional_template__$b4 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$b4 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$b4,
  staticRenderFns: __vue_staticRenderFns__$b4
}, __vue_inject_styles__$b4, __vue_script__$b4, __vue_scope_id__$b4, __vue_is_functional_template__$b4, __vue_module_identifier__$b4, false, undefined, undefined, undefined);

var script$b5 = Vue.extend({
  name: "PhShieldCheck",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$b5 = script$b5;
/* template */

var __vue_render__$b5 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,114.66667V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.66667c0,84.01533-71.306,111.85016-85.5438,116.57058a7.54755,7.54755,0,0,1-4.9124,0C111.306,226.51683,40,198.682,40,114.66667Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "172 104 113.333 160 84 132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,114.66667V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.66667c0,84.01533-71.306,111.85016-85.5438,116.57058a7.54755,7.54755,0,0,1-4.9124,0C111.306,226.51683,40,198.682,40,114.66667Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,114.66667V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.66667c0,84.01533-71.306,111.85016-85.5438,116.57058a7.54755,7.54755,0,0,1-4.9124,0C111.306,226.51683,40,198.682,40,114.66667Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "172 104 113.333 160 84 132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208.00146,40h-160a16.02085,16.02085,0,0,0-16,16v58.66406c0,89.46094,75.82032,119.125,91.03125,124.16406a15.45824,15.45824,0,0,0,9.9375,0c15.20313-5.03906,91.03125-34.69531,91.03125-124.16406V56A16.02084,16.02084,0,0,0,208.00146,40ZM177.5249,109.78906l-58.67187,56a8.00489,8.00489,0,0,1-11.04688,0l-29.32812-28A8.00135,8.00135,0,1,1,89.5249,126.21094l23.80469,22.72656L166.478,98.21094a8.00135,8.00135,0,1,1,11.04687,11.57812Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,114.66667V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.66667c0,84.01533-71.306,111.85016-85.5438,116.57058a7.54755,7.54755,0,0,1-4.9124,0C111.306,226.51683,40,198.682,40,114.66667Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "172 104 113.333 160 84 132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,114.66667V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.66667c0,84.01533-71.306,111.85016-85.5438,116.57058a7.54755,7.54755,0,0,1-4.9124,0C111.306,226.51683,40,198.682,40,114.66667Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "172 104 113.333 160 84 132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,114.66667V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.66667c0,84.01533-71.306,111.85016-85.5438,116.57058a7.54755,7.54755,0,0,1-4.9124,0C111.306,226.51683,40,198.682,40,114.66667Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "172 104 113.333 160 84 132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$b5 = [];
/* style */

const __vue_inject_styles__$b5 = undefined;
/* scoped */

const __vue_scope_id__$b5 = undefined;
/* module identifier */

const __vue_module_identifier__$b5 = undefined;
/* functional template */

const __vue_is_functional_template__$b5 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$b5 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$b5,
  staticRenderFns: __vue_staticRenderFns__$b5
}, __vue_inject_styles__$b5, __vue_script__$b5, __vue_scope_id__$b5, __vue_is_functional_template__$b5, __vue_module_identifier__$b5, false, undefined, undefined, undefined);

var script$b6 = Vue.extend({
  name: "PhShieldCheckered",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$b6 = script$b6;
/* template */

var __vue_render__$b6 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M39.99463,114.66215V55.99548a8,8,0,0,1,8-8h160a8,8,0,0,1,8,8v58.66667c0,84.01533-71.306,111.85016-85.5438,116.57059a7.54755,7.54755,0,0,1-4.9124,0C111.30065,226.51231,39.99463,198.67748,39.99463,114.66215Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40.62051",
      "y1": "128",
      "x2": "215.36996",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "48",
      "x2": "128",
      "y2": "231.64356",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M48,48h80a0,0,0,0,1,0,0v80a0,0,0,0,1,0,0H40a0,0,0,0,1,0,0V56A8,8,0,0,1,48,48Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M215.37082,128.00012c-7.03543,73.66468-71.46406,98.77141-84.92,103.23262A7.75437,7.75437,0,0,1,128,231.64358V128h87.37Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M39.99463,114.66215V55.99548a8,8,0,0,1,8-8h160a8,8,0,0,1,8,8v58.66667c0,84.01533-71.306,111.85016-85.5438,116.57059a7.54755,7.54755,0,0,1-4.9124,0C111.30065,226.51231,39.99463,198.67748,39.99463,114.66215Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40.62051",
      "y1": "128",
      "x2": "215.36996",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "48",
      "x2": "128",
      "y2": "231.64356",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M207.99463,39.99512h-160a16.018,16.018,0,0,0-16,16v58.667c0,89.458,75.82617,119.125,91.02588,124.16406a15.48947,15.48947,0,0,0,9.94775,0c15.2002-5.03906,91.02637-34.70605,91.02637-124.16406v-58.667A16.018,16.018,0,0,0,207.99463,39.99512Zm-80.00244,183.623C115.27393,219.38965,55.67285,196.00488,48.67383,128H128V55.99512h79.99463v58.667A130.11069,130.11069,0,0,1,207.31592,128H128v95.61548Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M39.99463,114.66215V55.99548a8,8,0,0,1,8-8h160a8,8,0,0,1,8,8v58.66667c0,84.01533-71.306,111.85016-85.5438,116.57059a7.54755,7.54755,0,0,1-4.9124,0C111.30065,226.51231,39.99463,198.67748,39.99463,114.66215Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40.62051",
      "y1": "128",
      "x2": "215.36996",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "48",
      "x2": "128",
      "y2": "231.64356",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M39.99463,114.66215V55.99548a8,8,0,0,1,8-8h160a8,8,0,0,1,8,8v58.66667c0,84.01533-71.306,111.85016-85.5438,116.57059a7.54755,7.54755,0,0,1-4.9124,0C111.30065,226.51231,39.99463,198.67748,39.99463,114.66215Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40.62051",
      "y1": "128",
      "x2": "215.36996",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "48",
      "x2": "128",
      "y2": "231.64356",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M39.99463,114.66215V55.99548a8,8,0,0,1,8-8h160a8,8,0,0,1,8,8v58.66667c0,84.01533-71.306,111.85016-85.5438,116.57059a7.54755,7.54755,0,0,1-4.9124,0C111.30065,226.51231,39.99463,198.67748,39.99463,114.66215Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40.62051",
      "y1": "128",
      "x2": "215.36996",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "48",
      "x2": "128",
      "y2": "231.64356",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$b6 = [];
/* style */

const __vue_inject_styles__$b6 = undefined;
/* scoped */

const __vue_scope_id__$b6 = undefined;
/* module identifier */

const __vue_module_identifier__$b6 = undefined;
/* functional template */

const __vue_is_functional_template__$b6 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$b6 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$b6,
  staticRenderFns: __vue_staticRenderFns__$b6
}, __vue_inject_styles__$b6, __vue_script__$b6, __vue_scope_id__$b6, __vue_is_functional_template__$b6, __vue_module_identifier__$b6, false, undefined, undefined, undefined);

var script$b7 = Vue.extend({
  name: "PhShieldChevron",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$b7 = script$b7;
/* template */

var __vue_render__$b7 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,114.66667V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.66667c0,84.01533-71.306,111.85016-85.5438,116.57058a7.54755,7.54755,0,0,1-4.9124,0C111.306,226.51683,40,198.682,40,114.66667Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "202.402 172.082 128 120 53.597 172.082",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M202.40575,172.0837C180.989,212.285,140.7647,227.81955,130.4562,231.23725a7.54755,7.54755,0,0,1-4.9124,0c-10.30857-3.41773-50.53339-18.95246-71.95-59.15443l.00313-.001L128,120l74.40193,52.08167Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,114.66667V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.66667c0,84.01533-71.306,111.85016-85.5438,116.57058a7.54755,7.54755,0,0,1-4.9124,0C111.306,226.51683,40,198.682,40,114.66667Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "202.402 172.082 128 120 53.597 172.082",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M207.99951,40.00012h-160a16.01818,16.01818,0,0,0-16,16v58.66651c0,89.45312,75.82617,119.12451,91.02637,124.16406a15.48361,15.48361,0,0,0,9.94726.00049c15.2002-5.04,91.02637-34.71143,91.02637-124.16455V56.00012A16.01817,16.01817,0,0,0,207.99951,40.00012Zm-160,16h160v58.66651c0,17.68237-3.39453,32.69653-8.79639,45.4104L132.5874,113.44617a8.00131,8.00131,0,0,0-9.17578,0L56.79541,160.077c-5.40137-12.71387-8.7959-27.728-8.7959-45.4104Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,114.66667V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.66667c0,84.01533-71.306,111.85016-85.5438,116.57058a7.54755,7.54755,0,0,1-4.9124,0C111.306,226.51683,40,198.682,40,114.66667Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "202.402 172.082 128 120 53.597 172.082",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,114.66667V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.66667c0,84.01533-71.306,111.85016-85.5438,116.57058a7.54755,7.54755,0,0,1-4.9124,0C111.306,226.51683,40,198.682,40,114.66667Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "202.402 172.082 128 120 53.597 172.082",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,114.66667V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.66667c0,84.01533-71.306,111.85016-85.5438,116.57058a7.54755,7.54755,0,0,1-4.9124,0C111.306,226.51683,40,198.682,40,114.66667Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "202.402 172.082 128 120 53.597 172.082",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$b7 = [];
/* style */

const __vue_inject_styles__$b7 = undefined;
/* scoped */

const __vue_scope_id__$b7 = undefined;
/* module identifier */

const __vue_module_identifier__$b7 = undefined;
/* functional template */

const __vue_is_functional_template__$b7 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$b7 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$b7,
  staticRenderFns: __vue_staticRenderFns__$b7
}, __vue_inject_styles__$b7, __vue_script__$b7, __vue_scope_id__$b7, __vue_is_functional_template__$b7, __vue_module_identifier__$b7, false, undefined, undefined, undefined);

var script$b8 = Vue.extend({
  name: "PhShieldPlus",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$b8 = script$b8;
/* template */

var __vue_render__$b8 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M39.99463,114.66215V55.99548a8,8,0,0,1,8-8h160a8,8,0,0,1,8,8v58.66667c0,84.01533-71.306,111.85016-85.5438,116.57059a7.54755,7.54755,0,0,1-4.9124,0C111.30065,226.51231,39.99463,198.67748,39.99463,114.66215Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "128",
      "x2": "160",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "96",
      "x2": "128",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M39.99463,114.66215V55.99548a8,8,0,0,1,8-8h160a8,8,0,0,1,8,8v58.66667c0,84.01533-71.306,111.85016-85.5438,116.57059a7.54755,7.54755,0,0,1-4.9124,0C111.30065,226.51231,39.99463,198.67748,39.99463,114.66215Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M39.99463,114.66215V55.99548a8,8,0,0,1,8-8h160a8,8,0,0,1,8,8v58.66667c0,84.01533-71.306,111.85016-85.5438,116.57059a7.54755,7.54755,0,0,1-4.9124,0C111.30065,226.51231,39.99463,198.67748,39.99463,114.66215Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "128",
      "x2": "160",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "96",
      "x2": "128",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M207.99463,39.99512h-160a16.018,16.018,0,0,0-16,16v58.667c0,89.458,75.82617,119.125,91.02588,124.16406a15.48947,15.48947,0,0,0,9.94775,0c15.2002-5.03906,91.02637-34.70605,91.02637-124.16406v-58.667A16.018,16.018,0,0,0,207.99463,39.99512ZM160,136H136v24a8,8,0,0,1-16,0V136H96a8,8,0,0,1,0-16h24V96a8,8,0,0,1,16,0v24h24a8,8,0,0,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M39.99463,114.66215V55.99548a8,8,0,0,1,8-8h160a8,8,0,0,1,8,8v58.66667c0,84.01533-71.306,111.85016-85.5438,116.57059a7.54755,7.54755,0,0,1-4.9124,0C111.30065,226.51231,39.99463,198.67748,39.99463,114.66215Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "128",
      "x2": "160",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "96",
      "x2": "128",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M39.99463,114.66215V55.99548a8,8,0,0,1,8-8h160a8,8,0,0,1,8,8v58.66667c0,84.01533-71.306,111.85016-85.5438,116.57059a7.54755,7.54755,0,0,1-4.9124,0C111.30065,226.51231,39.99463,198.67748,39.99463,114.66215Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "128",
      "x2": "160",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "96",
      "x2": "128",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M39.99463,114.66215V55.99548a8,8,0,0,1,8-8h160a8,8,0,0,1,8,8v58.66667c0,84.01533-71.306,111.85016-85.5438,116.57059a7.54755,7.54755,0,0,1-4.9124,0C111.30065,226.51231,39.99463,198.67748,39.99463,114.66215Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "128",
      "x2": "160",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "96",
      "x2": "128",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$b8 = [];
/* style */

const __vue_inject_styles__$b8 = undefined;
/* scoped */

const __vue_scope_id__$b8 = undefined;
/* module identifier */

const __vue_module_identifier__$b8 = undefined;
/* functional template */

const __vue_is_functional_template__$b8 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$b8 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$b8,
  staticRenderFns: __vue_staticRenderFns__$b8
}, __vue_inject_styles__$b8, __vue_script__$b8, __vue_scope_id__$b8, __vue_is_functional_template__$b8, __vue_module_identifier__$b8, false, undefined, undefined, undefined);

var script$b9 = Vue.extend({
  name: "PhShieldSlash",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$b9 = script$b9;
/* template */

var __vue_render__$b9 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "33.5",
      "y1": "24",
      "x2": "222.5",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M187.53527,193.51968c-21.56883,24.54405-48.85178,34.98988-57.07907,37.71757a7.54755,7.54755,0,0,1-4.9124,0C111.306,226.51683,40,198.682,40,114.66667V56a8,8,0,0,1,8-8h7.30776",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M109.353,48H208a8,8,0,0,1,8,8v58.66667a125.41227,125.41227,0,0,1-7.13369,42.8506",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M39.99951,114.66667V56a8,8,0,0,1,8-8h160a8,8,0,0,1,8,8v58.66667c0,84.01533-71.306,111.85016-85.5438,116.57058a7.54755,7.54755,0,0,1-4.9124,0C111.30553,226.51683,39.99951,198.682,39.99951,114.66667Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "33.5",
      "y1": "24",
      "x2": "222.5",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M187.53527,193.51968c-21.56883,24.54405-48.85178,34.98988-57.07907,37.71757a7.54755,7.54755,0,0,1-4.9124,0C111.306,226.51683,40,198.682,40,114.66667V56a8,8,0,0,1,8-8h7.30776",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M98.54466,48H208a8,8,0,0,1,8,8v58.66667c0,20.0838-4.07475,36.95719-10.47061,51.07187",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M227.87939,237.9209a8,8,0,0,1-11.30078-.541L187.4165,205.28613a147.318,147.318,0,0,1-54.44238,33.54492,15.49078,15.49078,0,0,1-9.94824,0c-15.2002-5.04-91.02637-34.71289-91.02637-124.16406V56a15.98851,15.98851,0,0,1,7.48242-13.52026L27.57861,29.37988a8,8,0,0,1,11.8418-10.75976l21.7998,23.99121.00879.00879L193.45654,188.13965l.01563.019,34.94824,38.46143A7.9992,7.9992,0,0,1,227.87939,237.9209Zm-28.2705-66.80274a8.00083,8.00083,0,0,0,13.208-2.07812c7.41993-16.376,11.18262-34.66992,11.18262-54.37305V56a16.01833,16.01833,0,0,0-16-16H98.54443a8.00019,8.00019,0,0,0-5.92089,13.37988Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "33.5",
      "y1": "24",
      "x2": "222.5",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M187.53527,193.51968c-21.56883,24.54405-48.85178,34.98988-57.07907,37.71757a7.54755,7.54755,0,0,1-4.9124,0C111.306,226.51683,40,198.682,40,114.66667V56a8,8,0,0,1,8-8h7.30776",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M98.54466,48H208a8,8,0,0,1,8,8v58.66667c0,20.0838-4.07475,36.95719-10.47061,51.07187",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "33.5",
      "y1": "24",
      "x2": "222.5",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M187.53527,193.51968c-21.56883,24.54405-48.85178,34.98988-57.07907,37.71757a7.54755,7.54755,0,0,1-4.9124,0C111.306,226.51683,40,198.682,40,114.66667V56a8,8,0,0,1,8-8h7.30776",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M98.54466,48H208a8,8,0,0,1,8,8v58.66667c0,20.0838-4.07475,36.95719-10.47061,51.07187",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "33.5",
      "y1": "24",
      "x2": "222.5",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M187.53527,193.51968c-21.56883,24.54405-48.85178,34.98988-57.07907,37.71757a7.54755,7.54755,0,0,1-4.9124,0C111.306,226.51683,40,198.682,40,114.66667V56a8,8,0,0,1,8-8h7.30776",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M98.54466,48H208a8,8,0,0,1,8,8v58.66667c0,20.0838-4.07475,36.95719-10.47061,51.07187",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$b9 = [];
/* style */

const __vue_inject_styles__$b9 = undefined;
/* scoped */

const __vue_scope_id__$b9 = undefined;
/* module identifier */

const __vue_module_identifier__$b9 = undefined;
/* functional template */

const __vue_is_functional_template__$b9 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$b9 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$b9,
  staticRenderFns: __vue_staticRenderFns__$b9
}, __vue_inject_styles__$b9, __vue_script__$b9, __vue_scope_id__$b9, __vue_is_functional_template__$b9, __vue_module_identifier__$b9, false, undefined, undefined, undefined);

var script$ba = Vue.extend({
  name: "PhShieldWarning",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$ba = script$ba;
/* template */

var __vue_render__$ba = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M39.99951,114.66667V56a8,8,0,0,1,8-8h160a8,8,0,0,1,8,8v58.66667c0,84.01533-71.306,111.85016-85.5438,116.57058a7.54755,7.54755,0,0,1-4.9124,0C111.30553,226.51683,39.99951,198.682,39.99951,114.66667Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "127.99951",
      "y1": "92",
      "x2": "127.99951",
      "y2": "132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "172",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M39.99951,114.66667V56a8,8,0,0,1,8-8h160a8,8,0,0,1,8,8v58.66667c0,84.01533-71.306,111.85016-85.5438,116.57058a7.54755,7.54755,0,0,1-4.9124,0C111.30553,226.51683,39.99951,198.682,39.99951,114.66667Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M39.99951,114.66667V56a8,8,0,0,1,8-8h160a8,8,0,0,1,8,8v58.66667c0,84.01533-71.306,111.85016-85.5438,116.57058a7.54755,7.54755,0,0,1-4.9124,0C111.30553,226.51683,39.99951,198.682,39.99951,114.66667Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "127.99951",
      "y1": "96",
      "x2": "127.99951",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "172",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M207.99951,40h-160a16.01833,16.01833,0,0,0-16,16v58.667c0,89.45313,75.82617,119.124,91.02637,124.16406a15.48781,15.48781,0,0,0,9.94726,0c15.2002-5.04,91.02637-34.71093,91.02637-124.16406V56A16.01833,16.01833,0,0,0,207.99951,40Zm-88,56a8,8,0,1,1,16,0v40a8,8,0,0,1-16,0Zm8,88a12,12,0,1,1,12-12A12,12,0,0,1,127.99951,184Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M39.99951,114.66667V56a8,8,0,0,1,8-8h160a8,8,0,0,1,8,8v58.66667c0,84.01533-71.306,111.85016-85.5438,116.57058a7.54755,7.54755,0,0,1-4.9124,0C111.30553,226.51683,39.99951,198.682,39.99951,114.66667Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "127.99951",
      "y1": "96",
      "x2": "127.99951",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "172",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M39.99951,114.66667V56a8,8,0,0,1,8-8h160a8,8,0,0,1,8,8v58.66667c0,84.01533-71.306,111.85016-85.5438,116.57058a7.54755,7.54755,0,0,1-4.9124,0C111.30553,226.51683,39.99951,198.682,39.99951,114.66667Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "127.99951",
      "y1": "96",
      "x2": "127.99951",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "172",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,114.66667V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.66667c0,84.01533-71.306,111.85016-85.5438,116.57058a7.54755,7.54755,0,0,1-4.9124,0C111.306,226.51683,40,198.682,40,114.66667Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "96",
      "x2": "128",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "172",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$ba = [];
/* style */

const __vue_inject_styles__$ba = undefined;
/* scoped */

const __vue_scope_id__$ba = undefined;
/* module identifier */

const __vue_module_identifier__$ba = undefined;
/* functional template */

const __vue_is_functional_template__$ba = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$ba = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$ba,
  staticRenderFns: __vue_staticRenderFns__$ba
}, __vue_inject_styles__$ba, __vue_script__$ba, __vue_scope_id__$ba, __vue_is_functional_template__$ba, __vue_module_identifier__$ba, false, undefined, undefined, undefined);

var script$bb = Vue.extend({
  name: "PhShoppingBag",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bb = script$bb;
/* template */

var __vue_render__$bb = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,88a40,40,0,0,1-80,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,88a40,40,0,0,1-80,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,40H40A16.01833,16.01833,0,0,0,24,56V200a16.01833,16.01833,0,0,0,16,16H216a16.01833,16.01833,0,0,0,16-16V56A16.01833,16.01833,0,0,0,216,40Zm-88,96A48.054,48.054,0,0,1,80,88a8,8,0,0,1,16,0,32,32,0,0,0,64,0,8,8,0,0,1,16,0A48.054,48.054,0,0,1,128,136Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,88a40,40,0,0,1-80,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,88a40,40,0,0,1-80,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,88a40,40,0,0,1-80,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bb = [];
/* style */

const __vue_inject_styles__$bb = undefined;
/* scoped */

const __vue_scope_id__$bb = undefined;
/* module identifier */

const __vue_module_identifier__$bb = undefined;
/* functional template */

const __vue_is_functional_template__$bb = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bb = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bb,
  staticRenderFns: __vue_staticRenderFns__$bb
}, __vue_inject_styles__$bb, __vue_script__$bb, __vue_scope_id__$bb, __vue_is_functional_template__$bb, __vue_module_identifier__$bb, false, undefined, undefined, undefined);

var script$bc = Vue.extend({
  name: "PhShoppingBagOpen",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bc = script$bc;
/* template */

var __vue_render__$bc = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "88",
      "x2": "224",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,124a40,40,0,0,1-80,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,80H224V56a8,8,0,0,0-8-8H40a8,8,0,0,0-8,8Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "80",
      "x2": "224",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,112a40,40,0,0,1-80,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,40H40A16.01833,16.01833,0,0,0,24,56V200a16.01833,16.01833,0,0,0,16,16H216a16.01833,16.01833,0,0,0,16-16V56A16.01833,16.01833,0,0,0,216,40ZM128,160a48.054,48.054,0,0,1-48-48,8,8,0,0,1,16,0,32,32,0,0,0,64,0,8,8,0,0,1,16,0A48.054,48.054,0,0,1,128,160ZM40,72V56H216l.001,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "80",
      "x2": "224",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,112a40,40,0,0,1-80,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "80",
      "x2": "224",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,112a40,40,0,0,1-80,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "80",
      "x2": "224",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,112a40,40,0,0,1-80,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bc = [];
/* style */

const __vue_inject_styles__$bc = undefined;
/* scoped */

const __vue_scope_id__$bc = undefined;
/* module identifier */

const __vue_module_identifier__$bc = undefined;
/* functional template */

const __vue_is_functional_template__$bc = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bc = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bc,
  staticRenderFns: __vue_staticRenderFns__$bc
}, __vue_inject_styles__$bc, __vue_script__$bc, __vue_scope_id__$bc, __vue_is_functional_template__$bc, __vue_module_identifier__$bc, false, undefined, undefined, undefined);

var script$bd = Vue.extend({
  name: "PhShoppingCart",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bd = script$bd;
/* template */

var __vue_render__$bd = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M184,184H69.81818L41.92162,30.56892A8,8,0,0,0,34.05066,24H16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "80",
      "cy": "204",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "184",
      "cy": "204",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M62.54543,144H188.10132a16,16,0,0,0,15.74192-13.13783L216,64H48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M62.54543,144H188.10132a16,16,0,0,0,15.74192-13.13783L216,64H48Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,184H69.81818L41.92162,30.56892A8,8,0,0,0,34.05066,24H16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "80",
      "cy": "204",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "184",
      "cy": "204",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M62.54543,144H188.10132a16,16,0,0,0,15.74192-13.13783L216,64H48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M223.87109,65.43115l-12.15722,66.86231A23.98711,23.98711,0,0,1,188.10156,152H72.13135l4.36377,24H184a24.01161,24.01161,0,1,1-22.624,16H102.624a24.00309,24.00309,0,1,1-40.85986-7.57666L34.05078,32H16a8,8,0,0,1,0-16H34.05078A15.9918,15.9918,0,0,1,49.793,29.13818L54.67676,56H216a8.00076,8.00076,0,0,1,7.87109,9.43115Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M184,184H69.81818L41.92162,30.56892A8,8,0,0,0,34.05066,24H16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "80",
      "cy": "204",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "184",
      "cy": "204",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M62.54543,144H188.10132a16,16,0,0,0,15.74192-13.13783L216,64H48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M184,184H69.81818L41.92162,30.56892A8,8,0,0,0,34.05066,24H16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "80",
      "cy": "204",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "184",
      "cy": "204",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M62.54543,144H188.10132a16,16,0,0,0,15.74192-13.13783L216,64H48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M184,184H69.81818L41.92162,30.56892A8,8,0,0,0,34.05066,24H16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "80",
      "cy": "204",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "184",
      "cy": "204",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M62.54543,144H188.10132a16,16,0,0,0,15.74192-13.13783L216,64H48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bd = [];
/* style */

const __vue_inject_styles__$bd = undefined;
/* scoped */

const __vue_scope_id__$bd = undefined;
/* module identifier */

const __vue_module_identifier__$bd = undefined;
/* functional template */

const __vue_is_functional_template__$bd = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bd = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bd,
  staticRenderFns: __vue_staticRenderFns__$bd
}, __vue_inject_styles__$bd, __vue_script__$bd, __vue_scope_id__$bd, __vue_is_functional_template__$bd, __vue_module_identifier__$bd, false, undefined, undefined, undefined);

var script$be = Vue.extend({
  name: "PhShoppingCartSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$be = script$be;
/* template */

var __vue_render__$be = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "80",
      "cy": "216",
      "r": "20"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "184",
      "cy": "216",
      "r": "20"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M42.28575,72H221.71429l-24.113,84.39554A16,16,0,0,1,182.21689,168H81.78311a16,16,0,0,1-15.38439-11.60446L32.51492,37.80223A8,8,0,0,0,24.82273,32H12",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M42.28575,72H221.71429l-26.39873,92.39554A16,16,0,0,1,179.93118,176H84.06882a16,16,0,0,1-15.38438-11.60446Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "80",
      "cy": "216",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "184",
      "cy": "216",
      "r": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M42.28575,72H221.71429l-26.39873,92.39554A16,16,0,0,1,179.93118,176H84.06882a16,16,0,0,1-15.38438-11.60446L32.51492,37.80223A8,8,0,0,0,24.82273,32H8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M96,216a16,16,0,1,1-16-16A16.00016,16.00016,0,0,1,96,216Zm88-16a16,16,0,1,0,16,16A16.00016,16.00016,0,0,0,184,200ZM228.10059,67.18262A7.99866,7.99866,0,0,0,221.71387,64H48.32031L40.207,35.604A16.06984,16.06984,0,0,0,24.82227,24H8A8,8,0,0,0,8,40H24.82227l9.73046,34.05469c.02637.09863.05372.19677.084.29443l26.35547,92.24365A24.10087,24.10087,0,0,0,84.06836,184h95.86328a24.101,24.101,0,0,0,23.07617-17.40674l26.39844-92.39551A8.00023,8.00023,0,0,0,228.10059,67.18262Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "80",
      "cy": "216",
      "r": "14"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "184",
      "cy": "216",
      "r": "14"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M42.28575,72H221.71429l-26.39873,92.39554A16,16,0,0,1,179.93118,176H84.06882a16,16,0,0,1-15.38438-11.60446L32.51492,37.80223A8,8,0,0,0,24.82273,32H8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "80",
      "cy": "216",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "184",
      "cy": "216",
      "r": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M42.28575,72H221.71429l-26.39873,92.39554A16,16,0,0,1,179.93118,176H84.06882a16,16,0,0,1-15.38438-11.60446L32.51492,37.80223A8,8,0,0,0,24.82273,32H8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "80",
      "cy": "216",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "184",
      "cy": "216",
      "r": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M42.28575,72H221.71429l-26.39873,92.39554A16,16,0,0,1,179.93118,176H84.06882a16,16,0,0,1-15.38438-11.60446L32.51492,37.80223A8,8,0,0,0,24.82273,32H8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$be = [];
/* style */

const __vue_inject_styles__$be = undefined;
/* scoped */

const __vue_scope_id__$be = undefined;
/* module identifier */

const __vue_module_identifier__$be = undefined;
/* functional template */

const __vue_is_functional_template__$be = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$be = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$be,
  staticRenderFns: __vue_staticRenderFns__$be
}, __vue_inject_styles__$be, __vue_script__$be, __vue_scope_id__$be, __vue_is_functional_template__$be, __vue_module_identifier__$be, false, undefined, undefined, undefined);

var script$bf = Vue.extend({
  name: "PhShower",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bf = script$bf;
/* template */

var __vue_render__$bf = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "60",
      "cy": "228",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "196",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "28",
      "cy": "196",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "60",
      "cy": "164",
      "r": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M244,40H219.31371a8,8,0,0,0-5.65686,2.34315L184,72,64.39532,86.07114A8,8,0,0,0,59.6732,99.6732l96.6536,96.6536a8,8,0,0,0,13.60206-4.72212L184,72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M184,72,55.334,93.44433a8,8,0,0,0-4.34166,13.548l98.01532,98.01532a8,8,0,0,0,13.548-4.34166Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "60",
      "cy": "228",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "88",
      "cy": "200",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "28",
      "cy": "196",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "56",
      "cy": "168",
      "r": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M248,40H219.31371a8,8,0,0,0-5.65686,2.34315L184,72,55.334,93.44433a8,8,0,0,0-4.34166,13.548l98.01532,98.01532a8,8,0,0,0,13.548-4.34166L184,72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M72,228a12,12,0,1,1-12-12A12,12,0,0,1,72,228Zm16-40a12,12,0,1,0,12,12A12,12,0,0,0,88,188Zm-60-4a12,12,0,1,0,12,12A12,12,0,0,0,28,184Zm40-16a12,12,0,1,0-12,12A12,12,0,0,0,68,168ZM248,32H219.31348A15.89354,15.89354,0,0,0,208,36.68652L180.15576,64.53027,54.01855,85.55322a16.00028,16.00028,0,0,0-8.6831,27.09619l98.01514,98.01465a15.99969,15.99969,0,0,0,27.09619-8.68261l21.023-126.13721v-.00049L219.31348,48H248a8,8,0,0,0,0-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "60",
      "cy": "228",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "88",
      "cy": "200",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "28",
      "cy": "196",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "56",
      "cy": "168",
      "r": "10"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M248,40H219.31371a8,8,0,0,0-5.65686,2.34315L184,72,55.334,93.44433a8,8,0,0,0-4.34166,13.548l98.01532,98.01532a8,8,0,0,0,13.548-4.34166L184,72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "60",
      "cy": "228",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "88",
      "cy": "200",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "28",
      "cy": "196",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "56",
      "cy": "168",
      "r": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M248,40H219.31371a8,8,0,0,0-5.65686,2.34315L184,72,55.334,93.44433a8,8,0,0,0-4.34166,13.548l98.01532,98.01532a8,8,0,0,0,13.548-4.34166L184,72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "60",
      "cy": "228",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "88",
      "cy": "200",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "28",
      "cy": "196",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "56",
      "cy": "168",
      "r": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M248,40H219.31371a8,8,0,0,0-5.65686,2.34315L184,72,55.334,93.44433a8,8,0,0,0-4.34166,13.548l98.01532,98.01532a8,8,0,0,0,13.548-4.34166L184,72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bf = [];
/* style */

const __vue_inject_styles__$bf = undefined;
/* scoped */

const __vue_scope_id__$bf = undefined;
/* module identifier */

const __vue_module_identifier__$bf = undefined;
/* functional template */

const __vue_is_functional_template__$bf = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bf = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bf,
  staticRenderFns: __vue_staticRenderFns__$bf
}, __vue_inject_styles__$bf, __vue_script__$bf, __vue_scope_id__$bf, __vue_is_functional_template__$bf, __vue_module_identifier__$bf, false, undefined, undefined, undefined);

var script$bg = Vue.extend({
  name: "PhShuffle",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bg = script$bg;
/* template */

var __vue_render__$bg = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,72H55.06445a64,64,0,0,1,52.079,26.80076l41.7132,58.39848A64,64,0,0,0,200.93555,184H232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 48 232 72 208 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 160 232 184 208 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152.76794,93.858A64.00219,64.00219,0,0,1,200.93555,72H232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,184H55.06445a64.00212,64.00212,0,0,0,48.16769-21.85814",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,72H55.06445a64,64,0,0,1,52.079,26.80076l41.7132,58.39848A64,64,0,0,0,200.93555,184H232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 48 232 72 208 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 160 232 184 208 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M147.66275,100.47214l1.19385-1.67138A64,64,0,0,1,200.93555,72H232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,184H55.06445a64,64,0,0,0,52.079-26.80076l1.19384-1.67138",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M237.65723,178.34277a8.00122,8.00122,0,0,1,0,11.31446l-24,24A8.00066,8.00066,0,0,1,200,208V191.98584a72.13911,72.13911,0,0,1-57.65332-30.13721L100.63379,103.4502A56.11029,56.11029,0,0,0,55.06445,80H32a8,8,0,0,1,0-16H55.06445a72.14126,72.14126,0,0,1,58.58887,30.15137l41.71289,58.39843A56.0996,56.0996,0,0,0,200,175.97168V160a8.00065,8.00065,0,0,1,13.65723-5.65723Zm-94.64356-71.36132a7.99621,7.99621,0,0,0,11.15918-1.86036l1.19336-1.67089A56.0996,56.0996,0,0,1,200,80.02832V96a8.00053,8.00053,0,0,0,13.65723,5.65723l24-24a8.00122,8.00122,0,0,0,0-11.31446l-24-24A8.00065,8.00065,0,0,0,200,48V64.01416a72.13911,72.13911,0,0,0-57.65332,30.13721l-1.19336,1.6709A7.9986,7.9986,0,0,0,143.01367,106.98145Zm-30.02734,42.0371a7.99642,7.99642,0,0,0-11.15918,1.86036l-1.19336,1.67089A56.11029,56.11029,0,0,1,55.06445,176H32a8,8,0,0,0,0,16H55.06445a72.14126,72.14126,0,0,0,58.58887-30.15137l1.19336-1.6709A7.9986,7.9986,0,0,0,112.98633,149.01855Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,72H55.06445a64,64,0,0,1,52.079,26.80076l41.7132,58.39848A64,64,0,0,0,200.93555,184H232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 48 232 72 208 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 160 232 184 208 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M147.66275,100.47214l1.19385-1.67138A64,64,0,0,1,200.93555,72H232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,184H55.06445a64,64,0,0,0,52.079-26.80076l1.19384-1.67138",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,72H55.06445a64,64,0,0,1,52.079,26.80076l41.7132,58.39848A64,64,0,0,0,200.93555,184H232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 48 232 72 208 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 160 232 184 208 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M147.66275,100.47214l1.19385-1.67138A64,64,0,0,1,200.93555,72H232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,184H55.06445a64,64,0,0,0,52.079-26.80076l1.19384-1.67138",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,72H55.06445a64,64,0,0,1,52.079,26.80076l41.7132,58.39848A64,64,0,0,0,200.93555,184H232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 48 232 72 208 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 160 232 184 208 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M147.66275,100.47214l1.19385-1.67138A64,64,0,0,1,200.93555,72H232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,184H55.06445a64,64,0,0,0,52.079-26.80076l1.19384-1.67138",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bg = [];
/* style */

const __vue_inject_styles__$bg = undefined;
/* scoped */

const __vue_scope_id__$bg = undefined;
/* module identifier */

const __vue_module_identifier__$bg = undefined;
/* functional template */

const __vue_is_functional_template__$bg = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bg = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bg,
  staticRenderFns: __vue_staticRenderFns__$bg
}, __vue_inject_styles__$bg, __vue_script__$bg, __vue_scope_id__$bg, __vue_is_functional_template__$bg, __vue_module_identifier__$bg, false, undefined, undefined, undefined);

var script$bh = Vue.extend({
  name: "PhShuffleAngular",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bh = script$bh;
/* template */

var __vue_render__$bh = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,72H83.88306a8,8,0,0,1,6.50986,3.35009l75.21416,105.29982A8,8,0,0,0,172.11694,184H232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 48 232 72 208 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 160 232 184 208 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,184H83.88306a8,8,0,0,0,6.50986-3.35009l13.02884-18.24038",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152.57823,93.59048l13.02885-18.24039A8,8,0,0,1,172.11694,72H232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,72H83.88306a8,8,0,0,1,6.50986,3.35009l75.21416,105.29982A8,8,0,0,0,172.11694,184H232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 48 232 72 208 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 160 232 184 208 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M147.66242,100.47261l17.94466-25.12252A8,8,0,0,1,172.11694,72H232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,184H83.88306a8,8,0,0,0,6.50986-3.35009l17.94466-25.12252",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M237.65723,178.34277a8.00122,8.00122,0,0,1,0,11.31446l-24,24A8.00066,8.00066,0,0,1,200,208V192H172.11719a16.03,16.03,0,0,1-13.01953-6.7002L83.88281,79.999,32,80a8,8,0,0,1,0-16H83.88281a16.03,16.03,0,0,1,13.01953,6.7002L172.11719,176.001,200,176.00049V160a8.00065,8.00065,0,0,1,13.65723-5.65723Zm-94.64551-71.36035a7.99822,7.99822,0,0,0,11.16015-1.85937L172.11719,80H200V96a8.00053,8.00053,0,0,0,13.65723,5.65723l24-24a8.00122,8.00122,0,0,0,0-11.31446l-24-24A8.00065,8.00065,0,0,0,200,48V64H172.11719a16.03166,16.03166,0,0,0-13.01953,6.69922L141.15234,95.82227A8.00057,8.00057,0,0,0,143.01172,106.98242Zm-30.02344,42.03516a7.99913,7.99913,0,0,0-11.16016,1.85937L83.88281,176H32a8,8,0,0,0,0,16H83.88281a16.03166,16.03166,0,0,0,13.01953-6.69922l17.94532-25.12305A8.00057,8.00057,0,0,0,112.98828,149.01758Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,72H83.88306a8,8,0,0,1,6.50986,3.35009l75.21416,105.29982A8,8,0,0,0,172.11694,184H232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 48 232 72 208 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 160 232 184 208 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M147.66242,100.47261l17.94466-25.12252A8,8,0,0,1,172.11694,72H232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,184H83.88306a8,8,0,0,0,6.50986-3.35009l17.94466-25.12252",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,72H83.88306a8,8,0,0,1,6.50986,3.35009l75.21416,105.29982A8,8,0,0,0,172.11694,184H232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 48 232 72 208 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 160 232 184 208 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M147.66242,100.47261l17.94466-25.12252A8,8,0,0,1,172.11694,72H232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,184H83.88306a8,8,0,0,0,6.50986-3.35009l17.94466-25.12252",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,72H83.88306a8,8,0,0,1,6.50986,3.35009l75.21416,105.29982A8,8,0,0,0,172.11694,184H232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 48 232 72 208 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 160 232 184 208 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M147.66242,100.47261l17.94466-25.12252A8,8,0,0,1,172.11694,72H232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,184H83.88306a8,8,0,0,0,6.50986-3.35009l17.94466-25.12252",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bh = [];
/* style */

const __vue_inject_styles__$bh = undefined;
/* scoped */

const __vue_scope_id__$bh = undefined;
/* module identifier */

const __vue_module_identifier__$bh = undefined;
/* functional template */

const __vue_is_functional_template__$bh = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bh = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bh,
  staticRenderFns: __vue_staticRenderFns__$bh
}, __vue_inject_styles__$bh, __vue_script__$bh, __vue_scope_id__$bh, __vue_is_functional_template__$bh, __vue_module_identifier__$bh, false, undefined, undefined, undefined);

var script$bi = Vue.extend({
  name: "PhShuffleSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bi = script$bi;
/* template */

var __vue_render__$bi = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "168 48 208 48 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 168 208 208 168 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "48",
      "x2": "208",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156.28419",
      "y1": "99.71581",
      "x2": "208",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "208",
      "x2": "99.7158",
      "y2": "156.2842",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "168 48 208 48 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 168 208 208 168 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "48",
      "x2": "208",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "150.62718",
      "y1": "105.37282",
      "x2": "208",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "208",
      "x2": "105.37282",
      "y2": "150.62718",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,48V88a8.00018,8.00018,0,0,1-13.65723,5.65674L188,79.314l-31.71582,31.71583a8.00035,8.00035,0,0,1-11.31445-11.314L176.68579,68l-14.343-14.34326A8.00038,8.00038,0,0,1,168,40h40A8.00008,8.00008,0,0,1,216,48Zm-4.93848,112.60889a8.00113,8.00113,0,0,0-8.71875,1.73437L188,176.686,53.65723,42.34326A8.00018,8.00018,0,1,0,42.34277,53.65674L176.686,188l-14.34327,14.34326A8.00038,8.00038,0,0,0,168,216h40a8.00008,8.00008,0,0,0,8-8V168A8.00015,8.00015,0,0,0,211.06152,160.60889ZM99.71582,144.97021l-57.373,57.373a8.00018,8.00018,0,0,0,11.31446,11.31348l57.373-57.37256a8.00035,8.00035,0,0,0-11.31445-11.314Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "168 48 208 48 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 168 208 208 168 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "48",
      "x2": "208",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "150.62718",
      "y1": "105.37282",
      "x2": "208",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "208",
      "x2": "105.37282",
      "y2": "150.62718",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "168 48 208 48 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 168 208 208 168 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "48",
      "x2": "208",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "150.62718",
      "y1": "105.37282",
      "x2": "208",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "208",
      "x2": "105.37282",
      "y2": "150.62718",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "168 48 208 48 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 168 208 208 168 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "48",
      "x2": "208",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "150.62718",
      "y1": "105.37282",
      "x2": "208",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "208",
      "x2": "105.37282",
      "y2": "150.62718",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bi = [];
/* style */

const __vue_inject_styles__$bi = undefined;
/* scoped */

const __vue_scope_id__$bi = undefined;
/* module identifier */

const __vue_module_identifier__$bi = undefined;
/* functional template */

const __vue_is_functional_template__$bi = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bi = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bi,
  staticRenderFns: __vue_staticRenderFns__$bi
}, __vue_inject_styles__$bi, __vue_script__$bi, __vue_scope_id__$bi, __vue_is_functional_template__$bi, __vue_module_identifier__$bi, false, undefined, undefined, undefined);

var script$bj = Vue.extend({
  name: "PhSignIn",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bj = script$bj;
/* template */

var __vue_render__$bj = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "94.011 170 136 128 94.011 86",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "128",
      "x2": "135.97057",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M136,40h56a8,8,0,0,1,8,8V208a8,8,0,0,1-8,8H136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "94.011 170 136 128 94.011 86",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "128",
      "x2": "135.97057",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M136,40h56a8,8,0,0,1,8,8V208a8,8,0,0,1-8,8H136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M141.65723,133.65625l-41.98828,42A8.00033,8.00033,0,0,1,86.01074,170V136H24a8,8,0,0,1,0-16H86.01074V86A8.00033,8.00033,0,0,1,99.669,80.34375l41.98828,42A7.99974,7.99974,0,0,1,141.65723,133.65625ZM192,32H136a8,8,0,0,0,0,16h56V208H136a8,8,0,0,0,0,16h56a16.01833,16.01833,0,0,0,16-16V48A16.01833,16.01833,0,0,0,192,32Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "94.011 170 136 128 94.011 86",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "128",
      "x2": "135.97057",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M136,40h56a8,8,0,0,1,8,8V208a8,8,0,0,1-8,8H136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "94.011 170 136 128 94.011 86",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "128",
      "x2": "135.97057",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M136,40h56a8,8,0,0,1,8,8V208a8,8,0,0,1-8,8H136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "94.011 170 136 128 94.011 86",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "128",
      "x2": "135.97057",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M136,40h56a8,8,0,0,1,8,8V208a8,8,0,0,1-8,8H136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bj = [];
/* style */

const __vue_inject_styles__$bj = undefined;
/* scoped */

const __vue_scope_id__$bj = undefined;
/* module identifier */

const __vue_module_identifier__$bj = undefined;
/* functional template */

const __vue_is_functional_template__$bj = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bj = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bj,
  staticRenderFns: __vue_staticRenderFns__$bj
}, __vue_inject_styles__$bj, __vue_script__$bj, __vue_scope_id__$bj, __vue_is_functional_template__$bj, __vue_module_identifier__$bj, false, undefined, undefined, undefined);

var script$bk = Vue.extend({
  name: "PhSignOut",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bk = script$bk;
/* template */

var __vue_render__$bk = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "174.011 86 216 128 174.011 170",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "128",
      "x2": "215.97057",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,216H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8h56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "174.011 86 216 128 174.011 170",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "128",
      "x2": "215.97057",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,216H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8h56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M221.65723,133.65625l-41.98828,42A8.00033,8.00033,0,0,1,166.01074,170V136H104a8,8,0,0,1,0-16h62.01074V86A8.00033,8.00033,0,0,1,179.669,80.34375l41.98828,42A7.99974,7.99974,0,0,1,221.65723,133.65625ZM104,208H48V48h56a8,8,0,0,0,0-16H48A16.01833,16.01833,0,0,0,32,48V208a16.01833,16.01833,0,0,0,16,16h56a8,8,0,0,0,0-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "174.011 86 216 128 174.011 170",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "128",
      "x2": "215.97057",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,216H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8h56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "174.011 86 216 128 174.011 170",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "128",
      "x2": "215.97057",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,216H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8h56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "174.011 86 216 128 174.011 170",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "128",
      "x2": "215.97057",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,216H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8h56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bk = [];
/* style */

const __vue_inject_styles__$bk = undefined;
/* scoped */

const __vue_scope_id__$bk = undefined;
/* module identifier */

const __vue_module_identifier__$bk = undefined;
/* functional template */

const __vue_is_functional_template__$bk = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bk = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bk,
  staticRenderFns: __vue_staticRenderFns__$bk
}, __vue_inject_styles__$bk, __vue_script__$bk, __vue_scope_id__$bk, __vue_is_functional_template__$bk, __vue_module_identifier__$bk, false, undefined, undefined, undefined);

var script$bl = Vue.extend({
  name: "PhSimCard",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bl = script$bl;
/* template */

var __vue_render__$bl = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,224.00005H55.99219a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8L152,32l56,56v128A8,8,0,0,1,200,224.00005Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "88",
      "y": "124",
      "width": "80",
      "height": "64",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "164",
      "x2": "128",
      "y2": "188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "80",
      "y": "120",
      "width": "96",
      "height": "72",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,224.00005H55.99219a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8L152,32l56,56v128A8,8,0,0,1,200,224.00005Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "80",
      "y": "120",
      "width": "96",
      "height": "72",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "152",
      "x2": "112",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "152",
      "x2": "144",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M213.65723,82.34277l-56-56A8.00235,8.00235,0,0,0,152,24H55.99219a16.01833,16.01833,0,0,0-16,16V216a16.01833,16.01833,0,0,0,16,16H200a16.01833,16.01833,0,0,0,16-16V88A8.00235,8.00235,0,0,0,213.65723,82.34277ZM200,216H55.99219V40h92.69433L200,91.314l.00977,124.68555Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,112H80a8.00039,8.00039,0,0,0-8,8v72a8.00039,8.00039,0,0,0,8,8h96a8.00039,8.00039,0,0,0,8-8V120A8.00039,8.00039,0,0,0,176,112Zm-56,64a8,8,0,0,1-16,0V136a8,8,0,0,1,16,0Zm32,0a8,8,0,0,1-16,0V136a8,8,0,0,1,16,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,224.00005H55.99219a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8L152,32l56,56v128A8,8,0,0,1,200,224.00005Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "80",
      "y": "120",
      "width": "96",
      "height": "72",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "152",
      "x2": "112",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "152",
      "x2": "144",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,224.00005H55.99219a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8L152,32l56,56v128A8,8,0,0,1,200,224.00005Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "80",
      "y": "120",
      "width": "96",
      "height": "72",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "152",
      "x2": "112",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "152",
      "x2": "144",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,224.00005H55.99219a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8L152,32l56,56v128A8,8,0,0,1,200,224.00005Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "80",
      "y": "120",
      "width": "96",
      "height": "72",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "152",
      "x2": "112",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "152",
      "x2": "144",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bl = [];
/* style */

const __vue_inject_styles__$bl = undefined;
/* scoped */

const __vue_scope_id__$bl = undefined;
/* module identifier */

const __vue_module_identifier__$bl = undefined;
/* functional template */

const __vue_is_functional_template__$bl = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bl = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bl,
  staticRenderFns: __vue_staticRenderFns__$bl
}, __vue_inject_styles__$bl, __vue_script__$bl, __vue_scope_id__$bl, __vue_is_functional_template__$bl, __vue_module_identifier__$bl, false, undefined, undefined, undefined);

var script$bm = Vue.extend({
  name: "PhSketchLogo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bm = script$bm;
/* template */

var __vue_render__$bm = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "72 40 184 40 240 104 128 224 16 104 72 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "177.091 104 128 224 78.909 104 128 40 177.091 104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "104",
      "x2": "240",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "184 40 128 40 78.909 104 128 224 240 104 184 40",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "72 40 184 40 240 104 128 224 16 104 72 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "177.091 104 128 224 78.909 104 128 40 177.091 104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "104",
      "x2": "240",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', {
    attrs: {
      "id": "Raw"
    }
  }, [_c('path', {
    attrs: {
      "d": "M247.98926,103.783c-.00488-.16467-.01074-.3291-.02539-.49317-.00977-.11059-.02442-.21948-.03907-.32873-.01806-.14075-.03808-.28088-.064-.42053-.022-.11878-.04736-.23584-.07471-.35254-.02978-.12793-.062-.25488-.09814-.38147q-.05054-.17909-.10938-.35437c-.041-.12146-.08545-.24146-.13232-.36133-.04492-.1156-.09131-.23022-.1416-.34314-.05225-.1178-.10987-.23328-.168-.349-.05567-.10986-.11133-.21924-.17139-.32593-.063-.11181-.13183-.22119-.20068-.33056-.0669-.10572-.1333-.21143-.20459-.31385-.07178-.1029-.14942-.20275-.22656-.303-.07911-.10242-.15772-.20472-.24121-.3031-.02491-.02955-.04639-.061-.07178-.09034l-56-64A8.001,8.001,0,0,0,184,32H72a8.001,8.001,0,0,0-6.02051,2.73193l-56,64c-.02539.0293-.04687.06079-.07178.09034-.08349.09838-.1621.20068-.24121.3031-.07714.10022-.15478.20007-.22656.303-.07129.10242-.13769.20813-.20459.31385-.06885.10937-.13769.21875-.20068.33056-.06006.10669-.11572.21607-.17139.32593-.0581.11572-.11572.2312-.168.349-.05029.11292-.09668.22754-.1416.34314-.04687.11987-.09131.23987-.13232.36133q-.05861.17541-.10938.35437c-.03613.12659-.06836.25354-.09814.38147-.02735.1167-.05274.23376-.07471.35254-.02588.13965-.0459.27978-.064.42053-.01465.10925-.0293.21814-.03907.32873-.01465.16407-.02051.3285-.02539.49317-.002.07275-.01074.1438-.01074.217,0,.02014.00293.03955.00293.05957.00146.197.01416.39355.02978.58984.00538.06238.00538.126.01172.18775q.03882.3717.1128.73938c.022.11.05322.21643.07959.32483.03369.13684.06445.27392.10547.40918.03515.11779.07861.23169.11914.347.04345.12293.085.24622.13476.36731.0459.11267.09815.22168.14942.33155.05517.12011.11035.23986.17236.35754.05566.1062.1167.20886.17676.31213.06689.1145.13379.22876.207.34058.06689.10266.13867.20166.21.3009.07617.10535.15234.21033.23389.31275.07959.09961.16308.19519.24707.29089.0542.06177.10253.12683.15869.18726l112,120c.11377.12158.2373.2312.35742.345.05615.0531.1084.10937.1665.16089a7.99282,7.99282,0,0,0,.81006.634c.06348.0437.13037.08154.19531.12329a7.94976,7.94976,0,0,0,.7295.416c.081.041.16113.08325.24414.12146a8.02746,8.02746,0,0,0,.96045.37487c.04736.0149.09716.02417.145.03809a7.97556,7.97556,0,0,0,.89062.20349c.09424.01624.18848.03137.28369.04419a7.12355,7.12355,0,0,0,2.13184,0c.09521-.01282.18945-.028.28369-.04419a7.97556,7.97556,0,0,0,.89062-.20349c.04786-.01392.09766-.02319.145-.03809a8.02746,8.02746,0,0,0,.96045-.37487c.083-.03821.16309-.08045.24414-.12146a7.94976,7.94976,0,0,0,.7295-.416c.06494-.04175.13183-.07959.19531-.12329a7.99282,7.99282,0,0,0,.81006-.634c.0581-.05152.11035-.10779.1665-.16089.12012-.11377.24365-.22339.35742-.345l112-120c.05616-.06031.10449-.12525.15821-.187.08447-.0957.168-.1914.24755-.29113.08155-.10242.15772-.2074.23389-.31275.07129-.09924.14307-.19824.21-.3009.07324-.11182.14014-.22608.207-.34058.06006-.10327.1211-.20593.17676-.31213.062-.11768.11719-.23743.17236-.35754.05127-.10987.10352-.21888.14942-.33155.0498-.12109.09131-.24438.13476-.36731.04053-.11535.084-.22925.11914-.347.041-.13526.07178-.27234.10547-.40918.02637-.1084.05762-.21485.07959-.32483q.074-.3673.1128-.73938c.00634-.06177.00634-.12537.01172-.18775.01562-.19629.02832-.39282.02978-.58984,0-.02.00293-.03943.00293-.05957C248,103.92676,247.99121,103.85571,247.98926,103.783ZM75.62988,48h36.15137L74.96289,96H33.63037ZM34.40967,112h39.1289l30.53418,74.63892Zm117.51758,74.63892L182.46143,112h39.1289ZM181.03711,96,144.21875,48h36.15137l41.99951,48Z"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Flat"
    }
  }, [_c('path', {
    attrs: {
      "d": "M247.98926,103.783c-.00488-.16467-.01074-.3291-.02539-.49317-.00977-.11059-.02442-.21948-.03907-.32873-.01806-.14075-.03808-.28088-.064-.42053-.022-.11878-.04736-.23584-.07471-.35254-.02978-.12793-.062-.25488-.09814-.38147q-.05054-.17909-.10938-.35437c-.041-.12146-.08545-.24146-.13232-.36133-.04492-.1156-.09131-.23022-.1416-.34314-.05225-.1178-.10987-.23328-.168-.349-.05567-.10986-.11133-.21924-.17139-.32593-.063-.11181-.13183-.22119-.20068-.33056-.0669-.10572-.1333-.21143-.20459-.31385-.07178-.1029-.14942-.20275-.22656-.303-.07911-.10242-.15772-.20472-.24121-.3031-.02491-.02955-.04639-.061-.07178-.09034l-56-64A8.001,8.001,0,0,0,184,32H72a8.001,8.001,0,0,0-6.02051,2.73193l-56,64c-.02539.0293-.04687.06079-.07178.09034-.08349.09838-.1621.20068-.24121.3031-.07714.10022-.15478.20007-.22656.303-.07129.10242-.13769.20813-.20459.31385-.06885.10937-.13769.21875-.20068.33056-.06006.10669-.11572.21607-.17139.32593-.0581.11572-.11572.2312-.168.349-.05029.11292-.09668.22754-.1416.34314-.04687.11987-.09131.23987-.13232.36133q-.05861.17541-.10938.35437c-.03613.12659-.06836.25354-.09814.38147-.02735.1167-.05274.23376-.07471.35254-.02588.13965-.0459.27978-.064.42053-.01465.10925-.0293.21814-.03907.32873-.01465.16407-.02051.3285-.02539.49317-.002.07275-.01074.1438-.01074.217,0,.02014.00293.03955.00293.05957.00146.197.01416.39355.02978.58984.00538.06238.00538.126.01172.18775q.03882.3717.1128.73938c.022.11.05322.21643.07959.32483.03369.13684.06445.27392.10547.40918.03515.11779.07861.23169.11914.347.04345.12293.085.24622.13476.36731.0459.11267.09815.22168.14942.33155.05517.12011.11035.23986.17236.35754.05566.1062.1167.20886.17676.31213.06689.1145.13379.22876.207.34058.06689.10266.13867.20166.21.3009.07617.10535.15234.21033.23389.31275.07959.09961.16308.19519.24707.29089.0542.06177.10253.12683.15869.18726l112,120c.11377.12158.2373.2312.35742.345.05615.0531.1084.10937.1665.16089a7.99282,7.99282,0,0,0,.81006.634c.06348.0437.13037.08154.19531.12329a7.94976,7.94976,0,0,0,.7295.416c.081.041.16113.08325.24414.12146a8.02746,8.02746,0,0,0,.96045.37487c.04736.0149.09716.02417.145.03809a7.97556,7.97556,0,0,0,.89062.20349c.09424.01624.18848.03137.28369.04419a7.12355,7.12355,0,0,0,2.13184,0c.09521-.01282.18945-.028.28369-.04419a7.97556,7.97556,0,0,0,.89062-.20349c.04786-.01392.09766-.02319.145-.03809a8.02746,8.02746,0,0,0,.96045-.37487c.083-.03821.16309-.08045.24414-.12146a7.94976,7.94976,0,0,0,.7295-.416c.06494-.04175.13183-.07959.19531-.12329a7.99282,7.99282,0,0,0,.81006-.634c.0581-.05152.11035-.10779.1665-.16089.12012-.11377.24365-.22339.35742-.345l112-120c.05616-.06031.10449-.12525.15821-.187.08447-.0957.168-.1914.24755-.29113.08155-.10242.15772-.2074.23389-.31275.07129-.09924.14307-.19824.21-.3009.07324-.11182.14014-.22608.207-.34058.06006-.10327.1211-.20593.17676-.31213.062-.11768.11719-.23743.17236-.35754.05127-.10987.10352-.21888.14942-.33155.0498-.12109.09131-.24438.13476-.36731.04053-.11535.084-.22925.11914-.347.041-.13526.07178-.27234.10547-.40918.02637-.1084.05762-.21485.07959-.32483q.074-.3673.1128-.73938c.00634-.06177.00634-.12537.01172-.18775.01562-.19629.02832-.39282.02978-.58984,0-.02.00293-.03943.00293-.05957C248,103.92676,247.99121,103.85571,247.98926,103.783ZM75.62988,48h36.15137L74.96289,96H33.63037ZM34.40967,112h39.1289l30.53418,74.63892Zm117.51758,74.63892L182.46143,112h39.1289ZM181.03711,96,144.21875,48h36.15137l41.99951,48Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "72 40 184 40 240 104 128 224 16 104 72 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "177.091 104 128 224 78.909 104 128 40 177.091 104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "104",
      "x2": "240",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "72 40 184 40 240 104 128 224 16 104 72 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "177.091 104 128 224 78.909 104 128 40 177.091 104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "104",
      "x2": "240",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "72 40 184 40 240 104 128 224 16 104 72 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "177.091 104 128 224 78.909 104 128 40 177.091 104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "104",
      "x2": "240",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bm = [];
/* style */

const __vue_inject_styles__$bm = undefined;
/* scoped */

const __vue_scope_id__$bm = undefined;
/* module identifier */

const __vue_module_identifier__$bm = undefined;
/* functional template */

const __vue_is_functional_template__$bm = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bm = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bm,
  staticRenderFns: __vue_staticRenderFns__$bm
}, __vue_inject_styles__$bm, __vue_script__$bm, __vue_scope_id__$bm, __vue_is_functional_template__$bm, __vue_module_identifier__$bm, false, undefined, undefined, undefined);

var script$bn = Vue.extend({
  name: "PhSkipBack",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bn = script$bn;
/* template */

var __vue_render__$bn = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M67.17024,121.17374,187.8284,47.4382A8,8,0,0,1,200,54.26445v147.4711a8,8,0,0,1-12.1716,6.82625L67.17024,134.82625A8,8,0,0,1,67.17024,121.17374Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "40",
      "x2": "56",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M67.17024,121.17374,187.8284,47.4382A8,8,0,0,1,200,54.26445v147.4711a8,8,0,0,1-12.1716,6.82625L67.17024,134.82625A8,8,0,0,1,67.17024,121.17374Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M67.17024,121.17374,187.8284,47.4382A8,8,0,0,1,200,54.26445v147.4711a8,8,0,0,1-12.1716,6.82625L67.17024,134.82625A8,8,0,0,1,67.17024,121.17374Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "40",
      "x2": "56",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56,32a8.00008,8.00008,0,0,1,8,8v73.73535l119.65723-73.124A16.0002,16.0002,0,0,1,208,54.26465v147.4707a16.004,16.004,0,0,1-24.34375,13.65283L64,142.26416V216a8,8,0,0,1-16,0V40A8.00008,8.00008,0,0,1,56,32Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M67.17024,121.17374,187.8284,47.4382A8,8,0,0,1,200,54.26445v147.4711a8,8,0,0,1-12.1716,6.82625L67.17024,134.82625A8,8,0,0,1,67.17024,121.17374Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "40",
      "x2": "56",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M67.17024,121.17374,187.8284,47.4382A8,8,0,0,1,200,54.26445v147.4711a8,8,0,0,1-12.1716,6.82625L67.17024,134.82625A8,8,0,0,1,67.17024,121.17374Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "40",
      "x2": "56",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M67.17024,121.17374,187.8284,47.4382A8,8,0,0,1,200,54.26445v147.4711a8,8,0,0,1-12.1716,6.82625L67.17024,134.82625A8,8,0,0,1,67.17024,121.17374Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "40",
      "x2": "56",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bn = [];
/* style */

const __vue_inject_styles__$bn = undefined;
/* scoped */

const __vue_scope_id__$bn = undefined;
/* module identifier */

const __vue_module_identifier__$bn = undefined;
/* functional template */

const __vue_is_functional_template__$bn = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bn = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bn,
  staticRenderFns: __vue_staticRenderFns__$bn
}, __vue_inject_styles__$bn, __vue_script__$bn, __vue_scope_id__$bn, __vue_is_functional_template__$bn, __vue_module_identifier__$bn, false, undefined, undefined, undefined);

var script$bo = Vue.extend({
  name: "PhSkipBackCircle",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bo = script$bo;
/* template */

var __vue_render__$bo = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "156 156 120 128 156 100 156 156",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "100",
      "x2": "100",
      "y2": "156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,32a96,96,0,1,0,96,96A95.99991,95.99991,0,0,0,128,32Zm28,128-48-32,48-32Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "108 128 156 96 156 160 108 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "96",
      "x2": "100",
      "y2": "160",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.12041,104.12041,0,0,0,128,24Zm36,136a7.99975,7.99975,0,0,1-12.4375,6.65625L108,137.61426V160a8,8,0,0,1-16,0V96a8,8,0,0,1,16,0v22.38574l43.5625-29.042A7.99612,7.99612,0,0,1,164,96Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "108 128 156 96 156 160 108 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "96",
      "x2": "100",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "108 128 156 96 156 160 108 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "96",
      "x2": "100",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "108 128 156 96 156 160 108 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "96",
      "x2": "100",
      "y2": "160",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bo = [];
/* style */

const __vue_inject_styles__$bo = undefined;
/* scoped */

const __vue_scope_id__$bo = undefined;
/* module identifier */

const __vue_module_identifier__$bo = undefined;
/* functional template */

const __vue_is_functional_template__$bo = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bo = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bo,
  staticRenderFns: __vue_staticRenderFns__$bo
}, __vue_inject_styles__$bo, __vue_script__$bo, __vue_scope_id__$bo, __vue_is_functional_template__$bo, __vue_module_identifier__$bo, false, undefined, undefined, undefined);

var script$bp = Vue.extend({
  name: "PhSkipForward",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bp = script$bp;
/* template */

var __vue_render__$bp = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M188.82976,121.17374,68.1716,47.4382A8,8,0,0,0,56,54.26445v147.4711a8,8,0,0,0,12.1716,6.82625l120.65816-73.73555A8,8,0,0,0,188.82976,121.17374Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "40",
      "x2": "200",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M188.82976,121.17374,68.1716,47.4382A8,8,0,0,0,56,54.26445v147.4711a8,8,0,0,0,12.1716,6.82625l120.65816-73.73555A8,8,0,0,0,188.82976,121.17374Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M188.82976,121.17374,68.1716,47.4382A8,8,0,0,0,56,54.26445v147.4711a8,8,0,0,0,12.1716,6.82625l120.65816-73.73555A8,8,0,0,0,188.82976,121.17374Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "40",
      "x2": "200",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,40V216a8,8,0,0,1-16,0V142.26416l-119.65625,73.124A16.00029,16.00029,0,0,1,48,201.73535V54.26465A16.0002,16.0002,0,0,1,72.34277,40.61133L192,113.73535V40a8,8,0,0,1,16,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M188.82976,121.17374,68.1716,47.4382A8,8,0,0,0,56,54.26445v147.4711a8,8,0,0,0,12.1716,6.82625l120.65816-73.73555A8,8,0,0,0,188.82976,121.17374Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "40",
      "x2": "200",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M188.82976,121.17374,68.1716,47.4382A8,8,0,0,0,56,54.26445v147.4711a8,8,0,0,0,12.1716,6.82625l120.65816-73.73555A8,8,0,0,0,188.82976,121.17374Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "40",
      "x2": "200",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M188.82976,121.17374,68.1716,47.4382A8,8,0,0,0,56,54.26445v147.4711a8,8,0,0,0,12.1716,6.82625l120.65816-73.73555A8,8,0,0,0,188.82976,121.17374Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "40",
      "x2": "200",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bp = [];
/* style */

const __vue_inject_styles__$bp = undefined;
/* scoped */

const __vue_scope_id__$bp = undefined;
/* module identifier */

const __vue_module_identifier__$bp = undefined;
/* functional template */

const __vue_is_functional_template__$bp = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bp = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bp,
  staticRenderFns: __vue_staticRenderFns__$bp
}, __vue_inject_styles__$bp, __vue_script__$bp, __vue_scope_id__$bp, __vue_is_functional_template__$bp, __vue_module_identifier__$bp, false, undefined, undefined, undefined);

var script$bq = Vue.extend({
  name: "PhSkipForwardCircle",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bq = script$bq;
/* template */

var __vue_render__$bq = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "100 156 136 128 100 100 100 156",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "100",
      "x2": "156",
      "y2": "156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,32a96,96,0,1,0,96,96A95.99991,95.99991,0,0,0,128,32ZM100,160V96l48,32Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "148 128 100 96 100 160 148 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "96",
      "x2": "156",
      "y2": "160",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.12041,104.12041,0,0,0,128,24Zm36,136a8,8,0,0,1-16,0V137.61426l-43.5625,29.042A7.99612,7.99612,0,0,1,92,160V96a7.99612,7.99612,0,0,1,12.4375-6.65625L148,118.38574V96a8,8,0,0,1,16,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "96",
      "x2": "156",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "148 128 100 96 100 160 148 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "96",
      "x2": "156",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "148 128 100 96 100 160 148 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "148 128 100 96 100 160 148 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "96",
      "x2": "156",
      "y2": "160",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bq = [];
/* style */

const __vue_inject_styles__$bq = undefined;
/* scoped */

const __vue_scope_id__$bq = undefined;
/* module identifier */

const __vue_module_identifier__$bq = undefined;
/* functional template */

const __vue_is_functional_template__$bq = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bq = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bq,
  staticRenderFns: __vue_staticRenderFns__$bq
}, __vue_inject_styles__$bq, __vue_script__$bq, __vue_scope_id__$bq, __vue_is_functional_template__$bq, __vue_module_identifier__$bq, false, undefined, undefined, undefined);

var script$br = Vue.extend({
  name: "PhSlackLogo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$br = script$br;
/* template */

var __vue_render__$br = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,56.00005h24a0,0,0,0,1,0,0v72a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24V80a24,24,0,0,1,24-24Z",
      "transform": "translate(184.00005 24.00003) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,80H104a24,24,0,0,1-24-24V56a24,24,0,0,1,24-24h0a24,24,0,0,1,24,24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,32.00007h24a0,0,0,0,1,0,0v72a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24V56A24,24,0,0,1,152,32.00007Z",
      "transform": "translate(304 160.00011) rotate(180)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,128V104a24,24,0,0,1,24-24h0a24,24,0,0,1,24,24v0a24,24,0,0,1-24,24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,104.00005h24a0,0,0,0,1,0,0v72a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24V128a24,24,0,0,1,24-24Z",
      "transform": "translate(23.99995 328.00003) rotate(-90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,176h24a24,24,0,0,1,24,24v0a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,128h24a0,0,0,0,1,0,0v72a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24V152A24,24,0,0,1,104,128Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,128v24a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24v0a24,24,0,0,1,24-24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,104.00005h24a0,0,0,0,1,0,0v72a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24V128a24,24,0,0,1,24-24Z",
      "transform": "translate(23.99995 328.00003) rotate(-90)",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,176h24a24,24,0,0,1,24,24v0a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,56.00005h24a0,0,0,0,1,0,0v72a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24V80a24,24,0,0,1,24-24Z",
      "transform": "translate(184.00005 24.00003) rotate(90)",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,80H104a24,24,0,0,1-24-24V56a24,24,0,0,1,24-24h0a24,24,0,0,1,24,24Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,56.00005h24a0,0,0,0,1,0,0v72a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24V80a24,24,0,0,1,24-24Z",
      "transform": "translate(184.00005 24.00003) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,80H104a24,24,0,0,1-24-24V56a24,24,0,0,1,24-24h0a24,24,0,0,1,24,24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,32.00007h24a0,0,0,0,1,0,0v72a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24V56A24,24,0,0,1,152,32.00007Z",
      "transform": "translate(304 160.00011) rotate(180)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,128V104a24,24,0,0,1,24-24h0a24,24,0,0,1,24,24v0a24,24,0,0,1-24,24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,104.00005h24a0,0,0,0,1,0,0v72a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24V128a24,24,0,0,1,24-24Z",
      "transform": "translate(23.99995 328.00003) rotate(-90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,176h24a24,24,0,0,1,24,24v0a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,128h24a0,0,0,0,1,0,0v72a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24V152A24,24,0,0,1,104,128Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,128v24a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24v0a24,24,0,0,1,24-24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M221.13184,128A31.97762,31.97762,0,0,0,184,76.30522V56a31.97939,31.97939,0,0,0-56-21.132A31.97768,31.97768,0,0,0,76.30518,72H56a31.97928,31.97928,0,0,0-21.13184,56A31.97763,31.97763,0,0,0,72,179.69487V200a31.97939,31.97939,0,0,0,56,21.132A31.97768,31.97768,0,0,0,179.69482,184H200a31.97928,31.97928,0,0,0,21.13184-56ZM88,56a16,16,0,0,1,32,0V72H104A16.01833,16.01833,0,0,1,88,56ZM40,104A16.01833,16.01833,0,0,1,56,88h48a16.01833,16.01833,0,0,1,16,16v16H56A16.01833,16.01833,0,0,1,40,104Zm128,96a16,16,0,0,1-32,0V184h16A16.01833,16.01833,0,0,1,168,200Zm32-32H152a16.01833,16.01833,0,0,1-16-16V136h64a16,16,0,0,1,0,32Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,56.00005h24a0,0,0,0,1,0,0v72a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24V80a24,24,0,0,1,24-24Z",
      "transform": "translate(184.00005 24.00003) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,80H104a24,24,0,0,1-24-24V56a24,24,0,0,1,24-24h0a24,24,0,0,1,24,24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,32.00007h24a0,0,0,0,1,0,0v72a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24V56a24,24,0,0,1,24-24Z",
      "transform": "translate(304 160.00011) rotate(180)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,128V104a24,24,0,0,1,24-24h0a24,24,0,0,1,24,24v0a24,24,0,0,1-24,24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,104.00005h24a0,0,0,0,1,0,0v72a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24V128A24,24,0,0,1,176,104.00005Z",
      "transform": "translate(23.99995 328.00003) rotate(-90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,176h24a24,24,0,0,1,24,24v0a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,128h24a0,0,0,0,1,0,0v72a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24V152A24,24,0,0,1,104,128Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,128v24a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24v0a24,24,0,0,1,24-24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,56.00005h24a0,0,0,0,1,0,0v72a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24V80a24,24,0,0,1,24-24Z",
      "transform": "translate(184.00005 24.00003) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,80H104a24,24,0,0,1-24-24V56a24,24,0,0,1,24-24h0a24,24,0,0,1,24,24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,32.00007h24a0,0,0,0,1,0,0v72a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24V56A24,24,0,0,1,152,32.00007Z",
      "transform": "translate(304 160.00011) rotate(180)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,128V104a24,24,0,0,1,24-24h0a24,24,0,0,1,24,24v0a24,24,0,0,1-24,24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,104.00005h24a0,0,0,0,1,0,0v72a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24V128a24,24,0,0,1,24-24Z",
      "transform": "translate(23.99995 328.00003) rotate(-90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,176h24a24,24,0,0,1,24,24v0a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,128h24a0,0,0,0,1,0,0v72a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24V152a24,24,0,0,1,24-24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,128v24a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24v0a24,24,0,0,1,24-24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,56.00005h24a0,0,0,0,1,0,0v72a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24V80a24,24,0,0,1,24-24Z",
      "transform": "translate(184.00005 24.00003) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,80H104a24,24,0,0,1-24-24V56a24,24,0,0,1,24-24h0a24,24,0,0,1,24,24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,32.00007h24a0,0,0,0,1,0,0v72a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24V56a24,24,0,0,1,24-24Z",
      "transform": "translate(304 160.00011) rotate(180)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,128V104a24,24,0,0,1,24-24h0a24,24,0,0,1,24,24v0a24,24,0,0,1-24,24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,104.00005h24a0,0,0,0,1,0,0v72a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24V128a24,24,0,0,1,24-24Z",
      "transform": "translate(23.99995 328.00003) rotate(-90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,176h24a24,24,0,0,1,24,24v0a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,128h24a0,0,0,0,1,0,0v72a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24V152a24,24,0,0,1,24-24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,128v24a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24v0a24,24,0,0,1,24-24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$br = [];
/* style */

const __vue_inject_styles__$br = undefined;
/* scoped */

const __vue_scope_id__$br = undefined;
/* module identifier */

const __vue_module_identifier__$br = undefined;
/* functional template */

const __vue_is_functional_template__$br = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$br = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$br,
  staticRenderFns: __vue_staticRenderFns__$br
}, __vue_inject_styles__$br, __vue_script__$br, __vue_scope_id__$br, __vue_is_functional_template__$br, __vue_module_identifier__$br, false, undefined, undefined, undefined);

var script$bs = Vue.extend({
  name: "PhSliders",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bs = script$bs;
/* template */

var __vue_render__$bs = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "127.99805",
      "y1": "108",
      "x2": "127.99817",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "127.99817",
      "y1": "40",
      "x2": "127.99805",
      "y2": "68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "127.99805",
      "cy": "88",
      "r": "20",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "199.99805",
      "y1": "188",
      "x2": "199.99888",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "199.99888",
      "y1": "40",
      "x2": "199.99805",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "199.99805",
      "cy": "168",
      "r": "20",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "55.99805",
      "y1": "156",
      "x2": "55.99746",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "55.99746",
      "y1": "40",
      "x2": "55.99805",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "55.99805",
      "cy": "136",
      "r": "20",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "55.99609",
      "cy": "136",
      "r": "20",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "127.99609",
      "y1": "108",
      "x2": "127.99622",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "127.99622",
      "y1": "40",
      "x2": "127.99609",
      "y2": "68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "127.99609",
      "cy": "88",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "199.99609",
      "y1": "188",
      "x2": "199.99693",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "199.99693",
      "y1": "40",
      "x2": "199.99609",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "199.99609",
      "cy": "168",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "55.99609",
      "y1": "156",
      "x2": "55.99551",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "55.99551",
      "y1": "40",
      "x2": "55.99609",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "55.99609",
      "cy": "136",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M135.99707,65.376V39.99988a8,8,0,0,0-16,0V65.376a23.995,23.995,0,0,0,0,45.2478v105.3761a8,8,0,0,0,16,0V110.62378a23.995,23.995,0,0,0,0-45.2478Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M223.99707,167.99988a24.03744,24.03744,0,0,0-16-22.6239l.001-105.3761a8,8,0,1,0-16,0l-.001,105.3761a23.995,23.995,0,0,0,0,45.2478l.001,25.3761a8,8,0,0,0,16,0l-.001-25.37622A24.03728,24.03728,0,0,0,223.99707,167.99988Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M63.99707,113.376l-.00049-73.3761a8,8,0,0,0-16,0l.00049,73.3761a23.995,23.995,0,0,0,0,45.2478l-.00049,57.3761a8,8,0,1,0,16,0l.00049-57.3761a23.995,23.995,0,0,0,0-45.2478Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "127.99902",
      "y1": "108",
      "x2": "127.99915",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "127.99915",
      "y1": "40",
      "x2": "127.99902",
      "y2": "68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "127.99902",
      "cy": "88",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "199.99902",
      "y1": "188",
      "x2": "199.99986",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "199.99986",
      "y1": "40",
      "x2": "199.99902",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "199.99902",
      "cy": "168",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "55.99902",
      "y1": "156",
      "x2": "55.99844",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "55.99844",
      "y1": "40",
      "x2": "55.99902",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "55.99902",
      "cy": "136",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "108",
      "x2": "128.00012",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128.00012",
      "y1": "40",
      "x2": "128",
      "y2": "68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "88",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "188",
      "x2": "200.00083",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200.00083",
      "y1": "40",
      "x2": "200",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "200",
      "cy": "168",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "156",
      "x2": "55.99941",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "55.99941",
      "y1": "40",
      "x2": "56",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "56",
      "cy": "136",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128.00098",
      "y1": "108",
      "x2": "128.0011",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128.0011",
      "y1": "40",
      "x2": "128.00098",
      "y2": "68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128.00098",
      "cy": "88",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200.00098",
      "y1": "188",
      "x2": "200.00181",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200.00181",
      "y1": "40",
      "x2": "200.00098",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "200.00098",
      "cy": "168",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56.00098",
      "y1": "156",
      "x2": "56.00039",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56.00039",
      "y1": "40",
      "x2": "56.00098",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "56.00098",
      "cy": "136",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bs = [];
/* style */

const __vue_inject_styles__$bs = undefined;
/* scoped */

const __vue_scope_id__$bs = undefined;
/* module identifier */

const __vue_module_identifier__$bs = undefined;
/* functional template */

const __vue_is_functional_template__$bs = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bs = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bs,
  staticRenderFns: __vue_staticRenderFns__$bs
}, __vue_inject_styles__$bs, __vue_script__$bs, __vue_scope_id__$bs, __vue_is_functional_template__$bs, __vue_module_identifier__$bs, false, undefined, undefined, undefined);

var script$bt = Vue.extend({
  name: "PhSlidersHorizontal",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bt = script$bt;
/* template */

var __vue_render__$bt = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "147.99951",
      "y1": "171.99353",
      "x2": "39.99951",
      "y2": "171.99365",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "215.99951",
      "y1": "171.99365",
      "x2": "187.99951",
      "y2": "171.99353",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "167.99951",
      "cy": "171.99353",
      "r": "20",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "83.99951",
      "y1": "83.99353",
      "x2": "39.99951",
      "y2": "83.99294",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "215.99951",
      "y1": "83.99294",
      "x2": "123.99951",
      "y2": "83.99353",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "103.99951",
      "cy": "83.99353",
      "r": "20",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "103.99951",
      "cy": "83.99353",
      "r": "20",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "147.99951",
      "y1": "171.99353",
      "x2": "39.99951",
      "y2": "171.99365",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "215.99951",
      "y1": "171.99365",
      "x2": "187.99951",
      "y2": "171.99353",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "167.99951",
      "cy": "171.99353",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "83.99951",
      "y1": "83.99353",
      "x2": "39.99951",
      "y2": "83.99294",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "215.99951",
      "y1": "83.99294",
      "x2": "123.99951",
      "y2": "83.99353",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "103.99951",
      "cy": "83.99353",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M215.99951,163.99353H194.8291a27.99567,27.99567,0,0,0-53.65918,0H39.99951a8,8,0,0,0,0,16H141.16992a27.99567,27.99567,0,0,0,53.65918,0h21.17041a8,8,0,0,0,0-16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M39.999,91.99255l37.1709.001a27.99567,27.99567,0,0,0,53.65918,0l85.17041-.001a8,8,0,0,0,0-16l-85.17041.001a27.99567,27.99567,0,0,0-53.65918,0L40,75.99255h-.00049a8,8,0,0,0-.00049,16Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "147.99951",
      "y1": "171.99353",
      "x2": "39.99951",
      "y2": "171.99365",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "215.99951",
      "y1": "171.99365",
      "x2": "187.99951",
      "y2": "171.99353",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "167.99951",
      "cy": "171.99353",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "83.99951",
      "y1": "83.99353",
      "x2": "39.99951",
      "y2": "83.99294",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "215.99951",
      "y1": "83.99294",
      "x2": "123.99951",
      "y2": "83.99353",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "103.99951",
      "cy": "83.99353",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "147.99951",
      "y1": "171.99353",
      "x2": "39.99951",
      "y2": "171.99365",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "215.99951",
      "y1": "171.99365",
      "x2": "187.99951",
      "y2": "171.99353",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "167.99951",
      "cy": "171.99353",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "83.99951",
      "y1": "83.99353",
      "x2": "39.99951",
      "y2": "83.99294",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "215.99951",
      "y1": "83.99294",
      "x2": "123.99951",
      "y2": "83.99353",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "103.99951",
      "cy": "83.99353",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "147.99951",
      "y1": "171.99353",
      "x2": "39.99951",
      "y2": "171.99365",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "215.99951",
      "y1": "171.99365",
      "x2": "187.99951",
      "y2": "171.99353",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "167.99951",
      "cy": "171.99353",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "83.99951",
      "y1": "83.99353",
      "x2": "39.99951",
      "y2": "83.99294",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "215.99951",
      "y1": "83.99294",
      "x2": "123.99951",
      "y2": "83.99353",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "103.99951",
      "cy": "83.99353",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bt = [];
/* style */

const __vue_inject_styles__$bt = undefined;
/* scoped */

const __vue_scope_id__$bt = undefined;
/* module identifier */

const __vue_module_identifier__$bt = undefined;
/* functional template */

const __vue_is_functional_template__$bt = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bt = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bt,
  staticRenderFns: __vue_staticRenderFns__$bt
}, __vue_inject_styles__$bt, __vue_script__$bt, __vue_scope_id__$bt, __vue_is_functional_template__$bt, __vue_module_identifier__$bt, false, undefined, undefined, undefined);

var script$bu = Vue.extend({
  name: "PhSmiley",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bu = script$bu;
/* template */

var __vue_render__$bu = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "108",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "108",
      "r": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M169.58,151.99735a48.016,48.016,0,0,1-83.15966.00055",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "108",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "108",
      "r": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M169.58,151.99735a48.016,48.016,0,0,1-83.15966.00055",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.12041,104.12041,0,0,0,128,24Zm36,72a12,12,0,1,1-12,12A12.0006,12.0006,0,0,1,164,96ZM92,96a12,12,0,1,1-12,12A12.0006,12.0006,0,0,1,92,96Zm84.50488,60.00293a56.01609,56.01609,0,0,1-97.00976.00049,8.00016,8.00016,0,1,1,13.85058-8.01074,40.01628,40.01628,0,0,0,69.30957-.00049,7.99974,7.99974,0,1,1,13.84961,8.01074Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "108",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "108",
      "r": "10"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M169.58,151.99735a48.016,48.016,0,0,1-83.15966.00055",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "108",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "108",
      "r": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M169.58,151.99735a48.016,48.016,0,0,1-83.15966.00055",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "108",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "108",
      "r": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M169.58,151.99735a48.016,48.016,0,0,1-83.15966.00055",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bu = [];
/* style */

const __vue_inject_styles__$bu = undefined;
/* scoped */

const __vue_scope_id__$bu = undefined;
/* module identifier */

const __vue_module_identifier__$bu = undefined;
/* functional template */

const __vue_is_functional_template__$bu = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bu = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bu,
  staticRenderFns: __vue_staticRenderFns__$bu
}, __vue_inject_styles__$bu, __vue_script__$bu, __vue_scope_id__$bu, __vue_is_functional_template__$bu, __vue_module_identifier__$bu, false, undefined, undefined, undefined);

var script$bv = Vue.extend({
  name: "PhSmileyBlank",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bv = script$bv;
/* template */

var __vue_render__$bv = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "108",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "108",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "108",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "108",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.12041,104.12041,0,0,0,128,24ZM92,120a12,12,0,1,1,12-12A12.0006,12.0006,0,0,1,92,120Zm72,0a12,12,0,1,1,12-12A12.0006,12.0006,0,0,1,164,120Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "108",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "108",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "108",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "108",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "108",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "108",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bv = [];
/* style */

const __vue_inject_styles__$bv = undefined;
/* scoped */

const __vue_scope_id__$bv = undefined;
/* module identifier */

const __vue_module_identifier__$bv = undefined;
/* functional template */

const __vue_is_functional_template__$bv = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bv = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bv,
  staticRenderFns: __vue_staticRenderFns__$bv
}, __vue_inject_styles__$bv, __vue_script__$bv, __vue_scope_id__$bv, __vue_is_functional_template__$bv, __vue_module_identifier__$bv, false, undefined, undefined, undefined);

var script$bw = Vue.extend({
  name: "PhSmileyMeh",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bw = script$bw;
/* template */

var __vue_render__$bw = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "160",
      "x2": "168",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "108",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "108",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "160",
      "x2": "168",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "108",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "108",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.12041,104.12041,0,0,0,128,24ZM92,96a12,12,0,1,1-12,12A12.0006,12.0006,0,0,1,92,96Zm76,72H88a8,8,0,0,1,0-16h80a8,8,0,0,1,0,16Zm-4-48a12,12,0,1,1,12-12A12.0006,12.0006,0,0,1,164,120Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "160",
      "x2": "168",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "108",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "108",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "160",
      "x2": "168",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "108",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "108",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "160",
      "x2": "168",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "108",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "108",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bw = [];
/* style */

const __vue_inject_styles__$bw = undefined;
/* scoped */

const __vue_scope_id__$bw = undefined;
/* module identifier */

const __vue_module_identifier__$bw = undefined;
/* functional template */

const __vue_is_functional_template__$bw = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bw = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bw,
  staticRenderFns: __vue_staticRenderFns__$bw
}, __vue_inject_styles__$bw, __vue_script__$bw, __vue_scope_id__$bw, __vue_is_functional_template__$bw, __vue_module_identifier__$bw, false, undefined, undefined, undefined);

var script$bx = Vue.extend({
  name: "PhSmileyNervous",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bx = script$bx;
/* template */

var __vue_render__$bx = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "85.791 164.762 96 152 112 172 128 152 144 172 160 152 170.21 164.762",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "108",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "108",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 172 96 152 112 172 128 152 144 172 160 152 176 172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "108",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "108",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.11791,104.11791,0,0,0,128,24Zm36,72a12,12,0,1,1-12,12A12,12,0,0,1,164,96ZM92,96a12,12,0,1,1-12,12A12,12,0,0,1,92,96Zm88.99756,82.24707a8.00032,8.00032,0,0,1-11.24463-1.24951L160,164.80615l-9.75293,12.19141a8.00025,8.00025,0,0,1-12.49414,0L128,164.80615l-9.75293,12.19141a8.00025,8.00025,0,0,1-12.49414,0L96,164.80615l-9.75293,12.19141a8.00009,8.00009,0,0,1-12.49414-9.99512l16-20a8.00025,8.00025,0,0,1,12.49414,0L112,159.19385l9.75293-12.19141a8.00025,8.00025,0,0,1,12.49414,0L144,159.19385l9.75293-12.19141a8.00025,8.00025,0,0,1,12.49414,0l16,20A8.00036,8.00036,0,0,1,180.99756,178.24707Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 172 96 152 112 172 128 152 144 172 160 152 176 172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "108",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "108",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 172 96 152 112 172 128 152 144 172 160 152 176 172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "108",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "108",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 172 96 152 112 172 128 152 144 172 160 152 176 172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "108",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "108",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bx = [];
/* style */

const __vue_inject_styles__$bx = undefined;
/* scoped */

const __vue_scope_id__$bx = undefined;
/* module identifier */

const __vue_module_identifier__$bx = undefined;
/* functional template */

const __vue_is_functional_template__$bx = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bx = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bx,
  staticRenderFns: __vue_staticRenderFns__$bx
}, __vue_inject_styles__$bx, __vue_script__$bx, __vue_scope_id__$bx, __vue_is_functional_template__$bx, __vue_module_identifier__$bx, false, undefined, undefined, undefined);

var script$by = Vue.extend({
  name: "PhSmileySad",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$by = script$by;
/* template */

var __vue_render__$by = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "108",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "108",
      "r": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M165.27508,169.75305a48.0042,48.0042,0,0,0-74.5508.00079",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "108",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "108",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "108",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "108",
      "r": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M169.58,176a48.016,48.016,0,0,0-83.15966-.00055",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.12041,104.12041,0,0,0,128,24Zm36,72a12,12,0,1,1-12,12A12.0006,12.0006,0,0,1,164,96ZM92,96a12,12,0,1,1-12,12A12.0006,12.0006,0,0,1,92,96Zm81.58545,86.9248a7.99636,7.99636,0,0,1-10.93018-2.91943,40.01579,40.01579,0,0,0-69.30957-.00049,8.00016,8.00016,0,0,1-13.85058-8.01074,56.0156,56.0156,0,0,1,97.00976.00049A7.99915,7.99915,0,0,1,173.58545,182.9248Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "108",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "108",
      "r": "10"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M169.58,176a48.016,48.016,0,0,0-83.15966-.00055",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "108",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "108",
      "r": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M169.58,176a48.016,48.016,0,0,0-83.15966-.00055",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "108",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "108",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "108",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "108",
      "r": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M169.58,176a48.016,48.016,0,0,0-83.15966-.00055",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$by = [];
/* style */

const __vue_inject_styles__$by = undefined;
/* scoped */

const __vue_scope_id__$by = undefined;
/* module identifier */

const __vue_module_identifier__$by = undefined;
/* functional template */

const __vue_is_functional_template__$by = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$by = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$by,
  staticRenderFns: __vue_staticRenderFns__$by
}, __vue_inject_styles__$by, __vue_script__$by, __vue_scope_id__$by, __vue_is_functional_template__$by, __vue_module_identifier__$by, false, undefined, undefined, undefined);

var script$bz = Vue.extend({
  name: "PhSmileySticker",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bz = script$bz;
/* template */

var __vue_render__$bz = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M156.21732,219.78606a95.898,95.898,0,1,1,63.57-63.573Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "108",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "108",
      "r": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M169.58,151.99735a48.016,48.016,0,0,1-83.15966.00055",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M156.21732,219.78606a95.898,95.898,0,1,1,63.57-63.573Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M156.21732,219.78606a95.898,95.898,0,1,1,63.57-63.573Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "108",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "108",
      "r": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M169.58,151.99735a48.016,48.016,0,0,1-83.15966.00055",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24a104,104,0,1,0,30.56543,203.43359,7.99683,7.99683,0,0,0,3.30859-1.99072l63.57032-63.57324a7.99548,7.99548,0,0,0,1.99072-3.30859A104.07559,104.07559,0,0,0,128,24Zm36,72a12,12,0,1,1-12,12A12,12,0,0,1,164,96ZM92,96a12,12,0,1,1-12,12A12,12,0,0,1,92,96Zm84.50488,60.00269a56.01585,56.01585,0,0,1-97.00976.00048,8.00016,8.00016,0,0,1,13.85058-8.01074,40.016,40.016,0,0,0,69.30957-.00049,7.99975,7.99975,0,1,1,13.84961,8.01075Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M156.21732,219.78606a95.898,95.898,0,1,1,63.57-63.573Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "108",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "108",
      "r": "10"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M169.58,151.99735a48.016,48.016,0,0,1-83.15966.00055",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M156.21732,219.78606a95.898,95.898,0,1,1,63.57-63.573Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "108",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "108",
      "r": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M169.58,151.99735a48.016,48.016,0,0,1-83.15966.00055",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M156.21732,219.78606a95.898,95.898,0,1,1,63.57-63.573Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "108",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "108",
      "r": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M169.58,151.99735a48.016,48.016,0,0,1-83.15966.00055",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bz = [];
/* style */

const __vue_inject_styles__$bz = undefined;
/* scoped */

const __vue_scope_id__$bz = undefined;
/* module identifier */

const __vue_module_identifier__$bz = undefined;
/* functional template */

const __vue_is_functional_template__$bz = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bz = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bz,
  staticRenderFns: __vue_staticRenderFns__$bz
}, __vue_inject_styles__$bz, __vue_script__$bz, __vue_scope_id__$bz, __vue_is_functional_template__$bz, __vue_module_identifier__$bz, false, undefined, undefined, undefined);

var script$bA = Vue.extend({
  name: "PhSmileyWink",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bA = script$bA;
/* template */

var __vue_render__$bA = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "108",
      "r": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "108",
      "x2": "176",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M169.58,151.99735a48.016,48.016,0,0,1-83.15966.00055",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "108",
      "r": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "108",
      "x2": "176",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M169.58,151.99735a48.016,48.016,0,0,1-83.15966.00055",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.11791,104.11791,0,0,0,128,24ZM92,96a12,12,0,1,1-12,12A12,12,0,0,1,92,96Zm84.50488,60.00293a56.01609,56.01609,0,0,1-97.00976.00049,8.00016,8.00016,0,0,1,13.85058-8.01074,40.01628,40.01628,0,0,0,69.30957-.00049,7.99974,7.99974,0,1,1,13.84961,8.01074ZM180,116H148a8,8,0,0,1,0-16h32a8,8,0,0,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "108",
      "r": "10"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "108",
      "x2": "176",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M169.58,151.99735a48.016,48.016,0,0,1-83.15966.00055",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "108",
      "r": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "108",
      "x2": "176",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M169.58,151.99735a48.016,48.016,0,0,1-83.15966.00055",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "108",
      "r": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "108",
      "x2": "176",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M169.58,151.99735a48.016,48.016,0,0,1-83.15966.00055",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bA = [];
/* style */

const __vue_inject_styles__$bA = undefined;
/* scoped */

const __vue_scope_id__$bA = undefined;
/* module identifier */

const __vue_module_identifier__$bA = undefined;
/* functional template */

const __vue_is_functional_template__$bA = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bA = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bA,
  staticRenderFns: __vue_staticRenderFns__$bA
}, __vue_inject_styles__$bA, __vue_script__$bA, __vue_scope_id__$bA, __vue_is_functional_template__$bA, __vue_module_identifier__$bA, false, undefined, undefined, undefined);

var script$bB = Vue.extend({
  name: "PhSmileyXEyes",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bB = script$bB;
/* template */

var __vue_render__$bB = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "180",
      "y1": "96",
      "x2": "148",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "180",
      "y1": "128",
      "x2": "148",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "108",
      "y1": "96",
      "x2": "76",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "108",
      "y1": "128",
      "x2": "76",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "180",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "96",
      "x2": "152",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "128",
      "x2": "152",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "96",
      "x2": "72",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "128",
      "x2": "72",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "180",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.12041,104.12041,0,0,0,128,24Zm-18.34375,98.34375a7.99915,7.99915,0,1,1-11.3125,11.3125L88,123.3125,77.65625,133.65625a7.99915,7.99915,0,0,1-11.3125-11.3125L76.6875,112,66.34375,101.65625a7.99915,7.99915,0,0,1,11.3125-11.3125L88,100.6875,98.34375,90.34375a7.99915,7.99915,0,0,1,11.3125,11.3125L99.3125,112ZM128,192a12,12,0,1,1,12-12A12.0006,12.0006,0,0,1,128,192Zm61.65625-69.65625a7.99915,7.99915,0,1,1-11.3125,11.3125L168,123.3125l-10.34375,10.34375a7.99915,7.99915,0,0,1-11.3125-11.3125L156.6875,112l-10.34375-10.34375a7.99915,7.99915,0,0,1,11.3125-11.3125L168,100.6875l10.34375-10.34375a7.99915,7.99915,0,0,1,11.3125,11.3125L179.3125,112Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "96",
      "x2": "152",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "128",
      "x2": "152",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "96",
      "x2": "72",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "128",
      "x2": "72",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "180",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "96",
      "x2": "152",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "128",
      "x2": "152",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "96",
      "x2": "72",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "128",
      "x2": "72",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "180",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "96",
      "x2": "152",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "128",
      "x2": "152",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "96",
      "x2": "72",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "128",
      "x2": "72",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "180",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bB = [];
/* style */

const __vue_inject_styles__$bB = undefined;
/* scoped */

const __vue_scope_id__$bB = undefined;
/* module identifier */

const __vue_module_identifier__$bB = undefined;
/* functional template */

const __vue_is_functional_template__$bB = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bB = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bB,
  staticRenderFns: __vue_staticRenderFns__$bB
}, __vue_inject_styles__$bB, __vue_script__$bB, __vue_scope_id__$bB, __vue_is_functional_template__$bB, __vue_module_identifier__$bB, false, undefined, undefined, undefined);

var script$bC = Vue.extend({
  name: "PhSnapchatLogo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bC = script$bC;
/* template */

var __vue_render__$bC = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M18.52262,188.68274S72,163.9473,72,80a56,56,0,0,1,112,0c0,83.94728,53.47772,108.6824,53.47772,108.6824-9.25514,8.68693-28.93167,3.38673-40.13691,9.55547-11.03868,6.077-17.07266,25.58078-29.56764,28.77765C155.6908,230.10684,141.04586,216,128,216s-27.6905,14.10686-39.77275,11.01563C75.73218,223.81879,69.69808,204.315,58.65931,198.238,47.45415,192.06928,27.77771,197.36958,18.52262,188.68274Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "189.3256",
      "y1": "122.66978",
      "x2": "216",
      "y2": "112.00002",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "66.67601",
      "y1": "122.67043",
      "x2": "40",
      "y2": "112.00002",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M18.52262,188.68274S72,163.9473,72,80a56,56,0,0,1,112,0c0,83.94728,53.47772,108.6824,53.47772,108.6824-9.25514,8.68693-28.93167,3.38673-40.13691,9.55547-11.03868,6.077-17.07266,25.58078-29.56764,28.77765C155.6908,230.10684,141.04586,216,128,216s-27.6905,14.10686-39.77275,11.01563C75.73218,223.81879,69.69808,204.315,58.65931,198.238,47.45415,192.06928,27.77771,197.36958,18.52262,188.68274Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M18.52262,188.68274S72,163.9473,72,80a56,56,0,0,1,112,0c0,83.94728,53.47772,108.6824,53.47772,108.6824-9.25514,8.68693-28.93167,3.38673-40.13691,9.55547-11.03868,6.077-17.07266,25.58078-29.56764,28.77765C155.6908,230.10684,141.04586,216,128,216s-27.6905,14.10686-39.77275,11.01563C75.73218,223.81879,69.69808,204.315,58.65931,198.238,47.45415,192.06928,27.77771,197.36958,18.52262,188.68274Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "189.3256",
      "y1": "122.66978",
      "x2": "216",
      "y2": "112.00002",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "66.67601",
      "y1": "122.67043",
      "x2": "40",
      "y2": "112.00002",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M242.95264,194.51565c-7.17285,6.73242-17.44434,7.418-26.50684,8.02343-5.77881.38575-11.75391.78418-15.24658,2.707-3.37012,1.85546-6.84522,6.61914-10.20557,11.22558-5.40674,7.41113-11.53418,15.81152-21.2373,18.29395-9.356,2.39648-18.584-1.90625-26.72608-5.70118C137.688,226.57424,132.16357,224,128,224c-4.16309,0-9.6875,2.57422-15.02979,5.06445-6.51074,3.03321-13.71728,6.39161-21.126,6.39161a22.48462,22.48462,0,0,1-5.59961-.69043c-9.70361-2.48243-15.83154-10.88282-21.23877-18.29493-3.36035-4.60546-6.835-9.36914-10.20459-11.2246-3.49268-1.92286-9.46826-2.32129-15.24658-2.707-9.0625-.60546-19.334-1.291-26.50684-8.02343a7.99944,7.99944,0,0,1,2.085-13.07911c.27149-.13085,12.46192-6.085,24.44629-21.32324a107.03319,107.03319,0,0,0,17.35156-32.72558l-19.90136-7.96a7.99977,7.99977,0,0,1,5.9414-14.85547L61.023,111.793A163.22264,163.22264,0,0,0,64,80a64,64,0,0,1,128,0,163.22264,163.22264,0,0,0,2.977,31.793l18.05176-7.2207a8,8,0,0,1,5.94238,14.85547l-19.90137,7.96093a107.023,107.023,0,0,0,17.35157,32.72461c12.05957,15.334,24.32763,21.2666,24.45019,21.3252a8.021,8.021,0,0,1,2.08106,13.07715Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M18.52262,188.68274S72,163.9473,72,80a56,56,0,0,1,112,0c0,83.94728,53.47772,108.6824,53.47772,108.6824-9.25514,8.68693-28.93167,3.38673-40.13691,9.55547-11.03868,6.077-17.07266,25.58078-29.56764,28.77765C155.6908,230.10684,141.04586,216,128,216s-27.6905,14.10686-39.77275,11.01563C75.73218,223.81879,69.69808,204.315,58.65931,198.238,47.45415,192.06928,27.77771,197.36958,18.52262,188.68274Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "189.3256",
      "y1": "122.66978",
      "x2": "216",
      "y2": "112.00002",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "66.67601",
      "y1": "122.67043",
      "x2": "40",
      "y2": "112.00002",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M18.52262,188.68274S72,163.9473,72,80a56,56,0,0,1,112,0c0,83.94728,53.47772,108.6824,53.47772,108.6824-9.25514,8.68693-28.93167,3.38673-40.13691,9.55547-11.03868,6.077-17.07266,25.58078-29.56764,28.77765C155.6908,230.10684,141.04586,216,128,216s-27.6905,14.10686-39.77275,11.01563C75.73218,223.81879,69.69808,204.315,58.65931,198.238,47.45415,192.06928,27.77771,197.36958,18.52262,188.68274Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "189.3256",
      "y1": "122.66978",
      "x2": "216",
      "y2": "112.00002",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "66.67601",
      "y1": "122.67043",
      "x2": "40",
      "y2": "112.00002",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M18.52262,188.68274S72,163.9473,72,80a56,56,0,0,1,112,0c0,83.94728,53.47772,108.6824,53.47772,108.6824-9.25514,8.68693-28.93167,3.38673-40.13691,9.55547-11.03868,6.077-17.07266,25.58078-29.56764,28.77765C155.6908,230.10684,141.04586,216,128,216s-27.6905,14.10686-39.77275,11.01563C75.73218,223.81879,69.69808,204.315,58.65931,198.238,47.45415,192.06928,27.77771,197.36958,18.52262,188.68274Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "189.3256",
      "y1": "122.66978",
      "x2": "216",
      "y2": "112.00002",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "66.67601",
      "y1": "122.67043",
      "x2": "40",
      "y2": "112.00002",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bC = [];
/* style */

const __vue_inject_styles__$bC = undefined;
/* scoped */

const __vue_scope_id__$bC = undefined;
/* module identifier */

const __vue_module_identifier__$bC = undefined;
/* functional template */

const __vue_is_functional_template__$bC = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bC = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bC,
  staticRenderFns: __vue_staticRenderFns__$bC
}, __vue_inject_styles__$bC, __vue_script__$bC, __vue_scope_id__$bC, __vue_is_functional_template__$bC, __vue_module_identifier__$bC, false, undefined, undefined, undefined);

var script$bD = Vue.extend({
  name: "PhSnowflake",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bD = script$bD;
/* template */

var __vue_render__$bD = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "64",
      "x2": "128",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "104 40 128 64 152 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "104 216 128 192 152 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72.57437",
      "y1": "96",
      "x2": "183.42563",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "39.79 104.785 72.574 96 63.79 63.215",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192.21 192.785 183.426 160 216.21 151.215",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72.57437",
      "y1": "160",
      "x2": "183.42563",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "63.79 192.785 72.574 160 39.79 151.215",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "216.21 104.785 183.426 96 192.21 63.215",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "64",
      "x2": "128",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "104 40 128 64 152 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "104 216 128 192 152 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72.57437",
      "y1": "96",
      "x2": "183.42563",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "39.79 104.785 72.574 96 63.79 63.215",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192.21 192.785 183.426 160 216.21 151.215",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72.57437",
      "y1": "160",
      "x2": "183.42563",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "63.79 192.785 72.574 160 39.79 151.215",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "216.21 104.785 183.426 96 192.21 63.215",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M223.938,149.14551a7.99991,7.99991,0,0,1-5.65723,9.79785l-25.05713,6.71387,6.71436,25.05664a8.00007,8.00007,0,1,1-15.45508,4.14062l-7.927-29.58374L136,141.856V188.686l21.65674,21.65673a8.00018,8.00018,0,0,1-11.31348,11.31446L128,203.31348l-18.34326,18.34375a8.00018,8.00018,0,0,1-11.31348-11.31446L120,188.686V141.856L79.44409,165.27075l-7.927,29.58374A8.00007,8.00007,0,1,1,56.062,190.71387l6.71436-25.05664-25.05713-6.71387a8.00007,8.00007,0,1,1,4.14062-15.45508L71.44458,151.415,112.00073,128,71.44458,104.585l-29.58472,7.92676a8.00007,8.00007,0,1,1-4.14062-15.45508l25.05713-6.71387L56.062,65.28613a8.00007,8.00007,0,1,1,15.45508-4.14062l7.927,29.58374L120,114.144V67.314L98.34326,45.65723a8.00018,8.00018,0,0,1,11.31348-11.31446L128,52.68652l18.34326-18.34375a8.00018,8.00018,0,1,1,11.31348,11.31446L136,67.314V114.144l40.55591-23.41479,7.927-29.58374A8.00007,8.00007,0,1,1,199.938,65.28613l-6.71436,25.05664,25.05713,6.71387a8.00007,8.00007,0,1,1-4.14062,15.45508L184.55542,104.585,143.99927,128l40.55615,23.415,29.58472-7.92676A8.00062,8.00062,0,0,1,223.938,149.14551Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "64",
      "x2": "128",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "104 40 128 64 152 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "104 216 128 192 152 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72.57437",
      "y1": "96",
      "x2": "183.42563",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "39.79 104.785 72.574 96 63.79 63.215",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192.21 192.785 183.426 160 216.21 151.215",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72.57437",
      "y1": "160",
      "x2": "183.42563",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "63.79 192.785 72.574 160 39.79 151.215",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "216.21 104.785 183.426 96 192.21 63.215",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "64",
      "x2": "128",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "104 40 128 64 152 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "104 216 128 192 152 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72.57437",
      "y1": "96",
      "x2": "183.42563",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "39.79 104.785 72.574 96 63.79 63.215",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192.21 192.785 183.426 160 216.21 151.215",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72.57437",
      "y1": "160",
      "x2": "183.42563",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "63.79 192.785 72.574 160 39.79 151.215",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "216.21 104.785 183.426 96 192.21 63.215",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "64",
      "x2": "128",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "104 40 128 64 152 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "104 216 128 192 152 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72.57437",
      "y1": "96",
      "x2": "183.42563",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "39.79 104.785 72.574 96 63.79 63.215",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192.21 192.785 183.426 160 216.21 151.215",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72.57437",
      "y1": "160",
      "x2": "183.42563",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "63.79 192.785 72.574 160 39.79 151.215",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "216.21 104.785 183.426 96 192.21 63.215",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bD = [];
/* style */

const __vue_inject_styles__$bD = undefined;
/* scoped */

const __vue_scope_id__$bD = undefined;
/* module identifier */

const __vue_module_identifier__$bD = undefined;
/* functional template */

const __vue_is_functional_template__$bD = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bD = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bD,
  staticRenderFns: __vue_staticRenderFns__$bD
}, __vue_inject_styles__$bD, __vue_script__$bD, __vue_scope_id__$bD, __vue_is_functional_template__$bD, __vue_module_identifier__$bD, false, undefined, undefined, undefined);

var script$bE = Vue.extend({
  name: "PhSoccerBall",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bE = script$bE;
/* template */

var __vue_render__$bE = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "128 74.039 76.68 111.325 96.282 171.655 159.718 171.655 179.32 111.325 128 74.039",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "32",
      "x2": "128",
      "y2": "74.0389",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "36.69857",
      "y1": "98.33437",
      "x2": "76.67992",
      "y2": "111.32512",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "71.57262",
      "y1": "205.66563",
      "x2": "96.28244",
      "y2": "171.6555",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184.42738",
      "y1": "205.66563",
      "x2": "159.71756",
      "y2": "171.6555",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "219.30143",
      "y1": "98.33437",
      "x2": "179.32008",
      "y2": "111.32512",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "128 86 88.056 115.021 103.313 161.979 152.687 161.979 167.944 115.021 128 86",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.98335,38.58649a96.37511,96.37511,0,0,1,70.03342.00005l-.00031.00077L128,64,92.98372,38.58745Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32.142,133.67252A96.375,96.375,0,0,1,53.78352,67.0668l.00064.00052,13.34822,41.15559L32.143,133.67246Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M103.77312,220.91932a96.37514,96.37514,0,0,1-56.65819-41.16465l.0007-.00045,43.26611.02287,13.39164,41.14123Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208.885,179.75478a96.37518,96.37518,0,0,1-56.65826,41.16457l-.0002-.00081,13.39171-41.14145,43.26588-.02287Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M202.21656,67.06689A96.375,96.375,0,0,1,223.858,133.67264l-.00083,0-34.98958-25.44969,13.34815-41.15537Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "128 86 88.056 115.021 103.313 161.979 152.687 161.979 167.944 115.021 128 86",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "64",
      "x2": "128",
      "y2": "86",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "163.016 38.587 128 64 92.984 38.587",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "67.13238",
      "y1": "108.22291",
      "x2": "88.05563",
      "y2": "115.02129",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "53.784 67.067 67.132 108.223 32.143 133.672",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "90.38174",
      "y1": "179.77709",
      "x2": "103.31302",
      "y2": "161.97871",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "47.116 179.754 90.382 179.777 103.773 220.918",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "165.61826",
      "y1": "179.77709",
      "x2": "152.68698",
      "y2": "161.97871",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152.227 220.919 165.618 179.777 208.884 179.754",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "188.86762",
      "y1": "108.22291",
      "x2": "167.94437",
      "y2": "115.02129",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "223.857 133.673 188.868 108.223 202.216 67.068",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M231.76978,134.8335a8.01081,8.01081,0,0,0,.07861-1.23633Q231.99652,130.81689,232,128a103.4965,103.4965,0,0,0-22.96765-65.10937,7.99721,7.99721,0,0,0-1.39539-1.69776,104.47716,104.47716,0,0,0-41.09863-29.78662,7.94558,7.94558,0,0,0-1.14416-.44824,103.96223,103.96223,0,0,0-74.78968.00049,7.97953,7.97953,0,0,0-1.14245.44775A104.47726,104.47726,0,0,0,48.36353,61.19238a7.99972,7.99972,0,0,0-1.39612,1.69825A103.49872,103.49872,0,0,0,24,128q0,2.81982.1521,5.60352A7.99281,7.99281,0,0,0,24.23,134.8291a103.303,103.303,0,0,0,15.69409,48.41211,7.99155,7.99155,0,0,0,1.05615,1.64307,104.37857,104.37857,0,0,0,60.27588,43.62353c.10743.03565.21851.05762.32752.08887a104.21832,104.21832,0,0,0,52.82971.00049c.11011-.03125.22241-.05371.33093-.08936a104.38026,104.38026,0,0,0,60.27552-43.62353,7.99155,7.99155,0,0,0,1.05615-1.64307A103.30408,103.30408,0,0,0,231.76978,134.8335ZM68.53931,117.0918l13.1676,4.27832,12.738,39.2041L86.30713,171.7749l-34.6377-.01806a87.36716,87.36716,0,0,1-11.15771-34.2793Zm118.92151,0,28.02746,20.38574a87.36716,87.36716,0,0,1-11.15771,34.2793l-34.6377.01806-8.13782-11.20068,12.738-39.2041Zm5.73291-48.13819L182.51624,101.875l-13.16749,4.27832L136,81.92383V68.07861l28.04492-20.353A88.44244,88.44244,0,0,1,193.19373,68.95361ZM91.95532,47.72559,120,68.07861V81.92383L86.65125,106.15332,73.48376,101.875,62.8064,68.95361A88.44288,88.44288,0,0,1,91.95532,47.72559Zm18.02539,166.4165-10.72937-32.9624,8.13782-11.20117h41.22168l8.13782,11.20117-10.72925,32.9624a88.31128,88.31128,0,0,1-36.0387,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "128 86 88.056 115.021 103.313 161.979 152.687 161.979 167.944 115.021 128 86",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "64",
      "x2": "128",
      "y2": "86",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "163.016 38.587 128 64 92.984 38.587",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "67.13238",
      "y1": "108.22291",
      "x2": "88.05563",
      "y2": "115.02129",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "53.784 67.067 67.132 108.223 32.143 133.672",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "90.38174",
      "y1": "179.77709",
      "x2": "103.31302",
      "y2": "161.97871",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "47.116 179.754 90.382 179.777 103.773 220.918",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "165.61826",
      "y1": "179.77709",
      "x2": "152.68698",
      "y2": "161.97871",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152.227 220.919 165.618 179.777 208.884 179.754",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "188.86762",
      "y1": "108.22291",
      "x2": "167.94437",
      "y2": "115.02129",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "223.857 133.673 188.868 108.223 202.216 67.068",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "128 86 88.056 115.021 103.313 161.979 152.687 161.979 167.944 115.021 128 86",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "64",
      "x2": "128",
      "y2": "86",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "163.016 38.587 128 64 92.984 38.587",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "67.13238",
      "y1": "108.22291",
      "x2": "88.05563",
      "y2": "115.02129",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "53.784 67.067 67.132 108.223 32.143 133.672",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "90.38174",
      "y1": "179.77709",
      "x2": "103.31302",
      "y2": "161.97871",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "47.116 179.754 90.382 179.777 103.773 220.918",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "165.61826",
      "y1": "179.77709",
      "x2": "152.68698",
      "y2": "161.97871",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152.227 220.919 165.618 179.777 208.884 179.754",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "188.86762",
      "y1": "108.22291",
      "x2": "167.94437",
      "y2": "115.02129",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "223.857 133.673 188.868 108.223 202.216 67.068",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "128 86 88.056 115.021 103.313 161.979 152.687 161.979 167.944 115.021 128 86",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "64",
      "x2": "128",
      "y2": "86",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "163.016 38.587 128 64 92.984 38.587",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "67.13238",
      "y1": "108.22291",
      "x2": "88.05563",
      "y2": "115.02129",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "53.784 67.067 67.132 108.223 32.143 133.672",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "90.38174",
      "y1": "179.77709",
      "x2": "103.31302",
      "y2": "161.97871",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "47.116 179.754 90.382 179.777 103.773 220.918",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "165.61826",
      "y1": "179.77709",
      "x2": "152.68698",
      "y2": "161.97871",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152.227 220.919 165.618 179.777 208.884 179.754",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "188.86762",
      "y1": "108.22291",
      "x2": "167.94437",
      "y2": "115.02129",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "223.857 133.673 188.868 108.223 202.216 67.068",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bE = [];
/* style */

const __vue_inject_styles__$bE = undefined;
/* scoped */

const __vue_scope_id__$bE = undefined;
/* module identifier */

const __vue_module_identifier__$bE = undefined;
/* functional template */

const __vue_is_functional_template__$bE = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bE = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bE,
  staticRenderFns: __vue_staticRenderFns__$bE
}, __vue_inject_styles__$bE, __vue_script__$bE, __vue_scope_id__$bE, __vue_is_functional_template__$bE, __vue_module_identifier__$bE, false, undefined, undefined, undefined);

var script$bF = Vue.extend({
  name: "PhSortAscending",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bF = script$bF;
/* template */

var __vue_render__$bF = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "144 167.994 184 207.994 223.999 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "111.99347",
      "x2": "184",
      "y2": "207.99347",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "127.99353",
      "x2": "119.99902",
      "y2": "127.99353",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "63.99353",
      "x2": "183.99902",
      "y2": "63.99353",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "191.99353",
      "x2": "104",
      "y2": "191.99353",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "144 167.994 184 207.994 223.999 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "111.99347",
      "x2": "184",
      "y2": "207.99347",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "127.99353",
      "x2": "119.99902",
      "y2": "127.99353",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "63.99353",
      "x2": "183.99902",
      "y2": "63.99353",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "191.99353",
      "x2": "104",
      "y2": "191.99353",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M229.65527,173.65759l-39.999,39.99317a8,8,0,0,1-11.313,0l-40-40A8.00037,8.00037,0,0,1,144,159.99353h.001l31.999.00293V111.99353a8,8,0,0,1,16,0v48.00391l32,.00293a7.99976,7.99976,0,0,1,5.65527,13.65722ZM119.999,119.99353H48a8,8,0,0,0,0,16h71.999a8,8,0,1,0,0-16Zm-71.999-48H183.999a8,8,0,0,0,0-16H48a8,8,0,1,0,0,16Zm56,112H48a8,8,0,0,0,0,16h56a8,8,0,0,0,0-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "144 167.994 184 207.994 223.999 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "111.99347",
      "x2": "184",
      "y2": "207.99347",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "127.99353",
      "x2": "119.99902",
      "y2": "127.99353",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "63.99353",
      "x2": "183.99902",
      "y2": "63.99353",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "191.99353",
      "x2": "104",
      "y2": "191.99353",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "144 167.994 184 207.994 223.999 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "111.99347",
      "x2": "184",
      "y2": "207.99347",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "127.99353",
      "x2": "119.99902",
      "y2": "127.99353",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "63.99353",
      "x2": "183.99902",
      "y2": "63.99353",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "191.99353",
      "x2": "104",
      "y2": "191.99353",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "144 167.994 184 207.994 223.999 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "111.99347",
      "x2": "184",
      "y2": "207.99347",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "127.99353",
      "x2": "119.99902",
      "y2": "127.99353",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "63.99353",
      "x2": "183.99902",
      "y2": "63.99353",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "191.99353",
      "x2": "104",
      "y2": "191.99353",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bF = [];
/* style */

const __vue_inject_styles__$bF = undefined;
/* scoped */

const __vue_scope_id__$bF = undefined;
/* module identifier */

const __vue_module_identifier__$bF = undefined;
/* functional template */

const __vue_is_functional_template__$bF = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bF = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bF,
  staticRenderFns: __vue_staticRenderFns__$bF
}, __vue_inject_styles__$bF, __vue_script__$bF, __vue_scope_id__$bF, __vue_is_functional_template__$bF, __vue_module_identifier__$bF, false, undefined, undefined, undefined);

var script$bG = Vue.extend({
  name: "PhSortDescending",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bG = script$bG;
/* template */

var __vue_render__$bG = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "144 87.994 184 47.994 223.999 87.987",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "143.99359",
      "x2": "184",
      "y2": "47.99359",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "127.99353",
      "x2": "119.99902",
      "y2": "127.99353",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "63.99353",
      "x2": "103.99902",
      "y2": "63.99353",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "191.99353",
      "x2": "183.99902",
      "y2": "191.99353",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "144 87.994 184 47.994 223.999 87.987",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "143.99359",
      "x2": "184",
      "y2": "47.99359",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "127.99353",
      "x2": "119.99902",
      "y2": "127.99353",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "63.99353",
      "x2": "103.99902",
      "y2": "63.99353",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "191.99353",
      "x2": "183.99902",
      "y2": "191.99353",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M231.39062,91.04724A7.99937,7.99937,0,0,1,224,95.9867l-32,.00268v48.00415a8,8,0,0,1-16,0V95.99085l-31.999.00268a8.00037,8.00037,0,0,1-5.65772-13.65723l40-40a8.00122,8.00122,0,0,1,11.313,0l39.999,39.99317A8.00019,8.00019,0,0,1,231.39062,91.04724ZM48,135.99353h71.999a8,8,0,1,0,0-16H48a8,8,0,0,0,0,16Zm0-64h55.999a8,8,0,0,0,0-16H48a8,8,0,1,0,0,16Zm135.999,112H48a8,8,0,0,0,0,16H183.999a8,8,0,0,0,0-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "144 87.994 184 47.994 223.999 87.987",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "143.99359",
      "x2": "184",
      "y2": "47.99359",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "127.99353",
      "x2": "119.99902",
      "y2": "127.99353",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "63.99353",
      "x2": "103.99902",
      "y2": "63.99353",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "191.99353",
      "x2": "183.99902",
      "y2": "191.99353",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "144 87.994 184 47.994 223.999 87.987",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "143.99359",
      "x2": "184",
      "y2": "47.99359",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "127.99353",
      "x2": "119.99902",
      "y2": "127.99353",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "63.99353",
      "x2": "103.99902",
      "y2": "63.99353",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "191.99353",
      "x2": "183.99902",
      "y2": "191.99353",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "144 87.994 184 47.994 223.999 87.987",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "143.99359",
      "x2": "184",
      "y2": "47.99359",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "127.99353",
      "x2": "119.99902",
      "y2": "127.99353",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "63.99353",
      "x2": "103.99902",
      "y2": "63.99353",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "191.99353",
      "x2": "183.99902",
      "y2": "191.99353",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bG = [];
/* style */

const __vue_inject_styles__$bG = undefined;
/* scoped */

const __vue_scope_id__$bG = undefined;
/* module identifier */

const __vue_module_identifier__$bG = undefined;
/* functional template */

const __vue_is_functional_template__$bG = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bG = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bG,
  staticRenderFns: __vue_staticRenderFns__$bG
}, __vue_inject_styles__$bG, __vue_script__$bG, __vue_scope_id__$bG, __vue_is_functional_template__$bG, __vue_module_identifier__$bG, false, undefined, undefined, undefined);

var script$bH = Vue.extend({
  name: "PhSpade",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bH = script$bH;
/* template */

var __vue_render__$bH = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M160,232H96l8.66461-46.21023A52.01694,52.01694,0,0,1,28,140C28,88,128,24,128,24S228,88,228,140a52.01693,52.01693,0,0,1-76.66484,45.78964Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24S228,88,228,140a52.00142,52.00142,0,0,1-85.37486,39.87791L160,232H96l17.37486-52.12209A52.00142,52.00142,0,0,1,28,140C28,88,128,24,128,24Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,24S228,88,228,140a52.00142,52.00142,0,0,1-85.37486,39.87791L160,232H96l17.37486-52.12209A52.00142,52.00142,0,0,1,28,140C28,88,128,24,128,24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232,140a55.99915,55.99915,0,0,1-81.90137,49.64941l11.94092,35.82129A7.99929,7.99929,0,0,1,154.4502,236H101.5498a7.99966,7.99966,0,0,1-7.58935-10.53027l11.94092-35.82032A55.99915,55.99915,0,0,1,24,140C24,86.42676,121.68555,23.292,125.84375,20.63086a3.9978,3.9978,0,0,1,4.3125,0C134.31445,23.292,232,86.42676,232,140Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24S228,88,228,140a52.00142,52.00142,0,0,1-85.37486,39.87791L160,232H96l17.37486-52.12209A52.00142,52.00142,0,0,1,28,140C28,88,128,24,128,24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24S228,88,228,140a52.00142,52.00142,0,0,1-85.37486,39.87791L160,232H96l17.37486-52.12209A52.00142,52.00142,0,0,1,28,140C28,88,128,24,128,24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24S228,88,228,140a52.00142,52.00142,0,0,1-85.37486,39.87791L160,232H96l17.37486-52.12209A52.00142,52.00142,0,0,1,28,140C28,88,128,24,128,24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bH = [];
/* style */

const __vue_inject_styles__$bH = undefined;
/* scoped */

const __vue_scope_id__$bH = undefined;
/* module identifier */

const __vue_module_identifier__$bH = undefined;
/* functional template */

const __vue_is_functional_template__$bH = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bH = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bH,
  staticRenderFns: __vue_staticRenderFns__$bH
}, __vue_inject_styles__$bH, __vue_script__$bH, __vue_scope_id__$bH, __vue_is_functional_template__$bH, __vue_module_identifier__$bH, false, undefined, undefined, undefined);

var script$bI = Vue.extend({
  name: "PhSparkle",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bI = script$bI;
/* template */

var __vue_render__$bI = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M138.72355,175.46465l-19.21681,52.1599a8,8,0,0,1-15.01348,0l-19.21681-52.1599a8,8,0,0,0-4.7411-4.7411l-52.1599-19.21681a8,8,0,0,1,0-15.01348l52.1599-19.21681a8,8,0,0,0,4.7411-4.7411l19.21681-52.1599a8,8,0,0,1,15.01348,0l19.21681,52.1599a8,8,0,0,0,4.7411,4.7411l52.1599,19.21681a8,8,0,0,1,0,15.01348l-52.1599,19.21681A8,8,0,0,0,138.72355,175.46465Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "16",
      "x2": "176",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "40",
      "x2": "152",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "72",
      "x2": "224",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "240",
      "y1": "88",
      "x2": "208",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M138.72355,175.46465l-19.21681,52.1599a8,8,0,0,1-15.01348,0l-19.21681-52.1599a8,8,0,0,0-4.7411-4.7411l-52.1599-19.21681a8,8,0,0,1,0-15.01348l52.1599-19.21681a8,8,0,0,0,4.7411-4.7411l19.21681-52.1599a8,8,0,0,1,15.01348,0l19.21681,52.1599a8,8,0,0,0,4.7411,4.7411l52.1599,19.21681a8,8,0,0,1,0,15.01348l-52.1599,19.21681A8,8,0,0,0,138.72355,175.46465Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M138.72355,175.46465l-19.21681,52.1599a8,8,0,0,1-15.01348,0l-19.21681-52.1599a8,8,0,0,0-4.7411-4.7411l-52.1599-19.21681a8,8,0,0,1,0-15.01348l52.1599-19.21681a8,8,0,0,0,4.7411-4.7411l19.21681-52.1599a8,8,0,0,1,15.01348,0l19.21681,52.1599a8,8,0,0,0,4.7411,4.7411l52.1599,19.21681a8,8,0,0,1,0,15.01348l-52.1599,19.21681A8,8,0,0,0,138.72355,175.46465Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "16",
      "x2": "176",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "40",
      "x2": "152",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "72",
      "x2": "224",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "240",
      "y1": "88",
      "x2": "208",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208.8584,144a15.85626,15.85626,0,0,1-10.46778,15.01367l-52.16015,19.2168-19.2168,52.16015a16.00075,16.00075,0,0,1-30.02734,0l-19.2168-52.16015-52.16015-19.2168a16.00075,16.00075,0,0,1,0-30.02734l52.16015-19.2168,19.2168-52.16015a16.00075,16.00075,0,0,1,30.02734,0l19.2168,52.16015,52.16015,19.2168A15.85626,15.85626,0,0,1,208.8584,144ZM152,48h16V64a8,8,0,0,0,16,0V48h16a8,8,0,0,0,0-16H184V16a8,8,0,0,0-16,0V32H152a8,8,0,0,0,0,16Zm88,32h-8V72a8,8,0,0,0-16,0v8h-8a8,8,0,0,0,0,16h8v8a8,8,0,0,0,16,0V96h8a8,8,0,0,0,0-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M138.72355,175.46465l-19.21681,52.1599a8,8,0,0,1-15.01348,0l-19.21681-52.1599a8,8,0,0,0-4.7411-4.7411l-52.1599-19.21681a8,8,0,0,1,0-15.01348l52.1599-19.21681a8,8,0,0,0,4.7411-4.7411l19.21681-52.1599a8,8,0,0,1,15.01348,0l19.21681,52.1599a8,8,0,0,0,4.7411,4.7411l52.1599,19.21681a8,8,0,0,1,0,15.01348l-52.1599,19.21681A8,8,0,0,0,138.72355,175.46465Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "16",
      "x2": "176",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "40",
      "x2": "152",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "72",
      "x2": "224",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "240",
      "y1": "88",
      "x2": "208",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M138.72355,175.46465l-19.21681,52.1599a8,8,0,0,1-15.01348,0l-19.21681-52.1599a8,8,0,0,0-4.7411-4.7411l-52.1599-19.21681a8,8,0,0,1,0-15.01348l52.1599-19.21681a8,8,0,0,0,4.7411-4.7411l19.21681-52.1599a8,8,0,0,1,15.01348,0l19.21681,52.1599a8,8,0,0,0,4.7411,4.7411l52.1599,19.21681a8,8,0,0,1,0,15.01348l-52.1599,19.21681A8,8,0,0,0,138.72355,175.46465Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "16",
      "x2": "176",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "40",
      "x2": "152",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "72",
      "x2": "224",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "240",
      "y1": "88",
      "x2": "208",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M138.72355,175.46465l-19.21681,52.1599a8,8,0,0,1-15.01348,0l-19.21681-52.1599a8,8,0,0,0-4.7411-4.7411l-52.1599-19.21681a8,8,0,0,1,0-15.01348l52.1599-19.21681a8,8,0,0,0,4.7411-4.7411l19.21681-52.1599a8,8,0,0,1,15.01348,0l19.21681,52.1599a8,8,0,0,0,4.7411,4.7411l52.1599,19.21681a8,8,0,0,1,0,15.01348l-52.1599,19.21681A8,8,0,0,0,138.72355,175.46465Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "16",
      "x2": "176",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "40",
      "x2": "152",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "72",
      "x2": "224",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "240",
      "y1": "88",
      "x2": "208",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bI = [];
/* style */

const __vue_inject_styles__$bI = undefined;
/* scoped */

const __vue_scope_id__$bI = undefined;
/* module identifier */

const __vue_module_identifier__$bI = undefined;
/* functional template */

const __vue_is_functional_template__$bI = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bI = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bI,
  staticRenderFns: __vue_staticRenderFns__$bI
}, __vue_inject_styles__$bI, __vue_script__$bI, __vue_scope_id__$bI, __vue_is_functional_template__$bI, __vue_module_identifier__$bI, false, undefined, undefined, undefined);

var script$bJ = Vue.extend({
  name: "PhSpeakerHigh",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bJ = script$bJ;
/* template */

var __vue_render__$bJ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M218.89989,77.08831a72,72,0,0,1,0,101.82338",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "79.98242",
      "y1": "88",
      "x2": "79.98242",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M190.61551,105.37258a32,32,0,0,1,0,45.25484",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M218.91161,77.08831a72,72,0,0,1,0,101.82338",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "79.9707",
      "y1": "88",
      "x2": "79.9707",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M190.62723,105.37258a32,32,0,0,1,0,45.25484",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M224.56836,71.43935a8.00053,8.00053,0,0,0-11.31445,11.31446,63.99788,63.99788,0,0,1,0,90.50976A8.00053,8.00053,0,0,0,224.56836,184.578a80.00148,80.00148,0,0,0,0-113.13868Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M155.51465,24.82217a7.99448,7.99448,0,0,0-8.42578.87207l-69.834,54.31445H32a16.01833,16.01833,0,0,0-16,16v64a16.01833,16.01833,0,0,0,16,16H77.25488l69.834,54.31445A7.99958,7.99958,0,0,0,160,224.00869v-192A7.9997,7.9997,0,0,0,155.51465,24.82217ZM32,96.00869H71.9707v64H32Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184.96973,99.72549a7.99913,7.99913,0,0,0,.001,11.31347,23.99832,23.99832,0,0,1,0,33.93946,7.99983,7.99983,0,1,0,11.3125,11.31445,39.99719,39.99719,0,0,0,0-56.56836A7.99825,7.99825,0,0,0,184.96973,99.72549Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M218.894,77.08831a72,72,0,0,1,0,101.82338",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "79.98828",
      "y1": "88",
      "x2": "79.98828",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M190.60965,105.37258a32,32,0,0,1,0,45.25484",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M218.88817,77.08831a72,72,0,0,1,0,101.82338",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "79.99414",
      "y1": "88",
      "x2": "79.99414",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M190.60379,105.37258a32,32,0,0,1,0,45.25484",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M218.88231,77.08831a72,72,0,0,1,0,101.82338",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "88",
      "x2": "80",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M190.59793,105.37258a32,32,0,0,1,0,45.25484",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bJ = [];
/* style */

const __vue_inject_styles__$bJ = undefined;
/* scoped */

const __vue_scope_id__$bJ = undefined;
/* module identifier */

const __vue_module_identifier__$bJ = undefined;
/* functional template */

const __vue_is_functional_template__$bJ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bJ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bJ,
  staticRenderFns: __vue_staticRenderFns__$bJ
}, __vue_inject_styles__$bJ, __vue_script__$bJ, __vue_scope_id__$bJ, __vue_is_functional_template__$bJ, __vue_module_identifier__$bJ, false, undefined, undefined, undefined);

var script$bK = Vue.extend({
  name: "PhSpeakerLow",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bK = script$bK;
/* template */

var __vue_render__$bK = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "79.98242",
      "y1": "88",
      "x2": "79.98242",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M190.61551,105.37258a32,32,0,0,1,0,45.25484",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "79.9707",
      "y1": "88",
      "x2": "79.9707",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M190.62723,105.37258a32,32,0,0,1,0,45.25484",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M155.51465,24.81927a7.99655,7.99655,0,0,0-8.42578.87207l-69.834,54.31445H32a16.01833,16.01833,0,0,0-16,16v64a16.01833,16.01833,0,0,0,16,16H77.25488l69.834,54.31446A7.99958,7.99958,0,0,0,160,224.00579v-192A7.9997,7.9997,0,0,0,155.51465,24.81927ZM32,96.00579H71.9707v64H32Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M196.2832,99.72161a7.99984,7.99984,0,0,0-11.3125,11.31446,23.99831,23.99831,0,0,1,0,33.93945A7.99983,7.99983,0,1,0,196.2832,156.29a39.99719,39.99719,0,0,0,0-56.56836Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "79.98828",
      "y1": "88",
      "x2": "79.98828",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M190.60965,105.37258a32,32,0,0,1,0,45.25484",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "79.99414",
      "y1": "88",
      "x2": "79.99414",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M190.60379,105.37258a32,32,0,0,1,0,45.25484",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "88",
      "x2": "80",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M190.59793,105.37258a32,32,0,0,1,0,45.25484",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bK = [];
/* style */

const __vue_inject_styles__$bK = undefined;
/* scoped */

const __vue_scope_id__$bK = undefined;
/* module identifier */

const __vue_module_identifier__$bK = undefined;
/* functional template */

const __vue_is_functional_template__$bK = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bK = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bK,
  staticRenderFns: __vue_staticRenderFns__$bK
}, __vue_inject_styles__$bK, __vue_script__$bK, __vue_scope_id__$bK, __vue_is_functional_template__$bK, __vue_module_identifier__$bK, false, undefined, undefined, undefined);

var script$bL = Vue.extend({
  name: "PhSpeakerNone",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bL = script$bL;
/* template */

var __vue_render__$bL = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "79.98242",
      "y1": "88",
      "x2": "79.98242",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "79.9707",
      "y1": "88",
      "x2": "79.9707",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M155.51465,24.81637a7.99655,7.99655,0,0,0-8.42578.87207L77.25488,80.0029H32a16.01833,16.01833,0,0,0-16,16v64a16.01833,16.01833,0,0,0,16,16H77.25488l69.834,54.31445A7.99958,7.99958,0,0,0,160,224.0029v-192A7.99972,7.99972,0,0,0,155.51465,24.81637ZM32,96.0029H71.9707v64H32Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "79.98828",
      "y1": "88",
      "x2": "79.98828",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "79.99414",
      "y1": "88",
      "x2": "79.99414",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "88",
      "x2": "80",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bL = [];
/* style */

const __vue_inject_styles__$bL = undefined;
/* scoped */

const __vue_scope_id__$bL = undefined;
/* module identifier */

const __vue_module_identifier__$bL = undefined;
/* functional template */

const __vue_is_functional_template__$bL = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bL = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bL,
  staticRenderFns: __vue_staticRenderFns__$bL
}, __vue_inject_styles__$bL, __vue_script__$bL, __vue_scope_id__$bL, __vue_is_functional_template__$bL, __vue_module_identifier__$bL, false, undefined, undefined, undefined);

var script$bM = Vue.extend({
  name: "PhSpeakerSimpleHigh",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bM = script$bM;
/* template */

var __vue_render__$bM = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "191.98828",
      "y1": "104",
      "x2": "191.98828",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "227.98828",
      "y1": "88",
      "x2": "227.98828",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "104",
      "x2": "192",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "88",
      "x2": "224",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M155.50977,24.80957a7.993,7.993,0,0,0-8.42188.875L77.24414,79.99707h-45.25a16.01583,16.01583,0,0,0-16,16v64a16.01583,16.01583,0,0,0,16,16h45.25l69.84375,54.3125a7.99451,7.99451,0,0,0,12.90625-6.3125v-192A7.99374,7.99374,0,0,0,155.50977,24.80957Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M191.99414,96a8.00039,8.00039,0,0,0-8,8v48a8,8,0,0,0,16,0V104A8.00039,8.00039,0,0,0,191.99414,96Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M223.99414,80a8.00039,8.00039,0,0,0-8,8v80a8,8,0,0,0,16,0V88A8.00039,8.00039,0,0,0,223.99414,80Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "191.98242",
      "y1": "104",
      "x2": "191.98242",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "223.98242",
      "y1": "88",
      "x2": "223.98242",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "191.97656",
      "y1": "104",
      "x2": "191.97656",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "223.97656",
      "y1": "88",
      "x2": "223.97656",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "191.9707",
      "y1": "104",
      "x2": "191.9707",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "223.9707",
      "y1": "88",
      "x2": "223.9707",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bM = [];
/* style */

const __vue_inject_styles__$bM = undefined;
/* scoped */

const __vue_scope_id__$bM = undefined;
/* module identifier */

const __vue_module_identifier__$bM = undefined;
/* functional template */

const __vue_is_functional_template__$bM = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bM = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bM,
  staticRenderFns: __vue_staticRenderFns__$bM
}, __vue_inject_styles__$bM, __vue_script__$bM, __vue_scope_id__$bM, __vue_is_functional_template__$bM, __vue_module_identifier__$bM, false, undefined, undefined, undefined);

var script$bN = Vue.extend({
  name: "PhSpeakerSimpleLow",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bN = script$bN;
/* template */

var __vue_render__$bN = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "191.98828",
      "y1": "104",
      "x2": "191.98828",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "104",
      "x2": "192",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M155.50977,24.80957a7.993,7.993,0,0,0-8.42188.875L77.24414,79.99707h-45.25a16.01583,16.01583,0,0,0-16,16v64a16.01583,16.01583,0,0,0,16,16h45.25l69.84375,54.3125a7.99451,7.99451,0,0,0,12.90625-6.3125v-192A7.99374,7.99374,0,0,0,155.50977,24.80957Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M191.99414,96a8.00039,8.00039,0,0,0-8,8v48a8,8,0,0,0,16,0V104A8.00039,8.00039,0,0,0,191.99414,96Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "191.98242",
      "y1": "104",
      "x2": "191.98242",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "191.97656",
      "y1": "104",
      "x2": "191.97656",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "191.9707",
      "y1": "104",
      "x2": "191.9707",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bN = [];
/* style */

const __vue_inject_styles__$bN = undefined;
/* scoped */

const __vue_scope_id__$bN = undefined;
/* module identifier */

const __vue_module_identifier__$bN = undefined;
/* functional template */

const __vue_is_functional_template__$bN = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bN = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bN,
  staticRenderFns: __vue_staticRenderFns__$bN
}, __vue_inject_styles__$bN, __vue_script__$bN, __vue_scope_id__$bN, __vue_is_functional_template__$bN, __vue_module_identifier__$bN, false, undefined, undefined, undefined);

var script$bO = Vue.extend({
  name: "PhSpeakerSimpleNone",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bO = script$bO;
/* template */

var __vue_render__$bO = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M155.50977,24.8096a7.993,7.993,0,0,0-8.42188.875L77.24414,79.9971h-45.25a16.01583,16.01583,0,0,0-16,16v64a16.01582,16.01582,0,0,0,16,16h45.25l69.84375,54.3125a7.99451,7.99451,0,0,0,12.90625-6.3125v-192A7.99375,7.99375,0,0,0,155.50977,24.8096Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bO = [];
/* style */

const __vue_inject_styles__$bO = undefined;
/* scoped */

const __vue_scope_id__$bO = undefined;
/* module identifier */

const __vue_module_identifier__$bO = undefined;
/* functional template */

const __vue_is_functional_template__$bO = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bO = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bO,
  staticRenderFns: __vue_staticRenderFns__$bO
}, __vue_inject_styles__$bO, __vue_script__$bO, __vue_scope_id__$bO, __vue_is_functional_template__$bO, __vue_module_identifier__$bO, false, undefined, undefined, undefined);

var script$bP = Vue.extend({
  name: "PhSpeakerSimpleSlash",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bP = script$bP;
/* template */

var __vue_render__$bP = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "227.97656",
      "y1": "88",
      "x2": "227.97656",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,154.4V224L80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H91.63636",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "118.484 58.068 152 32 152 94.935",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "191.97656",
      "y1": "104",
      "x2": "191.97656",
      "y2": "138.9095",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "191.97656",
      "y1": "104",
      "x2": "191.97656",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "223.97656",
      "y1": "88",
      "x2": "223.97656",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "112.15 62.994 152 32 152 106.829",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,154.4V224L80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H91.63636",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M191.97656,160a8.00039,8.00039,0,0,0,8-8V104a8,8,0,0,0-16,0v48A8.00039,8.00039,0,0,0,191.97656,160Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M223.97656,80a8.00039,8.00039,0,0,0-8,8v80a8,8,0,1,0,16,0V88A8.00039,8.00039,0,0,0,223.97656,80Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M53.91992,34.61813A8.0006,8.0006,0,1,0,42.08008,45.3818L73.55127,80H32A16.01833,16.01833,0,0,0,16,96v64a16.01833,16.01833,0,0,0,16,16H77.25488l69.834,54.31445A7.99958,7.99958,0,0,0,160,224V175.09372l42.08008,46.28808a8.0006,8.0006,0,1,0,11.83984-10.76367Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M146.08008,112.2109A8.0004,8.0004,0,0,0,160,106.82907V32a7.99958,7.99958,0,0,0-12.91113-6.31446L107.23926,56.67965a7.99966,7.99966,0,0,0-1.00879,11.69629Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "191.97656",
      "y1": "104",
      "x2": "191.97656",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "223.97656",
      "y1": "88",
      "x2": "223.97656",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "112.15 62.994 152 32 152 106.829",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,154.4V224L80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H91.63636",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "191.97656",
      "y1": "104",
      "x2": "191.97656",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "223.97656",
      "y1": "88",
      "x2": "223.97656",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "112.15 62.994 152 32 152 106.829",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,154.4V224L80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H91.63636",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "191.97656",
      "y1": "104",
      "x2": "191.97656",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "223.97656",
      "y1": "88",
      "x2": "223.97656",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "112.15 62.994 152 32 152 106.829",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,154.4V224L80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H91.63636",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bP = [];
/* style */

const __vue_inject_styles__$bP = undefined;
/* scoped */

const __vue_scope_id__$bP = undefined;
/* module identifier */

const __vue_module_identifier__$bP = undefined;
/* functional template */

const __vue_is_functional_template__$bP = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bP = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bP,
  staticRenderFns: __vue_staticRenderFns__$bP
}, __vue_inject_styles__$bP, __vue_script__$bP, __vue_scope_id__$bP, __vue_is_functional_template__$bP, __vue_module_identifier__$bP, false, undefined, undefined, undefined);

var script$bQ = Vue.extend({
  name: "PhSpeakerSimpleX",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bQ = script$bQ;
/* template */

var __vue_render__$bQ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "239.99997",
      "y1": "104",
      "x2": "191.99997",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "239.99997",
      "y1": "152",
      "x2": "191.99997",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "239.99997",
      "y1": "104",
      "x2": "191.99997",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "239.99997",
      "y1": "152",
      "x2": "191.99997",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M155.50977,24.80957a7.993,7.993,0,0,0-8.42188.875L77.24414,79.99707h-45.25a16.01583,16.01583,0,0,0-16,16v64a16.01583,16.01583,0,0,0,16,16h45.25l69.84375,54.3125a7.99451,7.99451,0,0,0,12.90625-6.3125v-192A7.99374,7.99374,0,0,0,155.50977,24.80957Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M227.30664,127.99707l18.34375-18.34375a7.99915,7.99915,0,0,0-11.3125-11.3125l-18.34375,18.34375L197.65039,98.34082a7.99915,7.99915,0,0,0-11.3125,11.3125l18.34375,18.34375-18.34375,18.34375a7.99915,7.99915,0,1,0,11.3125,11.3125l18.34375-18.34375,18.34375,18.34375a7.99915,7.99915,0,0,0,11.3125-11.3125Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "239.99997",
      "y1": "104",
      "x2": "191.99997",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "239.99997",
      "y1": "152",
      "x2": "191.99997",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "239.99997",
      "y1": "104",
      "x2": "191.99997",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "239.99997",
      "y1": "152",
      "x2": "191.99997",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "239.99997",
      "y1": "104",
      "x2": "191.99997",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "239.99997",
      "y1": "152",
      "x2": "191.99997",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bQ = [];
/* style */

const __vue_inject_styles__$bQ = undefined;
/* scoped */

const __vue_scope_id__$bQ = undefined;
/* module identifier */

const __vue_module_identifier__$bQ = undefined;
/* functional template */

const __vue_is_functional_template__$bQ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bQ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bQ,
  staticRenderFns: __vue_staticRenderFns__$bQ
}, __vue_inject_styles__$bQ, __vue_script__$bQ, __vue_scope_id__$bQ, __vue_is_functional_template__$bQ, __vue_module_identifier__$bQ, false, undefined, undefined, undefined);

var script$bR = Vue.extend({
  name: "PhSpeakerSlash",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bR = script$bR;
/* template */

var __vue_render__$bR = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "79.99414",
      "y1": "88.01159",
      "x2": "79.99414",
      "y2": "168.01159",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,154.4v69.61162l-72-56H32a8,8,0,0,1-8-8v-64a8,8,0,0,1,8-8H80L86.82274,82.705",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "118.49 58.075 152 32.012 152 94.935",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M190.60379,105.38417a32.01923,32.01923,0,0,1,5.51036,37.88051",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M218.88817,77.0999a72.00424,72.00424,0,0,1,4.72754,96.61262",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M218.88817,77.0999a72,72,0,0,1,0,101.82337",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "79.99414",
      "y1": "88.01159",
      "x2": "79.99414",
      "y2": "168.01159",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M190.60379,105.38417a32,32,0,0,1,0,45.25483",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,154.4v69.61162l-72-56H32a8,8,0,0,1-8-8v-64a8,8,0,0,1,8-8H80L86.82274,82.705",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "112.156 63.001 152 32.012 152 106.829",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M53.91992,34.61813A8.0006,8.0006,0,1,0,42.08008,45.3818L73.55371,80.0029H32a16.01833,16.01833,0,0,0-16,16v64a16.01833,16.01833,0,0,0,16,16H77.25488l69.834,54.31445-.00537-.01123.00439.00342a7.99451,7.99451,0,0,0,12.90625-6.3125V175.08737l42.08594,46.29443a8.0006,8.0006,0,1,0,11.83984-10.76367ZM71.9707,160.0029H32v-64H71.9707Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M146.08008,112.2109A8.0004,8.0004,0,0,0,160,106.82907V32.01169a7.99958,7.99958,0,0,0-12.91113-6.31446L107.24512,56.68649a7.99966,7.99966,0,0,0-1.00879,11.69629Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224.544,71.44235a7.99983,7.99983,0,1,0-11.3125,11.31445,63.99908,63.99908,0,0,1,0,90.50879A7.99983,7.99983,0,1,0,224.544,184.58a79.99795,79.99795,0,0,0,0-113.13769Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M191.97656,128.01169a23.83779,23.83779,0,0,1-7.02929,16.96972,7.99984,7.99984,0,1,0,11.3125,11.31446,39.99957,39.99957,0,0,0,.001-56.56934A8.00052,8.00052,0,0,0,184.94629,111.041,23.84269,23.84269,0,0,1,191.97656,128.01169Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M218.88817,77.0999a72,72,0,0,1,0,101.82337",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "79.99414",
      "y1": "88.01159",
      "x2": "79.99414",
      "y2": "168.01159",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M190.60379,105.38417a32,32,0,0,1,0,45.25483",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,154.4v69.61162l-72-56H32a8,8,0,0,1-8-8v-64a8,8,0,0,1,8-8H80L86.82274,82.705",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "112.156 63.001 152 32.012 152 106.829",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M218.88817,77.0999a72,72,0,0,1,0,101.82337",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "79.99414",
      "y1": "88.01159",
      "x2": "79.99414",
      "y2": "168.01159",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M190.60379,105.38417a32,32,0,0,1,0,45.25483",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,154.4v69.61162l-72-56H32a8,8,0,0,1-8-8v-64a8,8,0,0,1,8-8H80L86.82274,82.705",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "112.156 63.001 152 32.012 152 106.829",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M218.88817,77.0999a72,72,0,0,1,0,101.82337",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "79.99414",
      "y1": "88.01159",
      "x2": "79.99414",
      "y2": "168.01159",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M190.60379,105.38417a32,32,0,0,1,0,45.25483",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,154.4v69.61162l-72-56H32a8,8,0,0,1-8-8v-64a8,8,0,0,1,8-8H80L86.82274,82.705",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "112.156 63.001 152 32.012 152 106.829",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bR = [];
/* style */

const __vue_inject_styles__$bR = undefined;
/* scoped */

const __vue_scope_id__$bR = undefined;
/* module identifier */

const __vue_module_identifier__$bR = undefined;
/* functional template */

const __vue_is_functional_template__$bR = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bR = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bR,
  staticRenderFns: __vue_staticRenderFns__$bR
}, __vue_inject_styles__$bR, __vue_script__$bR, __vue_scope_id__$bR, __vue_is_functional_template__$bR, __vue_module_identifier__$bR, false, undefined, undefined, undefined);

var script$bS = Vue.extend({
  name: "PhSpeakerX",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bS = script$bS;
/* template */

var __vue_render__$bS = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "239.99997",
      "y1": "104",
      "x2": "191.99997",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "239.99997",
      "y1": "152",
      "x2": "191.99997",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "79.98242",
      "y1": "88",
      "x2": "79.98242",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "239.99997",
      "y1": "104",
      "x2": "191.99997",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "239.99997",
      "y1": "152",
      "x2": "191.99997",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "79.9707",
      "y1": "88",
      "x2": "79.9707",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M155.51465,24.81348a7.99448,7.99448,0,0,0-8.42578.87207L77.25488,80H32A16.01833,16.01833,0,0,0,16,96v64a16.01833,16.01833,0,0,0,16,16H77.25488l69.834,54.31445A7.99958,7.99958,0,0,0,160,224V32A7.9997,7.9997,0,0,0,155.51465,24.81348ZM32,96H71.9707v64H32Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M227.31445,128l18.34278-18.34277a8.00053,8.00053,0,0,0-11.31446-11.31446L216,116.68555,197.65723,98.34277a8.00053,8.00053,0,0,0-11.31446,11.31446L204.68555,128l-18.34278,18.34277a8.00053,8.00053,0,0,0,11.31446,11.31446L216,139.31445l18.34277,18.34278a8.00053,8.00053,0,0,0,11.31446-11.31446Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "239.99997",
      "y1": "104",
      "x2": "191.99997",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "239.99997",
      "y1": "152",
      "x2": "191.99997",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "79.98828",
      "y1": "88",
      "x2": "79.98828",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "239.99997",
      "y1": "104",
      "x2": "191.99997",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "239.99997",
      "y1": "152",
      "x2": "191.99997",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "79.99414",
      "y1": "88",
      "x2": "79.99414",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "239.99997",
      "y1": "104",
      "x2": "191.99997",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "239.99997",
      "y1": "152",
      "x2": "191.99997",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "88",
      "x2": "80",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bS = [];
/* style */

const __vue_inject_styles__$bS = undefined;
/* scoped */

const __vue_scope_id__$bS = undefined;
/* module identifier */

const __vue_module_identifier__$bS = undefined;
/* functional template */

const __vue_is_functional_template__$bS = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bS = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bS,
  staticRenderFns: __vue_staticRenderFns__$bS
}, __vue_inject_styles__$bS, __vue_script__$bS, __vue_scope_id__$bS, __vue_is_functional_template__$bS, __vue_module_identifier__$bS, false, undefined, undefined, undefined);

var script$bT = Vue.extend({
  name: "PhSpinner",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bT = script$bT;
/* template */

var __vue_render__$bT = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "32",
      "x2": "128",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "195.88225",
      "y1": "60.11775",
      "x2": "173.25483",
      "y2": "82.74517",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "128",
      "x2": "192",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "195.88225",
      "y1": "195.88225",
      "x2": "173.25483",
      "y2": "173.25483",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "224",
      "x2": "128",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "60.11775",
      "y1": "195.88225",
      "x2": "82.74517",
      "y2": "173.25483",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "128",
      "x2": "64",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "60.11775",
      "y1": "60.11775",
      "x2": "82.74517",
      "y2": "82.74517",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "32",
      "x2": "128",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "195.88225",
      "y1": "60.11775",
      "x2": "173.25483",
      "y2": "82.74517",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "128",
      "x2": "192",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "195.88225",
      "y1": "195.88225",
      "x2": "173.25483",
      "y2": "173.25483",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "224",
      "x2": "128",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "60.11775",
      "y1": "195.88225",
      "x2": "82.74517",
      "y2": "173.25483",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "128",
      "x2": "64",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "60.11775",
      "y1": "60.11775",
      "x2": "82.74517",
      "y2": "82.74517",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M136,32V64a8,8,0,0,1-16,0V32a8,8,0,0,1,16,0Zm37.25488,58.74512a7.97769,7.97769,0,0,0,5.65723-2.34278l22.62695-22.62695a8.00052,8.00052,0,1,0-11.31445-11.31445l-22.627,22.627a8,8,0,0,0,5.65722,13.65723ZM224,120H192a8,8,0,0,0,0,16h32a8,8,0,0,0,0-16Zm-45.08789,47.59766a8.00052,8.00052,0,0,0-11.31445,11.31445l22.627,22.62695a8.00052,8.00052,0,1,0,11.31445-11.31445ZM128,184a8.00039,8.00039,0,0,0-8,8v32a8,8,0,0,0,16,0V192A8.00039,8.00039,0,0,0,128,184ZM77.08789,167.59766l-22.62695,22.627a8.00052,8.00052,0,0,0,11.31445,11.31445l22.62695-22.62695a8.00052,8.00052,0,0,0-11.31445-11.31445ZM72,128a8.00039,8.00039,0,0,0-8-8H32a8,8,0,0,0,0,16H64A8.00039,8.00039,0,0,0,72,128ZM65.77539,54.46094A8.00052,8.00052,0,0,0,54.46094,65.77539l22.627,22.62695A8.00052,8.00052,0,0,0,88.40234,77.08789Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "32",
      "x2": "128",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "195.88225",
      "y1": "60.11775",
      "x2": "173.25483",
      "y2": "82.74517",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "128",
      "x2": "192",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "195.88225",
      "y1": "195.88225",
      "x2": "173.25483",
      "y2": "173.25483",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "224",
      "x2": "128",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "60.11775",
      "y1": "195.88225",
      "x2": "82.74517",
      "y2": "173.25483",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "128",
      "x2": "64",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "60.11775",
      "y1": "60.11775",
      "x2": "82.74517",
      "y2": "82.74517",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "32",
      "x2": "128",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "195.88225",
      "y1": "60.11775",
      "x2": "173.25483",
      "y2": "82.74517",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "128",
      "x2": "192",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "195.88225",
      "y1": "195.88225",
      "x2": "173.25483",
      "y2": "173.25483",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "224",
      "x2": "128",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "60.11775",
      "y1": "195.88225",
      "x2": "82.74517",
      "y2": "173.25483",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "128",
      "x2": "64",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "60.11775",
      "y1": "60.11775",
      "x2": "82.74517",
      "y2": "82.74517",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "32",
      "x2": "128",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "195.88225",
      "y1": "60.11775",
      "x2": "173.25483",
      "y2": "82.74517",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "128",
      "x2": "192",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "195.88225",
      "y1": "195.88225",
      "x2": "173.25483",
      "y2": "173.25483",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "224",
      "x2": "128",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "60.11775",
      "y1": "195.88225",
      "x2": "82.74517",
      "y2": "173.25483",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "128",
      "x2": "64",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "60.11775",
      "y1": "60.11775",
      "x2": "82.74517",
      "y2": "82.74517",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bT = [];
/* style */

const __vue_inject_styles__$bT = undefined;
/* scoped */

const __vue_scope_id__$bT = undefined;
/* module identifier */

const __vue_module_identifier__$bT = undefined;
/* functional template */

const __vue_is_functional_template__$bT = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bT = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bT,
  staticRenderFns: __vue_staticRenderFns__$bT
}, __vue_inject_styles__$bT, __vue_script__$bT, __vue_scope_id__$bT, __vue_is_functional_template__$bT, __vue_module_identifier__$bT, false, undefined, undefined, undefined);

var script$bU = Vue.extend({
  name: "PhSpinnerGap",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bU = script$bU;
/* template */

var __vue_render__$bU = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "32",
      "x2": "128",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "128",
      "x2": "192",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "195.88225",
      "y1": "195.88225",
      "x2": "173.25483",
      "y2": "173.25483",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "224",
      "x2": "128",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "60.11775",
      "y1": "195.88225",
      "x2": "82.74517",
      "y2": "173.25483",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "128",
      "x2": "64",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "60.11775",
      "y1": "60.11775",
      "x2": "82.74517",
      "y2": "82.74517",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "32",
      "x2": "128",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "128",
      "x2": "192",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "195.88225",
      "y1": "195.88225",
      "x2": "173.25483",
      "y2": "173.25483",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "224",
      "x2": "128",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "60.11775",
      "y1": "195.88225",
      "x2": "82.74517",
      "y2": "173.25483",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "128",
      "x2": "64",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "60.11775",
      "y1": "60.11775",
      "x2": "82.74517",
      "y2": "82.74517",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M136,32V64a8,8,0,0,1-16,0V32a8,8,0,0,1,16,0Zm88,88H192a8,8,0,0,0,0,16h32a8,8,0,0,0,0-16Zm-45.08789,47.59766a8.00052,8.00052,0,0,0-11.31445,11.31445l22.627,22.62695a8.00052,8.00052,0,1,0,11.31445-11.31445ZM128,184a8.00039,8.00039,0,0,0-8,8v32a8,8,0,0,0,16,0V192A8.00039,8.00039,0,0,0,128,184ZM77.08789,167.59766l-22.62695,22.627a8.00052,8.00052,0,0,0,11.31445,11.31445l22.62695-22.62695a8.00052,8.00052,0,0,0-11.31445-11.31445ZM72,128a8.00039,8.00039,0,0,0-8-8H32a8,8,0,0,0,0,16H64A8.00039,8.00039,0,0,0,72,128ZM65.77539,54.46094A8.00052,8.00052,0,0,0,54.46094,65.77539l22.627,22.62695A8.00052,8.00052,0,0,0,88.40234,77.08789Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "32",
      "x2": "128",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "128",
      "x2": "192",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "195.88225",
      "y1": "195.88225",
      "x2": "173.25483",
      "y2": "173.25483",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "224",
      "x2": "128",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "60.11775",
      "y1": "195.88225",
      "x2": "82.74517",
      "y2": "173.25483",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "128",
      "x2": "64",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "60.11775",
      "y1": "60.11775",
      "x2": "82.74517",
      "y2": "82.74517",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "32",
      "x2": "128",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "128",
      "x2": "192",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "195.88225",
      "y1": "195.88225",
      "x2": "173.25483",
      "y2": "173.25483",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "224",
      "x2": "128",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "60.11775",
      "y1": "195.88225",
      "x2": "82.74517",
      "y2": "173.25483",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "128",
      "x2": "64",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "60.11775",
      "y1": "60.11775",
      "x2": "82.74517",
      "y2": "82.74517",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "32",
      "x2": "128",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "128",
      "x2": "192",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "195.88225",
      "y1": "195.88225",
      "x2": "173.25483",
      "y2": "173.25483",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "224",
      "x2": "128",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "60.11775",
      "y1": "195.88225",
      "x2": "82.74517",
      "y2": "173.25483",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "128",
      "x2": "64",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "60.11775",
      "y1": "60.11775",
      "x2": "82.74517",
      "y2": "82.74517",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bU = [];
/* style */

const __vue_inject_styles__$bU = undefined;
/* scoped */

const __vue_scope_id__$bU = undefined;
/* module identifier */

const __vue_module_identifier__$bU = undefined;
/* functional template */

const __vue_is_functional_template__$bU = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bU = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bU,
  staticRenderFns: __vue_staticRenderFns__$bU
}, __vue_inject_styles__$bU, __vue_script__$bU, __vue_scope_id__$bU, __vue_is_functional_template__$bU, __vue_module_identifier__$bU, false, undefined, undefined, undefined);

var script$bV = Vue.extend({
  name: "PhSpotifyLogo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bV = script$bV;
/* template */

var __vue_render__$bV = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M179.1333,116.32931a112.19069,112.19069,0,0,0-102.3584.04859",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M158.73682,155.34884a67.9512,67.9512,0,0,0-61.56592.04737",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M179.1333,108.32931a112.19069,112.19069,0,0,0-102.3584.04859",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M164.29541,136.71457a79.94058,79.94058,0,0,0-72.68359.04736",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M149.47217,165.07248a47.97816,47.97816,0,0,0-43.03662.04736",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.1179,104.1179,0,0,0,128,24Zm28.624,144.65722a8.00058,8.00058,0,0,1-10.73633,3.56641,39.98258,39.98258,0,0,0-35.85156.04,7.99966,7.99966,0,1,1-7.20117-14.28711,55.97479,55.97479,0,0,1,50.22217-.05566A7.99977,7.99977,0,0,1,156.624,168.65719Zm14.79737-28.30664a8.00153,8.00153,0,0,1-10.76221,3.49024,71.9412,71.9412,0,0,0-65.40234.042,7.99976,7.99976,0,1,1-7.29-14.24219,87.94,87.94,0,0,1,79.96484-.05176A7.9994,7.9994,0,0,1,171.42139,140.35055Zm14.82666-28.36426a8.00037,8.00037,0,0,1-10.77246,3.458,104.1903,104.1903,0,0,0-95.03614.04492,8,8,0,1,1-7.3291-14.22265,120.19311,120.19311,0,0,1,109.68066-.05274A7.99973,7.99973,0,0,1,186.24805,111.98629Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('g', [_c('path', {
    attrs: {
      "d": "M179.1333,108.32931a112.19069,112.19069,0,0,0-102.3584.04859",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M164.29541,136.71457a79.94058,79.94058,0,0,0-72.68359.04736",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M149.47217,165.07248a47.97816,47.97816,0,0,0-43.03662.04736",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })])]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('g', [_c('path', {
    attrs: {
      "d": "M179.1333,108.32931a112.19069,112.19069,0,0,0-102.3584.04859",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M164.29541,136.71457a79.94058,79.94058,0,0,0-72.68359.04736",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M149.47217,165.07248a47.97816,47.97816,0,0,0-43.03662.04736",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })])]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('g', [_c('path', {
    attrs: {
      "d": "M179.1333,108.32931a112.19069,112.19069,0,0,0-102.3584.04859",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M164.29541,136.71457a79.94058,79.94058,0,0,0-72.68359.04736",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M149.47217,165.07248a47.97816,47.97816,0,0,0-43.03662.04736",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })])]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bV = [];
/* style */

const __vue_inject_styles__$bV = undefined;
/* scoped */

const __vue_scope_id__$bV = undefined;
/* module identifier */

const __vue_module_identifier__$bV = undefined;
/* functional template */

const __vue_is_functional_template__$bV = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bV = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bV,
  staticRenderFns: __vue_staticRenderFns__$bV
}, __vue_inject_styles__$bV, __vue_script__$bV, __vue_scope_id__$bV, __vue_is_functional_template__$bV, __vue_module_identifier__$bV, false, undefined, undefined, undefined);

var script$bW = Vue.extend({
  name: "PhSquare",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bW = script$bW;
/* template */

var __vue_render__$bW = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "32",
      "width": "192",
      "height": "192",
      "rx": "16"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bW = [];
/* style */

const __vue_inject_styles__$bW = undefined;
/* scoped */

const __vue_scope_id__$bW = undefined;
/* module identifier */

const __vue_module_identifier__$bW = undefined;
/* functional template */

const __vue_is_functional_template__$bW = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bW = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bW,
  staticRenderFns: __vue_staticRenderFns__$bW
}, __vue_inject_styles__$bW, __vue_script__$bW, __vue_scope_id__$bW, __vue_is_functional_template__$bW, __vue_module_identifier__$bW, false, undefined, undefined, undefined);

var script$bX = Vue.extend({
  name: "PhSquareHalf",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bX = script$bX;
/* template */

var __vue_render__$bX = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "44",
      "y": "44",
      "width": "168",
      "height": "168",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "44",
      "x2": "128",
      "y2": "212",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "139.99414",
      "y1": "44",
      "x2": "212",
      "y2": "116.00586",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "127.99998",
      "y1": "88.00584",
      "x2": "212",
      "y2": "172.00586",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "127.99998",
      "y1": "144.00584",
      "x2": "195.99414",
      "y2": "212",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,44h76a8,8,0,0,1,8,8V204a8,8,0,0,1-8,8H128Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "44",
      "y": "44",
      "width": "168",
      "height": "168",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "44",
      "x2": "128",
      "y2": "212",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M204,36H52A16.01833,16.01833,0,0,0,36,52V204a16.01833,16.01833,0,0,0,16,16H204a16.01833,16.01833,0,0,0,16-16V52A16.01833,16.01833,0,0,0,204,36ZM52,52h76V204H52Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "44",
      "y": "44",
      "width": "168",
      "height": "168",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "44",
      "x2": "128",
      "y2": "212",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "139.99414",
      "y1": "44",
      "x2": "212",
      "y2": "116.00586",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "127.99998",
      "y1": "88.00584",
      "x2": "212",
      "y2": "172.00586",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "127.99998",
      "y1": "144.00584",
      "x2": "195.99414",
      "y2": "212",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "44",
      "y": "44",
      "width": "168",
      "height": "168",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "44",
      "x2": "128",
      "y2": "212",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "139.99414",
      "y1": "44",
      "x2": "212",
      "y2": "116.00586",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "127.99998",
      "y1": "88.00584",
      "x2": "212",
      "y2": "172.00586",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "127.99998",
      "y1": "144.00584",
      "x2": "195.99414",
      "y2": "212",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "44",
      "y": "44",
      "width": "168",
      "height": "168",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "44",
      "x2": "128",
      "y2": "212",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "139.99414",
      "y1": "44",
      "x2": "212",
      "y2": "116.00586",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "127.99998",
      "y1": "88.00584",
      "x2": "212",
      "y2": "172.00586",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "127.99998",
      "y1": "144.00584",
      "x2": "195.99414",
      "y2": "212",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bX = [];
/* style */

const __vue_inject_styles__$bX = undefined;
/* scoped */

const __vue_scope_id__$bX = undefined;
/* module identifier */

const __vue_module_identifier__$bX = undefined;
/* functional template */

const __vue_is_functional_template__$bX = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bX = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bX,
  staticRenderFns: __vue_staticRenderFns__$bX
}, __vue_inject_styles__$bX, __vue_script__$bX, __vue_scope_id__$bX, __vue_is_functional_template__$bX, __vue_module_identifier__$bX, false, undefined, undefined, undefined);

var script$bY = Vue.extend({
  name: "PhSquareLogo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bY = script$bY;
/* template */

var __vue_render__$bY = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40.00002",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "96",
      "y": "96.00002",
      "width": "64",
      "height": "64",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "96",
      "y": "96.00002",
      "width": "64",
      "height": "64",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40.00002",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "96",
      "y": "96.00002",
      "width": "64",
      "height": "64",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,32H48A16.01833,16.01833,0,0,0,32,48V208a16.01833,16.01833,0,0,0,16,16H208a16.01833,16.01833,0,0,0,16-16V48A16.01833,16.01833,0,0,0,208,32Zm0,176H48V48H208l.01025,159.99951ZM168,96v64a7.99977,7.99977,0,0,1-8,8H96a7.99977,7.99977,0,0,1-8-8V96a7.99977,7.99977,0,0,1,8-8h64A7.99977,7.99977,0,0,1,168,96Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40.00002",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "96",
      "y": "96.00002",
      "width": "64",
      "height": "64",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40.00002",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "96",
      "y": "96.00002",
      "width": "64",
      "height": "64",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40.00002",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "96",
      "y": "96.00002",
      "width": "64",
      "height": "64",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bY = [];
/* style */

const __vue_inject_styles__$bY = undefined;
/* scoped */

const __vue_scope_id__$bY = undefined;
/* module identifier */

const __vue_module_identifier__$bY = undefined;
/* functional template */

const __vue_is_functional_template__$bY = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bY = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bY,
  staticRenderFns: __vue_staticRenderFns__$bY
}, __vue_inject_styles__$bY, __vue_script__$bY, __vue_scope_id__$bY, __vue_is_functional_template__$bY, __vue_module_identifier__$bY, false, undefined, undefined, undefined);

var script$bZ = Vue.extend({
  name: "PhSquaresFour",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bZ = script$bZ;
/* template */

var __vue_render__$bZ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "48",
      "y": "48",
      "width": "60",
      "height": "60",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "148",
      "y": "48",
      "width": "60",
      "height": "60",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "48",
      "y": "148",
      "width": "60",
      "height": "60",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "148",
      "y": "148",
      "width": "60",
      "height": "60",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "48",
      "y": "48",
      "width": "64",
      "height": "64",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "144",
      "y": "48",
      "width": "64",
      "height": "64",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "48",
      "y": "144",
      "width": "64",
      "height": "64",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "144",
      "y": "144",
      "width": "64",
      "height": "64",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "144",
      "y": "144",
      "width": "64",
      "height": "64",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "48",
      "y": "48",
      "width": "64",
      "height": "64",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "144",
      "y": "48",
      "width": "64",
      "height": "64",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "48",
      "y": "144",
      "width": "64",
      "height": "64",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "80",
      "height": "80",
      "rx": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "136",
      "y": "40",
      "width": "80",
      "height": "80",
      "rx": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "136",
      "width": "80",
      "height": "80",
      "rx": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "136",
      "y": "136",
      "width": "80",
      "height": "80",
      "rx": "8"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "48",
      "y": "48",
      "width": "64",
      "height": "64",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "144",
      "y": "48",
      "width": "64",
      "height": "64",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "48",
      "y": "144",
      "width": "64",
      "height": "64",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "144",
      "y": "144",
      "width": "64",
      "height": "64",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "48",
      "y": "48",
      "width": "64",
      "height": "64",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "144",
      "y": "48",
      "width": "64",
      "height": "64",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "48",
      "y": "144",
      "width": "64",
      "height": "64",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "144",
      "y": "144",
      "width": "64",
      "height": "64",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "48",
      "y": "48",
      "width": "64",
      "height": "64",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "144",
      "y": "48",
      "width": "64",
      "height": "64",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "48",
      "y": "144",
      "width": "64",
      "height": "64",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "144",
      "y": "144",
      "width": "64",
      "height": "64",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bZ = [];
/* style */

const __vue_inject_styles__$bZ = undefined;
/* scoped */

const __vue_scope_id__$bZ = undefined;
/* module identifier */

const __vue_module_identifier__$bZ = undefined;
/* functional template */

const __vue_is_functional_template__$bZ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bZ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bZ,
  staticRenderFns: __vue_staticRenderFns__$bZ
}, __vue_inject_styles__$bZ, __vue_script__$bZ, __vue_scope_id__$bZ, __vue_is_functional_template__$bZ, __vue_module_identifier__$bZ, false, undefined, undefined, undefined);

var script$b_ = Vue.extend({
  name: "PhStack",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$b_ = script$b_;
/* template */

var __vue_render__$b_ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "32 176 128 232 224 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "32 128 128 184 224 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "32 80 128 136 224 80 128 24 32 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "32 80 128 136 224 80 128 24 32 80",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "32 176 128 232 224 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "32 128 128 184 224 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "32 80 128 136 224 80 128 24 32 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M219.96875,169.08984,128,222.73828,36.03125,169.08984a8.00008,8.00008,0,0,0-8.0625,13.82032l96,56a8.00059,8.00059,0,0,0,8.0625,0l96-56a8.00008,8.00008,0,0,0-8.0625-13.82032Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M219.96875,121.08984,128,174.73828,36.03125,121.08984a8.00008,8.00008,0,0,0-8.0625,13.82032l96,56a8.00059,8.00059,0,0,0,8.0625,0l96-56a8.00008,8.00008,0,0,0-8.0625-13.82032Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M27.96875,86.91016l96,56a8.00059,8.00059,0,0,0,8.0625,0l96-56a8.00016,8.00016,0,0,0,0-13.82032l-96-56a8.00059,8.00059,0,0,0-8.0625,0l-96,56a8.00016,8.00016,0,0,0,0,13.82032Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "32 176 128 232 224 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "32 128 128 184 224 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "32 80 128 136 224 80 128 24 32 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "32 176 128 232 224 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "32 128 128 184 224 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "32 80 128 136 224 80 128 24 32 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "32 176 128 232 224 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "32 128 128 184 224 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "32 80 128 136 224 80 128 24 32 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$b_ = [];
/* style */

const __vue_inject_styles__$b_ = undefined;
/* scoped */

const __vue_scope_id__$b_ = undefined;
/* module identifier */

const __vue_module_identifier__$b_ = undefined;
/* functional template */

const __vue_is_functional_template__$b_ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$b_ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$b_,
  staticRenderFns: __vue_staticRenderFns__$b_
}, __vue_inject_styles__$b_, __vue_script__$b_, __vue_scope_id__$b_, __vue_is_functional_template__$b_, __vue_module_identifier__$b_, false, undefined, undefined, undefined);

var script$b$ = Vue.extend({
  name: "PhStackSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$b$ = script$b$;
/* template */

var __vue_render__$b$ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "16 100 128 164 240 100 128 36 16 100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "16 148 128 212 240 148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "16 104 128 168 240 104 128 40 16 104",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "16 104 128 168 240 104 128 40 16 104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "16 144 128 208 240 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M12.03125,110.94629l112,64a8.00091,8.00091,0,0,0,7.9375,0l112-64a8.00024,8.00024,0,0,0,0-13.89258l-112-64a8.00411,8.00411,0,0,0-7.9375,0l-112,64a8.00024,8.00024,0,0,0,0,13.89258Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M236.03125,137.05371,128,198.78613,19.96875,137.05371a8.00012,8.00012,0,0,0-7.9375,13.89258l112,64a8.00091,8.00091,0,0,0,7.9375,0l112-64a8.00012,8.00012,0,0,0-7.9375-13.89258Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "16 104 128 168 240 104 128 40 16 104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "16 144 128 208 240 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "16 104 128 168 240 104 128 40 16 104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "16 144 128 208 240 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "16 104 128 168 240 104 128 40 16 104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "16 144 128 208 240 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$b$ = [];
/* style */

const __vue_inject_styles__$b$ = undefined;
/* scoped */

const __vue_scope_id__$b$ = undefined;
/* module identifier */

const __vue_module_identifier__$b$ = undefined;
/* functional template */

const __vue_is_functional_template__$b$ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$b$ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$b$,
  staticRenderFns: __vue_staticRenderFns__$b$
}, __vue_inject_styles__$b$, __vue_script__$b$, __vue_scope_id__$b$, __vue_is_functional_template__$b$, __vue_module_identifier__$b$, false, undefined, undefined, undefined);

var script$c0 = Vue.extend({
  name: "PhStar",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$c0 = script$c0;
/* template */

var __vue_render__$c0 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M132.41106,190.73266l50.43543,31.95385c6.44693,4.08451,14.45124-1.99032,12.53819-9.51579l-14.57192-57.32241a8.75742,8.75742,0,0,1,2.83756-8.87589l45.2273-37.64345c5.94268-4.9462,2.87542-14.80876-4.75965-15.30428l-59.06388-3.83326a8.41836,8.41836,0,0,1-7.24792-5.3506l-22.02834-55.473a8.31887,8.31887,0,0,0-15.55566,0L98.19383,84.84083a8.41836,8.41836,0,0,1-7.24792,5.3506L31.882,94.02469c-7.63507.49552-10.70233,10.35808-4.75965,15.30428l45.2273,37.64345a8.75742,8.75742,0,0,1,2.83756,8.87589L61.6734,209.00846c-2.29566,9.03056,7.30952,16.32036,15.04583,11.41895l46.86971-29.69475A8.21431,8.21431,0,0,1,132.41106,190.73266Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M132.41106,190.73266l50.43543,31.95385c6.44693,4.08451,14.45124-1.99032,12.53819-9.51579l-14.57192-57.32241a8.75742,8.75742,0,0,1,2.83756-8.87589l45.2273-37.64345c5.94268-4.9462,2.87542-14.80876-4.75965-15.30428l-59.06388-3.83326a8.41836,8.41836,0,0,1-7.24792-5.3506l-22.02834-55.473a8.31887,8.31887,0,0,0-15.55566,0L98.19383,84.84083a8.41836,8.41836,0,0,1-7.24792,5.3506L31.882,94.02469c-7.63507.49552-10.70233,10.35808-4.75965,15.30428l45.2273,37.64345a8.75742,8.75742,0,0,1,2.83756,8.87589L61.6734,209.00846c-2.29566,9.03056,7.30952,16.32036,15.04583,11.41895l46.86971-29.69475A8.21431,8.21431,0,0,1,132.41106,190.73266Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M132.41106,190.73266l50.43543,31.95385c6.44693,4.08451,14.45124-1.99032,12.53819-9.51579l-14.57192-57.32241a8.75742,8.75742,0,0,1,2.83756-8.87589l45.2273-37.64345c5.94268-4.9462,2.87542-14.80876-4.75965-15.30428l-59.06388-3.83326a8.41836,8.41836,0,0,1-7.24792-5.3506l-22.02834-55.473a8.31887,8.31887,0,0,0-15.55566,0L98.19383,84.84083a8.41836,8.41836,0,0,1-7.24792,5.3506L31.882,94.02469c-7.63507.49552-10.70233,10.35808-4.75965,15.30428l45.2273,37.64345a8.75742,8.75742,0,0,1,2.83756,8.87589L61.6734,209.00846c-2.29566,9.03056,7.30952,16.32036,15.04583,11.41895l46.86971-29.69475A8.21431,8.21431,0,0,1,132.41106,190.73266Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M239.166,97.41117A16.37036,16.37036,0,0,0,224.63477,86.044l-59.39063-4.15625L143.21289,26.41117A16.33117,16.33117,0,0,0,127.99414,15.9971h-.01562A16.324,16.324,0,0,0,112.791,26.41117L90.43164,82.208,31.36914,86.044A16.37036,16.37036,0,0,0,16.83789,97.41117a16.68222,16.68222,0,0,0,5.15625,18.0625l45.4375,38.40625L53.916,207.044a18.37492,18.37492,0,0,0,7.01562,19.51562,17.83088,17.83088,0,0,0,20.0625.625l46.875-29.69531c.0625-.04687.125-.07812.26563,0l50.4375,31.95313a16.14026,16.14026,0,0,0,18.20312-.5625,16.64744,16.64744,0,0,0,6.35938-17.67969L188.77539,153.1221l45.23438-37.64843A16.68222,16.68222,0,0,0,239.166,97.41117Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M132.41106,190.73266l50.43543,31.95385c6.44693,4.08451,14.45124-1.99032,12.53819-9.51579l-14.57192-57.32241a8.75742,8.75742,0,0,1,2.83756-8.87589l45.2273-37.64345c5.94268-4.9462,2.87542-14.80876-4.75965-15.30428l-59.06388-3.83326a8.41836,8.41836,0,0,1-7.24792-5.3506l-22.02834-55.473a8.31887,8.31887,0,0,0-15.55566,0L98.19383,84.84083a8.41836,8.41836,0,0,1-7.24792,5.3506L31.882,94.02469c-7.63507.49552-10.70233,10.35808-4.75965,15.30428l45.2273,37.64345a8.75742,8.75742,0,0,1,2.83756,8.87589L61.6734,209.00846c-2.29566,9.03056,7.30952,16.32036,15.04583,11.41895l46.86971-29.69475A8.21431,8.21431,0,0,1,132.41106,190.73266Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M132.41106,190.73266l50.43543,31.95385c6.44693,4.08451,14.45124-1.99032,12.53819-9.51579l-14.57192-57.32241a8.75742,8.75742,0,0,1,2.83756-8.87589l45.2273-37.64345c5.94268-4.9462,2.87542-14.80876-4.75965-15.30428l-59.06388-3.83326a8.41836,8.41836,0,0,1-7.24792-5.3506l-22.02834-55.473a8.31887,8.31887,0,0,0-15.55566,0L98.19383,84.84083a8.41836,8.41836,0,0,1-7.24792,5.3506L31.882,94.02469c-7.63507.49552-10.70233,10.35808-4.75965,15.30428l45.2273,37.64345a8.75742,8.75742,0,0,1,2.83756,8.87589L61.6734,209.00846c-2.29566,9.03056,7.30952,16.32036,15.04583,11.41895l46.86971-29.69475A8.21431,8.21431,0,0,1,132.41106,190.73266Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M132.41106,190.73266l50.43543,31.95385c6.44693,4.08451,14.45124-1.99032,12.53819-9.51579l-14.57192-57.32241a8.75742,8.75742,0,0,1,2.83756-8.87589l45.2273-37.64345c5.94268-4.9462,2.87542-14.80876-4.75965-15.30428l-59.06388-3.83326a8.41836,8.41836,0,0,1-7.24792-5.3506l-22.02834-55.473a8.31887,8.31887,0,0,0-15.55566,0L98.19383,84.84083a8.41836,8.41836,0,0,1-7.24792,5.3506L31.882,94.02469c-7.63507.49552-10.70233,10.35808-4.75965,15.30428l45.2273,37.64345a8.75742,8.75742,0,0,1,2.83756,8.87589L61.6734,209.00846c-2.29566,9.03056,7.30952,16.32036,15.04583,11.41895l46.86971-29.69475A8.21431,8.21431,0,0,1,132.41106,190.73266Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$c0 = [];
/* style */

const __vue_inject_styles__$c0 = undefined;
/* scoped */

const __vue_scope_id__$c0 = undefined;
/* module identifier */

const __vue_module_identifier__$c0 = undefined;
/* functional template */

const __vue_is_functional_template__$c0 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$c0 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$c0,
  staticRenderFns: __vue_staticRenderFns__$c0
}, __vue_inject_styles__$c0, __vue_script__$c0, __vue_scope_id__$c0, __vue_is_functional_template__$c0, __vue_module_identifier__$c0, false, undefined, undefined, undefined);

var script$c1 = Vue.extend({
  name: "PhStarFour",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$c1 = script$c1;
/* template */

var __vue_render__$c1 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M158.72416,163.50856l-23.20581,63.816a8,8,0,0,1-15.0367,0l-23.20581-63.816a8,8,0,0,0-4.7844-4.7844l-63.816-23.20581a8,8,0,0,1,0-15.0367l63.816-23.20581a8,8,0,0,0,4.7844-4.7844l23.20581-63.816a8,8,0,0,1,15.0367,0l23.20581,63.816a8,8,0,0,0,4.7844,4.7844l63.816,23.20581a8,8,0,0,1,0,15.0367l-63.816,23.20581A8,8,0,0,0,158.72416,163.50856Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M158.72416,163.50856l-23.20581,63.816a8,8,0,0,1-15.0367,0l-23.20581-63.816a8,8,0,0,0-4.7844-4.7844l-63.816-23.20581a8,8,0,0,1,0-15.0367l63.816-23.20581a8,8,0,0,0,4.7844-4.7844l23.20581-63.816a8,8,0,0,1,15.0367,0l23.20581,63.816a8,8,0,0,0,4.7844,4.7844l63.816,23.20581a8,8,0,0,1,0,15.0367l-63.816,23.20581A8,8,0,0,0,158.72416,163.50856Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M158.72416,163.50856l-23.20581,63.816a8,8,0,0,1-15.0367,0l-23.20581-63.816a8,8,0,0,0-4.7844-4.7844l-63.816-23.20581a8,8,0,0,1,0-15.0367l63.816-23.20581a8,8,0,0,0,4.7844-4.7844l23.20581-63.816a8,8,0,0,1,15.0367,0l23.20581,63.816a8,8,0,0,0,4.7844,4.7844l63.816,23.20581a8,8,0,0,1,0,15.0367l-63.816,23.20581A8,8,0,0,0,158.72416,163.50856Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M240.58984,128a15.84794,15.84794,0,0,1-10.53125,15.03711l-63.81543,23.206-23.206,63.81543a16.001,16.001,0,0,1-30.07422,0L89.75684,166.24316l-63.81543-23.206a16.001,16.001,0,0,1,0-30.07422L89.75684,89.75684l23.20605-63.81543a16.001,16.001,0,0,1,30.07422,0l23.206,63.81543,63.81543,23.20605A15.84794,15.84794,0,0,1,240.58984,128Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M158.72416,163.50856l-23.20581,63.816a8,8,0,0,1-15.0367,0l-23.20581-63.816a8,8,0,0,0-4.7844-4.7844l-63.816-23.20581a8,8,0,0,1,0-15.0367l63.816-23.20581a8,8,0,0,0,4.7844-4.7844l23.20581-63.816a8,8,0,0,1,15.0367,0l23.20581,63.816a8,8,0,0,0,4.7844,4.7844l63.816,23.20581a8,8,0,0,1,0,15.0367l-63.816,23.20581A8,8,0,0,0,158.72416,163.50856Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M158.72416,163.50856l-23.20581,63.816a8,8,0,0,1-15.0367,0l-23.20581-63.816a8,8,0,0,0-4.7844-4.7844l-63.816-23.20581a8,8,0,0,1,0-15.0367l63.816-23.20581a8,8,0,0,0,4.7844-4.7844l23.20581-63.816a8,8,0,0,1,15.0367,0l23.20581,63.816a8,8,0,0,0,4.7844,4.7844l63.816,23.20581a8,8,0,0,1,0,15.0367l-63.816,23.20581A8,8,0,0,0,158.72416,163.50856Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M158.72416,163.50856l-23.20581,63.816a8,8,0,0,1-15.0367,0l-23.20581-63.816a8,8,0,0,0-4.7844-4.7844l-63.816-23.20581a8,8,0,0,1,0-15.0367l63.816-23.20581a8,8,0,0,0,4.7844-4.7844l23.20581-63.816a8,8,0,0,1,15.0367,0l23.20581,63.816a8,8,0,0,0,4.7844,4.7844l63.816,23.20581a8,8,0,0,1,0,15.0367l-63.816,23.20581A8,8,0,0,0,158.72416,163.50856Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$c1 = [];
/* style */

const __vue_inject_styles__$c1 = undefined;
/* scoped */

const __vue_scope_id__$c1 = undefined;
/* module identifier */

const __vue_module_identifier__$c1 = undefined;
/* functional template */

const __vue_is_functional_template__$c1 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$c1 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$c1,
  staticRenderFns: __vue_staticRenderFns__$c1
}, __vue_inject_styles__$c1, __vue_script__$c1, __vue_scope_id__$c1, __vue_is_functional_template__$c1, __vue_module_identifier__$c1, false, undefined, undefined, undefined);

var script$c2 = Vue.extend({
  name: "PhStarHalf",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$c2 = script$c2;
/* template */

var __vue_render__$c2 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "24.00002",
      "x2": "128",
      "y2": "189.44779",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M220.16021,116.58462l8.71741-7.25565c5.94268-4.9462,2.87542-14.80876-4.75965-15.30428l-11.54749-.74944",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M173.021,216.46145l9.82554,6.22506c6.44693,4.08451,14.45124-1.99032,12.53819-9.51579l-2.774-10.91217",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M182.00561,160.54069l-1.19285-4.69238a8.75742,8.75742,0,0,1,2.83756-8.87589l3.41259-2.84035",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M169.59525,90.48615l-4.54116-.29472a8.41836,8.41836,0,0,1-7.24792-5.3506L152.7071,72.00006,135.77783,29.36778a8.31887,8.31887,0,0,0-15.55566,0L98.19383,84.84083a8.41836,8.41836,0,0,1-7.24792,5.3506L31.882,94.02469c-7.63507.49552-10.70233,10.35808-4.75965,15.30428l45.2273,37.64345a8.75742,8.75742,0,0,1,2.83756,8.87589L61.6734,209.00846c-2.29566,9.03056,7.30952,16.32036,15.04583,11.41895l46.86971-29.69475a8.21431,8.21431,0,0,1,8.82212,0l4.24315,2.68829",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,189.44781a8.23108,8.23108,0,0,0-4.411,1.28485L76.71923,220.42741c-7.73631,4.90141-17.34149-2.38839-15.04583-11.41895l13.51384-53.16015a8.75742,8.75742,0,0,0-2.83756-8.87589L27.12238,109.329C21.1797,104.38277,24.247,94.52021,31.882,94.02469l59.06388-3.83326a8.41836,8.41836,0,0,0,7.24792-5.3506l22.02834-55.473A8.27507,8.27507,0,0,1,128.00007,24L128,24Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "24.00002",
      "x2": "128",
      "y2": "189.44779",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M220.16021,116.58462l8.71741-7.25565c5.94268-4.9462,2.87542-14.80876-4.75965-15.30428l-11.54749-.74944",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184.12661,168.88422l-3.31385-13.03591a8.75742,8.75742,0,0,1,2.83756-8.87589l10.032-8.34985",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M178.19035,91.044l-13.13626-.85254a8.41836,8.41836,0,0,1-7.24792-5.3506L152.7071,72.00006,135.77783,29.36778a8.31887,8.31887,0,0,0-15.55566,0L98.19383,84.84083a8.41836,8.41836,0,0,1-7.24792,5.3506L31.882,94.02469c-7.63507.49552-10.70233,10.35808-4.75965,15.30428l45.2273,37.64345a8.75742,8.75742,0,0,1,2.83756,8.87589L61.6734,209.00846c-2.29566,9.03056,7.30952,16.32036,15.04583,11.41895l46.86971-29.69475a8.21431,8.21431,0,0,1,8.82212,0l11.51649,7.29638",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M173.021,216.46145l9.82554,6.22506c6.44693,4.08451,14.45124-1.99032,12.53819-9.51579l-2.774-10.91217",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M233.99609,115.47754l-8.71777,7.25586A7.99993,7.99993,0,0,1,215.042,110.43652l8.71778-7.25586a.645.645,0,0,0,.18652-.81054c-.11328-.34766-.23242-.35547-.34668-.36231l-11.54688-.749a8.00016,8.00016,0,0,1,1.03516-15.9668l11.54785.749A16.36187,16.36187,0,0,1,239.16016,97.418,16.65646,16.65646,0,0,1,233.99609,115.47754Zm-60.93652,42.34277,3.31445,13.03516a7.99972,7.99972,0,0,0,15.50586-3.94336l-3.31347-13.0332a.77056.77056,0,0,1,.20117-.75684l10.03222-8.34961a8.00006,8.00006,0,0,0-10.23437-12.29883l-10.03223,8.34961A16.81494,16.81494,0,0,0,173.05957,157.82031ZM186.17383,91.5625a8.00082,8.00082,0,0,0-7.46485-8.50195L165.57227,82.208a.453.453,0,0,1-.33008-.32031L143.21289,26.416a16.31771,16.31771,0,0,0-30.42578-.001L90.75781,81.88965a.45394.45394,0,0,1-.3291.31836L31.36328,86.041A16.36063,16.36063,0,0,0,16.83984,97.418a16.65646,16.65646,0,0,0,5.16407,18.05957l45.22851,37.64453a.77256.77256,0,0,1,.20215.75586L53.9209,207.03711a18.3696,18.3696,0,0,0,6.999,19.5166A17.79837,17.79837,0,0,0,81,227.18555l46.87012-29.69532a.23765.23765,0,0,1,.12939-.042h.00244a.24439.24439,0,0,1,.12793.042l11.5166,7.29688a7.99982,7.99982,0,1,0,8.5625-13.51563l-11.5166-7.29687c-.22656-.14356-.46-.273-.69238-.4043V51.60425L150.37109,87.792A16.49953,16.49953,0,0,0,164.53516,98.1748l13.13672.85254A8.00533,8.00533,0,0,0,186.17383,91.5625Zm14.18945,108.72461a7.99972,7.99972,0,0,0-15.50586,3.94336l2.77442,10.91113a.64731.64731,0,0,1-.05274.59473.82311.82311,0,0,1-.30566.2666.61873.61873,0,0,1-.14551-.07422l-9.82617-6.22461a7.99982,7.99982,0,0,0-8.5625,13.51563l9.82519,6.22461a16.16285,16.16285,0,0,0,18.23047-.57227,16.63644,16.63644,0,0,0,6.34278-17.67285Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "24.00002",
      "x2": "128",
      "y2": "189.44779",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M220.16021,116.58462l8.71741-7.25565c5.94268-4.9462,2.87542-14.80876-4.75965-15.30428l-11.54749-.74944",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184.12661,168.88422l-3.31385-13.03591a8.75742,8.75742,0,0,1,2.83756-8.87589l10.032-8.34985",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M178.19035,91.044l-13.13626-.85254a8.41836,8.41836,0,0,1-7.24792-5.3506L152.7071,72.00006,135.77783,29.36778a8.31887,8.31887,0,0,0-15.55566,0L98.19383,84.84083a8.41836,8.41836,0,0,1-7.24792,5.3506L31.882,94.02469c-7.63507.49552-10.70233,10.35808-4.75965,15.30428l45.2273,37.64345a8.75742,8.75742,0,0,1,2.83756,8.87589L61.6734,209.00846c-2.29566,9.03056,7.30952,16.32036,15.04583,11.41895l46.86971-29.69475a8.21431,8.21431,0,0,1,8.82212,0l11.51649,7.29638",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M173.021,216.46145l9.82554,6.22506c6.44693,4.08451,14.45124-1.99032,12.53819-9.51579l-2.774-10.91217",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "-130.597 14.748 -63.749 -33.718 3.098 -82.183",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16",
      "opacity": "0.5"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "-140.002 1.804 -73.154 -46.662 -6.306 -95.127",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16",
      "opacity": "0.5"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "24.00002",
      "x2": "128",
      "y2": "189.44779",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M220.16021,116.58462l8.71741-7.25565c5.94268-4.9462,2.87542-14.80876-4.75965-15.30428l-11.54749-.74944",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184.12661,168.88422l-3.31385-13.03591a8.75742,8.75742,0,0,1,2.83756-8.87589l10.032-8.34985",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M178.19035,91.044l-13.13626-.85254a8.41836,8.41836,0,0,1-7.24792-5.3506L152.7071,72.00006,135.77783,29.36778a8.31887,8.31887,0,0,0-15.55566,0L98.19383,84.84083a8.41836,8.41836,0,0,1-7.24792,5.3506L31.882,94.02469c-7.63507.49552-10.70233,10.35808-4.75965,15.30428l45.2273,37.64345a8.75742,8.75742,0,0,1,2.83756,8.87589L61.6734,209.00846c-2.29566,9.03056,7.30952,16.32036,15.04583,11.41895l46.86971-29.69475a8.21431,8.21431,0,0,1,8.82212,0l11.51649,7.29638",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M173.021,216.46145l9.82554,6.22506c6.44693,4.08451,14.45124-1.99032,12.53819-9.51579l-2.774-10.91217",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "24.00002",
      "x2": "128",
      "y2": "189.44779",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M220.16021,116.58462l8.71741-7.25565c5.94268-4.9462,2.87542-14.80876-4.75965-15.30428l-11.54749-.74944",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184.12661,168.88422l-3.31385-13.03591a8.75742,8.75742,0,0,1,2.83756-8.87589l10.032-8.34985",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M178.19035,91.044l-13.13626-.85254a8.41836,8.41836,0,0,1-7.24792-5.3506L152.7071,72.00006,135.77783,29.36778a8.31887,8.31887,0,0,0-15.55566,0L98.19383,84.84083a8.41836,8.41836,0,0,1-7.24792,5.3506L31.882,94.02469c-7.63507.49552-10.70233,10.35808-4.75965,15.30428l45.2273,37.64345a8.75742,8.75742,0,0,1,2.83756,8.87589L61.6734,209.00846c-2.29566,9.03056,7.30952,16.32036,15.04583,11.41895l46.86971-29.69475a8.21431,8.21431,0,0,1,8.82212,0l11.51649,7.29638",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M173.021,216.46145l9.82554,6.22506c6.44693,4.08451,14.45124-1.99032,12.53819-9.51579l-2.774-10.91217",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$c2 = [];
/* style */

const __vue_inject_styles__$c2 = undefined;
/* scoped */

const __vue_scope_id__$c2 = undefined;
/* module identifier */

const __vue_module_identifier__$c2 = undefined;
/* functional template */

const __vue_is_functional_template__$c2 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$c2 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$c2,
  staticRenderFns: __vue_staticRenderFns__$c2
}, __vue_inject_styles__$c2, __vue_script__$c2, __vue_scope_id__$c2, __vue_is_functional_template__$c2, __vue_module_identifier__$c2, false, undefined, undefined, undefined);

var script$c3 = Vue.extend({
  name: "PhSticker",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$c3 = script$c3;
/* template */

var __vue_render__$c3 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M136,216H88a48,48,0,0,1-48-48V88A48,48,0,0,1,88,40h80a48,48,0,0,1,48,48v48C208,160,160,208,136,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M136,216V184a48,48,0,0,1,48-48h32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M136,216V184a48,48,0,0,1,48-48h32C208,160,160,208,136,216Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M136,216H88a48,48,0,0,1-48-48V88A48,48,0,0,1,88,40h80a48,48,0,0,1,48,48v48C208,160,160,208,136,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M136,216V184a48,48,0,0,1,48-48h32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M168,32H88A56.0629,56.0629,0,0,0,32,88v80a56.0629,56.0629,0,0,0,56,56h48a8.0151,8.0151,0,0,0,2.53027-.41016c26.23243-8.74511,76.31446-58.82714,85.05957-85.05957A8.0151,8.0151,0,0,0,224,136V88A56.0629,56.0629,0,0,0,168,32ZM136,207.42236V176a40.04584,40.04584,0,0,1,40-40h31.42236C198.15991,157.55176,157.55176,198.16016,136,207.42236Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M136,216H88a48,48,0,0,1-48-48V88A48,48,0,0,1,88,40h80a48,48,0,0,1,48,48v48C208,160,160,208,136,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M136,216V184a48,48,0,0,1,48-48h32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M136,216H88a48,48,0,0,1-48-48V88A48,48,0,0,1,88,40h80a48,48,0,0,1,48,48v48C208,160,160,208,136,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M136,216V184a48,48,0,0,1,48-48h32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M136,216H88a48,48,0,0,1-48-48V88A48,48,0,0,1,88,40h80a48,48,0,0,1,48,48v48C208,160,160,208,136,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M136,216V184a48,48,0,0,1,48-48h32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$c3 = [];
/* style */

const __vue_inject_styles__$c3 = undefined;
/* scoped */

const __vue_scope_id__$c3 = undefined;
/* module identifier */

const __vue_module_identifier__$c3 = undefined;
/* functional template */

const __vue_is_functional_template__$c3 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$c3 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$c3,
  staticRenderFns: __vue_staticRenderFns__$c3
}, __vue_inject_styles__$c3, __vue_script__$c3, __vue_scope_id__$c3, __vue_is_functional_template__$c3, __vue_module_identifier__$c3, false, undefined, undefined, undefined);

var script$c4 = Vue.extend({
  name: "PhStop",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$c4 = script$c4;
/* template */

var __vue_render__$c4 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "52",
      "y": "52",
      "width": "152",
      "height": "152",
      "rx": "6.90909",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "52",
      "y": "52",
      "width": "152",
      "height": "152",
      "rx": "6.90909",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "52",
      "y": "52",
      "width": "152",
      "height": "152",
      "rx": "6.90909",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('rect', {
    attrs: {
      "x": "44",
      "y": "44",
      "width": "168",
      "height": "168",
      "rx": "14.90918"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "52",
      "y": "52",
      "width": "152",
      "height": "152",
      "rx": "6.90909",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "52",
      "y": "52",
      "width": "152",
      "height": "152",
      "rx": "6.90909",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "52",
      "y": "52",
      "width": "152",
      "height": "152",
      "rx": "6.90909",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$c4 = [];
/* style */

const __vue_inject_styles__$c4 = undefined;
/* scoped */

const __vue_scope_id__$c4 = undefined;
/* module identifier */

const __vue_module_identifier__$c4 = undefined;
/* functional template */

const __vue_is_functional_template__$c4 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$c4 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$c4,
  staticRenderFns: __vue_staticRenderFns__$c4
}, __vue_inject_styles__$c4, __vue_script__$c4, __vue_scope_id__$c4, __vue_is_functional_template__$c4, __vue_module_identifier__$c4, false, undefined, undefined, undefined);

var script$c5 = Vue.extend({
  name: "PhStopCircle",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$c5 = script$c5;
/* template */

var __vue_render__$c5 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "108",
      "y": "108",
      "width": "40",
      "height": "40",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,32a96,96,0,1,0,96,96A95.99991,95.99991,0,0,0,128,32Zm24,120H104V104h48Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "104",
      "y": "104",
      "width": "48",
      "height": "48",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.11791,104.11791,0,0,0,128,24Zm32,128a8.00008,8.00008,0,0,1-8,8H104a8.00008,8.00008,0,0,1-8-8V104a8.00008,8.00008,0,0,1,8-8h48a8.00008,8.00008,0,0,1,8,8Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "104",
      "y": "104",
      "width": "48",
      "height": "48",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "104",
      "y": "104",
      "width": "48",
      "height": "48",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "104",
      "y": "104",
      "width": "48",
      "height": "48",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$c5 = [];
/* style */

const __vue_inject_styles__$c5 = undefined;
/* scoped */

const __vue_scope_id__$c5 = undefined;
/* module identifier */

const __vue_module_identifier__$c5 = undefined;
/* functional template */

const __vue_is_functional_template__$c5 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$c5 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$c5,
  staticRenderFns: __vue_staticRenderFns__$c5
}, __vue_inject_styles__$c5, __vue_script__$c5, __vue_scope_id__$c5, __vue_is_functional_template__$c5, __vue_module_identifier__$c5, false, undefined, undefined, undefined);

var script$c6 = Vue.extend({
  name: "PhStorefront",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$c6 = script$c6;
/* template */

var __vue_render__$c6 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M48,139.58816V208a8,8,0,0,0,8,8H200a8,8,0,0,0,8-8V139.58972",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M54.03441,40H201.96559a8,8,0,0,1,7.69219,5.80223L224,96H32L46.34222,45.80223A8,8,0,0,1,54.03441,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,96v16a32,32,0,0,1-64,0V96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160,96v16a32,32,0,0,1-64,0V96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,96v16a32,32,0,0,1-64,0V96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M96,96v16a32,32,0,0,1-64,0V96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,96v16a32,32,0,0,1-64,0V96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,139.58816V208a8,8,0,0,0,8,8H200a8,8,0,0,0,8-8V139.58972",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M54.03441,40H201.96559a8,8,0,0,1,7.69219,5.80223L224,96H32L46.34222,45.80223A8,8,0,0,1,54.03441,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,96v16a32,32,0,0,1-64,0V96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160,96v16a32,32,0,0,1-64,0V96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,96v16a32,32,0,0,1-64,0V96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M231.98975,95.79919c-.00293-.11914-.00953-.23779-.01807-.35705-.0127-.1836-.03149-.36475-.0564-.5448-.0144-.10315-.02881-.20581-.04712-.30872-.03784-.21142-.08545-.41894-.13964-.62426-.01416-.05372-.02076-.10853-.03614-.16211L217.35059,43.604A16.06985,16.06985,0,0,0,201.96582,32H54.03418A16.06971,16.06971,0,0,0,38.64941,43.60449L24.30762,93.80225c-.01538.05358-.022.10839-.03614.16211-.05419.20532-.1018.41284-.13964.62426-.01831.10291-.03272.20557-.04712.30872-.02491.18-.0437.3612-.0564.5448-.00854.11926-.01514.23791-.01807.35705C24.00854,95.86658,24,95.93213,24,96v16a39.96242,39.96242,0,0,0,16,31.978V208a16.01833,16.01833,0,0,0,16,16H200a16.01833,16.01833,0,0,0,16-16V143.978A39.96242,39.96242,0,0,0,232,112V96C232,95.93213,231.99146,95.86658,231.98975,95.79919ZM40,104H88v8a23.98436,23.98436,0,0,1-35.12427,21.256,7.98438,7.98438,0,0,0-1.813-1.05774A23.99623,23.99623,0,0,1,40,112Zm112,8a24,24,0,0,1-48,0v-8h48Zm52.93213,20.20166a7.97469,7.97469,0,0,0-1.80176,1.05115A23.98441,23.98441,0,0,1,168,112v-8h48v8A23.99664,23.99664,0,0,1,204.93213,132.20166Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M48,139.58816V208a8,8,0,0,0,8,8H200a8,8,0,0,0,8-8V139.58972",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M54.03441,40H201.96559a8,8,0,0,1,7.69219,5.80223L224,96H32L46.34222,45.80223A8,8,0,0,1,54.03441,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,96v16a32,32,0,0,1-64,0V96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160,96v16a32,32,0,0,1-64,0V96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,96v16a32,32,0,0,1-64,0V96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M48,139.58816V208a8,8,0,0,0,8,8H200a8,8,0,0,0,8-8V139.58972",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M54.03441,40H201.96559a8,8,0,0,1,7.69219,5.80223L224,96H32L46.34222,45.80223A8,8,0,0,1,54.03441,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,96v16a32,32,0,0,1-64,0V96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160,96v16a32,32,0,0,1-64,0V96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,96v16a32,32,0,0,1-64,0V96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M48,139.58816V208a8,8,0,0,0,8,8H200a8,8,0,0,0,8-8V139.58972",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M54.03441,40H201.96559a8,8,0,0,1,7.69219,5.80223L224,96H32L46.34222,45.80223A8,8,0,0,1,54.03441,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,96v16a32,32,0,0,1-64,0V96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160,96v16a32,32,0,0,1-64,0V96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,96v16a32,32,0,0,1-64,0V96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$c6 = [];
/* style */

const __vue_inject_styles__$c6 = undefined;
/* scoped */

const __vue_scope_id__$c6 = undefined;
/* module identifier */

const __vue_module_identifier__$c6 = undefined;
/* functional template */

const __vue_is_functional_template__$c6 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$c6 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$c6,
  staticRenderFns: __vue_staticRenderFns__$c6
}, __vue_inject_styles__$c6, __vue_script__$c6, __vue_scope_id__$c6, __vue_is_functional_template__$c6, __vue_module_identifier__$c6, false, undefined, undefined, undefined);

var script$c7 = Vue.extend({
  name: "PhStripeLogo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$c7 = script$c7;
/* template */

var __vue_render__$c7 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M91.93248,152c0,13.25484,16.148,24,36.06752,24s36.06752-10.74516,36.06752-24c0-32-70.13129-20-70.13129-48,0-13.25483,14.14423-24,34.06377-24,14.93966,0,26.6307,6.04416,31.54249,14.65811",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40.00002",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40.00002",
      "width": "176",
      "height": "176",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M91.93248,152c0,13.25484,16.148,24,36.06752,24s36.06752-10.74516,36.06752-24c0-32-70.13129-20-70.13129-48,0-13.25483,14.14423-24,34.06377-24,14.93966,0,26.6307,6.04416,31.54249,14.65811",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40.00002",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,32H48A16.01817,16.01817,0,0,0,32,48V208a16.01833,16.01833,0,0,0,16,16H208a16.01833,16.01833,0,0,0,16-16V48A16.01817,16.01817,0,0,0,208,32ZM128,184c-24.71045,0-44.06738-14.05615-44.06738-32a8,8,0,0,1,16,0c0,7.56787,11.52685,16,28.06738,16,13.27539,0,28.06738-6.5708,28.06738-16,0-9.60376-12.1958-13.44092-30.80224-18.19849-8.70606-2.22631-17.709-4.52856-24.75733-8.25024C90.83887,120.44558,85.936,113.1946,85.936,104c0-18.24292,18.08349-32,42.064-32,17.16748,0,31.917,7.16382,38.49219,18.69556a8.00006,8.00006,0,0,1-13.89942,7.92529C148.91406,92.169,139.26074,88,128,88c-14.61523,0-26.064,7.02808-26.064,16,0,6.81152,10.80664,10.08447,27.293,14.30005,19.08545,4.88037,42.83838,10.95435,42.83838,33.7C172.06738,169.94387,152.71045,184,128,184Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M91.93248,152c0,13.25484,16.148,24,36.06752,24s36.06752-10.74516,36.06752-24c0-32-70.13129-20-70.13129-48,0-13.25483,14.14423-24,34.06377-24,14.93966,0,26.6307,6.04416,31.54249,14.65811",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40.00002",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M91.93248,152c0,13.25484,16.148,24,36.06752,24s36.06752-10.74516,36.06752-24c0-32-70.13129-20-70.13129-48,0-13.25483,14.14423-24,34.06377-24,14.93966,0,26.6307,6.04416,31.54249,14.65811",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40.00002",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M91.93248,152c0,13.25484,16.148,24,36.06752,24s36.06752-10.74516,36.06752-24c0-32-70.13129-20-70.13129-48,0-13.25483,14.14423-24,34.06377-24,14.93966,0,26.6307,6.04416,31.54249,14.65811",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40.00002",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$c7 = [];
/* style */

const __vue_inject_styles__$c7 = undefined;
/* scoped */

const __vue_scope_id__$c7 = undefined;
/* module identifier */

const __vue_module_identifier__$c7 = undefined;
/* functional template */

const __vue_is_functional_template__$c7 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$c7 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$c7,
  staticRenderFns: __vue_staticRenderFns__$c7
}, __vue_inject_styles__$c7, __vue_script__$c7, __vue_scope_id__$c7, __vue_is_functional_template__$c7, __vue_module_identifier__$c7, false, undefined, undefined, undefined);

var script$c8 = Vue.extend({
  name: "PhStudent",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$c8 = script$c8;
/* template */

var __vue_render__$c8 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "32",
      "y1": "64",
      "x2": "32",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M54.23194,215.99924a88.02249,88.02249,0,0,1,147.53587-.00038",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "224 64 128 96 32 64 128 32 224 64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M169.33686,82.22033a56,56,0,1,1-82.67374,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "224 64 128 96 32 64 128 32 224 64",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "64",
      "x2": "32",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M54.23194,215.99924a88.02249,88.02249,0,0,1,147.53587-.00038",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "224 64 128 96 32 64 128 32 224 64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M169.33686,82.22033a56,56,0,1,1-82.67374,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M226.52979,56.41016l-96-32a8.00672,8.00672,0,0,0-5.05958,0L29.6239,56.35889l-.00976.00341-.14393.04786c-.02819.00927-.053.02465-.08105.03442a7.91407,7.91407,0,0,0-1.01074.42871c-.03748.019-.07642.03516-.11353.05469a7.97333,7.97333,0,0,0-.93139.58325c-.06543.04688-.129.09522-.19288.144a8.08459,8.08459,0,0,0-.81872.71119c-.0238.02416-.04443.05053-.06787.0747a8.0222,8.0222,0,0,0-.661.783c-.04163.05567-.08472.10986-.12476.16675a8.00177,8.00177,0,0,0-.56714.92993c-.02588.04981-.04809.10083-.073.15112a7.97024,7.97024,0,0,0-.40515.97608c-.01062.03149-.0238.06128-.03405.093a7.95058,7.95058,0,0,0-.26282,1.08544c-.01331.07666-.02405.15308-.035.23A8.02888,8.02888,0,0,0,24,64v80a8,8,0,0,0,16,0V75.09985L73.58521,86.29492a63.9717,63.9717,0,0,0,20.42944,87.89746,95.88087,95.88087,0,0,0-46.48389,37.4375,7.9997,7.9997,0,1,0,13.40235,8.73828,80.023,80.023,0,0,1,134.1333,0,7.99969,7.99969,0,1,0,13.40234-8.73828,95.87941,95.87941,0,0,0-46.4834-37.43725,63.972,63.972,0,0,0,20.42944-87.89771l44.115-14.70508a8.0005,8.0005,0,0,0,0-15.17968ZM128,168A47.99154,47.99154,0,0,1,89.34875,91.54932l36.12146,12.04052a8.00672,8.00672,0,0,0,5.05958,0l36.12146-12.04052A47.99154,47.99154,0,0,1,128,168Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "32",
      "y1": "64",
      "x2": "32",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M54.23194,215.99924a88.02249,88.02249,0,0,1,147.53587-.00038",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "224 64 128 96 32 64 128 32 224 64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M169.33686,82.22033a56,56,0,1,1-82.67374,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "32",
      "y1": "64",
      "x2": "32",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M54.23194,215.99924a88.02249,88.02249,0,0,1,147.53587-.00038",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "224 64 128 96 32 64 128 32 224 64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M169.33686,82.22033a56,56,0,1,1-82.67374,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "32",
      "y1": "64",
      "x2": "32",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M54.23194,215.99924a88.02249,88.02249,0,0,1,147.53587-.00038",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "224 64 128 96 32 64 128 32 224 64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M169.33686,82.22033a56,56,0,1,1-82.67374,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$c8 = [];
/* style */

const __vue_inject_styles__$c8 = undefined;
/* scoped */

const __vue_scope_id__$c8 = undefined;
/* module identifier */

const __vue_module_identifier__$c8 = undefined;
/* functional template */

const __vue_is_functional_template__$c8 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$c8 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$c8,
  staticRenderFns: __vue_staticRenderFns__$c8
}, __vue_inject_styles__$c8, __vue_script__$c8, __vue_scope_id__$c8, __vue_is_functional_template__$c8, __vue_module_identifier__$c8, false, undefined, undefined, undefined);

var script$c9 = Vue.extend({
  name: "PhSuitcase",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$c9 = script$c9;
/* template */

var __vue_render__$c9 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "68",
      "width": "192",
      "height": "144",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,212V48a16,16,0,0,0-16-16H104A16,16,0,0,0,88,48V212",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M88,72V216l-47.99219,0a8,8,0,0,1-8-8v-128a8,8,0,0,1,8-8Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168.00781,72V216l47.99219,0a8,8,0,0,0,8-8v-128a8,8,0,0,0-8-8Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "144",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,216V56a16,16,0,0,0-16-16H104A16,16,0,0,0,88,56V216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,64H175.99219V56a24.0275,24.0275,0,0,0-24-24h-48a24.0275,24.0275,0,0,0-24,24v8H40A16.01833,16.01833,0,0,0,24,80V208a16.01833,16.01833,0,0,0,16,16H216a16.01833,16.01833,0,0,0,16-16V80A16.01833,16.01833,0,0,0,216,64ZM95.99219,80h64V208h-64Zm0-24a8.00916,8.00916,0,0,1,8-8h48a8.00917,8.00917,0,0,1,8,8v8h-64Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "144",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,216V56a16,16,0,0,0-16-16H104A16,16,0,0,0,88,56V216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "144",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,216V56a16,16,0,0,0-16-16H104A16,16,0,0,0,88,56V216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "144",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,216V56a16,16,0,0,0-16-16H104A16,16,0,0,0,88,56V216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$c9 = [];
/* style */

const __vue_inject_styles__$c9 = undefined;
/* scoped */

const __vue_scope_id__$c9 = undefined;
/* module identifier */

const __vue_module_identifier__$c9 = undefined;
/* functional template */

const __vue_is_functional_template__$c9 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$c9 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$c9,
  staticRenderFns: __vue_staticRenderFns__$c9
}, __vue_inject_styles__$c9, __vue_script__$c9, __vue_scope_id__$c9, __vue_is_functional_template__$c9, __vue_module_identifier__$c9, false, undefined, undefined, undefined);

var script$ca = Vue.extend({
  name: "PhSuitcaseSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$ca = script$ca;
/* template */

var __vue_render__$ca = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "68",
      "width": "192",
      "height": "144",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,68V48a16,16,0,0,0-16-16H104A16,16,0,0,0,88,48V68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "160",
      "x2": "224",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,160v48a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V160",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "144",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,72V56a16,16,0,0,0-16-16H104A16,16,0,0,0,88,56V72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "160",
      "x2": "224",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216.0006,64H175.99429V56a24.027,24.027,0,0,0-23.9991-24H103.997A24.027,24.027,0,0,0,79.9979,56v8H40.00721a16.018,16.018,0,0,0-15.9994,16v79.84521c-.001.05225-.00781.10254-.00781.15479s.00684.10254.00781.15479V208a16.018,16.018,0,0,0,15.9994,16H216.0006A16.018,16.018,0,0,0,232,208V80A16.018,16.018,0,0,0,216.0006,64ZM95.9973,56a8.009,8.009,0,0,1,7.9997-8h47.99819a8.009,8.009,0,0,1,7.9997,8v8H95.9973ZM216.0006,80l.00586,72H40.00721V80Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "144",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,72V56a16,16,0,0,0-16-16H104A16,16,0,0,0,88,56V72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "160",
      "x2": "224",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "144",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,72V56a16,16,0,0,0-16-16H104A16,16,0,0,0,88,56V72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "160",
      "x2": "224",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "144",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,72V56a16,16,0,0,0-16-16H104A16,16,0,0,0,88,56V72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "160",
      "x2": "224",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$ca = [];
/* style */

const __vue_inject_styles__$ca = undefined;
/* scoped */

const __vue_scope_id__$ca = undefined;
/* module identifier */

const __vue_module_identifier__$ca = undefined;
/* functional template */

const __vue_is_functional_template__$ca = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$ca = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$ca,
  staticRenderFns: __vue_staticRenderFns__$ca
}, __vue_inject_styles__$ca, __vue_script__$ca, __vue_scope_id__$ca, __vue_is_functional_template__$ca, __vue_module_identifier__$ca, false, undefined, undefined, undefined);

var script$cb = Vue.extend({
  name: "PhSun",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cb = script$cb;
/* template */

var __vue_render__$cb = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "28",
      "x2": "128",
      "y2": "12",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "198.71068",
      "y1": "57.28932",
      "x2": "210.02439",
      "y2": "45.97561",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "228",
      "y1": "128",
      "x2": "244",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "198.71068",
      "y1": "198.71068",
      "x2": "210.02439",
      "y2": "210.02439",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "228",
      "x2": "128",
      "y2": "244",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "57.28932",
      "y1": "198.71068",
      "x2": "45.97561",
      "y2": "210.02439",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "28",
      "y1": "128",
      "x2": "12",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "57.28932",
      "y1": "57.28932",
      "x2": "45.97561",
      "y2": "45.97561",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "60",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "36",
      "x2": "128",
      "y2": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "62.94618",
      "y1": "62.94618",
      "x2": "48.80404",
      "y2": "48.80404",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "36",
      "y1": "128",
      "x2": "16",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "62.94618",
      "y1": "193.05382",
      "x2": "48.80404",
      "y2": "207.19596",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "220",
      "x2": "128",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "193.05382",
      "y1": "193.05382",
      "x2": "207.19596",
      "y2": "207.19596",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "220",
      "y1": "128",
      "x2": "240",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "193.05382",
      "y1": "62.94618",
      "x2": "207.19596",
      "y2": "48.80404",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "68"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,44a8.00008,8.00008,0,0,0,8-8V16a8,8,0,0,0-16,0V36A8.00008,8.00008,0,0,0,128,44Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M57.28955,68.603A7.99984,7.99984,0,1,0,68.603,57.28955L54.46094,43.14746A7.99984,7.99984,0,1,0,43.14746,54.46094Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M44,128a8.00008,8.00008,0,0,0-8-8H16a8,8,0,0,0,0,16H36A8.00008,8.00008,0,0,0,44,128Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M57.28955,187.397,43.14746,201.53906a7.99984,7.99984,0,1,0,11.31348,11.31348L68.603,198.71045A7.99984,7.99984,0,1,0,57.28955,187.397Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,212a8.00008,8.00008,0,0,0-8,8v20a8,8,0,0,0,16,0V220A8.00008,8.00008,0,0,0,128,212Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M198.71045,187.397A7.99984,7.99984,0,1,0,187.397,198.71045l14.14209,14.14209a7.99984,7.99984,0,1,0,11.31348-11.31348Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M240,120H220a8,8,0,0,0,0,16h20a8,8,0,0,0,0-16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M193.05371,70.94629a7.97507,7.97507,0,0,0,5.65674-2.34326l14.14209-14.14209a7.99984,7.99984,0,1,0-11.31348-11.31348L187.397,57.28955a7.99976,7.99976,0,0,0,5.65674,13.65674Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "36",
      "x2": "128",
      "y2": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "62.94618",
      "y1": "62.94618",
      "x2": "48.80404",
      "y2": "48.80404",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "36",
      "y1": "128",
      "x2": "16",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "62.94618",
      "y1": "193.05382",
      "x2": "48.80404",
      "y2": "207.19596",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "220",
      "x2": "128",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "193.05382",
      "y1": "193.05382",
      "x2": "207.19596",
      "y2": "207.19596",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "220",
      "y1": "128",
      "x2": "240",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "193.05382",
      "y1": "62.94618",
      "x2": "207.19596",
      "y2": "48.80404",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "36",
      "x2": "128",
      "y2": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "62.94618",
      "y1": "62.94618",
      "x2": "48.80404",
      "y2": "48.80404",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "36",
      "y1": "128",
      "x2": "16",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "62.94618",
      "y1": "193.05382",
      "x2": "48.80404",
      "y2": "207.19596",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "220",
      "x2": "128",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "193.05382",
      "y1": "193.05382",
      "x2": "207.19596",
      "y2": "207.19596",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "220",
      "y1": "128",
      "x2": "240",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "193.05382",
      "y1": "62.94618",
      "x2": "207.19596",
      "y2": "48.80404",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "36",
      "x2": "128",
      "y2": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "62.94618",
      "y1": "62.94618",
      "x2": "48.80404",
      "y2": "48.80404",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "36",
      "y1": "128",
      "x2": "16",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "62.94618",
      "y1": "193.05382",
      "x2": "48.80404",
      "y2": "207.19596",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "220",
      "x2": "128",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "193.05382",
      "y1": "193.05382",
      "x2": "207.19596",
      "y2": "207.19596",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "220",
      "y1": "128",
      "x2": "240",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "193.05382",
      "y1": "62.94618",
      "x2": "207.19596",
      "y2": "48.80404",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cb = [];
/* style */

const __vue_inject_styles__$cb = undefined;
/* scoped */

const __vue_scope_id__$cb = undefined;
/* module identifier */

const __vue_module_identifier__$cb = undefined;
/* functional template */

const __vue_is_functional_template__$cb = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cb = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cb,
  staticRenderFns: __vue_staticRenderFns__$cb
}, __vue_inject_styles__$cb, __vue_script__$cb, __vue_scope_id__$cb, __vue_is_functional_template__$cb, __vue_module_identifier__$cb, false, undefined, undefined, undefined);

var script$cc = Vue.extend({
  name: "PhSunDim",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cc = script$cc;
/* template */

var __vue_render__$cc = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "28",
      "x2": "128",
      "y2": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "198.71068",
      "y1": "57.28932",
      "x2": "204.36753",
      "y2": "51.63247",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "228",
      "y1": "128",
      "x2": "236",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "198.71068",
      "y1": "198.71068",
      "x2": "204.36753",
      "y2": "204.36753",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "228",
      "x2": "128",
      "y2": "236",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "57.28932",
      "y1": "198.71068",
      "x2": "51.63247",
      "y2": "204.36753",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "28",
      "y1": "128",
      "x2": "20",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "57.28932",
      "y1": "57.28932",
      "x2": "51.63247",
      "y2": "51.63247",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "60",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "36",
      "x2": "128",
      "y2": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "62.94618",
      "y1": "62.94618",
      "x2": "57.28932",
      "y2": "57.28932",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "36",
      "y1": "128",
      "x2": "28",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "62.94618",
      "y1": "193.05382",
      "x2": "57.28932",
      "y2": "198.71068",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "220",
      "x2": "128",
      "y2": "228",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "193.05382",
      "y1": "193.05382",
      "x2": "198.71068",
      "y2": "198.71068",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "220",
      "y1": "128",
      "x2": "228",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "193.05382",
      "y1": "62.94618",
      "x2": "198.71068",
      "y2": "57.28932",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "68"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,44a7.99993,7.99993,0,0,0,8-8V28a8,8,0,0,0-16,0v8A7.99993,7.99993,0,0,0,128,44Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M57.28906,68.603A8,8,0,1,0,68.603,57.28955l-5.65674-5.657A7.99983,7.99983,0,1,0,51.63281,62.946Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M36,120H28a8,8,0,0,0,0,16h8a8,8,0,0,0,0-16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M57.28955,187.397l-5.65674,5.65674a7.99984,7.99984,0,1,0,11.31348,11.31348l5.65674-5.65674A7.99984,7.99984,0,0,0,57.28955,187.397Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,212a7.99977,7.99977,0,0,0-8,8v8a8,8,0,0,0,16,0v-8A7.99977,7.99977,0,0,0,128,212Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M198.71045,187.397A7.99984,7.99984,0,0,0,187.397,198.71045l5.65674,5.65674a7.99984,7.99984,0,0,0,11.31348-11.31348Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M228,120h-8a8,8,0,0,0,0,16h8a8,8,0,0,0,0-16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M193.05371,70.94629a7.977,7.977,0,0,0,5.65723-2.34326l5.65625-5.657a7.99983,7.99983,0,1,0-11.31348-11.31347l-5.65674,5.657a7.99988,7.99988,0,0,0,5.65674,13.65674Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "36",
      "x2": "128",
      "y2": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "62.94618",
      "y1": "62.94618",
      "x2": "57.28932",
      "y2": "57.28932",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "36",
      "y1": "128",
      "x2": "28",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "62.94618",
      "y1": "193.05382",
      "x2": "57.28932",
      "y2": "198.71068",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "220",
      "x2": "128",
      "y2": "228",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "193.05382",
      "y1": "193.05382",
      "x2": "198.71068",
      "y2": "198.71068",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "220",
      "y1": "128",
      "x2": "228",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "193.05382",
      "y1": "62.94618",
      "x2": "198.71068",
      "y2": "57.28932",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "36",
      "x2": "128",
      "y2": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "62.94618",
      "y1": "62.94618",
      "x2": "57.28932",
      "y2": "57.28932",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "36",
      "y1": "128",
      "x2": "28",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "62.94618",
      "y1": "193.05382",
      "x2": "57.28932",
      "y2": "198.71068",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "220",
      "x2": "128",
      "y2": "228",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "193.05382",
      "y1": "193.05382",
      "x2": "198.71068",
      "y2": "198.71068",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "220",
      "y1": "128",
      "x2": "228",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "193.05382",
      "y1": "62.94618",
      "x2": "198.71068",
      "y2": "57.28932",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "36",
      "x2": "128",
      "y2": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "62.94618",
      "y1": "62.94618",
      "x2": "57.28932",
      "y2": "57.28932",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "36",
      "y1": "128",
      "x2": "28",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "62.94618",
      "y1": "193.05382",
      "x2": "57.28932",
      "y2": "198.71068",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "220",
      "x2": "128",
      "y2": "228",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "193.05382",
      "y1": "193.05382",
      "x2": "198.71068",
      "y2": "198.71068",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "220",
      "y1": "128",
      "x2": "228",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "193.05382",
      "y1": "62.94618",
      "x2": "198.71068",
      "y2": "57.28932",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cc = [];
/* style */

const __vue_inject_styles__$cc = undefined;
/* scoped */

const __vue_scope_id__$cc = undefined;
/* module identifier */

const __vue_module_identifier__$cc = undefined;
/* functional template */

const __vue_is_functional_template__$cc = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cc = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cc,
  staticRenderFns: __vue_staticRenderFns__$cc
}, __vue_inject_styles__$cc, __vue_script__$cc, __vue_scope_id__$cc, __vue_is_functional_template__$cc, __vue_module_identifier__$cc, false, undefined, undefined, undefined);

var script$cd = Vue.extend({
  name: "PhSunHorizon",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cd = script$cd;
/* template */

var __vue_render__$cd = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "92.79312",
      "y1": "59.00308",
      "x2": "85.13946",
      "y2": "40.52549",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "43.00308",
      "y1": "108.79312",
      "x2": "24.52549",
      "y2": "101.13946",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "212.99692",
      "y1": "108.79312",
      "x2": "231.47451",
      "y2": "101.13946",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "163.20688",
      "y1": "59.00308",
      "x2": "170.86054",
      "y2": "40.52549",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "240",
      "y1": "160",
      "x2": "16",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "200",
      "x2": "48",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M77.3915,160.00018a52,52,0,1,1,101.217.00018",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M70.157,160.00035a60,60,0,1,1,115.686-.00008Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "92.79312",
      "y1": "59.00308",
      "x2": "85.13946",
      "y2": "40.52549",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "43.00308",
      "y1": "108.79312",
      "x2": "24.52549",
      "y2": "101.13946",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "212.99692",
      "y1": "108.79312",
      "x2": "231.47451",
      "y2": "101.13946",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "163.20688",
      "y1": "59.00308",
      "x2": "170.86054",
      "y2": "40.52549",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "240",
      "y1": "160",
      "x2": "16",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "200",
      "x2": "48",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M70.157,160.00035a60,60,0,1,1,115.686-.00008",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M77.74854,43.58691a8.00009,8.00009,0,0,1,14.78222-6.123l7.65332,18.47754a8.00009,8.00009,0,1,1-14.78222,6.123ZM21.46387,108.53027l18.47754,7.65332a7.99964,7.99964,0,1,0,6.123-14.78125L27.58691,93.749a7.99964,7.99964,0,1,0-6.123,14.78125ZM213,116.79492a7.97082,7.97082,0,0,0,3.05859-.61133l18.47754-7.65332a7.99964,7.99964,0,1,0-6.123-14.78125l-18.47754,7.65332A8.001,8.001,0,0,0,213,116.79492ZM160.14551,66.39355a7.99266,7.99266,0,0,0,10.45263-4.3291l7.65332-18.47754a8.00009,8.00009,0,0,0-14.78222-6.123l-7.65332,18.47754A7.99929,7.99929,0,0,0,160.14551,66.39355ZM240,152H195.52319a68,68,0,1,0-135.04638,0H16a8,8,0,0,0,0,16H185.81812l.02905.00195L185.87085,168H240a8,8,0,0,0,0-16Zm-32,40H48a8,8,0,0,0,0,16H208a8,8,0,0,0,0-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "92.79312",
      "y1": "59.00308",
      "x2": "85.13946",
      "y2": "40.52549",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "43.00308",
      "y1": "108.79312",
      "x2": "24.52549",
      "y2": "101.13946",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "212.99692",
      "y1": "108.79312",
      "x2": "231.47451",
      "y2": "101.13946",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "163.20688",
      "y1": "59.00308",
      "x2": "170.86054",
      "y2": "40.52549",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "240",
      "y1": "160",
      "x2": "16",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "200",
      "x2": "48",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M70.157,160.00035a60,60,0,1,1,115.686-.00008",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "92.79312",
      "y1": "59.00308",
      "x2": "85.13946",
      "y2": "40.52549",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "43.00308",
      "y1": "108.79312",
      "x2": "24.52549",
      "y2": "101.13946",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "212.99692",
      "y1": "108.79312",
      "x2": "231.47451",
      "y2": "101.13946",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "163.20688",
      "y1": "59.00308",
      "x2": "170.86054",
      "y2": "40.52549",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "240",
      "y1": "160",
      "x2": "16",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "200",
      "x2": "48",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M70.157,160.00035a60,60,0,1,1,115.686-.00008",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "92.79312",
      "y1": "59.00308",
      "x2": "85.13946",
      "y2": "40.52549",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "43.00308",
      "y1": "108.79312",
      "x2": "24.52549",
      "y2": "101.13946",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "212.99692",
      "y1": "108.79312",
      "x2": "231.47451",
      "y2": "101.13946",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "163.20688",
      "y1": "59.00308",
      "x2": "170.86054",
      "y2": "40.52549",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "240",
      "y1": "160",
      "x2": "16",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "200",
      "x2": "48",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M70.157,160.00035a60,60,0,1,1,115.686-.00008",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cd = [];
/* style */

const __vue_inject_styles__$cd = undefined;
/* scoped */

const __vue_scope_id__$cd = undefined;
/* module identifier */

const __vue_module_identifier__$cd = undefined;
/* functional template */

const __vue_is_functional_template__$cd = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cd = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cd,
  staticRenderFns: __vue_staticRenderFns__$cd
}, __vue_inject_styles__$cd, __vue_script__$cd, __vue_scope_id__$cd, __vue_is_functional_template__$cd, __vue_module_identifier__$cd, false, undefined, undefined, undefined);

var script$ce = Vue.extend({
  name: "PhSwap",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$ce = script$ce;
/* template */

var __vue_render__$ce = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,159.99316H208a8,8,0,0,0,8-8v-104a8,8,0,0,0-8-8H96a8,8,0,0,0-8,8v8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "104 136 80 160 104 184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,96H48a8,8,0,0,0-8,8V208a8,8,0,0,0,8,8H160a8,8,0,0,0,8-8v-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 119.993 176 95.993 152 71.993",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,40H96a8,8,0,0,0-8,8V96H48a8,8,0,0,0-8,8V208a8,8,0,0,0,8,8H160a8,8,0,0,0,8-8V160h40a8,8,0,0,0,8-8V48A8,8,0,0,0,208,40Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,159.99316H208a8,8,0,0,0,8-8v-104a8,8,0,0,0-8-8H96a8,8,0,0,0-8,8v8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "104 136 80 160 104 184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,96H48a8,8,0,0,0-8,8V208a8,8,0,0,0,8,8H160a8,8,0,0,0,8-8v-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 119.993 176 95.993 152 71.993",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,47.99316v104a16.01833,16.01833,0,0,1-16,16H112V184a8.00018,8.00018,0,0,1-13.65674,5.65723l-24-24a7.98872,7.98872,0,0,1-1.36011-1.822c-.00622-.01124-.01367-.022-.01977-.03333-.10376-.192-.19556-.38843-.28259-.58655-.01892-.04309-.04114-.08435-.05921-.12768-.07483-.179-.13794-.36121-.19922-.54407-.0227-.06751-.04944-.13318-.07043-.20154-.0531-.17383-.09436-.34985-.13538-.52624-.01867-.08045-.04223-.15882-.05859-.24012-.03809-.19043-.06348-.38232-.08765-.57446-.00879-.06934-.023-.137-.02978-.20691-.02637-.26575-.04053-.53235-.04041-.79907L72,159.99316c0-.025.00342-.04907.00366-.07409.00244-.23572.0127-.47132.03577-.70606.01526-.15759.043-.31128.06726-.46618.01587-.09986.02612-.20032.04565-.29969.03565-.18139.083-.358.13062-.53479.01953-.072.03418-.145.05566-.21655.05591-.18652.123-.3678.1919-.54834.02331-.06116.04248-.12329.06738-.184.07739-.18884.16553-.37146.25659-.55286.02527-.05041.04688-.10229.07324-.15222.1084-.20459.22706-.40222.35218-.59582.0155-.024.02844-.04907.04431-.073a8.02882,8.02882,0,0,1,1.09057-1.31836l23.92847-23.92847A8.00037,8.00037,0,0,1,112,136v15.99316h96v-104H96v8a8,8,0,0,1-16,0v-8a16.01833,16.01833,0,0,1,16-16H208A16.01833,16.01833,0,0,1,224,47.99316ZM168,192a8.00008,8.00008,0,0,0-8,8v8H48V104h96v15.99316a8.00018,8.00018,0,0,0,13.65674,5.65723l23.92847-23.92847a8.0284,8.0284,0,0,0,1.09057-1.31836c.01587-.02392.02881-.049.04431-.073.12512-.19361.24378-.39124.35218-.59583.02648-.05017.04809-.10217.0736-.15283.09095-.18091.17884-.36316.256-.55164.02539-.06176.04492-.12524.06872-.1875.06848-.17968.13513-.35986.1908-.54541.02148-.07153.03613-.14453.05566-.21655.04761-.17676.095-.35339.13062-.53479.01953-.09936.02978-.19983.04565-.29968.02429-.15491.052-.3086.06726-.46619.02307-.23474.03333-.47034.03577-.70605C183.99658,96.04907,184,96.025,184,96l-.00012-.00208c.00012-.26672-.014-.53332-.04041-.79907-.00683-.06994-.021-.13757-.02978-.20691-.02417-.19214-.04956-.384-.08765-.57446-.01636-.0813-.03992-.15967-.05859-.24011-.041-.17639-.08228-.35242-.13538-.52625-.02087-.06787-.04748-.13305-.06995-.20019-.06152-.1836-.12475-.36634-.2-.5459-.01782-.04248-.0393-.08252-.05786-.12463-.08716-.1991-.17944-.39637-.28369-.58912-.0061-.01135-.01355-.02209-.01977-.03332a7.9885,7.9885,0,0,0-1.36011-1.822l-24-24A8.00037,8.00037,0,0,0,144,71.99316V88H48a16.01833,16.01833,0,0,0-16,16V208a16.01833,16.01833,0,0,0,16,16H160a16.01833,16.01833,0,0,0,16-16v-8A8.00008,8.00008,0,0,0,168,192Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,159.99316H208a8,8,0,0,0,8-8v-104a8,8,0,0,0-8-8H96a8,8,0,0,0-8,8v8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "104 136 80 160 104 184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,96H48a8,8,0,0,0-8,8V208a8,8,0,0,0,8,8H160a8,8,0,0,0,8-8v-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 119.993 176 95.993 152 71.993",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,159.99316H208a8,8,0,0,0,8-8v-104a8,8,0,0,0-8-8H96a8,8,0,0,0-8,8v8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "104 136 80 160 104 184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,96H48a8,8,0,0,0-8,8V208a8,8,0,0,0,8,8H160a8,8,0,0,0,8-8v-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 119.993 176 95.993 152 71.993",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,159.99316H208a8,8,0,0,0,8-8v-104a8,8,0,0,0-8-8H96a8,8,0,0,0-8,8v8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "104 136 80 160 104 184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,96H48a8,8,0,0,0-8,8V208a8,8,0,0,0,8,8H160a8,8,0,0,0,8-8v-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 119.993 176 95.993 152 71.993",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$ce = [];
/* style */

const __vue_inject_styles__$ce = undefined;
/* scoped */

const __vue_scope_id__$ce = undefined;
/* module identifier */

const __vue_module_identifier__$ce = undefined;
/* functional template */

const __vue_is_functional_template__$ce = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$ce = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$ce,
  staticRenderFns: __vue_staticRenderFns__$ce
}, __vue_inject_styles__$ce, __vue_script__$ce, __vue_scope_id__$ce, __vue_is_functional_template__$ce, __vue_module_identifier__$ce, false, undefined, undefined, undefined);

var script$cf = Vue.extend({
  name: "PhSwatches",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cf = script$cf;
/* template */

var __vue_render__$cf = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M36.67036,173.04838,60.85763,35.87558a8,8,0,0,1,9.26764-6.48928l55.14924,9.7243a8,8,0,0,1,6.48927,9.26765L107.453,186.25133a36.00022,36.00022,0,0,1-41.01188,29.317C46.4984,212.4439,33.16509,192.92775,36.67036,173.04838Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M118.28071,124.84457,191.244,98.2881a8,8,0,0,1,10.2537,4.78138l19.15313,52.62278a8,8,0,0,1-4.78138,10.25371l-131.557,47.88282",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M219.99977,162.53273v45.467a8,8,0,0,1-8,8h-140",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "180",
      "x2": "74.08378",
      "y2": "168.18231",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M36.67036,173.04838,60.85763,35.87558a8,8,0,0,1,9.26764-6.48928l55.14924,9.7243a8,8,0,0,1,6.48927,9.26765L107.453,186.25133a36.00022,36.00022,0,0,1-41.01188,29.317C46.4984,212.4439,33.16509,192.92775,36.67036,173.04838Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M36.67036,173.04838,60.85763,35.87558a8,8,0,0,1,9.26764-6.48928l55.14924,9.7243a8,8,0,0,1,6.48927,9.26765L107.453,186.25133a36.00022,36.00022,0,0,1-41.01188,29.317C46.4984,212.4439,33.16509,192.92775,36.67036,173.04838Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M118.28071,124.84457,191.244,98.2881a8,8,0,0,1,10.2537,4.78138l19.15313,52.62278a8,8,0,0,1-4.78138,10.25371l-131.557,47.88282",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M219.99977,162.53273v45.467a8,8,0,0,1-8,8h-140",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "72",
      "cy": "180",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M228.16846,152.95605,209.01514,100.334a16.0165,16.0165,0,0,0-20.50733-9.56347l-59.94262,21.81738,11.0769-62.82031a16.00057,16.00057,0,0,0-12.97852-18.53613L71.51514,21.50879A15.99894,15.99894,0,0,0,52.979,34.48633L28.792,171.65918a45.288,45.288,0,0,0,7.74365,33.9834A43.299,43.299,0,0,0,71.937,223.99707h.00342c.02014,0,.03955.00293.05957.00293H212a16.01833,16.01833,0,0,0,16-16V164.27759A15.91483,15.91483,0,0,0,228.16846,152.95605ZM72,192a12,12,0,1,1,12-12A12.01343,12.01343,0,0,1,72,192Zm140,16H123.71875L212,175.86841Zm-98.54736-13.29053a43.46748,43.46748,0,0,0,1.8789-7.06885l10.02552-56.85791L193.98,105.80566l19.15332,52.623Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M36.67036,173.04838,60.85763,35.87558a8,8,0,0,1,9.26764-6.48928l55.14924,9.7243a8,8,0,0,1,6.48927,9.26765L107.453,186.25133a36.00022,36.00022,0,0,1-41.01188,29.317C46.4984,212.4439,33.16509,192.92775,36.67036,173.04838Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M118.28071,124.84457,191.244,98.2881a8,8,0,0,1,10.2537,4.78138l19.15313,52.62278a8,8,0,0,1-4.78138,10.25371l-131.557,47.88282",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M219.99977,162.53273v45.467a8,8,0,0,1-8,8h-140",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "72",
      "cy": "180",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M36.67036,173.04838,60.85763,35.87558a8,8,0,0,1,9.26764-6.48928l55.14924,9.7243a8,8,0,0,1,6.48927,9.26765L107.453,186.25133a36.00022,36.00022,0,0,1-41.01188,29.317C46.4984,212.4439,33.16509,192.92775,36.67036,173.04838Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M118.28071,124.84457,191.244,98.2881a8,8,0,0,1,10.2537,4.78138l19.15313,52.62278a8,8,0,0,1-4.78138,10.25371l-131.557,47.88282",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M219.99977,162.53273v45.467a8,8,0,0,1-8,8h-140",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "72",
      "cy": "180",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M36.67036,173.04838,60.85763,35.87558a8,8,0,0,1,9.26764-6.48928l55.14924,9.7243a8,8,0,0,1,6.48927,9.26765L107.453,186.25133a36.00022,36.00022,0,0,1-41.01188,29.317C46.4984,212.4439,33.16509,192.92775,36.67036,173.04838Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M118.28071,124.84457,191.244,98.2881a8,8,0,0,1,10.2537,4.78138l19.15313,52.62278a8,8,0,0,1-4.78138,10.25371l-131.557,47.88282",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M219.99977,162.53273v45.467a8,8,0,0,1-8,8h-140",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "72",
      "cy": "180",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cf = [];
/* style */

const __vue_inject_styles__$cf = undefined;
/* scoped */

const __vue_scope_id__$cf = undefined;
/* module identifier */

const __vue_module_identifier__$cf = undefined;
/* functional template */

const __vue_is_functional_template__$cf = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cf = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cf,
  staticRenderFns: __vue_staticRenderFns__$cf
}, __vue_inject_styles__$cf, __vue_script__$cf, __vue_scope_id__$cf, __vue_is_functional_template__$cf, __vue_module_identifier__$cf, false, undefined, undefined, undefined);

var script$cg = Vue.extend({
  name: "PhSword",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cg = script$cg;
/* template */

var __vue_render__$cg = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "72.201 128.201 152.201 40.201 216 40 215.799 103.799 127.799 183.799",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "156",
      "x2": "160",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M82.14214,205.45584,60.201,227.397a8,8,0,0,1-11.31371,0L28.603,207.11268a8,8,0,0,1,0-11.31371l21.94113-21.94112a8,8,0,0,0,0-11.31371L33.65685,145.65685a8,8,0,0,1,0-11.3137l16.6863-16.6863a8,8,0,0,1,11.3137,0l76.6863,76.6863a8,8,0,0,1,0,11.3137l-16.6863,16.6863a8,8,0,0,1-11.3137,0L93.45584,205.45584A8,8,0,0,0,82.14214,205.45584Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M82.14214,197.45584,52.201,227.397a8,8,0,0,1-11.31371,0L28.603,215.11268a8,8,0,0,1,0-11.31371l29.94113-29.94112a8,8,0,0,0,0-11.31371L37.65685,141.65685a8,8,0,0,1,0-11.3137l12.6863-12.6863a8,8,0,0,1,11.3137,0l76.6863,76.6863a8,8,0,0,1,0,11.3137l-12.6863,12.6863a8,8,0,0,1-11.3137,0L93.45584,197.45584A8,8,0,0,0,82.14214,197.45584Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "76.201 132.201 152.201 40.201 216 40 215.799 103.799 123.799 179.799",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "156",
      "x2": "160",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M82.14214,197.45584,52.201,227.397a8,8,0,0,1-11.31371,0L28.603,215.11268a8,8,0,0,1,0-11.31371l29.94113-29.94112a8,8,0,0,0,0-11.31371L37.65685,141.65685a8,8,0,0,1,0-11.3137l12.6863-12.6863a8,8,0,0,1,11.3137,0l76.6863,76.6863a8,8,0,0,1,0,11.3137l-12.6863,12.6863a8,8,0,0,1-11.3137,0L93.45584,197.45584A8,8,0,0,0,82.14214,197.45584Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M221.65723,34.34326A8.00246,8.00246,0,0,0,216,32h-.02539l-63.79883.20117A8.00073,8.00073,0,0,0,146.0332,35.106L75.637,120.32275,67.31348,111.999A16.02162,16.02162,0,0,0,44.68555,112L32.001,124.68555A15.99888,15.99888,0,0,0,32,147.31348l20.88672,20.88769L22.94531,198.14258a16.01777,16.01777,0,0,0,.001,22.62695l12.28418,12.28418a16.00007,16.00007,0,0,0,22.62793,0L87.79883,203.1123,108.68652,224.001A16.02251,16.02251,0,0,0,131.31445,224L143.999,211.31445A15.99888,15.99888,0,0,0,144,188.68652l-8.32324-8.32324,85.21679-70.39648a8.00125,8.00125,0,0,0,2.90528-6.14258L224,40.02539A8.001,8.001,0,0,0,221.65723,34.34326Zm-13.84668,65.67822-83.49829,68.97706L111.314,156l54.34327-54.34277a8.00053,8.00053,0,0,0-11.31446-11.31446L100,144.686,87.00195,131.6875,155.97852,48.189l51.99609-.16357Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "76.201 132.201 152.201 40.201 216 40 215.799 103.799 123.799 179.799",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "156",
      "x2": "160",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M82.14214,197.45584,52.201,227.397a8,8,0,0,1-11.31371,0L28.603,215.11268a8,8,0,0,1,0-11.31371l29.94113-29.94112a8,8,0,0,0,0-11.31371L37.65685,141.65685a8,8,0,0,1,0-11.3137l12.6863-12.6863a8,8,0,0,1,11.3137,0l76.6863,76.6863a8,8,0,0,1,0,11.3137l-12.6863,12.6863a8,8,0,0,1-11.3137,0L93.45584,197.45584A8,8,0,0,0,82.14214,197.45584Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "76.201 132.201 152.201 40.201 216 40 215.799 103.799 123.799 179.799",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "156",
      "x2": "160",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M82.14214,197.45584,52.201,227.397a8,8,0,0,1-11.31371,0L28.603,215.11268a8,8,0,0,1,0-11.31371l29.94113-29.94112a8,8,0,0,0,0-11.31371L37.65685,141.65685a8,8,0,0,1,0-11.3137l12.6863-12.6863a8,8,0,0,1,11.3137,0l76.6863,76.6863a8,8,0,0,1,0,11.3137l-12.6863,12.6863a8,8,0,0,1-11.3137,0L93.45584,197.45584A8,8,0,0,0,82.14214,197.45584Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "76.201 132.201 152.201 40.201 216 40 215.799 103.799 123.799 179.799",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "156",
      "x2": "160",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M82.14214,197.45584,52.201,227.397a8,8,0,0,1-11.31371,0L28.603,215.11268a8,8,0,0,1,0-11.31371l29.94113-29.94112a8,8,0,0,0,0-11.31371L37.65685,141.65685a8,8,0,0,1,0-11.3137l12.6863-12.6863a8,8,0,0,1,11.3137,0l76.6863,76.6863a8,8,0,0,1,0,11.3137l-12.6863,12.6863a8,8,0,0,1-11.3137,0L93.45584,197.45584A8,8,0,0,0,82.14214,197.45584Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cg = [];
/* style */

const __vue_inject_styles__$cg = undefined;
/* scoped */

const __vue_scope_id__$cg = undefined;
/* module identifier */

const __vue_module_identifier__$cg = undefined;
/* functional template */

const __vue_is_functional_template__$cg = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cg = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cg,
  staticRenderFns: __vue_staticRenderFns__$cg
}, __vue_inject_styles__$cg, __vue_script__$cg, __vue_scope_id__$cg, __vue_is_functional_template__$cg, __vue_module_identifier__$cg, false, undefined, undefined, undefined);

var script$ch = Vue.extend({
  name: "PhTShirt",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$ch = script$ch;
/* template */

var __vue_render__$ch = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M192,120h26.66667a8,8,0,0,0,7.38461-4.92308l15.32021-36.76848a8,8,0,0,0-3.19184-9.89019L192,40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,120H37.33333a8,8,0,0,1-7.38461-4.92308L14.62851,78.30844a8,8,0,0,1,3.19184-9.89019L64,40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160,40a32,32,0,0,1-64,0H64V208a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M192,120h27.05573a8,8,0,0,0,7.15542-4.42229l18.40439-36.80878a8,8,0,0,0-3.18631-10.52366L192,40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,120H36.94427a8,8,0,0,1-7.15542-4.42229L11.38446,78.76893a8,8,0,0,1,3.18631-10.52366L64,40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M192,120h27.05573a8,8,0,0,0,7.15542-4.42229l18.40439-36.80878a8,8,0,0,0-3.18631-10.52366L192,40Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,120H36.94427a8,8,0,0,1-7.15542-4.42229L11.38446,78.76893a8,8,0,0,1,3.18631-10.52366L64,40Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160,40a32,32,0,0,1-64,0H64V208a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M245.39844,61.29932,195.96924,33.0542c-.01953-.01123-.04-.019-.05957-.03027-.15833-.08887-.32215-.16846-.48694-.24659-.07752-.03686-.15393-.07763-.23206-.11181-.14917-.06494-.30322-.12012-.45691-.176-.09912-.03638-.19726-.07666-.29724-.10888-.11938-.03809-.24243-.06714-.36425-.09986-.13868-.03735-.27662-.07739-.41614-.10693-.08631-.01807-.17493-.0293-.26209-.04468-.1781-.03149-.35583-.06226-.53442-.08154-.07031-.00757-.142-.00928-.21265-.0149-.19653-.01586-.39282-.02856-.58911-.02978-.01953,0-.03833-.00293-.05786-.00293H160a7.99977,7.99977,0,0,0-8,8,24,24,0,0,1-48,0,7.99977,7.99977,0,0,0-8-8H64c-.02576,0-.05054.00366-.07629.00391-.16809.00146-.33606.01318-.50428.02539-.09814.00708-.19726.01025-.29443.02075-.15137.0166-.302.0437-.453.06909-.11365.019-.2284.03394-.34046.05786-.11706.0249-.23291.05933-.34936.08985-.14331.03735-.28736.072-.42749.11694-.08545.02759-.16931.0625-.25415.09326-.16724.05982-.334.12012-.49573.19067-.07251.03174-.14343.06983-.21545.10376-.16907.08008-.33692.16163-.49927.25269-.01953.011-.0398.0188-.05933.03L10.60107,61.29932A16.00794,16.00794,0,0,0,4.229,82.34668l18.4043,36.80811A15.91231,15.91231,0,0,0,36.94434,128H56v80a16.01833,16.01833,0,0,0,16,16H184a16.01833,16.01833,0,0,0,16-16V128h19.05566a15.91146,15.91146,0,0,0,14.31055-8.84473l18.40527-36.80908A16.00784,16.00784,0,0,0,245.39844,61.29932ZM36.94434,112,18.54,75.19092,56,53.7854V112Zm182.11132,0H200V53.7854l37.46045,21.406Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M192,120h27.05573a8,8,0,0,0,7.15542-4.42229l18.40439-36.80878a8,8,0,0,0-3.18631-10.52366L192,40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,120H36.94427a8,8,0,0,1-7.15542-4.42229L11.38446,78.76893a8,8,0,0,1,3.18631-10.52366L64,40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160,40a32,32,0,0,1-64,0H64V208a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M192,120h27.05573a8,8,0,0,0,7.15542-4.42229l18.40439-36.80878a8,8,0,0,0-3.18631-10.52366L192,40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,120H36.94427a8,8,0,0,1-7.15542-4.42229L11.38446,78.76893a8,8,0,0,1,3.18631-10.52366L64,40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160,40a32,32,0,0,1-64,0H64V208a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M192,120h27.05573a8,8,0,0,0,7.15542-4.42229l18.40439-36.80878a8,8,0,0,0-3.18631-10.52366L192,40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,120H36.94427a8,8,0,0,1-7.15542-4.42229L11.38446,78.76893a8,8,0,0,1,3.18631-10.52366L64,40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160,40a32,32,0,0,1-64,0H64V208a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$ch = [];
/* style */

const __vue_inject_styles__$ch = undefined;
/* scoped */

const __vue_scope_id__$ch = undefined;
/* module identifier */

const __vue_module_identifier__$ch = undefined;
/* functional template */

const __vue_is_functional_template__$ch = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$ch = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$ch,
  staticRenderFns: __vue_staticRenderFns__$ch
}, __vue_inject_styles__$ch, __vue_script__$ch, __vue_scope_id__$ch, __vue_is_functional_template__$ch, __vue_module_identifier__$ch, false, undefined, undefined, undefined);

var script$ci = Vue.extend({
  name: "PhTable",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$ci = script$ci;
/* template */

var __vue_render__$ci = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32.0002,56H223.9998a0,0,0,0,1,0,0V192a8,8,0,0,1-8,8H40.0002a8,8,0,0,1-8-8V56A0,0,0,0,1,32.0002,56Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "104",
      "x2": "224",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "152",
      "x2": "224",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88.00008",
      "y1": "104",
      "x2": "88.00008",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32.0002",
      "y": "104",
      "width": "55.99988",
      "height": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32.0002,56H223.9998a0,0,0,0,1,0,0V192a8,8,0,0,1-8,8H40.0002a8,8,0,0,1-8-8V56A0,0,0,0,1,32.0002,56Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "104",
      "x2": "224",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "152",
      "x2": "224",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88.00008",
      "y1": "104",
      "x2": "88.00008",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224.00586,48h-192a7.99977,7.99977,0,0,0-8,8V192a16.01833,16.01833,0,0,0,16,16h176a16.01833,16.01833,0,0,0,16-16V56A7.99977,7.99977,0,0,0,224.00586,48Zm-184,64h40v32h-40Zm56,0H216.01l.00244,32H96.00586Zm-56,48h40v32h-40Zm176,32h-120V160H216.01367l.00244,31.99951Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32.0002,56H223.9998a0,0,0,0,1,0,0V192a8,8,0,0,1-8,8H40.0002a8,8,0,0,1-8-8V56A0,0,0,0,1,32.0002,56Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "104",
      "x2": "224",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "152",
      "x2": "224",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88.00008",
      "y1": "104",
      "x2": "88.00008",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32.0002,56H223.9998a0,0,0,0,1,0,0V192a8,8,0,0,1-8,8H40.0002a8,8,0,0,1-8-8V56A0,0,0,0,1,32.0002,56Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "104",
      "x2": "224",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "152",
      "x2": "224",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88.00008",
      "y1": "104",
      "x2": "88.00008",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,56H224a0,0,0,0,1,0,0V192a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V56A0,0,0,0,1,32,56Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "104",
      "x2": "224",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "152",
      "x2": "224",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88.00008",
      "y1": "104",
      "x2": "88.00008",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$ci = [];
/* style */

const __vue_inject_styles__$ci = undefined;
/* scoped */

const __vue_scope_id__$ci = undefined;
/* module identifier */

const __vue_module_identifier__$ci = undefined;
/* functional template */

const __vue_is_functional_template__$ci = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$ci = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$ci,
  staticRenderFns: __vue_staticRenderFns__$ci
}, __vue_inject_styles__$ci, __vue_script__$ci, __vue_scope_id__$ci, __vue_is_functional_template__$ci, __vue_module_identifier__$ci, false, undefined, undefined, undefined);

var script$cj = Vue.extend({
  name: "PhTag",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cj = script$cj;
/* template */

var __vue_render__$cj = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M122.66459,25.8792,42.0101,42.0101,25.8792,122.66459a8,8,0,0,0,2.1878,7.22578L132.51977,234.34315a8,8,0,0,0,11.31371,0l90.50967-90.50967a8,8,0,0,0,0-11.31371L129.89037,28.067A8,8,0,0,0,122.66459,25.8792Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "84",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M122.66459,25.8792,42.0101,42.0101,25.8792,122.66459a8,8,0,0,0,2.1878,7.22578L132.51977,234.34315a8,8,0,0,0,11.31371,0l90.50967-90.50967a8,8,0,0,0,0-11.31371L129.89037,28.067A8,8,0,0,0,122.66459,25.8792Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M122.66459,25.8792,42.0101,42.0101,25.8792,122.66459a8,8,0,0,0,2.1878,7.22578L132.51977,234.34315a8,8,0,0,0,11.31371,0l90.50967-90.50967a8,8,0,0,0,0-11.31371L129.89037,28.067A8,8,0,0,0,122.66459,25.8792Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "84",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M240,126.8623,135.54785,22.41016a15.95972,15.95972,0,0,0-14.45215-4.376L40.44043,34.165A8.00261,8.00261,0,0,0,34.165,40.44043L18.03418,121.0957a15.97009,15.97009,0,0,0,4.376,14.45215L126.86133,239.999a16.00006,16.00006,0,0,0,22.6289.001L239.999,149.49121A16.00007,16.00007,0,0,0,240,126.8623ZM83.99414,96a12,12,0,1,1,12-12A12,12,0,0,1,83.99414,96Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M122.66459,25.8792,42.0101,42.0101,25.8792,122.66459a8,8,0,0,0,2.1878,7.22578L132.51977,234.34315a8,8,0,0,0,11.31371,0l90.50967-90.50967a8,8,0,0,0,0-11.31371L129.89037,28.067A8,8,0,0,0,122.66459,25.8792Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "84",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M122.66459,25.8792,42.0101,42.0101,25.8792,122.66459a8,8,0,0,0,2.1878,7.22578L132.51977,234.34315a8,8,0,0,0,11.31371,0l90.50967-90.50967a8,8,0,0,0,0-11.31371L129.89037,28.067A8,8,0,0,0,122.66459,25.8792Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "84",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M122.66459,25.8792,42.0101,42.0101,25.8792,122.66459a8,8,0,0,0,2.1878,7.22578L132.51977,234.34315a8,8,0,0,0,11.31371,0l90.50967-90.50967a8,8,0,0,0,0-11.31371L129.89037,28.067A8,8,0,0,0,122.66459,25.8792Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "84",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cj = [];
/* style */

const __vue_inject_styles__$cj = undefined;
/* scoped */

const __vue_scope_id__$cj = undefined;
/* module identifier */

const __vue_module_identifier__$cj = undefined;
/* functional template */

const __vue_is_functional_template__$cj = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cj = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cj,
  staticRenderFns: __vue_staticRenderFns__$cj
}, __vue_inject_styles__$cj, __vue_script__$cj, __vue_scope_id__$cj, __vue_is_functional_template__$cj, __vue_module_identifier__$cj, false, undefined, undefined, undefined);

var script$ck = Vue.extend({
  name: "PhTagChevron",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$ck = script$ck;
/* template */

var __vue_render__$ck = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M186.38079,196.42923l42.66667-64a8,8,0,0,0,0-8.87521l-42.66667-64a8,8,0,0,0-6.6564-3.5624H24.00586L69.0477,123.56221a8,8,0,0,1-.00048,8.8752L24.00586,199.99162H179.72439A8,8,0,0,0,186.38079,196.42923Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M186.38079,196.42923l42.66667-64a8,8,0,0,0,0-8.87521l-42.66667-64a8,8,0,0,0-6.6564-3.5624H24.00586L69.0477,123.56221a8,8,0,0,1-.00048,8.8752L24.00586,199.99162H179.72439A8,8,0,0,0,186.38079,196.42923Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M186.38079,196.42923l42.66667-64a8,8,0,0,0,0-8.87521l-42.66667-64a8,8,0,0,0-6.6564-3.5624H24.00586L69.0477,123.56221a8,8,0,0,1-.00048,8.8752L24.00586,199.99162H179.72439A8,8,0,0,0,186.38079,196.42923Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M235.7041,136.86719l-42.667,64h0a15.96753,15.96753,0,0,1-13.3125,7.124H24.00586a7.99977,7.99977,0,0,1-6.65625-12.4375L62.39062,128,17.34912,60.42871a8.00013,8.00013,0,0,1,6.65674-12.4375H179.72461a15.96734,15.96734,0,0,1,13.3125,7.125l42.667,64A15.96086,15.96086,0,0,1,235.7041,136.86719Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M186.38079,196.42923l42.66667-64a8,8,0,0,0,0-8.87521l-42.66667-64a8,8,0,0,0-6.6564-3.5624H24.00586L69.0477,123.56221a8,8,0,0,1-.00048,8.8752L24.00586,199.99162H179.72439A8,8,0,0,0,186.38079,196.42923Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M186.38079,196.42923l42.66667-64a8,8,0,0,0,0-8.87521l-42.66667-64a8,8,0,0,0-6.6564-3.5624H24.00586L69.0477,123.56221a8,8,0,0,1-.00048,8.8752L24.00586,199.99162H179.72439A8,8,0,0,0,186.38079,196.42923Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M186.38079,196.42923l42.66667-64a8,8,0,0,0,0-8.87521l-42.66667-64a8,8,0,0,0-6.6564-3.5624H24.00586L69.0477,123.56221a8,8,0,0,1-.00048,8.8752L24.00586,199.99162H179.72439A8,8,0,0,0,186.38079,196.42923Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$ck = [];
/* style */

const __vue_inject_styles__$ck = undefined;
/* scoped */

const __vue_scope_id__$ck = undefined;
/* module identifier */

const __vue_module_identifier__$ck = undefined;
/* functional template */

const __vue_is_functional_template__$ck = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$ck = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$ck,
  staticRenderFns: __vue_staticRenderFns__$ck
}, __vue_inject_styles__$ck, __vue_script__$ck, __vue_scope_id__$ck, __vue_is_functional_template__$ck, __vue_module_identifier__$ck, false, undefined, undefined, undefined);

var script$cl = Vue.extend({
  name: "PhTagSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cl = script$cl;
/* template */

var __vue_render__$cl = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M194.37493,196.43765,240,128,194.37493,59.56244a8,8,0,0,0-6.6564-3.56239H40a8,8,0,0,0-8,8V192a8,8,0,0,0,8,8H187.71853A8,8,0,0,0,194.37493,196.43765Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M194.37493,196.43765,240,128,194.37493,59.56244a8,8,0,0,0-6.6564-3.56239H40a8,8,0,0,0-8,8V192a8,8,0,0,0,8,8H187.71853A8,8,0,0,0,194.37493,196.43765Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M194.37493,196.43765,240,128,194.37493,59.56244a8,8,0,0,0-6.6564-3.56239H40a8,8,0,0,0-8,8V192a8,8,0,0,0,8,8H187.71853A8,8,0,0,0,194.37493,196.43765Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M246.65625,123.56213l-45.624-68.43652a15.9687,15.9687,0,0,0-13.31348-7.126H40a16.01833,16.01833,0,0,0-16,16v128a16.01833,16.01833,0,0,0,16,16H187.71875a15.96649,15.96649,0,0,0,13.31348-7.125l-.001.001,45.625-68.43848A7.99771,7.99771,0,0,0,246.65625,123.56213Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M194.37493,196.43765,240,128,194.37493,59.56244a8,8,0,0,0-6.6564-3.56239H40a8,8,0,0,0-8,8V192a8,8,0,0,0,8,8H187.71853A8,8,0,0,0,194.37493,196.43765Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M194.37493,196.43765,240,128,194.37493,59.56244a8,8,0,0,0-6.6564-3.56239H40a8,8,0,0,0-8,8V192a8,8,0,0,0,8,8H187.71853A8,8,0,0,0,194.37493,196.43765Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M194.37493,196.43765,240,128,194.37493,59.56244a8,8,0,0,0-6.6564-3.56239H40a8,8,0,0,0-8,8V192a8,8,0,0,0,8,8H187.71853A8,8,0,0,0,194.37493,196.43765Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cl = [];
/* style */

const __vue_inject_styles__$cl = undefined;
/* scoped */

const __vue_scope_id__$cl = undefined;
/* module identifier */

const __vue_module_identifier__$cl = undefined;
/* functional template */

const __vue_is_functional_template__$cl = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cl = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cl,
  staticRenderFns: __vue_staticRenderFns__$cl
}, __vue_inject_styles__$cl, __vue_script__$cl, __vue_scope_id__$cl, __vue_is_functional_template__$cl, __vue_module_identifier__$cl, false, undefined, undefined, undefined);

var script$cm = Vue.extend({
  name: "PhTarget",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cm = script$cm;
/* template */

var __vue_render__$cm = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "224",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M161.94113,94.05887A47.98662,47.98662,0,1,0,175.05255,137.516",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M195.88225,60.11775A95.92854,95.92854,0,1,0,218.012,94.55869",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "48",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "224",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M195.88225,60.11775a95.90539,95.90539,0,1,0,18.76606,26.49271",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M161.94113,94.05887a47.99886,47.99886,0,1,0,13.98107,31.20092",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M211.2002,79.3916a8.00051,8.00051,0,0,0-3.77051,10.667,88.0876,88.0876,0,1,1-23.13037-29.67187l-22.769,22.76855a55.99686,55.99686,0,0,0-73.1333,84.438l.0044.00488.00537.00489a56.00035,56.00035,0,0,0,95.50244-42.79737,8.0002,8.0002,0,1,0-15.97461.90821,40.01415,40.01415,0,0,1-61.99805,35.66357l23.94922-23.94922,37.71289-37.7124.00489-.00537,62.05371-62.05371a8.00036,8.00036,0,0,0-11.31446-11.314L195.667,49.01855a104.00214,104.00214,0,0,0-141.206,152.52051A104.01636,104.01636,0,0,0,221.86719,83.16211,7.99983,7.99983,0,0,0,211.2002,79.3916Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "224",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M195.88225,60.11775a95.90539,95.90539,0,1,0,18.76606,26.49271",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M161.94113,94.05887a47.99886,47.99886,0,1,0,13.98107,31.20092",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "224",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M195.88225,60.11775a95.90539,95.90539,0,1,0,18.76606,26.49271",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M161.94113,94.05887a47.99886,47.99886,0,1,0,13.98107,31.20092",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "224",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M195.88225,60.11775a95.90539,95.90539,0,1,0,18.76606,26.49271",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M161.94113,94.05887a47.99886,47.99886,0,1,0,13.98107,31.20092",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cm = [];
/* style */

const __vue_inject_styles__$cm = undefined;
/* scoped */

const __vue_scope_id__$cm = undefined;
/* module identifier */

const __vue_module_identifier__$cm = undefined;
/* functional template */

const __vue_is_functional_template__$cm = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cm = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cm,
  staticRenderFns: __vue_staticRenderFns__$cm
}, __vue_inject_styles__$cm, __vue_script__$cm, __vue_scope_id__$cm, __vue_is_functional_template__$cm, __vue_module_identifier__$cm, false, undefined, undefined, undefined);

var script$cn = Vue.extend({
  name: "PhTelegramLogo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cn = script$cn;
/* template */

var __vue_render__$cn = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M88,134.87236l89.91726,79.12718a8,8,0,0,0,13.08288-4.21869L228.61385,45.64829a8,8,0,0,0-10.72308-9.233L33.33393,108.91975a8,8,0,0,0,1.35629,15.29065Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "134.87236",
      "x2": "224.11223",
      "y2": "36.56908",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M132.90708,174.39059l-31.25023,31.25023A8,8,0,0,1,88,199.984v-65.1116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M88,134.87236,224.11223,36.56908l.00168-.00367a7.87244,7.87244,0,0,0-6.22314-.15014L33.33393,108.91975a8,8,0,0,0,1.35629,15.29065Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M132.90708,174.39059l-31.25023,31.25023A8,8,0,0,1,88,199.984v-65.1116Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,134.87236l89.91726,79.12718a8,8,0,0,0,13.08288-4.21869L228.61385,45.64829a8,8,0,0,0-10.72308-9.233L33.33393,108.91975a8,8,0,0,0,1.35629,15.29065Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "134.87236",
      "x2": "224.11223",
      "y2": "36.56908",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M132.90708,174.39059l-31.25023,31.25023A8,8,0,0,1,88,199.984v-65.1116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M231.25586,31.73635a15.9634,15.9634,0,0,0-16.29-2.76758L30.40869,101.47365a15.99988,15.99988,0,0,0,2.7124,30.58106L80,141.43069V199.9844a15.99415,15.99415,0,0,0,27.31348,11.31347L133.25684,185.355l39.376,34.65088a15.86863,15.86863,0,0,0,10.51709,4.00293,16.15674,16.15674,0,0,0,4.96338-.78711,15.86491,15.86491,0,0,0,10.68457-11.65332L236.41162,47.43557A15.96073,15.96073,0,0,0,231.25586,31.73635ZM183.20215,207.99416,100.81006,135.4883l118.64453-85.687Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M88,134.87236l89.91726,79.12718a8,8,0,0,0,13.08288-4.21869L228.61385,45.64829a8,8,0,0,0-10.72308-9.233L33.33393,108.91975a8,8,0,0,0,1.35629,15.29065Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "134.87236",
      "x2": "224.11223",
      "y2": "36.56908",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M132.90708,174.39059l-31.25023,31.25023A8,8,0,0,1,88,199.984v-65.1116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M88,134.87236l89.91726,79.12718a8,8,0,0,0,13.08288-4.21869L228.61385,45.64829a8,8,0,0,0-10.72308-9.233L33.33393,108.91975a8,8,0,0,0,1.35629,15.29065Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "134.87236",
      "x2": "224.11223",
      "y2": "36.56908",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M132.90708,174.39059l-31.25023,31.25023A8,8,0,0,1,88,199.984v-65.1116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M88,134.87236l89.91726,79.12718a8,8,0,0,0,13.08288-4.21869L228.61385,45.64829a8,8,0,0,0-10.72308-9.233L33.33393,108.91975a8,8,0,0,0,1.35629,15.29065Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "134.87236",
      "x2": "224.11223",
      "y2": "36.56908",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M132.90708,174.39059l-31.25023,31.25023A8,8,0,0,1,88,199.984v-65.1116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cn = [];
/* style */

const __vue_inject_styles__$cn = undefined;
/* scoped */

const __vue_scope_id__$cn = undefined;
/* module identifier */

const __vue_module_identifier__$cn = undefined;
/* functional template */

const __vue_is_functional_template__$cn = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cn = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cn,
  staticRenderFns: __vue_staticRenderFns__$cn
}, __vue_inject_styles__$cn, __vue_script__$cn, __vue_scope_id__$cn, __vue_is_functional_template__$cn, __vue_module_identifier__$cn, false, undefined, undefined, undefined);

var script$co = Vue.extend({
  name: "PhTelevision",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$co = script$co;
/* template */

var __vue_render__$co = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "136",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 24 128 72 176 24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "184",
      "cy": "116",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "184",
      "cy": "164",
      "r": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "140",
      "y1": "208",
      "x2": "140",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M152,208V72H40a8,8,0,0,0-8,8V200a8,8,0,0,0,8,8Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "136",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 24 128 72 176 24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "116",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "164",
      "r": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "208",
      "x2": "152",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,64H147.31445l34.34278-34.34277a8.00053,8.00053,0,0,0-11.31446-11.31446L128,60.68652,85.65723,18.34277A8.00053,8.00053,0,0,0,74.34277,29.65723L108.68555,64H40A16.01833,16.01833,0,0,0,24,80V200a16.01833,16.01833,0,0,0,16,16H216a16.01833,16.01833,0,0,0,16-16V80A16.01833,16.01833,0,0,0,216,64Zm0,136H160V80h56l.00977,120Zm-16-84a12,12,0,1,1-12-12A12,12,0,0,1,200,116Zm0,48a12,12,0,1,1-12-12A12,12,0,0,1,200,164Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "136",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 24 128 72 176 24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "116",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "164",
      "r": "10"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "208",
      "x2": "152",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "136",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 24 128 72 176 24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "116",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "164",
      "r": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "208",
      "x2": "152",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "136",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 24 128 72 176 24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "116",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "164",
      "r": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "208",
      "x2": "152",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$co = [];
/* style */

const __vue_inject_styles__$co = undefined;
/* scoped */

const __vue_scope_id__$co = undefined;
/* module identifier */

const __vue_module_identifier__$co = undefined;
/* functional template */

const __vue_is_functional_template__$co = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$co = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$co,
  staticRenderFns: __vue_staticRenderFns__$co
}, __vue_inject_styles__$co, __vue_script__$co, __vue_scope_id__$co, __vue_is_functional_template__$co, __vue_module_identifier__$co, false, undefined, undefined, undefined);

var script$cp = Vue.extend({
  name: "PhTelevisionSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cp = script$cp;
/* template */

var __vue_render__$cp = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "136",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 24 128 72 176 24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "136",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "136",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 24 128 72 176 24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232,80V200a16.01833,16.01833,0,0,1-16,16H40a16.01833,16.01833,0,0,1-16-16V80A16.01833,16.01833,0,0,1,40,64h68.68555L74.34277,29.65723A8.00053,8.00053,0,0,1,85.65723,18.34277L128,60.68652l42.34277-42.34375a8.00053,8.00053,0,0,1,11.31446,11.31446L147.31445,64H216A16.01833,16.01833,0,0,1,232,80Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "136",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 24 128 72 176 24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "136",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 24 128 72 176 24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "136",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 24 128 72 176 24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cp = [];
/* style */

const __vue_inject_styles__$cp = undefined;
/* scoped */

const __vue_scope_id__$cp = undefined;
/* module identifier */

const __vue_module_identifier__$cp = undefined;
/* functional template */

const __vue_is_functional_template__$cp = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cp = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cp,
  staticRenderFns: __vue_staticRenderFns__$cp
}, __vue_inject_styles__$cp, __vue_script__$cp, __vue_scope_id__$cp, __vue_is_functional_template__$cp, __vue_module_identifier__$cp, false, undefined, undefined, undefined);

var script$cq = Vue.extend({
  name: "PhTennisBall",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cq = script$cq;
/* template */

var __vue_render__$cq = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M127.83333,32.00018a96,96,0,0,1-95.83212,95.83315",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M223.99982,128.16667a96,96,0,0,0-95.83315,95.83212",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,128a96,96,0,0,1,95.83333-95.99986v0a96,96,0,0,1-95.83212,95.83315Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128.16648,224.16649a96,96,0,0,1,95.83334-95.99986v0a96,96,0,0,1-95.83213,95.83315Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M127.83333,32.00018a96,96,0,0,1-95.83212,95.83315",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M223.99982,128.16667a96,96,0,0,0-95.83315,95.83212",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,136.041c2.53906,0,5.07721.125,7.6087.34277a103.89367,103.89367,0,0,1-95.22107,95.2793A87.855,87.855,0,0,1,224,136.041Zm-73.53906,14.41992A103.31914,103.31914,0,0,1,224,120q3.85537,0,7.66394.27734a103.91077,103.91077,0,0,0-96-96,103.79931,103.79931,0,0,1-30.12488,81.26172A103.31914,103.31914,0,0,1,32,136q-3.85546,0-7.66394-.27734a103.91077,103.91077,0,0,0,96,96A103.79931,103.79931,0,0,1,150.46094,150.46094ZM94.22559,94.22559a87.83528,87.83528,0,0,0,25.38678-69.88868,103.89355,103.89355,0,0,0-95.221,95.2793A87.83194,87.83194,0,0,0,94.22559,94.22559Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M127.83333,32.00018a96,96,0,0,1-95.83212,95.83315",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M223.99982,128.16667a96,96,0,0,0-95.83315,95.83212",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M127.83333,32.00018a96,96,0,0,1-95.83212,95.83315",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M223.99982,128.16667a96,96,0,0,0-95.83315,95.83212",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M127.83333,32.00018a96,96,0,0,1-95.83212,95.83315",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M223.99982,128.16667a96,96,0,0,0-95.83315,95.83212",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cq = [];
/* style */

const __vue_inject_styles__$cq = undefined;
/* scoped */

const __vue_scope_id__$cq = undefined;
/* module identifier */

const __vue_module_identifier__$cq = undefined;
/* functional template */

const __vue_is_functional_template__$cq = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cq = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cq,
  staticRenderFns: __vue_staticRenderFns__$cq
}, __vue_inject_styles__$cq, __vue_script__$cq, __vue_scope_id__$cq, __vue_is_functional_template__$cq, __vue_module_identifier__$cq, false, undefined, undefined, undefined);

var script$cr = Vue.extend({
  name: "PhTerminal",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cr = script$cr;
/* template */

var __vue_render__$cr = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "40 64 112 128 40 192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "119.99414",
      "y1": "192",
      "x2": "215.99414",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "40 64 112 128 40 192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "119.99414",
      "y1": "192",
      "x2": "215.99414",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M120,128a8.00063,8.00063,0,0,0-2.68506-5.97949l-72-64a8.00018,8.00018,0,0,0-10.62988,11.959L99.9585,128,34.68506,186.02051a8.00018,8.00018,0,0,0,10.62988,11.959l72-64A8.00063,8.00063,0,0,0,120,128Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M215.99414,184h-96a8,8,0,0,0,0,16h96a8,8,0,1,0,0-16Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "40 64 112 128 40 192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "119.99414",
      "y1": "192",
      "x2": "215.99414",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "40 64 112 128 40 192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "119.99414",
      "y1": "192",
      "x2": "215.99414",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "40 64 112 128 40 192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "119.99414",
      "y1": "192",
      "x2": "215.99414",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cr = [];
/* style */

const __vue_inject_styles__$cr = undefined;
/* scoped */

const __vue_scope_id__$cr = undefined;
/* module identifier */

const __vue_module_identifier__$cr = undefined;
/* functional template */

const __vue_is_functional_template__$cr = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cr = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cr,
  staticRenderFns: __vue_staticRenderFns__$cr
}, __vue_inject_styles__$cr, __vue_script__$cr, __vue_scope_id__$cr, __vue_is_functional_template__$cr, __vue_module_identifier__$cr, false, undefined, undefined, undefined);

var script$cs = Vue.extend({
  name: "PhTerminalWindow",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cs = script$cs;
/* template */

var __vue_render__$cs = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 96 120 128 80 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "143.99414",
      "y1": "160",
      "x2": "175.99414",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8.48528",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8.48528",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 96 120 128 80 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "135.99414",
      "y1": "160",
      "x2": "175.99414",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8.48528",
      "stroke-width": "16.97056",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M215.51465,39.51465H40.48535a16.99025,16.99025,0,0,0-16.9707,16.9707v143.0293a16.99025,16.99025,0,0,0,16.9707,16.9707h175.0293a16.99025,16.99025,0,0,0,16.9707-16.9707V56.48535A16.99025,16.99025,0,0,0,215.51465,39.51465Zm-94.51758,94.73242-40,32a7.99979,7.99979,0,1,1-9.99414-12.49414L103.19336,128,71.00293,102.24707a7.99979,7.99979,0,1,1,9.99414-12.49414l40,32a7.99943,7.99943,0,0,1,0,12.49414ZM179.99414,168h-40a8,8,0,0,1,0-16h40a8,8,0,1,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 96 120 128 80 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "135.99414",
      "y1": "160",
      "x2": "175.99414",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8.48528",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 96 120 128 80 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "135.99414",
      "y1": "160",
      "x2": "175.99414",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8.48528",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 96 120 128 80 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "135.99414",
      "y1": "160",
      "x2": "175.99414",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8.48528",
      "stroke-width": "16.97056",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cs = [];
/* style */

const __vue_inject_styles__$cs = undefined;
/* scoped */

const __vue_scope_id__$cs = undefined;
/* module identifier */

const __vue_module_identifier__$cs = undefined;
/* functional template */

const __vue_is_functional_template__$cs = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cs = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cs,
  staticRenderFns: __vue_staticRenderFns__$cs
}, __vue_inject_styles__$cs, __vue_script__$cs, __vue_scope_id__$cs, __vue_is_functional_template__$cs, __vue_module_identifier__$cs, false, undefined, undefined, undefined);

var script$ct = Vue.extend({
  name: "PhTestTube",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$ct = script$ct;
/* template */

var __vue_render__$ct = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,100,94,214A36.7695,36.7695,0,0,1,42,214L42,214A36.7695,36.7695,0,0,1,42,162L172,32l60,60Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M68,136s20-16,52,0,52,0,52,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M68,136s20-16,52,0,52,0,52,0L94,214A36.7695,36.7695,0,0,1,42,214L42,214A36.7695,36.7695,0,0,1,42,162Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,100,94,214A36.7695,36.7695,0,0,1,42,214L42,214A36.7695,36.7695,0,0,1,42,162L172,32l60,60Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M68,136s20-16,52,0,52,0,52,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M237.65674,86.34326l-60-60a8.00063,8.00063,0,0,0-11.314,0L62.39453,130.29193l-.01172.01129-26.04,26.04a44.76956,44.76956,0,0,0,63.314,63.31348L177.605,141.70868l.0127-.01288,34.70361-34.70361,22.2085-7.40283a7.9996,7.9996,0,0,0,3.127-13.2461Zm-32.18653,6.06738a8.00221,8.00221,0,0,0-3.12744,1.93262l-35.59814,35.59821c-2.148,1.51983-17.895,11.53961-43.167-1.09674-10.99854-5.49964-20.811-7.63062-29.18116-7.92743L172,43.314l45.19043,45.19Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,100,94,214A36.7695,36.7695,0,0,1,42,214L42,214A36.7695,36.7695,0,0,1,42,162L172,32l60,60Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M68,136s20-16,52,0,52,0,52,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,100,94,214A36.7695,36.7695,0,0,1,42,214L42,214A36.7695,36.7695,0,0,1,42,162L172,32l60,60Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M68,136s20-16,52,0,52,0,52,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,100,94,214A36.7695,36.7695,0,0,1,42,214L42,214A36.7695,36.7695,0,0,1,42,162L172,32l60,60Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M68,136s20-16,52,0,52,0,52,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$ct = [];
/* style */

const __vue_inject_styles__$ct = undefined;
/* scoped */

const __vue_scope_id__$ct = undefined;
/* module identifier */

const __vue_module_identifier__$ct = undefined;
/* functional template */

const __vue_is_functional_template__$ct = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$ct = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$ct,
  staticRenderFns: __vue_staticRenderFns__$ct
}, __vue_inject_styles__$ct, __vue_script__$ct, __vue_scope_id__$ct, __vue_is_functional_template__$ct, __vue_module_identifier__$ct, false, undefined, undefined, undefined);

var script$cu = Vue.extend({
  name: "PhTextAa",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cu = script$cu;
/* template */

var __vue_render__$cu = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "140 192 76 56 12 192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "121.17649",
      "y1": "152",
      "x2": "30.82348",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "204",
      "cy": "167",
      "rx": "32",
      "ry": "27",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M183.99592,109.04406A34.8085,34.8085,0,0,1,204,102.9c17.67311,0,32,12.536,32,28V192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "152 192 80 56 8 192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "208",
      "cy": "166.9",
      "rx": "32",
      "ry": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M183.9948,112.38439A34.03967,34.03967,0,0,1,208,102.9c17.67311,0,32,12.536,32,28V192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "130.82351",
      "y1": "152",
      "x2": "29.17645",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M137.86572,148.20361l-.01416-.02685L87.07031,52.25684a8.00006,8.00006,0,0,0-14.14062,0L22.14844,148.17676l-.01416.02685L.92969,188.25684a8,8,0,0,0,14.14062,7.48632L33.99316,160h92.01368l18.92285,35.74316a8,8,0,0,0,14.14062-7.48632ZM42.46387,144,80,73.09766,117.53613,144ZM208,94.90039a42.22159,42.22159,0,0,0-29.63867,11.80469,7.9999,7.9999,0,1,0,11.26758,11.35937A26.12387,26.12387,0,0,1,208,110.90039c13.2334,0,24,8.97168,24,20v7.21973a42.75745,42.75745,0,0,0-24-7.21973c-22.05566,0-40,16.14941-40,36s17.94434,36,40,36a42.65985,42.65985,0,0,0,24.67236-7.6958A7.9985,7.9985,0,0,0,248,192V130.90039C248,111.0498,230.05566,94.90039,208,94.90039Zm0,92c-13.2334,0-24-8.97168-24-20s10.7666-20,24-20,24,8.97168,24,20S221.2334,186.90039,208,186.90039Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "152 192 80 56 8 192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "208",
      "cy": "166.9",
      "rx": "32",
      "ry": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M183.9948,112.38439A34.03967,34.03967,0,0,1,208,102.9c17.67311,0,32,12.536,32,28V192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "130.82351",
      "y1": "152",
      "x2": "29.17645",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "152 192 80 56 8 192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "208",
      "cy": "166.9",
      "rx": "32",
      "ry": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M183.9948,112.38439A34.03967,34.03967,0,0,1,208,102.9c17.67311,0,32,12.536,32,28V192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "130.82351",
      "y1": "152",
      "x2": "29.17645",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "152 192 80 56 8 192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "208",
      "cy": "166.9",
      "rx": "32",
      "ry": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M183.9948,112.38439A34.03967,34.03967,0,0,1,208,102.9c17.67311,0,32,12.536,32,28V192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "130.82351",
      "y1": "152",
      "x2": "29.17645",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cu = [];
/* style */

const __vue_inject_styles__$cu = undefined;
/* scoped */

const __vue_scope_id__$cu = undefined;
/* module identifier */

const __vue_module_identifier__$cu = undefined;
/* functional template */

const __vue_is_functional_template__$cu = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cu = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cu,
  staticRenderFns: __vue_staticRenderFns__$cu
}, __vue_inject_styles__$cu, __vue_script__$cu, __vue_scope_id__$cu, __vue_is_functional_template__$cu, __vue_module_identifier__$cu, false, undefined, undefined, undefined);

var script$cv = Vue.extend({
  name: "PhTextAlignCenter",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cv = script$cv;
/* template */

var __vue_render__$cv = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "68",
      "x2": "216",
      "y2": "68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "108",
      "x2": "192",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40.00307",
      "y1": "148",
      "x2": "215.99693",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64.00307",
      "y1": "188",
      "x2": "191.99693",
      "y2": "188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "68",
      "x2": "216",
      "y2": "68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "108",
      "x2": "192",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40.00307",
      "y1": "148",
      "x2": "215.99693",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64.00307",
      "y1": "188",
      "x2": "191.99693",
      "y2": "188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M40,76H216a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,100a8,8,0,0,0,0,16H192a8,8,0,0,0,0-16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M215.99707,140H40.00293a8,8,0,1,0,0,16H215.99707a8,8,0,0,0,0-16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M191.99707,180H64.00293a8,8,0,0,0,0,16H191.99707a8,8,0,0,0,0-16Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "68",
      "x2": "216",
      "y2": "68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "108",
      "x2": "192",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40.00307",
      "y1": "148",
      "x2": "215.99693",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64.00307",
      "y1": "188",
      "x2": "191.99693",
      "y2": "188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "68",
      "x2": "216",
      "y2": "68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "108",
      "x2": "192",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40.00307",
      "y1": "148",
      "x2": "215.99693",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64.00307",
      "y1": "188",
      "x2": "191.99693",
      "y2": "188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "68",
      "x2": "216",
      "y2": "68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "108",
      "x2": "192",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40.00307",
      "y1": "148",
      "x2": "215.99693",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64.00307",
      "y1": "188",
      "x2": "191.99693",
      "y2": "188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cv = [];
/* style */

const __vue_inject_styles__$cv = undefined;
/* scoped */

const __vue_scope_id__$cv = undefined;
/* module identifier */

const __vue_module_identifier__$cv = undefined;
/* functional template */

const __vue_is_functional_template__$cv = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cv = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cv,
  staticRenderFns: __vue_staticRenderFns__$cv
}, __vue_inject_styles__$cv, __vue_script__$cv, __vue_scope_id__$cv, __vue_is_functional_template__$cv, __vue_module_identifier__$cv, false, undefined, undefined, undefined);

var script$cw = Vue.extend({
  name: "PhTextAlignJustify",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cw = script$cw;
/* template */

var __vue_render__$cw = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "68",
      "x2": "216",
      "y2": "68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "108",
      "x2": "216",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40.00614",
      "y1": "148",
      "x2": "216",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40.00614",
      "y1": "188",
      "x2": "216",
      "y2": "188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "68",
      "x2": "216",
      "y2": "68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "108",
      "x2": "216",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40.00614",
      "y1": "148",
      "x2": "216",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40.00614",
      "y1": "188",
      "x2": "216",
      "y2": "188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M40,76H216a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,100H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,140H40.00586a8,8,0,1,0,0,16H216a8,8,0,0,0,0-16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,180H40.00586a8,8,0,1,0,0,16H216a8,8,0,0,0,0-16Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "68",
      "x2": "216",
      "y2": "68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "108",
      "x2": "216",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40.00614",
      "y1": "148",
      "x2": "216",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40.00614",
      "y1": "188",
      "x2": "216",
      "y2": "188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "68",
      "x2": "216",
      "y2": "68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "108",
      "x2": "216",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40.00614",
      "y1": "148",
      "x2": "216",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40.00614",
      "y1": "188",
      "x2": "216",
      "y2": "188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "68",
      "x2": "216",
      "y2": "68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "108",
      "x2": "216",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40.00614",
      "y1": "148",
      "x2": "216",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40.00614",
      "y1": "188",
      "x2": "216",
      "y2": "188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cw = [];
/* style */

const __vue_inject_styles__$cw = undefined;
/* scoped */

const __vue_scope_id__$cw = undefined;
/* module identifier */

const __vue_module_identifier__$cw = undefined;
/* functional template */

const __vue_is_functional_template__$cw = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cw = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cw,
  staticRenderFns: __vue_staticRenderFns__$cw
}, __vue_inject_styles__$cw, __vue_script__$cw, __vue_scope_id__$cw, __vue_is_functional_template__$cw, __vue_module_identifier__$cw, false, undefined, undefined, undefined);

var script$cx = Vue.extend({
  name: "PhTextAlignLeft",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cx = script$cx;
/* template */

var __vue_render__$cx = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "68",
      "x2": "216",
      "y2": "68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "108",
      "x2": "168",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40.00614",
      "y1": "148",
      "x2": "216",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40.00614",
      "y1": "188",
      "x2": "168",
      "y2": "188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "68",
      "x2": "216",
      "y2": "68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "108",
      "x2": "168",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40.00614",
      "y1": "148",
      "x2": "216",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40.00614",
      "y1": "188",
      "x2": "168",
      "y2": "188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M40.02344,76h176a8,8,0,0,0,0-16h-176a8,8,0,1,0,0,16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40.02344,116h128a8,8,0,0,0,0-16h-128a8,8,0,1,0,0,16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216.02344,140H40.0293a8,8,0,0,0,0,16H216.02344a8,8,0,0,0,0-16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168.02344,180H40.0293a8,8,0,0,0,0,16H168.02344a8,8,0,0,0,0-16Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "68",
      "x2": "216",
      "y2": "68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "108",
      "x2": "168",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40.00614",
      "y1": "148",
      "x2": "216",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40.00614",
      "y1": "188",
      "x2": "168",
      "y2": "188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "68",
      "x2": "216",
      "y2": "68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "108",
      "x2": "168",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40.00614",
      "y1": "148",
      "x2": "216",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40.00614",
      "y1": "188",
      "x2": "168",
      "y2": "188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "68",
      "x2": "216",
      "y2": "68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "108",
      "x2": "168",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40.00614",
      "y1": "148",
      "x2": "216",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40.00614",
      "y1": "188",
      "x2": "168",
      "y2": "188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cx = [];
/* style */

const __vue_inject_styles__$cx = undefined;
/* scoped */

const __vue_scope_id__$cx = undefined;
/* module identifier */

const __vue_module_identifier__$cx = undefined;
/* functional template */

const __vue_is_functional_template__$cx = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cx = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cx,
  staticRenderFns: __vue_staticRenderFns__$cx
}, __vue_inject_styles__$cx, __vue_script__$cx, __vue_scope_id__$cx, __vue_is_functional_template__$cx, __vue_module_identifier__$cx, false, undefined, undefined, undefined);

var script$cy = Vue.extend({
  name: "PhTextAlignRight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cy = script$cy;
/* template */

var __vue_render__$cy = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "68",
      "x2": "216",
      "y2": "68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "108",
      "x2": "216",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40.00614",
      "y1": "148",
      "x2": "216",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88.00614",
      "y1": "188",
      "x2": "216",
      "y2": "188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "68",
      "x2": "216",
      "y2": "68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "108",
      "x2": "216",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40.00614",
      "y1": "148",
      "x2": "216",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88.00614",
      "y1": "188",
      "x2": "216",
      "y2": "188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M40,76H216a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,100H88a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,140H40.00586a8,8,0,1,0,0,16H216a8,8,0,0,0,0-16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,180H88.00586a8,8,0,1,0,0,16H216a8,8,0,0,0,0-16Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "68",
      "x2": "216",
      "y2": "68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "108",
      "x2": "216",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40.00614",
      "y1": "148",
      "x2": "216",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88.00614",
      "y1": "188",
      "x2": "216",
      "y2": "188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "68",
      "x2": "216",
      "y2": "68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "108",
      "x2": "216",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40.00614",
      "y1": "148",
      "x2": "216",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88.00614",
      "y1": "188",
      "x2": "216",
      "y2": "188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "68",
      "x2": "216",
      "y2": "68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "108",
      "x2": "216",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40.00614",
      "y1": "148",
      "x2": "216",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88.00614",
      "y1": "188",
      "x2": "216",
      "y2": "188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cy = [];
/* style */

const __vue_inject_styles__$cy = undefined;
/* scoped */

const __vue_scope_id__$cy = undefined;
/* module identifier */

const __vue_module_identifier__$cy = undefined;
/* functional template */

const __vue_is_functional_template__$cy = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cy = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cy,
  staticRenderFns: __vue_staticRenderFns__$cy
}, __vue_inject_styles__$cy, __vue_script__$cy, __vue_scope_id__$cy, __vue_is_functional_template__$cy, __vue_module_identifier__$cy, false, undefined, undefined, undefined);

var script$cz = Vue.extend({
  name: "PhTextBolder",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cz = script$cz;
/* template */

var __vue_render__$cz = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M64,120h88a40,40,0,0,1,0,80l-88.00586-.00488v-152L140,48a36,36,0,0,1,0,72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M64,120h88a40,40,0,0,1,0,80l-88.00586-.00488v-152L140,48a36,36,0,0,1,0,72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M170.4834,115.70117A43.98012,43.98012,0,0,0,140.00049,40l-76.00586-.00488h-.00049a7.99955,7.99955,0,0,0-8,8v152a8,8,0,0,0,7.99951,8L152,208a48.00015,48.00015,0,0,0,18.4834-92.29883ZM71.99414,55.99561,140,56a28,28,0,0,1,0,56H71.99414ZM152.00049,192l-80.00635-.00439V128H152a32,32,0,0,1,.00049,64Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M64,120h88a40,40,0,0,1,0,80l-88.00586-.00488v-152L140,48a36,36,0,0,1,0,72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M64,120h88a40,40,0,0,1,0,80l-88.00586-.00488v-152L140,48a36,36,0,0,1,0,72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M64,120h88a40,40,0,0,1,0,80l-88.00586-.00488v-152L140,48a36,36,0,0,1,0,72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cz = [];
/* style */

const __vue_inject_styles__$cz = undefined;
/* scoped */

const __vue_scope_id__$cz = undefined;
/* module identifier */

const __vue_module_identifier__$cz = undefined;
/* functional template */

const __vue_is_functional_template__$cz = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cz = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cz,
  staticRenderFns: __vue_staticRenderFns__$cz
}, __vue_inject_styles__$cz, __vue_script__$cz, __vue_scope_id__$cz, __vue_is_functional_template__$cz, __vue_module_identifier__$cz, false, undefined, undefined, undefined);

var script$cA = Vue.extend({
  name: "PhTextH",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cA = script$cA;
/* template */

var __vue_render__$cA = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "56",
      "y1": "56",
      "x2": "56",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "128",
      "x2": "56",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "56",
      "x2": "200",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "56",
      "y1": "56",
      "x2": "56",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "128",
      "x2": "56",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "56",
      "x2": "200",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,56V200a8,8,0,0,1-16,0V136H64v64a8,8,0,0,1-16,0V56a8,8,0,0,1,16,0v64H192V56a8,8,0,0,1,16,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "56",
      "y1": "56",
      "x2": "56",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "128",
      "x2": "56",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "56",
      "x2": "200",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "56",
      "y1": "56",
      "x2": "56",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "128",
      "x2": "56",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "56",
      "x2": "200",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "56",
      "y1": "56",
      "x2": "56",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "128",
      "x2": "56",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "56",
      "x2": "200",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cA = [];
/* style */

const __vue_inject_styles__$cA = undefined;
/* scoped */

const __vue_scope_id__$cA = undefined;
/* module identifier */

const __vue_module_identifier__$cA = undefined;
/* functional template */

const __vue_is_functional_template__$cA = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cA = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cA,
  staticRenderFns: __vue_staticRenderFns__$cA
}, __vue_inject_styles__$cA, __vue_script__$cA, __vue_scope_id__$cA, __vue_is_functional_template__$cA, __vue_module_identifier__$cA, false, undefined, undefined, undefined);

var script$cB = Vue.extend({
  name: "PhTextHFive",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cB = script$cB;
/* template */

var __vue_render__$cB = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "56",
      "x2": "40",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "116",
      "x2": "40",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "56",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M240,108H199.83477L192,156.20232a27.99935,27.99935,0,1,1,0,39.5969",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "56",
      "x2": "40",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "116",
      "x2": "40",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "56",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M240,108H199.83477L192,156.20232a27.99935,27.99935,0,1,1,0,39.5969",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M152,56V176a8,8,0,0,1-16,0V124H48v52a8,8,0,0,1-16,0V56a8,8,0,0,1,16,0v52h88V56a8,8,0,0,1,16,0ZM211.88184,140.002a36.413,36.413,0,0,0-9.33985,1.209L206.63965,116H240a8,8,0,0,0,0-16H199.835a8.00076,8.00076,0,0,0-7.89648,6.7168l-7.835,48.20215a7.99971,7.99971,0,0,0,13.541,6.95214,20.20412,20.20412,0,0,1,28.47461-.001,19.91646,19.91646,0,0,1,.001,28.25976,20.20173,20.20173,0,0,1-28.47461.001,7.99985,7.99985,0,1,0-11.291,11.33594A36.05843,36.05843,0,1,0,211.88184,140.002Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "56",
      "x2": "40",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "116",
      "x2": "40",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "56",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M240,108H199.83477L192,156.20232a27.99935,27.99935,0,1,1,0,39.5969",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "56",
      "x2": "40",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "116",
      "x2": "40",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "56",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M240,108H199.83477L192,156.20232a27.99935,27.99935,0,1,1,0,39.5969",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "56",
      "x2": "40",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "116",
      "x2": "40",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "56",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M240,108H199.83477L192,156.20232a27.99935,27.99935,0,1,1,0,39.5969",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cB = [];
/* style */

const __vue_inject_styles__$cB = undefined;
/* scoped */

const __vue_scope_id__$cB = undefined;
/* module identifier */

const __vue_module_identifier__$cB = undefined;
/* functional template */

const __vue_is_functional_template__$cB = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cB = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cB,
  staticRenderFns: __vue_staticRenderFns__$cB
}, __vue_inject_styles__$cB, __vue_script__$cB, __vue_scope_id__$cB, __vue_is_functional_template__$cB, __vue_module_identifier__$cB, false, undefined, undefined, undefined);

var script$cC = Vue.extend({
  name: "PhTextHFour",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cC = script$cC;
/* template */

var __vue_render__$cC = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "56",
      "x2": "40",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "116",
      "x2": "40",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "56",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "211.998 100 188 168 236 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "236",
      "y1": "136",
      "x2": "236",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "56",
      "x2": "40",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "116",
      "x2": "40",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "56",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "211.998 100 188 168 236 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "236",
      "y1": "136",
      "x2": "236",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M152,56V176a8,8,0,0,1-16,0V124H48v52a8,8,0,0,1-16,0V56a8,8,0,0,1,16,0v52h88V56a8,8,0,0,1,16,0Zm84,72a8.00039,8.00039,0,0,0-8,8v24H199.30664L219.542,102.66211a7.99987,7.99987,0,1,0-15.08789-5.32422l-23.99805,68A7.99995,7.99995,0,0,0,188,176h40v24a8,8,0,0,0,16,0V136A8.00039,8.00039,0,0,0,236,128Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "56",
      "x2": "40",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "116",
      "x2": "40",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "56",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "211.998 100 188 168 236 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "236",
      "y1": "136",
      "x2": "236",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "56",
      "x2": "40",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "116",
      "x2": "40",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "56",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "211.998 100 188 168 236 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "236",
      "y1": "136",
      "x2": "236",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "56",
      "x2": "40",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "116",
      "x2": "40",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "56",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "211.998 100 188 168 236 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "236",
      "y1": "136",
      "x2": "236",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cC = [];
/* style */

const __vue_inject_styles__$cC = undefined;
/* scoped */

const __vue_scope_id__$cC = undefined;
/* module identifier */

const __vue_module_identifier__$cC = undefined;
/* functional template */

const __vue_is_functional_template__$cC = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cC = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cC,
  staticRenderFns: __vue_staticRenderFns__$cC
}, __vue_inject_styles__$cC, __vue_script__$cC, __vue_scope_id__$cC, __vue_is_functional_template__$cC, __vue_module_identifier__$cC, false, undefined, undefined, undefined);

var script$cD = Vue.extend({
  name: "PhTextHOne",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cD = script$cD;
/* template */

var __vue_render__$cD = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "56",
      "x2": "40",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "116",
      "x2": "40",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "56",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "196 123.993 220 108 220 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "56",
      "x2": "40",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "116",
      "x2": "40",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "56",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "196 123.993 220 108 220 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M152,56V176a8,8,0,0,1-16,0V124H48v52a8,8,0,0,1-16,0V56a8,8,0,0,1,16,0v52h88V56a8,8,0,0,1,16,0Zm71.77539,44.94727a7.99755,7.99755,0,0,0-8.21191.3955l-24,15.99317a8.00008,8.00008,0,1,0,8.873,13.31445L212,122.94434V200a8,8,0,0,0,16,0V108A7.99932,7.99932,0,0,0,223.77539,100.94727Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "56",
      "x2": "40",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "116",
      "x2": "40",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "56",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "196 123.993 220 108 220 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "56",
      "x2": "40",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "116",
      "x2": "40",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "56",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "196 123.993 220 108 220 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "56",
      "x2": "40",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "116",
      "x2": "40",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "56",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "196 123.993 220 108 220 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cD = [];
/* style */

const __vue_inject_styles__$cD = undefined;
/* scoped */

const __vue_scope_id__$cD = undefined;
/* module identifier */

const __vue_module_identifier__$cD = undefined;
/* functional template */

const __vue_is_functional_template__$cD = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cD = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cD,
  staticRenderFns: __vue_staticRenderFns__$cD
}, __vue_inject_styles__$cD, __vue_script__$cD, __vue_scope_id__$cD, __vue_is_functional_template__$cD, __vue_module_identifier__$cD, false, undefined, undefined, undefined);

var script$cE = Vue.extend({
  name: "PhTextHSix",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cE = script$cE;
/* template */

var __vue_render__$cE = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "56",
      "x2": "40",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "116",
      "x2": "40",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "56",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "191.75129",
      "y1": "153.98956",
      "x2": "224",
      "y2": "100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "216",
      "cy": "168",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "56",
      "x2": "40",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "116",
      "x2": "40",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "56",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "191.75129",
      "y1": "153.98956",
      "x2": "224",
      "y2": "100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "216",
      "cy": "168",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M152,56V176a8,8,0,0,1-16,0V124H48v52a8,8,0,0,1-16,0V56a8,8,0,0,1,16,0v52h88V56a8,8,0,0,1,16,0ZM252,168a36,36,0,1,1-67.41943-17.54346c.09448-.19189.19067-.3833.30224-.56982l32.249-53.98926a8.00015,8.00015,0,1,1,13.73632,8.20508l-16.6914,27.94385Q215.08276,132.001,216,132A36.04061,36.04061,0,0,1,252,168Zm-16,0a20,20,0,1,0-20,20A20.02229,20.02229,0,0,0,236,168Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "56",
      "x2": "40",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "116",
      "x2": "40",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "56",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "191.75129",
      "y1": "153.98956",
      "x2": "224",
      "y2": "100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "216",
      "cy": "168",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "56",
      "x2": "40",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "116",
      "x2": "40",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "56",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "191.75129",
      "y1": "153.98956",
      "x2": "224",
      "y2": "100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "216",
      "cy": "168",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "56",
      "x2": "40",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "116",
      "x2": "40",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "56",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "191.75129",
      "y1": "153.98956",
      "x2": "224",
      "y2": "100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "216",
      "cy": "168",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cE = [];
/* style */

const __vue_inject_styles__$cE = undefined;
/* scoped */

const __vue_scope_id__$cE = undefined;
/* module identifier */

const __vue_module_identifier__$cE = undefined;
/* functional template */

const __vue_is_functional_template__$cE = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cE = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cE,
  staticRenderFns: __vue_staticRenderFns__$cE
}, __vue_inject_styles__$cE, __vue_script__$cE, __vue_scope_id__$cE, __vue_is_functional_template__$cE, __vue_module_identifier__$cE, false, undefined, undefined, undefined);

var script$cF = Vue.extend({
  name: "PhTextHThree",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cF = script$cF;
/* template */

var __vue_render__$cF = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "56",
      "x2": "40",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "116",
      "x2": "40",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "56",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M191.99683,107.99216h48L212.00317,148a28,28,0,1,1-19.799,47.799",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "56",
      "x2": "40",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "116",
      "x2": "40",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "56",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M191.99683,107.99216h48L212.00317,148a28,28,0,1,1-19.799,47.799",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M152,56V176a8,8,0,0,1-16,0V124H48v52a8,8,0,0,1-16,0V56a8,8,0,0,1,16,0v52h88V56a8,8,0,0,1,16,0Zm85.459,94.54492a35.92878,35.92878,0,0,0-11.92578-7.92676l21.01856-30.03906a8,8,0,0,0-6.55469-12.58691h-48a8,8,0,0,0,0,16h32.63867l-19.1875,27.4209A8,8,0,0,0,212.00293,156a20,20,0,1,1-14.1416,34.1416,8.00052,8.00052,0,0,0-11.31445,11.31445,35.99995,35.99995,0,1,0,50.9121-50.91113Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "56",
      "x2": "40",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "116",
      "x2": "40",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "56",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M191.99683,107.99216h48L212.00317,148a28,28,0,1,1-19.799,47.799",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "56",
      "x2": "40",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "116",
      "x2": "40",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "56",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M191.99683,107.99216h48L212.00317,148a28,28,0,1,1-19.799,47.799",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "56",
      "x2": "40",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "116",
      "x2": "40",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "56",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M191.99683,107.99216h48L212.00317,148a28,28,0,1,1-19.799,47.799",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cF = [];
/* style */

const __vue_inject_styles__$cF = undefined;
/* scoped */

const __vue_scope_id__$cF = undefined;
/* module identifier */

const __vue_module_identifier__$cF = undefined;
/* functional template */

const __vue_is_functional_template__$cF = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cF = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cF,
  staticRenderFns: __vue_staticRenderFns__$cF
}, __vue_inject_styles__$cF, __vue_script__$cF, __vue_scope_id__$cF, __vue_is_functional_template__$cF, __vue_module_identifier__$cF, false, undefined, undefined, undefined);

var script$cG = Vue.extend({
  name: "PhTextHTwo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cG = script$cG;
/* template */

var __vue_render__$cG = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "56",
      "x2": "40",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "116",
      "x2": "40",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "56",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M193.886,118.65812a24.00387,24.00387,0,1,1,42.01514,22.7605v0L192,200v-.00575h48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "56",
      "x2": "40",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "116",
      "x2": "40",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "56",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M193.886,118.65812a24.00387,24.00387,0,1,1,42.01514,22.7605v0L192,200v-.00575h48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M152,56V176a8,8,0,0,1-16,0V124H48v52a8,8,0,0,1-16,0V56a8,8,0,0,1,16,0v52h88V56a8,8,0,0,1,16,0Zm88,135.99414H207.99707l34.30566-45.77734c.07911-.1045.1543-.21094.22754-.31934A32.00406,32.00406,0,1,0,186.51758,115.542a8,8,0,1,0,14.73633,6.23242A16.00416,16.00416,0,1,1,229.37012,136.794l-43.67285,58.27539A8.00367,8.00367,0,0,0,191.999,208.001c.10547,0,.21192-.00293.31836-.00684H240a8,8,0,0,0,0-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "56",
      "x2": "40",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "116",
      "x2": "40",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "56",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M193.886,118.65812a24.00387,24.00387,0,1,1,42.01514,22.7605v0L192,200v-.00575h48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "56",
      "x2": "40",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "116",
      "x2": "40",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "56",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M193.886,118.65812a24.00387,24.00387,0,1,1,42.01514,22.7605v0L192,200v-.00575h48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "56",
      "x2": "40",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "116",
      "x2": "40",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "56",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M193.886,118.65812a24.00387,24.00387,0,1,1,42.01514,22.7605v0L192,200v-.00575h48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cG = [];
/* style */

const __vue_inject_styles__$cG = undefined;
/* scoped */

const __vue_scope_id__$cG = undefined;
/* module identifier */

const __vue_module_identifier__$cG = undefined;
/* functional template */

const __vue_is_functional_template__$cG = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cG = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cG,
  staticRenderFns: __vue_staticRenderFns__$cG
}, __vue_inject_styles__$cG, __vue_script__$cG, __vue_scope_id__$cG, __vue_is_functional_template__$cG, __vue_module_identifier__$cG, false, undefined, undefined, undefined);

var script$cH = Vue.extend({
  name: "PhTextItalic",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cH = script$cH;
/* template */

var __vue_render__$cH = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "151.99414",
      "y1": "55.99512",
      "x2": "103.99414",
      "y2": "199.99512",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "63.99414",
      "y1": "199.99512",
      "x2": "143.99414",
      "y2": "199.99512",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "111.99414",
      "y1": "55.99512",
      "x2": "191.99414",
      "y2": "55.99512",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "151.99414",
      "y1": "55.99512",
      "x2": "103.99414",
      "y2": "199.99512",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "63.99414",
      "y1": "199.99512",
      "x2": "143.99414",
      "y2": "199.99512",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "111.99414",
      "y1": "55.99512",
      "x2": "191.99414",
      "y2": "55.99512",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M199.99414,55.99512a8.00008,8.00008,0,0,1-8,8H157.76l-42.6665,128h28.90063a8,8,0,0,1,0,16H104.02307l-.028.002-.02735-.002H63.99414a8,8,0,0,1,0-16H98.22827l42.66651-128H111.99414a8,8,0,0,1,0-16h80A8.00008,8.00008,0,0,1,199.99414,55.99512Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "151.99414",
      "y1": "55.99512",
      "x2": "103.99414",
      "y2": "199.99512",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "63.99414",
      "y1": "199.99512",
      "x2": "143.99414",
      "y2": "199.99512",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "111.99414",
      "y1": "55.99512",
      "x2": "191.99414",
      "y2": "55.99512",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "151.99414",
      "y1": "55.99512",
      "x2": "103.99414",
      "y2": "199.99512",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "63.99414",
      "y1": "199.99512",
      "x2": "143.99414",
      "y2": "199.99512",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "111.99414",
      "y1": "55.99512",
      "x2": "191.99414",
      "y2": "55.99512",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "151.99414",
      "y1": "55.99512",
      "x2": "103.99414",
      "y2": "199.99512",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "63.99414",
      "y1": "199.99512",
      "x2": "143.99414",
      "y2": "199.99512",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "111.99414",
      "y1": "55.99512",
      "x2": "191.99414",
      "y2": "55.99512",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cH = [];
/* style */

const __vue_inject_styles__$cH = undefined;
/* scoped */

const __vue_scope_id__$cH = undefined;
/* module identifier */

const __vue_module_identifier__$cH = undefined;
/* functional template */

const __vue_is_functional_template__$cH = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cH = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cH,
  staticRenderFns: __vue_staticRenderFns__$cH
}, __vue_inject_styles__$cH, __vue_script__$cH, __vue_scope_id__$cH, __vue_is_functional_template__$cH, __vue_module_identifier__$cH, false, undefined, undefined, undefined);

var script$cI = Vue.extend({
  name: "PhTextStrikethrough",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cI = script$cI;
/* template */

var __vue_render__$cI = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('g', [_c('path', {
    attrs: {
      "d": "M75.11111,88c0-22.09139,21.96094-40,52.88889-40,23.77865,0,42.25677,10.58606,49.529,25.52014",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,168c0,22.09139,25.07205,40,56,40s56-17.90861,56-40c0-23.76634-21.62275-32.97043-45.59723-40.00076",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })])]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76.334,96.00294A25.48209,25.48209,0,0,1,75.11111,88c0-22.09139,21.96094-40,52.88889-40,23.77865,0,42.25677,10.58606,49.529,25.52014",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,168c0,22.09139,25.07205,40,56,40s56-17.90861,56-40c0-23.76634-21.62275-32.97043-45.59723-40.00076",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,128a7.99977,7.99977,0,0,1-8,8H175.93091C185.11755,143.11133,192,153.20166,192,168c0,13.33936-7.01465,25.6958-19.75244,34.79395C160.32568,211.31006,144.61133,216,128,216S95.67432,211.31006,83.75244,202.794C71.01465,193.6958,64,181.33936,64,168a8,8,0,0,1,16,0c0,17.3457,21.98145,32,48,32s48-14.6543,48-32c0-14.85425-10.54053-23.58228-38.76587-32H40a8,8,0,0,1,0-16h98.239c.03028-.00049.06055.00024.0907,0H216A7.99977,7.99977,0,0,1,224,128ZM76.33252,104.00488a8.00573,8.00573,0,0,0,7.60254-10.49609A17.42935,17.42935,0,0,1,83.11133,88c0-18.24316,19.29785-32,44.88867-32,19.5,0,36.11768,8.25195,42.33643,21.02246a7.99984,7.99984,0,1,0,14.38476-7.00488C175.70557,51.502,153.97119,40,128,40,93.2876,40,67.11133,60.63574,67.11133,88a33.60555,33.60555,0,0,0,1.62158,10.49707A8.00289,8.00289,0,0,0,76.33252,104.00488Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('g', [_c('path', {
    attrs: {
      "d": "M76.334,96.00294A25.48209,25.48209,0,0,1,75.11111,88c0-22.09139,21.96094-40,52.88889-40,23.77865,0,42.25677,10.58606,49.529,25.52014",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,168c0,22.09139,25.07205,40,56,40s56-17.90861,56-40c0-23.76634-21.62275-32.97043-45.59723-40.00076",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })])]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('g', [_c('path', {
    attrs: {
      "d": "M76.334,96.00294A25.48209,25.48209,0,0,1,75.11111,88c0-22.09139,21.96094-40,52.88889-40,23.77865,0,42.25677,10.58606,49.529,25.52014",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,168c0,22.09139,25.07205,40,56,40s56-17.90861,56-40c0-23.76634-21.62275-32.97043-45.59723-40.00076",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })])]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('g', [_c('path', {
    attrs: {
      "d": "M76.334,96.00294A25.48209,25.48209,0,0,1,75.11111,88c0-22.09139,21.96094-40,52.88889-40,23.77865,0,42.25677,10.58606,49.529,25.52014",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,168c0,22.09139,25.07205,40,56,40s56-17.90861,56-40c0-23.76634-21.62275-32.97043-45.59723-40.00076",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })])]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cI = [];
/* style */

const __vue_inject_styles__$cI = undefined;
/* scoped */

const __vue_scope_id__$cI = undefined;
/* module identifier */

const __vue_module_identifier__$cI = undefined;
/* functional template */

const __vue_is_functional_template__$cI = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cI = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cI,
  staticRenderFns: __vue_staticRenderFns__$cI
}, __vue_inject_styles__$cI, __vue_script__$cI, __vue_scope_id__$cI, __vue_is_functional_template__$cI, __vue_module_identifier__$cI, false, undefined, undefined, undefined);

var script$cJ = Vue.extend({
  name: "PhTextT",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cJ = script$cJ;
/* template */

var __vue_render__$cJ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "127.99414",
      "y1": "55.99512",
      "x2": "127.99414",
      "y2": "199.99512",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "47.994 87.995 47.994 55.995 207.994 55.995 207.994 87.995",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "95.99414",
      "y1": "199.99512",
      "x2": "159.99414",
      "y2": "199.99512",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "127.99414",
      "y1": "55.99512",
      "x2": "127.99414",
      "y2": "199.99512",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "47.994 87.995 47.994 55.995 207.994 55.995 207.994 87.995",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "95.99414",
      "y1": "199.99512",
      "x2": "159.99414",
      "y2": "199.99512",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M207.99414,47.99512h-160a8.00008,8.00008,0,0,0-8,8v32a8,8,0,0,0,16,0v-24h64v128h-24a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16h-24v-128h64v24a8,8,0,1,0,16,0v-32A8.00008,8.00008,0,0,0,207.99414,47.99512Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "127.99414",
      "y1": "55.99512",
      "x2": "127.99414",
      "y2": "199.99512",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "47.994 87.995 47.994 55.995 207.994 55.995 207.994 87.995",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "95.99414",
      "y1": "199.99512",
      "x2": "159.99414",
      "y2": "199.99512",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "127.99414",
      "y1": "55.99512",
      "x2": "127.99414",
      "y2": "199.99512",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "47.994 87.995 47.994 55.995 207.994 55.995 207.994 87.995",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "95.99414",
      "y1": "199.99512",
      "x2": "159.99414",
      "y2": "199.99512",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "127.99414",
      "y1": "55.99512",
      "x2": "127.99414",
      "y2": "199.99512",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "47.994 87.995 47.994 55.995 207.994 55.995 207.994 87.995",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "95.99414",
      "y1": "199.99512",
      "x2": "159.99414",
      "y2": "199.99512",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cJ = [];
/* style */

const __vue_inject_styles__$cJ = undefined;
/* scoped */

const __vue_scope_id__$cJ = undefined;
/* module identifier */

const __vue_module_identifier__$cJ = undefined;
/* functional template */

const __vue_is_functional_template__$cJ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cJ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cJ,
  staticRenderFns: __vue_staticRenderFns__$cJ
}, __vue_inject_styles__$cJ, __vue_script__$cJ, __vue_scope_id__$cJ, __vue_is_functional_template__$cJ, __vue_module_identifier__$cJ, false, undefined, undefined, undefined);

var script$cK = Vue.extend({
  name: "PhTextUnderline",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cK = script$cK;
/* template */

var __vue_render__$cK = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "216",
      "x2": "216",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,56v60a64,64,0,0,0,128,0V56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "216",
      "x2": "216",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,56v64a64,64,0,0,0,128,0V56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,216a7.99977,7.99977,0,0,1-8,8H40a8,8,0,0,1,0-16H216A7.99977,7.99977,0,0,1,224,216Zm-96-24a72.0814,72.0814,0,0,0,72-72V56a8,8,0,0,0-16,0v64a56,56,0,0,1-112,0V56a8,8,0,0,0-16,0v64A72.0814,72.0814,0,0,0,128,192Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "216",
      "x2": "216",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,56v64a64,64,0,0,0,128,0V56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "216",
      "x2": "216",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,56v64a64,64,0,0,0,128,0V56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "216",
      "x2": "216",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,56v64a64,64,0,0,0,128,0V56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cK = [];
/* style */

const __vue_inject_styles__$cK = undefined;
/* scoped */

const __vue_scope_id__$cK = undefined;
/* module identifier */

const __vue_module_identifier__$cK = undefined;
/* functional template */

const __vue_is_functional_template__$cK = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cK = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cK,
  staticRenderFns: __vue_staticRenderFns__$cK
}, __vue_inject_styles__$cK, __vue_script__$cK, __vue_scope_id__$cK, __vue_is_functional_template__$cK, __vue_module_identifier__$cK, false, undefined, undefined, undefined);

var script$cL = Vue.extend({
  name: "PhThermometer",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cL = script$cL;
/* template */

var __vue_render__$cL = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "216",
      "cy": "80",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "108",
      "cy": "188",
      "r": "12",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "108",
      "y1": "168",
      "x2": "108",
      "y2": "92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M68,154.77579V56a40,40,0,0,1,80,0v98.77485l.0017-.0014a52,52,0,1,1-80.00385.00054Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "212",
      "cy": "80",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,147.02548V48a32,32,0,0,1,64,0v99.02548l.00787-.01006a52,52,0,1,1-64.01574,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "120",
      "cy": "188",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152.00787,147.01562,152,147.02539V48a32,32,0,0,0-64,0v99.02539l-.00787-.00977a52,52,0,1,0,64.01574,0ZM120,208a20,20,0,1,1,20-20A19.9999,19.9999,0,0,1,120,208Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "168",
      "x2": "120",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M212,52a28,28,0,1,0,28,28A28.03146,28.03146,0,0,0,212,52Zm0,40a12,12,0,1,1,12-12A12.01343,12.01343,0,0,1,212,92Zm-52,51.27441V48a40,40,0,0,0-80,0v95.27441a60,60,0,1,0,80,0ZM120,24a24.02718,24.02718,0,0,1,24,24V80H96V48A24.02718,24.02718,0,0,1,120,24Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "212",
      "cy": "80",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,147.02548V48a32,32,0,0,1,64,0v99.02548l.00787-.01006a52,52,0,1,1-64.01574,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "120",
      "cy": "188",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "168",
      "x2": "120",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "212",
      "cy": "80",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,147.02548V48a32,32,0,0,1,64,0v99.02548l.00787-.01006a52,52,0,1,1-64.01574,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "120",
      "cy": "188",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "168",
      "x2": "120",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "212",
      "cy": "80",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,147.02548V48a32,32,0,0,1,64,0v99.02548l.00787-.01006a52,52,0,1,1-64.01574,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "120",
      "cy": "188",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "168",
      "x2": "120",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cL = [];
/* style */

const __vue_inject_styles__$cL = undefined;
/* scoped */

const __vue_scope_id__$cL = undefined;
/* module identifier */

const __vue_module_identifier__$cL = undefined;
/* functional template */

const __vue_is_functional_template__$cL = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cL = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cL,
  staticRenderFns: __vue_staticRenderFns__$cL
}, __vue_inject_styles__$cL, __vue_script__$cL, __vue_scope_id__$cL, __vue_is_functional_template__$cL, __vue_module_identifier__$cL, false, undefined, undefined, undefined);

var script$cM = Vue.extend({
  name: "PhThermometerCold",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cM = script$cM;
/* template */

var __vue_render__$cM = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "108",
      "cy": "188",
      "r": "12",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "108",
      "y1": "176",
      "x2": "108",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "212",
      "y1": "48",
      "x2": "212",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "181.56619",
      "y1": "70.11146",
      "x2": "212",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "193.19087",
      "y1": "105.88854",
      "x2": "212",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "230.80913",
      "y1": "105.88854",
      "x2": "212",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "242.43381",
      "y1": "70.11146",
      "x2": "212",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M68,154.77579V56a40,40,0,0,1,80,0v98.77485l.0017-.0014a52,52,0,1,1-80.00385.00054Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "212",
      "y1": "48",
      "x2": "212",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "181.56619",
      "y1": "70.11146",
      "x2": "212",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "193.19087",
      "y1": "105.88854",
      "x2": "212",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "230.80913",
      "y1": "105.88854",
      "x2": "212",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "242.43381",
      "y1": "70.11146",
      "x2": "212",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "120",
      "cy": "188",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "168",
      "x2": "120",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,147.02548V48a32,32,0,0,1,64,0v99.02548l.00787-.01006a52,52,0,1,1-64.01574,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152.00787,147.01562,152,147.02539V48a32,32,0,0,0-64,0v99.02539l-.00787-.00977a52,52,0,1,0,64.01574,0ZM120,208a20,20,0,1,1,20-20A19.9999,19.9999,0,0,1,120,208Z",
      "opacity": "0.2"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M244.90576,77.71973l-19.96167,6.48632,12.33716,16.98047a8,8,0,1,1-12.94434,9.4043L212,93.61035l-12.33691,16.98047a7.99995,7.99995,0,0,1-12.94434-9.4043l12.33716-16.98047-19.96167-6.48632a8,8,0,1,1,4.94433-15.2168L204,68.98877V48a8,8,0,0,1,16,0V68.98877l19.96143-6.48584a8,8,0,1,1,4.94433,15.2168ZM180,188A60,60,0,1,1,80,143.27441V48a40,40,0,0,1,80,0v95.27441A59.61666,59.61666,0,0,1,180,188ZM96,48v56h48V48a24,24,0,0,0-48,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "120",
      "cy": "188",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "168",
      "x2": "120",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "212",
      "y1": "48",
      "x2": "212",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "181.56619",
      "y1": "70.11146",
      "x2": "212",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "193.19087",
      "y1": "105.88854",
      "x2": "212",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "230.80913",
      "y1": "105.88854",
      "x2": "212",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "242.43381",
      "y1": "70.11146",
      "x2": "212",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,147.02548V48a32,32,0,0,1,64,0v99.02548l.00787-.01006a52,52,0,1,1-64.01574,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "120",
      "cy": "188",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "168",
      "x2": "120",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "212",
      "y1": "48",
      "x2": "212",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "181.56619",
      "y1": "70.11146",
      "x2": "212",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "193.19087",
      "y1": "105.88854",
      "x2": "212",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "230.80913",
      "y1": "105.88854",
      "x2": "212",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "242.43381",
      "y1": "70.11146",
      "x2": "212",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,147.02548V48a32,32,0,0,1,64,0v99.02548l.00787-.01006a52,52,0,1,1-64.01574,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "120",
      "cy": "188",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "168",
      "x2": "120",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "212",
      "y1": "48",
      "x2": "212",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "181.56619",
      "y1": "70.11146",
      "x2": "212",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "193.19087",
      "y1": "105.88854",
      "x2": "212",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "230.80913",
      "y1": "105.88854",
      "x2": "212",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "242.43381",
      "y1": "70.11146",
      "x2": "212",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,147.02548V48a32,32,0,0,1,64,0v99.02548l.00787-.01006a52,52,0,1,1-64.01574,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cM = [];
/* style */

const __vue_inject_styles__$cM = undefined;
/* scoped */

const __vue_scope_id__$cM = undefined;
/* module identifier */

const __vue_module_identifier__$cM = undefined;
/* functional template */

const __vue_is_functional_template__$cM = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cM = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cM,
  staticRenderFns: __vue_staticRenderFns__$cM
}, __vue_inject_styles__$cM, __vue_script__$cM, __vue_scope_id__$cM, __vue_is_functional_template__$cM, __vue_module_identifier__$cM, false, undefined, undefined, undefined);

var script$cN = Vue.extend({
  name: "PhThermometerHot",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cN = script$cN;
/* template */

var __vue_render__$cN = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "108",
      "cy": "188",
      "r": "12",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "108",
      "y1": "176",
      "x2": "108",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M240.28427,80A20,20,0,0,1,212,80a20,20,0,0,0-28.28427,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M240.28427,120A20,20,0,0,1,212,120a20,20,0,0,0-28.28427,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M68,154.77579V56a40,40,0,0,1,80,0v98.77485l.0017-.0014a52,52,0,1,1-80.00385.00054Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "120",
      "cy": "188",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "168",
      "x2": "120",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M240.28427,80A20,20,0,0,1,212,80a20,20,0,0,0-28.28427,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M240.28427,120A20,20,0,0,1,212,120a20,20,0,0,0-28.28427,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,147.02548V48a32,32,0,0,1,64,0v99.02548l.00787-.01006a52,52,0,1,1-64.01574,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152.00787,147.01562,152,147.02539V48a32,32,0,0,0-64,0v99.02539l-.00787-.00977a52,52,0,1,0,64.01574,0ZM120,208a20,20,0,1,1,20-20A19.9999,19.9999,0,0,1,120,208Z",
      "opacity": "0.2"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M160,143.27441V48a40,40,0,0,0-80,0v95.27441a60,60,0,1,0,80,0ZM120,24a24.02718,24.02718,0,0,1,24,24v8H96V48A24.02718,24.02718,0,0,1,120,24Zm58.05908,61.65723a8.00034,8.00034,0,0,1,0-11.31446,27.99923,27.99923,0,0,1,39.59766,0,12.01214,12.01214,0,0,0,16.9707,0,8.00018,8.00018,0,0,1,11.31348,11.31446,27.99923,27.99923,0,0,1-39.59766,0,12.01214,12.01214,0,0,0-16.9707,0A8.00182,8.00182,0,0,1,178.05908,85.65723Zm67.88184,28.68554a8.00034,8.00034,0,0,1,0,11.31446,27.99923,27.99923,0,0,1-39.59766,0,12.01214,12.01214,0,0,0-16.9707,0,8.00018,8.00018,0,0,1-11.31348-11.31446,27.99923,27.99923,0,0,1,39.59766,0,12.01214,12.01214,0,0,0,16.9707,0A8.00182,8.00182,0,0,1,245.94092,114.34277Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "120",
      "cy": "188",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "168",
      "x2": "120",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M240.28427,80A20,20,0,0,1,212,80a20,20,0,0,0-28.28427,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M240.28427,120A20,20,0,0,1,212,120a20,20,0,0,0-28.28427,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,147.02548V48a32,32,0,0,1,64,0v99.02548l.00787-.01006a52,52,0,1,1-64.01574,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "120",
      "cy": "188",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "168",
      "x2": "120",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M240.28427,80A20,20,0,0,1,212,80a20,20,0,0,0-28.28427,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M240.28427,120A20,20,0,0,1,212,120a20,20,0,0,0-28.28427,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,147.02548V48a32,32,0,0,1,64,0v99.02548l.00787-.01006a52,52,0,1,1-64.01574,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "120",
      "cy": "188",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "168",
      "x2": "120",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M240.28427,80A20,20,0,0,1,212,80a20,20,0,0,0-28.28427,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M240.28427,120A20,20,0,0,1,212,120a20,20,0,0,0-28.28427,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,147.02548V48a32,32,0,0,1,64,0v99.02548l.00787-.01006a52,52,0,1,1-64.01574,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cN = [];
/* style */

const __vue_inject_styles__$cN = undefined;
/* scoped */

const __vue_scope_id__$cN = undefined;
/* module identifier */

const __vue_module_identifier__$cN = undefined;
/* functional template */

const __vue_is_functional_template__$cN = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cN = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cN,
  staticRenderFns: __vue_staticRenderFns__$cN
}, __vue_inject_styles__$cN, __vue_script__$cN, __vue_scope_id__$cN, __vue_is_functional_template__$cN, __vue_module_identifier__$cN, false, undefined, undefined, undefined);

var script$cO = Vue.extend({
  name: "PhThermometerSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cO = script$cO;
/* template */

var __vue_render__$cO = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "188",
      "r": "12",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "168",
      "x2": "128",
      "y2": "92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,154.77579V56a40,40,0,0,1,80,0v98.77485l.0017-.0014a52,52,0,1,1-80.00385.00054Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M160.00787,147.01562,160,147.02539V48a32,32,0,0,0-64,0v99.02539l-.00787-.00977a52,52,0,1,0,64.01574,0ZM128,208a20,20,0,1,1,20-20A19.9999,19.9999,0,0,1,128,208Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,147.02548V48a32,32,0,0,1,64,0v99.02548l.00787-.01006a52,52,0,1,1-64.01574,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "188",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "168",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M168,143.27441V48a40,40,0,0,0-80,0v95.27441a60,60,0,1,0,80,0ZM128,24a24.02718,24.02718,0,0,1,24,24V80H104V48A24.02718,24.02718,0,0,1,128,24Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M96,147.02548V48a32,32,0,0,1,64,0v99.02548l.00787-.01006a52,52,0,1,1-64.01574,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "188",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "168",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M96,147.02548V48a32,32,0,0,1,64,0v99.02548l.00787-.01006a52,52,0,1,1-64.01574,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "188",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "168",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M96,147.02548V48a32,32,0,0,1,64,0v99.02548l.00787-.01006a52,52,0,1,1-64.01574,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "188",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "168",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cO = [];
/* style */

const __vue_inject_styles__$cO = undefined;
/* scoped */

const __vue_scope_id__$cO = undefined;
/* module identifier */

const __vue_module_identifier__$cO = undefined;
/* functional template */

const __vue_is_functional_template__$cO = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cO = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cO,
  staticRenderFns: __vue_staticRenderFns__$cO
}, __vue_inject_styles__$cO, __vue_script__$cO, __vue_scope_id__$cO, __vue_is_functional_template__$cO, __vue_module_identifier__$cO, false, undefined, undefined, undefined);

var script$cP = Vue.extend({
  name: "PhThumbsDown",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cP = script$cP;
/* template */

var __vue_render__$cP = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M31.99414,48h48a0,0,0,0,1,0,0V152a0,0,0,0,1,0,0h-48a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M79.99414,152l40,80a32,32,0,0,0,32-32V176h61.87549a16,16,0,0,0,15.87644-17.98456l-12-96A16,16,0,0,0,201.86963,48H79.99414",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M31.99414,48h48a0,0,0,0,1,0,0V152a0,0,0,0,1,0,0h-48a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M31.99414,48h48a0,0,0,0,1,0,0V152a0,0,0,0,1,0,0h-48a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M79.99414,152l40,80a32,32,0,0,0,32-32V176h61.87549a16,16,0,0,0,15.87644-17.98456l-12-96A16,16,0,0,0,201.86963,48H79.99414",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M237.68457,157.02344l-12-96.00049A24.03944,24.03944,0,0,0,201.86914,40H31.99414a16.01833,16.01833,0,0,0-16,16v88a16.01833,16.01833,0,0,0,16,16H75.0498l37.78907,75.57764A7.99869,7.99869,0,0,0,119.99414,240a40.04552,40.04552,0,0,0,40-40V184h53.875a24.00051,24.00051,0,0,0,23.81543-26.97656ZM71.99414,144h-40V56h40Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M31.99414,48h48a0,0,0,0,1,0,0V152a0,0,0,0,1,0,0h-48a8,8,0,0,1-8-8V56A8,8,0,0,1,31.99414,48Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M79.99414,152l40,80a32,32,0,0,0,32-32V176h61.87549a16,16,0,0,0,15.87644-17.98456l-12-96A16,16,0,0,0,201.86963,48H79.99414",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M31.99414,48h48a0,0,0,0,1,0,0V152a0,0,0,0,1,0,0h-48a8,8,0,0,1-8-8V56A8,8,0,0,1,31.99414,48Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M79.99414,152l40,80a32,32,0,0,0,32-32V176h61.87549a16,16,0,0,0,15.87644-17.98456l-12-96A16,16,0,0,0,201.86963,48H79.99414",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M31.99414,48h48a0,0,0,0,1,0,0V152a0,0,0,0,1,0,0h-48a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M79.99414,152l40,80a32,32,0,0,0,32-32V176h61.87549a16,16,0,0,0,15.87644-17.98456l-12-96A16,16,0,0,0,201.86963,48H79.99414",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cP = [];
/* style */

const __vue_inject_styles__$cP = undefined;
/* scoped */

const __vue_scope_id__$cP = undefined;
/* module identifier */

const __vue_module_identifier__$cP = undefined;
/* functional template */

const __vue_is_functional_template__$cP = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cP = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cP,
  staticRenderFns: __vue_staticRenderFns__$cP
}, __vue_inject_styles__$cP, __vue_script__$cP, __vue_scope_id__$cP, __vue_is_functional_template__$cP, __vue_module_identifier__$cP, false, undefined, undefined, undefined);

var script$cQ = Vue.extend({
  name: "PhThumbsUp",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cQ = script$cQ;
/* template */

var __vue_render__$cQ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M31.99414,104h48a0,0,0,0,1,0,0V208a0,0,0,0,1,0,0h-48a8,8,0,0,1-8-8V112A8,8,0,0,1,31.99414,104Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M79.99414,104l40-80a32,32,0,0,1,32,32V80h61.87549a16,16,0,0,1,15.87644,17.98456l-12,96A16,16,0,0,1,201.86963,208H79.99414",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M31.99414,104h48a0,0,0,0,1,0,0V208a0,0,0,0,1,0,0h-48a8,8,0,0,1-8-8V112A8,8,0,0,1,31.99414,104Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M31.99414,104h48a0,0,0,0,1,0,0V208a0,0,0,0,1,0,0h-48a8,8,0,0,1-8-8V112A8,8,0,0,1,31.99414,104Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M79.99414,104l40-80a32,32,0,0,1,32,32V80h61.87549a16,16,0,0,1,15.87644,17.98456l-12,96A16,16,0,0,1,201.86963,208H79.99414",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M231.86133,80.11621A24.01156,24.01156,0,0,0,213.86914,72h-53.875V56a40.04552,40.04552,0,0,0-40-40,7.99869,7.99869,0,0,0-7.15527,4.42236L75.0498,96H31.99414a16.01833,16.01833,0,0,0-16,16v88a16.01833,16.01833,0,0,0,16,16h169.875a24.03945,24.03945,0,0,0,23.81543-21.02344l12-96A24.01444,24.01444,0,0,0,231.86133,80.11621ZM31.99414,112h40v88h-40Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M31.99414,104h48a0,0,0,0,1,0,0V208a0,0,0,0,1,0,0h-48a8,8,0,0,1-8-8V112A8,8,0,0,1,31.99414,104Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M79.99414,104l40-80a32,32,0,0,1,32,32V80h61.87549a16,16,0,0,1,15.87644,17.98456l-12,96A16,16,0,0,1,201.86963,208H79.99414",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M31.99414,104h48a0,0,0,0,1,0,0V208a0,0,0,0,1,0,0h-48a8,8,0,0,1-8-8V112A8,8,0,0,1,31.99414,104Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M79.99414,104l40-80a32,32,0,0,1,32,32V80h61.87549a16,16,0,0,1,15.87644,17.98456l-12,96A16,16,0,0,1,201.86963,208H79.99414",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M31.99414,104h48a0,0,0,0,1,0,0V208a0,0,0,0,1,0,0h-48a8,8,0,0,1-8-8V112A8,8,0,0,1,31.99414,104Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M79.99414,104l40-80a32,32,0,0,1,32,32V80h61.87549a16,16,0,0,1,15.87644,17.98456l-12,96A16,16,0,0,1,201.86963,208H79.99414",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cQ = [];
/* style */

const __vue_inject_styles__$cQ = undefined;
/* scoped */

const __vue_scope_id__$cQ = undefined;
/* module identifier */

const __vue_module_identifier__$cQ = undefined;
/* functional template */

const __vue_is_functional_template__$cQ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cQ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cQ,
  staticRenderFns: __vue_staticRenderFns__$cQ
}, __vue_inject_styles__$cQ, __vue_script__$cQ, __vue_scope_id__$cQ, __vue_is_functional_template__$cQ, __vue_module_identifier__$cQ, false, undefined, undefined, undefined);

var script$cR = Vue.extend({
  name: "PhTicket",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cR = script$cR;
/* template */

var __vue_render__$cR = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "56",
      "x2": "96",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,167.19024a7.98836,7.98836,0,0,1,6.39917-7.83019,32.00785,32.00785,0,0,0,0-62.7201A7.98836,7.98836,0,0,1,24,88.80976V64a8,8,0,0,1,8-8H224a8,8,0,0,1,8,8V88.80976A7.98836,7.98836,0,0,1,225.60083,96.64a32.00785,32.00785,0,0,0,0,62.7201A7.98836,7.98836,0,0,1,232,167.19024V192a8,8,0,0,1-8,8H32a8,8,0,0,1-8-8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M96,56H224a8,8,0,0,1,8,8V88.80976A7.98836,7.98836,0,0,1,225.60083,96.64a32.00785,32.00785,0,0,0,0,62.7201A7.98836,7.98836,0,0,1,232,167.19024V192a8,8,0,0,1-8,8H96Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "56",
      "x2": "96",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,167.19024a7.98836,7.98836,0,0,1,6.39917-7.83019,32.00785,32.00785,0,0,0,0-62.7201A7.98836,7.98836,0,0,1,24,88.80976V64a8,8,0,0,1,8-8H224a8,8,0,0,1,8,8V88.80976A7.98836,7.98836,0,0,1,225.60083,96.64a32.00785,32.00785,0,0,0,0,62.7201A7.98836,7.98836,0,0,1,232,167.19024V192a8,8,0,0,1-8,8H32a8,8,0,0,1-8-8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M227.19141,104.48A16.04032,16.04032,0,0,0,240,88.80957V64a16.01833,16.01833,0,0,0-16-16H32A16.01833,16.01833,0,0,0,16,64V88.80957A16.04032,16.04032,0,0,0,28.80859,104.48a24.00818,24.00818,0,0,1,0,47.04A16.04032,16.04032,0,0,0,16,167.19043V192a16.01833,16.01833,0,0,0,16,16H224a16.01833,16.01833,0,0,0,16-16V167.19043A16.04032,16.04032,0,0,0,227.19141,151.52a24.00818,24.00818,0,0,1,0-47.04ZM32,167.19824a40.00306,40.00306,0,0,0,0-78.38867V64H88V192H32Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "56",
      "x2": "96",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,167.19024a7.98836,7.98836,0,0,1,6.39917-7.83019,32.00785,32.00785,0,0,0,0-62.7201A7.98836,7.98836,0,0,1,24,88.80976V64a8,8,0,0,1,8-8H224a8,8,0,0,1,8,8V88.80976A7.98836,7.98836,0,0,1,225.60083,96.64a32.00785,32.00785,0,0,0,0,62.7201A7.98836,7.98836,0,0,1,232,167.19024V192a8,8,0,0,1-8,8H32a8,8,0,0,1-8-8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "56",
      "x2": "96",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,167.19024a7.98836,7.98836,0,0,1,6.39917-7.83019,32.00785,32.00785,0,0,0,0-62.7201A7.98836,7.98836,0,0,1,24,88.80976V64a8,8,0,0,1,8-8H224a8,8,0,0,1,8,8V88.80976A7.98836,7.98836,0,0,1,225.60083,96.64a32.00785,32.00785,0,0,0,0,62.7201A7.98836,7.98836,0,0,1,232,167.19024V192a8,8,0,0,1-8,8H32a8,8,0,0,1-8-8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "56",
      "x2": "96",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,167.19024a7.98836,7.98836,0,0,1,6.39917-7.83019,32.00785,32.00785,0,0,0,0-62.7201A7.98836,7.98836,0,0,1,24,88.80976V64a8,8,0,0,1,8-8H224a8,8,0,0,1,8,8V88.80976A7.98836,7.98836,0,0,1,225.60083,96.64a32.00785,32.00785,0,0,0,0,62.7201A7.98836,7.98836,0,0,1,232,167.19024V192a8,8,0,0,1-8,8H32a8,8,0,0,1-8-8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cR = [];
/* style */

const __vue_inject_styles__$cR = undefined;
/* scoped */

const __vue_scope_id__$cR = undefined;
/* module identifier */

const __vue_module_identifier__$cR = undefined;
/* functional template */

const __vue_is_functional_template__$cR = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cR = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cR,
  staticRenderFns: __vue_staticRenderFns__$cR
}, __vue_inject_styles__$cR, __vue_script__$cR, __vue_scope_id__$cR, __vue_is_functional_template__$cR, __vue_module_identifier__$cR, false, undefined, undefined, undefined);

var script$cS = Vue.extend({
  name: "PhTiktokLogo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cS = script$cS;
/* template */

var __vue_render__$cS = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M167.99955,105.98292A95.56434,95.56434,0,0,0,224,124V84a56,56,0,0,1-56-56l-40,0V156a28,28,0,1,1-40.00062-25.30518L88,89.05549A68.00535,68.00535,0,1,0,168,156Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M167.99955,105.98292A95.56434,95.56434,0,0,0,224,124V84a56,56,0,0,1-56-56l-40,0V156a28,28,0,1,1-40.00062-25.30518L88,89.05549A68.00535,68.00535,0,1,0,168,156Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M167.99955,105.98292A95.56434,95.56434,0,0,0,224,124V84a56,56,0,0,1-56-56l-40,0V156a28,28,0,1,1-40.00062-25.30518L88,89.05549A68.00535,68.00535,0,1,0,168,156Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232,84v40a7.99977,7.99977,0,0,1-8,8,103.32406,103.32406,0,0,1-48.00049-11.70752L176,156A76,76,0,1,1,86.59766,81.17971,7.99952,7.99952,0,0,1,96,89.05569l-.00049,41.63916a7.99971,7.99971,0,0,1-4.56689,7.22607A20.00272,20.00272,0,1,0,120,156V28a7.99977,7.99977,0,0,1,8-8h40a7.99977,7.99977,0,0,1,8,8,48.05436,48.05436,0,0,0,48,48A7.99977,7.99977,0,0,1,232,84Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M167.99955,105.98292A95.56434,95.56434,0,0,0,224,124V84a56,56,0,0,1-56-56l-40,0V156a28,28,0,1,1-40.00062-25.30518L88,89.05549A68.00535,68.00535,0,1,0,168,156Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M167.99955,105.98292A95.56434,95.56434,0,0,0,224,124V84a56,56,0,0,1-56-56l-40,0V156a28,28,0,1,1-40.00062-25.30518L88,89.05549A68.00535,68.00535,0,1,0,168,156Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M167.99955,105.98292A95.56434,95.56434,0,0,0,224,124V84a56,56,0,0,1-56-56l-40,0V156a28,28,0,1,1-40.00062-25.30518L88,89.05549A68.00535,68.00535,0,1,0,168,156Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cS = [];
/* style */

const __vue_inject_styles__$cS = undefined;
/* scoped */

const __vue_scope_id__$cS = undefined;
/* module identifier */

const __vue_module_identifier__$cS = undefined;
/* functional template */

const __vue_is_functional_template__$cS = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cS = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cS,
  staticRenderFns: __vue_staticRenderFns__$cS
}, __vue_inject_styles__$cS, __vue_script__$cS, __vue_scope_id__$cS, __vue_is_functional_template__$cS, __vue_module_identifier__$cS, false, undefined, undefined, undefined);

var script$cT = Vue.extend({
  name: "PhTimer",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cT = script$cT;
/* template */

var __vue_render__$cT = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "140",
      "r": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "140",
      "x2": "161.94113",
      "y2": "106.05887",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "12",
      "x2": "152",
      "y2": "12",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "88",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "167.59798",
      "y2": "88.40202",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "8",
      "x2": "152",
      "y2": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M104,16h48a8,8,0,0,0,0-16H104a8,8,0,0,0,0,16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,32a96,96,0,1,0,96,96A96.10874,96.10874,0,0,0,128,32Zm45.25488,62.05859-39.59765,39.59815a8.00018,8.00018,0,0,1-11.31446-11.31348l39.59815-39.59814a8,8,0,1,1,11.314,11.31347Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "167.59798",
      "y2": "88.40202",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "8",
      "x2": "152",
      "y2": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "167.59798",
      "y2": "88.40202",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "8",
      "x2": "152",
      "y2": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "167.59798",
      "y2": "88.40202",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "8",
      "x2": "152",
      "y2": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cT = [];
/* style */

const __vue_inject_styles__$cT = undefined;
/* scoped */

const __vue_scope_id__$cT = undefined;
/* module identifier */

const __vue_module_identifier__$cT = undefined;
/* functional template */

const __vue_is_functional_template__$cT = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cT = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cT,
  staticRenderFns: __vue_staticRenderFns__$cT
}, __vue_inject_styles__$cT, __vue_script__$cT, __vue_scope_id__$cT, __vue_is_functional_template__$cT, __vue_module_identifier__$cT, false, undefined, undefined, undefined);

var script$cU = Vue.extend({
  name: "PhToggleLeft",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cU = script$cU;
/* template */

var __vue_render__$cU = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "16.00006",
      "y": "64",
      "width": "223.99987",
      "height": "128",
      "rx": "63.99994",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "80",
      "cy": "128",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "80",
      "cy": "128",
      "r": "32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "16.00006",
      "y": "64",
      "width": "223.99987",
      "height": "128",
      "rx": "63.99994",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "80",
      "cy": "128",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,56H80a72,72,0,0,0,0,144h96a72,72,0,0,0,0-144ZM80,168a40,40,0,1,1,40-40A40.04552,40.04552,0,0,1,80,168Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "16.00006",
      "y": "64",
      "width": "223.99987",
      "height": "128",
      "rx": "63.99994",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "80",
      "cy": "128",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "16.00006",
      "y": "64",
      "width": "223.99987",
      "height": "128",
      "rx": "63.99994",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "80",
      "cy": "128",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "16.00006",
      "y": "64",
      "width": "223.99987",
      "height": "128",
      "rx": "63.99994",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "80",
      "cy": "128",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cU = [];
/* style */

const __vue_inject_styles__$cU = undefined;
/* scoped */

const __vue_scope_id__$cU = undefined;
/* module identifier */

const __vue_module_identifier__$cU = undefined;
/* functional template */

const __vue_is_functional_template__$cU = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cU = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cU,
  staticRenderFns: __vue_staticRenderFns__$cU
}, __vue_inject_styles__$cU, __vue_script__$cU, __vue_scope_id__$cU, __vue_is_functional_template__$cU, __vue_module_identifier__$cU, false, undefined, undefined, undefined);

var script$cV = Vue.extend({
  name: "PhToggleRight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cV = script$cV;
/* template */

var __vue_render__$cV = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "16.00006",
      "y": "64",
      "width": "223.99987",
      "height": "128",
      "rx": "63.99994",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "128",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "176",
      "cy": "128",
      "r": "32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "16.00006",
      "y": "64",
      "width": "223.99987",
      "height": "128",
      "rx": "63.99994",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "128",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,56H80a72,72,0,0,0,0,144h96a72,72,0,0,0,0-144Zm0,112a40,40,0,1,1,40-40A40.00006,40.00006,0,0,1,176,168Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "16.00006",
      "y": "64",
      "width": "223.99987",
      "height": "128",
      "rx": "63.99994",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "128",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "16.00006",
      "y": "64",
      "width": "223.99987",
      "height": "128",
      "rx": "63.99994",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "128",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "16.00006",
      "y": "64",
      "width": "223.99987",
      "height": "128",
      "rx": "63.99994",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "128",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cV = [];
/* style */

const __vue_inject_styles__$cV = undefined;
/* scoped */

const __vue_scope_id__$cV = undefined;
/* module identifier */

const __vue_module_identifier__$cV = undefined;
/* functional template */

const __vue_is_functional_template__$cV = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cV = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cV,
  staticRenderFns: __vue_staticRenderFns__$cV
}, __vue_inject_styles__$cV, __vue_script__$cV, __vue_scope_id__$cV, __vue_is_functional_template__$cV, __vue_module_identifier__$cV, false, undefined, undefined, undefined);

var script$cW = Vue.extend({
  name: "PhToiletPaper",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cW = script$cW;
/* template */

var __vue_render__$cW = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "64",
      "cy": "120",
      "r": "16"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "64",
      "cy": "120",
      "rx": "40",
      "ry": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,120v88a8,8,0,0,0,8,8H224a8,8,0,0,0,8-8V120c0-44.18278-17.90861-80-40-80H64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "120",
      "x2": "124",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "164",
      "y1": "120",
      "x2": "172",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "212",
      "y1": "120",
      "x2": "232",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "64",
      "cy": "120",
      "rx": "40",
      "ry": "80",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "64",
      "cy": "120",
      "r": "12"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "64",
      "cy": "120",
      "rx": "40",
      "ry": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,120v88a8,8,0,0,0,8,8H224a8,8,0,0,0,8-8V120c0-44.18278-17.90861-80-40-80H64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "120",
      "x2": "128",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "120",
      "x2": "176",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "120",
      "x2": "232",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M184,120a7.99993,7.99993,0,0,1-8,8H160a8,8,0,0,1,0-16h16A7.99993,7.99993,0,0,1,184,120Zm56,0v88a16.01833,16.01833,0,0,1-16,16H112a16.01833,16.01833,0,0,1-16-16V186.34595C87.37219,200.36914,76.1825,208,64,208c-13.87256,0-26.459-9.89209-35.43945-27.854C20.46045,163.94678,16,142.58643,16,120c0-22.58667,4.46045-43.947,12.56055-60.14624C37.541,41.89185,50.12744,32,64,32H192c13.87256,0,26.459,9.89185,35.43945,27.85376C235.53955,76.053,240,97.41333,240,120ZM76,120a12,12,0,1,0-12,12A12,12,0,0,0,76,120Zm148,8H208a8,8,0,0,1,0-16h15.79443C221.84131,73.89966,206.16479,48,192,48H92.12109a73.18268,73.18268,0,0,1,7.31836,11.85376C106.57593,74.126,110.88281,92.40625,111.80762,112H128a8,8,0,0,1,0,16H112v80H224Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "64",
      "cy": "120",
      "r": "10"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "64",
      "cy": "120",
      "rx": "40",
      "ry": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,120v88a8,8,0,0,0,8,8H224a8,8,0,0,0,8-8V120c0-44.18278-17.90861-80-40-80H64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "120",
      "x2": "128",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "120",
      "x2": "176",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "120",
      "x2": "232",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "64",
      "cy": "120",
      "r": "8"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "64",
      "cy": "120",
      "rx": "40",
      "ry": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,120v88a8,8,0,0,0,8,8H224a8,8,0,0,0,8-8V120c0-44.18278-17.90861-80-40-80H64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "120",
      "x2": "128",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "120",
      "x2": "176",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "120",
      "x2": "232",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "64",
      "cy": "120",
      "r": "12"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "64",
      "cy": "120",
      "rx": "40",
      "ry": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,120v88a8,8,0,0,0,8,8H224a8,8,0,0,0,8-8V120c0-44.18278-17.90861-80-40-80H64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "120",
      "x2": "128",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "120",
      "x2": "176",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "120",
      "x2": "232",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cW = [];
/* style */

const __vue_inject_styles__$cW = undefined;
/* scoped */

const __vue_scope_id__$cW = undefined;
/* module identifier */

const __vue_module_identifier__$cW = undefined;
/* functional template */

const __vue_is_functional_template__$cW = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cW = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cW,
  staticRenderFns: __vue_staticRenderFns__$cW
}, __vue_inject_styles__$cW, __vue_script__$cW, __vue_scope_id__$cW, __vue_is_functional_template__$cW, __vue_module_identifier__$cW, false, undefined, undefined, undefined);

var script$cX = Vue.extend({
  name: "PhTote",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cX = script$cX;
/* template */

var __vue_render__$cX = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208.83966,216H47.16034a8,8,0,0,1-7.95107-7.11655l-14.22222-128A8,8,0,0,1,32.93812,72H223.06188a8,8,0,0,1,7.95107,8.88345l-14.22222,128A8,8,0,0,1,208.83966,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,104V72a40,40,0,0,1,80,0v32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208.83966,216H47.16034a8,8,0,0,1-7.95107-7.11655l-14.22222-128A8,8,0,0,1,32.93812,72H223.06188a8,8,0,0,1,7.95107,8.88345l-14.22222,128A8,8,0,0,1,208.83966,216Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208.83966,216H47.16034a8,8,0,0,1-7.95107-7.11655l-14.22222-128A8,8,0,0,1,32.93812,72H223.06188a8,8,0,0,1,7.95107,8.88345l-14.22222,128A8,8,0,0,1,208.83966,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,104V72a40,40,0,0,1,80,0v32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M234.9834,69.3291A16.01892,16.01892,0,0,0,223.06152,64H175.3208a47.99073,47.99073,0,0,0-94.6416,0H32.93848A16.00031,16.00031,0,0,0,17.03613,81.7666L31.25781,209.76709A15.98372,15.98372,0,0,0,47.16016,224H208.83984a15.98375,15.98375,0,0,0,15.90235-14.2334l14.22168-128A16.01871,16.01871,0,0,0,234.9834,69.3291ZM95.99219,104a8,8,0,0,1-16,0V88a8,8,0,0,1,16,0ZM97.0127,64a32.00443,32.00443,0,0,1,61.9746,0Zm78.97949,40a8,8,0,0,1-16,0V88a8,8,0,0,1,16,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208.83966,216H47.16034a8,8,0,0,1-7.95107-7.11655l-14.22222-128A8,8,0,0,1,32.93812,72H223.06188a8,8,0,0,1,7.95107,8.88345l-14.22222,128A8,8,0,0,1,208.83966,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,104V72a40,40,0,0,1,80,0v32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208.83966,216H47.16034a8,8,0,0,1-7.95107-7.11655l-14.22222-128A8,8,0,0,1,32.93812,72H223.06188a8,8,0,0,1,7.95107,8.88345l-14.22222,128A8,8,0,0,1,208.83966,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,104V72a40,40,0,0,1,80,0v32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208.83966,216H47.16034a8,8,0,0,1-7.95107-7.11655l-14.22222-128A8,8,0,0,1,32.93812,72H223.06188a8,8,0,0,1,7.95107,8.88345l-14.22222,128A8,8,0,0,1,208.83966,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,104V72a40,40,0,0,1,80,0v32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cX = [];
/* style */

const __vue_inject_styles__$cX = undefined;
/* scoped */

const __vue_scope_id__$cX = undefined;
/* module identifier */

const __vue_module_identifier__$cX = undefined;
/* functional template */

const __vue_is_functional_template__$cX = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cX = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cX,
  staticRenderFns: __vue_staticRenderFns__$cX
}, __vue_inject_styles__$cX, __vue_script__$cX, __vue_scope_id__$cX, __vue_is_functional_template__$cX, __vue_module_identifier__$cX, false, undefined, undefined, undefined);

var script$cY = Vue.extend({
  name: "PhToteSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cY = script$cY;
/* template */

var __vue_render__$cY = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208.83966,216H47.16034a8,8,0,0,1-7.95107-7.11655l-14.22222-128A8,8,0,0,1,32.93812,72H223.06188a8,8,0,0,1,7.95107,8.88345l-14.22222,128A8,8,0,0,1,208.83966,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,72a40,40,0,0,1,80,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208.83966,216H47.16034a8,8,0,0,1-7.95107-7.11655l-14.22222-128A8,8,0,0,1,32.93812,72H223.06188a8,8,0,0,1,7.95107,8.88345l-14.22222,128A8,8,0,0,1,208.83966,216Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208.83966,216H47.16034a8,8,0,0,1-7.95107-7.11655l-14.22222-128A8,8,0,0,1,32.93812,72H223.06188a8,8,0,0,1,7.95107,8.88345l-14.22222,128A8,8,0,0,1,208.83966,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,72a40,40,0,0,1,80,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M234.9834,69.3291A16.01892,16.01892,0,0,0,223.06152,64H175.3208a47.99073,47.99073,0,0,0-94.6416,0H32.93848A16.00031,16.00031,0,0,0,17.03613,81.7666L31.25781,209.76709A15.98372,15.98372,0,0,0,47.16016,224H208.83984a15.98375,15.98375,0,0,0,15.90235-14.2334l14.22168-128A16.01871,16.01871,0,0,0,234.9834,69.3291ZM128,40a32.05773,32.05773,0,0,1,30.9873,24H97.0127A32.05773,32.05773,0,0,1,128,40Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208.83966,216H47.16034a8,8,0,0,1-7.95107-7.11655l-14.22222-128A8,8,0,0,1,32.93812,72H223.06188a8,8,0,0,1,7.95107,8.88345l-14.22222,128A8,8,0,0,1,208.83966,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,72a40,40,0,0,1,80,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208.83966,216H47.16034a8,8,0,0,1-7.95107-7.11655l-14.22222-128A8,8,0,0,1,32.93812,72H223.06188a8,8,0,0,1,7.95107,8.88345l-14.22222,128A8,8,0,0,1,208.83966,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,72a40,40,0,0,1,80,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208.83966,216H47.16034a8,8,0,0,1-7.95107-7.11655l-14.22222-128A8,8,0,0,1,32.93812,72H223.06188a8,8,0,0,1,7.95107,8.88345l-14.22222,128A8,8,0,0,1,208.83966,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,72a40,40,0,0,1,80,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cY = [];
/* style */

const __vue_inject_styles__$cY = undefined;
/* scoped */

const __vue_scope_id__$cY = undefined;
/* module identifier */

const __vue_module_identifier__$cY = undefined;
/* functional template */

const __vue_is_functional_template__$cY = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cY = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cY,
  staticRenderFns: __vue_staticRenderFns__$cY
}, __vue_inject_styles__$cY, __vue_script__$cY, __vue_scope_id__$cY, __vue_is_functional_template__$cY, __vue_module_identifier__$cY, false, undefined, undefined, undefined);

var script$cZ = Vue.extend({
  name: "PhTrafficSign",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cZ = script$cZ;
/* template */

var __vue_render__$cZ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "144 144 168 120 144 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "45.97561",
      "y": "45.97561",
      "width": "164.04877",
      "height": "164.04877",
      "rx": "8",
      "transform": "translate(-53.01934 128) rotate(-45)",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,148v-4a24,24,0,0,1,24-24h56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "45.97561",
      "y": "45.97561",
      "width": "164.04877",
      "height": "164.04877",
      "rx": "8",
      "transform": "translate(-53.01934 128) rotate(-45)",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 144 168 120 144 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "45.97561",
      "y": "45.97561",
      "width": "164.04877",
      "height": "164.04877",
      "rx": "8",
      "transform": "translate(-53.01934 128) rotate(-45)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,152v-8a24,24,0,0,1,24-24h56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M244,116.68555,139.31445,12.001A15.99888,15.99888,0,0,0,116.68652,12L11.999,116.68652A16.02163,16.02163,0,0,0,12,139.31445L116.68555,243.999a15.99888,15.99888,0,0,0,22.62793.001L244.001,139.31348A16.02163,16.02163,0,0,0,244,116.68555ZM175.999,120.022q-.00145.38379-.03906.7666c-.01172.12061-.03418.2378-.05127.35694-.02.13965-.03613.27929-.064.41748-.02637.13525-.06348.26611-.09717.39892-.03027.12012-.05664.24073-.09277.35987-.03956.13037-.0879.25586-.13379.3833-.04248.11914-.08155.23877-.13038.356-.04882.11767-.106.23-.16015.34472-.05762.12256-.11182.2461-.17627.36572-.05762.10791-.12354.21-.186.31495-.0708.11914-.13867.24023-.2163.35644-.07618.11328-.16065.22022-.24219.3291-.07471.1001-.144.20264-.22412.3003-.14893.18115-.30762.35449-.47168.522-.02.02051-.03711.04248-.05713.063l-24,24a8.00018,8.00018,0,0,1-11.31348-11.31446L148.686,128H112a16.01833,16.01833,0,0,0-16,16v8a8,8,0,0,1-16,0v-8a32.03667,32.03667,0,0,1,32-32h36.686l-10.34278-10.34277a8.00018,8.00018,0,0,1,11.31348-11.31446l24,24c.02.02051.03711.04248.05713.063.16406.16748.32275.34082.47168.522.08007.09766.14941.2002.22412.3003.08154.10888.166.21582.24219.3291.07763.11621.1455.2373.2163.35644.0625.105.12842.207.186.31495.06445.11962.11865.24316.17627.36572.0542.11474.11133.22705.16015.34472.04883.11719.0879.23682.13038.356.04589.12744.09423.25293.13379.3833.03613.11914.0625.23975.09277.35987.03369.13281.0708.26367.09717.39892.02783.13819.04394.27783.064.41748.01709.11914.03955.23633.05127.35694q.03809.38232.03906.7666L176,120Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "144 144 168 120 144 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "45.97561",
      "y": "45.97561",
      "width": "164.04877",
      "height": "164.04877",
      "rx": "8",
      "transform": "translate(-53.01934 128) rotate(-45)",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,152v-8a24,24,0,0,1,24-24h56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "144 144 168 120 144 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "45.97561",
      "y": "45.97561",
      "width": "164.04877",
      "height": "164.04877",
      "rx": "8",
      "transform": "translate(-53.01934 128) rotate(-45)",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,152v-8a24,24,0,0,1,24-24h56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "144 144 168 120 144 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "45.97561",
      "y": "45.97561",
      "width": "164.04877",
      "height": "164.04877",
      "rx": "8",
      "transform": "translate(-53.01934 128) rotate(-45)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,152v-8a24,24,0,0,1,24-24h56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cZ = [];
/* style */

const __vue_inject_styles__$cZ = undefined;
/* scoped */

const __vue_scope_id__$cZ = undefined;
/* module identifier */

const __vue_module_identifier__$cZ = undefined;
/* functional template */

const __vue_is_functional_template__$cZ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cZ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cZ,
  staticRenderFns: __vue_staticRenderFns__$cZ
}, __vue_inject_styles__$cZ, __vue_script__$cZ, __vue_scope_id__$cZ, __vue_is_functional_template__$cZ, __vue_module_identifier__$cZ, false, undefined, undefined, undefined);

var script$c_ = Vue.extend({
  name: "PhTrain",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$c_ = script$c_;
/* template */

var __vue_render__$c_ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "44",
      "y1": "128",
      "x2": "212",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "44",
      "y1": "72",
      "x2": "212",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "208",
      "x2": "72",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "208",
      "x2": "184",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "44",
      "y": "32",
      "width": "168",
      "height": "176",
      "rx": "24",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "72",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "88",
      "cy": "168",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "168",
      "cy": "168",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "44",
      "y": "72",
      "width": "168",
      "height": "56",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "44",
      "y1": "128",
      "x2": "212",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "44",
      "y1": "72",
      "x2": "212",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "208",
      "x2": "72",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "208",
      "x2": "184",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "44",
      "y": "32",
      "width": "168",
      "height": "176",
      "rx": "24",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "72",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "172",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "172",
      "cy": "172",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M188,24H68A32.03667,32.03667,0,0,0,36,56V184a32.03667,32.03667,0,0,0,32,32H79.99976L65.59961,235.2002a8.00019,8.00019,0,0,0,12.80078,9.5996L100.00024,216h55.99952l21.59985,28.7998a8.00019,8.00019,0,0,0,12.80078-9.5996L176.00024,216H188a32.03667,32.03667,0,0,0,32-32V56A32.03667,32.03667,0,0,0,188,24ZM84,184a12,12,0,1,1,12-12A12,12,0,0,1,84,184Zm36-64H52V80h68Zm52,64a12,12,0,1,1,12-12A12,12,0,0,1,172,184Zm32-64H136V80h68Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "44",
      "y1": "128",
      "x2": "212",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "44",
      "y1": "72",
      "x2": "212",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "208",
      "x2": "72",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "208",
      "x2": "184",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "44",
      "y": "32",
      "width": "168",
      "height": "176",
      "rx": "24",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "72",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "172",
      "cy": "172",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "172",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "44",
      "y1": "128",
      "x2": "212",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "44",
      "y1": "72",
      "x2": "212",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "208",
      "x2": "72",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "208",
      "x2": "184",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "44",
      "y": "32",
      "width": "168",
      "height": "176",
      "rx": "24",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "72",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "172",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "172",
      "cy": "172",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "44",
      "y1": "128",
      "x2": "212",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "44",
      "y1": "72",
      "x2": "212",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "208",
      "x2": "72",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "208",
      "x2": "184",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "44",
      "y": "32",
      "width": "168",
      "height": "176",
      "rx": "24",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "72",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "172",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "172",
      "cy": "172",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$c_ = [];
/* style */

const __vue_inject_styles__$c_ = undefined;
/* scoped */

const __vue_scope_id__$c_ = undefined;
/* module identifier */

const __vue_module_identifier__$c_ = undefined;
/* functional template */

const __vue_is_functional_template__$c_ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$c_ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$c_,
  staticRenderFns: __vue_staticRenderFns__$c_
}, __vue_inject_styles__$c_, __vue_script__$c_, __vue_scope_id__$c_, __vue_is_functional_template__$c_, __vue_module_identifier__$c_, false, undefined, undefined, undefined);

var script$c$ = Vue.extend({
  name: "PhTrainRegional",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$c$ = script$c$;
/* template */

var __vue_render__$c$ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M70.11037,32H185.88963a8,8,0,0,1,7.71811,5.89506L216,120l-22.39226,82.10494A8,8,0,0,1,185.88963,208H70.11037a8,8,0,0,1-7.71811-5.89506L40,120,62.39226,37.89506A8,8,0,0,1,70.11037,32Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "208",
      "x2": "128",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "40 120 128 136 216 120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "88",
      "x2": "160",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "208",
      "x2": "72",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "208",
      "x2": "184",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,120l88,16,88-16-22.39226,82.10494A8,8,0,0,1,185.88963,208H70.11037a8,8,0,0,1-7.71811-5.89506Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M70.11037,32H185.88963a8,8,0,0,1,7.71811,5.89506L216,120l-22.39226,82.10494A8,8,0,0,1,185.88963,208H70.11037a8,8,0,0,1-7.71811-5.89506L40,120,62.39226,37.89506A8,8,0,0,1,70.11037,32Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "208",
      "x2": "128",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "40 120 128 136 216 120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "88",
      "x2": "160",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "208",
      "x2": "72",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "208",
      "x2": "184",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M160,80H96a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M223.99023,119.85681q-.00732-.37884-.05078-.76166c-.011-.09741-.02295-.194-.03759-.291-.012-.07855-.01661-.15656-.03077-.23529-.03271-.18048-.08007-.35437-.124-.52967-.01221-.04766-.01636-.09668-.0293-.14416l-.033-.12073-.00122-.00421L201.3252,35.79A16.03362,16.03362,0,0,0,185.88965,24H70.11035A16.03362,16.03362,0,0,0,54.6748,35.79L32.31665,117.76892l-.002.00733-.03247.11877c-.0127.047-.01685.09546-.02881.14264-.04444.17578-.09155.35022-.12451.53119-.01416.07873-.0188.15674-.03077.23529-.01464.097-.02661.1936-.03759.291q-.044.38316-.05078.76166c-.00123.06708-.00611.13373-.00562.20081a7.94859,7.94859,0,0,0,.06567.98889c.00269.0202.00757.0401.0105.06036a7.95052,7.95052,0,0,0,.18115.89508c.00879.03406.01148.06909.02076.103L54.6748,204.209A16.03394,16.03394,0,0,0,70.11035,216h9.88941L65.59961,235.2002a8.00019,8.00019,0,0,0,12.80078,9.5996L100.00024,216h55.99952l21.59985,28.7998a8.00019,8.00019,0,0,0,12.80078-9.5996L176.00024,216h9.88941a16.03394,16.03394,0,0,0,15.43555-11.791l22.39257-82.104c.00928-.03394.012-.069.02076-.103a7.95052,7.95052,0,0,0,.18115-.89508c.00293-.02026.00781-.04016.0105-.06036a7.94859,7.94859,0,0,0,.06567-.98889C223.99634,119.99054,223.99146,119.92389,223.99023,119.85681ZM136,192a8,8,0,0,1-16,0V152a8,8,0,0,1,16,0Zm-8-64.13135L50.0127,113.68927,70.10645,40h115.7832l20.09717,73.68933Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M70.11037,32H185.88963a8,8,0,0,1,7.71811,5.89506L216,120l-22.39226,82.10494A8,8,0,0,1,185.88963,208H70.11037a8,8,0,0,1-7.71811-5.89506L40,120,62.39226,37.89506A8,8,0,0,1,70.11037,32Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "208",
      "x2": "128",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "40 120 128 136 216 120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "88",
      "x2": "160",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "208",
      "x2": "72",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "208",
      "x2": "184",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M70.11037,32H185.88963a8,8,0,0,1,7.71811,5.89506L216,120l-22.39226,82.10494A8,8,0,0,1,185.88963,208H70.11037a8,8,0,0,1-7.71811-5.89506L40,120,62.39226,37.89506A8,8,0,0,1,70.11037,32Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "208",
      "x2": "128",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "40 120 128 136 216 120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "88",
      "x2": "160",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "208",
      "x2": "72",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "208",
      "x2": "184",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M70.11037,32H185.88963a8,8,0,0,1,7.71811,5.89506L216,120l-22.39226,82.10494A8,8,0,0,1,185.88963,208H70.11037a8,8,0,0,1-7.71811-5.89506L40,120,62.39226,37.89506A8,8,0,0,1,70.11037,32Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "208",
      "x2": "128",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "40 120 128 136 216 120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "88",
      "x2": "160",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "208",
      "x2": "72",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "208",
      "x2": "184",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$c$ = [];
/* style */

const __vue_inject_styles__$c$ = undefined;
/* scoped */

const __vue_scope_id__$c$ = undefined;
/* module identifier */

const __vue_module_identifier__$c$ = undefined;
/* functional template */

const __vue_is_functional_template__$c$ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$c$ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$c$,
  staticRenderFns: __vue_staticRenderFns__$c$
}, __vue_inject_styles__$c$, __vue_script__$c$, __vue_scope_id__$c$, __vue_is_functional_template__$c$, __vue_module_identifier__$c$, false, undefined, undefined, undefined);

var script$d0 = Vue.extend({
  name: "PhTrainSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$d0 = script$d0;
/* template */

var __vue_render__$d0 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "44",
      "y1": "128",
      "x2": "212",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "208",
      "x2": "72",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "208",
      "x2": "184",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "44",
      "y": "32",
      "width": "168",
      "height": "176",
      "rx": "24",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "88",
      "cy": "168",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "168",
      "cy": "168",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M212,56a24,24,0,0,0-24-24H68A24,24,0,0,0,44,56v72H212Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "44",
      "y1": "128",
      "x2": "212",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "208",
      "x2": "72",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "208",
      "x2": "184",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "44",
      "y": "32",
      "width": "168",
      "height": "176",
      "rx": "24",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "172",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "172",
      "cy": "172",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M188,24H68A32.03667,32.03667,0,0,0,36,56V184a32.03667,32.03667,0,0,0,32,32H79.99976L65.59961,235.2002a8.00019,8.00019,0,0,0,12.80078,9.5996L100.00024,216h55.99952l21.59985,28.7998a8.00019,8.00019,0,0,0,12.80078-9.5996L176.00024,216H188a32.03667,32.03667,0,0,0,32-32V56A32.03667,32.03667,0,0,0,188,24Zm0,176H68a16.01833,16.01833,0,0,1-16-16V136H204v48A16.01833,16.01833,0,0,1,188,200Z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "172",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "172",
      "cy": "172",
      "r": "12"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "44",
      "y1": "128",
      "x2": "212",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "208",
      "x2": "72",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "208",
      "x2": "184",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "44",
      "y": "32",
      "width": "168",
      "height": "176",
      "rx": "24",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "172",
      "cy": "172",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "172",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "44",
      "y1": "128",
      "x2": "212",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "208",
      "x2": "72",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "208",
      "x2": "184",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "44",
      "y": "32",
      "width": "168",
      "height": "176",
      "rx": "24",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "172",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "172",
      "cy": "172",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "44",
      "y1": "128",
      "x2": "212",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "208",
      "x2": "72",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "208",
      "x2": "184",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "44",
      "y": "32",
      "width": "168",
      "height": "176",
      "rx": "24",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "172",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "172",
      "cy": "172",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$d0 = [];
/* style */

const __vue_inject_styles__$d0 = undefined;
/* scoped */

const __vue_scope_id__$d0 = undefined;
/* module identifier */

const __vue_module_identifier__$d0 = undefined;
/* functional template */

const __vue_is_functional_template__$d0 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$d0 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$d0,
  staticRenderFns: __vue_staticRenderFns__$d0
}, __vue_inject_styles__$d0, __vue_script__$d0, __vue_scope_id__$d0, __vue_is_functional_template__$d0, __vue_module_identifier__$d0, false, undefined, undefined, undefined);

var script$d1 = Vue.extend({
  name: "PhTranslate",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$d1 = script$d1;
/* template */

var __vue_render__$d1 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "231.982 216 175.982 104 119.982 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "135.98242",
      "y1": "184",
      "x2": "215.98242",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "87.98242",
      "y1": "32",
      "x2": "87.98242",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "23.98242",
      "y1": "56",
      "x2": "151.98242",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M119.98242,56a96,96,0,0,1-96,96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64.69682,96.00062a96.01575,96.01575,0,0,0,87.27974,55.96606",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "231.971 216 175.971 104 119.971 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "135.9707",
      "y1": "184",
      "x2": "215.9707",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "87.9707",
      "y1": "32",
      "x2": "87.9707",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "23.9707",
      "y1": "56",
      "x2": "151.9707",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M119.9707,56a96,96,0,0,1-96,96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M61.43952,88.00088a96.03987,96.03987,0,0,0,90.52532,63.9658",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M239.13184,212.42188l-56-112a8.0001,8.0001,0,0,0-14.31055,0L147.12378,143.817a88.01219,88.01219,0,0,1-47.15234-16.89991A103.63932,103.63932,0,0,0,127.67187,64h24.30469a8,8,0,0,0,0-16h-56V32a8,8,0,0,0-16,0V48h-56a8,8,0,0,0,0,16h87.63257a87.71326,87.71326,0,0,1-23.64038,52.34106A87.6285,87.6285,0,0,1,68.98682,85.332a7.99985,7.99985,0,1,0-15.083,5.33789A103.55961,103.55961,0,0,0,75.9856,126.93945,87.52745,87.52745,0,0,1,23.97656,144a8,8,0,0,0,0,16,103.48476,103.48476,0,0,0,64.01331-22.09045A104.14165,104.14165,0,0,0,139.43115,159.202l-26.60986,53.21985a8.00006,8.00006,0,0,0,14.31055,7.15625L140.9209,192h70.11133l13.78906,27.57813a8.00006,8.00006,0,0,0,14.31055-7.15625ZM148.9209,176l27.05566-54.11133L203.03223,176Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "231.988 216 175.988 104 119.988 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "135.98828",
      "y1": "184",
      "x2": "215.98828",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "87.98828",
      "y1": "32",
      "x2": "87.98828",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "23.98828",
      "y1": "56",
      "x2": "151.98828",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M119.98828,56a96,96,0,0,1-96,96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M61.4571,88.00088a96.03987,96.03987,0,0,0,90.52532,63.9658",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "231.994 216 175.994 104 119.994 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "135.99414",
      "y1": "184",
      "x2": "215.99414",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "87.99414",
      "y1": "32",
      "x2": "87.99414",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "23.99414",
      "y1": "56",
      "x2": "151.99414",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M119.99414,56a96,96,0,0,1-96,96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M61.463,88.00088a96.03987,96.03987,0,0,0,90.52532,63.9658",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "232 216 176 104 120 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "184",
      "x2": "216",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "32",
      "x2": "88",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "56",
      "x2": "152",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M120,56a96,96,0,0,1-96,96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M61.46882,88.00088a96.03987,96.03987,0,0,0,90.52532,63.9658",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$d1 = [];
/* style */

const __vue_inject_styles__$d1 = undefined;
/* scoped */

const __vue_scope_id__$d1 = undefined;
/* module identifier */

const __vue_module_identifier__$d1 = undefined;
/* functional template */

const __vue_is_functional_template__$d1 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$d1 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$d1,
  staticRenderFns: __vue_staticRenderFns__$d1
}, __vue_inject_styles__$d1, __vue_script__$d1, __vue_scope_id__$d1, __vue_is_functional_template__$d1, __vue_module_identifier__$d1, false, undefined, undefined, undefined);

var script$d2 = Vue.extend({
  name: "PhTrash",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$d2 = script$d2;
/* template */

var __vue_render__$d2 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "215.99609",
      "y1": "60",
      "x2": "39.99609",
      "y2": "60.00005",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "104",
      "x2": "104",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "104",
      "x2": "152",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,60V208a8,8,0,0,1-8,8H64a8,8,0,0,1-8-8V60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,60V36a16,16,0,0,0-16-16H104A16,16,0,0,0,88,36V60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M199.99609,56.00005V208a8,8,0,0,1-8,8h-128a8,8,0,0,1-8-8v-152Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "215.99609",
      "y1": "56",
      "x2": "39.99609",
      "y2": "56.00005",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "104",
      "x2": "104",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "104",
      "x2": "152",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,56V208a8,8,0,0,1-8,8H64a8,8,0,0,1-8-8V56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,56V40a16,16,0,0,0-16-16H104A16,16,0,0,0,88,40V56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M215.99609,48H176V40a24.02718,24.02718,0,0,0-24-24H104A24.02718,24.02718,0,0,0,80,40v8H39.99609a8,8,0,0,0,0,16h8V208a16.01833,16.01833,0,0,0,16,16h128a16.01833,16.01833,0,0,0,16-16V64h8a8,8,0,0,0,0-16ZM112,168a8,8,0,0,1-16,0V104a8,8,0,0,1,16,0Zm48,0a8,8,0,0,1-16,0V104a8,8,0,0,1,16,0Zm0-120H96V40a8.00917,8.00917,0,0,1,8-8h48a8.00917,8.00917,0,0,1,8,8Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "215.99609",
      "y1": "56",
      "x2": "39.99609",
      "y2": "56.00005",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "104",
      "x2": "104",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "104",
      "x2": "152",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,56V208a8,8,0,0,1-8,8H64a8,8,0,0,1-8-8V56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,56V40a16,16,0,0,0-16-16H104A16,16,0,0,0,88,40V56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "215.99609",
      "y1": "56",
      "x2": "39.99609",
      "y2": "56.00005",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "104",
      "x2": "104",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "104",
      "x2": "152",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,56V208a8,8,0,0,1-8,8H64a8,8,0,0,1-8-8V56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,56V40a16,16,0,0,0-16-16H104A16,16,0,0,0,88,40V56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "215.99609",
      "y1": "56",
      "x2": "39.99609",
      "y2": "56.00005",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "104",
      "x2": "104",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "104",
      "x2": "152",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,56V208a8,8,0,0,1-8,8H64a8,8,0,0,1-8-8V56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,56V40a16,16,0,0,0-16-16H104A16,16,0,0,0,88,40V56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$d2 = [];
/* style */

const __vue_inject_styles__$d2 = undefined;
/* scoped */

const __vue_scope_id__$d2 = undefined;
/* module identifier */

const __vue_module_identifier__$d2 = undefined;
/* functional template */

const __vue_is_functional_template__$d2 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$d2 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$d2,
  staticRenderFns: __vue_staticRenderFns__$d2
}, __vue_inject_styles__$d2, __vue_script__$d2, __vue_scope_id__$d2, __vue_is_functional_template__$d2, __vue_module_identifier__$d2, false, undefined, undefined, undefined);

var script$d3 = Vue.extend({
  name: "PhTrashSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$d3 = script$d3;
/* template */

var __vue_render__$d3 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "215.99609",
      "y1": "60",
      "x2": "39.99609",
      "y2": "60.00005",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "20",
      "x2": "168",
      "y2": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,60V208a8,8,0,0,1-8,8H64a8,8,0,0,1-8-8V60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M199.99609,56.00005V208a8,8,0,0,1-8,8h-128a8,8,0,0,1-8-8v-152Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "215.99609",
      "y1": "56",
      "x2": "39.99609",
      "y2": "56.00005",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "24",
      "x2": "168",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,56V208a8,8,0,0,1-8,8H64a8,8,0,0,1-8-8V56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,56a8.00008,8.00008,0,0,1-8,8h-8V208a16.01833,16.01833,0,0,1-16,16H64a16.01833,16.01833,0,0,1-16-16V64H40a8,8,0,0,1,0-16H216A8.00008,8.00008,0,0,1,224,56ZM88.00391,32h80a8,8,0,0,0,0-16h-80a8,8,0,0,0,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "215.99609",
      "y1": "56",
      "x2": "39.99609",
      "y2": "56.00005",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "24",
      "x2": "168",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,56V208a8,8,0,0,1-8,8H64a8,8,0,0,1-8-8V56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "215.99609",
      "y1": "56",
      "x2": "39.99609",
      "y2": "56.00005",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "24",
      "x2": "168",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,56V208a8,8,0,0,1-8,8H64a8,8,0,0,1-8-8V56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "215.99609",
      "y1": "56",
      "x2": "39.99609",
      "y2": "56.00005",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "24",
      "x2": "168",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,56V208a8,8,0,0,1-8,8H64a8,8,0,0,1-8-8V56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$d3 = [];
/* style */

const __vue_inject_styles__$d3 = undefined;
/* scoped */

const __vue_scope_id__$d3 = undefined;
/* module identifier */

const __vue_module_identifier__$d3 = undefined;
/* functional template */

const __vue_is_functional_template__$d3 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$d3 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$d3,
  staticRenderFns: __vue_staticRenderFns__$d3
}, __vue_inject_styles__$d3, __vue_script__$d3, __vue_scope_id__$d3, __vue_is_functional_template__$d3, __vue_module_identifier__$d3, false, undefined, undefined, undefined);

var script$d4 = Vue.extend({
  name: "PhTray",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$d4 = script$d4;
/* template */

var __vue_render__$d4 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M39.99414,156H76.68043a8,8,0,0,1,5.65686,2.34315l19.3137,19.3137A8,8,0,0,0,107.30785,180h41.37258a8,8,0,0,0,5.65686-2.34315l19.3137-19.3137A8,8,0,0,1,179.30785,156h36.68629",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M76.68066,160a7.9996,7.9996,0,0,1,5.65674,2.34326l19.31348,19.31348A7.99962,7.99962,0,0,0,107.30762,184h41.373a7.9996,7.9996,0,0,0,5.65674-2.34326l19.31348-19.31348A7.99962,7.99962,0,0,1,179.30762,160h36.68652l.00586.00439V48a7.99977,7.99977,0,0,0-8-8H48a7.99977,7.99977,0,0,0-8,8V160Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M39.99414,160H76.68043a8,8,0,0,1,5.65686,2.34315l19.3137,19.3137A8,8,0,0,0,107.30785,184h41.37258a8,8,0,0,0,5.65686-2.34315l19.3137-19.3137A8,8,0,0,1,179.30785,160h36.68629",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208.00293,32h-160a16.01833,16.01833,0,0,0-16,16V159.88379c-.00049.03906-.00586.07715-.00586.11621s.00537.07715.00586.11621V208a16.01833,16.01833,0,0,0,16,16h160a16.01833,16.01833,0,0,0,16-16V48A16.01833,16.01833,0,0,0,208.00293,32Zm0,176h-160V168l28.68066-.001,19.31446,19.31641A15.89834,15.89834,0,0,0,107.31055,192h41.373a15.89606,15.89606,0,0,0,11.31348-4.68652L179.31055,168h28.6997l.00245,40Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M39.99414,160H76.68043a8,8,0,0,1,5.65686,2.34315l19.3137,19.3137A8,8,0,0,0,107.30785,184h41.37258a8,8,0,0,0,5.65686-2.34315l19.3137-19.3137A8,8,0,0,1,179.30785,160h36.68629",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M39.99414,160H76.68043a8,8,0,0,1,5.65686,2.34315l19.3137,19.3137A8,8,0,0,0,107.30785,184h41.37258a8,8,0,0,0,5.65686-2.34315l19.3137-19.3137A8,8,0,0,1,179.30785,160h36.68629",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M39.99414,160H76.68043a8,8,0,0,1,5.65686,2.34315l19.3137,19.3137A8,8,0,0,0,107.30785,184h41.37258a8,8,0,0,0,5.65686-2.34315l19.3137-19.3137A8,8,0,0,1,179.30785,160h36.68629",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$d4 = [];
/* style */

const __vue_inject_styles__$d4 = undefined;
/* scoped */

const __vue_scope_id__$d4 = undefined;
/* module identifier */

const __vue_module_identifier__$d4 = undefined;
/* functional template */

const __vue_is_functional_template__$d4 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$d4 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$d4,
  staticRenderFns: __vue_staticRenderFns__$d4
}, __vue_inject_styles__$d4, __vue_script__$d4, __vue_scope_id__$d4, __vue_is_functional_template__$d4, __vue_module_identifier__$d4, false, undefined, undefined, undefined);

var script$d5 = Vue.extend({
  name: "PhTree",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$d5 = script$d5;
/* template */

var __vue_render__$d5 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "232",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "152",
      "x2": "80",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "176",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M132.476,181.2265a63.99546,63.99546,0,1,0,62.27163-111.367A7.98712,7.98712,0,0,1,190.7243,65.693a68.02876,68.02876,0,0,0-125.44861,0,7.98711,7.98711,0,0,1-4.02328,4.16655,63.99621,63.99621,0,1,0,62.27159,111.367A8.03193,8.03193,0,0,1,132.476,181.2265Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M132.476,181.2265a63.99546,63.99546,0,1,0,62.27163-111.367A7.98712,7.98712,0,0,1,190.7243,65.693a68.02876,68.02876,0,0,0-125.44861,0,7.98711,7.98711,0,0,1-4.02328,4.16655,63.99621,63.99621,0,1,0,62.27159,111.367A8.03193,8.03193,0,0,1,132.476,181.2265Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "232",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "152",
      "x2": "80",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "176",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M132.476,181.2265a63.99546,63.99546,0,1,0,62.27163-111.367A7.98712,7.98712,0,0,1,190.7243,65.693a68.02876,68.02876,0,0,0-125.44861,0,7.98711,7.98711,0,0,1-4.02328,4.16655,63.99621,63.99621,0,1,0,62.27159,111.367A8.03193,8.03193,0,0,1,132.476,181.2265Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M128.02637,187.875c-.02246-.01562-.03028-.01562-.05274,0A72.19779,72.19779,0,0,1,120,192.49219V232a8,8,0,0,0,16,0V192.4917a72.33623,72.33623,0,0,1-7.97266-4.6167Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M198.10059,62.5957a76.0256,76.0256,0,0,0-140.1958-.002A72.26145,72.26145,0,0,0,16,127.7998c-.10547,38.81739,31.36035,71.19629,70.14453,72.17676A71.65658,71.65658,0,0,0,120,192.49219V156.94434L76.42236,135.15527a7.99984,7.99984,0,1,1,7.15528-14.31054L120,139.05566V88a8,8,0,0,1,16,0v27.05566l36.42236-18.21093a7.99984,7.99984,0,1,1,7.15528,14.31054L136,132.94434V192.4917A71.52878,71.52878,0,0,0,167.99707,200q.92871,0,1.86035-.02344c38.78418-.98144,70.25-33.36133,70.14258-72.18066A72.26158,72.26158,0,0,0,198.10059,62.5957Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "232",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "152",
      "x2": "80",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "176",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M132.476,181.2265a63.99546,63.99546,0,1,0,62.27163-111.367A7.98712,7.98712,0,0,1,190.7243,65.693a68.02876,68.02876,0,0,0-125.44861,0,7.98711,7.98711,0,0,1-4.02328,4.16655,63.99621,63.99621,0,1,0,62.27159,111.367A8.03193,8.03193,0,0,1,132.476,181.2265Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "232",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "152",
      "x2": "80",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "176",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M132.476,181.2265a63.99546,63.99546,0,1,0,62.27163-111.367A7.98712,7.98712,0,0,1,190.7243,65.693a68.02876,68.02876,0,0,0-125.44861,0,7.98711,7.98711,0,0,1-4.02328,4.16655,63.99621,63.99621,0,1,0,62.27159,111.367A8.03193,8.03193,0,0,1,132.476,181.2265Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "232",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "152",
      "x2": "80",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "176",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M132.476,181.2265a63.99546,63.99546,0,1,0,62.27163-111.367A7.98712,7.98712,0,0,1,190.7243,65.693a68.02876,68.02876,0,0,0-125.44861,0,7.98711,7.98711,0,0,1-4.02328,4.16655,63.99621,63.99621,0,1,0,62.27159,111.367A8.03193,8.03193,0,0,1,132.476,181.2265Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$d5 = [];
/* style */

const __vue_inject_styles__$d5 = undefined;
/* scoped */

const __vue_scope_id__$d5 = undefined;
/* module identifier */

const __vue_module_identifier__$d5 = undefined;
/* functional template */

const __vue_is_functional_template__$d5 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$d5 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$d5,
  staticRenderFns: __vue_staticRenderFns__$d5
}, __vue_inject_styles__$d5, __vue_script__$d5, __vue_scope_id__$d5, __vue_is_functional_template__$d5, __vue_module_identifier__$d5, false, undefined, undefined, undefined);

var script$d6 = Vue.extend({
  name: "PhTreeEvergreen",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$d6 = script$d6;
/* template */

var __vue_render__$d6 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "128 16 48 120 88 120 32 192 224 192 168 120 208 120 128 16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "192",
      "x2": "128",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "128 16 48 120 88 120 32 192 224 192 168 120 208 120 128 16",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "128 16 48 120 88 120 32 192 224 192 168 120 208 120 128 16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "192",
      "x2": "128",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M231.18652,195.51465A7.9997,7.9997,0,0,1,224,200H136v40a8,8,0,0,1-16,0V200H32a7.99958,7.99958,0,0,1-6.31445-12.91113L71.64258,128H48a8.00019,8.00019,0,0,1-6.34082-12.87793l80-104a8,8,0,0,1,12.68164,0l80,104A8.00019,8.00019,0,0,1,208,128H184.35742l45.957,59.08887A7.99813,7.99813,0,0,1,231.18652,195.51465Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "128 16 48 120 88 120 32 192 224 192 168 120 208 120 128 16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "192",
      "x2": "128",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "128 16 48 120 88 120 32 192 224 192 168 120 208 120 128 16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "192",
      "x2": "128",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "128 16 48 120 88 120 32 192 224 192 168 120 208 120 128 16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "192",
      "x2": "128",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$d6 = [];
/* style */

const __vue_inject_styles__$d6 = undefined;
/* scoped */

const __vue_scope_id__$d6 = undefined;
/* module identifier */

const __vue_module_identifier__$d6 = undefined;
/* functional template */

const __vue_is_functional_template__$d6 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$d6 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$d6,
  staticRenderFns: __vue_staticRenderFns__$d6
}, __vue_inject_styles__$d6, __vue_script__$d6, __vue_scope_id__$d6, __vue_is_functional_template__$d6, __vue_module_identifier__$d6, false, undefined, undefined, undefined);

var script$d7 = Vue.extend({
  name: "PhTreeStructure",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$d7 = script$d7;
/* template */

var __vue_render__$d7 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "100",
      "width": "56",
      "height": "56",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "160",
      "y": "40",
      "width": "64",
      "height": "64",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "160",
      "y": "152",
      "width": "64",
      "height": "64",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "128",
      "x2": "120",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160,184H144a24,24,0,0,1-24-24V96a24,24,0,0,1,24-24h16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "100",
      "width": "56",
      "height": "56",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "160",
      "y": "40",
      "width": "64",
      "height": "64",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "160",
      "y": "152",
      "width": "64",
      "height": "64",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "24",
      "y": "100",
      "width": "56",
      "height": "56",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "160",
      "y": "40",
      "width": "64",
      "height": "64",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "160",
      "y": "152",
      "width": "64",
      "height": "64",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "128",
      "x2": "120",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160,184H144a24,24,0,0,1-24-24V96a24,24,0,0,1,24-24h16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M156,92V80H144a16.01833,16.01833,0,0,0-16,16v64a16.01833,16.01833,0,0,0,16,16h12V164a16.01833,16.01833,0,0,1,16-16h40a16.01833,16.01833,0,0,1,16,16v40a16.01833,16.01833,0,0,1-16,16H172a16.01833,16.01833,0,0,1-16-16V192H144a32.03635,32.03635,0,0,1-32-32V136H84v8a16.01833,16.01833,0,0,1-16,16H36a16.01833,16.01833,0,0,1-16-16V112A16.01833,16.01833,0,0,1,36,96H68a16.01833,16.01833,0,0,1,16,16v8h28V96a32.03635,32.03635,0,0,1,32-32h12V52a16.01833,16.01833,0,0,1,16-16h40a16.01833,16.01833,0,0,1,16,16V92a16.01833,16.01833,0,0,1-16,16H172A16.01833,16.01833,0,0,1,156,92Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "100",
      "width": "56",
      "height": "56",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "160",
      "y": "40",
      "width": "64",
      "height": "64",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "160",
      "y": "152",
      "width": "64",
      "height": "64",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "128",
      "x2": "120",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160,184H144a24,24,0,0,1-24-24V96a24,24,0,0,1,24-24h16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "100",
      "width": "56",
      "height": "56",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "160",
      "y": "40",
      "width": "64",
      "height": "64",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "160",
      "y": "152",
      "width": "64",
      "height": "64",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "128",
      "x2": "120",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160,184H144a24,24,0,0,1-24-24V96a24,24,0,0,1,24-24h16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "100",
      "width": "56",
      "height": "56",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "160",
      "y": "40",
      "width": "64",
      "height": "64",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "160",
      "y": "152",
      "width": "64",
      "height": "64",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "128",
      "x2": "120",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160,184H144a24,24,0,0,1-24-24V96a24,24,0,0,1,24-24h16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$d7 = [];
/* style */

const __vue_inject_styles__$d7 = undefined;
/* scoped */

const __vue_scope_id__$d7 = undefined;
/* module identifier */

const __vue_module_identifier__$d7 = undefined;
/* functional template */

const __vue_is_functional_template__$d7 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$d7 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$d7,
  staticRenderFns: __vue_staticRenderFns__$d7
}, __vue_inject_styles__$d7, __vue_script__$d7, __vue_scope_id__$d7, __vue_is_functional_template__$d7, __vue_module_identifier__$d7, false, undefined, undefined, undefined);

var script$d8 = Vue.extend({
  name: "PhTrendDown",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$d8 = script$d8;
/* template */

var __vue_render__$d8 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "232.002 200 136.002 104 96.002 144 24.002 72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "232.002 136 232.002 200 168.002 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "232.002 200 136.002 104 96.002 144 24.002 72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "232.002 136 232.002 200 168.002 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M240.00244,136v64a8.00008,8.00008,0,0,1-8,8h-64a8.00038,8.00038,0,0,1-5.65723-13.65674L188.68848,168l-52.686-52.686-34.34277,34.34278a8.00122,8.00122,0,0,1-11.31446,0l-72-72A8.00018,8.00018,0,1,1,29.65967,66.34326L96.00244,132.686l34.34277-34.34278a8.00122,8.00122,0,0,1,11.31446,0L200.00244,156.686l26.34277-26.34278A8.0001,8.0001,0,0,1,240.00244,136Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "232.002 200 136.002 104 96.002 144 24.002 72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "232.002 136 232.002 200 168.002 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "232.002 200 136.002 104 96.002 144 24.002 72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "232.002 136 232.002 200 168.002 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "232.002 200 136.002 104 96.002 144 24.002 72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "232.002 136 232.002 200 168.002 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$d8 = [];
/* style */

const __vue_inject_styles__$d8 = undefined;
/* scoped */

const __vue_scope_id__$d8 = undefined;
/* module identifier */

const __vue_module_identifier__$d8 = undefined;
/* functional template */

const __vue_is_functional_template__$d8 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$d8 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$d8,
  staticRenderFns: __vue_staticRenderFns__$d8
}, __vue_inject_styles__$d8, __vue_script__$d8, __vue_scope_id__$d8, __vue_is_functional_template__$d8, __vue_module_identifier__$d8, false, undefined, undefined, undefined);

var script$d9 = Vue.extend({
  name: "PhTrendUp",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$d9 = script$d9;
/* template */

var __vue_render__$d9 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "232.002 56 136.002 152 96.002 112 24.002 184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "232.002 120 232.002 56 168.002 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "232.002 56 136.002 152 96.002 112 24.002 184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "232.002 120 232.002 56 168.002 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M240.00244,56v64a8.00018,8.00018,0,0,1-13.65723,5.65674L200.00244,99.314l-58.34277,58.34278a8.00122,8.00122,0,0,1-11.31446,0L96.00244,123.314,29.65967,189.65674a8.00018,8.00018,0,0,1-11.31446-11.31348l72-72a8.00122,8.00122,0,0,1,11.31446,0L136.00244,140.686,188.68848,88,162.34521,61.65674A8.00038,8.00038,0,0,1,168.00244,48h64A8.00008,8.00008,0,0,1,240.00244,56Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "232.002 56 136.002 152 96.002 112 24.002 184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "232.002 120 232.002 56 168.002 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "232.002 56 136.002 152 96.002 112 24.002 184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "232.002 120 232.002 56 168.002 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "232.002 56 136.002 152 96.002 112 24.002 184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "232.002 120 232.002 56 168.002 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$d9 = [];
/* style */

const __vue_inject_styles__$d9 = undefined;
/* scoped */

const __vue_scope_id__$d9 = undefined;
/* module identifier */

const __vue_module_identifier__$d9 = undefined;
/* functional template */

const __vue_is_functional_template__$d9 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$d9 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$d9,
  staticRenderFns: __vue_staticRenderFns__$d9
}, __vue_inject_styles__$d9, __vue_script__$d9, __vue_scope_id__$d9, __vue_is_functional_template__$d9, __vue_module_identifier__$d9, false, undefined, undefined, undefined);

var script$da = Vue.extend({
  name: "PhTriangle",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$da = script$da;
/* template */

var __vue_render__$da = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M114.15243,39.98472,26.17616,191.977a16.00005,16.00005,0,0,0,13.84762,24.01535H215.97625A16,16,0,0,0,229.82386,191.977L141.84757,39.98472A16,16,0,0,0,114.15243,39.98472Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M114.15243,39.98472,26.17616,191.977a16.00005,16.00005,0,0,0,13.84762,24.01535H215.97625A16,16,0,0,0,229.82386,191.977L141.84757,39.98472A16,16,0,0,0,114.15243,39.98472Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M114.15243,39.98472,26.17616,191.977a16.00005,16.00005,0,0,0,13.84762,24.01535H215.97625A16,16,0,0,0,229.82386,191.977L141.84757,39.98472A16,16,0,0,0,114.15243,39.98472Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M236.74219,187.96875,148.77344,35.97656a24.00413,24.00413,0,0,0-41.54688,0h.00781L19.25781,187.96875a23.9925,23.9925,0,0,0,20.76563,36.02344H215.97656a23.9925,23.9925,0,0,0,20.76563-36.02344Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M114.15243,39.98472,26.17616,191.977a16.00005,16.00005,0,0,0,13.84762,24.01535H215.97625A16,16,0,0,0,229.82386,191.977L141.84757,39.98472A16,16,0,0,0,114.15243,39.98472Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M114.15243,39.98472,26.17616,191.977a16.00005,16.00005,0,0,0,13.84762,24.01535H215.97625A16,16,0,0,0,229.82386,191.977L141.84757,39.98472A16,16,0,0,0,114.15243,39.98472Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M114.15243,39.98472,26.17616,191.977a16.00005,16.00005,0,0,0,13.84762,24.01535H215.97625A16,16,0,0,0,229.82386,191.977L141.84757,39.98472A16,16,0,0,0,114.15243,39.98472Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$da = [];
/* style */

const __vue_inject_styles__$da = undefined;
/* scoped */

const __vue_scope_id__$da = undefined;
/* module identifier */

const __vue_module_identifier__$da = undefined;
/* functional template */

const __vue_is_functional_template__$da = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$da = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$da,
  staticRenderFns: __vue_staticRenderFns__$da
}, __vue_inject_styles__$da, __vue_script__$da, __vue_scope_id__$da, __vue_is_functional_template__$da, __vue_module_identifier__$da, false, undefined, undefined, undefined);

var script$db = Vue.extend({
  name: "PhTrophy",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$db = script$db;
/* template */

var __vue_render__$db = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56,56v55.09613c0,39.70052,31.75464,72.60753,71.45407,72.90185A72.00008,72.00008,0,0,0,200,112V56a8,8,0,0,0-8-8H64A8,8,0,0,0,56,56Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "224",
      "x2": "160",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "184",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M198.21561,128H208a32,32,0,0,0,32-32V80a8,8,0,0,0-8-8H200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M57.964,128H47.87289a32,32,0,0,1-32-32V80a8,8,0,0,1,8-8h32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56,56v55.09613c0,39.70052,31.75464,72.60753,71.45407,72.90185A72.00008,72.00008,0,0,0,200,112V56a8,8,0,0,0-8-8H64A8,8,0,0,0,56,56Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,56v55.09613c0,39.70052,31.75464,72.60753,71.45407,72.90185A72.00008,72.00008,0,0,0,200,112V56a8,8,0,0,0-8-8H64A8,8,0,0,0,56,56Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "224",
      "x2": "160",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "184",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M198.21561,128H208a32,32,0,0,0,32-32V80a8,8,0,0,0-8-8H200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M57.964,128H47.87289a32,32,0,0,1-32-32V80a8,8,0,0,1,8-8h32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232,64H208V56a16.01833,16.01833,0,0,0-16-16H64A16.01833,16.01833,0,0,0,48,56v8H23.87305a16.01833,16.01833,0,0,0-16,16V96a40.04583,40.04583,0,0,0,40,40H51.917c9.64258,29.93658,36.14258,52.34668,68.083,55.58276V216H96a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16H136V191.60626A80.12,80.12,0,0,0,204.34521,136H208a40.04584,40.04584,0,0,0,40-40V80A16.01833,16.01833,0,0,0,232,64ZM47.87305,120a24.0275,24.0275,0,0,1-24-24V80H48v31.0957A81.777,81.777,0,0,0,48.499,120ZM232,96a24.0275,24.0275,0,0,1-24,24h-.39209q.39037-3.96176.39209-8V80h24Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56,56v55.09613c0,39.70052,31.75464,72.60753,71.45407,72.90185A72.00008,72.00008,0,0,0,200,112V56a8,8,0,0,0-8-8H64A8,8,0,0,0,56,56Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "224",
      "x2": "160",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "184",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M198.21561,128H208a32,32,0,0,0,32-32V80a8,8,0,0,0-8-8H200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M57.964,128H47.87289a32,32,0,0,1-32-32V80a8,8,0,0,1,8-8h32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56,56v55.09613c0,39.70052,31.75464,72.60753,71.45407,72.90185A72.00008,72.00008,0,0,0,200,112V56a8,8,0,0,0-8-8H64A8,8,0,0,0,56,56Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "224",
      "x2": "160",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "184",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M198.21561,128H208a32,32,0,0,0,32-32V80a8,8,0,0,0-8-8H200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M57.964,128H47.87289a32,32,0,0,1-32-32V80a8,8,0,0,1,8-8h32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56,56v55.09613c0,39.70052,31.75464,72.60753,71.45407,72.90185A72.00008,72.00008,0,0,0,200,112V56a8,8,0,0,0-8-8H64A8,8,0,0,0,56,56Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "224",
      "x2": "160",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "184",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M198.21561,128H208a32,32,0,0,0,32-32V80a8,8,0,0,0-8-8H200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M57.964,128H47.87289a32,32,0,0,1-32-32V80a8,8,0,0,1,8-8h32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$db = [];
/* style */

const __vue_inject_styles__$db = undefined;
/* scoped */

const __vue_scope_id__$db = undefined;
/* module identifier */

const __vue_module_identifier__$db = undefined;
/* functional template */

const __vue_is_functional_template__$db = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$db = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$db,
  staticRenderFns: __vue_staticRenderFns__$db
}, __vue_inject_styles__$db, __vue_script__$db, __vue_scope_id__$db, __vue_is_functional_template__$db, __vue_module_identifier__$db, false, undefined, undefined, undefined);

var script$dc = Vue.extend({
  name: "PhTruck",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dc = script$dc;
/* template */

var __vue_render__$dc = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M240,120H176V80h42.58374a8,8,0,0,1,7.42781,5.02887Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "144",
      "x2": "176",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "192",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "76",
      "cy": "192",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "192",
      "x2": "100",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M52,192H24a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8H176V168.33192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,168.33192V120h64v64a8,8,0,0,1-8,8H204",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,144H16v40a8,8,0,0,0,8,8H44a24,24,0,0,1,48,0h72a23.99048,23.99048,0,0,1,11.99813-20.78815Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M212,192a24.00631,24.00631,0,0,0-36.00187-20.78815L176,120h64v64a8,8,0,0,1-8,8H212",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M240,120H176V80h42.58374a8,8,0,0,1,7.42781,5.02887Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "144",
      "x2": "176",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "192",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "192",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "164",
      "y1": "192",
      "x2": "92",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M44,192H24a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8H176V171.21508",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,171.21508V120h64v64a8,8,0,0,1-8,8H212",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M247.99682,119.94092c-.00073-.084-.00952-.168-.01269-.252-.00855-.22216-.02271-.44287-.04907-.66015-.01148-.09424-.02808-.188-.04322-.28223-.03393-.21631-.07568-.4292-.12695-.63965-.02051-.08447-.0415-.16845-.06494-.25293q-.10035-.36108-.23364-.708c-.0149-.03858-.02344-.07862-.03882-.11719l-.04956-.12354-.01075-.02734-13.928-34.82031A15.92368,15.92368,0,0,0,218.58374,72h-34.584V64a8.00039,8.00039,0,0,0-8-8h-152a16.01833,16.01833,0,0,0-16,16V184a16.01833,16.01833,0,0,0,16,16h13.0127a32.00444,32.00444,0,0,0,61.97461,0h58.02539a32.00444,32.00444,0,0,0,61.97461,0h13.01269a16.01833,16.01833,0,0,0,16-16V120C247.99975,119.98,247.99682,119.96094,247.99682,119.94092ZM183.99975,88h34.584l9.59961,24h-44.1836Zm-160-16h144v64h-144Zm44,136a16,16,0,1,1,16-16A16.01833,16.01833,0,0,1,67.99975,208Zm120,0a16,16,0,1,1,16-16A16.01833,16.01833,0,0,1,187.99975,208Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M240,120H176V80h42.58374a8,8,0,0,1,7.42781,5.02887Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "144",
      "x2": "176",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "192",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "192",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "164",
      "y1": "192",
      "x2": "92",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M44,192H24a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8H176V171.21508",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,171.21508V120h64v64a8,8,0,0,1-8,8H212",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M240,120H176V80h42.58374a8,8,0,0,1,7.42781,5.02887Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "144",
      "x2": "176",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "192",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "192",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "164",
      "y1": "192",
      "x2": "92",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M44,192H24a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8H176V171.21508",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,171.21508V120h64v64a8,8,0,0,1-8,8H212",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M240,120H176V80h42.58374a8,8,0,0,1,7.42781,5.02887Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "144",
      "x2": "176",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "192",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "192",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "164",
      "y1": "192",
      "x2": "92",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M44,192H24a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8H176V171.21508",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,171.21508V120h64v64a8,8,0,0,1-8,8H212",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dc = [];
/* style */

const __vue_inject_styles__$dc = undefined;
/* scoped */

const __vue_scope_id__$dc = undefined;
/* module identifier */

const __vue_module_identifier__$dc = undefined;
/* functional template */

const __vue_is_functional_template__$dc = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dc = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dc,
  staticRenderFns: __vue_staticRenderFns__$dc
}, __vue_inject_styles__$dc, __vue_script__$dc, __vue_scope_id__$dc, __vue_is_functional_template__$dc, __vue_module_identifier__$dc, false, undefined, undefined, undefined);

var script$dd = Vue.extend({
  name: "PhTwitchLogo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dd = script$dd;
/* template */

var __vue_render__$dd = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M165.1036,200H122.8964a8,8,0,0,0-5.12148,1.85423L72,240V200H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8V156.253a8,8,0,0,1-2.87852,6.14577l-42.89641,35.747A8,8,0,0,1,165.1036,200Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "88.00002",
      "x2": "168",
      "y2": "136.00002",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "88.00002",
      "x2": "120",
      "y2": "136.00002",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M165.1036,200H122.8964a8,8,0,0,0-5.12148,1.85423L72,240V200H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8V156.253a8,8,0,0,1-2.87852,6.14577l-42.89641,35.747A8,8,0,0,1,165.1036,200Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M165.1036,200H122.8964a8,8,0,0,0-5.12148,1.85423L72,240V200H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8V156.253a8,8,0,0,1-2.87852,6.14577l-42.89641,35.747A8,8,0,0,1,165.1036,200Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "88.00002",
      "x2": "168",
      "y2": "136.00002",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "88.00002",
      "x2": "120",
      "y2": "136.00002",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,32H48A16.01833,16.01833,0,0,0,32,48V192a16.01833,16.01833,0,0,0,16,16H64v32a7.99949,7.99949,0,0,0,13.12109,6.14551L122.89648,208h42.207a16.03033,16.03033,0,0,0,10.24316-3.709l42.896-35.7461A15.958,15.958,0,0,0,224,156.253V48A16.01833,16.01833,0,0,0,208,32ZM128,136a8,8,0,0,1-16,0V88a8,8,0,0,1,16,0Zm48,0a8,8,0,0,1-16,0V88a8,8,0,0,1,16,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M165.1036,200H122.8964a8,8,0,0,0-5.12148,1.85423L72,240V200H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8V156.253a8,8,0,0,1-2.87852,6.14577l-42.89641,35.747A8,8,0,0,1,165.1036,200Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "88.00002",
      "x2": "168",
      "y2": "136.00002",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "88.00002",
      "x2": "120",
      "y2": "136.00002",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M165.1036,200H122.8964a8,8,0,0,0-5.12148,1.85423L72,240V200H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8V156.253a8,8,0,0,1-2.87852,6.14577l-42.89641,35.747A8,8,0,0,1,165.1036,200Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "88.00002",
      "x2": "168",
      "y2": "136.00002",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "88.00002",
      "x2": "120",
      "y2": "136.00002",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M165.1036,200H122.8964a8,8,0,0,0-5.12148,1.85423L72,240V200H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8V156.253a8,8,0,0,1-2.87852,6.14577l-42.89641,35.747A8,8,0,0,1,165.1036,200Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "88.00002",
      "x2": "168",
      "y2": "136.00002",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "88.00002",
      "x2": "120",
      "y2": "136.00002",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dd = [];
/* style */

const __vue_inject_styles__$dd = undefined;
/* scoped */

const __vue_scope_id__$dd = undefined;
/* module identifier */

const __vue_module_identifier__$dd = undefined;
/* functional template */

const __vue_is_functional_template__$dd = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dd = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dd,
  staticRenderFns: __vue_staticRenderFns__$dd
}, __vue_inject_styles__$dd, __vue_script__$dd, __vue_scope_id__$dd, __vue_is_functional_template__$dd, __vue_module_identifier__$dd, false, undefined, undefined, undefined);

var script$de = Vue.extend({
  name: "PhTwitterLogo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$de = script$de;
/* template */

var __vue_render__$de = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,88.00288a40.00668,40.00668,0,0,1,76.67148-16.00327L240,72l-32.26239,32.2625A128.00746,128.00746,0,0,1,80,224c-32,0-40-12-40-12s32-12,48-36c0,0-64-32-48-120,0,0,40,40,87.9862,48Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,88.00288a40.00668,40.00668,0,0,1,76.67148-16.00327L240,72l-32.26239,32.2625A128.00746,128.00746,0,0,1,80,224c-32,0-40-12-40-12s32-12,48-36c0,0-64-32-48-120,0,0,40,40,87.9862,48Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,88.00288a40.00668,40.00668,0,0,1,76.67148-16.00327L240,72l-32.26239,32.2625A128.00746,128.00746,0,0,1,80,224c-32,0-40-12-40-12s32-12,48-36c0,0-64-32-48-120,0,0,40,40,87.9862,48Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M245.65723,77.65674l-30.16407,30.16455C209.4707,177.70215,150.53809,232,80,232c-14.52441,0-26.49414-2.30273-35.57764-6.84473-7.33056-3.665-10.33349-7.59912-11.07861-8.71777a8,8,0,0,1,3.84717-11.92822c.25732-.09717,23.84814-9.15772,39.09521-26.40869a109.574,109.574,0,0,1-24.72656-24.355c-13.708-18.60352-28.206-50.91114-19.43066-99.17676a8.00023,8.00023,0,0,1,13.52832-4.22559c.35254.35156,33.64209,33.1709,74.3374,43.772L120,87.99609a48.31863,48.31863,0,0,1,48.6084-47.99267,48.11329,48.11329,0,0,1,40.96875,23.99609L240,64a8.0001,8.0001,0,0,1,5.65723,13.65674Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,88.00288a40.00668,40.00668,0,0,1,76.67148-16.00327L240,72l-32.26239,32.2625A128.00746,128.00746,0,0,1,80,224c-32,0-40-12-40-12s32-12,48-36c0,0-64-32-48-120,0,0,40,40,87.9862,48Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,88.00288a40.00668,40.00668,0,0,1,76.67148-16.00327L240,72l-32.26239,32.2625A128.00746,128.00746,0,0,1,80,224c-32,0-40-12-40-12s32-12,48-36c0,0-64-32-48-120,0,0,40,40,87.9862,48Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,88.00288a40.00668,40.00668,0,0,1,76.67148-16.00327L240,72l-32.26239,32.2625A128.00746,128.00746,0,0,1,80,224c-32,0-40-12-40-12s32-12,48-36c0,0-64-32-48-120,0,0,40,40,87.9862,48Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$de = [];
/* style */

const __vue_inject_styles__$de = undefined;
/* scoped */

const __vue_scope_id__$de = undefined;
/* module identifier */

const __vue_module_identifier__$de = undefined;
/* functional template */

const __vue_is_functional_template__$de = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$de = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$de,
  staticRenderFns: __vue_staticRenderFns__$de
}, __vue_inject_styles__$de, __vue_script__$de, __vue_scope_id__$de, __vue_is_functional_template__$de, __vue_module_identifier__$de, false, undefined, undefined, undefined);

var script$df = Vue.extend({
  name: "PhUmbrella",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$df = script$df;
/* template */

var __vue_render__$df = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,200a24,24,0,0,1-48,0V136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32.33457,136a8.021,8.021,0,0,1-7.97506-8.70945,104.00633,104.00633,0,0,1,207.281,0A8.021,8.021,0,0,1,223.66543,136Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,136c0-72,40-104,40-104s40,32,40,104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,32a104.00963,104.00963,0,0,1,103.64049,95.29055A8.021,8.021,0,0,1,223.66543,136H168c0-72-40-104-40-104",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,32A104.00963,104.00963,0,0,0,24.35951,127.29055,8.021,8.021,0,0,0,32.33457,136H88c0-72,40-104,40-104",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,200a24,24,0,0,1-48,0V136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32.33457,136a8.021,8.021,0,0,1-7.97506-8.70945,104.00633,104.00633,0,0,1,207.281,0A8.021,8.021,0,0,1,223.66543,136Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,136c0-72,40-104,40-104s40,32,40,104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M239.61328,126.62988A112.0108,112.0108,0,0,0,128.00684,24h-.01368A112.0108,112.0108,0,0,0,16.38672,126.62988,16.02123,16.02123,0,0,0,32.33447,144H120v56a32,32,0,0,0,64,0,8,8,0,0,0-16,0,16,16,0,0,1-32,0V144h87.66553a16.02123,16.02123,0,0,0,15.94775-17.37012ZM32.332,127.95215a95.97942,95.97942,0,0,1,75.85645-85.874C96.47266,58.05713,81.84521,86.12988,80.16553,128H32.33447ZM175.83447,128c-1.67968-41.87012-16.30713-69.94287-28.023-85.92188A95.96509,95.96509,0,0,1,223.66553,128Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,200a24,24,0,0,1-48,0V136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32.33457,136a8.021,8.021,0,0,1-7.97506-8.70945,104.00633,104.00633,0,0,1,207.281,0A8.021,8.021,0,0,1,223.66543,136Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,136c0-72,40-104,40-104s40,32,40,104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,200a24,24,0,0,1-48,0V136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32.33457,136a8.021,8.021,0,0,1-7.97506-8.70945,104.00633,104.00633,0,0,1,207.281,0A8.021,8.021,0,0,1,223.66543,136Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,136c0-72,40-104,40-104s40,32,40,104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,200a24,24,0,0,1-48,0V136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32.33457,136a8.021,8.021,0,0,1-7.97506-8.70945,104.00633,104.00633,0,0,1,207.281,0A8.021,8.021,0,0,1,223.66543,136Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,136c0-72,40-104,40-104s40,32,40,104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$df = [];
/* style */

const __vue_inject_styles__$df = undefined;
/* scoped */

const __vue_scope_id__$df = undefined;
/* module identifier */

const __vue_module_identifier__$df = undefined;
/* functional template */

const __vue_is_functional_template__$df = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$df = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$df,
  staticRenderFns: __vue_staticRenderFns__$df
}, __vue_inject_styles__$df, __vue_script__$df, __vue_scope_id__$df, __vue_is_functional_template__$df, __vue_module_identifier__$df, false, undefined, undefined, undefined);

var script$dg = Vue.extend({
  name: "PhUmbrellaSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dg = script$dg;
/* template */

var __vue_render__$dg = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,200a24,24,0,0,1-48,0V136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32.33457,136a8.021,8.021,0,0,1-7.97506-8.70945,104.00633,104.00633,0,0,1,207.281,0A8.021,8.021,0,0,1,223.66543,136Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32.33457,136a8.021,8.021,0,0,1-7.97506-8.70945,104.00633,104.00633,0,0,1,207.281,0A8.021,8.021,0,0,1,223.66543,136Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,200a24,24,0,0,1-48,0V136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32.33457,136a8.021,8.021,0,0,1-7.97506-8.70945,104.00633,104.00633,0,0,1,207.281,0A8.021,8.021,0,0,1,223.66543,136Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M235.42676,138.83984A16.02871,16.02871,0,0,1,223.66553,144H136v56a16,16,0,0,0,32,0,8,8,0,0,1,16,0,32,32,0,0,1-64,0V144H32.33447a16.02123,16.02123,0,0,1-15.94775-17.37012,112.00665,112.00665,0,0,1,223.22656,0A16.11107,16.11107,0,0,1,235.42676,138.83984Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,200a24,24,0,0,1-48,0V136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32.33457,136a8.021,8.021,0,0,1-7.97506-8.70945,104.00633,104.00633,0,0,1,207.281,0A8.021,8.021,0,0,1,223.66543,136Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,200a24,24,0,0,1-48,0V136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32.33457,136a8.021,8.021,0,0,1-7.97506-8.70945,104.00633,104.00633,0,0,1,207.281,0A8.021,8.021,0,0,1,223.66543,136Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,200a24,24,0,0,1-48,0V136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32.33457,136a8.021,8.021,0,0,1-7.97506-8.70945,104.00633,104.00633,0,0,1,207.281,0A8.021,8.021,0,0,1,223.66543,136Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dg = [];
/* style */

const __vue_inject_styles__$dg = undefined;
/* scoped */

const __vue_scope_id__$dg = undefined;
/* module identifier */

const __vue_module_identifier__$dg = undefined;
/* functional template */

const __vue_is_functional_template__$dg = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dg = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dg,
  staticRenderFns: __vue_staticRenderFns__$dg
}, __vue_inject_styles__$dg, __vue_script__$dg, __vue_scope_id__$dg, __vue_is_functional_template__$dg, __vue_module_identifier__$dg, false, undefined, undefined, undefined);

var script$dh = Vue.extend({
  name: "PhUpload",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dh = script$dh;
/* template */

var __vue_render__$dh = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M172,128h52a8,8,0,0,1,8,8v64a8,8,0,0,1-8,8H32a8,8,0,0,1-8-8V136a8,8,0,0,1,8-8H84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 72 128 24 176 72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "168",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "128",
      "width": "208",
      "height": "80",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,128h48a8,8,0,0,1,8,8v64a8,8,0,0,1-8,8H32a8,8,0,0,1-8-8V136a8,8,0,0,1,8-8H80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 72 128 24 176 72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "168",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M85.65674,77.65723,120,43.31348V128a8,8,0,0,0,16,0V43.31348l34.34326,34.34375a8.00018,8.00018,0,0,0,11.31348-11.31446l-48-48c-.023-.02246-.04785-.0415-.0708-.064-.165-.16113-.33545-.31787-.51416-.46485-.09619-.07861-.19776-.14746-.29639-.22119-.11035-.08252-.21826-.168-.333-.24511-.11377-.07618-.23242-.14209-.34912-.21192-.10742-.06445-.2124-.13183-.32324-.19092-.11572-.062-.23535-.11425-.35352-.17041-.11865-.05615-.23584-.11523-.35742-.166-.11181-.0459-.22558-.083-.33887-.12354-.1333-.04834-.26513-.09961-.40185-.14062-.10889-.0332-.21973-.05664-.33008-.085-.14258-.03662-.28369-.07617-.42969-.105-.12109-.02393-.24365-.0376-.36523-.05567-.13623-.0205-.271-.04541-.40918-.05908-.20215-.01953-.40479-.02637-.60742-.03076C128.11768,16.00781,128.05957,16,128,16s-.11768.00781-.17676.00879c-.20263.00439-.40527.01123-.60742.03076-.13818.01367-.27295.03858-.40918.05908-.12158.01807-.24414.03174-.36523.05567-.146.02881-.28711.06836-.42969.105-.11035.02832-.22119.05176-.33008.085-.13672.041-.26855.09228-.40185.14062-.11329.04053-.22706.07764-.33887.12354-.12158.05078-.23877.10986-.35742.166-.11817.05616-.2378.1084-.35352.17041-.11084.05909-.21582.12647-.32324.19092-.1167.06983-.23535.13574-.34912.21192-.11475.07714-.22266.16259-.333.24511-.09863.07373-.2002.14258-.29639.22119-.17578.14454-.34277.29834-.50537.457-.02588.0249-.0542.04638-.07959.07177l-48,48A8.00018,8.00018,0,0,0,85.65674,77.65723Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,120H152v8a24,24,0,0,1-48,0v-8H32a16.01833,16.01833,0,0,0-16,16v64a16.01833,16.01833,0,0,0,16,16H224a16.01833,16.01833,0,0,0,16-16V136A16.01833,16.01833,0,0,0,224,120Zm-35.99951,60a12,12,0,1,1,12-12A12,12,0,0,1,188.00049,180Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,128h48a8,8,0,0,1,8,8v64a8,8,0,0,1-8,8H32a8,8,0,0,1-8-8V136a8,8,0,0,1,8-8H80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 72 128 24 176 72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "168",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,128h48a8,8,0,0,1,8,8v64a8,8,0,0,1-8,8H32a8,8,0,0,1-8-8V136a8,8,0,0,1,8-8H80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 72 128 24 176 72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "168",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,128h48a8,8,0,0,1,8,8v64a8,8,0,0,1-8,8H32a8,8,0,0,1-8-8V136a8,8,0,0,1,8-8H80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 72 128 24 176 72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "168",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dh = [];
/* style */

const __vue_inject_styles__$dh = undefined;
/* scoped */

const __vue_scope_id__$dh = undefined;
/* module identifier */

const __vue_module_identifier__$dh = undefined;
/* functional template */

const __vue_is_functional_template__$dh = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dh = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dh,
  staticRenderFns: __vue_staticRenderFns__$dh
}, __vue_inject_styles__$dh, __vue_script__$dh, __vue_scope_id__$dh, __vue_is_functional_template__$dh, __vue_module_identifier__$dh, false, undefined, undefined, undefined);

var script$di = Vue.extend({
  name: "PhUploadSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$di = script$di;
/* template */

var __vue_render__$di = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "86 81.989 128 40 170 81.989",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "152",
      "x2": "128",
      "y2": "40.02943",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,152v56a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "86 81.989 128 40 170 81.989",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "152",
      "x2": "128",
      "y2": "40.02943",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,152v56a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M78.60889,85.0498A7.99881,7.99881,0,0,1,80.34375,76.332l42-41.98926a8.00063,8.00063,0,0,1,11.3125,0l42,41.98926A8,8,0,0,1,170,89.98926H136V152a8,8,0,0,1-16,0V89.98926H86A7.999,7.999,0,0,1,78.60889,85.0498ZM216,144a8.00039,8.00039,0,0,0-8,8v56H48V152a8,8,0,0,0-16,0v56a16.01833,16.01833,0,0,0,16,16H208a16.01833,16.01833,0,0,0,16-16V152A8.00039,8.00039,0,0,0,216,144Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "86 81.989 128 40 170 81.989",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "152",
      "x2": "128",
      "y2": "40.02943",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,152v56a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "86 81.989 128 40 170 81.989",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "152",
      "x2": "128",
      "y2": "40.02943",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,152v56a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "86 81.989 128 40 170 81.989",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "152",
      "x2": "128",
      "y2": "40.02943",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,152v56a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$di = [];
/* style */

const __vue_inject_styles__$di = undefined;
/* scoped */

const __vue_scope_id__$di = undefined;
/* module identifier */

const __vue_module_identifier__$di = undefined;
/* functional template */

const __vue_is_functional_template__$di = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$di = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$di,
  staticRenderFns: __vue_staticRenderFns__$di
}, __vue_inject_styles__$di, __vue_script__$di, __vue_scope_id__$di, __vue_is_functional_template__$di, __vue_module_identifier__$di, false, undefined, undefined, undefined);

var script$dj = Vue.extend({
  name: "PhUser",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dj = script$dj;
/* template */

var __vue_render__$dj = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "96",
      "r": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M30.989,215.99064a112.03731,112.03731,0,0,1,194.02311.002",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "96",
      "r": "64",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "96",
      "r": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M30.989,215.99064a112.03731,112.03731,0,0,1,194.02311.002",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M231.93652,211.98633a120.48718,120.48718,0,0,0-67.12-54.14258,72.00007,72.00007,0,1,0-73.63294,0,120.48813,120.48813,0,0,0-67.11865,54.14062,7.99981,7.99981,0,0,0,6.92432,12.00635l194.023.002a7.99957,7.99957,0,0,0,6.92431-12.00635Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "96",
      "r": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M30.989,215.99064a112.03731,112.03731,0,0,1,194.02311.002",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "96",
      "r": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M30.989,215.99064a112.03731,112.03731,0,0,1,194.02311.002",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "96",
      "r": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M30.989,215.99064a112.03731,112.03731,0,0,1,194.02311.002",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dj = [];
/* style */

const __vue_inject_styles__$dj = undefined;
/* scoped */

const __vue_scope_id__$dj = undefined;
/* module identifier */

const __vue_module_identifier__$dj = undefined;
/* functional template */

const __vue_is_functional_template__$dj = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dj = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dj,
  staticRenderFns: __vue_staticRenderFns__$dj
}, __vue_inject_styles__$dj, __vue_script__$dj, __vue_scope_id__$dj, __vue_is_functional_template__$dj, __vue_module_identifier__$dj, false, undefined, undefined, undefined);

var script$dk = Vue.extend({
  name: "PhUserCircle",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dk = script$dk;
/* template */

var __vue_render__$dk = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M63.79905,199.37405a72.02812,72.02812,0,0,1,128.40177-.00026",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,32A96.00088,96.00088,0,0,0,63.79883,199.375v-.001A71.99731,71.99731,0,0,1,128,160a40,40,0,1,1,40-40,40.0001,40.0001,0,0,1-40,40,71.99731,71.99731,0,0,1,64.20117,39.374A96.0002,96.0002,0,0,0,128,32Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M63.79905,199.37405a72.02812,72.02812,0,0,1,128.40177-.00026",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "44"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.11791,104.11791,0,0,0,128,24Zm65.75806,162.41016a79.70266,79.70266,0,0,0-24.43091-22.97461,59.83641,59.83641,0,0,1-82.6543,0A79.7048,79.7048,0,0,0,62.2417,186.41016a88.00015,88.00015,0,1,1,131.51636,0Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M63.79905,199.37405a72.02812,72.02812,0,0,1,128.40177-.00026",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M63.79905,199.37405a72.02812,72.02812,0,0,1,128.40177-.00026",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M63.79905,199.37405a72.02812,72.02812,0,0,1,128.40177-.00026",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dk = [];
/* style */

const __vue_inject_styles__$dk = undefined;
/* scoped */

const __vue_scope_id__$dk = undefined;
/* module identifier */

const __vue_module_identifier__$dk = undefined;
/* functional template */

const __vue_is_functional_template__$dk = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dk = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dk,
  staticRenderFns: __vue_staticRenderFns__$dk
}, __vue_inject_styles__$dk, __vue_script__$dk, __vue_scope_id__$dk, __vue_is_functional_template__$dk, __vue_module_identifier__$dk, false, undefined, undefined, undefined);

var script$dl = Vue.extend({
  name: "PhUserCircleGear",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dl = script$dl;
/* template */

var __vue_render__$dl = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M63.79905,199.37405a72.02812,72.02812,0,0,1,128.40177-.00026",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "56",
      "x2": "200",
      "y2": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "56",
      "x2": "180.97887",
      "y2": "49.81966",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "56",
      "x2": "188.24429",
      "y2": "72.18034",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "56",
      "x2": "211.75571",
      "y2": "72.18034",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "56",
      "x2": "219.02113",
      "y2": "49.81966",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M223.31831,116.5001A96.987,96.987,0,0,1,224,128a96,96,0,1,1-96-96q4.50554,0,8.90843.40785",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M205.30634,71.08008A15.965,15.965,0,0,1,184.92,50.6936,96.001,96.001,0,0,0,63.79883,199.375v-.001A71.99731,71.99731,0,0,1,128,160a40,40,0,1,1,40-40,40.0001,40.0001,0,0,1-40,40,71.99731,71.99731,0,0,1,64.20117,39.374A96.002,96.002,0,0,0,205.30634,71.08008Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M63.79905,199.37405a72.02812,72.02812,0,0,1,128.40177-.00026",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "200",
      "cy": "56",
      "r": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "40",
      "x2": "200",
      "y2": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "186.14359",
      "y1": "48",
      "x2": "175.75129",
      "y2": "42",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "186.14359",
      "y1": "64",
      "x2": "175.75129",
      "y2": "70",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "72",
      "x2": "200",
      "y2": "84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "213.85641",
      "y1": "64",
      "x2": "224.24871",
      "y2": "70",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "213.85641",
      "y1": "48",
      "x2": "224.24871",
      "y2": "42",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M223.31831,116.5001A96.987,96.987,0,0,1,224,128a96,96,0,1,1-96-96q4.50554,0,8.90843.40785",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,76a44,44,0,1,1-44,44A44,44,0,0,1,128,76Zm103.17676-2a7.99671,7.99671,0,0,1-10.92822,2.92822l-4.66822-2.69531A24.0036,24.0036,0,0,1,208,78.624V84a8,8,0,0,1-16,0V78.624a24.0036,24.0036,0,0,1-7.58032-4.39111l-4.66822,2.69531a8,8,0,0,1-8-13.85644l4.65687-2.68872a23.72829,23.72829,0,0,1,0-8.76612l-4.65687-2.68872a8,8,0,0,1,8-13.85644l4.66822,2.69531A24.0036,24.0036,0,0,1,192,33.376V28a8,8,0,0,1,16,0v5.376a24.0036,24.0036,0,0,1,7.58032,4.39111l4.66822-2.69531a8,8,0,1,1,8,13.85644l-4.65687,2.68872a23.72829,23.72829,0,0,1,0,8.76612l4.65687,2.68872A8.00037,8.00037,0,0,1,231.17676,74ZM200,64a8,8,0,1,0-8-8A8.00917,8.00917,0,0,0,200,64Zm22.37012,44.5564a7.99991,7.99991,0,0,0-6.99512,8.89209A89.40475,89.40475,0,0,1,216,128a87.63852,87.63852,0,0,1-22.24194,58.41064,79.70677,79.70677,0,0,0-24.431-22.97485,59.83657,59.83657,0,0,1-82.65418-.00024A79.7048,79.7048,0,0,0,62.2417,186.41016,87.9498,87.9498,0,0,1,128,40c2.72656,0,5.477.126,8.1748.37427a8.00012,8.00012,0,0,0,1.4668-15.93286C134.4585,24.14844,131.21436,24,128,24A103.95123,103.95123,0,0,0,57.81982,204.68091a7.93384,7.93384,0,0,0,1.32544,1.18921,103.78418,103.78418,0,0,0,137.71155-.002,7.935,7.935,0,0,0,1.31983-1.18383A103.74663,103.74663,0,0,0,232,128a105.40092,105.40092,0,0,0-.73828-12.44849A8,8,0,0,0,222.37012,108.5564Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M63.79905,199.37405a72.02812,72.02812,0,0,1,128.40177-.00026",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "200",
      "cy": "56",
      "r": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "40",
      "x2": "200",
      "y2": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "186.14359",
      "y1": "48",
      "x2": "175.75129",
      "y2": "42",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "186.14359",
      "y1": "64",
      "x2": "175.75129",
      "y2": "70",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "72",
      "x2": "200",
      "y2": "84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "213.85641",
      "y1": "64",
      "x2": "224.24871",
      "y2": "70",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "213.85641",
      "y1": "48",
      "x2": "224.24871",
      "y2": "42",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M223.31831,116.5001A96.987,96.987,0,0,1,224,128a96,96,0,1,1-96-96q4.50554,0,8.90843.40785",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M63.79905,199.37405a72.02812,72.02812,0,0,1,128.40177-.00026",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "200",
      "cy": "56",
      "r": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "40",
      "x2": "200",
      "y2": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "186.14359",
      "y1": "48",
      "x2": "175.75129",
      "y2": "42",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "186.14359",
      "y1": "64",
      "x2": "175.75129",
      "y2": "70",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "72",
      "x2": "200",
      "y2": "84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "213.85641",
      "y1": "64",
      "x2": "224.24871",
      "y2": "70",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "213.85641",
      "y1": "48",
      "x2": "224.24871",
      "y2": "42",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M223.31831,116.5001A96.987,96.987,0,0,1,224,128a96,96,0,1,1-96-96q4.50554,0,8.90843.40785",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M63.79905,199.37405a72.02812,72.02812,0,0,1,128.40177-.00026",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "200",
      "cy": "56",
      "r": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "40",
      "x2": "200",
      "y2": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "186.14359",
      "y1": "48",
      "x2": "175.75129",
      "y2": "42",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "186.14359",
      "y1": "64",
      "x2": "175.75129",
      "y2": "70",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "72",
      "x2": "200",
      "y2": "84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "213.85641",
      "y1": "64",
      "x2": "224.24871",
      "y2": "70",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "213.85641",
      "y1": "48",
      "x2": "224.24871",
      "y2": "42",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M223.31831,116.5001A96.987,96.987,0,0,1,224,128a96,96,0,1,1-96-96q4.50554,0,8.90843.40785",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dl = [];
/* style */

const __vue_inject_styles__$dl = undefined;
/* scoped */

const __vue_scope_id__$dl = undefined;
/* module identifier */

const __vue_module_identifier__$dl = undefined;
/* functional template */

const __vue_is_functional_template__$dl = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dl = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dl,
  staticRenderFns: __vue_staticRenderFns__$dl
}, __vue_inject_styles__$dl, __vue_script__$dl, __vue_scope_id__$dl, __vue_is_functional_template__$dl, __vue_module_identifier__$dl, false, undefined, undefined, undefined);

var script$dm = Vue.extend({
  name: "PhUserCircleMinus",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dm = script$dm;
/* template */

var __vue_render__$dm = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M63.79905,199.37405a72.02812,72.02812,0,0,1,128.40177-.00026",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "56",
      "x2": "224",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M218.5374,96A95.90174,95.90174,0,1,1,143.13974,33.187",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,32A96.00088,96.00088,0,0,0,63.79883,199.375v-.001A71.99731,71.99731,0,0,1,128,160a40,40,0,1,1,40-40,40.0001,40.0001,0,0,1-40,40,71.99731,71.99731,0,0,1,64.20117,39.374A96.0002,96.0002,0,0,0,128,32Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M63.79905,199.37405a72.02812,72.02812,0,0,1,128.40177-.00026",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "56",
      "x2": "224",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M218.5374,96A95.90174,95.90174,0,1,1,143.13974,33.187",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,76a44,44,0,1,1-44,44A43.99983,43.99983,0,0,1,128,76Zm48-12h48a8,8,0,0,0,0-16H176a8,8,0,0,0,0,16Zm39.87158,24.457a8.00076,8.00076,0,0,0-4.87695,10.209,88.016,88.016,0,0,1-17.23645,87.74414,79.7044,79.7044,0,0,0-24.431-22.97461,59.83641,59.83641,0,0,1-82.6543,0A79.70345,79.70345,0,0,0,62.2417,186.41016,87.9498,87.9498,0,0,1,128,40a89.04252,89.04252,0,0,1,13.8877,1.08838,7.99994,7.99994,0,0,0,2.5039-15.80274A104.08275,104.08275,0,0,0,24,128a103.74716,103.74716,0,0,0,33.81934,76.68066,7.94507,7.94507,0,0,0,1.32629,1.18946,103.784,103.784,0,0,0,137.71252-.00293,7.94633,7.94633,0,0,0,1.31678-1.18115A104.0138,104.0138,0,0,0,226.08008,93.334,8.00062,8.00062,0,0,0,215.87158,88.457Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M63.79905,199.37405a72.02812,72.02812,0,0,1,128.40177-.00026",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "56",
      "x2": "224",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M218.5374,96A95.90174,95.90174,0,1,1,143.13974,33.187",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M63.79905,199.37405a72.02812,72.02812,0,0,1,128.40177-.00026",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "56",
      "x2": "224",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M218.5374,96A95.90174,95.90174,0,1,1,143.13974,33.187",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M63.79905,199.37405a72.02812,72.02812,0,0,1,128.40177-.00026",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "56",
      "x2": "224",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M218.5374,96A95.90174,95.90174,0,1,1,143.13974,33.187",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dm = [];
/* style */

const __vue_inject_styles__$dm = undefined;
/* scoped */

const __vue_scope_id__$dm = undefined;
/* module identifier */

const __vue_module_identifier__$dm = undefined;
/* functional template */

const __vue_is_functional_template__$dm = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dm = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dm,
  staticRenderFns: __vue_staticRenderFns__$dm
}, __vue_inject_styles__$dm, __vue_script__$dm, __vue_scope_id__$dm, __vue_is_functional_template__$dm, __vue_module_identifier__$dm, false, undefined, undefined, undefined);

var script$dn = Vue.extend({
  name: "PhUserCirclePlus",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dn = script$dn;
/* template */

var __vue_render__$dn = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M63.79905,199.37405a72.02812,72.02812,0,0,1,128.40177-.00026",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "56",
      "x2": "224",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "32",
      "x2": "200",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M222.81257,112.85778a95.9029,95.9029,0,1,1-79.67019-79.67033",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,32A96.00088,96.00088,0,0,0,63.79883,199.375v-.001A71.99731,71.99731,0,0,1,128,160a40,40,0,1,1,40-40,40.0001,40.0001,0,0,1-40,40,71.99731,71.99731,0,0,1,64.20117,39.374A96.0002,96.0002,0,0,0,128,32Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M63.79905,199.37405a72.02812,72.02812,0,0,1,128.40177-.00026",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "56",
      "x2": "224",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "32",
      "x2": "200",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M222.81257,112.85778a95.9029,95.9029,0,1,1-79.67019-79.67033",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,76a44,44,0,1,1-44,44A43.99983,43.99983,0,0,1,128,76Zm48-12h16V80a8,8,0,0,0,16,0V64h16a8,8,0,0,0,0-16H208V32a8,8,0,0,0-16,0V48H176a8,8,0,0,0,0,16Zm45.56006,40.95605a8.00039,8.00039,0,0,0-6.64893,9.15381A89.00044,89.00044,0,0,1,216,128a87.63672,87.63672,0,0,1-22.24182,58.41016,79.7044,79.7044,0,0,0-24.431-22.97461,59.83641,59.83641,0,0,1-82.6543,0A79.70345,79.70345,0,0,0,62.2417,186.41016,87.9498,87.9498,0,0,1,128,40a89.02966,89.02966,0,0,1,13.89062,1.08887,7.99994,7.99994,0,1,0,2.50391-15.80274A104.0826,104.0826,0,0,0,24,128a103.74716,103.74716,0,0,0,33.81934,76.68066,7.94507,7.94507,0,0,0,1.32629,1.18946,103.784,103.784,0,0,0,137.71252-.00293,7.94633,7.94633,0,0,0,1.31678-1.18115A103.74751,103.74751,0,0,0,232,128a105.04749,105.04749,0,0,0-1.28613-16.39453A7.99752,7.99752,0,0,0,221.56006,104.95605Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M63.79905,199.37405a72.02812,72.02812,0,0,1,128.40177-.00026",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "56",
      "x2": "224",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "32",
      "x2": "200",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M222.81257,112.85778a95.9029,95.9029,0,1,1-79.67019-79.67033",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M63.79905,199.37405a72.02812,72.02812,0,0,1,128.40177-.00026",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "56",
      "x2": "224",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "32",
      "x2": "200",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M222.81257,112.85778a95.9029,95.9029,0,1,1-79.67019-79.67033",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M63.79905,199.37405a72.02812,72.02812,0,0,1,128.40177-.00026",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "56",
      "x2": "224",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "32",
      "x2": "200",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M222.81257,112.85778a95.9029,95.9029,0,1,1-79.67019-79.67033",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dn = [];
/* style */

const __vue_inject_styles__$dn = undefined;
/* scoped */

const __vue_scope_id__$dn = undefined;
/* module identifier */

const __vue_module_identifier__$dn = undefined;
/* functional template */

const __vue_is_functional_template__$dn = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dn = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dn,
  staticRenderFns: __vue_staticRenderFns__$dn
}, __vue_inject_styles__$dn, __vue_script__$dn, __vue_scope_id__$dn, __vue_is_functional_template__$dn, __vue_module_identifier__$dn, false, undefined, undefined, undefined);

var script$do = Vue.extend({
  name: "PhUserFocus",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$do = script$do;
/* template */

var __vue_render__$do = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M180,40h28a8,8,0,0,1,8,8V75.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M180,216h28a8,8,0,0,0,8-8V179.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76,216H48a8,8,0,0,1-8-8V179.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76,40H48a8,8,0,0,0-8,8V75.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "112",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M79.998,167.99792a60.00877,60.00877,0,0,1,96.004-.00225",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "112",
      "r": "32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M180,40h28a8,8,0,0,1,8,8V75.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M180,216h28a8,8,0,0,0,8-8V179.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76,216H48a8,8,0,0,1-8-8V179.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76,40H48a8,8,0,0,0-8,8V75.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "112",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M74.92057,175.99964a60.02261,60.02261,0,0,1,106.15892.00009",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,48V76a8,8,0,0,1-16,0V48H180a8,8,0,0,1,0-16h28A16.01833,16.01833,0,0,1,224,48Zm-8,124a8.00008,8.00008,0,0,0-8,8v28H180a8,8,0,0,0,0,16h28a16.01833,16.01833,0,0,0,16-16V180A8.00008,8.00008,0,0,0,216,172ZM76,208H48V180a8,8,0,0,0-16,0v28a16.01833,16.01833,0,0,0,16,16H76a8,8,0,0,0,0-16ZM40,84a8.00008,8.00008,0,0,0,8-8V48H76a8,8,0,0,0,0-16H48A16.01833,16.01833,0,0,0,32,48V76A8.00008,8.00008,0,0,0,40,84Zm61.06079,57.54077a67.94605,67.94605,0,0,0-33.21313,30.72095A7.99956,7.99956,0,0,0,74.92041,184H181.07959a7.99956,7.99956,0,0,0,7.07275-11.73828,67.94605,67.94605,0,0,0-33.21313-30.72095,40,40,0,1,0-53.87842,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M180,40h28a8,8,0,0,1,8,8V75.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M180,216h28a8,8,0,0,0,8-8V179.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76,216H48a8,8,0,0,1-8-8V179.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76,40H48a8,8,0,0,0-8,8V75.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "112",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M74.92057,175.99964a60.02261,60.02261,0,0,1,106.15892.00009",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M180,40h28a8,8,0,0,1,8,8V75.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M180,216h28a8,8,0,0,0,8-8V179.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76,216H48a8,8,0,0,1-8-8V179.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76,40H48a8,8,0,0,0-8,8V75.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "112",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M74.92057,175.99964a60.02261,60.02261,0,0,1,106.15892.00009",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M180,40h28a8,8,0,0,1,8,8V75.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M180,216h28a8,8,0,0,0,8-8V179.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76,216H48a8,8,0,0,1-8-8V179.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76,40H48a8,8,0,0,0-8,8V75.99963",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "112",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M74.92057,175.99964a60.02261,60.02261,0,0,1,106.15892.00009",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$do = [];
/* style */

const __vue_inject_styles__$do = undefined;
/* scoped */

const __vue_scope_id__$do = undefined;
/* module identifier */

const __vue_module_identifier__$do = undefined;
/* functional template */

const __vue_is_functional_template__$do = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$do = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$do,
  staticRenderFns: __vue_staticRenderFns__$do
}, __vue_inject_styles__$do, __vue_script__$do, __vue_scope_id__$do, __vue_is_functional_template__$do, __vue_module_identifier__$do, false, undefined, undefined, undefined);

var script$dp = Vue.extend({
  name: "PhUserGear",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dp = script$dp;
/* template */

var __vue_render__$dp = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "224",
      "y1": "136",
      "x2": "224",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "136",
      "x2": "204.97887",
      "y2": "129.81966",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "136",
      "x2": "212.24429",
      "y2": "152.18034",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "136",
      "x2": "235.75571",
      "y2": "152.18034",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "136",
      "x2": "243.02113",
      "y2": "129.81966",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "108",
      "cy": "100",
      "r": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M22.208,199.99785a112.00725,112.00725,0,0,1,171.58459.00066",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "108",
      "cy": "100",
      "r": "60",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "108",
      "cy": "100",
      "r": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M22.208,199.99785a112.00725,112.00725,0,0,1,171.58459.00066",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "220",
      "cy": "136",
      "r": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "220",
      "y1": "120",
      "x2": "220",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "206.14359",
      "y1": "128",
      "x2": "195.75129",
      "y2": "122",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "206.14359",
      "y1": "144",
      "x2": "195.75129",
      "y2": "150",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "220",
      "y1": "152",
      "x2": "220",
      "y2": "164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "233.85641",
      "y1": "144",
      "x2": "244.24871",
      "y2": "150",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "233.85641",
      "y1": "128",
      "x2": "244.24871",
      "y2": "122",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M199.91748,194.85156a8.00007,8.00007,0,0,1-6.125,13.14649H22.208a8.00007,8.00007,0,0,1-6.125-13.14649,119.8892,119.8892,0,0,1,55.77441-37.29339,68,68,0,1,1,72.28516,0A119.89061,119.89061,0,0,1,199.91748,194.85156ZM251.17676,154a7.99606,7.99606,0,0,1-10.92822,2.92822l-4.66822-2.69519A23.999,23.999,0,0,1,228,158.6239V164a8,8,0,0,1-16,0v-5.3761a23.999,23.999,0,0,1-7.58032-4.39087l-4.66822,2.69519a8,8,0,0,1-8-13.85644l4.65674-2.68866a23.73636,23.73636,0,0,1,0-8.76624l-4.65674-2.68866a8,8,0,1,1,8-13.85644l4.66822,2.69519A23.999,23.999,0,0,1,212,113.3761V108a8,8,0,0,1,16,0v5.3761a23.999,23.999,0,0,1,7.58032,4.39087l4.66822-2.69519a8,8,0,1,1,8,13.85644l-4.65674,2.68866a23.73636,23.73636,0,0,1,0,8.76624l4.65674,2.68866A8.00032,8.00032,0,0,1,251.17676,154ZM220,144a8,8,0,1,0-8-8A8.00917,8.00917,0,0,0,220,144Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "108",
      "cy": "100",
      "r": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M22.208,199.99785a112.00725,112.00725,0,0,1,171.58459.00066",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "220",
      "cy": "136",
      "r": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "220",
      "y1": "120",
      "x2": "220",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "206.14359",
      "y1": "128",
      "x2": "195.75129",
      "y2": "122",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "206.14359",
      "y1": "144",
      "x2": "195.75129",
      "y2": "150",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "220",
      "y1": "152",
      "x2": "220",
      "y2": "164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "233.85641",
      "y1": "144",
      "x2": "244.24871",
      "y2": "150",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "233.85641",
      "y1": "128",
      "x2": "244.24871",
      "y2": "122",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "108",
      "cy": "100",
      "r": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M22.208,199.99785a112.00725,112.00725,0,0,1,171.58459.00066",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "220",
      "cy": "136",
      "r": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "220",
      "y1": "120",
      "x2": "220",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "206.14359",
      "y1": "128",
      "x2": "195.75129",
      "y2": "122",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "206.14359",
      "y1": "144",
      "x2": "195.75129",
      "y2": "150",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "220",
      "y1": "152",
      "x2": "220",
      "y2": "164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "233.85641",
      "y1": "144",
      "x2": "244.24871",
      "y2": "150",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "233.85641",
      "y1": "128",
      "x2": "244.24871",
      "y2": "122",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "108",
      "cy": "100",
      "r": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M22.208,199.99785a112.00725,112.00725,0,0,1,171.58459.00066",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "220",
      "cy": "136",
      "r": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "220",
      "y1": "120",
      "x2": "220",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "206.14359",
      "y1": "128",
      "x2": "195.75129",
      "y2": "122",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "206.14359",
      "y1": "144",
      "x2": "195.75129",
      "y2": "150",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "220",
      "y1": "152",
      "x2": "220",
      "y2": "164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "233.85641",
      "y1": "144",
      "x2": "244.24871",
      "y2": "150",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "233.85641",
      "y1": "128",
      "x2": "244.24871",
      "y2": "122",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dp = [];
/* style */

const __vue_inject_styles__$dp = undefined;
/* scoped */

const __vue_scope_id__$dp = undefined;
/* module identifier */

const __vue_module_identifier__$dp = undefined;
/* functional template */

const __vue_is_functional_template__$dp = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dp = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dp,
  staticRenderFns: __vue_staticRenderFns__$dp
}, __vue_inject_styles__$dp, __vue_script__$dp, __vue_scope_id__$dp, __vue_is_functional_template__$dp, __vue_module_identifier__$dp, false, undefined, undefined, undefined);

var script$dq = Vue.extend({
  name: "PhUserList",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dq = script$dq;
/* template */

var __vue_render__$dq = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "80",
      "cy": "104",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "80",
      "x2": "244",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "128",
      "x2": "244",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "176",
      "x2": "244",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M18.01628,192a64.02064,64.02064,0,0,1,123.96743,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "80",
      "cy": "104",
      "r": "40",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "80",
      "cy": "104",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "80",
      "x2": "248",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "128",
      "x2": "248",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "176",
      "x2": "248",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M18.01628,192a64.02064,64.02064,0,0,1,123.96743,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M144,80a8.00008,8.00008,0,0,1,8-8h96a8,8,0,0,1,0,16H152A8.00008,8.00008,0,0,1,144,80Zm104,40H152a8,8,0,0,0,0,16h96a8,8,0,0,0,0-16Zm0,48H176a8,8,0,0,0,0,16h72a8,8,0,0,0,0-16ZM109.11,142.13013a48,48,0,1,0-58.22,0,71.90424,71.90424,0,0,0-40.62146,47.87573A8,8,0,0,0,18.01611,200H141.98389a8,8,0,0,0,7.74756-9.99414A71.90424,71.90424,0,0,0,109.11,142.13013Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "80",
      "cy": "104",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "80",
      "x2": "248",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "128",
      "x2": "248",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "176",
      "x2": "248",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M18.01628,192a64.02064,64.02064,0,0,1,123.96743,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "80",
      "cy": "104",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "80",
      "x2": "248",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "128",
      "x2": "248",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "176",
      "x2": "248",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M18.01628,192a64.02064,64.02064,0,0,1,123.96743,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "80",
      "cy": "104",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "80",
      "x2": "248",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "128",
      "x2": "248",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "176",
      "x2": "248",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M18.01628,192a64.02064,64.02064,0,0,1,123.96743,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dq = [];
/* style */

const __vue_inject_styles__$dq = undefined;
/* scoped */

const __vue_scope_id__$dq = undefined;
/* module identifier */

const __vue_module_identifier__$dq = undefined;
/* functional template */

const __vue_is_functional_template__$dq = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dq = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dq,
  staticRenderFns: __vue_staticRenderFns__$dq
}, __vue_inject_styles__$dq, __vue_script__$dq, __vue_scope_id__$dq, __vue_is_functional_template__$dq, __vue_module_identifier__$dq, false, undefined, undefined, undefined);

var script$dr = Vue.extend({
  name: "PhUserMinus",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dr = script$dr;
/* template */

var __vue_render__$dr = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "204",
      "y1": "136",
      "x2": "244",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "108",
      "cy": "100",
      "r": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M22.208,199.99785a112.00725,112.00725,0,0,1,171.58459.00066",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "108",
      "cy": "100",
      "r": "60",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "136",
      "x2": "248",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "108",
      "cy": "100",
      "r": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M22.208,199.99785a112.00725,112.00725,0,0,1,171.58459.00066",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M256,136a7.99977,7.99977,0,0,1-8,8H200a8,8,0,0,1,0-16h48A7.99977,7.99977,0,0,1,256,136ZM144.1427,157.55811a68,68,0,1,0-72.2854,0,119.88787,119.88787,0,0,0-55.77478,37.29394,8.00012,8.00012,0,0,0,6.12549,13.146l171.58447.00049a8.00012,8.00012,0,0,0,6.12549-13.146A119.88993,119.88993,0,0,0,144.1427,157.55811Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "200",
      "y1": "136",
      "x2": "248",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "108",
      "cy": "100",
      "r": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M22.208,199.99785a112.00725,112.00725,0,0,1,171.58459.00066",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "200",
      "y1": "136",
      "x2": "248",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "108",
      "cy": "100",
      "r": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M22.208,199.99785a112.00725,112.00725,0,0,1,171.58459.00066",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "200",
      "y1": "136",
      "x2": "248",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "108",
      "cy": "100",
      "r": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M22.208,199.99785a112.00725,112.00725,0,0,1,171.58459.00066",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dr = [];
/* style */

const __vue_inject_styles__$dr = undefined;
/* scoped */

const __vue_scope_id__$dr = undefined;
/* module identifier */

const __vue_module_identifier__$dr = undefined;
/* functional template */

const __vue_is_functional_template__$dr = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dr = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dr,
  staticRenderFns: __vue_staticRenderFns__$dr
}, __vue_inject_styles__$dr, __vue_script__$dr, __vue_scope_id__$dr, __vue_is_functional_template__$dr, __vue_module_identifier__$dr, false, undefined, undefined, undefined);

var script$ds = Vue.extend({
  name: "PhUserPlus",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$ds = script$ds;
/* template */

var __vue_render__$ds = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "204",
      "y1": "136",
      "x2": "244",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "116",
      "x2": "224",
      "y2": "156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "108",
      "cy": "100",
      "r": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M22.208,199.99785a112.00725,112.00725,0,0,1,171.58459.00066",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "108",
      "cy": "100",
      "r": "60",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "136",
      "x2": "248",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "112",
      "x2": "224",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "108",
      "cy": "100",
      "r": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M22.208,199.99785a112.00725,112.00725,0,0,1,171.58459.00066",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M256,136a7.99977,7.99977,0,0,1-8,8H232v16a8,8,0,0,1-16,0V144H200a8,8,0,0,1,0-16h16V112a8,8,0,0,1,16,0v16h16A7.99977,7.99977,0,0,1,256,136ZM144.1427,157.55811a68,68,0,1,0-72.2854,0,119.88787,119.88787,0,0,0-55.77478,37.29394,8.00012,8.00012,0,0,0,6.12549,13.146l171.58447.00049a8.00012,8.00012,0,0,0,6.12549-13.146A119.88993,119.88993,0,0,0,144.1427,157.55811Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "200",
      "y1": "136",
      "x2": "248",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "112",
      "x2": "224",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "108",
      "cy": "100",
      "r": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M22.208,199.99785a112.00725,112.00725,0,0,1,171.58459.00066",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "200",
      "y1": "136",
      "x2": "248",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "112",
      "x2": "224",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "108",
      "cy": "100",
      "r": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M22.208,199.99785a112.00725,112.00725,0,0,1,171.58459.00066",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "200",
      "y1": "136",
      "x2": "248",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "112",
      "x2": "224",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "108",
      "cy": "100",
      "r": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M22.208,199.99785a112.00725,112.00725,0,0,1,171.58459.00066",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$ds = [];
/* style */

const __vue_inject_styles__$ds = undefined;
/* scoped */

const __vue_scope_id__$ds = undefined;
/* module identifier */

const __vue_module_identifier__$ds = undefined;
/* functional template */

const __vue_is_functional_template__$ds = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$ds = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$ds,
  staticRenderFns: __vue_staticRenderFns__$ds
}, __vue_inject_styles__$ds, __vue_script__$ds, __vue_scope_id__$ds, __vue_is_functional_template__$ds, __vue_module_identifier__$ds, false, undefined, undefined, undefined);

var script$dt = Vue.extend({
  name: "PhUserRectangle",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dt = script$dt;
/* template */

var __vue_render__$dt = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M63.48467,207.999a72.02867,72.02867,0,0,1,129.03066,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,48H40a8,8,0,0,0-8,8V200a8,8,0,0,0,8,8H60.09857v-.00439A72.02979,72.02979,0,0,1,128,160a40,40,0,1,1,40-40,40.00006,40.00006,0,0,1-40,40,72.02986,72.02986,0,0,1,67.90149,47.99561V208H216a8,8,0,0,0,8-8V56A8,8,0,0,0,216,48Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M60.09854,207.99545a72.02945,72.02945,0,0,1,135.80292,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "44"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,40H40A16.01833,16.01833,0,0,0,24,56V200a16.01833,16.01833,0,0,0,16,16H216a16.01833,16.01833,0,0,0,16-16V56A16.01833,16.01833,0,0,0,216,40Zm0,160H201.32227a80.03059,80.03059,0,0,0-32.05469-36.50757,59.83658,59.83658,0,0,1-82.53516,0A80.03059,80.03059,0,0,0,54.67773,200H40V56H216l.01025,143.99951Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M60.09854,207.99545a72.02945,72.02945,0,0,1,135.80292,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M60.09854,207.99545a72.02945,72.02945,0,0,1,135.80292,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M60.09854,207.99545a72.02945,72.02945,0,0,1,135.80292,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dt = [];
/* style */

const __vue_inject_styles__$dt = undefined;
/* scoped */

const __vue_scope_id__$dt = undefined;
/* module identifier */

const __vue_module_identifier__$dt = undefined;
/* functional template */

const __vue_is_functional_template__$dt = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dt = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dt,
  staticRenderFns: __vue_staticRenderFns__$dt
}, __vue_inject_styles__$dt, __vue_script__$dt, __vue_scope_id__$dt, __vue_is_functional_template__$dt, __vue_module_identifier__$dt, false, undefined, undefined, undefined);

var script$du = Vue.extend({
  name: "PhUserSquare",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$du = script$du;
/* template */

var __vue_render__$du = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M57.78418,215.99979a72.02025,72.02025,0,0,1,140.43164,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,40H48a8,8,0,0,0-8,8V208a8,8,0,0,0,8,8H208a8,8,0,0,0,8-8V48A8,8,0,0,0,208,40ZM57.78418,215.99976A72.0276,72.0276,0,0,1,128,160a40,40,0,1,1,40-40,40.00006,40.00006,0,0,1-40,40,72.02755,72.02755,0,0,1,70.21582,55.99976Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M57.78418,215.99979a72.02025,72.02025,0,0,1,140.43164,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "44"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,32H48A16.01833,16.01833,0,0,0,32,48V208a16.01833,16.01833,0,0,0,16,16H208a16.01833,16.01833,0,0,0,16-16V48A16.01833,16.01833,0,0,0,208,32Zm0,176h-3.67322a80.44452,80.44452,0,0,0-26.069-38.24561,79.23073,79.23073,0,0,0-8.98218-6.26953,59.83684,59.83684,0,0,1-82.55126,0,79.23073,79.23073,0,0,0-8.98218,6.26953A80.44452,80.44452,0,0,0,51.67322,208H48V48H208l.01025,159.99951Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M57.78418,215.99979a72.02025,72.02025,0,0,1,140.43164,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M57.78418,215.99979a72.02025,72.02025,0,0,1,140.43164,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M57.78418,215.99979a72.02025,72.02025,0,0,1,140.43164,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$du = [];
/* style */

const __vue_inject_styles__$du = undefined;
/* scoped */

const __vue_scope_id__$du = undefined;
/* module identifier */

const __vue_module_identifier__$du = undefined;
/* functional template */

const __vue_is_functional_template__$du = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$du = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$du,
  staticRenderFns: __vue_staticRenderFns__$du
}, __vue_inject_styles__$du, __vue_script__$du, __vue_scope_id__$du, __vue_is_functional_template__$du, __vue_module_identifier__$du, false, undefined, undefined, undefined);

var script$dv = Vue.extend({
  name: "PhUsers",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dv = script$dv;
/* template */

var __vue_render__$dv = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "88",
      "cy": "108",
      "r": "52",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M155.41251,57.937A52.00595,52.00595,0,1,1,169.52209,160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16,197.39665a88.013,88.013,0,0,1,144-.0055",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M169.52209,160a87.89491,87.89491,0,0,1,72.00032,37.3912",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "88.00033",
      "cy": "108",
      "r": "52",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "88.00033",
      "cy": "108",
      "r": "52",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M155.41251,57.937A52.00595,52.00595,0,1,1,169.52209,160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M15.99613,197.39669a88.01736,88.01736,0,0,1,144.00452-.00549",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M169.52209,160a87.89491,87.89491,0,0,1,72.00032,37.3912",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M121.19873,157.94751a59.99994,59.99994,0,1,0-66.39661,0A96.21448,96.21448,0,0,0,9.45459,192.791a8.0002,8.0002,0,0,0,6.542,12.60546l144.0044-.00537a7.99991,7.99991,0,0,0,6.54052-12.606A96.21491,96.21491,0,0,0,121.19873,157.94751Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M248.06348,192.78516a96.214,96.214,0,0,0-45.34327-34.83765A60.00088,60.00088,0,0,0,153.24707,50.23535a8,8,0,0,0-4.251,12.47852,75.83151,75.83151,0,0,1,3.84082,84.88623,8,8,0,0,0,2.04493,10.60107,113.20643,113.20643,0,0,1,8.74365,7.2146c.14429.15674.28979.31275.44873.46021a112.03418,112.03418,0,0,1,25.479,34.90527,7.99971,7.99971,0,0,0,7.24951,4.61523l44.72071-.00537a8.0001,8.0001,0,0,0,6.54-12.606Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "88.00033",
      "cy": "108",
      "r": "52",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M155.41251,57.937A52.00595,52.00595,0,1,1,169.52209,160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M15.99613,197.39669a88.01736,88.01736,0,0,1,144.00452-.00549",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M169.52209,160a87.89491,87.89491,0,0,1,72.00032,37.3912",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "88.00033",
      "cy": "108",
      "r": "52",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M155.41251,57.937A52.00595,52.00595,0,1,1,169.52209,160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M15.99613,197.39669a88.01736,88.01736,0,0,1,144.00452-.00549",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M169.52209,160a87.89491,87.89491,0,0,1,72.00032,37.3912",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "88.00033",
      "cy": "108",
      "r": "52",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M155.41251,57.937A52.00595,52.00595,0,1,1,169.52209,160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M15.99613,197.39669a88.01736,88.01736,0,0,1,144.00452-.00549",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M169.52209,160a87.89491,87.89491,0,0,1,72.00032,37.3912",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dv = [];
/* style */

const __vue_inject_styles__$dv = undefined;
/* scoped */

const __vue_scope_id__$dv = undefined;
/* module identifier */

const __vue_module_identifier__$dv = undefined;
/* functional template */

const __vue_is_functional_template__$dv = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dv = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dv,
  staticRenderFns: __vue_staticRenderFns__$dv
}, __vue_inject_styles__$dv, __vue_script__$dv, __vue_scope_id__$dv, __vue_is_functional_template__$dv, __vue_module_identifier__$dv, false, undefined, undefined, undefined);

var script$dw = Vue.extend({
  name: "PhUsersFour",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dw = script$dw;
/* template */

var __vue_render__$dw = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "80",
      "cy": "172",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M31.99717,223.99792a60.00878,60.00878,0,0,1,96.004-.00225",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "80",
      "cy": "64",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M31.99717,115.99792a60.00878,60.00878,0,0,1,96.004-.00225",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "172",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M127.99717,223.99792a60.00878,60.00878,0,0,1,96.004-.00225",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "64",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M127.99717,115.99792a60.00878,60.00878,0,0,1,96.004-.00225",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "80",
      "cy": "168",
      "r": "32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "80",
      "cy": "64",
      "r": "32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "168",
      "r": "32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "64",
      "r": "32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "80",
      "cy": "168",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M31.99717,223.99792a60.00878,60.00878,0,0,1,96.004-.00225",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "80",
      "cy": "64",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M31.99717,119.99792a60.00878,60.00878,0,0,1,96.004-.00225",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "168",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M127.99717,223.99792a60.00878,60.00878,0,0,1,96.004-.00225",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "64",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M127.99717,119.99792a60.00878,60.00878,0,0,1,96.004-.00225",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M25.60059,115.19336A67.8103,67.8103,0,0,1,53.0293,93.51074a40,40,0,1,1,53.9414,0A67.30469,67.30469,0,0,1,128,107.81421a67.29094,67.29094,0,0,1,21.0293-14.30347,40,40,0,1,1,53.9414,0,67.81009,67.81009,0,0,1,27.42676,21.68067,7.99981,7.99981,0,1,1-12.79248,9.60937,52.0088,52.0088,0,0,0-83.21143.00195c-.01318.01758-.0288.032-.042.04932a7.86941,7.86941,0,0,1-.5166.60791c-.05957.064-.1206.12476-.18213.18628q-.21019.20983-.43847.406c-.08838.07666-.17725.15185-.26807.22387-.04785.03784-.09082.07959-.13965.11646-.09131.06836-.1875.12524-.28076.18921-.10156.07007-.20166.14184-.30615.20654-.16358.10181-.33155.19238-.5.281-.084.04419-.165.0935-.25.13452a7.94481,7.94481,0,0,1-1.62012.57348c-.08057.01905-.16211.0315-.24365.0481-.19434.03979-.38916.07544-.58545.10034-.11035.01416-.22071.02295-.33106.03272-.16552.01416-.33056.02417-.49609.02807-.06738.00171-.13477.01148-.20215.01148-.0459,0-.09082-.00977-.13623-.01075a8.03172,8.03172,0,0,1-1.03027-.08081c-.09424-.01391-.187-.03637-.28076-.05371a7.99507,7.99507,0,0,1-.83692-.2019c-.09424-.02832-.18945-.05078-.2832-.08276a8.00518,8.00518,0,0,1-.96045-.40381c-.09326-.04615-.18555-.09375-.27783-.14405a7.8885,7.8885,0,0,1-.92823-.58471c-.021-.01538-.04443-.02539-.06494-.041-.1167-.0874-.22168-.18408-.332-.27637-.064-.0542-.13037-.10473-.19287-.16088-.166-.1482-.32129-.304-.47266-.4629-.02636-.02807-.05468-.054-.08056-.08251a7.99527,7.99527,0,0,1-.61231-.74,52.00276,52.00276,0,0,0-83.1084.13085,8,8,0,1,1-12.793-9.60937ZM202.9707,197.51074a40,40,0,1,0-53.9414,0A67.29094,67.29094,0,0,0,128,211.81421a67.30469,67.30469,0,0,0-21.0293-14.30347,40,40,0,1,0-53.9414,0,67.8103,67.8103,0,0,0-27.42871,21.68262,8,8,0,0,0,6.39648,12.80469l95.97266-.002.02734.002,96.00439-.002a7.9996,7.9996,0,0,0,6.396-12.80468A67.81009,67.81009,0,0,0,202.9707,197.51074Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "80",
      "cy": "168",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M31.99717,223.99792a60.00878,60.00878,0,0,1,96.004-.00225",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "80",
      "cy": "64",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M31.99717,119.99792a60.00878,60.00878,0,0,1,96.004-.00225",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "168",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M127.99717,223.99792a60.00878,60.00878,0,0,1,96.004-.00225",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "64",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M127.99717,119.99792a60.00878,60.00878,0,0,1,96.004-.00225",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "80",
      "cy": "168",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M31.99717,223.99792a60.00878,60.00878,0,0,1,96.004-.00225",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "80",
      "cy": "64",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M31.99717,119.99792a60.00878,60.00878,0,0,1,96.004-.00225",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "168",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M127.99717,223.99792a60.00878,60.00878,0,0,1,96.004-.00225",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "64",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M127.99717,119.99792a60.00878,60.00878,0,0,1,96.004-.00225",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "80",
      "cy": "168",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M31.99717,223.99792a60.00878,60.00878,0,0,1,96.004-.00225",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "80",
      "cy": "64",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M31.99717,119.99792a60.00878,60.00878,0,0,1,96.004-.00225",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "168",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M127.99717,223.99792a60.00878,60.00878,0,0,1,96.004-.00225",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "64",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M127.99717,119.99792a60.00878,60.00878,0,0,1,96.004-.00225",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dw = [];
/* style */

const __vue_inject_styles__$dw = undefined;
/* scoped */

const __vue_scope_id__$dw = undefined;
/* module identifier */

const __vue_module_identifier__$dw = undefined;
/* functional template */

const __vue_is_functional_template__$dw = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dw = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dw,
  staticRenderFns: __vue_staticRenderFns__$dw
}, __vue_inject_styles__$dw, __vue_script__$dw, __vue_scope_id__$dw, __vue_is_functional_template__$dw, __vue_module_identifier__$dw, false, undefined, undefined, undefined);

var script$dx = Vue.extend({
  name: "PhUsersThree",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dx = script$dx;
/* template */

var __vue_render__$dx = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "140",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M70.4343,215.9991a64.02584,64.02584,0,0,1,115.13125-.00031",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M204.50925,116.59876a59.962,59.962,0,0,1,39.49189,23.39691",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M167.10717,70.22754a32.00487,32.00487,0,1,1,36.89009,44.765",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M52.00271,114.99256a32.00461,32.00461,0,1,1,36.88964-44.766",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M11.99717,139.99792A59.96206,59.96206,0,0,1,51.4908,116.59875",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "140",
      "r": "40",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "60",
      "cy": "84",
      "r": "32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "196",
      "cy": "84",
      "r": "32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "140",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M196,116a59.909,59.909,0,0,1,48.00114,23.99567",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M11.99717,139.99792A59.909,59.909,0,0,1,60,116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M70.4343,215.9991a64.02584,64.02584,0,0,1,115.13125-.00031",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M60,116A32,32,0,1,1,91.437,77.99243",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M164.56291,77.993A32.0027,32.0027,0,1,1,196,116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M63.99805,140.002a7.99955,7.99955,0,0,1-8,8h-.00049l-44.00147-.0039a8,8,0,0,1-6.3955-12.80469A67.81463,67.81463,0,0,1,33.02783,113.5127,39.99241,39.99241,0,1,1,99.29492,76.50293a7.99971,7.99971,0,0,1-3.78515,8.37695,64.36027,64.36027,0,0,0-27.85889,33.7959A63.645,63.645,0,0,0,63.99805,140.002Zm186.39941-4.81054a67.81009,67.81009,0,0,0-27.42676-21.68067A39.99246,39.99246,0,1,0,156.70361,76.5a8.00092,8.00092,0,0,0,3.78467,8.37695,64.367,64.367,0,0,1,27.85938,33.79688A63.64448,63.64448,0,0,1,192,140a8.00039,8.00039,0,0,0,8.001,8l44.001-.00391a8,8,0,0,0,6.39551-12.80468ZM157.16162,178.0896a48,48,0,1,0-58.32324,0,71.66776,71.66776,0,0,0-35.59522,34.40454A7.9997,7.9997,0,0,0,70.43457,223.999H185.56543a8.00017,8.00017,0,0,0,7.19141-11.50488A71.66776,71.66776,0,0,0,157.16162,178.0896Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "140",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M196,116a59.909,59.909,0,0,1,48.00114,23.99567",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M11.99717,139.99792A59.909,59.909,0,0,1,60,116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M70.4343,215.9991a64.02584,64.02584,0,0,1,115.13125-.00031",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M60,116A32,32,0,1,1,91.437,77.99243",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M164.56291,77.993A32.0027,32.0027,0,1,1,196,116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "140",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M196,116a59.909,59.909,0,0,1,48.00114,23.99567",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M11.99717,139.99792A59.909,59.909,0,0,1,60,116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M70.4343,215.9991a64.02584,64.02584,0,0,1,115.13125-.00031",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M60,116A32,32,0,1,1,91.437,77.99243",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M164.56291,77.993A32.0027,32.0027,0,1,1,196,116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "140",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M196,116a59.909,59.909,0,0,1,48.00114,23.99567",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M11.99717,139.99792A59.909,59.909,0,0,1,60,116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M70.4343,215.9991a64.02584,64.02584,0,0,1,115.13125-.00031",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M60,116A32,32,0,1,1,91.437,77.99243",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M164.56291,77.993A32.0027,32.0027,0,1,1,196,116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dx = [];
/* style */

const __vue_inject_styles__$dx = undefined;
/* scoped */

const __vue_scope_id__$dx = undefined;
/* module identifier */

const __vue_module_identifier__$dx = undefined;
/* functional template */

const __vue_is_functional_template__$dx = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dx = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dx,
  staticRenderFns: __vue_staticRenderFns__$dx
}, __vue_inject_styles__$dx, __vue_script__$dx, __vue_scope_id__$dx, __vue_is_functional_template__$dx, __vue_module_identifier__$dx, false, undefined, undefined, undefined);

var script$dy = Vue.extend({
  name: "PhVibrate",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dy = script$dy;
/* template */

var __vue_render__$dy = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "76",
      "width": "176",
      "height": "104",
      "rx": "16",
      "transform": "translate(256) rotate(90)",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "220.00244",
      "y1": "100",
      "x2": "220.00244",
      "y2": "156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "36",
      "y1": "100",
      "x2": "36",
      "y2": "156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "80",
      "width": "176",
      "height": "96",
      "rx": "16",
      "transform": "translate(256) rotate(90)",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "80",
      "width": "176",
      "height": "96",
      "rx": "16",
      "transform": "translate(256) rotate(90)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208.00244",
      "y1": "88",
      "x2": "208.00244",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "240.00244",
      "y1": "104",
      "x2": "240.00244",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "88",
      "x2": "48",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "104",
      "x2": "16",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('rect', {
    attrs: {
      "x": "71.99951",
      "y": "32",
      "width": "112",
      "height": "192",
      "rx": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208.00244,80a8.00039,8.00039,0,0,0-8,8v80a8,8,0,0,0,16,0V88A8.00039,8.00039,0,0,0,208.00244,80Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M240.00244,96a8.00039,8.00039,0,0,0-8,8v48a8,8,0,0,0,16,0V104A8.00039,8.00039,0,0,0,240.00244,96Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M47.99951,80a8.00039,8.00039,0,0,0-8,8v80a8,8,0,0,0,16,0V88A8.00039,8.00039,0,0,0,47.99951,80Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M15.99951,96a8.00039,8.00039,0,0,0-8,8v48a8,8,0,0,0,16,0V104A8.00039,8.00039,0,0,0,15.99951,96Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "80",
      "width": "176",
      "height": "96",
      "rx": "16",
      "transform": "translate(256) rotate(90)",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208.00244",
      "y1": "88",
      "x2": "208.00244",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "240.00244",
      "y1": "104",
      "x2": "240.00244",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "88",
      "x2": "48",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "104",
      "x2": "16",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "80",
      "width": "176",
      "height": "96",
      "rx": "16",
      "transform": "translate(256) rotate(90)",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208.00244",
      "y1": "88",
      "x2": "208.00244",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "240.00244",
      "y1": "104",
      "x2": "240.00244",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "88",
      "x2": "48",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "104",
      "x2": "16",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "80",
      "width": "176",
      "height": "96",
      "rx": "16",
      "transform": "translate(256) rotate(90)",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208.00244",
      "y1": "88",
      "x2": "208.00244",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "240.00244",
      "y1": "104",
      "x2": "240.00244",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "88",
      "x2": "48",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "104",
      "x2": "16",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dy = [];
/* style */

const __vue_inject_styles__$dy = undefined;
/* scoped */

const __vue_scope_id__$dy = undefined;
/* module identifier */

const __vue_module_identifier__$dy = undefined;
/* functional template */

const __vue_is_functional_template__$dy = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dy = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dy,
  staticRenderFns: __vue_staticRenderFns__$dy
}, __vue_inject_styles__$dy, __vue_script__$dy, __vue_scope_id__$dy, __vue_is_functional_template__$dy, __vue_module_identifier__$dy, false, undefined, undefined, undefined);

var script$dz = Vue.extend({
  name: "PhVideoCamera",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dz = script$dz;
/* template */

var __vue_render__$dz = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M24,60H152a32,32,0,0,1,32,32v96a8,8,0,0,1-8,8H48a32,32,0,0,1-32-32V68A8,8,0,0,1,24,60Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "184 112 240 80 240 176 184 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M24,60H152a32,32,0,0,1,32,32v96a8,8,0,0,1-8,8H48a32,32,0,0,1-32-32V68A8,8,0,0,1,24,60Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,60H152a32,32,0,0,1,32,32v96a8,8,0,0,1-8,8H48a32,32,0,0,1-32-32V68A8,8,0,0,1,24,60Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "184 112 240 80 240 176 184 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,92v96a16.01833,16.01833,0,0,1-16,16H48A40.04584,40.04584,0,0,1,8,164V68A16.01833,16.01833,0,0,1,24,52H136A40.04584,40.04584,0,0,1,176,92Zm68.01562-18.91895a8.00341,8.00341,0,0,0-7.98437-.02734l-40,22.85742A8,8,0,0,0,192,102.85742v50.28516a8,8,0,0,0,4.03125,6.94629l40,22.85742A8.0003,8.0003,0,0,0,248,176V80A7.99807,7.99807,0,0,0,244.01562,73.08105Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M24,60H152a32,32,0,0,1,32,32v96a8,8,0,0,1-8,8H48a32,32,0,0,1-32-32V68A8,8,0,0,1,24,60Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "184 112 240 80 240 176 184 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M24,60H152a32,32,0,0,1,32,32v96a8,8,0,0,1-8,8H48a32,32,0,0,1-32-32V68A8,8,0,0,1,24,60Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "184 112 240 80 240 176 184 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M24,60H152a32,32,0,0,1,32,32v96a8,8,0,0,1-8,8H48a32,32,0,0,1-32-32V68A8,8,0,0,1,24,60Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "184 112 240 80 240 176 184 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dz = [];
/* style */

const __vue_inject_styles__$dz = undefined;
/* scoped */

const __vue_scope_id__$dz = undefined;
/* module identifier */

const __vue_module_identifier__$dz = undefined;
/* functional template */

const __vue_is_functional_template__$dz = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dz = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dz,
  staticRenderFns: __vue_staticRenderFns__$dz
}, __vue_inject_styles__$dz, __vue_script__$dz, __vue_scope_id__$dz, __vue_is_functional_template__$dz, __vue_module_identifier__$dz, false, undefined, undefined, undefined);

var script$dA = Vue.extend({
  name: "PhVideoCameraSlash",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dA = script$dA;
/* template */

var __vue_render__$dA = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "240 176 184 144 184 112 240 80 240 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "34.9091",
      "y1": "24",
      "x2": "224",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M121.69523,60H152a32,32,0,0,1,32,32v96a8,8,0,0,1-8,8H48a32,32,0,0,1-32-32V68a8,8,0,0,1,8-8H67.63637",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M24,60H152a32,32,0,0,1,32,32v96a8,8,0,0,1-8,8H48a32,32,0,0,1-32-32V68A8,8,0,0,1,24,60Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "240 176 184 144 184 112 240 80 240 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "34.9091",
      "y1": "24",
      "x2": "224",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M110.8827,60H152a32,32,0,0,1,32,32v52",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,188a8,8,0,0,1-8,8H48a32,32,0,0,1-32-32V68a8,8,0,0,1,8-8H67.63637",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M229.91992,226.61816a8.0006,8.0006,0,0,1-11.83984,10.76368l-42.34229-46.57618A16.01483,16.01483,0,0,1,160,204H48A40.04584,40.04584,0,0,1,8,164V68A16.01833,16.01833,0,0,1,24,52H49.55127l-20.562-22.61816A8.0006,8.0006,0,0,1,40.8291,18.61816Zm14.0957-153.53711a8.00341,8.00341,0,0,0-7.98437-.02734l-40,22.85742A8,8,0,0,0,192,102.85742v50.28516a8,8,0,0,0,4.03125,6.94629l40,22.85742A8.0003,8.0003,0,0,0,248,176V80A7.99807,7.99807,0,0,0,244.01562,73.08105Zm-81.93554,55.12989A8.0004,8.0004,0,0,0,176,122.8291V92a40.04584,40.04584,0,0,0-40-40H110.88281a8.00036,8.00036,0,0,0-5.91992,13.38184Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "240 176 184 144 184 112 240 80 240 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "34.9091",
      "y1": "24",
      "x2": "224",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M110.8827,60H152a32,32,0,0,1,32,32v52",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,188a8,8,0,0,1-8,8H48a32,32,0,0,1-32-32V68a8,8,0,0,1,8-8H67.63637",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "240 176 184 144 184 112 240 80 240 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "34.9091",
      "y1": "24",
      "x2": "224",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M110.8827,60H152a32,32,0,0,1,32,32v52",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,188a8,8,0,0,1-8,8H48a32,32,0,0,1-32-32V68a8,8,0,0,1,8-8H67.63637",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "240 176 184 144 184 112 240 80 240 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "34.9091",
      "y1": "24",
      "x2": "224",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M110.8827,60H152a32,32,0,0,1,32,32v52",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,188a8,8,0,0,1-8,8H48a32,32,0,0,1-32-32V68a8,8,0,0,1,8-8H67.63637",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dA = [];
/* style */

const __vue_inject_styles__$dA = undefined;
/* scoped */

const __vue_scope_id__$dA = undefined;
/* module identifier */

const __vue_module_identifier__$dA = undefined;
/* functional template */

const __vue_is_functional_template__$dA = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dA = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dA,
  staticRenderFns: __vue_staticRenderFns__$dA
}, __vue_inject_styles__$dA, __vue_script__$dA, __vue_scope_id__$dA, __vue_is_functional_template__$dA, __vue_module_identifier__$dA, false, undefined, undefined, undefined);

var script$dB = Vue.extend({
  name: "PhVoicemail",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dB = script$dB;
/* template */

var __vue_render__$dB = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "60",
      "cy": "128",
      "r": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "196",
      "cy": "128",
      "r": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "60",
      "y1": "176",
      "x2": "196",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "56",
      "cy": "128",
      "r": "48",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "200",
      "cy": "128",
      "r": "48",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "56",
      "cy": "128",
      "r": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "200",
      "cy": "128",
      "r": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "176",
      "x2": "200",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,72a55.96339,55.96339,0,0,0-39.13867,96H95.13867A55.96225,55.96225,0,1,0,56,184H200a56,56,0,0,0,0-112ZM16,128a40,40,0,1,1,40,40A40.04584,40.04584,0,0,1,16,128Zm184,40a40,40,0,1,1,40-40A40.04584,40.04584,0,0,1,200,168Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "56",
      "cy": "128",
      "r": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "200",
      "cy": "128",
      "r": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "176",
      "x2": "200",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "56",
      "cy": "128",
      "r": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "200",
      "cy": "128",
      "r": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "176",
      "x2": "200",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "56",
      "cy": "128",
      "r": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "200",
      "cy": "128",
      "r": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "176",
      "x2": "200",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dB = [];
/* style */

const __vue_inject_styles__$dB = undefined;
/* scoped */

const __vue_scope_id__$dB = undefined;
/* module identifier */

const __vue_module_identifier__$dB = undefined;
/* functional template */

const __vue_is_functional_template__$dB = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dB = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dB,
  staticRenderFns: __vue_staticRenderFns__$dB
}, __vue_inject_styles__$dB, __vue_script__$dB, __vue_scope_id__$dB, __vue_is_functional_template__$dB, __vue_module_identifier__$dB, false, undefined, undefined, undefined);

var script$dC = Vue.extend({
  name: "PhVolleyball",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dC = script$dC;
/* template */

var __vue_render__$dC = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "44.86156",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "211.13844",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "128",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M116.57865,32.65643a96.043,96.043,0,0,1,56.4788,95.34363",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M51.14073,185.563a96.04294,96.04294,0,0,1,54.3306-96.58389",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216.28063,165.7806a96.04293,96.04293,0,0,1-110.80941,1.24026",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M79.992,211.15229a96.03068,96.03068,0,0,0,136.27063-45.37936l.018.00767a96.04293,96.04293,0,0,1-110.80941,1.24026L80,211.13844Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,211.13844a95.68885,95.68885,0,0,1-28.8588-25.57583l-.00047.00035a96.04294,96.04294,0,0,1,54.3306-96.58389L128,128Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,44.86156A95.68887,95.68887,0,0,1,116.57872,32.657l-.00007-.00059a96.043,96.043,0,0,1,56.4788,95.34363L128,128Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "44.86156",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "211.13844",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "128",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M116.57865,32.65643a96.043,96.043,0,0,1,56.4788,95.34363",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M51.14073,185.563a96.04294,96.04294,0,0,1,54.3306-96.58389",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216.28063,165.7806a96.04293,96.04293,0,0,1-110.80941,1.24026",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M231.97754,127.55615A103.99094,103.99094,0,1,0,37.93311,180a105.72542,105.72542,0,0,0,6.46447,9.87012,7.95641,7.95641,0,0,0,.54554.74316,103.21348,103.21348,0,0,0,56.1394,37.84277,104.55745,104.55745,0,0,0,27.08643,3.58887,104.02475,104.02475,0,0,0,94.95739-62.12109,7.99045,7.99045,0,0,0,.86658-2.03223,104.79039,104.79039,0,0,0,7.97668-39.29053c.01478-.19921.0304-.39795.0304-.60107C232,127.8501,231.98572,127.7041,231.97754,127.55615ZM44.52612,155.88037A88.18268,88.18268,0,0,1,77.26184,56.11914l17.12708,29.665a104.19392,104.19392,0,0,0-49.8628,70.09619Zm32.74121,43.99121A87.25645,87.25645,0,0,1,58.90808,182.4873a88.00774,88.00774,0,0,1,43.48059-82.84716L118.76245,128Zm132.3877-39.2251a88.01249,88.01249,0,0,1-93.40991,3.71387L132.6189,136h82.96142A88.7146,88.7146,0,0,1,209.655,160.64648ZM181.36572,120a104.1963,104.1963,0,0,0-35.68689-78.15527A87.80467,87.80467,0,0,1,215.60864,120Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "44.86156",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "211.13844",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "128",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M116.57865,32.65643a96.043,96.043,0,0,1,56.4788,95.34363",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M51.14073,185.563a96.04294,96.04294,0,0,1,54.3306-96.58389",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216.28063,165.7806a96.04293,96.04293,0,0,1-110.80941,1.24026",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "44.86156",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "211.13844",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "128",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M116.57865,32.65643a96.043,96.043,0,0,1,56.4788,95.34363",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M51.14073,185.563a96.04294,96.04294,0,0,1,54.3306-96.58389",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216.28063,165.7806a96.04293,96.04293,0,0,1-110.80941,1.24026",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "44.86156",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "211.13844",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "128",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M116.57865,32.65643a96.043,96.043,0,0,1,56.4788,95.34363",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M51.14073,185.563a96.04294,96.04294,0,0,1,54.3306-96.58389",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216.28063,165.7806a96.04293,96.04293,0,0,1-110.80941,1.24026",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dC = [];
/* style */

const __vue_inject_styles__$dC = undefined;
/* scoped */

const __vue_scope_id__$dC = undefined;
/* module identifier */

const __vue_module_identifier__$dC = undefined;
/* functional template */

const __vue_is_functional_template__$dC = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dC = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dC,
  staticRenderFns: __vue_staticRenderFns__$dC
}, __vue_inject_styles__$dC, __vue_script__$dC, __vue_scope_id__$dC, __vue_is_functional_template__$dC, __vue_module_identifier__$dC, false, undefined, undefined, undefined);

var script$dD = Vue.extend({
  name: "PhWall",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dD = script$dD;
/* template */

var __vue_render__$dD = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "104",
      "x2": "128",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "152",
      "x2": "80",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "152",
      "x2": "176",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "200",
      "x2": "128",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "104",
      "x2": "224",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "152",
      "x2": "224",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "56",
      "width": "192",
      "height": "144",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "56",
      "width": "96",
      "height": "48",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "128",
      "y": "152",
      "width": "96",
      "height": "48",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "176",
      "y": "104",
      "width": "48",
      "height": "48",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "104",
      "x2": "128",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "152",
      "x2": "80",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "152",
      "x2": "176",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "200",
      "x2": "128",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "104",
      "x2": "224",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "152",
      "x2": "224",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "56",
      "width": "192",
      "height": "144",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M136,92h96V56a8.00008,8.00008,0,0,0-8-8H136Z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "184",
      "y": "108",
      "width": "48",
      "height": "44"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "88",
      "y": "108",
      "width": "80",
      "height": "44"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "24",
      "y": "108",
      "width": "48",
      "height": "44"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M136,168v40h88a8.00008,8.00008,0,0,0,8-8V168Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M120,92V48H32a8.00008,8.00008,0,0,0-8,8V92Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M120,168H24v32a8.00008,8.00008,0,0,0,8,8h88Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "104",
      "x2": "128",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "152",
      "x2": "80",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "152",
      "x2": "176",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "200",
      "x2": "128",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "104",
      "x2": "224",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "152",
      "x2": "224",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "56",
      "width": "192",
      "height": "144",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "104",
      "x2": "128",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "152",
      "x2": "80",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "152",
      "x2": "176",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "200",
      "x2": "128",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "104",
      "x2": "224",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "152",
      "x2": "224",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "56",
      "width": "192",
      "height": "144",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "104",
      "x2": "128",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "152",
      "x2": "80",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "152",
      "x2": "176",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "200",
      "x2": "128",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "104",
      "x2": "224",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "152",
      "x2": "224",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "56",
      "width": "192",
      "height": "144",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dD = [];
/* style */

const __vue_inject_styles__$dD = undefined;
/* scoped */

const __vue_scope_id__$dD = undefined;
/* module identifier */

const __vue_module_identifier__$dD = undefined;
/* functional template */

const __vue_is_functional_template__$dD = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dD = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dD,
  staticRenderFns: __vue_staticRenderFns__$dD
}, __vue_inject_styles__$dD, __vue_script__$dD, __vue_scope_id__$dD, __vue_is_functional_template__$dD, __vue_module_identifier__$dD, false, undefined, undefined, undefined);

var script$dE = Vue.extend({
  name: "PhWallet",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dE = script$dE;
/* template */

var __vue_render__$dE = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "180",
      "cy": "144",
      "r": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,68V192a16,16,0,0,0,16,16H216a8,8,0,0,0,8-8V96a8,8,0,0,0-8-8H60.47932c-10.84468,0-20.081-8.43286-20.46634-19.27069A20.00049,20.00049,0,0,1,60,48H192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,192a16,16,0,0,0,16,16H216a8,8,0,0,0,8-8V88a8,8,0,0,0-8-8H56A16,16,0,0,1,40,64Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,64V192a16,16,0,0,0,16,16H216a8,8,0,0,0,8-8V88a8,8,0,0,0-8-8H56A16,16,0,0,1,40,64v0A16,16,0,0,1,56,48H192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "144",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,72H56a8,8,0,0,1,0-16H192a8,8,0,0,0,0-16H56A24.0275,24.0275,0,0,0,32,64V192a24.0275,24.0275,0,0,0,24,24H216a16.01833,16.01833,0,0,0,16-16V88A16.01833,16.01833,0,0,0,216,72Zm-36,84a12,12,0,1,1,12-12A12,12,0,0,1,180,156Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,64V192a16,16,0,0,0,16,16H216a8,8,0,0,0,8-8V88a8,8,0,0,0-8-8H56A16,16,0,0,1,40,64v0A16,16,0,0,1,56,48H192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "144",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,64V192a16,16,0,0,0,16,16H216a8,8,0,0,0,8-8V88a8,8,0,0,0-8-8H56A16,16,0,0,1,40,64v0A16,16,0,0,1,56,48H192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "144",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,64V192a16,16,0,0,0,16,16H216a8,8,0,0,0,8-8V88a8,8,0,0,0-8-8H56A16,16,0,0,1,40,64v0A16,16,0,0,1,56,48H192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "144",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dE = [];
/* style */

const __vue_inject_styles__$dE = undefined;
/* scoped */

const __vue_scope_id__$dE = undefined;
/* module identifier */

const __vue_module_identifier__$dE = undefined;
/* functional template */

const __vue_is_functional_template__$dE = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dE = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dE,
  staticRenderFns: __vue_staticRenderFns__$dE
}, __vue_inject_styles__$dE, __vue_script__$dE, __vue_scope_id__$dE, __vue_is_functional_template__$dE, __vue_module_identifier__$dE, false, undefined, undefined, undefined);

var script$dF = Vue.extend({
  name: "PhWarning",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dF = script$dF;
/* template */

var __vue_render__$dF = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "104",
      "x2": "128",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M114.15243,39.98472,26.17616,191.977a16.00005,16.00005,0,0,0,13.84762,24.01535H215.97625A16,16,0,0,0,229.82386,191.977L141.84757,39.98472A16,16,0,0,0,114.15243,39.98472Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "176",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M114.15243,39.98472,26.17616,191.977a16.00005,16.00005,0,0,0,13.84762,24.01535H215.97625A16,16,0,0,0,229.82386,191.977L141.84757,39.98472A16,16,0,0,0,114.15243,39.98472Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "112",
      "x2": "128",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M114.15243,39.98472,26.17616,191.977a16.00005,16.00005,0,0,0,13.84762,24.01535H215.97625A16,16,0,0,0,229.82386,191.977L141.84757,39.98472A16,16,0,0,0,114.15243,39.98472Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "180",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M236.74414,187.96585l-87.96875-152a24.012,24.012,0,0,0-41.54687,0v.00782L19.25977,187.96585a23.9982,23.9982,0,0,0,20.76562,36.02344H215.97852a23.9982,23.9982,0,0,0,20.76562-36.02344Zm-116.75-83.96875a8,8,0,1,1,16,0v40a8,8,0,1,1-16,0ZM128,192a12,12,0,1,1,12-12A12.00059,12.00059,0,0,1,128,192Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "104",
      "x2": "128",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M114.15243,39.98472,26.17616,191.977a16.00005,16.00005,0,0,0,13.84762,24.01535H215.97625A16,16,0,0,0,229.82386,191.977L141.84757,39.98472A16,16,0,0,0,114.15243,39.98472Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "180",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "104",
      "x2": "128",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M114.15243,39.98472,26.17616,191.977a16.00005,16.00005,0,0,0,13.84762,24.01535H215.97625A16,16,0,0,0,229.82386,191.977L141.84757,39.98472A16,16,0,0,0,114.15243,39.98472Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "180",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "104",
      "x2": "128",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M114.15243,39.98472,26.17616,191.977a16.00005,16.00005,0,0,0,13.84762,24.01535H215.97625A16,16,0,0,0,229.82386,191.977L141.84757,39.98472A16,16,0,0,0,114.15243,39.98472Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "180",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dF = [];
/* style */

const __vue_inject_styles__$dF = undefined;
/* scoped */

const __vue_scope_id__$dF = undefined;
/* module identifier */

const __vue_module_identifier__$dF = undefined;
/* functional template */

const __vue_is_functional_template__$dF = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dF = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dF,
  staticRenderFns: __vue_staticRenderFns__$dF
}, __vue_inject_styles__$dF, __vue_script__$dF, __vue_scope_id__$dF, __vue_is_functional_template__$dF, __vue_module_identifier__$dF, false, undefined, undefined, undefined);

var script$dG = Vue.extend({
  name: "PhWarningCircle",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dG = script$dG;
/* template */

var __vue_render__$dG = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "80",
      "x2": "128",
      "y2": "132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "172",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "80",
      "x2": "128",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "172",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24.00012a104,104,0,1,0,104,104A104.11759,104.11759,0,0,0,128,24.00012Zm-8,56a8,8,0,1,1,16,0v56a8,8,0,1,1-16,0Zm8,104a12,12,0,1,1,12-12A12,12,0,0,1,128,184.00012Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "80",
      "x2": "128",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "172",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "80",
      "x2": "128",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "172",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "80",
      "x2": "128",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "172",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dG = [];
/* style */

const __vue_inject_styles__$dG = undefined;
/* scoped */

const __vue_scope_id__$dG = undefined;
/* module identifier */

const __vue_module_identifier__$dG = undefined;
/* functional template */

const __vue_is_functional_template__$dG = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dG = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dG,
  staticRenderFns: __vue_staticRenderFns__$dG
}, __vue_inject_styles__$dG, __vue_script__$dG, __vue_scope_id__$dG, __vue_is_functional_template__$dG, __vue_module_identifier__$dG, false, undefined, undefined, undefined);

var script$dH = Vue.extend({
  name: "PhWarningOctagon",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dH = script$dH;
/* template */

var __vue_render__$dH = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "80",
      "x2": "128",
      "y2": "132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M164.45079,32H91.54921a8,8,0,0,0-5.65686,2.34315l-51.5492,51.5492A8,8,0,0,0,32,91.54921v72.90158a8,8,0,0,0,2.34315,5.65686l51.5492,51.5492A8,8,0,0,0,91.54921,224h72.90158a8,8,0,0,0,5.65686-2.34315l51.5492-51.5492A8,8,0,0,0,224,164.45079V91.54921a8,8,0,0,0-2.34315-5.65686l-51.5492-51.5492A8,8,0,0,0,164.45079,32Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "172",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M164.45079,32H91.54921a8,8,0,0,0-5.65686,2.34315l-51.5492,51.5492A8,8,0,0,0,32,91.54921v72.90158a8,8,0,0,0,2.34315,5.65686l51.5492,51.5492A8,8,0,0,0,91.54921,224h72.90158a8,8,0,0,0,5.65686-2.34315l51.5492-51.5492A8,8,0,0,0,224,164.45079V91.54921a8,8,0,0,0-2.34315-5.65686l-51.5492-51.5492A8,8,0,0,0,164.45079,32Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "80",
      "x2": "128",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M164.45079,32H91.54921a8,8,0,0,0-5.65686,2.34315l-51.5492,51.5492A8,8,0,0,0,32,91.54921v72.90158a8,8,0,0,0,2.34315,5.65686l51.5492,51.5492A8,8,0,0,0,91.54921,224h72.90158a8,8,0,0,0,5.65686-2.34315l51.5492-51.5492A8,8,0,0,0,224,164.45079V91.54921a8,8,0,0,0-2.34315-5.65686l-51.5492-51.5492A8,8,0,0,0,164.45079,32Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "172",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M227.3125,80.23438,175.76562,28.6875A16.11511,16.11511,0,0,0,164.45312,24H91.54687a16.11515,16.11515,0,0,0-11.3125,4.6875L28.6875,80.23438A16.11511,16.11511,0,0,0,24,91.54688v72.90625a16.11515,16.11515,0,0,0,4.6875,11.3125L80.23437,227.3125A16.11515,16.11515,0,0,0,91.54687,232h72.90625a16.11511,16.11511,0,0,0,11.3125-4.6875l51.54688-51.54687A16.11515,16.11515,0,0,0,232,164.45313V91.54688A16.11511,16.11511,0,0,0,227.3125,80.23438ZM120,80a8,8,0,0,1,16,0v56a8,8,0,0,1-16,0Zm8,104a12,12,0,1,1,12-12A12.0006,12.0006,0,0,1,128,184Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "80",
      "x2": "128",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M164.45079,32H91.54921a8,8,0,0,0-5.65686,2.34315l-51.5492,51.5492A8,8,0,0,0,32,91.54921v72.90158a8,8,0,0,0,2.34315,5.65686l51.5492,51.5492A8,8,0,0,0,91.54921,224h72.90158a8,8,0,0,0,5.65686-2.34315l51.5492-51.5492A8,8,0,0,0,224,164.45079V91.54921a8,8,0,0,0-2.34315-5.65686l-51.5492-51.5492A8,8,0,0,0,164.45079,32Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "172",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "80",
      "x2": "128",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M164.45079,32H91.54921a8,8,0,0,0-5.65686,2.34315l-51.5492,51.5492A8,8,0,0,0,32,91.54921v72.90158a8,8,0,0,0,2.34315,5.65686l51.5492,51.5492A8,8,0,0,0,91.54921,224h72.90158a8,8,0,0,0,5.65686-2.34315l51.5492-51.5492A8,8,0,0,0,224,164.45079V91.54921a8,8,0,0,0-2.34315-5.65686l-51.5492-51.5492A8,8,0,0,0,164.45079,32Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "172",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "80",
      "x2": "128",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M164.45079,32H91.54921a8,8,0,0,0-5.65686,2.34315l-51.5492,51.5492A8,8,0,0,0,32,91.54921v72.90158a8,8,0,0,0,2.34315,5.65686l51.5492,51.5492A8,8,0,0,0,91.54921,224h72.90158a8,8,0,0,0,5.65686-2.34315l51.5492-51.5492A8,8,0,0,0,224,164.45079V91.54921a8,8,0,0,0-2.34315-5.65686l-51.5492-51.5492A8,8,0,0,0,164.45079,32Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "172",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dH = [];
/* style */

const __vue_inject_styles__$dH = undefined;
/* scoped */

const __vue_scope_id__$dH = undefined;
/* module identifier */

const __vue_module_identifier__$dH = undefined;
/* functional template */

const __vue_is_functional_template__$dH = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dH = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dH,
  staticRenderFns: __vue_staticRenderFns__$dH
}, __vue_inject_styles__$dH, __vue_script__$dH, __vue_scope_id__$dH, __vue_is_functional_template__$dH, __vue_module_identifier__$dH, false, undefined, undefined, undefined);

var script$dI = Vue.extend({
  name: "PhWatch",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dI = script$dI;
/* template */

var __vue_render__$dI = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 96 128 128 160 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,68.12774l6.95849-45.34129A8,8,0,0,1,102.86591,16h50.26817a8,8,0,0,1,7.90743,6.78646L168,68.128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,187.87226l6.95849,45.34129A8,8,0,0,0,102.86591,240h50.26817a8,8,0,0,0,7.90743-6.78646L168,187.872",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "72",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 88 128 128 168 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,68.12774l6.80838-37.55481A8,8,0,0,1,102.68007,24h50.63985a8,8,0,0,1,7.87169,6.57294L168,68.128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,187.87226l6.80838,37.55481A8,8,0,0,0,102.68007,232h50.63985a8,8,0,0,0,7.87169-6.57294L168,187.872",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M175.29687,63.53107l-6.23339-34.38556A15.99062,15.99062,0,0,0,153.31982,16H102.68018A15.99062,15.99062,0,0,0,86.93652,29.14551l-6.2334,34.38556a79.89661,79.89661,0,0,0,0,128.93786l6.2334,34.38556A15.99062,15.99062,0,0,0,102.68018,240h50.63964a15.99062,15.99062,0,0,0,15.74366-13.14551l6.23339-34.38556a79.8966,79.8966,0,0,0,0-128.93786ZM102.68018,32h50.64013l3.90723,21.55316a79.69216,79.69216,0,0,0-58.45508,0Zm50.63964,192H102.67969l-3.90723-21.55316a79.69216,79.69216,0,0,0,58.45508,0ZM168,136H128a8.00008,8.00008,0,0,1-8-8V88a8,8,0,0,1,16,0v32h32a8,8,0,0,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 88 128 128 168 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,68.12774l6.80838-37.55481A8,8,0,0,1,102.68007,24h50.63985a8,8,0,0,1,7.87169,6.57294L168,68.128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,187.87226l6.80838,37.55481A8,8,0,0,0,102.68007,232h50.63985a8,8,0,0,0,7.87169-6.57294L168,187.872",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 88 128 128 168 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,68.12774l6.80838-37.55481A8,8,0,0,1,102.68007,24h50.63985a8,8,0,0,1,7.87169,6.57294L168,68.128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,187.87226l6.80838,37.55481A8,8,0,0,0,102.68007,232h50.63985a8,8,0,0,0,7.87169-6.57294L168,187.872",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 88 128 128 168 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,68.12774l6.80838-37.55481A8,8,0,0,1,102.68007,24h50.63985a8,8,0,0,1,7.87169,6.57294L168,68.128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,187.87226l6.80838,37.55481A8,8,0,0,0,102.68007,232h50.63985a8,8,0,0,0,7.87169-6.57294L168,187.872",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dI = [];
/* style */

const __vue_inject_styles__$dI = undefined;
/* scoped */

const __vue_scope_id__$dI = undefined;
/* module identifier */

const __vue_module_identifier__$dI = undefined;
/* functional template */

const __vue_is_functional_template__$dI = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dI = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dI,
  staticRenderFns: __vue_staticRenderFns__$dI
}, __vue_inject_styles__$dI, __vue_script__$dI, __vue_scope_id__$dI, __vue_is_functional_template__$dI, __vue_module_identifier__$dI, false, undefined, undefined, undefined);

var script$dJ = Vue.extend({
  name: "PhWaves",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dJ = script$dJ;
/* template */

var __vue_render__$dJ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,72s40-32,88,0,88,0,88,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,128s40-32,88,0,88,0,88,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,184s40-32,88,0,88,0,88,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,72s40-32,88,0,88,0,88,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,128s40-32,88,0,88,0,88,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,184s40-32,88,0,88,0,88,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M33.74609,76.96289a7.98611,7.98611,0,0,1,1.25635-11.21A81.79682,81.79682,0,0,1,64.05957,52.23926c16.16406-4.042,41.14941-5.04785,68.37793,13.10449,42.333,28.22363,77.12891,1.53906,78.58887.38965a8.00032,8.00032,0,0,1,9.97119,12.51367,81.79682,81.79682,0,0,1-29.05713,13.51367,81.324,81.324,0,0,1-19.71484,2.4375c-14.04053,0-30.87207-3.68164-48.66309-15.542-42.333-28.22266-77.12842-1.53906-78.58887-.38965A8.01729,8.01729,0,0,1,33.74609,76.96289ZM211.02637,121.7334c-1.46,1.14941-36.25586,27.833-78.58887-.38965-27.22852-18.15137-52.21387-17.14844-68.37793-13.10449a81.79682,81.79682,0,0,0-29.05713,13.51367,8.00032,8.00032,0,0,0,9.97119,12.51367c1.46045-1.14941,36.25586-27.834,78.58887.38965,17.791,11.86035,34.62256,15.542,48.66309,15.542a83.50512,83.50512,0,0,0,48.772-15.95117,8.00032,8.00032,0,0,0-9.97119-12.51367Zm0,56c-1.46,1.15039-36.25586,27.832-78.58887-.38965-27.22852-18.15332-52.21387-17.14746-68.37793-13.10449a81.79682,81.79682,0,0,0-29.05713,13.51367,8.00032,8.00032,0,0,0,9.97119,12.51367c1.46045-1.15039,36.25586-27.835,78.58887.38965,17.791,11.86035,34.62256,15.542,48.66309,15.542a83.50512,83.50512,0,0,0,48.772-15.95117,8.00032,8.00032,0,0,0-9.97119-12.51367Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,72s40-32,88,0,88,0,88,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,128s40-32,88,0,88,0,88,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,184s40-32,88,0,88,0,88,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,72s40-32,88,0,88,0,88,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,128s40-32,88,0,88,0,88,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,184s40-32,88,0,88,0,88,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,72s40-32,88,0,88,0,88,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,128s40-32,88,0,88,0,88,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,184s40-32,88,0,88,0,88,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dJ = [];
/* style */

const __vue_inject_styles__$dJ = undefined;
/* scoped */

const __vue_scope_id__$dJ = undefined;
/* module identifier */

const __vue_module_identifier__$dJ = undefined;
/* functional template */

const __vue_is_functional_template__$dJ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dJ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dJ,
  staticRenderFns: __vue_staticRenderFns__$dJ
}, __vue_inject_styles__$dJ, __vue_script__$dJ, __vue_scope_id__$dJ, __vue_is_functional_template__$dJ, __vue_module_identifier__$dJ, false, undefined, undefined, undefined);

var script$dK = Vue.extend({
  name: "PhWhatsappLogo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dK = script$dK;
/* template */

var __vue_render__$dK = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M45.429,176.99811A95.95978,95.95978,0,1,1,79.00277,210.5717l.00023-.001L45.84643,220.044a8,8,0,0,1-9.89-9.89l9.47331-33.15657Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80.00147,103.535A23.89033,23.89033,0,0,1,104,80h3.47048a8,8,0,0,1,6.85994,3.884l7.41013,12.35021a8,8,0,0,1,.29548,7.69368l-4.7745,9.549-.00127-.00063a36.06864,36.06864,0,0,0,25.26306,25.26334l-.00052-.001,9.54928-4.77464a8,8,0,0,1,7.69368.29548l12.35021,7.41013A8,8,0,0,1,176,148.52952V152a23.89033,23.89033,0,0,1-23.535,23.99853A72.00011,72.00011,0,0,1,80.00147,103.535Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128.00049,32A96.02264,96.02264,0,0,0,45.4292,176.99807l.00049-.00061-9.47315,33.15661a8,8,0,0,0,9.89014,9.8899l33.15625-9.47327v.001A96.00624,96.00624,0,1,0,128.00049,32ZM152.11377,183.9999A80.0001,80.0001,0,0,1,72,103.88625,27.97634,27.97634,0,0,1,100,76h0a6.89208,6.89208,0,0,1,5.98438,3.4729l11.6914,20.45923a8.00129,8.00129,0,0,1-.08594,8.08521l-9.38916,15.64843h0a48.18271,48.18271,0,0,0,24.1333,24.13379l.00049-.00012,15.64795-9.389a8.00033,8.00033,0,0,1,8.08545-.08594l20.459,11.69092A6.89223,6.89223,0,0,1,180,156,28.081,28.081,0,0,1,152.11377,183.9999Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M45.429,176.99811A95.95978,95.95978,0,1,1,79.00277,210.5717l.00023-.001L45.84643,220.044a8,8,0,0,1-9.89-9.89l9.47331-33.15657Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152.11369,183.99992a80,80,0,0,1-80.11361-80.11361A27.97622,27.97622,0,0,1,100,76h0a6.89265,6.89265,0,0,1,5.98451,3.47295l11.69105,20.45931a8,8,0,0,1-.086,8.08508l-9.38907,15.64844h0a48.18239,48.18239,0,0,0,24.13373,24.13373l0,0,15.64841-9.389a8,8,0,0,1,8.08508-.086l20.45931,11.691A6.89265,6.89265,0,0,1,180,156v0A28.081,28.081,0,0,1,152.11369,183.99992Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M128.00049,24a104.0281,104.0281,0,0,0-91.189,154.041l-8.54687,29.915A15.99944,15.99944,0,0,0,48.044,227.73635l29.916-8.54688A104.00728,104.00728,0,1,0,128.00049,24ZM152.125,192c-.0293.02344-.084,0-.126,0A87.99949,87.99949,0,0,1,64,103.876,36.01385,36.01385,0,0,1,100,68,14.92643,14.92643,0,0,1,112.93066,75.503l11.69092,20.46094a16.01674,16.01674,0,0,1-.17187,16.16992l-7.11084,11.85156a40.03607,40.03607,0,0,0,14.67627,14.67676l11.85107-7.11133a16.01883,16.01883,0,0,1,16.17041-.17285l20.45947,11.69141A14.9238,14.9238,0,0,1,188,156,36.01427,36.01427,0,0,1,152.125,192Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M136.4502,154.6592a7.99584,7.99584,0,0,1-7.397.43652,56.03179,56.03179,0,0,1-28.14892-28.14843,7.99972,7.99972,0,0,1,.43652-7.39746l9.38867-15.64844L99.36328,84.00979A19.99027,19.99027,0,0,0,80,103.89748,72.00036,72.00036,0,0,0,152,176h.10254a19.99027,19.99027,0,0,0,19.88769-19.36328l-19.8916-11.36621Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M45.429,176.99811A95.95978,95.95978,0,1,1,79.00277,210.5717l.00023-.001L45.84643,220.044a8,8,0,0,1-9.89-9.89l9.47331-33.15657Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152.11369,183.99992a80,80,0,0,1-80.11361-80.11361A27.97622,27.97622,0,0,1,100,76h0a6.89265,6.89265,0,0,1,5.98451,3.47295l11.69105,20.45931a8,8,0,0,1-.086,8.08508l-9.38907,15.64844h0a48.18239,48.18239,0,0,0,24.13373,24.13373l0,0,15.64841-9.389a8,8,0,0,1,8.08508-.086l20.45931,11.691A6.89265,6.89265,0,0,1,180,156v0A28.081,28.081,0,0,1,152.11369,183.99992Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M45.429,176.99811A95.95978,95.95978,0,1,1,79.00277,210.5717l.00023-.001L45.84643,220.044a8,8,0,0,1-9.89-9.89l9.47331-33.15657Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152.11369,183.99992a80,80,0,0,1-80.11361-80.11361A27.97622,27.97622,0,0,1,100,76h0a6.89265,6.89265,0,0,1,5.98451,3.47295l11.69105,20.45931a8,8,0,0,1-.086,8.08508l-9.38907,15.64844h0a48.18239,48.18239,0,0,0,24.13373,24.13373l0,0,15.64841-9.389a8,8,0,0,1,8.08508-.086l20.45931,11.691A6.89265,6.89265,0,0,1,180,156v0A28.081,28.081,0,0,1,152.11369,183.99992Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M45.429,176.99811A95.95978,95.95978,0,1,1,79.00277,210.5717l.00023-.001L45.84643,220.044a8,8,0,0,1-9.89-9.89l9.47331-33.15657Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152.11369,183.99992a80,80,0,0,1-80.11361-80.11361A27.97622,27.97622,0,0,1,100,76h0a6.89265,6.89265,0,0,1,5.98451,3.47295l11.69105,20.45931a8,8,0,0,1-.086,8.08508l-9.38907,15.64844h0a48.18239,48.18239,0,0,0,24.13373,24.13373l0,0,15.64841-9.389a8,8,0,0,1,8.08508-.086l20.45931,11.691A6.89265,6.89265,0,0,1,180,156v0A28.081,28.081,0,0,1,152.11369,183.99992Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dK = [];
/* style */

const __vue_inject_styles__$dK = undefined;
/* scoped */

const __vue_scope_id__$dK = undefined;
/* module identifier */

const __vue_module_identifier__$dK = undefined;
/* functional template */

const __vue_is_functional_template__$dK = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dK = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dK,
  staticRenderFns: __vue_staticRenderFns__$dK
}, __vue_inject_styles__$dK, __vue_script__$dK, __vue_scope_id__$dK, __vue_is_functional_template__$dK, __vue_module_identifier__$dK, false, undefined, undefined, undefined);

var script$dL = Vue.extend({
  name: "PhWheelchair",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dL = script$dL;
/* template */

var __vue_render__$dL = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "95.88745",
      "cy": "40",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "95.887 60 95.887 136 183.887 136 215.887 200 239.887 192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M163.20563,184.07319A64.00734,64.00734,0,1,1,103.88745,96h56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "95.88745",
      "cy": "40",
      "r": "20",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "95.88745",
      "cy": "40",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "95.887 60 95.887 132 183.887 132 215.887 196 239.887 188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M167.76447,164.00014A64.001,64.001,0,1,1,103.88745,96h56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M247.47729,185.47021a7.99737,7.99737,0,0,0-10.12012-5.05957l-17.417,5.80567-28.89746-57.79395A7.99979,7.99979,0,0,0,183.88745,124h-80V104h56a8,8,0,0,0,0-16h-56V62.629a24,24,0,1,0-16,0V89.81421a71.99395,71.99395,0,1,0,87.86133,74.678,7.99953,7.99953,0,1,0-15.96875-.98438,56.001,56.001,0,1,1-71.89258-57.16644V132a8.00008,8.00008,0,0,0,8,8h83.05566l29.78906,59.57764a7.9934,7.9934,0,0,0,9.68555,4.01172l24-8A8.00045,8.00045,0,0,0,247.47729,185.47021Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "95.88745",
      "cy": "40",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "95.887 60 95.887 132 183.887 132 215.887 196 239.887 188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M167.76447,164.00014A64.001,64.001,0,1,1,103.88745,96h56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "95.88745",
      "cy": "40",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "95.887 60 95.887 132 183.887 132 215.887 196 239.887 188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M167.76447,164.00014A64.001,64.001,0,1,1,103.88745,96h56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "95.88745",
      "cy": "40",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "95.887 60 95.887 132 183.887 132 215.887 196 239.887 188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M167.76447,164.00014A64.001,64.001,0,1,1,103.88745,96h56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dL = [];
/* style */

const __vue_inject_styles__$dL = undefined;
/* scoped */

const __vue_scope_id__$dL = undefined;
/* module identifier */

const __vue_module_identifier__$dL = undefined;
/* functional template */

const __vue_is_functional_template__$dL = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dL = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dL,
  staticRenderFns: __vue_staticRenderFns__$dL
}, __vue_inject_styles__$dL, __vue_script__$dL, __vue_scope_id__$dL, __vue_is_functional_template__$dL, __vue_module_identifier__$dL, false, undefined, undefined, undefined);

var script$dM = Vue.extend({
  name: "PhWifiHigh",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dM = script$dM;
/* template */

var __vue_render__$dM = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.91969,166.06177a50.7769,50.7769,0,0,1,70.145,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M58.97857,132.12064a98.75415,98.75415,0,0,1,138.02724,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M25.06379,98.17952a146.68225,146.68225,0,0,1,205.8568,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "200",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M20.20855,75.93124c63.48474-47.90809,152.098-47.90812,215.58263.00015a8.015,8.015,0,0,1,1.201,11.61025c-19.04723,22.44929-82.94714,97.76169-102.95188,121.33925a7.93583,7.93583,0,0,1-12.14044-.0705L19.03968,87.57941A8.055,8.055,0,0,1,20.20855,75.93124Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M20.20855,75.93124c63.48474-47.90809,152.098-47.90812,215.58263.00015a8.015,8.015,0,0,1,1.201,11.61025c-19.04723,22.44929-82.94714,97.76169-102.95188,121.33925a7.93583,7.93583,0,0,1-12.14044-.0705L19.03968,87.57941A8.055,8.055,0,0,1,20.20855,75.93124Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M246.86034,80.49665a15.72068,15.72068,0,0,0-6.209-10.91944C174.34325,19.50788,81.71141,19.49665,15.39061,69.54548a15.73529,15.73529,0,0,0-6.21142,10.936,16.27674,16.27674,0,0,0,3.76074,12.27393L115.85985,214.05768a15.95117,15.95117,0,0,0,12.17383,5.65528A15.77638,15.77638,0,0,0,140.081,214.127L243.12206,92.6822A16.16767,16.16767,0,0,0,246.86034,80.49665Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.91969,166.06177a50.7769,50.7769,0,0,1,70.145,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M58.97857,132.12064a98.75415,98.75415,0,0,1,138.02724,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M25.06379,98.17952a146.68225,146.68225,0,0,1,205.8568,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "200",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.91969,166.06177a50.7769,50.7769,0,0,1,70.145,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M58.97857,132.12064a98.75415,98.75415,0,0,1,138.02724,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M25.06379,98.17952a146.68225,146.68225,0,0,1,205.8568,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "200",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.91969,166.06177a50.7769,50.7769,0,0,1,70.145,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M58.97857,132.12064a98.75415,98.75415,0,0,1,138.02724,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M25.06379,98.17952a146.68225,146.68225,0,0,1,205.8568,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "200",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dM = [];
/* style */

const __vue_inject_styles__$dM = undefined;
/* scoped */

const __vue_scope_id__$dM = undefined;
/* module identifier */

const __vue_module_identifier__$dM = undefined;
/* functional template */

const __vue_is_functional_template__$dM = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dM = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dM,
  staticRenderFns: __vue_staticRenderFns__$dM
}, __vue_inject_styles__$dM, __vue_script__$dM, __vue_scope_id__$dM, __vue_is_functional_template__$dM, __vue_module_identifier__$dM, false, undefined, undefined, undefined);

var script$dN = Vue.extend({
  name: "PhWifiLow",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dN = script$dN;
/* template */

var __vue_render__$dN = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.91969,166.06177a50.7769,50.7769,0,0,1,70.145,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "200",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M71.06558,148.89719a88.00756,88.00756,0,0,1,113.86856-.00025l-50.89382,59.98395a7.93583,7.93583,0,0,1-12.14044-.0705Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M20.20855,75.93124c63.48474-47.90809,152.098-47.90812,215.58263.00015a8.015,8.015,0,0,1,1.201,11.61025c-19.04723,22.44929-82.94714,97.76169-102.95188,121.33925a7.93583,7.93583,0,0,1-12.14044-.0705L19.03968,87.57941A8.055,8.055,0,0,1,20.20855,75.93124Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M71.06558,148.89719a88.00756,88.00756,0,0,1,113.86856-.00025",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M246.84081,80.49756a15.76545,15.76545,0,0,0-6.231-10.95215c-66.30273-50.03516-158.9165-50.03516-225.22021,0l-.00049.00049a15.73787,15.73787,0,0,0-6.21045,10.936,16.28081,16.28081,0,0,0,3.76074,12.27344l102.86035,121.231a16.15644,16.15644,0,0,0,3.97534,3.38556,15.97543,15.97543,0,0,0,8.25709,2.29852h.00048a15.84564,15.84564,0,0,0,10.90992-4.34833,16.03046,16.03046,0,0,0,1.198-1.26544L243.09227,92.71729A16.20974,16.20974,0,0,0,246.84081,80.49756Zm-15.94873,1.86816-47.10327,55.516a95.96888,95.96888,0,0,0-111.57813-.00012L25.14013,82.4043a.23245.23245,0,0,1-.05958-.12744c60.625-45.71192,145.28174-45.69922,205.85694-.01954A.138.138,0,0,1,230.89208,82.36572Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.91969,166.06177a50.7769,50.7769,0,0,1,70.145,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "200",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.91969,166.06177a50.7769,50.7769,0,0,1,70.145,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "200",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.91969,166.06177a50.7769,50.7769,0,0,1,70.145,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "200",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dN = [];
/* style */

const __vue_inject_styles__$dN = undefined;
/* scoped */

const __vue_scope_id__$dN = undefined;
/* module identifier */

const __vue_module_identifier__$dN = undefined;
/* functional template */

const __vue_is_functional_template__$dN = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dN = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dN,
  staticRenderFns: __vue_staticRenderFns__$dN
}, __vue_inject_styles__$dN, __vue_script__$dN, __vue_scope_id__$dN, __vue_is_functional_template__$dN, __vue_module_identifier__$dN, false, undefined, undefined, undefined);

var script$dO = Vue.extend({
  name: "PhWifiMedium",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dO = script$dO;
/* template */

var __vue_render__$dO = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.91969,166.06177a50.7769,50.7769,0,0,1,70.145,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M58.97857,132.12064a98.75415,98.75415,0,0,1,138.02724,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "200",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M134.04032,208.88089a7.93583,7.93583,0,0,1-12.14044-.0705L50.36222,124.49611a120.01033,120.01033,0,0,1,155.27524-.00029Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M20.20855,75.93124c63.48474-47.90809,152.098-47.90812,215.58263.00015a8.015,8.015,0,0,1,1.201,11.61025c-19.04723,22.44929-82.94714,97.76169-102.95188,121.33925a7.93583,7.93583,0,0,1-12.14044-.0705L19.03968,87.57941A8.055,8.055,0,0,1,20.20855,75.93124Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M50.36222,124.49611a120.01033,120.01033,0,0,1,155.27524-.00029",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M240.60352,69.55179C174.33789,19.52054,81.71289,19.50492,15.416,69.53617a15.67919,15.67919,0,0,0-6.23438,10.9375,16.20384,16.20384,0,0,0,3.76563,12.28125L115.791,213.98148a16.04165,16.04165,0,0,0,12.21875,5.6875h.01562a15.846,15.846,0,0,0,12.10938-5.60938v-.00781L243.10352,92.708a16.264,16.264,0,0,0,3.73437-12.22656A15.76645,15.76645,0,0,0,240.60352,69.55179ZM25.00977,82.333h0l.01562-.01562C25.02539,82.32523,25.02539,82.32523,25.00977,82.333ZM204.48242,113.4971A127.38716,127.38716,0,0,0,187.502,102.81156c-.2539-.13575-.50781-.26953-.76562-.40235a127.88589,127.88589,0,0,0-17.78711-7.57129c-.50195-.17089-1.00781-.3164-1.51367-.48144a127.931,127.931,0,0,0-18.42188-4.5625c-.53125-.08985-1.0664-.13086-1.60156-.21387a119.8284,119.8284,0,0,0-38.80859-.00293c-.53711.083-1.07813.126-1.61524.21582a127.94763,127.94763,0,0,0-18.40039,4.55567c-.50781.165-1.01562.3125-1.51953.48437a128.124,128.124,0,0,0-17.76563,7.55762c-.26367.13672-.52343.27441-.78515.41308a127.2435,127.2435,0,0,0-16.96094,10.666l-.002.001L25.10352,82.27054c60.625-45.71875,145.26562-45.6875,205.79687.09375Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.91969,166.06177a50.7769,50.7769,0,0,1,70.145,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M58.97857,132.12064a98.75415,98.75415,0,0,1,138.02724,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "200",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.91969,166.06177a50.7769,50.7769,0,0,1,70.145,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M58.97857,132.12064a98.75415,98.75415,0,0,1,138.02724,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "200",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.91969,166.06177a50.7769,50.7769,0,0,1,70.145,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M58.97857,132.12064a98.75415,98.75415,0,0,1,138.02724,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "200",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dO = [];
/* style */

const __vue_inject_styles__$dO = undefined;
/* scoped */

const __vue_scope_id__$dO = undefined;
/* module identifier */

const __vue_module_identifier__$dO = undefined;
/* functional template */

const __vue_is_functional_template__$dO = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dO = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dO,
  staticRenderFns: __vue_staticRenderFns__$dO
}, __vue_inject_styles__$dO, __vue_script__$dO, __vue_scope_id__$dO, __vue_is_functional_template__$dO, __vue_module_identifier__$dO, false, undefined, undefined, undefined);

var script$dP = Vue.extend({
  name: "PhWifiNone",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dP = script$dP;
/* template */

var __vue_render__$dP = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "200",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M20.20827,75.93119c63.485-47.90816,152.09866-47.90813,215.58361.00009a8.06594,8.06594,0,0,1,1.208,11.6015c-19.03707,22.43714-82.95213,97.76737-102.95962,121.34817a7.87135,7.87135,0,0,1-12.08054,0C101.9523,185.30027,38.03757,109.97061,19.00019,87.53317A8.06626,8.06626,0,0,1,20.20827,75.93119Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,219.70508a15.90814,15.90814,0,0,1-12.14014-5.64844L12.8999,92.709a16.182,16.182,0,0,1-3.71826-12.206,15.97026,15.97026,0,0,1,6.208-10.95752c66.30371-50.03418,158.91748-50.03516,225.22119,0a15.97226,15.97226,0,0,1,6.20752,10.957A16.18377,16.18377,0,0,1,243.10059,92.708L140.14014,214.05664A15.90814,15.90814,0,0,1,128,219.70508ZM25.084,82.27441a.12788.12788,0,0,0,.01612.083l102.89844,121.2749L230.8999,82.35693a.16373.16373,0,0,0,.01074-.11767C170.36279,36.57764,85.709,36.563,25.084,82.27441Zm-.05664.04248ZM20.2085,75.93115h0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "200",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "200",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "200",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dP = [];
/* style */

const __vue_inject_styles__$dP = undefined;
/* scoped */

const __vue_scope_id__$dP = undefined;
/* module identifier */

const __vue_module_identifier__$dP = undefined;
/* functional template */

const __vue_is_functional_template__$dP = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dP = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dP,
  staticRenderFns: __vue_staticRenderFns__$dP
}, __vue_inject_styles__$dP, __vue_script__$dP, __vue_scope_id__$dP, __vue_is_functional_template__$dP, __vue_module_identifier__$dP, false, undefined, undefined, undefined);

var script$dQ = Vue.extend({
  name: "PhWifiSlash",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dQ = script$dQ;
/* template */

var __vue_render__$dQ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "47.98242",
      "y1": "40",
      "x2": "207.98242",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M25.04621,98.17952A145.88673,145.88673,0,0,1,72.40779,66.8671",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M58.961,132.12064a97.89874,97.89874,0,0,1,49.03639-26.105",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.90211,166.06177a50.81565,50.81565,0,0,1,67.576-2.317",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M116.96071,56.40892q5.45356-.4036,11.0139-.406A145.90176,145.90176,0,0,1,230.903,98.17952",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M167.79881,112.332a97.8573,97.8573,0,0,1,29.18942,19.78862",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "200",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M20.20855,75.93124c63.48474-47.90809,152.098-47.90812,215.58263.00015a8.015,8.015,0,0,1,1.201,11.61025c-19.04723,22.44929-82.94714,97.76169-102.95188,121.33925a7.93583,7.93583,0,0,1-12.14044-.0705L19.03968,87.57941A8.055,8.055,0,0,1,20.20855,75.93124Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M166.62276,170.47925l-32.58244,38.40164a7.93583,7.93583,0,0,1-12.14044-.0705L19.03968,87.57941a8.055,8.055,0,0,1,1.16887-11.64817A177.24421,177.24421,0,0,1,60.07361,53.27507",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M94.16029,43.19328A179.46662,179.46662,0,0,1,235.79118,75.93139a8.015,8.015,0,0,1,1.201,11.61025c-9.27624,10.93309-29.19069,34.40431-49.49207,58.33153",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M53.86491,34.61787A8.0029,8.0029,0,0,0,42.01886,45.38155l4.63294,5.093A185.51021,185.51021,0,0,0,15.31272,69.55151,15.73558,15.73558,0,0,0,9.097,80.48806a16.27045,16.27045,0,0,0,3.76351,12.27248L115.78283,213.99217a16.0416,16.0416,0,0,0,12.24131,5.6836,15.86724,15.86724,0,0,0,12.11428-5.61329l26.70577-31.4561,35.27175,38.77545a8.0029,8.0029,0,0,0,11.846-10.76369Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M246.90336,80.50173a15.766,15.766,0,0,0-6.23425-10.95022,187.8405,187.8405,0,0,0-148.037-34.211A7.99849,7.99849,0,0,0,88.207,48.5798L181.6035,151.25965a8.00587,8.00587,0,0,0,5.923,2.61915c.04593,0,.09136,0,.13729-.001a8.007,8.007,0,0,0,5.967-2.82325l49.5227-58.33212A16.20333,16.20333,0,0,0,246.90336,80.50173Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "47.98828",
      "y1": "40",
      "x2": "207.98828",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M107.11812,57.47077a148.358,148.358,0,0,1,20.86235-1.46787,145.90176,145.90176,0,0,1,102.9284,42.17662",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M25.05207,98.17952A145.88673,145.88673,0,0,1,72.41365,66.8671",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152.10795,106.95874a97.88563,97.88563,0,0,1,44.88614,25.1619",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M58.96685,132.12064a97.89874,97.89874,0,0,1,49.03639-26.105",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.908,166.06177a50.81565,50.81565,0,0,1,67.576-2.317",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "200",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "47.99414",
      "y1": "40",
      "x2": "207.99414",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M107.124,57.47077a148.358,148.358,0,0,1,20.86235-1.46787,145.90176,145.90176,0,0,1,102.9284,42.17662",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M25.05793,98.17952A145.88673,145.88673,0,0,1,72.41951,66.8671",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152.11381,106.95874A97.88563,97.88563,0,0,1,197,132.12064",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M58.97271,132.12064a97.89874,97.89874,0,0,1,49.03639-26.105",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.91383,166.06177a50.81565,50.81565,0,0,1,67.576-2.317",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "200",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M107.12984,57.47077a148.358,148.358,0,0,1,20.86235-1.46787,145.90176,145.90176,0,0,1,102.9284,42.17662",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M25.06379,98.17952A145.88673,145.88673,0,0,1,72.42537,66.8671",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152.11967,106.95874a97.88568,97.88568,0,0,1,44.88614,25.1619",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M58.97857,132.12064a97.89874,97.89874,0,0,1,49.03639-26.105",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.91969,166.06177a50.81565,50.81565,0,0,1,67.576-2.317",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "200",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dQ = [];
/* style */

const __vue_inject_styles__$dQ = undefined;
/* scoped */

const __vue_scope_id__$dQ = undefined;
/* module identifier */

const __vue_module_identifier__$dQ = undefined;
/* functional template */

const __vue_is_functional_template__$dQ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dQ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dQ,
  staticRenderFns: __vue_staticRenderFns__$dQ
}, __vue_inject_styles__$dQ, __vue_script__$dQ, __vue_scope_id__$dQ, __vue_is_functional_template__$dQ, __vue_module_identifier__$dQ, false, undefined, undefined, undefined);

var script$dR = Vue.extend({
  name: "PhWifiX",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dR = script$dR;
/* template */

var __vue_render__$dR = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.91969,166.06177a50.7769,50.7769,0,0,1,70.145,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "56",
      "x2": "176",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "104",
      "x2": "176",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M25.06379,98.17952A145.90174,145.90174,0,0,1,127.99219,56.0029q4.03231,0,8.0117.21441",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M58.97857,132.12064a98.11506,98.11506,0,0,1,69.01362-28.11774q4.04751,0,8.0141.319",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "200",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M20.20855,75.93124c63.48474-47.90809,152.098-47.90812,215.58263.00015a8.015,8.015,0,0,1,1.201,11.61025c-19.04723,22.44929-82.94714,97.76169-102.95188,121.33925a7.93583,7.93583,0,0,1-12.14044-.0705L19.03968,87.57941A8.055,8.055,0,0,1,20.20855,75.93124Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "56",
      "x2": "176",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "104",
      "x2": "176",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M202.73959,127.91193c-25.42164,29.962-55.96036,65.9549-68.69927,80.969a7.93583,7.93583,0,0,1-12.14044-.0705L19.03968,87.57941a8.055,8.055,0,0,1,1.16887-11.64817A179.20728,179.20728,0,0,1,147.6789,41.073",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M211.30223,79.99421,229.645,61.65143A8.00018,8.00018,0,1,0,218.33153,50.337L199.98827,68.68024,181.645,50.337a8.00018,8.00018,0,1,0-11.31348,11.31445L188.6743,79.99421,170.33153,98.337A8.00018,8.00018,0,0,0,181.645,109.65143l18.34326-18.34326,18.34326,18.34326A8.00018,8.00018,0,0,0,229.645,98.337Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M199.98827,113.93561l-7.03113,7.03125a24.00024,24.00024,0,0,1-33.93933-33.9436l7.02905-7.029-7.0299-7.03a24.03027,24.03027,0,0,1,4.60974-37.55127A187.51454,187.51454,0,0,0,15.39061,69.54548a15.73529,15.73529,0,0,0-6.21142,10.936,16.27674,16.27674,0,0,0,3.76074,12.27393L115.85985,214.05768a15.95117,15.95117,0,0,0,12.17383,5.65528A15.77638,15.77638,0,0,0,140.081,214.127l74.647-87.97925a23.97614,23.97614,0,0,1-7.71021-5.18262Z"
    }
  })])]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.91969,166.06177a50.7769,50.7769,0,0,1,70.145,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "56",
      "x2": "176",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "104",
      "x2": "176",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M25.06379,98.17952A145.90174,145.90174,0,0,1,127.99219,56.0029a148.757,148.757,0,0,1,16.01524.86162",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M58.97857,132.12064a98.11506,98.11506,0,0,1,69.01362-28.11774,99.87589,99.87589,0,0,1,16.02985,1.28855",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "200",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.91969,166.06177a50.7769,50.7769,0,0,1,70.145,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "56",
      "x2": "176",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "104",
      "x2": "176",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M25.06379,98.17952A145.90174,145.90174,0,0,1,127.99219,56.0029a148.757,148.757,0,0,1,16.01524.86162",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M58.97857,132.12064a98.11506,98.11506,0,0,1,69.01362-28.11774,99.87589,99.87589,0,0,1,16.02985,1.28855",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "200",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.91969,166.06177a50.7769,50.7769,0,0,1,70.145,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "56",
      "x2": "176",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "104",
      "x2": "176",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M25.06379,98.17952A145.90174,145.90174,0,0,1,127.99219,56.0029a148.757,148.757,0,0,1,16.01524.86162",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M58.97857,132.12064a98.11506,98.11506,0,0,1,69.01362-28.11774,99.87589,99.87589,0,0,1,16.02985,1.28855",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "200",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dR = [];
/* style */

const __vue_inject_styles__$dR = undefined;
/* scoped */

const __vue_scope_id__$dR = undefined;
/* module identifier */

const __vue_module_identifier__$dR = undefined;
/* functional template */

const __vue_is_functional_template__$dR = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dR = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dR,
  staticRenderFns: __vue_staticRenderFns__$dR
}, __vue_inject_styles__$dR, __vue_script__$dR, __vue_scope_id__$dR, __vue_is_functional_template__$dR, __vue_module_identifier__$dR, false, undefined, undefined, undefined);

var script$dS = Vue.extend({
  name: "PhWind",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dS = script$dS;
/* template */

var __vue_render__$dS = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M102.11138,51.99974A24.0001,24.0001,0,1,1,120,92H24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M190.11128,91.99985A24.0001,24.0001,0,1,1,208,132H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M134.11121,212.00007A24.0001,24.0001,0,1,0,152,172H40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M129.48449,192.32854A24.00285,24.00285,0,1,0,152,160H40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M97.48449,63.67146A24.00285,24.00285,0,1,1,120,96H24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M185.48449,95.67146A24.00285,24.00285,0,1,1,208,128H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M184,184a32.00415,32.00415,0,0,1-62.01855,11.10449,8.00013,8.00013,0,1,1,15.00585-5.55273A16.00278,16.00278,0,1,0,152,168H40a8,8,0,0,1,0-16H152A32.03635,32.03635,0,0,1,184,184Zm-64-80A32,32,0,1,0,89.98145,60.89551a8.00013,8.00013,0,1,0,15.00585,5.55273A16.00278,16.00278,0,1,1,120,88H24a8,8,0,0,0,0,16Zm88-32a32.13165,32.13165,0,0,0-30.01855,20.89551,8.00013,8.00013,0,1,0,15.00585,5.55273A16.00278,16.00278,0,1,1,208,120H32a8,8,0,0,0,0,16H208a32,32,0,0,0,0-64Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M129.48449,192.32854A24.00285,24.00285,0,1,0,152,160H40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M97.48449,63.67146A24.00285,24.00285,0,1,1,120,96H24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M185.48449,95.67146A24.00285,24.00285,0,1,1,208,128H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M129.48449,192.32854A24.00285,24.00285,0,1,0,152,160H40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M97.48449,63.67146A24.00285,24.00285,0,1,1,120,96H24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M185.48449,95.67146A24.00285,24.00285,0,1,1,208,128H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M129.48449,192.32854A24.00285,24.00285,0,1,0,152,160H40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M97.48449,63.67146A24.00285,24.00285,0,1,1,120,96H24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M185.48449,95.67146A24.00285,24.00285,0,1,1,208,128H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dS = [];
/* style */

const __vue_inject_styles__$dS = undefined;
/* scoped */

const __vue_scope_id__$dS = undefined;
/* module identifier */

const __vue_module_identifier__$dS = undefined;
/* functional template */

const __vue_is_functional_template__$dS = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dS = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dS,
  staticRenderFns: __vue_staticRenderFns__$dS
}, __vue_inject_styles__$dS, __vue_script__$dS, __vue_scope_id__$dS, __vue_is_functional_template__$dS, __vue_module_identifier__$dS, false, undefined, undefined, undefined);

var script$dT = Vue.extend({
  name: "PhWindowsLogo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dT = script$dT;
/* template */

var __vue_render__$dT = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "100 108 100 61.091 40 72 40 108 100 108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "216 108 216 40 140 53.818 140 108 216 108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "100 148 100 194.909 40 184 40 148 100 148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "216 148 216 216 140 202.182 140 148 216 148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "216 216 136 201.455 136 201.455 136 144 216 144 216 216",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "104 195.636 40 184 40 144 104 144 104 195.636",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "216 40 136 54.545 136 54.545 136 112 216 112 216 40",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "104 60.364 40 72 40 112 104 112 104 60.364",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "216 216 136 201.455 136 201.455 136 144 216 144 216 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "104 195.636 40 184 40 144 104 144 104 195.636",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "216 40 136 54.545 136 54.545 136 112 216 112 216 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "104 60.364 40 72 40 112 104 112 104 60.364",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M112,144v51.63672a7.9983,7.9983,0,0,1-9.43115,7.87061l-64-11.63623A8.00019,8.00019,0,0,1,32,184V144a8.00008,8.00008,0,0,1,8-8h64A8.00008,8.00008,0,0,1,112,144ZM109.126,54.2217a7.995,7.995,0,0,0-6.55713-1.729l-64,11.63623A8.00017,8.00017,0,0,0,32,72v40a8.00008,8.00008,0,0,0,8,8h64a8.00008,8.00008,0,0,0,8-8V60.3633A7.99853,7.99853,0,0,0,109.126,54.2217ZM216,136H136a8.00008,8.00008,0,0,0-8,8v57.45459a7.99967,7.99967,0,0,0,6.56885,7.87061l80,14.5459A8.0001,8.0001,0,0,0,224,216V144A8.00008,8.00008,0,0,0,216,136Zm5.126-102.14209a7.99714,7.99714,0,0,0-6.55713-1.729l-80,14.5459A7.99965,7.99965,0,0,0,128,54.54543V112a8.00008,8.00008,0,0,0,8,8h80a8.00008,8.00008,0,0,0,8-8V40A8.00028,8.00028,0,0,0,221.126,33.85793Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "216 216 136 201.455 136 201.455 136 144 216 144 216 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "104 195.636 40 184 40 144 104 144 104 195.636",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "216 40 136 54.545 136 54.545 136 112 216 112 216 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "104 60.364 40 72 40 112 104 112 104 60.364",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "216 216 136 201.455 136 201.455 136 144 216 144 216 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "104 195.636 40 184 40 144 104 144 104 195.636",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "216 40 136 54.545 136 54.545 136 112 216 112 216 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "104 60.364 40 72 40 112 104 112 104 60.364",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "216 216 136 201.455 136 201.455 136 144 216 144 216 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "104 195.636 40 184 40 144 104 144 104 195.636",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "216 40 136 54.545 136 54.545 136 112 216 112 216 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "104 60.364 40 72 40 112 104 112 104 60.364",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dT = [];
/* style */

const __vue_inject_styles__$dT = undefined;
/* scoped */

const __vue_scope_id__$dT = undefined;
/* module identifier */

const __vue_module_identifier__$dT = undefined;
/* functional template */

const __vue_is_functional_template__$dT = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dT = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dT,
  staticRenderFns: __vue_staticRenderFns__$dT
}, __vue_inject_styles__$dT, __vue_script__$dT, __vue_scope_id__$dT, __vue_is_functional_template__$dT, __vue_module_identifier__$dT, false, undefined, undefined, undefined);

var script$dU = Vue.extend({
  name: "PhWine",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dU = script$dU;
/* template */

var __vue_render__$dU = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "176",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "232",
      "x2": "168",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,24h96l26.05817,88.278a23.979,23.979,0,0,1-1.1376,16.67254,80.03345,80.03345,0,0,1-145.841.00041A23.979,23.979,0,0,1,53.942,112.27835Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M57.48453,100.27689C68.083,94.644,92.7349,86.36745,128,104c37.55571,18.77785,63.07475,8.17173,72.402,2.66713",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200.402,106.66714l1.65622,5.61085a23.979,23.979,0,0,1-1.1376,16.67254,80.03345,80.03345,0,0,1-145.841.00041A23.979,23.979,0,0,1,53.942,112.27835l3.54259-12.00146h0C68.083,94.644,92.7349,86.36745,128,104c37.55571,18.77785,63.07475,8.17173,72.402,2.66713Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "176",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "232",
      "x2": "168",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,24h96l26.05817,88.278a23.979,23.979,0,0,1-1.1376,16.67254,80.03345,80.03345,0,0,1-145.841.00041A23.979,23.979,0,0,1,53.942,112.27835Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M57.48453,100.27689C68.083,94.644,92.7349,86.36745,128,104c37.55571,18.77785,63.07475,8.17173,72.402,2.66713",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M209.73047,110.01318,183.67285,21.73535A7.99985,7.99985,0,0,0,176,16H80a7.99985,7.99985,0,0,0-7.67285,5.73535L46.26953,110.01367A31.984,31.984,0,0,0,47.791,132.24951,88.23263,88.23263,0,0,0,120,183.62012V224H88a8,8,0,0,0,0,16h80a8,8,0,0,0,0-16H136V183.62012a88.2322,88.2322,0,0,0,72.209-51.3711A31.98167,31.98167,0,0,0,209.73047,110.01318ZM131.57764,96.84473C105.398,83.75488,84.38428,83.76318,69.66943,87.25586L85.97949,32h84.041l20.8125,70.5083C180.05664,107.001,159.75586,110.93359,131.57764,96.84473Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "176",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "232",
      "x2": "168",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,24h96l26.05817,88.278a23.979,23.979,0,0,1-1.1376,16.67254,80.03345,80.03345,0,0,1-145.841.00041A23.979,23.979,0,0,1,53.942,112.27835Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M57.48453,100.27689C68.083,94.644,92.7349,86.36745,128,104c37.55571,18.77785,63.07475,8.17173,72.402,2.66713",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "176",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "232",
      "x2": "168",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,24h96l26.05817,88.278a23.979,23.979,0,0,1-1.1376,16.67254,80.03345,80.03345,0,0,1-145.841.00041A23.979,23.979,0,0,1,53.942,112.27835Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M57.48453,100.27689C68.083,94.644,92.7349,86.36745,128,104c37.55571,18.77785,63.07475,8.17173,72.402,2.66713",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "176",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "232",
      "x2": "168",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,24h96l26.05817,88.278a23.979,23.979,0,0,1-1.1376,16.67254,80.03345,80.03345,0,0,1-145.841.00041A23.979,23.979,0,0,1,53.942,112.27835Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M57.48453,100.27689C68.083,94.644,92.7349,86.36745,128,104c37.55571,18.77785,63.07475,8.17173,72.402,2.66713",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dU = [];
/* style */

const __vue_inject_styles__$dU = undefined;
/* scoped */

const __vue_scope_id__$dU = undefined;
/* module identifier */

const __vue_module_identifier__$dU = undefined;
/* functional template */

const __vue_is_functional_template__$dU = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dU = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dU,
  staticRenderFns: __vue_staticRenderFns__$dU
}, __vue_inject_styles__$dU, __vue_script__$dU, __vue_scope_id__$dU, __vue_is_functional_template__$dU, __vue_module_identifier__$dU, false, undefined, undefined, undefined);

var script$dV = Vue.extend({
  name: "PhWrench",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dV = script$dV;
/* template */

var __vue_render__$dV = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M184.99131,37.06756,143.02944,79.02944l5.65685,28.28427,28.28427,5.65685,41.96188-41.96187.0041-.00174a64.02489,64.02489,0,0,1-89.88113,81.03367l.00123-.00214L72.97056,216.97056a24,24,0,0,1-33.94112-33.94112L103.9608,126.944l-.00137.0007a64.02489,64.02489,0,0,1,81.03363-89.88122Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M184.99131,37.06756,143.02944,79.02944l5.65685,28.28427,28.28427,5.65685,41.96188-41.96187.0041-.00174a64.02489,64.02489,0,0,1-89.88113,81.03367l.00123-.00214L72.97056,216.97056a24,24,0,0,1-33.94112-33.94112L103.9608,126.944l-.00137.0007a64.02489,64.02489,0,0,1,81.03363-89.88122Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184.99131,37.06756,143.02944,79.02944l5.65685,28.28427,28.28427,5.65685,41.96188-41.96187.0041-.00174a64.02489,64.02489,0,0,1-89.88113,81.03367l.00123-.00214L72.97056,216.97056a24,24,0,0,1-33.94112-33.94112L103.9608,126.944l-.00137.0007a64.02489,64.02489,0,0,1,81.03363-89.88122Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M210.91162,146.91211a72.37653,72.37653,0,0,1-79.84424,15.03613L79.0249,222.2002q-.19116.22119-.39746.42773a32.00021,32.00021,0,0,1-45.25537-45.25488c.1377-.1377.28076-.27051.42773-.39844l60.25293-52.043a72.02489,72.02489,0,0,1,94.06153-95.23437A8.004,8.004,0,0,1,190.648,42.72461L151.71387,81.6582l3.77148,18.85645,18.856,3.77148,38.93457-38.93457a8.00429,8.00429,0,0,1,13.02685,2.53418A71.72729,71.72729,0,0,1,210.91162,146.91211Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M184.99131,37.06756,143.02944,79.02944l5.65685,28.28427,28.28427,5.65685,41.96188-41.96187.0041-.00174a64.02489,64.02489,0,0,1-89.88113,81.03367l.00123-.00214L72.97056,216.97056a24,24,0,0,1-33.94112-33.94112L103.9608,126.944l-.00137.0007a64.02489,64.02489,0,0,1,81.03363-89.88122Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M184.99131,37.06756,143.02944,79.02944l5.65685,28.28427,28.28427,5.65685,41.96188-41.96187.0041-.00174a64.02489,64.02489,0,0,1-89.88113,81.03367l.00123-.00214L72.97056,216.97056a24,24,0,0,1-33.94112-33.94112L103.9608,126.944l-.00137.0007a64.02489,64.02489,0,0,1,81.03363-89.88122Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M184.99131,37.06756,143.02944,79.02944l5.65685,28.28427,28.28427,5.65685,41.96188-41.96187.0041-.00174a64.02489,64.02489,0,0,1-89.88113,81.03367l.00123-.00214L72.97056,216.97056a24,24,0,0,1-33.94112-33.94112L103.9608,126.944l-.00137.0007a64.02489,64.02489,0,0,1,81.03363-89.88122Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dV = [];
/* style */

const __vue_inject_styles__$dV = undefined;
/* scoped */

const __vue_scope_id__$dV = undefined;
/* module identifier */

const __vue_module_identifier__$dV = undefined;
/* functional template */

const __vue_is_functional_template__$dV = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dV = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dV,
  staticRenderFns: __vue_staticRenderFns__$dV
}, __vue_inject_styles__$dV, __vue_script__$dV, __vue_scope_id__$dV, __vue_is_functional_template__$dV, __vue_module_identifier__$dV, false, undefined, undefined, undefined);

var script$dW = Vue.extend({
  name: "PhX",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dW = script$dW;
/* template */

var __vue_render__$dW = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "200",
      "y1": "56",
      "x2": "56",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "200",
      "x2": "56",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "200",
      "y1": "56",
      "x2": "56",
      "y2": "200",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "200",
      "x2": "56",
      "y2": "56",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M139.31348,128l66.34326-66.34326a7.99984,7.99984,0,0,0-11.31348-11.31348L128,116.68652,61.65674,50.34326A7.99984,7.99984,0,0,0,50.34326,61.65674L116.68652,128,50.34326,194.34326a7.99984,7.99984,0,1,0,11.31348,11.31348L128,139.31348l66.34326,66.34326a7.99984,7.99984,0,0,0,11.31348-11.31348Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "200",
      "y1": "56",
      "x2": "56",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "200",
      "x2": "56",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "200",
      "y1": "56",
      "x2": "56",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "200",
      "x2": "56",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "200",
      "y1": "56",
      "x2": "56",
      "y2": "200",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "200",
      "x2": "56",
      "y2": "56",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dW = [];
/* style */

const __vue_inject_styles__$dW = undefined;
/* scoped */

const __vue_scope_id__$dW = undefined;
/* module identifier */

const __vue_module_identifier__$dW = undefined;
/* functional template */

const __vue_is_functional_template__$dW = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dW = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dW,
  staticRenderFns: __vue_staticRenderFns__$dW
}, __vue_inject_styles__$dW, __vue_script__$dW, __vue_scope_id__$dW, __vue_is_functional_template__$dW, __vue_module_identifier__$dW, false, undefined, undefined, undefined);

var script$dX = Vue.extend({
  name: "PhXCircle",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dX = script$dX;
/* template */

var __vue_render__$dX = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "96",
      "x2": "96",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "160",
      "x2": "96",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "96",
      "x2": "96",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "160",
      "x2": "96",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.12041,104.12041,0,0,0,128,24Zm37.65625,130.34375a7.99915,7.99915,0,1,1-11.3125,11.3125L128,139.3125l-26.34375,26.34375a7.99915,7.99915,0,0,1-11.3125-11.3125L116.6875,128,90.34375,101.65625a7.99915,7.99915,0,0,1,11.3125-11.3125L128,116.6875l26.34375-26.34375a7.99915,7.99915,0,0,1,11.3125,11.3125L139.3125,128Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "96",
      "x2": "96",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "160",
      "x2": "96",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "96",
      "x2": "96",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "160",
      "x2": "96",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "96",
      "x2": "96",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "160",
      "x2": "96",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dX = [];
/* style */

const __vue_inject_styles__$dX = undefined;
/* scoped */

const __vue_scope_id__$dX = undefined;
/* module identifier */

const __vue_module_identifier__$dX = undefined;
/* functional template */

const __vue_is_functional_template__$dX = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dX = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dX,
  staticRenderFns: __vue_staticRenderFns__$dX
}, __vue_inject_styles__$dX, __vue_script__$dX, __vue_scope_id__$dX, __vue_is_functional_template__$dX, __vue_module_identifier__$dX, false, undefined, undefined, undefined);

var script$dY = Vue.extend({
  name: "PhXSquare",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dY = script$dY;
/* template */

var __vue_render__$dY = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "160",
      "y1": "96",
      "x2": "96",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "160",
      "x2": "96",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "24",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "96",
      "x2": "96",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "160",
      "x2": "96",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208.00146,32h-160a16.01582,16.01582,0,0,0-16,16V208a16.01583,16.01583,0,0,0,16,16h160a16.01582,16.01582,0,0,0,16-16V48A16.01581,16.01581,0,0,0,208.00146,32ZM165.65771,154.34375a7.99915,7.99915,0,1,1-11.3125,11.3125L128.00146,139.3125l-26.34375,26.34375a7.99915,7.99915,0,0,1-11.3125-11.3125L116.689,128,90.34521,101.65625a7.99915,7.99915,0,0,1,11.3125-11.3125l26.34375,26.34375,26.34375-26.34375a7.99915,7.99915,0,0,1,11.3125,11.3125L139.314,128Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "160",
      "y1": "96",
      "x2": "96",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "160",
      "x2": "96",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "12",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "160",
      "y1": "96",
      "x2": "96",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "160",
      "x2": "96",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "8",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "160",
      "y1": "96",
      "x2": "96",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "160",
      "x2": "96",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "stroke-width": "16",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dY = [];
/* style */

const __vue_inject_styles__$dY = undefined;
/* scoped */

const __vue_scope_id__$dY = undefined;
/* module identifier */

const __vue_module_identifier__$dY = undefined;
/* functional template */

const __vue_is_functional_template__$dY = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dY = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dY,
  staticRenderFns: __vue_staticRenderFns__$dY
}, __vue_inject_styles__$dY, __vue_script__$dY, __vue_scope_id__$dY, __vue_is_functional_template__$dY, __vue_module_identifier__$dY, false, undefined, undefined, undefined);

var script$dZ = Vue.extend({
  name: "PhYoutubeLogo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight !== null && weight !== void 0 ? weight : contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size !== null && size !== void 0 ? size : contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color !== null && color !== void 0 ? color : contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return (mirrored !== null && mirrored !== void 0 ? mirrored : contextMirrored) ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dZ = script$dZ;
/* template */

var __vue_render__$dZ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "164 128 108 92 108 164 164 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,128c0,29.75546,3.07414,47.21382,5.41108,56.18664a15.91682,15.91682,0,0,0,9.63282,10.89441C72.52083,207.94575,128,207.5925,128,207.5925s55.47857.35324,88.9558-12.51137a15.91684,15.91684,0,0,0,9.6329-10.89432C228.92572,175.214,232,157.75554,232,128s-3.07415-47.21382-5.41108-56.18664A15.91682,15.91682,0,0,0,216.9561,60.919C183.47917,48.05425,128,48.4075,128,48.4075s-55.47857-.35324-88.9558,12.51137a15.91684,15.91684,0,0,0-9.6329,10.89432C27.07427,80.786,24,98.24446,24,128Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M226.58887,71.81348A15.91692,15.91692,0,0,0,216.95605,60.919C183.479,48.0542,128,48.40747,128,48.40747S72.52148,48.0542,39.044,60.919a15.91766,15.91766,0,0,0-9.63282,10.89428C27.07422,80.78613,24,98.24438,24,128c0,29.75537,3.07422,47.21387,5.41113,56.18652A15.91692,15.91692,0,0,0,39.044,195.08105C72.521,207.9458,128,207.59253,128,207.59253s55.47852.35327,88.95605-12.51148a15.91655,15.91655,0,0,0,9.63282-10.89428C228.92578,175.21387,232,157.75562,232,128,232,98.24463,228.92578,80.78613,226.58887,71.81348ZM112,160V96l48,32Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "160 128 112 96 112 160 160 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,128c0,29.75546,3.07414,47.21382,5.41108,56.18664a15.91682,15.91682,0,0,0,9.63282,10.89441C72.52083,207.94575,128,207.5925,128,207.5925s55.47857.35324,88.9558-12.51137a15.91684,15.91684,0,0,0,9.6329-10.89432C228.92572,175.214,232,157.75554,232,128s-3.07415-47.21382-5.41108-56.18664A15.91682,15.91682,0,0,0,216.9561,60.919C183.47917,48.05425,128,48.4075,128,48.4075s-55.47857-.35324-88.9558,12.51137a15.91684,15.91684,0,0,0-9.6329,10.89432C27.07427,80.786,24,98.24446,24,128Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M234.33057,69.79736a23.96369,23.96369,0,0,0-14.50489-16.34619C185.55615,40.28223,130.97949,40.39209,128,40.40771c-2.978-.02392-57.55518-.126-91.8252,13.04346A23.96415,23.96415,0,0,0,21.66992,69.79639C19.083,79.72705,16,97.88574,16,128c0,30.11377,3.083,48.27246,5.66943,58.20264a23.96369,23.96369,0,0,0,14.50489,16.34619c32.80615,12.60693,84.22168,13.04541,91.167,13.04541.6206.00049.69678.00049,1.31738,0,6.95069-.00049,58.36231-.43945,91.16651-13.04541a23.96415,23.96415,0,0,0,14.50488-16.34522C236.917,176.273,240,158.11426,240,128,240,97.88623,236.917,79.72754,234.33057,69.79736Zm-72.11182,61.53076-48,32A3.99967,3.99967,0,0,1,108,160V96a3.99968,3.99968,0,0,1,6.21875-3.32813l48,32a3.99979,3.99979,0,0,1,0,6.65625Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "160 128 112 96 112 160 160 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,128c0,29.75546,3.07414,47.21382,5.41108,56.18664a15.91682,15.91682,0,0,0,9.63282,10.89441C72.52083,207.94575,128,207.5925,128,207.5925s55.47857.35324,88.9558-12.51137a15.91684,15.91684,0,0,0,9.6329-10.89432C228.92572,175.214,232,157.75554,232,128s-3.07415-47.21382-5.41108-56.18664A15.91682,15.91682,0,0,0,216.9561,60.919C183.47917,48.05425,128,48.4075,128,48.4075s-55.47857-.35324-88.9558,12.51137a15.91684,15.91684,0,0,0-9.6329,10.89432C27.07427,80.786,24,98.24446,24,128Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "160 128 112 96 112 160 160 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,128c0,29.75546,3.07414,47.21382,5.41108,56.18664a15.91682,15.91682,0,0,0,9.63282,10.89441C72.52083,207.94575,128,207.5925,128,207.5925s55.47857.35324,88.9558-12.51137a15.91684,15.91684,0,0,0,9.6329-10.89432C228.92572,175.214,232,157.75554,232,128s-3.07415-47.21382-5.41108-56.18664A15.91682,15.91682,0,0,0,216.9561,60.919C183.47917,48.05425,128,48.4075,128,48.4075s-55.47857-.35324-88.9558,12.51137a15.91684,15.91684,0,0,0-9.6329,10.89432C27.07427,80.786,24,98.24446,24,128Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "160 128 112 96 112 160 160 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,128c0,29.75546,3.07414,47.21382,5.41108,56.18664a15.91682,15.91682,0,0,0,9.63282,10.89441C72.52083,207.94575,128,207.5925,128,207.5925s55.47857.35324,88.9558-12.51137a15.91684,15.91684,0,0,0,9.6329-10.89432C228.92572,175.214,232,157.75554,232,128s-3.07415-47.21382-5.41108-56.18664A15.91682,15.91682,0,0,0,216.9561,60.919C183.47917,48.05425,128,48.4075,128,48.4075s-55.47857-.35324-88.9558,12.51137a15.91684,15.91684,0,0,0-9.6329,10.89432C27.07427,80.786,24,98.24446,24,128Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dZ = [];
/* style */

const __vue_inject_styles__$dZ = undefined;
/* scoped */

const __vue_scope_id__$dZ = undefined;
/* module identifier */

const __vue_module_identifier__$dZ = undefined;
/* functional template */

const __vue_is_functional_template__$dZ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dZ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dZ,
  staticRenderFns: __vue_staticRenderFns__$dZ
}, __vue_inject_styles__$dZ, __vue_script__$dZ, __vue_scope_id__$dZ, __vue_is_functional_template__$dZ, __vue_module_identifier__$dZ, false, undefined, undefined, undefined);

/* eslint-disable import/prefer-default-export */

var components = /*#__PURE__*/Object.freeze({
  __proto__: null,
  PhActivity: __vue_component__,
  PhAddressBook: __vue_component__$1,
  PhAirplane: __vue_component__$2,
  PhAirplaneInFlight: __vue_component__$3,
  PhAirplaneLanding: __vue_component__$4,
  PhAirplaneTakeoff: __vue_component__$5,
  PhAirplaneTilt: __vue_component__$6,
  PhAirplay: __vue_component__$7,
  PhAlarm: __vue_component__$8,
  PhAlignBottom: __vue_component__$9,
  PhAlignCenterHorizontal: __vue_component__$a,
  PhAlignCenterVertical: __vue_component__$b,
  PhAlignLeft: __vue_component__$c,
  PhAlignRight: __vue_component__$d,
  PhAlignTop: __vue_component__$e,
  PhAnchor: __vue_component__$f,
  PhAnchorSimple: __vue_component__$g,
  PhAndroidLogo: __vue_component__$h,
  PhAperture: __vue_component__$i,
  PhAppWindow: __vue_component__$j,
  PhAppleLogo: __vue_component__$k,
  PhArchive: __vue_component__$l,
  PhArchiveBox: __vue_component__$m,
  PhArchiveTray: __vue_component__$n,
  PhArmchair: __vue_component__$o,
  PhArrowArcLeft: __vue_component__$p,
  PhArrowArcRight: __vue_component__$q,
  PhArrowBendDoubleUpLeft: __vue_component__$r,
  PhArrowBendDoubleUpRight: __vue_component__$s,
  PhArrowBendDownLeft: __vue_component__$t,
  PhArrowBendDownRight: __vue_component__$u,
  PhArrowBendLeftDown: __vue_component__$v,
  PhArrowBendLeftUp: __vue_component__$w,
  PhArrowBendRightDown: __vue_component__$x,
  PhArrowBendRightUp: __vue_component__$y,
  PhArrowBendUpLeft: __vue_component__$z,
  PhArrowBendUpRight: __vue_component__$A,
  PhArrowCircleDown: __vue_component__$B,
  PhArrowCircleDownLeft: __vue_component__$C,
  PhArrowCircleDownRight: __vue_component__$D,
  PhArrowCircleLeft: __vue_component__$E,
  PhArrowCircleRight: __vue_component__$F,
  PhArrowCircleUp: __vue_component__$G,
  PhArrowCircleUpLeft: __vue_component__$H,
  PhArrowCircleUpRight: __vue_component__$I,
  PhArrowClockwise: __vue_component__$J,
  PhArrowCounterClockwise: __vue_component__$K,
  PhArrowDown: __vue_component__$L,
  PhArrowDownLeft: __vue_component__$M,
  PhArrowDownRight: __vue_component__$N,
  PhArrowElbowDownLeft: __vue_component__$O,
  PhArrowElbowDownRight: __vue_component__$P,
  PhArrowElbowLeft: __vue_component__$Q,
  PhArrowElbowLeftDown: __vue_component__$R,
  PhArrowElbowLeftUp: __vue_component__$S,
  PhArrowElbowRight: __vue_component__$T,
  PhArrowElbowRightDown: __vue_component__$U,
  PhArrowElbowRightUp: __vue_component__$V,
  PhArrowElbowUpLeft: __vue_component__$W,
  PhArrowElbowUpRight: __vue_component__$X,
  PhArrowFatDown: __vue_component__$Y,
  PhArrowFatLeft: __vue_component__$Z,
  PhArrowFatLineDown: __vue_component__$_,
  PhArrowFatLineLeft: __vue_component__$$,
  PhArrowFatLineRight: __vue_component__$10,
  PhArrowFatLineUp: __vue_component__$11,
  PhArrowFatLinesDown: __vue_component__$12,
  PhArrowFatLinesLeft: __vue_component__$13,
  PhArrowFatLinesRight: __vue_component__$14,
  PhArrowFatLinesUp: __vue_component__$15,
  PhArrowFatRight: __vue_component__$16,
  PhArrowFatUp: __vue_component__$17,
  PhArrowLeft: __vue_component__$18,
  PhArrowLineDown: __vue_component__$19,
  PhArrowLineDownLeft: __vue_component__$1a,
  PhArrowLineDownRight: __vue_component__$1b,
  PhArrowLineLeft: __vue_component__$1c,
  PhArrowLineRight: __vue_component__$1d,
  PhArrowLineUp: __vue_component__$1e,
  PhArrowLineUpLeft: __vue_component__$1f,
  PhArrowLineUpRight: __vue_component__$1g,
  PhArrowRight: __vue_component__$1h,
  PhArrowSquareDown: __vue_component__$1i,
  PhArrowSquareDownLeft: __vue_component__$1j,
  PhArrowSquareDownRight: __vue_component__$1k,
  PhArrowSquareIn: __vue_component__$1l,
  PhArrowSquareLeft: __vue_component__$1m,
  PhArrowSquareOut: __vue_component__$1n,
  PhArrowSquareRight: __vue_component__$1o,
  PhArrowSquareUp: __vue_component__$1p,
  PhArrowSquareUpLeft: __vue_component__$1q,
  PhArrowSquareUpRight: __vue_component__$1r,
  PhArrowUDownLeft: __vue_component__$1s,
  PhArrowUDownRight: __vue_component__$1t,
  PhArrowULeftDown: __vue_component__$1u,
  PhArrowULeftUp: __vue_component__$1v,
  PhArrowURightDown: __vue_component__$1w,
  PhArrowURightUp: __vue_component__$1x,
  PhArrowUUpLeft: __vue_component__$1y,
  PhArrowUUpRight: __vue_component__$1z,
  PhArrowUp: __vue_component__$1A,
  PhArrowUpLeft: __vue_component__$1B,
  PhArrowUpRight: __vue_component__$1C,
  PhArrowsClockwise: __vue_component__$1D,
  PhArrowsCounterClockwise: __vue_component__$1E,
  PhArrowsDownUp: __vue_component__$1F,
  PhArrowsIn: __vue_component__$1G,
  PhArrowsInCardinal: __vue_component__$1H,
  PhArrowsInLineHorizontal: __vue_component__$1I,
  PhArrowsInLineVertical: __vue_component__$1J,
  PhArrowsInSimple: __vue_component__$1K,
  PhArrowsLeftRight: __vue_component__$1L,
  PhArrowsOut: __vue_component__$1M,
  PhArrowsOutCardinal: __vue_component__$1N,
  PhArrowsOutLineHorizontal: __vue_component__$1O,
  PhArrowsOutLineVertical: __vue_component__$1P,
  PhArrowsOutSimple: __vue_component__$1Q,
  PhArticle: __vue_component__$1R,
  PhArticleMedium: __vue_component__$1S,
  PhArticleNyTimes: __vue_component__$1T,
  PhAsterisk: __vue_component__$1U,
  PhAt: __vue_component__$1V,
  PhAtom: __vue_component__$1W,
  PhBaby: __vue_component__$1X,
  PhBackspace: __vue_component__$1Y,
  PhBag: __vue_component__$1Z,
  PhBagSimple: __vue_component__$1_,
  PhBandaids: __vue_component__$1$,
  PhBank: __vue_component__$20,
  PhBarbell: __vue_component__$21,
  PhBarcode: __vue_component__$22,
  PhBaseball: __vue_component__$23,
  PhBasketball: __vue_component__$24,
  PhBatteryCharging: __vue_component__$25,
  PhBatteryChargingVertical: __vue_component__$26,
  PhBatteryEmpty: __vue_component__$27,
  PhBatteryFull: __vue_component__$28,
  PhBatteryHigh: __vue_component__$29,
  PhBatteryLow: __vue_component__$2a,
  PhBatteryMedium: __vue_component__$2b,
  PhBatteryWarning: __vue_component__$2c,
  PhBatteryWarningVertical: __vue_component__$2d,
  PhBed: __vue_component__$2e,
  PhBell: __vue_component__$2f,
  PhBellRinging: __vue_component__$2g,
  PhBellSimple: __vue_component__$2h,
  PhBellSimpleRinging: __vue_component__$2i,
  PhBellSimpleSlash: __vue_component__$2j,
  PhBellSimpleZ: __vue_component__$2k,
  PhBellSlash: __vue_component__$2l,
  PhBellZ: __vue_component__$2m,
  PhBicycle: __vue_component__$2n,
  PhBird: __vue_component__$2o,
  PhBluetooth: __vue_component__$2p,
  PhBluetoothConnected: __vue_component__$2q,
  PhBluetoothSlash: __vue_component__$2r,
  PhBluetoothX: __vue_component__$2s,
  PhBoat: __vue_component__$2t,
  PhBook: __vue_component__$2u,
  PhBookBookmark: __vue_component__$2v,
  PhBookOpen: __vue_component__$2w,
  PhBookmark: __vue_component__$2x,
  PhBookmarkSimple: __vue_component__$2y,
  PhBookmarks: __vue_component__$2z,
  PhBookmarksSimple: __vue_component__$2A,
  PhBooks: __vue_component__$2B,
  PhBoundingBox: __vue_component__$2C,
  PhBracketsAngle: __vue_component__$2D,
  PhBracketsCurly: __vue_component__$2E,
  PhBracketsRound: __vue_component__$2F,
  PhBracketsSquare: __vue_component__$2G,
  PhBrain: __vue_component__$2H,
  PhBrandy: __vue_component__$2I,
  PhBriefcase: __vue_component__$2J,
  PhBriefcaseMetal: __vue_component__$2K,
  PhBroadcast: __vue_component__$2L,
  PhBrowser: __vue_component__$2M,
  PhBrowsers: __vue_component__$2N,
  PhBug: __vue_component__$2O,
  PhBugBeetle: __vue_component__$2P,
  PhBugDroid: __vue_component__$2Q,
  PhBuildings: __vue_component__$2R,
  PhBus: __vue_component__$2S,
  PhCake: __vue_component__$2T,
  PhCalculator: __vue_component__$2U,
  PhCalendar: __vue_component__$2V,
  PhCalendarBlank: __vue_component__$2W,
  PhCalendarCheck: __vue_component__$2X,
  PhCalendarPlus: __vue_component__$2Y,
  PhCalendarX: __vue_component__$2Z,
  PhCamera: __vue_component__$2_,
  PhCameraSlash: __vue_component__$2$,
  PhCar: __vue_component__$30,
  PhCarSimple: __vue_component__$31,
  PhCardholder: __vue_component__$32,
  PhCards: __vue_component__$33,
  PhCaretCircleDoubleDown: __vue_component__$34,
  PhCaretCircleDoubleLeft: __vue_component__$35,
  PhCaretCircleDoubleRight: __vue_component__$36,
  PhCaretCircleDoubleUp: __vue_component__$37,
  PhCaretCircleDown: __vue_component__$38,
  PhCaretCircleLeft: __vue_component__$39,
  PhCaretCircleRight: __vue_component__$3a,
  PhCaretCircleUp: __vue_component__$3b,
  PhCaretDoubleDown: __vue_component__$3c,
  PhCaretDoubleLeft: __vue_component__$3d,
  PhCaretDoubleRight: __vue_component__$3e,
  PhCaretDoubleUp: __vue_component__$3f,
  PhCaretDown: __vue_component__$3g,
  PhCaretLeft: __vue_component__$3h,
  PhCaretRight: __vue_component__$3i,
  PhCaretUp: __vue_component__$3j,
  PhCat: __vue_component__$3k,
  PhCellSignalFull: __vue_component__$3l,
  PhCellSignalHigh: __vue_component__$3m,
  PhCellSignalLow: __vue_component__$3n,
  PhCellSignalMedium: __vue_component__$3o,
  PhCellSignalNone: __vue_component__$3p,
  PhCellSignalSlash: __vue_component__$3q,
  PhCellSignalX: __vue_component__$3r,
  PhChalkboard: __vue_component__$3s,
  PhChalkboardSimple: __vue_component__$3t,
  PhChalkboardTeacher: __vue_component__$3u,
  PhChartBar: __vue_component__$3v,
  PhChartBarHorizontal: __vue_component__$3w,
  PhChartLine: __vue_component__$3x,
  PhChartLineUp: __vue_component__$3y,
  PhChartPie: __vue_component__$3z,
  PhChartPieSlice: __vue_component__$3A,
  PhChat: __vue_component__$3B,
  PhChatCentered: __vue_component__$3C,
  PhChatCenteredDots: __vue_component__$3D,
  PhChatCenteredText: __vue_component__$3E,
  PhChatCircle: __vue_component__$3F,
  PhChatCircleDots: __vue_component__$3G,
  PhChatCircleText: __vue_component__$3H,
  PhChatDots: __vue_component__$3I,
  PhChatTeardrop: __vue_component__$3J,
  PhChatTeardropDots: __vue_component__$3K,
  PhChatTeardropText: __vue_component__$3L,
  PhChatText: __vue_component__$3M,
  PhChats: __vue_component__$3N,
  PhChatsCircle: __vue_component__$3O,
  PhChatsTeardrop: __vue_component__$3P,
  PhCheck: __vue_component__$3Q,
  PhCheckCircle: __vue_component__$3R,
  PhCheckSquare: __vue_component__$3S,
  PhCheckSquareOffset: __vue_component__$3T,
  PhChecks: __vue_component__$3U,
  PhCircle: __vue_component__$3V,
  PhCircleDashed: __vue_component__$3W,
  PhCircleHalf: __vue_component__$3X,
  PhCircleHalfTilt: __vue_component__$3Y,
  PhCircleWavy: __vue_component__$3Z,
  PhCircleWavyCheck: __vue_component__$3_,
  PhCircleWavyQuestion: __vue_component__$3$,
  PhCircleWavyWarning: __vue_component__$40,
  PhCirclesFour: __vue_component__$41,
  PhCirclesThree: __vue_component__$42,
  PhCirclesThreePlus: __vue_component__$43,
  PhClipboard: __vue_component__$44,
  PhClipboardText: __vue_component__$45,
  PhClock: __vue_component__$46,
  PhClockAfternoon: __vue_component__$47,
  PhClockClockwise: __vue_component__$48,
  PhClockCounterClockwise: __vue_component__$49,
  PhClosedCaptioning: __vue_component__$4a,
  PhCloud: __vue_component__$4b,
  PhCloudArrowDown: __vue_component__$4c,
  PhCloudArrowUp: __vue_component__$4d,
  PhCloudCheck: __vue_component__$4e,
  PhCloudFog: __vue_component__$4f,
  PhCloudLightning: __vue_component__$4g,
  PhCloudMoon: __vue_component__$4h,
  PhCloudRain: __vue_component__$4i,
  PhCloudSlash: __vue_component__$4j,
  PhCloudSnow: __vue_component__$4k,
  PhCloudSun: __vue_component__$4l,
  PhClub: __vue_component__$4m,
  PhCode: __vue_component__$4n,
  PhCodeSimple: __vue_component__$4o,
  PhCoffee: __vue_component__$4p,
  PhCoin: __vue_component__$4q,
  PhColumns: __vue_component__$4r,
  PhCommand: __vue_component__$4s,
  PhCompass: __vue_component__$4t,
  PhComputerTower: __vue_component__$4u,
  PhCookie: __vue_component__$4v,
  PhCookingPot: __vue_component__$4w,
  PhCopy: __vue_component__$4x,
  PhCopySimple: __vue_component__$4y,
  PhCopyright: __vue_component__$4z,
  PhCornersIn: __vue_component__$4A,
  PhCornersOut: __vue_component__$4B,
  PhCpu: __vue_component__$4C,
  PhCreditCard: __vue_component__$4D,
  PhCrop: __vue_component__$4E,
  PhCrosshair: __vue_component__$4F,
  PhCrosshairSimple: __vue_component__$4G,
  PhCrown: __vue_component__$4H,
  PhCrownSimple: __vue_component__$4I,
  PhCube: __vue_component__$4J,
  PhCurrencyBtc: __vue_component__$4K,
  PhCurrencyCircleDollar: __vue_component__$4L,
  PhCurrencyCny: __vue_component__$4M,
  PhCurrencyDollar: __vue_component__$4N,
  PhCurrencyDollarSimple: __vue_component__$4O,
  PhCurrencyEur: __vue_component__$4P,
  PhCurrencyGbp: __vue_component__$4Q,
  PhCurrencyInr: __vue_component__$4R,
  PhCurrencyJpy: __vue_component__$4S,
  PhCurrencyKrw: __vue_component__$4T,
  PhCurrencyRub: __vue_component__$4U,
  PhCursor: __vue_component__$4V,
  PhDatabase: __vue_component__$4W,
  PhDesktop: __vue_component__$4X,
  PhDesktopTower: __vue_component__$4Y,
  PhDeviceMobile: __vue_component__$4Z,
  PhDeviceMobileCamera: __vue_component__$4_,
  PhDeviceMobileSpeaker: __vue_component__$4$,
  PhDeviceTablet: __vue_component__$50,
  PhDeviceTabletCamera: __vue_component__$51,
  PhDeviceTabletSpeaker: __vue_component__$52,
  PhDiamond: __vue_component__$53,
  PhDiceFive: __vue_component__$54,
  PhDiceFour: __vue_component__$55,
  PhDiceOne: __vue_component__$56,
  PhDiceSix: __vue_component__$57,
  PhDiceThree: __vue_component__$58,
  PhDiceTwo: __vue_component__$59,
  PhDisc: __vue_component__$5a,
  PhDiscordLogo: __vue_component__$5b,
  PhDivide: __vue_component__$5c,
  PhDog: __vue_component__$5d,
  PhDoor: __vue_component__$5e,
  PhDotsNine: __vue_component__$5f,
  PhDotsSix: __vue_component__$5g,
  PhDotsSixVertical: __vue_component__$5h,
  PhDotsThree: __vue_component__$5i,
  PhDotsThreeCircle: __vue_component__$5j,
  PhDotsThreeCircleVertical: __vue_component__$5k,
  PhDotsThreeOutline: __vue_component__$5l,
  PhDotsThreeOutlineVertical: __vue_component__$5m,
  PhDotsThreeVertical: __vue_component__$5n,
  PhDownload: __vue_component__$5o,
  PhDownloadSimple: __vue_component__$5p,
  PhDribbbleLogo: __vue_component__$5q,
  PhDrop: __vue_component__$5r,
  PhDropHalf: __vue_component__$5s,
  PhEar: __vue_component__$5t,
  PhEarSlash: __vue_component__$5u,
  PhEject: __vue_component__$5v,
  PhEjectSimple: __vue_component__$5w,
  PhEnvelope: __vue_component__$5x,
  PhEnvelopeOpen: __vue_component__$5y,
  PhEnvelopeSimple: __vue_component__$5z,
  PhEnvelopeSimpleOpen: __vue_component__$5A,
  PhEquals: __vue_component__$5B,
  PhEraser: __vue_component__$5C,
  PhExport: __vue_component__$5D,
  PhEye: __vue_component__$5E,
  PhEyeClosed: __vue_component__$5F,
  PhEyeSlash: __vue_component__$5G,
  PhEyedropper: __vue_component__$5H,
  PhFaceMask: __vue_component__$5I,
  PhFacebookLogo: __vue_component__$5J,
  PhFactory: __vue_component__$5K,
  PhFaders: __vue_component__$5L,
  PhFadersHorizontal: __vue_component__$5M,
  PhFastForward: __vue_component__$5N,
  PhFastForwardCircle: __vue_component__$5O,
  PhFigmaLogo: __vue_component__$5P,
  PhFile: __vue_component__$5Q,
  PhFileArrowDown: __vue_component__$5R,
  PhFileArrowUp: __vue_component__$5S,
  PhFileDotted: __vue_component__$5T,
  PhFileMinus: __vue_component__$5U,
  PhFilePdf: __vue_component__$5V,
  PhFilePlus: __vue_component__$5W,
  PhFileSearch: __vue_component__$5X,
  PhFileText: __vue_component__$5Y,
  PhFileX: __vue_component__$5Z,
  PhFiles: __vue_component__$5_,
  PhFilmStrip: __vue_component__$5$,
  PhFingerprint: __vue_component__$60,
  PhFingerprintSimple: __vue_component__$61,
  PhFinnTheHuman: __vue_component__$62,
  PhFire: __vue_component__$63,
  PhFireSimple: __vue_component__$64,
  PhFirstAid: __vue_component__$65,
  PhFirstAidKit: __vue_component__$66,
  PhFish: __vue_component__$67,
  PhFishSimple: __vue_component__$68,
  PhFlag: __vue_component__$69,
  PhFlagBanner: __vue_component__$6a,
  PhFlame: __vue_component__$6b,
  PhFlashlight: __vue_component__$6c,
  PhFlask: __vue_component__$6d,
  PhFloppyDisk: __vue_component__$6e,
  PhFloppyDiskBack: __vue_component__$6f,
  PhFlowArrow: __vue_component__$6g,
  PhFlower: __vue_component__$6h,
  PhFlowerLotus: __vue_component__$6i,
  PhFolder: __vue_component__$6j,
  PhFolderMinus: __vue_component__$6k,
  PhFolderNotch: __vue_component__$6l,
  PhFolderNotchMinus: __vue_component__$6m,
  PhFolderNotchOpen: __vue_component__$6n,
  PhFolderNotchPlus: __vue_component__$6o,
  PhFolderOpen: __vue_component__$6p,
  PhFolderPlus: __vue_component__$6q,
  PhFolderSimple: __vue_component__$6r,
  PhFolderSimpleMinus: __vue_component__$6s,
  PhFolderSimplePlus: __vue_component__$6t,
  PhFolders: __vue_component__$6u,
  PhFootball: __vue_component__$6v,
  PhForkKnife: __vue_component__$6w,
  PhFrameCorners: __vue_component__$6x,
  PhFramerLogo: __vue_component__$6y,
  PhFunnel: __vue_component__$6z,
  PhFunnelSimple: __vue_component__$6A,
  PhGameController: __vue_component__$6B,
  PhGasPump: __vue_component__$6C,
  PhGauge: __vue_component__$6D,
  PhGear: __vue_component__$6E,
  PhGearSix: __vue_component__$6F,
  PhGenderFemale: __vue_component__$6G,
  PhGenderIntersex: __vue_component__$6H,
  PhGenderMale: __vue_component__$6I,
  PhGenderNeuter: __vue_component__$6J,
  PhGenderNonbinary: __vue_component__$6K,
  PhGenderTransgender: __vue_component__$6L,
  PhGhost: __vue_component__$6M,
  PhGif: __vue_component__$6N,
  PhGift: __vue_component__$6O,
  PhGitBranch: __vue_component__$6P,
  PhGitCommit: __vue_component__$6Q,
  PhGitDiff: __vue_component__$6R,
  PhGitFork: __vue_component__$6S,
  PhGitMerge: __vue_component__$6T,
  PhGitPullRequest: __vue_component__$6U,
  PhGithubLogo: __vue_component__$6V,
  PhGitlabLogo: __vue_component__$6W,
  PhGitlabLogoSimple: __vue_component__$6X,
  PhGlobe: __vue_component__$6Y,
  PhGlobeHemisphereEast: __vue_component__$6Z,
  PhGlobeHemisphereWest: __vue_component__$6_,
  PhGlobeSimple: __vue_component__$6$,
  PhGlobeStand: __vue_component__$70,
  PhGoogleLogo: __vue_component__$71,
  PhGooglePlayLogo: __vue_component__$72,
  PhGraduationCap: __vue_component__$73,
  PhGridFour: __vue_component__$74,
  PhHand: __vue_component__$75,
  PhHandFist: __vue_component__$76,
  PhHandGrabbing: __vue_component__$77,
  PhHandPalm: __vue_component__$78,
  PhHandPointing: __vue_component__$79,
  PhHandSoap: __vue_component__$7a,
  PhHandWaving: __vue_component__$7b,
  PhHandbag: __vue_component__$7c,
  PhHandbagSimple: __vue_component__$7d,
  PhHandsClapping: __vue_component__$7e,
  PhHandshake: __vue_component__$7f,
  PhHardDrive: __vue_component__$7g,
  PhHardDrives: __vue_component__$7h,
  PhHash: __vue_component__$7i,
  PhHashStraight: __vue_component__$7j,
  PhHeadlights: __vue_component__$7k,
  PhHeadphones: __vue_component__$7l,
  PhHeadset: __vue_component__$7m,
  PhHeart: __vue_component__$7n,
  PhHeartStraight: __vue_component__$7o,
  PhHeartbeat: __vue_component__$7p,
  PhHexagon: __vue_component__$7q,
  PhHighlighterCircle: __vue_component__$7r,
  PhHorse: __vue_component__$7s,
  PhHourglass: __vue_component__$7t,
  PhHourglassHigh: __vue_component__$7u,
  PhHourglassLow: __vue_component__$7v,
  PhHourglassMedium: __vue_component__$7w,
  PhHourglassSimple: __vue_component__$7x,
  PhHourglassSimpleHigh: __vue_component__$7y,
  PhHourglassSimpleLow: __vue_component__$7z,
  PhHourglassSimpleMedium: __vue_component__$7A,
  PhHouse: __vue_component__$7B,
  PhHouseLine: __vue_component__$7C,
  PhHouseSimple: __vue_component__$7D,
  PhIdentificationBadge: __vue_component__$7E,
  PhIdentificationCard: __vue_component__$7F,
  PhImage: __vue_component__$7G,
  PhImageSquare: __vue_component__$7H,
  PhInfinity: __vue_component__$7I,
  PhInfo: __vue_component__$7J,
  PhInstagramLogo: __vue_component__$7K,
  PhIntersect: __vue_component__$7L,
  PhJeep: __vue_component__$7M,
  PhKey: __vue_component__$7N,
  PhKeyReturn: __vue_component__$7O,
  PhKeyboard: __vue_component__$7P,
  PhKnife: __vue_component__$7Q,
  PhLamp: __vue_component__$7R,
  PhLaptop: __vue_component__$7S,
  PhLayout: __vue_component__$7T,
  PhLeaf: __vue_component__$7U,
  PhLifebuoy: __vue_component__$7V,
  PhLightbulb: __vue_component__$7W,
  PhLightbulbFilament: __vue_component__$7X,
  PhLightning: __vue_component__$7Y,
  PhLightningSlash: __vue_component__$7Z,
  PhLineSegment: __vue_component__$7_,
  PhLineSegments: __vue_component__$7$,
  PhLink: __vue_component__$80,
  PhLinkBreak: __vue_component__$81,
  PhLinkSimple: __vue_component__$82,
  PhLinkSimpleBreak: __vue_component__$83,
  PhLinkSimpleHorizontal: __vue_component__$84,
  PhLinkSimpleHorizontalBreak: __vue_component__$85,
  PhLinkedinLogo: __vue_component__$86,
  PhList: __vue_component__$87,
  PhListBullets: __vue_component__$88,
  PhListDashes: __vue_component__$89,
  PhListNumbers: __vue_component__$8a,
  PhListPlus: __vue_component__$8b,
  PhLock: __vue_component__$8c,
  PhLockKey: __vue_component__$8d,
  PhLockKeyOpen: __vue_component__$8e,
  PhLockLaminated: __vue_component__$8f,
  PhLockLaminatedOpen: __vue_component__$8g,
  PhLockOpen: __vue_component__$8h,
  PhLockSimple: __vue_component__$8i,
  PhLockSimpleOpen: __vue_component__$8j,
  PhMagicWand: __vue_component__$8k,
  PhMagnet: __vue_component__$8l,
  PhMagnetStraight: __vue_component__$8m,
  PhMagnifyingGlass: __vue_component__$8n,
  PhMagnifyingGlassMinus: __vue_component__$8o,
  PhMagnifyingGlassPlus: __vue_component__$8p,
  PhMapPin: __vue_component__$8q,
  PhMapPinLine: __vue_component__$8r,
  PhMapTrifold: __vue_component__$8s,
  PhMarkerCircle: __vue_component__$8t,
  PhMartini: __vue_component__$8u,
  PhMathOperations: __vue_component__$8v,
  PhMedal: __vue_component__$8w,
  PhMediumLogo: __vue_component__$8x,
  PhMegaphone: __vue_component__$8y,
  PhMegaphoneSimple: __vue_component__$8z,
  PhMessengerLogo: __vue_component__$8A,
  PhMicrophone: __vue_component__$8B,
  PhMicrophoneSlash: __vue_component__$8C,
  PhMinus: __vue_component__$8D,
  PhMinusCircle: __vue_component__$8E,
  PhMoney: __vue_component__$8F,
  PhMonitor: __vue_component__$8G,
  PhMonitorPlay: __vue_component__$8H,
  PhMoon: __vue_component__$8I,
  PhMoonStars: __vue_component__$8J,
  PhMouse: __vue_component__$8K,
  PhMouseSimple: __vue_component__$8L,
  PhMusicNote: __vue_component__$8M,
  PhMusicNoteSimple: __vue_component__$8N,
  PhMusicNotes: __vue_component__$8O,
  PhMusicNotesSimple: __vue_component__$8P,
  PhNavigationArrow: __vue_component__$8Q,
  PhNewspaper: __vue_component__$8R,
  PhNewspaperClipping: __vue_component__$8S,
  PhNote: __vue_component__$8T,
  PhNoteBlank: __vue_component__$8U,
  PhNotePencil: __vue_component__$8V,
  PhNotebook: __vue_component__$8W,
  PhNotepad: __vue_component__$8X,
  PhNotification: __vue_component__$8Y,
  PhNumberCircleEight: __vue_component__$8Z,
  PhNumberCircleFive: __vue_component__$8_,
  PhNumberCircleFour: __vue_component__$8$,
  PhNumberCircleNine: __vue_component__$90,
  PhNumberCircleOne: __vue_component__$91,
  PhNumberCircleSeven: __vue_component__$92,
  PhNumberCircleSix: __vue_component__$93,
  PhNumberCircleThree: __vue_component__$94,
  PhNumberCircleTwo: __vue_component__$95,
  PhNumberCircleZero: __vue_component__$96,
  PhNumberEight: __vue_component__$97,
  PhNumberFive: __vue_component__$98,
  PhNumberFour: __vue_component__$99,
  PhNumberNine: __vue_component__$9a,
  PhNumberOne: __vue_component__$9b,
  PhNumberSeven: __vue_component__$9c,
  PhNumberSix: __vue_component__$9d,
  PhNumberSquareEight: __vue_component__$9e,
  PhNumberSquareFive: __vue_component__$9f,
  PhNumberSquareFour: __vue_component__$9g,
  PhNumberSquareNine: __vue_component__$9h,
  PhNumberSquareOne: __vue_component__$9i,
  PhNumberSquareSeven: __vue_component__$9j,
  PhNumberSquareSix: __vue_component__$9k,
  PhNumberSquareThree: __vue_component__$9l,
  PhNumberSquareTwo: __vue_component__$9m,
  PhNumberSquareZero: __vue_component__$9n,
  PhNumberThree: __vue_component__$9o,
  PhNumberTwo: __vue_component__$9p,
  PhNumberZero: __vue_component__$9q,
  PhNut: __vue_component__$9r,
  PhNyTimesLogo: __vue_component__$9s,
  PhOctagon: __vue_component__$9t,
  PhPackage: __vue_component__$9u,
  PhPaintBrush: __vue_component__$9v,
  PhPaintBrushBroad: __vue_component__$9w,
  PhPaintBrushHousehold: __vue_component__$9x,
  PhPaintBucket: __vue_component__$9y,
  PhPaintRoller: __vue_component__$9z,
  PhPalette: __vue_component__$9A,
  PhPaperPlane: __vue_component__$9B,
  PhPaperPlaneRight: __vue_component__$9C,
  PhPaperPlaneTilt: __vue_component__$9D,
  PhPaperclip: __vue_component__$9E,
  PhPaperclipHorizontal: __vue_component__$9F,
  PhPath: __vue_component__$9G,
  PhPause: __vue_component__$9H,
  PhPauseCircle: __vue_component__$9I,
  PhPawPrint: __vue_component__$9J,
  PhPeace: __vue_component__$9K,
  PhPen: __vue_component__$9L,
  PhPenNib: __vue_component__$9M,
  PhPenNibStraight: __vue_component__$9N,
  PhPencil: __vue_component__$9O,
  PhPencilCircle: __vue_component__$9P,
  PhPencilLine: __vue_component__$9Q,
  PhPencilSimple: __vue_component__$9R,
  PhPercent: __vue_component__$9S,
  PhPerson: __vue_component__$9T,
  PhPersonSimple: __vue_component__$9U,
  PhPersonSimpleRun: __vue_component__$9V,
  PhPersonSimpleWalk: __vue_component__$9W,
  PhPhone: __vue_component__$9X,
  PhPhoneCall: __vue_component__$9Y,
  PhPhoneDisconnect: __vue_component__$9Z,
  PhPhoneIncoming: __vue_component__$9_,
  PhPhoneOutgoing: __vue_component__$9$,
  PhPhoneSlash: __vue_component__$a0,
  PhPhoneX: __vue_component__$a1,
  PhPhosphorLogo: __vue_component__$a2,
  PhPictureInPicture: __vue_component__$a3,
  PhPill: __vue_component__$a4,
  PhPinterestLogo: __vue_component__$a5,
  PhPizza: __vue_component__$a6,
  PhPlaceholder: __vue_component__$a7,
  PhPlanet: __vue_component__$a8,
  PhPlay: __vue_component__$a9,
  PhPlayCircle: __vue_component__$aa,
  PhPlaylist: __vue_component__$ab,
  PhPlus: __vue_component__$ac,
  PhPlusCircle: __vue_component__$ad,
  PhPlusMinus: __vue_component__$ae,
  PhPokerChip: __vue_component__$af,
  PhPolygon: __vue_component__$ag,
  PhPower: __vue_component__$ah,
  PhPrescription: __vue_component__$ai,
  PhPresentation: __vue_component__$aj,
  PhPresentationChart: __vue_component__$ak,
  PhPrinter: __vue_component__$al,
  PhProhibit: __vue_component__$am,
  PhProhibitInset: __vue_component__$an,
  PhProjectorScreen: __vue_component__$ao,
  PhProjectorScreenChart: __vue_component__$ap,
  PhPushPin: __vue_component__$aq,
  PhPushPinSimple: __vue_component__$ar,
  PhPushPinSimpleSlash: __vue_component__$as,
  PhPushPinSlash: __vue_component__$at,
  PhPuzzlePiece: __vue_component__$au,
  PhQrCode: __vue_component__$av,
  PhQuestion: __vue_component__$aw,
  PhQueue: __vue_component__$ax,
  PhQuotes: __vue_component__$ay,
  PhRadical: __vue_component__$az,
  PhRadio: __vue_component__$aA,
  PhRainbow: __vue_component__$aB,
  PhRainbowCloud: __vue_component__$aC,
  PhReceipt: __vue_component__$aD,
  PhRecord: __vue_component__$aE,
  PhRectangle: __vue_component__$aF,
  PhRecycle: __vue_component__$aG,
  PhRedditLogo: __vue_component__$aH,
  PhRepeat: __vue_component__$aI,
  PhRepeatOnce: __vue_component__$aJ,
  PhRewind: __vue_component__$aK,
  PhRewindCircle: __vue_component__$aL,
  PhRobot: __vue_component__$aM,
  PhRocket: __vue_component__$aN,
  PhRocketLaunch: __vue_component__$aO,
  PhRows: __vue_component__$aP,
  PhRss: __vue_component__$aQ,
  PhRssSimple: __vue_component__$aR,
  PhRuler: __vue_component__$aS,
  PhScales: __vue_component__$aT,
  PhScissors: __vue_component__$aU,
  PhScreencast: __vue_component__$aV,
  PhScribbleLoop: __vue_component__$aW,
  PhSelection: __vue_component__$aX,
  PhSelectionAll: __vue_component__$aY,
  PhSelectionBackground: __vue_component__$aZ,
  PhSelectionForeground: __vue_component__$a_,
  PhSelectionInverse: __vue_component__$a$,
  PhSelectionPlus: __vue_component__$b0,
  PhSelectionSlash: __vue_component__$b1,
  PhShare: __vue_component__$b2,
  PhShareNetwork: __vue_component__$b3,
  PhShield: __vue_component__$b4,
  PhShieldCheck: __vue_component__$b5,
  PhShieldCheckered: __vue_component__$b6,
  PhShieldChevron: __vue_component__$b7,
  PhShieldPlus: __vue_component__$b8,
  PhShieldSlash: __vue_component__$b9,
  PhShieldWarning: __vue_component__$ba,
  PhShoppingBag: __vue_component__$bb,
  PhShoppingBagOpen: __vue_component__$bc,
  PhShoppingCart: __vue_component__$bd,
  PhShoppingCartSimple: __vue_component__$be,
  PhShower: __vue_component__$bf,
  PhShuffle: __vue_component__$bg,
  PhShuffleAngular: __vue_component__$bh,
  PhShuffleSimple: __vue_component__$bi,
  PhSignIn: __vue_component__$bj,
  PhSignOut: __vue_component__$bk,
  PhSimCard: __vue_component__$bl,
  PhSketchLogo: __vue_component__$bm,
  PhSkipBack: __vue_component__$bn,
  PhSkipBackCircle: __vue_component__$bo,
  PhSkipForward: __vue_component__$bp,
  PhSkipForwardCircle: __vue_component__$bq,
  PhSlackLogo: __vue_component__$br,
  PhSliders: __vue_component__$bs,
  PhSlidersHorizontal: __vue_component__$bt,
  PhSmiley: __vue_component__$bu,
  PhSmileyBlank: __vue_component__$bv,
  PhSmileyMeh: __vue_component__$bw,
  PhSmileyNervous: __vue_component__$bx,
  PhSmileySad: __vue_component__$by,
  PhSmileySticker: __vue_component__$bz,
  PhSmileyWink: __vue_component__$bA,
  PhSmileyXEyes: __vue_component__$bB,
  PhSnapchatLogo: __vue_component__$bC,
  PhSnowflake: __vue_component__$bD,
  PhSoccerBall: __vue_component__$bE,
  PhSortAscending: __vue_component__$bF,
  PhSortDescending: __vue_component__$bG,
  PhSpade: __vue_component__$bH,
  PhSparkle: __vue_component__$bI,
  PhSpeakerHigh: __vue_component__$bJ,
  PhSpeakerLow: __vue_component__$bK,
  PhSpeakerNone: __vue_component__$bL,
  PhSpeakerSimpleHigh: __vue_component__$bM,
  PhSpeakerSimpleLow: __vue_component__$bN,
  PhSpeakerSimpleNone: __vue_component__$bO,
  PhSpeakerSimpleSlash: __vue_component__$bP,
  PhSpeakerSimpleX: __vue_component__$bQ,
  PhSpeakerSlash: __vue_component__$bR,
  PhSpeakerX: __vue_component__$bS,
  PhSpinner: __vue_component__$bT,
  PhSpinnerGap: __vue_component__$bU,
  PhSpotifyLogo: __vue_component__$bV,
  PhSquare: __vue_component__$bW,
  PhSquareHalf: __vue_component__$bX,
  PhSquareLogo: __vue_component__$bY,
  PhSquaresFour: __vue_component__$bZ,
  PhStack: __vue_component__$b_,
  PhStackSimple: __vue_component__$b$,
  PhStar: __vue_component__$c0,
  PhStarFour: __vue_component__$c1,
  PhStarHalf: __vue_component__$c2,
  PhSticker: __vue_component__$c3,
  PhStop: __vue_component__$c4,
  PhStopCircle: __vue_component__$c5,
  PhStorefront: __vue_component__$c6,
  PhStripeLogo: __vue_component__$c7,
  PhStudent: __vue_component__$c8,
  PhSuitcase: __vue_component__$c9,
  PhSuitcaseSimple: __vue_component__$ca,
  PhSun: __vue_component__$cb,
  PhSunDim: __vue_component__$cc,
  PhSunHorizon: __vue_component__$cd,
  PhSwap: __vue_component__$ce,
  PhSwatches: __vue_component__$cf,
  PhSword: __vue_component__$cg,
  PhTShirt: __vue_component__$ch,
  PhTable: __vue_component__$ci,
  PhTag: __vue_component__$cj,
  PhTagChevron: __vue_component__$ck,
  PhTagSimple: __vue_component__$cl,
  PhTarget: __vue_component__$cm,
  PhTelegramLogo: __vue_component__$cn,
  PhTelevision: __vue_component__$co,
  PhTelevisionSimple: __vue_component__$cp,
  PhTennisBall: __vue_component__$cq,
  PhTerminal: __vue_component__$cr,
  PhTerminalWindow: __vue_component__$cs,
  PhTestTube: __vue_component__$ct,
  PhTextAa: __vue_component__$cu,
  PhTextAlignCenter: __vue_component__$cv,
  PhTextAlignJustify: __vue_component__$cw,
  PhTextAlignLeft: __vue_component__$cx,
  PhTextAlignRight: __vue_component__$cy,
  PhTextBolder: __vue_component__$cz,
  PhTextH: __vue_component__$cA,
  PhTextHFive: __vue_component__$cB,
  PhTextHFour: __vue_component__$cC,
  PhTextHOne: __vue_component__$cD,
  PhTextHSix: __vue_component__$cE,
  PhTextHThree: __vue_component__$cF,
  PhTextHTwo: __vue_component__$cG,
  PhTextItalic: __vue_component__$cH,
  PhTextStrikethrough: __vue_component__$cI,
  PhTextT: __vue_component__$cJ,
  PhTextUnderline: __vue_component__$cK,
  PhThermometer: __vue_component__$cL,
  PhThermometerCold: __vue_component__$cM,
  PhThermometerHot: __vue_component__$cN,
  PhThermometerSimple: __vue_component__$cO,
  PhThumbsDown: __vue_component__$cP,
  PhThumbsUp: __vue_component__$cQ,
  PhTicket: __vue_component__$cR,
  PhTiktokLogo: __vue_component__$cS,
  PhTimer: __vue_component__$cT,
  PhToggleLeft: __vue_component__$cU,
  PhToggleRight: __vue_component__$cV,
  PhToiletPaper: __vue_component__$cW,
  PhTote: __vue_component__$cX,
  PhToteSimple: __vue_component__$cY,
  PhTrafficSign: __vue_component__$cZ,
  PhTrain: __vue_component__$c_,
  PhTrainRegional: __vue_component__$c$,
  PhTrainSimple: __vue_component__$d0,
  PhTranslate: __vue_component__$d1,
  PhTrash: __vue_component__$d2,
  PhTrashSimple: __vue_component__$d3,
  PhTray: __vue_component__$d4,
  PhTree: __vue_component__$d5,
  PhTreeEvergreen: __vue_component__$d6,
  PhTreeStructure: __vue_component__$d7,
  PhTrendDown: __vue_component__$d8,
  PhTrendUp: __vue_component__$d9,
  PhTriangle: __vue_component__$da,
  PhTrophy: __vue_component__$db,
  PhTruck: __vue_component__$dc,
  PhTwitchLogo: __vue_component__$dd,
  PhTwitterLogo: __vue_component__$de,
  PhUmbrella: __vue_component__$df,
  PhUmbrellaSimple: __vue_component__$dg,
  PhUpload: __vue_component__$dh,
  PhUploadSimple: __vue_component__$di,
  PhUser: __vue_component__$dj,
  PhUserCircle: __vue_component__$dk,
  PhUserCircleGear: __vue_component__$dl,
  PhUserCircleMinus: __vue_component__$dm,
  PhUserCirclePlus: __vue_component__$dn,
  PhUserFocus: __vue_component__$do,
  PhUserGear: __vue_component__$dp,
  PhUserList: __vue_component__$dq,
  PhUserMinus: __vue_component__$dr,
  PhUserPlus: __vue_component__$ds,
  PhUserRectangle: __vue_component__$dt,
  PhUserSquare: __vue_component__$du,
  PhUsers: __vue_component__$dv,
  PhUsersFour: __vue_component__$dw,
  PhUsersThree: __vue_component__$dx,
  PhVibrate: __vue_component__$dy,
  PhVideoCamera: __vue_component__$dz,
  PhVideoCameraSlash: __vue_component__$dA,
  PhVoicemail: __vue_component__$dB,
  PhVolleyball: __vue_component__$dC,
  PhWall: __vue_component__$dD,
  PhWallet: __vue_component__$dE,
  PhWarning: __vue_component__$dF,
  PhWarningCircle: __vue_component__$dG,
  PhWarningOctagon: __vue_component__$dH,
  PhWatch: __vue_component__$dI,
  PhWaves: __vue_component__$dJ,
  PhWhatsappLogo: __vue_component__$dK,
  PhWheelchair: __vue_component__$dL,
  PhWifiHigh: __vue_component__$dM,
  PhWifiLow: __vue_component__$dN,
  PhWifiMedium: __vue_component__$dO,
  PhWifiNone: __vue_component__$dP,
  PhWifiSlash: __vue_component__$dQ,
  PhWifiX: __vue_component__$dR,
  PhWind: __vue_component__$dS,
  PhWindowsLogo: __vue_component__$dT,
  PhWine: __vue_component__$dU,
  PhWrench: __vue_component__$dV,
  PhX: __vue_component__$dW,
  PhXCircle: __vue_component__$dX,
  PhXSquare: __vue_component__$dY,
  PhYoutubeLogo: __vue_component__$dZ
});

// Import vue components
// eslint-disable-next-line @typescript-eslint/no-explicit-any

// install function executed by Vue.use()
const install = function installPhosphorVueTs(Vue) {
  if (install.installed) return;
  install.installed = true;
  Object.entries(components).forEach(([componentName, component]) => {
    Vue.component(componentName, component);
  });
}; // Create module definition for Vue.use()


const plugin = {
  install
}; // To auto-install on non-es builds, when vue is found

export default plugin;
export { __vue_component__ as PhActivity, __vue_component__$1 as PhAddressBook, __vue_component__$2 as PhAirplane, __vue_component__$3 as PhAirplaneInFlight, __vue_component__$4 as PhAirplaneLanding, __vue_component__$5 as PhAirplaneTakeoff, __vue_component__$6 as PhAirplaneTilt, __vue_component__$7 as PhAirplay, __vue_component__$8 as PhAlarm, __vue_component__$9 as PhAlignBottom, __vue_component__$a as PhAlignCenterHorizontal, __vue_component__$b as PhAlignCenterVertical, __vue_component__$c as PhAlignLeft, __vue_component__$d as PhAlignRight, __vue_component__$e as PhAlignTop, __vue_component__$f as PhAnchor, __vue_component__$g as PhAnchorSimple, __vue_component__$h as PhAndroidLogo, __vue_component__$i as PhAperture, __vue_component__$j as PhAppWindow, __vue_component__$k as PhAppleLogo, __vue_component__$l as PhArchive, __vue_component__$m as PhArchiveBox, __vue_component__$n as PhArchiveTray, __vue_component__$o as PhArmchair, __vue_component__$p as PhArrowArcLeft, __vue_component__$q as PhArrowArcRight, __vue_component__$r as PhArrowBendDoubleUpLeft, __vue_component__$s as PhArrowBendDoubleUpRight, __vue_component__$t as PhArrowBendDownLeft, __vue_component__$u as PhArrowBendDownRight, __vue_component__$v as PhArrowBendLeftDown, __vue_component__$w as PhArrowBendLeftUp, __vue_component__$x as PhArrowBendRightDown, __vue_component__$y as PhArrowBendRightUp, __vue_component__$z as PhArrowBendUpLeft, __vue_component__$A as PhArrowBendUpRight, __vue_component__$B as PhArrowCircleDown, __vue_component__$C as PhArrowCircleDownLeft, __vue_component__$D as PhArrowCircleDownRight, __vue_component__$E as PhArrowCircleLeft, __vue_component__$F as PhArrowCircleRight, __vue_component__$G as PhArrowCircleUp, __vue_component__$H as PhArrowCircleUpLeft, __vue_component__$I as PhArrowCircleUpRight, __vue_component__$J as PhArrowClockwise, __vue_component__$K as PhArrowCounterClockwise, __vue_component__$L as PhArrowDown, __vue_component__$M as PhArrowDownLeft, __vue_component__$N as PhArrowDownRight, __vue_component__$O as PhArrowElbowDownLeft, __vue_component__$P as PhArrowElbowDownRight, __vue_component__$Q as PhArrowElbowLeft, __vue_component__$R as PhArrowElbowLeftDown, __vue_component__$S as PhArrowElbowLeftUp, __vue_component__$T as PhArrowElbowRight, __vue_component__$U as PhArrowElbowRightDown, __vue_component__$V as PhArrowElbowRightUp, __vue_component__$W as PhArrowElbowUpLeft, __vue_component__$X as PhArrowElbowUpRight, __vue_component__$Y as PhArrowFatDown, __vue_component__$Z as PhArrowFatLeft, __vue_component__$_ as PhArrowFatLineDown, __vue_component__$$ as PhArrowFatLineLeft, __vue_component__$10 as PhArrowFatLineRight, __vue_component__$11 as PhArrowFatLineUp, __vue_component__$12 as PhArrowFatLinesDown, __vue_component__$13 as PhArrowFatLinesLeft, __vue_component__$14 as PhArrowFatLinesRight, __vue_component__$15 as PhArrowFatLinesUp, __vue_component__$16 as PhArrowFatRight, __vue_component__$17 as PhArrowFatUp, __vue_component__$18 as PhArrowLeft, __vue_component__$19 as PhArrowLineDown, __vue_component__$1a as PhArrowLineDownLeft, __vue_component__$1b as PhArrowLineDownRight, __vue_component__$1c as PhArrowLineLeft, __vue_component__$1d as PhArrowLineRight, __vue_component__$1e as PhArrowLineUp, __vue_component__$1f as PhArrowLineUpLeft, __vue_component__$1g as PhArrowLineUpRight, __vue_component__$1h as PhArrowRight, __vue_component__$1i as PhArrowSquareDown, __vue_component__$1j as PhArrowSquareDownLeft, __vue_component__$1k as PhArrowSquareDownRight, __vue_component__$1l as PhArrowSquareIn, __vue_component__$1m as PhArrowSquareLeft, __vue_component__$1n as PhArrowSquareOut, __vue_component__$1o as PhArrowSquareRight, __vue_component__$1p as PhArrowSquareUp, __vue_component__$1q as PhArrowSquareUpLeft, __vue_component__$1r as PhArrowSquareUpRight, __vue_component__$1s as PhArrowUDownLeft, __vue_component__$1t as PhArrowUDownRight, __vue_component__$1u as PhArrowULeftDown, __vue_component__$1v as PhArrowULeftUp, __vue_component__$1w as PhArrowURightDown, __vue_component__$1x as PhArrowURightUp, __vue_component__$1y as PhArrowUUpLeft, __vue_component__$1z as PhArrowUUpRight, __vue_component__$1A as PhArrowUp, __vue_component__$1B as PhArrowUpLeft, __vue_component__$1C as PhArrowUpRight, __vue_component__$1D as PhArrowsClockwise, __vue_component__$1E as PhArrowsCounterClockwise, __vue_component__$1F as PhArrowsDownUp, __vue_component__$1G as PhArrowsIn, __vue_component__$1H as PhArrowsInCardinal, __vue_component__$1I as PhArrowsInLineHorizontal, __vue_component__$1J as PhArrowsInLineVertical, __vue_component__$1K as PhArrowsInSimple, __vue_component__$1L as PhArrowsLeftRight, __vue_component__$1M as PhArrowsOut, __vue_component__$1N as PhArrowsOutCardinal, __vue_component__$1O as PhArrowsOutLineHorizontal, __vue_component__$1P as PhArrowsOutLineVertical, __vue_component__$1Q as PhArrowsOutSimple, __vue_component__$1R as PhArticle, __vue_component__$1S as PhArticleMedium, __vue_component__$1T as PhArticleNyTimes, __vue_component__$1U as PhAsterisk, __vue_component__$1V as PhAt, __vue_component__$1W as PhAtom, __vue_component__$1X as PhBaby, __vue_component__$1Y as PhBackspace, __vue_component__$1Z as PhBag, __vue_component__$1_ as PhBagSimple, __vue_component__$1$ as PhBandaids, __vue_component__$20 as PhBank, __vue_component__$21 as PhBarbell, __vue_component__$22 as PhBarcode, __vue_component__$23 as PhBaseball, __vue_component__$24 as PhBasketball, __vue_component__$25 as PhBatteryCharging, __vue_component__$26 as PhBatteryChargingVertical, __vue_component__$27 as PhBatteryEmpty, __vue_component__$28 as PhBatteryFull, __vue_component__$29 as PhBatteryHigh, __vue_component__$2a as PhBatteryLow, __vue_component__$2b as PhBatteryMedium, __vue_component__$2c as PhBatteryWarning, __vue_component__$2d as PhBatteryWarningVertical, __vue_component__$2e as PhBed, __vue_component__$2f as PhBell, __vue_component__$2g as PhBellRinging, __vue_component__$2h as PhBellSimple, __vue_component__$2i as PhBellSimpleRinging, __vue_component__$2j as PhBellSimpleSlash, __vue_component__$2k as PhBellSimpleZ, __vue_component__$2l as PhBellSlash, __vue_component__$2m as PhBellZ, __vue_component__$2n as PhBicycle, __vue_component__$2o as PhBird, __vue_component__$2p as PhBluetooth, __vue_component__$2q as PhBluetoothConnected, __vue_component__$2r as PhBluetoothSlash, __vue_component__$2s as PhBluetoothX, __vue_component__$2t as PhBoat, __vue_component__$2u as PhBook, __vue_component__$2v as PhBookBookmark, __vue_component__$2w as PhBookOpen, __vue_component__$2x as PhBookmark, __vue_component__$2y as PhBookmarkSimple, __vue_component__$2z as PhBookmarks, __vue_component__$2A as PhBookmarksSimple, __vue_component__$2B as PhBooks, __vue_component__$2C as PhBoundingBox, __vue_component__$2D as PhBracketsAngle, __vue_component__$2E as PhBracketsCurly, __vue_component__$2F as PhBracketsRound, __vue_component__$2G as PhBracketsSquare, __vue_component__$2H as PhBrain, __vue_component__$2I as PhBrandy, __vue_component__$2J as PhBriefcase, __vue_component__$2K as PhBriefcaseMetal, __vue_component__$2L as PhBroadcast, __vue_component__$2M as PhBrowser, __vue_component__$2N as PhBrowsers, __vue_component__$2O as PhBug, __vue_component__$2P as PhBugBeetle, __vue_component__$2Q as PhBugDroid, __vue_component__$2R as PhBuildings, __vue_component__$2S as PhBus, __vue_component__$2T as PhCake, __vue_component__$2U as PhCalculator, __vue_component__$2V as PhCalendar, __vue_component__$2W as PhCalendarBlank, __vue_component__$2X as PhCalendarCheck, __vue_component__$2Y as PhCalendarPlus, __vue_component__$2Z as PhCalendarX, __vue_component__$2_ as PhCamera, __vue_component__$2$ as PhCameraSlash, __vue_component__$30 as PhCar, __vue_component__$31 as PhCarSimple, __vue_component__$32 as PhCardholder, __vue_component__$33 as PhCards, __vue_component__$34 as PhCaretCircleDoubleDown, __vue_component__$35 as PhCaretCircleDoubleLeft, __vue_component__$36 as PhCaretCircleDoubleRight, __vue_component__$37 as PhCaretCircleDoubleUp, __vue_component__$38 as PhCaretCircleDown, __vue_component__$39 as PhCaretCircleLeft, __vue_component__$3a as PhCaretCircleRight, __vue_component__$3b as PhCaretCircleUp, __vue_component__$3c as PhCaretDoubleDown, __vue_component__$3d as PhCaretDoubleLeft, __vue_component__$3e as PhCaretDoubleRight, __vue_component__$3f as PhCaretDoubleUp, __vue_component__$3g as PhCaretDown, __vue_component__$3h as PhCaretLeft, __vue_component__$3i as PhCaretRight, __vue_component__$3j as PhCaretUp, __vue_component__$3k as PhCat, __vue_component__$3l as PhCellSignalFull, __vue_component__$3m as PhCellSignalHigh, __vue_component__$3n as PhCellSignalLow, __vue_component__$3o as PhCellSignalMedium, __vue_component__$3p as PhCellSignalNone, __vue_component__$3q as PhCellSignalSlash, __vue_component__$3r as PhCellSignalX, __vue_component__$3s as PhChalkboard, __vue_component__$3t as PhChalkboardSimple, __vue_component__$3u as PhChalkboardTeacher, __vue_component__$3v as PhChartBar, __vue_component__$3w as PhChartBarHorizontal, __vue_component__$3x as PhChartLine, __vue_component__$3y as PhChartLineUp, __vue_component__$3z as PhChartPie, __vue_component__$3A as PhChartPieSlice, __vue_component__$3B as PhChat, __vue_component__$3C as PhChatCentered, __vue_component__$3D as PhChatCenteredDots, __vue_component__$3E as PhChatCenteredText, __vue_component__$3F as PhChatCircle, __vue_component__$3G as PhChatCircleDots, __vue_component__$3H as PhChatCircleText, __vue_component__$3I as PhChatDots, __vue_component__$3J as PhChatTeardrop, __vue_component__$3K as PhChatTeardropDots, __vue_component__$3L as PhChatTeardropText, __vue_component__$3M as PhChatText, __vue_component__$3N as PhChats, __vue_component__$3O as PhChatsCircle, __vue_component__$3P as PhChatsTeardrop, __vue_component__$3Q as PhCheck, __vue_component__$3R as PhCheckCircle, __vue_component__$3S as PhCheckSquare, __vue_component__$3T as PhCheckSquareOffset, __vue_component__$3U as PhChecks, __vue_component__$3V as PhCircle, __vue_component__$3W as PhCircleDashed, __vue_component__$3X as PhCircleHalf, __vue_component__$3Y as PhCircleHalfTilt, __vue_component__$3Z as PhCircleWavy, __vue_component__$3_ as PhCircleWavyCheck, __vue_component__$3$ as PhCircleWavyQuestion, __vue_component__$40 as PhCircleWavyWarning, __vue_component__$41 as PhCirclesFour, __vue_component__$42 as PhCirclesThree, __vue_component__$43 as PhCirclesThreePlus, __vue_component__$44 as PhClipboard, __vue_component__$45 as PhClipboardText, __vue_component__$46 as PhClock, __vue_component__$47 as PhClockAfternoon, __vue_component__$48 as PhClockClockwise, __vue_component__$49 as PhClockCounterClockwise, __vue_component__$4a as PhClosedCaptioning, __vue_component__$4b as PhCloud, __vue_component__$4c as PhCloudArrowDown, __vue_component__$4d as PhCloudArrowUp, __vue_component__$4e as PhCloudCheck, __vue_component__$4f as PhCloudFog, __vue_component__$4g as PhCloudLightning, __vue_component__$4h as PhCloudMoon, __vue_component__$4i as PhCloudRain, __vue_component__$4j as PhCloudSlash, __vue_component__$4k as PhCloudSnow, __vue_component__$4l as PhCloudSun, __vue_component__$4m as PhClub, __vue_component__$4n as PhCode, __vue_component__$4o as PhCodeSimple, __vue_component__$4p as PhCoffee, __vue_component__$4q as PhCoin, __vue_component__$4r as PhColumns, __vue_component__$4s as PhCommand, __vue_component__$4t as PhCompass, __vue_component__$4u as PhComputerTower, __vue_component__$4v as PhCookie, __vue_component__$4w as PhCookingPot, __vue_component__$4x as PhCopy, __vue_component__$4y as PhCopySimple, __vue_component__$4z as PhCopyright, __vue_component__$4A as PhCornersIn, __vue_component__$4B as PhCornersOut, __vue_component__$4C as PhCpu, __vue_component__$4D as PhCreditCard, __vue_component__$4E as PhCrop, __vue_component__$4F as PhCrosshair, __vue_component__$4G as PhCrosshairSimple, __vue_component__$4H as PhCrown, __vue_component__$4I as PhCrownSimple, __vue_component__$4J as PhCube, __vue_component__$4K as PhCurrencyBtc, __vue_component__$4L as PhCurrencyCircleDollar, __vue_component__$4M as PhCurrencyCny, __vue_component__$4N as PhCurrencyDollar, __vue_component__$4O as PhCurrencyDollarSimple, __vue_component__$4P as PhCurrencyEur, __vue_component__$4Q as PhCurrencyGbp, __vue_component__$4R as PhCurrencyInr, __vue_component__$4S as PhCurrencyJpy, __vue_component__$4T as PhCurrencyKrw, __vue_component__$4U as PhCurrencyRub, __vue_component__$4V as PhCursor, __vue_component__$4W as PhDatabase, __vue_component__$4X as PhDesktop, __vue_component__$4Y as PhDesktopTower, __vue_component__$4Z as PhDeviceMobile, __vue_component__$4_ as PhDeviceMobileCamera, __vue_component__$4$ as PhDeviceMobileSpeaker, __vue_component__$50 as PhDeviceTablet, __vue_component__$51 as PhDeviceTabletCamera, __vue_component__$52 as PhDeviceTabletSpeaker, __vue_component__$53 as PhDiamond, __vue_component__$54 as PhDiceFive, __vue_component__$55 as PhDiceFour, __vue_component__$56 as PhDiceOne, __vue_component__$57 as PhDiceSix, __vue_component__$58 as PhDiceThree, __vue_component__$59 as PhDiceTwo, __vue_component__$5a as PhDisc, __vue_component__$5b as PhDiscordLogo, __vue_component__$5c as PhDivide, __vue_component__$5d as PhDog, __vue_component__$5e as PhDoor, __vue_component__$5f as PhDotsNine, __vue_component__$5g as PhDotsSix, __vue_component__$5h as PhDotsSixVertical, __vue_component__$5i as PhDotsThree, __vue_component__$5j as PhDotsThreeCircle, __vue_component__$5k as PhDotsThreeCircleVertical, __vue_component__$5l as PhDotsThreeOutline, __vue_component__$5m as PhDotsThreeOutlineVertical, __vue_component__$5n as PhDotsThreeVertical, __vue_component__$5o as PhDownload, __vue_component__$5p as PhDownloadSimple, __vue_component__$5q as PhDribbbleLogo, __vue_component__$5r as PhDrop, __vue_component__$5s as PhDropHalf, __vue_component__$5t as PhEar, __vue_component__$5u as PhEarSlash, __vue_component__$5v as PhEject, __vue_component__$5w as PhEjectSimple, __vue_component__$5x as PhEnvelope, __vue_component__$5y as PhEnvelopeOpen, __vue_component__$5z as PhEnvelopeSimple, __vue_component__$5A as PhEnvelopeSimpleOpen, __vue_component__$5B as PhEquals, __vue_component__$5C as PhEraser, __vue_component__$5D as PhExport, __vue_component__$5E as PhEye, __vue_component__$5F as PhEyeClosed, __vue_component__$5G as PhEyeSlash, __vue_component__$5H as PhEyedropper, __vue_component__$5I as PhFaceMask, __vue_component__$5J as PhFacebookLogo, __vue_component__$5K as PhFactory, __vue_component__$5L as PhFaders, __vue_component__$5M as PhFadersHorizontal, __vue_component__$5N as PhFastForward, __vue_component__$5O as PhFastForwardCircle, __vue_component__$5P as PhFigmaLogo, __vue_component__$5Q as PhFile, __vue_component__$5R as PhFileArrowDown, __vue_component__$5S as PhFileArrowUp, __vue_component__$5T as PhFileDotted, __vue_component__$5U as PhFileMinus, __vue_component__$5V as PhFilePdf, __vue_component__$5W as PhFilePlus, __vue_component__$5X as PhFileSearch, __vue_component__$5Y as PhFileText, __vue_component__$5Z as PhFileX, __vue_component__$5_ as PhFiles, __vue_component__$5$ as PhFilmStrip, __vue_component__$60 as PhFingerprint, __vue_component__$61 as PhFingerprintSimple, __vue_component__$62 as PhFinnTheHuman, __vue_component__$63 as PhFire, __vue_component__$64 as PhFireSimple, __vue_component__$65 as PhFirstAid, __vue_component__$66 as PhFirstAidKit, __vue_component__$67 as PhFish, __vue_component__$68 as PhFishSimple, __vue_component__$69 as PhFlag, __vue_component__$6a as PhFlagBanner, __vue_component__$6b as PhFlame, __vue_component__$6c as PhFlashlight, __vue_component__$6d as PhFlask, __vue_component__$6e as PhFloppyDisk, __vue_component__$6f as PhFloppyDiskBack, __vue_component__$6g as PhFlowArrow, __vue_component__$6h as PhFlower, __vue_component__$6i as PhFlowerLotus, __vue_component__$6j as PhFolder, __vue_component__$6k as PhFolderMinus, __vue_component__$6l as PhFolderNotch, __vue_component__$6m as PhFolderNotchMinus, __vue_component__$6n as PhFolderNotchOpen, __vue_component__$6o as PhFolderNotchPlus, __vue_component__$6p as PhFolderOpen, __vue_component__$6q as PhFolderPlus, __vue_component__$6r as PhFolderSimple, __vue_component__$6s as PhFolderSimpleMinus, __vue_component__$6t as PhFolderSimplePlus, __vue_component__$6u as PhFolders, __vue_component__$6v as PhFootball, __vue_component__$6w as PhForkKnife, __vue_component__$6x as PhFrameCorners, __vue_component__$6y as PhFramerLogo, __vue_component__$6z as PhFunnel, __vue_component__$6A as PhFunnelSimple, __vue_component__$6B as PhGameController, __vue_component__$6C as PhGasPump, __vue_component__$6D as PhGauge, __vue_component__$6E as PhGear, __vue_component__$6F as PhGearSix, __vue_component__$6G as PhGenderFemale, __vue_component__$6H as PhGenderIntersex, __vue_component__$6I as PhGenderMale, __vue_component__$6J as PhGenderNeuter, __vue_component__$6K as PhGenderNonbinary, __vue_component__$6L as PhGenderTransgender, __vue_component__$6M as PhGhost, __vue_component__$6N as PhGif, __vue_component__$6O as PhGift, __vue_component__$6P as PhGitBranch, __vue_component__$6Q as PhGitCommit, __vue_component__$6R as PhGitDiff, __vue_component__$6S as PhGitFork, __vue_component__$6T as PhGitMerge, __vue_component__$6U as PhGitPullRequest, __vue_component__$6V as PhGithubLogo, __vue_component__$6W as PhGitlabLogo, __vue_component__$6X as PhGitlabLogoSimple, __vue_component__$6Y as PhGlobe, __vue_component__$6Z as PhGlobeHemisphereEast, __vue_component__$6_ as PhGlobeHemisphereWest, __vue_component__$6$ as PhGlobeSimple, __vue_component__$70 as PhGlobeStand, __vue_component__$71 as PhGoogleLogo, __vue_component__$72 as PhGooglePlayLogo, __vue_component__$73 as PhGraduationCap, __vue_component__$74 as PhGridFour, __vue_component__$75 as PhHand, __vue_component__$76 as PhHandFist, __vue_component__$77 as PhHandGrabbing, __vue_component__$78 as PhHandPalm, __vue_component__$79 as PhHandPointing, __vue_component__$7a as PhHandSoap, __vue_component__$7b as PhHandWaving, __vue_component__$7c as PhHandbag, __vue_component__$7d as PhHandbagSimple, __vue_component__$7e as PhHandsClapping, __vue_component__$7f as PhHandshake, __vue_component__$7g as PhHardDrive, __vue_component__$7h as PhHardDrives, __vue_component__$7i as PhHash, __vue_component__$7j as PhHashStraight, __vue_component__$7k as PhHeadlights, __vue_component__$7l as PhHeadphones, __vue_component__$7m as PhHeadset, __vue_component__$7n as PhHeart, __vue_component__$7o as PhHeartStraight, __vue_component__$7p as PhHeartbeat, __vue_component__$7q as PhHexagon, __vue_component__$7r as PhHighlighterCircle, __vue_component__$7s as PhHorse, __vue_component__$7t as PhHourglass, __vue_component__$7u as PhHourglassHigh, __vue_component__$7v as PhHourglassLow, __vue_component__$7w as PhHourglassMedium, __vue_component__$7x as PhHourglassSimple, __vue_component__$7y as PhHourglassSimpleHigh, __vue_component__$7z as PhHourglassSimpleLow, __vue_component__$7A as PhHourglassSimpleMedium, __vue_component__$7B as PhHouse, __vue_component__$7C as PhHouseLine, __vue_component__$7D as PhHouseSimple, __vue_component__$7E as PhIdentificationBadge, __vue_component__$7F as PhIdentificationCard, __vue_component__$7G as PhImage, __vue_component__$7H as PhImageSquare, __vue_component__$7I as PhInfinity, __vue_component__$7J as PhInfo, __vue_component__$7K as PhInstagramLogo, __vue_component__$7L as PhIntersect, __vue_component__$7M as PhJeep, __vue_component__$7N as PhKey, __vue_component__$7O as PhKeyReturn, __vue_component__$7P as PhKeyboard, __vue_component__$7Q as PhKnife, __vue_component__$7R as PhLamp, __vue_component__$7S as PhLaptop, __vue_component__$7T as PhLayout, __vue_component__$7U as PhLeaf, __vue_component__$7V as PhLifebuoy, __vue_component__$7W as PhLightbulb, __vue_component__$7X as PhLightbulbFilament, __vue_component__$7Y as PhLightning, __vue_component__$7Z as PhLightningSlash, __vue_component__$7_ as PhLineSegment, __vue_component__$7$ as PhLineSegments, __vue_component__$80 as PhLink, __vue_component__$81 as PhLinkBreak, __vue_component__$82 as PhLinkSimple, __vue_component__$83 as PhLinkSimpleBreak, __vue_component__$84 as PhLinkSimpleHorizontal, __vue_component__$85 as PhLinkSimpleHorizontalBreak, __vue_component__$86 as PhLinkedinLogo, __vue_component__$87 as PhList, __vue_component__$88 as PhListBullets, __vue_component__$89 as PhListDashes, __vue_component__$8a as PhListNumbers, __vue_component__$8b as PhListPlus, __vue_component__$8c as PhLock, __vue_component__$8d as PhLockKey, __vue_component__$8e as PhLockKeyOpen, __vue_component__$8f as PhLockLaminated, __vue_component__$8g as PhLockLaminatedOpen, __vue_component__$8h as PhLockOpen, __vue_component__$8i as PhLockSimple, __vue_component__$8j as PhLockSimpleOpen, __vue_component__$8k as PhMagicWand, __vue_component__$8l as PhMagnet, __vue_component__$8m as PhMagnetStraight, __vue_component__$8n as PhMagnifyingGlass, __vue_component__$8o as PhMagnifyingGlassMinus, __vue_component__$8p as PhMagnifyingGlassPlus, __vue_component__$8q as PhMapPin, __vue_component__$8r as PhMapPinLine, __vue_component__$8s as PhMapTrifold, __vue_component__$8t as PhMarkerCircle, __vue_component__$8u as PhMartini, __vue_component__$8v as PhMathOperations, __vue_component__$8w as PhMedal, __vue_component__$8x as PhMediumLogo, __vue_component__$8y as PhMegaphone, __vue_component__$8z as PhMegaphoneSimple, __vue_component__$8A as PhMessengerLogo, __vue_component__$8B as PhMicrophone, __vue_component__$8C as PhMicrophoneSlash, __vue_component__$8D as PhMinus, __vue_component__$8E as PhMinusCircle, __vue_component__$8F as PhMoney, __vue_component__$8G as PhMonitor, __vue_component__$8H as PhMonitorPlay, __vue_component__$8I as PhMoon, __vue_component__$8J as PhMoonStars, __vue_component__$8K as PhMouse, __vue_component__$8L as PhMouseSimple, __vue_component__$8M as PhMusicNote, __vue_component__$8N as PhMusicNoteSimple, __vue_component__$8O as PhMusicNotes, __vue_component__$8P as PhMusicNotesSimple, __vue_component__$8Q as PhNavigationArrow, __vue_component__$8R as PhNewspaper, __vue_component__$8S as PhNewspaperClipping, __vue_component__$8T as PhNote, __vue_component__$8U as PhNoteBlank, __vue_component__$8V as PhNotePencil, __vue_component__$8W as PhNotebook, __vue_component__$8X as PhNotepad, __vue_component__$8Y as PhNotification, __vue_component__$8Z as PhNumberCircleEight, __vue_component__$8_ as PhNumberCircleFive, __vue_component__$8$ as PhNumberCircleFour, __vue_component__$90 as PhNumberCircleNine, __vue_component__$91 as PhNumberCircleOne, __vue_component__$92 as PhNumberCircleSeven, __vue_component__$93 as PhNumberCircleSix, __vue_component__$94 as PhNumberCircleThree, __vue_component__$95 as PhNumberCircleTwo, __vue_component__$96 as PhNumberCircleZero, __vue_component__$97 as PhNumberEight, __vue_component__$98 as PhNumberFive, __vue_component__$99 as PhNumberFour, __vue_component__$9a as PhNumberNine, __vue_component__$9b as PhNumberOne, __vue_component__$9c as PhNumberSeven, __vue_component__$9d as PhNumberSix, __vue_component__$9e as PhNumberSquareEight, __vue_component__$9f as PhNumberSquareFive, __vue_component__$9g as PhNumberSquareFour, __vue_component__$9h as PhNumberSquareNine, __vue_component__$9i as PhNumberSquareOne, __vue_component__$9j as PhNumberSquareSeven, __vue_component__$9k as PhNumberSquareSix, __vue_component__$9l as PhNumberSquareThree, __vue_component__$9m as PhNumberSquareTwo, __vue_component__$9n as PhNumberSquareZero, __vue_component__$9o as PhNumberThree, __vue_component__$9p as PhNumberTwo, __vue_component__$9q as PhNumberZero, __vue_component__$9r as PhNut, __vue_component__$9s as PhNyTimesLogo, __vue_component__$9t as PhOctagon, __vue_component__$9u as PhPackage, __vue_component__$9v as PhPaintBrush, __vue_component__$9w as PhPaintBrushBroad, __vue_component__$9x as PhPaintBrushHousehold, __vue_component__$9y as PhPaintBucket, __vue_component__$9z as PhPaintRoller, __vue_component__$9A as PhPalette, __vue_component__$9B as PhPaperPlane, __vue_component__$9C as PhPaperPlaneRight, __vue_component__$9D as PhPaperPlaneTilt, __vue_component__$9E as PhPaperclip, __vue_component__$9F as PhPaperclipHorizontal, __vue_component__$9G as PhPath, __vue_component__$9H as PhPause, __vue_component__$9I as PhPauseCircle, __vue_component__$9J as PhPawPrint, __vue_component__$9K as PhPeace, __vue_component__$9L as PhPen, __vue_component__$9M as PhPenNib, __vue_component__$9N as PhPenNibStraight, __vue_component__$9O as PhPencil, __vue_component__$9P as PhPencilCircle, __vue_component__$9Q as PhPencilLine, __vue_component__$9R as PhPencilSimple, __vue_component__$9S as PhPercent, __vue_component__$9T as PhPerson, __vue_component__$9U as PhPersonSimple, __vue_component__$9V as PhPersonSimpleRun, __vue_component__$9W as PhPersonSimpleWalk, __vue_component__$9X as PhPhone, __vue_component__$9Y as PhPhoneCall, __vue_component__$9Z as PhPhoneDisconnect, __vue_component__$9_ as PhPhoneIncoming, __vue_component__$9$ as PhPhoneOutgoing, __vue_component__$a0 as PhPhoneSlash, __vue_component__$a1 as PhPhoneX, __vue_component__$a2 as PhPhosphorLogo, __vue_component__$a3 as PhPictureInPicture, __vue_component__$a4 as PhPill, __vue_component__$a5 as PhPinterestLogo, __vue_component__$a6 as PhPizza, __vue_component__$a7 as PhPlaceholder, __vue_component__$a8 as PhPlanet, __vue_component__$a9 as PhPlay, __vue_component__$aa as PhPlayCircle, __vue_component__$ab as PhPlaylist, __vue_component__$ac as PhPlus, __vue_component__$ad as PhPlusCircle, __vue_component__$ae as PhPlusMinus, __vue_component__$af as PhPokerChip, __vue_component__$ag as PhPolygon, __vue_component__$ah as PhPower, __vue_component__$ai as PhPrescription, __vue_component__$aj as PhPresentation, __vue_component__$ak as PhPresentationChart, __vue_component__$al as PhPrinter, __vue_component__$am as PhProhibit, __vue_component__$an as PhProhibitInset, __vue_component__$ao as PhProjectorScreen, __vue_component__$ap as PhProjectorScreenChart, __vue_component__$aq as PhPushPin, __vue_component__$ar as PhPushPinSimple, __vue_component__$as as PhPushPinSimpleSlash, __vue_component__$at as PhPushPinSlash, __vue_component__$au as PhPuzzlePiece, __vue_component__$av as PhQrCode, __vue_component__$aw as PhQuestion, __vue_component__$ax as PhQueue, __vue_component__$ay as PhQuotes, __vue_component__$az as PhRadical, __vue_component__$aA as PhRadio, __vue_component__$aB as PhRainbow, __vue_component__$aC as PhRainbowCloud, __vue_component__$aD as PhReceipt, __vue_component__$aE as PhRecord, __vue_component__$aF as PhRectangle, __vue_component__$aG as PhRecycle, __vue_component__$aH as PhRedditLogo, __vue_component__$aI as PhRepeat, __vue_component__$aJ as PhRepeatOnce, __vue_component__$aK as PhRewind, __vue_component__$aL as PhRewindCircle, __vue_component__$aM as PhRobot, __vue_component__$aN as PhRocket, __vue_component__$aO as PhRocketLaunch, __vue_component__$aP as PhRows, __vue_component__$aQ as PhRss, __vue_component__$aR as PhRssSimple, __vue_component__$aS as PhRuler, __vue_component__$aT as PhScales, __vue_component__$aU as PhScissors, __vue_component__$aV as PhScreencast, __vue_component__$aW as PhScribbleLoop, __vue_component__$aX as PhSelection, __vue_component__$aY as PhSelectionAll, __vue_component__$aZ as PhSelectionBackground, __vue_component__$a_ as PhSelectionForeground, __vue_component__$a$ as PhSelectionInverse, __vue_component__$b0 as PhSelectionPlus, __vue_component__$b1 as PhSelectionSlash, __vue_component__$b2 as PhShare, __vue_component__$b3 as PhShareNetwork, __vue_component__$b4 as PhShield, __vue_component__$b5 as PhShieldCheck, __vue_component__$b6 as PhShieldCheckered, __vue_component__$b7 as PhShieldChevron, __vue_component__$b8 as PhShieldPlus, __vue_component__$b9 as PhShieldSlash, __vue_component__$ba as PhShieldWarning, __vue_component__$bb as PhShoppingBag, __vue_component__$bc as PhShoppingBagOpen, __vue_component__$bd as PhShoppingCart, __vue_component__$be as PhShoppingCartSimple, __vue_component__$bf as PhShower, __vue_component__$bg as PhShuffle, __vue_component__$bh as PhShuffleAngular, __vue_component__$bi as PhShuffleSimple, __vue_component__$bj as PhSignIn, __vue_component__$bk as PhSignOut, __vue_component__$bl as PhSimCard, __vue_component__$bm as PhSketchLogo, __vue_component__$bn as PhSkipBack, __vue_component__$bo as PhSkipBackCircle, __vue_component__$bp as PhSkipForward, __vue_component__$bq as PhSkipForwardCircle, __vue_component__$br as PhSlackLogo, __vue_component__$bs as PhSliders, __vue_component__$bt as PhSlidersHorizontal, __vue_component__$bu as PhSmiley, __vue_component__$bv as PhSmileyBlank, __vue_component__$bw as PhSmileyMeh, __vue_component__$bx as PhSmileyNervous, __vue_component__$by as PhSmileySad, __vue_component__$bz as PhSmileySticker, __vue_component__$bA as PhSmileyWink, __vue_component__$bB as PhSmileyXEyes, __vue_component__$bC as PhSnapchatLogo, __vue_component__$bD as PhSnowflake, __vue_component__$bE as PhSoccerBall, __vue_component__$bF as PhSortAscending, __vue_component__$bG as PhSortDescending, __vue_component__$bH as PhSpade, __vue_component__$bI as PhSparkle, __vue_component__$bJ as PhSpeakerHigh, __vue_component__$bK as PhSpeakerLow, __vue_component__$bL as PhSpeakerNone, __vue_component__$bM as PhSpeakerSimpleHigh, __vue_component__$bN as PhSpeakerSimpleLow, __vue_component__$bO as PhSpeakerSimpleNone, __vue_component__$bP as PhSpeakerSimpleSlash, __vue_component__$bQ as PhSpeakerSimpleX, __vue_component__$bR as PhSpeakerSlash, __vue_component__$bS as PhSpeakerX, __vue_component__$bT as PhSpinner, __vue_component__$bU as PhSpinnerGap, __vue_component__$bV as PhSpotifyLogo, __vue_component__$bW as PhSquare, __vue_component__$bX as PhSquareHalf, __vue_component__$bY as PhSquareLogo, __vue_component__$bZ as PhSquaresFour, __vue_component__$b_ as PhStack, __vue_component__$b$ as PhStackSimple, __vue_component__$c0 as PhStar, __vue_component__$c1 as PhStarFour, __vue_component__$c2 as PhStarHalf, __vue_component__$c3 as PhSticker, __vue_component__$c4 as PhStop, __vue_component__$c5 as PhStopCircle, __vue_component__$c6 as PhStorefront, __vue_component__$c7 as PhStripeLogo, __vue_component__$c8 as PhStudent, __vue_component__$c9 as PhSuitcase, __vue_component__$ca as PhSuitcaseSimple, __vue_component__$cb as PhSun, __vue_component__$cc as PhSunDim, __vue_component__$cd as PhSunHorizon, __vue_component__$ce as PhSwap, __vue_component__$cf as PhSwatches, __vue_component__$cg as PhSword, __vue_component__$ch as PhTShirt, __vue_component__$ci as PhTable, __vue_component__$cj as PhTag, __vue_component__$ck as PhTagChevron, __vue_component__$cl as PhTagSimple, __vue_component__$cm as PhTarget, __vue_component__$cn as PhTelegramLogo, __vue_component__$co as PhTelevision, __vue_component__$cp as PhTelevisionSimple, __vue_component__$cq as PhTennisBall, __vue_component__$cr as PhTerminal, __vue_component__$cs as PhTerminalWindow, __vue_component__$ct as PhTestTube, __vue_component__$cu as PhTextAa, __vue_component__$cv as PhTextAlignCenter, __vue_component__$cw as PhTextAlignJustify, __vue_component__$cx as PhTextAlignLeft, __vue_component__$cy as PhTextAlignRight, __vue_component__$cz as PhTextBolder, __vue_component__$cA as PhTextH, __vue_component__$cB as PhTextHFive, __vue_component__$cC as PhTextHFour, __vue_component__$cD as PhTextHOne, __vue_component__$cE as PhTextHSix, __vue_component__$cF as PhTextHThree, __vue_component__$cG as PhTextHTwo, __vue_component__$cH as PhTextItalic, __vue_component__$cI as PhTextStrikethrough, __vue_component__$cJ as PhTextT, __vue_component__$cK as PhTextUnderline, __vue_component__$cL as PhThermometer, __vue_component__$cM as PhThermometerCold, __vue_component__$cN as PhThermometerHot, __vue_component__$cO as PhThermometerSimple, __vue_component__$cP as PhThumbsDown, __vue_component__$cQ as PhThumbsUp, __vue_component__$cR as PhTicket, __vue_component__$cS as PhTiktokLogo, __vue_component__$cT as PhTimer, __vue_component__$cU as PhToggleLeft, __vue_component__$cV as PhToggleRight, __vue_component__$cW as PhToiletPaper, __vue_component__$cX as PhTote, __vue_component__$cY as PhToteSimple, __vue_component__$cZ as PhTrafficSign, __vue_component__$c_ as PhTrain, __vue_component__$c$ as PhTrainRegional, __vue_component__$d0 as PhTrainSimple, __vue_component__$d1 as PhTranslate, __vue_component__$d2 as PhTrash, __vue_component__$d3 as PhTrashSimple, __vue_component__$d4 as PhTray, __vue_component__$d5 as PhTree, __vue_component__$d6 as PhTreeEvergreen, __vue_component__$d7 as PhTreeStructure, __vue_component__$d8 as PhTrendDown, __vue_component__$d9 as PhTrendUp, __vue_component__$da as PhTriangle, __vue_component__$db as PhTrophy, __vue_component__$dc as PhTruck, __vue_component__$dd as PhTwitchLogo, __vue_component__$de as PhTwitterLogo, __vue_component__$df as PhUmbrella, __vue_component__$dg as PhUmbrellaSimple, __vue_component__$dh as PhUpload, __vue_component__$di as PhUploadSimple, __vue_component__$dj as PhUser, __vue_component__$dk as PhUserCircle, __vue_component__$dl as PhUserCircleGear, __vue_component__$dm as PhUserCircleMinus, __vue_component__$dn as PhUserCirclePlus, __vue_component__$do as PhUserFocus, __vue_component__$dp as PhUserGear, __vue_component__$dq as PhUserList, __vue_component__$dr as PhUserMinus, __vue_component__$ds as PhUserPlus, __vue_component__$dt as PhUserRectangle, __vue_component__$du as PhUserSquare, __vue_component__$dv as PhUsers, __vue_component__$dw as PhUsersFour, __vue_component__$dx as PhUsersThree, __vue_component__$dy as PhVibrate, __vue_component__$dz as PhVideoCamera, __vue_component__$dA as PhVideoCameraSlash, __vue_component__$dB as PhVoicemail, __vue_component__$dC as PhVolleyball, __vue_component__$dD as PhWall, __vue_component__$dE as PhWallet, __vue_component__$dF as PhWarning, __vue_component__$dG as PhWarningCircle, __vue_component__$dH as PhWarningOctagon, __vue_component__$dI as PhWatch, __vue_component__$dJ as PhWaves, __vue_component__$dK as PhWhatsappLogo, __vue_component__$dL as PhWheelchair, __vue_component__$dM as PhWifiHigh, __vue_component__$dN as PhWifiLow, __vue_component__$dO as PhWifiMedium, __vue_component__$dP as PhWifiNone, __vue_component__$dQ as PhWifiSlash, __vue_component__$dR as PhWifiX, __vue_component__$dS as PhWind, __vue_component__$dT as PhWindowsLogo, __vue_component__$dU as PhWine, __vue_component__$dV as PhWrench, __vue_component__$dW as PhX, __vue_component__$dX as PhXCircle, __vue_component__$dY as PhXSquare, __vue_component__$dZ as PhYoutubeLogo };
